'use strict';
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function () {
    'use strict';
    function changeCookiesState(state) {
        if (window.TRPCONFIG === undefined) {
            window.TRPCONFIG = { Domain: {}, Domain2: {} };
        }
        TRPCONFIG.Domain.ShortlistsEnabled = TRPCONFIG.Domain.ShortlistsEnabled && state;
        TRPCONFIG.EnableSavedSearches = TRPCONFIG.EnableSavedSearches && state;
        TRPCONFIG.PayPalEnabled = state;
        TRPCONFIG.Domain.RecentHotelsEnabled = TRPCONFIG.Domain.RecentHotelsEnabled && state;
        TRPCONFIG.MenuEnabled = state;
        TRPCONFIG.SignInEnabled = state;
        TRPCONFIG.ManageBookingEnabled = state;
    }
    var cookies = ('cookie' in document && (document.cookie.length > 0 ||
        (document.cookie = 'test').indexOf.call(document.cookie, 'test') > -1));
    changeCookiesState(cookies);
    var devices = {
        desktop: 'Desktop',
        mobile: 'Mobile'
    };
    var angularModules = [
        'ngRoute',
        'ngSanitize',
        'ngMessages'
    ];
    // In production this array is replaced by an entry from dep.json during build
    var modules = [
        'attractions',
        'carHire',
        'cms',
        'core',
        'dashboard',
        'deals',
        'ekh',
        'flights',
        'insurance',
        'manageBooking',
        'marhaba',
        'parking',
        'products',
        'quote',
        'recommendations',
        'reviews',
        'search',
        'searchUnit',
        'snm',
        'transfers',
        'trp',
        'trustpilot',
        'destinations',
        'deepLink'
    ];
    if ([37, 56, 61, 66, 69].indexOf(TRPCONFIG.Domain.DomainId) > -1) {
        modules.push('ekh');
    }
    if (TRPCONFIG.Domain.LiveChat && TRPCONFIG.Domain.LiveChat.Enabled) {
        modules.push('liveChatModule');
    }
    if (TRPCONFIG.Domain.LiveChat && TRPCONFIG.Domain.LiveChat.SnapInEnabled) {
        modules.push('liveChatSnapInModule');
    }
    if (TRPCONFIG.Domain.DomainId === 60) {
        modules.push('snm');
    }
    if (TRPCONFIG.Domain.AccountsEnabled) {
        modules.push('dashboard');
    }
    if (TRPCONFIG.Domain.QuoteEnabled) {
        modules.push('quote');
    }
    if (TRPCONFIG.Domain.MarhabaEnabled) {
        modules.push('marhaba');
    }
    if (modules.indexOf('travelAgent') < 0) {
        modules.push('travelAgent');
    }
    for (var i in modules) {
        angular.module(modules[i], ['ngRoute']);
    }
    //Vendor ones need to stay after our own modules, otherwise they will get initialised wrongly
    if (TRPCONFIG.Domain.DeviceType === devices.desktop) {
        modules.push('toaster');
    }
    angular.module('TR', angularModules.concat(modules));
})();
(function () {
    /* eslint-disable no-extend-native, no-global-assign, new-cap */
    'use strict';
    // Replaces string vars by argument index+1
    // i.e. {0} is replaced by second argument
    String.format = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var tokenised = args[0];
        return tokenised.replace(/{[0-9]}/g, function (matched) {
            matched = matched.replace(/[{}]/g, '');
            return args[parseInt(matched) + 1];
        });
    };
    // Replaces string vars by name
    // i.e. String.supplant('Hi {name}', {name: 'abc'}); //'Hi abc'
    Object.defineProperty(String, 'supplant', {
        enumerable: false,
        configurable: false,
        value: function (str, o) {
            // http://javascript.crockford.com/remedial.html
            return str.replace(/\{([^{}]*)\}/g, function (a, b) {
                var r = o[b];
                return typeof r === 'string' || typeof r === 'number' ? r : a;
            });
        }
    });
    //polyfill because phantom js does not currently support bind which is annoying
    Function.prototype.bind || (Function.prototype.bind = function (thisp) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.apply(thisp, args);
        };
    });
    // This polyfill adds forEach compatibility to all Browsers supporting ES5
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
    //date polyfills which seem to be necessary for android 2.3.x and maybe others
    var supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
    var acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z'));
    var doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));
    if (!Date.parse || doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
        // XXX global assignment won't work in embeddings that use
        // an alternate object for the context.
        Date = (function (NativeDate) {
            // Date.length === 7
            function Date() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var Y = args[0], M = args[1], D = args[2], h = args[3], m = args[4], s = args[5], ms = args[6];
                var length = args.length;
                if (this instanceof NativeDate) {
                    var date = length === 1 && String(Y) === Y ? // isString(Y)
                        // We explicitly pass it through parse:
                        new NativeDate(Date.parse(Y)) :
                        // We have to manually make calls depending on argument
                        // length here
                        length >= 7 ? new NativeDate(Y, M, D, h, m, s, ms) :
                            length >= 6 ? new NativeDate(Y, M, D, h, m, s) :
                                length >= 5 ? new NativeDate(Y, M, D, h, m) :
                                    length >= 4 ? new NativeDate(Y, M, D, h) :
                                        length >= 3 ? new NativeDate(Y, M, D) :
                                            length >= 2 ? new NativeDate(Y, M) :
                                                length >= 1 ? new NativeDate(Y) :
                                                    new NativeDate();
                    // Prevent mixups with unfixed Date object
                    date.constructor = Date;
                    return date;
                }
                return NativeDate.apply(void 0, args);
            }
            // 15.9.1.15 Date Time String Format.
            var isoDateExpression = new RegExp('^' +
                '(\\d{4}|[+-]\\d{6})' + // four-digit year capture or sign +
                // 6-digit extended year
                '(?:-(\\d{2})' + // optional month capture
                '(?:-(\\d{2})' + // optional day capture
                '(?:' + // capture hours:minutes:seconds.milliseconds
                'T(\\d{2})' + // hours capture
                ':(\\d{2})' + // minutes capture
                '(?:' + // optional :seconds.milliseconds
                ':(\\d{2})' + // seconds capture
                '(?:(\\.\\d{1,}))?' + // milliseconds capture
                ')?' +
                '(' + // capture UTC offset component
                'Z|' + // UTC capture
                '(?:' + // offset specifier +/-hours:minutes
                '([-+])' + // sign capture
                '(\\d{2})' + // hours offset capture
                ':(\\d{2})' + // minutes offset capture
                ')' +
                ')?)?)?)?' +
                '$');
            var months = [
                0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365
            ];
            function dayFromMonth(year, month) {
                var t = month > 1 ? 1 : 0;
                return (months[month] +
                    Math.floor((year - 1969 + t) / 4) -
                    Math.floor((year - 1901 + t) / 100) +
                    Math.floor((year - 1601 + t) / 400) +
                    365 * (year - 1970));
            }
            function toUTC(t) {
                return Number(new NativeDate(1970, 0, 1, 0, 0, 0, t));
            }
            // Copy any custom methods a 3rd party library may have added
            for (var key in NativeDate) {
                Date[key] = NativeDate[key];
            }
            // Copy "native" methods explicitly; they may be non-enumerable
            Date.now = NativeDate.now;
            Date.UTC = NativeDate.UTC;
            Date.prototype = NativeDate.prototype;
            Date.prototype.constructor = Date;
            // Upgrade Date.parse to handle simplified ISO 8601 strings
            Date.parse = function parse() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var string = args[0];
                var match = isoDateExpression.exec(string);
                if (match) {
                    // parse months, days, hours, minutes, seconds, and milliseconds
                    // provide default values if necessary
                    // parse the UTC offset component
                    var year = Number(match[1]);
                    var month = Number(match[2] || 1) - 1;
                    var day = Number(match[3] || 1) - 1;
                    var hour = Number(match[4] || 0);
                    var minute = Number(match[5] || 0);
                    var second = Number(match[6] || 0);
                    var millisecond = Math.floor(Number(match[7] || 0) * 1000);
                    // When time zone is missed, local offset should be used
                    // (ES 5.1 bug)
                    // see https://bugs.ecmascript.org/show_bug.cgi?id=112
                    var isLocalTime = Boolean(match[4] && !match[8]);
                    var signOffset = match[9] === '-' ? 1 : -1;
                    var hourOffset = Number(match[10] || 0);
                    var minuteOffset = Number(match[11] || 0);
                    var result = void 0;
                    if (hour < (minute > 0 || second > 0 || millisecond > 0 ?
                        24 : 25) &&
                        minute < 60 && second < 60 && millisecond < 1000 &&
                        month > -1 && month < 12 && hourOffset < 24 &&
                        minuteOffset < 60 && // detect invalid offsets
                        day > -1 &&
                        day < (dayFromMonth(year, month + 1) -
                            dayFromMonth(year, month))) {
                        result = ((dayFromMonth(year, month) + day) * 24 +
                            hour +
                            hourOffset * signOffset) * 60;
                        result = ((result + minute + minuteOffset * signOffset) * 60 +
                            second) * 1000 + millisecond;
                        if (isLocalTime) {
                            result = toUTC(result);
                        }
                        if (-8.64e15 <= result && result <= 8.64e15) {
                            return result;
                        }
                    }
                    return NaN;
                }
                return NativeDate.parse.apply(NativeDate, args);
            };
            return Date;
        })(Date);
    }
    // missing forEach on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    if (/GT-I9195|GT-I9000/.test(navigator.userAgent)) {
        /*
            FIX for [ GalaxyS4-Mini (GT-I9195) | S3 (GT-I9000) ]
            It seems that, for some reason, the samsung stock browser can't handle correctly
            a change in the page dimension. To solve this the function binded to the touchmove
            event checks if the user is at the bottom of the page. If this is not the case a
            repaint is forced by moving the scroll down by one pixel (the movement is not visible)
            this way the dimensions of the page are recalculated by webkit.
            The "+ 2" has been inserted because a miscalculation of a single pixel can happen
            while comparing the left side of the formula with the scrollHeight (this should not affect
            the user experience).
         */
        document.body.addEventListener('touchmove', function () {
            //  Scroll Position    + Visibile page      + 2 < total dimension of the page
            if (window.pageYOffset + window.innerHeight + 2 < document.body.scrollHeight) {
                scrollTo(0, window.pageYOffset + 1);
            }
        }, false);
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.config(['$routeProvider', '$locationProvider', '$httpProvider', '$provide', '$sceDelegateProvider', '$compileProvider', 'popupAuth',
        function ($routeProvider, $locationProvider, $httpProvider, $provide, $sceDelegateProvider, $compileProvider, popupAuth) {
            /**
             * this is a horrible hack to make it possible to mandate that a dynamic route param must
             * match a certain regex.
             * Provided modifiers are ! for number, % for guid, and £ for fromUrlV2 route
             * i.e. :tripId% means that we match only if the route param is a guid
             */
            var routeModifiers = {
                '!': '(\\d+)',
                '%': '(.{8}-.{4}-.{4}-.{4}-.{12})',
                '£': '(\\d+-\\d+-\\d+-\\d+)',
                '€': '(\\d+-\\d+(?:-\\d+)?)'
            };
            function pathRegExp(path) {
                var p1 = path.replace(/([().])/g, '\\$1');
                // Add routeModifier to this replace statement
                path = p1.replace(/(\/)?:(\w+)([?*!%£€])?/g, function (_, slash, key, option) {
                    var optional = option === '?' ? option : null;
                    var star = option === '*' ? option : null;
                    var special = routeModifiers[option];
                    var keyMatch = (special || (star && '(.+?)' || '([^/]+)'));
                    slash = slash || '';
                    return (optional ? '' : slash) + "(?:" + (optional ? slash : '') + keyMatch + (optional || '') + ")" + (optional || '');
                })
                    .replace(/([/$*])/g, '\\$1');
                return new RegExp("^" + path + "/?$", 'i');
            }
            var $route = $routeProvider.$get[$routeProvider.$get.length - 1]({
                $on: function () {
                    // do nothing
                }
            });
            var when = $routeProvider.when;
            $routeProvider.when = function (path, route) {
                when.apply($routeProvider, [path, route]);
                // Add routeModifier to this list
                if (path && (path.indexOf('!') >= 0 || path.indexOf('%') >= 0 || path.indexOf('£') >= 0 || path.indexOf('€') >= 0)) {
                    $route.routes[path].regexp = pathRegExp(path);
                }
            };
            $compileProvider.debugInfoEnabled(TRPCONFIG.DebugInfoEnabled);
            $sceDelegateProvider.resourceUrlWhitelist(['self', TRPCONFIG.Domain.CacheDistributionUrl + "**", '/partials/**']);
            var reHasQuery = /^(\w*\/)*\w*\?.*=/;
            var reIsCmsRoute = /^cms\/(component|page)\//;
            $provide.decorator('$sce', ['$delegate', function ($delegate) {
                    // Adds a version token after every template request
                    // in order to better manage the cache
                    function addVersion(url) {
                        if (url &&
                            url.indexOf('tempver=') === -1 &&
                            url.indexOf('NOVERSION') === -1) {
                            var connector = reHasQuery.test(url) ? '&' : '?';
                            url += connector + "cultureCode=" + TRPCONFIG.Domain.CultureCode;
                            url += "&domainId=" + TRPCONFIG.Domain.DomainId;
                            url += "&device=" + TRPCONFIG.Domain.DeviceType;
                            url += "&isAgent=" + TRPCONFIG.Domain.isAgentMode;
                            url += "&udp=" + TRPCONFIG.Domain.UserDeviceProfile;
                            if (!reIsCmsRoute.test(url)) {
                                url += "&tempver=" + TRPCONFIG.CurrentVersion;
                            }
                        }
                        if (TRPCONFIG.Domain.CloudFrontCachingEnabled && TRPCONFIG.Domain.CloudFrontCachePartials && url != null) {
                            url = TRPCONFIG.Domain.CacheDistributionUrl + url;
                        }
                        return url;
                    }
                    // ng-include and everything else
                    $delegate.getTrusted = (function (original) {
                        return function (type, url) {
                            return original(type, addVersion(url));
                        };
                    })($delegate.getTrusted);
                    // ng-view and directives
                    $delegate.getTrustedResourceUrl = (function (original) {
                        return function (url) {
                            return original(addVersion(url));
                        };
                    })($delegate.getTrustedResourceUrl);
                    return $delegate;
                }]);
            $locationProvider.hashPrefix('!');
            //this resolver is now only used for the availability path not the landing page path
            var hotelResolver = {
                bookedEstabId: angular.noop,
                hotel: ['hotelResolver', function (hotelResolver) {
                        return hotelResolver.resolve(false);
                    }]
            };
            var bookingCopyResolver = {
                booking: ['tripService', 'bookingService', '$route', function (tripService, bookingService, $route) {
                        return tripService.restoreSearchUnit($route.current.params.tripId).then(function (trip) {
                            return bookingService.getBooking(trip.BookingId).then(function (b) {
                                return angular.copy(b);
                            });
                        });
                    }]
            };
            function getCookie(key) {
                // this logic has been duplicated from CookieService which we can't access here
                if (!key) {
                    return null;
                }
                return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + "\\s*\\=\\s*([^;]*).*$)|^.*$"), '$1')) || null;
            }
            function getDestination() {
                var json = $('body').attr('destination');
                return json == null ? null : JSON.parse(json);
            }
            $routeProvider.when('/impersonate_customer/:tenantId/:customerId:params?', {
                template: '<div></div>',
                controller: function ($location, $routeParams, authService, bookingService, loggingService) {
                    var tenantId = $routeParams.tenantId, customerId = $routeParams.customerId, trackingTag = $routeParams.trackingTag;
                    var domainTenantId = parseInt(TRPCONFIG.Domain.TenantId);
                    //double check that the tenant supplied is the tenant that we are actually on
                    if (domainTenantId === parseInt(tenantId)) {
                        //note that this will fail if the user is not signed in as an agent - we are not handling that possibility
                        authService.impersonatedSignIn(customerId.toUpperCase())
                            .then(function () { return bookingService.setTrackingTag(trackingTag); })
                            .then(function () { return $location.url('/'); })
                            .catch(function (err) {
                            $location.url('/error');
                            loggingService.logWarn('Impersonation has failed. Please check your permissions, tenant id and customer id. Error: ', JSON.stringify(err));
                        });
                    }
                    else {
                        $location.url('/');
                    }
                }
            });
            function forwardToManageYourBooking(operation) {
                return [
                    '$location',
                    '$http',
                    '$routeParams',
                    'authService',
                    'currentUser',
                    'v1Redirection',
                    'loggingService',
                    function ($location, $http, $routeParams, authService, currentUser, v1Redirection, loggingService) {
                        var tenantId = $routeParams.tenantId, bookingId = $routeParams.bookingId, trackingTag = $routeParams.trackingTag, categoryId = $routeParams.categoryId;
                        var domainTenantId = parseInt(TRPCONFIG.Domain.TenantId);
                        var user = currentUser.get();
                        var authenticateBookingCallback = function () {
                            if (domainTenantId === parseInt(tenantId)) {
                                authService.bookingSignInByAgent(bookingId)
                                    .then(function (anonSignedIn) {
                                    if (!anonSignedIn) {
                                        $location.url('/');
                                        return;
                                    }
                                    var _a = currentUser.get(), Contact = _a.Contact, BookingSummary = _a.BookingSummary;
                                    v1Redirection.v1Redirect({
                                        SID: BookingSummary.SiteId,
                                        BID: BookingSummary.BookingId,
                                        SN: Contact.LastName,
                                        NAV: operation,
                                        trackingTag: trackingTag,
                                        categoryId: categoryId
                                    });
                                })
                                    .catch(function (err) {
                                    loggingService.logWarn("Error signing in booking. Please check permissions, tenant id and booking id. Error: " + JSON.stringify(err));
                                });
                            }
                            else {
                                $location.url('/');
                            }
                        };
                        if (user.AnonSignedIn || user.SignedIn) {
                            return $http.post('/api2/managebooking/signout').then(authenticateBookingCallback);
                        }
                        // Attempt to logout user if it's logged in, but continue execution if it's not logged in
                        authenticateBookingCallback();
                    }
                ];
            }
            $routeProvider.when('/update_booking/:tenantId/:bookingId', {
                template: '<div></div>',
                controller: forwardToManageYourBooking('options')
            });
            $routeProvider.when('/raise_csr/:tenantId/:bookingId:params?', {
                template: '<div></div>',
                controller: forwardToManageYourBooking('amend')
            });
            // duplicates impersonate customer for now
            $routeProvider.when('/new_quote/:tenantId/:customerId:params?', {
                template: '<div></div>',
                controller: function ($location, $routeParams, authService, quoteService) {
                    var tenantId = $routeParams.tenantId, customerId = $routeParams.customerId, trackingTag = $routeParams.trackingTag;
                    //double check that the tenant supplied is the tenant that we are actually on
                    if (TRPCONFIG.Domain.TenantId === parseInt(tenantId)) {
                        //note that this will fail if the user is not signed in as an agent - we are not handling that possibility
                        authService.impersonatedSignIn(customerId.toUpperCase())
                            .then(function () { return quoteService.setTrackingTag(trackingTag); })
                            .then(function () { return $location.url('/'); });
                    }
                }
            });
            $routeProvider.when('/update_quote/:tenantId/:quoteReference', {
                template: '<div></div>',
                controller: function ($location, $routeParams, quoteService, loggingService) {
                    var tenantId = $routeParams.tenantId, quoteReference = $routeParams.quoteReference;
                    var domainTenantId = parseInt(TRPCONFIG.Domain.TenantId);
                    if (domainTenantId !== parseInt(tenantId) && quoteReference.length < 1) {
                        return $location.url('/');
                    }
                    quoteService.getQuoteByReference("QUO/" + quoteReference)
                        .then(function (quote) {
                        if (quote && !quote.Error) {
                            $location.url("/quote/manage/QUO/" + quoteReference);
                            return;
                        }
                        loggingService.logWarn('Quote was not impersonated without error');
                        $location.url('/');
                    })
                        .catch(function (err) {
                        loggingService.logWarn('Error while signing a quote. Please check the permissions, tenant id and quoute id', JSON.stringify(err));
                    });
                }
            });
            $routeProvider.when('/agents/signin', {
                templateUrl: 'partials/agents/signin',
                controllerAs: 'cm',
                controller: 'Agent'
            });
            $routeProvider.when('/agents/settings', {
                templateUrl: 'partials/agents/settings',
                controllerAs: 'cm',
                controller: 'Debug'
            });
            $routeProvider.when('/agents/initiateresetpassword', {
                templateUrl: 'livepartials/agents/initiateresetpassword',
                controllerAs: 'cm',
                controller: 'Agent'
            });
            $routeProvider.when('/admin/resetpassword', {
                templateUrl: 'livepartials/agents/resetpassword',
                controllerAs: 'cm',
                controller: 'Agent'
            });
            $routeProvider.when('/agents/resetsuccessful', {
                templateUrl: 'livepartials/agents/resetsuccessful',
                controllerAs: 'cm',
                controller: 'Agent'
            });
            function configAuthRoutesMyb() {
                var path = 'bookingsignin';
                $routeProvider.when("/" + path, popupAuth ? {
                    resolve: {
                        redirect: ['authRedirection', function (authRedirection) { return authRedirection.authRedirect(path); }]
                    }
                } : {
                    templateUrl: "partials/auth/" + path,
                    controllerAs: 'cm',
                    controller: 'Auth'
                });
            }
            function configureAuthRoutes() {
                var isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
                var enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');
                var v2SigninRequest = !enableV3SignIn || isAgentMode;
                var loginPaths = v2SigninRequest ? ['signin', 'signup', 'bookingsignin', 'forgot'] : ['bookingsignin', 'forgot'];
                loginPaths.forEach(function (path) {
                    $routeProvider.when("/" + path, popupAuth ? {
                        resolve: {
                            redirect: ['authRedirection', function (authRedirection) { return authRedirection.authRedirect(path); }]
                        }
                    } : {
                        templateUrl: "partials/auth/" + path,
                        controllerAs: 'cm',
                        controller: 'Auth'
                    });
                });
                $routeProvider.when('/customer/changepassword', {
                    templateUrl: 'partials/auth/reset',
                    controllerAs: 'cm',
                    controller: 'Auth'
                });
                $routeProvider.when('/customer/verify', {
                    templateUrl: 'partials/auth/verify',
                    controllerAs: 'cm',
                    controller: 'Auth'
                });
                $routeProvider.when('/customer/verifyandchoosepassword', {
                    templateUrl: 'partials/auth/activate',
                    controllerAs: 'cm',
                    controller: 'Auth'
                });
                $routeProvider.when('/resetsuccessful', {
                    templateUrl: 'partials/auth/resetsuccessful',
                    controllerAs: 'cm',
                    controller: 'Auth'
                });
                $routeProvider.when('/verified', {
                    templateUrl: 'partials/auth/verified',
                    controllerAs: 'cm',
                    controller: 'Auth'
                });
                if (!popupAuth) {
                    $routeProvider.when('/changeemailsent', {
                        templateUrl: 'partials/auth/changeemailsent',
                        controllerAs: 'cm',
                        controller: 'Auth'
                    });
                    $routeProvider.when('/verificationsent', {
                        templateUrl: 'partials/auth/verificationsent',
                        controllerAs: 'cm',
                        controller: 'Auth'
                    });
                    $routeProvider.when('/resetsent', {
                        templateUrl: 'partials/auth/resetsent',
                        controllerAs: 'cm',
                        controller: 'Auth'
                    });
                }
            }
            function getBookingFormTemplate(area) {
                if ((!TRPCONFIG.Domain.isAgentMode || TRPCONFIG.Domain.BookingFormV2OnAgentEnabled) && !isMobileSite()) {
                    var version = parseFloat(TRPCONFIG.Domain.BookingFormVersion);
                    if (version > 2) {
                        if (TRPCONFIG.Domain.BookingFormABTest) {
                            var cookieVersion = getCookie('BookingFormVersion');
                            if (parseFloat(cookieVersion) > 2) {
                                return "partials/booking/template?name=Book&version=" + cookieVersion;
                            }
                        }
                        else {
                            return "partials/booking/template?name=Book&version=" + version;
                        }
                    }
                }
                return "partials/" + area + "/book";
            }
            function configureCommonRoutes(areas) {
                angular.forEach(areas, function (area) {
                    $routeProvider.when("/" + area + "/search-" + area + ".aspx", {
                        redirectTo: area
                    });
                    $routeProvider.when("/" + area, {
                        templateUrl: "partials/" + area + "/index",
                        controller: 'Home',
                        controllerAs: 'cm',
                        area: area
                    });
                    $routeProvider.when("/" + area + "/notfound", {
                        templateUrl: 'partials/home/searchnotfound',
                        controllerAs: 'cm',
                        controller: 'NotFound',
                        area: area
                    });
                    $routeProvider.when("/" + area + "/destination", {
                        templateUrl: 'partials/home/destination',
                        controller: 'SearchUnit',
                        controllerAs: 'cm',
                        area: area
                    });
                    $routeProvider.when("/" + area + "/occupancy", {
                        templateUrl: "partials/" + area + "/occupancy",
                        controller: 'Occupancy',
                        controllerAs: 'cm',
                        area: area
                    });
                    $routeProvider.when("/" + area + "/book/:tripId%", {
                        templateUrl: getBookingFormTemplate(area),
                        controllerAs: 'cm',
                        controller: 'Booking',
                        area: area,
                        analyticsTag: 'Booking Form',
                        pixelTrackingPageName: area + "BookingForm",
                        noGroup: true,
                        hideDistractionLinks: true,
                        hideTravelAgentLinks: true,
                        breadcrumb: {
                            crumb: 50
                        }
                    });
                    $routeProvider.when("/" + area + "/book/:tripId%/:direction/departuredate", {
                        templateUrl: "partials/" + area + "/departuredate",
                        controllerAs: 'cm',
                        controller: 'FlightCapture',
                        resolve: bookingCopyResolver,
                        hideDistractionLinks: true,
                        hideTravelAgentLinks: true
                    });
                    $routeProvider.when("/" + area + "/book/:tripId%/:direction/departureairport", {
                        templateUrl: "partials/" + area + "/departureairports",
                        controllerAs: 'cm',
                        controller: 'FlightCapture',
                        area: 'flights',
                        noGroup: true,
                        resolve: bookingCopyResolver,
                        hideDistractionLinks: true,
                        hideTravelAgentLinks: true
                    });
                    $routeProvider.when("/" + area + "/book/:tripId%/:direction/destinationairport", {
                        templateUrl: "partials/" + area + "/destinationairports",
                        controllerAs: 'cm',
                        controller: 'FlightCapture',
                        area: 'flights',
                        resolve: bookingCopyResolver,
                        hideDistractionLinks: true,
                        hideTravelAgentLinks: true
                    });
                    $routeProvider.when("/" + area + "/departureairport", {
                        templateUrl: "partials/" + area + "/searchunitdepartureairports",
                        controller: [
                            '$window', 'searchUnitService', function ($window, searchUnitService) {
                                var cm = this;
                                cm.setDepartureAirport = function (item) {
                                    searchUnitService.setDepartureAirports(item);
                                    setTimeout(function () {
                                        $window.history.back();
                                    }, 0);
                                };
                            }
                        ],
                        controllerAs: 'cm',
                        area: 'flights'
                    });
                });
            }
            function configureHotelRoutes() {
                //make sure that this doesn't get incorrectly interpreted as availability results
                $routeProvider.when('/hotels/hotel-listings.aspx', {
                    redirectTo: '/hotels'
                });
                $routeProvider.when('/hotels/:tripId%', {
                    templateUrl: 'partials/hotels/hotelsearch',
                    area: 'hotels',
                    analyticsTag: 'Hotel Selection',
                    pixelTrackingPageName: 'hotelsSearchResults',
                    reloadOnSearch: false,
                    breadcrumb: {
                        crumb: 20
                    }
                });
                $routeProvider.when('/hotels/:tripId%/:estabId', {
                    templateUrl: 'partials/hotels/availability',
                    controller: 'HotelAvailability',
                    controllerAs: 'cm',
                    area: 'hotels',
                    analyticsTag: 'Room Selection',
                    pixelTrackingPageName: 'hotelsRoomSelection',
                    resolve: hotelResolver,
                    breadcrumb: {
                        crumb: 21,
                        squash: true
                    }
                });
            }
            $routeProvider.when('/sitemap/:landingPageV3£/:urlText*', {
                templateUrl: 'partials/hotels/hotelssitemap',
                controller: 'HotelsSitemap',
                controllerAs: 'cm',
                area: 'hotels'
            });
            $routeProvider.when('/sitemap/:landingPageV2€/:urlText*', {
                templateUrl: 'partials/hotels/hotelssitemap',
                controller: 'HotelsSitemap',
                controllerAs: 'cm',
                area: 'hotels'
            });
            function configureHolidayRoutes() {
                $routeProvider.when('/holidays/departure', {
                    templateUrl: 'partials/holidays/departure',
                    controller: 'Departure',
                    controllerAs: 'cm'
                });
                $routeProvider.when('/holidays/flights/search', {
                    templateUrl: 'partials/holidays/flightsearch',
                    controller: ['flightSearch', '$location', 'hotelSearch', function (flightSearch, $location, hotelSearch) {
                            flightSearch.search().then(function (data) {
                                hotelSearch.search(data.AvailabilitySearchId);
                                $location.path("/holidays/flights/" + data.AvailabilitySearchId);
                            });
                        }]
                });
                $routeProvider.when('/holidays/flights/:tripId%', {
                    templateUrl: 'partials/holidays/flightresults',
                    controller: 'HolidaySearch',
                    controllerAs: 'cm',
                    area: 'holidays',
                    analyticsTag: 'Flight Selection',
                    pixelTrackingPageName: 'holidaysFlightSearch',
                    breadcrumb: {
                        crumb: 10
                    }
                });
                $routeProvider.when('/holidays/hotels/:tripId%', {
                    templateUrl: 'partials/holidays/hotelsearch',
                    reloadOnSearch: false,
                    area: 'holidays',
                    analyticsTag: 'Hotel Selection',
                    pixelTrackingPageName: 'holidaysHotelsSearchResults',
                    breadcrumb: {
                        crumb: 20
                    }
                });
                $routeProvider.when('/holidays/january-sale', {
                    template: '<div></div>',
                    controller: ['$scope', 'resourceService', 'basketService', function ($scope, resourceService, basketService) {
                            $scope.$emit('block', {
                                title: resourceService.get('SEARCHINGHOTELS'),
                                subtitle: resourceService.get('THISMAYTAKE'),
                                loadingScreenStyle: 'default-searchUnitCtrl'
                            });
                            basketService.startMultiDestHolidayWorkflow();
                        }]
                });
                $routeProvider.when('/holidays/january-sale/:tripId%', {
                    templateUrl: 'partials/holidays/hotelsearch?multiDestination=true',
                    // HTML has `ng-controller="HotelSearch as cm"`
                    reloadOnSearch: false,
                    area: 'holidays',
                    analyticsTag: 'Hotel Selection',
                    pixelTrackingPageName: 'holidaysJanuarySale'
                });
                $routeProvider.when('/holidays/options/:tripId%/:productId?', {
                    templateUrl: 'partials/holidays/options',
                    controllerAs: 'cm',
                    controller: 'Options',
                    area: 'holidays',
                    analyticsTag: 'Options',
                    pixelTrackingPageName: 'holidaysOptions',
                    hideDistractionLinks: true,
                    breadcrumb: {
                        crumb: 40
                    }
                });
                $routeProvider.when('/hotels/options/:tripId%', {
                    templateUrl: 'partials/hotels/hoteloptions',
                    controllerAs: 'cm',
                    controller: 'HotelOptions',
                    area: 'hotels',
                    analyticsTag: 'HotelOptions',
                    pixelTrackingPageName: 'hotelsOptions',
                    hideDistractionLinks: true,
                    breadcrumb: {
                        crumb: 40
                    }
                });
                $routeProvider.when('/holidays/:tripId%/:estabId', {
                    templateUrl: 'partials/holidays/availability',
                    controller: 'HotelAvailability',
                    controllerAs: 'cm',
                    area: 'holidays',
                    analyticsTag: 'Room Selection',
                    pixelTrackingPageName: 'holidaysRoomSelection',
                    reloadOnSearch: false,
                    resolve: hotelResolver,
                    breadcrumb: {
                        crumb: 21,
                        squash: true
                    }
                });
                $routeProvider.when('/holidays/hotels/:tripId%/:estabId', {
                    templateUrl: 'partials/holidays/availability',
                    controller: 'HotelAvailability',
                    controllerAs: 'cm',
                    area: 'holidays',
                    analyticsTag: 'Room Selection',
                    pixelTrackingPageName: 'holidaysRoomSelection',
                    reloadOnSearch: false,
                    resolve: hotelResolver,
                    breadcrumb: {
                        crumb: 21,
                        squash: true
                    }
                });
                if (TRPCONFIG.Domain.AprilCampaignRoutes) {
                    TRPCONFIG.Domain.AprilCampaignRoutes.forEach(function (url) {
                        $routeProvider.when("/" + url, {
                            templateUrl: 'partials/holidaydeals/aprilcampaign',
                            controller: 'seasonalDeals',
                            controllerAs: 'sd',
                            area: 'holidays',
                            reloadOnSearch: false
                        });
                    });
                }
                if (TRPCONFIG.Domain.ActiveSeasonalDeals) {
                    TRPCONFIG.Domain.ActiveSeasonalDeals.forEach(function (deal) {
                        $routeProvider.when(deal.Url, {
                            templateUrl: "partials/holidaydeals/seasonaldeals?seasonCode=" + deal.SeasonCode,
                            controller: 'seasonalDeals',
                            controllerAs: 'sd',
                            area: 'holidays',
                            reloadOnSearch: false
                        });
                    });
                }
                if (TRPCONFIG.Domain.LastMinuteDealsPageEnabled) {
                    $routeProvider.when('/holidaydeals:params?', {
                        templateUrl: 'partials/holidaydeals/lastminutedealspromo',
                        controller: 'lastMinuteDeals',
                        controllerAs: 'ldp',
                        area: 'holidays',
                        reloadOnSearch: false
                    });
                    $routeProvider.when('/holidaydealspromo/:params?', {
                        redirectTo: '/holidaydeals'
                    });
                    $routeProvider.when('/holidaydeals/occupancy', {
                        templateUrl: 'partials/holidaydeals/occupancy',
                        controller: 'Occupancy',
                        controllerAs: 'cm',
                        area: 'holidays'
                    });
                }
                else {
                    $routeProvider.when('/holidaydeals/:params?', {
                        templateUrl: 'partials/holidaydeals/holidaydealsresults',
                        controller: 'HolidayDealsResults',
                        controllerAs: 'hd',
                        area: 'holidays',
                        reloadOnSearch: false
                    });
                    $routeProvider.when('/holidaydealspromo/:params?', {
                        templateUrl: 'partials/holidaydeals/holidaydealspromo',
                        controller: 'HolidayDealsPromo',
                        controllerAs: 'hdp',
                        area: 'holidays',
                        reloadOnSearch: false
                    });
                }
                $routeProvider.when('/offers/early-summer-2019-holidays', {
                    redirectTo: '/offers/early-summer-holidays'
                });
                $routeProvider.when('/recommendations/loading', {
                    templateUrl: 'partials/recommendations/loading',
                    controller: 'Loading',
                    controllerAs: 'ld'
                });
            }
            function configureTransferRoutes() {
                $routeProvider.when('/transfers/destinationairports', {
                    templateUrl: 'partials/home/destinationairports',
                    controller: 'TransferAirports',
                    controllerAs: 'cm',
                    area: 'transfers'
                });
                $routeProvider.when('/transfers/resorts', {
                    templateUrl: 'partials/home/resorts',
                    controller: 'Resorts',
                    controllerAs: 'cm'
                });
                $routeProvider.when('/transfers/direction', {
                    templateUrl: 'partials/home/direction',
                    controller: 'TransferDirection',
                    controllerAs: 'cm',
                    area: 'transfers'
                });
                $routeProvider.when('/transfers/departuredate', {
                    templateUrl: 'partials/transfers/arrivaldate',
                    controller: 'SearchUnit',
                    controllerAs: 'cm',
                    area: 'transfers'
                });
                $routeProvider.when('/transfers/returndate', {
                    templateUrl: 'partials/transfers/returndate',
                    controller: 'SearchUnit',
                    controllerAs: 'cm',
                    area: 'transfers'
                });
                $routeProvider.when('/transfers/:tripId%', {
                    templateUrl: 'partials/transfers/search',
                    controller: 'TransferSearch',
                    controllerAs: 'cm',
                    area: 'transfers',
                    analyticsTag: 'Transfer Selection',
                    pixelTrackingPageName: 'transfersSearchResults',
                    breadcrumb: {
                        crumb: 30
                    }
                });
            }
            function isMobileSite() {
                return TRPCONFIG.IsMobileView;
            }
            function configureMarhabaRoutes() {
                $routeProvider.when('/marhaba', {
                    templateUrl: 'partials/marhaba/index',
                    controller: 'Home',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/occupancy', {
                    templateUrl: 'partials/marhaba/occupancy',
                    controller: 'Occupancy',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/book/:tripId%/:productId', {
                    templateUrl: function () { return getBookingFormTemplate('marhaba'); },
                    controllerAs: 'cm',
                    controller: 'Booking',
                    area: 'marhaba',
                    noGroup: true,
                    pixelTrackingPageName: 'marhabaBookingForm',
                    hideDistractionLinks: true,
                    hideTravelAgentLinks: true
                });
                $routeProvider.when('/marhaba/departuredate', {
                    templateUrl: 'partials/transfers/arrivaldate',
                    controller: 'SearchUnit',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/destinationairports', {
                    templateUrl: 'partials/marhaba/marhabaairports',
                    controller: 'MarhabaAirports',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/terminal', {
                    templateUrl: 'partials/marhaba/terminal',
                    controller: 'Terminal',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/flighttype', {
                    templateUrl: 'partials/marhaba/flighttype',
                    controller: 'FlightType',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/notfound', {
                    templateUrl: 'partials/marhaba/searchnotfound'
                });
                $routeProvider.when('/marhaba/connectingairport/:tripId%/:productId?', {
                    templateUrl: 'partials/marhaba/destinationairports',
                    controller: 'ConnectingAirport',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/:tripId%/:productId', {
                    templateUrl: 'partials/marhaba/options',
                    controller: 'MarhabaOptions',
                    pixelTrackingPageName: 'marhabaOptions',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
                $routeProvider.when('/marhaba/book/:tripId%/passenger/:room/:index/:productId', {
                    templateUrl: 'partials/holidays/passenger',
                    controller: 'Passenger',
                    controllerAs: 'cm',
                    hideDistractionLinks: true,
                    hideTravelAgentLinks: true
                });
                $routeProvider.when('/marhaba/:tripId%', {
                    templateUrl: 'partials/marhaba/availability',
                    controller: 'MarhabaAvailability',
                    pixelTrackingPageName: 'marhabaSearchResults',
                    controllerAs: 'cm',
                    area: 'marhaba'
                });
            }
            function configureParkingRoutes() {
                var area = 'parking';
                $routeProvider.when('/parking', {
                    templateUrl: 'partials/parking/index',
                    controllerAs: 'cm',
                    controller: 'ParkingSearchUnit',
                    area: area
                });
                $routeProvider.when("/" + area + "/dropoffdate", {
                    templateUrl: "partials/" + area + "/dropoffdate",
                    controller: 'ParkingSearchUnit',
                    controllerAs: 'cm',
                    area: area
                });
                $routeProvider.when("/" + area + "/pickupdate", {
                    templateUrl: "partials/" + area + "/pickupdate",
                    controller: 'ParkingSearchUnit',
                    controllerAs: 'cm',
                    area: area
                });
                $routeProvider.when("/" + area + "/occupancy", {
                    templateUrl: "partials/" + area + "/occupancy",
                    controller: 'Occupancy',
                    controllerAs: 'cm',
                    area: area
                });
                $routeProvider.when("/" + area + "/departureairport", {
                    templateUrl: "partials/" + area + "/searchunitdepartureairports",
                    controller: [
                        '$window', 'searchUnitService', function ($window, searchUnitService) {
                            var cm = this;
                            cm.setDepartureAirport = function (item) {
                                searchUnitService.setDepartureAirports(item);
                                setTimeout(function () {
                                    $window.history.back();
                                }, 0);
                            };
                        }
                    ],
                    controllerAs: 'cm',
                    area: area
                });
                $routeProvider.when("/" + area + "/:tripId%", {
                    templateUrl: 'partials/parking/parkingresults',
                    controllerAs: 'cm',
                    controller: 'ParkingResults',
                    area: area,
                    analyticsTag: 'Parking Selection',
                    breadcrumb: {
                        crumb: 35
                    }
                });
            }
            function configureInsuranceRoutes() {
                $routeProvider.when('/insurance', {
                    templateUrl: 'partials/insurance/index',
                    controller: 'Home',
                    area: 'insurance'
                });
                $routeProvider.when('/insurance/book/:tripId%', {
                    templateUrl: getBookingFormTemplate('insurance'),
                    controllerAs: 'cm',
                    controller: 'Booking',
                    area: 'insurance',
                    noGroup: true,
                    hideDistractionLinks: true,
                    hideTravelAgentLinks: true
                });
                $routeProvider.when('/insurance/notfound', {
                    templateUrl: 'partials/insurance/searchnotfound',
                    controller: 'NotFound',
                    controllerAs: 'cm'
                });
                $routeProvider.when('/insurance/results/:tripId%', {
                    templateUrl: 'partials/insurance/insuranceresults',
                    controller: 'InsuranceResults',
                    pixelTrackingPageName: 'insuranceSearchResults',
                    controllerAs: 'cm',
                    area: 'insurance'
                });
            }
            function termsProviderTemplate(params) {
                var sup = '';
                angular.forEach(params.suppliers.split('|'), function (s) {
                    sup += "&suppliers=" + s;
                });
                return String.format('partials/terms/provider?cultureCode={0}&bookingProcessId={1}{2}&transferRateId={3}', params.culture, params.bookingId, sup, params.transferRate);
            }
            function configureHelpRoutes() {
                $routeProvider.when('/help', {
                    templateUrl: 'partials/help/index',
                    analyticsTag: ' Help'
                });
                angular.forEach(TRPCONFIG.Domain.HelpRoutes || [], function (path) {
                    $routeProvider.when("/help/" + path, {
                        templateUrl: "partials/help/" + path,
                        analyticsTag: 'Help'
                    });
                });
                $routeProvider.when('/terms/agency', {
                    templateUrl: 'partials/terms/agency',
                    analyticsTag: 'Terms',
                    pixelTrackingPageName: 'termsAgency'
                });
                //we need to have a special hard-coded italian route here temporarily due to an error
                //in the ios app
                $routeProvider.when('/termini/fornitore/:culture/:bookingId/:suppliers/:transferRate?', {
                    templateUrl: termsProviderTemplate
                });
                $routeProvider.when('/terms/provider/:culture/:bookingId/:suppliers/:transferRate?', {
                    templateUrl: termsProviderTemplate
                });
            }
            function configureFlightsRoutes() {
                $routeProvider.when('/flights/destinationairports', {
                    templateUrl: 'partials/home/destinationairports',
                    controller: 'TransferAirports',
                    controllerAs: 'cm',
                    area: 'flights'
                });
                $routeProvider.when('/flights/:tripId%', {
                    templateUrl: 'partials/flights/flightresults',
                    controller: 'HolidaySearch',
                    controllerAs: 'cm',
                    pixelTrackingPageName: 'flightsSearchResults',
                    area: 'flights',
                    breadcrumb: {
                        crumb: 10
                    }
                });
                $routeProvider.when('/multiflights/:tripId%', {
                    templateUrl: 'partials/flights/multiflightresults',
                    controller: 'MultiFlightsSearch',
                    controllerAs: 'mfs',
                    area: 'multisector'
                });
            }
            if (TRPCONFIG.Domain.UseIdBasedHotelUrls) {
                $routeProvider.when('/:landingPageV2€/:urlText*', {
                    templateUrl: 'partials/landingpage/landingcontainer?landing=true',
                    area: 'hotels',
                    analyticsTag: 'Landing Page',
                    pixelTrackingPageName: 'landingPage',
                    controller: 'LandingPage',
                    controllerAs: 'lp',
                    reloadOnSearch: false,
                    landing: true
                });
            }
            if (TRPCONFIG.Domain.UrlRouteTesting || TRPCONFIG.Domain.UseIdBasedUrls) {
                $routeProvider.when('/:landingPageV3£/:urlText*', {
                    templateUrl: 'partials/landingpage/landingcontainer?landing=true',
                    controller: 'LandingPage',
                    analyticsTag: 'Landing Page',
                    pixelTrackingPageName: 'landingPage',
                    controllerAs: 'lp',
                    reloadOnSearch: false,
                    landing: true
                });
                $routeProvider.when('/:urlText*/:landingPageV4£', {
                    templateUrl: 'partials/landingpage/landingcontainer?landing=true',
                    controller: 'LandingPage',
                    controllerAs: 'lp',
                    analyticsTag: 'Landing Page',
                    pixelTrackingPageName: 'landingPage',
                    reloadOnSearch: false,
                    landing: true
                });
            }
            $routeProvider.when('/:landingPage*.html', {
                templateUrl: 'partials/landingpage/landingcontainer?landing=true',
                controller: 'LandingPage',
                analyticsTag: 'Landing Page',
                pixelTrackingPageName: 'landingPage',
                controllerAs: 'lp',
                reloadOnSearch: false,
                landing: true
            });
            function configureProductRoutes(product) {
                switch (product) {
                    case 'hotels':
                        configureHotelRoutes();
                        break;
                    case 'flights':
                        configureFlightsRoutes();
                        break;
                    case 'holidays':
                        configureHolidayRoutes();
                        break;
                    case 'transfers':
                        configureTransferRoutes();
                        break;
                    case 'marhaba':
                        configureMarhabaRoutes();
                        break;
                    case 'parking':
                        configureParkingRoutes();
                        break;
                    case 'insurance':
                        configureInsuranceRoutes();
                        break;
                }
            }
            //we still need to handle the old landing page routes for the time being
            function rerouteOldLandingPage(args, $route, destinationService, $location, urlUtils) {
                $route.current.$$route.area = args.area;
                destinationService.getDetails({
                    CountryId: args.countryId,
                    ProvinceId: args.provinceId,
                    LocationId: args.locationId,
                    PlaceId: args.placeId,
                    PolygonId: args.polygonId,
                    EstablishmentId: 0
                }, { fields: 'PagePath' }).then(function (dest) {
                    $location.path(urlUtils.stripLeadingSlash(dest.PagePath));
                });
            }
            $routeProvider.when('/:area/hotel/:estabId', {
                template: '<div></div>',
                controller: function ($route, $routeParams, $location, hotelRehydrator, urlUtils, pageStrand) {
                    $route.current.$$route.area = $routeParams.area;
                    var strand = pageStrand.fromRoute();
                    hotelRehydrator.hotels([$routeParams.estabId], { fields: ['Id', 'Url'] }).then(function (hotels) {
                        $location.url(pageStrand.adjustUrl(urlUtils.stripLeadingSlash(hotels[0].Url), strand));
                    });
                }
            });
            $routeProvider.when('/:area/destination/:countryId/:provinceId/:locationId/:placeId/:polygonId', {
                template: '<div></div>',
                controller: function ($route, $routeParams, $location, destinationService, urlUtils) {
                    rerouteOldLandingPage($routeParams, $route, destinationService, $location, urlUtils);
                }
            });
            $routeProvider.when('/:area/destination/:countryId', {
                template: '<div></div>',
                controller: function ($route, $routeParams, $location, destinationService, urlUtils) {
                    rerouteOldLandingPage({
                        area: $routeParams.area,
                        countryId: $routeParams.countryId,
                        provinceId: 0,
                        locationId: 0,
                        placeId: 0,
                        polygonId: 0
                    }, $route, destinationService, $location, urlUtils);
                }
            });
            var commonRoutes = [];
            var supportedProducts = TRPCONFIG.Domain.SupportedProducts;
            var products = {
                none: 0,
                hotels: 1,
                flights: 2,
                holidays: 4,
                transfers: 8,
                carhire: 16,
                marhaba: 32,
                // attractions: 64,
                parking: 128,
                insurance: 256
            };
            function isSupported(product) {
                // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Flags_and_bitmasks
                // eslint-disable-next-line no-bitwise
                return (products[product] | supportedProducts) === supportedProducts;
            }
            ['flights', 'holidays', 'transfers', 'hotels', 'parking'].forEach(function (product) {
                if (isSupported(product)) {
                    commonRoutes.push(product);
                }
            });
            configureCommonRoutes(commonRoutes);
            ['hotels', 'flights', 'holidays', 'transfers', 'marhaba', 'parking', 'insurance'].forEach(function (product) {
                // NOTE: attractions routes defined in attractions.config.ts
                if (isSupported(product)) {
                    configureProductRoutes(product);
                }
            });
            if (TRPCONFIG.Domain.AccountsEnabled) {
                configureAuthRoutes();
            }
            // New config function For EKH MYB, only the dashboard sign in is available
            if (TRPCONFIG.Domain.DashboardBookingEnabled) {
                configAuthRoutesMyb();
            }
            configureHelpRoutes();
            $routeProvider.when('/booking/complete/paypal/:tripId%/:ref*', {
                controller: 'BookingComplete',
                controllerAs: 'cm',
                analyticsTag: 'Booking Complete',
                inTransactionalFlow: true,
                hideFooterToolbar: true,
                templateUrl: function (params) {
                    var qs = "?bookingRef=" + params.ref.split('|').join('&bookingRef=');
                    return "partials/home/bookingcomplete" + qs;
                }
            });
            $routeProvider.when('/booking/complete/:ref*', {
                controller: 'BookingComplete',
                controllerAs: 'cm',
                analyticsTag: 'Booking Complete',
                pixelTrackingPageName: 'bookingComplete',
                inTransactionalFlow: true,
                hideFooterToolbar: true,
                templateUrl: function (params) {
                    var qs = "?bookingRef=" + params.ref.split('|').join('&bookingRef=');
                    return "partials/home/bookingcomplete" + qs;
                }
            });
            $routeProvider.when('/booking/complete', {
                templateUrl: 'partials/home/bookingcomplete',
                analyticsTag: 'Booking Complete',
                inTransactionalFlow: true,
                hideFooterToolbar: true,
                controller: function ($scope, broker) {
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }
            });
            function createDesktopCookie(domain) {
                var name = 'trpDesktop';
                var date = new Date();
                date.setTime(date.getTime() + (2 * 60 * 60 * 1000));
                document.cookie = String.format("{0}={0}; expires={1}; path=/; domain=" + domain, name, date.toGMTString());
            }
            $routeProvider.when('/desktop-myb/:SID/:BID/:SN/:NAV', {
                template: '<div></div>',
                controller: ['$routeParams', function ($p) {
                        var domain = TRPCONFIG.Domain.HostName;
                        var desktopUrl = "https://www." + domain;
                        desktopUrl += '/manage-your-booking/login.aspx';
                        desktopUrl += "?SID=" + $p.SID + "&BID=" + $p.BID + "&SN=" + $p.SN;
                        desktopUrl += "&navpage=" + $p.NAV;
                        createDesktopCookie(domain);
                        location.replace(desktopUrl);
                    }]
            });
            $routeProvider.when('/desktop-site', {
                template: '<div></div>',
                controller: [function () {
                        var domain = TRPCONFIG.Domain.HostName;
                        var desktopUrl = TRPCONFIG.Domain.RedirectToDesktopUrl || "https://www." + domain;
                        createDesktopCookie(domain);
                        location.replace(desktopUrl);
                    }]
            });
            $routeProvider.when('/apis-unsubscribe', {
                templateUrl: function () { return "unsubscribe/apisUnsubscribe" + location.search; }
            });
            $routeProvider.when('/nps-unsubscribe', {
                templateUrl: function () { return "unsubscribe/npsUnsubscribe" + location.search; }
            });
            if (TRPCONFIG.Domain.ShortlistsEnabled) {
                $routeProvider.when('/shortlist', {
                    templateUrl: 'partials/shortlist/index',
                    controller: 'Shortlist',
                    controllerAs: 'cm',
                    analyticsTag: 'Hotel Shortlist'
                });
            }
            if (TRPCONFIG.Domain.RecentHotelsEnabled) {
                $routeProvider.when('/recenthotels', {
                    templateUrl: 'partials/recenthotels/index',
                    controller: 'RecentHotels',
                    controllerAs: 'cm',
                    analyticsTag: 'Recent Hotels'
                });
            }
            $routeProvider.when('/error', {
                templateUrl: 'partials/home/error',
                analyticsTag: 'Error Page',
                pixelTrackingPageName: 'errorPage',
                controller: function ($scope, broker) {
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }
            });
            $routeProvider.when('/errordatesmismatch', {
                templateUrl: 'partials/home/errordatesmismatch',
                analyticsTag: 'Error Page',
                pixelTrackingPageName: 'errorDatesMismatch',
                controller: function ($scope, broker) {
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }
            });
            $routeProvider.when('/bookingalreadydone', {
                templateUrl: 'partials/home/bookingnotfound',
                analyticsTag: 'Booking Already Done',
                pixelTrackingPageName: 'bookingAlreadyDone',
                controller: function ($scope, broker) {
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }
            });
            $routeProvider.when('/pagenotfound', {
                templateUrl: 'partials/home/pagenotfound',
                analyticsTag: 'Page Not Found',
                pixelTrackingPageName: 'pageNotFound',
                controller: function ($scope, broker) {
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }
            });
            $routeProvider.when('/selectcountry', {
                templateUrl: 'partials/home/selectcountry'
            });
            $routeProvider.when('/holidays/flightunavailable', {
                templateUrl: 'partials/holidays/flightunavailable'
            });
            if (TRPCONFIG.Domain.PromotionTermsPageEnabled) {
                $routeProvider.when('/promotionterms', {
                    templateUrl: 'partials/information/promotiontermsandcond',
                    controller: 'PromotionTerms',
                    controllerAs: 'pt'
                });
            }
            //this is just a little bit of routing required when paypal payment doesn't go through for some reason
            $routeProvider.when('/paypalfail/:tripId%', {
                template: '<div></div>',
                controller: ['$location', '$routeParams', 'basketStore', 'tripService', function ($location, $routeParams, basketStore, tripService) {
                        tripService.getTrip($routeParams.tripId).then(function (trip) {
                            if (trip) {
                                basketStore.all(trip.BasketId).then(function (products) {
                                    if (products.t != null) {
                                        $location.url("transfers/book/" + $routeParams.tripId + "?ppResp=" + $routeParams.ppResp);
                                    }
                                    else if (products.f != null) {
                                        $location.url("holidays/book/" + $routeParams.tripId + "?ppResp=" + $routeParams.ppResp);
                                    }
                                    else {
                                        $location.url("hotels/book/" + $routeParams.tripId + "?ppResp=" + $routeParams.ppResp);
                                    }
                                });
                            }
                        });
                    }]
            });
            $routeProvider.when('/keymessages', {
                templateUrl: 'partials/home/keymessagestext',
                controller: ['$scope', '$window', function (scope, $window) {
                        scrollTo(0, 0);
                        scope.back = function () {
                            setTimeout(function () {
                                $window.history.back();
                            }, 0);
                        };
                    }]
            });
            $routeProvider.when('/landing-pages/destination.aspx', {
                redirectTo: function () {
                    var destination = getDestination();
                    if (destination == null) {
                        return 'hotels';
                    }
                    if (destination.EstablishmentId > 0) {
                        return "hotels/hotel/" + destination.EstablishmentId + "?pd=" + destination.pd;
                    }
                    return "hotels?k=" + destination.k;
                }
            });
            //$routeProvider.when('/keymessages', {
            //    templateUrl: 'partials/home/keymessagestext',
            //    controller: ['$scope', '$window', function (scope, $window) {
            //        scrollTo(0, 0);
            //        scope.back = function () {
            //            setTimeout(function () {
            //                $window.history.back();
            //            }, 0);
            //        };
            //    }]
            //});
            $routeProvider.when('/keymessages', {
                templateUrl: 'partials/home/keymessagestext',
                controller: ['$scope', '$window', function (scope, $window) {
                        scrollTo(0, 0);
                        scope.back = function () {
                            setTimeout(function () {
                                $window.history.back();
                            }, 0);
                        };
                    }]
            });
            if (!TRPCONFIG.Domain.CMSHomePageEnabled) {
                var newHomeConf = {
                    bodyUncontained: true,
                    templateUrl: 'partials/home/newindex'
                };
                var mobileHomeConf = {
                    bodyUncontained: true,
                    templateUrl: 'partials/home/newindex'
                };
                var superHeroConf = {
                    bodyUncontained: true,
                    templateUrl: 'partials/home/superherotest'
                };
                $routeProvider.when('/', Object.assign({
                    templateUrl: 'partials/home/index',
                    controller: 'Home',
                    area: isSupported('holidays') ? 'holidays' : 'hotels',
                    strapLine: true,
                    isResponsive: true,
                    pixelTrackingPageName: 'homePage'
                }, !isMobileSite() && TRPCONFIG.Domain.NewHomepageEnabled && newHomeConf, !isMobileSite() && TRPCONFIG.Domain.SuperheroBannerEnabled && superHeroConf, isMobileSite() && TRPCONFIG.Domain.NewMobileHomepageEnabled && mobileHomeConf));
            }
            $routeProvider.when('/selectdomain', {
                templateUrl: 'livepartials/home/selectdomain',
                controllerAs: 'cm',
                controller: 'SelectDomain'
            });
            $routeProvider.when('/selectoffice', {
                templateUrl: 'livepartials/home/selectoffice',
                controllerAs: 'cm',
                controller: 'SelectOffice'
            });
            $routeProvider.when('/agentsettings', {
                templateUrl: 'livepartials/home/agentsettings',
                controllerAs: 'cm',
                controller: 'Agent'
            });
            $routeProvider.when('/brochure', {
                templateUrl: 'partials/home/brochure'
            });
            $routeProvider.when('/apps', {
                templateUrl: 'partials/home/apppromo',
                controllerAs: 'ap',
                controller: 'AppPromo'
            });
            $routeProvider.when('/test-page', {
                templateUrl: 'partials/information/testpage',
                controllerAs: 'cm',
                controller: 'TestPage'
            });
            $routeProvider.when('/test-home', {
                templateUrl: 'partials/information/testhome',
                controllerAs: 'cm',
                controller: 'TestHome',
                bodyUncontained: true
            });
            $routeProvider.when('/test-components', {
                templateUrl: 'partials/information/testcomponents'
            });
            if (TRPCONFIG.DynamicRoutingEnabled) {
                $routeProvider.otherwise({
                    template: '<div ng-include="cc.template"><h1>Loading...</h1></div>',
                    controllerAs: 'cc',
                    controller: 'DynamicRouting'
                });
            }
            else {
                $routeProvider.otherwise({ redirectTo: '/' });
            }
            delete $httpProvider.defaults.headers.common['X-Requested-With'];
            delete $httpProvider.defaults.headers.common['x-requested-with'];
            $locationProvider.html5Mode(true).hashPrefix('!');
        }]);
    TR.run([
        '$location', '$route', '$rootScope', 'authService', 'analytics', 'cancellerService', 'broker', 'authRedirection', 'cookieService', '$injector', '$templateCache', 'AD_FORM_FLAGS', 'DTCM_FLAGS', 'urlStoreService', 'v2v3HandoverService',
        function ($location, $route, $rootScope, authService, analytics, cancellerService, broker, authRedirection, cookieService, $injector, $templateCache, AD_FORM_FLAGS, DTCM_FLAGS, urlStoreService, v2v3HandoverService) {
            if (TRPCONFIG.Domain.BD4TRecommenderEnabled && !window.Mocha) {
                //On live must be referenced, so that it's constructors will run, so the broker will subscribe :(
                //However this cannot run during unit tests because the resource service will not be mockable.
                $injector.get('recommender');
                $injector.get('houseRecommender');
            }
            $templateCache.put('loadingcmscomponent.html', '<div></div>');
            $rootScope.ShortlistsEnabled = TRPCONFIG.Domain.ShortlistsEnabled;
            $rootScope.EnableSavedSearches = TRPCONFIG.EnableSavedSearches;
            $rootScope.MenuEnabled = TRPCONFIG.MenuEnabled;
            $rootScope.ManageBookingEnabled = TRPCONFIG.ManageBookingEnabled;
            $rootScope.SignInEnabled = TRPCONFIG.SignInEnabled;
            $rootScope.AD_FORM_FLAGS = AD_FORM_FLAGS;
            $rootScope.DTCM_FLAGS = DTCM_FLAGS;
            analytics.pageLoad($location.absUrl());
            $rootScope.$on('$routeChangeSuccess', function () {
                analytics.routeChange($location.absUrl(), $location.url());
                if (TRPCONFIG.Domain.SalesforceChatEnabled && window.salesForceSetCurrentUrl) {
                    window.salesForceSetCurrentUrl();
                }
                $rootScope.showErrors = false;
                broker.publish('selfdestruct');
                urlStoreService.pushURL();
            });
            $rootScope.$on('$routeChangeStart', function (ev, next) {
                var currentPath = $location.path();
                var redirectEstabLandingPath = v2v3HandoverService.redirectEstabLandingPath(currentPath);
                var redirectDestLandingPath = v2v3HandoverService.redirectDestLandingPath(currentPath);
                var redirectLoginPaths = v2v3HandoverService.redirectLoginPaths(currentPath);
                var isV2Request = v2v3HandoverService.isV2Request();
                var windowLocationReplace = function (path) {
                    var search = window.location.search;
                    var _a = window.location, hostname = _a.hostname, protocol = _a.protocol, pathname = _a.pathname;
                    var paths = pathname && pathname.split('/').filter(function (path) { return path; })[0] || '';
                    var v2Paths = paths ? paths.toLowerCase() : '';
                    var isV2OnlyJourney = (v2Paths === 'transfers' || v2Paths === 'attractions');
                    if (search && redirectLoginPaths) {
                        search = '';
                    }
                    var parasolRoutingPrefix = TRPCONFIG.Domain2.ParasolRoutingPrefix.trim();
                    var prefix = parasolRoutingPrefix ? "/" + parasolRoutingPrefix : '';
                    var v3prefix = (redirectDestLandingPath || redirectEstabLandingPath || redirectLoginPaths || isV2OnlyJourney) ? '' : prefix;
                    var port = (/(www|m).dev.travelrepublic/.test(hostname) && !isV2OnlyJourney) ? ':3000' : '';
                    window.location = protocol + "//" + hostname + port + v3prefix + path + search;
                };
                if (redirectEstabLandingPath && !isV2Request) {
                    windowLocationReplace(currentPath);
                    return;
                }
                if (redirectDestLandingPath && !isV2Request) {
                    windowLocationReplace(currentPath);
                    return;
                }
                var user = authService.getUser();
                if (redirectLoginPaths && !isV2Request) {
                    var updatedPath = currentPath.replace('/v3', '/');
                    windowLocationReplace(updatedPath);
                    return;
                }
                if (sessionStorage.getItem('willRedirectionOccurByVWO') === 'true') {
                    var vwoAbsUrl = sessionStorage.getItem('willRedirectionOccurByVWOAbsUrl');
                    var vwoUrl = sessionStorage.getItem('willRedirectionOccurByVWOUrl');
                    analytics.routeChange(vwoAbsUrl, vwoUrl);
                    sessionStorage.removeItem('willRedirectionOccurByVWOAbsUrl');
                    sessionStorage.removeItem('willRedirectionOccurByVWOUrl');
                    sessionStorage.removeItem('willRedirectionOccurByVWO');
                }
                if ($location.search().utm_source && $location.search().utm_medium) {
                    cookieService.set('CampaignReferrer', $location.search().utm_source + "_" + $location.search().utm_medium);
                }
                var FeatureType = {
                    Hotels: 'hotels',
                    Destinations: 'destinations',
                    Booking: 'booking',
                    HotelsLanding: 'hotelsLanding',
                    Flights: 'flights',
                    Holidays: 'holidays',
                    AdaptiveBooking: 'adaptiveBooking',
                    AdaptiveHotels: 'adaptiveHotels',
                    AdaptiveFlights: 'adaptiveFlights',
                    AdaptiveHolidays: 'adaptiveHolidays'
                };
                var isPathAndFeatureTrue = function (nextPath, featureType) {
                    var matchesPath = _.get(next, '$$route.originalPath') === nextPath;
                    // Features that are permanently enabled to all users
                    var parasolEnabledFeatures = _.get(TRPCONFIG, 'Domain.ParasolEnabledFeatures');
                    var includesEnabledFeature = parasolEnabledFeatures && parasolEnabledFeatures.includes(featureType);
                    // Features that are part of a test and can only be access by authenticated users
                    var parasolTestingFeatures = _.get(TRPCONFIG, 'Domain2.ParasolTestingFeatures');
                    var includesTestingFeature = parasolTestingFeatures && parasolTestingFeatures.includes(featureType);
                    var testUserAuthenticated = cookieService.get('x-v3') === 'true' || cookieService.get('x-v3') === TRPCONFIG.Domain.ParasolVWOTestId;
                    return matchesPath && (includesEnabledFeature || (testUserAuthenticated && includesTestingFeature));
                };
                var isPathAndFeatureTrueAcc = function (acc, _a) {
                    var nextPath = _a.nextPath, featureType = _a.featureType;
                    return acc || isPathAndFeatureTrue(nextPath, featureType);
                };
                // Adds cookie if EnableV3 is set to true in VWO and it doesn't have a cookie yet
                if (TRPCONFIG.Domain.TestingV3 && TRPCONFIG.EnableV3 === true && cookieService.get('x-v3') == null) {
                    cookieService.set('x-v3', TRPCONFIG.Domain.ParasolVWOTestId, false, false, true, 'none');
                }
                // Regarding m., need to keep these hosts names in else it will start trying to move
                // dnata and others onto v3 as well.
                var isOurMobileHostname = window.location.hostname.startsWith('m.travelrepublic') ||
                    window.location.hostname.startsWith('m.pp.travelrepublic') ||
                    window.location.hostname.startsWith('m.bf.travelrepublic') ||
                    window.location.hostname.startsWith('m.qa.travelrepublic') ||
                    (TRPCONFIG.IsMobileView && TRPCONFIG.IsCombinedViewMode);
                var isAdaptiveBookingCompleteRoute = [
                    { nextPath: '/booking/complete/:ref*', featureType: FeatureType.AdaptiveBooking },
                    { nextPath: '/booking/complete', featureType: FeatureType.AdaptiveBooking }
                ].reduce(isPathAndFeatureTrueAcc, false);
                var isAdaptiveRoute = isAdaptiveBookingCompleteRoute || [
                    { nextPath: '/hotels/book/:tripId%', featureType: FeatureType.AdaptiveBooking },
                    { nextPath: '/holidays/book/:tripId%', featureType: FeatureType.AdaptiveBooking },
                    { nextPath: '/hotels/:tripId%/:estabId', featureType: FeatureType.AdaptiveHotels },
                    { nextPath: '/hotels/:tripId%', featureType: FeatureType.AdaptiveHotels },
                    { nextPath: '/flights/:tripId%', featureType: FeatureType.AdaptiveFlights },
                    { nextPath: '/holidays/hotels/:tripId%', featureType: FeatureType.AdaptiveHolidays },
                    { nextPath: '/holidays/hotels/:tripId%/:estabId', featureType: FeatureType.AdaptiveHolidays },
                    { nextPath: '/holidays/:tripId%/:estabId', featureType: FeatureType.AdaptiveHolidays },
                    { nextPath: '/holidays/flights/:tripId%', featureType: FeatureType.AdaptiveHolidays },
                    { nextPath: '/holidays/options/:tripId%', featureType: FeatureType.AdaptiveHolidays }
                ].reduce(isPathAndFeatureTrueAcc, false);
                var isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
                var MetaTrafficIds = _.get(TRPCONFIG, 'Domain2.MetaTrafficIds');
                var isntMetaTraffic = MetaTrafficIds && !MetaTrafficIds.includes(cookieService.get('visitSource'));
                // We're now taking into account agents and metachannel traffic (by checking the visitSource cookie) and we reroute to v2
                if (TRPCONFIG.Domain.TestingV3 && !isV2Request && (isOurMobileHostname || isAdaptiveRoute) && !isAgentMode && isntMetaTraffic) {
                    var currPath = $location.path();
                    // are we on a V3 supported route?
                    if ([
                        { nextPath: '/hotels/:tripId%/:estabId', featureType: FeatureType.Hotels },
                        { nextPath: '/hotels/:tripId%', featureType: FeatureType.Hotels },
                        { nextPath: '/flights/:tripId%', featureType: FeatureType.Flights },
                        { nextPath: '/holidays/hotels/:tripId%', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/hotels/:tripId%/:estabId', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/:tripId%/:estabId', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/flights/:tripId%', featureType: FeatureType.Holidays },
                        { nextPath: '/holidays/options/:tripId%', featureType: FeatureType.Holidays }
                    ].reduce(isPathAndFeatureTrueAcc, false)) {
                        ev.preventDefault();
                        windowLocationReplace(currPath
                            .replace('/holidays/flights/', '/holidays/hotels/')
                            .replace(/holidays\/((.{8}-.{4}-.{4}-.{4}-.{12})\/([^/]+))/, function (fullPath, tripIdAndEstab) { return "holidays/hotels/" + tripIdAndEstab; }));
                        return;
                    }
                    // check if they're going to booking complete and have come from a V2 holiday
                    // but if its an adaptive booking journey route it to V3
                    if (!isAdaptiveBookingCompleteRoute && [
                        { nextPath: '/booking/complete/:ref*', featureType: FeatureType.Booking },
                        { nextPath: '/booking/complete', featureType: FeatureType.Booking }
                    ].reduce(isPathAndFeatureTrueAcc, false)) {
                        ev.preventDefault();
                        if (sessionStorage.getItem('eCommercePurchaseData')) {
                            // if booking has eCommerce data re-route it to V2 booking complete
                            windowLocationReplace("" + currPath + (currPath.match(/\?/) ? '&' : '?') + "gov=2");
                            return;
                        }
                        // route traffic on immediately
                        windowLocationReplace(currPath);
                        return;
                    }
                    // are we on a V3 adaptive booking route and are our booking options supported on V3?
                    if (isAdaptiveRoute && currPath.includes('/holidays/book/')) {
                        ev.preventDefault();
                        windowLocationReplace(currPath.replace('/holidays/book/', '/booking/passengers/'));
                        return;
                    }
                }
                var redirect = true;
                if ($location.search().rl === '1') {
                    $location.replace();
                    $location.search('rl', null);
                    $route.reload();
                }
                cancellerService.process($location.path());
                var allowedAgentRoutes = ['/agents/initiateresetpassword', '/admin/resetpassword', '/agents/resetsuccessful'];
                if (user && !user.Agent && TRPCONFIG.Domain.IsAgentDomain && allowedAgentRoutes.indexOf($location.path()) === -1) {
                    $rootScope.$evalAsync(function () {
                        $location.path('agents/signin').search({ Dest: TRPCONFIG.Domain.AgentLogonUrlDest });
                    });
                    return;
                }
                if (!next.requiresHardAuth && !next.requiresAnonAuth) {
                    redirect = false;
                }
                if (next.requiresHardAuth && user && user.HardSignedIn) {
                    redirect = false;
                }
                if (next.requiresAnonAuth && user && (user.AnonSignedIn || user.HardSignedIn)) {
                    redirect = false;
                }
                if (redirect) {
                    authService.bufferRoute($location.url());
                    $location.replace();
                    var redirectUrl = !next.requiresHardAuth && next.requiresAnonAuth ? 'bookingsignin' : 'signin';
                    authRedirection.authRedirect(redirectUrl, null, next.params);
                }
            });
        }
    ]);
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .config(dashboardConfig);
    function dashboardConfig($routeProvider, dashboardEnabledConfig, dashboardDisabledUrl, dashboardDisabledReferenceUrl) {
        var dashboardEnabled = TRPCONFIG.Domain[dashboardEnabledConfig];
        var redirectTo = function (url) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return ({
                redirect: ['$window', '$route', function ($window, $route) { return $window.location = String.format.apply(String, [url].concat(params.map(function (p) { return $route.current.params[p]; }))); }]
            });
        };
        var amendResolver = {
            canAutoRebook: ['$http', '$location', '$route', function ($http, $location, $route) {
                    var params = $route.current.params;
                    return $http.get('/api/bookings/amendments/options', {
                        params: {
                            bookingId: params.BookingId,
                        }
                    })
                        .then(function (_a) {
                        var CanAutoRebook = _a.data.CanAutoRebook;
                        if (!CanAutoRebook) {
                            $location.url("desktop-url/" + params.BookingRef + "/" + params.BookingId + "/" + params.LeadPassengerLastName + "/amend");
                            $location.replace();
                        }
                    });
                }],
            booking: ['dashboardBookingService', '$route', function (dashboardBookingService, $route) {
                    return dashboardBookingService.getMybBooking($route.current.params.BookingId);
                }],
            bookedEstabId: ['dashboardBookingService', '$route', function (dashboardBookingService, $route) {
                    return dashboardBookingService.getMybBooking($route.current.params.BookingId)
                        .then(function (booking) { return _.get(booking, 'Itinerary.Stays[0].Hotel.EstabId'); });
                }],
            hotel: ['hotelResolver', function (hotelResolver) {
                    return hotelResolver.resolve(false);
                }],
        };
        $routeProvider.when('/dashboard/amend-booking/:BookingRef/:BookingId/:LeadPassengerLastName/start', {
            templateUrl: 'partials/dashboard/amendBooking',
            controller: 'AmendBooking',
            controllerAs: 'amend',
            area: 'hotels',
            resolve: _.pick(amendResolver, 'canAutoRebook', 'booking'),
        });
        $routeProvider.when('/dashboard/amend-booking/:BookingRef/:BookingId/:tripId', {
            templateUrl: 'partials/dashboard/amendBookingHotelSearch',
            controller: 'HotelSearch',
            controllerAs: 'cm',
            area: 'hotels',
            reloadOnSearch: false,
            breadcrumb: {
                crumb: 20
            }
        });
        $routeProvider.when('/dashboard/amend-booking/:BookingRef/:BookingId/:tripId/:estabId', {
            templateUrl: 'partials/dashboard/amendBookingAvailability',
            controller: 'HotelAvailability',
            controllerAs: 'cm',
            area: 'hotels',
            resolve: _.pick(amendResolver, 'hotel', 'bookedEstabId'),
        });
        if (!dashboardEnabled) {
            $routeProvider.when('/dashboard/booking-not-yours/:bookingId', {
                templateUrl: 'partials/dashboard/bookingnotyours',
                controllerAs: 'cm',
                controller: function ($routeParams) {
                    this.bookingNotYoursId = $routeParams.bookingId;
                }
            });
        }
        if (TRPCONFIG.Domain.DashboardHomeEnabled) {
            $routeProvider.when('/dashboard', {
                templateUrl: 'partials/dashboard/account',
                controllerAs: 'cm',
                controller: 'Dashboard',
                requiresHardAuth: true,
                requiresAnonAuth: false
            });
        }
        $routeProvider.when('/dashboard/bookings/:bookingPeriod', dashboardEnabled ? {
            templateUrl: function ($routeParams) { return "partials/dashboard/bookings?bookingType=" + $routeParams.bookingPeriod; },
            controllerAs: 'cm',
            controller: 'DashboardBookings',
            requiresHardAuth: true,
            requiresAnonAuth: false
        } : {
            requiresHardAuth: true,
            requiresAnonAuth: false,
            resolve: redirectTo(dashboardDisabledUrl)
        });
        $routeProvider.when('/dashboard/bookings/reference/:bookingId', dashboardEnabled ? {
            templateUrl: 'partials/dashboard/bookings?bookingType=reference',
            controller: 'DashboardBookings',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            pixelTrackingPageName: 'dashboardBookingReference'
        } : {
            requiresAnonAuth: true,
            resolve: redirectTo(dashboardDisabledReferenceUrl)
        });
        if (TRPCONFIG.Domain.DashboardBookingEnabled || TRPCONFIG.Domain.DashboardMobileEnabled) {
            $routeProvider.when('/dashboard/bookings/', {
                redirectTo: '/dashboard/bookings/current'
            });
            $routeProvider.when('/dashboard/booking-details/:bookingId', {
                templateUrl: 'partials/dashboard/bookingdetails',
                controller: 'DashboardBookingDetails',
                pixelTrackingPageName: 'dashboardBookingDetails',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
                hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/csr/:bookingId', {
                templateUrl: 'partials/dashboard/csr',
                controller: 'Csr',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
                hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/create-csr/:bookingId', {
                templateUrl: 'partials/dashboard/createcsr',
                controller: 'Csr',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
                hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/csr-details/:bookingId/:csrId', {
                templateUrl: 'partials/dashboard/csrdetails',
                controller: 'CsrDetails',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
                hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/resend-voucher/:bookingId', {
                templateUrl: 'partials/dashboard/resendvoucher',
                controller: 'ResendVoucher',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
                hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/contact-detail/:bookingId', {
                templateUrl: 'partials/dashboard/contactdetail',
                controller: 'ContactDetail',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
                hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/pay-balance/:bookingId', dashboardEnabled && TRPCONFIG.Domain.PaybalanceV2Enabled ? {
                templateUrl: 'partials/dashboard/paybalance',
                controller: 'PayBalance',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                pixelTrackingPageName: 'dashboardPayBalance',
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter
            } : {
                requiresAnonAuth: true,
                resolve: redirectTo('/manage-your-booking/make-a-payment.aspx?BID={0}', 'bookingId')
            });
            if (TRPCONFIG.Domain.PaybalanceV2Enabled) {
                $routeProvider.when('/dashboard/pay-balance/complete/:bookingId', {
                    templateUrl: 'partials/dashboard/paybalancecomplete',
                    controller: 'PayBalanceComplete',
                    controllerAs: 'cm',
                    requiresAnonAuth: true,
                    hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                    hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter
                });
            }
        }
        if (TRPCONFIG.Domain.DashboardReviewsEnabled) {
            $routeProvider.when('/dashboard/reviews', {
                templateUrl: 'partials/dashboard/myreview',
                controllerAs: 'cm',
                controller: 'DashboardReview',
                requiresHardAuth: false,
                requiresAnonAuth: true,
                resolve: {
                    redirect: ['authService', '$location', function (authService, $location) {
                            var user = authService.getUser();
                            var bookingId = _.get(user, 'BookingId') || _.get(user, 'Contact.BookingId');
                            if (user.AnonSignedIn && bookingId) {
                                $location.path("review-hotel/" + bookingId);
                            }
                        }],
                    action: function () { return 'get-reviews'; }
                }
            });
            $routeProvider.when('/dashboard/reviews/submitted/:bookingId/:objectId?', {
                templateUrl: 'partials/dashboard/reviewsubmitted',
                controllerAs: 'cm',
                controller: 'DashboardReview',
                requiresHardAuth: true,
                requiresAnonAuth: true,
                resolve: {
                    action: function () { return 'review-submitted'; }
                }
            });
            $routeProvider.when('/dashboard/feedbackform/:bookingId/:objectId?', {
                templateUrl: 'partials/dashboard/feedbackform',
                controllerAs: 'cm',
                controller: 'DashboardReview',
                requiresHardAuth: false,
                requiresAnonAuth: true,
                resolve: {
                    action: function () { return 'review-hotel'; }
                }
            });
            $routeProvider.when('/dashboard/review-hotel/:bookingId/:userId/:token', {
                templateUrl: 'partials/dashboard/feedbackform',
                controllerAs: 'cm',
                controller: 'DashboardReview',
                requiresHardAuth: false,
                requiresAnonAuth: false,
                resolve: {
                    action: function () { return 'review-hotel'; }
                }
            });
        }
        if (TRPCONFIG.Domain.DashboardSettingsEnabled) {
            $routeProvider.when('/dashboard/settings', {
                templateUrl: 'partials/dashboard/settings',
                controllerAs: 'cm',
                controller: 'DashboardSettings',
                requiresHardAuth: true,
                requiresAnonAuth: false
            });
        }
        if (TRPCONFIG.Domain.DashboardBookingEnabled || TRPCONFIG.Domain.DashboardMobileEnabled) {
            //to redirect to old desktop urls.
            $routeProvider
                .when('/desktop-url/:SID/:BID/:SN/:NAV/:CSRID?', {
                template: '<div></div>',
                controller: ['v1Redirection', '$routeParams', function (v1Redirection, $routeParams) { return v1Redirection.v1Redirect($routeParams); }]
            });
            $routeProvider.when('/dashboard/support', {
                templateUrl: 'partials/dashboard/dashboardsupport',
                controller: 'Csr',
                controllerAs: 'cm',
                requiresAnonAuth: true
            });
        }
        if (TRPCONFIG.Domain.FlightCheckinEnabled) {
            $routeProvider.when('/dashboard/online-checkin/:bookingId', {
                templateUrl: 'partials/dashboard/onlinecheckin',
                controller: 'OnlineCheckin',
                controllerAs: 'cm',
                requiresHardAuth: true,
                requiresAnonAuth: false
            });
        }
        if (TRPCONFIG.Domain.DashboardAddBagsEnabled) {
            $routeProvider.when('/dashboard/add-baggage/:bookingId', {
                templateUrl: 'partials/dashboard/addbaggage',
                controller: 'AddBaggage',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/add-baggage/complete/:bookingId', {
                templateUrl: 'partials/dashboard/addbaggagecomplete',
                requiresAnonAuth: true,
                controller: 'PayBalanceComplete',
                controllerAs: 'cm',
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
            });
        }
        if (TRPCONFIG.Domain.DashboardAddSeatsEnabled) {
            $routeProvider.when('/dashboard/seat-selection/:bookingId', {
                templateUrl: 'partials/dashboard/dashboardseatselection',
                controller: 'DashboardSeatSelection',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
            });
            $routeProvider.when('/dashboard/seat-selection/complete/:bookingId', {
                templateUrl: 'partials/dashboard/addseatscomplete',
                requiresAnonAuth: true,
                controller: 'PayBalanceComplete',
                controllerAs: 'cm',
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
            });
        }
        if (TRPCONFIG.Domain.DashboardAddAPIEnabled) {
            $routeProvider.when('/dashboard/add-api/:bookingId', {
                templateUrl: 'partials/dashboard/addapi',
                requiresAnonAuth: true,
                controller: 'AddAPI',
                controllerAs: 'cm',
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
            });
        }
    }
})();
var Reviews;
(function (Reviews) {
    angular.module('reviews').config(function ($routeProvider) {
        $routeProvider.when('/review-hotel/preview/:bookingId/:userId/:token', {
            templateUrl: 'partials/review/partialTemplate?type=preview',
            controllerAs: 'rp',
            controller: 'ReviewPreview',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });
        $routeProvider.when('/review-hotel/submitted/:hotelId', {
            templateUrl: 'partials/review/partialTemplate?type=submitted',
            controllerAs: 'rhs',
            controller: 'ReviewSubmitted'
        });
        $routeProvider.when('/review-hotel/:bookingId/:userId?/:token?', {
            templateUrl: 'partials/review/partialTemplate?type=reviewHotel',
            controllerAs: 'rh',
            controller: 'ReviewHotel'
        });
    });
})(Reviews || (Reviews = {}));
(function () {
    'use strict';
    angular.module('quote')
        .config(quoteConfig);
    function quoteConfig($routeProvider) {
        if (!TRPCONFIG.Domain.QuoteEnabled) {
            return;
        }
        if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain2.AllowAgentManageQuote) {
            $routeProvider.when('/quote/manage/:quoteRef?/:quoteNo?', {
                templateUrl: 'partials/quote/index',
                controllerAs: 'qc',
                controller: 'Quote'
            });
            $routeProvider.when('/quote/advancedSearch', {
                templateUrl: 'partials/quote/quoteadvancedsearch'
            });
        }
        else {
            $routeProvider.when('/quote/manage/:quoteRef?/:quoteNo?', {
                templateUrl: 'partials/quote/indexPublic',
                controllerAs: 'qp',
                controller: 'QuotePublic'
            });
        }
        /* Reverting these urls into existence due to v1 - dont use them, use the urls they redirect to instead */
        $routeProvider.when('/quote/manageyourquote/login', {
            redirectTo: '/quote/manage/'
        });
        $routeProvider.when('/quote/manageyourquote/details/:quoteRef/:quoteNo', {
            redirectTo: '/quote/manage/:quoteRef/:quoteNo'
        });
    }
})();
angular.module('liveChatSnapInModule', [])
    .config(function livechatSnapinConfig($routeProvider) {
    if (TRPCONFIG.Domain.LiveChat && TRPCONFIG.Domain.LiveChat.SnapInEnabled) {
        var cookies_1 = document.cookie + '';
        $routeProvider.when('/livechatredirect', {
            template: '',
            controller: ['cookieService', function (cookieService) {
                    var redirectUrl = _.get(TRPCONFIG, 'Domain.LiveChat.SnapInConfig.RedirectUrl');
                    var cookieName = _.get(TRPCONFIG, 'Domain.LiveChat.SnapInConfig.cookieName', 'key');
                    var cookie = cookieService.get(cookieName, cookies_1);
                    window.location.href = "" + redirectUrl + cookie;
                }]
        });
    }
})
    .run(['liveChatSnapInService', function (liveChatSnapInService) {
        TRPCONFIG.Domain.LiveChat
            && TRPCONFIG.Domain.LiveChat.SnapInEnabled
            && liveChatSnapInService.initialise();
    }]);
(function () {
    'use strict';
    angular.module('cms')
        .config(['$routeProvider', function ($routeProvider) {
            $routeProvider.when('/cms/preview/:pageId/:componentId', {
                template: '<div ng-include="cc.template"><h1>Loading...</h1></div>',
                controllerAs: 'cc',
                controller: ['$routeParams', function ($routeParams) {
                        this.template = "cms/component/" + $routeParams.pageId + "/" + $routeParams.componentId + "?device=Apps";
                    }]
            });
        }]);
})();
angular.module('attractions').config(function ($routeProvider) {
    function isMobileSite() {
        return TRPCONFIG.IsMobileView;
    }
    function getCookie(key) {
        // this logic has been duplicated from CookieService which we can't access here
        if (!key) {
            return null;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key)
            .replace(/[-.+*]/g, '\\$&') + "\\s*\\=\\s*([^;]*).*$)|^.*$"), '$1'))
            || null;
    }
    function getBookingFormTemplate(area) {
        if (!TRPCONFIG.Domain.isAgentMode && !isMobileSite()) {
            var version = parseFloat(TRPCONFIG.Domain.BookingFormVersion);
            if (version > 2) {
                if (TRPCONFIG.Domain.BookingFormABTest) {
                    if (!TRPCONFIG.Domain.isAgentMode) {
                        var cookieVersion = getCookie('BookingFormVersion');
                        if (cookieVersion && parseFloat(cookieVersion) > 2) {
                            return "partials/booking/template?name=Book&version=" + cookieVersion;
                        }
                    }
                }
                else {
                    return "partials/booking/template?name=Book&version=" + version;
                }
            }
        }
        return "partials/" + area + "/book";
    }
    if (TRPCONFIG.Domain.SupportedProducts & 64) {
        var area = 'attractions';
        $routeProvider.when('/' + area + '/basket', {
            templateUrl: 'partials/' + area + '/basket',
            controllerAs: 'cm',
            controller: 'AttractionsBasket',
            area: area,
            hideDistractionLinks: true,
            analyticsTag: 'Attractions Basket'
        });
        $routeProvider.when('/' + area + '/book/:tripId', {
            templateUrl: getBookingFormTemplate(area),
            controllerAs: 'cm',
            controller: 'Booking',
            area: area,
            noGroup: true,
            hideDistractionLinks: true,
            analyticsTag: 'Booking Form'
        });
        $routeProvider.when('/' + area + '/book/:tripId/passenger/:room/:index', {
            templateUrl: 'partials/' + area + '/passenger',
            controllerAs: 'cm',
            controller: 'Passenger',
            hideDistractionLinks: true,
            hideTravelAgentLinks: true
        });
    }
});
(function () {
    'use strict';
    angular
        .module('TR')
        .config(configOuter);
    function configOuter($provide) {
        $provide.decorator('$http', http);
        http.$inject = ['$delegate', 'errInterceptor'];
        function http($http, errInterceptor) {
            var customHttp = function (config) {
                handleErrorCallback(config);
                return $http(config);
            };
            for (var prop in $http) {
                if (typeof ($http[prop]) === 'function') {
                    customHttp[prop] =
                        (function (name) {
                            return function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                handleErrorCallback(args[args.length - 1]);
                                return $http[name].apply($http, args);
                            };
                        })(prop);
                }
                else {
                    customHttp[prop] = $http[prop];
                }
            }
            function handleErrorCallback(config) {
                if (!config || typeof (config) !== 'object') {
                    return;
                }
                if (config.ignoreErrors) {
                    config.customErrCallback = angular.noop;
                }
                if (config.customErrCallback) {
                    var _id = errInterceptor.addErrCallback(config.customErrCallback);
                    var _customHeader = { 'x-callback': _id };
                    delete config.customErrCallback;
                    config.headers = angular.extend(config.headers || {}, _customHeader);
                }
            }
            return customHttp;
        }
    }
})();
var Core;
(function (Core) {
    var SeoKnowledgeGraph = /** @class */ (function () {
        function SeoKnowledgeGraph($scope, $sce, $filter, $window, $location, $element) {
            this.$scope = $scope;
            this.$sce = $sce;
            this.$filter = $filter;
            this.$window = $window;
            this.$location = $location;
            this.$element = $element;
            var vm = this;
            function checkValue(value) {
                if (!value) {
                    return;
                }
                var excludeStr = 'SEO_STUCTUREDDATA';
                var validValue = (value && value.includes(excludeStr)) ? '' : value;
                return (validValue) ? validValue : null;
            }
            function setJson(value) {
                return vm.$sce.trustAsHtml(vm.$filter('json')(value));
            }
            var showStructuredData = TRPCONFIG.Domain2.ShowJsonLdHomepage;
            if (!showStructuredData) {
                return;
            }
            var el = vm.$element[0];
            var activate = function () {
                var baseUrl = $location && $location.absUrl();
                var addressLocality = checkValue($scope.addressLocality);
                var postalCode = checkValue($scope.postalCode);
                var streetAddress = checkValue($scope.streetAddress);
                var addressCountry = checkValue($scope.addressCountry);
                var imagePath = checkValue($scope.logoPath);
                var image = "" + baseUrl + imagePath;
                var logo = image;
                var name = checkValue($scope.name);
                var telephone = checkValue($scope.telephone);
                var contactType = checkValue($scope.contactType);
                var url = baseUrl;
                var socialNetworks = checkValue($scope.socialNetworks);
                var sameAs = (socialNetworks) ? socialNetworks.replace(/\r?\n|\r/g, '').split(',') : null;
                var schemaType = checkValue($scope.schemaType);
                var address = {
                    addressLocality: addressLocality,
                    streetAddress: streetAddress,
                    postalCode: postalCode,
                    addressCountry: addressCountry,
                    image: image
                };
                var contactPoint = {
                    telephone: telephone,
                    contactType: contactType
                };
                var generic = {
                    logo: logo,
                    sameAs: sameAs,
                    name: name,
                    url: url
                };
                var addressCompacted = _.pickBy(address, function (value) { return value; });
                var contactPointCompacted = _.pickBy(contactPoint, function (value) { return value; });
                var genericCompacted = _.pickBy(generic, function (value) { return value; });
                var ldJson = __assign({ '@context': 'http://schema.org', '@type': schemaType }, genericCompacted, { 'address': __assign({ '@type': 'PostalAddress' }, addressCompacted), 'contactPoint': __assign({ '@type': 'ContactPoint' }, contactPointCompacted) });
                vm.$scope.ldJson = ldJson;
            };
            vm.$scope.$on('$routeChangeSuccess', function () {
                var homepage = $location.path();
                if (homepage !== '/') {
                    el.innerHTML = '';
                }
                else {
                    el.innerHTML = setJson(vm.$scope.ldJson);
                }
                activate();
            });
        }
        SeoKnowledgeGraph.prototype.onGetJson = function () {
            var path = this.$location.path();
            if (path !== '/') {
                return;
            }
            return this.$sce.trustAsHtml(this.$filter('json')(this.$scope.ldJson));
        };
        return SeoKnowledgeGraph;
    }());
    Core.SeoKnowledgeGraph = SeoKnowledgeGraph;
    angular
        .module('core')
        .directive('seoKnowledgeGraph', function () {
        return {
            restrict: 'E',
            scope: {
                addressLocality: '=',
                postalCode: '=',
                streetAddress: '=',
                addressCountry: '=',
                name: '=',
                telephone: '=',
                socialNetworks: '=',
                contactType: '=',
                logoPath: '=',
                schemaType: '=',
            },
            controller: SeoKnowledgeGraph,
            controllerAs: 'spr',
            replace: true,
            bindToController: {
                ld: '=',
            },
            template: function () {
                return '<script id="knowledge-graph" type="application/ld+json" ng-bind-html="spr.onGetJson()"></script>';
            },
        };
    });
})(Core || (Core = {}));
/// <reference path="./deepLinkInterfaces.ts"/>
var DeepLinkController = /** @class */ (function () {
    function DeepLinkController($rootScope, deepLinkService, $location, searchQueryString) {
        $rootScope.$emit('block', {});
        $location.replace();
        var reqParams = searchQueryString.getDeepLinkQSParams();
        deepLinkService.getSearchDeepLink(reqParams)
            .then(function (deepLinkUrl) {
            $location.replace();
            var pathnameWithoutCulture = deepLinkService.parseFullUrl(deepLinkUrl).pathnameWithoutCulture;
            $location.url(pathnameWithoutCulture);
            $rootScope.$apply();
        });
    }
    return DeepLinkController;
}());
angular
    .module('deepLink')
    .controller('DeepLinkController', DeepLinkController);
angular
    .module('deepLink')
    .config(DeepLinkConfig);
function DeepLinkConfig($routeProvider) {
    $routeProvider.when('/holidays/search', {
        template: '',
        controller: 'DeepLinkController',
        controllerAs: 'deepLinkCtrl'
    });
}
var TR;
(function (TR) {
    angular
        .module('TR')
        .constant('hotelCriteria', [
        { val: [1], name: 'RECOMMENDED' },
        { val: [5, 6], name: 'PRICE', defaultSort: 5, defaultOrder: 'asc' },
        { val: [8, 7], name: 'STARRATING', defaultSort: 8, defaultOrder: 'desc' }
    ])
        .constant('flightCriteria', [
        { val: [10], name: 'RECOMMENDEDFLIGHT', oneWay: true },
        { val: [1, 2], name: 'PRICE', oneWay: true, defaultSort: 1, defaultOrder: 'asc' },
        {
            val: [4, 5],
            name: 'DEPARTURETIME',
            oneWay: true,
            defaultSort: 4,
            defaultOrder: 'asc',
            ascSuffix: 'SORTDIRECTIONTIMELABELASCENDING',
            descSuffix: 'SORTDIRECTIONTIMELABELDESCENDING'
        },
        {
            val: [6, 7],
            name: 'RETURNTIME',
            oneWay: false,
            defaultSort: 6,
            defaultOrder: 'asc',
            ascSuffix: 'SORTDIRECTIONTIMELABELASCENDING',
            descSuffix: 'SORTDIRECTIONTIMELABELDESCENDING'
        },
        { val: [9, 8], oneWay: true, name: 'TOTALJOURNEYTIME', defaultSort: 9, defaultOrder: 'asc' }
    ])
        .constant('dealsCriteria', [
        { val: [1], name: 'RECOMMENDED', qs: 'rc' },
        { val: [5, 6], name: 'PRICE', defaultSort: 5, defaultOrder: 'asc' },
        { val: [8, 7], name: 'STARRATING', defaultSort: 8, defaultOrder: 'desc' }
    ])
        .constant('costBreakdownCodes', {
        Hotel: 1,
        CancellationProtection: 21,
    });
})(TR || (TR = {}));
var Core;
(function (Core) {
    function AgentCorrelationId(agentModeService, tripService, $q, $routeParams) {
        return {
            scope: {},
            replace: true,
            template: "<div class=\"supplier-name\" ng-show=\"::cm.hotelAvailabilitySearchId\">\n                         Search Id: {{::cm.hotelAvailabilitySearchId}}\n                       </div>",
            controllerAs: 'cm',
            controller: function () {
                var _this = this;
                agentModeService.getDebugSettings()
                    .then(function (debugSettings) { return _.get(debugSettings, 'EnableSearchTracing'); })
                    .then(function (enableSearchTracing) { return enableSearchTracing && tripService.getTrip($routeParams.tripId); })
                    .then(function (trip) { return _.get(trip, 'HotelsRequest.AvailabilitySearchId'); })
                    .then(function (availabilitySearchId) { return _this.hotelAvailabilitySearchId = availabilitySearchId; });
            },
        };
    }
    if (TRPCONFIG.Domain.isAgentMode) {
        angular
            .module('core')
            .directive('agentCorrelationId', AgentCorrelationId);
    }
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AgentNetInfo = /** @class */ (function () {
        function AgentNetInfo($scope, $q, $route, $routeParams, agentNetInfoService) {
            var _this = this;
            this.$scope = $scope;
            this.$q = $q;
            this.$route = $route;
            this.$routeParams = $routeParams;
            this.agentNetInfoService = agentNetInfoService;
            this.displayToolTip = false;
            this.currency = TRPCONFIG.Domain.CurrencyCode;
            this.areas = {
                Holidays: 'holidays',
                Hotels: 'hotels',
                Flights: 'flights'
            };
            this.enabled = false;
            var area = this.$route.current.area;
            this.enabled = false;
            var enabledAreas = TRPCONFIG.Domain.AgentNetInfoEnabledAreas.split(',');
            var areaIsEnabled = enabledAreas.length && enabledAreas.some(function (item) {
                return item === area;
            });
            if (areaIsEnabled) {
                this.createToolTip().then(function (data) {
                    _this.enabled = true;
                    _this.populateToolTip();
                }, function (data) {
                    _this.enabled = false;
                });
            }
        }
        AgentNetInfo.prototype.createToolTip = function () {
            var _this = this;
            var deferred = this.$q.defer();
            if (this.data) {
                var isValidData = this.agentNetInfoService.hasRequiredValues(this.data, this.mode);
                isValidData ? deferred.resolve(this.data) : deferred.reject(this.data);
            }
            else {
                var dataLoaded_1 = this.$scope.$watch('ani.data', function (value, prev) {
                    if (_this.agentNetInfoService.hasRequiredValues(value, _this.mode)) {
                        dataLoaded_1();
                        deferred.resolve(_this.data);
                    }
                    else {
                        deferred.reject(_this.data);
                    }
                });
            }
            return deferred.promise;
        };
        AgentNetInfo.prototype.populateToolTip = function () {
            this.netValues = this.populateNetValues();
        };
        AgentNetInfo.prototype.showToolTip = function () {
            this.displayToolTip = !this.displayToolTip;
        };
        AgentNetInfo.prototype.populateNetValues = function () {
            if (this.$route.current.area === this.areas.Hotels) {
                this.data = this.data.concat([
                    { Cost: { Value: this.vat, CurrencyCode: TRPCONFIG.Domain.CurrencyCode }, Type: 0 },
                    __assign({}, this.markdown, { Type: 99 })
                ]);
            }
            return this.agentNetInfoService.parse(this.data, this.mode);
        };
        return AgentNetInfo;
    }());
    var AgentNetInfoHotels = /** @class */ (function () {
        function AgentNetInfoHotels($scope, agentNetInfoService) {
            this.$scope = $scope;
            this.agentNetInfoService = agentNetInfoService;
            this.displayToolTip = false;
            this.enabled = false;
            this.enabled = this.agentNetInfoService.hasRequiredValues(this.data, 'hotelinfo');
            if (this.enabled) {
                this.netValues = this.populateNetValues();
            }
        }
        AgentNetInfoHotels.prototype.populateNetValues = function () {
            return this.agentNetInfoService.parse(this.data, 'hotelinfo');
        };
        AgentNetInfoHotels.prototype.showToolTip = function () {
            this.displayToolTip = !this.displayToolTip;
        };
        return AgentNetInfoHotels;
    }());
    angular
        .module('core')
        .directive('agentNetInfo', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: AgentNetInfo,
            controllerAs: 'ani',
            bindToController: {
                data: '=',
                mode: '@',
                showTaxes: '=',
                vat: '=',
                markdown: '='
            },
            template: "<div class=\"question-mark-red\"\n                ng-mouseenter=\"ani.showToolTip()\"\n                ng-mouseleave=\"ani.showToolTip()\" ng-show=\"ani.enabled\">\n                    <div class=\"ui-tooltip\" ng-show=\"ani.displayToolTip\">\n                        <agent-net-info-table data=\"ani.netValues\" show-tax=\"ani.showTaxes\"\n                        commission-type=\"{{ani.netValues.CommissionType}}\" mode=\"{{ani.mode}}\"></agent-net-info-table>\n                    </div>\n                </div>"
        };
    })
        .directive('agentNetInfoHotels', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: AgentNetInfoHotels,
            controllerAs: 'anih',
            bindToController: {
                data: '='
            },
            template: "<div class=\"question-mark-red\"\n                ng-mouseenter=\"anih.showToolTip()\"\n                ng-mouseleave=\"anih.showToolTip()\" ng-show=\"anih.enabled\">\n                 <div class=\"ui-tooltip\" ng-show=\"anih.displayToolTip\">\n                        <agent-net-info-table data=\"anih.netValues\" mode=\"hotel\"></agent-net-info-table>\n                    </div>\n                </div>"
        };
    });
})(Core || (Core = {}));
;
var Core;
(function (Core) {
    var AgentNetInfoTable = /** @class */ (function () {
        function AgentNetInfoTable() {
            this.currency = TRPCONFIG.Domain.CurrencyCode;
            if (!this.commissionType) {
                this.commissionType = 'Commission';
            }
        }
        return AgentNetInfoTable;
    }());
    angular
        .module('core')
        .directive('agentNetInfoTable', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: AgentNetInfoTable,
            controllerAs: 'anit',
            bindToController: {
                data: '=',
                showTax: '=',
                commissionType: '@',
                mode: '@'
            },
            templateUrl: "partials/home/directivetemplate?type=AgentNetInfoTable"
        };
    });
})(Core || (Core = {}));
/*
    Autocompleter field base class
*/
var Autocompleter;
(function (Autocompleter) {
    var AutocompleterField = /** @class */ (function () {
        function AutocompleterField() {
            var _this = this;
            this.prefix = '';
            this.showLoading = false;
            this.initialData = null;
            this.debouncedFetch = _.debounce(function () {
                _this.$scope.$evalAsync(_this.fetch());
            }, 300);
            this.minPrefix = this.minPrefix || TRPCONFIG.Domain.AutoCompleterMinPrefix;
        }
        AutocompleterField.prototype.init = function (areaOverride) {
            if (areaOverride) {
                this.areaOverride = areaOverride;
            }
        };
        AutocompleterField.prototype.change = function () {
            this.debouncedFetch();
        };
        AutocompleterField.prototype.update = function (result) {
            // Override in derived class to process `fetch()` result
            ;
        };
        AutocompleterField.prototype.addHeader = function (arr, resourceName) {
            // Returns a copy of `arr` with header item prepended
            if (arr.length) {
                return [{
                        Title: this.resourceService.get(resourceName),
                        header: true
                    }].concat(arr);
            }
            return [];
        };
        AutocompleterField.prototype.fetch = function () {
            var _this = this;
            this.$scope.$emit('flash:hide');
            if (!this.prefix || !this.prefix.length) {
                this.deselect();
            }
            var area = this.getArea();
            var allowedZeroInput = TRPCONFIG.Domain.AllowZeroInputDestinationAutocompleter
                && TRPCONFIG.Domain.DeviceType === 'Desktop'
                && area !== 'flights'
                && area !== 'transfers';
            if (this.prefix.length < this.minPrefix && !allowedZeroInput) {
                // `initialData` is `null` unless overwritten i.e. for recommendations
                this.data = this.initialData;
                if (area === 'flights-departure') {
                    this.autocompleter.initialDepartureAirports().then(function (result) { return _this.update(result); });
                }
                return this.$q.when(null);
            }
            this.showLoading = true;
            return this.autocompleter.lookup(area, this.prefix, this.filterFunction).then(function (result) {
                _this.showLoading = false;
                if (result.prefix === _this.prefix) {
                    _this.update(result);
                    return result;
                }
                return null;
            });
        };
        AutocompleterField.prototype.getArea = function () {
            var current = this.$route.current ? this.$route.current.area : '';
            return this.areaOverride || current;
        };
        return AutocompleterField;
    }());
    Autocompleter.AutocompleterField = AutocompleterField;
})(Autocompleter || (Autocompleter = {}));
/*
    Creates an airport multi select field.
    Selectable options are exposed as `ac.data`.
*/
var Autocompleter;
(function (Autocompleter) {
    var AirportMultiSelect = /** @class */ (function (_super) {
        __extends(AirportMultiSelect, _super);
        function AirportMultiSelect($scope, $route, resourceService, $q, autocompleter) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$route = $route;
            _this.resourceService = resourceService;
            _this.$q = $q;
            _this.autocompleter = autocompleter;
            _this.available = [];
            _this.selected = [];
            _this.areaOverride = _this.areaOverride || 'flights';
            _this.$scope.$watch('ac.currentValue', function (v) {
                _this._resetSelected(_.flattenDeep([v]));
            });
            // Wrap `select` attribute fn
            _this.selectAttrFn = _this.select;
            _this.select = function (item) {
                _this.selectItem(item);
                _this.selectAttrFn({ items: _this.selected });
            };
            if (_this.prefilled != null) {
                _this.prefill(_this.prefilled);
            }
            return _this;
        }
        AirportMultiSelect.prototype.prefill = function (data) {
            var _this = this;
            var prefill = data.split(/\s*,\s*/);
            this.prefix = data;
            this.fetch().then(function () {
                prefill.forEach(function (code) {
                    _this.available.forEach(function (item) {
                        if (item.Code === code) {
                            _this.select(item);
                        }
                    });
                });
            });
        };
        Object.defineProperty(AirportMultiSelect.prototype, "placeholder", {
            get: function () {
                return this._placeholder;
            },
            set: function (placeholder) {
                if (!this.notActive) {
                    this._placeholder = placeholder;
                }
                else {
                    this._placeholder = TRPCONFIG.Domain.DefaultStaticAirportLabel;
                }
            },
            enumerable: true,
            configurable: true
        });
        AirportMultiSelect.prototype.update = function (result) {
            // Called by super.fetch() with autocompleter.lookup result
            this.available = result.data;
            this._refreshData();
            if (_.isEmpty(this.data) && !this.notActive) {
                this.data = null;
                this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        };
        AirportMultiSelect.prototype.selectItem = function (item) {
            var _this = this;
            if (item && item.Code) {
                // Remove codes that are already selected
                var codes = _.reject(item.Code.split(','), function (item1) {
                    return _.find(_this.selected, function (item2) { return item1 === item2.Code; });
                });
                this._selectEachCode(codes, item.Title);
                this.prefix = '';
            }
        };
        AirportMultiSelect.prototype.removeItem = function (item) {
            if (!item) {
                return;
            }
            this.selected.splice(this.selected.indexOf(item), 1);
            if (!this.selected.length) {
                this.deselect();
            }
            else {
                this.selectAttrFn({ items: this.selected });
            }
        };
        AirportMultiSelect.prototype._refreshData = function () {
            this.data = this.addHeader(this._getAvailable(), 'AIRPORTS');
        };
        AirportMultiSelect.prototype._selectEachCode = function (codes, sharedTitle) {
            var _this = this;
            codes.forEach(function (code) {
                if (!_this.notActive || code === _this.prefilled) {
                    _this.selected.push({ Code: code, Title: sharedTitle });
                }
            });
        };
        AirportMultiSelect.prototype._resetSelected = function (items) {
            var _this = this;
            if (items === void 0) { items = []; }
            // Overwrites `this.selected` with data from `currentValue` attr on every change
            this.selected = [];
            items.forEach(function (item) {
                if (item && item.Code) {
                    _this._selectEachCode(item.Code.split(','), item.Title);
                }
            });
            this._refreshData();
        };
        AirportMultiSelect.prototype._getAvailable = function () {
            var _this = this;
            // Filters out items where all codes are already selected
            return _.reject(this.available, function (item) {
                var selectedCodes = _.map(_this.selected, 'Code');
                if (item.Code.indexOf(',') > -1) {
                    return _.every(item.Code.split(','), function (i) {
                        return _.indexOf(selectedCodes, i) > -1;
                    });
                }
                else {
                    return _.indexOf(selectedCodes, item.Code) > -1;
                }
            });
        };
        return AirportMultiSelect;
    }(Autocompleter.AutocompleterField));
    angular
        .module('TR')
        .directive('airportMultiSelect', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'ac',
            bindToController: {
                placeholder: '@',
                select: '&',
                deselect: '&',
                currentValue: '=',
                focusTracker: '=',
                minPrefix: '@',
                notActive: '@',
                prefilled: '@',
                disabled: '@',
                areaOverride: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=AirportMultiSelect',
            controller: AirportMultiSelect,
            transclude: true,
            link: function (scope, el) {
                scope.ac.inputField = el.find('input');
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
/*
    Creates an airport multi select field.
    Selectable options are exposed as `ac.data`.
*/
var Autocompleter;
(function (Autocompleter) {
    var AirportMultiSelectUnified2 = /** @class */ (function (_super) {
        __extends(AirportMultiSelectUnified2, _super);
        function AirportMultiSelectUnified2($scope, $route, autocompleter, resourceService, $q, destinationService, $timeout) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$route = $route;
            _this.autocompleter = autocompleter;
            _this.resourceService = resourceService;
            _this.$q = $q;
            _this.destinationService = destinationService;
            _this.$timeout = $timeout;
            _this.available = [];
            _this.isCodeSelected = function (code) { return _.find(_this.currentValue, function (v) { return code === v.Code; }); };
            _this.titleCache = {};
            if (!_this.areaOverride) {
                _this.areaOverride = 'flights';
            }
            _this.$scope.$watch('ac.currentValue', function (v) {
                if (v) {
                    _this._refreshData();
                }
            });
            // Wrap `select` attribute fn
            _this.selectAttrFn = _this.select;
            _this.select = function (item) {
                _this.selectItem(item);
                _this.selectAttrFn({ items: _this.currentValue });
            };
            if (_this.prefilled != null) {
                _this.prefill(_this.prefilled);
            }
            else if (_this.getArea() === 'flights-departure') {
                _this.autocompleter.initialDepartureAirports().then(function (result) { return _this.update(result); });
            }
            _this.$scope.$watch('extraFocusTrackerFocused', function (val, old) {
                if (val === false && old === true) {
                    _this.blur();
                }
            });
            return _this;
        }
        AirportMultiSelectUnified2.prototype.init = function (elements) {
            this.elements = elements;
            this.inputField = this.elements.input;
        };
        AirportMultiSelectUnified2.prototype.prefill = function (data) {
            var _this = this;
            var prefill = data.split(/\s*,\s*/);
            this.prefix = data;
            this.fetch().then(function () {
                prefill.forEach(function (code) {
                    _this.available.forEach(function (item) {
                        if (item.Code === code) {
                            _this.select(item);
                        }
                    });
                });
            });
        };
        Object.defineProperty(AirportMultiSelectUnified2.prototype, "placeholder", {
            get: function () {
                return this._placeholder;
            },
            set: function (placeholder) {
                if (!this.notActive) {
                    this._placeholder = placeholder;
                }
                else {
                    this._placeholder = this.resourceService.get('DEFAULTAIRPORT');
                }
            },
            enumerable: true,
            configurable: true
        });
        AirportMultiSelectUnified2.prototype.update = function (result) {
            // Called by super.fetch() with autocompleter.lookup result
            this.available = result.data;
            this._refreshData();
            if (this.data && !this.data.length && !this.notActive) {
                this.data = null;
                var prefix_1 = (result.prefix + '').toLowerCase();
                var hasPrefixAlreadyBeenUsed = prefix_1 &&
                    _.find(this.currentValue, function (v) { return (v.Title + '').toLowerCase().indexOf(prefix_1) > -1; });
                if (!hasPrefixAlreadyBeenUsed) {
                    this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
                }
            }
        };
        AirportMultiSelectUnified2.prototype.selectItem = function (item) {
            var _this = this;
            if (item && item.Code) {
                // Add codes which are not already selected
                var codes = item.Code.split(',');
                _.forEach(codes, function (code) {
                    if (!_this.isCodeSelected(code)) {
                        if (!_this.currentValue) {
                            _this.currentValue = [];
                        }
                        var individual = _.find(_this.available, function (i) { return i.Code === code; });
                        individual = individual ? angular.copy(individual) : { Code: code, Title: item.Title };
                        _this.currentValue.push(individual);
                    }
                });
                this.prefix = '';
                this._refreshData();
            }
        };
        AirportMultiSelectUnified2.prototype.removeItem = function (item) {
            if (!item) {
                return;
            }
            this.currentValue.splice(this.currentValue.indexOf(item), 1);
            if (!this.currentValue.length) {
                this.deselect();
            }
            else {
                this.selectAttrFn({ items: this.currentValue });
            }
            this._refreshData();
        };
        AirportMultiSelectUnified2.prototype.blur = function () {
            var _this = this;
            this.$timeout(function () {
                if (_this.prefix) {
                    var firstItem = _.find(_this.data || [], function (d) { return !d.header; });
                    if (firstItem) {
                        _this.select(firstItem);
                    }
                }
            }, 200);
        };
        AirportMultiSelectUnified2.prototype.focusOnInput = function () {
            this.inputField.focus();
        };
        AirportMultiSelectUnified2.prototype.firstTitle = function () {
            if (!this.$scope.extraFocusTrackerFocused) {
                if (this.currentValue && this.currentValue[0]) {
                    return this.getTitle(this.currentValue[0]);
                }
            }
        };
        AirportMultiSelectUnified2.prototype.getTitle = function (airport) {
            var _this = this;
            if (airport.Code in this.titleCache) {
                return this.titleCache[airport.Code];
            }
            if (airport.Title) {
                return this.titleCache[airport.Code] = this.formatTitle(airport.Title);
            }
            this.destinationService
                .getAirport(airport.Code)
                .then(function (airport) { return _this.titleCache[airport.Code] = _this.formatTitle(airport.Title); });
            return this.titleCache[airport.Code] = ' ';
        };
        AirportMultiSelectUnified2.prototype.formatTitle = function (title) {
            return (title || '').split('(')[0].split(',')[0];
        };
        AirportMultiSelectUnified2.prototype._refreshData = function () {
            //this.data = this.addHeader(this._getAvailable(), 'AIRPORTS');
            this.data = this._getAvailable();
        };
        AirportMultiSelectUnified2.prototype._getAvailable = function () {
            var _this = this;
            // Filters out items where all codes are already selected
            return _.reject(this.available, function (item) { return _.every(item.Code.split(','), _this.isCodeSelected); });
        };
        return AirportMultiSelectUnified2;
    }(Autocompleter.AutocompleterField));
    angular
        .module('TR')
        .directive('airportMultiSelectUnified2', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'ac',
            bindToController: {
                placeholder: '@',
                select: '&',
                deselect: '&',
                currentValue: '=',
                focusTracker: '=',
                minPrefix: '@',
                notActive: '@',
                prefilled: '@',
                disabled: '@',
                areaOverride: '@',
                iconName: '@?'
            },
            templateUrl: 'partials/home/directivetemplate?type=AirportMultiSelectUnified',
            controller: AirportMultiSelectUnified2,
            transclude: true,
            link: function (scope, el, attrs, ac) {
                var elements = {
                    el: el,
                    field: el.find('.field'),
                    input: el.find('input')
                };
                ac.init(elements);
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
var Core;
(function (Core) {
    var BookingExtrasCarHireOption = /** @class */ (function () {
        function BookingExtrasCarHireOption() {
        }
        BookingExtrasCarHireOption.prototype.select = function ($event) {
            $event.preventDefault();
            this.selectCar({ quoteId: this.quote.CarHireId.CarHireCode });
        };
        return BookingExtrasCarHireOption;
    }());
    angular
        .module('TR')
        .directive('bookingExtrasCarHireOption', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            bindToController: {
                quote: '=',
                model: '=',
                selectable: '=',
                selectCar: '&'
            },
            controller: BookingExtrasCarHireOption,
            controllerAs: 'cho',
            templateUrl: 'partials/home/directivetemplate?type=BookingExtrasCarHireOption'
        };
    });
})(Core || (Core = {}));
/**
 * Created by bdickson on 15/06/2016.
 */
var TR;
(function (TR) {
    var BookingExtrasOptionOld = /** @class */ (function () {
        function BookingExtrasOptionOld($scope) {
            var _this = this;
            // watch the model
            $scope.$watch('beo.model', function (model) {
                _this._checkSelected();
            });
        }
        BookingExtrasOptionOld.prototype.click = function (event) {
            // update the model only if the value has changed
            if (!angular.equals(this.model, this.val)) {
                this.model = this.val;
            }
        };
        BookingExtrasOptionOld.prototype._checkSelected = function () {
            this.selected = angular.equals(this.model, this.val);
            //this._input.prop('checked', this.selected);
        };
        return BookingExtrasOptionOld;
    }());
    angular
        .module('TR')
        .directive('bookingExtrasOptionOld', function () {
        return {
            scope: {},
            bindToController: {
                model: '=',
                val: '=',
                group: '@',
                price: '=',
                perPerson: '=',
                pricePerDay: '=',
                isDelta: '=?',
                pricePerPerson: '=?',
                priceFull: '=?',
                included: '=?',
                priceRounded: '=?'
            },
            controller: BookingExtrasOptionOld,
            controllerAs: 'beo',
            templateUrl: 'partials/home/directivetemplate?type=BookingExtrasOptionOld',
            transclude: true,
            replace: true,
        };
    });
})(TR || (TR = {}));
var Core;
(function (Core) {
    var BookingFormHeader = /** @class */ (function () {
        function BookingFormHeader(tripService, $routeParams, basketStore, $q, resourceService) {
            var _this = this;
            this.tripHeading = '';
            tripService.getTrip($routeParams.tripId)
                .then(function (trip) {
                var promise = $q.when();
                var resource = '';
                switch (trip.TripType) {
                    case tripService.tripTypes.Holiday:
                        resource = resourceService.get('YOURHOLIDAYTO');
                        promise = basketStore.hotel(trip.BasketId);
                        break;
                    case tripService.tripTypes.Hotel:
                        resource = resourceService.get('YOURHOTELIN');
                        promise = basketStore.hotel(trip.BasketId);
                        break;
                    case tripService.tripTypes.Flight:
                        resource = resourceService.get('YOURFLIGHTTO');
                        promise = basketStore.flight(trip.BasketId);
                        break;
                    case tripService.tripTypes.Transfer:
                        resource = resourceService.get('YOURTRANSFERTO');
                        promise = basketStore.transfer(trip.BasketId);
                        break;
                    case tripService.tripTypes.Parking:
                        resource = resourceService.get('YOURAIRPORTPARKINGAT');
                        break;
                    case tripService.tripTypes.Attractions:
                        resource = resourceService.get('YOURATTRACTIONS');
                        break;
                    case tripService.tripTypes.Insurance:
                        resource = resourceService.get('YOURTRAVELINSURANCE');
                        break;
                    case tripService.tripTypes.Marhaba:
                        resource = resourceService.get('YOURMARHABA');
                        break;
                }
                promise.then(function (result) {
                    if (result) {
                        var detail = function () {
                            var prop = 'Details.Location';
                            switch (trip.TripType) {
                                case tripService.tripTypes.Flight:
                                    prop = 'Details.Itinerary.Legs[0].ArrivalAirport.Title';
                                    break;
                                case tripService.tripTypes.Transfer:
                                    prop = 'Details.Itinerary.OutboundLeg.DestinationPoint';
                                    break;
                                case tripService.tripTypes.Attractions:
                                    prop = 'LineItems[0].Description.Title';
                                    break;
                            }
                            return prop;
                        };
                        var destination = result ? _.get(result, detail(), '') : '';
                        if (!destination) {
                            if (trip.TripType === tripService.tripTypes.Transfer) {
                                destination = _.get(result, 'Details.Itinerary.InboundLeg.DestinationPoint', '');
                            }
                        }
                        _this.tripHeading = String.format(resource, destination);
                    }
                    else if (trip.TripType === tripService.tripTypes.Parking) {
                        _this.tripHeading = String.format(resource, _.get(trip, 'ParkingRequest.Airport.ShortTitle', ''));
                    }
                    else {
                        _this.tripHeading = resource;
                    }
                });
            });
        }
        return BookingFormHeader;
    }());
    angular
        .module('core')
        .directive('bookingFormHeader', function (tripService, $routeParams, basketStore, resourceService) {
        return {
            restrict: 'E',
            template: "<div class=\"sc-o-row u-grid-gutter-y\">\n                            <div class=\"sc-o-col-m-8 sc-o-col-l-6\">\n                                <h1 class=\"sc-o-hero-heading sc-o-hero-heading--s\">\n                                    {{ bfh.tripHeading }}\n                                </h1>\n                            </div>\n                        </div>",
            controller: BookingFormHeader,
            controllerAs: 'bfh'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var BookingFormSummary = /** @class */ (function () {
        function BookingFormSummary() {
            this.links = {
                details: {
                    enabled: false,
                    caption: this.detailsLinkCaption || ''
                },
                change: {
                    enabled: false,
                    caption: this.changeLinkCaption || '',
                    state: this.workflowState || 0,
                }
            };
            function changeWorkflow(state) {
                this.onChange(state);
            }
        }
        return BookingFormSummary;
    }());
    angular
        .module('core')
        .directive('bookingFormSummary', function ($route) {
        return {
            link: function (scope) {
                var type = $route.current.area;
                scope.template = "partials/booking/template?name=BookingSummary" + type;
            },
            template: "<div ng-include='template'></div>"
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var BookingSummaryBreakdown = /** @class */ (function () {
        function BookingSummaryBreakdown() {
        }
        return BookingSummaryBreakdown;
    }());
    angular
        .module('core')
        .directive('bookingSummaryBreakdown', function () {
        return {
            scope: {},
            restrict: 'E',
            bindToController: {
                title: '@',
                total: '='
            },
            controller: BookingSummaryBreakdown,
            controllerAs: 'bsb',
            replace: true,
            templateUrl: 'partials/booking/template?name=BookingSummaryBreakdown'
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('canonicalTags', canonicalDirective);
    function canonicalDirective(broker, $document, urlUtils) {
        return {
            restrict: 'E',
            link: link
        };
        function link(scope) {
            broker.subscribe('canonicalDirective', 'seoCanonicalDetected', function (eventData) {
                _.map($document[0].head.getElementsByTagName('link'), function (linkTag) {
                    if (linkTag.rel === 'canonical' || linkTag.rel === 'alternate') {
                        linkTag.href = setCanonicalFid(linkTag.href, eventData.data.fid);
                    }
                });
            });
            scope.$on('$destroy', function () {
                broker.unsubscribe('canonicalDirective');
            });
        }
        // this assumes that a canonical url with a fid will be the path + the single fid parameter
        function setCanonicalFid(targetUrl, fid) {
            var parsedHref = urlUtils.parse(targetUrl);
            return parsedHref.url + "?fid=" + fid;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .directive('datepickerMkc', datepickerMkc);
    function datepickerMkc(dateUtil) {
        return {
            restrict: 'E',
            link: _linker,
            require: '^datePicker'
        };
        function _linker(scope, el, attr, datepicker) {
            /* In the event of a transclusion inside an isolated-scope-directive the transcluding
               directive's scope will always be the previous sibling.
               This approach forced me to use an angular private property but, at least, we're not
               polluting the controller's scope (when using a shared directive-controller we can't
               create an isolated scope because we're on the same element) */
            var tScope = scope.$parent;
            var dateEl = datepicker.dateEl;
            scope = tScope.currentDate;
            dateEl.on('keydown', function switchToTab(event) {
                /* If we have two datepicker on the same page and we are concurrently updating them
                   both the update event on the second dp will show the date selection div this will
                   forcefully hide it */
                if (event.which === 13) {
                    $('#ui-datepicker-div').fadeOut('fast');
                }
                if (event.which === 9) {
                    tScope.$apply(function () {
                        tScope.select({ date: dateEl.datepicker('getDate') });
                    });
                }
            });
            tScope.$watch('currentDate', function (val) {
                if (val) {
                    dateEl.datepicker('setDate', dateUtil.parseDate(tScope.currentDate));
                }
            });
            tScope.$on('$destroy', function () {
                dateEl.off('input');
                dateEl.off('blur');
                dateEl.off('keydown');
            });
        }
    }
})();
/* tslint:disable:max-line-length */
var Device;
(function (Device) {
    var DeviceMeta = /** @class */ (function () {
        function DeviceMeta() {
            // http://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-mobile-device-in-jquery
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                var metaTag = document.querySelector('meta[name=viewport]');
                metaTag.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
            }
        }
        return DeviceMeta;
    }());
    angular.module('core')
        .directive('deviceMeta', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controller: DeviceMeta
        };
    });
})(Device || (Device = {}));
var Core;
(function (Core) {
    function factory(template) {
        return function () {
            return {
                scope: true,
                bindToController: {
                    message: '@'
                },
                restrict: 'E',
                controller: 'DiscountMessage',
                controllerAs: 'dm',
                template: template,
                replace: true
            };
        };
    }
    var messageTemplate = "\n        <div class=\"hype-message hype-message-discount\">\n            {{::dm.message}}\n        </div>";
    var DiscountMessage = /** @class */ (function () {
        function DiscountMessage() {
        }
        return DiscountMessage;
    }());
    angular.module('core')
        .controller('DiscountMessage', DiscountMessage)
        .directive('discountMessage', factory(messageTemplate));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var FlightBookingSummary = /** @class */ (function () {
        function FlightBookingSummary($q, $routeParams, $scope, basketStore, broker, tripService, occupancyService) {
            var _this = this;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.basketStore = basketStore;
            this.broker = broker;
            this.tripService = tripService;
            this.occupancyService = occupancyService;
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                if (trip && trip.BasketId) {
                    _this.trip = trip;
                    tripService.getTripOccupancy(trip.TripId)
                        .then(function (results) {
                        _this.occupancy = results[0];
                    });
                    _this.getCostBreakdown();
                    _this.updateFlightInfo();
                    broker.subscribe('FlightBookingSummary', 'basketUpdated', function () {
                        _this.getCostBreakdown();
                        _this.updateFlightInfo();
                    });
                    broker.subscribe('FlightBookingSummary', 'updatePricesOnPUP', function (e) {
                        _this.getCostBreakdown();
                        _this.updateFlightInfo();
                    });
                    $scope.$on('$destroy', function () {
                        broker.unsubscribe('FlightBookingSummary');
                    });
                }
            });
        }
        FlightBookingSummary.prototype.getCostBreakdown = function () {
            var _this = this;
            this.$q.all([
                this.basketStore.totalCost(this.trip.BasketId),
                this.basketStore.costBreakdownGrouped(this.trip.BasketId),
                this.basketStore.carHire(this.trip.BasketId),
                this.basketStore.isAtolProtected(this.trip.BasketId),
                this.basketStore.attractionCost(this.trip.BasketId)
            ]).then(function (_a) {
                var totalCost = _a[0], costBreakdownGrouped = _a[1], carHire = _a[2], isAtolProtected = _a[3], attractionsCost = _a[4];
                _this.totalCost = parseFloat(totalCost);
                _this.atolAvailable = isAtolProtected;
                _this.attractionsCost = attractionsCost;
                _.each(costBreakdownGrouped, function (cb) {
                    if (cb.group === 2) {
                        // FLIGHTS
                        _this.flightCost = cb.total;
                        var atol = _.find(cb.costBreakdown, function (item) {
                            return item.Description.indexOf('ATOL') >= 0;
                        });
                        if (atol) {
                            _this.atolCost = atol.UnitAmount * atol.Quantity;
                            _this.flightCost = cb.total - _this.atolCost; // subtract the atol cost from the flights total
                        }
                        else {
                            _this.flightCost = cb.total;
                        }
                    }
                    else if (cb.group === 3) {
                        // EXTRAS
                        _this.extrasCost = cb.total;
                        _this.extras = _this.basketStore.extrasBreakdown(cb.costBreakdown);
                    }
                });
                var carHireExtras = _.get(carHire, 'RequestedItems');
                _this.carHireExtras = carHireExtras;
                _this.carHireExtrasTotal = carHireExtras ?
                    carHireExtras.reduce(function (total, extra) { return total += extra.UnitAmount; }, 0) :
                    undefined;
            });
        };
        FlightBookingSummary.prototype.updateFlightInfo = function () {
            var _this = this;
            this.basketStore.flight(this.trip.BasketId)
                .then(function (flight) {
                _this.flight = flight;
                _this.nights = _this.flight.Details.Itinerary.Nights;
            });
        };
        FlightBookingSummary.prototype.showDetails = function (e) {
            var passengers = this.occupancyService.getTotalPeopleCounts();
            e.preventDefault();
            this.broker.publish('showModalFlightDetails', { flight: this.flight.Details.Itinerary });
        };
        return FlightBookingSummary;
    }());
    angular
        .module('core')
        .directive('flightBookingSummary', function () {
        return {
            scope: {},
            restrict: 'E',
            bindToController: {
                cardFeeForTotal: '=?'
            },
            controller: FlightBookingSummary,
            controllerAs: 'fbs',
            replace: true,
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=FlightBookingSummary&version='
                        + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=FlightBookingSummary';
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var HotelList = /** @class */ (function () {
        function HotelList($scope, imageService, urlUtils) {
            var _this = this;
            this.$scope = $scope;
            this.imageService = imageService;
            this.urlUtils = urlUtils;
            this.hotelImageIndex = 0;
            this.hotelImages = [];
            this.ready = false;
            this.showHotelImages = false;
            this.spinnerId = 0;
            if (!this.hotels) {
                var watch_1 = $scope.$watch('hl.hotels', function (n, o) {
                    if (n && n !== o) {
                        _this.ready = true;
                        watch_1();
                    }
                });
            }
            else {
                this.ready = true;
            }
        }
        HotelList.prototype.selectHotel = function (hotel) {
            this.spinnerId = hotel.Id;
        };
        HotelList.prototype.openImageGallery = function (hotelId, photoCount, e) {
            e.preventDefault();
            var w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
            var h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
            this.hotelImageIndex = 0;
            this.hotelImages = [];
            for (var i = 0, l = photoCount; i < l; i++) {
                this.hotelImages.push({
                    src: this.imageService.getImageUrl(hotelId, w, h, i, false)
                });
            }
            this.showHotelImages = true;
        };
        HotelList.prototype.getHotelUrl = function (hotel) {
            return this.urlUtils.stripLeadingSlash(hotel.Url);
        };
        return HotelList;
    }());
    angular
        .module('core')
        .directive('hotelList', function () {
        return {
            scope: {},
            controller: HotelList,
            controllerAs: 'hl',
            replace: true,
            bindToController: {
                hotels: '=',
                removeHotel: '&'
            },
            templateUrl: 'partials/home/directivetemplate?type=HotelList'
        };
    });
})(Core || (Core = {}));
var LangSwitcher;
(function (LangSwitcher) {
    function languageSwitcher() {
        return {
            bindToController: {},
            restrict: 'E',
            replace: true,
            controller: 'LanguageSwitcher',
            controllerAs: 'ls',
            templateUrl: 'partials/home/directivetemplate?type=LanguageSwitcher',
        };
    }
    var LanguageSwitcher = /** @class */ (function () {
        function LanguageSwitcher(languageService, $location, $scope, $route) {
            var _this = this;
            this.languageService = languageService;
            this.$location = $location;
            this.$scope = $scope;
            this.$route = $route;
            this.enabled = true;
            this.menu = false;
            this.$scope.$on('$routeChangeSuccess', function () {
                var path = $location.path();
                _this.enabled = !/book/.test(path) && !/options/.test(path);
            });
        }
        LanguageSwitcher.prototype.toggle = function () {
            this.menu = !this.menu;
        };
        LanguageSwitcher.prototype.isRegionEnabled = function (region) {
            var host = this.$location.host();
            var exit = TRPCONFIG.Domain.EnabledRegionOnLangSelectorOverride;
            if (host && host.endsWith(exit)) {
                return true;
            }
            var regions = TRPCONFIG.Domain.EnabledRegionOnLangSelector.split(',') || [];
            return regions.includes(region);
        };
        LanguageSwitcher.prototype.setLanguage = function (lang, id) {
            var _this = this;
            this.languageService.setLanguage(lang, id).then(function () {
                if (TRPCONFIG.Domain.RedirectLanguageChangeToHomepage &&
                    TRPCONFIG.Domain.DomainId !== Number(id)) {
                    window.location.href = '/?rl=1';
                }
                else {
                    window.location.href = _this.$location.absUrl();
                }
            });
        };
        return LanguageSwitcher;
    }());
    angular
        .module('TR')
        .controller('LanguageSwitcher', LanguageSwitcher)
        .directive('languageSwitcher', languageSwitcher);
})(LangSwitcher || (LangSwitcher = {}));
var Core;
(function (Core) {
    var LoaderPanel = /** @class */ (function () {
        function LoaderPanel() {
        }
        return LoaderPanel;
    }());
    angular
        .module('core')
        .directive('loaderPanel', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            bindToController: {
                busy: '='
            },
            controller: LoaderPanel,
            controllerAs: 'lp',
            template: '<div ng-show="lp.busy" class="loader-panel">' +
                '<preloader class="circular subtle large"></preloader>' +
                '</div>'
        };
    });
})(Core || (Core = {}));
var Autocompleter;
(function (Autocompleter) {
    var ManySelect = /** @class */ (function () {
        function ManySelect($scope, $route, autocompleter, resourceService, $q, $timeout, arrayUtil) {
            var _this = this;
            this.$scope = $scope;
            this.$route = $route;
            this.autocompleter = autocompleter;
            this.resourceService = resourceService;
            this.$q = $q;
            this.$timeout = $timeout;
            this.arrayUtil = arrayUtil;
            $timeout(function () {
                $scope.$watch(function () { return ({ options: _this.options, model: _this.model, prefix: _this.prefix }); }, function (val) {
                    _this.remainingOptions = _this.arrayUtil.difference(val.options, val.model);
                    var prefix = val.prefix && val.prefix.toLowerCase();
                    if (prefix) {
                        _this.remainingOptions = _.filter(_this.remainingOptions, function (o) { return o.Title && o.Title.toLowerCase().indexOf(prefix) > -1; });
                    }
                }, true);
            });
        }
        ManySelect.prototype.select = function (item) {
            if (item && this.model) {
                var isAlreadySelected = _.some(this.model, function (o) { return angular.equals(item, o); });
                if (!isAlreadySelected) {
                    this.model.push(item);
                }
                this.prefix = '';
            }
        };
        ManySelect.prototype.removeItem = function (item) {
            if (item) {
                this.model.splice(this.model.indexOf(item), 1);
            }
        };
        ManySelect.prototype.blur = function () {
            var _this = this;
            this.$timeout(function () {
                if (_this.prefix) {
                    var firstItem = _.find(_this.remainingOptions, function (d) { return !d.header; });
                    if (firstItem) {
                        _this.select(firstItem);
                    }
                }
            }, 200);
        };
        return ManySelect;
    }());
    angular
        .module('TR')
        .directive('manySelect', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'ms',
            bindToController: {
                placeholder: '@',
                model: '=',
                options: '=',
                iconClass: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=ManySelect',
            controller: ManySelect,
            transclude: true,
            link: function (scope, el) {
                scope.ms.inputField = el.find('input');
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
var Core;
(function (Core) {
    function MonthPicker($location, dateUtil, searchUnitService) {
        return {
            scope: {
                value: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=MonthPicker',
            link: function ($scope, $element) {
                $scope.showSelectors = false;
                $scope.range = (function () {
                    var origin = dateUtil.todayPlus(4);
                    var year = origin.getFullYear();
                    var month = origin.getMonth();
                    var months = _.range(month, month + 12);
                    return _.map(months, function (m) { return new Date(year, m, 15, 0, 0, 0, 0); });
                })();
                $scope.onSelectorClick = function ($event, date) {
                    $scope.value = date;
                    $location.search('startDate', dateUtil.format(date, 'yyyy-MM-dd'));
                    searchUnitService.startDate(1, date);
                    $scope.showSelectors = false;
                    if ($event.stopPropagation) {
                        $event.stopPropagation();
                    }
                };
                $scope.onInputClick = function ($event) {
                    $scope.showSelectors = !$scope.showSelectors;
                    if ($event.stopPropagation) {
                        $event.stopPropagation();
                    }
                };
                $scope.preventClose = function ($event) {
                    if ($event.stopPropagation) {
                        $event.stopPropagation();
                    }
                };
                $(document.body).on('click.monthPicker', function (e) {
                    $scope.showSelectors = false;
                    $scope.$apply();
                });
                $scope.$on('$destroy', function () {
                    $(document.body).off('click.monthPicker');
                });
            }
        };
    }
    angular
        .module('core')
        .directive('monthPicker', MonthPicker);
})(Core || (Core = {}));
angular
    .module('core')
    .directive('noIndexFollow', function ($rootScope, broker) {
    return {
        restrict: 'EA',
        replace: true,
        template: '<meta name="robots" content="noindex, follow" ng-if="nif.isNoIndexFollow" />',
        controllerAs: 'nif',
        controller: function ($scope) {
            var _this = this;
            $rootScope.$on('$routeChangeStart', function () { return _this.isNoIndexFollow = false; });
            broker.subscribe('noIndexFollow', 'ISNOINDEXFOLLOW', function (e) { return _this.isNoIndexFollow = e.data.isNoIndexFollow; });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('noIndexFollow');
            });
        }
    };
});
(function () {
    'use strict';
    angular
        .module('core')
        .directive('pauseCall', pauseCall);
    function pauseCall($rootScope, agentModeService, resourceService, broker) {
        return {
            restrict: 'A',
            link: _linker
        };
        function _linker(scope, element) {
            var structure = _createStructure();
            element.on('focus', 'input, select', _pollingStatus);
            broker.subscribe('pauseCallDirective', 'pciFrameFocus', _pollingStatus);
            var extensions = $rootScope.agent ? $rootScope.agent.PhoneNumbers : [];
            scope.$on('$destroy', function () {
                $(structure.action).off('click');
                broker.unsubscribe('pauseCallDirective');
            });
            function _pollingStatus() {
                _bringInFocus(element);
                _bringInFocus($('#payment-details'));
                agentModeService
                    .checkExtensionStatus(extensions)
                    .then(function existActiveExtension(exists) {
                    if (exists) {
                        structure.overlay.style.display = 'block';
                        _addMessages({ messageText: resourceService.get('CPTRYPAUSE') });
                        _tryToPause();
                    }
                    else {
                        _hideOverlay();
                    }
                });
            }
            function _tryToPause() {
                agentModeService
                    .pauseCall()
                    .then(function _successfullyPaused() {
                    _addMessages({
                        messageText: resourceService.get('CPSUCCESSPAUSE'),
                        actionText: resourceService.get('CPRESUME'),
                        actionHandler: _tryToResume
                    });
                }, function _pauseFailed(errorString) {
                    if (errorString === 'ABORT') {
                        _hideOverlay();
                        return;
                    }
                    _addMessages({
                        messageText: resourceService.get('CPFAILPAUSE') + " " + errorString,
                        actionText: resourceService.get('CPTRYAGAIN'),
                        actionHandler: _tryToPause
                    }, {
                        messageText: resourceService.get('CPOR')
                    }, {
                        actionText: resourceService.get('CPCONTINUEUNPAUSED'),
                        actionHandler: _forceContinue('Pause')
                    });
                });
            }
            function _tryToResume() {
                agentModeService
                    .resumeCall()
                    .then(function _successfullyResumed() {
                    _addMessages({
                        messageText: resourceService.get('CPSUCCESSRESUME'),
                        actionText: resourceService.get('CPHIDE'),
                        actionHandler: _hideOverlay
                    });
                }, function _resumeFailed(errorString) {
                    if (errorString === 'ABORT') {
                        _hideOverlay();
                        return;
                    }
                    _addMessages({
                        messageText: resourceService.get('CPFAILRESUME') + " " + errorString,
                        actionText: resourceService.get('CPTRYAGAIN'),
                        actionHandler: _tryToResume
                    }, {
                        messageText: resourceService.get('CPOR')
                    }, {
                        actionText: resourceService.get('CPCONTINUE'),
                        actionHandler: _forceContinue('Resume')
                    });
                });
            }
            function _forceContinue(type) {
                return function () {
                    agentModeService.logFatalError(type);
                    _hideOverlay();
                };
            }
            function _bringInFocus(el) {
                el.css('z-index', 4200);
                el.css('position', 'relative');
            }
            function _hideOverlay() {
                structure.container.style.display = 'none';
                structure.overlay.style.display = 'none';
                element.css('z-index', 0);
                $('#payment-details').css('z-index', 0);
            }
            function _addMessages() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                while (structure.container.lastChild) {
                    structure.container.removeChild(structure.container.lastChild);
                }
                for (var i = 0, ii = args.length; i < ii; i++) {
                    var curr = args[i];
                    var message = document.createElement('span');
                    message.textContent += i > 0 ? ' ' : '';
                    message.textContent += curr.messageText ? curr.messageText + " " : '';
                    structure.container.appendChild(message);
                    var action = document.createElement('span');
                    action.className = 'pause-resume-action';
                    action.textContent = curr.actionText || '';
                    action.onclick = curr.actionHandler || undefined;
                    structure.container.appendChild(action);
                }
                structure.container.style.display = 'block';
            }
            function _createStructure() {
                var overlay = document.createElement('div');
                overlay.className = 'pause-resume-overlay';
                document.body.appendChild(overlay);
                var messageContainer = document.createElement('div');
                messageContainer.className = 'agent-panel';
                messageContainer.style.display = 'none';
                element[0].appendChild(messageContainer);
                return {
                    overlay: overlay,
                    container: messageContainer
                };
            }
        }
    }
})();
var Core;
(function (Core) {
    var ScrollToTopWhen = /** @class */ (function () {
        function ScrollToTopWhen($scope, $timeout, broker) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.broker = broker;
        }
        ScrollToTopWhen.prototype.init = function (element, eventName) {
            var _this = this;
            this.broker.subscribe('ScrollToTopWhen', eventName, function (e) {
                _this.$timeout(function () {
                    angular.element(element)[0].scrollTop = 0;
                }, 100);
            });
            this.$scope.$on('$destroy', function () {
                _this.broker.unsubscribe('ScrollToTopWhen');
            });
        };
        return ScrollToTopWhen;
    }());
    angular
        .module('core')
        .directive('scrollToTopWhen', function () {
        return {
            scope: {},
            restrict: 'A',
            controller: ScrollToTopWhen,
            controllerAs: 'sttw',
            link: function (scope, el, attr, controller) {
                controller.init(el, attr['scrollToTopWhen']);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AgentNetInfoService = /** @class */ (function () {
        function AgentNetInfoService() {
            this.costTypes = {
                AdultReturn: 'AdultReturnTicket',
                AdultTaxAirlineFees: 'AdultTaxandAirlineFees'
            };
            this.commissionTypes = {
                Commission: 'Commission',
                Markup: 'Markup'
            };
            this.calculationItemTypes = {
                ExchangeRate: 4,
                ClientExchangeRate: 11,
                Commission: 2,
                Rounding: 12,
                Markup: 7,
                SupplierNetRate: 1,
                SupplierGrossRate: 5,
                SupplierBindingPrice: 3,
                Vat: 0,
                PriceAdjustment: 15,
                Promotion: 16,
                Markdown: 99
            };
            this.modes = {
                Hotel: 'hotel',
                Flight: 'flight',
                Markup: 'markup',
                HotelInfo: 'hotelinfo'
            };
            this.requiredProps = {
                hotel: ['Type'],
                flight: ['AdultNetFare.Amount'],
                markup: ['Type'],
                hotelinfo: ['AgentToolTip.SupplierNetRate',
                    'AgentToolTip.CommissionPercentage',
                    'AgentToolTip.TotalCommission', 'Cost']
            };
        }
        AgentNetInfoService.prototype.parse = function (data, mode) {
            switch (mode) {
                case this.modes.Hotel:
                    return this._parseHotelData(data);
                case this.modes.Flight:
                    return this._parseFlightData(data);
                case this.modes.Markup:
                    return this._parseMarkupData(data);
                case this.modes.HotelInfo:
                    return this._parseHotelInfo(data);
                default:
                    return this._getDefaultValues();
            }
        };
        AgentNetInfoService.prototype.hasRequiredValues = function (data, mode) {
            switch (mode) {
                case this.modes.Hotel:
                case this.modes.Flight:
                case this.modes.Markup:
                    return this._validate(data, this.requiredProps[mode.toLowerCase()]);
                case this.modes.HotelInfo:
                    return this._validate(data, this.requiredProps[mode.toLowerCase()], true);
                default:
                    return false;
            }
        };
        AgentNetInfoService.prototype._getDefaultValues = function () {
            return {
                SupplierNetRate: 0, CommissionAmount: 0, CommissionPercentage: 0, Tax: 0,
                TaxCommissionAmount: 0, TaxCommissionPercentage: 0, TotalGross: 0,
                CommissionType: this.commissionTypes.Commission
            };
        };
        AgentNetInfoService.prototype._validate = function (data, props, showNegativeValues) {
            if (showNegativeValues === void 0) { showNegativeValues = false; }
            var valid = false;
            if (_.isArray(data)) {
                valid = data.every(function (item) {
                    return props.every(function (prop) {
                        return _.has(item, prop);
                    });
                });
            }
            else {
                valid = props.every(function (prop) {
                    var hasProp = _.has(data, prop);
                    if (!showNegativeValues) {
                        return hasProp && _.get(data, prop, 0) > 0;
                    }
                    return hasProp;
                });
            }
            return valid;
        };
        AgentNetInfoService.prototype._parseHotelData = function (data) {
            var _this = this;
            var netValues = this._getDefaultValues();
            //Commission
            var commission = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Commission;
            });
            netValues.CommissionPercentage = this._calculateValue(commission, 'CommissionPercent');
            netValues.CommissionAmount = this._calculateValue(commission, 'Cost.Value');
            netValues.CommissionCurrency = this._getCurrencyCode(commission);
            // Commission changes
            var commissionChanges = data.filter(function (item) {
                return item.Type === _this.calculationItemTypes.Markup
                    && item.PercentChange && item.Cancelled === false;
            });
            if (commissionChanges && commissionChanges.length > 0) {
                var firstChange = commissionChanges.find(function (change) {
                    return change.Cost.CurrencyCode !== '';
                });
                netValues.CommissionCurrency = this._getCurrencyCode(firstChange);
            }
            var commissionChangeTotal = commissionChanges.reduce(function (total, value) {
                return total + (value.PercentChange || 0);
            }, netValues.CommissionPercentage);
            netValues.CommissionPercentage += (commissionChanges && commissionChanges.length > 0)
                ? commissionChangeTotal : 0;
            //SupplierNetRate
            var supplierPrefs = [
                this.calculationItemTypes.ExchangeRate,
                this.calculationItemTypes.SupplierNetRate,
                this.calculationItemTypes.SupplierGrossRate
            ];
            var supplierRate;
            for (var index = 0; index < supplierPrefs.length; index++) {
                var supplierPref = supplierPrefs[index];
                supplierRate = data.find(function (item) {
                    return item.Type === supplierPref;
                });
                if (supplierRate) {
                    break;
                }
            }
            var supplierRateValue = this._calculateValue(supplierRate, 'Cost.Value');
            netValues.SupplierNetRate = supplierRateValue - (supplierRate && supplierRate.Type
                === this.calculationItemTypes.SupplierNetRate
                ? 0 : netValues.CommissionAmount);
            netValues.SupplierCurrency = this._getCurrencyCode(supplierRate);
            //commission adjustments
            if (netValues.CommissionPercentage > 0 && netValues.CommissionAmount === 0) {
                netValues.CommissionAmount = this._calculatePercentageAmount(netValues.SupplierNetRate, netValues.CommissionPercentage);
            }
            ;
            // Total gross ( rounded up)
            var totalGross = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Rounding;
            });
            var totalGrossValue = this._calculateValue(totalGross, 'Cost.Value');
            netValues.TotalGross = Math.ceil(totalGrossValue);
            //client exchange rate
            var clientExchange = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.ClientExchangeRate;
            });
            var exchangeRate = this._calculateValue(clientExchange, 'ExchangeRate');
            var exchangedGross = (exchangeRate > 0)
                ? netValues.TotalGross / exchangeRate
                : netValues.TotalGross;
            //exchanged commission adjustments
            netValues.CommissionAmount = exchangedGross - netValues.SupplierNetRate;
            if (exchangeRate > 0) {
                netValues.CommissionAmount *= exchangeRate;
            }
            ;
            //remove any markdown value from commission amount
            var markdown = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Markdown;
            });
            var markdownValue = this._calculateValue(markdown, 'MarkdownAmount');
            netValues.CommissionAmount -= markdownValue;
            netValues.CommissionPercentage = (netValues.CommissionAmount / netValues.TotalGross) * 100;
            netValues.TotalGrossCurrency = this._getCurrencyCode(totalGross);
            netValues.CommissionCurrency = netValues.TotalGrossCurrency;
            //VAT
            var outputVat = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Vat;
            });
            netValues.OutputVat = this._calculateValue(outputVat, 'Cost.Value');
            netValues.OutputVatCurrency = netValues.TotalGrossCurrency || this._getCurrencyCode(outputVat);
            return this._formatAsDecimals(netValues);
        };
        AgentNetInfoService.prototype._parseHotelInfo = function (data) {
            var netValues = this._getDefaultValues();
            var currency = data.AgentToolTip.CurrencyCode || TRPCONFIG.Domain.CurrencyCode;
            netValues.SupplierNetRate = data.AgentToolTip.SupplierNetRate || 0;
            netValues.SupplierCurrency = this._getCurrencyCode(data.AgentToolTip.SupplierNetRate, currency);
            netValues.CommissionAmount = data.AgentToolTip.TotalCommission || 0;
            netValues.CommissionPercentage = data.AgentToolTip.CommissionPercentage || 0;
            netValues.CommissionCurrency = this._getCurrencyCode(data.AgentToolTip.TotalCommission, currency);
            netValues.TotalGross = data.Cost || 0;
            netValues.TotalGrossCurrency = this._getCurrencyCode(data.Cost, currency);
            netValues.OutputVat = data.OutputVat || 0;
            netValues.OutputVatCurrency = netValues.TotalGrossCurrency ||
                this._getCurrencyCode(data.OutputVat, currency);
            return this._formatAsDecimals(netValues);
        };
        AgentNetInfoService.prototype._parseFlightData = function (data) {
            var netValues = this._getDefaultValues();
            netValues.SupplierNetRate = this._calculateValue(data, 'AdultNetFare.Amount');
            var commissionMarkup = this._getMarkup(data, this.costTypes.AdultReturn);
            var commission = this._calculateCommission(commissionMarkup, netValues.SupplierNetRate);
            netValues.CommissionAmount = commission.Amount;
            netValues.CommissionPercentage = Math.floor(commission.Percent);
            netValues.CommissionType = commission.CommissionType;
            if (netValues.CommissionType === this.commissionTypes.Commission) {
                netValues.SupplierNetRate -= netValues.CommissionAmount;
            }
            netValues.Tax = this._calculateValue(data, 'AdultNetTax.Amount');
            var taxMarkup = this._getMarkup(data, this.costTypes.AdultTaxAirlineFees);
            var taxcommission = this._calculateCommission(taxMarkup, netValues.Tax);
            netValues.TaxCommissionAmount = taxcommission.Amount;
            netValues.TaxCommissionPercentage = Math.floor(taxcommission.Percent);
            netValues.CommissionType = taxcommission.CommissionType;
            if (netValues.CommissionType === this.commissionTypes.Commission) {
                netValues.Tax -= netValues.TaxCommissionAmount;
            }
            netValues.TotalGross = Math.ceil(netValues.SupplierNetRate
                + netValues.CommissionAmount
                + netValues.Tax
                + netValues.TaxCommissionAmount);
            return this._formatAsDecimals(netValues);
        };
        AgentNetInfoService.prototype._parseMarkupData = function (data) {
            var _this = this;
            var netValues = this._getDefaultValues();
            var commission = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Commission;
            });
            netValues.CommissionPercentage = this._calculateValue(commission, 'CommissionPercent');
            netValues.CommissionAmount = this._calculateValue(commission, 'Cost.Value');
            netValues.CommissionCurrency = this._getCurrencyCode(commission);
            var supplierNetRate = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.SupplierNetRate;
            });
            netValues.SupplierNetRate = this._calculateValue(supplierNetRate, 'Cost.Value');
            var supplierGrossRate = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.SupplierGrossRate;
            });
            var supplierBindingPrice = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.SupplierBindingPrice;
            });
            netValues.SupplierNetRate = this._calculateValue(supplierNetRate, 'Cost.Value');
            netValues.SupplierGrossRate = this._calculateValue(supplierGrossRate, 'Cost.Value');
            netValues.SupplierBindingPrice = this._calculateValue(supplierBindingPrice, 'Cost.Value');
            var activeRate = (supplierNetRate || supplierGrossRate || supplierBindingPrice);
            netValues.SupplierCurrency = this._getCurrencyCode(activeRate);
            var exchangeRate = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.ExchangeRate;
            });
            netValues.ExchangeRate = (exchangeRate && exchangeRate.ExchangeRate) || 0;
            netValues.ExchangeRateTotal = this._calculateValue(exchangeRate, 'Cost.Value');
            netValues.ExchangeCurrency = this._getCurrencyCode(exchangeRate);
            netValues.Markups = data.filter(function (item) {
                return item.Type === _this.calculationItemTypes.Markup;
            }) || [];
            netValues.Markups = netValues.Markups.map(function (markup) {
                if (markup.Markup) {
                    if (markup.Markup.DepartureStartDate && markup.Markup.DepartureStartDate === '0001-01-01T00:00:00') {
                        markup.Markup.DepartureStartDate = '';
                    }
                    if (markup.Markup.DepartureEndDate && markup.Markup.DepartureEndDate === '0001-01-01T00:00:00') {
                        markup.Markup.DepartureEndDate = '';
                    }
                }
                return markup;
            });
            netValues.Promotions = data.filter(function (item) {
                return item.Type === _this.calculationItemTypes.Promotion;
            });
            netValues.PriceAdjustments = data.filter(function (item) {
                return item.Type === _this.calculationItemTypes.PriceAdjustment;
            });
            var totalGross = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Rounding;
            });
            netValues.TotalGross = this._calculateValue(totalGross, 'Cost.Value');
            netValues.TotalGrossCurrency = this._getCurrencyCode(totalGross);
            var outputVat = data.find(function (item) {
                return item.Type === _this.calculationItemTypes.Vat;
            });
            netValues.OutputVat = this._calculateValue(outputVat, 'Cost.Value');
            netValues.OutputVatCurrency = this._getCurrencyCode(outputVat);
            return this._formatAsDecimals(netValues);
        };
        AgentNetInfoService.prototype._calculatePercentageAmount = function (value, percentage) {
            return ((value) / 100) * percentage;
        };
        AgentNetInfoService.prototype._getMarkup = function (data, costType) {
            var markup = { AdditionalInfo: '', CommissionAmount: 0, CommissionPercent: 0,
                MarkupAmount: 0, MarkupPercent: 0, Priority: 0 };
            if (!data || !costType) {
                return markup;
            }
            ;
            if (data.Legs && data.Legs.length) {
                var leg = data.Legs[0];
                if (leg.MarkupsApplied && leg.MarkupsApplied.length) {
                    markup = leg.MarkupsApplied.find(function (item) {
                        return new RegExp(costType, 'g').test(item.AdditionalInfo);
                    });
                }
            }
            return markup;
        };
        AgentNetInfoService.prototype._calculateCommission = function (data, rate) {
            var amount = 0;
            var percent = 0;
            var commissionType = this.commissionTypes.Commission;
            if (data && rate) {
                var commissionPercentage = data.CommissionPercent || 0;
                var commissionAmount = data.CommissionAmount || 0;
                var markupPercentage = data.MarkupPercent || 0;
                var markupAmount = data.MarkupAmount || 0;
                if (markupPercentage > 0 || markupAmount > 0) {
                    commissionType = this.commissionTypes.Markup;
                    if (markupAmount === 0 && markupPercentage > 0) {
                        markupAmount = this._calculatePercentageAmount(rate, markupPercentage);
                    }
                    amount = markupAmount;
                    percent = markupPercentage;
                }
                else {
                    if (commissionAmount === 0 && commissionPercentage > 0) {
                        commissionAmount = this._calculatePercentageAmount(rate, commissionPercentage);
                    }
                    amount = commissionAmount;
                    percent = commissionPercentage;
                }
            }
            return { Amount: amount, Percent: percent, CommissionType: commissionType };
        };
        AgentNetInfoService.prototype._calculateValue = function (data, type, defaultValue) {
            if (defaultValue === void 0) { defaultValue = 0; }
            if (data && type) {
                return _.get(data, type, defaultValue);
            }
            return defaultValue;
        };
        AgentNetInfoService.prototype._getCurrencyCode = function (data, defaultValue) {
            if (defaultValue === void 0) { defaultValue = TRPCONFIG.Domain.CurrencyCode; }
            if (data) {
                return _.get(data, 'Cost.CurrencyCode', defaultValue);
            }
            return defaultValue;
        };
        AgentNetInfoService.prototype._formatAsDecimals = function (value) {
            return _.mapValues(value, function (item) {
                return (!Number.isInteger(item) && item > 0) ? item.toFixed(2) : item;
            });
        };
        AgentNetInfoService.prototype._toNearest10 = function (value) {
            return Math.ceil(value / 10) * 10;
        };
        return AgentNetInfoService;
    }());
    angular
        .module('core')
        .service('agentNetInfoService', AgentNetInfoService);
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .factory('crossSellService', crossSellService);
    function crossSellService(analytics, crossSellCommonService, enumService, imageService, flightExtrasService, $q) {
        var crossSellKeyByProductType = {
            1: 'Flight',
            2: 'Attractions',
            4: 'CarHire',
            8: 'Hotels',
            16: 'Parking',
            32: 'Transfer'
        };
        var maxCrossSell = 4;
        var maxSameType = 2;
        var service = {
            getBookingCrossSell: getBookingCrossSell,
            getTripCrossSell: getTripCrossSell,
            getCrossSellProbability: getCrossSellProbability,
            startCrossSellJourney: startCrossSellJourney,
            addExtrasAndCrossSells: addExtrasAndCrossSells
        };
        function getBookingCrossSell(bookingId) {
            return crossSellCommonService.getBookingCrossSell(bookingId).then(processData);
        }
        function addExtrasAndCrossSells(tr) {
            var crossSells = [];
            var addBaggage = [];
            getTripCrossSell(tr, true).then(function (cs) {
                crossSells = cs || [];
                updateTripWithCrossSells();
            });
            getExtras(tr).then(function (ab) {
                addBaggage = ab || [];
                updateTripWithCrossSells();
            });
            function updateTripWithCrossSells() {
                tr.crossSellProducts = _mergeExtrasAndCrossSells(addBaggage, crossSells);
            }
        }
        function getTripCrossSell(tr) {
            return crossSellCommonService.getTripCrossSell(tr, service.getBookingCrossSell);
        }
        function getExtras(tr) {
            var flightBookingType = 1;
            var flightBooking = _.find(tr.Bookings, function (b) { return b.Type === flightBookingType; });
            return TRPCONFIG.Domain.DashboardAddBagsEnabled && flightBooking
                ? flightExtrasService.getExtrasCrossSell(flightBooking.BookingId)
                : $q.when([]);
        }
        function _mergeExtrasAndCrossSells(extras, crossSells) {
            var crossSellToReplace = crossSells.length + extras.length - maxCrossSell;
            if (crossSellToReplace > 0) {
                _.remove(crossSells, function (cs) {
                    return cs.Priority >= crossSells.length - crossSellToReplace;
                });
            }
            _.each(crossSells, function (cs) { cs.Priority += extras.length; });
            return extras.concat(crossSells);
        }
        function processData(result) {
            if (!result) {
                return [];
            }
            var crossSells = result.data;
            return filterCrossSellByPriority(crossSells).map(function (cs) {
                return _.extend(cs, { roundedCurrency: true });
            });
        }
        function startCrossSellJourney(bookingId, crossSellProduct) {
            crossSellCommonService.startCrossSellJourney(bookingId, crossSellProduct);
        }
        function getCrossSellImage(product) {
            switch (product.ProductType) {
                case enumService.ProductType.Hotel:
                    return imageService.getMainImageUrl(product.EstabId, 400, 140, true);
                case enumService.ProductType.Transfer:
                    return '/build/img/assets/product/transfers.jpg';
                case enumService.ProductType.CarHire:
                    return '/build/img/assets/car_hire.jpg';
                case enumService.ProductType.Parking:
                    return '/build/img/assets/car_parking.jpg';
                case enumService.ProductType.Attraction:
                    return "/attractions/Handlers/crosssellimage.ashx?acsid=" + product.Id;
                default:
                    return '';
            }
        }
        function addProperties(productType, product, type) {
            var productToDisplay = _.merge(_.omit(productType, 'CrossSells'), product);
            _.assignIn(productToDisplay, type);
            productToDisplay.Image = getCrossSellImage(productToDisplay);
            productToDisplay.Price = productToDisplay.AdultPrice || productToDisplay.Price;
            productToDisplay.Title = productToDisplay.Title || productToDisplay.Description || productToDisplay.CarPark;
            return productToDisplay;
        }
        function getCrossSellProbability(basketId, productTypes) {
            return crossSellCommonService.getBasketCrossSell(basketId).then(function (data) {
                var result = {};
                _.forEach(data, function (i) {
                    if (productTypes.indexOf(i.Product) !== -1) {
                        result[i.Product] = i.Probability;
                    }
                });
                analytics.track('Event', 'BasketCrossSell', { BasketId: basketId, ProductProbability: result });
                analytics.track('mixpanel', 'BasketCrossSell', {
                    ProductProbabilityCarHire: result[enumService.ProductType.CarHire],
                    ProductProbabilityTransfer: result[enumService.ProductType.Transfer]
                });
                return result !== {} ? result : null;
            });
        }
        function filterCrossSellByPriority(crossSell) {
            var filteredCrossSell = {};
            var simplifiedCrossSellList = [];
            var counter = 0;
            if (crossSell.Priorities.length > 0) {
                var priorities_1 = _.sortBy(crossSell.Priorities, function (p) { return p.Order; });
                _.times(maxCrossSell, function (c) {
                    if (counter >= priorities_1.length) {
                        counter = 0;
                    }
                    var key = crossSellKeyByProductType[priorities_1[counter].Type];
                    if (!filteredCrossSell[key]) {
                        filteredCrossSell[key] = [];
                    }
                    if (filteredCrossSell[key].length < maxSameType) {
                        var cs = crossSell[key].CrossSells[filteredCrossSell[key].length];
                        if (cs) {
                            cs.Priority = c;
                            cs = addProperties(crossSell[key], cs, crossSellCommonService.productTypeProperties[key]);
                            filteredCrossSell[key].push(cs);
                        }
                    }
                    counter++;
                });
                _.each(priorities_1, function (p) { return simplifiedCrossSellList.push.apply(simplifiedCrossSellList, filteredCrossSell[crossSellKeyByProductType[p.Type]]); });
            }
            return simplifiedCrossSellList;
        }
        return service;
    }
})();
var Core;
(function (Core) {
    var PostBookingLookup = /** @class */ (function () {
        function PostBookingLookup($location, authService) {
            this.$location = $location;
            this.authService = authService;
        }
        PostBookingLookup.prototype.redirect = function () {
            if (TRPCONFIG.Domain.DashboardBookingEnabled) {
                var bookingId = this.authService.getSignedInBookingId();
                if (bookingId) {
                    this.$location.path('dashboard/bookings/reference/' + bookingId);
                }
                return;
            }
            document.location.href = '/manage-your-booking/options.aspx';
        };
        return PostBookingLookup;
    }());
    Core.PostBookingLookup = PostBookingLookup;
    angular
        .module('core')
        .service('postBookingLookup', PostBookingLookup);
})(Core || (Core = {}));
var Dashboard;
(function (Dashboard) {
    var BookingActionLink = /** @class */ (function () {
        function BookingActionLink() {
            this.desktopUrl = 'desktop-url/{{BookingRef}}/{{BookingId}}/{{LeadPassengerLastName}}';
            this.actionLinks = {
                'VIEWBOOKINGDETAILS': 'dashboard/booking-details/{{::BookingId}}',
                'CHANGECONTACTDETAILS': 'dashboard/contact-detail/{{::BookingId}}',
                'CANCELBOOKINGS': TRPCONFIG.Domain.CreateCSRToCancelBooking ?
                    'dashboard/create-csr/{{BookingId}}?id=3' : this.desktopUrl + '/cancel',
                'CSR': TRPCONFIG.Domain.DisableFAQs ?
                    'dashboard/create-csr/{{BookingId}}' : 'dashboard/csr/{{BookingId}}',
                'MANAGEPASSENGERDETAILS': this.desktopUrl + '/api',
                'PRINTVOUCHER': 'document/receipt/{{::BookingId}}',
                'PRINTRECEIPT': 'document/receipt/{{::BookingId}}',
                'PAYBALANCE': TRPCONFIG.Domain.PaybalanceV2Enabled ?
                    'dashboard/pay-balance/{{::BookingId}}' : this.desktopUrl + '/payment',
                'ONLINECHECKIN': 'dashboard/online-checkin/{{BookingId}}',
                'VOUCHERACTIONS': 'dashboard/resend-voucher/{{BookingId}}',
                'AMENDBOOKING': TRPCONFIG.Domain.CreateCSRToAmendBooking ?
                    'dashboard/create-csr/{{BookingId}}?id=159' :
                    TRPCONFIG.Domain.EnableAmendBookingV2 ?
                        'dashboard/amend-booking/{{BookingRef}}/{{BookingId}}/{{LeadPassengerLastName}}/start' :
                        this.desktopUrl + '/amend',
                'ENTERAPI': TRPCONFIG.Domain.DashboardAddAPIEnabled ?
                    'dashboard/add-api/{{::BookingId}}' : this.desktopUrl + '/api',
                'ENTERREVIEW': 'review-hotel/{{BookingId}}',
                'ADDBAGGAGE': 'dashboard/add-baggage/{{::BookingId }}',
                'ADDSEATS': 'dashboard/seat-selection/{{::BookingId }}',
                'DERWENTLINK': TRPCONFIG.Domain.DerwentUrl + 'Booking/boBookingDetails.aspx?BookingId={{BookingId}}',
                'PRINTINVOICE': 'document/invoice/{{::BookingId}}'
            };
        }
        BookingActionLink.prototype.get = function () {
            return angular.copy(this.actionLinks);
        };
        return BookingActionLink;
    }());
    Dashboard.BookingActionLink = BookingActionLink;
    angular
        .module('dashboard')
        .service('bookingActionLink', BookingActionLink);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    angular
        .module('dashboard')
        .constant('dashboardEnabledConfig', 'DashboardBookingEnabled')
        .constant('dashboardDisabledReferenceUrl', '/manage-your-booking/options.aspx')
        .constant('dashboardDisabledUrl', '/account/bookings.aspx');
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var NotificationLink = /** @class */ (function () {
        function NotificationLink() {
            this.desktopUrl = 'desktop-url/{{SiteId}}/{{BookingId}}/{{LastName}}';
            this.notificationLinks = {
                1: '/dashboard/csr/{{::BookingId}}',
                2: '/dashboard/csr/{{::BookingId}}',
                3: '/dashboard/pay-balance/{{::BookingId}}',
                4: this.desktopUrl + '/api',
                6: 'review-hotel/{{::BookingId}}'
                //0,5,6,7,8,9 type of notifications are there.. need link for them
            };
        }
        NotificationLink.prototype.get = function () {
            return angular.copy(this.notificationLinks);
        };
        return NotificationLink;
    }());
    Dashboard.NotificationLink = NotificationLink;
    angular
        .module('dashboard')
        .service('notificationLink', NotificationLink);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var V1Redirection = /** @class */ (function () {
        function V1Redirection($http, $window, $location, dashboardBookingService) {
            this.$http = $http;
            this.$window = $window;
            this.$location = $location;
            this.dashboardBookingService = dashboardBookingService;
        }
        V1Redirection.prototype.v1Redirect = function (routeParams) {
            var url;
            switch (routeParams.NAV) {
                case 'contactdetails':
                    url = 'change-your-contact-details.aspx';
                    break;
                case 'cancel':
                    url = 'cancel-your-booking.aspx';
                    break;
                case 'api':
                    url = 'submit-your-passenger-information.aspx';
                    break;
                case 'printvoucher':
                    url = 'view-booking-receipt.aspx';
                    break;
                case 'payment':
                    url = 'make-a-payment.aspx';
                    break;
                case 'newrequest':
                    url = 'raise-a-customer-service-request.aspx';
                    break;
                case 'viewrequest':
                    url = 'customer-service-request-details.aspx?Id=' + routeParams.CSRID;
                    break;
                case 'amend':
                    // tslint:disable-next-line
                    url = 'amend-your-booking.aspx?';
                    if (routeParams.trackingTag) {
                        url += "trackingTag=" + routeParams.trackingTag + "&";
                    }
                    if (routeParams.categoryId) {
                        url += "categoryId=" + routeParams.categoryId + "&";
                    }
                    break;
                case 'review':
                    url = '/Client/clClientFeedBack.aspx?bid={0}&emailLink=0';
                    break;
                case 'options':
                    url = 'options.aspx';
                    break;
            }
            this._loadBooking(routeParams, url);
        };
        V1Redirection.prototype._loadBooking = function (routeParams, url) {
            var _this = this;
            var mybPath = '/manage-your-booking/';
            var data = {
                bookingId: routeParams.BID,
                siteId: routeParams.SID,
                surname: routeParams.SN,
                type: (routeParams.NAV === 'review') ? 2 : 1
            };
            var loadV1 = function () {
                return _this.$http.get('/Include/Handlers/UserAccount.ashx?' + $.param(data)).then(function (result) {
                    if (result.data.success === true) {
                        if (data.type === 2) {
                            url = String.format(url, result.data.secureId);
                            _this.$window.location = url;
                            location.replace(url);
                        }
                        else {
                            _this.$window.location = mybPath + url;
                            location.replace(mybPath + url);
                        }
                    }
                });
            };
            if (TRPCONFIG.Domain.AccountsEnabled && _.includes(['amend', 'cancel'], routeParams.NAV)) {
                return this.dashboardBookingService.getBookingDetail(routeParams.BID).then(function (details) {
                    return details && details.PackageId
                        ? _this.$location.path("dashboard/csr/" + data.bookingId).search({
                            id: routeParams.NAV === 'amend' ? '129' : '3'
                        })
                        : loadV1();
                });
            }
            return loadV1();
        };
        return V1Redirection;
    }());
    Dashboard.V1Redirection = V1Redirection;
    angular
        .module('dashboard')
        .service('v1Redirection', V1Redirection);
})(Dashboard || (Dashboard = {}));
var TR;
(function (TR) {
    'use strict';
    var HolidayDealsPromo = /** @class */ (function () {
        function HolidayDealsPromo($location, $scope, $rootScope, filtering, analytics, broker, holidayDeals, holidayDealsPromoService, resourceService) {
            var _this = this;
            this.$location = $location;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.filtering = filtering;
            this.analytics = analytics;
            this.broker = broker;
            this.holidayDeals = holidayDeals;
            this.holidayDealsPromoService = holidayDealsPromoService;
            this.resourceService = resourceService;
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-holidayDealsResults'
            });
            this.$rootScope.hideFooterToolbar = true;
            this.analytics.track('mixpanel', 'HolidayDealsInsLanding');
            this.holidayDealsPromoService.getInfoPromo().then(function (info) {
                _this.summary = info.summary;
                _this.blocks = info.blocks;
                _this.$scope.$emit('unblock');
            });
            this.flags = {
                searchUnit: true,
                clicks: 0
            };
            this.broker.subscribe('holidayDealsPromoController', 'PROMO_OVERLAY', function (_a) {
                var data = _a.data;
                _this.flags.clicks = _this.flags.clicks + 1;
                _this.flags.holidayType = data.group === 'type' ? data.type : _this.flags.holidayType;
                _this.flags.budget = data.group === 'budget' ? data.type : _this.flags.budget;
            });
            this.broker.subscribe('holidayDealsPromoController', 'REFRESHSEARCH', function () {
                _this.holidayDealsPromoService.getInfoPromo().then(function (info) {
                    _this.summary = info.summary;
                    _this.blocks = info.blocks;
                });
            });
            $scope.$on('$destroy', function () {
                _this.broker.unsubscribe('holidayDealsPromoController', 'PROMO_OVERLAY');
                _this.broker.unsubscribe('holidayDealsPromoController', 'REFRESHSEARCH');
            });
        }
        HolidayDealsPromo.prototype.toggleSearchUnit = function () {
            this.flags.searchUnit = !this.flags.searchUnit;
        };
        HolidayDealsPromo.prototype.goToDeals = function () {
            this.broker.unsubscribe('holidayDealsPromoController', 'PROMO_OVERLAY');
            this.broker.unsubscribe('holidayDealsPromoController', 'REFRESHSEARCH');
            this.$scope.$emit('block', {
                title: this.resourceService.get('SEARCHINGDEALS'),
                subtitle: this.resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-holidayDealsResults'
            });
            var params = this.$location.search();
            this.analytics.track('mixpanel', 'HolidayInspSelected', {
                Budget: this.flags.budget,
                Type: this.flags.holidayType,
                Clicks: this.flags.clicks
            });
            this.$location.search('flex', 15);
            this.$location.path('/holidaydeals');
        };
        return HolidayDealsPromo;
    }());
    angular
        .module('TR')
        .controller('HolidayDealsPromo', HolidayDealsPromo);
})(TR || (TR = {}));
var TR;
(function (TR) {
    function Loading($scope, $timeout, resourceService) {
        $timeout(function () {
            $scope.$emit('block', {
                title: resourceService.get('LOADINGRECOMMENDEDESTAB'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'hotels-hotelSearchCtrl-isHolidayFalse'
            });
        });
    }
    angular
        .module('TR')
        .controller('Loading', Loading);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('acceptanceText', function (insuranceService) {
        var domain = TRPCONFIG.Domain;
        return {
            restrict: 'A',
            link: function (scope, el) {
                scope.$watch('cm.booking.AcceptanceText', function () {
                    if (scope.cm.booking == null) {
                        return;
                    }
                    //various bad things happening here, all because the acceptance text is coming from the server in one block
                    if (scope.cm.insurance) {
                        var docPaths = insuranceService.getDocumentPaths();
                        var policyWordingLink = scope.cm.insurance.Details.InsuranceQuotes[0].SchemeType === 'Silver' ? docPaths.SilverPolicyWording : docPaths.PolicyWording;
                        $('a.showInsuranceTerms', el).attr('href', policyWordingLink).attr('target', '_blank');
                        $('a.showStatusDisclosure', el).attr('href', docPaths.Disclosure).attr('target', '_blank');
                        $('a.insuranceProductInformation', el).attr('href', docPaths.InsuranceProductInformation).attr('target', '_blank');
                    }
                    else {
                        $('a.showInsuranceTerms', el).parent().hide();
                    }
                    function attachLightbox(e, url, content) {
                        e.preventDefault();
                        scope.cm.selectedImportantInfo = url;
                        scope.cm.showImportantInfo = true;
                        scope.cm.importantInfoContent = content || '';
                        scope.$apply();
                    }
                    $('a.agencyTerms', el).bind('click', function (e) {
                        attachLightbox(e, 'partials/popups/agencyterms');
                    });
                    var route = [domain.CultureCode, scope.cm.booking.BookingProcessId, scope.cm.booking.TermsData.Suppliers.join('|'), (scope.cm.booking.TermsData.TransferRateId || '')].join('/');
                    // Supplier Terms
                    var sup = '';
                    angular.forEach(scope.cm.booking.TermsData.Suppliers, function (s) {
                        sup += "&suppliers=" + s;
                    });
                    var termsUrl = String.format('partials/terms/provider?cultureCode={0}&bookingProcessId={1}{2}&transferRateId={3}', domain.CultureCode, scope.cm.booking.BookingProcessId, sup, scope.cm.booking.TermsData.TransferRateId || '');
                    $('a.bookingTerms', el).attr('href', route).attr('target', '_blank');
                    $('a.bookingTerms', el).bind('click', function (e) {
                        attachLightbox(e, termsUrl);
                    });
                    if (scope.cm.flight) {
                        $('a.showFareRules', el).bind('click', function (e) {
                            var fareRulesText = _.get(scope.cm.flight, 'Details.SupplierFareRules', '');
                            attachLightbox(e, 'partials/popups/farerules', fareRulesText);
                        });
                    }
                });
            }
        };
    });
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('accordionDirective', function () {
        return {
            scope: true,
            link: function ($scope) {
                $scope.accordion = { show: false };
            }
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('agentAutofill', AgentAutofill);
    function AgentAutofill(agentModeService, resourceService) {
        return {
            restrict: 'E',
            require: '?ngModel',
            scope: {
                booking: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return "partials/booking/template?name=Agent/AgentAutofillDirective&version=" + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=AgentAutofillDirective';
            },
            link: linker
        };
        function linker(scope) {
            scope.lookup = lookup;
            function lookup(bookingId) {
                scope.errorMessage = undefined;
                agentModeService.getBookingContact(bookingId)
                    .then(fillInformations, handleErrors);
            }
            function fillInformations(bookingInfo) {
                if (TRPCONFIG.Domain.AutofillBasicContactInfo) {
                    //agent mode for dnata agents needs only the following keys to be auto populated
                    var basicInfoKeys = ['Title', 'FirstName', 'LastName', 'CountryCode'];
                    fillBasicInformations(bookingInfo, basicInfoKeys);
                    return;
                }
                fillBasicInformations(bookingInfo, Object.keys(scope.booking));
            }
            function fillBasicInformations(bookingInfo, keys) {
                keys.forEach(function (key) {
                    if (bookingInfo[key]) {
                        scope.booking[key] = bookingInfo[key];
                    }
                });
            }
            function handleErrors(res) {
                switch (res.status) {
                    case 400:
                        scope.errorMessage = resourceService.get('AGENTBOOKINGIDINVALID');
                        break;
                    case 404:
                        scope.errorMessage = resourceService.get('AGENTBOOKINGIDNOTFOUND');
                        break;
                    default:
                        scope.errorMessage = resourceService.get('AGENTBOOKINGIDERROR');
                        break;
                }
            }
        }
    }
})();
var TR;
(function (TR) {
    var BoardTypeFilter = /** @class */ (function () {
        function BoardTypeFilter($scope, resourceService, occupancyService) {
            var _this = this;
            var titles = {
                1: resourceService.get('ROOMONLY'),
                2: resourceService.get('BEDANDBREAKFAST'),
                3: resourceService.get('HALFBOARD'),
                4: resourceService.get('FULLBOARD'),
                5: resourceService.get('ALLINCLUSIVE'),
                6: resourceService.get('SELFCATERING')
            };
            $scope.$watch('bt.aggregate', function (agg) {
                if (!agg) {
                    return;
                }
                var boardArr = [];
                for (var key in agg) {
                    boardArr.push(_.extend(agg[key], { id: key, title: titles[key] }));
                }
                _.set(_.minBy(boardArr, function (v) { return v.MinPrice; }), 'cheapest', true);
                _this.boardArr = boardArr;
                _this.people = occupancyService.getNumberOfNonInfantPassengers();
            });
        }
        BoardTypeFilter.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        BoardTypeFilter.prototype.reset = function () {
            this.model = [];
        };
        BoardTypeFilter.prototype.more = function (all) {
            this.showAll = all;
        };
        BoardTypeFilter.prototype.showMoreLess = function () {
            return Object.keys(this.aggregate || {}).length > this.limit;
        };
        return BoardTypeFilter;
    }());
    angular
        .module('TR')
        .directive('boardTypeFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=BoardTypeFilter',
            bindToController: {
                aggregate: '=',
                model: '=',
                limit: '@',
                priceMode: '='
            },
            controller: BoardTypeFilter,
            controllerAs: 'bt'
        };
    });
    var BoardTypeFilterLabel = /** @class */ (function () {
        function BoardTypeFilterLabel($scope, resourceService, analytics) {
            var _this = this;
            this.titles = {
                1: resourceService.get('ROOMONLY'),
                2: resourceService.get('BEDANDBREAKFAST'),
                3: resourceService.get('HALFBOARD'),
                4: resourceService.get('FULLBOARD'),
                5: resourceService.get('ALLINCLUSIVE'),
                6: resourceService.get('SELFCATERING')
            };
            $scope.$watch('bt.model', function (value) {
                if (!value || !value.length) {
                    return;
                }
                var boardType = value.map(function (v) { return _this.getName(v); });
                analytics.track('mixpanel', 'HolidayDealsFilterBoardTypes', { value: boardType });
            });
        }
        BoardTypeFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"bt.isSet()\">\n                    <a\n                        href=\"#\"\n                        ng-repeat=\"board in bt.model\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"bt.remove(board)\">\n                        <span> {{bt.getName(board)}} </span>\n                    </a>\n                </span>\n            ";
        };
        BoardTypeFilterLabel.prototype.getName = function (board) {
            return this.titles[board];
        };
        BoardTypeFilterLabel.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        BoardTypeFilterLabel.prototype.remove = function (board) {
            this.model = this.model.filter(function (v) { return v !== board; });
        };
        return BoardTypeFilterLabel;
    }());
    angular
        .module('TR')
        .directive('boardTypeFilterLabel', function () {
        return {
            scope: {},
            template: BoardTypeFilterLabel.getTemplate(),
            bindToController: {
                model: '='
            },
            controller: BoardTypeFilterLabel,
            controllerAs: 'bt'
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('boardTypeFilters', function (broker, hotelSearch) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=BoardTypeFilters',
            scope: {
                hotel: '=',
                buttonClass: '='
            },
            link: function (scope) {
                var cancel = scope.$watch('hotel.Rooms', function (h) {
                    if (!h || _.isEmpty(h)) {
                        return;
                    }
                    cancel();
                    scope.showMenu = false;
                    if (scope.hotel == null || scope.hotel.Rooms == null) {
                        return;
                    }
                    scope.$watchCollection('filter.BoardTypes', function (v, o) {
                        if (v == null || v === o) {
                            return;
                        }
                        broker.publish('boardTypeFilterUpdated', v);
                    });
                    var boardTypes = {};
                    scope.hotel.Rooms.forEach(function (r) {
                        r.Availability.forEach(function (a) {
                            if (!boardTypes[a.BoardType] || boardTypes[a.BoardType].Text.length > a.BoardDescription.length) {
                                boardTypes[a.BoardType] = {
                                    Text: a.BoardDescription,
                                    Value: a.BoardType,
                                    Count: 0
                                };
                            }
                            boardTypes[a.BoardType].Count += 1;
                        });
                        scope.showMenu = Object.keys(boardTypes).length > 1;
                        // convert object to array for the dropdown multi select control
                        scope.boardTypeOptions = [];
                        _.forEach(boardTypes, function (b) {
                            scope.boardTypeOptions.push(b);
                        });
                    });
                    var filterBoardTypes = angular.copy(hotelSearch.getFilter().BoardTypes);
                    filterBoardTypes = _.filter(filterBoardTypes, function (fbt) {
                        return _.some(scope.boardTypeOptions, function (option) { return option.Value === fbt; });
                    });
                    scope.filter = {
                        BoardTypes: filterBoardTypes
                    };
                });
            }
        };
    });
})();
var TR;
(function (TR) {
    var ChildDestinationFilter = /** @class */ (function () {
        function ChildDestinationFilter($scope, occupancyService) {
            var _this = this;
            $scope.$watch('cd.aggregate', function (agg) {
                if (!agg) {
                    return;
                }
                var destArray = [];
                for (var key in agg) {
                    destArray.push(_.extend(agg[key], { id: key }));
                }
                var min = _.minBy(destArray, function (v) { return v.MinPrice; });
                if (min) {
                    min.cheapest = true;
                }
                _this.model = _.filter(_this.model, function (d) { return _.has(agg, d); });
                _this.destArray = destArray;
                _this.people = occupancyService.getNumberOfNonInfantPassengers();
            });
        }
        ChildDestinationFilter.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        ChildDestinationFilter.prototype.reset = function () {
            this.model = [];
        };
        ChildDestinationFilter.prototype.more = function (all) {
            this.showAll = all;
        };
        ChildDestinationFilter.prototype.showMoreLess = function () {
            return Object.keys(this.aggregate || {}).length > this.limit;
        };
        return ChildDestinationFilter;
    }());
    angular
        .module('TR')
        .directive('childDestinationFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=ChildDestinationFilter',
            bindToController: {
                aggregate: '=',
                model: '=',
                limit: '@',
                priceMode: '='
            },
            controller: ChildDestinationFilter,
            controllerAs: 'cd'
        };
    });
    var ChildDestinationFilterLabel = /** @class */ (function () {
        function ChildDestinationFilterLabel($scope, analytics) {
            var _this = this;
            $scope.$watch('cd.model', function (value) {
                if (!value || !value.length) {
                    return;
                }
                var destinations = value.map(function (v) { return _this.getName(v); });
                analytics.track('mixpanel', 'HolidayDealsFilterDestinations', { value: destinations });
            });
        }
        ChildDestinationFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"cd.isSet()\">\n                    <a\n                        href=\"#\"\n                        ng-repeat=\"dest in cd.model\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"cd.remove(dest)\">\n                        <span> {{cd.getName(dest)}} </span>\n                    </a>\n                </span>\n            ";
        };
        ChildDestinationFilterLabel.prototype.getName = function (dest) {
            if (!this.aggregate) {
                return '';
            }
            return (this.aggregate[dest] || {}).Title;
        };
        ChildDestinationFilterLabel.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        ChildDestinationFilterLabel.prototype.remove = function (dest) {
            this.model = this.model.filter(function (v) { return v !== dest; });
        };
        return ChildDestinationFilterLabel;
    }());
    angular
        .module('TR')
        .directive('childDestinationFilterLabel', function () {
        return {
            scope: {},
            template: ChildDestinationFilterLabel.getTemplate(),
            bindToController: {
                aggregate: '=',
                model: '='
            },
            controller: ChildDestinationFilterLabel,
            controllerAs: 'cd'
        };
    });
})(TR || (TR = {}));
angular
    .module('TR')
    .directive('chooseDifferentHotel', function ($location) {
    return {
        scope: {
            changeHotel: '&?',
            dest: '=?'
        },
        templateUrl: 'partials/home/directivetemplate?type=ChooseDifferentHotel',
        link: function (scope) {
            scope.handleChangeHotel = function () {
                if (scope.changeHotel) {
                    scope.changeHotel();
                }
                else {
                    var breadcrumbTrail = _.get(scope, ['dest', 'BreadcrumbTrail'], []);
                    $location.url(_.get(_.nth(breadcrumbTrail, -2), 'PagePath', '/'));
                }
            };
        },
        restrict: 'E',
        replace: true,
    };
});
var TR;
(function (TR) {
    var ClickTripz = /** @class */ (function () {
        function ClickTripz($routeParams, tripService, loaderService) {
            this.$routeParams = $routeParams;
            this.tripService = tripService;
            this.loaderService = loaderService;
            if ($routeParams.tripId
                && _.includes(TRPCONFIG.Domain.ClickTripzProviders, $routeParams.source)
                && !window.document.getElementById('click-tripz')) {
                tripService.getTripNumberOfNights(0, $routeParams.tripId).then(function (numberOfNights) {
                    if (_.includes(TRPCONFIG.Domain.ClickTripzNumberOfNights, numberOfNights)) {
                        loaderService.loadJS(window.document, 'script', 'click-tripz', TRPCONFIG.Domain.ClickTripzURL);
                    }
                });
            }
        }
        return ClickTripz;
    }());
    angular
        .module('TR')
        .directive('clickTripz', function () {
        return {
            controller: ClickTripz,
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var CruiseListing = /** @class */ (function () {
        function CruiseListing(analytics) {
            this.analytics = analytics;
        }
        CruiseListing.prototype.gotToCruise = function (url) {
            this._trackClick();
            window.open(url);
        };
        CruiseListing.prototype._trackClick = function () {
            this.analytics.track('mixpanel', 'HolidayDealsCruiseDetails', {
                Title: this.cruise.Title,
                ShipName: this.cruise.ShipName,
                LineName: this.cruise.CruiseLineName
            });
        };
        return CruiseListing;
    }());
    angular
        .module('TR')
        .directive('cruiseListing', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=CruiseListing',
            replace: true,
            bindToController: {
                cruise: '=',
                priceMode: '=',
            },
            controller: CruiseListing,
            controllerAs: 'cl'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var DirectPaymentInformation = /** @class */ (function () {
        function DirectPaymentInformation($filter, resourceService, $scope) {
            this.$filter = $filter;
            this.resourceService = resourceService;
            this.$scope = $scope;
            this.keyMap = {};
            //decide which resource keys we want to push in to our object based on the footnote scope value
            var m = {
                conversion: '',
                noConversion: ''
            };
            if (this.hasFootnote === 'true') {
                m.conversion = 'DIRECTPAYMENTTOHOTELCONVERTED';
                m.noConversion = 'DIRECTPAYMENTTOHOTEL';
            }
            else {
                m.conversion = 'DIRECTPAYMENTTOHOTELCONVERTEDNONOTE';
                m.noConversion = 'DIRECTPAYMENTTOHOTELNONOTE';
            }
            this.keyMap[0] = m; //add the keys for hotels to the map
        }
        DirectPaymentInformation.prototype.directPaymentCaveat = function (product, payment) {
            var res = product.productType === 0 ? 'DIRECTACCOMPAYMENTADVICE' : 'DIRECTFLIGHTPAYMENTADVICE';
            if (payment.localCurrency === payment.currency) {
                return String.format(this.resourceService.get(res), this.$filter('customCurrency')(payment.amount, payment.currency));
            }
            return String.format(this.resourceService.get(res), this.$filter('customCurrency')(payment.localAmount, payment.localCurrency) + " \n            " + String.format(this.resourceService.get('CUSTOMEREQUIVALENT'), this.$filter('customCurrency')(payment.amount, payment.currency)));
        };
        DirectPaymentInformation.prototype.getText = function (productType, payment) {
            var paymentAmount = this.$filter('customCurrency')(payment.amount, payment.currency);
            var resource = this.keyMap[productType];
            if (productType === 0) {
                if (payment.localCurrency === payment.currency) {
                    return String.format(this.resourceService.get(resource.noConversion), paymentAmount);
                }
                else {
                    return String.format(this.resourceService.get(resource.conversion), this.$filter('customCurrency')(payment.localAmount, payment.localCurrency), paymentAmount);
                }
            }
            return '';
        };
        return DirectPaymentInformation;
    }());
    angular
        .module('TR')
        .directive('directPaymentInformation', function () {
        return {
            scope: {
                hasFootnote: '@',
                paymentData: '=',
                showDirectPayments: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=DirectPaymentInformation&version=' + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=DirectPaymentInformation';
            },
            bindToController: true,
            controller: DirectPaymentInformation,
            controllerAs: 'dpi',
            replace: true
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('dropdownMultiSelect', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                caption: '@',
                model: '=',
                options: '=',
                valueName: '@',
                labelName: '@',
                classes: '@',
                ulClasses: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=dropdownmultiselect',
            transclude: true,
            link: function (scope, el) {
                scope.open = false;
                scope.focusIndex = -1;
                scope.selectedIndexes = [];
                scope.toggle = function (e) {
                    e.preventDefault();
                    if (scope.open) {
                        close();
                    }
                    else {
                        open();
                    }
                };
                function open() {
                    scope.open = true;
                }
                function close() {
                    scope.open = false;
                    scope.focusIndex = -1;
                }
                $(document).on('click.dropdownmultiselect', function (e) {
                    // close panel if the click target is not a child of the element
                    var isChild = el.find(e.target).length > 0;
                    if (!isChild) {
                        scope.$apply(function () {
                            close();
                        });
                    }
                });
                // set up watches for the model and the options
                scope.$watch('model', function (v) {
                    if (v == null) {
                        return;
                    }
                    scope.updateOnWatch();
                }, true);
                scope.$watch('options', function (v) {
                    if (v == null) {
                        return;
                    }
                    scope.updateOnWatch();
                }, true);
                scope.updateOnWatch = function () {
                    // either the model or options have changed
                    // iterate options
                    _.forEach(scope.options, function (o, index) {
                        // is this option in the model array?
                        var match = _.find(scope.model, function (m) {
                            return o[scope.valueName] === m;
                        });
                        var selectedIndex = scope.selectedIndexes.indexOf(index);
                        if (_.isUndefined(match)) {
                            // remove this index
                            if (selectedIndex > -1) {
                                scope.selectedIndexes.splice(selectedIndex, 1);
                            }
                        }
                        else if (selectedIndex === -1) {
                            // add this index
                            scope.selectedIndexes.push(index);
                        }
                    });
                };
                scope.optionClick = function (index) {
                    applyOption(index);
                    //scope.open = false;
                    el.find('a').focus();
                };
                function applyOption(index) {
                    // get option at this index
                    var value = scope.options[index][scope.valueName];
                    // change the model
                    if (scope.selectedIndexes.indexOf(index) > -1) {
                        // remove this value from the model array
                        scope.model = _.reject(scope.model, function (m) {
                            return m === value;
                        });
                    }
                    else {
                        // add this value to the model array
                        scope.model.push(value);
                    }
                    // set "focus" to this option
                    scope.focusIndex = index;
                }
                var behaviours = {
                    // Tab
                    9: function () {
                        close();
                    },
                    // Escape
                    27: function () {
                        close();
                    },
                    // Up Arrow
                    38: function (e) {
                        e.preventDefault();
                        open();
                        if ((scope.focusIndex - 1) > -1) {
                            scope.focusIndex -= 1;
                        }
                    },
                    // Down Arrow
                    40: function (e) {
                        e.preventDefault();
                        open();
                        if ((scope.focusIndex + 1) <= scope.options.length - 1) {
                            scope.focusIndex += 1;
                        }
                    },
                    // Return
                    13: function (e) {
                        if (scope.focusIndex > -1) {
                            e.preventDefault();
                            applyOption(scope.focusIndex);
                        }
                        else {
                            scope.toggle(e);
                        }
                    }
                };
                scope.onKeydown = function (e) {
                    var fn = behaviours[e.keyCode] || angular.noop;
                    fn(e);
                };
                scope.$on('$destroy', function () {
                    $(document).off('click.dropdownmultiselect');
                });
            }
        };
    });
})();
var TR;
(function (TR) {
    var FacilitiesFilter = /** @class */ (function () {
        function FacilitiesFilter($scope, occupancyService) {
            var _this = this;
            this.limits = {};
            this.showPrice = {};
            $scope.$watch('ff.aggregate', function (agg) {
                if (!agg) {
                    return;
                }
                _this.people = occupancyService.getNumberOfNonInfantPassengers();
                var groupArray = [];
                for (var group in agg) {
                    var elementArray = [];
                    if (group === 'Facilities') {
                        _this.limits[group] = parseInt(_this.facLimit, 10);
                        _this.showPrice[group] = false;
                    }
                    else {
                        _this.limits[group] = parseInt(_this.htLimit, 10);
                        _this.showPrice[group] = true;
                    }
                    for (var key in agg[group]) {
                        elementArray.push(_.extend(agg[group][key], { id: key }));
                    }
                    _.minBy(elementArray, function (v) { return v.MinPrice; }).cheapest = true;
                    groupArray.push({ title: group, elements: _.clone(elementArray) });
                }
                _this.groupArray = groupArray;
            });
            this.showAll = {};
        }
        FacilitiesFilter.prototype.isSet = function (group) {
            if (!this.aggregate[group] || !this.model) {
                return;
            }
            var keys = Object.keys(this.aggregate[group]);
            return _.intersection(this.model, keys).length > 0;
        };
        FacilitiesFilter.prototype.reset = function (group) {
            var keys = Object.keys(this.aggregate[group]);
            this.model = _.difference(this.model, keys);
        };
        FacilitiesFilter.prototype.more = function (group, all) {
            this.showAll[group] = all;
        };
        FacilitiesFilter.prototype.showMoreLess = function (group) {
            return Object.keys(this.aggregate[group] || {}).length > this.limits[group];
        };
        return FacilitiesFilter;
    }());
    angular
        .module('TR')
        .directive('facilitiesFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=FacilitiesFilter',
            bindToController: {
                aggregate: '=',
                model: '=',
                facLimit: '@',
                htLimit: '@',
                priceMode: '='
            },
            controller: FacilitiesFilter,
            controllerAs: 'ff'
        };
    });
    var FacilitiesFilterLabel = /** @class */ (function () {
        function FacilitiesFilterLabel($scope, analytics) {
            var _this = this;
            $scope.$watch('ff.model', function (value) {
                if (!value || !value.length) {
                    return;
                }
                var grouped = _this._getNameGrouped(value);
                for (var group in grouped) {
                    analytics.track('mixpanel', "HolidayDealsFilter" + group.replace(' ', ''), { value: grouped[group] });
                }
            });
        }
        FacilitiesFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"ff.isSet()\">\n                    <a\n                        href=\"#\"\n                        ng-repeat=\"item in ff.model\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"ff.remove(item)\">\n                        <span> {{ff.getName(item)}} </span>\n                    </a>\n                </span>\n            ";
        };
        FacilitiesFilterLabel.prototype.getName = function (item) {
            if (!this.aggregate) {
                return '';
            }
            for (var group in this.aggregate) {
                var filter = this.aggregate[group][item];
                if (filter) {
                    return filter.Title;
                }
            }
        };
        FacilitiesFilterLabel.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        FacilitiesFilterLabel.prototype.remove = function (dest) {
            this.model = this.model.filter(function (v) { return v !== dest; });
        };
        FacilitiesFilterLabel.prototype._getNameGrouped = function (filter) {
            if (!this.aggregate) {
                return '';
            }
            var grouped = {};
            for (var i = 0, ii = filter.length; i < ii; i++) {
                var filterValue = filter[i];
                for (var group in this.aggregate) {
                    var item = this.aggregate[group][filterValue];
                    if (item) {
                        if (!grouped[group]) {
                            grouped[group] = [];
                        }
                        grouped[group].push(item.Title);
                    }
                }
            }
            return grouped;
        };
        return FacilitiesFilterLabel;
    }());
    angular
        .module('TR')
        .directive('facilitiesFilterLabel', function () {
        return {
            scope: {},
            template: FacilitiesFilterLabel.getTemplate(),
            bindToController: {
                aggregate: '=',
                model: '='
            },
            controller: FacilitiesFilterLabel,
            controllerAs: 'ff'
        };
    });
})(TR || (TR = {}));
(function () {
    /*
        Imports value from a remote field when it updates, if this form is `$pristine`.
        If the remote field is a select field, only option `label` matches are accepted.
    
        Example HTML:
            <input type="text"
                ng-model="guest.FirstName"
                field-import="form.contactForm.firstName" />
    */
    'use strict';
    angular.module('TR')
        .directive('fieldImport', function () {
        // Deregister all instances
        var allowInit = true;
        var deregisterFns = [];
        var deregisterAll = function () {
            if (deregisterFns) {
                allowInit = false;
                deregisterFns.forEach(function (fn) { return fn(); });
                deregisterFns = null; // Clear memory
            }
        };
        return {
            restrict: 'A',
            require: '^form',
            scope: {
                ngModel: '=',
                fieldImport: '&'
            },
            link: function (scope, el, attr, formCtrl) {
                var remoteField = scope.fieldImport();
                // `remoteField` may be `false` if attribute contains a condition
                if (allowInit && typeof remoteField === 'object') {
                    init();
                }
                // Initialise
                function init() {
                    // If fields were autofilled, form is still `$pristine` so check value
                    if (scope.ngModel) {
                        deregisterAll();
                    }
                    else {
                        // Set listeners
                        deregisterFns.push(scope.$watch(function () { return remoteField.$modelValue; }, updateField));
                        scope.$on('$destroy', deregisterAll);
                    }
                }
                // Populate this field
                function updateField(val) {
                    var submittedForm = false;
                    var lastParent = formCtrl;
                    while (!submittedForm && lastParent) {
                        submittedForm = lastParent.$submitted;
                        lastParent = lastParent.$$parentForm;
                    }
                    // If form was changed by user
                    if (!formCtrl.$pristine || submittedForm) {
                        deregisterAll();
                    }
                    else {
                        // Set any falsy value to `undefined` to clear field
                        if (!val) {
                            val = undefined;
                        }
                        // For a select, only allow label matches (case insensitive)
                        if (val && el.is('select')) {
                            val = enforceMatch(
                            // i.e. ["--", "Mr", "Mrs", "Miss", "Ms", "Dr"]
                            $.map(el.find('option'), function (op) { return op.label; }), val);
                        }
                        // Set field value
                        scope.ngModel = val;
                        formCtrl.$setPristine(); // Only user edits will make '$pristine' false
                    }
                }
                // Restrict value to specified strings
                function enforceMatch(allowedVals, val) {
                    var i = allowedVals.length;
                    while (i--) {
                        var allowedStr = allowedVals[i];
                        if (val.toLowerCase() === allowedStr.toLowerCase()) {
                            return allowedStr;
                        }
                    }
                    // `val` not found, clear field
                    return undefined;
                }
            }
        };
    });
})();
var TR;
(function (TR) {
    var FiltersBox = /** @class */ (function () {
        function FiltersBox($scope, broker, filtering) {
            var _this = this;
            this.$scope = $scope;
            this.broker = broker;
            this.filtering = filtering;
            $scope.$watch('fi.filters', function (f) { return _this.updateFilters(f); }, true);
            this.enabledFilters = [];
        }
        FiltersBox.prototype.updateFilters = function (filters) {
            if (!filters) {
                return;
            }
            var position = $('body').scrollTop();
            var listener = this.$scope.$on('$locationChangeSuccess', function () {
                $('body').scrollTop(position);
                listener();
            });
            this.enabledFilters = Object.keys(filters);
            if (this.filtering.serialiseFilters(filters)) {
                return this.broker.publish('REFRESHSEARCH');
            }
        };
        FiltersBox.prototype.showFilter = function (name) {
            return this.enabledFilters.indexOf(name) > -1;
        };
        FiltersBox.prototype.apply = function () {
            return this.show = false;
        };
        return FiltersBox;
    }());
    angular
        .module('TR')
        .directive('filtersBox', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=FiltersBox',
            bindToController: {
                aggregates: '=',
                filters: '=',
                priceMode: '=',
                show: '='
            },
            controller: FiltersBox,
            controllerAs: 'fi'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var FiltersLabels = /** @class */ (function () {
        function FiltersLabels() {
        }
        return FiltersLabels;
    }());
    angular
        .module('TR')
        .directive('filtersLabels', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=FiltersLabels',
            replace: true,
            bindToController: {
                filters: '=',
                aggregates: '=',
                priceMode: '='
            },
            controller: FiltersLabels,
            controllerAs: 'fl'
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('formSubmit', function ($rootScope, scrollService, $timeout, analytics, $routeParams, tripService, resourceService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                isDisabled: '=',
                inputClass: '@',
                form: '=',
                click: '&',
                model: '=',
                label: '@',
                scroll: '=',
                preFlight: '&',
                templateVersion: '='
            },
            templateUrl: function (element, attr) { return attr.templateVersion ?
                "partials/booking/template?name=FormSubmit&version=" + attr.templateVersion :
                'partials/home/directivetemplate?type=FormSubmit'; },
            link: function (scope, element, attrs) {
                var noClass = (scope.inputClass || '').replace(/ /g, '').length <= 0;
                scope.buttonClass = noClass ? 'button primary' : scope.inputClass;
                function onClick(event) {
                    $rootScope.submittedForm = null;
                    if (!scope.form.$valid) {
                        $rootScope.submittedForm = scope.form;
                        $rootScope.$broadcast('form:submitted-invalid', scope.form);
                        //wrap in timeout to allow time for address search field to reveal itself
                        $timeout(function () {
                            var form = $(element).parents('form');
                            var selectors = '.tokenising-field.ng-invalid:visible,' +
                                '.dob-picker.ng-invalid select:visible,' +
                                'input.ng-invalid:visible,' +
                                'select.ng-invalid:visible,' +
                                'div.ng-invalid .driver-type-select:visible,' +
                                'div.checkbox-btn.ng-invalid:visible,' +
                                'label.checkbox-btn.ng-invalid:visible,' +
                                '.pseudo-input.ng-invalid:visible,' +
                                'textarea.ng-invalid:visible,' +
                                'date-picker.ng-invalid .hasDatepicker:visible,' +
                                'div.ng-invalid input:visible';
                            //check if we have a closer isolated ng-form, if so pick the next element
                            var target = null;
                            var elements = $(selectors, form);
                            if (form.length > 0) {
                                _.each(elements, function (i) {
                                    var ngForm = $(i).closest('ng-form')[0] || null;
                                    if (!ngForm || !$(ngForm).hasClass('isolated-form')) {
                                        target = $(i);
                                        return false;
                                    }
                                });
                            }
                            else {
                                target = $(selectors).first();
                            }
                            if (scope.scroll) {
                                scrollService.scrollTo(target, { animate: true, offset: 100 })
                                    .then(function () { return target.focus(); });
                            }
                            else {
                                target.focus();
                            }
                        });
                        setTimeout(function () { return analytics.track('mixpanel', 'FormValidation', { form: scope.form }); });
                        return;
                    }
                    scope.click({ model: scope.model, event: event });
                }
                scope.$click = function (event) {
                    var res = scope.preFlight && scope.preFlight();
                    if (res) {
                        scope.disabled = true;
                        res.then(function () { return $timeout(function () {
                            scope.disabled = false;
                            onClick(event);
                        }); }).catch(function () { return scope.disabled = false; });
                    }
                    else {
                        onClick(event);
                    }
                };
                if (attrs.templateVersion) {
                    tripService.getTrip($routeParams.tripId)
                        .then(function (trip) {
                        var tripType = _.findKey(tripService.tripTypes, function (o) { return o === trip.TripType; });
                        tripType = (tripType || '').toUpperCase();
                        scope.labelForJourney = TRPCONFIG.Domain.WPIframeUpdate ? resourceService.get('PAYNOWBUTTON') : resourceService.get("FORMSUBMITBUTTON_TRIPTYPE_" + tripType);
                    })
                        .catch(angular.noop)
                        .then(function () {
                        if (!scope.labelForJourney || scope.labelForJourney.indexOf('FORMSUBMITBUTTON') > -1) {
                            scope.labelForJourney = resourceService.get('FORMSUBMITBUTTON_TRIPTYPE_NONE');
                        }
                    });
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('hiddenContent', function () {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                open: '@',
                showMoreText: '@',
                showLessText: '@',
                hideable: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=HiddenContent',
            link: function (scope) {
                scope.more = function (e) {
                    e.preventDefault();
                    scope.showMore = true;
                };
                scope.less = function (e) {
                    e.preventDefault();
                    scope.showMore = false;
                };
                scope.showMore = scope.open === 'true';
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('hideMenuBar', function ($location, $window) {
        return {
            restrict: 'A',
            scope: '=',
            compile: function ($elem) {
                if (window.TRPCONFIG.Domain2.ShowMinimalHeader) {
                    return;
                }
                var elem = $elem[0];
                var isMatchedPath = function () {
                    var regEx = /.*\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}[0-9a-fA-F]{0,1}[/]*?/;
                    var abtesttUrl = ($location.$$path.match(regEx) || $location.$$path.match(/attractions[/].*/));
                    var abtesttUrlMatched = abtesttUrl && abtesttUrl.input;
                    return abtesttUrlMatched;
                };
                if (isMatchedPath()) {
                    elem.classList.add('u-hidden');
                }
                else {
                    elem.classList.remove('u-hidden');
                }
                return function postLink($scope, $el) {
                    var el = $el[0];
                    var hideMenu = function () {
                        var elClassList = el.classList;
                        var menuBarEl = elClassList.contains('sc-c-menubar');
                        var headerEl = el.closest('.sc-c-masthead');
                        var headerNextElementSiblingEl = headerEl && headerEl.nextElementSibling;
                        var mastHeadMainEl = headerEl && headerEl.querySelector('.sc-c-masthead__main');
                        var hasShadowClass = mastHeadMainEl && mastHeadMainEl.classList.contains('sc-c-masthead__main--box-shadow');
                        var hasHiddenMenuClass = headerNextElementSiblingEl && headerNextElementSiblingEl.classList.contains('sc-c-main--hidden');
                        var hasHiddenClass = elClassList.contains('u-hidden');
                        var mastHeadMainElClassList = mastHeadMainEl.classList;
                        var headerNextElementSiblingElClassList = headerNextElementSiblingEl.classList;
                        var mastHeadCss = 'sc-c-masthead__main--box-shadow';
                        var menuBarCss = 'sc-c-main--hidden';
                        if (isMatchedPath()) {
                            if (!hasShadowClass) {
                                mastHeadMainElClassList.add(mastHeadCss);
                            }
                            if (!hasHiddenMenuClass) {
                                headerNextElementSiblingElClassList.add(menuBarCss);
                            }
                            if (menuBarEl && !hasHiddenClass) {
                                elClassList.add('u-hidden');
                            }
                        }
                        else {
                            if (hasShadowClass) {
                                mastHeadMainElClassList.remove(mastHeadCss);
                            }
                            if (hasHiddenMenuClass) {
                                headerNextElementSiblingElClassList.remove(menuBarCss);
                            }
                            if (menuBarEl && hasHiddenClass) {
                                elClassList.remove('u-hidden');
                            }
                        }
                    };
                    var initHideMenu = function () {
                        if (window.TRPCONFIG.Domain2.HideMinimalHeader) {
                            hideMenu();
                        }
                    };
                    $scope.$on('$routeChangeStart', function () {
                        initHideMenu();
                    });
                    $scope.$on('$routeChangeSuccess', function () {
                        initHideMenu();
                    });
                    $window.onload = function () {
                        initHideMenu();
                    };
                    /*eslint-disable */
                    window._vwo_evq = window._vwo_evq || [];
                    window._vwo_evq.push = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        /*eslint-enable */
                        var eventData = args[0];
                        if (eventData[1] === '303') {
                            initHideMenu();
                        }
                    };
                };
            }
        };
    });
})();
var TR;
(function (TR) {
    var HolidayDealPromoListing = /** @class */ (function () {
        function HolidayDealPromoListing($element, $scope, $sce, $location, broker, resourceService) {
            var _this = this;
            this.$location = $location;
            this.broker = broker;
            this.resourceService = resourceService;
            this.$overlay = $element.find('.holiday-deal-promo-listing .click-overlay');
            this.$iconOverlay = $element.find('.holiday-deal-promo-listing .icon-overlay');
            this.getLabel = function (label) {
                var res = resourceService.get(label);
                $sce.trustAsHtml(label);
                return res;
            };
            this.broker.subscribe("PROMO_" + this.type + "_" + this.index, 'PROMO_OVERLAY', function (_a) {
                var data = _a.data;
                if (_this.group !== data.group) {
                    return;
                }
                if (_this.name !== data.name) {
                    _this.$location.search(_this.name, null);
                }
                if (_this.value !== data.value) {
                    _this._toggleOverlay(false);
                }
            });
            $scope.$watch('hpl.value', function (v) {
                if (!v) {
                    return;
                }
                var params = _this.$location.search();
                _this._toggleOverlay(params[_this.name] === v);
            });
            $scope.$on('$destroy', function () {
                _this.broker.unsubscribe('holidayDealsPromoController', "PROMO_" + _this.type + "_" + _this.index);
            });
        }
        HolidayDealPromoListing.prototype.select = function () {
            this.broker.publish('PROMO_OVERLAY', {
                name: this.name,
                group: this.group,
                value: this.value,
                type: this.type || this.getLabel(this.label)
            });
            var params = this.$location.search();
            var isAlreadySelected = params[this.name] === this.value;
            if (isAlreadySelected) {
                return;
            }
            this.$location.search(this.name, this.value);
            this._toggleOverlay(true);
        };
        HolidayDealPromoListing.prototype._toggleOverlay = function (show) {
            if (show) {
                this.$overlay.fadeIn(200);
                this.$iconOverlay.fadeIn(200);
                return;
            }
            this.$overlay.fadeOut(200);
            this.$iconOverlay.fadeOut(200);
        };
        return HolidayDealPromoListing;
    }());
    angular
        .module('TR')
        .directive('holidayDealPromoListing', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=HolidayDealPromoListing',
            bindToController: {
                label: '@',
                img: '@',
                name: '@',
                value: '=',
                group: '@',
                type: '@',
                index: '@'
            },
            controller: HolidayDealPromoListing,
            controllerAs: 'hpl'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var HotelReviewsBrowser = /** @class */ (function () {
        function HotelReviewsBrowser($scope, broker, pagingService, reviewService) {
            var _this = this;
            this.$scope = $scope;
            this.broker = broker;
            this.pagingService = pagingService;
            this.reviewService = reviewService;
            this.broker.subscribe('hotelReviewsBrowser', 'SHOWREVIEWS', this.showReviews.bind(this));
            this.pageReviews = function (page) { return _this.getReviews(_this.selectedHotel, page); };
            $scope.$on('$destroy', function () {
                broker.unsubscribe('hotelReviewsBrowser');
            });
        }
        HotelReviewsBrowser.prototype.showReviews = function (e, page) {
            if (page === void 0) { page = 1; }
            this.selectedHotel = e.data.hotel;
            this.reviewPaging = this.pagingService.data(1, 10, this.selectedHotel.CustomerRatingCount);
            this.getReviews(e.data.hotel, page);
        };
        HotelReviewsBrowser.prototype.getReviews = function (hotel, page) {
            var _this = this;
            if (this.reviewPaging.page === 1) {
                this.loadingFirstReviews = true;
            }
            this.reviewsShowing = true;
            return this.reviewService.getReviews(this.selectedHotel, this.reviewPaging.page - 1)
                .then(function (res) {
                _this.reviews = res.reviews;
                _this.loadingFirstReviews = false;
                _this.reviewPaging = _this.pagingService.data(_this.reviewPaging.page, 10, _this.selectedHotel.CustomerRatingCount);
            });
        };
        return HotelReviewsBrowser;
    }());
    angular
        .module('TR')
        .directive('hotelReviewsBrowser', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=HotelReviewBrowser',
            bindToController: {},
            controller: HotelReviewsBrowser,
            controllerAs: 'cm'
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('hotelStats', HotelStats);
    function HotelStats(arrayUtil, urgencyMessaging, toaster) {
        return {
            restrict: 'E',
            replace: false,
            scope: {
                model: '='
            },
            template: '<div><div>',
            link: function (scope) {
                if (TRPCONFIG.Domain.UrgencyMessaging) {
                    urgencyMessaging.get(scope.model).then(function (stats) {
                        if (stats != null) {
                            var msgs = arrayUtil.filter([stats.CurrentViewsText, stats.LastBookedDateText], function (msg) {
                                return msg != null;
                            });
                            angular.forEach(msgs, function (msg) {
                                toaster.pop('info', msg);
                            });
                        }
                    });
                }
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('imageGallery', function (imageService, $timeout) {
        return {
            restrict: 'E',
            replace: false,
            scope: {
                model: '=',
                enableReviews: '@',
                showReviews: '&'
            },
            templateUrl: 'partials/hotels/imagegallery',
            link: function (scope, el, attrs) {
                scope.isPrerender = /prerender/i.test(navigator.userAgent);
                //need to do this as type of the original property gets changed back to text later (by angular we suspect)
                scope.reviewsEnabled = scope.enableReviews === 'true' && TRPCONFIG.Domain.ReviewsEnabled;
                scope.images = [];
                var itemCarousel = el.find('.large-gallery');
                var thumbCarousel = el.find('.thumb-list');
                var thumbH = 68;
                var thumbW = 68;
                var mainH = 480;
                var mainW = 870;
                var cms = attrs.cms === 'true';
                var cancel = scope.$watch('model', function (v) {
                    if (!v) {
                        return;
                    }
                    cancel();
                    var cmsImageUrls = scope.model.CmsImageUrls;
                    if (cms) {
                        scope.images = v;
                    }
                    else if (cmsImageUrls) {
                        _.forEach(cmsImageUrls, function (i) {
                            scope.images.push({
                                altText: '',
                                thumbUrl: i,
                                mainUrl: i,
                                backgroundImage: { 'background-image': "url('" + i + "')" }
                            });
                        });
                    }
                    else {
                        var model = scope.model;
                        var _a = model.Title, Title = _a === void 0 ? '' : _a, _b = model.Location, Location_1 = _b === void 0 ? '' : _b, _c = model.Province, Province = _c === void 0 ? '' : _c, _d = model.Country, Country = _d === void 0 ? '' : _d;
                        var altText = "" + Title + (Title && ', ') + Location_1 + (Location_1 && ', ') + Province + (Province && ', ') + Country + (Country && ', ');
                        var NumberOfPhotos = scope.model.NumberOfPhotos;
                        for (var i = 0; i < NumberOfPhotos; i++) {
                            var thumbUrl = imageService.getImageUrl(scope.model.Id, thumbW, thumbH, i, true);
                            var mainUrl = imageService.getImageUrl(scope.model.Id, mainW, mainH, i, false);
                            scope.images.push({
                                altText: "" + altText + (i + 1),
                                thumbUrl: thumbUrl,
                                mainUrl: mainUrl,
                                backgroundImage: { 'background-image': "url('" + thumbUrl + "')" }
                            });
                        }
                    }
                    $timeout(initCarousel);
                });
                function initCarousel() {
                    // slick is dumb and won't clone enough slides to fill the whole container
                    // https://github.com/kenwheeler/slick/issues/1207
                    var imgCount = scope.images.length;
                    itemCarousel.slick({
                        rtl: TRPCONFIG.Rtl,
                        asNavFor: thumbCarousel,
                        speed: 500,
                        prevArrow: el.find('.stage .slick-prev'),
                        nextArrow: el.find('.stage .slick-next'),
                        infinite: imgCount > 5
                    });
                    itemCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        scope.selected = nextSlide;
                        scope.$apply();
                    });
                    // we need to remove 1 slide so the infinite carousel looks infinite
                    var minSlidesToShow = imgCount > 1 ? imgCount - 1 : imgCount;
                    thumbCarousel.slick({
                        rtl: TRPCONFIG.Rtl,
                        asNavFor: itemCarousel,
                        infinite: imgCount > 5,
                        centerMode: true,
                        focusOnSelect: true,
                        slidesToShow: minSlidesToShow,
                        swipeToSlide: true,
                        variableWidth: true
                    });
                    scope.$on('$destroy', function () {
                        itemCarousel.slick('unslick');
                        thumbCarousel.slick('unslick');
                    });
                }
            }
        };
    });
})();
/*  this exists because we need to force angular to reload a route if it is clicked inside
    a link list. If left to its own devices it may not do the right thing because sometimes
    only the query string is different
 */
angular
    .module('TR')
    .directive('linklist', function ($location, $route, $rootScope, urlUtils) {
    return {
        restrict: 'A',
        scope: {},
        link: function (scope, el) {
            function stripAndParse(url) {
                return urlUtils.parse(urlUtils.stripLeadingSlash(url));
            }
            var url = stripAndParse($location.path());
            $('a', el).click(function (e) {
                var linkPath = $(e.target).attr('href');
                var linkUrl = stripAndParse(linkPath);
                if (url.url === linkUrl.url) {
                    $route.reload();
                }
            });
            scope.$on('$destroy', function () { return $('a', el).off(); });
            $rootScope.$on('$routeChangeSuccess', function () {
                url = stripAndParse($location.path());
            });
        }
    };
});
(function () {
    'use strict';
    angular.module('TR')
        .directive('newsletterBanner', function (currentUser, cookieService, $timeout) { return ({
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'partials/home/directivetemplate?type=newsletterbanner',
        controllerAs: 'nb',
        controller: function ($scope, $rootScope) {
            var _this = this;
            var key = 'trpNewsletterClose';
            var monthMs = 2592e6; // 30 days
            var tempTTL = monthMs * 3;
            var permTTL = monthMs * 120;
            var user = currentUser.get();
            var isSignedIn = user && user.HardSignedIn;
            this.if = false; // DOM inclusion
            this.hide = false; // CSS transition
            if (!isSignedIn) {
                // Get persisted timestamp (async)
                localforage.getItem(key, function (err, value) {
                    var hideTs = value * 1; // Ensure is a number
                    var cookies = cookieService.get('CookiesAccepted') || false;
                    if (hideTs && (Date.now() > hideTs)) {
                        localforage.removeItem(key);
                        hideTs = null;
                    }
                    _this.hide = !cookies; // Hide if cookies never accepted
                    _this.if = !hideTs;
                });
            }
            this.close = function (ttl) {
                if (ttl === void 0) { ttl = tempTTL; }
                localforage.setItem(key, Date.now() + ttl);
                _this.hide = true;
                $timeout(function () { return _this.if = false; }, 1000);
            };
            $rootScope.$on('cookiesAccepted', function () {
                _this.hide = false;
            });
            $scope.$on('newsletterSignUp', function () {
                // Display success message before hiding
                $timeout(function () {
                    _this.close(permTTL);
                }, 1400);
            });
        }
    }); });
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('occupancyDesktop', Occupancy);
    function Occupancy($timeout, $route, $document, arrayUtil, occupancyService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                maxRooms: '@',
                maxAge: '@',
                occupancy: '=',
                multiroomDisabled: '=',
                hideGroupBookingLink: '@',
                areaOverride: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=OccupancyDesktop',
            link: _linker
        };
        function _linker(scope, el) {
            var area = scope.areaOverride || scope.$parent.areaOverride || $route.current.area;
            var limits = TRPCONFIG.Domain.OccupancyLimits[area];
            var wrapper = $('#occupancy-selectors', el);
            var inp = $('.input-occupancy', el);
            var timer;
            var initPos = function () {
                $timeout.cancel(timer);
                timer = $timeout(function () {
                    wrapper.position({
                        my: 'right top',
                        of: el,
                        at: 'right bottom',
                        collision: 'fit'
                    });
                }, 50);
            };
            scope.ages = arrayUtil.createRange(parseInt(scope.maxAge) || TRPCONFIG.Domain.MaximumChildAge, 0);
            scope.getAdultsLimit = _.memoize(getAdultsLimit);
            scope.getChildrenLimit = _.memoize(getChildrenLimit);
            scope.rooms = arrayUtil.createRange(scope.maxRooms || limits.maxRooms);
            scope.updateOccupancy = updateOccupancy;
            scope.showOccupancyWrapper = showOccupancyWrapper;
            scope.switchWrapper = switchWrapper;
            scope.changeRooms = changeRooms;
            scope.$watch('occupancy', function (val) {
                if (val == null) {
                    return;
                }
                scope.occupancyString = scope.multiroomDisabled ?
                    occupancyService.getOccupancyString() :
                    occupancyService.getRoomOccupancyString();
            }, true);
            function getAdultsLimit(firstRoom) {
                return arrayUtil.createRange(firstRoom ? limits.maxAdults : 6);
            }
            function getChildrenLimit(firstRoom) {
                return arrayUtil.createRange(firstRoom ? limits.maxChildren : 5, 0);
            }
            function switchWrapper(value) {
                if (value) {
                    initPos();
                }
                scope.showWrapper = value;
            }
            function showOccupancyWrapper(e) {
                initPos();
                scope.showWrapper = true;
                // Going to attach another click event which should not be fired
                // in the current event bubble
                e.stopPropagation();
                //this function must be declared locally to prevent it being hoisted to far,
                //and then removed from scope
                var _hideOccupancyWrapper = function _hideOccupancyWrapperFn(e) {
                    var isChild = el.find(e.target).length > 0;
                    if (!isChild) {
                        scope.$apply(function () {
                            scope.showWrapper = false;
                            $document.off('click.occupancy', _hideOccupancyWrapper);
                        });
                    }
                };
                inp.on('keydown', function tab(e) {
                    if (e.which === 9 || e.which === 27) {
                        scope.$apply(function () {
                            scope.showWrapper = false;
                        });
                    }
                });
                $document.on('click.occupancy', _hideOccupancyWrapper);
            }
            scope.$on('$destroy', function () {
                inp.off('keydown');
                $document.off('click.occupancy');
            });
            function changeRooms() {
                _.each(scope.occupancy, function (room, index) {
                    // ensure we have not added a null room to the occupancy array
                    room = room || {};
                    room.ChildAges = room.ChildAges || [];
                    room.Adults = room.Adults || 2;
                    scope.occupancy[index] = room;
                });
                updateOccupancy(scope.occupancy);
            }
            function updateOccupancy(o) {
                occupancyService.setOccupancy(o, true);
                scope.occupancyString = scope.multiroomDisabled ?
                    occupancyService.getOccupancyString() :
                    occupancyService.getRoomOccupancyString();
            }
        }
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('openNewTab', function ($parse) {
        return {
            restrict: 'A',
            scope: '=',
            link: function ($scope, $el, $attr) {
                var fn = $parse($attr.openNewTab);
                var el = $el[0];
                function handleRightClick(event) {
                    $scope.$apply(function () {
                        if (typeof fn === 'function') {
                            fn($scope, { $event: event });
                        }
                    });
                }
                el.addEventListener('contextmenu', handleRightClick);
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('pageTitle', function ($rootScope, resourceService) {
        return {
            restrict: 'A',
            link: function (scope, el, attr) {
                var defaultTitle = attr.pageTitle;
                var resources = {
                    transfers: 'TRANSFERSHOMEPAGETITLE'
                };
                $rootScope.$on('$routeChangeStart', function (scope, next) {
                    if (!next.landing) {
                        var title = defaultTitle;
                        var resource = resources[next.area];
                        if (resource) {
                            title = resourceService.get(resource);
                        }
                        document.title = title;
                    }
                });
            }
        };
    });
})();
var TR;
(function (TR) {
    var PriceFilter = /** @class */ (function () {
        function PriceFilter($scope, occupancyService, broker) {
            var _this = this;
            this.$scope = $scope;
            this.occupancyService = occupancyService;
            $scope.$watch('pf.aggregate', this.setRange.bind(this), true);
            $scope.$watch('pf.model', function (m) {
                if (m === null) {
                    _this.reset(undefined);
                }
            });
            broker.subscribe('priceFilter', 'RESETPRICE', this.reset.bind(this));
            $scope.$on('$destroy', function () {
                broker.unsubscribe('priceFilter');
            });
        }
        PriceFilter.prototype.setRange = function (a) {
            if (!a) {
                return;
            }
            if (_.get(this.model, 'Min') === 0) {
                this.model.Min = a.Min;
            }
            if (_.get(this.model, 'Max') === 0) {
                this.model.Max = a.Max;
            }
            this.range = this.model
                ? { Min: this.model.Min, Max: this.model.Max }
                : { Min: a.Min, Max: a.Max };
            this.people = this.occupancyService.getNumberOfNonInfantPassengers();
        };
        PriceFilter.prototype.updateModel = function () {
            // if model already in sync skip
            if (this.model &&
                ((this.model.Min === this.range.Min) && (this.model.Max === this.range.Max))) {
                return;
            }
            // if new value is the default one reset
            if (this.range.Min === this.aggregate.Min && this.range.Max === this.aggregate.Max) {
                return this.model = null;
            }
            return this.model = { Min: this.range.Min, Max: this.range.Max };
        };
        PriceFilter.prototype.isSet = function () {
            return !!this.model;
        };
        PriceFilter.prototype.reset = function (e) {
            if (e && e.data) {
                this.range[e.data] = this.aggregate[e.data];
                return this.model[e.data] = this.aggregate[e.data];
            }
            this.range = { Min: this.aggregate.Min, Max: this.aggregate.Max };
            this.model = null;
        };
        return PriceFilter;
    }());
    angular
        .module('TR')
        .directive('priceFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=PriceFilter',
            bindToController: {
                aggregate: '=',
                model: '=',
                priceMode: '='
            },
            controller: PriceFilter,
            controllerAs: 'pf'
        };
    });
    var PriceFilterLabel = /** @class */ (function () {
        function PriceFilterLabel($scope, $filter, broker, analytics, occupancyService) {
            this.$filter = $filter;
            this.broker = broker;
            this.occupancyService = occupancyService;
            this.currencySymbol = TRPCONFIG.Domain.CurrencyCode;
            this.currencyFilter = this.$filter('roundedCurrency');
            $scope.$watch('pf.model', function (value) {
                if (!value) {
                    return;
                }
                analytics.track('mixpanel', 'HolidayDealsFilterPrice');
            });
        }
        PriceFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"pf.isSet('Min')\">\n                    <a\n                        href=\"#\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"pf.remove('Min')\">\n                        <span> {{pf.getName('Min', pf.priceMode)}} </span>\n                    </a>\n                </span>\n                <span ng-if=\"pf.isSet('Max')\">\n                    <a\n                        href=\"#\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"pf.remove('Max')\">\n                        <span> {{pf.getName('Max', pf.priceMode)}} </span>\n                    </a>\n                </span>\n            ";
        };
        PriceFilterLabel.prototype.getName = function (end, priceMode) {
            var price = end === 'Min' ? this.model.Min : this.model.Max;
            var priceSentence = end === 'Min' ? this.sentenceMin : this.sentenceMax;
            var people = this.occupancyService.getNumberOfNonInfantPassengers();
            return priceSentence.replace('{0}', this.currencyFilter(priceMode === 1 ? price : price / people, this.currencySymbol));
        };
        PriceFilterLabel.prototype.isSet = function (end) {
            return !!this.model && this.model[end] !== this.aggregate[end] && this.model[end] !== 0;
        };
        PriceFilterLabel.prototype.remove = function (end) {
            this.broker.publish('RESETPRICE', end);
        };
        return PriceFilterLabel;
    }());
    angular
        .module('TR')
        .directive('priceFilterLabel', function () {
        return {
            scope: {},
            template: PriceFilterLabel.getTemplate(),
            bindToController: {
                aggregate: '=',
                model: '=',
                priceMode: '=',
                sentenceMin: '@',
                sentenceMax: '@'
            },
            controller: PriceFilterLabel,
            controllerAs: 'pf'
        };
    });
})(TR || (TR = {}));
angular
    .module('TR')
    .directive('priceToken', function () {
    return {
        restrict: 'E',
        replace: true,
        template: '<span class="price" ng-transclude></span>',
        transclude: true
    };
});
angular
    .module('TR')
    .directive('primaryNavigationList', function ($location, broker, scrollService, $route, $window, $document) {
    return {
        restrict: 'A',
        link: function (scope, el) {
            var navBarContentElement = $('#navbarcont');
            var isSlidePanel = (el.parents('.navigation-drawer').length === 1);
            if (isSlidePanel) {
                // we are not showing sub menus in the navigation drawer yet,
                // just publish the instruction to close the slide panel
                el.find('a').click(function (e) {
                    broker.publish('hideNavigationDrawer');
                });
                return;
            }
            var setStaticBar = function () {
                navBarContentElement.addClass('static');
            };
            var unsetStaticBar = function () {
                navBarContentElement.removeClass('static');
            };
            broker.subscribe('primaryNavigationList', 'bookingFormInitialised', setStaticBar);
            broker.subscribe('primaryNavigationList', 'bookingFormClosed', unsetStaticBar);
            var $listItemsWithSubMenus = el.find('> li.has-sub-menu');
            var $subMenuLinks = $listItemsWithSubMenus.find('.sub-menu a');
            if ($window.TRPCONFIG.IsTouchDevice) {
                $listItemsWithSubMenus.find('> a').on('click', function (e) {
                    var $link = $(e.currentTarget);
                    var $listItem = $link.parent();
                    var isOpen = $listItem.hasClass('open');
                    if (isOpen) {
                        // let navigation execute and close menu
                        $listItem.removeClass('open');
                    }
                    else {
                        // prevent link navigation and open the sub menu
                        e.preventDefault();
                        // close any other sub menus
                        $listItemsWithSubMenus.filter('.open').removeClass('open');
                        // open this sub menu
                        $listItem.addClass('open');
                        e.stopPropagation();
                        // close sub menu when anything else is clicked
                        $document.one('click.primaryNavigationList', function (e2) {
                            // something else was clicked so close menu
                            $listItem.removeClass('open');
                        });
                    }
                });
            }
            else {
                // apply "open" class on hover
                var hoverTimeout_1 = null;
                $listItemsWithSubMenus.hover(function (e) {
                    // hover action has a 200ms delay
                    hoverTimeout_1 = setTimeout(function () {
                        $(e.currentTarget).addClass('open');
                    }, 200);
                }, function (e) {
                    clearTimeout(hoverTimeout_1);
                    $(e.currentTarget).removeClass('open');
                });
                $listItemsWithSubMenus.find('a').one('click', function (e) {
                    var $link = $(e.currentTarget);
                    $link.parent().removeClass('open');
                });
            }
            // close sub menu on any sub menu link clicks
            $subMenuLinks.click(function (e) {
                var $link = $(e.currentTarget);
                $link.parents('li.has-sub-menu').removeClass('open');
            });
            scope.$on('$destroy', function () {
                $listItemsWithSubMenus.off();
                $subMenuLinks.off();
            });
        }
    };
});
var TR;
(function (TR) {
    var PropertyTypeFilter = /** @class */ (function () {
        function PropertyTypeFilter($scope, occupancyService) {
            var _this = this;
            $scope.$watch('pt.aggregate', function (agg) {
                if (!agg) {
                    return;
                }
                _this.people = occupancyService.getNumberOfNonInfantPassengers();
                var propArray = [];
                for (var key in agg) {
                    propArray.push(_.extend(agg[key], { id: key }));
                }
                _.set(_.minBy(propArray, function (v) { return v.MinPrice; }), 'cheapest', true);
                _this.propArray = propArray;
            });
        }
        PropertyTypeFilter.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        PropertyTypeFilter.prototype.reset = function () {
            this.model = [];
        };
        PropertyTypeFilter.prototype.more = function (all) {
            this.showAll = all;
        };
        PropertyTypeFilter.prototype.showMoreLess = function () {
            return Object.keys(this.aggregate || {}).length > this.limit;
        };
        return PropertyTypeFilter;
    }());
    angular
        .module('TR')
        .directive('propertyTypeFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=PropertyTypeFilter',
            bindToController: {
                aggregate: '=',
                model: '=',
                limit: '@',
                priceMode: '='
            },
            controller: PropertyTypeFilter,
            controllerAs: 'pt'
        };
    });
    var PropertyTypeFilterLabel = /** @class */ (function () {
        function PropertyTypeFilterLabel($scope, analytics) {
            var _this = this;
            $scope.$watch('pt.model', function (value) {
                if (!value || !value.length) {
                    return;
                }
                var pt = value.map(function (v) { return _this.getName(v); });
                analytics.track('mixpanel', 'HolidayDealsFilterPropertyType', { value: pt });
            });
        }
        PropertyTypeFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"pt.isSet()\">\n                    <a\n                        href=\"#\"\n                        ng-repeat=\"type in pt.model\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"pt.remove(type)\">\n                        <span> {{pt.getName(type)}} </span>\n                    </a>\n                </span>\n            ";
        };
        PropertyTypeFilterLabel.prototype.getName = function (type) {
            if (!this.aggregate) {
                return '';
            }
            return (this.aggregate[type] || {}).Title;
        };
        PropertyTypeFilterLabel.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        PropertyTypeFilterLabel.prototype.remove = function (type) {
            this.model = this.model.filter(function (v) { return v !== type; });
        };
        return PropertyTypeFilterLabel;
    }());
    angular
        .module('TR')
        .directive('propertyTypeFilterLabel', function () {
        return {
            scope: {},
            template: PropertyTypeFilterLabel.getTemplate(),
            bindToController: {
                aggregate: '=',
                model: '='
            },
            controller: PropertyTypeFilterLabel,
            controllerAs: 'pt'
        };
    });
})(TR || (TR = {}));
(function () {
    /*
        Brings data from publicityService into scope
    */
    'use strict';
    angular.module('TR')
        .directive('publicityData', function (publicityService) { return ({
        restrict: 'A',
        scope: false,
        link: function (scope) {
            publicityService
                .getStats({
                StatisticTypes: 'All'
            })
                .then(function (data) {
                // Add returned data to scope
                scope.publicityData = data;
            });
        }
    }); });
})();
var TR;
(function (TR) {
    var RatingFilter = /** @class */ (function () {
        function RatingFilter($scope, broker) {
            var _this = this;
            this.$scope = $scope;
            this.$scope.$watch('rf.aggregate', this.setRange.bind(this), true);
            $scope.$watch('rf.model', function (m) {
                if (m === null) {
                    _this.reset();
                }
            });
            broker.subscribe('ratingFilter', 'RESETRATING', this.reset.bind(this));
            $scope.$on('$destroy', function () {
                broker.unsubscribe('ratingFilter');
            });
        }
        RatingFilter.prototype.setRange = function (a) {
            if (!a) {
                return;
            }
            this.range = this.model
                ? { Min: this.model.Min, Max: this.model.Max }
                : { Min: a.Min, Max: a.Max };
        };
        RatingFilter.prototype.updateModel = function () {
            // if model already in sync skip
            if (this.model && (this.model.Min === this.range.Min)) {
                return;
            }
            // if new value is the default one reset
            if (this.range.Min === this.aggregate.Min) {
                return this.model = null;
            }
            return this.model = { Min: this.range.Min, Max: this.range.Max };
        };
        RatingFilter.prototype.isSet = function () {
            return !!this.model;
        };
        RatingFilter.prototype.reset = function () {
            this.range = { Min: this.aggregate.Min, Max: this.aggregate.Max };
            this.model = null;
        };
        return RatingFilter;
    }());
    angular
        .module('TR')
        .directive('ratingFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=RatingFilter',
            bindToController: {
                aggregate: '=',
                model: '='
            },
            controller: RatingFilter,
            controllerAs: 'rf'
        };
    });
    var RatingFilterLabel = /** @class */ (function () {
        function RatingFilterLabel($scope, broker, analytics) {
            this.broker = broker;
            $scope.$watch('rf.model', function (value) {
                if (!value) {
                    return;
                }
                analytics.track('mixpanel', 'HolidayDealsFilterRating');
            });
        }
        RatingFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"rf.isSet()\">\n                    <a\n                        href=\"#\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"rf.remove()\">\n                        <span> {{rf.getName()}} </span>\n                    </a>\n                </span>\n            ";
        };
        RatingFilterLabel.prototype.getName = function () {
            return this.sentence.replace('{0}', this.model.Min);
        };
        RatingFilterLabel.prototype.isSet = function () {
            return !!this.model && this.model.Min > this.aggregate.Min;
        };
        RatingFilterLabel.prototype.remove = function (dest) {
            this.broker.publish('RESETRATING');
        };
        return RatingFilterLabel;
    }());
    angular
        .module('TR')
        .directive('ratingFilterLabel', function () {
        return {
            scope: {},
            template: RatingFilterLabel.getTemplate(),
            bindToController: {
                aggregate: '=',
                model: '=',
                sentence: '@'
            },
            controller: RatingFilterLabel,
            controllerAs: 'rf'
        };
    });
})(TR || (TR = {}));
var Core;
(function (Core) {
    var ReviewSnippetBrowser = /** @class */ (function () {
        function ReviewSnippetBrowser($scope, $q, $interval, $timeout, $locale) {
            this.$scope = $scope;
            this.$q = $q;
            this.$interval = $interval;
            this.$timeout = $timeout;
            this.$locale = $locale;
            this.eventNamespace = 'reviewsnippetbrowser';
            this.show = false;
            this.slickOptions = {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: TRPCONFIG.Rtl,
                speed: 200,
                autoplay: true,
                autoplaySpeed: 6000
            };
        }
        ReviewSnippetBrowser.prototype.init = function (elements) {
            var _this = this;
            this.elements = elements;
            this.$scope.$watch('rsb.hotel', function (val) {
                if (val) {
                    _this.initSlick();
                }
            });
        };
        // private initSlick(): void {
        //     this.elements.carousel.slick(this.slickOptions);
        //     this.$scope.$on('$destroy', () => {
        //         this.elements.carousel.slick('unslick');
        //     });
        // }
        ReviewSnippetBrowser.prototype.initSlick = function () {
            var _this = this;
            var interval = 10, attempts = 5, stopTrying;
            var tryInit = function () {
                var ready = _this.elements.carousel[0].children && _this.elements.carousel[0].children.length > 0;
                if (ready) {
                    // stop the loop
                    _this.$interval.cancel(stopTrying);
                    // do the init
                    _this.elements.carousel.slick(_this.slickOptions);
                    _this.show = true;
                    _this.$scope.$on('$destroy', function () {
                        _this.elements.carousel.slick('unslick');
                    });
                }
            };
            // start the loop
            stopTrying = this.$interval(tryInit, interval, attempts);
        };
        return ReviewSnippetBrowser;
    }());
    angular
        .module('search')
        .directive('reviewSnippetBrowser', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: ReviewSnippetBrowser,
            controllerAs: 'rsb',
            transclude: true,
            bindToController: {
                hotel: '='
            },
            templateUrl: 'partials/home/reviewsnippetbrowser',
            link: function (scope, el, attr, controller) {
                var elements = {
                    carousel: el.find('.carousel')
                };
                controller.init(elements);
            }
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('scrollIntoView', scrollIntoView);
    function scrollIntoView($timeout) {
        return {
            restrict: 'A',
            scope: '=',
            compile: function ($element, $attrs) {
                // raw template
                var element = $element[0];
                var showLessbutton = element.querySelector('#seo-lists__showLessButton');
                var showMorebutton = element.querySelector('#seo-lists__showMoreButton');
                var seoListsPanel = element.querySelector('#seo-lists__grid');
                var seoListsContainer = element.querySelector('#seo-lists');
                if (!showLessbutton && !seoListsPanel && !seoListsContainer) {
                    return;
                }
                var configTimeout = $attrs.timeout && parseInt($attrs.timeout) || '';
                var configDelay = (typeof configTimeout === 'number') ? configTimeout : 0;
                if (configDelay) {
                    seoListsPanel.classList.add('open');
                }
                return function postLink($scope) {
                    var removeOpen = function () {
                        if (seoListsPanel.classList.contains('open')) {
                            seoListsPanel.classList.remove('open');
                        }
                    };
                    var addActive = function () {
                        if (!showMorebutton.classList.contains('active')) {
                            showMorebutton.classList.add('active');
                        }
                    };
                    var wait = function (ms) {
                        if (ms === void 0) { ms = 0; }
                        return new Promise(function (resolve) { return $timeout(resolve, ms); });
                    };
                    function handleScrollToView() {
                        seoListsContainer.scrollIntoView();
                    }
                    function scrollToSeoListContainer() {
                        showLessbutton.addEventListener('click', handleScrollToView);
                    }
                    function delayRemoveOpen() {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, wait(configDelay)];
                                    case 1:
                                        _a.sent();
                                        removeOpen();
                                        scrollToSeoListContainer();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                    function handleError(err) {
                        console.log(err);
                    }
                    $scope.$on('$routeChangeSuccess', function (prev, next, current) {
                        addActive();
                        if (current) {
                            removeOpen();
                            scrollToSeoListContainer();
                        }
                    });
                    window.onload = (function () {
                        if (configDelay) {
                            delayRemoveOpen().catch(handleError);
                        }
                    })();
                };
            }
        };
    }
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('shortlistToggle', shortlistToggle);
    function shortlistToggle(shortlistService, $rootScope) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                hotel: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=ShortlistToggle',
            link: function (scope) {
                var cancel = scope.$watch('hotel', function (v) {
                    if (v) {
                        cancel();
                        shortlistService.isHotelShortlisted(scope.hotel)
                            .then(function (shortlisted) { return scope.hotel.inShortlist = shortlisted; });
                        scope.toggleShortlist = function (e) {
                            e.preventDefault();
                            shortlistService.toggleHotel(scope.hotel).then(function (shortlisted) {
                                scope.hotel.inShortlist = shortlisted;
                                scope.$emit('hotelShortlistStatusUpdated', scope.hotel);
                            });
                            e.stopPropagation();
                        };
                        $rootScope.$on('hotelShortlistStatusUpdated', function (ev, args) {
                            if (scope.hotel.Id === args.Id) {
                                scope.hotel.inShortlist = args.inShortlist;
                            }
                        });
                    }
                });
            }
        };
    }
})();
var TR;
(function (TR) {
    var SimpleImageGallery = /** @class */ (function () {
        function SimpleImageGallery($scope, $element, imageService) {
            var _this = this;
            this.$scope = $scope;
            this.imageService = imageService;
            this.directions = { LEFT: 0, RIGHT: 1 };
            // CSS Setup
            var gallery = $element.find('.simple-image-gallery');
            var leftArrow = gallery.find('.icon-chevron-left');
            var rightArrow = gallery.find('.icon-chevron-right');
            this.slider = gallery.find('.slider');
            var arrowSize = Math.floor(this.height / 8);
            var arrowTop = (this.height / 2) - (arrowSize / 2);
            var arrowCss = {
                'font-size': arrowSize + "px",
                'top': arrowTop + "px"
            };
            gallery.css('height', this.height + "px");
            leftArrow.css(arrowCss);
            rightArrow.css(arrowCss);
            $scope.$watch(function () { return gallery.is(':visible'); }, function () { return _this._setPadding(gallery); });
            $scope.$watch(function () { return gallery.width(); }, function () { return _this._setPadding(gallery); });
            this.slider.css({
                left: "-" + this.width + "px",
            });
            this.size = {
                width: this.width + "px",
                height: this.height + "px"
            };
            // Image Insertion
            this.$scope.$watch('si.estabId', function (v) {
                if (!v) {
                    return;
                }
                _this.images = [];
                for (var i = 0, ii = _this.imageNumber; i < ii; i++) {
                    _this.images.push(imageService.getImageUrl(_this.estabId, _this.width, _this.height, i, true));
                }
            });
            // Events
            rightArrow.click(function () { return _this._slide(_this.directions.RIGHT); });
            leftArrow.click(function () { return _this._slide(_this.directions.LEFT); });
            gallery[0].addEventListener('touchstart', function (e) { return _this._handleTouchStart(e); }, false);
            gallery[0].addEventListener('touchend', function (e) { return _this._handleTouchMove(e); }, false);
        }
        SimpleImageGallery.prototype._setPadding = function (gallery) {
            var w = gallery.width();
            var pad = w > this.width ? (w - this.width) / 2 + "px" : '10px';
            if (w > this.width) {
                this.slider.css('padding-left', pad);
            }
        };
        SimpleImageGallery.prototype._handleTouchStart = function (e) {
            this.touchStart = e.touches[0].clientX;
        };
        SimpleImageGallery.prototype._handleTouchMove = function (e) {
            if (!this.touchStart) {
                return;
            }
            var touchEnd = e.changedTouches[0].clientX;
            var diff = this.touchStart - touchEnd;
            if (Math.abs(diff) < 30) {
                return;
            }
            return this._slide(diff > 0 ? this.directions.RIGHT : this.directions.LEFT);
        };
        SimpleImageGallery.prototype._slide = function (dir) {
            var _this = this;
            var current = parseInt(this.slider.css('left'), 10);
            var move = dir === this.directions.LEFT
                ? current + this.width
                : current - this.width;
            this.slider.animate({ left: move }, 200, function () {
                var selectedImage = TRPCONFIG.Rtl ? 'img:nth-last-child(2)' : 'img:nth-child(2)';
                _this.slider.find(selectedImage).css('opacity', '0.5');
                var first = _this.slider.find('img:first');
                var last = _this.slider.find('img:last');
                if (TRPCONFIG.Rtl) {
                    if (dir === _this.directions.RIGHT) {
                        first.before(last);
                    }
                    else {
                        last.after(first);
                    }
                }
                else {
                    if (dir === _this.directions.LEFT) {
                        first.before(last);
                    }
                    else {
                        last.after(first);
                    }
                }
                _this.slider.css({ 'left': "-" + _this.width + "px" });
                _this.slider.find(selectedImage).css('opacity', '1');
            });
        };
        return SimpleImageGallery;
    }());
    angular
        .module('TR')
        .directive('simpleImageGallery', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=SimpleImageGallery',
            bindToController: {
                estabId: '=',
                imageNumber: '=',
                width: '=?',
                height: '=?'
            },
            controller: SimpleImageGallery,
            controllerAs: 'si'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var StarsFilter = /** @class */ (function () {
        function StarsFilter($scope, occupancyService) {
            var _this = this;
            $scope.$watch('sf.aggregate', function (agg) {
                if (!agg) {
                    return;
                }
                _this.people = occupancyService.getNumberOfNonInfantPassengers();
                _this.ordered = Object.keys(agg)
                    .map(function (v) { return parseInt(v, 10); })
                    .sort(function (a, b) { return b - a; })
                    .map(function (v) { return ({
                    stars: v.toString(),
                    Count: agg[v].Count,
                    MinPrice: agg[v].MinPrice
                }); });
                _.set(_.minBy(_this.ordered, function (v) { return v.MinPrice; }), 'cheapest', true);
            });
        }
        StarsFilter.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        StarsFilter.prototype.reset = function () {
            this.model = [];
        };
        return StarsFilter;
    }());
    angular
        .module('TR')
        .directive('starsFilter', function () {
        return {
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=StarsFilter',
            bindToController: {
                aggregate: '=',
                model: '=',
                priceMode: '='
            },
            controller: StarsFilter,
            controllerAs: 'sf'
        };
    });
    var StarsFilterLabel = /** @class */ (function () {
        function StarsFilterLabel($scope, analytics) {
            $scope.$watch('sf.model', function (value) {
                if (!value || !value.length) {
                    return;
                }
                analytics.track('mixpanel', 'HolidayDealsFilterStars', { value: value });
            });
        }
        StarsFilterLabel.getTemplate = function () {
            return "\n                <span ng-if=\"sf.isSet()\">\n                    <a\n                        href=\"#\"\n                        ng-repeat=\"star in sf.model\"\n                        class=\"filter-criterion-toggle\"\n                        ng-click=\"sf.remove(star)\">\n                        <span ng-if=\"star == 0\"> {{::sf.unrated}} </span>\n                        <span ng-if=\"star == 1\"> 1 {{::sf.singular}} </span>\n                        <span ng-if=\"star > 1\"> {{::star}} {{::sf.plural}} </span>\n                    </a>\n                </span>\n            ";
        };
        StarsFilterLabel.prototype.isSet = function () {
            return !!_.size(this.model);
        };
        StarsFilterLabel.prototype.remove = function (star) {
            this.model = this.model.filter(function (v) { return v !== star; });
        };
        return StarsFilterLabel;
    }());
    angular
        .module('TR')
        .directive('starsFilterLabel', function () {
        return {
            scope: {},
            template: StarsFilterLabel.getTemplate(),
            bindToController: {
                unrated: '@',
                singular: '@',
                plural: '@',
                model: '='
            },
            controller: StarsFilterLabel,
            controllerAs: 'sf'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var TextFader = /** @class */ (function () {
        function TextFader() {
            this.showContent = true;
            this.showExpanderLink = true;
        }
        TextFader.prototype.init = function (contentHeight) {
            console.log('text fader: ' + contentHeight);
            //if there isn't enough content remove the more less links
            this.showContent = !(contentHeight > this.height);
            this.showExpanderLink = !this.showContent;
        };
        return TextFader;
    }());
    angular
        .module('TR')
        .directive('textFader', function () {
        return {
            scope: {
                height: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=TextFader',
            bindToController: true,
            controller: TextFader,
            controllerAs: 'tf',
            link: function (scope, el, attr, ctrl) {
                setTimeout(function () {
                    // angular finished its thing we can get the height
                    ctrl.init(el.find(' > .content').outerHeight());
                }, 0);
            },
            replace: true,
            transclude: true
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('tooltip', function () {
        return {
            restrict: 'A',
            scope: {
                placement: '@'
            },
            link: function (scope, el, attr) {
                if (TRPCONFIG.IsTouchDevice) {
                    return;
                }
                var popup;
                var placement = (function () {
                    switch (scope.placement) {
                        case 'start': return TRPCONFIG.Rtl ? 'right' : 'left';
                        case 'end': return TRPCONFIG.Rtl ? 'left' : 'right';
                        default: return scope.placement || 'top';
                    }
                })();
                el.on('mouseenter', function () {
                    if (!attr.tooltip) {
                        return;
                    }
                    if (!popup) {
                        el.trppopup({
                            trigger: 'manual',
                            placement: placement,
                            content: function () {
                                return attr.tooltip;
                            }
                        });
                        popup = el.data('trppopup');
                    }
                    popup.show();
                });
                el.on('mouseleave', function () {
                    if (popup) {
                        popup.hide();
                    }
                });
                scope.$on('$destroy', function () {
                    el.off('mouseenter');
                    el.off('mouseleave');
                    if (popup) {
                        popup.destroy();
                    }
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('tooltipUi', tooltipUi);
    function tooltipUi() {
        return {
            restrict: 'A',
            scope: {
                tooltipClass: '@'
            },
            link: function (scope, el, attr) {
                $(el).mouseover(function () {
                    $(el).tooltip({
                        items: el[0].tagName,
                        content: attr.tooltipUi,
                        position: { my: 'center top+15', at: 'center bottom' },
                        hide: false,
                        show: false,
                        tooltipClass: scope.tooltipClass
                    });
                    $(el).tooltip('open');
                });
                scope.$on('$destroy', function () { return $(el).off(); });
            }
        };
    }
})();
var TR;
(function (TR) {
    var TrustpilotLogo = /** @class */ (function () {
        function TrustpilotLogo(TrustpilotService) {
            var _this = this;
            this.TrustpilotService = TrustpilotService;
            // get business unit info from Trustpilot
            this.TrustpilotService.getBusinessUnit().then(function (res) {
                _this.summary = res;
            });
        }
        return TrustpilotLogo;
    }());
    angular
        .module('TR')
        .directive('trustpilotLogo', function () {
        return {
            bindToController: {
                stars: '=',
                count: '=',
                name: '@',
                class: '@',
                path: '@',
                altLogo: '=?',
            },
            controller: TrustpilotLogo,
            controllerAs: 'tpl',
            templateUrl: 'partials/home/directivetemplate?type=TrustpilotLogo',
            link: function ($scope) {
                $scope.hostName = 'https://uk.trustpilot.com/review/www.' + TRPCONFIG.Domain.HostName;
                setTimeout(function () {
                    var widgetManagement = _.get(window, 'Trustpilot.Modules.WidgetManagement');
                    if (!widgetManagement) {
                        $(document.body).append("<script type=\"text/javascript\"\n                                src=\"//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js\" async></script>");
                    }
                }, 1500);
            }
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    ///NOTE: this is now deprecated, please use the validationMessage directive as that
    //is aligned with what we would like to do going forward with the look and feel and activation
    //or errors across the site.
    TR.directive('validationErrors', function ($rootScope, validationService, broker) {
        return {
            restrict: 'E',
            replace: true,
            priority: 1000,
            scope: {
                rootForm: '=',
                field: '=',
                label: '@',
                msgMap: '@',
                immediate: '@',
                stayActive: '@' // Error stays visible until another field is focused (i.e. whilst using calendar)
            },
            template: '<ul ng-class="{invalid:!field.$valid}" class="animate-fade flash-message error-message" ng-show="!field.$valid && showErrors()">' +
                '    <li ng-show="val" ng-repeat="(name, val) in field.$error">' +
                '        {{translate(name, val)}}' +
                '    </li>' +
                '</ul>',
            link: function (scope) {
                scope.showErrors = function () {
                    var field = scope.field;
                    if (field) {
                        var stayActive = (scope.stayActive === 'true' && field.lastFocused);
                        return (field.focused || stayActive || immediateTest()) &&
                            ($rootScope.submittedForm === scope.rootForm && !scope.rootForm.$valid || immediateTest());
                    }
                };
                function immediateTest() {
                    if (scope.immediate != null) {
                        if (scope.immediate === 'true') {
                            return true;
                        }
                        var immediate = scope.immediate.split('|');
                        for (var i in immediate) {
                            var doNow = immediate[i];
                            if (doNow && scope.field.$error[doNow]) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
                var map = scope.msgMap == null ? {} : JSON.parse(scope.msgMap);
                var watcher = scope.$watch('field', function (val) {
                    if (val) {
                        scope.field.label = scope.label;
                        watcher();
                    }
                });
                scope.$watch(scope.showErrors, function (val) {
                    if (val && scope.field.$invalid) {
                        var validationErrors = Object.keys(scope.field.$error)
                            .map(function (name) { return validationService.translateField(scope.field, name, map); });
                        broker.publish('validationErrors', validationErrors);
                    }
                });
                scope.translate = function (name, val) {
                    if (!val) {
                        return '';
                    }
                    return validationService.translateField(scope.field, name, map);
                };
            }
        };
    });
})();
var TR;
(function (TR) {
    var FormField = /** @class */ (function () {
        function FormField(field) {
            this.Children = [];
            this.Inputs = [];
            this.Field = FormField.addValidationObjectToField(field);
        }
        FormField.prototype.addChildField = function (input, field) {
            this.addInputField(input);
            this.Children.push(FormField.addValidationObjectToField(field));
        };
        FormField.prototype.addInputField = function (input) {
            this.Inputs.push(input);
        };
        FormField.prototype.errorMessages = function () {
            return this.isValid() ? {} : this.Field.$error;
        };
        FormField.prototype.getInputFields = function () {
            return this.Inputs;
        };
        FormField.prototype.isFocused = function () {
            return this.Children.length > 0 ?
                _.some(this.Children, function (f) { return f.ValidationSummary.Focused === true; })
                : this.Field.ValidationSummary.Focused;
        };
        FormField.prototype.isValid = function () {
            return !this.Field.$invalid;
        };
        FormField.prototype.wasPreviouslyFocused = function () {
            return this.Children.length > 0 ?
                _.every(this.Children, function (f) { return f.ValidationSummary.PreviouslyFocused === true; })
                : this.Field.ValidationSummary.PreviouslyFocused;
        };
        FormField.addValidationObjectToField = function (field) {
            var f = field;
            f.ValidationSummary = {
                Focused: false,
                PreviouslyFocused: false
            };
            return f;
        };
        return FormField;
    }());
    var ValidationMessage = /** @class */ (function () {
        function ValidationMessage($scope, $timeout, validationService) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.validationService = validationService;
            this.fields = [];
            this.labels = [];
            this.watchers = [];
            this.errorMessages = [];
            for (var _i = 0, _a = this.labelStrings.split('|'); _i < _a.length; _i++) {
                var l = _a[_i];
                this.labels.push(l);
            }
            this.map = this.msgMap == null ? {} : JSON.parse(this.msgMap);
        }
        ValidationMessage.prototype.init = function (form, formElement) {
            var _this = this;
            this.form = form;
            var _loop_1 = function (name_1) {
                f = this_1.form[name_1];
                var formField = new FormField(this_1.form[name_1]);
                //find the input DOM element within our form and attach some handlers
                //use the name property to associate the field and input also keep a
                //pointer to the input field as we will want to add/remove css classes
                //depending on its validity
                var input = formElement.find("[name='" + name_1 + "']").first();
                if (input.is('select') || input.is('input')) {
                    input
                        .focus(function (e) { return _this.focusHandler(e); })
                        .blur(function (e) { return _this.blurHandler(e); });
                    formField.addInputField(input);
                }
                else {
                    //find our actual sub inputs and add a Validation summary to these
                    _.each(input.find('select,input'), function (ele) { return formField.addChildField($(ele), _this.form[ele.name]); });
                    input
                        .focusin(function (e) { return _this.focusHandler(e); })
                        .focusout(function (e) { return _this.blurHandler(e); });
                }
                this_1.fields.push(formField);
            };
            var this_1 = this, f;
            for (var _i = 0, _a = this.fieldNames.split('|'); _i < _a.length; _i++) {
                var name_1 = _a[_i];
                _loop_1(name_1);
            }
            //this is a bit of a hack to solve issues where we have external influences on a field.
            //we should avoid having so many watches
            if (this.alwaysWatch()) {
                _.each(this.fields, function (f, i) {
                    _this.watchers.push(_this.$scope.$watch("vm.fields[" + i + "].isValid()", function (n, o) {
                        if (n !== o) {
                            _this.active = _.every(_this.fields, function (f) { return f.wasPreviouslyFocused() === true; })
                                || _.every(_this.fields, function (f) { return f.isValid() === true; });
                            _this.updateValidationStatus();
                        }
                    }));
                });
            }
            this.$scope.$watch('vm.rootForm.$submitted', function (v) {
                if (v) {
                    _this.active = true;
                    _this.updateValidationStatus();
                }
            });
        };
        ValidationMessage.prototype.blurHandler = function (e) {
            if (this.watchers.length && !this.alwaysWatch()) {
                _.each(this.watchers, function (w) { return w(); });
                this.watchers = [];
            }
            //use the elements name to get the field from the form
            var field = this.form[e.target.name];
            field.ValidationSummary.Focused = false;
            field.ValidationSummary.PreviouslyFocused = true;
            this.active = _.every(this.fields, function (f) { return f.wasPreviouslyFocused() === true; });
            this.updateValidationStatus();
        };
        ValidationMessage.prototype.focusHandler = function (e) {
            var _this = this;
            //use the elements name to get the field from the form
            var field = this.form[e.target.name];
            field.ValidationSummary.Focused = true;
            //if all the fields were previously active and we are invalid then watch our fields while we type
            //so that we know when we are valid
            if (_.every(this.fields, function (f) { return f.wasPreviouslyFocused() === true; }) && !this.alwaysWatch()) {
                _.each(this.fields, function (f, i) {
                    _this.watchers.push(_this.$scope.$watch("vm.fields[" + i + "].isValid()", function () {
                        _this.updateValidationStatus();
                    }, true));
                });
            }
        };
        ValidationMessage.prototype.updateValidationStatus = function () {
            var _this = this;
            var allValid = true;
            var errors = [];
            var errorClassName = 'sc-c-field--error';
            var successClassName = 'sc-c-field--success';
            var fds = this.fields;
            _.each(this.fields, function (f, index) {
                var valid = f.isValid();
                if (!valid && _this.active) {
                    allValid = false;
                    _.forOwn(f.errorMessages(), function (v, k) {
                        return errors.push(_this.validationService.translateFieldLabel(_this.labels[index], k, _this.map));
                    });
                    var inputfields = f.getInputFields();
                    _.each(inputfields, function (field) {
                        field.parent().addClass(errorClassName);
                        if (field.parent().hasClass(successClassName)) {
                            field.parent().removeClass(successClassName);
                        }
                    });
                }
                else if (valid && _this.active) {
                    var inputfields = f.getInputFields();
                    _.each(f.getInputFields(), function (field) {
                        if (field.parent().hasClass(errorClassName)) {
                            field.parent().removeClass(errorClassName);
                        }
                        field.parent().addClass(successClassName);
                    });
                }
            });
            this.$timeout(function () {
                _this.invalid = !allValid;
                _this.errorMessages = _.uniq(errors);
            }, 0);
        };
        ValidationMessage.prototype.alwaysWatch = function () {
            return this.alwaysWatchFields === 'true';
        };
        return ValidationMessage;
    }());
    angular
        .module('TR')
        .directive('validationMessage', function () {
        return {
            require: '^form',
            restrict: 'E',
            replace: true,
            scope: {},
            template: "<div>\n                        <p class=\"sc-c-form-control-prompt sc-c-form-control-prompt--error\"\n                            ng-repeat=\"err in vm.errorMessages\"\n                            ng-show=\"vm.active && vm.invalid\">\n                            {{err}}\n                        </p>\n                    </div>",
            bindToController: {
                fieldNames: '@',
                labelStrings: '@',
                msgMap: '@?',
                rootForm: '=',
                waitFor: '=?',
                alwaysWatchFields: '@?'
            },
            controller: ValidationMessage,
            controllerAs: 'vm',
            link: function (scope, el, attr, formCtrl) {
                //there is an assumption here that the directive is within the same form as the input field
                //we are validating and also that the field name is that same as the name property on the input.
                // Not great, but so the we can keep everything together this might be ok (maybe, sort of)
                //we need our form DOM element so that we can find the inputs
                //get the elements parent forms and the first one should be the one to use
                var formEl = ($(angular.element(el).parents('ng-form')[0])
                    || $(angular.element(el).closest('form.quoteFormNonReg')));
                if (attr.waitFor) {
                    var watch_2 = scope.$watch('vm.waitFor', function (v) {
                        if (v) {
                            scope.vm.init(formCtrl, formEl);
                            watch_2();
                        }
                    });
                }
                else {
                    scope.vm.init(formCtrl, formEl);
                }
            }
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var FormField = /** @class */ (function () {
        function FormField(field) {
            this.Children = [];
            this.Field = FormField.addValidationObjectToField(field);
        }
        FormField.prototype.addChildField = function (field) {
            this.Children.push(FormField.addValidationObjectToField(field));
        };
        FormField.prototype.wasPreviouslyFocused = function () {
            return this.Children.length > 0 ?
                _.every(this.Children, function (f) { return f.ValidationSummary.PreviouslyFocused === true; })
                : this.Field.ValidationSummary.PreviouslyFocused;
        };
        FormField.prototype.isValid = function () {
            return !this.Field.$invalid;
        };
        FormField.prototype.errorMessages = function () {
            return this.isValid() ? {} : this.Field.$error;
        };
        FormField.addValidationObjectToField = function (field) {
            var f = field;
            f.ValidationSummary = {
                PreviouslyFocused: false
            };
            return f;
        };
        return FormField;
    }());
    var ValidationStatus = /** @class */ (function () {
        function ValidationStatus($scope, analytics, broker, validationService) {
            this.$scope = $scope;
            this.analytics = analytics;
            this.broker = broker;
            this.validationService = validationService;
            this.fields = [];
            this.labels = [];
            this.watchers = [];
            this.errorMessages = [];
            for (var _i = 0, _a = this.labelStrings.split('|'); _i < _a.length; _i++) {
                var l = _a[_i];
                this.labels.push(l);
            }
            this.map = this.msgMap == null ? {} : JSON.parse(this.msgMap);
        }
        ValidationStatus.prototype.init = function (form, formElement) {
            var _this = this;
            this.form = form;
            var _loop_2 = function (name_2) {
                var field = this_2.form[name_2];
                if (!field) {
                    throw new Error("There was no field named \"" + name_2 + "\"");
                }
                var formField = new FormField(field);
                //find the input DOM element within our form and attach some handlers
                //use the name property to associate the field and input
                var input = formElement.find("[name='" + name_2 + "']").first();
                if (input.is('select') || input.is('input')) {
                    input
                        .focus(function () { return _this.focusHandler(); })
                        .blur(function (e) { return _this.blurHandler(e); });
                }
                else {
                    //find our actual sub inputs and add track these
                    _.each(input.find('select,input'), function (ele) {
                        var field = _this.form[ele.name];
                        if (field) {
                            formField.addChildField(field);
                        }
                    });
                    input
                        .focusin(function () { return _this.focusHandler(); })
                        .focusout(function (e) { return _this.blurHandler(e); });
                }
                this_2.fields.push(formField);
            };
            var this_2 = this;
            for (var _i = 0, _a = this.fieldNames.split('|'); _i < _a.length; _i++) {
                var name_2 = _a[_i];
                _loop_2(name_2);
            }
            //this is a bit of a hack to solve issues where we have external influences on a field.
            //we should avoid having so many watches
            if (this.alwaysWatch()) {
                _.each(this.fields, function (f, i) {
                    _this.watchers.push(_this.$scope.$watch("vs.fields[" + i + "].isValid()", function (n, o) {
                        if (n !== o) {
                            _this.active = _.every(_this.fields, function (f) { return f.wasPreviouslyFocused() === true; })
                                || _.every(_this.fields, function (f) { return f.isValid() === true; });
                            _this.updateValidationStatus();
                        }
                    }));
                });
            }
            this.$scope.$watch('vs.rootForm.$submitted', function (v) {
                if (v) {
                    _this.active = true;
                    _this.updateValidationStatus();
                }
            });
        };
        ValidationStatus.prototype.blurHandler = function (e) {
            var _this = this;
            if (this.watchers.length && !this.alwaysWatch()) {
                _.each(this.watchers, function (w) { return w(); });
                this.watchers = [];
            }
            //use the elements name to get the field from the form
            var field = this.form[e.target.name];
            field.ValidationSummary.PreviouslyFocused = true;
            this.$scope.$apply(function () {
                _this.active = _.every(_this.fields, function (f) { return f.wasPreviouslyFocused() === true; })
                    || _.every(_this.fields, function (f) { return f.isValid() === true; });
                if (_this.active) {
                    _this.updateValidationStatus();
                }
            });
        };
        ValidationStatus.prototype.focusHandler = function () {
            var _this = this;
            //if all the fields were previously active and we are invalid then watch our fields while we type
            //so that we know when we are valid
            if (_.every(this.fields, function (f) { return f.wasPreviouslyFocused() === true; }) && !this.alwaysWatch()) {
                _.each(this.fields, function (f, i) {
                    _this.watchers.push(_this.$scope.$watch("vs.fields[" + i + "].isValid()", function () {
                        _this.updateValidationStatus();
                    }, true));
                });
            }
        };
        ValidationStatus.prototype.updateValidationStatus = function () {
            var _this = this;
            var errors = [];
            _.transform(this.fields, function (result, f, i) {
                if (!f.isValid()) {
                    _.forOwn(f.errorMessages(), function (v, k) {
                        return result.push(_this.validationService.translateFieldLabel(_this.labels[i], k, _this.map));
                    });
                }
                return result;
            }, errors);
            this.invalid = errors.length > 0;
            this.errorMessages = _.uniq(errors);
            if (errors.length > 0 && this.active) {
                this.analytics.track('mixpanel', 'FormValidationInline', { InlineErrors: this.errorMessages.join(',') });
                this.broker.publish('validationErrors', this.errorMessages);
            }
        };
        ValidationStatus.prototype.alwaysWatch = function () {
            return this.alwaysWatchFields === 'true';
        };
        return ValidationStatus;
    }());
    angular
        .module('TR')
        .directive('validationStatus', function () {
        return {
            require: '^form',
            restrict: 'E',
            replace: true,
            scope: {},
            template: "<div class=\"validation-status-wrapper\">\n                            <div ng-class=\"{'auto-width': vs.cssAutoWidth === 'true'}\">\n                                <i class=\"status\"\n                                   ng-class=\"vs.invalid ? 'icon-close' : 'icon-check'\"\n                                   ng-show=\"vs.active\">\n                                </i>\n                                <div class=\"content\" ng-transclude></div>\n                            </div>\n                            <ul class=\"error-messages\" ng-show=\"vs.active && vs.invalid\">\n                                <li ng-repeat=\"err in vs.errorMessages\">\n                                   {{err}}\n                               </li>\n                            </ul>\n                        </div>",
            transclude: true,
            bindToController: {
                alwaysWatchFields: '@?',
                cssAutoWidth: '@?',
                fieldNames: '@',
                labelStrings: '@',
                msgMap: '@?',
                rootForm: '=',
                waitFor: '=?'
            },
            controller: ValidationStatus,
            controllerAs: 'vs',
            link: function (scope, el, attr, formCtrl) {
                //there is an assumption here that the input field we are validating has a name attribute that is a
                //property on the form with the same value.
                //Not great, but so the we can keep everything together this might be ok (maybe, sort of)
                //we need our form DOM element so that we can find the inputs
                //get the elements parent forms and the first one should be the one to use
                var formEl = angular.element(el).closest('form,ng-form');
                if (attr.waitFor) {
                    var watch_3 = scope.$watch('vs.waitFor', function (v) {
                        if (v) {
                            scope.vs.init(formCtrl, formEl);
                            watch_3();
                        }
                    });
                }
                else {
                    scope.vs.init(formCtrl, formEl);
                }
            }
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    /*
     * Depends:
     *   jquery.ui.core.js
     *   jquery.ui.widget.js
     */
    (function ($) {
        $.widget('trp.modal', {
            options: {
                template: '<div class="modal-overlay">' +
                    '   <div class="lightbox">' +
                    '       <div class="lightbox-inner">' +
                    '           <div class="stage">' +
                    '               <div class="modal-header">' +
                    '                   <span class="modal-title"></span>' +
                    '                   <a href="#" class="close close-btn"></a>' +
                    '               </div>' +
                    '               <div class="modal-content"></div>' +
                    '           </div>' +
                    '       </div>' +
                    '   </div>' +
                    '</div>',
                fadeSpeed: 200,
                easing: 'swing',
                clickOffToClose: false
            },
            _create: function () {
                // element refs
                this.$lightbox = null;
                this.$stage = null;
                this.$loader = null;
                this.isShown = false;
                this._show();
            },
            _show: function () {
                if (this.isShown) {
                    return;
                }
                this.isShown = true;
                this._createLightbox();
            },
            _createLightbox: function () {
                var self = this;
                // create lightbox using template
                this.$lightbox = $(this.options.template)
                    .appendTo(document.body)
                    .fadeIn(this.options.fadeSpeed, this.options.easing, $.proxy());
                // set refs to child elements
                this.$stage = this.$lightbox.find('.stage');
                this.$loader = this.$stage.find('.loader');
                this.$stage.find('a.close-btn')
                    .on('click.modal', $.proxy(function (e) {
                    e.preventDefault();
                    this._trigger('closeClicked', e);
                    this._hide();
                }, this));
                this._getContent(function (content) {
                    self.$loader.hide();
                    // set the content
                    if (content) {
                        self.$stage.find('.modal-content').html(content);
                    }
                });
                // bind for any confirmation buttons
                this.$stage.find('a.ok-btn')
                    .on('click.modal', $.proxy(function (e) {
                    e.preventDefault();
                    this._trigger('okClicked', e);
                    this._hide();
                }, this));
                this.$stage.find('a.cancel-btn')
                    .on('click.modal', $.proxy(function (e) {
                    e.preventDefault();
                    self._trigger('cancelClicked', e);
                    this._hide();
                }, this));
                if (this.options.clickOffToClose) {
                    // hide if user clicks outside the lightbox
                    this.$lightbox.on('click.modal', $.proxy(this._hide, this));
                    this.$stage.on('click.modal', function (e) { e.stopPropagation(); });
                    // support keyboard commands
                    $('html').on('keyup.modal', $.proxy(function (e) {
                        return (e.which === 27 && this._hide()); // escape to close
                    }, this));
                }
                this._trigger('created');
            },
            _getContent: function (callback) {
                if (typeof this.options.content === 'function') {
                    // default behaviour using content function
                    this.options.content.call(this.element[0], function (response) {
                        callback(response);
                    });
                }
                else {
                    // just return content as is
                    callback(this.options.content);
                }
            },
            _hide: function () {
                if (!this.isShown) {
                    return;
                }
                this.isShown = false;
                // fade out the overlay and destroy
                this.$lightbox.fadeOut(200, this.options.easing, $.proxy(function () {
                    this.destroy();
                }, this));
                this._trigger('hidden');
            },
            _destroy: function () {
                this.$lightbox.remove();
                //this.$overlay.remove();
                $('html').off('keyup.modal');
            }
        });
    })(window.jQuery);
})();
(function () {
    'use strict';
    (function ($) {
        var Trppopup = function (element, options) {
            this.init('trppopup', element, options);
        };
        Trppopup.prototype = {
            constructor: Trppopup,
            init: function (type, element, options) {
                // initialise
                this.type = type;
                this.$el = $(element);
                this.options = $.extend({}, $.fn[this.type].defaults, options);
                this.$popup = null; // (created on first "show')
                // listen to appropriate trigger events
                switch (this.options.trigger) {
                    case 'click':
                        // toggle popup on click of target element
                        this.$el.on("click." + this.type, $.proxy(this.toggle, this));
                        break;
                    case 'hover':
                        this.$el.on("mouseenter." + this.type, $.proxy(this.enter, this));
                        this.$el.on("mouseleave." + this.type, $.proxy(this.hide, this));
                        break;
                    case 'focus':
                        // for use with input fields
                        this.$el.on("focus." + this.type, $.proxy(this.enter, this));
                        if (this.options.hideOnBlur) {
                            this.$el.on("blur." + this.type, $.proxy(this.hide, this));
                        }
                        // close on tab out
                        this.$el.on("keydown." + this.type, $.proxy(this.checkKeydown, this));
                        // close on external click
                        $('html').on("mousedown." + this.type, $.proxy(this.checkClick, this));
                        break;
                    case 'blur':
                        this.hide();
                        break;
                    case 'manual':
                        // hide and show must be triggered manually
                        break;
                }
            },
            enter: function () { this.show(true); },
            leave: function () { this.hide(); },
            toggle: function () {
                if (this.open) {
                    this.hide();
                }
                else {
                    this.show(true);
                }
            },
            checkClick: function (e) {
                var $target = $(e.target);
                if (this.$popup && this.open) {
                    // close popup on external click
                    if ($target[0] !== this.$popup && this.$popup.find('*').index($target[0]) === -1) {
                        this.hide();
                    }
                }
                else if (this.$popup && !this.open && $target.index(this.$el) >= 0) {
                    this.show(true);
                }
            },
            checkKeydown: function (e) {
                var key = e.keyCode || e.which;
                // close if user tabs out
                if (key === 9) {
                    this.hide();
                }
            },
            show: function (animate) {
                if (this.open) {
                    return;
                }
                var $popup = this.popup();
                this.setContent();
                // we need to show the panel to get position
                $popup.show().css({ opacity: 0 });
                var options = {};
                switch (this.options.placement) {
                    case 'top':
                        options = {
                            my: 'center bottom',
                            of: this.$el,
                            at: 'center top-10',
                            collision: 'none'
                        };
                        break;
                    case 'bottom':
                        options = {
                            my: 'center top',
                            of: this.$el,
                            at: 'center bottom+10',
                            collision: 'none'
                        };
                        break;
                    case 'left':
                        options = {
                            my: 'right center',
                            of: this.$el,
                            at: 'left-15 center',
                            collision: 'none'
                        };
                        break;
                    case 'right':
                        options = {
                            my: 'left center',
                            of: this.$el,
                            at: 'right+15 center',
                            collision: 'none'
                        };
                        break;
                }
                $popup.position(options);
                if (animate) {
                    $popup.animate({ opacity: 1 }, 150);
                }
                else {
                    $popup.css({ opacity: 1 });
                }
                this.open = true;
            },
            hide: function () {
                if (!this.open) {
                    return;
                }
                var self = this;
                var _popup = this.$popup;
                _popup.animate({ opacity: 0 }, 150, function () {
                    _popup.hide();
                    self.open = false;
                    self.destroy();
                });
            },
            getPosition: function () {
                return $.extend({}, (this.$el.offset()), {
                    width: this.$el[0].offsetWidth,
                    height: this.$el[0].offsetHeight
                });
            },
            setContent: function () {
                var $popup = this.popup();
                var content = this.getContent();
                $popup.find('.content')[this.options.html ? 'html' : 'text'](content);
            },
            getContent: function () {
                // content can be a string or a function
                return typeof this.options.content === 'function' ? this.options.content.call(this.$el[0]) : this.options.content;
            },
            popup: function () {
                // create element if it does not exist
                if (!this.$popup) {
                    this.$popup = $(this.options.popupTemplate)
                        .addClass(this.options.placement);
                    if (this.options.variant) {
                        this.$popup.addClass(this.options.variant);
                    }
                    if (this.options.width) {
                        this.$popup.css('width', this.options.width);
                    }
                    //this.$popup.insertAfter(this.$el);
                    this.$popup.appendTo(document.body);
                }
                return this.$popup;
            },
            destroy: function () {
                //this.hide();
                switch (this.options.trigger) {
                    case 'click':
                        // toggle popup on click of target element
                        this.$el.off("click." + this.type);
                        break;
                    case 'hover':
                        this.$el.off("mouseenter." + this.type);
                        this.$el.off("mouseleave." + this.type);
                        break;
                    case 'focus':
                        // for use with input fields
                        this.$el.off("focus." + this.type);
                        this.$el.off("blur." + this.type);
                        // close on tab out
                        this.$el.off("keydown." + this.type);
                        // close on external click
                        $('html').off("mousedown." + this.type);
                        break;
                }
                this.$el.data('trppopup', null);
                //DK quick fix to stop our logs filling up
                if (this.$popup != null) {
                    this.$popup.remove();
                    this.$popup = null;
                }
            }
        };
        /* trppopup PLUGIN DEFINITION
        * ========================= */
        $.fn.trppopup = function (option) {
            return this.each(function () {
                var $this = $(this);
                var options = typeof option === 'object' && option;
                var data = $this.data('trppopup');
                if (!data) {
                    $this.data('trppopup', (data = new Trppopup(this, options)));
                }
                if (typeof option === 'string') {
                    data[option]();
                }
            });
        };
        $.fn.trppopup.Constructor = Trppopup;
        $.fn.trppopup.defaults = {
            trigger: 'focus',
            placement: 'bottom',
            popupTemplate: '<div class="popup"><div class="arrow"></div><div class="content"></div></div>',
            variant: '',
            content: '',
            html: true,
            width: null,
            hideOnBlur: false
        };
    })(jQuery);
})();
(function () {
    'use strict';
    angular.module('TR')
        .service('breadcrumbDetailsService', breadcrumbDetailsService);
    function breadcrumbDetailsService(resourceService, tripService, $routeParams, basketService) {
        var service = {
            getClasses: getClasses,
            getText: getText,
            getCrumbs: getCrumbs,
            getTextShort: getTextShort
        };
        function getClasses(bc) {
            return function (c) {
                var currentCrumb = basketService.isFlightPreselected() && bc.crumb === 10 ? 25 : bc.crumb;
                return c < currentCrumb ? 'done' : c === currentCrumb ? 'is-active' : '';
            };
        }
        function getText() {
            return {
                0: resourceService.getDeferred('BREADCRUMBHOME'),
                5: resourceService.getDeferred('BREADCRUMBDEAL'),
                10: resourceService.getDeferred('BREADCRUMBFLIGHT'),
                20: resourceService.getDeferred('BREADCRUMBHOTEL'),
                21: resourceService.getDeferred('BREADCRUMBROOM'),
                25: resourceService.getDeferred('BREADCRUMBCHANGEFLIGHT'),
                30: resourceService.getDeferred('BREADCRUMBTRANSFER'),
                35: resourceService.getDeferred('BREADCRUMBPARKING'),
                40: resourceService.getDeferred('BREADCRUMBEXTRAS'),
                50: resourceService.getDeferred('BREADCRUMBPAYMENT')
            };
        }
        function getTextShort() {
            return {
                0: resourceService.getDeferred('BREADCRUMBHOMESHORT'),
                20: resourceService.getDeferred('BREADCRUMBHOTELSHORT'),
                21: resourceService.getDeferred('BREADCRUMBROOMSHORT'),
                25: resourceService.getDeferred('BREADCRUMBCHANGEFLIGHTSHORT'),
                40: resourceService.getDeferred('BREADCRUMBEXTRASSHORT'),
                50: resourceService.getDeferred('BREADCRUMBPAYMENTSHORT')
            };
        }
        function getCrumbs() {
            return tripService.getTrip($routeParams.tripId).then(function (trip) {
                if (trip && trip.Deal) {
                    return [5, 21, 50];
                }
                if ((basketService.isFlightPreselected() && trip.TripType === tripService.tripTypes.Holiday) ||
                    TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                    return [0, 20, 21, 25, 40, 50];
                }
                switch (trip.TripType) {
                    case 1://flight
                        return [0, 10, 40, 50];
                    case 2://hotel
                        return [0, 20, 21, 50];
                    case 3://transfer
                        return [0, 30, 50];
                    case 4://holiday
                        return [0, 10, 20, 21, 40, 50];
                    case 5:// marhaba
                        return []; // ?
                    case 6:// parking
                        return [0, 35, 50];
                    default:
                        return [];
                }
            });
        }
        return service;
    }
})();
/**
 * Created by bdickson on 04/12/2015.
 */
var TR;
(function (TR) {
    var TrustpilotService = /** @class */ (function () {
        function TrustpilotService($http, loggingService) {
            this.$http = $http;
            this.loggingService = loggingService;
            this.apiRootUrl = 'https://api.trustpilot.com/v1/business-units/' + TRPCONFIG.Domain.TrustPilotId;
            this.apiKey = TRPCONFIG.Domain.TrustPilotAPIKey;
        }
        TrustpilotService.prototype.getJsonp = function (url) {
            var _this = this;
            url += (url.indexOf('?') === -1) ? '?' : '&';
            url += 'apikey=' + this.apiKey;
            return this.$http.jsonp(url + '&callback=JSON_CALLBACK', { ignoreErrors: true, cache: true })
                .then(function (res) {
                if (res && angular.isObject(res.data)) {
                    return res.data;
                }
                return {};
            }, function (err) {
                _this.loggingService
                    .logWarn("Trustpilot api call failed with following response " + JSON.stringify(err));
                return {
                    reviews: []
                };
            });
        };
        TrustpilotService.prototype.getBusinessUnit = function () {
            return this.getJsonp(this.apiRootUrl);
        };
        return TrustpilotService;
    }());
    TR.TrustpilotService = TrustpilotService;
    angular.module('TR').service('TrustpilotService', TrustpilotService);
})(TR || (TR = {}));
var Attractions;
(function (Attractions_1) {
    var Attractions = /** @class */ (function () {
        function Attractions($routeParams, $scope, attractionDetailsService, basketService, basketStore, dateUtil, tripService, broker) {
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.attractionDetailsService = attractionDetailsService;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.dateUtil = dateUtil;
            this.tripService = tripService;
            this.broker = broker;
            this.attractions = {
                selected: [],
                occupancy: {}
            };
            this.attractionsAvailabilityBusy = true;
            var at = this;
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                var basketId = trip.BasketId, tripId = trip.TripId, attractionSearchId = trip.AttractionRequest ? trip.AttractionRequest.AvailabilitySearchId : null;
                at.destination = trip.HotelsRequest && trip.HotelsRequest.Destination ?
                    trip.HotelsRequest.Destination['Title'] : '';
                basketStore.attraction(basketId).then(function (results) {
                    var occupancyMap = {}, 
                    // Extras attractions format is one product entry with nested data for multiples
                    products = results && results[0];
                    if (products) {
                        at.attractions = {
                            selected: angular.copy(products.Details.AttractionIds),
                            occupancy: angular.copy(products.Details.AttractionRequests)
                        };
                    }
                    if (TRPCONFIG.Domain.AttractionsExtraEnabled || TRPCONFIG.Domain.AttractionsExtraMobileEnabled) {
                        basketStore.flight(basketId).then(function (flight) {
                            var flightDate = _.get(flight, 'Details.Itinerary.DepartureDate');
                            var dateDiff = dateUtil.dayDiff(flightDate, new Date());
                            if (dateDiff >= TRPCONFIG.MinDaysBeforeDeparture || at.isHotelJourney) {
                                basketService.getAttractionQuotes(attractionSearchId, basketId, tripId)
                                    .then(function (attractionQuotes) {
                                    at.attractionQuotes = attractionQuotes;
                                    at.cheapestAttraction = attractionQuotes[0];
                                    at.attractionsAvailabilityBusy = false;
                                    at.cheapestAttraction = getCheapest(at.attractionQuotes);
                                    function getCheapest(quotes) {
                                        var hasAdult = _.filter(quotes, function (a) {
                                            return a.Prices[0].Price > 0;
                                        });
                                        return _.minBy(hasAdult, function (a) {
                                            return a.Prices[0].Price;
                                        });
                                    }
                                    _updateSubtitle();
                                    var stopAttractionWatch = $scope.$watch('at.attractions', _attractionsWatch, true);
                                    angular.forEach(attractionQuotes, function (a) {
                                        occupancyMap[a.AttractionId] = at.attractions.occupancy[a.AttractionId] || {
                                            Adult: a.Prices[0].Count,
                                            Child: a.Prices[1].Count,
                                            Infant: a.Prices[2].Count
                                        };
                                    });
                                    // angular copy throwing digest loops in ie9, ie10
                                    at.attractions.occupancy = $.extend(true, {}, occupancyMap);
                                    function _attractionsWatch(val, oldval) {
                                        if (val == null || angular.equals(val, oldval) || !val.selected) {
                                            return;
                                        }
                                        if (val.selected.length > 0 && _validateAttractionOccupancy(val, oldval)) {
                                            tripService.getTrip(tripId).then(function (t) {
                                                attractionSearchId = t.AttractionRequest.AvailabilitySearchId;
                                                basketStore.putAttractionExtras(attractionSearchId, val, basketId)
                                                    .then(function () { return basketService.updateBasket(); })
                                                    .then(function () { return basketStore.attractionCost(basketId); })
                                                    .then(function (cost) {
                                                    at.attractionsTotal = cost;
                                                    _updateSubtitle();
                                                });
                                            });
                                        }
                                        else {
                                            basketStore.removeAttraction(basketId).then(basketService.updateBasket);
                                            at.attractionsTotal = 0;
                                            _updateSubtitle();
                                        }
                                    }
                                    function _validateAttractionOccupancy(val, oldval) {
                                        var selectedOriginal = angular.copy(val);
                                        var valid = false;
                                        var occupacyChange = false;
                                        angular.forEach(selectedOriginal.selected, function (attractionId, index) {
                                            var attrOcc = val.occupancy[attractionId];
                                            occupacyChange = _.some(attrOcc, function (occ, type) { return type !== 'Infant' && occ; });
                                            if (occupacyChange) {
                                                valid = true;
                                            }
                                            else {
                                                if (val.selected.length <= oldval.selected.length) {
                                                    val.selected.splice(index, 1);
                                                }
                                                stopAttractionWatch();
                                                var attrOccu = occupancyMap[attractionId];
                                                val.occupancy[attractionId] = angular.copy(attrOccu);
                                                stopAttractionWatch = $scope.$watch('at.attractions', _attractionsWatch, true);
                                            }
                                        });
                                        return valid;
                                    }
                                });
                                basketStore.attractionCost(basketId).then(function (cost) {
                                    at.attractionsTotal = cost;
                                });
                            }
                            else {
                                at.attractionsAvailabilityBusy = false;
                            }
                        });
                    }
                }).then(null, basketService.restartHolidayWorkflow);
                function _updateSubtitle() {
                    var subTitle = '';
                    if (at.attractionQuotes && at.attractions.selected.length) {
                        angular.forEach(at.attractions.selected, function (id) {
                            var quote = _.find(at.attractionQuotes, function (a) { return id === a.AttractionId; });
                            if (quote) {
                                subTitle += quote.ShortTitle + '<br>';
                            }
                        });
                    }
                    at.attractionsDescription = subTitle;
                }
            }, basketService.bookingAlreadyDone("attractions: '" + $routeParams.tripId + "'"));
            at.getImageUrl = attractionDetailsService.getImageUrl;
            at.toggleResults = function (e) {
                e.preventDefault();
                at.showResults = !at.showResults;
                at.state.showInformation = false;
            };
            at.state = {
                showInformation: false,
                informationRequested: false,
                informationLoaded: false
            };
            at.viewInformation = function (e, id) {
                e.preventDefault();
                at.informationPath = 'partials/holidays/attractionmoreinformation/' + id;
                at.state.showInformation = true;
                broker.publish('attractionsInformationRequested');
            };
            at.viewWhatsIncluded = function (e, id) {
                e.preventDefault();
                at.informationPath = "partials/holidays/attractionwhatsincluded/" + id;
                at.state.showInformation = true;
                broker.publish('attractionsInformationRequested');
            };
            at.$scope.$on('$includeContentRequested', function (args) {
                at.state.informationRequested = true;
                at.state.informationLoaded = false;
            });
            at.$scope.$on('$includeContentLoaded', function (args) {
                at.state.informationLoaded = true;
            });
            at.viewResults = function (e) {
                e.preventDefault();
                at.state.showInformation = false;
            };
        }
        return Attractions;
    }());
    angular
        .module('attractions')
        .controller('Attractions', Attractions);
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    var BasketItem = /** @class */ (function () {
        function BasketItem(responseData, attractionService) {
            this.attractionService = attractionService;
            // UI
            this.Changes = {};
            this.Totals = {};
            this.Validity = {};
            angular.extend(this, responseData);
            this.orderTickets();
            this.updateTotals();
            this.setDates();
        }
        BasketItem.prototype.onChange = function (changes) {
            angular.extend(this.Changes, changes);
            this.updateTotals();
        };
        BasketItem.prototype.orderTickets = function () {
            var order = {};
            this.Tickets.forEach(function (o) {
                var key = o.Key;
                order[key] = /adult/.test(key) ? 0 :
                    /:child/.test(key) ? 1 : 2; // i.e. not ':youngchild'
            });
            this.Tickets.sort(function (a, b) {
                return order[a.Key] < order[b.Key] ? -1 :
                    order[a.Key] > order[b.Key] ? 1 : 0;
            });
        };
        BasketItem.prototype.flushChanges = function () {
            var changes = this.Changes;
            this.Changes = {};
            return changes;
        };
        BasketItem.prototype.updateTotals = function () {
            var _this = this;
            this.Totals = { total: 0 };
            this.Tickets.forEach(function (o) {
                var amount = Number(o.Value || 0) * Number(o.Price || 0);
                _this.Totals[o.Key] = amount;
                _this.Totals.total += amount;
            });
        };
        BasketItem.prototype.setDates = function () {
            var dates = this.attractionService.getLineItemDates(this);
            this.SelectedDate = dates.selected;
            this.Validity = dates.from && dates.to
                ? { from: dates.from, to: dates.to } : null;
        };
        return BasketItem;
    }());
    var AttractionsBasket = /** @class */ (function () {
        function AttractionsBasket($scope, $timeout, $routeParams, $location, $http, attractionService, basketService, basketStore, broker, attractionDetailsService) {
            var _this = this;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.$location = $location;
            this.$http = $http;
            this.attractionService = attractionService;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.broker = broker;
            this.attractionDetailsService = attractionDetailsService;
            this.items = [];
            this.totalPrice = 0;
            this.initialising = true;
            this.loading = false;
            this.error = false;
            this.debouncedUpdate = _.debounce(function (p) { return _this.update(p); }, 400);
            basketStore.getAttractionsBasket()
                .then(function (basket) {
                _this.basketId = basket.BasketId;
                _this.setBasketItems(basket.LineItems);
                _this.initialising = false;
            });
        }
        AttractionsBasket.prototype.setBasketItems = function (lineItems) {
            var _this = this;
            if (lineItems === void 0) { lineItems = []; }
            this.items = [];
            if (lineItems.length) {
                lineItems.forEach(function (lineItem) {
                    var item = new BasketItem(lineItem, _this.attractionService);
                    item.Tickets.forEach(function (ticket) {
                        _this.$scope.$watch(function () { return ticket.Value; }, function (v, oldV) {
                            if (v != null && v !== oldV && !_this.error) {
                                item.onChange((_a = {},
                                    _a[ticket.Key] = v,
                                    _a));
                                _this.updateTotalPrice();
                                _this.debouncedUpdate(item);
                            }
                            var _a;
                        });
                    });
                    _this.items.push(item);
                });
            }
            this.updateTotalPrice();
            this.broker.publish('attractionsBasketUpdated');
        };
        AttractionsBasket.prototype.update = function (item) {
            var _this = this;
            // Do nothing if no tickets remain selected
            if (this.totalPrice) {
                this.loading = true;
                this.basketStore.updateAttraction(item.LineItemId, item.flushChanges(), this.basketId).then(function (res) {
                    if (res.error) {
                        _this.error = true;
                        return;
                    }
                    _this.error = false;
                    _this.loading = false;
                    var basket = res.Basket;
                    _this.setBasketItems(basket && basket.LineItems);
                });
            }
        };
        AttractionsBasket.prototype.remove = function (item) {
            var _this = this;
            this.basketStore.removeAttractionsLineItem(item.LineItemId, this.basketId).then(function (res) {
                if (res.error) {
                    _this.error = true;
                    return;
                }
                _this.error = false;
                var basket = res.Basket;
                _this.setBasketItems(basket && basket.LineItems);
            });
        };
        AttractionsBasket.prototype.updateTotalPrice = function () {
            this.totalPrice = this.items.reduce(function (prev, item) { return prev + item.Totals.total; }, 0);
        };
        AttractionsBasket.prototype.book = function () {
            if (this.totalPrice && !this.error) {
                this.loading = true;
                this.basketService.bookAttractionsBasket();
            }
        };
        return AttractionsBasket;
    }());
    angular
        .module('attractions')
        .controller('AttractionsBasket', AttractionsBasket);
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    var AttractionsBasketModal = /** @class */ (function () {
        function AttractionsBasketModal($location, $scope, modalService, broker) {
            var _this = this;
            this.$location = $location;
            this.$scope = $scope;
            this.modalService = modalService;
            this.broker = broker;
            broker.subscribe('AttractionsBasketModal', 'modal:ready', function () {
                _this.total = modalService.get('total');
                _this.lineItems = modalService.get('lineItems');
            });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('AttractionsBasketModal');
            });
        }
        AttractionsBasketModal.prototype.continueShopping = function () {
            this.modalService.close();
        };
        AttractionsBasketModal.prototype.viewBasket = function () {
            this.$location.path('attractions/basket');
        };
        return AttractionsBasketModal;
    }());
    angular
        .module('attractions')
        .controller('AttractionsBasketModal', AttractionsBasketModal);
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    var AttractionsHeaderPanel = /** @class */ (function () {
        function AttractionsHeaderPanel($location, $scope, productService, broker) {
            var _this = this;
            this.$location = $location;
            this.$scope = $scope;
            this.productService = productService;
            this.broker = broker;
            // Attributes
            this.product = this.product();
            this.debouncedUpdateTeaserPrice = _.debounce(function (p) { return _this.updateTeaserPrice(p); }, 100);
            if (!this.chooseAgainUrl) {
                this.chooseAgainUrl = 'attractions';
            }
            var qsTags = $location.search();
            if (qsTags) {
                angular.extend(this.product, { Tags: qsTags });
            }
            broker.subscribe('attractionsHeaderPanel', 'attractionsProductUpdate', function (res) { return _this.debouncedUpdateTeaserPrice({ Tags: res.data }); });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('attractionsHeaderPanel');
            });
        }
        AttractionsHeaderPanel.prototype.updateTeaserPrice = function (productData) {
            var _this = this;
            if (this.product) {
                var date = _.get(productData, 'Tags.date', null);
                var product = angular.extend({
                    DomainId: TRPCONFIG.Domain.DomainId,
                    Currency: TRPCONFIG.Domain.CurrencyCode
                }, this.product, date === null ? { Tags: _.omit(productData.Tags, ('date')) } : productData);
                this.productService.getTeaserPrices('attraction', [product])
                    .then(function (res) {
                    var resKey = Object.keys(res)[0];
                    if (resKey) {
                        var first = res[resKey];
                        var adultPrice = _.find(first.Prices, { Type: 'Adult' });
                        var price = adultPrice || (Array.isArray(first.Prices) && first.Prices.length
                            ? first.Prices[0] : null);
                        _this.teaserPrice = price && price.Price;
                    }
                });
            }
        };
        return AttractionsHeaderPanel;
    }());
    angular
        .module('attractions')
        .directive('attractionsHeaderPanel', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {},
            bindToController: {
                product: '&',
                productId: '@',
                chooseAgainUrl: '@',
                panelTitle: '@'
            },
            controller: AttractionsHeaderPanel,
            controllerAs: 'hp',
            templateUrl: 'partials/attractions/headerpanel'
        };
    });
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    var AttractionsProductForm = /** @class */ (function () {
        function AttractionsProductForm($scope, $timeout, $routeParams, $location, attractionService, attractionSearchValidator, dateUtil, basketService, broker, modalService, Area, resourceService, cmsUtils) {
            var _this = this;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.$location = $location;
            this.attractionService = attractionService;
            this.attractionSearchValidator = attractionSearchValidator;
            this.dateUtil = dateUtil;
            this.basketService = basketService;
            this.broker = broker;
            this.modalService = modalService;
            this.Area = Area;
            this.resourceService = resourceService;
            this.cmsUtils = cmsUtils;
            this.stepsData = [];
            this.priceData = {};
            this.formModel = {};
            this.dateLimits = {};
            this.initialised = false;
            this.loading = false;
            this.infoModal = {};
            this.infoText = {};
            this.normalisedValues = {};
            var bookingWindow = TRPCONFIG.Domain2.AttractionsMinimumBookingWindow;
            var $injector = angular.element(document).injector();
            this.areaInfo = Area['attractions'];
            this.fetchCriteria();
            this.dateLimits = {
                startDateMin: this.dateUtil.todayPlus(0, 0, true),
                activeDateFrom: this.dateUtil.todayPlus(bookingWindow, 0, true),
            };
            this.throttledUpdateTotalPrice = _.throttle(function () { return _this.updateTotalPrice(); }, 100);
            this.throttledUpdatePrices = _.throttle(function () { return _this.updatePrices(); }, 100);
            broker.subscribe('attractionsProductForm', 'tabProductOptionSelected', function (e) {
                return _.forEach(e.data || {}, function (v, k) {
                    return _this.changeField(k, v);
                });
            });
            // Show spinner if delayed
            this.initTimer = $timeout(function () { return (_this.loading = true); }, 1000);
            $scope.$on('$destroy', function () {
                broker.unsubscribe('attractionsProductForm');
            });
        }
        AttractionsProductForm.prototype.fetchCriteria = function () {
            var _this = this;
            this.attractionService
                .getProductFormCriteria(this.productId)
                .then(function (res) {
                var qsTags = _this.$location.search();
                if (qsTags) {
                    angular.extend(_this.formModel, qsTags);
                }
                _this.$timeout.cancel(_this.initTimer);
                _this.initialised = true;
                _this.loading = false;
                _this.stepsData = res.Steps;
                if (Array.isArray(_this.stepsData)) {
                    _this.stepsData.forEach(function (item) {
                        _this.mapNormalisedValues(item);
                        item.Fields.forEach(function (field) {
                            if (field.Type.toLowerCase() === 'group') {
                                _this.formModel[field.Key] = 1;
                            }
                        });
                        if (item.Info) {
                            _this.infoModal[item.Info.ResourceKey] = false;
                            _this.infoText[item.Info.ResourceKey] = {
                                header: _this.resourceService.get(item.Info.ResourceKey + ':HEADER'),
                                body: _this.resourceService.get(item.Info.ResourceKey),
                            };
                        }
                    });
                }
            });
        };
        AttractionsProductForm.prototype.setPriceData = function (key, price) {
            this.priceData[key] = {
                price: price,
            };
        };
        AttractionsProductForm.prototype.initField = function (fieldKey, value, allowUnknown) {
            // Set initial value, unless already populated
            if (this.formModel[fieldKey] == null) {
                this.changeField(fieldKey, value, allowUnknown);
            }
        };
        AttractionsProductForm.prototype.changeField = function (fieldKey, value, allowUnknown) {
            // NOTE: only allows existing option values unless `allowUnknown` is true
            var isUpdate;
            if (allowUnknown) {
                this.formModel[fieldKey] = value;
                isUpdate = true;
            }
            else {
                var existingVal = this.getMatchedValue(value);
                if (existingVal != null) {
                    this.formModel[fieldKey] = existingVal;
                    isUpdate = true;
                }
            }
            if (isUpdate) {
                this.publishUpdate();
                this.throttledUpdateTotalPrice();
            }
        };
        AttractionsProductForm.prototype.fieldChangeHandler = function (affectsPrices) {
            if (affectsPrices === void 0) { affectsPrices = false; }
            this.changeField('date', null, true);
            this.publishUpdate();
            if (affectsPrices) {
                this.throttledUpdatePrices();
            }
            else {
                this.throttledUpdateTotalPrice();
            }
        };
        AttractionsProductForm.prototype.publishUpdate = function () {
            this.broker.publish('attractionsProductUpdate', this.formModel);
        };
        AttractionsProductForm.prototype.mapNormalisedValues = function (step) {
            var _this = this;
            // Map existing field values for normalised comparison with CMS values
            var map = {};
            var fields = step.Fields || [];
            fields.forEach(function (field) {
                if (field.Data) {
                    field.Data.forEach(function (op) {
                        map[_this.cmsUtils.normaliseValue(op.Value)] = op.Value;
                    });
                }
            });
            angular.extend(this.normalisedValues, map);
        };
        AttractionsProductForm.prototype.getMatchedValue = function (value) {
            return this.normalisedValues[this.cmsUtils.normaliseValue(value)];
        };
        AttractionsProductForm.prototype.isDateMatch = function (d1, d2) {
            if (d1 === void 0) { d1 = ''; }
            if (d2 === void 0) { d2 = ''; }
            // Dates may or may not end with '.000Z'
            return d1.split('.')[0] === d2.split('.')[0];
        };
        AttractionsProductForm.prototype.updatePrices = function () {
            var _this = this;
            if (this.formModel.date) {
                this.loading = true;
                this.attractionService
                    .getAvailability(this.productId, angular.extend({}, this.formModel))
                    .then(function (res) {
                    if (res.error) {
                        _this.totalPrice = 0;
                    }
                    else {
                        _this.loading = false;
                        res.Dates.forEach(function (o) {
                            if (_this.isDateMatch(o.Date, _this.formModel.date)) {
                                o.Tickets.forEach(function (d) {
                                    _this.setPriceData(d.Key, d.Price);
                                });
                            }
                        });
                        _this.throttledUpdateTotalPrice();
                    }
                });
            }
        };
        AttractionsProductForm.prototype.updateTotalPrice = function () {
            var _this = this;
            var total = 0;
            _.each(this.formModel, function (v, k) {
                var priceData = _this.priceData[k], price = priceData && priceData.price;
                if (price) {
                    total += price * v;
                }
            });
            this.$scope.$evalAsync(function () {
                _this.totalPrice = total;
            });
        };
        AttractionsProductForm.prototype.book = function () {
            var _this = this;
            var errors = this.attractionSearchValidator.validate(this.formModel);
            if (errors.length) {
                this.$scope.$emit('flash:error', errors);
            }
            else {
                this.loading = true;
                this.$scope.$emit('flash:hide');
                this.basketService
                    .startWorkflow(this.areaInfo.flow, {
                    productId: this.productId,
                    productTags: this.formModel,
                })
                    .then(function (lineItems) {
                    _this.loading = false;
                    _this.modalService.launch('partials/attractions/BasketModal', {
                        lineItems: lineItems,
                        total: _this.attractionService.getProductTotals(lineItems).price,
                    });
                });
            }
        };
        return AttractionsProductForm;
    }());
    angular
        .module('attractions')
        .directive('attractionsProductForm', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            bindToController: {
                productId: '@',
            },
            controller: AttractionsProductForm,
            controllerAs: 'pf',
            templateUrl: 'partials/attractions/productform',
        };
    });
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    var KEY_ENTER = 13;
    var AttractionsSearch = /** @class */ (function (_super) {
        __extends(AttractionsSearch, _super);
        function AttractionsSearch($scope, $element, $parse, $route, autocompleter, resourceService, attractionService, $location, $q) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$element = $element;
            _this.$parse = $parse;
            _this.$route = $route;
            _this.autocompleter = autocompleter;
            _this.resourceService = resourceService;
            _this.attractionService = attractionService;
            _this.$location = $location;
            _this.$q = $q;
            _this.areaOverride = 'attractions';
            // Watch for initial value
            var unwatchInit = _this.$scope.$watch('ac.currentValue', function (item) {
                if (item && item.Title) {
                    _this.prefix = item.Title;
                    unwatchInit();
                }
            });
            // Wrap `select` attribute fn
            _this.selectAttrFn = _this.select;
            _this.select = function (item) {
                _this.selectAttrFn({ item: item });
                _this.selectItem(item);
            };
            $scope.$on('fieldOptionSelected', function (e, data) {
                _this.selectedData = data;
            });
            return _this;
        }
        AttractionsSearch.prototype.search = function () {
            if (this.selectedData) {
                this.attractionService.trackAttractionSearch(this.searchId, this.selectedData.Id, this.selectedData.Title);
                this.selectedData.Route ? this.$location.url(this.selectedData.Route) : this.showError(null);
            }
            else {
                if (this.inputField && this.inputField.val().length) {
                    this.automaticSearch();
                }
                else {
                    this.showError(null);
                }
            }
        };
        AttractionsSearch.prototype.automaticSearch = function () {
            var _this = this;
            if (this.selectedData) {
                this.search();
            }
            else {
                this.fetch().then(function (res) {
                    _this.update(res);
                    if (_this.data) {
                        _this.selectedData = _this.data[0];
                        _this.search();
                    }
                    else {
                        _this.showError(null);
                    }
                });
            }
        };
        AttractionsSearch.prototype.update = function (result) {
            var options = result.data.Results;
            if (this.selectedData) {
                /// On update reset previously selected data.
                this.selectedData = null;
            }
            if (options.length) {
                this.searchId = result.data.SearchId;
                this.data = options.map(function (item) {
                    return {
                        Title: item.Name,
                        Id: item.Id,
                        Value: item.Value,
                        Route: item.Route
                    };
                });
            }
            else {
                this.data = null;
                //this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        };
        AttractionsSearch.prototype.selectItem = function (item) {
            if (item && item.Title) {
                this.prefix = item.Title;
            }
        };
        AttractionsSearch.prototype.showError = function (e) {
            this.$scope.$emit('flash:error', this.resourceService.get('NOATTRACTIONURL'));
        };
        return AttractionsSearch;
    }(Autocompleter.AutocompleterField));
    angular
        .module('TR')
        .directive('attractionsSearch', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'ac',
            bindToController: {
                placeholder: '@',
                select: '&',
                deselect: '&',
                currentValue: '=',
                areaOverride: '@',
                focusTracker: '=',
                minPrefix: '@',
                notActive: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=AttractionsAutocompleter',
            controller: AttractionsSearch,
            transclude: true,
            compile: function (el, attrs, transclude) {
                return function ($scope) {
                    transclude($scope, function (clone) {
                        el.append(clone);
                        $scope.ac.inputField = el.find('input');
                        $scope.ac.inputField.on('keyup', function (e) {
                            if (KEY_ENTER === e.keyCode && $scope.ac.inputField.val().length > 2) {
                                $scope.ac.automaticSearch();
                            }
                            else {
                                $scope.ac.selectedData = null;
                            }
                        });
                    });
                };
            }
        };
    });
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    var ShowBeforeOrAfter;
    (function (ShowBeforeOrAfter) {
        ShowBeforeOrAfter[ShowBeforeOrAfter["Both"] = 0] = "Both";
        ShowBeforeOrAfter[ShowBeforeOrAfter["Before"] = 1] = "Before";
        ShowBeforeOrAfter[ShowBeforeOrAfter["After"] = 2] = "After";
    })(ShowBeforeOrAfter || (ShowBeforeOrAfter = {}));
    ;
    ;
    var ThemeParkCombo = /** @class */ (function () {
        function ThemeParkCombo() {
            this.showMobileFilters = false;
            this.pricesSorted = false;
            this.afterDateVal = '2017-05-01T00:00:00.000Z';
            this.afterDate = false; // Value of the toggle filter
            this.isAfterDate = false; // True if today is actually after the afterDateVal
            this.hasItems = true;
            this.isAfterDate = this.checkIsAfterDate();
            this.comboFilters = [
                { id: 1,
                    img: 'disney_logos/WDW-blk.jpg',
                    title: 'Walt Disney World Resort',
                    included: [
                        { img: 'disney_logos/Disneys_Magic_Kingdom.jpg',
                            title: 'Magic Kingdom',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'disney_logos/Disneys_Animal_Kingdom.jpg',
                            title: 'Animal Kingdom',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'disney_logos/Disneys_Epcot.jpg',
                            title: 'Epcot',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'disney_logos/Disneys_Blizzard_Beach.jpg',
                            title: 'Blizzard Beach Water Park',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'disney_logos/Disneys_Hollywood_Studios.jpg',
                            title: 'Disney\'s Hollywood Studios',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'disney_logos/Disneys_Typhoon_Lagoon.jpg',
                            title: 'Typhoon Lagoon Water Park',
                            available: ShowBeforeOrAfter.Both
                        }
                    ]
                },
                { id: 2,
                    img: 'seaworld_logos/SeaWorld-All.jpg',
                    title: 'SeaWorld Parks',
                    included: [
                        { img: 'seaworld_logos/SeaWorld.jpg',
                            title: 'SeaWorld',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'seaworld_logos/Busch_Gardens.jpg',
                            title: 'Busch Gardens',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'seaworld_logos/Aquatica.jpg',
                            title: 'Aquatica',
                            available: ShowBeforeOrAfter.Both
                        }
                    ]
                },
                { id: 3,
                    img: 'universal_logos/Universal_Studios.png',
                    title: 'Universal Orlando Resort&trade;',
                    included: [
                        { img: 'universal_logos/universal-studios-florida.png',
                            title: 'Universal Studios Florida&trade;',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'universal_logos/Universal_Island_of_Adventure.jpg',
                            title: 'Universal\'s Islands Of Adventure&trade;',
                            available: ShowBeforeOrAfter.Both
                        },
                        { img: 'universal_logos/Universal_Volcano_Bay.jpg',
                            title: 'Universal\'s Volcano Bay&trade;',
                            available: ShowBeforeOrAfter.After
                        }
                    ]
                },
                { id: 4,
                    img: 'legoland/Legoland.jpg',
                    title: 'LEGOLAND Florida Resort',
                    included: []
                },
                { id: 5,
                    img: 'kennedy-space-center/kennedy-space-center.jpg',
                    title: 'Kennedy Space Center',
                    included: []
                }
            ];
        }
        ThemeParkCombo.prototype.getItems = function () {
            var _this = this;
            if (!this.pricesSorted) {
                this.pricesSorted = true;
                this.comboItems.map(function (item) {
                    return item.Prices = item.Prices.sort(function (a, b) {
                        return a.Type.toLowerCase() === 'adult' ? -1 : 1;
                    });
                });
            }
            var selectedParkIds = _.map(this.checkedFilters, function (val, key) {
                return val ? parseInt(key, 10) : 0;
            }).filter(function (val) { return val > 0; });
            var beforeOrAfterItems = this.comboItems.filter(function (item) {
                return (item.ShowBeforeOrAfter === ShowBeforeOrAfter.Both)
                    || (item.ShowBeforeOrAfter === ShowBeforeOrAfter.Before && !_this.afterDate)
                    || (item.ShowBeforeOrAfter === ShowBeforeOrAfter.After && _this.afterDate);
            });
            var filteredItems = !selectedParkIds.length ? beforeOrAfterItems :
                beforeOrAfterItems.filter(function (item) {
                    var filterId = item.ParksIncluded
                        .reduce(function (res, val) { return res | Math.pow(2, val - 1); }, 0);
                    return selectedParkIds
                        .map(function (parkId) { return Math.pow(2, parkId - 1) & filterId; })
                        .every(function (parkFilterId) { return parkFilterId > 0; });
                });
            this.hasItems = filteredItems.length > 0;
            return filteredItems;
        };
        ThemeParkCombo.prototype.getFilters = function (limit) {
            return (typeof limit === 'number' && limit > 0) ? this.comboFilters.slice(0, limit) : this.comboFilters;
        };
        ThemeParkCombo.prototype.getFilter = function (num) {
            return this.comboFilters[num - 1];
        };
        ThemeParkCombo.prototype.hasFiltersSelected = function () {
            return _.map(this.checkedFilters, function (val, key) { return val; }).some(function (val) { return val; });
        };
        ThemeParkCombo.prototype.getSelectedFilters = function () {
            var _this = this;
            return this.comboFilters.filter(function (filter) { return _this.checkedFilters[filter.id]; });
        };
        ThemeParkCombo.prototype.hasIncludedParksToDisplay = function (included) {
            var _this = this;
            return included.map(function (i) { return _this.showIncludedPark(i); }).some(function (t) { return t; });
        };
        ThemeParkCombo.prototype.showIncludedPark = function (item) {
            return item.available === ShowBeforeOrAfter.Both
                || (item.available === ShowBeforeOrAfter.Before && !(this.afterDate || this.isAfterDate))
                || (item.available === ShowBeforeOrAfter.After && (this.afterDate || this.isAfterDate));
        };
        ThemeParkCombo.prototype.includesPark = function (parkId, comboItem) {
            return comboItem.ParksIncluded.indexOf(parkId) > -1;
        };
        ThemeParkCombo.prototype.includesParkClass = function (parkId, comboItem) {
            return this.includesPark(parkId, comboItem) ? 'icon-check' : 'icon-close';
        };
        ThemeParkCombo.prototype.checkIsAfterDate = function () {
            return (new Date()) > (new Date(this.afterDateVal));
        };
        return ThemeParkCombo;
    }());
    angular
        .module('TR')
        .directive('themeParkCombo', function () {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {},
            bindToController: {
                comboItems: '='
            },
            controller: ThemeParkCombo,
            controllerAs: 'tpc',
            compile: function (el, attrs, transclude) {
                return function ($scope) { return transclude($scope, function (clone) { return el.append(clone); }); };
            }
        };
    });
})(Attractions || (Attractions = {}));
var Attractions;
(function (Attractions) {
    angular
        .module('attractions')
        .service('attractionService', attractionService);
    function attractionService($q, $http, tripService, analytics, dateUtil) {
        var domain = TRPCONFIG.Domain, apiUrl = '/api2/attractions', service = {
            trackAttractionSearch: trackAttractionSearch,
            getProductName: getProductName,
            getProductFormCriteria: getProductFormCriteria,
            getAvailability: getAvailability,
            getProductTotals: getProductTotals,
            getLineItemChanges: getLineItemChanges,
            getAttractionQuotes: getAttractionQuotes,
            getAttractionQuotesFromSession: getAttractionQuotesFromSession,
            getOccupancy: getOccupancy,
            getLineItemDates: getLineItemDates,
            getAttractionsDesc: getAttractionsDesc
        };
        function getAttractionsDesc(attractions, attractionDetails, id) {
            var desc = '';
            var prefDate = '';
            var product = _.find(attractions, function (a) { return a.Details && a.Details.AttractionRequests[id]; });
            var details = _.find(attractionDetails, {
                ProductId: id
            });
            if (product) {
                var attractionIds = _.get(product, 'Details.AttractionIds');
                var i = attractionIds && attractionIds.indexOf(id);
                var cb = product.CostBreakdown;
                if (cb && i != null) {
                    desc = cb[i].Description;
                }
                if (details) {
                    prefDate = dateUtil.format(dateUtil.parseDate(details.PreferredDate)) + ', ';
                }
            }
            return prefDate + desc;
        }
        ;
        function trackAttractionSearch(searchId, itemId, itemName) {
            return $http.post(apiUrl + '/analytics/autocompleter/selection', {
                SearchId: searchId,
                SelectedItemId: itemId,
                SelectedItemName: itemName
            }, { ignoreErrors: true });
        }
        function getProductName(productId) {
            return $http.post(apiUrl + "/bookingfunnel/getproduct/" + productId, [], { ignoreErrors: true }).then(function (res) { return res.data; });
        }
        function getProductFormCriteria(productId) {
            return $http.post(apiUrl + '/bookingfunnel/getcriteria/' + productId).then(function (res) { return res.data; });
        }
        function getAvailability(productId, tags) {
            // Standardise date to first of month
            var date = new Date(dateUtil.parseDate(tags.date).getTime());
            date.setDate(1);
            date.setHours(12);
            return $http.post(apiUrl + '/bookingfunnel/searchavailability', {
                Id: productId,
                Tags: angular.extend({}, tags, { date: date }),
                DomainId: domain.DomainId,
                Currency: domain.CurrencyCode
            }, { ignoreErrors: true }).then(function (res) { return res.data; }, function (err) { return ({ error: err }); });
        }
        function getProductTotals(lineItems) {
            var totals = { count: 0, price: 0 };
            totals.price = lineItems && lineItems.reduce(function (total, item) {
                if (item.Tickets) {
                    totals.count++;
                    return total + item.Tickets.reduce(function (t, o) { return t + (o.Price * o.Value); }, 0);
                }
            }, 0);
            return totals;
        }
        function getLineItemDates(lineItem) {
            var dates = {
                selected: null,
                from: null,
                to: null
            };
            if (lineItem.Description && lineItem.Description.SelectedDate) {
                dates.selected = dateUtil.format(lineItem.Description.SelectedDate);
            }
            var validity = lineItem.Description && lineItem.Description.Validity
                ? lineItem.Description.Validity : null;
            if (validity) {
                var from = dateUtil.format(validity.From);
                var to = dateUtil.format(validity.To);
                if (from && to && !dateUtil.sameDay(validity.From, validity.To)) {
                    dates.from = from;
                    dates.to = to;
                }
            }
            return dates;
        }
        function getLineItemChanges(basketData) {
            // Returns lineItems data indicating basket changes
            var lineItems = [], changeData = basketData.Change, modifiedData = changeData && changeData.Modified || [];
            modifiedData.forEach(function (modifiedItem) {
                var LineItemId = modifiedItem.LineItemId, basketItem = _.find(basketData.Basket.LineItems, {
                    LineItemId: LineItemId
                });
                if (basketItem) {
                    lineItems.push(_mergeTicketChanges(basketItem, modifiedItem));
                }
            });
            return lineItems;
        }
        function _mergeTicketChanges(basketItem, modifiedData) {
            // Merges ticket changes data into basket lineItem data
            // Resulting data indicates ticket changes
            var lineItem = angular.extend({}, basketItem);
            lineItem.Tickets = [];
            ['Modified', 'New'].forEach(function (modificationType) {
                modifiedData[modificationType].forEach(function (props) {
                    var basketTicket = _.find(basketItem.Tickets, {
                        Key: props.Key
                    });
                    if (basketTicket) {
                        lineItem.Tickets.push(angular.extend({}, basketTicket, props));
                    }
                });
            });
            return lineItem;
        }
        /*
         Attractions extras
         */
        function getAttractionQuotes(tripId, request) {
            var req = angular.extend({
                DomainId: domain.DomainId,
                Currency: domain.CurrencyCode
            }, request);
            analytics.startTimer('AttractionsAvailabilityRequest');
            return $http.post(apiUrl + '/availability/GetCrossSell', req, { ignoreErrors: true }).then(function (res) {
                analytics.endTimer('AttractionsAvailabilityRequest');
                tripService.recordAttractionSearch(tripId, request);
                return res.data.AttractionQuotes;
            });
        }
        function getAttractionQuotesFromSession(availabilitySearchId) {
            return $http.post(apiUrl + '/availability/getfromsession', {
                'AvailabilitySearchId': availabilitySearchId
            }, { ignoreErrors: true }).then(function (res) {
                return res.data.AttractionQuotes;
            });
        }
        function getOccupancy(tripId) {
            return tripService.getTripReducedOccupancy(tripId).then(function (occ) {
                var res = [];
                for (var i = 0; i < occ.Adults; i++) {
                    res.push({ Age: 21, Type: 'Adult' });
                }
                angular.forEach(occ.ChildAges, function (age) {
                    res.push({
                        Type: age < 2 ? 'Infant' : 'Child',
                        Age: age
                    });
                });
                return res;
            });
        }
        return service;
    }
})(Attractions || (Attractions = {}));
angular
    .module('attractions')
    .service('attractionDetailsService', attractionDetailsService);
function attractionDetailsService($http, $cacheFactory, $q) {
    var url = '/api2/attractions/details/', timeout, cacheLabel = 'detailPromiseCache', promiseCache = $cacheFactory.get(cacheLabel) || $cacheFactory(cacheLabel);
    var imageUrl = TRPCONFIG.Domain.AttractionsImageUrl;
    // var domain = TRPCONFIG.Domain,
    var service = {
        getAttractionDetails: getAttractionDetails,
        getImageUrl: getImageUrl,
        rehydrate: rehydrate,
        purge: purge
    };
    function enhanceData(data) {
        data.AttractionIds = [];
        angular.forEach(data.AttractionRequests, function (r, k) {
            data.AttractionIds.push(parseInt(k, 10));
        });
        return data;
    }
    function getAttractionDetails(productDetails) {
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        timeout = $q.defer();
        return $http.post(url + 'get', productDetails, { ignoreErrors: true, timeout: timeout.promise })
            .then(function (res) {
            promiseCache.remove(res.data.DetailsSearchId);
            timeout = null;
            return enhanceData(res.data);
        });
    }
    function rehydrate(detailsSearchId) {
        // Retrieve product details from session
        if (!promiseCache.get(detailsSearchId)) {
            promiseCache.put(detailsSearchId, $http.post(url + 'getfromsession', { DetailsSearchId: detailsSearchId }, { ignoreErrors: true })
                .then(function (res) { return enhanceData(res.data); }));
        }
        return promiseCache.get(detailsSearchId);
    }
    function purge() {
        $cacheFactory.get(cacheLabel).removeAll();
    }
    function getImageUrl(id) {
        return imageUrl + id;
    }
    return service;
}
var Attractions;
(function (Attractions) {
    var AttractionSearchValidator = /** @class */ (function () {
        function AttractionSearchValidator(resourceService) {
            this.resourceService = resourceService;
        }
        AttractionSearchValidator.prototype.validate = function (formModel) {
            var errors = [], uiCountTotal = 0;
            Object.keys(formModel).forEach(function (k) {
                if (/ui:count/.test(k)) {
                    var v = formModel[k];
                    if (!isNaN(v)) {
                        uiCountTotal += v * 1;
                    }
                }
            });
            if (!uiCountTotal) {
                errors.push(this.resourceService.get('ATTRACTIONSSELECTWHO'));
            }
            if (!formModel.date) {
                errors.push(this.resourceService.get('SELECTDATE'));
            }
            return errors;
        };
        return AttractionSearchValidator;
    }());
    angular
        .module('attractions')
        .service('attractionSearchValidator', AttractionSearchValidator);
})(Attractions || (Attractions = {}));
angular
    .module('carHire')
    .controller('CarHire', CarHire);
function CarHire($filter, $q, $routeParams, $scope, arrayUtil, basketService, basketStore, carHireDetailsService, extraProductsService, scrollService, tripService) {
    var ch = this;
    ch.noneCarHire = '-1';
    ch.currentCarHireLimit = ch.carHireLimit = 5;
    ch.DriverAgeConfig = {
        Min: 21,
        Max: 90
    };
    var deferred;
    var optionOperation;
    //Desktop
    ch.driverAgeList = arrayUtil.createRange(ch.DriverAgeConfig.Max, ch.DriverAgeConfig.Min);
    //DesktopEnd
    tripService.getTrip($routeParams.tripId).then(function (trip) {
        var basketId = trip.BasketId, tripId = trip.TripId, carHireSearchId = trip.CarHireRequest ? trip.CarHireRequest.AvailabilitySearchId : null, onewayonly = trip.FlightsRequest.OneWayOnly;
        ch.carHireDriverAge = trip.CarHireRequest ? trip.CarHireRequest.DriverAge : 30;
        $q.all([
            basketStore.carHire(basketId, $routeParams.productId),
            basketStore.rules(basketId, $routeParams.productId),
            basketStore.carHireOptions(basketId, $routeParams)
        ]).then(function (results) {
            var carHire = results[0] ? results[0].Details.CarHireId.CarHireCode : ch.noneCarHire;
            ch.basketRules = results[1];
            if ((TRPCONFIG.Domain.CarHireEnabled || TRPCONFIG.Domain.CarHireMobileEnabled) && !onewayonly) {
                $scope.$watch('ch.carHireDriverAge', _.debounce(function (val, oldVal) {
                    if (val == null) {
                        return;
                    }
                    ch.carHireBusyAvailability = true;
                    if (oldVal !== val) {
                        carHireSearchId = null;
                    }
                    deferred = $q.defer();
                    var processResults = function (carHireQuotes, options) {
                        ch.carHireQuotes = arrayUtil.sort(carHireQuotes, 'Price');
                        ch.carHireLimit = 5;
                        ch.carHireBusyAvailability = false;
                        if (!ch.carHire) {
                            ch.carHire = angular.copy(carHire);
                            ch.carHireSelectedOptions = _normaliseCarHireOptions(options) || [];
                        }
                        else {
                            var quote = arrayUtil.first(ch.carHireQuotes, function (q) {
                                return q.CarHireId.CarHireCode === ch.carHire;
                            });
                            if (!quote) {
                                ch.carHire = angular.copy(ch.noneCarHire);
                            }
                            else {
                                ch.appendDetails(quote);
                            }
                        }
                    };
                    if (carHireSearchId == null) {
                        basketService.getCarQuotes(basketId, tripId, ch.carHireDriverAge)
                            .then(function (quotes) { return processResults(quotes, results[2]); });
                    }
                    else {
                        basketService.getCarQuotesFromSession(carHireSearchId, 0)
                            .then(function (quotes) { return processResults(quotes, results[2]); });
                    }
                }, 400));
                $scope.$watch('ch.carHire', _selectCar, true);
                $scope.$watch('ch.carHireSelectedOptions', optionsWatch, true);
            }
        }).then(angular.noop, basketService.restartHolidayWorkflow);
        ch.appendDetails = function (quote, $event) {
            if ($event) {
                $event.preventDefault();
            }
            _.each(ch.carHireQuotes, function (q) {
                q.viewDetails = false;
            });
            if (!quote.Details) {
                quote.busy = true;
                tripService.getTrip(tripId).then(function (t) {
                    carHireSearchId = t.CarHireRequest.AvailabilitySearchId;
                    carHireDetailsService
                        .getCarDetails({ AvailabilitySearchId: carHireSearchId, CarHireQuote: quote }, true)
                        .then(function (d) {
                        quote.viewDetails = true;
                        quote.Details = d;
                        quote.busy = false;
                        quote.showDetailsError = false;
                    }, function () {
                        quote.busy = false;
                        quote.showDetailsError = true;
                    });
                });
            }
            else {
                quote.viewDetails = true;
            }
        };
        ch.hideDetails = function (quote, $event) {
            if ($event) {
                $event.preventDefault();
            }
            quote.viewDetails = false;
        };
        ch.showMoreOrLess = function ($event) {
            if ($event) {
                $event.preventDefault();
            }
            var moreCarHireQuotes = ch.currentCarHireLimit !== ch.carHireQuotes.length;
            var currentCarHireLimit = moreCarHireQuotes ? ch.carHireQuotes.length : ch.carHireLimit;
            if (!moreCarHireQuotes) {
                scrollService.scrollTo('#car-hire-product-expander', { animate: true, offset: 70 }).then(function () {
                    ch.moreCarHireQuotes = false;
                    ch.currentCarHireLimit = currentCarHireLimit;
                });
            }
            else {
                ch.moreCarHireQuotes = true;
                ch.currentCarHireLimit = currentCarHireLimit;
            }
        };
        var selectingCar = $q.when();
        function _selectCar(val, oldVal) {
            if (val == null || val === oldVal) {
                return;
            }
            _updateSubtitle();
            if (val !== ch.noneCarHire) {
                var quote = arrayUtil.first(ch.carHireQuotes, function (q) {
                    return q.CarHireId.CarHireCode === val;
                });
                if (!!quote) {
                    quote.busy = !quote.Details;
                    if (!deferred) {
                        deferred = $q.defer();
                    }
                    var select = function () {
                        return tripService.getTrip(tripId).then(function (t) {
                            carHireSearchId = t.CarHireRequest.AvailabilitySearchId;
                            return basketService.selectCar(quote, carHireSearchId, basketId)
                                .then(function (d) {
                                ch.carHireSelectedOptions = arrayUtil.filter(ch.carHireSelectedOptions, function (op) {
                                    return op.carHireId === val;
                                });
                                quote.Details = d.Details;
                                quote.showDetailsError = false;
                                quote.viewDetails = true;
                                quote.busy = false;
                                if (deferred) {
                                    deferred.resolve();
                                }
                                if (optionOperation) {
                                    optionOperation.then(updateBasketAndCarHireOptions);
                                }
                                selectingCar = $q.when();
                            }, function () {
                                ch.carHire = angular.copy(ch.noneCarHire);
                                quote.busy = false;
                                quote.showDetailsError = true;
                            });
                        });
                    };
                    selectingCar = selectingCar.then(select);
                    return selectingCar;
                }
                ch.carHire = ch.noneCarHire;
            }
            else {
                selectingCar = selectingCar.then(function () {
                    return basketStore.removeCar(basketId).then(function () {
                        ch.carHireSelectedOptions = [];
                        if (deferred) {
                            deferred.resolve();
                        }
                        updateBasketAndCarHireOptions();
                    });
                });
                return selectingCar;
            }
        }
        optionOperation = $q.when();
        function optionsWatch(selectedOptions, old) {
            if (!selectedOptions ||
                selectedOptions === old ||
                selectedOptions.length === 0 && !!old && old.length > 1) {
                return;
            }
            optionOperation = optionOperation.then(function () {
                return selectOptions();
            });
            function selectOptions() {
                if (selectedOptions.length >= 1) {
                    if (ch.carHire !== selectedOptions[selectedOptions.length - 1].carHireId) {
                        ch.carHire = selectedOptions[selectedOptions.length - 1].carHireId;
                        deferred = $q.defer();
                        selectedOptions = [selectedOptions[selectedOptions.length - 1]];
                    }
                }
                ch.carHireSelectedOptions = selectedOptions;
                return deferred.promise.then(function () {
                    return addOrRemoveOption(selectedOptions);
                });
            }
        }
        function addOrRemoveOption(selectedOptions) {
            if (ch.carHire === ch.noneCarHire) {
                return $q.when();
            }
            return basketStore.carHireOptions(basketId).then(function (basketOptions) {
                var boNormal = _normaliseCarHireOptions(basketOptions);
                return _missingFrom(boNormal, selectedOptions, updateCarHireOptionsInBasket(basketStore.removeOptions))
                    .then(function () {
                    return _missingFrom(selectedOptions, boNormal, updateCarHireOptionsInBasket(basketStore.addOptions))
                        .then(function () {
                        return updateBasketAndCarHireOptions();
                    });
                });
            });
        }
        function updateCarHireOptionsInBasket(storeFn) {
            return function (options) {
                var quote = arrayUtil.first(ch.carHireQuotes, function (q) {
                    return angular.equals(q.CarHireId.CarHireCode, ch.carHire);
                });
                if (!quote || !quote.Details) {
                    return $q.when();
                }
                return storeFn.call(basketStore, basketStore.productType.CarHire, quote.Details.DetailsSearchId, options, basketId);
            };
        }
        function updateBasketAndCarHireOptions() {
            basketService.updateBasket();
            return basketStore.carHireOptions(basketId);
        }
    }, basketService.bookingAlreadyDone("carHire: '" + $routeParams.tripId + "'"));
    function _missingFrom(src, dst, forall) {
        return forall(arrayUtil.map(arrayUtil.filter(src, function (o1) {
            return !arrayUtil.any(dst, function (o2) {
                return angular.equals(o1, o2);
            });
        }), function (optionId) {
            return { OptionId: optionId.optionId, ChosenQuantity: 1 };
        }));
    }
    ch.filterQuotes = extraProductsService.filterQuotes;
    function _normaliseCarHireOptions(bo) {
        var res = [];
        angular.forEach(bo, function (b) {
            res.push({ carHireId: ch.carHire, optionId: b });
        });
        return res;
    }
    function _updateSubtitle() {
        if (ch.carHireQuotes && ch.carHire) {
            var carHireQuote = arrayUtil.first(ch.carHireQuotes, function (c) {
                return angular.equals(c.CarHireId.CarHireCode, ch.carHire);
            });
            ch.carHireQuoteDescription = carHireQuote ?
                carHireQuote.Description + ' (' + $filter('customCurrency')(carHireQuote.Price) + ')'
                : null;
        }
    }
}
angular
    .module('carHire')
    .service('carHireService', carHireService);
function carHireService($q, $http, tripService, analytics) {
    var domain = TRPCONFIG.Domain, service = {
        getCarQuotes: getCarQuotes,
        getCarQuotesFromSession: getCarQuotesFromSession
    };
    var timeout;
    function getCarQuotes(tripId, request) {
        var req = angular.extend({
            DomainId: domain.DomainId,
            Currency: domain.CurrencyCode
        }, request);
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        timeout = $q.defer();
        analytics.startTimer('CarHireAvailabilityRequest');
        return $http.post('/api2/carhire/availability/get', req, {
            ignoreErrors: true,
            timeout: timeout.promise
        }).then(function (res) {
            analytics.endTimer('CarHireAvailabilityRequest');
            tripService.recordCarHireSearch(tripId, request);
            timeout = null;
            return res.data.CarHireQuotes;
        });
    }
    function getCarQuotesFromSession(request) {
        return $http.post('/api2/carhire/availability/getfromsession', request, { ignoreErrors: true }).then(function (res) {
            return res.data.CarHireQuotes;
        });
    }
    return service;
}
angular
    .module('carHire')
    .service('carHireDetailsService', carHireDetailsService);
function carHireDetailsService($http, arrayUtil, $cacheFactory, $q, broker) {
    var url = '/api2/carhire/details/';
    var timeout;
    var promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');
    // var domain = TRPCONFIG.Domain,
    var service = {
        getCarDetails: getCarDetails,
        rehydrate: rehydrate
    };
    function stringifyOptions(details) {
        details.AdditionalOptions = arrayUtil.map(details.AdditionalOptions, function (o) {
            o.OptionId = '' + o.OptionId;
            return o;
        });
        return details;
    }
    function getCarDetails(quote) {
        if (!!quote.CarHireQuote.Details) {
            return $q.when(quote.CarHireQuote.Details);
        }
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        var request = {
            AvailabilitySearchId: quote.AvailabilitySearchId,
            CarHireQuoteId: quote.CarHireQuote.CarHireId
        };
        timeout = $q.defer();
        return $http.post(url + 'get', request, {
            timeout: null,
            customErrCallback: function (args) {
                if (args.status) {
                    broker.publish('carHireRequestFailed');
                }
                return true;
            }
        }).then(function (res) {
            promiseCache.remove(res.data.DetailsSearchId);
            timeout = null;
            return stringifyOptions(res.data);
        });
    }
    function rehydrate(id) {
        if (!promiseCache.get(id)) {
            promiseCache.put(id, $http.post(url + 'getfromsession', { DetailsSearchId: id }, { ignoreErrors: true })
                .then(function (res) {
                return stringifyOptions(res.data);
            }, function () {
                return $q.when('hello');
            }));
        }
        return promiseCache.get(id);
    }
    return service;
}
var CMS;
(function (CMS) {
    angular
        .module('cms')
        .component('mobileHero', {
        bindings: {
            elements: '@',
            heroStyle: '=',
            sale: '=',
        },
        controller: function ($scope, $route) {
            var scope = $scope.mh;
            scope.showHero = function (name) {
                var supportsHeroStyle = ['hotels', 'holidays'].indexOf(name) >= 0;
                var supportsSalesStyle = ['hotels', 'holidays'].indexOf(name) >= 0;
                if (supportsHeroStyle && scope.heroStyle && scope.heroStyle['background-image'] !== '') {
                    return false;
                }
                else if (supportsSalesStyle && scope.sale && scope.sale !== '') {
                    return false;
                }
                return true;
            };
            scope.currentArea = $route.current.area && $route.current.area.toLowerCase();
            var supportedProducts = TRPCONFIG.Domain.SupportedProductNames.map(function (p) { return p.toLowerCase(); });
            try {
                var heroes_1 = JSON.parse(scope.elements);
                var heroKeys = _.keys(heroes_1);
                this.heroes = [];
                heroKeys.forEach(function (elem) {
                    var url = _.get(heroes_1, "" + elem, null);
                    var header = _.get(heroes_1, elem + "Header", '');
                    var linkUrl = _.get(heroes_1, elem + "LinkUrl", '');
                    var name = elem.toLowerCase();
                    if (_.isString(url) && url.replace(/\s+/, '').length > 0 &&
                        supportedProducts.indexOf(name) >= 0 &&
                        scope.currentArea === name &&
                        scope.showHero(name)) {
                        scope.heroes.push({ name: name, url: url, header: header, linkUrl: linkUrl });
                    }
                });
            }
            catch (e) { }
        },
        controllerAs: 'mh',
        template: "\n            <div\n                ng-repeat=\"hero in mh.heroes track by $index\"\n                class=\"sc-c-superhero\"\n            >\n            <a href={{hero.linkUrl}} tabindex=\"0\" style=\"\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            z-index: 2;\n            \"></a>\n                <div class=\"sc-c-superhero-slide\">\n                    <img \n                        class=\"sc-c-superhero-slide__image\"\n                        src=\"{{hero.url}}\"\n                    >\n                </div>\n                <div ng-if=\"hero.header.length > 0\"\n                    class=\"sc-c-container sc-c-container--gutters-x\">\n                    <div class=\"sc-c-superhero__headline\">\n                        <h1>{{hero.header}}</h1>\n                    </div>\n                </div>\n            </div>\n            "
    });
})(CMS || (CMS = {}));
var CMS;
(function (CMS) {
    angular
        .module('cms')
        .directive('analyticsEvent', function (analytics) {
        return {
            scope: {
                type: '@',
                name: '@',
                properties: '='
            },
            link: function (scope) {
                analytics.track(scope.type, scope.name, scope.properties);
            }
        };
    });
})(CMS || (CMS = {}));
var CMS;
(function (CMS) {
    var observable = 'IntersectionObserver' in window;
    var CmsComponent = /** @class */ (function () {
        function CmsComponent() {
        }
        CmsComponent.prototype.url = function () {
            if (!this.inView && this.lazy && observable) {
                return 'loadingcmscomponent.html';
            }
            if (this.componentId) {
                return "cms/component/" + this.pageId + "/" + this.componentId;
            }
            else if (this.componentName) {
                return "cms/component/" + this.pageId + "/" + this.componentName;
            }
            else if (this.pageId) {
                return "cms/component/" + this.pageId;
            }
            else {
                return "cms/missing";
            }
        };
        return CmsComponent;
    }());
    angular.module('cms').directive('lazyCms', function () {
        return {
            restrict: 'A',
            require: '^cmsComponent',
            link: function (scope, el, attr, controller) {
                if (!observable || !controller.lazy) {
                    return;
                }
                var observer = new IntersectionObserver(loadContent, {
                    rootMargin: '200px 0px 200px 0px'
                });
                observer.observe(el[0]);
                function loadContent(changes) {
                    changes.forEach(function (change) {
                        if (change.intersectionRatio > 0) {
                            observer.unobserve(change.target);
                            scope.$apply(function () { return controller.inView = true; });
                        }
                    });
                }
            }
        };
    });
    /*
    The lazy attribute controls whether this component will be loaded lazily based on whether it is
    visible in the viewport
     */
    angular.module('cms').directive('cmsComponent', function ($timeout) {
        return {
            scope: {},
            replace: true,
            bindToController: {
                data: '=',
                pageId: '@',
                componentName: '@',
                componentId: '@',
                lazy: '<'
            },
            controller: CmsComponent,
            controllerAs: 'cc',
            template: '<span lazy-cms ng-include="cc.url()"></span>',
            link: function (scope, el, attr, controller) {
                var p = scope.$parent;
                while (p != null) {
                    if (p['rc'] != null) {
                        controller.modal = p['rc'].modal;
                        controller.rc = p['rc'];
                        p = null;
                    }
                    else {
                        p = p.$parent;
                    }
                }
            }
        };
    });
})(CMS || (CMS = {}));
var CMS;
(function (CMS) {
    angular.module('cms').directive('seoMetaData', function () {
        return {
            scope: {
                title: '@',
                description: '@',
                keywords: '@',
                robots: '@'
            },
            replace: false,
            link: function (scope, el, attr) {
                var tags = {}, head = $('head');
                if (scope.title) {
                    tags.title = "<title>" + scope.title + "</title>";
                    tags['meta[name=title]'] = "<meta name='title' content='" + scope.title + "'/>";
                }
                if (scope.description) {
                    tags['meta[name=description]'] = "<meta name='description' content='" + scope.description + "'/>";
                }
                if (scope.keywords) {
                    tags['meta[name=keywords]'] = "<meta name='keywords' content='" + scope.keywords + "'/>";
                }
                if (scope.robots) {
                    tags['meta[name=robots]'] = "<meta name='robots' content='" + scope.robots + "'/>";
                }
                $.each(tags, function (selector, html) {
                    $(selector).remove();
                    head.append(html);
                });
            }
        };
    });
})(CMS || (CMS = {}));
var CMS;
(function (CMS) {
    var CmsUtils = /** @class */ (function () {
        function CmsUtils() {
            this.reWhitespace = /\s/g;
        }
        CmsUtils.prototype.normaliseValue = function (val) {
            return decodeURIComponent(String(val))
                .toLowerCase()
                .replace(this.reWhitespace, '');
        };
        CmsUtils.prototype.propsMatch = function (srcOb, props) {
            // Returns `true` if all `props` k:v pairs have a normalised match in `srcOb`
            if (!angular.isObject(srcOb) || !angular.isObject(props)) {
                return false;
            }
            var matchCount = 0;
            var srcKeys = Object.keys(srcOb);
            var propsKeys = Object.keys(props);
            var pi = propsKeys.length;
            while (pi--) {
                var si = srcKeys.length;
                var normalisedKey = this.normaliseValue(propsKeys[pi]);
                var normalisedVal = this.normaliseValue(props[propsKeys[pi]]);
                while (si--) {
                    if (this.normaliseValue(srcKeys[si]) === normalisedKey &&
                        this.normaliseValue(srcOb[srcKeys[si]]) === normalisedVal) {
                        if (++matchCount === propsKeys.length) {
                            return true;
                        }
                        break;
                    }
                }
            }
            ;
            return false;
        };
        return CmsUtils;
    }());
    angular
        .module('cms')
        .service('cmsUtils', CmsUtils);
})(CMS || (CMS = {}));
var Core;
(function (Core) {
    var AdHoc;
    (function (AdHoc) {
        /// Duration unit enum
        var DurationUnitSingular;
        (function (DurationUnitSingular) {
            DurationUnitSingular[DurationUnitSingular["Hour"] = 1] = "Hour";
            DurationUnitSingular[DurationUnitSingular["Day"] = 2] = "Day";
        })(DurationUnitSingular = AdHoc.DurationUnitSingular || (AdHoc.DurationUnitSingular = {}));
        var DurationUnitPlural;
        (function (DurationUnitPlural) {
            DurationUnitPlural[DurationUnitPlural["Hours"] = 1] = "Hours";
            DurationUnitPlural[DurationUnitPlural["Days"] = 2] = "Days";
        })(DurationUnitPlural = AdHoc.DurationUnitPlural || (AdHoc.DurationUnitPlural = {}));
    })(AdHoc = Core.AdHoc || (Core.AdHoc = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Booking;
    (function (Booking) {
        var BookingStatus;
        (function (BookingStatus) {
            BookingStatus[BookingStatus["Complete"] = 1] = "Complete";
            BookingStatus[BookingStatus["Alert"] = 2] = "Alert";
            BookingStatus[BookingStatus["ThreeDs"] = 3] = "ThreeDs";
            BookingStatus[BookingStatus["Error"] = 4] = "Error";
            BookingStatus[BookingStatus["ValidationError"] = 5] = "ValidationError";
            BookingStatus[BookingStatus["TimedOut"] = 6] = "TimedOut";
            BookingStatus[BookingStatus["BookingError"] = 7] = "BookingError";
            BookingStatus[BookingStatus["PayPalVerification"] = 8] = "PayPalVerification";
            BookingStatus[BookingStatus["PayPalVerified"] = 9] = "PayPalVerified";
            BookingStatus[BookingStatus["Cpg"] = 10] = "Cpg";
            BookingStatus[BookingStatus["Refresh"] = 13] = "Refresh";
            BookingStatus[BookingStatus["WPHostedPayment"] = 15] = "WPHostedPayment";
            BookingStatus[BookingStatus["HostedPayment"] = 16] = "HostedPayment";
        })(BookingStatus = Booking.BookingStatus || (Booking.BookingStatus = {}));
        var PassengerType;
        (function (PassengerType) {
            PassengerType[PassengerType["None"] = 0] = "None";
            PassengerType[PassengerType["Adult"] = 1] = "Adult";
            PassengerType[PassengerType["Child"] = 2] = "Child";
            PassengerType[PassengerType["Infant"] = 3] = "Infant";
            PassengerType[PassengerType["AdultSwimmer"] = 4] = "AdultSwimmer";
            PassengerType[PassengerType["AdultNonSwimmer"] = 5] = "AdultNonSwimmer";
            PassengerType[PassengerType["ChildSwimmer"] = 6] = "ChildSwimmer";
            PassengerType[PassengerType["ChildNonSwimmer"] = 7] = "ChildNonSwimmer";
        })(PassengerType = Booking.PassengerType || (Booking.PassengerType = {}));
        ;
        var DriverType;
        (function (DriverType) {
            DriverType[DriverType["NotADriver"] = 0] = "NotADriver";
            DriverType[DriverType["MainDriver"] = 1] = "MainDriver";
            DriverType[DriverType["AdditionalDriver"] = 2] = "AdditionalDriver";
        })(DriverType = Booking.DriverType || (Booking.DriverType = {}));
        var CreateBookingStatus;
        (function (CreateBookingStatus) {
            CreateBookingStatus[CreateBookingStatus["Complete"] = 1] = "Complete";
            CreateBookingStatus[CreateBookingStatus["Alert"] = 2] = "Alert";
            CreateBookingStatus[CreateBookingStatus["ThreeDs"] = 3] = "ThreeDs";
            CreateBookingStatus[CreateBookingStatus["Error"] = 4] = "Error";
            CreateBookingStatus[CreateBookingStatus["ValidationError"] = 5] = "ValidationError";
            CreateBookingStatus[CreateBookingStatus["TimedOut"] = 6] = "TimedOut";
            CreateBookingStatus[CreateBookingStatus["BookingError"] = 7] = "BookingError";
            CreateBookingStatus[CreateBookingStatus["PayPalVerification"] = 8] = "PayPalVerification";
            CreateBookingStatus[CreateBookingStatus["PayPalVerified"] = 9] = "PayPalVerified";
            CreateBookingStatus[CreateBookingStatus["Cpg"] = 10] = "Cpg";
            CreateBookingStatus[CreateBookingStatus["Refresh"] = 13] = "Refresh";
            CreateBookingStatus[CreateBookingStatus["WPHostedPayment"] = 15] = "WPHostedPayment";
            CreateBookingStatus[CreateBookingStatus["HostedPayment"] = 16] = "HostedPayment";
        })(CreateBookingStatus = Booking.CreateBookingStatus || (Booking.CreateBookingStatus = {}));
        var ProductType;
        (function (ProductType) {
            ProductType[ProductType["Flight"] = 1] = "Flight";
            ProductType[ProductType["Attraction"] = 2] = "Attraction";
            ProductType[ProductType["CarHire"] = 4] = "CarHire";
            ProductType[ProductType["Hotel"] = 8] = "Hotel";
            ProductType[ProductType["Parking"] = 16] = "Parking";
            ProductType[ProductType["Transfer"] = 32] = "Transfer";
            ProductType[ProductType["Insurance"] = 64] = "Insurance";
            ProductType[ProductType["Marhaba"] = 256] = "Marhaba";
            ProductType[ProductType["Cruise"] = 512] = "Cruise";
        })(ProductType = Booking.ProductType || (Booking.ProductType = {}));
        var RecentSearchType;
        (function (RecentSearchType) {
            RecentSearchType[RecentSearchType["Flights"] = 1] = "Flights";
            RecentSearchType[RecentSearchType["Hotels"] = 2] = "Hotels";
            RecentSearchType[RecentSearchType["Holidays"] = 3] = "Holidays";
        })(RecentSearchType = Booking.RecentSearchType || (Booking.RecentSearchType = {}));
        // This enum is only used client side in order to provide a common type for
        // standard products cross-sells (e.g. transfers/attractions) and
        // flight extras cross sells (e.g. bags/seats)
        var CrossSellType;
        (function (CrossSellType) {
            CrossSellType[CrossSellType["Hotels"] = 1] = "Hotels";
            CrossSellType[CrossSellType["Attractions"] = 2] = "Attractions";
            CrossSellType[CrossSellType["Transfers"] = 3] = "Transfers";
            CrossSellType[CrossSellType["CarHire"] = 4] = "CarHire";
            CrossSellType[CrossSellType["Seats"] = 5] = "Seats";
            CrossSellType[CrossSellType["Baggage"] = 6] = "Baggage";
            CrossSellType[CrossSellType["Parking"] = 7] = "Parking";
        })(CrossSellType = Booking.CrossSellType || (Booking.CrossSellType = {}));
    })(Booking = Core.Booking || (Core.Booking = {}));
})(Core || (Core = {}));
// Contracts for TravelRepublic.Manager.Bookings
// --------------------------------------------------
var Core;
(function (Core) {
    var ManageBooking;
    (function (ManageBooking) {
        var TripStage;
        (function (TripStage) {
            TripStage[TripStage["PreTrip"] = 0] = "PreTrip";
            TripStage[TripStage["OnTrip"] = 1] = "OnTrip";
            TripStage[TripStage["PostTrip"] = 2] = "PostTrip";
        })(TripStage = ManageBooking.TripStage || (ManageBooking.TripStage = {}));
        var BookedTrip = /** @class */ (function () {
            function BookedTrip() {
                // decorated properties
                this.DaysUntilDeparture = 0;
                this.DaysUntilReturn = 0;
                this.Duration = 0;
                this.MainBookingId = 0;
                this.PaymentDetails = new PaymentDetails();
            }
            return BookedTrip;
        }());
        ManageBooking.BookedTrip = BookedTrip;
        var PaymentDetails = /** @class */ (function () {
            function PaymentDetails() {
                this.Balances = [];
                this.Paid = 0;
                this.PayDirect = [];
                this.Outstanding = 0;
                this.Total = 0;
            }
            return PaymentDetails;
        }());
        ManageBooking.PaymentDetails = PaymentDetails;
        var BalanceDue = /** @class */ (function () {
            function BalanceDue() {
                this.Amount = 0;
            }
            return BalanceDue;
        }());
        ManageBooking.BalanceDue = BalanceDue;
        var DirectPayment = /** @class */ (function () {
            function DirectPayment() {
                this.Amount = 0;
                this.LocalAmount = 0;
            }
            return DirectPayment;
        }());
        ManageBooking.DirectPayment = DirectPayment;
    })(ManageBooking = Core.ManageBooking || (Core.ManageBooking = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var CarHire;
    (function (CarHire) {
        var FuelPolicyType;
        (function (FuelPolicyType) {
            FuelPolicyType[FuelPolicyType["FullFull"] = 0] = "FullFull";
            FuelPolicyType[FuelPolicyType["EmptyEmpty"] = 1] = "EmptyEmpty";
            FuelPolicyType[FuelPolicyType["FullEmpty"] = 2] = "FullEmpty";
            FuelPolicyType[FuelPolicyType["HalfEmpty"] = 3] = "HalfEmpty";
            FuelPolicyType[FuelPolicyType["QuarterEmpty"] = 4] = "QuarterEmpty";
            FuelPolicyType[FuelPolicyType["HalfHalf"] = 5] = "HalfHalf";
            FuelPolicyType[FuelPolicyType["QuarterQuarter"] = 6] = "QuarterQuarter";
            FuelPolicyType[FuelPolicyType["FreeTank"] = 7] = "FreeTank";
            FuelPolicyType[FuelPolicyType["FullEmptyRefund"] = 8] = "FullEmptyRefund";
            FuelPolicyType[FuelPolicyType["FullFullHybrid"] = 9] = "FullFullHybrid";
            FuelPolicyType[FuelPolicyType["ChauFulFul"] = 10] = "ChauFulFul";
            FuelPolicyType[FuelPolicyType["ChaufFuelInc"] = 11] = "ChaufFuelInc";
            FuelPolicyType[FuelPolicyType["Unknown"] = 12] = "Unknown";
        })(FuelPolicyType = CarHire.FuelPolicyType || (CarHire.FuelPolicyType = {}));
        var FuelType;
        (function (FuelType) {
            FuelType[FuelType["Unspecified"] = 0] = "Unspecified";
            FuelType[FuelType["Petrol"] = 1] = "Petrol";
            FuelType[FuelType["Diesel"] = 2] = "Diesel";
        })(FuelType = CarHire.FuelType || (CarHire.FuelType = {}));
        var SortOrder;
        (function (SortOrder) {
            SortOrder[SortOrder["None"] = 0] = "None";
            SortOrder[SortOrder["Price"] = 1] = "Price";
            SortOrder[SortOrder["Recommended"] = 2] = "Recommended";
        })(SortOrder = CarHire.SortOrder || (CarHire.SortOrder = {}));
    })(CarHire = Core.CarHire || (Core.CarHire = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var CrossSellOption = /** @class */ (function () {
            function CrossSellOption(bookingId, crossSellType, priceIsPerPerson, teaserPrice) {
                this.BookingId = 0;
                this.PriceIsPerPerson = false;
                this.TeaserPrice = 0;
                this.BookingId = bookingId;
                this.CrossSellType = crossSellType;
                this.PriceIsPerPerson = priceIsPerPerson;
                this.TeaserPrice = teaserPrice;
            }
            return CrossSellOption;
        }());
        Customer.CrossSellOption = CrossSellOption;
        var CrossSellProductOption = /** @class */ (function (_super) {
            __extends(CrossSellProductOption, _super);
            function CrossSellProductOption(bookingId, crossSellType, priceIsPerPerson, teaserPrice, imageUrl, productDetails, title) {
                var _this = _super.call(this, bookingId, crossSellType, priceIsPerPerson, teaserPrice) || this;
                _this.ImageUrl = imageUrl;
                _this.ProductDetails = productDetails;
                _this.Title = title;
                return _this;
            }
            return CrossSellProductOption;
        }(CrossSellOption));
        Customer.CrossSellProductOption = CrossSellProductOption;
        var CrossSellHotelOption = /** @class */ (function (_super) {
            __extends(CrossSellHotelOption, _super);
            function CrossSellHotelOption(bookingId, crossSellType, priceIsPerPerson, teaserPrice, imageUrl, productDetails, title, hotel) {
                var _this = _super.call(this, bookingId, crossSellType, priceIsPerPerson, teaserPrice, imageUrl, productDetails, title) || this;
                _this.Hotel = hotel;
                return _this;
            }
            return CrossSellHotelOption;
        }(CrossSellProductOption));
        Customer.CrossSellHotelOption = CrossSellHotelOption;
        var CrossSellFlightExtraOption = /** @class */ (function (_super) {
            __extends(CrossSellFlightExtraOption, _super);
            function CrossSellFlightExtraOption(bookingId, crossSellType, priceIsPerPerson, teaserPrice, url) {
                var _this = _super.call(this, bookingId, crossSellType, priceIsPerPerson, teaserPrice) || this;
                _this.Url = url;
                return _this;
            }
            return CrossSellFlightExtraOption;
        }(CrossSellOption));
        Customer.CrossSellFlightExtraOption = CrossSellFlightExtraOption;
        // this is used for mix-panel analytics
        var DashboardTileType;
        (function (DashboardTileType) {
            DashboardTileType[DashboardTileType["SignIn"] = 0] = "SignIn";
            DashboardTileType[DashboardTileType["Trip"] = 1] = "Trip";
            DashboardTileType[DashboardTileType["Search"] = 2] = "Search";
            DashboardTileType[DashboardTileType["Destination"] = 3] = "Destination";
            DashboardTileType[DashboardTileType["LastHotel"] = 4] = "LastHotel";
            DashboardTileType[DashboardTileType["CrossSellHotels"] = 5] = "CrossSellHotels";
            DashboardTileType[DashboardTileType["CrossSellAttractions"] = 6] = "CrossSellAttractions";
            DashboardTileType[DashboardTileType["CrossSellTransfers"] = 7] = "CrossSellTransfers";
            DashboardTileType[DashboardTileType["CrossSellCarHire"] = 8] = "CrossSellCarHire";
            DashboardTileType[DashboardTileType["CrossSellSeats"] = 9] = "CrossSellSeats";
            DashboardTileType[DashboardTileType["CrossSellBaggage"] = 10] = "CrossSellBaggage";
            DashboardTileType[DashboardTileType["InsuranceOption"] = 11] = "InsuranceOption";
            DashboardTileType[DashboardTileType["InsuranceClaim"] = 12] = "InsuranceClaim";
            DashboardTileType[DashboardTileType["InsuranceConf"] = 13] = "InsuranceConf";
            DashboardTileType[DashboardTileType["TravelGuide"] = 14] = "TravelGuide";
            DashboardTileType[DashboardTileType["ContactUs"] = 15] = "ContactUs";
            DashboardTileType[DashboardTileType["ReviewHotel"] = 16] = "ReviewHotel";
            DashboardTileType[DashboardTileType["AppPromo"] = 17] = "AppPromo";
            DashboardTileType[DashboardTileType["InspirationalContent"] = 18] = "InspirationalContent";
        })(DashboardTileType = Customer.DashboardTileType || (Customer.DashboardTileType = {}));
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Destinations;
    (function (Destinations) {
        var DestinationType;
        (function (DestinationType) {
            DestinationType[DestinationType["Establishment"] = 1] = "Establishment";
            DestinationType[DestinationType["Location"] = 2] = "Location";
            DestinationType[DestinationType["Province"] = 3] = "Province";
            DestinationType[DestinationType["Country"] = 4] = "Country";
            DestinationType[DestinationType["Place"] = 5] = "Place";
            DestinationType[DestinationType["Polygon"] = 10] = "Polygon";
            DestinationType[DestinationType["Universal"] = 12] = "Universal";
        })(DestinationType = Destinations.DestinationType || (Destinations.DestinationType = {}));
    })(Destinations = Core.Destinations || (Core.Destinations = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Flights;
    (function (Flights) {
        var DetailsResponseCode;
        (function (DetailsResponseCode) {
            DetailsResponseCode[DetailsResponseCode["Success"] = 0] = "Success";
            DetailsResponseCode[DetailsResponseCode["Unavailable"] = 1] = "Unavailable";
        })(DetailsResponseCode = Flights.DetailsResponseCode || (Flights.DetailsResponseCode = {}));
        var SortCriterion;
        (function (SortCriterion) {
            SortCriterion[SortCriterion["None"] = 0] = "None";
            SortCriterion[SortCriterion["PriceLowToHigh"] = 1] = "PriceLowToHigh";
            SortCriterion[SortCriterion["PriceHighToLow"] = 2] = "PriceHighToLow";
            SortCriterion[SortCriterion["Airline"] = 3] = "Airline";
            SortCriterion[SortCriterion["DepartureTimeEarlyToLate"] = 4] = "DepartureTimeEarlyToLate";
            SortCriterion[SortCriterion["DepartureTimeLateToEarly"] = 5] = "DepartureTimeLateToEarly";
            SortCriterion[SortCriterion["ReturnTimeEarlyToLate"] = 6] = "ReturnTimeEarlyToLate";
            SortCriterion[SortCriterion["ReturnTimeLateToEarly"] = 7] = "ReturnTimeLateToEarly";
            SortCriterion[SortCriterion["TotalJourneyTimeLongestFirst"] = 8] = "TotalJourneyTimeLongestFirst";
            SortCriterion[SortCriterion["TotalJourneyShortestLongestFirst"] = 9] = "TotalJourneyShortestLongestFirst";
            SortCriterion[SortCriterion["Convenience"] = 10] = "Convenience";
        })(SortCriterion = Flights.SortCriterion || (Flights.SortCriterion = {}));
        var FareType;
        (function (FareType) {
            FareType[FareType["NotSpecified"] = 0] = "NotSpecified";
            FareType[FareType["Published"] = 1] = "Published";
            FareType[FareType["Private"] = 2] = "Private";
            FareType[FareType["Package"] = 3] = "Package";
        })(FareType = Flights.FareType || (Flights.FareType = {}));
        var OptionalExtraGroupType;
        (function (OptionalExtraGroupType) {
            OptionalExtraGroupType[OptionalExtraGroupType["Baggage"] = 0] = "Baggage";
            OptionalExtraGroupType[OptionalExtraGroupType["Meal"] = 1] = "Meal";
            OptionalExtraGroupType[OptionalExtraGroupType["Other"] = 2] = "Other";
            OptionalExtraGroupType[OptionalExtraGroupType["SpecialBaggage"] = 3] = "SpecialBaggage";
            OptionalExtraGroupType[OptionalExtraGroupType["CheckIn"] = 4] = "CheckIn";
        })(OptionalExtraGroupType = Flights.OptionalExtraGroupType || (Flights.OptionalExtraGroupType = {}));
        var Cabin;
        (function (Cabin) {
            Cabin[Cabin["NotSpecified"] = 0] = "NotSpecified";
            Cabin[Cabin["Economy"] = 1] = "Economy";
            Cabin[Cabin["PremiumEconomy"] = 2] = "PremiumEconomy";
            Cabin[Cabin["First"] = 3] = "First";
            Cabin[Cabin["Business"] = 4] = "Business";
        })(Cabin = Flights.Cabin || (Flights.Cabin = {}));
    })(Flights = Core.Flights || (Core.Flights = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Hotels;
    (function (Hotels) {
        var GroupType;
        (function (GroupType) {
            GroupType[GroupType["Facilities"] = 1] = "Facilities";
            GroupType[GroupType["HolidayType"] = 2] = "HolidayType";
        })(GroupType = Hotels.GroupType || (Hotels.GroupType = {}));
        var BoardType;
        (function (BoardType) {
            BoardType[BoardType["Mixed"] = 0] = "Mixed";
            BoardType[BoardType["RoomOnly"] = 1] = "RoomOnly";
            BoardType[BoardType["BedAndBreakfast"] = 2] = "BedAndBreakfast";
            BoardType[BoardType["HalfBoard"] = 3] = "HalfBoard";
            BoardType[BoardType["FullBoard"] = 4] = "FullBoard";
            BoardType[BoardType["AllInclusive"] = 5] = "AllInclusive";
            BoardType[BoardType["SelfCatering"] = 6] = "SelfCatering";
        })(BoardType = Hotels.BoardType || (Hotels.BoardType = {}));
        var SupplierDiscountType;
        (function (SupplierDiscountType) {
            SupplierDiscountType[SupplierDiscountType["None"] = 1] = "None";
            SupplierDiscountType[SupplierDiscountType["Mobile"] = 2] = "Mobile";
            SupplierDiscountType[SupplierDiscountType["Promotional"] = 3] = "Promotional";
        })(SupplierDiscountType = Hotels.SupplierDiscountType || (Hotels.SupplierDiscountType = {}));
        var AwardType;
        (function (AwardType) {
            AwardType[AwardType["Winner"] = 1] = "Winner";
            AwardType[AwardType["BestIn"] = 2] = "BestIn";
        })(AwardType = Hotels.AwardType || (Hotels.AwardType = {}));
        var BookingPath;
        (function (BookingPath) {
            BookingPath[BookingPath["HotelOnly"] = 1] = "HotelOnly";
            BookingPath[BookingPath["Holiday"] = 2] = "Holiday";
            BookingPath[BookingPath["HotelDeal"] = 3] = "HotelDeal";
            BookingPath[BookingPath["HolidayDeal"] = 4] = "HolidayDeal";
            BookingPath[BookingPath["MetaHotelOnly"] = 5] = "MetaHotelOnly";
            BookingPath[BookingPath["MetaHoliday"] = 6] = "MetaHoliday";
        })(BookingPath = Hotels.BookingPath || (Hotels.BookingPath = {}));
        var BoostReason;
        (function (BoostReason) {
            BoostReason[BoostReason["UserClickPrimary"] = 1] = "UserClickPrimary";
            BoostReason[BoostReason["UserClickSecondary"] = 2] = "UserClickSecondary";
            BoostReason[BoostReason["UserClickTertiary"] = 3] = "UserClickTertiary";
            BoostReason[BoostReason["UserClickOther"] = 4] = "UserClickOther";
            BoostReason[BoostReason["TopSlot"] = 5] = "TopSlot";
            BoostReason[BoostReason["Recommended"] = 6] = "Recommended";
        })(BoostReason = Hotels.BoostReason || (Hotels.BoostReason = {}));
    })(Hotels = Core.Hotels || (Core.Hotels = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ManageBooking;
    (function (ManageBooking) {
        var BookingStatus;
        (function (BookingStatus) {
            BookingStatus[BookingStatus["Pending"] = 1] = "Pending";
            BookingStatus[BookingStatus["Receipted"] = 2] = "Receipted";
            BookingStatus[BookingStatus["Ticketed"] = 4] = "Ticketed";
            BookingStatus[BookingStatus["Complete"] = 5] = "Complete";
            BookingStatus[BookingStatus["CancelledByClient"] = 6] = "CancelledByClient";
            BookingStatus[BookingStatus["Void"] = 7] = "Void";
            BookingStatus[BookingStatus["HoldAwaitingConfirmation"] = 8] = "HoldAwaitingConfirmation";
            BookingStatus[BookingStatus["DeclinedByEstab"] = 9] = "DeclinedByEstab";
            BookingStatus[BookingStatus["ConfirmedByEstab"] = 10] = "ConfirmedByEstab";
            BookingStatus[BookingStatus["CancellationConfirmedByEstab"] = 11] = "CancellationConfirmedByEstab";
            BookingStatus[BookingStatus["CancellationDeclinedByEstab"] = 12] = "CancellationDeclinedByEstab";
            BookingStatus[BookingStatus["FailedSecurityCheck"] = 13] = "FailedSecurityCheck";
            BookingStatus[BookingStatus["HoldSupplierSwap"] = 14] = "HoldSupplierSwap";
            BookingStatus[BookingStatus["AutoAccepted"] = 15] = "AutoAccepted";
            BookingStatus[BookingStatus["PriceUp"] = 16] = "PriceUp";
            BookingStatus[BookingStatus["NotAvailable"] = 17] = "NotAvailable";
            BookingStatus[BookingStatus["AwaitingCustomerResponse"] = 18] = "AwaitingCustomerResponse";
            BookingStatus[BookingStatus["Migrated"] = 19] = "Migrated";
        })(BookingStatus = ManageBooking.BookingStatus || (ManageBooking.BookingStatus = {}));
        var BookingInfoItemType;
        (function (BookingInfoItemType) {
            BookingInfoItemType[BookingInfoItemType["Invalid"] = 0] = "Invalid";
            BookingInfoItemType[BookingInfoItemType["Generic"] = 1] = "Generic";
            BookingInfoItemType[BookingInfoItemType["CancellationCondition"] = 2] = "CancellationCondition";
            BookingInfoItemType[BookingInfoItemType["PublishedNote"] = 3] = "PublishedNote";
            BookingInfoItemType[BookingInfoItemType["BaggageInformation"] = 4] = "BaggageInformation";
            BookingInfoItemType[BookingInfoItemType["TerminalInformation"] = 5] = "TerminalInformation";
            BookingInfoItemType[BookingInfoItemType["FareRules"] = 6] = "FareRules";
            BookingInfoItemType[BookingInfoItemType["OutboundFlights"] = 7] = "OutboundFlights";
            BookingInfoItemType[BookingInfoItemType["InboundFlights"] = 8] = "InboundFlights";
            BookingInfoItemType[BookingInfoItemType["SpecialOffer"] = 9] = "SpecialOffer";
            BookingInfoItemType[BookingInfoItemType["BookingCondition"] = 10] = "BookingCondition";
        })(BookingInfoItemType = ManageBooking.BookingInfoItemType || (ManageBooking.BookingInfoItemType = {}));
        var ItineraryType;
        (function (ItineraryType) {
            ItineraryType[ItineraryType["FlightOutbound"] = 1] = "FlightOutbound";
            ItineraryType[ItineraryType["FlightInbound"] = 2] = "FlightInbound";
            ItineraryType[ItineraryType["CarHire"] = 3] = "CarHire";
            ItineraryType[ItineraryType["HotelRoom"] = 4] = "HotelRoom";
            ItineraryType[ItineraryType["AttractionTicket"] = 5] = "AttractionTicket";
            ItineraryType[ItineraryType["FlightInfo"] = 6] = "FlightInfo";
            ItineraryType[ItineraryType["CarParking"] = 7] = "CarParking";
            ItineraryType[ItineraryType["TransferArrival"] = 8] = "TransferArrival";
            ItineraryType[ItineraryType["TransferReturn"] = 9] = "TransferReturn";
            ItineraryType[ItineraryType["Insurance"] = 10] = "Insurance";
            ItineraryType[ItineraryType["PackageHoliday"] = 11] = "PackageHoliday";
            ItineraryType[ItineraryType["Marhaba"] = 13] = "Marhaba";
            ItineraryType[ItineraryType["Bundle"] = 14] = "Bundle";
            ItineraryType[ItineraryType["PointToPointTransfer"] = 15] = "PointToPointTransfer";
            ItineraryType[ItineraryType["AdHoc"] = 16] = "AdHoc";
        })(ItineraryType = ManageBooking.ItineraryType || (ManageBooking.ItineraryType = {}));
        var BookingType;
        (function (BookingType) {
            BookingType[BookingType["Flight"] = 1] = "Flight";
            BookingType[BookingType["AttractionTickets"] = 2] = "AttractionTickets";
            BookingType[BookingType["CarHire"] = 4] = "CarHire";
            BookingType[BookingType["Accommodation"] = 8] = "Accommodation";
            BookingType[BookingType["TailorMadeHoliday"] = 9] = "TailorMadeHoliday";
            BookingType[BookingType["Parking"] = 16] = "Parking";
            BookingType[BookingType["Transfer"] = 32] = "Transfer";
            BookingType[BookingType["TravelInsurance"] = 64] = "TravelInsurance";
            BookingType[BookingType["PackageHolidays"] = 128] = "PackageHolidays";
            BookingType[BookingType["Marhaba"] = 256] = "Marhaba";
            BookingType[BookingType["CruiseHolidays"] = 512] = "CruiseHolidays";
            BookingType[BookingType["Bundle"] = 1024] = "Bundle";
            BookingType[BookingType["AdHoc"] = 2048] = "AdHoc";
        })(BookingType = ManageBooking.BookingType || (ManageBooking.BookingType = {}));
    })(ManageBooking = Core.ManageBooking || (Core.ManageBooking = {}));
})(Core || (Core = {}));
var Quote;
(function (Quote) {
    var QuoteProductType;
    (function (QuoteProductType) {
        QuoteProductType[QuoteProductType["Accommodation"] = 0] = "Accommodation";
        QuoteProductType[QuoteProductType["Flight"] = 1] = "Flight";
        QuoteProductType[QuoteProductType["Transfer"] = 2] = "Transfer";
        QuoteProductType[QuoteProductType["AirportParking"] = 3] = "AirportParking";
        QuoteProductType[QuoteProductType["AttractionTicket"] = 4] = "AttractionTicket";
        QuoteProductType[QuoteProductType["CarHire"] = 5] = "CarHire";
    })(QuoteProductType = Quote.QuoteProductType || (Quote.QuoteProductType = {}));
    var CreateQuoteResponseCode;
    (function (CreateQuoteResponseCode) {
        CreateQuoteResponseCode[CreateQuoteResponseCode["Success"] = 0] = "Success";
        CreateQuoteResponseCode[CreateQuoteResponseCode["Unknown"] = 1] = "Unknown";
    })(CreateQuoteResponseCode = Quote.CreateQuoteResponseCode || (Quote.CreateQuoteResponseCode = {}));
})(Quote || (Quote = {}));
var Core;
(function (Core) {
    var Trip;
    (function (Trip) {
        var TripType;
        (function (TripType) {
            TripType[TripType["None"] = 0] = "None";
            TripType[TripType["Flight"] = 1] = "Flight";
            TripType[TripType["Hotel"] = 2] = "Hotel";
            TripType[TripType["Transfer"] = 3] = "Transfer";
            TripType[TripType["Holiday"] = 4] = "Holiday";
            TripType[TripType["Marhaba"] = 5] = "Marhaba";
            TripType[TripType["AirportParking"] = 6] = "AirportParking";
            TripType[TripType["Attractions"] = 7] = "Attractions";
            TripType[TripType["DynamicPackage"] = 8] = "DynamicPackage";
            TripType[TripType["Insurance"] = 9] = "Insurance";
        })(TripType = Trip.TripType || (Trip.TripType = {}));
    })(Trip = Core.Trip || (Core.Trip = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var BookingComplete = /** @class */ (function () {
        function BookingComplete($location, $routeParams, $scope, $window, agentModeService, analytics, broker) {
            var _this = this;
            this.$location = $location;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.$window = $window;
            this.agentModeService = agentModeService;
            this.analytics = analytics;
            this.broker = broker;
            this._initPage();
            this.payLaterEnabled = TRPCONFIG.Domain.BuyNowPayLaterEnabled && this.$location.search().pl === '1';
            if (TRPCONFIG.Domain.isAgentMode) {
                var bookingId = this.$routeParams.ref.split('|')[0];
                if (bookingId && bookingId.split('/')[1]) {
                    agentModeService.getBookingContact(bookingId.split('/')[1]).then(function (result) {
                        _this.bookingSummarySurname = result.LastName;
                    });
                }
            }
            if (TRPCONFIG.Domain.HideBookingRefOnConfirmation) {
                this.$location.replace();
                this.$location.url('booking/complete');
            }
            if ((this.$routeParams.paypal === 'true') && this.$routeParams.tripData) {
                var tripData = JSON.parse(decodeURIComponent(this.$routeParams.tripData));
                this.analytics.track('eCommercePaypal', 'purchase', tripData);
            }
            if (sessionStorage.getItem('eCommercePurchaseData')) {
                var purchaseData = JSON.parse(sessionStorage.getItem('eCommercePurchaseData') || '{}');
                this.$window.dataLayer.push(purchaseData);
                sessionStorage.removeItem('eCommercePurchaseData');
            }
        }
        BookingComplete.prototype._initPage = function () {
            var _this = this;
            this.broker.publish('unblock');
            this.$scope.$emit('unblock');
            this.broker.subscribe('bookingComplete', 'lightboxOpened', function () { return _this.lightboxOpened = true; });
            this.broker.subscribe('bookingComplete', 'lightboxCloseClicked', function () { return _this.lightboxOpened = false; });
            this.broker.subscribe('bookingComplete', 'manageBookingClicked', function () { return _this.manageBookingStarted = true; });
            this.manageBookingStarted = false;
        };
        return BookingComplete;
    }());
    angular
        .module('core')
        .controller('BookingComplete', BookingComplete);
})(Core || (Core = {}));
var Core;
(function (Core) {
    /**
     * If we receive a route that does not match any of our static routes
     * we will end up here. We will then call an api to check whether this is
     * a dynamic route of some kind. If we still don't understand the route
     * just send the user to the home page.
     */
    var DynamicRouting = /** @class */ (function () {
        function DynamicRouting($location, publicityService, broker) {
            var _this = this;
            this.$location = $location;
            this.publicityService = publicityService;
            this.broker = broker;
            this.minimalRoutes = [
                /^\/famous-film-locations$/,
                /^\/famous-film-locations\/.+/
            ];
            publicityService.getStats({
                StatisticTypes: 'All'
            }).then(function (data) {
                _this.data = {
                    numberOfAirlines: data.AirlineCount.Value,
                    numberOfHotels: data.EstabCount.Value,
                    bookingsLastHour: data.BookingsInLastHour.Value,
                    customersCurrentlyOnHoliday: data.CustomersCurrentlyOnHoliday.Value,
                    reviewCount: data.ReviewCount.Value,
                    searchesInLastHour: data.SearchesInLastHour.Value,
                    villaCount: data.VillaCount.Value
                };
            });
            this.template = "cms/page" + $location.path();
            var path = $location.path();
            var minimal = this.minimalRoutes.reduce(function (matched, re) { return matched || re.test(path); }, false);
            this.template = "cms/page" + path;
            if (minimal) {
                broker.publish('stripHeader');
                broker.publish('hideFooter');
            }
        }
        return DynamicRouting;
    }());
    angular
        .module('core')
        .controller('DynamicRouting', DynamicRouting);
})(Core || (Core = {}));
var Core;
(function (Core) {
    var CmsPageProps = /** @class */ (function () {
        function CmsPageProps($rootScope) {
            this.$rootScope = $rootScope;
        }
        CmsPageProps.prototype.$onInit = function () {
            this.$rootScope.$broadcast('cmsPageProps', {
                pageName: this.pageName
            });
        };
        return CmsPageProps;
    }());
    angular
        .module('core')
        .directive('cmsPageProps', function () {
        return {
            restrict: 'E',
            controller: CmsPageProps,
            controllerAs: 'cmsCtrl',
            bindToController: {
                pageName: '@'
            },
            template: ""
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var MultiSectorFlight = /** @class */ (function () {
        function MultiSectorFlight(broker) {
            this.broker = broker;
        }
        MultiSectorFlight.prototype.isSameCarrierOnAllSegments = function (flightSector) {
            return flightSector.Segments.every(function (s) { return s.CodeshareAirlineName === s.CarrierName; });
        };
        MultiSectorFlight.prototype.showModalFlightDetails = function (flightSector) {
            this.broker.publish('showModalFlightDetails', { flight: { Legs: [flightSector] } });
        };
        return MultiSectorFlight;
    }());
    angular
        .module('core')
        .directive('multiSectorFlight', function () {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                legs: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=multisectorflight',
            controller: MultiSectorFlight,
            controllerAs: 'msf'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AbTestSelector = /** @class */ (function () {
        function AbTestSelector(cookieService) {
            this.cookieService = cookieService;
            this.bindableTests = JSON.parse(this.tests);
            this.bindableTests.forEach(function (t) {
                var cookie = cookieService.get(t.CookieName);
                t.variant = cookie ? parseInt(cookie, 10) : 0;
            });
        }
        AbTestSelector.prototype.update = function () {
            var _this = this;
            this.bindableTests.forEach(function (t) {
                _this.cookieService.set(t.CookieName, t.variant, t.variant === 0 ? new Date() : null);
            });
        };
        AbTestSelector.prototype.numArray = function (i) {
            return new Array(i);
        };
        return AbTestSelector;
    }());
    angular
        .module('core')
        .directive('abTestSelector', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            bindToController: {
                tests: '@'
            },
            controller: AbTestSelector,
            controllerAs: 'abt',
            templateUrl: 'partials/home/directivetemplate?type=AbTestSelector'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AD_FORM_FLAGS = {
        HOTEL_SEARCH_PAGE: 'hotelSearchPage',
        EVERY_PAGE: 'everyPage',
        NEWSLETTER_SIGN_UP_SUCCESS: 'newsletterSignUpSuccess',
        PAYMENT_DETAILS_PAGE: 'paymentDetailsPage',
        BOOKING_COMPLETE_PAGE: 'bookingCompletePage',
        BOOKING_OPTIONS_PAGE: 'bookingOptionsPage',
        HOTEL_SELECTED_PAGE: 'hotelSelectedPage'
    };
    var AdFormService = /** @class */ (function () {
        function AdFormService() {
            this.flags = [];
            this.flags = AdFormService.getFlags();
        }
        AdFormService.prototype.isEnabledFlag = function (flagName) {
            return this.flags.indexOf(flagName) !== -1;
        };
        ;
        AdFormService.getFlags = function () {
            if (TRPCONFIG.Domain && TRPCONFIG.Domain.AdFormTrackingFlags instanceof Array) {
                return TRPCONFIG.Domain.AdFormTrackingFlags.map(function (flagName) { return flagName.trim(); });
            }
            return [];
        };
        ;
        AdFormService.prototype.isNewsletterSignUpEventEnabled = function () {
            return this.isEnabledFlag(AD_FORM_FLAGS.NEWSLETTER_SIGN_UP_SUCCESS);
        };
        ;
        AdFormService.prototype.getTrackingId = function () {
            return TRPCONFIG.Domain.AdFormTrackingId;
        };
        return AdFormService;
    }());
    Core.AdFormService = AdFormService;
    angular
        .module('core')
        .constant('AD_FORM_FLAGS', AD_FORM_FLAGS)
        .service('adFormService', AdFormService);
})(Core || (Core = {}));
// This directive is to delay the loading of all AdForm Tracking scripts
// until after AngularJS has has a change to load itself.
var Core;
(function (Core) {
    var AdFormController = /** @class */ (function () {
        function AdFormController($element, $timeout, adFormService) {
            this.$element = $element;
            this.$timeout = $timeout;
            this.adFormService = adFormService;
        }
        AdFormController.prototype.$onInit = function () {
            var _this = this;
            if (this.adFormService.isEnabledFlag(this.flagName)) {
                this.$timeout(function () {
                    var script = "<script src=\"" + _this.script + "\" async></script>";
                    _this.$element.append(script);
                }, 1000);
            }
        };
        return AdFormController;
    }());
    angular
        .module('core')
        .directive('adForm', function () {
        return {
            restrict: 'E',
            controllerAs: 'af',
            scope: {},
            bindToController: {
                script: '@',
                flagName: '@'
            },
            controller: AdFormController
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AddFlightDetailsModal = /** @class */ (function () {
        function AddFlightDetailsModal($scope, broker, mandatoryTransferService) {
            this.$scope = $scope;
            this.broker = broker;
            this.mandatoryTransferService = mandatoryTransferService;
            this.transfers = [];
            this.hotel = $scope.hotel;
        }
        AddFlightDetailsModal.prototype.init = function (container) {
            var _this = this;
            this.broker.subscribe('modalAddFlightDetails', 'showModalAddFlightDetails', function (e) {
                _this.transfers = _this.mandatoryTransferService.getTransfers(e.data.roomInfo.Extras || []);
                _this.includedTransfer = _this.mandatoryTransferService
                    .findSelectedTransfer(_this.transfers, e.data.roomInfo.IncludedExtras);
                _this.flightDetails.transfer = _this.includedTransfer || _this.transfers[0];
                _this.roomId = e.data.roomId;
                _this.priceId = [e.data.priceId];
                _this.show = true;
                _this.multipleRoomMode = false;
                _this.priceMode = e.data.priceMode;
                _this.totalNonInfants = e.data.totalNonInfants;
                _this.roomCost = e.data.roomInfo.TotalCost;
            });
            this.broker.subscribe('modalAddFlightDetails', 'showModalAddFlightDetailsForMultiRooms', function (e) {
                _this.show = true;
                _this.multipleRoomMode = true;
                _this.priceMode = e.data.priceMode;
                _this.roomsWithTransfers = e.data.rooms;
                _this.includedTransfer = [];
                _this.flightDetails.transfers = [];
                _this.transfers = [];
                _this.transferExtras = [];
                _this.includedTransfer = [];
                _this.priceId = [];
                for (var i = 0; i < _this.roomsWithTransfers.length; i++) {
                    _this.flightDetails.transfers[i] = _this.mandatoryTransferService
                        .findSelectedTransfer(_this.roomsWithTransfers.mandatoryTransfers, _this.roomsWithTransfers[i].IncludedExtras)
                        || _this.roomsWithTransfers[i].mandatoryTransfers[0];
                    _this.transfers = _this.roomsWithTransfers[i].mandatoryTransfers ||
                        _this.roomsWithTransfers[i].IncludedExtras;
                    _this.priceId.push(_this.roomsWithTransfers[i].Id);
                    _this.transferExtras = _this.mandatoryTransferService.getTransfers(_this.roomsWithTransfers[i].Extras || []);
                    _this.includedTransfer[i] = _this.mandatoryTransferService
                        .findSelectedTransfer(_this.transferExtras, _this.roomsWithTransfers[i].IncludedExtras);
                }
            });
            this.broker.subscribe('modalAddFlightDetails', 'HotelAvailabilityReceive', function (e) {
                _this.hotel.Availability = e.data.Availability;
            });
            this.broker.subscribe('modalAddFlightDetails', 'roomsSet', function (e) {
                _this.hotel.Availability = e.data.RequestedRooms[0].Availability;
            });
            this.$scope.$on('$destroy', function () {
                _this.broker.unsubscribe('modalAddFlightDetails');
            });
        };
        AddFlightDetailsModal.prototype.continueToBook = function () {
            if (!this.multipleRoomMode) {
                this.broker.publish('continueToBookFromFlightDetailsModal', {
                    roomId: this.roomId,
                    priceId: this.priceId,
                    flightDetails: this.flightDetails
                });
                this.mandatoryTransferService.generateMandatoryOptions(this.roomId, this.flightDetails);
            }
            else {
                this.flightDetails.options = this.mandatoryTransferService
                    .generateOptionsForMultiRooms(this.flightDetails, this.roomsWithTransfers);
                this.mandatoryTransferService.generateMandatoryOptions(this.roomId, this.flightDetails);
                this.broker.publish('continueToBookFromFlightDetailsModal', {
                    multipleRoomMode: this.multipleRoomMode,
                    flightDetails: this.flightDetails,
                    priceId: this.priceId
                });
            }
        };
        return AddFlightDetailsModal;
    }());
    angular
        .module('core')
        .directive('addFlightDetailsModal', function () {
        return {
            scope: { hotel: '=' },
            controller: AddFlightDetailsModal,
            controllerAs: 'afdc',
            templateUrl: 'partials/home/directivetemplate?type=AddFlightDetailsModal',
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AtolCostBreakdown = /** @class */ (function () {
        function AtolCostBreakdown($scope, tripService, $routeParams) {
            var _this = this;
            this.$scope = $scope;
            this.tripService = tripService;
            this.$routeParams = $routeParams;
            var killTheWatch = $scope.$watchCollection(function () { return _this.costs; }, function (val) {
                if (val) {
                    var costs = _.groupBy(_this.costs, 'AtolProtected');
                    _this.atolProtectedCosts = costs['true'];
                    _this.otherCosts = costs['false'];
                    _this.total = _this.sumCosts(_this.costs);
                    _this.atolSubTotal = _this.sumCosts(_this.atolProtectedCosts);
                    _this.setClientCurrencyCode();
                    killTheWatch();
                }
            });
        }
        AtolCostBreakdown.prototype.sumCosts = function (costs) {
            if (costs) {
                return costs.reduce(function (sum, item) { return sum + item.Quantity * item.UnitAmount; }, 0);
            }
            return 0;
        };
        AtolCostBreakdown.prototype.setClientCurrencyCode = function () {
            var _this = this;
            if (this.costs && (this.costs.length >= 1)) {
                if (this.costs[0].ClientCurrencyCode) {
                    this.clientCurrencyCode = this.costs[0].ClientCurrencyCode;
                }
                else {
                    this.tripService.getCurrency(this.$routeParams.tripId).then(function (currency) {
                        _this.clientCurrencyCode = currency;
                    });
                }
            }
        };
        return AtolCostBreakdown;
    }());
    angular
        .module('core')
        .directive('atolCostBreakdown', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            bindToController: {
                costs: '=',
                totalLabel: '@',
                atolSubtotalLabel: '@'
            },
            controller: AtolCostBreakdown,
            controllerAs: 'acb',
            templateUrl: 'partials/home/atolcostbreakdown'
        };
    });
})(Core || (Core = {}));
var Search;
(function (Search) {
    var AutoSearch = /** @class */ (function () {
        function AutoSearch(basketService, unifiedSearchService, destinationService, searchQueryString, urlUtils, $scope, resourceService) {
            this.basketService = basketService;
            this.unifiedSearchService = unifiedSearchService;
            this.destinationService = destinationService;
            this.searchQueryString = searchQueryString;
            this.urlUtils = urlUtils;
            this.$scope = $scope;
            this.resourceService = resourceService;
        }
        AutoSearch.prototype.search = function ($event) {
            var _this = this;
            if ($event) {
                $event.preventDefault();
            }
            if (this.href && this.href.length > 0) {
                var index = this.href.indexOf('?');
                if (index > 0) {
                    this.$scope.$emit('block', {
                        title: this.resourceService.get('SEARCHINGHOTELS'),
                        subtitle: this.resourceService.get('THISMAYTAKE'),
                        loadingScreenStyle: 'default-searchUnitCtrl'
                    });
                    this.href = this.href.slice(index + 1);
                    var queryParams_1 = { type: '0', id: '0' };
                    queryParams_1 = this.urlUtils.splitQs(this.href || '');
                    if (parseInt(queryParams_1.type, 10) >= 0 && parseInt(queryParams_1.id, 10) >= 0) {
                        this.destinationService.enhanceLegacyDestination({
                            LegacyType: queryParams_1.type,
                            LegacyId: queryParams_1.id
                        })
                            .then(this.destinationService.getDetails)
                            .then(function (dest) {
                            _this.requestModel = _this.unifiedSearchService.getDefaultModel();
                            _this.searchQueryString.getQueryStringValues(queryParams_1).then(function (queryStringValues) {
                                _this.requestParams = queryStringValues;
                                _this.requestParams.destination = [dest];
                                _this.unifiedSearchService.populateSearchUnitService(_this.requestParams);
                                _this.basketService.startWorkflow(_this.basketService.autoSearch, _this.requestParams);
                            });
                        });
                    }
                }
            }
        };
        ;
        return AutoSearch;
    }());
    angular
        .module('core')
        .directive('autoSearch', function () {
        return {
            replace: true,
            restrict: 'A',
            transclude: true,
            scope: {},
            bindToController: {
                href: '@'
            },
            controller: AutoSearch,
            controllerAs: 'autosearch',
            template: '<div ng-click="autosearch.search($event)" ng-transclude></div>'
        };
    });
})(Search || (Search = {}));
/*
    Creates an autocompleter field.
    Results are exposed as `ac.data`.
*/
var Autocompleter;
(function (Autocompleter_1) {
    var Autocompleter = /** @class */ (function (_super) {
        __extends(Autocompleter, _super);
        function Autocompleter($scope, $element, $parse, $route, autocompleter, resourceService, $timeout, $q) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$element = $element;
            _this.$parse = $parse;
            _this.$route = $route;
            _this.autocompleter = autocompleter;
            _this.resourceService = resourceService;
            _this.$timeout = $timeout;
            _this.$q = $q;
            _this.setPrefixDebounced = _.debounce(function (prefix) {
                _this.prefix = prefix;
                $scope.$apply();
            }, 100);
            // Watch for initial value
            _this.$scope.$watchCollection('ac.currentValue', function (value) {
                var selected = _.isArray(value) ? value[0] : value;
                if (selected) {
                    var title = selected[_this.titleProp];
                    if (title) {
                        _this.setPrefixDebounced(title);
                    }
                }
                else {
                    _this.prefix = '';
                }
            });
            // Wrap `select` attribute fn
            _this.selectAttrFn = _this.select;
            _this.select = function (item) {
                _this.selectAttrFn({ item: item });
                _this.selectItem(item);
            };
            _this.titleProp = _this.titleProp || 'Title';
            // set focus on input field when required
            _this.$scope.$watch(function () { return _this.setFocus; }, function (value) {
                if (value === true) {
                    _this.$timeout(function () {
                        _this.inputField && _this.inputField.focus();
                    });
                }
            });
            return _this;
        }
        Autocompleter.prototype.focus = function () {
            if (TRPCONFIG.Domain.AllowZeroInputDestinationAutocompleter
                && TRPCONFIG.Domain.DeviceType === 'Desktop'
                && (this.prefix === '' || this.prefix === undefined)) {
                this.fetch();
            }
        };
        Autocompleter.prototype.update = function (result) {
            var data = result.data, area = this.getArea();
            if (['businesscustomers', 'travelAgents', 'coworkers', 'userAccounts'].indexOf(area) > -1) {
                this.data = data;
            }
            else if (['transfers', 'flights', 'flights-departure', 'marhaba', 'parking'].indexOf(area) > -1) {
                this.data = this.addHeader(data, 'AIRPORTS');
            }
            else if (area === 'resorts') {
                this.data = this.addHeader(data, 'RESORTSPLUSHOTELS');
            }
            else {
                this.data = this._groupHotelResults(data);
            }
            if (!this.data || !this.data.length) {
                this.data = null;
                this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        };
        Autocompleter.prototype.selectItem = function (item) {
            if (item && item[this.titleProp]) {
                angular.isArray(this.currentValue) ? this.currentValue[0] = item : this.currentValue = item;
            }
        };
        Autocompleter.prototype.blur = function () {
            var _this = this;
            this.setFocus = false;
            // timeout is to prevent blur firing immediately before we select a menu item
            this.$timeout(function () {
                if (!_this.prefix &&
                    !TRPCONFIG.Domain.AllowZeroInputDestinationAutocompleter &&
                    TRPCONFIG.Domain.DeviceType !== 'Desktop') {
                    // we have no prefix so clear the current value
                    angular.isArray(_this.currentValue) ? _this.currentValue.length = 0 : delete _this.currentValue;
                    return;
                }
                if (!_this.data || !_this.data.length) {
                    // no data
                    return;
                }
                var value = _this.currentValue && _this.currentValue[0] || _this.currentValue, title = value && value[_this.titleProp], isCurrentValueInMenu = _.some(_this.data, function (d) { return d[_this.titleProp] === title; });
                if (!isCurrentValueInMenu) {
                    // current value is not in our data so select the first option
                    var firstItem = _.find(_this.data, function (d) { return !d.header; });
                    if (firstItem) {
                        _this.select(angular.copy(firstItem));
                        return;
                    }
                }
                if (title) {
                    // set the autcompleter text to match the current value
                    _this.setPrefixDebounced(title);
                }
            }, 200);
        };
        Autocompleter.prototype._groupHotelResults = function (data) {
            var hotels = [];
            var destinations = [];
            angular.forEach(data, function (item) {
                if (item.EstablishmentId !== 0) {
                    hotels.push(item);
                }
                else {
                    destinations.push(item);
                }
            });
            return this.addHeader(destinations, 'DESTINATIONS')
                .concat(this.addHeader(hotels, 'HOTELS'));
        };
        return Autocompleter;
    }(Autocompleter_1.AutocompleterField));
    angular
        .module('TR')
        .directive('autocompleter', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'ac',
            bindToController: {
                placeholder: '@',
                select: '&',
                deselect: '&',
                setFocus: '=?',
                currentValue: '=?',
                areaOverride: '@',
                focusTracker: '=',
                minPrefix: '@',
                notActive: '@',
                titleProp: '@',
                filterFunction: '&?',
                iconName: '@?'
            },
            templateUrl: 'partials/home/directivetemplate?type=Autocompleter',
            controller: Autocompleter,
            transclude: true,
            link: function (scope, el) {
                scope.ac.inputField = el.find('input');
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
/*
    Displays recommendations on an autocompleter field.
    Requires `autocompleter` directive as parent.
*/
var Autocompleter;
(function (Autocompleter) {
    var AutocompleterRecommendations = /** @class */ (function () {
        function AutocompleterRecommendations($scope, $route, $timeout, $q, resourceService, autocompleter, houseRecommender) {
            this.$scope = $scope;
            this.$route = $route;
            this.$timeout = $timeout;
            this.$q = $q;
            this.resourceService = resourceService;
            this.autocompleter = autocompleter;
            this.houseRecommender = houseRecommender;
            this.acMethods = {};
        }
        AutocompleterRecommendations.prototype.init = function (ac) {
            this.parentCtrl = ac;
            this._wrapAcMethod('focus', this.load);
            this._wrapAcMethod('select', this.select);
        };
        AutocompleterRecommendations.prototype.load = function () {
            var _this = this;
            if (this.allow()) {
                this.fetch().then(function (destinations) {
                    if (destinations) {
                        _this.$timeout(function () {
                            if (_this.allow()) {
                                // Set `data` on autocompleter
                                _this.parentCtrl.data = destinations;
                            }
                            // Set `initialData` on autocompleter
                            // Repopulates menu when no search term i.e. <3 chars
                            _this.parentCtrl.initialData = destinations;
                            _this._unwrapAcMethod('focus');
                        });
                    }
                });
            }
        };
        AutocompleterRecommendations.prototype.select = function (dest) {
            var _this = this;
            if (dest && this.allow()) {
                var currentArea = this.$route.current ? this.$route.current.area : '';
                var ac_1 = this.parentCtrl;
                var area = ac_1.areaOverride || currentArea;
                var destTitle = dest && dest.Title;
                if (destTitle) {
                    ac_1.loading = true;
                    ac_1.prefix = destTitle;
                    ac_1.data = null;
                    // Fetch autocompleter item data on select
                    this.autocompleter.lookup(area, destTitle)
                        .then(function (res) {
                        var item = res && res.data && res.data[0];
                        if (item) {
                            // Call original non-wrapped method
                            _this.acMethods.select(item);
                            _this.houseRecommender.trackHouseClick(dest);
                        }
                        else {
                            ac_1.prefix = '';
                            ac_1.data = null;
                            ac_1.$emit('flash:error', _this.resourceService.get('NOMATCHES'));
                        }
                        ac_1.loading = false;
                    });
                }
                return true; // Block wrapped ac.select()
            }
        };
        AutocompleterRecommendations.prototype.allow = function () {
            var prefix = this.parentCtrl.prefix;
            return !prefix || prefix.length < this.parentCtrl.minPrefix;
        };
        AutocompleterRecommendations.prototype.fetch = function () {
            var _this = this;
            // `houseRecommendationService` has its own caching
            return this.houseRecommender.getHouseRecs()
                .then(function (dests) {
                var destinations = _.filter(dests, function (d) { return d.searchable && (!_this.isHoliday || (_this.isHoliday && d.holidayEnabled)); });
                if (destinations && destinations.length) {
                    destinations.splice(0, 0, {
                        Title: _this.resourceService.get('RECOMMENDED'),
                        header: true
                    });
                    _this.recommendationType = dests[0].Type;
                    return _.map(destinations, function (d) {
                        if (!d.header) {
                            d.Title = d.title;
                            d.EstablishmentCount = d.estabCount;
                        }
                        return d;
                    });
                }
            });
        };
        AutocompleterRecommendations.prototype._wrapAcMethod = function (method, fn) {
            var _this = this;
            // Original method doesn't run if `fn()` returns `true`
            var m = this.parentCtrl[method];
            if (m) {
                this.acMethods[method] = m;
            }
            this.parentCtrl[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var v = fn.apply(_this, args);
                if (m && v !== true) {
                    return m.apply(_this.parentCtrl, args);
                }
            };
        };
        AutocompleterRecommendations.prototype._unwrapAcMethod = function (method) {
            var m = this.acMethods[method];
            if (m) {
                delete this.acMethods[method];
            }
            this.parentCtrl[method] = m; // May be undefined
        };
        return AutocompleterRecommendations;
    }());
    ;
    angular
        .module('TR')
        .directive('autocompleterRecommendations', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: AutocompleterRecommendations,
            controllerAs: 'acr',
            bindToController: {
                isHoliday: '='
            },
            require: '^autocompleter',
            link: function (scope, el, attr, autocompleterCtrl) {
                scope.acr.init(autocompleterCtrl);
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
var Dashboard;
(function (Dashboard) {
    var BaggageOptions = /** @class */ (function () {
        function BaggageOptions($scope) {
            var _this = this;
            this.$scope = $scope;
            this.loading = true;
            var bagOptionsWatch = this.$scope.$watch('cm.bagOptions', function (val) {
                if (val) {
                    _this.maxBagsSelectable = _this.bagOptions && _this.bagOptions.length || 0;
                    var bag = _.minBy(_this.bagOptions, 'UnitAmount');
                    if (bag) {
                        _this.bagsTeaserCost = bag.UnitAmount / 2;
                        _this.holdBaggageWeight = bag.UnitWeightKg || TRPCONFIG.Domain.DashboardHoldBaggageWeight;
                    }
                    bagOptionsWatch();
                    _this.loading = false;
                }
            }, true);
        }
        BaggageOptions.prototype.updateBaggageOptions = function () {
            var selectedBagOptionsRaw = this.bagOptions.slice(0, this.bagsSelected);
            this.flightBaggageTotal = _(selectedBagOptionsRaw).sumBy('UnitAmount');
            this.selectedBagOptions = (selectedBagOptionsRaw.map(function (so) { return ({ OptionId: so.OptionId, ChosenQuantity: 1 }); }));
        };
        return BaggageOptions;
    }());
    angular
        .module('core')
        .component('baggageOptions', {
        bindings: {
            bagOptions: '=',
            handBaggageInformation: '=',
            flightBaggageTotal: '=',
            selectedBagOptions: '='
        },
        controller: BaggageOptions,
        controllerAs: 'cm',
        templateUrl: 'partials/home/baggageoptions'
    });
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .directive('baseStaticMap', baseStaticMap);
    var template = "\n    <div>\n        <lightbox class=\"lightbox-map\" show=\"showModal\" close=\"close()\">\n            <div class=\"map-canvas\" style=\"z-index: 1\"> </div>\n        </lightbox>\n    </div>\n";
    function baseStaticMap($window, $compile, $rootScope, currentDestination, mapLabel, broker, hotelRehydrator, hotelStaticMapService, maps) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                zoom: '=',
                hideLabels: '@'
            },
            template: template,
            link: function (scope, el) {
                maps.loadScript(_.bind(_linker, {}, scope, el));
            }
        };
        function _linker(scope, el) {
            scope.ready = true;
            var Label = mapLabel($window.google);
            var infoWindow = new google.maps.InfoWindow();
            var labels = [];
            currentDestination.getCurrentDestination().then(function (destination) {
                broker.subscribe('hotelStaticMap', 'MAPLIGHTBOX', _.bind(buildMap, {}, destination));
                scope.$on('$destroy', function () {
                    broker.unsubscribe('hotelStaticMap');
                });
            });
            function buildMap(destination) {
                scope.showModal = true;
                scope.close = function () {
                    scope.showModal = false;
                };
                var map = new google.maps.Map(el.find('.map-canvas')[0], {
                    zoom: scope.zoom || destination.ZoomLevel,
                    scrollwheel: true,
                    overviewMapControl: false,
                    center: new google.maps.LatLng(destination.Latitude, destination.Longitude),
                    mapTypeControl: false,
                    streetViewControl: true,
                    scaleControl: true
                });
                google.maps.event.addListenerOnce(map, 'idle', function () {
                    setTimeout(function () {
                        google.maps.event.trigger(map, 'resize');
                        map.setCenter(new google.maps.LatLng(destination.Latitude, destination.Longitude));
                    }, 500);
                });
                google.maps.event.addListener(map, 'idle', function () {
                    var zoom = map.getZoom();
                    var loadedBounds = map.getBounds();
                    var sw = loadedBounds.getSouthWest();
                    var ne = loadedBounds.getNorthEast();
                    var url = "?X1=" + sw.lng() + "&Y1=" + sw.lat() + "&X2=" + ne.lng() + "&Y2=" + ne.lat() + "&Z=" + zoom;
                    hotelStaticMapService.getMarkers(url).then(function (res) {
                        if (scope.hideLabels !== 'true') {
                            _clearLabels();
                            generateLabels(res.data.Markers, map);
                        }
                    });
                });
            }
            function generateLabels(points, map) {
                for (var i = 0, ii = points.length; i < ii; i++) {
                    var p = points[i];
                    var key = _getKey(p);
                    var markerLabel = new Label({
                        map: map,
                        visible: true,
                        position: new google.maps.LatLng(p.Y, p.X, true),
                        text: p.N
                    }, key, p.N);
                    markerLabel.clickHandler =
                        p.N === 1 ?
                            _.bind(hotelClickHandler, markerLabel, p.Id, map) :
                            _.bind(clusterClickHandler, markerLabel, p, map);
                    labels.push(markerLabel);
                }
            }
            function clusterClickHandler(point, map) {
                var sw = new google.maps.LatLng(point.B.Y1, point.B.X1);
                var ne = new google.maps.LatLng(point.B.Y2, point.B.X2);
                var bds = new google.maps.LatLngBounds(sw, ne);
                map.fitBounds(bds);
            }
            function hotelClickHandler(estabId, map) {
                infoWindow.close();
                infoWindow.setContent('<div class="hotel-info-window-loader"> </div>');
                infoWindow.open(map, this);
                hotelRehydrator.hotel(estabId).then(function (h) {
                    var t = '<info-window></info-window>';
                    var s = $rootScope.$new(true);
                    s.hotel = h;
                    infoWindow.setContent($compile(t)(s)[0]);
                });
            }
            function _clearLabels() {
                for (var i = 0, ii = labels.length; i < ii; i++) {
                    labels[i].visible = false;
                }
                labels.length = 0;
                broker.publish('CHANGEDLABELVISIBILITY');
            }
            function _getKey(point) {
                return (point.X + "__" + point.Y + "__" + point.N + "__" + point.T).replace(/\./g, '_');
            }
        }
    }
})();
var Core;
(function (Core) {
    var BasicContentCard = /** @class */ (function () {
        function BasicContentCard() {
        }
        return BasicContentCard;
    }());
    angular
        .module('core')
        .directive('basicContentCard', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: BasicContentCard,
            controllerAs: 'bcc',
            transclude: true,
            bindToController: {
                click: '&',
                header: '@',
                overlay: '@',
                imageUrl: '@',
                href: '@',
                contentCardClass: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=BasicContentCard'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .directive('blogSection', function () {
        return {
            restrict: 'E',
            templateUrl: function (tElement, tAttrs) {
                return "partials/home/directivetemplate?type=LandingPage/BlogSection&search=" + tAttrs.search;
            },
            link: function ($scope, element) {
                $scope.posts = [];
                var raw = element.find('.blog-post-raw');
                raw.children()
                    .each(function () {
                    var e = $(this);
                    var imgStyle = e.find('.search-image-inner').attr('style');
                    var imgFeatured = e.find('.post-featured-image-inner')
                        .attr('style');
                    var image = imgStyle ? imgStyle : imgFeatured || '';
                    var blogSummaryText = e.find('.entry-summary p').text();
                    var blogEntryContent = e.find('.entry-content p').text();
                    var blogText = (blogSummaryText) ? blogSummaryText : blogEntryContent || '';
                    var blogElipsis = blogText.slice(0, 150) + (blogText.length > 150 ? '...' : '') || '';
                    $scope.posts.push({
                        imgSrc: image ? image.match(/['"](.*)['"]/)[1] : '',
                        heading: e.find('h4 a').text() || '',
                        text: blogElipsis,
                        href: e.find('h4 a').attr('href') || '',
                    });
                });
                raw.remove();
            },
        };
    });
})(Core || (Core = {}));
/**
 * Created by bdickson on 15/06/2016.
 */
var TR;
(function (TR) {
    var BookingExtrasOption = /** @class */ (function () {
        function BookingExtrasOption() {
        }
        return BookingExtrasOption;
    }());
    angular
        .module('TR')
        .directive('bookingExtrasOption', function () {
        return {
            scope: {},
            bindToController: {
                model: '=',
                val: '=',
                group: '@',
                price: '=',
                perPerson: '=',
                showFrom: '=',
                showTotal: '=',
                priceTotal: '=',
                pricePerDay: '=',
                isDelta: '=?',
                priceFull: '=?',
                included: '=?',
                priceRounded: '=?'
            },
            controller: BookingExtrasOption,
            controllerAs: 'beo',
            templateUrl: 'partials/home/directivetemplate?type=BookingExtrasOption',
            transclude: true,
            replace: true
        };
    });
})(TR || (TR = {}));
var Core;
(function (Core) {
    var BookingSummary = /** @class */ (function () {
        function BookingSummary($q, $routeParams, $scope, analytics, basketStore, broker, hotelFromSession, tripService, taxationService, costBreakdownCodes, occupancyService, cookieService, modalService) {
            var _this = this;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.analytics = analytics;
            this.basketStore = basketStore;
            this.broker = broker;
            this.hotelFromSession = hotelFromSession;
            this.tripService = tripService;
            this.taxationService = taxationService;
            this.costBreakdownCodes = costBreakdownCodes;
            this.occupancyService = occupancyService;
            this.cookieService = cookieService;
            this.modalService = modalService;
            this.isMultiDestHoliday = false;
            this.cityTaxTypeId = 22; // typeId of cityTax product in cost breakdown list
            this.voucherDiscountMsg = { Message: '', Code: 0 };
            this.voucherSuccessMsg = '';
            this.isDiscountMsgPositive = false;
            this.mandatoryTransferTypeId = 23;
            this.hotelExtrasTypeIds = [1, 23, 24, 25, 26];
            this.mandatoryTransfersCost = 0;
            this.voucherDiscountMsg = JSON.parse(cookieService.get('VoucherWarnMessage')
                || '{ "Message": "", "Code": 0 }') || { Message: '', Code: 0 };
            switch (this.voucherDiscountMsg.Code) {
                case 3:
                    this.voucherSuccessMsg = 'Promotional discount applied';
                    this.isDiscountMsgPositive = true;
                    break;
                case 5:
                    this.voucherSuccessMsg = 'Voucher code discount updated';
                    this.isDiscountMsgPositive = true;
                    break;
                case 6:
                    this.voucherSuccessMsg = 'Voucher code discount applied';
                    this.isDiscountMsgPositive = true;
                    break;
                case 7:
                    this.voucherSuccessMsg = 'Voucher code discount removed';
                    this.isDiscountMsgPositive = true;
                    break;
                default:
                    this.voucherSuccessMsg = '';
                    this.isDiscountMsgPositive = false;
                    break;
            }
            this.changeFlightEnabled = this.changeFlightEnabled === 'true';
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                _this.isHolidayType = trip.TripType === tripService.tripTypes.Holiday;
                if (trip && trip.BasketId) {
                    _this.trip = trip;
                    //we can have two ever so slightly different modes that this directive is used in
                    //1. as part of a holiday booking search
                    //2. as part of a quote which has no trip info just a basket
                    //we need to remove the reliance on the trip if possible
                    _this.getProductInfo(trip.BasketId, $routeParams.tripId);
                    _this.getCostBreakdown(trip.BasketId);
                    //checks we have a number of optional attributes, so here are some rules
                    //to keep us in check
                    if (_.isUndefined(_this.cardFeeForDeposit) !== _.isUndefined(_this.cardFeeForTotal)) {
                        throw Error('BookingSummary directive, both CardFee attributes should be supplied or neither.');
                    }
                    // Multi destination holidays, 'change flight' starts a new workflow which needs a loading screen
                    if (trip && trip.HotelsRequest && trip.HotelsRequest.Destinations) {
                        _this.isMultiDestHoliday = true;
                    }
                }
            });
            this.showContinueButton = !!this.continueToNextStep;
            var init = function (basketId, tripId) {
                _this.getProductInfo(basketId, tripId);
                _this.getCostBreakdown(basketId);
                broker.subscribe('BookingSummary', 'basketUpdated', function () {
                    _this.getCostBreakdown(basketId);
                    _this.updateFlightInfo(basketId);
                });
                broker.subscribe('BookingSummary', 'updatePricesOnPUP', function (e) {
                    _this.getCostBreakdown(basketId);
                    _this.updateFlightInfo(basketId);
                });
                $scope.$on('$destroy', function () {
                    broker.unsubscribe('BookingSummary');
                });
                if (tripId) {
                    //need to override the package price setting to show flight cost breakdown
                    _this.tripService.usePackageRates(tripId)
                        .then(function (packagePrice) { return _this.packagePrice = packagePrice; });
                    _this.modifyEssentialsRoute = "/holidays/options/" + _this.tripId;
                }
                if (!_this.priceDifference) {
                    _this.priceDifference = 0;
                }
            };
            if (!$routeParams.tripId && this.basketId && this.tripId) {
                init(this.basketId, this.tripId);
            }
            else {
                tripService.getTrip($routeParams.tripId).then(function (trip) {
                    if (trip && trip.BasketId) {
                        init(trip.BasketId, trip.TripId);
                    }
                });
            }
            this.quoteRef = $routeParams.quoteRef;
            this.quoteNo = $routeParams.quoteNo;
        }
        BookingSummary.prototype.getProductInfo = function (basketId, tripId) {
            var _this = this;
            this.$q.all([
                this.basketStore.all(basketId),
                this.tripService.getTripReducedOccupancy(tripId)
            ]).then(function (results) {
                var basket = results[0];
                if (basket.h) {
                    var hotelFromBasket_1 = basket.h;
                    _this.hotelFromSession.getHotel(hotelFromBasket_1.AvailabilitySearchId, hotelFromBasket_1.Details.Id, tripId)
                        .then(function (hotel) {
                        _this.hotel = angular.extend(hotel, hotelFromBasket_1);
                    });
                }
                _this.occupancy = results[1];
                _this.flight = basket.f;
                _this.attraction = basket.a;
                _this.carhire = basket.c;
                _this.insurance = basket.i;
                _this.parking = basket.p;
                _this.transfer = basket.t;
            });
            this.updateFlightInfo(basketId);
            this.updateHotelInfo(basketId);
        };
        BookingSummary.prototype.updateFlightInfo = function (basketId) {
            var _this = this;
            return this.basketStore.flight(basketId)
                .then(function (flight) {
                if (!flight) {
                    return;
                }
                _this.flight = flight;
                _this.flightCostBreakdown = flight.CostBreakdown;
                //remove atol cost from flight cost breakdown
                var atol = _.find(_this.flightCostBreakdown, function (item) {
                    return item.Description.indexOf('ATOL') >= 0;
                });
                if (atol) {
                    _this.flightCostBreakdown = _.filter(_this.flightCostBreakdown, function (item) { return item !== atol; });
                }
                return;
            });
        };
        BookingSummary.prototype.updateHotelInfo = function (basketId) {
            var _this = this;
            return this.basketStore.hotel(basketId)
                .then(function (hotel) {
                if (!hotel) {
                    return;
                }
                var costType = {
                    Unknown: 0,
                    Accommodation: 1,
                    Discount: 20,
                    AccommodationCancellationProtection: 21,
                    AccommodationLocalFeesAndTaxes: 22,
                    AccommodationExtraTransfer: 23,
                    AccommodationExtraEvent: 24,
                    AccommodationExtraAttraction: 25,
                    AccommodationExtra: 26,
                };
                var costBreakdown = hotel.CostBreakdown;
                var extraCostItems = costBreakdown.filter(function (cost) {
                    var match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') ===
                        (costType.AccommodationExtraTransfer ||
                            costType.AccommodationExtraEvent ||
                            costType.AccommodationExtraAttraction ||
                            costType.AccommodationExtra ||
                            costType.AccommodationLocalFeesAndTaxes ||
                            costType.AccommodationCancellationProtection ||
                            costType.Discount);
                    return match;
                }).filter(function (extra) { return extra; });
                var roomCostItems = costBreakdown.filter(function (cost) { return !_.get(cost, 'ParentId')
                    && _.get(cost, 'TypeId') === costType.Accommodation; }).map(function (room, LinkId) {
                    return __assign({}, room, { LinkId: LinkId });
                });
                if (extraCostItems && extraCostItems.length > 0 && roomCostItems && roomCostItems.length > 0) {
                    var updatedRoomCostItems_1 = roomCostItems.map(function (room) {
                        return { RoomId: room.Id, RoomDescription: room.Description };
                    });
                    var enhancedExtras = extraCostItems.map(function (extras) {
                        return __assign({}, extras, updatedRoomCostItems_1.find(function (acc) { return acc.RoomId === extras.ParentId; }));
                    });
                    var updatedExtrasCostItems = enhancedExtras.map(function (extra, LinkId) {
                        var splitDescription = _.get(extra, 'RoomDescription').toString().split('(');
                        var Description = splitDescription[1] ?
                            extra.Description + " (" + splitDescription[1] :
                            extra.Description;
                        return __assign({}, extra, { Description: Description,
                            LinkId: LinkId });
                    });
                    var updatedCostBreakdown = roomCostItems.concat(updatedExtrasCostItems);
                    var costsSortedById = updatedCostBreakdown.sort(function (a, b) { return (a.LinkId >= b.LinkId) ? 1 : -1; });
                    _this.hotelCostBreakdown = costsSortedById;
                }
                else {
                    _this.hotelCostBreakdown = hotel.CostBreakdown.filter(function (item) {
                        return _this.hotelExtrasTypeIds.indexOf(item.TypeId) !== -1;
                    });
                }
                _this.hotelExtrasCostBreakdown = _this.hotelCostBreakdown.filter(function (item) { return item.TypeId !== 1; });
                return;
            });
        };
        BookingSummary.prototype.getCostBreakdown = function (basketId) {
            var _this = this;
            this.$q.all([
                this.basketStore.totalDiscount(basketId),
                this.basketStore.totalDeposit(basketId, this.$routeParams.ProductId),
                this.basketStore.costBreakdownGrouped(basketId),
                this.basketStore.rules(basketId, this.$routeParams.ProductId),
                this.basketStore.payDirectTotal(basketId),
                this.basketStore.carHire(basketId),
                this.basketStore.isAtolProtected(basketId),
                this.basketStore.attractionCost(basketId)
            ]).then(function (_a) {
                var totalDiscount = _a[0], totalDeposit = _a[1], costBreakdownGrouped = _a[2], rules = _a[3], payDirectTotal = _a[4], carHire = _a[5], isAtolProtected = _a[6], attractionsCost = _a[7];
                _this.totalDiscount = totalDiscount;
                _this.totalDeposit = totalDeposit;
                _this.costBreakdown = costBreakdownGrouped;
                _this.totalCost = costBreakdownGrouped.total;
                _this.atolAvailable = isAtolProtected;
                _this.attractionsCost = attractionsCost;
                _.each(_this.costBreakdown, function (cb) {
                    if (cb.group === 1) {
                        // HOTEL
                        _this.hotelCost = cb.costBreakdown
                            .reduce(function (totalCost, currentHotel) {
                            return totalCost
                                + (currentHotel.UnitAmount > 0
                                    ? currentHotel.UnitAmount
                                    : (currentHotel.TypeId !== 20 ? currentHotel.UnitAmount : 0));
                        }, 0); /* id: 20 is discounts */
                        _this.cancellationProtection = _.get(cb.costBreakdown.find(function (cost) {
                            return cost.TypeId === _this.costBreakdownCodes.CancellationProtection;
                        }), 'UnitAmount', 0);
                        _this.covidProtectionCover = _.get(cb.costBreakdown.find(function (cost) {
                            return cost.TypeId === 30;
                        }), 'UnitAmount');
                        _this.tax = cb.costBreakdown
                            .reduce(function (totalCost, currentHotel) {
                            return totalCost + (currentHotel.TypeId === _this.cityTaxTypeId ? currentHotel.UnitAmount : 0);
                        }, 0);
                        if (_this.tax && _this.tax > 0) {
                            _this.hotelCost = _this.hotelCost - _this.tax;
                        }
                        if (_this.cancellationProtection) {
                            _this.hotelCost = _this.hotelCost - _this.cancellationProtection;
                        }
                        if (_this.covidProtectionCover) {
                            _this.hotelCost = _this.hotelCost - _this.covidProtectionCover;
                        }
                        _this.mandatoryTransfersCost = cb.costBreakdown
                            .reduce(function (totalCost, currentHotel) {
                            return totalCost + (currentHotel.TypeId === _this.mandatoryTransferTypeId ?
                                currentHotel.UnitAmount : 0);
                        }, 0);
                    }
                    else if (cb.group === 2) {
                        // FLIGHTS
                        // Isolate the ATOL cost
                        // Ideally we would be able to search by type but we have to use the description
                        var atol = _.find(cb.costBreakdown, function (item) {
                            return item.Description.indexOf('ATOL') >= 0;
                        });
                        if (atol) {
                            _this.atolCost = atol.UnitAmount * atol.Quantity;
                            _this.flightCost = cb.total - _this.atolCost; // subtract the atol cost from the flights total
                        }
                        else {
                            _this.flightCost = cb.total;
                        }
                    }
                    else if (cb.group === 3) {
                        // EXTRAS
                        _this.extrasCost = cb.total;
                        _this.extras = _this.basketStore.extrasBreakdown(cb.costBreakdown);
                    }
                });
                _this.hasDeposit = rules.depositAllowed;
                _this.hasPayDirect = payDirectTotal > 0;
                var carHireExtras = _.get(carHire, 'RequestedItems');
                _this.carHireExtras = carHireExtras;
                _this.carHireExtrasTotal = carHireExtras ?
                    carHireExtras.reduce(function (total, extra) { return total += extra.UnitAmount; }, 0) :
                    undefined;
            });
        };
        BookingSummary.prototype.editEssentials = function () {
            this.analytics.track('mixpanel', 'EmailMeEditQuote');
        };
        BookingSummary.prototype.showDetails = function (e) {
            var passengers = this.occupancyService.getTotalPeopleCounts();
            e.preventDefault();
            this.broker.publish('showModalFlightDetails', { flight: this.flight.Details.Itinerary, passengers: passengers });
        };
        BookingSummary.prototype.modal = function (url) {
            this.modalService.launch(url);
        };
        return BookingSummary;
    }());
    angular
        .module('core')
        .directive('bookingSummary', function () {
        return {
            scope: {},
            restrict: 'E',
            bindToController: {
                basketId: '=?',
                tripId: '=?',
                cardFeeForDeposit: '=?',
                cardFeeForTotal: '=?',
                changeFlightEnabled: '@?',
                continueToNextStep: '&?',
                occupancy: '=?',
                //for quotes we also watch out for price changes and tell the user so enable that functionality if
                //set. (i know not great but short of duplicating all of this code it seems like the best thing to do)
                priceDifference: '=?',
                modifyEssentials: '=?',
                currencyCode: '=',
                showAncillaries: '@?'
            },
            controller: BookingSummary,
            controllerAs: 'hbs',
            replace: true,
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=BookingSummary&version='
                        + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=BookingSummary';
            }
        };
    });
})(Core || (Core = {}));
var ekh;
(function (ekh) {
    var ONE_SEVEN = !!TRPCONFIG.Rtl ? '‎7 x 1' : '1 x 7';
    var TWO_SEVEN = !!TRPCONFIG.Rtl ? '‎7 x 2' : '2 x 7';
    var ONE_TWO_THREE = !!TRPCONFIG.Rtl ? '‎23 x 1' : '1 x 23';
    var TWO_TWO_THREE = !!TRPCONFIG.Rtl ? '‎23 x 2' : '2 x 23';
    var TWO_THREE_TWO = !!TRPCONFIG.Rtl ? '‎32 x 2' : '2 x 32';
    var TransformedType;
    (function (TransformedType) {
        TransformedType[TransformedType["EconomySpecial"] = 0] = "EconomySpecial";
        TransformedType[TransformedType["EconomySaver"] = 1] = "EconomySaver";
        TransformedType[TransformedType["EconomyFlex"] = 2] = "EconomyFlex";
        TransformedType[TransformedType["EconomyFlexPlus"] = 3] = "EconomyFlexPlus";
        TransformedType[TransformedType["BusinessSpecial"] = 4] = "BusinessSpecial";
        TransformedType[TransformedType["BusinessSaver"] = 5] = "BusinessSaver";
        TransformedType[TransformedType["BusinessFlex"] = 6] = "BusinessFlex";
        TransformedType[TransformedType["BusinessFlexPlus"] = 7] = "BusinessFlexPlus";
        TransformedType[TransformedType["FirstSaver"] = 8] = "FirstSaver";
        TransformedType[TransformedType["FirstFlex"] = 9] = "FirstFlex";
        TransformedType[TransformedType["FirstFlexPlus"] = 10] = "FirstFlexPlus";
        TransformedType[TransformedType["NotDefined"] = 11] = "NotDefined";
    })(TransformedType = ekh.TransformedType || (ekh.TransformedType = {}));
    var AttributeTypes;
    (function (AttributeTypes) {
        AttributeTypes[AttributeTypes["Baggage"] = 0] = "Baggage";
        AttributeTypes[AttributeTypes["CabinBaggage"] = 1] = "CabinBaggage";
        AttributeTypes[AttributeTypes["SeatsSelection"] = 2] = "SeatsSelection";
        AttributeTypes[AttributeTypes["Meals"] = 3] = "Meals";
        AttributeTypes[AttributeTypes["WiFi"] = 4] = "WiFi";
        AttributeTypes[AttributeTypes["Refundable"] = 5] = "Refundable";
        AttributeTypes[AttributeTypes["Changes"] = 6] = "Changes";
        AttributeTypes[AttributeTypes["PriorityCheckin"] = 7] = "PriorityCheckin";
        AttributeTypes[AttributeTypes["FastTrack"] = 8] = "FastTrack";
    })(AttributeTypes = ekh.AttributeTypes || (ekh.AttributeTypes = {}));
    var BrandedFareTypesService = /** @class */ (function () {
        function BrandedFareTypesService(resourceService) {
            this.resourceService = resourceService;
        }
        BrandedFareTypesService.prototype.transform = function (brandedFareType) {
            var _this = this;
            var flightSectors = brandedFareType.FlightSectors.map(function (fs) {
                fs.TransformedType = _this._getTransformedType(fs.BrandTitle);
                fs.BaggageType = _this._getBaggageType(fs);
                fs.BaggageText = _this.getBaggage(fs);
                fs.CabinBaggageText = _this.getCabinBaggage(fs);
                fs.ChauffeurText = _this.getChauffeur(fs);
                fs.SeatsSelectionText = _this.getSeatsSelection(fs);
                return fs;
            });
            var brandedFareTypePrice = this.getBrandedFareTypePrice(brandedFareType);
            return __assign({}, brandedFareType, { FlightSectors: flightSectors, BrandedFareTypeTotalPrice: brandedFareTypePrice });
        };
        BrandedFareTypesService.prototype.squeeze = function (brandedfareTypes) {
            var _this = this;
            return brandedfareTypes.reduce(function (prev, curBf) {
                if (prev.length) {
                    var lastBf = prev.slice(-1)[0];
                    var sectorFirstEqual = _this._isEqualFlightSectors(lastBf.FlightSectors[0], curBf.FlightSectors[0]);
                    var sectorSecondEqual = _this._isEqualFlightSectors(lastBf.FlightSectors[1], curBf.FlightSectors[1]);
                    if (!sectorFirstEqual || !sectorSecondEqual) {
                        prev.push(curBf);
                    }
                }
                else {
                    prev.push(curBf);
                }
                return prev;
            }, []);
        };
        BrandedFareTypesService.prototype._isEqualFlightSectors = function (oneFs, secondFs) {
            var props = [
                'BaggageText',
                'CabinBaggageText',
                'SeatsSelectionText',
                'ChauffeurText'
            ];
            var res = true;
            for (var i = 0; i < props.length; ++i) {
                var propName = props[i];
                if (oneFs[propName] !== secondFs[propName]) {
                    res = false;
                    break;
                }
            }
            return res;
        };
        BrandedFareTypesService.prototype.getBrandedFareTypePrice = function (brandedFareType) {
            if (brandedFareType.TotalAmount) {
                return brandedFareType.TotalAmount;
            }
            var adultPrice = this._getPricePerPassengerAge('Adult', brandedFareType);
            var childPrice = this._getPricePerPassengerAge('Child', brandedFareType);
            var infantPrice = this._getPricePerPassengerAge('Infant', brandedFareType);
            return adultPrice + childPrice + infantPrice;
        };
        BrandedFareTypesService.prototype._getPricePerPassengerAge = function (type, brandedFareType) {
            var fare = _.get(brandedFareType, type + "Fare.Amount") || 0;
            var fareQuantity = _.get(brandedFareType.priceQuantities, type + "FareQuantity") || 0;
            var tax = _.get(brandedFareType, type + "Tax.Amount") || 0;
            var taxQuantity = _.get(brandedFareType.priceQuantities, type + "TaxQuantity") || 0;
            return fare * fareQuantity + tax * taxQuantity;
        };
        BrandedFareTypesService.prototype.getBaggage = function (sector) {
            switch (sector.BaggageType) {
                case 'ONE_TWO_THREE':
                    return ONE_TWO_THREE + " " + this.resourceService.get('BRANDED_FARE_TYPES_KGPP');
                case 'PIECE_CONCEPT':
                    return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_PIECE_CONCEPT');
                case 'TWO_TWO_THREE':
                    return TWO_TWO_THREE + " " + this.resourceService.get('BRANDED_FARE_TYPES_KGPP');
                case 'TWO_THREE_TWO':
                    return TWO_THREE_TWO + " " + this.resourceService.get('BRANDED_FARE_TYPES_KGPP');
                case 'NOT_INCLUDED':
                    return this.resourceService.get('BRANDED_FARE_TYPES_BAGGAGE_NOT_INCLUDED');
                default:
                    return sector.BaggageType + " " + this.resourceService.get('BRANDED_FARE_TYPES_KGPP');
            }
        };
        BrandedFareTypesService.prototype._getBaggageType = function (sector) {
            var attr = this._getAttribute(sector, AttributeTypes.Baggage);
            var checkedMatcher = attr.Text.match(/^Checked[^\d]+(\d+)kg/);
            var cabin = this._getCabin(sector);
            var isEconomySaver = sector.TransformedType === TransformedType.EconomySaver;
            var isEconomySpecial = sector.TransformedType === TransformedType.EconomySpecial;
            if (attr.AttributeInclusionType === 0) {
                switch (true) {
                    case checkedMatcher !== null:
                        return checkedMatcher[1];
                    case cabin === 1 && isEconomySpecial:
                        return 'ONE_TWO_THREE';
                    case cabin === 1 && isEconomySaver:
                        return 'PIECE_CONCEPT';
                    case cabin === 1:
                        return 'TWO_TWO_THREE';
                    default:
                        return 'TWO_THREE_TWO';
                }
            }
            else {
                return 'NOT_INCLUDED';
            }
        };
        BrandedFareTypesService.prototype.getCabinBaggage = function (sector) {
            var cabin = this._getCabin(sector);
            var attr = this._getAttribute(sector, AttributeTypes.CabinBaggage);
            return attr.AttributeInclusionType === 0 && cabin === 1 ?
                ONE_SEVEN + " " + this.resourceService.get('BRANDED_FARE_TYPES_KGPP') :
                TWO_SEVEN + " " + this.resourceService.get('BRANDED_FARE_TYPES_KGPP');
        };
        BrandedFareTypesService.prototype.getSeatsSelection = function (sector) {
            if (this.isRestrictedSeats(sector)) {
                return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_SELECTION_RESTRICTED');
            }
            var attr = this._getAttribute(sector, AttributeTypes.SeatsSelection);
            if (attr.AttributeInclusionType === 0) {
                return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_SELECTION_COMPLIMENTARY');
            }
            else {
                return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_SELECTION_AT_CHECK_IN');
            }
        };
        BrandedFareTypesService.prototype.isRestrictedSeats = function (sector) {
            var attr = this._getAttribute(sector, AttributeTypes.SeatsSelection);
            return attr.AttributeInclusionType === 0 && sector.TransformedType === TransformedType.BusinessSpecial;
        };
        BrandedFareTypesService.prototype.getChauffeur = function (sector) {
            var cabin = this._getCabin(sector);
            return sector.TransformedType === TransformedType.BusinessSpecial || cabin === 1 ?
                this.resourceService.get('BRANDED_FARE_TYPES_CHAUFFEUR_NOT_ELIGIBLE') :
                this.resourceService.get('BRANDED_FARE_TYPES_CHAUFFEUR_ELIGIBLE');
        };
        BrandedFareTypesService.prototype.containPieceBaggageConcept = function (fareTypes, sectorNumber) {
            var res = false;
            for (var i = 0; i < fareTypes.length; ++i) {
                var sector = fareTypes[i].FlightSectors[sectorNumber];
                if (sector.BaggageType === 'PIECE_CONCEPT') {
                    res = true;
                    break;
                }
            }
            return res;
        };
        BrandedFareTypesService.prototype._getCabin = function (sector) {
            return sector.Segments[0].Cabin;
        };
        BrandedFareTypesService.prototype._getAttribute = function (leg, attrType) {
            return _.find(leg.BrandAttributes, { AttributeType: attrType });
        };
        BrandedFareTypesService.prototype._getTransformedType = function (brandTitle) {
            switch (brandTitle.trim().toLowerCase()) {
                case 'economy special':
                    return TransformedType.EconomySpecial;
                case 'economy saver':
                    return TransformedType.EconomySaver;
                case 'economy flex':
                    return TransformedType.EconomyFlex;
                case 'economy flex plus':
                    return TransformedType.EconomyFlexPlus;
                case 'business special':
                    return TransformedType.BusinessSpecial;
                case 'business saver':
                    return TransformedType.BusinessSaver;
                case 'business flex':
                    return TransformedType.BusinessFlex;
                case 'business flex plus':
                    return TransformedType.BusinessFlexPlus;
                case 'first saver':
                    return TransformedType.FirstSaver;
                case 'first flex':
                    return TransformedType.FirstFlex;
                case 'first flex plus':
                    return TransformedType.FirstFlexPlus;
                default:
                    return TransformedType.NotDefined;
            }
        };
        return BrandedFareTypesService;
    }());
    ekh.BrandedFareTypesService = BrandedFareTypesService;
    angular
        .module('ekh')
        .service('brandedFareTypesService', BrandedFareTypesService);
})(ekh || (ekh = {}));
var Core;
(function (Core) {
    var BrandedFare = /** @class */ (function () {
        function BrandedFare(brandedFareTypesService, resourceService, $filter) {
            this.brandedFareTypesService = brandedFareTypesService;
            this.resourceService = resourceService;
            this.$filter = $filter;
        }
        BrandedFare.prototype.$onInit = function () {
            this.classNameIn = this._setClassName(this.fare.FlightSectors[0].TransformedType);
            this.classNameOut = this._setClassName(this.fare.FlightSectors[1].TransformedType);
            this.selectButtonLabel = this.resourceService.get('BRANDED_FARE_TYPES_BUTTON_SELECT');
            this.selectedButtonLabel = this.resourceService.get('BRANDED_FARE_TYPES_BUTTON_SELECTED');
        };
        BrandedFare.prototype.select = function () {
            this.onSelect(this.fare);
        };
        BrandedFare.prototype.getBaggage = function (sector) {
            return sector.BaggageText;
        };
        BrandedFare.prototype.getCabinBaggage = function (sector) {
            return sector.CabinBaggageText;
        };
        BrandedFare.prototype.getSeatsSelection = function (sector) {
            return sector.SeatsSelectionText;
        };
        BrandedFare.prototype.getChauffeur = function (sector) {
            return sector.ChauffeurText;
        };
        BrandedFare.prototype.getPriceDelta = function () {
            var dif = this.fare.BrandedFareTypeTotalPrice - this.selectedFareTotalPrice;
            if (Math.round(dif) === 0) {
                return '';
            }
            var sign = dif > 0 ? '+' : '';
            return "" + sign + this.$filter('roundedCurrency')(dif, this.currency);
        };
        BrandedFare.prototype.isRestrictedSeats = function (sector) {
            return this.brandedFareTypesService.isRestrictedSeats(sector);
        };
        BrandedFare.prototype.getSeatsSelectionTooltipText = function () {
            return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_RESTRICTED_TOOLTIP_TEXT');
        };
        BrandedFare.prototype._setClassName = function (type) {
            switch (type) {
                case ekh.TransformedType.EconomySpecial:
                    return 'economy-special';
                case ekh.TransformedType.EconomySaver:
                    return 'economy-saver';
                case ekh.TransformedType.EconomyFlex:
                    return 'economy-flex';
                case ekh.TransformedType.EconomyFlexPlus:
                    return 'economy-flex-plus';
                case ekh.TransformedType.BusinessSpecial:
                    return 'business-special';
                case ekh.TransformedType.BusinessSaver:
                    return 'business-saver';
                case ekh.TransformedType.BusinessFlex:
                    return 'business-flex';
                case ekh.TransformedType.BusinessFlexPlus:
                    return 'business-flex-plus';
                case ekh.TransformedType.FirstSaver:
                    return 'first-saver';
                case ekh.TransformedType.FirstFlex:
                    return 'first-flex';
                case ekh.TransformedType.FirstFlexPlus:
                    return 'first-flex-plus';
                default:
                    return '';
            }
        };
        return BrandedFare;
    }());
    angular
        .module('core')
        .directive('brandedFare', function () {
        return {
            restrict: 'E',
            controller: BrandedFare,
            controllerAs: 'bf',
            bindToController: {
                isSelected: '=',
                fare: '=',
                onSelect: '&',
                pieceConceptLegIn: '=',
                pieceConceptLegOut: '=',
                selectedFareTotalPrice: '=',
                currency: '='
            },
            template: "\n                <div ng-class=\"[bf.classNameIn]\" class=\"in-flight\">\n                    <div class=\"property-label branded-fare-title\">\n                        <img src=\"/build/img/emiratesHolidays/brandedFareTypes/ic-plane-right-white.svg\">\n                        <span>{{::bf.fare.FlightSectors[0].BrandTitle}}</span>\n                    </div>\n                    <div class=\"property-names-container\" ng-class=\"{'piece-concept': bf.pieceConceptLegIn}\">\n                        <div class=\"property-label baggage-label\">{{::bf.getBaggage(bf.fare.FlightSectors[0])}}</div>\n                        <div class=\"property-label\">{{::bf.getCabinBaggage(bf.fare.FlightSectors[0])}}</div>\n                        <div class=\"property-label\"\n                             ng-class=\"{'restricted-seats': bf.isRestrictedSeats(bf.fare.FlightSectors[0])}\">\n                            {{::bf.getSeatsSelection(bf.fare.FlightSectors[0])}}\n                            <span tooltip=\"{{bf.getSeatsSelectionTooltipText()}}\">\n                                <img src=\"/build/img/emiratesHolidays/brandedFareTypes/ic-info.svg\"/>\n                                </span>\n                        </div>\n                        <div class=\"property-label chauffeur-label\">\n                            {{::bf.getChauffeur(bf.fare.FlightSectors[0])}}\n                        </div>\n                    </div>\n                </div>\n                <div ng-class=\"[bf.classNameOut]\" class=\"out-flight\">\n                    <div class=\"property-label branded-fare-title\">\n                        <img src=\"/build/img/emiratesHolidays/brandedFareTypes/ic-plane-left-white.svg\">\n                        <span>{{::bf.fare.FlightSectors[1].BrandTitle}}</span>\n                    </div>\n                    <div class=\"property-names-container\" ng-class=\"{'piece-concept': bf.pieceConceptLegOut}\">\n                        <div class=\"property-label baggage-label\">{{::bf.getBaggage(bf.fare.FlightSectors[1])}}</div>\n                        <div class=\"property-label\">{{::bf.getCabinBaggage(bf.fare.FlightSectors[1])}}</div>\n                        <div class=\"property-label\"\n                             ng-class=\"{'restricted-seats': bf.isRestrictedSeats(bf.fare.FlightSectors[1])}\">\n                            {{::bf.getSeatsSelection(bf.fare.FlightSectors[1])}}\n                            <span tooltip=\"{{bf.getSeatsSelectionTooltipText()}}\">\n                                <img src=\"/build/img/emiratesHolidays/brandedFareTypes/ic-info.svg\"/>\n                                </span>\n                        </div>\n                        <div class=\"property-label chauffeur-label\">\n                            {{::bf.getChauffeur(bf.fare.FlightSectors[1])}}\n                        </div>\n                        <div class=\"property-label total-price-delta\"><span>{{bf.getPriceDelta()}}</span></div>\n                        <button ng-if=\"!bf.isSelected\" class=\"bft-select\" ng-click=\"bf.select()\">\n                            {{bf.selectButtonLabel}}\n                        </button>\n                        <button ng-if=\"bf.isSelected\" class=\"bft-select\">{{bf.selectedButtonLabel}}</button>\n                    </div>\n                </div>\n\n                "
        };
    });
})(Core || (Core = {}));
var ekh;
(function (ekh) {
    var BrandedFareTypes = /** @class */ (function () {
        function BrandedFareTypes(tripService, $routeParams, flightDetail, $q, basketStore, basketService, $element, brandedFareTypesService, resourceService, $filter, analytics, occupancyService, v2v3HandoverService) {
            this.tripService = tripService;
            this.$routeParams = $routeParams;
            this.flightDetail = flightDetail;
            this.$q = $q;
            this.basketStore = basketStore;
            this.basketService = basketService;
            this.$element = $element;
            this.brandedFareTypesService = brandedFareTypesService;
            this.resourceService = resourceService;
            this.$filter = $filter;
            this.analytics = analytics;
            this.occupancyService = occupancyService;
            this.v2v3HandoverService = v2v3HandoverService;
            this.flight = {};
            this.originalCabinClass = 0;
            this.trip = {};
            this.brandedFareTypes = undefined;
            this.filteredBrandedFareTypes = undefined;
            this.selectedBrandedFareTypeIndex = 0;
        }
        BrandedFareTypes.prototype.$onInit = function () {
            var _this = this;
            this.loadingBrandedFareTypes = true;
            this.expanded = !TRPCONFIG.IsMobileDevice;
            this._getTrip()
                .then(this._getFlight.bind(this))
                .then(this._getBrandedFareTypes.bind(this))
                .then(this._setCurrency.bind(this))
                .finally(function () {
                _this.loadingBrandedFareTypes = false;
            });
        };
        BrandedFareTypes.prototype.getTranslation = function (term) {
            return this.resourceService.get(term);
        };
        BrandedFareTypes.prototype.getPostLoadedHeader = function () {
            var priceDif = this._getStartUpgradePrice();
            if (this.filteredBrandedFareTypes && this.filteredBrandedFareTypes.length) {
                if (TRPCONFIG.IsMobileDevice || !priceDif || priceDif === '') {
                    return String.format(this.getTranslation('BRANDED_FARE_TYPES_POSTLOADED_MOBILE_HEADER'), this.filteredBrandedFareTypes.length, priceDif);
                }
                else {
                    return String.format(this.getTranslation('BRANDED_FARE_TYPES_POSTLOADED_HEADER'), this.filteredBrandedFareTypes.length, priceDif);
                }
            }
            return '';
        };
        BrandedFareTypes.prototype.getAirports = function (leg) {
            var arAir = _.get(leg, 'ArrivalAirport.Code');
            var depAir = _.get(leg, 'DepartureAirport.Code');
            return depAir + "-" + arAir;
        };
        BrandedFareTypes.prototype._getTrip = function () {
            var _this = this;
            return this.tripService.getTrip(this.$routeParams.tripId).then(function (trip) {
                _this.trip = trip;
            });
        };
        BrandedFareTypes.prototype._getBrandedFareTypes = function () {
            var _this = this;
            var tripId = this.trip && this.trip.TripId;
            var searchId = _.get(this.trip, 'FlightsRequest.AvailabilitySearchId');
            var flightId = _.get(this.trip, 'FlightsRequest.SelectedFlight.FlightId');
            var isAgentMode = TRPCONFIG.Domain.isAgentMode;
            var isV2Request = this.v2v3HandoverService.isV2Request();
            var continueV2FlightDetailsRequest = isV2Request || isAgentMode;
            if (tripId && searchId && flightId) {
                return this.flightDetail.getFlightDetails(tripId, continueV2FlightDetailsRequest, {
                    AvailabilitySearchId: searchId,
                    FlightId: flightId,
                    IncludeSeatPlan: true,
                    MultiSector: false,
                    IncludeBrandedFares: true
                })
                    .then(function (details) {
                    if (details) {
                        _this._setPriceQuantities(details);
                        _this._setDefaultBrandedFareType(details);
                        _this._setSelectedFareType(_this.flight);
                        var brandedFareTypes = _.get(details, 'Itinerary.BrandedFares', [])
                            .map(function (b) {
                            b.priceQuantities = _this.priceQuantities;
                            return _this.brandedFareTypesService.transform(b);
                        });
                        if (!_this._isExistedDefaultFareType(brandedFareTypes)) {
                            brandedFareTypes.unshift(_this.defaultBrandedFareType);
                        }
                        _this.brandedFareTypes = _this.brandedFareTypesService.squeeze(brandedFareTypes);
                        _this.isContainPieceBaggageConceptInLeg = _this.brandedFareTypesService
                            .containPieceBaggageConcept(_this.brandedFareTypes, 0);
                        _this.isContainPieceBaggageConceptOutLeg = _this.brandedFareTypesService
                            .containPieceBaggageConcept(_this.brandedFareTypes, 1);
                        if (_this.brandedFareTypes && _this.originalCabinClass === 8) {
                            _this.filteredBrandedFareTypes = _this.brandedFareTypes.filter(function (item) { return item.FlightSectors[0].TransformedType >= ekh.TransformedType.BusinessSpecial; });
                        }
                        else if (_this.brandedFareTypes && _this.originalCabinClass === 4) {
                            _this.filteredBrandedFareTypes = _this.brandedFareTypes.filter(function (item) { return item.FlightSectors[0].TransformedType >= ekh.TransformedType.FirstSaver; });
                        }
                        else {
                            _this.filteredBrandedFareTypes = _this.brandedFareTypes;
                        }
                    }
                });
            }
            return this.$q.when();
        };
        BrandedFareTypes.prototype._getFlight = function () {
            var _this = this;
            if (this.trip && this.trip.BasketId) {
                return this.basketStore.flight(this.trip.BasketId).then(function (flight) {
                    _this.flight = _.get(flight, 'Details.Itinerary') || {};
                    _this.flight.TotalAmount = flight.TotalAmount;
                    _this.originalCabinClass = flight.Details.Itinerary.Legs[0].Segments[0].Cabin;
                });
            }
            return this.$q.when();
        };
        BrandedFareTypes.prototype._setSelectedFareType = function (flight) {
            this.selectedBrandedFareType = this.brandedFareTypesService.transform(__assign({ FlightSectors: [
                    this.flight.Legs[0],
                    this.flight.Legs[1]
                ] }, flight, { priceQuantities: this.priceQuantities }));
        };
        BrandedFareTypes.prototype._setPriceQuantities = function (details) {
            var quantities = [
                'AdultFareQuantity',
                'AdultTaxQuantity',
                'ChildFareQuantity',
                'ChildTaxQuantity',
                'InfantFareQuantity',
                'InfantTaxQuantity'
            ];
            this.priceQuantities = _.pick(details.Itinerary, quantities);
        };
        BrandedFareTypes.prototype._getStartUpgradePrice = function () {
            if (this.flight && this.filteredBrandedFareTypes && this.filteredBrandedFareTypes.length
                && this.selectedBrandedFareTypeIndex < this.filteredBrandedFareTypes.length - 1) {
                var defPrice = _.get(this.filteredBrandedFareTypes[this.selectedBrandedFareTypeIndex], 'BrandedFareTypeTotalPrice');
                var firstPrice = _.get(this.filteredBrandedFareTypes[this.selectedBrandedFareTypeIndex + 1], 'BrandedFareTypeTotalPrice');
                var dif = firstPrice - defPrice;
                return this.$filter('roundedCurrency')(dif, this.currency);
            }
            return '';
        };
        BrandedFareTypes.prototype._setDefaultBrandedFareType = function (details) {
            this.defaultBrandedFareType = this.brandedFareTypesService.transform(__assign({ FlightSectors: [
                    details.Itinerary.Legs[0],
                    details.Itinerary.Legs[1]
                ] }, details.Itinerary, { detailsId: details.DetailsId, priceQuantities: this.priceQuantities }));
        };
        BrandedFareTypes.prototype._isEqualBrandedFareTypes = function (b1, b2) {
            if (b1 && b2) {
                return b1.FlightSectors[0].TransformedType === b2.FlightSectors[0].TransformedType &&
                    b1.FlightSectors[1].TransformedType === b2.FlightSectors[1].TransformedType;
            }
            return false;
        };
        BrandedFareTypes.prototype._isExistedDefaultFareType = function (fareTypes) {
            var res = false;
            for (var i = 0; i < fareTypes.length; ++i) {
                if (this._isEqualBrandedFareTypes(this.defaultBrandedFareType, fareTypes[i])) {
                    res = true;
                    break;
                }
            }
            return res;
        };
        BrandedFareTypes.prototype._setCurrency = function () {
            var _this = this;
            return this.tripService.getCurrency(this.trip.TripId)
                .then(function (c) {
                _this.currency = c;
            });
        };
        BrandedFareTypes.prototype.isSelectedFare = function (b) {
            return this._isEqualBrandedFareTypes(b, this.selectedBrandedFareType);
        };
        BrandedFareTypes.prototype.initCarousel = function (isLastChild) {
            if (isLastChild) {
                this.$element.find('.bft-items').slick({
                    infinite: false,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    nextArrow: '.next-arrow',
                    prevArrow: '.prev-arrow',
                    rtl: !!TRPCONFIG.Rtl,
                    draggable: false,
                    touchMove: false,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 4
                            }
                        }
                    ]
                });
            }
        };
        BrandedFareTypes.prototype.select = function (selectedFare, idx) {
            var _this = this;
            this.savingSelectedFareType = true;
            this.selectedBrandedFareTypeIndex = idx;
            this.selectFare(selectedFare).then(function (_) {
                _this._updateBrandedFare(selectedFare);
            });
            var bLen = this.brandedFareTypes ? this.brandedFareTypes.length : 0;
            this._trackSelection(this.flight.Legs[0].ArrivalAirport.Code, idx + 1, bLen);
        };
        BrandedFareTypes.prototype.selectFare = function (selectedFare) {
            var _this = this;
            var detailsPromise;
            if (this._isEqualBrandedFareTypes(this.defaultBrandedFareType, selectedFare)) {
                detailsPromise = this.$q.when({
                    DetailsId: this.defaultBrandedFareType.detailsId
                });
            }
            else {
                detailsPromise = this.flightDetail.getBrandSpecificFlightDetails(selectedFare.Id);
            }
            this.flight.LeadAdultPrice = selectedFare.AdultFare.Amount;
            this.flight.LeadAdultTax = selectedFare.AdultTax.Amount;
            return detailsPromise.then(function (details) {
                var opts = {
                    details: details,
                    searchId: _.get(_this.trip, 'FlightsRequest.AvailabilitySearchId'),
                    basketId: _this.trip.BasketId,
                    packageId: _this.trip.PackageId,
                    bags: _this.flight.bags,
                    maxbags: _this.occupancyService.getNumberOfNonInfantPassengers() || 1
                };
                return _this.basketService.updateBrandedFare(opts);
            });
        };
        BrandedFareTypes.prototype._updateBrandedFare = function (selectedBrandedFare) {
            this.savingSelectedFareType = false;
            this.selectedBrandedFareType = selectedBrandedFare;
        };
        BrandedFareTypes.prototype._trackSelection = function (airport, position, bLen) {
            this.analytics.trackEvent({
                category: 'Branded Fares holidaysOptions',
                label: airport + "_" + position + "_" + bLen
            });
        };
        return BrandedFareTypes;
    }());
    angular
        .module('core')
        .directive('brandedFareTypes', function () {
        return {
            restrict: 'E',
            controller: BrandedFareTypes,
            controllerAs: 'bft',
            bindToController: {
                flight: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=BrandedFareTypes'
        };
    });
})(ekh || (ekh = {}));
var core;
(function (core) {
    var BreakdownTable = /** @class */ (function () {
        function BreakdownTable(modalService, $filter) {
            this.modalService = modalService;
            this.$filter = $filter;
            this.tax = this.$filter('customCurrency')(modalService.get('tax'));
            //this.currency = this.$filter('customCurrency')(modalService.get('currency'));
            this.total = this.$filter('customCurrency')(modalService.get('total'));
            this.package = this.$filter('customCurrency')(modalService.get('total') + modalService.get('tax'));
        }
        return BreakdownTable;
    }());
    angular
        .module('core')
        .directive('breakdownTable', function () {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=BreakdownTable',
            controllerAs: 'bt',
            controller: BreakdownTable
        };
    });
})(core || (core = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .directive('callToBookModal', function () {
        return {
            restrict: 'E',
            scope: {
                show: '=',
                close: '&'
            },
            templateUrl: 'partials/Home/directivetemplate?type=CallToBookModal',
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var CanonicalTag = /** @class */ (function () {
        function CanonicalTag($element, $rootScope) {
            this.$element = $element;
            this.$rootScope = $rootScope;
            $rootScope.$watch('canonicalSuffix', function (val, old) {
                if (val !== old && $element && $element[0] && $element[0].href) {
                    $element[0].href = $element[0].href.split('?')[0] + val;
                }
            });
        }
        return CanonicalTag;
    }());
    ;
    angular
        .module('core')
        .directive('canonicalTag', function () {
        return {
            restrict: 'A',
            controller: CanonicalTag,
            bindToController: true
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('checkUserPrefs', checkUserPrefs);
    function checkUserPrefs(authService) {
        return {
            restrict: 'A',
            scope: '=',
            compile: function () {
                if (!window.TRPCONFIG.Domain2.ClearUserPrefs) {
                    return;
                }
                return function postLink() {
                    var cookieName = authService.createCookieName();
                    authService.doesHttpOnlyCookieExist(cookieName);
                    authService.checkUserPreferences();
                };
            }
        };
    }
})();
var Core;
(function (Core) {
    var CheckboxPopup = /** @class */ (function () {
        function CheckboxPopup(analytics, $route) {
            this.analytics = analytics;
            this.$route = $route;
            this.checked = false;
        }
        CheckboxPopup.getEventData = function () {
            return {
                label: 'Hotel for only part of Holiday',
                category: 'Search Bar',
                action: 'Click',
                value: 1
            };
        };
        CheckboxPopup.prototype.$onInit = function () {
            this.labelText = this.getLabelText();
            this.popupMessageText = this.getPopupMessageText();
            this.popupHeaderText = this.getPopupHeaderText();
        };
        CheckboxPopup.prototype.closePopup = function () {
            this.checked = false;
        };
        CheckboxPopup.prototype.getCurrentRouteLabel = function () {
            return _.get(this.$route, 'current.$$route.pixelTrackingPageName');
        };
        CheckboxPopup.prototype.checkboxClick = function () {
            var eventData = CheckboxPopup.getEventData();
            var currentRouteName = this.getCurrentRouteLabel();
            if (currentRouteName) {
                eventData.category = eventData.category + " " + currentRouteName;
            }
            this.analytics.trackEvent(eventData);
        };
        return CheckboxPopup;
    }());
    angular
        .module('core')
        .directive('checkboxPopup', function () {
        return {
            restrict: 'E',
            controller: CheckboxPopup,
            controllerAs: 'checkboxPopupCtrl',
            bindToController: {
                getLabelText: '&',
                getPopupHeaderText: '&',
                getPopupMessageText: '&'
            },
            template: "\n                    <lightbox \n                        show=\"checkboxPopupCtrl.checked\"\n                        close=\"checkboxPopupCtrl.closePopup()\"\n                        header-text=\"checkboxPopupCtrl.popupHeaderText\"\n                        lightbox-class=\"lightbox-checkbox-popup\"\n                        >\n                        <div class=\"message-container\">\n                            <span ng-bind-html=\"checkboxPopupCtrl.popupMessageText\"></span>\n                            <button ng-click=\"checkboxPopupCtrl.closePopup()\">OK</button>\n                        </div>\n                    </lightbox>\n                    <div class=\"checkbox-popup-container\">\n                        <checkbox \n                            model=\"checkboxPopupCtrl.checked\"\n                            on-click=\"checkboxPopupCtrl.checkboxClick()\"\n                            >\n                            {{checkboxPopupCtrl.labelText}}\n                        </checkbox>\n                    </div>\n                "
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ConfidenceMessages = /** @class */ (function () {
        function ConfidenceMessages(resourceService) {
            this.showNortonLogo = true;
            this.messages = [];
            this.showAtolLogo = false;
            this.showCommissionOfAviation = false;
            if (this.flexiblePayments === 'true') {
                this.messages.unshift('USPFLEXIBLEPAYMENT');
            }
            if (this.atolProtected === 'true') {
                this.showAtolLogo = true;
                this.messages.unshift('ATOLPROTECTEDHOLIDAY');
            }
            if (this.commissionOfAviation === 'true') {
                this.showCommissionOfAviation = true;
                this.messages.unshift('COMMISSIONOFAVIATIONMESSAGE');
            }
            this.messagesResolved = this.messages.map(function (s) { return resourceService.get(s); });
        }
        return ConfidenceMessages;
    }());
    angular
        .module('core')
        .component('confidenceMessages', {
        bindings: {
            atolProtected: '@',
            commissionOfAviation: '@',
            flexiblePayments: '@',
            debitMessageType: '@'
        },
        controller: ConfidenceMessages,
        template: "\n                <div class=\"security-badge\">\n                    <div class=\"logo-list\">\n                        <span class=\"logo-list__item\" ng-if=\"$ctrl.showNortonLogo\">\n                            <sc-svg-inline \n                                name=\"norton-logo\" \n                                svg-width=\"90\" \n                                svg-height=\"41\">  \n                            </sc-svg-inline>\n                        </span>\n                        <span class=\"logo-list__item\" ng-if=\"$ctrl.showAtolLogo\">\n                            <sc-svg-inline \n                                name=\"atol-logo\" \n                                svg-width=\"40\" \n                                svg-height=\"41\">  \n                            </sc-svg-inline>\n                        </span>\n                        <span class=\"logo-list__item\" ng-if=\"$ctrl.showCommissionOfAviation\">\n                            <sc-svg-inline \n                                name=\"commission-for-aviation-regulation\" \n                                svg-width=\"50\" \n                                svg-height=\"41\">  \n                            </sc-svg-inline>\n                        </span>\n                    </div>\n                    <div class=\"confidence-text\">\n                        <ul>\n                            <li ng-repeat=\"message in $ctrl.messagesResolved\">{{message}}</li>\n                        </ul>\n                    </div>\n                    <div class=\"debit-message\" ng-if=\"$ctrl.showDebitIcon\">\n                        <i class=\"icon-payment\"></i>\n                        {{$ctrl.debitMessage}}\n                    </div>\n                </div>\n            "
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .directive('contactForm', contactForm);
    function contactForm(bookingService) {
        return {
            restrict: 'E',
            replace: false,
            transclude: true,
            scope: {
                contactDetail: '=',
                rootForm: '=',
                loggedInUser: '=',
                contactForm: '=',
                bookingTracker: '@',
                namePart: '@',
                signupPart: '@',
                emailPart: '@',
                isPostCodeRequired: '@',
                onNotYouClick: '&',
                enableEditEmailAlways: '@'
            },
            controller: function () {
                var cm = this;
                cm.form = cm.contactForm || cm.rootForm;
                cm.getContentUrl = function () {
                    return "partials/home/contactdetailsform?bookingTracker=" + cm.bookingTracker;
                };
                cm.agentMode = TRPCONFIG.Domain.isAgentMode;
                cm.showNamePart = cm.namePart === 'true';
                cm.showSignupPart = cm.signupPart === 'true';
                cm.showEmailPart = cm.emailPart === 'true';
                cm.adultTitles = bookingService.getAdultTitles();
            },
            controllerAs: 'cm',
            bindToController: true,
            template: '<div ng-include="cm.getContentUrl()"></div>'
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .directive('costBreakdown', costBreakdown);
    function costBreakdown(tripService, $routeParams, broker, $location) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                costs: '=',
                totalLabel: '@',
                isPackage: '=',
                hideAgentDetail: '@',
                isInsurance: '@'
            },
            templateUrl: 'partials/home/costbreakdown',
            controller: function () {
                var cm = this;
                cm.isTravelAgentMode = TRPCONFIG.Domain.IsTravelAgentMode;
                var localPaymentsList = [22]; // id's of payable locally products
                cm.localPayable = function (costBreakdownItem) {
                    return (localPaymentsList.indexOf(costBreakdownItem.TypeId) !== -1);
                };
                cm.payableNow = function (costBreakdownItem) {
                    return (localPaymentsList.indexOf(costBreakdownItem.TypeId) === -1);
                };
            },
            controllerAs: 'cm',
            link: function (scope) {
                function sumCosts() {
                    return (scope.costs || []).reduce(function (sum, cost) {
                        sum.total += (cost.Quantity * cost.UnitAmount);
                        sum.netTotal += (cost.Quantity * cost.NetUnitAmount);
                        sum.totalTravelAgentCommission += (cost.Quantity * cost.TravelAgentCommission);
                        checkIsInsurance(cost);
                        return sum;
                    }, { total: 0, netTotal: 0, totalTravelAgentCommission: 0 });
                }
                function setClientCurrencyCode() {
                    if (scope.costs && (scope.costs.length >= 1)) {
                        if (scope.costs[0].ClientCurrencyCode) {
                            scope.clientCurrencyCode = scope.costs[0].ClientCurrencyCode;
                        }
                        else {
                            tripService.getCurrency($routeParams.tripId).then(function (currency) {
                                scope.clientCurrencyCode = currency;
                            });
                        }
                    }
                }
                function _setBinRangeDiscount(discount) {
                    if (discount.data != null) {
                        scope.binRangeDiscount = discount.data[0];
                    }
                    else {
                        scope.binRangeDiscount = null;
                    }
                    calcCosts();
                }
                function calcCosts() {
                    var sum = sumCosts();
                    scope.total = sum.total;
                    scope.netTotal = sum.netTotal;
                    scope.totalTravelAgentCommission = sum.totalTravelAgentCommission;
                    if (scope.binRangeDiscount != null) {
                        scope.total -= scope.binRangeDiscount.DiscountValue;
                        scope.deposit -= scope.binRangeDiscount.DiscountValue;
                    }
                    setClientCurrencyCode();
                }
                function checkIsInsurance(cost) {
                    var isManageBooking = $location.path().indexOf('booking-details') > -1;
                    var inInsuranceQoute = false;
                    if (cost.Description) {
                        inInsuranceQoute = cost.Description.toLowerCase().indexOf('insurance') > -1;
                    }
                    if (!scope.isInsurance && isManageBooking && inInsuranceQoute) {
                        scope.isInsurance = true;
                    }
                }
                scope.$watchCollection('costs', function () {
                    calcCosts();
                });
                broker.subscribe('costBreakdownDirective', 'discountUpdated', _setBinRangeDiscount);
                scope.$on('$destroy', function () {
                    broker.unsubscribe('costBreakdownDirective');
                });
            }
        };
    }
})();
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var CrossSellType = Core.Booking.CrossSellType;
        var CrossSellSetting = /** @class */ (function () {
            function CrossSellSetting(iconClass, captionResourceKey, tagLineResourceKey) {
                this.iconClass = iconClass;
                this.captionResourceKey = captionResourceKey || null;
                this.tagLineResourceKey = tagLineResourceKey || null;
            }
            return CrossSellSetting;
        }());
        var CrossSellCard = /** @class */ (function () {
            function CrossSellCard($scope, $location, crossSellCommonService, resourceService) {
                var _this = this;
                this.$scope = $scope;
                this.$location = $location;
                this.crossSellCommonService = crossSellCommonService;
                this.resourceService = resourceService;
                this.crossSellSettings = {};
                //set up our settings
                this.crossSellSettings[CrossSellType.Attractions] = new CrossSellSetting('attractions');
                this.crossSellSettings[CrossSellType.Baggage] =
                    new CrossSellSetting('baggage', 'CROSSSELL_BAGS_CAPTION', 'CROSSSELL_BAGS_TAGLINE');
                this.crossSellSettings[CrossSellType.CarHire] =
                    new CrossSellSetting('car-hire', 'CROSSSELL_CARHIRE_CAPTION', 'CROSSSELL_CARHIRE_TAGLINE');
                this.crossSellSettings[CrossSellType.Hotels] =
                    new CrossSellSetting('hotels', 'CROSSSELL_HOTEL_CAPTION');
                this.crossSellSettings[CrossSellType.Parking] =
                    new CrossSellSetting('parking', 'CROSSSELL_PARKING_CAPTION', 'CROSSSELL_PARKING_TAGLINE');
                this.crossSellSettings[CrossSellType.Seats] =
                    new CrossSellSetting('seating', 'CROSSSELL_SEATS_CAPTION', 'CROSSSELL_SEATS_TAGLINE');
                this.crossSellSettings[CrossSellType.Transfers] =
                    new CrossSellSetting('transfers', 'CROSSSELL_TRANSFER_CAPTION', 'CROSSSELL_TRANSFER_TAGLINE');
                this.cssClass = (this.layout === 'tall') ? 'cross-sell-card-tall' : 'cross-sell-card-wide';
                var watch = $scope.$watch('csc.model', function (m) {
                    if (m) {
                        var settings = _this.crossSellSettings[_this.model.CrossSellType];
                        _this.icon = settings.iconClass;
                        _this.teaserPrice = _this.model.TeaserPrice;
                        if (settings.captionResourceKey) {
                            _this.caption = _this.resourceService.get(settings.captionResourceKey);
                        }
                        else if (_this.model instanceof Customer.CrossSellProductOption) {
                            _this.caption = _this.model.Title;
                        }
                        if (settings.tagLineResourceKey !== null) {
                            _this.tagline = _this.resourceService.get(settings.tagLineResourceKey) || null;
                        }
                        if (_this.model instanceof Customer.CrossSellHotelOption) {
                            _this.tagline = _this.model.Title;
                        }
                        watch();
                    }
                });
            }
            CrossSellCard.prototype.click = function () {
                if (this.model instanceof Customer.CrossSellFlightExtraOption) {
                    this.$location.url(this.model.Url);
                }
                else if (this.model instanceof Customer.CrossSellProductOption) {
                    this.crossSellCommonService.startCrossSellJourney(this.model.BookingId, this.model.ProductDetails);
                }
            };
            return CrossSellCard;
        }());
        angular
            .module('core')
            .directive('crossSellCard', function () {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: CrossSellCard,
                controllerAs: 'csc',
                bindToController: {
                    model: '=',
                    layout: '@'
                },
                templateUrl: 'partials/customer/crosssellcard'
            };
        });
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var TripStage = Core.ManageBooking.TripStage;
        var CurrentTripType;
        (function (CurrentTripType) {
            CurrentTripType[CurrentTripType["Flight"] = 1] = "Flight";
            CurrentTripType[CurrentTripType["Hotel"] = 2] = "Hotel";
            CurrentTripType[CurrentTripType["Holiday"] = 3] = "Holiday";
        })(CurrentTripType = Customer.CurrentTripType || (Customer.CurrentTripType = {}));
        var CurrentTripCard = /** @class */ (function () {
            function CurrentTripCard($scope, resourceService) {
                this.$scope = $scope;
                this.resourceService = resourceService;
                this.titles = {
                    Holiday: {
                        PreTrip: {
                            Days: 'CURRENTTRIP_HOLIDAY_STARTSINXDAYS',
                            Tomorrow: 'CURRENTTRIP_HOLIDAY_STARTSTOMORROW',
                            Today: 'CURRENTTRIP_HOLIDAY_STARTSTODAY'
                        },
                        OnTrip: {
                            Days: 'CURRENTTRIP_HOLIDAY_ENDSINXDAYS',
                            Tomorrow: 'CURRENTTRIP_HOLIDAY_ENDSTOMORROW',
                            Today: 'CURRENTTRIP_HOLIDAY_ENDSTODAY'
                        }
                    },
                    Hotel: {
                        PreTrip: {
                            Days: 'CURRENTTRIP_HOTEL_STARTSINXDAYS',
                            Tomorrow: 'CURRENTTRIP_HOTEL_STARTSTOMORROW',
                            Today: 'CURRENTTRIP_HOTEL_STARTSTODAY'
                        },
                        OnTrip: {
                            Days: 'CURRENTTRIP_HOTEL_ENDSINXDAYS',
                            Tomorrow: 'CURRENTTRIP_HOTEL_ENDSTOMORROW',
                            Today: 'CURRENTTRIP_HOTEL_ENDSTODAY'
                        }
                    },
                    Flight: {
                        PreTrip: {
                            Days: 'CURRENTTRIP_FLIGHT_STARTSINXDAYS',
                            Tomorrow: 'CURRENTTRIP_FLIGHT_STARTSTOMORROW',
                            Today: 'CURRENTTRIP_FLIGHT_STARTSTODAY'
                        },
                        OnTrip: {
                            Days: 'CURRENTTRIP_FLIGHT_ENDSINXDAYS',
                            Tomorrow: 'CURRENTTRIP_FLIGHT_ENDSTOMORROW',
                            Today: 'CURRENTTRIP_FLIGHT_ENDSTODAY'
                        }
                    }
                };
                this.flightLegsToDisplay = [];
                this.showExtraProducts = false;
            }
            CurrentTripCard.prototype.init = function () {
                if (this.trip.FlightBooking && this.trip.HotelBooking) {
                    this.tripType = CurrentTripType.Holiday;
                }
                else {
                    this.tripType = this.trip.HotelBooking ? CurrentTripType.Hotel : CurrentTripType.Flight;
                }
                if (this.trip.FlightBooking) {
                    if (this.trip.TripStage === TripStage.PreTrip) {
                        this.flightLegsToDisplay = this.trip.FlightBooking.Legs;
                    }
                    else {
                        this.flightLegsToDisplay.push(_.last(this.trip.FlightBooking.Legs));
                    }
                }
                if (this.trip.TransferBooking
                    || this.trip.CarHireBooking
                    || this.trip.AirportParkingBooking
                    || this.trip.InsuranceBooking) {
                    this.showExtraProducts = true;
                }
                this.cardTitle = this.getTitle();
            };
            CurrentTripCard.prototype.getTitle = function () {
                var tripTypeKey = CurrentTripType[this.tripType];
                var tripStageKey = TripStage[this.trip.TripStage];
                var daysUntil = this.trip.TripStage === TripStage.PreTrip
                    ? this.trip.DaysUntilDeparture
                    : this.trip.DaysUntilReturn;
                // Days, Tomorrow OR Today
                var durationKey = 'Today';
                if (daysUntil > 1) {
                    durationKey = 'Days';
                }
                else if (daysUntil === 1) {
                    durationKey = 'Tomorrow';
                }
                else {
                    durationKey = 'Today';
                }
                var resourceKey = this.titles[tripTypeKey][tripStageKey][durationKey];
                var title = this.resourceService.getDeferred(resourceKey)();
                if (daysUntil > 1) {
                    title = title.replace('{0}', daysUntil);
                }
                return title;
            };
            return CurrentTripCard;
        }());
        angular
            .module('core')
            .directive('currentTripCard', function () {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: CurrentTripCard,
                controllerAs: 'ct',
                bindToController: {
                    trip: '='
                },
                templateUrl: 'partials/customer/currenttripcard',
                link: function (scope, el, attr, controller) {
                    controller.init();
                }
            };
        });
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var CrossSellType = Core.Booking.CrossSellType;
        var TripStage = Core.ManageBooking.TripStage;
        var CustomerDashboard = /** @class */ (function () {
            function CustomerDashboard($rootScope, $scope, $q, bookingsManagerService, crossSellCommonService, customerDashboardService, houseRecommender, currentUser, authService) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$scope = $scope;
                this.$q = $q;
                this.bookingsManagerService = bookingsManagerService;
                this.crossSellCommonService = crossSellCommonService;
                this.customerDashboardService = customerDashboardService;
                this.houseRecommender = houseRecommender;
                this.currentUser = currentUser;
                this.authService = authService;
                // Object literal defines which cross-sells are supported by each place holder.
                // Cross-sells are arranged in priority order.
                this.crossSellsByPlaceholder = {
                    2: [
                        CrossSellType.Hotels,
                        CrossSellType.Attractions
                    ],
                    4: [
                        CrossSellType.Transfers,
                        CrossSellType.CarHire,
                        CrossSellType.Seats,
                        CrossSellType.Baggage
                    ],
                    5: [
                        CrossSellType.Transfers,
                        CrossSellType.CarHire,
                        CrossSellType.Seats,
                        CrossSellType.Baggage
                    ]
                };
                this.user = null;
                this.trip = null;
                this.lastViewedHotel = null;
                this.searches = [];
                this.destinations = [];
                this.crossSellOptions = {
                    Hotels: null,
                    Attractions: null,
                    Transfers: null,
                    CarHire: null,
                    Baggage: null,
                    Seats: null
                };
                this.tileTemplates = {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null
                };
                this.tileModels = {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null
                };
                this.tileTypes = {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null
                };
                $scope.$on('auth:signin', function () {
                    _this.setDashboardState();
                });
                $scope.$on('auth:signout', function () {
                    _this.setDashboardState();
                });
                this.setDashboardState();
            }
            CustomerDashboard.prototype.setDashboardState = function () {
                // Set local scope user
                this.user = this.currentUser.get();
                // Show this dashboard if the user is signed in
                this.showDashboard = this.user.AnonSignedIn || this.user.SignedIn;
                this.showDashboard && this.fetch();
            };
            CustomerDashboard.prototype.fetch = function () {
                var _this = this;
                this.fetching = true;
                this.tripReady = false;
                this.resetData();
                var bookingId = this.user.AnonSignedIn && this.authService.getSignedInBookingId();
                var tripPromise = bookingId
                    ? this.bookingsManagerService.getTrip(bookingId)
                    : this.bookingsManagerService.getCurrentTripForUser();
                tripPromise.then(function (trip) {
                    _this.trip = trip;
                    // // DEBUG -- force trip stage
                    // if (this.trip) {
                    //     this.trip.TripStage = TripStage.PreTrip;
                    // }
                    // Set the dashboard template
                    _this.dashboardTemplate = _this.customerDashboardService.getTemplateForDashboard(_this.trip);
                    // If appropriate, set the trip template whilst other content loads
                    if (_this.trip && (_this.trip.TripStage === TripStage.PreTrip
                        || _this.trip.TripStage === TripStage.OnTrip)) {
                        _this.tileTypes[1] = Customer.DashboardTileType.Trip;
                        _this.tileTemplates[1] =
                            _this.customerDashboardService.getTemplateForPlaceholder(Customer.DashboardTileType.Trip);
                        _this.tripReady = true;
                    }
                    var promises = [];
                    if (_this.trip && _this.trip.TripStage === TripStage.PreTrip) {
                        // get cross sells
                        promises.push(_this.customerDashboardService.getAllCrossSellOptions(_this.trip.MainBookingId));
                    }
                    else {
                        promises.push(_this.$q.when()); // dummy the cross-sell promise
                        // Get recent searches, last viewed hotel and recommended destinations
                        //promises.push(this.customerDashboardService.getRecentSearches(2));
                        promises.push(_this.$q.when());
                        promises.push(_this.customerDashboardService.getLastViewedHotel());
                        promises.push(_this.houseRecommender.getHouseRecs());
                    }
                    _this.$q.all(promises).then(function (_a) {
                        var crossSells = _a[0], searches = _a[1], hotel = _a[2], destinations = _a[3];
                        if (crossSells) {
                            // Assign any cross-sell options to our object literal
                            _.each(crossSells, function (option) {
                                _this.crossSellOptions[CrossSellType[option.CrossSellType]] = option;
                            });
                        }
                        if (searches) {
                            _this.searches = searches;
                        }
                        if (hotel) {
                            _this.lastViewedHotel = hotel;
                        }
                        if (destinations) {
                            _this.destinations = destinations;
                        }
                        // Now that we have all information, set the templates for each cell
                        _this.configureTiles().then(function () {
                            // We are done - display everything else
                            _this.fetching = false;
                            _this.customerDashboardService.trackDashboardLoad(_this.trip, _this.tileTypes);
                        });
                    });
                });
            };
            CustomerDashboard.prototype.configureTiles = function () {
                var _this = this;
                var deferred = this.$q.defer();
                if (this.trip) {
                    if (this.trip.TripStage === TripStage.PreTrip) {
                        // *** PRE TRIP ***
                        // Placeholder 1
                        // Trip
                        this.tileTypes[1] = Customer.DashboardTileType.Trip;
                        // Placeholders 2, 3, 4, 5
                        // Assign cross sell templates to placeholders according to our validity rules
                        var assignedTypes_1 = [];
                        // iterate placeholders which support cross-sells
                        _.forOwn(this.crossSellsByPlaceholder, function (types, key) {
                            // Take the first non-assigned cross-sell type which we have a cross-sell option for
                            var chosenType = _.find(types, function (type) {
                                return _this.crossSellOptions[CrossSellType[type]]
                                    && assignedTypes_1.indexOf(type) === -1;
                            });
                            if (chosenType) {
                                // assign the placeholder type for this cross-sell
                                assignedTypes_1.push(chosenType);
                                _this.tileTypes[key] = Customer.DashboardTileType["CrossSell" + CrossSellType[chosenType]];
                                _this.tileModels[key] = _this.crossSellOptions[CrossSellType[chosenType]];
                            }
                        });
                        // Placeholder 2 (if not populated by a cross-sell)
                        // Small App Promo
                        if (!this.tileTypes[2]) {
                            this.tileTypes[2] = Customer.DashboardTileType.AppPromo;
                        }
                        // Placeholder 3 (if not populated by a cross-sell)
                        // Insurance Confirmation OR Insurance Option
                        if (!this.tileTypes[3]) {
                            this.tileTypes[3] = this.trip.InsuranceBooking
                                ? Customer.DashboardTileType.InsuranceConf
                                : Customer.DashboardTileType.InsuranceOption;
                        }
                    }
                    else if (this.trip.TripStage === TripStage.OnTrip) {
                        // *** ON TRIP ***
                        // Placeholder 1
                        // Trip
                        // *** ALREADY SET ***
                        // Placeholder 2
                        // TR Contact
                        this.tileTypes[2] = Customer.DashboardTileType.ContactUs;
                        // Placeholder 3
                        // Insurance claim OR Travel guide
                        this.tileTypes[3] = this.trip.InsuranceBooking
                            ? Customer.DashboardTileType.InsuranceClaim
                            : Customer.DashboardTileType.TravelGuide;
                    }
                    else if (this.trip.TripStage === TripStage.PostTrip) {
                        // *** POST TRIP ***
                        // Placeholder 1
                        // Review your hotel OR App promo
                        this.tileTypes[1] =
                            this.trip.HotelBooking && !this.trip.HotelBooking.ReviewedByCustomer
                                ? Customer.DashboardTileType.ReviewHotel
                                : Customer.DashboardTileType.AppPromo;
                        // Placeholder 2
                        // Searches[0] OR Destinations[0]
                        if (this.searches[0]) {
                            this.tileTypes[2] = Customer.DashboardTileType.Search;
                            this.tileModels[2] = this.searches[0];
                        }
                        else {
                            this.tileTypes[2] = Customer.DashboardTileType.Destination;
                            this.tileModels[2] = this.destinations[0];
                        }
                        // Placeholder 3
                        // Destinations[0] OR Destinations[1]
                        this.tileTypes[3] = Customer.DashboardTileType.Destination;
                        if (this.tileTypes[2] === Customer.DashboardTileType.Search) {
                            // show the first destination which doesn't match the destination of the search
                            this.tileModels[3] = this.customerDashboardService.getDestinationExcludingSearch(this.tileModels[2], this.destinations);
                        }
                        else {
                            // show the second destination
                            this.tileModels[3] = this.destinations[1];
                        }
                    }
                }
                else {
                    // *** NO TRIP ***
                    // Placeholder 1
                    // App promo
                    this.tileTypes[1] = Customer.DashboardTileType.AppPromo;
                    // Placeholder 2
                    // Last Viewed Hotel OR Searches[0] OR Destinations[0]
                    if (this.lastViewedHotel) {
                        // show last viewed hotel
                        this.tileTypes[2] = Customer.DashboardTileType.LastHotel;
                        this.tileModels[2] = this.lastViewedHotel;
                    }
                    else if (this.searches[0]) {
                        // show first search
                        this.tileTypes[2] = Customer.DashboardTileType.Search;
                        this.tileModels[2] = this.searches[0];
                    }
                    else {
                        // show first destination
                        this.tileTypes[2] = Customer.DashboardTileType.Destination;
                        this.tileModels[2] = this.destinations[0];
                    }
                    // Placeholder 3
                    // Searches[0] OR Destinations[0] OR Destinations[1]
                    if (this.tileTypes[2] === Customer.DashboardTileType.LastHotel) {
                        // show first search OR first Destination
                        if (this.searches[0]) {
                            this.tileTypes[3] = Customer.DashboardTileType.Search;
                            this.tileModels[3] = this.searches[0];
                        }
                        else {
                            this.tileTypes[3] = Customer.DashboardTileType.Destination;
                            this.tileModels[3] = this.destinations[0];
                        }
                    }
                    else if (this.tileTypes[2] === Customer.DashboardTileType.Search) {
                        this.tileTypes[3] = Customer.DashboardTileType.Destination;
                        // show the first destination which doesn't match the destination of the search
                        this.tileModels[3] = this.customerDashboardService.getDestinationExcludingSearch(this.tileModels[2], this.destinations);
                    }
                    else {
                        // show second destination
                        this.tileTypes[3] = Customer.DashboardTileType.Destination;
                        this.tileModels[3] = this.destinations[1];
                    }
                }
                // map the templates to the types
                _.forOwn(this.tileTypes, function (type, key) {
                    if (type) {
                        _this.tileTemplates[key] = _this.customerDashboardService.getTemplateForPlaceholder(type);
                    }
                });
                deferred.resolve();
                return deferred.promise;
            };
            CustomerDashboard.prototype.resetData = function () {
                // reset all data to initial state
                this.trip = null;
                this.lastViewedHotel = null;
                this.searches.length = 0;
                this.destinations.length = 0;
                _.forOwn(this.crossSellOptions, function (o) { return o = null; });
                // placeholder templates and models
                _.forOwn(this.tileTemplates, function (p) { return p = null; });
                _.forOwn(this.tileModels, function (p) { return p = null; });
                _.forOwn(this.tileTypes, function (p) { return p = null; });
            };
            CustomerDashboard.prototype.getModelForPlaceholder = function (position) {
                // We return the model in an array so that we can use ng-repeat
                // to declare a privately scoped model for the ng-included template
                return [this.tileModels[position]];
            };
            CustomerDashboard.prototype.crossSellClick = function (option) {
                //mybTrack.track('MYB - Cross Sell Click');
                this.crossSellCommonService.startCrossSellJourney(option.BookingId, option.ProductDetails);
            };
            CustomerDashboard.prototype.tileClick = function (position) {
                this.customerDashboardService.trackDashboardClick(position, this.tileTypes[position]);
            };
            return CustomerDashboard;
        }());
        angular
            .module('core')
            .directive('customerDashboard', function () {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: CustomerDashboard,
                controllerAs: 'cd',
                bindToController: {},
                templateUrl: 'partials/customer/customerdashboard'
            };
        });
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var DateOrMonthPicker = /** @class */ (function () {
        function DateOrMonthPicker($scope, dateUtil) {
            this.minimumDate = dateUtil.todayPlus(1);
        }
        return DateOrMonthPicker;
    }());
    angular
        .module('core')
        .directive('dateOrMonthPicker', function () { return ({
        restrict: 'E',
        templateUrl: 'partials/home/directivetemplate?type=DateOrMonthPicker',
        controller: DateOrMonthPicker,
        controllerAs: 'cm',
        bindToController: {
            show: '=',
            value: '=',
            flexibility: '=',
        },
        scope: {},
    }); });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var DestinationContentCard = /** @class */ (function () {
        function DestinationContentCard(houseRecommender) {
            this.houseRecommender = houseRecommender;
        }
        DestinationContentCard.prototype.trackClick = function () {
            this.houseRecommender.trackHouseClick(this.model);
        };
        return DestinationContentCard;
    }());
    angular
        .module('core')
        .directive('destinationContentCard', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: DestinationContentCard,
            controllerAs: 'dc',
            replace: true,
            bindToController: {
                model: '=',
                header: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=DestinationContentCard'
        };
    });
})(Core || (Core = {}));
// This directive is to delay the loading of all DTCM Tracking scripts
// until after AngularJS has has a change to load itself.
var Core;
(function (Core) {
    var DtcmController = /** @class */ (function () {
        function DtcmController($element, $timeout, dtcmService) {
            this.$element = $element;
            this.$timeout = $timeout;
            this.dtcmService = dtcmService;
        }
        DtcmController.prototype.$onInit = function () {
            var _this = this;
            if (this.dtcmService.isEnabledFlag(this.flagName)) {
                this.$timeout(function () {
                    var script = "<script src=\"" + _this.script + "\" async></script>";
                    _this.$element.append(script);
                }, 1000);
            }
        };
        return DtcmController;
    }());
    angular
        .module('core')
        .directive('dtcm', function () {
        return {
            restrict: 'E',
            controllerAs: 'dtcm',
            scope: {},
            bindToController: {
                script: '@',
                flagName: '@'
            },
            controller: DtcmController
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular.module('core').directive('expander', expander);
    function expander($rootScope) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                title: '@',
                subtitle: '@',
                expanded: '=',
                expandable: '@',
                accordion: '@',
                accordionGroup: '@',
                headerClass: '@',
                bodyClass: '@',
                iconClassExpanded: '@',
                iconClassCollapsed: '@',
                forceHeaderClasses: '=',
            },
            templateUrl: 'partials/home/directivetemplate?type=Expander',
            link: function (scope, el, attr) {
                scope.hClass = '';
                //set defaults for unset scope values
                if (!attr.iconClassExpanded) {
                    attr.iconClassExpanded = 'icon icon-collapse';
                }
                if (!attr.iconClassCollapsed) {
                    attr.iconClassCollapsed = 'icon icon-expand';
                }
                //we have to capture the expanded attribute and assign it to a new property
                //otherwise angular gets upset if the attribute is not assignable (which we as
                //a directive have no control over
                scope.$watch('expanded', function (val) {
                    scope.e = val;
                });
                var accordion = attr.accordion === 'true';
                if (accordion) {
                    scope.$on(String.format('{0}expanderExpanded', attr.accordionGroup ? attr.accordionGroup : ''), function (ev, s) {
                        if (scope.$id !== s.$id && scope.e) {
                            scope.toggle();
                        }
                    });
                }
                scope.$on('forceExpand', function () {
                    scope.e = true;
                });
                scope.toggle = function () {
                    if (scope.expandable === 'false') {
                        return;
                    }
                    scope.e = !scope.e;
                    if (scope.e) {
                        $rootScope.$broadcast(String.format('{0}expanderExpanded', attr.accordionGroup ? attr.accordionGroup : ''), scope);
                    }
                };
                scope.headerClasses = function () {
                    if (scope.forceHeaderClasses === true) {
                        scope.hClass =
                            scope.headerClass == null
                                ? ''
                                : " " + scope.headerClass;
                    }
                    else {
                        scope.hClass = '';
                    }
                };
                scope.expanderClass = function () {
                    if (scope.expandable === 'false') {
                        scope.headerClasses();
                        return 'ng-hide';
                    }
                    //update the hClass property
                    scope.hClass = scope.e ? 'expanded' : 'collapsed';
                    scope.hClass +=
                        scope.headerClass == null
                            ? ''
                            : " " + scope.headerClass;
                    return scope.e
                        ? scope.iconClassExpanded
                        : scope.iconClassCollapsed;
                };
                scope.bClass = function () {
                    return scope.bodyClass == null ? '' : scope.bodyClass;
                };
            },
        };
    }
})();
var core;
(function (core) {
    var Tag = /** @class */ (function () {
        function Tag(title, isNew) {
            this.title = title;
            this.isNew = isNew;
        }
        return Tag;
    }());
    var ExtendableTagList = /** @class */ (function () {
        function ExtendableTagList($scope, analytics) {
            var _this = this;
            this.$scope = $scope;
            this.analytics = analytics;
            this.newTagTitle = '';
            this.tagLists = { predefined: [], userDefined: [] };
            var uniqueId = Math.random().toString(36).substr(2, 7);
            this.componentInputId = "extendable-tag-list--" + uniqueId;
            this.formName = "tagForm_" + uniqueId;
            //basic checks of our min, max values
            if (!this.maxTagLength || !this.minTagLength) {
                throw 'Extendable Tag List - Invalid parameters';
            }
            _.each(this.tags, function (t) {
                _this.tagLists.predefined.push(new Tag(t, false));
            });
            //sometimes our model will be set and may contain non-predefined tags, these need to be added to the
            //user defined list
            if (this.model && this.model.length > 0) {
                var userTags = _.difference(this.model, this.tags);
                _.each(userTags, function (t) { _this.addTagToUserDefinedList(t); });
            }
            if (this.analyticsTag) {
                $scope.$watchCollection('twi.model', function (n, o) {
                    if (n && o && (n.length > 0 || o.length > 0)) {
                        var changes = _.difference(n, o);
                        //we are only interested in additions
                        if (changes.length) {
                            _.each(changes, function (c) {
                                var userDefined = _.findIndex(_this.tagLists.userDefined, function (t) { return t.title === c; }) > -1;
                                _this.analytics.track('mixpanel', _this.analyticsTag + "_Add", { value: c, userDefined: userDefined });
                            });
                        }
                    }
                });
            }
        }
        ExtendableTagList.prototype.addUserTag = function (form) {
            var _this = this;
            form.$setSubmitted();
            if (!form.$valid) {
                return;
            }
            //check we don't already have it in the predefined list (if we do just select it)
            var tag = _.find(this.tagLists.predefined, function (t) { return t.title.toLowerCase() === _this.newTagTitle.toLowerCase(); });
            if (tag) {
                if (!_.find(this.model, function (t) { return t === tag.title; })) {
                    this.model.push(tag.title);
                }
                return;
            }
            //add it to our user defined list instead
            if (this.addTagToUserDefinedList(this.newTagTitle)) {
                this.model.push(this.newTagTitle); //also update our model
            }
            //clear our value and make sure the form is returned to a clean state
            this.newTagTitle = '';
            form.$setPristine();
            form.$setUntouched();
        };
        ExtendableTagList.prototype.removeUserTag = function (title) {
            var titleLowercase = title.toLowerCase();
            _.remove(this.tagLists.userDefined, function (t) { return t.title.toLowerCase() === titleLowercase; });
            _.remove(this.model, function (t) { return t.toLowerCase() === titleLowercase; });
        };
        ExtendableTagList.prototype.tagLimitReached = function () {
            return this.tagLists.userDefined.length >= this.maxExtraTags;
        };
        ExtendableTagList.prototype.$postLink = function () {
            //set our form correctly as it is dynamically named
            this.form = this.$scope[this.formName];
        };
        ;
        //adds a tag with the given title to the tags.userDefined list if it does not exist already. Returns a bool
        //indicating if anything was added
        ExtendableTagList.prototype.addTagToUserDefinedList = function (tagTitle) {
            //do we have the tag in our userdefined list? if so move on
            var tag = _.find(this.tagLists.userDefined, function (t) { return t.title.toLowerCase() === tagTitle.toLowerCase(); });
            if (!tag) {
                this.tagLists.userDefined.push(new Tag(tagTitle, true));
                return true;
            }
            return false;
        };
        return ExtendableTagList;
    }());
    angular
        .module('core')
        .directive('extendableTagList', function () {
        return {
            restrict: 'E',
            template: "<div>\n                                <div class=\"u-grid-gutter-y\">\n                                    <ul class=\"inline-list inline-list--sm\">\n                                        <li ng-repeat=\"tag in twi.tagLists.predefined\">\n                                            <label class=\"o-toggle\">\n                                                <input class=\"o-toggle__checkbox\" \n                                                       type=\"checkbox\" \n                                                       value=\"tag.title\"\n                                                       checkbox-array=\"twi.model\" /> \n                                                <span class=\"o-toggle__caption\">{{::tag.title}}</span>\n                                            </label>\n                                        </li><li ng-repeat=\"tag in twi.tagLists.userDefined\">\n                                            <label class=\"sc-c-pill\" ng-click=\"twi.removeUserTag(tag.title)\">\n                                                <span class=\"\">{{::tag.title}}</span>\n                                                <i class=\"icon-close sc-c-pill__close\"></i>\n                                            </label>\n                                        </li>\n                                    </ul>\n                                </div>\n\n                                <ng-form name=\"{{::twi.formName}}\"\n                                      class=\"sc-c-form-layout sc-c-form-layout--horizontal\"\n                                      data-isolate-form\n                                      ng-show=\"!twi.tagLimitReached()\">\n                                    <div class=\"form-component\">\n                                        <label class=\"form-component__label\" for=\"{{::twi.componentInputId}}\">\n                                            {{::twi.labelText}}\n                                        </label>\n                                        <div class=\"form-component__control\">\n                                            <input  class=\"form-component__input\"\n                                                    id=\"{{::twi.componentInputId}}\" \n                                                    name=\"tag\"\n                                                    ng-maxlength=\"{{::twi.maxTagLength}}\"\n                                                    ng-minlength=\"{{::twi.minTagLength}}\"\n                                                    ng-model=\"twi.newTagTitle\"\n                                                    required\n                                                    type=\"text\" />\n                                            <button class=\"sc-c-button\n                                                            sc-c-button--primary\n                                                            sc-c-button--hollow \n                                                            sc-c-button--round\"\n                                                    ng-click=\"twi.addUserTag(twi.form)\"\n                                                    type=\"button\" >\n                                                <i class=\"icon-plus sc-c-button__icon\" />\n                                            </button>\n                                            <div ng-show=\"twi.form.$submitted\" >\n                                                <div class=\"u-error-message\" \n                                                      ng-show=\"twi.form.tag.$error.minlength \n                                                                || twi.form.tag.$error.maxlength\">\n                                                    Please ensure your entry is between {{::twi.minTagLength}} and \n                                                    {{::twi.maxTagLength}} characters\n                                                </div>\n                                                <div class=\"u-error-message\"\n                                                      ng-show=\"twi.form.tag.$error.required\">Please enter a value</div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </ng-form>\n                                <div ng-show=\"twi.tagLimitReached()\">\n                                    You are allowed to specify a maximum of {{::twi.maxExtraTags}} tags, you'll have \n                                    to remove tags before being able to add more.\n                                </div>\n                            </div>",
            bindToController: {
                analyticsTag: '@',
                inputLabelText: '@',
                maxExtraTags: '=',
                maxTagLength: '@',
                minTagLength: '@',
                model: '=',
                labelText: '@',
                tags: '<'
            },
            scope: {},
            replace: true,
            controllerAs: 'twi',
            controller: ExtendableTagList
        };
    });
})(core || (core = {}));
var Core;
(function (Core) {
    var ExtraFocusTracker = /** @class */ (function () {
        function ExtraFocusTracker($element, $scope, extraFocusTrackerEventQueue) {
            var _this = this;
            this.$element = $element;
            this.$scope = $scope;
            this.extraFocusTrackerEventQueue = extraFocusTrackerEventQueue;
            this.cssClass = _.uniqueId('extra-focus-tracker-');
            var func = function (target) {
                if (target.is('body, body *')) {
                    if (!target.is('a[href], a[href] *')) {
                        _this.setFocus(target.is("." + _this.cssClass + ", ." + _this.cssClass + " *"));
                    }
                }
            };
            extraFocusTrackerEventQueue.queue.push(func);
            $scope.$on('$destroy', function () { return _.pull(extraFocusTrackerEventQueue.queue, func); });
        }
        ExtraFocusTracker.prototype.setFocus = function (value) {
            var _this = this;
            if (this.$scope.extraFocusTrackerFocused !== value) {
                this.$scope.$evalAsync(function () { return _this.$scope.extraFocusTrackerFocused = value; });
            }
        };
        return ExtraFocusTracker;
    }());
    angular
        .module('core')
        .factory('extraFocusTrackerEventQueue', function () {
        var service = {
            queue: []
        };
        $(function () {
            $('body').on('focusin click touchstart', '*', function (event) {
                var target = $(event.target);
                service.queue.forEach(function (f) { return f(target); });
            });
        });
        return service;
    })
        .directive('extraFocusTracker', function ($timeout) {
        return {
            controller: ExtraFocusTracker,
            restrict: 'A',
            link: function (scope, element, attrs, controller) {
                element.addClass(controller.cssClass);
                scope.extraFocusTrackerFocused = false;
            }
        };
    });
})(Core || (Core = {}));
/*
    Creates a dropdown menu of options for an input field.
    Header items must contain a truthy `header` property (will not be selectable).

    Configurable via attributes:
        Input field as `inputField`
        Data source as `data`.
        Options format as `headerFormat`, `optionFormat` (defaults to `Title`)
        `select` function receives arguments `(item, e)`.

    Other options defined in `bindToController`.
*/
var Autocompleter;
(function (Autocompleter) {
    var FieldOptions = /** @class */ (function () {
        function FieldOptions($scope, $element, $parse, $timeout, $q) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.$parse = $parse;
            this.$timeout = $timeout;
            this.$q = $q;
            this.uiState = {
                fieldFocused: false,
                menuShowing: false,
                menuPopulated: false,
                selectedIndex: -1,
                selectableOptions: {},
                selectableOpsCount: 0,
                denyHide: false,
                denyScroll: false,
                denyFocus: false,
                denyBlur: false
            };
            var self = this;
            // `no-hide` attribute
            if (this.noHide) {
                this.uiState.denyHide = true;
                this.uiState.menuShowing = true;
            }
            else {
                $element.hide();
            }
            this.createMenu = function (inputEl) {
                var uiState = _this.uiState, selectHandler = _this.select, formatHeader = $parse(_this.headerFormat || 'Title'), formatLabel = $parse(_this.optionFormat || 'Title'), ul = $element, eventNS = '.fieldOptions', selOptionClass = 'selected';
                var uiHandlers = {
                    9: selectCurrOption,
                    13: selectCurrOption,
                    16: angular.noop,
                    27: blurField,
                    38: function () { return traverseOptions(-1); },
                    40: function () { return traverseOptions(1); } // Down arrow
                };
                // Debounced menu refresh (thenable)
                var debouncedPopulateMenu = _.debounce(function (resolve) {
                    populateMenu(_this.data);
                    resolve();
                }, 100);
                init();
                function init() {
                    // Watch `data` attribute
                    $scope.$watch('fo.data', function (v) {
                        if (v) {
                            if (!uiState.denyFocus) {
                                refreshMenu().then(showMenu);
                            }
                        }
                        else {
                            hideMenu();
                            clearMenu();
                        }
                    });
                    // DOM listeners on input field
                    inputEl
                        .on('focus' + eventNS, function () {
                        focusField();
                    })
                        .on('keydown' + eventNS, function (e) {
                        var handler = uiHandlers[e.keyCode];
                        // Special keys i.e. escape, tab
                        if (handler) {
                            handler(e);
                        }
                        else {
                            refreshMenu().then(showMenu);
                        }
                    })
                        .on('click' + eventNS, function () {
                        this.setSelectionRange(0, this.value.length);
                        focusField();
                    })
                        .on('blur' + eventNS, function () {
                        // IE fix (clicking scrollbar hides menu)
                        $timeout(function () {
                            if (uiState.denyBlur) {
                                inputEl.focus();
                            }
                            else {
                                blurField();
                            }
                        });
                    });
                    // DOM listeners on menu ul
                    ul.on('mousedown' + eventNS, function () {
                        uiState.denyBlur = true; // IE fix (above)
                        suppressFocus();
                    })
                        .on('mouseup' + eventNS, function () { return uiState.denyBlur = false; })
                        .on('mouseleave' + eventNS, function () { return uiState.denyBlur = false; })
                        .on('mouseleave' + eventNS, function () { return clearHighlight(); })
                        .on('mouseenter' + eventNS, '> li', function (e) {
                        var index = ul.find('.field-options-item').index(e.target);
                        if (index > -1) {
                            highlightOption(index);
                        }
                        else {
                            clearHighlight();
                        }
                    });
                    $scope.$on('$destroy', deregister);
                }
                function showMenu() {
                    if (uiState.menuPopulated && uiState.fieldFocused) {
                        if (!uiState.menuShowing) {
                            selectNone();
                            uiState.menuShowing = true;
                            $element.show();
                            if (ul.isOnScreen && !ul.isOnScreen()) {
                                scrollToMenu();
                            }
                        }
                    }
                    else {
                        hideMenu();
                    }
                }
                function hideMenu() {
                    if (!uiState.denyHide && uiState.menuShowing) {
                        uiState.menuShowing = false;
                        selectNone();
                        $element.hide();
                    }
                }
                function refreshMenu() {
                    return $q(function (res) { return debouncedPopulateMenu(res); });
                }
                function focusField() {
                    if (!uiState.denyFocus) {
                        uiState.fieldFocused = true;
                        refreshMenu().then(showMenu);
                    }
                }
                function blurField() {
                    uiState.fieldFocused = false;
                    hideMenu();
                }
                function scrollToMenu() {
                    if (!uiState.denyScroll) {
                        uiState.denyScroll = true;
                        var winPos = $(window).scrollTop(), winHeight = $(window).height(), ulPos = ul.offset().top, ulHeight = ul.outerHeight(), ulBottom = ulPos - winPos + ulHeight + 10, // Arbitrary gap
                        scrollPos = winPos + Math.min(ulBottom - winHeight, 150);
                        if (scrollPos > 0) {
                            $('html, body').animate({ scrollTop: scrollPos }, 200);
                        }
                    }
                }
                function getSelectedOption() {
                    if (uiState.selectedIndex > -1) {
                        return $element.find('li').eq(uiState.selectableOptions[uiState.selectedIndex].domIndex);
                    }
                }
                function selectCurrOption() {
                    if (uiState.menuShowing) {
                        var op = getSelectedOption();
                        if (op) {
                            op.trigger('click');
                        }
                        hideMenu();
                    }
                }
                function selectItem(params) {
                    var item = params.item;
                    if (params.e) {
                        params.e.preventDefault();
                        params.e.stopPropagation();
                    }
                    suppressFocus();
                    hideMenu();
                    if (item && !item.header) {
                        self.$scope.$emit('fieldOptionSelected', item);
                        $timeout(function () {
                            selectHandler(params); // `select` attribute
                        });
                    }
                }
                function populateMenu(data) {
                    clearMenu();
                    if (data) {
                        var opsCount_1 = 0;
                        data.forEach(function (o, i) {
                            // restricted Code for directive
                            if (self.restricted != null
                                && o.Code !== self.restricted
                                && o.Title !== 'Airports') {
                                return;
                            }
                            $("<li class=\"" + getItemClasses(o) + "\">\n                                    " + getLabelHTML(o) + "\n                                </li>")
                                .click(function (e) { return selectItem({ item: o, e: e }); })
                                .appendTo(ul);
                            // Index non-headers
                            if (!o.header) {
                                uiState.selectableOptions[opsCount_1++] = { domIndex: i, item: o };
                            }
                        });
                        uiState.selectableOpsCount = opsCount_1;
                        if (opsCount_1) {
                            selectNone();
                            uiState.menuPopulated = true;
                        }
                        else {
                            hideMenu();
                            clearMenu();
                        }
                    }
                }
                function clearMenu() {
                    uiState.selectableOptions = {};
                    uiState.selectableOpsCount = 0;
                    uiState.menuPopulated = false;
                    ul.empty();
                }
                function getLabelHTML(item) {
                    if (item.header) {
                        return formatHeader(item);
                    }
                    var label = formatLabel(item), fieldVal = inputEl.val(), term = fieldVal && fieldVal.trim().toLowerCase();
                    if (term) {
                        var termPos = label.toLowerCase().indexOf(term);
                        if (termPos > -1) {
                            var termEnd = termPos + term.length, _a = [
                                label.substring(0, termPos),
                                label.substring(termPos, termEnd),
                                label.substring(termEnd)
                            ], str0 = _a[0], str1 = _a[1], str2 = _a[2];
                            label = str0 + "<span class=\"field-options-highlight\">" + str1 + "</span>" + str2;
                        }
                    }
                    // let icon = '';
                    // if (item.icon) {
                    //     const cssClass = item.isChild ? 'field-options-child' : '';
                    //     icon = `<i class="icon-${item.icon} ${cssClass}"></i>`;
                    // }
                    //label = `${icon} ${label}`;
                    return label;
                }
                function highlightOption(i) {
                    clearHighlight();
                    uiState.selectedIndex = loopIndex(i, 0, uiState.selectableOpsCount - 1);
                    var selectedOption = getSelectedOption();
                    if (selectedOption) {
                        selectedOption.addClass(selOptionClass);
                    }
                    return selectedOption;
                }
                function clearHighlight() {
                    $element.find('.' + selOptionClass).removeClass(selOptionClass);
                }
                function suppressFocus() {
                    // Stops input focus showing menu again i.e. on menu click
                    // NOTE: angular $timeout would run an unwanted digest
                    uiState.denyFocus = true;
                    setTimeout(function () { return uiState.denyFocus = false; }, 200);
                }
                function selectNone() {
                    uiState.selectedIndex = -1;
                    clearHighlight();
                }
                function traverseOptions(incr) {
                    if (uiState.menuShowing) {
                        var op = highlightOption(uiState.selectedIndex + incr), opPos = op.position(), opTop = opPos && opPos.top;
                        if (opTop) {
                            // Center option vertically
                            ul.scrollTop(ul.scrollTop() + opTop - ul.height() / 2 + op.outerHeight(true) / 2);
                        }
                    }
                }
                function loopIndex(i, start, end) {
                    return i < start ? end : (i > end ? start : i);
                }
                function deregister() {
                    inputEl.off(eventNS);
                    ul.off(eventNS);
                }
                function getItemClasses(item) {
                    var classes = [];
                    classes.push(item.header ? 'field-options-header' : 'field-options-item');
                    if (item.isGroup) {
                        classes.push('field-options-item-parent');
                    }
                    if (item.isChild) {
                        classes.push('field-options-item-child');
                    }
                    return classes.join(' ');
                }
            };
        }
        return FieldOptions;
    }());
    ;
    angular
        .module('core')
        .directive('fieldOptions', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: FieldOptions,
            controllerAs: 'fo',
            bindToController: {
                inputField: '&',
                data: '=',
                select: '&',
                headerFormat: '@',
                optionFormat: '@',
                noHide: '=',
                classes: '@' // Additional CSS classes on wrapping <div>
            },
            replace: true,
            template: "<ul ng-class=\"'field-options ' + classes\"></ul>",
            link: function (scope) {
                // Initialise once input field exists
                var unwatchInit = scope.$watch(function () { return scope.fo.inputField(); }, function (inputEl) {
                    if (inputEl) {
                        unwatchInit();
                        scope.fo.createMenu(inputEl);
                    }
                });
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
/*
    Creates a dropdown menu of options for an input field.
    Header items must contain a truthy `header` property (will not be selectable).
*/
var Autocompleter;
(function (Autocompleter) {
    var FieldOptions2 = /** @class */ (function () {
        function FieldOptions2($scope, $element, $timeout, $q, $parse) {
            this.$scope = $scope;
            this.$element = $element;
            this.$timeout = $timeout;
            this.$q = $q;
            this.selOptionClass = 'selected';
            this.uiState = {
                menuPopulated: false,
                denyScroll: false,
                selectedIndex: -1,
                selectableOptions: {},
                selectableOpsCount: 0,
            };
            this.formatHeader = $parse(this.headerFormat || 'Title');
            this.formatLabel = $parse(this.optionFormat || 'Title');
            this.ul = $element;
        }
        FieldOptions2.prototype.createMenu = function () {
            var _this = this;
            var eventNS = '.fieldOptions';
            var uiHandlers = {
                9: function () { return _this.selectCurrentOption(); },
                13: function () { return _this.selectCurrentOption(); },
                16: angular.noop,
                38: function () { return _this.traverseOptions(-1); },
                40: function () { return _this.traverseOptions(1); } // Down arrow
            };
            // Debounced menu refresh (thenable)
            var debouncedPopulateMenu = _.debounce(function (resolve) {
                _this.populateMenu(_this.data);
                resolve();
            }, 100, {
                'leading': true,
                'trailing': true
            });
            var refreshMenu = function () { return _this.$q(debouncedPopulateMenu); };
            this.$scope.$watch('fo.data', function (v) {
                if (v) {
                    refreshMenu();
                }
            });
            // DOM listeners on input field
            this.inputEl
                .on('focus' + eventNS, refreshMenu)
                .on('keydown' + eventNS, function (event) {
                var handler = uiHandlers[event.keyCode];
                handler ? handler() : refreshMenu();
            })
                .on('click' + eventNS, function () {
                this.setSelectionRange(0, this.value.length);
                refreshMenu();
            });
            // DOM listeners on menu ul
            this.ul
                .on('mouseleave' + eventNS, function () { return _this.clearHighlight(); })
                .on('mouseenter' + eventNS, '> li', function (event) {
                var index = _this.ul.find('.field-options-item').index(event.target);
                if (index > -1) {
                    _this.highlightOption(index);
                }
                else {
                    _this.clearHighlight();
                }
            });
            this.$scope.$on('$destroy', function () {
                _this.inputEl.off(eventNS);
                _this.ul.off(eventNS);
            });
        };
        FieldOptions2.prototype.getCurrentOption = function () {
            if (this.uiState.selectedIndex > -1) {
                return this.$element.find('li').eq(this.uiState.selectableOptions[this.uiState.selectedIndex].domIndex);
            }
        };
        FieldOptions2.prototype.selectCurrentOption = function () {
            var op = this.getCurrentOption();
            if (op) {
                op.trigger('click');
            }
        };
        FieldOptions2.prototype.selectItem = function (params) {
            var _this = this;
            var item = params.item;
            if (params.e) {
                params.e.preventDefault();
                params.e.stopPropagation();
            }
            if (item && !item.header) {
                this.$scope.$emit('fieldOptionSelected', item);
                this.$timeout(function () {
                    _this.select(params); // `select` attribute
                });
            }
        };
        FieldOptions2.prototype.clearMenu = function () {
            this.uiState.selectableOptions = {};
            this.uiState.selectableOpsCount = 0;
            this.uiState.menuPopulated = false;
            this.ul.empty();
        };
        FieldOptions2.prototype.populateMenu = function (data) {
            var _this = this;
            this.clearMenu();
            if (data) {
                var opsCount_2 = 0;
                data.forEach(function (o, i) {
                    $("<li class=\"" + _this.getItemClasses(o) + "\">\n                          " + _this.getLabelHTML(o) + "\n                       </li>")
                        .click(function (e) { return _this.selectItem({ item: o, e: e }); })
                        .appendTo(_this.ul);
                    // Index non-headers
                    if (!o.header) {
                        _this.uiState.selectableOptions[opsCount_2++] = { domIndex: i, item: o };
                    }
                });
                this.uiState.selectableOpsCount = opsCount_2;
                if (opsCount_2) {
                    this.selectNone();
                    this.uiState.menuPopulated = true;
                    this.scrollToMenu();
                }
                else {
                    this.clearMenu();
                }
            }
        };
        FieldOptions2.prototype.scrollToMenu = function () {
            var _this = this;
            this.$timeout(function () {
                if (!_this.uiState.denyScroll && _this.ul.is(':visible')) {
                    var winPos = $(window).scrollTop(), winHeight = $(window).height(), ulPos = _this.ul.offset().top, ulHeight = _this.ul.outerHeight(), ulBottom = ulPos - winPos + ulHeight + 10, // Arbitrary gap
                    scrollPos = winPos + Math.min(ulBottom - winHeight, 150);
                    if (scrollPos > 0) {
                        _this.uiState.denyScroll = true;
                        $('html, body').animate({ scrollTop: scrollPos }, 200);
                    }
                }
            });
        };
        FieldOptions2.prototype.getLabelHTML = function (item) {
            if (item.header) {
                return this.formatHeader(item);
            }
            var label = this.formatLabel(item), fieldVal = this.inputEl.val(), term = fieldVal && fieldVal.trim().toLowerCase();
            if (term) {
                var termPos = label.toLowerCase().indexOf(term);
                if (termPos > -1) {
                    var termEnd = termPos + term.length, _a = [
                        label.substring(0, termPos),
                        label.substring(termPos, termEnd),
                        label.substring(termEnd)
                    ], str0 = _a[0], str1 = _a[1], str2 = _a[2];
                    label = str0 + "<span class=\"field-options-highlight\">" + str1 + "</span>" + str2;
                }
            }
            var icon = '';
            if (item.icon) {
                //const cssClass = item.isChild ? 'field-options-child' : '';
                //icon = `<i class="icon-${item.icon} ${cssClass}"></i>`;
                //icon = `<i class="icon icon-${item.icon}"></i>`;
            }
            label = icon + " " + label;
            return label;
        };
        FieldOptions2.prototype.highlightOption = function (i) {
            this.clearHighlight();
            this.uiState.selectedIndex = this.loopIndex(i, 0, this.uiState.selectableOpsCount - 1);
            var currentOption = this.getCurrentOption();
            if (currentOption) {
                currentOption.addClass(this.selOptionClass);
            }
        };
        FieldOptions2.prototype.clearHighlight = function () {
            this.$element.find('.' + this.selOptionClass).removeClass(this.selOptionClass);
        };
        FieldOptions2.prototype.selectNone = function () {
            this.uiState.selectedIndex = -1;
            this.clearHighlight();
        };
        FieldOptions2.prototype.traverseOptions = function (incr) {
            var op = this.highlightOption(this.uiState.selectedIndex + incr), opPos = op.position(), opTop = opPos && opPos.top;
            if (opTop) {
                // Center option vertically
                this.ul.scrollTop(this.ul.scrollTop() + opTop - this.ul.height() / 2 + op.outerHeight(true) / 2);
            }
        };
        FieldOptions2.prototype.loopIndex = function (i, start, end) {
            return i < start ? end : (i > end ? start : i);
        };
        FieldOptions2.prototype.getItemClasses = function (item) {
            var classes = [];
            classes.push(item.header ? 'field-options-header' : 'field-options-item');
            if (item.isGroup) {
                classes.push('field-options-item-parent');
            }
            if (item.isChild) {
                classes.push('field-options-item-child');
            }
            return classes.join(' ');
        };
        return FieldOptions2;
    }());
    ;
    angular
        .module('core')
        .directive('fieldOptions2', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: FieldOptions2,
            controllerAs: 'fo',
            bindToController: {
                inputField: '&',
                data: '=',
                select: '&',
                headerFormat: '@',
                optionFormat: '@' // Expression for option text format in menu (via $parse)
            },
            replace: true,
            template: "<ul ng-class=\"'field-options ' + classes\"\n                                ng-show=\"fo.uiState.menuPopulated\"></ul>",
            link: function (scope) {
                // Initialise once input field exists
                var unwatchInit = scope.$watch(function () { return scope.fo.inputField(); }, function (inputEl) {
                    if (inputEl) {
                        unwatchInit();
                        scope.fo.inputEl = inputEl;
                        scope.fo.createMenu();
                    }
                });
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .directive('flightAllocationSash', function (tripService, $routeParams, occupancyService) {
        return {
            scope: {
                ribbon: '=?',
                isFromOverlay: '=?',
                saveAmountText: '=?',
                showFlightPreselection: '=?'
            },
            controllerAs: 'scr',
            restrict: 'E',
            link: function (scope, element, attrs) {
                scope.$watch('ribbon', function (value) {
                    var _this = this;
                    // TODO - refactor, fixes attaching several child content elements
                    element.empty();
                    var showFlightPreselection = scope.showFlightPreselection;
                    var numNonInfants = occupancyService.getNumberOfNonInfantPassengers();
                    var numFlights = TRPCONFIG.Domain2.FlightPreselectionNumFlights;
                    var baggageCost = TRPCONFIG.Domain2.FlightPreselectionBaggageCost;
                    var saveAmountText = scope.saveAmountText;
                    if (!showFlightPreselection) {
                        return;
                    }
                    function fetchTrip(tripId) {
                        return __awaiter(this, void 0, void 0, function () {
                            var trip;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, tripService.getTrip(tripId)];
                                    case 1:
                                        trip = _a.sent();
                                        return [2 /*return*/, trip];
                                }
                            });
                        });
                    }
                    function calculateBaggageSaving(baggageCost, nonInfants) {
                        return baggageCost * nonInfants;
                    }
                    function strip(saveAmountText, numBaggageItems) {
                        var totalBaggageCost = calculateBaggageSaving(baggageCost, numBaggageItems);
                        var regex = new RegExp(/\{([0-9])\}/g);
                        return saveAmountText && saveAmountText.replace(regex, totalBaggageCost);
                    }
                    var getDetails = function () { return __awaiter(_this, void 0, void 0, function () {
                        var FlightsRequest, numBaggageItems, Text, ribbon, prefix_2, styles_1, styleClass, contentClass, ribbonElement, ribbonContent_1, textLengthValidator, textSeparator, textArray, textLength_1, boldStrClass_1, normalStrClass_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!$routeParams.tripId) {
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, fetchTrip($routeParams.tripId)];
                                case 1:
                                    FlightsRequest = (_a.sent()).FlightsRequest;
                                    if (!FlightsRequest) {
                                        return [2 /*return*/];
                                    }
                                    numBaggageItems = numNonInfants * numFlights;
                                    Text = strip(saveAmountText, numBaggageItems).trim();
                                    ribbon = {
                                        Text: Text,
                                        ColourClass: 'quaternary',
                                        EffectClasses: ['lighten80']
                                    };
                                    if (ribbon) {
                                        prefix_2 = 'sc-c-sash--';
                                        styles_1 = [
                                            'sc-c-sash',
                                            "" + prefix_2 + (ribbon && ribbon.ColourClass)
                                        ];
                                        ribbon.EffectClasses.forEach(function (effect) {
                                            styles_1.push("" + prefix_2 + effect); // Sets effect class to sash
                                        });
                                        styleClass = styles_1.join(' ');
                                        contentClass = 'sc-c-sash__label';
                                        ribbonElement = angular.element("<div>").addClass(styleClass);
                                        ribbonContent_1 = angular.element("<div>").addClass(contentClass);
                                        textLengthValidator = function (text) { return text && text.slice(0, 10); };
                                        textSeparator = ribbon.Text.includes('|') ? '|' : ' ';
                                        textArray = ribbon.Text.toUpperCase()
                                            .split(textSeparator)
                                            .map(textLengthValidator);
                                        textLength_1 = textArray.length;
                                        boldStrClass_1 = 'star-rating sc-u-bold sc-c-sash__row row-gutter-y__zero';
                                        normalStrClass_1 = 'star-rating sc-c-sash__row row-gutter-y__zero';
                                        textArray.forEach(function (current, index) {
                                            var isBold = ((textLength_1 - 1) === index && textLength_1 > 2) || index === 0;
                                            var label = angular.element("<span>" + current + "</span>")
                                                .addClass(isBold ? boldStrClass_1 : normalStrClass_1);
                                            ribbonContent_1.append(label);
                                        });
                                        ribbonElement.append(ribbonContent_1);
                                        element.append(ribbonElement);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    getDetails();
                });
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var FlightExtraTitles = /** @class */ (function () {
        function FlightExtraTitles() {
        }
        return FlightExtraTitles;
    }());
    var FlightExtrasSummary = /** @class */ (function () {
        function FlightExtrasSummary($scope, resourceService) {
            var _this = this;
            this.$scope = $scope;
            this.resourceService = resourceService;
            this.flightExtrasDescription = '';
            this.flightStrings = {
                Bag: resourceService.getDeferred('BREAKDOWNBAG'),
                Bags: resourceService.getDeferred('BREAKDOWNBAGS'),
                Extra: resourceService.getDeferred('BREAKDOWNFLIGHTEXTRA'),
                Extras: resourceService.getDeferred('BREAKDOWNFLIGHTEXTRAS'),
                Seat: resourceService.getDeferred('BREAKDOWNSEAT'),
                Seats: resourceService.getDeferred('BREAKDOWNSEATS')
            };
            $scope.$watch('fes.optionCounts', function (v) {
                if (v) {
                    _this.updateFlightExtrasDescription();
                }
            });
        }
        FlightExtrasSummary.prototype.updateFlightExtrasDescription = function () {
            //we want to build a description of the extras included with our flight eg (+ bags, seats)
            var labels = [];
            if (this.optionCounts.HoldBags > 0) {
                var bagslabel = this.optionCounts.HoldBags === 1 ? this.flightStrings.Bag() : this.flightStrings.Bags();
                labels.push("" + bagslabel);
            }
            if (this.optionCounts.Seats > 0) {
                labels.push(this.optionCounts.Seats === 1 ? this.flightStrings.Seat() : this.flightStrings.Seats());
            }
            if (labels.length > 0) {
                this.flightExtrasDescription = String.format.apply(String, [labels.length > 1 ? this.flightStrings.Extras() : this.flightStrings.Extra()].concat(labels));
            }
            else {
                this.flightExtrasDescription = '';
            }
        };
        return FlightExtrasSummary;
    }());
    angular
        .module('core')
        .directive('flightExtrasSummary', function () {
        return {
            scope: {},
            restrict: 'E',
            bindToController: {
                optionCounts: '='
            },
            controller: FlightExtrasSummary,
            controllerAs: 'fes',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=FlightExtrasSummary'
        };
    });
})(Core || (Core = {}));
//This directive is to delay the loading of all Google Tag Manager type scripts
//until after AngularJS has has a change to load itself.
var Core;
(function (Core) {
    var Gtm = /** @class */ (function () {
        function Gtm($element, $timeout) {
            $timeout(function () {
                $element.append('<script src="build/gtm/gtm-bundle.js" async></script>');
                if (TRPCONFIG.Domain.GtmHelpersScriptEnabled) {
                    $element.append('<script src="build/gtm/gtm-helpers.js" async></script>');
                }
            }, 1000);
        }
        return Gtm;
    }());
    angular
        .module('core')
        .directive('gtm', function () {
        return {
            restrict: 'E',
            controller: Gtm
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var HotelContentCard = /** @class */ (function () {
        function HotelContentCard() {
        }
        return HotelContentCard;
    }());
    angular
        .module('core')
        .directive('hotelContentCard', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: HotelContentCard,
            controllerAs: 'hc',
            replace: true,
            bindToController: {
                model: '=',
                click: '&',
                header: '@',
                href: '@',
                teaserPrice: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=HotelContentCard'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var CancellationInformation = /** @class */ (function () {
        function CancellationInformation(nonRefundable, refundableCutOff, cancellationCutOff, payAtHotel) {
            if (nonRefundable === true) {
                this.nonRefundable = nonRefundable;
            }
            else if (refundableCutOff != null) {
                this.amendableUntil = refundableCutOff;
            }
            else if (cancellationCutOff != null) {
                this.freeCancellationUntil = cancellationCutOff;
            }
            this.isPayAtHotel = payAtHotel;
        }
        return CancellationInformation;
    }());
    var HotelStaySummaryRoom = /** @class */ (function () {
        function HotelStaySummaryRoom(quantity, roomDescription, boardDescription, cancellationPolicy) {
            this.quantity = 1;
            this.quantity = quantity;
            this.roomDescription = roomDescription;
            this.boardDescription = boardDescription;
            this.cancellationInfo = cancellationPolicy;
        }
        return HotelStaySummaryRoom;
    }());
    var HotelStaySummary = /** @class */ (function () {
        function HotelStaySummary($scope, modalService, basketService) {
            var _this = this;
            this.$scope = $scope;
            this.modalService = modalService;
            this.basketService = basketService;
            this.$scope.$watch('hss.hotel.Details.BookedItems', function (v) {
                if (!_.isArray(v)) {
                    return;
                }
                // concatenate rooms which have matching descriptions, board types and cancellation messages
                _this.rooms = [];
                _.each(v, function (bi) {
                    var room = bi.RoomDescription;
                    var board = bi.BoardDescription;
                    var info = new CancellationInformation(bi.NonRefundable, bi.RefundableCutOffDate, _this.hotel.FreeCancellationCutOffDate, bi.IsPayAtHotel);
                    if (_this.groupRooms === false) {
                        _this.rooms.push(new HotelStaySummaryRoom(1, room, board, info));
                    }
                    else {
                        var match = _.find(_this.rooms, function (r) {
                            return r.roomDescription === room
                                && r.boardDescription === board
                                && _.isEqual(r.cancellationInfo, info);
                        });
                        if (match) {
                            match.quantity += 1;
                        }
                        else {
                            _this.rooms.push(new HotelStaySummaryRoom(1, room, board, info));
                        }
                    }
                });
            });
        }
        HotelStaySummary.prototype.showModal = function (url) {
            this.modalService.launch(url);
        };
        HotelStaySummary.prototype.changeHotel = function () {
            this.basketService.changeJourneyUrl(20);
        };
        return HotelStaySummary;
    }());
    angular
        .module('core')
        .directive('hotelStaySummary', function () {
        return {
            scope: {},
            controller: HotelStaySummary,
            controllerAs: 'hss',
            replace: true,
            bindToController: {
                atolAvailable: '=',
                hotel: '=',
                occupancy: '=',
                groupRooms: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=HotelStaySummary&version='
                        + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=HotelStaySummary';
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    ;
    var HowToGetThere = /** @class */ (function () {
        function HowToGetThere(flightStaticService, geo, $q) {
            var _this = this;
            this.geo = geo;
            this.$q = $q;
            this.getDepartureAirports().then(function (departureAirports) {
                var departureAirportGroups = _.map(departureAirports, function (a) { return a.Code; });
                var destinationAirportGroups = [_this.destinationAirports];
                flightStaticService.getFlightDurations(departureAirportGroups, destinationAirportGroups)
                    .then(function (durations) {
                    _this.options = _.chain(departureAirports)
                        .map(function (a) { return ({
                        a: a,
                        d: _.find(durations, function (d) { return d.DurationMinutesDepartureAirport === a.Code; })
                    }); })
                        .filter(function (tuple) { return tuple.d; })
                        .map(function (tuple) {
                        var option = {
                            departureTitle: tuple.a.Title,
                            duration: _this.formatDuration(tuple.d.DurationMinutes)
                        };
                        return option;
                    })
                        .value();
                });
            });
        }
        HowToGetThere.prototype.getDepartureAirports = function () {
            if (TRPCONFIG.Domain.HowToGetThereDepartureAirports) {
                var departureAirports = angular.fromJson(TRPCONFIG.Domain.HowToGetThereDepartureAirports);
                return this.$q.when(departureAirports);
            }
            return this.geo.getNearestAirportTitles();
        };
        HowToGetThere.prototype.formatDuration = function (minutes) {
            var hours = Math.floor(minutes / 60);
            var duration = hours > 0 ? (hours + 'h ') : '';
            duration += (minutes % 60) + 'm';
            return duration;
        };
        return HowToGetThere;
    }());
    angular
        .module('core')
        .directive('howToGetThere', function () {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=LandingPage/HowToGetThere',
            bindToController: {
                destinationTitle: '@',
                destinationAirports: '@'
            },
            scope: {},
            controller: HowToGetThere,
            controllerAs: 'ht'
        };
    });
})(Core || (Core = {}));
var ekh;
(function (ekh) {
    angular
        .module('ekh')
        .directive('imageResize', function (imageService) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                var size = imageService.getAppropriateSize($(window).width())[0];
                var source = $attrs['imageResize'];
                if (!source) {
                    var imageObserver_1 = $attrs.$observe('imageResize', function (value) {
                        if (value) {
                            source = value;
                            applySource();
                            imageObserver_1();
                        }
                    });
                }
                else {
                    applySource();
                }
                function applySource() {
                    if (source) {
                        source = source.replace(/(width|height)=\d+&?/g, '');
                        var hasParams = /\?/.test(source);
                        source += (hasParams ? '&' : '?') + "width=" + size;
                        if ($element[0].tagName.toUpperCase() === 'IMG') {
                            $element.attr('src', source);
                        }
                        else {
                            $element.css({ 'background-image': "url('" + source + "')" });
                        }
                    }
                }
            }
        };
    });
})(ekh || (ekh = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    var count = 1;
    var startTime = new Date().toISOString();
    function uniqueId() {
        return startTime + count++;
    }
    function newCompile($element) {
        if (TRPCONFIG.Domain.AutocompleteFix === 'remove') {
            $element.removeAttr('autocomplete');
        }
        else if (TRPCONFIG.Domain.AutocompleteFix === 'nope') {
            //https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
            $element.attr('autocomplete', 'nope');
        }
        else if (TRPCONFIG.Domain.AutocompleteFix === 'unique') {
            $element.attr('autocomplete', uniqueId());
        }
    }
    if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain.AutocompleteFix) {
        TR.config(function ($provide) {
            $provide.decorator('inputDirective', function ($delegate) {
                var formDirective = $delegate[0];
                var oldCompile = formDirective.compile;
                formDirective.compile = function ($element) {
                    newCompile($element);
                    // eslint-disable-next-line prefer-rest-params
                    return oldCompile.apply(this, arguments);
                };
                return $delegate;
            });
        });
    }
})();
var Core;
(function (Core) {
    /*
    * This is for cases where we have nested forms and we'd like to validate the nested form independently of its
    * parent form
    * "borrowed" from here: https://github.com/angular/angular.js/issues/5858
     */
    var IsolateForm = /** @class */ (function () {
        function IsolateForm() {
            this.link = function (scope, element, attrs, controller) {
                if (!controller) {
                    return;
                }
                element.addClass('isolated-form');
                // Do a copy of the controller
                var copy = {};
                angular.copy(controller, copy);
                // Get the parent of the form
                var parent = element.parent().controller('form');
                // Remove parent link to the controller
                parent.$removeControl(controller);
                // Replace form controller with a "isolated form"
                var isolatedFormCtrl = {
                    $setValidity: function (validationToken, isValid, control) {
                        copy.$setValidity(validationToken, isValid, control);
                        parent.$setValidity(validationToken, true, controller);
                    },
                    $setDirty: function () {
                        element.removeClass('ng-pristine').addClass('ng-dirty');
                        controller.$dirty = true;
                        controller.$pristine = false;
                    }
                };
                angular.extend(controller, isolatedFormCtrl);
            };
            this.restrict = 'A';
            this.require = '?form';
        }
        IsolateForm.factory = function () {
            var directive = function () { return new IsolateForm(); };
            directive.$inject = [];
            return directive;
        };
        return IsolateForm;
    }());
    var TR = angular.module('TR');
    TR.directive('isolateForm', IsolateForm.factory());
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .directive('isolatedNestedForm', isolatedNestedForm);
    function isolatedNestedForm() {
        return {
            restrict: 'A',
            require: '?form',
            link: function (scope, element, attrs, formController) {
                var isolatedFormEnabled = true;
                if (attrs.isolatedNestedFormEnabled !== undefined) {
                    isolatedFormEnabled = (attrs.isolatedNestedFormEnabled === 'true');
                }
                if (!formController) {
                    return;
                }
                var parentForm = formController.$$parentForm;
                if (!parentForm) {
                    return;
                }
                // Remove this form from parent controller
                if (isolatedFormEnabled) {
                    parentForm.$removeControl(formController);
                }
            }
        };
    }
})();
(function () {
    'use strict';
    var allImages = {};
    angular
        .module('core')
        .directive('lazySrc', lazySrc);
    function lazySrc($window, imageService, broker, $document) {
        var lazyLoader = (function () {
            var images = [];
            var renderTimer = null;
            var renderDelay = 100;
            var win = $($window);
            var doc = $document;
            var documentHeight = doc.height();
            var documentTimer = null;
            var documentDelay = 2000;
            var isWatchingWindow = false;
            function addImage(image) {
                images.push(image);
                if (!renderTimer) {
                    startRenderTimer();
                }
                if (!isWatchingWindow) {
                    startWatchingWindow();
                }
            }
            function removeImage(image) {
                images = _.reject(images, function (i) { return i === image; });
                if (!images.length) {
                    clearRenderTimer();
                    stopWatchingWindow();
                }
            }
            function checkDocumentHeight() {
                if (renderTimer) {
                    return;
                }
                var currentDocumentHeight = doc.height();
                if (currentDocumentHeight === documentHeight) {
                    return;
                }
                documentHeight = currentDocumentHeight;
                startRenderTimer();
            }
            function checkImages() {
                var windowHeight = win.height();
                var topFoldOffset = win.scrollTop();
                var bottomFoldOffset = (topFoldOffset + windowHeight);
                images = _.filter(images, function (image) {
                    var visible = image.isVisible(topFoldOffset, bottomFoldOffset);
                    if (visible) {
                        image.render();
                    }
                    return !visible;
                });
                clearRenderTimer();
                if (!images.length) {
                    stopWatchingWindow();
                }
            }
            function clearRenderTimer() {
                clearTimeout(renderTimer);
                renderTimer = null;
            }
            function startRenderTimer() {
                renderTimer = setTimeout(checkImages, renderDelay);
            }
            function startWatchingWindow() {
                isWatchingWindow = true;
                win.on('resize.lazySrc', windowChanged);
                win.on('scroll.lazySrc', windowChanged);
                documentTimer = setInterval(checkDocumentHeight, documentDelay);
                broker.subscribe('LazySrc', 'LazySrcRetry', windowChanged);
            }
            function stopWatchingWindow() {
                isWatchingWindow = false;
                win.off('resize.lazySrc');
                win.off('scroll.lazySrc');
                clearInterval(documentTimer);
                broker.unsubscribe('LazySrc');
            }
            function windowChanged() {
                if (!renderTimer) {
                    startRenderTimer();
                }
            }
            return ({ addImage: addImage, removeImage: removeImage });
        })();
        function LazyImage(element, isFixedSize, isRendered) {
            var source = null;
            var height = null;
            $(element).addClass('lazy-load');
            function isVisible(topFoldOffset, bottomFoldOffset) {
                if (!element.is(':visible')) {
                    return false;
                }
                if (height === null) {
                    height = element.height();
                }
                var top = element.offset().top;
                var bottom = top + height;
                return (top <= bottomFoldOffset && top >= topFoldOffset) ||
                    (bottom <= bottomFoldOffset && bottom >= topFoldOffset) ||
                    (top <= topFoldOffset && bottom >= bottomFoldOffset);
            }
            function setSource(newSource) {
                source = newSource;
                if (isRendered) {
                    render();
                }
            }
            function render() {
                isRendered ? renderSource() : setTimeout(renderSource);
            }
            function renderSource() {
                var el = element[0];
                if (!isFixedSize) {
                    var elWidth = element.outerWidth();
                    var elHeight = element.outerHeight();
                    var appropWidth = void 0;
                    var appropHeight = void 0;
                    source = source.replace(/(width|height)=\d+&?/g, '');
                    if (!/\?/.test(source)) {
                        source += '?';
                    }
                    if (elWidth < 2 || elHeight < 2) {
                        // i.e. a 1x1 placeholder (no `src` fails ':visible' test above)
                        // Use parent width, leave height unspecified
                        appropWidth = elWidth > 2 ? elWidth : 0;
                        appropWidth = appropWidth || element.parent().width() || element.parent().parent().width() || 0;
                    }
                    else {
                        // Else add height to the img src string
                        _a = imageService.getAppropriateSize(elWidth, elHeight), appropWidth = _a[0], appropHeight = _a[1];
                    }
                    var isRatio16x9 = $(element).is('.sc-c-responsive-image--16x9, .sc-c-responsive-image--16x9 *');
                    if (isRatio16x9) {
                        appropHeight = Math.ceil(appropWidth * 9 / 16);
                        source += '&crop=true';
                    }
                    source += "&width=" + appropWidth;
                    if (appropHeight) {
                        source += "&height=" + appropHeight;
                    }
                    source = source.replace(/\?&+/g, '?');
                    source = source.replace(/&&+/g, '&');
                }
                if (isRendered) {
                    addSourceToElement(el, source);
                }
                else {
                    // preload the image before we set the src (for smooth fade in)
                    var image = new Image();
                    image.onload = function () { return addSourceToElement(el, source); };
                    image.src = source;
                }
                isRendered = true;
                var _a;
            }
            function addSourceToElement(el, source) {
                if (el.tagName.toUpperCase() === 'IMG') {
                    el.src = source;
                }
                else {
                    el.style.backgroundImage = "url(" + source + ")";
                }
                $(el).addClass('lazy-loaded');
            }
            return ({ isVisible: isVisible, render: render, setSource: setSource });
        }
        function link($scope, element, attributes) {
            var isRendered = (function () {
                if (attributes.lazySrcIsPrerender === 'true') {
                    return true;
                }
                if (attributes.lazySrcIsPrerender === 'false') {
                    return false;
                }
                if (attributes.lazySrc && allImages[attributes.lazySrc]) {
                    return true;
                }
                return TRPCONFIG.IsPrerender;
            })();
            allImages[attributes.lazySrc] = true;
            var isFixedSize = attributes.lazySrcFixedSize === 'true';
            var lazyImage = new LazyImage(element, isFixedSize, isRendered);
            lazyLoader.addImage(lazyImage);
            attributes.$observe('lazySrc', function (newSource) { return lazyImage.setSource(newSource); });
            $scope.$on('$destroy', function () { return lazyLoader.removeImage(lazyImage); });
        }
        return ({ link: link, restrict: 'A' });
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .directive('loadingSpinner', loadingSpinner);
    function loadingSpinner(resourceService) {
        return {
            restrict: 'A',
            scope: {
                block: '=loadingSpinner',
                message: '@message'
            },
            link: function (scope, el) {
                var loadingTemplate = "" + '<div class="content">' +
                    '    <div class="loading-screen">' +
                    '        <h3>' + resourceService.get(scope.message ? scope.message : 'LOADING') + "</h3>" +
                    '        <div class="spinner-horizontal"></div>' +
                    ("        <p>" + resourceService.get('THISMAYTAKE') + "</p>") +
                    '    </div>' +
                    '</div>';
                var wait = angular.element(loadingTemplate);
                el.css('display', 'none');
                el.after(wait);
                var sw = scope.$watch('block', function (val) {
                    if (val) {
                        el.css('display', '');
                        wait.css('display', 'none');
                        sw();
                    }
                });
            }
        };
    }
})();
var Core;
(function (Core) {
    var ModalFlightDetails = /** @class */ (function () {
        function ModalFlightDetails($scope, broker, flightDetail) {
            this.$scope = $scope;
            this.broker = broker;
            this.flightDetail = flightDetail;
            this.customiseMessage = false;
        }
        ModalFlightDetails.prototype.init = function (container) {
            var _this = this;
            this.broker.subscribe('modalFlightDetails', 'showModalFlightDetails', function (e) {
                _this.flight = e.data.flight;
                _this.passengers = e.data.passengers;
                _this.show = true;
                _this.customiseMessage = e.data.customiseMessage;
            });
            this.$scope.$on('$destroy', function () {
                _this.broker.unsubscribe('modalFlightDetails');
            });
        };
        ModalFlightDetails.prototype.isHFareFlightType = function () {
            return this.flightDetail.isHFlightType(this.flight);
        };
        return ModalFlightDetails;
    }());
    angular
        .module('core')
        .directive('modalFlightDetails', function () {
        return {
            scope: {},
            controller: ModalFlightDetails,
            controllerAs: 'fdc',
            templateUrl: 'partials/home/directivetemplate?type=FlightListingDetails',
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Booking;
(function (Booking) {
    var ModalLink = /** @class */ (function () {
        function ModalLink($element, $location, currentUser, accountMenuService, postBookingLookup, modalService, analytics) {
            this.$element = $element;
            this.$location = $location;
            this.currentUser = currentUser;
            this.accountMenuService = accountMenuService;
            this.postBookingLookup = postBookingLookup;
            this.modalService = modalService;
            this.analytics = analytics;
        }
        ModalLink.prototype.select = function (event) {
            switch (this.modalType) {
                case 'termsconditions':
                    this.modalService.launch('partials/popups/agencyterms');
                    break;
                case 'unsubscribe':
                    this.analytics.track('mixpanel', 'GDPRUnsubscribe');
                    this.modalService.launch('partials/popups/unsubscribe');
                    break;
                default:
                    this.manage();
                    break;
            }
        };
        ModalLink.prototype.manage = function () {
            if (this.currentUser.AnonSignedIn && !this.currentUser.SignedIn) {
                return this.postBookingLookup.redirect();
            }
            if (!this.currentUser.AnonSignedIn && this.currentUser.SignedIn) {
                return this.$location.path('dashboard/bookings/current');
            }
            return this.accountMenuService.launchOption('signin');
        };
        return ModalLink;
    }());
    angular
        .module('core')
        .directive('modalLink', function () {
        return {
            restrict: 'A',
            replace: true,
            transclude: true,
            scope: {},
            bindToController: {
                modalType: '@'
            },
            controller: ModalLink,
            controllerAs: 'ml',
            template: '<a ng-click="ml.select()" ng-transclude></a>'
        };
    });
})(Booking || (Booking = {}));
var Core;
(function (Core) {
    var ModalTransferDetails = /** @class */ (function () {
        function ModalTransferDetails($scope, broker, $filter) {
            this.$scope = $scope;
            this.broker = broker;
            this.$filter = $filter;
            this.passengers = { adults: 0, children: 0 };
            this.show = false;
            this.details = [];
        }
        ModalTransferDetails.prototype.init = function (container) {
            var _this = this;
            this.broker.subscribe('modalTransferDetails', 'showModalTransferDetails', function (e) {
                _this.show = true;
            });
            this.$scope.$on('$destroy', function () {
                _this.broker.unsubscribe('modalTransferDetails');
            });
            if (this.transfers) {
                this.passengers = {
                    adults: this.transfers.Details.Adults || 0,
                    children: this.transfers.Details.ChildAges ? this.transfers.Details.ChildAges.length : 0
                };
                this.details = ['Outbound', 'Inbound'].map(function (direction) {
                    var itinerary = _this.transfers.Details.Itinerary;
                    return {
                        Direction: direction,
                        Departure: _.get(itinerary, "[" + direction + "Leg].DeparturePoint", ''),
                        DepartureDate: _this.$filter('date')(_.get(itinerary, "[" + direction + "Leg].DepartureDate", ''), 'EEE d MMM yyyy, hh:mm'),
                        Destination: _.get(itinerary, "[" + direction + "Leg].DestinationPoint", ''),
                        FlightDate: _this.$filter('date')(_.get(itinerary, "[" + direction + "Leg].FlightDate", ''), 'EEE d MMM yyyy, hh:mm'),
                        TransferType: _.get(itinerary, "[" + direction + "Leg].TransferType", '')
                    };
                });
            }
        };
        return ModalTransferDetails;
    }());
    angular
        .module('core')
        .directive('modalTransferDetails', function () {
        return {
            scope: {},
            controller: ModalTransferDetails,
            controllerAs: 'mtd',
            templateUrl: 'partials/home/directivetemplate?type=TransferDetails',
            bindToController: {
                transfers: '='
            },
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var NewsFlash = /** @class */ (function () {
        function NewsFlash($element, cookieService) {
            this.$element = $element;
            this.cookieService = cookieService;
            this.isDismissed = false;
            this.isDismissed = this.cookieService.get('newsflash') !== null;
        }
        NewsFlash.prototype.onClosed = function () {
            this.$element.slideUp();
            this.persist();
        };
        NewsFlash.prototype.persist = function () {
            this.cookieService.set('newsflash', 'dismissed');
        };
        return NewsFlash;
    }());
    angular
        .module('core')
        .directive('newsflash', function (cookieService) {
        return {
            restrict: 'A',
            replace: true,
            transclude: true,
            controller: NewsFlash,
            controllerAs: 'nf',
            scope: {},
            bindToController: {
                dismissable: '@',
                text: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=Newsflash'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var PayLater = /** @class */ (function () {
        function PayLater($scope, analytics, modalService, $route) {
            var _this = this;
            this.$scope = $scope;
            this.analytics = analytics;
            this.modalService = modalService;
            this.$route = $route;
            this.enabled = false;
            this.validAreas = {
                Holidays: 'holidays',
                Hotels: 'hotels'
            };
            if (this.overrideEnabled) {
                this.enabled = true;
            }
            else {
                var total_1 = this.$scope.$watch('pl.total', function (value) {
                    if (value) {
                        _this.enabled = _this.getEnabled();
                        total_1();
                    }
                });
                var area_1 = this.$scope.$watch('pl.area', function (value) {
                    if (value) {
                        _this.enabled = _this.getEnabled();
                        area_1();
                    }
                });
            }
        }
        PayLater.prototype.getEnabled = function () {
            var area = this.area || this.$route.current.area;
            return (area.toLowerCase() === this.validAreas.Holidays || area.toLowerCase() === this.validAreas.Hotels)
                && TRPCONFIG.Domain.BuyNowPayLaterEnabled && this.total > TRPCONFIG.Domain.BuyNowPayLaterCost;
        };
        PayLater.prototype.showPayLaterModal = function () {
            this.analytics.track('mixpanel', 'PayLaterModal');
            this.modalService.launch('partials/popups/paylater');
        };
        return PayLater;
    }());
    angular
        .module('core')
        .directive('payLater', function ($filter) {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            bindToController: {
                message: '@',
                total: '@',
                viewType: '@',
                area: '@',
                overrideEnabled: '='
            },
            controller: PayLater,
            controllerAs: 'pl',
            template: function (elem, attrs) {
                if (attrs.viewType === 'link') {
                    return "<div class=\"hype-message\" ng-show=\"pl.enabled\">\n                        <a class=\"hype-message hype-message-pay-later\" href=\"offers/zero-interest-payment-plan\" \n                        target= \"_blank\">{{ pl.message }}</a>\n                        </div>";
                }
                else if (attrs.viewType === 'banner') {
                    return "<div class=\"pay-later-block\" ng-show=\"pl.enabled\">\n                        <img class=\"pay-later-banner\"/>\n                        </div>";
                }
                else if (attrs.viewType === 'block') {
                    return "<div class=\"pay-later-block\" ng-show=\"pl.enabled\">\n                        <div class=\"pay-later-img\"></div>\n                        <div class=\"pay-later-desc\">\n                            <p ng-bind-html=\"pl.message\"></p>\n                        </div>\n                        </div>";
                }
                return "<div class=\"hype-message hype-message-pay-later hype-message-has-popup\"\n                    ng-show=\"pl.enabled\" ng-click=\"pl.showPayLaterModal()\">\n                    {{ pl.message }}<i class=\"icon-information\"></i>\n                    </div>";
            }
        };
    });
})(Core || (Core = {}));
var Payment;
(function (Payment_1) {
    var PaymentCategory;
    (function (PaymentCategory) {
        PaymentCategory[PaymentCategory["SavedCard"] = 1] = "SavedCard";
        PaymentCategory[PaymentCategory["PayPal"] = 2] = "PayPal";
        PaymentCategory[PaymentCategory["Card"] = 3] = "Card";
    })(PaymentCategory || (PaymentCategory = {}));
    var PaymentOptionId;
    (function (PaymentOptionId) {
        PaymentOptionId[PaymentOptionId["PayPal"] = 101] = "PayPal";
    })(PaymentOptionId || (PaymentOptionId = {}));
    var year = new Date().getFullYear();
    var Payment = /** @class */ (function () {
        function Payment($scope, paymentsService, paymentsUtilService, broker) {
            var _this = this;
            this.$scope = $scope;
            this.paymentsService = paymentsService;
            this.paymentsUtilService = paymentsUtilService;
            this.broker = broker;
            this.currentDate = new Date();
            this.currentMonth = this.currentDate.getMonth();
            this.currentYear = this.currentDate.getFullYear();
            this.monthFrom = 1;
            this.months = _.range(1, 13);
            this.years = _.range(year, year + 21);
            this.yearsPast = _.range(year - 10, year + 1);
            //use the viewPage property to determine which functions and watches we should be using.
            // This is only here so that we can support the old template for the cards
            this.usingOldTemplate = /v1/i.test(this.viewPage);
            var wait = $scope.$watch('pay.ready', function (b) {
                if (b) {
                    _this.initPaymentOptions();
                    _this.initSavedCards();
                    if (_this.paymentAmount != null) {
                        $scope.$watch('pay.paymentAmount', function (v) {
                            if (v != null) {
                                _this.setCardFee(v);
                            }
                        });
                    }
                    _this.setDefaultSelection();
                    wait();
                }
            });
            if (this.usingOldTemplate) {
                $scope.$watch('pay.selectedSavedCard', function (v) {
                    if (v) {
                        _this.savedCardSelected_TabVersion(v);
                    }
                });
            }
            else {
                //better to watch the change of options like this. Radio button onChange seems to get it self in to
                //a muddle and each click generates 3 changes!
                $scope.$watch('pay.selectedPaymentOptionId', function (v) {
                    if (v) {
                        if (v.length > 1) {
                            _this.savedCardSelected(v);
                        }
                        else {
                            _this.paymentOptionChanged(parseInt(v, 10));
                        }
                    }
                });
            }
            $scope.$watch('[pay.model.cardDetail.expiryDate.year]', function (v) {
                var expiryDateYear = _this.model.cardDetail.expiryDate.year;
                var expiryDateMonth = _this.model.cardDetail.expiryDate.month;
                if (expiryDateYear === _this.currentYear) {
                    _this.monthFrom = _this.currentMonth + 1;
                    expiryDateMonth < _this.currentMonth ? _this.model.cardDetail.expiryDate.month = 0 : null;
                    _this.months = _.range(_this.monthFrom, 13);
                }
                else {
                    _this.months = _.range(1, 13);
                }
            });
            $scope.$watch('pay.creditCardErrors', function (value, previousValue) {
                if (value && value !== previousValue) {
                    if (value.invalid) {
                        _this.updateSelectedLogo(0);
                    }
                }
            });
        }
        Payment.prototype.updateCardType = function () {
            this.model.cardDetail.cardNumber = undefined;
            if (this.model.cardDetail.cardTypeId) {
                var card = _.find(this.paymentOptions, { 'CardTypeId': this.model.cardDetail.cardTypeId });
                this.model.isPayPalPayment = false;
                this.model.cardDetail.isSavedCard = false;
                this.model.cardDetail.paymentOptionId = card.Id;
                this.model.cardDetail.paymentTypeId = card.PaymentType;
                this.model.cardDetail.cardTypeId = card.CardTypeId;
                this.fullCardDetailsRequired = card.FullDetailsRequired;
                this.isExternalFop = card.IsExternalFop;
                this.model.externalFop = this.paymentsUtilService.createEmptyExternalFop();
                this.setCardFee(this.paymentAmount);
                this.updateSelectedLogo(this.model.cardDetail.cardTypeId);
            }
            else {
                this.clearModel();
            }
        };
        Payment.prototype.selectTab = function (category) {
            //USED in tab version of template
            this.clearModel();
            this.paymentCategory = category;
            if (category === PaymentCategory.SavedCard) {
                this.selectedSavedCard = this.savedCards[0];
            }
            else {
                this.selectedSavedCard = null;
                if (category === PaymentCategory.PayPal) {
                    this.selectPayPalOption();
                }
                else {
                    this.model.saveCard = TRPCONFIG.Domain.SavedCardsEnabled && this.cardCanBeSaved;
                }
            }
        };
        Payment.prototype.updateDfReferenceId = function (dfReferenceId) {
            this.onReceive({ dfReferenceId: dfReferenceId });
        };
        Payment.prototype.addPreBookCommand = function (command) {
            this.addCommand({ command: command });
        };
        Payment.prototype.checkCreditCardNumber = function (cardNumber) {
            var _this = this;
            this.cardTypeChanged = '';
            if (!cardNumber) {
                return;
            }
            this.paymentsService.checkCardNumber(this.paymentOptions, cardNumber, this.model.cardDetail.cardTypeId)
                .then(function (result) {
                _this.updateSelectedLogo(result);
            }, function (result) {
                var cardOption = _.find(_this.paymentOptions, function (o) { return (o.CardTypeId === result); });
                var correctId = cardOption ? cardOption.CardTypeId : undefined;
                if (_this.model.cardDetail.cardTypeId !== correctId) {
                    _this.clearModel();
                    _this.model.cardDetail.cardTypeId = correctId;
                    _this.updateCardType();
                    _this.model.cardDetail.cardNumber = cardNumber;
                    _this.cardTypeChanged = _this.paymentsService.getCardTitle(_this.paymentOptions, correctId);
                }
            });
        };
        Payment.prototype.selectPayPalOption = function () {
            this.model.isPayPalPayment = true;
            this.model.cardDetail.cardTypeId = this.payPalOption.CardTypeId;
            this.model.cardDetail.paymentOptionId = this.payPalOption.Id;
            this.model.cardDetail.paymentTypeId = this.payPalOption.PaymentType;
            this.setCardFee(this.paymentAmount);
        };
        Payment.prototype.savedCardSelected = function (cardId) {
            this.clearModel();
            var selectedCard = _.find(this.savedCards, { 'CardId': cardId });
            this.fullCardDetailsRequired = selectedCard.FullDetailsRequired;
            this.model.isPayPalPayment = false;
            this.model.cardDetail.isSavedCard = true;
            this.model.cardDetail.paymentOptionId = selectedCard.CardType;
            this.model.cardDetail.paymentTypeId = selectedCard.PaymentTypeId;
            this.model.cardDetail.savedCardId = selectedCard.CardId;
            this.setCardFee(this.paymentAmount);
        };
        Payment.prototype.savedCardSelected_TabVersion = function (card) {
            //USED in tab version of template
            this.clearModel();
            this.model.isPayPalPayment = false;
            this.model.cardDetail.isSavedCard = true;
            this.model.cardDetail.savedCardId = card.CardId;
            this.model.cardDetail.paymentOptionId = card.CardType;
            this.model.cardDetail.paymentTypeId = card.PaymentTypeId;
            this.fullCardDetailsRequired = card.FullDetailsRequired;
            this.setCardFee(this.paymentAmount);
        };
        Payment.prototype.paymentOptionChanged = function (category) {
            this.clearModel();
            if (category === PaymentCategory.Card) {
                this.model.saveCard = TRPCONFIG.Domain.SavedCardsEnabled && this.cardCanBeSaved;
            }
            else if (category === PaymentCategory.PayPal) {
                this.selectPayPalOption();
            }
        };
        Payment.prototype.initPaymentOptions = function () {
            this.paymentOptions = angular.copy(this.piPaymentOptions);
            var paypalOptions = _.remove(this.paymentOptions, function (o) { return o.IsPayPal === true; });
            if (paypalOptions && paypalOptions.length > 0 && paypalOptions[0].Id === PaymentOptionId.PayPal) {
                this.payPalOption = paypalOptions[0];
            }
            this.logoList = this.paymentsService.getLogosList(this.paymentOptions.concat(this.payPalOption || []));
        };
        Payment.prototype.updateSelectedLogo = function (selected) {
            this.broker.publish('Qubit:TRB-4:cardTypeUpdated', { id: selected });
        };
        Payment.prototype.initSavedCards = function () {
            var _this = this;
            if (this.piSavedCards && this.piSavedCards.length > 0) {
                this.savedCards = _.filter(this.piSavedCards, { 'IsExpired': false });
                if (this.usingOldTemplate === false) {
                    this.savedCards = _.take(this.savedCards, 3);
                }
            }
            else {
                this.savedCards = [];
            }
            this.haveSavedCards = this.savedCards.length > 0;
            if (this.haveSavedCards && !this.savedCardsWatch) {
                //watch if our original list is ever changed
                this.savedCardsWatch = this.$scope.$watch('pay.piSavedCards', function () {
                    _this.initSavedCards();
                    _this.setDefaultSelection();
                });
            }
        };
        Payment.prototype.setDefaultSelection = function () {
            if (this.savedCards && this.savedCards.length > 0) {
                if (this.usingOldTemplate) {
                    this.selectTab(PaymentCategory.SavedCard);
                }
                else {
                    this.selectedPaymentOptionId = this.savedCards[0].CardId; //default to the 1st card
                }
            }
            else {
                if (this.usingOldTemplate) {
                    this.selectTab(PaymentCategory.Card);
                }
                else {
                    this.selectedPaymentOptionId = PaymentCategory.Card.toString();
                    this.paymentOptionChanged(PaymentCategory.Card);
                }
            }
        };
        Payment.prototype.setCardFee = function (total) {
            var _this = this;
            //figure out which card type we are dealing with and update the
            //fee as required
            var setFee = function (amount, total, percent) {
                var fee = amount || total * (percent / 100);
                if (fee !== _this.model.fee) {
                    _this.model.fee = fee;
                }
                _this.cardPercentage = percent;
            };
            if (this.model.cardDetail.isSavedCard === true) {
                //get saved card id, find card and update
                var card = _.find(this.savedCards, { 'CardId': this.model.cardDetail.savedCardId });
                if (card) {
                    setFee(card.FeeAmount, total, card.FeePercent);
                }
            }
            else if (this.model.isPayPalPayment === true) {
                setFee(this.payPalOption.FeeAmount, total, this.payPalOption.FeePercent);
            }
            else if (this.model.cardDetail.cardTypeId != null) {
                //get payment option info and set fee
                var card = _.find(this.paymentOptions, { 'CardTypeId': this.model.cardDetail.cardTypeId });
                setFee(card.FeeAmount, total, card.FeePercent);
            }
        };
        Payment.prototype.clearModel = function () {
            this.model = this.paymentsUtilService.createEmptyPaymentModel();
            this.fullCardDetailsRequired = false;
            this.isExternalFop = false;
            this.cardPercentage = 0;
        };
        return Payment;
    }());
    angular
        .module('core')
        .directive('payment', function () {
        return {
            restrict: 'E',
            replace: false,
            transclude: true,
            scope: {
                piPaymentOptions: '=',
                piSavedCards: '=',
                atolProtected: '@',
                cardCanBeSaved: '=',
                flexiblePayments: '@',
                modal: '=',
                model: '=',
                onReceive: '&',
                addCommand: '&',
                paymentAmount: '=',
                ready: '=',
                rootForm: '=',
                viewPage: '@'
            },
            controller: Payment,
            controllerAs: 'pay',
            bindToController: true,
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return "partials/booking/template?name=PaymentWithTabs&version=" + attr.templateVersion;
                }
                return "partials/home/PaymentDirective?form=" + attr.viewPage;
            }
        };
    });
})(Payment || (Payment = {}));
var Core;
(function (Core) {
    var PaymentAmountSelection = /** @class */ (function () {
        function PaymentAmountSelection(currencyService, $scope) {
            var _this = this;
            this.currencyService = currencyService;
            this.$scope = $scope;
            this.payFull = true;
            this.currencySymbol = this.currencyService.getSymbol(this.currencyCode);
            var partPaymentAmountWatch;
            this.$scope.$watch('cm.payFull', function (payFull) {
                if (payFull) {
                    _this.paymentAmount.$setViewValue(_this.maxValue);
                    partPaymentAmountWatch && partPaymentAmountWatch();
                    _this.partPaymentAmount = undefined;
                }
                else {
                    partPaymentAmountWatch = _this._setPartPaymentAmountWatch();
                }
            });
        }
        PaymentAmountSelection.prototype._setPartPaymentAmountWatch = function () {
            var _this = this;
            return this.$scope.$watch('cm.partPaymentAmount', function (val) {
                _this.paymentAmount.$setViewValue(val);
            });
        };
        return PaymentAmountSelection;
    }());
    angular
        .module('core')
        .component('paymentAmountSelection', {
        require: {
            form: '?^form',
            paymentAmount: 'ngModel'
        },
        bindings: {
            maxValue: '@',
            currencyCode: '@',
            payFull: '='
        },
        controller: PaymentAmountSelection,
        controllerAs: 'cm',
        templateUrl: 'partials/dashboard/paymentamountselection'
    });
})(Core || (Core = {}));
var core;
(function (core) {
    var PriceInfo = /** @class */ (function () {
        function PriceInfo(modalService) {
            this.modalService = modalService;
        }
        PriceInfo.prototype.onInfoClicked = function () {
            this.modalService.launch('partials/popups/tax', {
                tax: this.tax,
                currency: this.currency,
                total: this.total
            });
        };
        ;
        return PriceInfo;
    }());
    angular
        .module('core')
        .directive('priceInfo', function () {
        return {
            restrict: 'E',
            template: '<div class="info-icon" ng-click="pi.onInfoClicked()"></div>',
            bindToController: {
                total: '=',
                tax: '=?',
                currency: '@?'
            },
            scope: {},
            replace: true,
            controllerAs: 'pi',
            controller: PriceInfo
        };
    });
})(core || (core = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .directive('pricingModals', function (voucherModalService, tripService, $route, cookieService) {
        return {
            restrict: 'E',
            template: '<voucher-modal show="showVoucherModal" close="closeVoucherModal()"'
                + ' voucher-info="voucherModalInfo"></voucher-modal>'
                + '<call-to-book-modal show="showCallToBookModal" close="closeCallToBookModal()">'
                + '</call-to-book-modal>',
            link: function ($scope) {
                $scope.voucherModalInfo = {};
                $scope.showCallToBookModal = false;
                $scope.showVoucherModal = false;
                $scope.closeVoucherModal = function () {
                    $scope.showVoucherModal = false;
                };
                $scope.closeCallToBookModal = function () {
                    $scope.showCallToBookModal = false;
                };
                var voucherInfoResponse = function (data) {
                    var showedModals = JSON.parse(sessionStorage.getItem('pricingShowedModals')
                        || '{ "callToBook": false, "vouchers": [] }');
                    $scope.voucherModalInfo = data && data.ModalForm || {};
                    $scope.showCallToBook = (data && data.CallToBookRequested || '') && !showedModals.callToBook;
                    if (!_.isEmpty($scope.voucherModalInfo)) {
                        var isShowedVoucher_1 = false;
                        _.forEach(showedModals.vouchers, function (voucher) {
                            if (voucher === $scope.voucherModalInfo.VoucherCode) {
                                isShowedVoucher_1 = true;
                                return false;
                            }
                        });
                        if (!isShowedVoucher_1) {
                            $scope.showVoucherModal = true;
                            $scope.showCallToBookModal = false;
                            showedModals.vouchers.unshift($scope.voucherModalInfo.VoucherCode);
                        }
                    }
                    else if ($scope.showCallToBook) {
                        $scope.showVoucherModal = false;
                        $scope.showCallToBookModal = true;
                        showedModals.callToBook = true;
                    }
                    sessionStorage.setItem('pricingShowedModals', JSON.stringify(showedModals));
                };
                $scope.$on('$locationChangeSuccess', function () {
                    var paramBoardTypes = $route.current.params && $route.current.params.fbt || '';
                    var tripId = $route.current.params && $route.current.params.tripId || '';
                    var userId = $route.current.params && $route.current.params.userId || '';
                    var estabId = Number($route.current.params && $route.current.params.estabId || 0);
                    var sourceId = Number(cookieService.get('visitSource') || 0);
                    var boardType = paramBoardTypes.length > 0 ?
                        paramBoardTypes.split(',').map(function (item) {
                            var board = item && parseInt(item, 10) || null;
                            if (board) {
                                return board;
                            }
                        }) : [];
                    if (tripId) {
                        tripService.getTrip(tripId).then(function (trip) {
                            var rooms = trip.HotelsRequest && trip.HotelsRequest.Rooms;
                            var adults = rooms && rooms.map(function (x) { return x.Adults; }).reduce(function (a, b) { return a + b; });
                            var children = rooms && rooms.map(function (x) { return x.ChildAges.length; }).reduce(function (a, b) { return a + b; });
                            var selections = JSON.parse(localStorage.getItem('flightsSelections') || '{}');
                            var inboundSegmentDetails = selections.InboundSegmentDetails
                                && selections.InboundSegmentDetails[0] || {};
                            var outboundSegmentDetails = selections.OutboundSegmentDetails
                                && selections.OutboundSegmentDetails[0] || {};
                            var CheckInDate = trip.HotelsRequest && trip.HotelsRequest.CheckInDate || '';
                            var CheckOutDate = trip.HotelsRequest && trip.HotelsRequest.CheckOutDate || '';
                            var options = {
                                DestinationAirport: inboundSegmentDetails.DepartureAirport || null,
                                OriginalAirport: outboundSegmentDetails.DepartureAirport || null,
                                Adults: adults,
                                Children: children,
                                CheckInDate: CheckInDate,
                                CheckOutDate: CheckOutDate,
                                IsPackage: trip.PackageId ? true : false,
                                IsFlightPlus: trip.HotelsRequest && trip.HotelsRequest.IsFlightPlus || false,
                                Cabin: outboundSegmentDetails.Cabin || 0,
                                UserId: userId,
                                EstabId: estabId,
                                VisitSourceId: sourceId,
                                BoardType: boardType,
                                DepartureDate: trip.FlightsRequest && trip.FlightsRequest.DepartureDate || '',
                                RoomsCount: trip.HotelsRequest && trip.HotelsRequest.Rooms.length || 0,
                                Carrier: outboundSegmentDetails.CarrierCode
                            };
                            voucherModalService.getVoucherInfo(options).then(voucherInfoResponse);
                        });
                    }
                    else {
                        voucherModalService.getVoucherInfo().then(voucherInfoResponse);
                    }
                });
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var DestinationType = Core.Destinations.DestinationType;
        var RecentSearchCard = /** @class */ (function () {
            function RecentSearchCard($scope, imageService, savedSearchService, basketService, analytics, dateUtil) {
                var _this = this;
                this.$scope = $scope;
                this.imageService = imageService;
                this.savedSearchService = savedSearchService;
                this.basketService = basketService;
                this.analytics = analytics;
                this.dateUtil = dateUtil;
                this.icons = {
                    1: ['flights'],
                    2: ['hotels'],
                    3: ['flights', 'hotels']
                };
                this.titles = {
                    1: 'SEARCHUNITTITLEFLIGHTS',
                    2: 'SEARCHUNITTITLEHOTELS',
                    3: 'SEARCHUNITTITLEHOLIDAYS'
                };
                this.viewModel = null;
                this.busy = false;
                this.$scope.$watch('rs.model', function (val, old) {
                    if (val) {
                        _this.viewModel = _this.enhanceModel(val);
                    }
                });
            }
            RecentSearchCard.prototype.enhanceModel = function (s) {
                var details = s.DisplayDetails;
                // get destination for image
                var dest;
                if (details.Destinations) {
                    // if hotel, use that
                    var first = _.head(details.Destinations);
                    if (first.Type === DestinationType.Establishment) {
                        dest = first;
                    }
                    else {
                        // get province OR first destination
                        dest = _.find(details.Destinations, ['Type', DestinationType.Province])
                            || first;
                    }
                }
                else {
                    // flight only - use airport
                    dest = details.DestinationAirports[0].Destination;
                }
                // Return the display details only
                return _.assignIn(details, {
                    Title: dest.Title,
                    ImageUrl: this.imageService.getDestinationImage({ Id: dest.Id, Type: dest.Type }),
                    Icons: this.icons[s.SearchType],
                    TitleResource: this.titles[s.SearchType],
                    StartDate: s.FromDate.Date,
                    EndDate: s.ToDate.Date,
                    Duration: s.OneWayOnly ? null : this.dateUtil.numberOfNights(s.FromDate.Date, s.ToDate.Date),
                    Adults: s.Adults,
                    Children: s.Children,
                    Rooms: s.Rooms ? s.Rooms.length : null
                });
            };
            // public deleteSearch(event, s: any) {
            //     event.preventDefault();
            //     event.stopPropagation();
            //     this.savedSearchService.removeSavedSearch(s.SavedSearchId);
            // }
            RecentSearchCard.prototype.restoreSearch = function (event, s) {
                var _this = this;
                event.preventDefault();
                if (!this.busy) {
                    this.busy = true;
                    this.savedSearchService.restoreSearch(s)
                        .then(function () {
                        _this.analytics.trackEvent({ label: 'restore saved search' });
                        return _this.basketService.startWorkflow(_this.basketService.workflowType[s.SearchType]);
                    })
                        .catch()
                        .then(function () { return _this.busy = false; });
                }
            };
            return RecentSearchCard;
        }());
        angular
            .module('core')
            .directive('recentSearchCard', function () {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: RecentSearchCard,
                controllerAs: 'rs',
                bindToController: {
                    model: '='
                },
                templateUrl: 'partials/customer/recentsearchcontentcard'
            };
        });
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var RefreshView = /** @class */ (function () {
        function RefreshView($q, $routeParams, $scope, $window, basketService, broker, tripService, windowUtil) {
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.$window = $window;
            this.basketService = basketService;
            this.broker = broker;
            this.tripService = tripService;
            this.windowUtil = windowUtil;
            this._initialised = false;
            this.showWarning = false;
        }
        RefreshView.prototype.init = function () {
            var _this = this;
            if (this._initialised) {
                return;
            }
            this._initialised = true;
            if (!this.isLocalStorageSupported()) {
                return;
            }
            var updateData = function () {
                if (_this.$routeParams['tripId']) {
                    _this.getInfoFromTrip(_this.$routeParams['tripId']).then(function (info) {
                        _this.setData(info);
                    });
                }
            };
            this.broker.subscribe('RefreshView', 'flightAddedToBasket', updateData);
            this.broker.subscribe('RefreshView', 'roomsAddedToBasket', updateData);
            var selectionHandler = this.selectionChanged.bind(this);
            this.$window.addEventListener('storage', selectionHandler);
            this.$scope.$on('$destroy', function () {
                _this.$window.removeEventListener('storage', selectionHandler);
                _this.broker.unsubscribe('RefreshView');
            });
        };
        RefreshView.prototype.selectionChanged = function (ev) {
            var _this = this;
            //leave if this page is not on a trip type page
            var tripId = this.$routeParams['tripId'];
            if (!tripId) {
                return;
            }
            //is the current page somewhere where we'd like to monitor the basket change on?
            var pageProduct = this.productsRelatedToPage(this.$window.location.toString());
            if (pageProduct === null) {
                return;
            }
            if (ev.key === 'trip') {
                var actual_1 = JSON.parse(ev.newValue);
                //check if it is our trip and if our other ids don't match
                if (actual_1.TripId === tripId) {
                    this.getInfoFromTrip(tripId).then(function (my) {
                        var displayWarning = false;
                        if (pageProduct !== null && (pageProduct & Product.Flight) === Product.Flight) {
                            displayWarning = actual_1.FlightInfo.ProductId !== my.FlightInfo.ProductId ||
                                actual_1.TripType !== my.TripType;
                        }
                        if (!displayWarning && pageProduct !== null && (pageProduct & Product.Hotel) === Product.Hotel) {
                            displayWarning = actual_1.HotelInfo !== my.HotelInfo
                                && actual_1.HotelInfo.ProductId !== my.HotelInfo.ProductId;
                        }
                        if (displayWarning) {
                            _this.$scope.$evalAsync(function () {
                                _this.showWarning = true;
                            });
                        }
                    });
                }
            }
        };
        RefreshView.prototype.refreshPage = function () {
            var _this = this;
            //this is a bit tricky now, depending on what is in the actual trip, where we are
            //in our journey and the type of journey we want to redirect the user to the most useful point.
            var tripId = this.$routeParams['tripId'];
            var currentLocation = this.$window.location.toString();
            if (currentLocation.indexOf('/holidays/options/') > -1
                || currentLocation.indexOf('/holidays/book/') > -1
                || /\/holidays\/[a-zA-Z\-0-9]{36}\/\d{4,}/.test(currentLocation)) {
                //for holidays always go back to hotel availability if we are on the hotels details page,
                //options page or the booking form.
                //This is to handle the situation where changing flights also changes the hotel results
                //due to filtering based on proximity to airports  (Canary islands)
                this.getInfoFromTrip(tripId).then(function (my) {
                    if (my.TripType === Core.Trip.TripType.Holiday) {
                        _this.windowUtil.location.href('holidays/hotels/' + tripId);
                        return;
                    }
                    _this.$window.location.reload();
                });
            }
            else {
                this.$window.location.reload();
            }
        };
        RefreshView.prototype.setData = function (productIds) {
            // date is needed to force refresh on the hotels on flights workflow on the second change to flight workflow
            localStorage.setItem('trip', JSON.stringify(__assign({}, productIds, { date: Date.now() })));
        };
        RefreshView.prototype.getInfoFromTrip = function (tripId) {
            var _this = this;
            return this.tripService.getTrip(tripId).then(function (trip) {
                var basketId = trip.BasketId;
                return _this.$q.all([
                    _this.basketService.getHotel(basketId),
                    _this.basketService.getFlight(basketId)
                ]).then(function (results) {
                    var flightProductId = results[1] && results[1].ProductId || null;
                    var hotelInfo = null;
                    if (trip.TripType === Core.Trip.TripType.Hotel
                        || trip.TripType === Core.Trip.TripType.Holiday) {
                        hotelInfo = new HotelInfo(results[0] && results[0].ProductId, results[0] && results[0].Details.Id, trip.HotelsRequest.CheckInDate, trip.HotelsRequest.CheckOutDate);
                    }
                    return new SelectedProductInfo(tripId, trip.TripType, new FlightInfo(flightProductId), hotelInfo);
                });
            });
        };
        RefreshView.prototype.getInfoFromStorage = function (tripId) {
            var info = JSON.parse(localStorage.getItem('trip') || '');
            if (info.TripId === tripId) {
                return info;
            }
            else {
                return null;
            }
        };
        RefreshView.prototype.isLocalStorageSupported = function () {
            var key = 'test';
            try {
                localStorage.setItem(key, '1');
                localStorage.removeItem(key);
                return true;
            }
            catch (error) {
                return false;
            }
        };
        RefreshView.prototype.productsRelatedToPage = function (url) {
            var map = [
                { Regex: /\/(hotels)\/book\/[a-zA-Z\-0-9]{36}/, Products: Product.Hotel },
                { Regex: /\/(holidays)\/book\/[a-zA-Z\-0-9]{36}/, Products: Product.Hotel + Product.Flight },
                { Regex: /\/holidays\/hotels\/[a-zA-Z\-0-9]{36}/, Products: Product.Hotel + Product.Flight },
                { Regex: /\/holidays\/[a-zA-Z\-0-9]{36}\/\d{4,}/, Products: Product.Flight },
                { Regex: /\/holidays\/options\/[a-zA-Z\-0-9]{36}/, Products: Product.Hotel + Product.Flight }
            ];
            for (var i = 0; i < map.length; i++) {
                if (map[i].Regex.test(url)) {
                    return map[i].Products;
                }
            }
            return null;
        };
        return RefreshView;
    }());
    ///Enum for holding product types should be keyed so that you can use bitwise operators
    ///to decide if a product is included in a set
    var Product;
    (function (Product) {
        Product[Product["Flight"] = 1] = "Flight";
        Product[Product["Hotel"] = 2] = "Hotel";
    })(Product || (Product = {}));
    var FlightInfo = /** @class */ (function () {
        function FlightInfo(ProductId) {
            this.ProductId = ProductId;
        }
        return FlightInfo;
    }());
    var HotelInfo = /** @class */ (function () {
        function HotelInfo(ProductId, Id, CheckInDate, CheckOutDate) {
            this.ProductId = ProductId;
            this.Id = Id;
            this.CheckInDate = CheckInDate;
            this.CheckOutDate = CheckOutDate;
        }
        return HotelInfo;
    }());
    var SelectedProductInfo = /** @class */ (function () {
        function SelectedProductInfo(TripId, TripType, FlightInfo, HotelInfo, date) {
            this.TripId = TripId;
            this.TripType = TripType;
            this.FlightInfo = FlightInfo;
            this.HotelInfo = HotelInfo;
            this.date = date;
        }
        return SelectedProductInfo;
    }());
    angular
        .module('core')
        .directive('refreshView', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'rv',
            controller: RefreshView,
            templateUrl: 'partials/home/directivetemplate?type=RefreshView',
            link: function (scope, el, attr, controller) {
                controller.init();
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var ReviewHotelCard = /** @class */ (function () {
            function ReviewHotelCard() {
            }
            return ReviewHotelCard;
        }());
        angular
            .module('core')
            .directive('reviewHotelCard', function () {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: ReviewHotelCard,
                controllerAs: 'rh',
                bindToController: {
                    trip: '='
                },
                templateUrl: 'partials/customer/reviewhotelcard'
            };
        });
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .directive('sash', function () {
        return {
            scope: {
                ribbon: '=?',
                isFromOverlay: '=?'
            },
            restrict: 'E',
            link: function (scope, element, attrs) {
                scope.$watch('ribbon', function (value) {
                    // TODO - refactor, fixes attaching several child content elements
                    element.empty();
                    var ribbon = scope.isFromOverlay ?
                        scope.ribbon && scope.ribbon.hotel && scope.ribbon.hotel.OverlaysNew[0]
                            || (scope.ribbon && scope.ribbon.OverlaysNew[0] || scope.ribbon)
                        : scope.ribbon;
                    if (ribbon) {
                        ribbon = !scope.isFromOverlay ? ribbon && (ribbon.ribbon || ribbon)
                            && (ribbon.ribbon && ribbon.ribbon.ribbon || ribbon.ribbon) : ribbon; // Find ribbon object
                        var prefix_3 = 'sc-c-sash--'; // Sash base style class
                        var styles_2 = [
                            'sc-c-sash',
                            "" + prefix_3 + (ribbon && ribbon.ColourClass)
                        ]; // Sash color class style
                        ribbon.EffectClasses.forEach(function (effect) {
                            styles_2.push("" + prefix_3 + effect); // Sets effect class to sash
                        });
                        var styleClass = styles_2.join(' '); // Join all styles into one
                        var contentClass = 'sc-c-sash__label';
                        var ribbonElement = angular.element("<div>").addClass(styleClass);
                        var ribbonContent_2 = angular.element("<div>").addClass(contentClass);
                        var textLengthValidator = function (text) { return text && text.slice(0, 10); };
                        var textSeparator = ribbon.Text.includes('|') ? '|' : ' ';
                        var textArray_1 = ribbon.Text.toUpperCase()
                            .split(textSeparator)
                            .map(textLengthValidator);
                        var boldStrClass_2 = 'star-rating sc-u-bold sc-c-sash__row row-gutter-y__zero';
                        var normalStrClass_2 = 'star-rating sc-c-sash__row row-gutter-y__zero';
                        textArray_1.forEach(function (current, index) {
                            var isBold = ((textArray_1.length - 1) === index && textArray_1.length > 2) || index === 0;
                            var label = angular.element("<span>" + current + "</span>")
                                .addClass(isBold ? boldStrClass_2 : normalStrClass_2);
                            ribbonContent_2.append(label);
                        });
                        ribbonElement.append(ribbonContent_2);
                        element.append(ribbonElement);
                    }
                });
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScrollAndClickCtrl = /** @class */ (function () {
        function ScrollAndClickCtrl($scope, $timeout, scrollService) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.scrollService = scrollService;
        }
        ScrollAndClickCtrl.prototype.scrollAndClick = function () {
            var _this = this;
            this.scrollService.scrollTo(this.scrollTarget, { animate: true });
            this.$timeout(function () {
                var clickTarget = angular.element(_this.clickTarget);
                if (!clickTarget.hasClass(_this.activeClass)) {
                    clickTarget.click();
                }
            });
        };
        return ScrollAndClickCtrl;
    }());
    angular
        .module('core')
        .directive('scrollAndClick', function () {
        return {
            bindToController: {
                scrollTarget: '@',
                clickTarget: '@',
                activeClass: '@'
            },
            controller: ScrollAndClickCtrl,
            controllerAs: 'scr',
            replace: false,
            restrict: 'E',
            scope: {},
            template: '<a href="" ng-click="scr.scrollAndClick()" ng-transclude></a>',
            transclude: true
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular.module('TR')
        .directive('scrollPage', scrollPage);
    function scrollPage() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                toBottom: '='
            },
            template: '<a ng-click="scrollPage()" ng-class="{visible : visible }" class="scroll-page" href="#"></a>',
            link: function (scope) {
                var scrollTo = 0;
                var offset = 400;
                var maxDuration = 500;
                var win = $(window);
                var toBottom = scope.toBottom;
                scope.visible = false;
                scope.checkVisibility = function () {
                    scrollTo = win.scrollTop() + (toBottom ? win.height() : 0);
                    if ((toBottom && scope.visible !== (scrollTo <= $(document).height() - offset))
                        || !toBottom && scope.visible !== (scrollTo >= offset)) {
                        scope.$apply(scope.visible = !scope.visible);
                    }
                };
                win.on(toBottom ? 'scroll.scrollBottom' : 'scroll.scrollTop', _.debounce(scope.checkVisibility, 100));
                scope.scrollPage = function () {
                    // set a duration relative to the distance we need to scroll
                    var duration = Math.min(maxDuration, Math.abs(Math.round(scrollTo * 0.3)));
                    var scrollInfo = { scrollTop: toBottom ? $(document).height() : 0 };
                    $('html, body').stop().animate(scrollInfo, { easing: 'swing', duration: duration });
                };
                scope.$on('$destroy', function () {
                    win.off(toBottom ? 'scroll.scrollBottom' : 'scroll.scrollTop');
                });
            }
        };
    }
})();
var Core;
(function (Core) {
    var ScrollerCtrl = /** @class */ (function () {
        function ScrollerCtrl($scope, scrollService) {
            this.$scope = $scope;
            this.scrollService = scrollService;
        }
        ScrollerCtrl.prototype.scroll = function () {
            var options = {
                animate: true,
                offset: this.offset
            };
            if (angular.element('.scroller-relative-container').length !== 0) {
                options.container = '.scroller-relative-container';
            }
            this.scrollService.scrollTo(this.target, options);
        };
        return ScrollerCtrl;
    }());
    angular
        .module('core')
        .directive('scroller', function () {
        return {
            bindToController: {
                target: '@',
                offset: '@',
                linkClass: '@'
            },
            controller: ScrollerCtrl,
            controllerAs: 'scr',
            replace: false,
            restrict: 'E',
            scope: {},
            template: '<a href="" ng-click="scr.scroll()" ng-class="scr.linkClass" ng-transclude></a>',
            transclude: true
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SelectedAttractionSummary = /** @class */ (function () {
        function SelectedAttractionSummary($scope) {
            var _this = this;
            this.$scope = $scope;
            this.show = false;
            var stop = this.$scope.$watch('sas.attraction', function (v) {
                if (v) {
                    _this.init(v);
                    stop();
                }
            });
        }
        SelectedAttractionSummary.prototype.init = function (attraction) {
            var tickets = [];
            _.each(attraction, function (a) {
                _.each(a.CostBreakdown, function (i) {
                    tickets.push({ quantity: i.Quantity, title: i.Description });
                });
            });
            this.tickets = tickets;
            this.show = tickets.length > 0;
        };
        return SelectedAttractionSummary;
    }());
    angular
        .module('core')
        .directive('selectedAttractionSummary', function () {
        return {
            scope: {},
            controller: SelectedAttractionSummary,
            controllerAs: 'sas',
            replace: true,
            bindToController: {
                attraction: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedAttractionSummary'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SelectedCarhireSummary = /** @class */ (function () {
        function SelectedCarhireSummary($scope) {
            var _this = this;
            this.$scope = $scope;
            this.show = false;
            var stop = this.$scope.$watch('scs.carhire', function (v) {
                if (v) {
                    _this.init(v);
                    stop();
                }
            });
        }
        SelectedCarhireSummary.prototype.init = function (carhire) {
            this.details = carhire.Details.HireDetails;
            this.show = true;
        };
        return SelectedCarhireSummary;
    }());
    angular
        .module('core')
        .directive('selectedCarhireSummary', function () {
        return {
            scope: {},
            controller: SelectedCarhireSummary,
            controllerAs: 'scs',
            replace: true,
            bindToController: {
                carhire: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedCarHireSummary'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SelectedFlightSummary = /** @class */ (function () {
        function SelectedFlightSummary(broker, flightSearch, $scope, resourceService, basketService, occupancyService) {
            this.broker = broker;
            this.flightSearch = flightSearch;
            this.$scope = $scope;
            this.resourceService = resourceService;
            this.basketService = basketService;
            this.occupancyService = occupancyService;
            this.hideCaption = false;
            this.changeFlightEnabled = this.changeFlightEnabled === 'true';
        }
        SelectedFlightSummary.prototype.init = function (container) {
        };
        SelectedFlightSummary.prototype.showDetails = function (e) {
            var passengers = this.occupancyService.getTotalPeopleCounts();
            e.preventDefault();
            this.broker.publish('showModalFlightDetails', {
                flight: this.flight.Details.Itinerary,
                passengers: passengers
            });
        };
        SelectedFlightSummary.prototype.changeFlight = function () {
            this.flightSearch.resetPageIndex();
            this.basketService.changeJourneyUrl(10, this.tripId);
            if (this.changeFlightInterstitial) {
                this.$scope.$emit('block', {
                    title: this.resourceService.get('SEARCHINGFLIGHTS'),
                    subtitle: this.resourceService.get('THISMAYTAKE'),
                    loadingScreenStyle: 'default-searchUnitCtrl'
                });
            }
        };
        return SelectedFlightSummary;
    }());
    angular
        .module('core')
        .directive('selectedFlightSummary', function () {
        return {
            scope: {},
            controller: SelectedFlightSummary,
            controllerAs: 'sfs',
            replace: true,
            bindToController: {
                tripId: '=?',
                flight: '=',
                changeFlightEnabled: '@',
                changeFlightInterstitial: '<',
                hideCaption: '@'
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=SelectedFlightSummary&version='
                        + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=SelectedFlightSummary';
            },
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SelectedInsuranceSummary = /** @class */ (function () {
        function SelectedInsuranceSummary($scope) {
            var _this = this;
            this.$scope = $scope;
            this.show = false;
            var stop = this.$scope.$watch('sis.insurance', function (v) {
                if (v) {
                    _this.init(v);
                    stop();
                }
            });
        }
        SelectedInsuranceSummary.prototype.init = function (insurance) {
            this.quote = insurance.Details.InsuranceQuotes[0];
            this.show = true;
        };
        return SelectedInsuranceSummary;
    }());
    angular
        .module('core')
        .directive('selectedInsuranceSummary', function () {
        return {
            scope: {},
            controller: SelectedInsuranceSummary,
            controllerAs: 'sis',
            replace: true,
            bindToController: {
                insurance: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedInsuranceSummary'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SelectedParkingSummary = /** @class */ (function () {
        function SelectedParkingSummary($scope) {
            var _this = this;
            this.$scope = $scope;
            this.show = false;
            var stop = this.$scope.$watch('sps.parking', function (v) {
                if (v) {
                    _this.init(v);
                    stop();
                }
            });
        }
        SelectedParkingSummary.prototype.init = function (parking) {
            this.quote = parking.Details.Quote;
            this.show = true;
        };
        return SelectedParkingSummary;
    }());
    angular
        .module('core')
        .directive('selectedParkingSummary', function () {
        return {
            scope: {},
            controller: SelectedParkingSummary,
            controllerAs: 'sps',
            replace: true,
            bindToController: {
                parking: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedParkingSummary'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SelectedTransferSummary = /** @class */ (function () {
        function SelectedTransferSummary($scope) {
            var _this = this;
            this.$scope = $scope;
            this.show = false;
            var stop = this.$scope.$watch('sts.transfer', function (v) {
                if (v) {
                    _this.init(v);
                    stop();
                }
            });
        }
        SelectedTransferSummary.prototype.init = function (transfer) {
            var legs = [];
            if (transfer.Details.Itinerary.OutboundLeg) {
                legs.push(__assign({}, transfer.Details.Itinerary.OutboundLeg, { isOutboundLeg: true }));
            }
            if (transfer.Details.Itinerary.InboundLeg) {
                legs.push(__assign({}, transfer.Details.Itinerary.InboundLeg, { isOutboundLeg: false }));
            }
            this.legs = [].concat(legs);
            this.show = true;
        };
        return SelectedTransferSummary;
    }());
    angular
        .module('core')
        .directive('selectedTransferSummary', function () {
        return {
            scope: {},
            controller: SelectedTransferSummary,
            controllerAs: 'sts',
            replace: true,
            bindToController: {
                transfer: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedTransferSummary'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var SignInDashboard = /** @class */ (function () {
            function SignInDashboard($rootScope, $scope, $q, customerDashboardService, houseRecommender, analytics, currentUser) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$scope = $scope;
                this.$q = $q;
                this.customerDashboardService = customerDashboardService;
                this.houseRecommender = houseRecommender;
                this.analytics = analytics;
                this.currentUser = currentUser;
                this.user = null;
                this.searches = [];
                this.destinations = [];
                this.tileTemplates = {
                    1: null,
                    2: null,
                    3: null
                };
                this.tileModels = {
                    1: null,
                    2: null,
                    3: null
                };
                this.tileTypes = {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null
                };
                $scope.$on('auth:signin', function () {
                    _this.setDashboardState();
                });
                $scope.$on('auth:signout', function () {
                    _this.setDashboardState();
                    _this.user = null;
                });
                this.setDashboardState();
            }
            SignInDashboard.prototype.setDashboardState = function () {
                // Set local scope user
                this.user = this.currentUser.get();
                // Show this dashboard if the user is NOT signed in
                this.showDashboard = !this.user.AnonSignedIn && !this.user.SignedIn;
                this.showDashboard && this.fetch();
            };
            SignInDashboard.prototype.fetch = function () {
                var _this = this;
                this.fetching = true;
                this.resetData();
                // The sign-in card doesn't require data so we can load it immediately
                this.tileTypes[1] = Customer.DashboardTileType.InspirationalContent;
                this.tileTemplates[1] = this.customerDashboardService.getTemplateForPlaceholder(Customer.DashboardTileType.InspirationalContent);
                var promises = [];
                // Get 2 recent searches
                promises.push(this.customerDashboardService.getRecentSearches(2));
                // Get recommended destinations
                promises.push(this.houseRecommender.getHouseRecs());
                this.$q.all(promises).then(function (_a) {
                    var searches = _a[0], destinations = _a[1];
                    _this.searches = searches;
                    _this.destinations = destinations;
                    _this.configureTiles().then(function () {
                        _this.fetching = false;
                        _this.customerDashboardService.trackDashboardLoad(null, _this.tileTypes);
                    });
                });
            };
            SignInDashboard.prototype.configureTiles = function () {
                var _this = this;
                var deferred = this.$q.defer();
                // Placeholder 1
                // Sign-in card
                // *** ALREADY SET ***
                // Placeholder 2
                // Searches[0] OR Destinations[0]
                var type;
                if (this.searches[0]) {
                    // show the first search
                    this.tileTypes[2] = Customer.DashboardTileType.Search;
                    this.tileModels[2] = this.searches[0];
                }
                else {
                    // show the first destination
                    this.tileTypes[2] = Customer.DashboardTileType.Destination;
                    this.tileModels[2] = this.destinations[0];
                }
                // Placeholder 3
                // Searches[1] OR Destinations[0] OR Destinations[1]
                if (this.searches[1]) {
                    // show the second search
                    this.tileTypes[3] = Customer.DashboardTileType.Search;
                    this.tileModels[3] = this.searches[1];
                }
                else {
                    // show a destination
                    this.tileTypes[3] = Customer.DashboardTileType.Destination;
                    if (this.tileTypes[2] === Customer.DashboardTileType.Search) {
                        // show the first destination which doesn't match the destination of the search
                        this.tileModels[3] = this.customerDashboardService.getDestinationExcludingSearch(this.tileModels[2], this.destinations);
                    }
                    else {
                        // show the second destination
                        this.tileModels[3] = this.destinations[1];
                    }
                }
                // map the templates to the types
                _.forOwn(this.tileTypes, function (type, key) {
                    if (type) {
                        _this.tileTemplates[key] = _this.customerDashboardService.getTemplateForPlaceholder(type);
                    }
                });
                deferred.resolve();
                return deferred.promise;
            };
            SignInDashboard.prototype.resetData = function () {
                // reset all data to initial state
                this.searches.length = 0;
                this.destinations.length = 0;
                // placeholder templates and models
                _.forOwn(this.tileTemplates, function (p) { return p = null; });
                _.forOwn(this.tileModels, function (p) { return p = null; });
                _.forOwn(this.tileTypes, function (p) { return p = null; });
            };
            SignInDashboard.prototype.getModelForPlaceholder = function (position) {
                // We return the model in an array so that we can use ng-repeat
                // to declare a privately scoped model for the ng-included template
                return [this.tileModels[position]];
            };
            SignInDashboard.prototype.tileClick = function (position) {
                this.customerDashboardService.trackDashboardClick(position, this.tileTypes[position]);
            };
            return SignInDashboard;
        }());
        angular
            .module('core')
            .directive('signInDashboard', function () {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: SignInDashboard,
                controllerAs: 'sid',
                bindToController: {},
                templateUrl: 'partials/customer/signindashboard'
            };
        });
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    angular.module('core')
        .directive('stickyElement', function () {
        return {
            restrict: 'E',
            template: '<div class="sticky-wrapper {{wrapperClass}}"' +
                ' data-bottom-limit-id="{{bottomLimitId > 0 ? bottomLimitId : \'0\'}}">' +
                '<div class="sticky-content"></div>' +
                '</div>',
            transclude: true,
            compile: function (el, attrs, transclude) {
                return function ($scope) {
                    var stickyTopOffset = 0;
                    var fixedClass = 'fixed';
                    var absoluteClass = 'absolute';
                    var $stickyWrapper = el.find('.sticky-wrapper');
                    var $stickyContent = el.find('.sticky-content');
                    var bottomLimit = 'true' === attrs.bottomLimit;
                    var bottomSelector = parseInt(attrs.bottomLimitId, 10) > 0 ? "[data-id=" + attrs.bottomLimitId + "]" : '.page-content';
                    var debounceThreshold = 100;
                    var resizeStickyContent = _.debounce(function () {
                        var stickyWrapperWidth = $stickyWrapper.width();
                        var stickyContentWidth = $stickyContent.outerWidth();
                        if (stickyContentWidth !== stickyWrapperWidth) {
                            $stickyContent.css({ width: stickyWrapperWidth + 'px' });
                            $stickyWrapper.css({ height: $stickyContent.outerHeight() + 'px' });
                        }
                    }, debounceThreshold);
                    var checkStickyOffset = function () {
                        var checkOffset = $stickyWrapper.offset().top;
                        if (!stickyTopOffset || (!$stickyWrapper.hasClass(fixedClass) &&
                            stickyTopOffset !== checkOffset)) {
                            stickyTopOffset = checkOffset;
                        }
                    };
                    var handleScroll = function () {
                        checkStickyOffset();
                        var scrollOffset = $(window).scrollTop();
                        var isAtBottomLimit = false;
                        if (bottomLimit) {
                            var $pageContent = $(bottomSelector);
                            if ($pageContent.length && $stickyWrapper.hasClass(fixedClass)) {
                                var bottomLimit_1 = $pageContent.offset().top + $pageContent.outerHeight();
                                var currentBottom = scrollOffset + $stickyContent.outerHeight();
                                if (bottomLimit_1 <= currentBottom) {
                                    isAtBottomLimit = true;
                                    if (!$stickyWrapper.hasClass(absoluteClass)) {
                                        $stickyWrapper.addClass(absoluteClass);
                                        $stickyContent.css({ top: (bottomLimit_1 - $stickyContent.outerHeight()) + 'px' });
                                    }
                                }
                                else {
                                    if ($stickyWrapper.hasClass(absoluteClass)) {
                                        $stickyWrapper.removeClass(absoluteClass);
                                        $stickyContent.css({ top: 0 });
                                    }
                                }
                            }
                        }
                        if (!isAtBottomLimit) {
                            if (scrollOffset >= stickyTopOffset && !$stickyWrapper.hasClass(fixedClass)) {
                                var wrapperHeight = $stickyWrapper.outerHeight();
                                if (wrapperHeight) {
                                    var contentWidth = $stickyContent.outerWidth();
                                    $stickyWrapper.css({ height: wrapperHeight + 'px' });
                                    $stickyContent.css({ width: contentWidth + 'px' });
                                    $stickyWrapper.addClass(fixedClass);
                                    window.addEventListener('resize', resizeStickyContent, false);
                                }
                            }
                            else if (scrollOffset < stickyTopOffset && $stickyWrapper.hasClass(fixedClass)) {
                                $stickyWrapper.removeClass(fixedClass);
                                $stickyWrapper.removeAttr('style');
                                $stickyContent.removeAttr('style');
                                window.removeEventListener('resize', resizeStickyContent, false);
                            }
                        }
                    };
                    transclude($scope, function (clone) {
                        $stickyContent.append(clone);
                        $scope.wrapperClass = attrs.wrapperClass;
                        $scope.bottomLimitId = attrs.bottomLimitId;
                        /// Watch the height of the content in the sticky wrapper. Height can change as the data is
                        /// being loaded in the sticky element. If the height of the wrapper is zero, it will not
                        /// stick.
                        var initialContentHeight = $stickyContent.outerHeight();
                        $scope.$watch(function () {
                            var contentHeight = $stickyContent.outerHeight();
                            var wrapperHeight = $stickyWrapper.outerHeight();
                            if (0 === initialContentHeight && contentHeight > 0) {
                                initialContentHeight = -1;
                                handleScroll();
                            }
                            else if (contentHeight !== wrapperHeight && $stickyWrapper.hasClass(fixedClass)) {
                                $stickyWrapper.css({ height: contentHeight + 'px' });
                            }
                        });
                        window.addEventListener('scroll', handleScroll, false);
                        $scope.$on('$destroy', function () {
                            window.removeEventListener('scroll', handleScroll, false);
                        });
                    });
                };
            }
        };
    });
})(Core || (Core = {}));
var ekh;
(function (ekh) {
    var CampaignTelephoneNumber = /** @class */ (function () {
        function CampaignTelephoneNumber(cookieService, resourceService) {
            this.cookieService = cookieService;
            this.resourceService = resourceService;
            var matchedCampaign = [];
            this.telephoneNumber = this.resourceService.get('TELEPHONENUMBER');
            var ref = this.cookieService.get('CampaignReferrer');
            if (ref && ref.includes('_')) {
                var referrerList = ref.split('_');
                var referrer_1 = {
                    Source: referrerList[0].toLowerCase(),
                    Medium: referrerList[1].toLowerCase()
                };
                matchedCampaign = this.campaigns.filter(function (campaign) {
                    var campSource = campaign.Source.toLowerCase();
                    var referSource = referrer_1.Source.toLowerCase();
                    var campMedium = campaign.Medium.toLowerCase();
                    var referMedium = referrer_1.Medium.toLowerCase();
                    return CampaignTelephoneNumber.isMatched(campSource, referSource)
                        && CampaignTelephoneNumber.isMatched(campMedium, referMedium);
                });
            }
            if (matchedCampaign.length && matchedCampaign[0].Number) {
                this.telephoneNumber = matchedCampaign[0].Number;
            }
        }
        CampaignTelephoneNumber.isMatched = function (campVal, referVal) {
            if (campVal === referVal) {
                return true;
            }
            if (campVal.indexOf('%') !== -1) {
                campVal = campVal.replace(/[-\/\\^$*+?.()|\[\]{}]/g, '\\$&');
                campVal = campVal.replace(/%/g, '.*');
                var regEx = new RegExp("^" + campVal + "$");
                return regEx.test(referVal);
            }
            return false;
        };
        return CampaignTelephoneNumber;
    }());
    angular
        .module('core')
        .directive('campaignTelephoneNumber', function (cookieService) {
        return {
            restrict: 'A',
            replace: true,
            controller: CampaignTelephoneNumber,
            controllerAs: 'tn',
            scope: {},
            bindToController: {
                campaigns: '=',
                eventTracker: '@',
                eventCategory: '@',
                eventAction: '@',
                eventLabel: '@',
            },
            template: function (element, attrs) {
                if (!attrs.eventCategory) {
                    return "\n                            <a href=\"tel:{{ tn.telephoneNumber }}\"\n                                event-tracker\n                                event-category=\"{{tn.eventCategory}}\"\n                                event-action=\"{{tn.eventAction}}\"\n                                event-label=\"{{tn.eventLabel}}\">{{ tn.telephoneNumber }}</a>";
                }
                return "<a href=\"tel:{{ tn.telephoneNumber }}\">{{ tn.telephoneNumber }}</a>";
            }
        };
    });
})(ekh || (ekh = {}));
var Core;
(function (Core) {
    var UniqueSellingPoint = /** @class */ (function () {
        function UniqueSellingPoint(modalService, $location) {
            this.modalService = modalService;
            this.$location = $location;
            this.autoLaunch();
        }
        UniqueSellingPoint.prototype.launchModal = function () {
            if (this.modal !== '') {
                this.modalService.launch(this.modal);
            }
        };
        UniqueSellingPoint.prototype.autoLaunch = function () {
            var usp = this.$location.search().usp;
            if (usp && this.modal !== '' && this.modal.indexOf('/') > 0) {
                if (usp === this.modal.split('/').pop()) {
                    this.launchModal();
                }
            }
        };
        return UniqueSellingPoint;
    }());
    angular
        .module('core')
        .directive('uniqueSellingPoint', function () {
        return {
            restrict: 'E',
            replace: true,
            controller: UniqueSellingPoint,
            controllerAs: 'usp',
            scope: {},
            bindToController: {
                icon: '@',
                title: '@',
                text: '@',
                modal: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=UniqueSellingPoint'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var UrlDiscount = /** @class */ (function () {
        function UrlDiscount($http) {
            var _this = this;
            this.$http = $http;
            if (!_.isEmpty(this.code)) {
                $http.get('?dlc=' + this.code).then(function () {
                    TRPCONFIG.DiscountCode = _this.code;
                });
            }
        }
        return UrlDiscount;
    }());
    angular.module('core')
        .directive('urlDiscount', function () {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                code: '@'
            },
            controller: UrlDiscount,
            controllerAs: 'urld'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .directive('voucherModal', function () {
        return {
            restrict: 'E',
            scope: {
                show: '=',
                close: '&',
                voucherInfo: '='
            },
            templateUrl: 'partials/Home/directivetemplate?type=VoucherModal',
            link: function ($scope) {
                $scope.copyVoucherToClipboard = function (voucher) {
                    var copyElement = document.createElement('textarea');
                    copyElement.style.position = 'fixed';
                    copyElement.style.opacity = '0';
                    copyElement.textContent = voucher;
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(copyElement);
                    copyElement.select();
                    document.execCommand('copy');
                    body.removeChild(copyElement);
                };
            }
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .filter('roundedCurrency', roundedCurrency)
        .filter('roundUpToNearest', roundUpToNearest);
    function roundedCurrency(currencyFilter, $locale, currencyService, decimalAdjust) {
        var formats = $locale.NUMBER_FORMATS;
        function separate(decimals, formats, result) {
            if (!decimals) {
                return result.lastIndexOf(formats.DECIMAL_SEP);
            }
            return result.lastIndexOf(formats.DECIMAL_SEP) + 3;
        }
        return function (amount, code, type, decimals, exp, spaced) {
            if (code === void 0) { code = TRPCONFIG.Domain.CurrencyCode; }
            if (type === void 0) { type = 'ceil'; }
            if (decimals === void 0) { decimals = false; }
            if (exp === void 0) { exp = 0; }
            if (spaced === void 0) { spaced = false; }
            if (amount == null) {
                return undefined;
            }
            var sym = currencyService.getSymbol(code);
            if (isNaN(amount)) {
                if (amount.toString().indexOf(sym) >= 0) {
                    var patt = new RegExp(sym + "|,| ", 'g');
                    var amountStr = amount.toString().replace(patt, '');
                    amount = parseFloat(amountStr);
                }
                else {
                    return undefined;
                }
            }
            if (type !== 'cut') {
                amount = decimalAdjust(type, amount, exp);
            }
            var res = sym ? currencyFilter(amount, sym) : currencyFilter(amount);
            var separated = separate(decimals, formats, res);
            var result = res.substring(0, separated) + res.substring(separated + 3);
            if (spaced) {
                var indexOfNumber = result.indexOf(result.match(/\d/));
                return result.substring(0, indexOfNumber) + " " + result.substring(indexOfNumber);
            }
            return result;
        };
    }
    // use to round a value up to nearest specified whole number
    // used for ensuring price values are always rounded higher;
    // defaults to use nearest 5 and 9
    function roundUpToNearest(currencyFilter, currencyService) {
        return function (amount, code, targets) {
            if (code === void 0) { code = TRPCONFIG.Domain.CurrencyCode; }
            if (targets === void 0) { targets = [5, 9]; }
            if (angular.isNumber(targets)) {
                targets = [targets];
            }
            var value = Math.ceil(amount);
            var diff = Math.abs(value) % 10;
            //check if the amount already ends in the specified targets
            if (targets.indexOf(diff) === -1) {
                targets = targets.concat(targets.map(function (i) { return i + 10; }));
                targets.sort(function (a, b) { return a - b; });
                for (var i = 0; i < targets.length; i++) {
                    if (diff < targets[i]) {
                        value += (targets[i] - diff);
                        break;
                    }
                }
            }
            var sym = currencyService.getSymbol(code);
            var res = currencyFilter(value, sym, 0);
            return res;
        };
    }
    angular
        .module('core')
        .filter('customCurrency', customCurrency);
    function customCurrency(currencyFilter, currencyService) {
        return function (cost, code) {
            if (cost == null || isNaN(cost)) {
                return undefined;
            }
            if (!code) {
                code = TRPCONFIG.Domain.CurrencyCode;
            }
            var symbol = currencyService.getCurrencies()[code];
            if (!symbol) {
                symbol = code + " ";
            }
            else {
                symbol = symbol();
            }
            return currencyFilter(cost, symbol);
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .filter('insuranceBandFilter', function () {
        return function (bands, guest) {
            var filteredBands = [];
            if (guest.Type === 1) {
                angular.forEach(bands, function (band) {
                    if (guest.Type === band.PassengerType) {
                        filteredBands.push(band);
                    }
                });
            }
            else {
                angular.forEach(bands, function (band) {
                    if (guest.Age <= band.EndAge && guest.Age >= band.StartAge) {
                        filteredBands.push(band);
                    }
                });
            }
            return filteredBands;
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('core')
        .filter('parseUtilityClasses', function () {
        return function (classes, prefix) { return classes && classes.map(function (i) { return prefix + "--" + i; }).join(' '); };
    });
})();
(function () {
    'use strict';
    angular
        .module('core')
        .filter('unadjustedDate', unadjustedDate);
    function unadjustedDate(dateFilter, dateUtil) {
        return function (date, format) {
            return date == null
                ? undefined
                : dateFilter(dateUtil.parseDate(date), format);
        };
    }
})();
(function () {
    'use strict';
    angular.module('core')
        .filter('unique', function () {
        return function (collection, keyname) {
            var output = [];
            var keys = [];
            angular.forEach(collection, function (item) {
                var key = item[keyname];
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                    output.push(item);
                }
            });
            return output;
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('core')
        .factory('authService', authService);
    function authService($rootScope, $window, $http, $location, $q, $route, $timeout, currentUser, broker, urlUtils, discountsService, criteoService, preferences, analytics, cookieService, dateUtil) {
        var _this = this;
        var domain = TRPCONFIG.Domain;
        var url = '/api2/useraccounts/';
        var preferencesUrl = '/api2/useraccounts/preferences/get';
        var bufferedRoute = {
            route: null,
            reload: false
        };
        var regPromise;
        var signInLevel = {
            None: 0,
            Soft: 1,
            Hard: 2
        };
        broker.subscribe('authService', 'bookingComplete', function () {
            $timeout(function () {
                var cu = currentUser.get();
                var userToExtend = {
                    Agent: cu ? cu.Agent : null,
                    AnonSignedIn: !!cu && cu.AnonSignedIn,
                    BookingId: getSignedInBookingId()
                };
                _extendUser(userToExtend);
            }, 2000);
        });
        broker.subscribe('authService', 'agentSignIn', signOut);
        var service = {
            register: register,
            registerForNewsletter: registerForNewsletter,
            unsubscribeFromNewsletter: unsubscribeFromNewsletter,
            signin: signin,
            socialSignin: socialSignin,
            verify: verify,
            forgotPassword: forgotPassword,
            changeEmail: changeEmail,
            changePasswordWithToken: changePasswordWithToken,
            changePassword: changePassword,
            signOut: signOut,
            changeContactDetails: changeContactDetails,
            changeContactInfo: changeContactInfo,
            deleteAccount: deleteAccount,
            getUser: getUser,
            setUser: setUser,
            getUrl: getUrl,
            bufferRoute: bufferRoute,
            anonSignIn: anonSignIn,
            bookingSignInByAgent: bookingSignInByAgent,
            getNextRoute: getNextRoute,
            newsletterSignUp: newsletterSignUp,
            redirectToBufferedRoute: redirectToBufferedRoute,
            getSignedinBooking: getSignedinBooking,
            impersonatedSignIn: impersonatedSignIn,
            getUserByAgent: getUserByAgent,
            anyEndUser: anyEndUser,
            getSignedInBookingId: getSignedInBookingId,
            doesHttpOnlyCookieExist: doesHttpOnlyCookieExist,
            checkUserPreferences: checkUserPreferences,
            createCookieName: createCookieName,
        };
        function _postRequest(path, data, options) {
            if (data) {
                data.CultureCode = domain.CultureCode;
                data.TenantId = domain.TenantId;
            }
            return $http
                .post(url + path, data, options || {})
                .then(function (res) {
                return res.data;
            });
        }
        function _extendUser(user) {
            return $http
                .get(url + "getsignedinuser")
                .then(function (res) {
                user.Provider = res.data.Identity.Provider;
                user.Email = res.data.Identity.Email;
                user.UserIdHash = res.data.Identity.UserIdHash;
                user.EmailHash = res.data.Identity.EmailHash;
                user.HardSignedIn = res.data.SigninLevel === signInLevel.Hard;
                user.SoftSignedIn = res.data.SigninLevel >= signInLevel.Soft;
                user.ImpersonatedSignedIn = !!res.data.Identity.IsImpersonated;
                user.SignedIn = user.HardSignedIn || user.SoftSignedIn || user.ImpersonatedSignedIn;
                //soft signed in - Contact.Email is not populated, but Identity.Email always is, so don't overwrite it
                if (res.data.Contact) {
                    delete res.data.Contact.Email;
                }
                user = angular.extend(user, res.data.Contact);
                currentUser.set(user);
                broker.publish('userExtended', user);
                return user;
            });
        }
        function _updateUserFromResponse(user) {
            if (user != null) {
                user.Contact = user.Contact || {};
                var hard = user.SigninLevel === signInLevel.Hard;
                var soft = user.SigninLevel >= signInLevel.Soft;
                var existUser = currentUser.get();
                user.Contact = user.SigninLevel < signInLevel.Soft && !!existUser
                    ? angular.extend(user.Contact, {
                        AnonSignedIn: existUser.AnonSignedIn,
                        Contact: existUser.Contact,
                        BookingSummary: existUser.BookingSummary
                    })
                    : angular.extend(user.Contact, { AnonSignedIn: false });
                currentUser.set(angular.extend(user.Contact, {
                    Provider: 'TRP',
                    Agent: existUser ? existUser.Agent : null,
                    Email: user.Identity.Email,
                    UserIdHash: user.Identity.UserIdHash,
                    EmailHash: user.Identity.EmailHash,
                    HardSignedIn: hard,
                    SoftSignedIn: soft,
                    ImpersonatedSignedIn: !!user.Identity.IsImpersonated,
                    SignedIn: hard || soft || !!user.Identity.IsImpersonated
                }));
                broker.publish('userExtended', user);
                preferences.clear();
                $rootScope.user = currentUser.get();
                $rootScope.$broadcast('auth:signin', user.Contact);
            }
        }
        function register(createRequest) {
            return regPromise || (regPromise = _postRequest('register', createRequest)
                .then(function (res) {
                regPromise = null;
                if (res.Result === 0) {
                    _updateUserFromResponse(res.User);
                }
                return res;
            }));
        }
        function registerForNewsletter(createRequest) {
            if (createRequest) {
                createRequest.CultureCode = domain.CultureCode;
                createRequest.TenantId = domain.TenantId;
                createRequest.DomainId = domain.DomainId;
            }
            return $http.post(url + "registerfornewsletter", createRequest, { ignoreErrors: true });
        }
        function unsubscribeFromNewsletter(createRequest) {
            return $http.post(url + "unsubscribe", _.assignIn({}, createRequest, { DomainId: domain.DomainId }), {
                ignoreErrors: false
            });
        }
        function verify(verifyRequest) {
            return _postRequest('verify', verifyRequest).then(function (res) {
                if (res.Success) {
                    _updateUserFromResponse(res.User);
                }
                return res;
            });
        }
        function afterPostSignin(res) {
            if (0 === res.Result) {
                if (currentUser.get() && currentUser.get().AnonSignedIn) {
                    $http.post('/api2/managebooking/signout');
                }
                return discountsService.getDiscountCodeForUser().then(function () {
                    _updateUserFromResponse(res.User);
                    if ($location.search().cb) {
                        // if cb starts with '?' redirect to homepage
                        $location.url($location.search().cb.indexOf('?') ? $location.search().cb : '');
                    }
                    else {
                        redirectToBufferedRoute();
                    }
                    criteoService.enqueue(currentUser.get(), 'signin');
                    if (currentUser.get().Email) {
                        analytics.setMixpanelEmail(currentUser.get().Email);
                    }
                    bufferedRoute.route = null;
                    return res;
                });
            }
            return res;
        }
        function signin(signInRequest) {
            return _postRequest('signin', signInRequest)
                .then(afterPostSignin);
        }
        function socialSignin(signInRequest) {
            return _postRequest('externalsignin', signInRequest)
                .then(afterPostSignin);
        }
        function forgotPassword(req) {
            return _postRequest('initiatechangepassword', req);
        }
        function changeEmail(req) {
            return _postRequest('changeemail', req)
                .then(function (res) {
                if (res.Result === 0) {
                    currentUser.set({ SignedIn: false });
                    $rootScope.$broadcast('auth:signout');
                    $location.path('changeemailsent');
                }
                return res;
            });
        }
        function changePasswordWithToken(req) {
            return _postRequest('changepasswordwithtoken', req)
                .then(function (res) {
                if (res.Result === 0) {
                    _updateUserFromResponse(res.User);
                }
                return res;
            });
        }
        function clearAllBrowserSessions(e) {
            if (e.key === 'clear-sessions' && e.newValue === 'session-cleared') {
                _updateUserSignedOut();
            }
        }
        $window.addEventListener('storage', clearAllBrowserSessions);
        function changePassword(req) {
            return _postRequest('changepassword', req).then(function (res) {
                if (res.Result === 0) {
                    localStorage.setItem('clear-sessions', 'session-cleared');
                    _updateUserSignedOut();
                    if ($route.current.requiresHardAuth || $route.current.requiresAnonAuth) {
                        $location.path('/signin');
                    }
                }
                return res;
            });
        }
        function signOut(req) {
            var isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
            var enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');
            var path = '/v3';
            var currentPath = $location.path();
            var dashboardPath = currentPath && currentPath.startsWith('/dashboard');
            var promises = [];
            if (currentUser.get().SignedIn) {
                promises.push(_postRequest('signout', req));
            }
            if (currentUser.get().AnonSignedIn) {
                promises.push($http.post('/api2/managebooking/signout'));
            }
            return $q
                .all(promises)
                .then(function () {
                discountsService.validate(TRPCONFIG.DiscountCode);
            })
                .then(function () {
                _updateUserSignedOut();
                var _a = window.location, hostname = _a.hostname, protocol = _a.protocol;
                var search = window.location.search;
                if (search) {
                    search = '';
                }
                if (enableV3SignIn && !isAgentMode && dashboardPath) {
                    if (!currentUser.get().SignedIn) {
                        window.location.href = protocol + "//" + hostname + path + search;
                    }
                }
                else if ($route.current.requiresHardAuth || $route.current.requiresAnonAuth) {
                    $location.path('');
                }
            });
        }
        function changeContactDetails(c) {
            return _postRequest('setcontact', c);
        }
        function changeContactInfo(c) {
            return _postRequest('setcontactinformation', c, { customErrCallback: function () { return true; } });
        }
        function _updateUserSignedOut() {
            currentUser.set(angular.extend({}, currentUser.get(), {
                SignedIn: false,
                AnonSignedIn: false,
                HardSignedIn: false,
                SoftSignedIn: false,
                ImpersonatedSignedIn: false,
                Contact: null
            }));
            preferences.clear();
            $rootScope.$broadcast('auth:signout');
            $rootScope.user = currentUser.get();
            var signedOut = localStorage.getItem('clear-sessions');
            if (signedOut === 'session-cleared') {
                $timeout(localStorage.removeItem('clear-sessions'), 500);
            }
        }
        function deleteAccount(req) {
            return _postRequest('delete', req)
                .then(function (res) {
                if (res.Success) {
                    _updateUserSignedOut();
                    $location.path('');
                }
                return res;
            });
        }
        function getUser() {
            return currentUser.get();
        }
        function setUser(user) {
            currentUser.set(user);
            if (user.SignedIn) {
                if (user.AnonSignedIn && user.SigninLevel >= signInLevel.Soft) {
                    //Only if the user is not impersonated
                    $http.post('/api2/managebooking/signout');
                }
                _extendUser(user);
            }
        }
        function getUrl() {
            return url;
        }
        function bufferRoute(r, reload) {
            if (reload === void 0) { reload = false; }
            bufferedRoute.route = r;
            bufferedRoute.reload = reload;
        }
        function redirectToBufferedRoute() {
            var redirect = !!(bufferedRoute.route && bufferedRoute.route.indexOf('?'));
            if (redirect) {
                if (bufferedRoute.reload) {
                    //Relaoding the location immediately after $location.path will fail in some browser.
                    window.location.href = bufferedRoute.route;
                }
                else {
                    var parsedUri = urlUtils.parse(bufferedRoute.route);
                    $location.path(parsedUri && parsedUri.url).search(parsedUri.qs);
                }
            }
            return redirect;
        }
        function bookingSignInByAgent(bookingId) {
            return $http.post('api2/bookings/manage/signinByAgent', {
                BookingId: bookingId
            }).then(function (res) {
                return res;
            })
                .then(function (res) { return _signInResult(res); });
        }
        function anonSignIn(bookingRef, lastName) {
            var user = currentUser.get();
            return (user.SignedIn ?
                _postRequest('signout') :
                $q.when()).then(function () {
                return $http.post('/api2/bookings/manage/signinv2', {
                    BookingRef: bookingRef,
                    Surname: lastName,
                    DomainId: TRPCONFIG.Domain.DomainId
                }).then(function (res) { return _signInResult(res); });
            });
        }
        function _signInResult(res) {
            if (!res.data.Success) {
                return $q.when(false);
            }
            return getSignedinBooking().then(function (booking) {
                var user = angular.extend({}, currentUser.get(), {
                    AnonSignedIn: res.data.Success,
                    Contact: booking.Contact,
                    BookingSummary: booking.Summary
                });
                setUser(user);
                if (user.AnonSignedIn) {
                    analytics.track('mixpanel', 'UserSignedIn', {
                        IdentityProvider: 'bookingLookup'
                    });
                    $rootScope.$broadcast('auth:signin', user);
                }
                return user.AnonSignedIn;
            });
        }
        function newsletterSignUp(userId, signupreason) {
            if (signupreason === void 0) { signupreason = 'Newsletter Signup'; }
            var data = {
                UserId: userId,
                Channel: 1,
                Status: 1,
                Source: 'TravelRepublic',
                Reason: signupreason,
                Date: (new Date()).toISOString()
            };
            return $http.post(url + "Setcommunicationpreference", data);
        }
        function getNextRoute() {
            return bufferedRoute.route || '';
        }
        function getSignedinBooking() {
            return $http.post('/api2/bookings/manage/getsignedinbookingcontact')
                .then(function (result) {
                return result && result.data ? result.data : null;
            });
        }
        function getHost() {
            return $location.host();
        }
        function getDomain() {
            var host = getHost();
            var cookieDomain;
            var domainParts;
            if (host.startsWith('pp2.')) {
                cookieDomain = host.replace('pp2.', '.pp2.');
            }
            else {
                domainParts = host.split('.');
                domainParts.shift();
                cookieDomain = "." + domainParts.join('.');
            }
            return cookieDomain;
        }
        function createCookieName() {
            var domainParts;
            var host = getHost();
            var devEnv = _.get(TRPCONFIG, 'Domain2.CookieEnv');
            domainParts = host.split('.');
            var match = domainParts.some(function (part) { return devEnv && devEnv.includes(part); });
            var devEnvStr = (match) ? 'DEV' : '';
            return devEnvStr + ".ASPXAUTH";
        }
        var getUserPreferences = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(preferencesUrl)];
                    case 1:
                        response = _a.sent();
                        status = response.status;
                        if (status === 401 || status === 403) {
                            return [2 /*return*/, status];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        function checkUserPreferences() {
            return __awaiter(this, void 0, void 0, function () {
                var enabled, getUserPrefResponse, user, signedIn;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            enabled = _.get(TRPCONFIG, 'Domain2.ClearUserPrefs');
                            if (!enabled) {
                                return [2 /*return*/];
                            }
                            user = getUser();
                            signedIn = _.get(user, 'SignedIn');
                            if (!signedIn) return [3 /*break*/, 2];
                            return [4 /*yield*/, getUserPreferences()];
                        case 1:
                            getUserPrefResponse = _a.sent();
                            _a.label = 2;
                        case 2:
                            if (getUserPrefResponse && signedIn === true) {
                                _updateUserSignedOut();
                                $location.path('/signin');
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function doesHttpOnlyCookieExist(cookiename) {
            var enabled = _.get(TRPCONFIG, 'Domain2.ClearUserPrefs');
            if (!enabled) {
                return;
            }
            var cookieDomain = getDomain();
            var duration = dateUtil.addDays(new Date(), 14);
            var expires = "expires= + " + duration;
            cookieService.set(cookiename, 1, expires, cookieDomain);
            var cookies = "" + document.cookie;
            var cookieASPXAUTH = cookieService.get(cookiename, cookies);
            var user = currentUser.get();
            var requiresHardAuth = _.get($route, 'current.requiresHardAuth');
            var requiresAnonAuth = _.get($route, 'current.requiresAnonAuth');
            if (cookieASPXAUTH !== null && _.get(user, 'SignedIn')) {
                _updateUserSignedOut();
                if (requiresHardAuth || requiresAnonAuth) {
                    $location.path('/signin');
                }
            }
        }
        function impersonatedSignIn(userId) {
            return _postRequest('impersonatedsignin', { userId: userId })
                .then(function (res) {
                if (res.Success === false) {
                    broker.publish('userDeimpersonated', null);
                }
                else {
                    _updateUserFromResponse(res.User);
                }
                return res;
            });
        }
        function getUserByAgent(userId) {
            return $http.get(url + "getuserbyagent?request.userId=" + userId, { ignoreErrors: true });
        }
        //True, if there is either Travel agent / Customer is selected
        function anyEndUser() {
            return TRPCONFIG.Domain.IsTravelAgentMode || (!!currentUser.get() && currentUser.get().ImpersonatedSignedIn);
        }
        function getSignedInBookingId() {
            var user = getUser();
            return user && user.AnonSignedIn ? (user.Contact ? user.Contact.BookingId : user.BookingId) : null;
        }
        return service;
    }
})();
var Core;
(function (Core) {
    var Booking;
    (function (Booking) {
        var BookingRequest = /** @class */ (function () {
            function BookingRequest(TripId, BookingProcessId, UserData, CultureCode, DomainId, ApplicationType, LinkedBookingId, TrackingTag, CheckLivePrices, BasketId) {
                this.TripId = TripId;
                this.BookingProcessId = BookingProcessId;
                this.UserData = UserData;
                this.CultureCode = CultureCode;
                this.DomainId = DomainId;
                this.ApplicationType = ApplicationType;
                this.LinkedBookingId = LinkedBookingId;
                this.TrackingTag = TrackingTag;
                this.CheckLivePrices = CheckLivePrices;
                this.BasketId = BasketId;
            }
            return BookingRequest;
        }());
        Booking.BookingRequest = BookingRequest;
        angular
            .module('core')
            .service('bookingService', bookingService);
        function bookingService($http, resourceService, basketStore, searchUnitService, $q, $location, $timeout, $interval, preferences, loggingService, urlUtils, $routeParams, localStorageProvider, $window, mandatoryTransferService, authService, $rootScope) {
            var url = '/api2/bookings/';
            var gmtUrl = '/api2/callmgmt/';
            var driverOptions = [
                { name: resourceService.getDeferred('NOTADRIVER'), value: Booking.DriverType.NotADriver },
                { name: resourceService.getDeferred('MAINDRIVER'), value: Booking.DriverType.MainDriver },
                { name: resourceService.getDeferred('ADDITIONALDRIVER'), value: Booking.DriverType.AdditionalDriver }
            ];
            var promise;
            var service = {
                driverOptions: driverOptions,
                trimBooking: trimBooking,
                prepareBooking: prepareBooking,
                getBooking: getBooking,
                updateBooking: updateBooking,
                book: book,
                getCpgStatus: getCpgStatus,
                getUrl: getUrl,
                getAdultTitles: getAdultTitles,
                copyFromContact: copyFromContact,
                detailsMatch: detailsMatch,
                clearContact: clearContact,
                clearGuests: clearGuests,
                checkValidEmail: checkValidEmail,
                updateDeposit: updateDeposit,
                paypalPostBooking: paypalPostBooking,
                getDiscountForCard: getDiscountForCard,
                getCardDiscountsForDomain: getCardDiscountsForDomain,
                setTrackingTag: setTrackingTag,
                getTrackingTag: getTrackingTag,
                pauseRecording: pauseRecording,
                resumeRecording: resumeRecording,
                browserDetails: browserDetails
            };
            function setTrackingTag(tag) {
                return localStorageProvider.setItem('trackingTag', tag);
            }
            function getTrackingTag(cb) {
                return localStorageProvider.getItem('trackingTag', function (error, value) { return cb(value); });
            }
            function removeTrackingTag() {
                return localStorageProvider.removeItem('trackingTag');
            }
            function _enhanceBooking(booking) {
                //this has to be done on the client because PayPalEnabled is dictated by whether or not cookies are enabled.
                booking.PaymentOptions = _.filter(booking.PaymentOptions, function (option) { return TRPCONFIG.PayPalEnabled || !option.IsPayPalPayment; });
                return $q.when(booking).then(setDashboardPreferences);
            }
            function setDashboardPreferences(booking) {
                if (!TRPCONFIG.Domain.DashboardSettingsEnabled) {
                    return $q.when(booking);
                }
                return preferences.get('smokingRoom').then(function (smokingRoom) {
                    return __assign({}, booking, { UserData: __assign({}, booking.UserData, { Rooms: booking.UserData.Rooms.map(function (room) {
                                var _a = [1, 2], yes = _a[0], no = _a[1];
                                var hasSpecialRequest = room.SpecialRequest === '' || room.SpecialRequest == null;
                                var isSmokingRoomSet = smokingRoom === yes || smokingRoom === no;
                                if (hasSpecialRequest && isSmokingRoomSet) {
                                    var smokingRequestResource = smokingRoom === yes
                                        ? 'SMOKINGROOMREQUEST'
                                        : 'NOSMOKINGROOMREQUEST';
                                    room.SpecialRequest = resourceService.getDeferred(smokingRequestResource)();
                                }
                                return room;
                            }) }) });
                });
            }
            function paypalPostBooking(paypalResult) {
                if (TRPCONFIG.Domain.PaypalInContextEnabled) {
                    var token = urlUtils.parse(paypalResult.AcsUrl).qs.token;
                    $window.paypal.checkout.startFlow(token);
                }
                else {
                    $window.location.href = paypalResult.AcsUrl;
                }
            }
            function trimBooking(booking) {
                var copy = _.cloneDeep(booking);
                return {
                    UserData: copy.UserData,
                    BookingProcessId: copy.BookingProcessId,
                    LinkedBookingId: copy.LinkedBookingId
                };
            }
            function prepareBooking(basketId, bookingId, tripId, userData) {
                var req = {
                    BookingProcessId: bookingId,
                    BasketId: basketId,
                    TripId: tripId,
                    IsRebook: !!$routeParams.BookingRef,
                    CultureCode: TRPCONFIG.Domain.CultureCode
                };
                promise = $http.post('website/booking/preparebooking', req)
                    .then(function (_a) {
                    var booking = _a.data;
                    return basketStore.applyCancelations(basketId, booking.BookingProcessId)
                        .then(function () { return booking; });
                })
                    .then(function (booking) {
                    if (userData) {
                        booking.UserData = userData;
                    }
                    return $q.all([
                        basketStore.rules(basketId),
                        basketStore.carHire(basketId),
                        _enhanceBooking(_.cloneDeep(booking))
                    ]);
                })
                    .then(function (_a) {
                    var rules = _a[0], carHire = _a[1], booking = _a[2];
                    if (rules.captureFlight) {
                        var mode = searchUnitService.transfer;
                        booking.UserData.ConnectingFlight = {
                            OutboundDate: searchUnitService.startDate(mode),
                            InboundDate: searchUnitService.endDate(mode)
                        };
                    }
                    if (TRPCONFIG.Domain.MandatoryExtrasEnabled) {
                        var connectingFlight = booking.UserData.ConnectingFlight;
                        var flightWithDetaild = mandatoryTransferService.addFlightDetails(connectingFlight);
                        booking.UserData.ConnectingFlight = flightWithDetaild;
                    }
                    if (carHire) {
                        booking.BookingRules.AdditionalDrivers = carHire.AdditionalDrivers;
                    }
                    if (rules.captureMainDriver) {
                        var main_1 = false;
                        var additional_1 = 0;
                        var additionalDrivers_1 = booking.BookingRules.AdditionalDrives;
                        booking.UserData.Rooms = booking.UserData.Rooms.map(function (room) { return (__assign({}, room, { Guests: room.Guests.map(function (guest) {
                                if (!main_1 && guest.DriverType !== 1) {
                                    main_1 = true;
                                    guest.DriverType = 1;
                                }
                                else if (additional_1 < additionalDrivers_1 && guest.Type === 1) {
                                    guest.DriverType = 2;
                                    additional_1++;
                                }
                                return guest;
                            }) })); });
                    }
                    service.updateBooking(booking);
                    return booking;
                });
                return promise;
            }
            function checkValidEmail(email) {
                var domain = TRPCONFIG.Domain;
                return $http.post(url + "validateemail", {
                    DomainId: domain.DomainId,
                    CultureCode: domain.CultureCode,
                    Email: email
                }).then(function (result) {
                    if (result && result.data) {
                        return $q.resolve();
                    }
                    return $q.reject();
                });
            }
            function getBooking(bookingId, tripId) {
                if (promise != null && !TRPCONFIG.Domain.isAgentMode) {
                    return promise.then(_enhanceBooking);
                }
                promise = $http.get("website/booking/getbooking?" + $.param({
                    TripId: tripId,
                    BookingProcessId: bookingId,
                    CultureCode: TRPCONFIG.Domain.CultureCode
                }), {
                    customErrCallback: function (data) {
                        if (data.status === 404) {
                            loggingService.logError("Booking Already Done: booking.service: getbooking?" + $.param({
                                TripId: tripId, BookingProcessId: bookingId,
                                CultureCode: TRPCONFIG.Domain.CultureCode
                            }) + ", DomainId:" + TRPCONFIG.Domain.DomainId + ", href:\"" + $location.absUrl());
                            $location.path('bookingalreadydone');
                        }
                        else {
                            return true;
                        }
                    }
                }).then(function (result) {
                    if (result) {
                        return _enhanceBooking(_.cloneDeep(result.data));
                    }
                    promise = null;
                });
                return promise;
            }
            function updateBooking(booking, description) {
                var copy = _.cloneDeep(booking);
                //make sure that we are not sending card data when calling update booking
                _.get(copy, 'UserData.PaymentDetails.CardDetails') && delete copy.UserData.PaymentDetails.CardDetails;
                promise = $q.when(booking);
                return $http.post(url + "updatebooking", {
                    DomainId: TRPCONFIG.Domain.DomainId,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                    BookingProcessId: booking.BookingProcessId,
                    UserData: copy.UserData,
                    Description: description
                }, { ignoreErrors: true }).then(function () { return promise != null ? promise : booking; }).then(function () {
                    var cookieName = authService.createCookieName();
                    if (cookieName) {
                        authService.doesHttpOnlyCookieExist(cookieName);
                    }
                });
            }
            function browserDetails() {
                var browserDetails = {
                    ScreenHeight: window.screen.height,
                    ScreenWidth: window.screen.width,
                    ColorDepth: window.screen.colorDepth,
                    AdditionalDetails: {
                        ExtraData: [
                            {
                                Name: null,
                                value: null
                            }
                        ]
                    }
                };
                return browserDetails;
            }
            function book(booking, tripId, basketId) {
                var domain = TRPCONFIG.Domain;
                //enable timeouts only for desktop
                var isMobile = TRPCONFIG.IsMobileView;
                var checkLivePrice = domain.CheckLivePrices && !isMobile;
                return $q(function (res, rej) {
                    service.getTrackingTag(function (value) {
                        booking.UserData['BrowserDetails'] = browserDetails();
                        var req = new BookingRequest(tripId, booking.BookingProcessId, booking.UserData, domain.CultureCode, domain.DomainId, TRPCONFIG.ApplicationType, booking.LinkedBookingId, value, checkLivePrice, basketId);
                        if (!req.UserData.PaymentDetails.CardDetails.PaymentTypeId
                            && !req.UserData.PaymentDetails.IsSkippingPayment) {
                            if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                                var cd = req.UserData.PaymentDetails.CardDetails;
                                cd.CardType = 370;
                                cd.PaymentTypeId = 36;
                            }
                            if (TRPCONFIG.Domain.WPIframeUpdate) {
                                var cd = req.UserData.PaymentDetails.CardDetails;
                                cd.CardType = 369;
                                cd.PaymentTypeId = 35;
                            }
                        }
                        $http.post(url + "createbooking", req).then(function (result) {
                            // Discard booking after creation if there are no messages and the status is complete
                            if (result.data.Messages && result.data.Messages.length === 0 &&
                                (result.data.Status === Booking.CreateBookingStatus.Complete ||
                                    result.data.Status === Booking.CreateBookingStatus.HostedPayment ||
                                    result.data.Status === Booking.CreateBookingStatus.WPHostedPayment)) {
                                promise = null;
                                removeTrackingTag();
                            }
                            res(result.data);
                        });
                    });
                });
            }
            function getCpgStatus(prePaymentId) {
                var pollDelayMsConfig = TRPCONFIG.Domain.CpgStatusIntervalDelay;
                var subRouteConfig = TRPCONFIG.Domain.CpgStatusApiSubRoute;
                var stopApiMsConfig = TRPCONFIG.Domain.CpgStatusTimeout;
                var subRouteStr = (subRouteConfig && subRouteConfig.trim()) || '';
                if (!prePaymentId && !window) {
                    return null;
                }
                var host = $location.host();
                var protocol = $location.protocol();
                var path = window.location.pathname || '';
                var parsedPath = path && path.split('/').filter(function (value) { return value; });
                var subPath = parsedPath[0] === subRouteStr ? "/" + parsedPath[0] : '';
                var cpgstatusURL = protocol + "://" + host + subPath + "/cpgstatus?prebookpaymentid=" + prePaymentId;
                return $q(function (res, rej) {
                    var interval = $interval(function () {
                        $http.get("" + cpgstatusURL).then(function (result) {
                            var bookingPath = $location.path();
                            if (bookingPath && !bookingPath.includes('book')) {
                                console.log('cpgStatus cancelled');
                                var response = {
                                    paRes: '',
                                    prePaymentId: '',
                                    error: '',
                                };
                                res(response);
                                $interval.cancel(interval);
                            }
                            if (result && result.status !== 200) {
                                console.log('cpgStatus result.status', result.status);
                                var response = {
                                    paRes: '',
                                    prePaymentId: '',
                                    error: '',
                                };
                                res(response);
                                $interval.cancel(interval);
                            }
                            if (result.data.Status === 'SUCCESS') {
                                var cpgStatus = result.data.Status;
                                var authCode = result.data && result.data.AuthCode;
                                var paRes = cpgStatus === 'SUCCESS'
                                    ? "^" + authCode + "^^^AUTHORISED"
                                    : '';
                                var response = {
                                    paRes: paRes,
                                    prePaymentId: prePaymentId,
                                    error: '',
                                };
                                res(response);
                                $interval.cancel(interval);
                            }
                            if (result.data.Status === 'FAILED') {
                                // payment failed so stop polling
                                // Log an error?
                                var error = 'FAILED';
                                var response = {
                                    paRes: '',
                                    prePaymentId: '',
                                    error: error,
                                };
                                res(response);
                                $interval.cancel(interval);
                            }
                            if (result.data.Status === 'STOP') {
                                // stop polling
                                // Duplicate, log error
                                console.log('stop polling');
                                var response = {
                                    paRes: '',
                                    prePaymentId: '',
                                    error: '',
                                };
                                res(response);
                                $interval.cancel(interval);
                            }
                        });
                    }, pollDelayMsConfig);
                    $timeout(function () {
                        $interval.cancel(interval);
                        var error = 'TIMER';
                        var response = {
                            paRes: '',
                            prePaymentId: '',
                            error: error,
                        };
                        $rootScope.$broadcast('cpgStatusAPIError', response);
                    }, stopApiMsConfig);
                });
            }
            function getUrl() {
                return url;
            }
            function _getTitleIndex(t) {
                if (!t) {
                    return -1;
                }
                var clean = function (s) {
                    return s.toLowerCase()
                        .replace(/[.-/#!$%^&*;:{}=\-_`~()]/g, '')
                        .replace(/\s{2,}/g, ' ');
                };
                var titlesString = clean(getAdultTitles()());
                var titleArray = titlesString.split(',');
                return titleArray
                    .indexOf(clean(t));
            }
            function copyFromContact(booking, e) {
                var guest = _.get(booking, 'UserData.Rooms[0].Guests[0]');
                var contact = booking.UserData.Contact;
                var titles = getAdultTitles()();
                guest.FirstName = contact.FirstName;
                guest.LastName = contact.LastName;
                var index = _getTitleIndex(contact.Title);
                if (index !== -1) {
                    guest.Title = titles.split(',')[index];
                }
                if (!!guest.FirstName && !!guest.LastName && index !== -1) {
                    service.updateBooking(booking);
                    if (e) {
                        e.stopPropagation();
                    }
                }
            }
            function getAdultTitles() {
                return resourceService.getDeferred('ADULTTITLES');
            }
            function detailsMatch(booking) {
                var guest = _.get(booking, 'UserData.Rooms[0].Guests[0]');
                var contact = booking.UserData.Contact;
                return (!contact.FirstName && !contact.LastName && !contact.Title)
                    ? true
                    : guest.FirstName === contact.FirstName &&
                        guest.LastName === contact.LastName &&
                        _getTitleIndex(contact.Title) === getAdultTitles()().split(',').indexOf(guest.Title);
            }
            function clearContact(userData) {
                userData.Contact = {
                    CountryCode: TRPCONFIG.Domain.CountryCode,
                    Title: '',
                    FirstName: '',
                    LastName: ''
                };
            }
            function clearGuests(rooms) {
                _.forEach(rooms, function (room) {
                    _.forEach(room.Guests, function (g) {
                        g.Title = '';
                        g.FirstName = '';
                        g.LastName = '';
                        g.DateOfBirth = undefined;
                    });
                });
            }
            function updateDeposit(deposit, payment, totalCost, minDeposit) {
                $timeout(function () {
                    if (deposit && deposit.$valid) {
                        payment.PaymentAmount = parseFloat(deposit.$modelValue);
                        return;
                    }
                    var errors = Object.keys(deposit.$error);
                    if (errors.length === 1) {
                        if (deposit.$error.maxValue) {
                            payment.PaymentAmount = parseFloat(totalCost);
                            return;
                        }
                    }
                    payment.PaymentAmount = parseFloat(minDeposit);
                });
            }
            function getDiscountForCard(bookingId, cardNumber, domainId, cultureCode) {
                return $http.get(url + "getdiscountforcard", {
                    params: {
                        'basketId': bookingId,
                        'cardNumber': cardNumber,
                        'domainId': domainId,
                        'cultureCode': cultureCode
                    }
                }).then(function (result) {
                    return result.data.DiscountDetails.Discount;
                });
            }
            function getCardDiscountsForDomain(domainId, cultureCode) {
                return $http.get(url + "getcarddiscountsfordomain", {
                    params: {
                        'domainId': domainId,
                        'cultureCode': cultureCode
                    },
                    cache: true
                }).then(function (result) {
                    return result.data;
                });
            }
            function pauseRecording(agentIpAddress) {
                return $http.post(gmtUrl + "pauserecording", {
                    params: {
                        'AgentIpAddress': agentIpAddress
                    }
                });
            }
            function resumeRecording(agentIpAddress) {
                return $http.post(gmtUrl + "resumerecording", {
                    params: {
                        'AgentIpAddress': agentIpAddress
                    }
                });
            }
            return service;
        }
    })(Booking = Core.Booking || (Core.Booking = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ManageBooking;
    (function (ManageBooking) {
        angular
            .module('core')
            .service('bookingsManagerService', BookingsManagerService);
        function BookingsManagerService($http, $q, $routeParams, dateUtil, imageService, destinationService) {
            var service = {
                getCurrentTripForUser: getCurrentTripForUser,
                getCancellationOptions: getCancellationOptions,
                getTrip: getTrip
            };
            var BookingTypePropertyMap;
            (function (BookingTypePropertyMap) {
                BookingTypePropertyMap[BookingTypePropertyMap["FlightBooking"] = 1] = "FlightBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["AttractionsBooking"] = 2] = "AttractionsBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["CarHireBooking"] = 4] = "CarHireBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["HotelBooking"] = 8] = "HotelBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["AirportParkingBooking"] = 16] = "AirportParkingBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["TransferBooking"] = 32] = "TransferBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["InsuranceBooking"] = 64] = "InsuranceBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["MarhabaBooking"] = 256] = "MarhabaBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["BundleBooking"] = 1024] = "BundleBooking";
                BookingTypePropertyMap[BookingTypePropertyMap["AdHocBooking"] = 2048] = "AdHocBooking";
            })(BookingTypePropertyMap || (BookingTypePropertyMap = {}));
            function getCancellationOptions(bookingId) {
                var url = "/api/bookings/cancellations/options?bookingId=" + bookingId;
                return $http.get(url).then(function (response) { return response && response.data; });
            }
            function getCurrentTripForUser() {
                var url = "/api/bookings/trips/current?culturecode=" + TRPCONFIG.Domain.CultureCode;
                return $http.get(url).then(function (response) {
                    if (response.status === 204) {
                        // 'No content' - this is expected if there is no current trip!
                        return null;
                    }
                    return _enrichBookedTrip(response.data);
                });
            }
            function getTrip(bookingId) {
                var url = "/api/bookings/" + bookingId + "/trip?culturecode=" + TRPCONFIG.Domain.CultureCode;
                return $http.get(url)
                    .then(function (_a) {
                    var data = _a.data;
                    if ($routeParams.ref) {
                        var refs_1 = $routeParams.ref.toUpperCase().split('|');
                        data.Bookings = _.filter(data.Bookings, function (b) { return _.find(refs_1, function (r) { return r === b['BookingRef'].toUpperCase(); }); });
                    }
                    return _enrichBookedTrip(data);
                });
            }
            function _enrichBookedTrip(booking) {
                // Decorate trip with properties not returned by the API response
                var trip = new ManageBooking.BookedTrip();
                trip.StartDate = booking.StartDate;
                trip.EndDate = booking.EndDate;
                trip.Adults = booking.Adults;
                trip.Children = booking.Children;
                trip.Infants = booking.Infants;
                var startDate = dateUtil.parseDate(trip.StartDate);
                var endDate = dateUtil.parseDate(trip.EndDate);
                trip.Duration = dateUtil.getDifferenceInDays(startDate, endDate);
                trip.DaysUntilDeparture = dateUtil.getDifferenceInDays(new Date(), startDate);
                trip.DaysUntilReturn = dateUtil.getDifferenceInDays(new Date(), endDate);
                //payment bits
                _.each(booking.Bookings, function (b) {
                    //set the currency code to be the same as the first bookings cleared payment currency
                    //handle cases where agents skip a payment (no payment info)
                    if (!trip.PaymentDetails.CurrencyCode) {
                        var head = _.head(b.PaymentInfo.ClearedPayments);
                        trip.PaymentDetails.CurrencyCode = head ? head.ClientCurrencyCode : '';
                    }
                    if (TRPCONFIG.Domain2.MonthlyPaymentsEnabled) {
                        trip.PaymentDetails.Paid += _.reduce(b.PaymentInfo.ClearedPayments, function (r, p) {
                            var isAmountSkipped = p.IsScheduledPayment && p.ClientCurrencyPaymentAmount < 0;
                            return isAmountSkipped ? r : r + p.ClientCurrencyPaymentAmount;
                        }, 0);
                    }
                    else {
                        trip.PaymentDetails.Paid += _.reduce(b.PaymentInfo.ClearedPayments, function (r, p) { return r + p.ClientCurrencyPaymentAmount; }, 0);
                    }
                    _.each(b.PaymentInfo.FuturePayments, function (p) {
                        var updateArray = function (arr, amount, due, currencyCode) {
                            var item = _.find(arr, { 'Due': due, 'CurrencyCode': currencyCode });
                            if (item) {
                                item.Amount += amount;
                            }
                            else {
                                arr.push({ Amount: amount, BookingType: b.BookingType, CurrencyCode: currencyCode, Due: due });
                            }
                        };
                        trip.PaymentDetails.Total += p.ClientCurrencyPaymentAmount;
                        updateArray(trip.PaymentDetails.Balances, p.ClientCurrencyPaymentAmount, p.PaymentDate, p.ClientCurrencyCode);
                    });
                    _.each(b.PaymentInfo.DirectPayments, function (p) {
                        trip.PaymentDetails.PayDirect.push({ Amount: p.Amount,
                            LocalAmount: p.LocalAmount,
                            LocalCurrency: p.LocalCurrency,
                            BookingType: b.BookingType
                        });
                        trip.PaymentDetails.Total += p.Amount;
                    });
                    delete b.PaymentInfo; //remove the payment info as we shouldn't need it going forward
                });
                trip.PaymentDetails.Total += trip.PaymentDetails.Paid; //set the total correctly
                trip.PaymentDetails.Outstanding = trip.PaymentDetails.Total - trip.PaymentDetails.Paid;
                trip.PaymentDetails.Balances = _.sortBy(trip.PaymentDetails.Balances, 'Due'); //tidy up
                //map our bookings array to our bookedTrip properties
                _mapBookingsArrayToProperties(trip, booking.Bookings);
                var mainBooking = (trip.FlightBooking || trip.HotelBooking);
                if (!mainBooking) {
                    mainBooking = booking.Bookings[0];
                }
                trip.MainBookingId = mainBooking.BookingId;
                if (trip.DaysUntilDeparture > 0) {
                    trip.TripStage = ManageBooking.TripStage.PreTrip;
                }
                else if (trip.DaysUntilReturn > 0) {
                    trip.TripStage = ManageBooking.TripStage.OnTrip;
                }
                else {
                    trip.TripStage = ManageBooking.TripStage.PostTrip;
                }
                // get destination based on either hotel OR flight destination airport
                var dest = null;
                if (trip.HotelBooking) {
                    var b = trip.HotelBooking;
                    // use Province OR first destination
                    var dests = b.Hotel.Destinations;
                    dest = _.find(dests, ['Type', Core.Destinations.DestinationType.Province])
                        || dests[0];
                }
                else if (trip.FlightBooking) {
                    // use destination of arrival airport
                    dest = _.head(trip.FlightBooking.Legs).ArrivalAirport.Destination;
                }
                else if (trip.TransferBooking) {
                    //we handle sorting out the destination info a little further down
                    //look there
                }
                else if (trip.AttractionsBooking) {
                    dest = _.head(trip.AttractionsBooking.Attractions).Destination;
                }
                var destPromise;
                if (dest) {
                    trip.Destination = dest;
                    trip.Destination.ImageUrl = imageService.getDestinationImage({ Id: dest.Id, Type: dest.Type });
                    // Make an additional API call to get the destination landing page path
                    destPromise = destinationService.getDetails(angular.copy(trip.Destination), ['PagePath']);
                }
                else {
                    destPromise = $q.when();
                }
                //extend product infos
                if (trip.HotelBooking) {
                    var b = trip.HotelBooking;
                    trip.HotelBooking.Duration = dateUtil.dayDiff(b.CheckInDate, b.CheckOutDate);
                    // get hotel image url
                    var d = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
                    b.Hotel.ImageUrl = imageService.getMainImageUrl(b.Hotel.EstabId, d, d, true);
                }
                if (trip.FlightBooking) {
                    _.each(trip.FlightBooking.Legs, function (l) {
                        var start = dateUtil.parseDate(l.DepartureTime);
                        var end = dateUtil.parseDate(l.ArrivalTime);
                        l.DayDiff = dateUtil.getDifferenceInDays(start, end);
                    });
                }
                if (trip.TransferBooking) {
                    trip.TransferBooking.Legs = [];
                    if (trip.TransferBooking.Outbound) {
                        trip.TransferBooking.Legs.push(trip.TransferBooking.Outbound);
                    }
                    if (trip.TransferBooking.Return) {
                        trip.TransferBooking.Legs.push(trip.TransferBooking.Return);
                    }
                    trip.TransferBooking.Title = trip.TransferBooking.Legs[0].Title;
                    //a bit of a hack to use a default image for transfers
                    if (!trip.Destination) {
                        trip.Destination = {
                            Id: 0,
                            Type: Core.Destinations.DestinationType.Universal,
                            Title: trip.TransferBooking.Legs[0].DropOffPoint,
                            ImageUrl: '/build/img/backdrops/transfers-dec16.jpg'
                        };
                    }
                }
                return destPromise.then(function (response) {
                    if (response && trip.Destination) {
                        trip.Destination.PagePath = response.PagePath;
                    }
                    return trip;
                });
            }
            function _mapBookingsArrayToProperties(trip, bookings) {
                //go through the array setting our properties, currently we support only one of each product
                //type, this may change in future possibly
                _.each(bookings, function (b) {
                    var property = BookingTypePropertyMap[b.BookingType];
                    trip[property] = b;
                });
            }
            return service;
        }
    })(ManageBooking = Core.ManageBooking || (Core.ManageBooking = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var CrossSellType = Core.Booking.CrossSellType;
    var BookingStatus;
    (function (BookingStatus) {
        BookingStatus[BookingStatus["Confirmed"] = 1] = "Confirmed";
        BookingStatus[BookingStatus["Pending"] = 2] = "Pending";
        BookingStatus[BookingStatus["Canceled"] = 3] = "Canceled";
    })(BookingStatus || (BookingStatus = {}));
    ;
    // this enum used for mapping cross sells to priorities
    // (required because the API fails to define a ProductType for each cross sell)
    var productTypeByCrossSellKey;
    (function (productTypeByCrossSellKey) {
        productTypeByCrossSellKey[productTypeByCrossSellKey["Attractions"] = 2] = "Attractions";
        productTypeByCrossSellKey[productTypeByCrossSellKey["Hotels"] = 8] = "Hotels";
        productTypeByCrossSellKey[productTypeByCrossSellKey["CarHire"] = 4] = "CarHire";
        productTypeByCrossSellKey[productTypeByCrossSellKey["Parking"] = 16] = "Parking";
        productTypeByCrossSellKey[productTypeByCrossSellKey["Transfer"] = 32] = "Transfer";
    })(productTypeByCrossSellKey = Core.productTypeByCrossSellKey || (Core.productTypeByCrossSellKey = {}));
    ;
    var crossSellTypeByCrossSellKey;
    (function (crossSellTypeByCrossSellKey) {
        crossSellTypeByCrossSellKey[crossSellTypeByCrossSellKey["Attractions"] = 2] = "Attractions";
        crossSellTypeByCrossSellKey[crossSellTypeByCrossSellKey["Hotels"] = 1] = "Hotels";
        crossSellTypeByCrossSellKey[crossSellTypeByCrossSellKey["CarHire"] = 4] = "CarHire";
        crossSellTypeByCrossSellKey[crossSellTypeByCrossSellKey["Parking"] = 7] = "Parking";
        crossSellTypeByCrossSellKey[crossSellTypeByCrossSellKey["Transfer"] = 3] = "Transfer";
    })(crossSellTypeByCrossSellKey = Core.crossSellTypeByCrossSellKey || (Core.crossSellTypeByCrossSellKey = {}));
    ;
    var CrossSellCommonService = /** @class */ (function () {
        function CrossSellCommonService($http, $location, $window, searchUnitService, dateUtil, $q, occupancyService, $locale, currentUser) {
            this.$http = $http;
            this.$location = $location;
            this.$window = $window;
            this.searchUnitService = searchUnitService;
            this.dateUtil = dateUtil;
            this.$q = $q;
            this.occupancyService = occupancyService;
            this.$locale = $locale;
            this.currentUser = currentUser;
            this.baseUrl = '/api2/crosssell/';
            this.sourceId = 2010;
            this.crossSellsCache = {};
            this.productTypeProperties = {
                Attractions: {
                    CrossSellType: crossSellTypeByCrossSellKey['Attractions'],
                    ProductType: productTypeByCrossSellKey['Attractions'],
                    Icon: 'icon-attractions',
                    Code: 'ATTRACTIONS'
                },
                Hotels: {
                    CrossSellType: crossSellTypeByCrossSellKey['Hotels'],
                    ProductType: productTypeByCrossSellKey['Hotels'],
                    Icon: 'icon-hotels',
                    Code: 'HOTELS'
                },
                CarHire: {
                    CrossSellType: crossSellTypeByCrossSellKey['CarHire'],
                    ProductType: productTypeByCrossSellKey['CarHire'],
                    Icon: 'icon-car-hire',
                    Code: 'CARHIRE'
                },
                Parking: {
                    CrossSellType: crossSellTypeByCrossSellKey['Parking'],
                    ProductType: productTypeByCrossSellKey['Parking'],
                    Icon: 'icon-parking',
                    Code: 'PARKING'
                },
                Transfer: {
                    CrossSellType: crossSellTypeByCrossSellKey['Transfer'],
                    ProductType: productTypeByCrossSellKey['Transfer'],
                    Icon: 'icon-transfers',
                    Code: 'TRANSFERS'
                }
            };
        }
        CrossSellCommonService.prototype.getBookingCrossSell = function (bookingId) {
            var crossSellUrl = this.baseUrl + 'bookingcrosssell/';
            if (this.currentUser.get() && this.currentUser.get().AnonSignedIn) {
                crossSellUrl = this.baseUrl + 'bookingcrosssell/linked/';
            }
            return this.$http.get(crossSellUrl
                + this.sourceId + '/'
                + bookingId + '/'
                + TRPCONFIG.Domain.DomainId, { ignoreErrors: true }).catch(_.noop);
        };
        CrossSellCommonService.prototype._trackCrossSell = function (bookingId, productType) {
            return this.$http.get(this.baseUrl
                + 'trackcrosssell/'
                + this.sourceId + '/'
                + bookingId + '/'
                + TRPCONFIG.Domain.DomainId + '/'
                + productType, { ignoreErrors: true });
        };
        CrossSellCommonService.prototype.getBasketCrossSell = function (basketId) {
            return this.$http.get(this.baseUrl
                + 'basketcrosssells/'
                + TRPCONFIG.Domain.DomainId + '/'
                + TRPCONFIG.ApplicationType + '/'
                + basketId, { ignoreErrors: true }).then(function (res) {
                return res.data.Predictions;
            });
        };
        CrossSellCommonService.prototype.getTripCrossSell = function (tr, getBookingCrossSell) {
            var _this = this;
            var isCurrent = this.dateUtil.compareDates(tr.EndDate, this.dateUtil.todayPlus(-1, 0, true)) === 1;
            if (TRPCONFIG.Domain.DashboardCrossSellEnabled &&
                isCurrent &&
                tr.Bookings) {
                if (this.crossSellsCache[tr.TripId]) {
                    return this.$q.when(this.crossSellsCache[tr.TripId]);
                }
                var booking = _.find(tr.Bookings, function (b) { return b.Status !== BookingStatus.Canceled; });
                if (booking && booking.BookingId && getBookingCrossSell) {
                    return getBookingCrossSell(booking.BookingId).then(function (cs) {
                        _this.crossSellsCache[tr.TripId] = cs;
                        return cs;
                    });
                }
                return this.$q.when();
            }
            return this.$q.when();
        };
        CrossSellCommonService.prototype.startCrossSellJourney = function (bookingId, crossSellProduct) {
            var _this = this;
            this._trackCrossSell(bookingId, crossSellProduct.ProductType);
            switch (crossSellProduct.CrossSellType) {
                case CrossSellType.Transfers:
                    var direction;
                    if (crossSellProduct.ReturnDate && crossSellProduct.ArrivalDate) {
                        direction = 1;
                    }
                    else if (crossSellProduct.ArrivalDate) {
                        direction = 2;
                    }
                    else if (crossSellProduct.ReturnDate) {
                        direction = 3;
                    }
                    this.searchUnitService.setDirection(direction);
                    var transferIndex = this.searchUnitService.transfer;
                    this.searchUnitService.endDate(transferIndex, crossSellProduct.ReturnDate || null);
                    this.searchUnitService.startDate(transferIndex, crossSellProduct.ArrivalDate || null);
                    this.searchUnitService.setDestinationAirport({
                        Title: crossSellProduct.AirportName,
                        Code: crossSellProduct.AirportCode
                    });
                    this.searchUnitService.setResort({
                        Type: 5,
                        Code: crossSellProduct.ResortLocationId,
                        Description: crossSellProduct.DestinationResort
                    });
                    this.occupancyService.setOccupancy([{
                            Adults: crossSellProduct.Adults,
                            ChildAges: crossSellProduct.ChildAges
                        }]);
                    this.$location.path('transfers').search('source', 'MYB cross-sell');
                    break;
                case CrossSellType.CarHire:
                    this.$window.location = TRPCONFIG.Domain.CarHireCrossSellUrl + '/book?' + $.param({
                        pickupDateTime: crossSellProduct.PickUpDate,
                        returnDateTime: crossSellProduct.DropOffDate,
                        pickupIATACode: crossSellProduct.AirportCode,
                        returnIATACode: crossSellProduct.AirportCode,
                        age: crossSellProduct.DriverAge,
                        residencyId: this.$locale.id.split('-')[1]
                    });
                    break;
                case CrossSellType.Attractions:
                    this.$window.location = TRPCONFIG.DesktopUrlRoot
                        + '/Attractions/ProductView.aspx?PIV='
                        + crossSellProduct.ProductViewId;
                    break;
                case CrossSellType.Hotels:
                    var hotelIndex = this.searchUnitService.hotel;
                    this.searchUnitService.endDate(hotelIndex, crossSellProduct.CheckOutDate || null);
                    this.searchUnitService.startDate(hotelIndex, crossSellProduct.CheckInDate || null);
                    //We should not go to the availability page directly, take the user to the landing page.
                    this.$location.path(crossSellProduct.Url).search('source', 'MYB cross-sell');
                    break;
                case CrossSellType.Parking:
                    var promise = this.searchUnitService.getAirport(crossSellProduct.AirportCode);
                    var parkingIndex = this.searchUnitService.parking;
                    this.searchUnitService.startDate(parkingIndex, crossSellProduct.DepartureDate || null);
                    this.searchUnitService.endDate(parkingIndex, crossSellProduct.ReturnDate || null);
                    this.occupancyService.setPassengerCount(crossSellProduct.PassengerCount);
                    promise.then(function (airport) {
                        _this.searchUnitService.setDepartureAirports(airport);
                        _this.$location.path('parking').search('source', 'MYB cross-sell');
                    });
            }
        };
        return CrossSellCommonService;
    }());
    Core.CrossSellCommonService = CrossSellCommonService;
    angular
        .module('core')
        .service('crossSellCommonService', CrossSellCommonService);
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Customer;
    (function (Customer) {
        var CrossSellType = Core.Booking.CrossSellType;
        var TripStage = Core.ManageBooking.TripStage;
        angular
            .module('core')
            .service('customerDashboardService', CustomerDashboardService);
        function CustomerDashboardService($http, $q, $interpolate, $rootScope, flightSearch, hotelService, imageService, destinationService, crossSellCommonService, flightExtrasService, bookingActionLink, hotelRehydrator, savedSearchService, searchTypesService, recentHotels, bookingsManagerService, analytics) {
            var service = {
                rehydrateHotelForHotelCard: rehydrateHotelForHotelCard,
                getRecentSearches: getRecentSearches,
                getLastViewedHotel: getLastViewedHotel,
                getAllCrossSellOptions: getAllCrossSellOptions,
                getTemplateForDashboard: getTemplateForDashboard,
                getTemplateForPlaceholder: getTemplateForPlaceholder,
                trackDashboardLoad: trackDashboardLoad,
                trackDashboardClick: trackDashboardClick,
                getDestinationExcludingSearch: getDestinationExcludingSearch
            };
            function getAllCrossSellOptions(bookingId) {
                var promises = [];
                promises.push(crossSellCommonService.getBookingCrossSell(bookingId));
                promises.push(flightExtrasService.getExtrasCrossSell(bookingId));
                var crossSellOptions = [];
                var hotelPromise = $q.when();
                return $q.all(promises).then(function (_a) {
                    var crossSells = _a[0], flightExtras = _a[1];
                    if (crossSells && crossSells.data) {
                        _.forOwn(crossSells.data, function (product, key) {
                            if (product && (key !== 'Priorities')) {
                                // build cross sell option
                                var type = Core.crossSellTypeByCrossSellKey[key], minPrice = 0, imageUrl = '', title = '';
                                // this is the original product (required for onward journey to remain compatible with MYB)
                                product.CrossSellType = type;
                                if (type === CrossSellType.CarHire ||
                                    type === CrossSellType.Parking ||
                                    type === CrossSellType.Transfers) {
                                    // use cheapest option
                                    minPrice = _.minBy(product.CrossSells, function (cs) { return cs.Price.Value; }).Price.Value;
                                }
                                if (type === CrossSellType.Attractions) {
                                    // use first attraction option
                                    var cs = _.head(product.CrossSells);
                                    minPrice = cs.AdultPrice.Value;
                                    imageUrl = "/attractions/Handlers/crosssellimage.ashx?acsid=" + cs.Id;
                                    title = cs.Title;
                                }
                                if (type === CrossSellType.Hotels) {
                                    // use first hotel option
                                    var cs = _.head(product.CrossSells);
                                    // we need to get additional hotel info before we return the cross sells
                                    hotelPromise = rehydrateHotelForHotelCard(cs.EstabId);
                                    return; //we will add this in after the promise completes as it is a different structure
                                }
                                crossSellOptions.push(new Customer.CrossSellProductOption(bookingId, type, product.CrossSellType === CrossSellType.Transfers
                                    || product.CrossSellType === CrossSellType.Attractions, minPrice, imageUrl, product, title));
                            }
                        });
                        // build cross sell options for flight extras
                        _.forEach(flightExtras, function (extra) {
                            crossSellOptions.push(new Customer.CrossSellFlightExtraOption(bookingId, extra.CrossSellType, true, extra.Price.Value, $interpolate(bookingActionLink.get()[extra.Name])(_.pick(extra, 'BookingId'))));
                        });
                        return hotelPromise.then(function (hotel) {
                            if (hotel) {
                                var product = crossSells.data.Hotels;
                                var cs = _.find(product.CrossSells, { 'EstabId': hotel.Id });
                                product.Url = cs.Url; // use hotel landing page Url
                                crossSellOptions.push(new Customer.CrossSellHotelOption(bookingId, CrossSellType.Hotels, false, cs.Price.Value, '', product, hotel.Title, hotel));
                            }
                            return crossSellOptions;
                        });
                    }
                });
            }
            function getRecentSearches(max) {
                // Restrict search types to Hotels/Holidays/Flights
                var searchTypes = [
                    searchTypesService.searchType.Flight,
                    searchTypesService.searchType.Hotels,
                    searchTypesService.searchType.Holidays
                ];
                return savedSearchService.getSavedSearches(searchTypes).then(function (searches) {
                    return _.take(searches, max);
                });
            }
            function getLastViewedHotel() {
                return recentHotels.getIds().then(function (ids) {
                    return ids.length > 0 ? rehydrateHotelForHotelCard(ids[0]) : $q.when();
                });
            }
            function rehydrateHotelForHotelCard(estabId) {
                return hotelRehydrator.hotels([estabId], {
                    fields: [
                        'Id',
                        'Title',
                        'Province',
                        'Country',
                        'StarRating',
                        'CustomerRating',
                        'CustomerRatingTitle',
                        'CustomerRatingCount',
                        'Url',
                        'IndicativeMinPrice'
                    ],
                    imageWidth: TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize,
                    imageHeight: TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize
                }).then(function (hotels) {
                    return hotels[0];
                });
            }
            function getTemplateForDashboard(trip) {
                var templateSuffix = trip
                    ? TripStage[trip.TripStage]
                    : 'NoTrip';
                return "partials/customer/CustomerDashboard" + templateSuffix;
            }
            function getTemplateForPlaceholder(type) {
                return "partials/customer/Placeholder" + Customer.DashboardTileType[type];
            }
            function trackDashboardLoad(trip, tiles) {
                var tripData = trip
                    ? {
                        MainBookingId: trip.MainBookingId,
                        TripStage: TripStage[trip.TripStage],
                        HasFlight: trip.FlightBooking ? true : false,
                        HasHotel: trip.HotelBooking ? true : false,
                        HasTransfer: trip.TransferBooking ? true : false,
                        HasCarHire: trip.CarHireBooking ? true : false,
                        HasAttractions: trip.AttractionsBooking ? true : false,
                        HasParking: trip.AirportParkingBooking ? true : false,
                        HasInsurance: trip.InsuranceBooking ? true : false
                    }
                    : null;
                var data = {
                    SignedIn: $rootScope.user.SignedIn,
                    Trip: tripData,
                    Tiles: _.mapValues(tiles, function (type) {
                        return Customer.DashboardTileType[type];
                    })
                };
                analytics.track('mixpanel', 'CustomerDashboardLoad', data);
            }
            function trackDashboardClick(position, type) {
                var data = {
                    position: position,
                    type: Customer.DashboardTileType[type]
                };
                analytics.track('mixpanel', 'CustomerDashboardClick', data);
            }
            function getDestinationExcludingSearch(search, destinations) {
                var searchDestination = _.get(search, 'DisplayDetails.Destinations[0]');
                if (!searchDestination && destinations) {
                    return destinations[0];
                }
                // return the first destination which doesn't match the destination of the search
                return _.find(destinations, function (dest) {
                    return dest.Id !== searchDestination.Id && dest.Type !== searchDestination.Type;
                });
            }
            return service;
        }
    })(Customer = Core.Customer || (Core.Customer = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    angular
        .module('core')
        .config(function ($provide, $httpProvider) {
        $provide.factory('domainIdHeaderInterceptor', function () { return ({
            request: function (config) {
                if (config && config.headers) {
                    config.headers['x-domain-id'] = TRPCONFIG.Domain.DomainId;
                }
                return config;
            }
        }); });
        if ($httpProvider.interceptors.indexOf('domainIdHeaderInterceptor') < 0) {
            $httpProvider.interceptors.push('domainIdHeaderInterceptor');
        }
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var DTCM_FLAGS = {
        LANDING_PAGE: 'landingPage',
        HOTEL_SEARCH_PAGE: 'hotelSearchPage',
        HOTEL_SELECTED_PAGE: 'hotelSelectedPage',
        BOOKING_OPTIONS_PAGE: 'bookingOptionsPage',
        PAYMENT_DETAILS_PAGE: 'paymentDetailsPage',
        BOOKING_COMPLETE_PAGE: 'bookingCompletePage'
    };
    var DtcmService = /** @class */ (function () {
        function DtcmService() {
            this.flags = [];
            this.flags = DtcmService.getFlags();
        }
        DtcmService.prototype.isEnabledFlag = function (flagName) {
            return this.flags.indexOf(flagName) !== -1;
        };
        ;
        DtcmService.getFlags = function () {
            if (TRPCONFIG.Domain && TRPCONFIG.Domain.DTCMTrackingFlags instanceof Array) {
                return TRPCONFIG.Domain.DTCMTrackingFlags.map(function (flagName) { return flagName.trim(); });
            }
            return [];
        };
        ;
        DtcmService.prototype.getTrackingId = function () {
            return TRPCONFIG.Domain.DTCMTrackingId;
        };
        return DtcmService;
    }());
    Core.DtcmService = DtcmService;
    angular
        .module('core')
        .constant('DTCM_FLAGS', DTCM_FLAGS)
        .service('dtcmService', DtcmService);
})(Core || (Core = {}));
var Core;
(function (Core) {
    function fidParser($location) {
        return {
            parse: function () {
                var fid = $location.search().fid;
                if (!fid && (TRPCONFIG.Domain.UseIdBasedUrls)) {
                    var path = ($location.path() || '').match(/(?:\d+-\d+-\d+-)(\d+)/);
                    if (path && path[1]) {
                        fid = path[1];
                    }
                }
                fid = fid === '0' || fid === 0 ? null : fid;
                return fid == null ? null : _.toNumber(fid);
            }
        };
    }
    angular
        .module('core')
        .service('fidParser', fidParser);
})(Core || (Core = {}));
var Core;
(function (Core) {
    var FieldType;
    (function (FieldType) {
        FieldType[FieldType["Global"] = 0] = "Global";
        FieldType[FieldType["Titles"] = 1] = "Titles";
        FieldType[FieldType["IndicativePrice"] = 2] = "IndicativePrice";
        FieldType[FieldType["ReviewSnippets"] = 3] = "ReviewSnippets";
        FieldType[FieldType["Description"] = 4] = "Description";
        FieldType[FieldType["UrgencyMessaging"] = 5] = "UrgencyMessaging";
        FieldType[FieldType["Url"] = 6] = "Url";
        FieldType[FieldType["Summary"] = 7] = "Summary";
        FieldType[FieldType["Characteristics"] = 8] = "Characteristics";
        FieldType[FieldType["Distances"] = 9] = "Distances";
        FieldType[FieldType["Facilities"] = 10] = "Facilities";
        FieldType[FieldType["Destinations"] = 11] = "Destinations";
        FieldType[FieldType["EstabGroupIds"] = 12] = "EstabGroupIds";
        FieldType[FieldType["RoomNightsBooked"] = 13] = "RoomNightsBooked";
        FieldType[FieldType["LegacyFacilities"] = 14] = "LegacyFacilities";
        FieldType[FieldType["RoomDetails"] = 15] = "RoomDetails";
        FieldType[FieldType["Pricing"] = 16] = "Pricing";
        FieldType[FieldType["RoomAvailability"] = 17] = "RoomAvailability";
        FieldType[FieldType["HolidayDeals"] = 18] = "HolidayDeals";
        FieldType[FieldType["Airports"] = 19] = "Airports";
        FieldType[FieldType["Weather"] = 20] = "Weather";
        FieldType[FieldType["Recommendations"] = 21] = "Recommendations";
        FieldType[FieldType["TransferTimes"] = 22] = "TransferTimes";
        FieldType[FieldType["UserClicks"] = 23] = "UserClicks";
        FieldType[FieldType["UserBookings"] = 24] = "UserBookings";
        FieldType[FieldType["AltTitles"] = 25] = "AltTitles";
        FieldType[FieldType["HotelDeals"] = 26] = "HotelDeals";
        FieldType[FieldType["HotelAwards"] = 27] = "HotelAwards";
    })(FieldType = Core.FieldType || (Core.FieldType = {}));
    ;
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .factory('funcUtil', funcUtil);
    function funcUtil($timeout, $q, $rootScope) {
        var service = {
            memoize: memoize,
            debounce: debounce,
            waitForValue: waitForValue,
            compose: compose
        };
        function has(obj, key) {
            return obj != null && obj.hasOwnProperty(key);
        }
        function memoize(func, hasher) {
            var m = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var key = args[0];
                var cache = m.cache;
                var address = "" + (hasher ? hasher.apply(void 0, args) : key);
                if (!has(cache, address)) {
                    cache[address] = func.apply(void 0, args);
                }
                return cache[address];
            };
            m.cache = {};
            return m;
        }
        function compose() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return function (x) {
                var retVal = x;
                for (var i = args.length - 1; i >= 0; i--) {
                    retVal = args[i](retVal);
                }
                return retVal;
            };
        }
        /* This is a little bit tricksy in that you call debounce and it *returns* you the function
           that you want to debounce. */
        function debounce(fn, delay) {
            var timer;
            return function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (timer != null) {
                    $timeout.cancel(timer);
                }
                timer = $timeout(function () {
                    fn.apply(_this, args);
                }, delay);
            };
        }
        function waitForValue(factory) {
            var initalValue = factory();
            if (initalValue) {
                return $q.when(initalValue);
            }
            var defered = $q.defer();
            var watch = $rootScope.$watch(factory, function (val) {
                if (val) {
                    watch();
                    defered.resolve(val);
                }
            });
            return defered.promise;
        }
        return service;
    }
})();
var Core;
(function (Core) {
    var Hotels;
    (function (Hotels) {
        /*
         Describes services for a single hotel e.g. hotel information and reviews
         */
        angular
            .module('core')
            .service('hotelService', hotelService);
        function hotelService(hotelFromSession, $filter, $http, $q, imageService, broker, $cacheFactory, tripService, $routeParams, fieldGroupService, cmsService) {
            var domain = TRPCONFIG.Domain;
            var url = '/api/hotels/';
            var hotelInfoCache = $cacheFactory('hotelInfoCache');
            var promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');
            var service = {
                getUrl: getUrl,
                getHotelDetails: getHotelDetails,
                //This is used to rehydrate the basket's hotel product
                rehydrate: rehydrate,
                getHotel: getHotel,
                trackHotelClick: trackHotelClick,
                getPaginationMode: getPaginationMode,
                getSimilarHotels: getSimilarHotels
            };
            var fieldFlags = fieldGroupService.getFieldGroup(Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.IndicativePrice, Core.FieldType.ReviewSnippets, Core.FieldType.Description, Core.FieldType.Url, Core.FieldType.Summary, Core.FieldType.Characteristics, Core.FieldType.Distances, Core.FieldType.Facilities, Core.FieldType.RoomDetails, Core.FieldType.LegacyFacilities, Core.FieldType.Recommendations, Core.FieldType.EstabGroupIds, Core.FieldType.Airports, Core.FieldType.AltTitles, Core.FieldType.HotelAwards);
            var fieldTypes = fieldGroupService.getFieldGroup(Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.Url, Core.FieldType.EstabGroupIds);
            function getUrl() {
                return url;
            }
            function getHotelDetails(req) {
                return $http.post(url + 'details/getdetails', req, {
                    customErrCallback: function () {
                        broker.publish('hotelDetailCallFailed', req);
                        return true;
                    }
                }).then(function (res) {
                    return res.data;
                });
            }
            function rehydrate(detailsId) {
                if (!promiseCache.get(detailsId)) {
                    promiseCache.put(detailsId, $http.post(url + 'details/getdetailsbyid', { DetailsId: detailsId })
                        .then(function (res) {
                        return service.getHotel(null, res.data.Itinerary.EstabId, $routeParams.tripId)
                            .then(function (h) {
                            return angular.extend({}, h, res.data);
                        });
                    }));
                }
                return promiseCache.get(detailsId);
            }
            function getHotel(searchId, estabId, tripId) {
                var promises = [];
                if (searchId && tripId) {
                    promises.push(hotelFromSession.getHotel(searchId, estabId, tripId));
                }
                else {
                    promises.push(hotelInfoCache.get(String(estabId)) ||
                        $http.get(url + 'static/gethotel', {
                            params: {
                                fieldsX: 'MinCost,OriginalCost',
                                Id: estabId,
                                CultureCode: domain.CultureCode,
                                DomainId: domain.DomainId,
                                FieldFlags: fieldFlags
                            },
                            cache: true
                        }));
                }
                promises.push(tripId ? tripService.getCurrency(tripId) : $q.when());
                if (TRPCONFIG.Domain.OverrideHotelInformationFromCms) {
                    promises.push(cmsService.getHotelInformation(estabId));
                }
                return $q.all(promises)
                    .then(function (results) {
                    var hotel = _.assign({}, results[0].data || results[0]);
                    var currency = results[1] || TRPCONFIG.Domain.CurrencyCode;
                    var cmsHotelInformation = results[2];
                    hotelInfoCache.put(String(estabId), hotel);
                    hotel.ImageUrl = imageService.getMainImageUrl(estabId, TRPCONFIG.DeviceSettings.HotelDetailImageSize, TRPCONFIG.DeviceSettings.HotelDetailImageSize, true);
                    hotel.ObjectTypeId = 1;
                    hotel.TeaserStr = $filter('roundedCurrency')(hotel.IndicativeMinPrice, currency);
                    hotel.HasReviewSnippets = !_.isEmpty(hotel.ReviewSnippets);
                    if (cmsHotelInformation) {
                        hotel.HotelName = cmsHotelInformation.HotelName;
                        hotel.Address = cmsHotelInformation.Address;
                        var imageList = _.get(cmsHotelInformation, 'ImageUrls', []);
                        if (imageList && imageList.length > 0) {
                            imageList = imageList.filter(function (e) {
                                if (e != null) {
                                    return e;
                                }
                            });
                        }
                        hotel.CmsImageUrls = imageList && imageList.length > 0 ? imageList : null;
                        hotel.Description = cmsHotelInformation.ReplaceDefaultDescription ?
                            cmsHotelInformation.Description :
                            hotel.Description + cmsHotelInformation.Description;
                        hotel.IsPlatinumHotel = cmsHotelInformation.IsPlatinumHotel;
                        hotel.HideFacilitiesList = cmsHotelInformation.HideFacilitiesList;
                        hotel.HideRoomFacilitiesList = cmsHotelInformation.HideRoomFacilitiesList;
                        hotel.IsBoutiqueHotel = cmsHotelInformation.IsBoutiqueHotel;
                        hotel.IsDsfHotel = cmsHotelInformation.IsDsfHotel;
                    }
                    //various other bits of code assume that the rooms array will always exist
                    if (hotel.Rooms == null) {
                        hotel.Rooms = [];
                    }
                    return hotel;
                });
            }
            function trackHotelClick(estabId, hotelIndex, boostReason, sortCriterion, searchId) {
                $http.post('/api/useractions/selections', {
                    Type: 2,
                    EstabId: estabId,
                    DomainId: _.get(TRPCONFIG, 'Domain.DomainId'),
                    SearchResultsIndex: hotelIndex,
                    SortCriterion: sortCriterion,
                    BoostReason: boostReason,
                    SearchId: searchId
                }, { ignoreErrors: true });
            }
            function getSimilarHotels(estabId) {
                return __awaiter(this, void 0, void 0, function () {
                    var config, response, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                config = {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        EstabId: estabId,
                                        CultureCode: TRPCONFIG.Domain.CultureCode,
                                        CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                                        DomainId: TRPCONFIG.Domain.DomainId,
                                        Radius: 10,
                                        ResultsToTakeFromNearestHotels: 3,
                                        ResultsToTakeFromSeoRanking: 3,
                                        FieldFlags: fieldTypes,
                                        FilterCriteria: {
                                            Stars: [3, 4, 5],
                                            MinNumberOfRatings: 1,
                                            OnlyShowAvailable: true
                                        },
                                        PageStrand: 1
                                    })
                                };
                                return [4 /*yield*/, fetch('/api/hotels/static/gethotelalternatives', config)];
                            case 1:
                                response = _a.sent();
                                if (!response.ok) {
                                    throw Error(response.statusText);
                                }
                                return [4 /*yield*/, response.json()];
                            case 2:
                                data = _a.sent();
                                return [2 /*return*/, data || []];
                        }
                    });
                });
            }
            function getPaginationMode(destinationId) {
                if (domain.PagingDisabled) {
                    return domain.PagingDisabledForDestinations.find(function (id) { return id === destinationId; });
                }
                return false;
            }
            return service;
        }
    })(Hotels = Core.Hotels || (Core.Hotels = {}));
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Hotels;
    (function (Hotels) {
        angular.module('core')
            .service('hotelFromSession', hotelFromSession);
        /*
         This exists to retrieve a single hotel's availability results from the cache.
         It is used by the map directive for showing information windows and is also used
         by the hotel page when in search mode. Calls are cached for the duration of a user's
         session
         */
        function hotelFromSession($filter, $location, $http, $cacheFactory, $q, imageService, $injector, $timeout, tripService, fieldGroupService, loggingService, occupancyService, analyticsTracker) {
            var cache = $cacheFactory('hotelfromSessionCache');
            var service = {
                getHotel: getHotel,
                getRoomTypes: getRoomTypes
            };
            var fieldFlags = fieldGroupService.getFieldGroup(Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.IndicativePrice, Core.FieldType.ReviewSnippets, Core.FieldType.Description, Core.FieldType.Url, Core.FieldType.Summary, Core.FieldType.Characteristics, Core.FieldType.Distances, Core.FieldType.Facilities, Core.FieldType.LegacyFacilities, Core.FieldType.RoomDetails, Core.FieldType.Pricing, Core.FieldType.RoomAvailability, Core.FieldType.Recommendations, Core.FieldType.EstabGroupIds, Core.FieldType.Airports, Core.FieldType.HotelAwards);
            function getHotel(searchId, estabId, tripId) {
                return _getHotelFromSession(searchId, estabId, tripId);
            }
            function getRoomTypes(estabId, searchId, boardTypeFilter) {
                var url = '/api/hotels/availability/gethotel';
                var flags = fieldGroupService.getFieldGroup(Core.FieldType.RoomAvailability, Core.FieldType.RoomDetails, Core.FieldType.LegacyFacilities);
                var request = {
                    Id: estabId,
                    AvailabilitySearchId: searchId,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                    DomainId: TRPCONFIG.Domain.DomainId,
                    FieldFlags: flags
                };
                return $http.post(url, request)
                    .then(function (res) { return res.data; })
                    .then(function (res) {
                    if (!res || !res.RequestedRooms) {
                        return [];
                    }
                    return res.RequestedRooms[0].Availability.map(function (r) {
                        _.assignIn(r, {
                            RoomDetails: _.find(res.RoomDetails, function (rd) { return rd.MasterId === r.MasterId; })
                        });
                        var uniqBoardTypes = {};
                        r.BoardOptions.forEach(function (bt) {
                            var current = uniqBoardTypes[bt.BoardType];
                            // is the unique cheapest boardType
                            // is in the filtered boardtypes if defined
                            if ((!current || current.Cost > bt.Cost) &&
                                (!boardTypeFilter.length || boardTypeFilter.indexOf(bt.BoardType) > -1)) {
                                uniqBoardTypes[bt.BoardType] = bt;
                            }
                        });
                        r.BoardOptions = _.values(uniqBoardTypes);
                        return r;
                    }).filter(function (r) { return r.BoardOptions.length > 0; });
                });
            }
            function _createCacheKey(_a) {
                var DiscountCode = _a.DiscountCode, Id = _a.Id, AvailabilitySearchId = _a.AvailabilitySearchId, BoardTypesFilter = _a.BoardTypesFilter;
                return DiscountCode + "," + Id + ", " + AvailabilitySearchId + ", " + BoardTypesFilter.sort().join('');
            }
            function _getHotelFromSession(searchId, estabId, tripId) {
                var hs = $injector.get('hotelSearch'); //this is absolutely fine. Not dodgy at all.
                var url = '/api/hotels/availability/gethotel';
                var request = {
                    Id: estabId,
                    AvailabilitySearchId: searchId,
                    CultureCode: TRPCONFIG.Domain.OverrideAPIHotelsCulture ?
                        TRPCONFIG.Domain.DefaultPosCultureCode : TRPCONFIG.Domain.CultureCode,
                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                    DomainId: TRPCONFIG.Domain.DomainId,
                    EnableTracking: analyticsTracker.isEnabled(),
                    BoardTypesFilter: hs.getFilter().BoardTypes,
                    FieldFlags: fieldFlags,
                    DiscountCode: TRPCONFIG.DiscountCode,
                    TripId: tripId
                };
                var cacheKey = _createCacheKey(request);
                var cachedHotel = cache.get(cacheKey);
                if (cachedHotel) {
                    return $q.when(cachedHotel);
                }
                var d = $q.defer();
                var start = new Date().getTime();
                var interval = 1000;
                var timeout = 60000;
                var goneResponses = 0;
                return $q.all([
                    tripService.getCurrency(tripId),
                    tripService.getHotelsRequestNumberOfNights(tripId),
                    tripService.getTripOccupancy(tripId),
                    tripService.isKidsFree(tripId),
                    tripService.getBoardTypeInclusions()
                ]).then(function (_a) {
                    var c = _a[0], n = _a[1], o = _a[2], k = _a[3], b = _a[4];
                    request.CurrencyCode = c || TRPCONFIG.Domain.CurrencyCode;
                    getResult(c, n, o, k, b);
                    return d.promise;
                });
                function getResult(currency, nights, occupancy, isKidsFree, boardTypeInclusions) {
                    if (isKidsFree === void 0) { isKidsFree = false; }
                    $http.post(url, request, { ignoreErrors: true })
                        .then(_processHotelFactory(d, estabId, cacheKey, currency, nights, occupancy, isKidsFree, boardTypeInclusions), _handleErrors);
                }
                function _handleErrors(res) {
                    switch (res.status) {
                        case 404:
                            return _notFound();
                        case 410:
                            return _gone();
                    }
                    return $q.when();
                }
                function logMissing(code) {
                    tripService.getHotelsRequest(tripId).then(function (req) {
                        loggingService.logWarn(code + " received getting hotel from session for request: \n                        " + (req ? JSON.stringify(req) : null));
                    });
                }
                function _notFound() {
                    var now = new Date().getTime();
                    if (now - start < timeout) {
                        $timeout(getResult, interval); //recurse
                        return $q.reject();
                    }
                    //resolve even in case of no results!
                    logMissing('404');
                    return d.resolve();
                }
                function _gone() {
                    if (goneResponses === 0) {
                        goneResponses += 1;
                        $timeout(getResult, interval); //recurse
                        return $q.reject();
                    }
                    logMissing('410');
                    d.reject();
                    $location.path('hotels/notfound');
                }
            }
            function _processHotelFactory(d, estabId, cacheKey, currency, nights, occupancy, isKidsFree, boardTypeInclusions) {
                if (isKidsFree === void 0) { isKidsFree = false; }
                return function (result) {
                    var hotel;
                    if (result.data != null) {
                        var dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
                        var numPeoplePaying = isKidsFree
                            ? occupancyService.getOnlyPayingIndividuals()
                            : occupancyService.getNumberOfNonInfantPassengers();
                        hotel = _formatHotelData(result.data, occupancy);
                        hotel.ImageUrl = imageService.getMainImageUrl(estabId, dim, dim);
                        hotel.MinCostStr = $filter('roundedCurrency')(hotel.MinCost, currency);
                        hotel.OriginalCostStr = $filter('roundedCurrency')(hotel.OriginalCost, currency);
                        hotel.MinCostPerNight = hotel.MinCost / nights;
                        hotel.MinCostPerPerson = hotel.MinCost / (numPeoplePaying || 1);
                        hotel.MinCostPerPersonPerNight = hotel.MinCostPerPerson / nights;
                        hotel.OriginalCostPerNight = hotel.OriginalCost / nights;
                        hotel.OriginalCostPerPerson = hotel.OriginalCost / (numPeoplePaying || 1);
                        hotel.OriginalCostPerPersonPerNight = hotel.OriginalCostPerPerson / nights;
                        hotel.MinCostStr =
                            $filter('roundedCurrency')(hotel.MinCost, currency);
                        hotel.MinCostPerNightStr =
                            $filter('roundedCurrency')(hotel.MinCostPerNight, currency);
                        hotel.MinCostPerPersonPerNightStr =
                            $filter('roundedCurrency')(hotel.MinCostPerPersonPerNight, currency);
                        hotel.OriginalCostStr =
                            $filter('roundedCurrency')(hotel.OriginalCost, currency);
                        hotel.OriginalCostPerNightStr =
                            $filter('roundedCurrency')(hotel.OriginalCostPerNight, currency);
                        hotel.OriginalCostPerPersonPerNightStr =
                            $filter('roundedCurrency')(hotel.OriginalCostPerPersonPerNight, currency);
                        hotel.LowDepositValue = 0;
                        hotel.IsPayAtHotelOnly = true;
                        hotel.Rooms.filter(function (rr) { return !_.isEmpty(rr.Availability); })
                            .forEach(function (rr, i) {
                            var minRoomDeposit = 0;
                            var cheapest;
                            _.forEach(rr.Availability, function (room) {
                                room.CostPerNight = room.Cost / nights;
                                room.OriginalCostPerNight = room.OriginalCost / nights;
                                if (hotel.IsPayAtHotelOnly && room.IsPayAtHotel === false) {
                                    hotel.IsPayAtHotelOnly = false;
                                }
                                if (room.LowDepositValue
                                    && (!minRoomDeposit || room.LowDepositValue < minRoomDeposit)) {
                                    minRoomDeposit = room.LowDepositValue;
                                }
                                if (!cheapest || cheapest.Cost > room.Cost) {
                                    cheapest = room;
                                }
                                room.InclusionText = getInclusionText(boardTypeInclusions, room.BTInclusions);
                                room.ExclusionText = getInclusionText(boardTypeInclusions, room.BTExclusions);
                            });
                            if (cheapest !== undefined) {
                                cheapest.IsCheapest = true;
                            }
                            if (minRoomDeposit) {
                                hotel.LowDepositValue = hotel.LowDepositValue + minRoomDeposit;
                            }
                        });
                        cache.put(cacheKey, hotel);
                        d.resolve(hotel);
                        return hotel;
                    }
                    d.resolve();
                    return null;
                };
            }
            function getInclusionText(boardTypeInclusions, inclusions) {
                var inclusionText = '';
                if (boardTypeInclusions) {
                    _.forEach(inclusions, function (inclusion) {
                        var boardTypeInclusion = boardTypeInclusions.filter(function (i) { return i.Id === inclusion.InclusionId; });
                        var text = '';
                        if (boardTypeInclusion && boardTypeInclusion.length === 1) {
                            text = boardTypeInclusion[0].Title.replace('{0}', inclusion.ReplacementText);
                            if (inclusionText !== '') {
                                inclusionText = inclusionText + ', ';
                            }
                            inclusionText = inclusionText + text;
                        }
                    });
                }
                return inclusionText;
            }
            function _formatHotelData(data, occupancy) {
                // Convert room data in response to flat list
                var hotel = _.assign({}, data);
                hotel.Rooms = _.map(data.RequestedRooms, function (rr, i) {
                    var availableRoomsList = [];
                    rr.Availability.forEach(function (room) {
                        room.BoardOptions.forEach(function (option) {
                            var ra = _.omit(room, 'BoardOption');
                            availableRoomsList.push(_.assign({}, option, ra));
                        });
                    });
                    return {
                        Title: occupancyService.getOccupancyStringForRoom(i, occupancy),
                        Availability: availableRoomsList
                    };
                });
                return hotel;
            }
            return service;
        }
    })(Hotels = Core.Hotels || (Core.Hotels = {}));
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .factory('paymentsService', PaymentsService);
    function PaymentsService($http, $q, $routeParams, tokeniser, tripService) {
        var _clientServerCardsMap = {};
        var _cardsUrl = '/api2/payments/cards';
        var _userCardUrl = '/api2/payments/cards/customer/';
        var _enbdCardUrl = '/api2/bookings/';
        var payPalResponses = {
            cancel: 'PAYPALCANCELLED',
            fail: 'PAYPALFAILED'
        };
        var enbdOptionId = TRPCONFIG.Domain2.EnbdPaymentOptionId;
        var service = {
            checkCardNumber: checkCardNumber,
            checkCardNumberV2: checkCardNumberV2,
            getScheme: getScheme,
            getCardFromId: getCardFromId,
            getCardTitle: getCardTitle,
            getLogosList: getLogosList,
            addCardDetails: addCardDetails,
            removeCard: removeCard,
            generateTokens: generateTokens,
            getSavedBookingCards: getSavedBookingCards,
            getEmptyPaymentDetails: getEmptyPaymentDetails,
            getPayPalResponseMessage: getPayPalResponseMessage,
            cpgValidation: cpgValidation,
            resendOtpConfirmation: resendOtpConfirmation,
            verifyOtp: verifyOtp
        };
        function getCardFromId(paymentOptions, cardId) {
            for (var i = 0, ii = paymentOptions.length; i < ii; i++) {
                //CardTypeId has been renamed to Id in new API.
                if (paymentOptions[i].CardTypeId === cardId || paymentOptions[i].Id === cardId) {
                    return paymentOptions[i];
                }
            }
        }
        function getScheme(cardNumber) {
            return $http.get(_cardsUrl + "/getscheme?cardNumber=" + cardNumber, { cache: true, ignoreErrors: true });
        }
        function getLogosList(paymentOptions) {
            //Removing getpaymentoptions as it became obsolete
            var logos = {
                amex: ['american express'],
                bitcoin: ['bitcoin'],
                dankort: ['dankort'],
                diners: ['diners card'],
                discover: ['discover'],
                maestro: ['maestro'],
                mastercard: ['mastercard'],
                paypal: ['paypal'],
                visa: ['visa', 'connect'],
                external: ['offline']
            };
            return _.filter(Object.keys(logos), function (key) { return _.some(logos[key], function (cardName) { return _.some(paymentOptions, function (option) { return _.includes(_.toLower(option.Title || option.Name), cardName); }); }); });
        }
        function checkCardNumberV2(paymentOptions, cardNumber, cardType) {
            //To support new payment option structure, not changing the old one
            if (cardNumber != null) {
                cardNumber = cardNumber.replace(/ /g, '').replace(/-/g, '');
            }
            if (TRPCONFIG.Domain.CardNumberCheckEnabled) {
                for (var i = 0, ii = paymentOptions.length; i < ii; i++) {
                    //Check with master card type
                    if (paymentOptions[i].CardType === cardType) {
                        if (paymentOptions[i].FeePercent > 0 || paymentOptions[i].FeeAmount > 0) {
                            return $q.when();
                        }
                    }
                }
            }
            var result = getScheme(cardNumber);
            return result.then(function (res) {
                var actualType = res.data;
                if (actualType !== parseInt(cardType)) {
                    return $q.reject(actualType);
                }
            }, function () {
                return cardType;
            });
        }
        function checkCardNumber(paymentOptions, cardNumber, selectedCardId) {
            if (cardNumber != null) {
                cardNumber = cardNumber.replace(/ /g, '').replace(/-/g, '');
            }
            var result = $q.all([
                _mapPaymentsType(paymentOptions),
                $http.get(_cardsUrl + "/getscheme?cardNumber=" + cardNumber, { cache: true, ignoreErrors: true })
            ]);
            return result.then(function _numberChecker(res) {
                var verifiedClientId = _clientServerCardsMap[res[1].data];
                if (!verifiedClientId) {
                    return;
                }
                if (verifiedClientId !== parseInt(selectedCardId)) {
                    return $q.reject(verifiedClientId);
                }
                else if (verifiedClientId === parseInt(selectedCardId)) {
                    return $q.resolve(verifiedClientId);
                }
            }, function () {
                return selectedCardId;
            });
        }
        function getCardTitle(paymentOptions, cardTypeId) {
            //TODO: CardTypeId, Title needs to be removed once after booking page started using new booking options API.
            for (var i = 0, ii = paymentOptions.length; i < ii; i++) {
                //CardTypeId has been renamed to Id in new API.
                var cardType = paymentOptions[i].CardTypeId || paymentOptions[i].Id;
                if (cardType === cardTypeId) {
                    //Title has been renamed to Name in new API.
                    return paymentOptions[i].Title || paymentOptions[i].Name;
                }
            }
        }
        function _mapPaymentsType(cp) {
            return tripService.getCurrency($routeParams.tripId).then(function (cur) {
                var url = _cardsUrl + "/gettypes" +
                    ("?domainId=" + TRPCONFIG.Domain.DomainId + "&currencyCode=" + (cur || TRPCONFIG.Domain.CurrencyCode));
                return $http.get(url, { cache: true, ignoreErrors: true }).then(function _mergePaymentClientServer(res) {
                    var sp = res.data;
                    for (var i = 0, ii = sp.length; i < ii; i++) {
                        var clientCard = _compareTitle(cp, sp[i].Title);
                        if (clientCard) {
                            _clientServerCardsMap[sp[i].CardType] = clientCard.CardTypeId;
                        }
                    }
                });
            });
        }
        function _compareTitle(paymentOptions, title) {
            for (var j = 0, jj = paymentOptions.length; j < jj; j++) {
                if (paymentOptions[j].Title === title) {
                    return paymentOptions[j];
                }
            }
        }
        function addCardDetails(card, savedFrom) {
            var cardRequest = {
                MasterCardTypeId: card.paymentType,
                Number: card.CardNumber,
                MaskedCardNumber: card.MaskedCardNumber,
                ExpiryMonth: card.ExpiryDate.Month,
                ExpiryYear: card.ExpiryDate.Year,
                SavedFrom: savedFrom
            };
            return $http.post(_userCardUrl + "set", cardRequest, { ignoreErrors: true });
        }
        function removeCard(cardId) {
            return $http.post(_userCardUrl + "remove", { CardId: cardId });
        }
        function getSavedBookingCards(allowedCards) {
            var allBookingTypes = 0;
            return $http.post(_userCardUrl + "getSavedBookingCards", {
                domainId: TRPCONFIG.Domain.DomainId,
                currencyCode: TRPCONFIG.Domain.CurrencyCode,
                bookingTypeId: allBookingTypes // 0 to get cards for all types of booking
            }, { ignoreErrors: true }).then(function (result) {
                var savedCards = result.data;
                if (savedCards.length > 0) {
                    var filteredCardList = _.filter(savedCards, function (c) {
                        return allowedCards[c.CardTypeId] !== undefined;
                    });
                    savedCards = _.map(filteredCardList, function (c) {
                        c.Title = allowedCards[c.CardTypeId].Title;
                        return c;
                    });
                }
                return savedCards;
            }, function () {
                return null;
            });
        }
        function getEmptyPaymentDetails() {
            return {
                PaypalDetails: {
                    //Not part of UserData contract in create booking
                    IsPaypalPayment: false
                },
                CardDetails: {
                    PaymentTypeId: 0,
                    CardType: 0,
                    CardNumber: null,
                    StartDate: {
                        Month: null,
                        Year: null
                    },
                    ExpiryDate: {
                        Month: null,
                        Year: null
                    },
                    SecurityCode: null,
                    IssueNumber: null,
                    CardId: null,
                    IsExpired: false
                },
                SaveThisCard: false
            };
        }
        function getPayPalResponseMessage(key) {
            return payPalResponses[key] || '';
        }
        function generateTokens(expiryMonth, expiryYear, saveCard) {
            //figure out if we need to generate tokens and if there should be an expiry
            //if pci compliant
            var requireTokens = TRPCONFIG.Domain.PCICompliant;
            var expiryDate = saveCard && expiryMonth !== 0 && expiryYear !== 0 ? new Date(expiryYear, expiryMonth) : null;
            if (saveCard && !expiryDate) {
                return $q.when(); //no point tokenising because the form is not valid
            }
            if (requireTokens) {
                return tokeniser.execute(expiryDate ? expiryDate.toISOString() : null);
            }
            return $q.when();
        }
        function cpgValidation(params) {
            var validationRequest = {
                CardNumber: params.cardNumber,
                ClientCurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                CardTypeId: enbdOptionId
            };
            return $http.post(_enbdCardUrl + "validateenbdcardnumber", validationRequest);
        }
        function resendOtpConfirmation(params) {
            var requestParams = {
                SessionToken: params.SessionToken,
                TransactionId: params.TransactionId,
                ClientCurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DomainId: params.domainId,
                CardTypeId: enbdOptionId,
                CardNumber: params.cardNumber
            };
            return $http.post(_enbdCardUrl + "resendotp", requestParams);
        }
        function verifyOtp(params) {
            var requestParams = {
                CardNumber: params.cardNumber,
                ClientCurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DomainId: params.domainId,
                CardTypeId: enbdOptionId,
                SessionToken: params.SessionToken,
                TransactionId: params.TransactionId,
                OTP: params.OTP
            };
            return $http.post(_enbdCardUrl + "verifyotp", requestParams);
        }
        return service;
    }
})();
var Core;
(function (Core) {
    //Our final payment option shape
    var PaymentType;
    (function (PaymentType) {
        PaymentType[PaymentType["CreditCard"] = 1] = "CreditCard";
        PaymentType[PaymentType["DebitCard"] = 2] = "DebitCard";
        PaymentType[PaymentType["PayPal"] = 14] = "PayPal";
    })(PaymentType || (PaymentType = {}));
    ;
})(Core || (Core = {}));
(function () {
    'use strict';
    var inTestingEnvironment = typeof __karma__ !== 'undefined';
    function decorate(service, $provide, $injector) {
        if (!$injector.has(service)) {
            return;
        }
        $provide.decorator(service, ['$delegate', '$q', function ($delegate, $q) {
                var newService = inTestingEnvironment ? $delegate : Object.assign({}, $delegate);
                var _loop_3 = function (fnName) {
                    var fn = $delegate[fnName];
                    newService[fnName] = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var res = fn.apply(void 0, args);
                        return !inTestingEnvironment && res instanceof Promise ? $q.when(res) : res;
                    };
                };
                for (var fnName in $delegate) {
                    _loop_3(fnName);
                }
                return newService;
            }]);
    }
    angular
        .module('TR')
        .config(['$provide', '$injector', function ($provide, $injector) {
            [
                'agentModeService',
                'animationUtil',
                'basketCrossSellService',
                'cmsService',
                'destinationAirport',
                'discountsService',
                'flightDetail',
                'flightSeatPlanService',
                'flightStaticService',
                'globalisationService',
                'googleStaticMap',
                'hotelStaticMapService',
                'languageService',
                'localStorageProvider',
                'loggingService',
                'postcodeService',
                'primaryNavigationService',
                'productService',
                'publicityService',
                'scrollService',
                'urgencyMessaging'
            ].forEach(function (service) { return decorate(service, $provide, $injector); });
        }]);
    angular
        .module('core')
        .config(['$provide', '$injector', function ($provide, $injector) {
            [
                'adHocService',
                'flightsTerminalService'
            ].forEach(function (service) { return decorate(service, $provide, $injector); });
        }]);
})();
var Quote;
(function (Quote) {
    var QuoteService = /** @class */ (function () {
        function QuoteService($http, $window, broker, $q, dateUtil, basketStore, localStorageProvider) {
            this.$http = $http;
            this.$window = $window;
            this.broker = broker;
            this.$q = $q;
            this.dateUtil = dateUtil;
            this.basketStore = basketStore;
            this.localStorageProvider = localStorageProvider;
            this.url = '/api2/quotes/';
            this.basketQuote = {};
            this.cachedQuoteSearch = null;
            this.domain = $window.TRPCONFIG.Domain;
        }
        QuoteService.prototype.setTrackingTag = function (tag) {
            return this.localStorageProvider.setItem('trackingTag', tag);
        };
        QuoteService.prototype.getTrackingTag = function (cb) {
            return this.localStorageProvider.getItem('trackingTag', function (error, value) { return cb(value); });
        };
        QuoteService.prototype.removeTrackingTag = function () {
            return this.localStorageProvider.removeItem('trackingTag');
        };
        QuoteService.prototype.getQuoteByReference = function (quoteRef) {
            return this.$http.get(this.url + 'getbyreference' + '?reference=' + quoteRef + '&domainId=' +
                this.domain.DomainId, { ignoreErrors: true }).then(function (res) {
                return res.data;
            });
        };
        QuoteService.prototype.refreshQuote = function (quoteId, productIds) {
            var _this = this;
            return this.$http.post(this.url + 'refreshproducts', { QuoteId: quoteId, ProductIds: productIds }, { ignoreErrors: true }).then(function (res) {
                _this.basketStore.destroyBasket();
                TRPCONFIG.BasketId = res.data.BasketId;
                _this.broker.publish('quoteLoadedToBasket');
                return res.data;
            }, function (res) {
                return { Error: res.data };
            });
        };
        QuoteService.prototype.createQuote = function (basketId, sharedUseFlag, cache) {
            var _this = this;
            if (cache === void 0) { cache = true; }
            if (this.basketQuote[basketId]) {
                return this.basketQuote[basketId];
            }
            return this.$q(function (res, rej) {
                _this.getTrackingTag(function (value) {
                    var params = {
                        BasketId: basketId,
                        SharedUse: sharedUseFlag,
                        QuoteId: '',
                        TrackingTag: value
                    };
                    res(_this.create(params, cache));
                });
            });
        };
        QuoteService.prototype.create = function (params, cache) {
            var _this = this;
            if (cache === void 0) { cache = true; }
            params.DomainId = params.DomainId || this.domain.DomainId;
            params.CultureCode = params.CultureCode || this.domain.CultureCode;
            this.basketQuote[params.BasketId || ''] = this.$http.post(this.url + 'create', params, {
                cache: cache,
                ignoreErrors: true
            }).then(function (res) {
                _this.removeTrackingTag();
                return res.data;
            }, function (res) {
                return { Error: res.data };
            });
            return this.basketQuote[params.BasketId || ''];
        };
        QuoteService.prototype.get = function (quoteId) {
            return this.$http.get(this.url + 'get' + '?quoteId=' + quoteId, { cache: true, ignoreErrors: true }).then(function (res) {
                return res.data;
            });
        };
        QuoteService.prototype.replaceProduct = function (quoteId, productId, replacementId) {
            return this.$http.post(this.url + 'replaceproduct', {
                QuoteId: quoteId,
                ProductId: productId,
                ReplacementId: replacementId
            }, { ignoreErrors: true }).then(function (res) {
                return res.data;
            });
        };
        QuoteService.prototype.addBookings = function (quoteId, bookingIds) {
            return this.$http.post(this.url + 'addbookings', {
                QuoteId: quoteId,
                BookingIds: bookingIds
            }, { ignoreErrors: true }).then(function (res) {
                return res.data;
            }, function () {
                return true;
            });
        };
        QuoteService.prototype.linkQuote = function (bookingReferences, quoteId) {
            if (quoteId) {
                var bookingIds = bookingReferences.map(function (ref) {
                    return parseInt(ref.replace(/[^0-9]/gi, ''), 10);
                });
                return this.addBookings(quoteId, bookingIds);
            }
            else {
                return this.$q.when({});
            }
        };
        QuoteService.prototype.addNote = function (quoteId, noteText) {
            var _this = this;
            return this.$http.post(this.url + 'addnote', { QuoteId: quoteId, NoteText: noteText }, { ignoreErrors: true })
                .then(function (res) {
                return res.data;
            }, function () {
                return _this.$q.when({});
            });
        };
        QuoteService.prototype.validateSearchModel = function (model) {
            var _this = this;
            var empty = function (v) { return !_.toString(v); };
            var today = this.dateUtil.todayPlus(0, 0, true);
            var isDatesAreInRange = function (start, end) {
                return !empty(start) && !empty(end) && _this.dateUtil.dayDiff(start, end) <= 30;
            };
            var isQuotedByDatesAreInRange = function (start, end) {
                return (!empty(start) && _this.dateUtil.dayDiff(start, today) <= 30)
                    || isDatesAreInRange(start, end);
            };
            return empty(model.quoteRef)
                && !isQuotedByDatesAreInRange(model.from, model.to)
                && empty(model.quotedById)
                && empty(model.userId)
                && empty(model.destination)
                && empty(model.externalAgentId)
                && empty(model.hotelName);
        };
        QuoteService.prototype.search = function (request) {
            var _this = this;
            this.cachedQuoteSearch = null;
            return this.validateSearchModel(request)
                ? this.$q.reject({ status: 400 })
                : this.$http.get(this.url + 'search?' + $.param(request), { ignoreErrors: true }).then(function (res) {
                    _this.cachedQuoteSearch = {
                        searchModel: request,
                        searchResponse: res.data
                    };
                    return res.data;
                });
        };
        QuoteService.prototype.getCachedSearch = function () {
            return this.cachedQuoteSearch;
        };
        QuoteService.prototype.getTravelAgentNameForQuote = function (quote) {
            if (quote && (quote.TravelAgentFirstName || quote.TravelAgentLastName)) {
                return [quote.TravelAgentTitle, quote.TravelAgentFirstName, quote.TravelAgentLastName]
                    .filter(function (i) { return null != i; }).join(' ');
            }
            return null;
        };
        QuoteService.prototype.getCustomerNameForQuote = function (quote, contact) {
            if (contact) {
                return contact.Title + " " + contact.FirstName + " " + contact.LastName;
            }
            else if (quote && quote.CustomerFirstName && quote.CustomerLastName) {
                return quote.CustomerFirstName + " " + quote.CustomerLastName;
            }
            return null;
        };
        QuoteService.prototype.getCustomerEmailForQuote = function (quote, contact) {
            if (contact && contact.Email) {
                return contact.Email;
            }
            else if (quote && quote.CustomerEmailAddress) {
                return quote.CustomerEmailAddress;
            }
            return null;
        };
        QuoteService.prototype.getCustomerPhoneNumberForQuote = function (contact) {
            return contact && (contact.MobileTel || contact.HomeTel || contact.Phone || contact.CustomerPhoneNumber);
        };
        QuoteService.prototype.getCustomerSkywardNumberForQuote = function (data) {
            if (data && (data.CustomerLoyaltyNumber || data.LoyaltyId)) {
                return data.CustomerLoyaltyNumber || data.LoyaltyId;
            }
            return null;
        };
        QuoteService.prototype.getPriceDifference = function (products) {
            var totalBaseCost = 0;
            var priceDifferenceAbs = 0;
            products.forEach(function (product) {
                totalBaseCost += product.QuotedCost;
                priceDifferenceAbs += (product.CurrentCost - product.QuotedCost);
            });
            var priceDifferencePercentage = (priceDifferenceAbs / totalBaseCost) * 100;
            return {
                priceDifferenceAbs: priceDifferenceAbs,
                priceDifferencePercentage: priceDifferencePercentage
            };
        };
        QuoteService.prototype.getEarliestDate = function (earliestDate, date) {
            var emptyValue = '';
            var compareDatesResult = this.dateUtil.compareDates(date, earliestDate) === -1;
            return (earliestDate === emptyValue) || compareDatesResult ? date : earliestDate;
        };
        QuoteService.prototype.extractEarliestDate = function (products) {
            var _this = this;
            var emptyValue = '';
            return _.reduce(products, function (acc, p) {
                var startDate;
                switch (p.TypeId) {
                    case Quote.QuoteProductType.Accommodation:
                        startDate = p.CheckInDate;
                        break;
                    case Quote.QuoteProductType.Flight:
                        startDate = p.OutboundLeg.Segments[0].DepartureDate;
                        break;
                    case Quote.QuoteProductType.Transfer:
                        startDate = p.OutboundDate || emptyValue;
                        break;
                    case Quote.QuoteProductType.CarHire:
                        startDate = p.PickUpDate;
                        break;
                    default:
                        startDate = emptyValue;
                        break;
                }
                return _this.getEarliestDate(acc, startDate);
            }, emptyValue);
        };
        QuoteService.prototype.validForDays = function (refreshedQuoteProducts) {
            var validForDaysLength = 30;
            var earliestDate = this.extractEarliestDate(refreshedQuoteProducts);
            if (earliestDate.length > 0) {
                var days = this.dateUtil.getDifferenceInDays(new Date(), this.dateUtil.parseDate(earliestDate));
                if (days < validForDaysLength) {
                    return days;
                }
            }
            return validForDaysLength;
        };
        return QuoteService;
    }());
    Quote.QuoteService = QuoteService;
    angular
        .module('TR')
        .service('quoteService', QuoteService);
})(Quote || (Quote = {}));
var QuoteManager;
(function (QuoteManager_1) {
    var QuoteManager = /** @class */ (function () {
        function QuoteManager($http, $window, cookieService) {
            this.$http = $http;
            this.$window = $window;
            this.cookieService = cookieService;
            this.url = '/api/quotes/';
            this.domain = $window.TRPCONFIG.Domain;
        }
        QuoteManager.prototype.create = function (params, cache) {
            if (cache === void 0) { cache = true; }
            params.DomainId = params.DomainId || this.domain.DomainId;
            params.CultureCode = params.CultureCode || this.domain.CultureCode;
            params.VisitSourceId = Number(this.cookieService.get('visitSource')) || null;
            return this.$http.post(this.url + 'create', params, {
                cache: cache,
                ignoreErrors: true
            }).then(function (res) {
                return res.data;
            }, function (res) {
                return { Error: res.data };
            });
        };
        return QuoteManager;
    }());
    QuoteManager_1.QuoteManager = QuoteManager;
    angular
        .module('TR')
        .service('quoteManager', QuoteManager);
})(QuoteManager || (QuoteManager = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .config(function ($provide, $httpProvider) {
        var codesToRetry = [500, 503, 12152, 12002, 12031, 12029, 12030, 12041, 12019, 444];
        $provide.factory('retryInterceptor', function ($injector, $q) { return ({
            responseError: function (resp) {
                if (codesToRetry.indexOf(resp.status) >= 0 &&
                    resp.config.headers['x-auto-retry'] == null) {
                    resp.config.headers['x-auto-retry'] = resp.status;
                    var $http = $injector.get('$http');
                    return $http(resp.config);
                }
                return $q.reject(resp);
            }
        }); });
        if ($httpProvider.interceptors.indexOf('retryInterceptor') < 0) {
            $httpProvider.interceptors.push('retryInterceptor');
        }
    });
})();
var Core;
(function (Core) {
    var RtbHouseTracking = /** @class */ (function () {
        function RtbHouseTracking(rtbHouseTrackingService, $location, tripService, $routeParams, $rootScope, urlUtils, regExpRoutes, hotelSearch, trackingPixelsService, basketService, currentDestination, destinationService, bookingCompleteTrackingService, broker, authService, $q) {
            var _this = this;
            this.rtbHouseTrackingService = rtbHouseTrackingService;
            this.$location = $location;
            this.tripService = tripService;
            this.$routeParams = $routeParams;
            this.$rootScope = $rootScope;
            this.urlUtils = urlUtils;
            this.regExpRoutes = regExpRoutes;
            this.hotelSearch = hotelSearch;
            this.trackingPixelsService = trackingPixelsService;
            this.basketService = basketService;
            this.currentDestination = currentDestination;
            this.destinationService = destinationService;
            this.bookingCompleteTrackingService = bookingCompleteTrackingService;
            this.broker = broker;
            this.authService = authService;
            this.$q = $q;
            this.$rootScope.$on('$routeChangeSuccess', function () {
                _this.initTracking();
                // Need for check any update of currentUser object
                // * in some cases currentUser can be updated after complete load page
                _this.broker.subscribe('rtbHouse', 'userSet', function () {
                    _this.initTracking();
                });
            });
            this.$rootScope.$on('auth:signout', function () {
                _this.initTracking();
            });
            this.$rootScope.$on('auth:signin', function () {
                _this.initTracking();
            });
        }
        RtbHouseTracking.prototype.checkCase = function (url, cases) {
            return this.rtbHouseTrackingService.boolFromMatch(url, cases);
        };
        RtbHouseTracking.prototype.initTracking = function () {
            var urlString = this.$location.url();
            var URL = this.urlUtils.stripLeadingSlash(urlString);
            var tripId = this.$routeParams.tripId || this.$location.search().tripId;
            var area = this.rtbHouseTrackingService.getCurrentArea(URL); // get currend area by url
            var _a = this.regExpRoutes, categoryCases = _a.categoryCases, listingCases = _a.listingCases, holidayDeals = _a.holidayDeals, offerCases = _a.offerCases, cartCases = _a.cartCases, bookingCases = _a.bookingCases, conversionCase = _a.conversionCase;
            if (urlString === '/') {
                this.trackingUrl = this.rtbHouseTrackingService.getHomeUrl();
            }
            else if (this.checkCase(URL, categoryCases)) {
                this.trackingUrl = this.rtbHouseTrackingService.getCategoryUrl(area);
            }
            else if (this.checkCase(URL, listingCases)) {
                this._getListingPixel(tripId, area);
            }
            else if (this.checkCase(URL, holidayDeals)) {
                this._getHolidayDealsPixel();
            }
            else if (this.checkCase(URL, offerCases)) {
                this._getOfferPixel(tripId, area);
            }
            else if (this.checkCase(URL, cartCases)) {
                this._getCartPixel(tripId, area);
            }
            else if (this.checkCase(URL, bookingCases)) {
                this._getBookingPixel(area);
            }
            else if (this.checkCase(URL, conversionCase)) {
                this._getConversionPixel(tripId);
            }
            else {
                this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
            }
        };
        RtbHouseTracking.prototype._getListingPixel = function (tripId, area) {
            // tracking pixels url for landing pages
            var _this = this;
            if (tripId) {
                this.tripService.getTrip(tripId).then(function (trip) {
                    var data = _this.rtbHouseTrackingService.getDataFromTrip(trip);
                    if (!data) {
                        _this.trackingUrl = _this.rtbHouseTrackingService.getDefaultUrl();
                    }
                    else {
                        var promise = _this.$q.when(_this.hotelSearch.getSearchResults(data.searchId, tripId));
                        promise.then(function (res) {
                            var args = {
                                type: 'listing',
                                area: data.area,
                                ids: _this.rtbHouseTrackingService.getIds(res.Hotels),
                                destination: data.dest,
                                checkin: data.checkIn,
                                checkout: data.checkOut,
                                adults: data.adults,
                                children: data.children
                            };
                            if (trip.TripType === _this.tripService.tripTypes.Flight) {
                                args.class = data.class;
                            }
                            _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args);
                        });
                    }
                });
            }
            else {
                var promises = this.$q.all({
                    details: this.currentDestination.getCurrentDestination().then(function (dest) {
                        return _this.destinationService.getDetails(dest);
                    }),
                    searchRes: this.hotelSearch.getStaticSearchResults()
                });
                promises.then(function (_a) {
                    var details = _a.details, searchRes = _a.searchRes;
                    var args = {
                        type: 'listing',
                        area: area,
                        ids: _this.rtbHouseTrackingService.getIds(searchRes.Hotels),
                        destination: _this.rtbHouseTrackingService.getAirportCodes(details.DestinationAirports),
                        checkin: _this.rtbHouseTrackingService.formatDate(details.StartDate),
                        checkout: _this.rtbHouseTrackingService.formatDate(details.EndDate),
                        adults: details && details.Adults ? details.Adults : 0,
                        children: details && details.ChildAges ? details.ChildAges.length : 0
                    };
                    _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args);
                });
            }
        };
        RtbHouseTracking.prototype._getHolidayDealsPixel = function () {
            this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
        };
        RtbHouseTracking.prototype._getOfferPixel = function (tripId, area) {
            // pixel for single offer page
            var _this = this;
            if (tripId) {
                this.tripService.getTrip(tripId).then(function (trip) {
                    var data = _this.rtbHouseTrackingService.getDataFromTrip(trip);
                    if (!data) {
                        _this.trackingUrl = _this.rtbHouseTrackingService.getDefaultUrl();
                    }
                    else {
                        var args_1 = {
                            type: 'offer',
                            area: data.area,
                            destination: data.dest,
                            checkin: data.checkIn,
                            checkout: data.checkOut,
                            adults: data.adults,
                            children: data.children
                        };
                        if (trip.TripType === _this.tripService.tripTypes.Flight) {
                            var promise = _this.$q.when(_this.currentDestination.getCurrentDestination());
                            promise.then(function (dest) {
                                args_1.ids = _this.rtbHouseTrackingService.topHotelId();
                                args_1.destination = dest.DestinationAirports;
                                _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args_1);
                            });
                        }
                        else {
                            _this.broker.subscribe('rtbHouse', 'hotelCacheReady', function (_a) {
                                var data = _a.data;
                                args_1.ids = data ? data.Id : null;
                                _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args_1);
                            });
                        }
                    }
                });
            }
            else {
                var promises = this.$q.all({
                    details: this.currentDestination.getCurrentDestination().then(function (dest) {
                        return _this.destinationService.getDetails(dest);
                    }),
                    searchResult: this.hotelSearch.getStaticSearchResults()
                });
                promises.then(function (_a) {
                    var details = _a.details, searchResult = _a.searchResult;
                    var args = {
                        type: 'offer',
                        area: area,
                        ids: _this.rtbHouseTrackingService.getIds(searchResult.Hotels),
                        destination: _this.rtbHouseTrackingService.getAirportCodes(details.DestinationAirports),
                        checkin: _this.rtbHouseTrackingService.formatDate(details.StartDate),
                        checkout: _this.rtbHouseTrackingService.formatDate(details.EndDate),
                        adults: details ? details.Adults : 0,
                        children: details && details.ChildAges ? details.ChildAges.length : 0
                    };
                    _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args);
                });
            }
        };
        RtbHouseTracking.prototype._getCartPixel = function (tripId, area) {
            // pixel for option page
            var _this = this;
            if (tripId) {
                this.tripService.getTrip(tripId).then(function (trip) {
                    var BasketId = trip.BasketId, TripType = trip.TripType;
                    var args = {
                        type: 'basketstatus',
                        area: _this.rtbHouseTrackingService.tripStates[TripType] || area
                    };
                    if (trip.TripType === _this.tripService.tripTypes.Flight) {
                        args.ids = _this.rtbHouseTrackingService.topHotelId();
                        _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args);
                    }
                    else {
                        _this.$q.when(_this.basketService.getHotel(BasketId)).then(function (hotel) {
                            args.ids = hotel.Details ? hotel.Details.Id : null;
                            _this.trackingUrl = _this.rtbHouseTrackingService.getPixelString(args);
                        });
                    }
                });
            }
            else {
                this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
            }
        };
        RtbHouseTracking.prototype._getBookingPixel = function (area) {
            // pixel booking/option pages in holiday case
            if (!area) {
                this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
            }
            var args = {
                type: 'startorder',
                area: area
            };
            this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
        };
        RtbHouseTracking.prototype._getConversionPixel = function (tripId) {
            // conversion pixel for RTB House provider
        };
        return RtbHouseTracking;
    }());
    angular.module('core')
        .directive('rtbHouseTracking', function () {
        return {
            restrict: 'E',
            scope: {},
            template: "<img ng-if=\"rtb.trackingUrl\" ng-src=\"{{rtb.trackingUrl}}\"\n                          width=\"1\" height=\"1\" style=\"position:absolute; bottom:0; display:none;\" />",
            controller: RtbHouseTracking,
            controllerAs: 'rtb'
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var RtbHouseTrackingService = /** @class */ (function () {
        function RtbHouseTrackingService($window, authService, pageStrand, regExpRoutes, dateUtil, tripService, cookieService) {
            this.$window = $window;
            this.authService = authService;
            this.pageStrand = pageStrand;
            this.regExpRoutes = regExpRoutes;
            this.dateUtil = dateUtil;
            this.tripService = tripService;
            this.cookieService = cookieService;
            this.secretKey = TRPCONFIG.Domain.RTBHouseUIDSecretKey;
            this.rtbHouseUrl = TRPCONFIG.Domain.RTBHouseTrackingURL;
            this.optionId = TRPCONFIG.Domain.RTBHouseOptionId;
            // tripStates - reverse map based on tripTypes from trip.servise
            this.tripStates = {
                '1': 'flights',
                '2': 'hotels',
                '3': 'transfers',
                '4': 'holidays',
                '5': 'marhaba',
                '6': 'parking',
                '7': 'attractions',
                '8': 'dynamicpackage',
                '9': 'insurance',
                '10': 'multidestHoliday'
            };
        }
        RtbHouseTrackingService.prototype.getPixelString = function (args) {
            // Generic Pixel URL. Result Depend from Input agguments.
            var url = this.rtbHouseUrl + "?type=img" + this.optionId + "_" + args.type;
            url += args.ids || args.ids === null ? "_" + args.ids : '';
            url += this.optionId + "_custom_type_" + args.area;
            url += args.destination || args.destination === null ?
                this.optionId + "_custom_destination_" + args.destination : '';
            url += args.checkin || args.checkin === null ?
                this.optionId + "_custom_checkin_" + args.checkin : '';
            url += args.checkout || args.checkout === null ?
                this.optionId + "_custom_checkout_" + args.checkout : '';
            url += args.adults || args.adults === 0 ?
                this.optionId + "_custom_adults_" + args.adults : '';
            url += args.children || args.children === 0 ?
                this.optionId + "_custom_children_" + args.children : '';
            url += args.class || args.class === null ?
                this.optionId + "_custom_class_" + args.class : '';
            url += this.optionId + "_uid_" + this.setUID();
            return url;
        };
        RtbHouseTrackingService.prototype.getHomeUrl = function () {
            // Unique case pixel URL. Use only for Home page.
            return String.format(this.rtbHouseUrl
                + ("?type=img" + this.optionId + "_home" + this.optionId + "_uid_{0}"), this.setUID());
        };
        RtbHouseTrackingService.prototype.getCategoryUrl = function (area) {
            // Unique case pixel URL. Use only for Hotel/Holiday etc. pages.
            return String.format(this.rtbHouseUrl
                + ("?type=img" + this.optionId + "_category2_{0}")
                + (this.optionId + "_uid_{1}")
                + (this.optionId + "_custom_type_{0}"), area, this.setUID());
        };
        RtbHouseTrackingService.prototype.getDefaultUrl = function () {
            // Url use for all other pages.
            return this.rtbHouseUrl + "?type=img" + this.optionId + "_uid_" + this.setUID();
        };
        RtbHouseTrackingService.prototype.matchFromUrl = function (url, matchs) {
            var matchRes = [];
            if (Array.isArray(matchs)) {
                matchs.forEach(function (item) {
                    var exp = new RegExp(item);
                    var match = url.match(exp);
                    if (match !== null) {
                        matchRes.push(match);
                    }
                });
            }
            return matchRes;
        };
        RtbHouseTrackingService.prototype.boolFromMatch = function (url, matches) {
            var match = this.matchFromUrl(url, matches);
            return match.length > 0;
        };
        RtbHouseTrackingService.prototype.getCurrentArea = function (path) {
            // get current area for pages without TripId
            var parsedPath = path.split('/')[0];
            var category = this.regExpRoutes.categoryCases;
            if (this.boolFromMatch(parsedPath, category)) {
                var res = this.matchFromUrl(parsedPath, category);
                return res[0][0];
            }
            if (this.boolFromMatch(parsedPath, this.regExpRoutes.idBasedPageV2)) {
                var res = this.matchFromUrl(parsedPath, this.regExpRoutes.idBasedPageV2);
                var strand = res[0][0].split('-')[0];
                return this.pageStrand.toRoute(strand);
            }
            if (this.boolFromMatch(parsedPath, this.regExpRoutes.idBasedPageV3)) {
                var res = this.matchFromUrl(parsedPath, this.regExpRoutes.idBasedPageV3);
                var strand = res[0][0].split('-')[2];
                return this.pageStrand.toRoute(strand);
            }
            return null;
        };
        RtbHouseTrackingService.prototype.getDataFromTrip = function (trip) {
            // parse Trip object
            var FlightsRequest = trip.FlightsRequest, HotelsRequest = trip.HotelsRequest, TripType = trip.TripType;
            var data = {}, req;
            if (TripType === this.tripService.tripTypes.Hotel || TripType === this.tripService.tripTypes.Holiday) {
                req = HotelsRequest;
                data.dest = this.getAirportCodes(req.Destination.DestinationAirports);
                data.checkIn = this.formatDate(req.CheckInDate);
                data.checkOut = this.formatDate(req.CheckOutDate);
            }
            else if (TripType === this.tripService.tripTypes.Flight) {
                req = FlightsRequest;
                data.checkIn = this.formatDate(req.DepartureDate),
                    data.checkOut = this.formatDate(req.ReturnDate),
                    data.class = req.Cabin;
                data.dest = this.getAirportCodes(req.DestinationAirports);
            }
            else {
                return false;
            }
            data = __assign({}, data, { area: this.tripStates[TripType], searchId: HotelsRequest && HotelsRequest.AvailabilitySearchId, adults: req.Rooms ? req.Rooms[0].Adults : 0, children: req.Rooms ? req.Rooms[0].ChildAges.length : 0 });
            return data;
        };
        RtbHouseTrackingService.prototype.setUID = function () {
            var user = this.authService.getUser();
            if (user) {
                var email = user.Email || user.Contact && user.Contact.Email;
                var uId = void 0;
                if (email && email.length > 0) {
                    uId = this.$window.md5("" + email + this.secretKey);
                    return uId;
                }
                uId = this.cookieService.get('RTBUID');
                if (uId != null) {
                    return uId;
                }
                var host = window.location.hostname;
                var cookieDomain = host.slice(host.indexOf('.'));
                uId = this.$window.md5("" + user.UtmId + this.secretKey);
                this.cookieService.set('RTBUID', uId, this.dateUtil.addDays(Date.now(), 365), cookieDomain);
                return uId;
            }
            return 'unknown';
        };
        RtbHouseTrackingService.prototype.getIds = function (searchList, key) {
            if (!searchList || searchList.length < 1) {
                return null;
            }
            var k = key ? key : 'Id';
            var topIndex = searchList.length > 5 ? 5 : searchList.length;
            var ids = [];
            this.topHotelId('set', searchList[0][k]);
            for (var i = 0; i < topIndex; i++) {
                ids.push(searchList[i][k]);
            }
            return ids.join(',');
        };
        RtbHouseTrackingService.prototype.formatDate = function (date) {
            if (!date) {
                return null;
            }
            return this.dateUtil.format(date, 'yyyy-MM-dd');
        };
        RtbHouseTrackingService.prototype.getAirportCodes = function (airports) {
            if (!airports) {
                return null;
            }
            if (Array.isArray(airports)) {
                return airports.length > 1 ? airports.join(',') : airports[0];
            }
            return airports;
        };
        RtbHouseTrackingService.prototype.topHotelId = function (method, val) {
            if (method === void 0) { method = 'get'; }
            if (method === 'set') {
                this.cookieService.set('_RtbTopHotelId', val);
            }
            else {
                return this.cookieService.get('_RtbTopHotelId') || null;
            }
        };
        return RtbHouseTrackingService;
    }());
    Core.RtbHouseTrackingService = RtbHouseTrackingService;
    angular
        .module('core')
        .service('rtbHouseTrackingService', RtbHouseTrackingService);
})(Core || (Core = {}));
var Core;
(function (Core) {
    var PassengerType;
    (function (PassengerType) {
        PassengerType[PassengerType["Adult"] = 1] = "Adult";
        PassengerType[PassengerType["Child"] = 2] = "Child";
    })(PassengerType || (PassengerType = {}));
    var ApiUrl = '/api/taxation/getCityTax';
    var TaxationService = /** @class */ (function () {
        function TaxationService($q, $http, basketStore, tripService) {
            this.$q = $q;
            this.$http = $http;
            this.basketStore = basketStore;
            this.tripService = tripService;
        }
        TaxationService.prototype.getCityTax = function (tripId, basketId) {
            var _this = this;
            if (TRPCONFIG.Domain.EnableCityTax) {
                var EstabId_1;
                return this.$q.all([
                    this.basketStore.hotel(basketId),
                    this.basketStore.hotelCost(basketId)
                ]).then(function (results) {
                    var hotelFromBasket = results[0], hotelCost = results[1];
                    if (hotelFromBasket) {
                        EstabId_1 = hotelFromBasket.Details.Itinerary.EstabId;
                        var Estabs = [
                            {
                                EstabId: EstabId_1,
                                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                                TotalCost: hotelCost
                            }
                        ];
                        return _this.getCityTaxes(tripId, Estabs);
                    }
                    else {
                        return _this.$q.when();
                    }
                }).then(function (res) { return _.find(res, function (t) { return t.EstabId === EstabId_1; }); });
            }
            else {
                return this.$q.when();
            }
        };
        TaxationService.prototype.getCityTaxes = function (tripId, Estabs) {
            var _this = this;
            if (TRPCONFIG.Domain.EnableCityTax) {
                return this.$q.all([
                    this.tripService.getHotelsRequestCheckInDate(tripId, true),
                    this.tripService.getHotelsRequestCheckOutDate(tripId, true),
                    this.tripService.getTripOccupancy(tripId)
                ]).then(function (_a) {
                    var CheckInDate = _a[0], CheckOutDate = _a[1], occupancy = _a[2];
                    return _this.$http.post(ApiUrl, {
                        CheckInDate: CheckInDate,
                        CheckOutDate: CheckOutDate,
                        Estabs: Estabs,
                        Rooms: _this.roomsFromOccupancy(occupancy)
                    }, { ignoreErrors: true });
                }).then(function (res) { return res.data; });
            }
            else {
                return this.$q.when();
            }
        };
        TaxationService.prototype.roomsFromOccupancy = function (occupancy) {
            var defaultAdultAge = TRPCONFIG.Domain.MaximumChildAge + 1;
            return _.map(occupancy, function (r, i) {
                var room = {};
                room.RoomId = i + 1; //A random roomId
                var adults = _.fill(Array(r.Adults), { PassengerType: PassengerType.Adult, Age: defaultAdultAge });
                var children = _.map(r.ChildAges ? r.ChildAges : [], function (a) {
                    return {
                        PassengerType: PassengerType.Child,
                        Age: a
                    };
                });
                room.Passengers = _.concat(adults, children);
                return room;
            });
        };
        return TaxationService;
    }());
    Core.TaxationService = TaxationService;
    angular.module('TR').service('taxationService', TaxationService);
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .config(configure);
    function configure($provide, $httpProvider) {
        $provide.factory('timerInterceptor', timerInterceptor);
        function timerInterceptor() {
            var COMMON_THRESHOLD = 20;
            return {
                request: function (config) {
                    try {
                        config.headers['x-timer'] = new Date().getTime();
                    }
                    catch (e) { }
                    return config;
                },
                response: function (data) {
                    try {
                        var timeElapsed = (new Date().getTime() - data.config.headers['x-timer']) / 1000;
                        var threshold = data.config.headers['x-threshold'] || COMMON_THRESHOLD;
                        if (timeElapsed > threshold) {
                            var utm = JSON.parse($('body').attr('user')).UtmId;
                            var msg = "OVERTHRESHOLD | " + timeElapsed + "s | " + data.config.url + " | " + utm + " | " + window.navigator.userAgent;
                            var r = new XMLHttpRequest();
                            r.open('POST', 'website/logging/log', true);
                            r.setRequestHeader('content-type', 'application/json');
                            r.send(JSON.stringify({ LogLevel: 'Warn', Message: msg }));
                        }
                    }
                    catch (e) { }
                    return data;
                }
            };
        }
        if ($httpProvider.interceptors.indexOf('timerInterceptor') < 0) {
            $httpProvider.interceptors.push('timerInterceptor');
        }
    }
})();
var Core;
(function (Core) {
    'use strict';
    angular
        .module('TR')
        .service('tripService', tripService);
    function tripService(loggingService, $q, dateUtil, $http, searchUnitService, broker, occupancyService, $routeParams, $location, destinationService) {
        var url = '/api2/tripstate/';
        var promiseCache = {};
        var tripTypes = {
            None: 0,
            Flight: 1,
            Hotel: 2,
            Transfer: 3,
            Holiday: 4,
            Marhaba: 5,
            Parking: 6,
            Attractions: 7,
            DynamicPackage: 8,
            Insurance: 9,
            MultiDestHoliday: 10
        };
        var defaultOpts = {
            bags: 0
        };
        var tripQueue = $q.when();
        var service = {
            tripTypes: tripTypes,
            persist: persist,
            getTrip: getTrip,
            getTripDestination: getTripDestination,
            recordHotelSearch: recordHotelSearch,
            recordFlightSearch: recordFlightSearch,
            recordMultiFlightSearch: recordMultiFlightSearch,
            recordTransferSearch: recordTransferSearch,
            recordMarhabaSearch: recordMarhabaSearch,
            recordInsuranceSearch: recordInsuranceSearch,
            recordCarHireSearch: recordCarHireSearch,
            recordParkingSearch: recordParkingSearch,
            recordAttractionSearch: recordAttractionSearch,
            clearOptionalExtras: clearOptionalExtras,
            changeTripType: changeTripType,
            setBookingId: setBookingId,
            setBasketId: setBasketId,
            setQuoteId: setQuoteId,
            setKidsFree: setKidsFree,
            setSelectedFlight: setSelectedFlight,
            supportsTransfers: supportsTransfers,
            setDirectToHotel: setDirectToHotel,
            restoreSearchUnit: restoreSearchUnit,
            getCurrency: getCurrency,
            isKidsFree: isKidsFree,
            getBoardTypeInclusions: getBoardTypeInclusions,
            getTripIdForDeal: getTripIdForDeal,
            getTripIdForHolidayDeal: getTripIdForHolidayDeal,
            getHotelsRequest: getHotelsRequest,
            getHotelsRequestCheckInDate: getHotelsRequestCheckInDate,
            getHotelsRequestCheckOutDate: getHotelsRequestCheckOutDate,
            getHotelsRequestNumberOfNights: getHotelsRequestNumberOfNights,
            getFlightsRequest: getFlightsRequest,
            getFlightsRequestDepartureDate: getFlightsRequestDepartureDate,
            getFlightsRequestReturnDate: getFlightsRequestReturnDate,
            getParkingDropOffDate: getParkingDropOffDate,
            getParkingPickUpDate: getParkingPickUpDate,
            getSelectedDepartureAirport: getSelectedDepartureAirport,
            getDepartureAirports: getDepartureAirports,
            getSelectedDestinationAirport: getSelectedDestinationAirport,
            getDestinationAirports: getDestinationAirports,
            getFlightCabin: getFlightCabin,
            getParkingAirport: getParkingAirport,
            isOneWayFlightEnabled: isOneWayFlightEnabled,
            getTripNumberOfNights: getTripNumberOfNights,
            getDurationSummary: getDurationSummary,
            getTripOccupancy: getTripOccupancy,
            getTripReducedOccupancy: getTripReducedOccupancy,
            getTransfersRequestSummary: getTransfersRequestSummary,
            getTransferDestinationAirport: getTransferDestinationAirport,
            getParkingRequestSummary: getParkingRequestSummary,
            getTripFromQuote: getTripFromQuote,
            usePackageRates: usePackageRates,
            getInsuranceRequestSummary: getInsuranceRequestSummary,
            getTransfersRequest: getTransfersRequest
        };
        function _updateTrip(tripId, fn) {
            return service.getTrip(tripId).then(function (trip) {
                service.persist(tripId, fn(trip));
                return $q.when(trip);
            });
        }
        function _recordSearch(tripId, search, name) {
            return _updateTrip(tripId, function (trip) {
                trip[name] = search;
                return trip;
            });
        }
        function persist(tripId, trip) {
            trip.UTMId = '0';
            promiseCache[tripId] = $http.post(url + "updatetripstate", {
                TripId: tripId,
                TripState: trip
            }).then(function () {
                var tripCopy = angular.copy(trip);
                broker.publish('tripUpdated', tripCopy);
                return tripCopy;
            });
            return promiseCache[tripId];
        }
        function supportsTransfers(trip) {
            return trip.TripType !== Core.Trip.TripType.Flight;
        }
        function getTrip(tripId) {
            if (!tripId) {
                return $q.when();
            }
            if (promiseCache[tripId] === undefined) {
                var validateUser = Boolean(TRPCONFIG.Domain.ValidateUserForTripstate);
                promiseCache[tripId] = $http.get(url + "gettripstate?tripId=" + tripId + "&validateUser=" + validateUser).then(function (res) {
                    if (res.data.TripId !== $routeParams.tripId) {
                        //load new trip and basket clone
                        $location.path($location.path().replace($routeParams.tripId, res.data.TripId));
                    }
                    return _enrichTripDestination(res.data);
                });
            }
            tripQueue = tripQueue.then(function () {
                return promiseCache[tripId].then(function (trip) {
                    return angular.copy(trip);
                });
            });
            return tripQueue;
            function _enrichTripDestination(trip) {
                var detailsPromise = [];
                detailsPromise.push(trip.FlightsRequest && trip.FlightsRequest.Destination
                    ? destinationService.getDetails(trip.FlightsRequest.Destination)
                    : $q.when());
                detailsPromise.push(trip.HotelsRequest
                    && trip.HotelsRequest.Destination
                    ? destinationService.getDetails(trip.HotelsRequest.Destination)
                    : $q.when());
                return $q.all(detailsPromise).then(function (_a) {
                    var flightDest = _a[0], hotelDest = _a[1];
                    if (flightDest && trip.FlightsRequest) {
                        trip.FlightsRequest.Destination = flightDest;
                    }
                    if (hotelDest && trip.HotelsRequest) {
                        trip.HotelsRequest.Destination = hotelDest;
                    }
                    return trip;
                }, function () {
                    loggingService.logInfo("Get Details is failing for " + trip.TripId);
                    return trip;
                });
            }
        }
        function getTripDestination(tripId) {
            return getTrip(tripId).then(function (trip) {
                if (trip) {
                    var flightDest = trip.FlightsRequest && trip.FlightsRequest.Destination;
                    var hotelsDest = trip.HotelsRequest && trip.HotelsRequest.Destination;
                    return flightDest || hotelsDest || null;
                }
                return null;
            }, function () { tripQueue = $q.when(); });
        }
        function getCurrency(tripId) {
            if (tripId == null) {
                return $q.when();
            }
            return getTrip(tripId).then(function (trip) {
                if (trip.HotelsRequest != null) {
                    return trip.HotelsRequest.CurrencyCode;
                }
            });
        }
        function isKidsFree(tripId) {
            if (tripId == null) {
                return $q.when(false);
            }
            return getTrip(tripId).then(function (trip) {
                return !!trip.IsKidsFree;
            });
        }
        function getBoardTypeInclusions() {
            var boardTypesUrl = '/api/hotels/boardtypes/inclusions/';
            return $http.get("" + boardTypesUrl).then(function (res) { return res.data; });
        }
        function getTripIdForHolidayDeal(deal, occupancy) {
            var tripId;
            var params = _.assignIn({}, deal, {
                DomainId: TRPCONFIG.Domain.DomainId,
                Occupancy: _.first(occupancy)
            });
            return $http.post(url + "createtripfromholidaydeal", params, { ignoreErrors: true })
                .then(function (res) { return tripId = res.data.TripId; }, function (res) { return $q.reject(res); })
                .then(function () { return _updateTrip(tripId, function (trip) {
                trip.HotelsRequest.DirectToHotel = false;
                return trip;
            }); })
                .then(function () { return tripId; });
        }
        function getTripIdForDeal(deal, originPath) {
            return $http.post(url + "createtripfromdeal", {
                AvailabilitySearchId: deal.AvailabilitySearchId,
                EstablishmentId: deal.EstablishmentId,
                Deal: deal,
                OriginPath: originPath,
                DomainId: TRPCONFIG.Domain.DomainId
            }, { ignoreErrors: true }).then(function (res) { return res.data.TripId; }, function (res) {
                if (res.status === 404) {
                    loggingService.logWarn("Unable to create a trip for deal " + deal.Id + " with availabilityId " + deal.AvailabilitySearchId);
                }
                return $q.reject(res);
            });
        }
        function recordHotelSearch(tripId, search) {
            search.DirectToHotel = true;
            return _recordSearch(tripId, search, 'HotelsRequest');
        }
        function recordFlightSearch(tripId, search) {
            return _recordSearch(tripId, search, 'FlightsRequest');
        }
        function recordMultiFlightSearch(tripId, search) {
            return _recordSearch(tripId, search, 'MultiFlightsRequest');
        }
        function recordTransferSearch(tripId, search) {
            return _recordSearch(tripId, search, 'TransfersRequest');
        }
        function recordMarhabaSearch(tripId, search) {
            return _recordSearch(tripId, search, 'MarhabaRequest');
        }
        function recordInsuranceSearch(tripId, search) {
            return _recordSearch(tripId, search, 'InsuranceRequest');
        }
        function recordCarHireSearch(tripId, search) {
            return _recordSearch(tripId, search, 'CarHireRequest');
        }
        function recordParkingSearch(tripId, search) {
            return _recordSearch(tripId, search, 'ParkingRequest');
        }
        function recordAttractionSearch(tripId, search) {
            return _recordSearch(tripId, search, 'AttractionRequest');
        }
        function clearOptionalExtras(tripId) {
            return _updateTrip(tripId, function (trip) {
                trip.TransfersRequest = undefined;
                trip.InsuranceRequest = undefined;
                trip.CarHireRequest = undefined;
                trip.ParkingRequest = undefined;
                trip.AttractionRequest = undefined;
                //TODO - set other optional extra requests to undefined
                return trip;
            });
        }
        function changeTripType(tripId, typeId) {
            return _updateTrip(tripId, function (trip) {
                trip.TripType = typeId;
                return trip;
            });
        }
        function setBookingId(tripId, bookingId) {
            return _updateTrip(tripId, function (trip) {
                trip.BookingId = bookingId;
                return trip;
            });
        }
        function setKidsFree(tripId, isKidsFree) {
            return _updateTrip(tripId, function (trip) {
                trip.IsKidsFree = isKidsFree;
                return trip;
            });
        }
        function setBasketId(tripId, basketId) {
            return _updateTrip(tripId, function (trip) {
                trip.BasketId = basketId;
                return trip;
            });
        }
        function setQuoteId(tripId, quoteId) {
            return _updateTrip(tripId, function (trip) {
                trip.QuoteId = quoteId;
                return trip;
            });
        }
        function setDirectToHotel(tripId, direct) {
            return service.getTrip(tripId).then(function (trip) {
                if (trip.HotelsRequest && trip.HotelsRequest.DirectToHotel !== direct) {
                    return _updateTrip(tripId, function (trip) {
                        if (trip.HotelsRequest) {
                            trip.HotelsRequest.DirectToHotel = direct;
                        }
                        return trip;
                    });
                }
                return trip;
            });
        }
        function setSelectedFlight(tripId, flight, opts) {
            opts = opts || defaultOpts;
            return _updateTrip(tripId, function (trip) {
                if (trip.FlightsRequest) {
                    trip.FlightsRequest.SelectedFlight = {
                        FlightId: flight.FlightId,
                        DetailsId: flight.DetailsId,
                        LeadAdultPrice: flight.LeadAdultPrice,
                        LeadAdultTax: flight.LeadAdultTax,
                        LeadBaggagePrice: flight.LeadBaggagePrice,
                        AllBagsOrNone: flight.AllBagsOrNone,
                        BaggageCount: opts.bags,
                        PriorityForPreSelection: flight.PriorityForPreSelection
                    };
                }
                return trip;
            });
        }
        function restoreSearchUnit(tripId) {
            if (!tripId) {
                return $q.when();
            }
            return service.getTrip(tripId).then(function (trip) {
                return $q.all([
                    searchUnitService.restoreFlightSearch(trip),
                    searchUnitService.restoreMultiFlightSearch(trip),
                    searchUnitService.restoreTransferSearch(trip),
                    searchUnitService.restoreMarhabaSearch(trip),
                    searchUnitService.restoreHotelSearch(trip),
                    searchUnitService.restoreParkingSearch(trip),
                    searchUnitService.restoreInsuranceSearch(trip)
                ])
                    .then(function () {
                    return trip;
                });
            });
        }
        function getHotelsRequest(tripId) {
            return service.getTrip(tripId).then(function (trip) { return trip.HotelsRequest; });
        }
        function getTransfersRequest(tripId) {
            return service.getTrip(tripId).then(function (trip) { return trip.TransfersRequest; });
        }
        function _getTripDate(tripId, requestType, dateType, serialised) {
            return service.getTrip(tripId).then(function (trip) {
                return trip && trip[requestType] && trip[requestType][dateType] ?
                    (serialised ? dateUtil.serialiseDate : dateUtil.parseDate)(trip[requestType][dateType])
                    : null;
            });
        }
        function getHotelsRequestCheckInDate(tripId, serialised) {
            if (serialised === void 0) { serialised = false; }
            return _getTripDate(tripId, 'HotelsRequest', 'CheckInDate', serialised);
        }
        function getHotelsRequestCheckOutDate(tripId, serialised) {
            if (serialised === void 0) { serialised = false; }
            return _getTripDate(tripId, 'HotelsRequest', 'CheckOutDate', serialised);
        }
        function getFlightsRequestDepartureDate(tripId, serialised) {
            if (serialised === void 0) { serialised = false; }
            return _getTripDate(tripId, 'FlightsRequest', 'DepartureDate', serialised);
        }
        function getFlightsRequestReturnDate(tripId, serialised) {
            if (serialised === void 0) { serialised = false; }
            return _getTripDate(tripId, 'FlightsRequest', 'ReturnDate', serialised);
        }
        function getSelectedDepartureAirport(tripId) {
            return service.getTrip(tripId).then(function (trip) {
                return trip && trip.FlightsRequest ? trip.FlightsRequest.SelectedDepartureAirport : null;
            });
        }
        //TODO - this needs investigating because DepartureAirports does not exist on the FlightsRequest
        function getDepartureAirports(tripId) {
            return getTrip(tripId).then(function (trip) {
                return trip && trip.FlightsRequest ? trip.FlightsRequest.DepartureAirports : [];
            });
        }
        function getParkingAirport(tripId) {
            return service.getTrip(tripId).then(function (trip) {
                return trip && trip.ParkingRequest ? _.omit(trip.ParkingRequest.Airport, 'ShortTitle') : {};
            });
        }
        //TODO - this return type mayes no sense because SelectedDestinationAirport is not an array
        function getSelectedDestinationAirport(tripId) {
            return getTrip(tripId).then(function (trip) {
                return trip && trip.FlightsRequest ? trip.FlightsRequest.SelectedDestinationAirport : [];
            });
        }
        //TODO - this needs investigating because DestinationAirports does not exist on the FlightsRequest
        function getDestinationAirports(tripId) {
            return getTrip(tripId).then(function (trip) {
                return trip && trip.FlightsRequest ? trip.FlightsRequest.DestinationAirports : [];
            });
        }
        function getFlightCabin(tripId) {
            return getTrip(tripId).then(function (trip) {
                return trip && trip.FlightsRequest ? trip.FlightsRequest.Cabin : null;
            });
        }
        function getParkingDropOffDate(tripId, serialised) {
            if (serialised === void 0) { serialised = false; }
            return _getTripDate(tripId, 'ParkingRequest', 'DepartureDate', serialised);
        }
        function getParkingPickUpDate(tripId, serialised) {
            if (serialised === void 0) { serialised = false; }
            return _getTripDate(tripId, 'ParkingRequest', 'ReturnDate', serialised);
        }
        function _parseTripDates(tripId) {
            var dates = [
                new dateUtil.DateRange(),
                new dateUtil.DateRange(),
                new dateUtil.DateRange(),
                new dateUtil.DateRange()
            ];
            return getTrip(tripId).then(function (trip) {
                if (trip) {
                    if (trip.HotelsRequest) {
                        if (trip.HotelsRequest.CheckInDate) {
                            setStartDate(searchUnitService.hotel, trip.HotelsRequest.CheckInDate);
                        }
                        if (trip.HotelsRequest.CheckOutDate) {
                            setEndDate(searchUnitService.hotel, trip.HotelsRequest.CheckOutDate);
                        }
                    }
                    if (trip.FlightsRequest) {
                        if (trip.FlightsRequest.DepartureDate) {
                            setStartDate(searchUnitService.flight, trip.FlightsRequest.DepartureDate);
                        }
                        if (trip.FlightsRequest.ReturnDate) {
                            setEndDate(searchUnitService.flight, trip.FlightsRequest.ReturnDate);
                        }
                    }
                    if (trip.TransfersRequest) {
                        if (trip.TransfersRequest.ArrivalDate) {
                            setStartDate(searchUnitService.transfer, trip.TransfersRequest.ArrivalDate);
                        }
                        if (trip.TransfersRequest.ReturnDate) {
                            setEndDate(searchUnitService.transfer, trip.TransfersRequest.ReturnDate);
                        }
                    }
                    if (trip.MarhabaRequest && trip.MarhabaRequest.DateAndTime) {
                        setStartDate(searchUnitService.marhaba, trip.MarhabaRequest.DateAndTime);
                    }
                }
                return dates;
            });
            function setStartDate(mode, date) {
                dates[mode].setStart(date);
            }
            function setEndDate(mode, date) {
                dates[mode].setEnd(date);
            }
        }
        function getTripNumberOfNights(mode, tripId) {
            return (!tripId || null == mode)
                ? $q.when()
                : _parseTripDates(tripId)
                    .then(function (dates) { return dates && dates[mode] && dates[mode].numberOfNights(); });
        }
        function getDurationSummary(mode, tripId) {
            if (!tripId) {
                return $q.when('');
            }
            return _parseTripDates(tripId).then(function (dates) {
                return (mode === searchUnitService.flight)
                    ? isOneWayFlightEnabled(tripId)
                        .then(function (oneWay) {
                        return oneWay ? dateUtil.format(dates[mode].start) : dates[mode].getDurationSummary();
                    })
                    : dates[mode].getDurationSummary();
            });
        }
        function isOneWayFlightEnabled(tripId) {
            return getTrip(tripId)
                .then(function (trip) { return trip && trip.FlightsRequest && trip.FlightsRequest.OneWayOnly; });
        }
        function getTripOccupancy(tripId) {
            return getTrip(tripId).then(function (trip) {
                if (!trip) {
                    return null;
                }
                var req = trip.HotelsRequest
                    || trip.FlightsRequest
                    || trip.TransfersRequest
                    || trip.MarhabaRequest
                    || trip.InsuranceRequest;
                if (!req) {
                    if (trip.ParkingRequest) {
                        return trip.ParkingRequest.PassengerCount;
                    }
                    return null;
                }
                return req.Rooms || [_.pick(req.Occupancy || req, 'Adults', 'ChildAges')];
            });
        }
        function getTripReducedOccupancy(tripId) {
            return getTripOccupancy(tripId).then(function (occupancy) {
                return occupancy &&
                    occupancy.map(function (o) { return o.ChildAges ? o : _.set(o, 'ChildAges', []); })
                        .reduce(function (o1, o2) { return ({
                        Adults: o1.Adults + o2.Adults,
                        ChildAges: (o1.ChildAges || []).concat(o2.ChildAges || [])
                    }); });
            });
        }
        function getTransferDestinationAirport(tripId) {
            return getTrip(tripId).then(function (trip) {
                return trip && trip.TransfersRequest ? trip.TransfersRequest.DestinationAirport : null;
            });
        }
        function getTransfersRequestSummary(tripId) {
            function getTransferNumericDirection(tripId) {
                return getTrip(tripId).then(function (trip) {
                    if (trip && trip.TransfersRequest && trip.TransfersRequest) {
                        var _a = trip.TransfersRequest, ArrivalDate = _a.ArrivalDate, ReturnDate = _a.ReturnDate;
                        if (ArrivalDate && ReturnDate) {
                            return 1;
                        }
                        if (ArrivalDate) {
                            return 2;
                        }
                        if (ReturnDate) {
                            return 3;
                        }
                        return null;
                    }
                });
            }
            function getTransferDestination(tripId) {
                return getTrip(tripId).then(function (trip) {
                    if (trip && trip.TransfersRequest && trip.TransfersRequest.LocationId) {
                        return destinationService.getDetails({
                            LocationId: trip.TransfersRequest.LocationId
                        });
                    }
                });
            }
            function _getTransferPickupPoint(tripId) {
                return getTrip(tripId).then(function (trip) {
                    return _.get(trip, 'TransfersRequest.Route.PickUpPoint.Description');
                });
            }
            function _getTransferDropOffPoint(tripId) {
                return getTrip(tripId).then(function (trip) {
                    return _.get(trip, 'TransfersRequest.Route.DropOffPoint.Description');
                });
            }
            return $q.all([
                getTransferDestinationAirport(tripId),
                _getTripDate(tripId, 'TransfersRequest', 'ArrivalDate', true),
                _getTripDate(tripId, 'TransfersRequest', 'ReturnDate', true),
                service.getTripOccupancy(tripId),
                getTransferNumericDirection(tripId),
                getTransferDestination(tripId),
                _getTransferPickupPoint(tripId),
                _getTransferDropOffPoint(tripId)
            ]).then(function (_a) {
                var DestinationAirport = _a[0], StartDate = _a[1], EndDate = _a[2], occupancy = _a[3], NumericDirection = _a[4], Destination = _a[5], PickUpPointTitle = _a[6], DropOffPointTitle = _a[7];
                return {
                    StartDate: StartDate,
                    EndDate: EndDate,
                    OccupancyString: occupancyService.getOccupancyString(occupancy),
                    NumericDirection: NumericDirection,
                    DestinationTitle: (Destination && Destination.ShortTitle)
                        || (DestinationAirport && DestinationAirport.Title),
                    PickUpPointTitle: PickUpPointTitle,
                    DropOffPointTitle: DropOffPointTitle,
                    TransferType: searchUnitService.getTransferType()
                };
            });
        }
        function getInsuranceRequestSummary(tripId) {
            return getTrip(tripId).then(function (trip) {
                var insuranceReq = (trip && trip.InsuranceRequest) || {};
                return {
                    PolicyType: insuranceReq.TripType,
                    StartDate: dateUtil.serialiseDate(insuranceReq.StartDate),
                    EndDate: dateUtil.serialiseDate(insuranceReq.EndDate),
                    Destination: insuranceReq.TravelDestination
                };
            });
        }
        function getParkingRequestSummary(tripId) {
            return getTrip(tripId)
                .then(function (trip) {
                var parkingReq = (trip && trip.ParkingRequest) || {};
                return {
                    Airport: parkingReq.Airport.ShortTitle,
                    DepartureDate: dateUtil.serialiseDate(parkingReq.DepartureDate),
                    ReturnDate: dateUtil.serialiseDate(parkingReq.ReturnDate),
                    PassengerCount: parkingReq.PassengerCount
                };
            });
        }
        function getHotelsRequestNumberOfNights(tripId) {
            if (!tripId) {
                return $q.when(0);
            }
            return $q.all([
                service.getHotelsRequestCheckInDate(tripId, false),
                service.getHotelsRequestCheckOutDate(tripId, false)
            ]).then(function (dates) { return dateUtil.numberOfNights.apply(dateUtil, dates); });
        }
        function getTripFromQuote(quote) {
            //create request object
            var tripFromQuoteRequest = {
                QuoteId: quote.Id,
                BasketId: quote.BasketId,
                ForHoliday: quote.ForHoliday
            };
            quote.Products.reduce(function (req, _a) {
                var AvailabilityId = _a.AvailabilityId, Type = _a.Type;
                switch (Type) {
                    case 'Accommodation':
                        req.HotelsRequestId = AvailabilityId;
                        break;
                    case 'Airport Parking':
                        req.ParkingRequestId = AvailabilityId;
                        break;
                    case 'Attraction Ticket':
                        req.AttractionsRequestId = AvailabilityId;
                        break;
                    case 'Car Hire':
                        req.CarHireRequestId = AvailabilityId;
                        break;
                    case 'Flight':
                        req.FlightsRequestId = AvailabilityId;
                        break;
                    case 'Insurance':
                        req.InsuranceRequestId = AvailabilityId;
                        break;
                    case 'Marhaba':
                        req.MarhabaRequestId = AvailabilityId;
                        break;
                    case 'Transfer':
                        req.TransfersRequestId = AvailabilityId;
                        break;
                }
                return req;
            }, tripFromQuoteRequest);
            return $http.post(url + "createtripfromquote", tripFromQuoteRequest, { ignoreErrors: true }).then(function (res) { return res.data; });
        }
        function usePackageRates(tripId) {
            if (tripId === void 0) { tripId = $routeParams && $routeParams.tripId; }
            return getTrip(tripId)
                .then(function (trip) {
                return trip && trip.TripType === tripTypes.Holiday && (TRPCONFIG.Domain.PackagePrice || trip.PackageId);
            })
                .then(function (result) { return !!result; });
        }
        function getPackageId(tripId) {
            if (tripId === void 0) { tripId = $routeParams && $routeParams.tripId; }
            return getTrip(tripId).then(function (trip) { return trip && trip.PackageId; });
        }
        function getFlightsRequest(tripId) {
            return service.getTrip(tripId).then(function (trip) { return trip && trip.FlightsRequest; });
        }
        return service;
    }
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Collections;
    (function (Collections) {
        var Dictionary = /** @class */ (function () {
            function Dictionary() {
                this._items = {};
                this._count = 0;
            }
            Dictionary.prototype.add = function (key, value) {
                if (this.containsKey(key)) {
                    throw new TypeError('Key already exists');
                }
                this._items[key] = value;
                this._count++;
            };
            Dictionary.prototype.containsKey = function (key) {
                return this._items.hasOwnProperty(key);
            };
            Dictionary.prototype.count = function () {
                return this._count;
            };
            Dictionary.prototype.item = function (key) {
                return this._items[key];
            };
            Dictionary.prototype.values = function () {
                var v = [];
                for (var p in this._items) {
                    if (this._items.hasOwnProperty(p)) {
                        v.push(this._items[p]);
                    }
                }
                return v;
            };
            return Dictionary;
        }());
        Collections.Dictionary = Dictionary;
    })(Collections = Core.Collections || (Core.Collections = {}));
})(Core || (Core = {}));
(function () {
    'use strict';
    var isPrerender = /prerender/i.test(navigator.userAgent);
    if (!isPrerender) {
        return;
    }
    var core = angular.module('core');
    var apiCallLog = [];
    //This is to record what api requests are made, so to track down what is going wrong with the prerender.
    core.decorator('$http', function ($delegate) {
        var $http = $delegate;
        var oldGet = $http.get;
        $http.get = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var log = {
                url: args[0],
                time: new Date()
            };
            apiCallLog.push(log);
            return oldGet.apply($http, args)
                .then(function (response) {
                log.status = response.status + " " + response.statusText;
                return response;
            })
                .catch(function (error) {
                log.error = error.status + " " + error.statusText;
                throw error;
            })
                .finally(function () {
                log.time = new Date() - log.time;
            });
        };
        return $delegate;
    });
    core.directive('prerenderLogging', function () { return ({
        restrict: 'E',
        template: '{{apiCallLog|json:false}}',
        link: function (scope) { return scope.apiCallLog = apiCallLog; }
    }); });
    if (console) {
        var oldError_1 = console.error;
        console.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            apiCallLog.push({
                jsError: args
            });
            oldError_1 && oldError_1.apply(console, args);
        };
    }
})();
var Dashboard;
(function (Dashboard) {
    var DashboardHome = /** @class */ (function () {
        function DashboardHome(dashboardNotificationService, $interpolate, $location) {
            var _this = this;
            this.dashboardNotificationService = dashboardNotificationService;
            this.$interpolate = $interpolate;
            this.$location = $location;
            this.notificationClicked = function (n) {
                _this.dashboardNotificationService.notificationClicked(n);
            };
            this.formatNotification = function (n) { return _this.dashboardNotificationService.formatNotification(n); };
            this.dashboardNotificationService.getNotifications()
                .then(function (data) { _this.alerts = data; });
        }
        return DashboardHome;
    }());
    angular
        .module('dashboard')
        .controller('Dashboard', DashboardHome);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var Notifications = /** @class */ (function () {
        function Notifications(dashboardNotificationService, $interpolate, $location) {
            var _this = this;
            this.dashboardNotificationService = dashboardNotificationService;
            this.$interpolate = $interpolate;
            this.$location = $location;
            this.notificationClicked = function (n) {
                _this.dashboardNotificationService.notificationClicked(n);
            };
            this.formatNotification = function (n) { return _this.dashboardNotificationService.formatNotification(n); };
            this.dashboardNotificationService.getNotifications()
                .then(function (data) { _this.alerts = data; });
        }
        return Notifications;
    }());
    angular
        .module('dashboard')
        .controller('Notifications', Notifications);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var AddAPI = /** @class */ (function () {
        function AddAPI($routeParams, dashboardBookingService, bookingsManagerService, addAPIService, globalisationService, $scope, resourceService, broker) {
            var _this = this;
            this.$routeParams = $routeParams;
            this.dashboardBookingService = dashboardBookingService;
            this.bookingsManagerService = bookingsManagerService;
            this.addAPIService = addAPIService;
            this.globalisationService = globalisationService;
            this.$scope = $scope;
            this.resourceService = resourceService;
            this.broker = broker;
            this.apiSubmitted = false;
            this.bookingId = parseInt($routeParams.bookingId, 10);
            addAPIService.getPassengerInfo(this.bookingId).then(function (passengers) {
                _this.apiSubmitted = _.some(passengers, function (p) { return p.DetailsSubmitted; });
                _this.passengers = passengers;
            });
            globalisationService.getCountries().then(function (countries) { return _this.countries = countries; });
            this.documentTypes = addAPIService.getDocumentTypes();
        }
        AddAPI.prototype.submitAPI = function () {
            var _this = this;
            this.busy = true;
            this.addAPIService.addAPI(this.$routeParams.bookingId, this.passengers).then(function () {
                _this.apiSubmitted = true;
                _this.busy = false;
                _this.broker.publish('apiAdded');
            }, function () {
                _this.$scope.$broadcast('flash:error', _this.resourceService.get('ADDAPIFAILURE'));
                _this.busy = false;
            });
        };
        AddAPI.prototype.getDocumentTypeLabel = function (id) {
            var docType = _.find(this.documentTypes, function (type) { return type.id === id; });
            return docType ? docType.label() : '';
        };
        AddAPI.prototype.getCountryName = function (id) {
            var country = _.find(this.countries, function (country) { return country.CountryCodeIso3 === id; });
            return country ? country.Name : '';
        };
        return AddAPI;
    }());
    angular
        .module('dashboard')
        .controller('AddAPI', AddAPI);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var AddOption = /** @class */ (function () {
        function AddOption($location, $q, $routeParams, $scope, $window, // unable to assign to $window.location if its type is declared
        broker, customCurrencyFilter, dashboardBookingService, flightExtrasService, mybTrack, paymentDetailsService, paymentsService, paymentsUtilService, resourceService, rootPath, urlUtils, dateUtil, currentUser) {
            var _this = this;
            this.$location = $location;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.$window = $window;
            this.broker = broker;
            this.customCurrencyFilter = customCurrencyFilter;
            this.dashboardBookingService = dashboardBookingService;
            this.flightExtrasService = flightExtrasService;
            this.mybTrack = mybTrack;
            this.paymentDetailsService = paymentDetailsService;
            this.paymentsService = paymentsService;
            this.paymentsUtilService = paymentsUtilService;
            this.resourceService = resourceService;
            this.rootPath = rootPath;
            this.urlUtils = urlUtils;
            this.dateUtil = dateUtil;
            this.currentUser = currentUser;
            this.paymentMethodText = ['New Card', 'PayPal', 'Saved Card'];
            this.selectedOptionsTotalPrice = 0;
            var flightBookingType = 1;
            this.bookingId = parseInt(this.$routeParams.bookingId, 10);
            var getOptions = this.paymentDetailsService.getPaymentOptions(flightBookingType, this.bookingId, TRPCONFIG.Domain.CurrencyCode);
            var getCards = this.paymentDetailsService.getSavedPaymentCards(flightBookingType, this.bookingId, TRPCONFIG.Domain.CurrencyCode);
            this.$q.all([getOptions, getCards])
                .then(function (results) {
                _this.paymentOptions = _this.paymentsUtilService.convertMybPaymentOptions(results[0]);
                if (results[1]) {
                    _this.savedCards = _this.paymentsUtilService.convertMybSavedCards(results[1], results[0]);
                }
            });
            this.paymentModel = this.paymentsUtilService.createEmptyPaymentModel();
            this.flightExtrasService.getOptionsData(this.bookingId).then(function (optionsData) {
                if (!optionsData || !_this.canAddOption(optionsData) || !optionsData[_this.getConfig().optionsType]) {
                    $location.path("dashboard/bookings/reference/" + _this.bookingId);
                    return;
                }
                _this[_this.getConfig().availableOptionsBinding] = optionsData[_this.getConfig().optionsType];
                _this.amendBookingOptionsId = optionsData.AmendBookingOptionsId;
                _this.handBaggageInformation = optionsData.HandBaggageInformation;
                if (_this.$routeParams.ppResp) {
                    _this.showError(_this.resourceService.get(_this.paymentsService.getPayPalResponseMessage(_this.$routeParams.ppResp)));
                }
            }, function () { return _this.$location.path("dashboard/bookings/reference/" + _this.bookingId); });
            this.$scope.$on('3DSValidationComplete', function (ev, data) {
                _this.finaliseOptions(data);
            });
            this.dashboardBookingService.getFlightBooking(this.$routeParams.bookingId).then(function (r) {
                _this.supplierIds = r.data.SupplierIds;
                _this.mybTrack.track(_this.getConfig().analyticsTag, {
                    Source: _this.$routeParams.source === 'noneml' ? 'email' : 'cross-Sell',
                    SupplierId: _this.supplierIds,
                    BookingId: _this.bookingId
                });
            });
            this.dashboardBookingService.isPartOfHoliday(this.$routeParams.bookingId)
                .then(function (r) { return _this.isPartOfHoliday = r; });
            this.dataLoaded = true;
        }
        AddOption.prototype.generateTokens = function () {
            return this.paymentsService.generateTokens(this.paymentModel.cardDetail.expiryDate.month, this.paymentModel.cardDetail.expiryDate.year, this.paymentModel.saveCard);
        };
        AddOption.prototype.makePayment = function () {
            var _this = this;
            this.analyticsTrackOpenOption();
            var expires = this.paymentModel.cardDetail.expiryDate;
            var today = this.dateUtil.todayPlus();
            if (expires &&
                expires.year
                && expires.month
                && expires.year <= today.getFullYear()
                && expires.month < (today.getMonth() + 1)) {
                this.showError(this.resourceService.get('CARDHASEXPIRED'));
                return;
            }
            this.block(true);
            var requireValidation = this.paymentModel.cardDetail.isSavedCard === false
                && !this.paymentModel.isPayPalPayment;
            this.flightExtrasService.addOptionsToBooking(this.formatClearRequestPayload(), requireValidation)
                .then(function (result) {
                if (result.Success) {
                    if (result.AcsRedirectRequired) {
                        if (_this.paymentModel.isPayPalPayment) {
                            //Paypal redirection
                            _this.$window.location = result.AcsUrl;
                        }
                        else {
                            //3ds redirection
                            _this.redirectTo3dSecurePayment(result);
                        }
                    }
                    else {
                        //Show complete page
                        _this.$location.path(String.format(_this.getConfig().completeUrl, _this.bookingId));
                    }
                }
                else {
                    if (result.PostPayment) {
                        _this.handlePaymentSuccessOptionsError();
                        return;
                    }
                    var message = result.ReasonCode ?
                        _this.paymentDetailsService.getcardFailureReasonMessage(result.ReasonCode)
                        : result.PaymentMessage;
                    _this.handleFailurePayment(message);
                }
            }, function () {
                _this.showError(_this.resourceService.get('PAYBALANCEERROR'));
            });
        };
        AddOption.prototype.formatClearRequestPayload = function () {
            var root = this.urlUtils.getOrigin() + this.rootPath.getRootPath();
            var payPalCallbackUrl = '{0}addoptionspaypalcallback?paymentId={1}&bookingId={2}&ppResp={3}' +
                '&amendBookingOptionsId={4}&pageUrl={5}';
            var request = (_a = {
                    BookingId: this.bookingId,
                    AmendBookingOptionsId: this.amendBookingOptionsId,
                    PaymentRequest: {
                        BookingId: this.bookingId,
                        DomainId: TRPCONFIG.Domain.DomainId,
                        CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                        Amount: this.selectedOptionsTotalPrice,
                        CultureCode: TRPCONFIG.Domain.CultureCode,
                        PayPalCallbackUrl: String.format(payPalCallbackUrl, root, '$PaymentId', this.bookingId, 'success', this.amendBookingOptionsId, this.getConfig().pageUrl),
                        PayPalCancellationUrl: String.format(payPalCallbackUrl, root, 0, this.bookingId, 'cancel', this.amendBookingOptionsId, this.getConfig().pageUrl)
                    }
                },
                _a[this.getConfig().selectedOptionsRequest] = this[this.getConfig().selectedOptionsBinding],
                _a);
            this.paymentsUtilService.addPaymentDetailsToClearRequest(this.paymentModel, request.PaymentRequest);
            return request;
            var _a;
        };
        AddOption.prototype.finaliseOptions = function (data) {
            var _this = this;
            this.block(true);
            this.flightExtrasService.finaliseOptions(this.formatFinaliseOptionsRequestPayload(data))
                .then(function (result) {
                _this.$scope.$broadcast('3DSValidationFinished', result.Success);
                if (result.Success) {
                    _this.$location.path(String.format(_this.getConfig().completeUrl, _this.bookingId));
                }
                else {
                    if (result.PostPayment) {
                        _this.handlePaymentSuccessOptionsError();
                        return;
                    }
                    _this.handleFailurePayment(result.PaymentMessage);
                }
            }, function () {
                _this.showError(_this.resourceService.get('AUTHORISEEERROR'));
            });
            this.$scope.$apply(function () {
                _this.threedsRedirecting = false;
            });
        };
        AddOption.prototype.formatFinaliseOptionsRequestPayload = function (data) {
            return {
                BookingId: this.bookingId,
                AmendBookingOptionsId: this.amendBookingOptionsId,
                PaymentId: data.prePaymentId,
                PaRes: decodeURIComponent(data.paRes),
                MD: data.md,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode
            };
        };
        AddOption.prototype.showError = function (msg) {
            this.$scope.$broadcast('flash:error', msg);
        };
        AddOption.prototype.block = function (completing) {
            this.$scope.$emit('block', {
                title: this.resourceService.get(completing ? 'COMPLETINGPAYMENT' : 'PREPARINGPAYMENT'),
                loadingScreenStyle: 'default-addBaggage'
            });
        };
        AddOption.prototype.redirectTo3dSecurePayment = function (result) {
            var root = this.urlUtils.getOrigin() + this.rootPath.getRootPath();
            //Create threeDSecure object
            this.ThreeDSecure = {
                PaReq: result.PaReq,
                MD: result.MD,
                TermUrl: String.format('{0}threedsecure?prePaymentID={1}', root, result.PaymentId),
                AcsUrl: result.AcsUrl,
                CanByPass: result.AllowThreeDSecureBypass,
                PrePaymentID: result.PaymentId
            };
            this.$scope.$broadcast('request3DSValidation', this.ThreeDSecure, {
                Journey: 'AddOptions',
                BookingID: this.bookingId,
                SignedIn: this.currentUser.get().SignedIn
            });
            this.threedsRedirecting = true;
            this.broker.publish('unblock');
            this.$scope.$emit('unblock');
        };
        AddOption.prototype.handleFailurePayment = function (msg) {
            var messages = [this.resourceService.get('PAYMENTFAILED') + msg,
                String.format(this.resourceService.get('PAYMENTASSISTENCE'), this.resourceService.get('TELEPHONENUMBER'))];
            this.showErrorMessages(messages);
        };
        AddOption.prototype.handlePaymentSuccessOptionsError = function () {
            var message = String.format(this.resourceService.get('AMENDMENTERRORMSG'), this.resourceService.get('TELEPHONENUMBER'));
            this.showErrorMessages(message);
        };
        AddOption.prototype.showErrorMessages = function (messages) {
            this.showError(messages);
            this.broker.publish('unblock');
            this.$scope.$emit('unblock');
        };
        return AddOption;
    }());
    Dashboard.AddOption = AddOption;
})(Dashboard || (Dashboard = {}));
///<reference path='dashboardAddOption.controller.ts'/>
var Dashboard;
(function (Dashboard) {
    var AddBaggage = /** @class */ (function (_super) {
        __extends(AddBaggage, _super);
        function AddBaggage($location, $q, $routeParams, $scope, $window, broker, customCurrencyFilter, dashboardBookingService, flightExtrasService, mybTrack, paymentDetailsService, paymentsService, paymentsUtilService, resourceService, rootPath, urlUtils, dateUtil, currentUser) {
            var _this = _super.call(this, $location, $q, $routeParams, $scope, $window, broker, customCurrencyFilter, dashboardBookingService, flightExtrasService, mybTrack, paymentDetailsService, paymentsService, paymentsUtilService, resourceService, rootPath, urlUtils, dateUtil, currentUser) || this;
            _this.$location = $location;
            _this.$q = $q;
            _this.$routeParams = $routeParams;
            _this.$scope = $scope;
            _this.$window = $window;
            _this.broker = broker;
            _this.customCurrencyFilter = customCurrencyFilter;
            _this.dashboardBookingService = dashboardBookingService;
            _this.flightExtrasService = flightExtrasService;
            _this.mybTrack = mybTrack;
            _this.paymentDetailsService = paymentDetailsService;
            _this.paymentsService = paymentsService;
            _this.paymentsUtilService = paymentsUtilService;
            _this.resourceService = resourceService;
            _this.rootPath = rootPath;
            _this.urlUtils = urlUtils;
            _this.dateUtil = dateUtil;
            _this.currentUser = currentUser;
            _this.$scope.$watch('cm.selectedOptions', function () { return _this.updateButtonLabel(); });
            _this.$scope.$watch('cm.paymentModel.fee', function () { return _this.updateButtonLabel(); });
            return _this;
        }
        AddBaggage.prototype.updateButtonLabel = function () {
            this.buttonLabel = this.getButtonLabel();
        };
        AddBaggage.prototype.getButtonLabel = function () {
            if (this.selectedOptions && this.selectedOptions.length === 1) {
                return String.format(this.resourceService.get('PAYFORONEBAG'), this.customCurrencyFilter(this.selectedOptionsTotalPrice + this.paymentModel.fee));
            }
            if (this.selectedOptions && this.selectedOptions.length > 1) {
                return String.format(this.resourceService.get('PAYFORBAGS'), this.customCurrencyFilter(this.selectedOptionsTotalPrice + this.paymentModel.fee), this.selectedOptions.length);
            }
            return this.resourceService.get('ADDBAGSTOPAY');
        };
        AddBaggage.prototype.analyticsTrackOpenOption = function () {
            this.mybTrack.track('MYB - Add Bag Payment', {
                NumberOfHoldBags: this.selectedOptions.length || 0,
                NumberOfHandBags: this.handBaggageInformation &&
                    this.handBaggageInformation.PiecesAllowed,
                PaymentMethod: this.paymentMethodText[this.paymentTab] || '',
                Source: this.$routeParams.source === 'noneml' ? 'email' : 'cross-Sell',
                SuplierIds: this.supplierIds
            });
        };
        AddBaggage.prototype.getConfig = function () {
            return {
                completeUrl: 'dashboard/add-baggage/complete/{0}',
                optionsType: 'BagOptions',
                availableOptionsBinding: 'bagOptions',
                selectedOptionsBinding: 'selectedOptions',
                selectedOptionsRequest: 'SelectedOptions',
                analyticsTag: 'MYB - Open Add Bag',
                pageUrl: 'dashboard/add-baggage'
            };
        };
        AddBaggage.prototype.canAddOption = function (optionsData) {
            return !!(optionsData && optionsData.CanAddBags);
        };
        return AddBaggage;
    }(Dashboard.AddOption));
    angular
        .module('dashboard')
        .controller('AddBaggage', AddBaggage);
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('ContactDetail', ContactDetail);
    function ContactDetail($routeParams, $rootScope, $location, $q, dashboardBookingService, deliveryAddressService, resourceService, mybTrack) {
        var cm = this;
        cm.updateDeliveryAddressWithlLeadContact = true;
        cm.bookingId = $routeParams.bookingId ? parseInt($routeParams.bookingId) : 0;
        cm.user = $rootScope.user;
        cm.isContactSaved = false;
        cm.bookingType = dashboardBookingService.getBookingTypeMap();
        cm.cancelContactChange = cancelContactChange;
        mybTrack.track('MYB - Open Contact Details');
        cm.updateContactDetails = function () {
            var putContact = dashboardBookingService.putContact(cm.bookingId, cm.ContactDetails, cm.updateRelatedBooking);
            var putDeliveryAddress = cm.requireDeliverAddress ? deliveryAddressService.put(cm.bookingId, cm.updateDeliveryAddressWithlLeadContact ? cm.ContactDetails : cm.DeliveryAddress) : null;
            $q.all([putContact, putDeliveryAddress]).then(function () {
                cm.isContactSaved = true;
            }, function () {
                $rootScope.$broadcast('flash:error', resourceService.get('CONTACTSAVEDERROR'));
                cm.isContactSaved = false;
            });
        };
        dashboardBookingService.getContact(cm.bookingId).then(function (contactDetail) {
            cm.ContactDetails = contactDetail.data;
        });
        function _processDeliveryAddress(bookingType) {
            if (bookingType === cm.bookingType.attraction) {
                //Require delivery address only for attractions
                cm.requireDeliverAddress = true;
                deliveryAddressService.get(cm.bookingId).then(function (deliveryAddress) {
                    cm.DeliveryAddress = deliveryAddress.data;
                    //Setting this to true, only if on load, delivery address is matched with contact address.
                    cm.updateDeliveryAddressWithlLeadContact = _.isMatch(cm.ContactDetails, cm.DeliveryAddress);
                });
            }
        }
        dashboardBookingService.getOutstandingTrips(null, $routeParams.bookingId).then(function (trips) {
            var trip = trips && trips.length > 0 ? trips[0] : null;
            cm.hasLinkedBookings = trip.Bookings.length > 1;
            var bookingInfo = cm.hasLinkedBookings ? _.find(trip.Bookings, function (b) { return b.BookingId === cm.bookingId; }) : trip.Bookings.length > 0 ? trip.Bookings[0] : null;
            _processDeliveryAddress(bookingInfo.Type);
            cm.bk = bookingInfo;
            cm.leadPassenegr = { FirstName: bookingInfo.LeadPassengerFirstName, LastName: bookingInfo.LeadPassengerLastName };
        });
        function cancelContactChange() {
            $location.path("dashboard/bookings/reference/" + cm.bookingId);
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('Csr', Csr);
    function Csr($routeParams, $location, $timeout, dashboardCsrService, dashboardBookingService, bookingsManagerService, resourceService, broker, mybTrack) {
        var cm = this;
        cm.bookingId = $routeParams.bookingId;
        cm.getCSRStatus = dashboardCsrService.getCSRStatus;
        cm.getResourceValue = function (resource) { return resourceService.get(resource); };
        cm.next = next;
        cm.previous = previous;
        cm.createCsr = createCsr;
        cm.currentStep = 2;
        cm.view = view;
        cm.resetCsrForm = resetCsrForm;
        cm.goToCreateCsr = goToCreateCsr;
        cm.CsrFaqCheckEnabled = TRPCONFIG.Domain.CsrFaqCheckEnabled;
        cm.csrCategoryChanged = csrCategoryChanged;
        cm.returnUrl = "/dashboard/csr/" + cm.bookingId;
        cm.baseUrl = '/dashboard';
        cm.disableFaq = TRPCONFIG.Domain.DisableFAQs;
        cm.isInProgress = false;
        mybTrack.track('MYB - Open CSR');
        function _linkCSR(csrs) {
            cm.csr = csrs;
            cm.allCsr = csrs.pending.concat(csrs.completed);
        }
        function _rejectCSR() {
            $location.path('dashboard/bookings/current');
        }
        dashboardCsrService.getCSRSummary(cm.bookingId).then(_linkCSR, _rejectCSR);
        dashboardBookingService.getBookingInfo(cm.bookingId).then(function (booking) {
            cm.bk = booking;
            dashboardCsrService.getCsrCategories(booking.Type, cm.bookingId).then(function (categories) {
                cm.csrCategories = categories;
                if (TRPCONFIG.Domain.HideCancelCSRForAutoCancellableBooking) {
                    var csrCancelId_1 = TRPCONFIG.Domain.CancelCSRId || 3;
                    bookingsManagerService.getCancellationOptions(booking.BookingId).then(function (booking) {
                        if (booking.CanAutoCancel) {
                            $timeout(function () {
                                cm.csrCategories = _.filter(categories, function (c) {
                                    return c.Id !== csrCancelId_1;
                                });
                            });
                        }
                    });
                }
                if ($routeParams.id) {
                    cm.newCsr.Category = _.find(cm.csrCategories, function (c) { return c.Id === parseInt($routeParams.id); });
                    csrCategoryChanged();
                }
            });
            cm.newCsr = {};
            cm.newCsr.TextAlerts = TRPCONFIG.Domain.CsrTextAlertsEnabled;
            cm.childActions = dashboardBookingService.getChildActions(booking.BookingOptions.Actions, 'CSR');
        });
        dashboardBookingService.getContact(cm.bookingId).then(function (contactDetail) {
            cm.ContactDetails = contactDetail.data;
        });
        function resetCsrForm() {
            cm.newCsr = {};
            cm.newCsr.TextAlerts = TRPCONFIG.Domain.CsrTextAlertsEnabled;
        }
        function next() {
            cm.currentStep++;
        }
        function previous() {
            cm.currentStep--;
        }
        function createCsr() {
            cm.isInProgress = true;
            var csrTrackingData = {
                CategoryId: cm.newCsr.Category.Id,
                CategoryText: cm.newCsr.Category.Text,
                TextAlert: !!cm.newCsr.TextAlerts
            };
            mybTrack.track('MYB - CSR', csrTrackingData);
            dashboardCsrService.createCsr(cm.newCsr, cm.bookingId, cm.ContactDetails.MobileTel).then(function (data) {
                //if text alert is selected // update contact details.
                if (cm.newCsr.TextAlerts) {
                    dashboardBookingService.putContact(cm.bookingId, cm.ContactDetails).then(function () { return cm.isInProgress = false; });
                }
                else {
                    cm.isInProgress = false;
                }
                cm.newCsr.csrId = data.Id;
                next();
                broker.publish('csrRaised');
                cm.csrCreated = true;
            });
        }
        function view(csr) {
            $location.path(cm.baseUrl + "/csr-details/" + csr.BookingId + "/" + csr.CsrId);
        }
        function goToCreateCsr(couldNotFindAnswer) {
            if (cm.CsrFaqCheckEnabled && !couldNotFindAnswer) {
                return false;
            }
            $location.path("dashboard/create-csr/" + cm.bookingId);
        }
        function csrCategoryChanged() {
            cm.newCsr.Subject = cm.newCsr.Category.Text;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('CsrDetails', CsrDetails);
    function CsrDetails($routeParams, dashboardCsrService) {
        var cm = this;
        cm.getCSRStatus = function (status) { return dashboardCsrService.getCSRStatus(status); };
        cm.bookingId = $routeParams.bookingId;
        cm.getCsrStatusClass = function (status) { return dashboardCsrService.getCsrStatusClass(status); };
        cm.returnUrl = "/dashboard/csr/" + cm.bookingId;
        dashboardCsrService.getCSRDetail($routeParams.csrId).then(function (res) {
            cm.csrDetails = res;
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('DashboardBookings', DashboardBookings);
    function DashboardBookings(currentUser, $location, $interpolate, dashboardBookingService, $routeParams, resourceService, dateUtil, crossSellService, onlineCheckinService, preferences, dashboardBookingsErrorMessage, dashboardNotificationService, scrollService, $q, imageService, mybTrack, dashboardCsrService, enumService) {
        if (!$routeParams.bookingId && $routeParams.bookingPeriod !== 'current' && $routeParams.bookingPeriod !== 'previous') {
            $location.path('dashboard/bookings/current');
        }
        var cm = this;
        if ($routeParams.selectBooking) {
            cm.selectBooking = true;
            cm.bookingSelected = bookingSelected;
            cm.redirectUrlPostBookingSelect = $routeParams.redirectUrlPostBookingSelect;
            cm.previousBookings = "dashboard/bookings/previous/selectbooking/" + cm.redirectUrlPostBookingSelect;
            cm.currentBookings = "dashboard/bookings/current/selectbooking/" + cm.redirectUrlPostBookingSelect;
        }
        else {
            cm.previousBookings = 'dashboard/bookings/previous';
            cm.currentBookings = 'dashboard/bookings/current';
        }
        cm.user = currentUser.get();
        cm.translateActionLink = translateActionLink;
        cm.limitBooking = dashboardBookingService.getLimitBooking();
        cm.next = next;
        cm.actionLink = dashboardBookingService.getActionLinks();
        cm.getResourceValue = function (resource) { return resourceService.get(resource); };
        cm.setExpandedTrip = setExpandedTrip;
        cm.addDays = dateUtil.todayPlus;
        cm.bookCrossSell = bookCrossSell;
        cm.bookingType = dashboardBookingService.getBookingTypeMap();
        cm.formatBookingMessage = dashboardBookingService.formatBookingMessage;
        cm.getCrossSellTeaserText = getCrossSellTeaserText;
        cm.getCrossSellStartingFromText = getCrossSellStartingFromText;
        cm.getTripTitle = dashboardBookingService.getTripTitle;
        cm.getCrossSellTitle = getCrossSellTitle;
        cm.getTripDateText = dashboardBookingService.getTripDateText;
        cm.actionClick = dashboardBookingService.actionClick;
        cm.getFuturePayments = dashboardBookingService.getFuturePayments;
        var pageSize = 10;
        cm.bookingStatus = dashboardBookingService.getBookingStatus();
        cm.loadingBooking = true;
        var trackEvent = {
            current: 'MYB - Current Booking',
            previous: 'MYB - Previous Booking'
        };
        if (trackEvent[$routeParams.bookingPeriod]) {
            mybTrack.track(trackEvent[$routeParams.bookingPeriod]);
        }
        $q.all([
            preferences.get('canceledBooking'),
            dashboardBookingService.getOutstandingTrips($routeParams.bookingPeriod, $routeParams.bookingId, true)
        ]).then(function (results) {
            var showCanceledBookings = results[0];
            cm.loadingBooking = false;
            cm.trips = results[1];
            if (showCanceledBookings === false) {
                cm.trips = dashboardBookingService.removeCanceledBookings(cm.trips);
            }
            if (TRPCONFIG.Domain.FlightCheckinEnabled && $routeParams.bookingPeriod === 'current') {
                onlineCheckinService.addCheckinData(cm.trips);
            }
            cm.bookingNotYoursId = dashboardBookingsErrorMessage.getMessage();
            if (cm.bookingNotYoursId) {
                cm.bookingNotYours = true;
            }
            bookingConfirmed();
            dashboardCsrService.addCsrToBooking(cm.trips);
        });
        //Notifications
        cm.notificationClicked = function (notification) { return dashboardNotificationService.notificationClicked(notification); };
        cm.formatNotification = function (notification) { return dashboardNotificationService.formatNotification(notification); };
        //End notifications
        function translateActionLink(link, booking) {
            return link ? $interpolate(link)(booking) : '';
        }
        function next() {
            cm.limitBooking += pageSize;
            dashboardBookingService.setLimitBooking(cm.limitBooking);
        }
        function setExpandedTrip(tr, $event) {
            if (!tr.isExpanded) {
                tr.isExpanded = true;
                cm.trips.forEach(function (t) {
                    t.isExpanded = (t.TripId === tr.TripId);
                });
                scrollService.scrollTo($event.target, { animate: true });
                var flightBooking_1 = _.find(tr.Bookings, function (b) { return b.Type === 1; });
                crossSellService.addExtrasAndCrossSells(tr);
                if (flightBooking_1 && !flightBooking_1.ObjectId) {
                    dashboardBookingService.getObjectFromBooking(flightBooking_1.BookingId).then(function (obj) {
                        return flightBooking_1.ImageUrl = imageService.getDestinationImage(obj, 300, 190);
                    });
                }
            }
        }
        function bookCrossSell(trip, crossSell) {
            if (crossSell) {
                mybTrack.track('MYB - Cross Sell Click', {
                    ProductType: crossSell.Code
                });
            }
            if (crossSell.CrossSellType === enumService.CrossSellType.Seats ||
                crossSell.CrossSellType === enumService.CrossSellType.Baggage) {
                if (cm.actionLink) {
                    var path = cm.translateActionLink(cm.actionLink[crossSell.Name], { BookingId: crossSell.BookingId });
                    $location.url(path);
                }
            }
            else {
                crossSellService.startCrossSellJourney(trip.Bookings[0].BookingId, crossSell);
            }
        }
        function bookingConfirmed() {
            var isConfirmed = false;
            if (cm.trips.length > 0 && cm.trips[0].Bookings.length > 0) {
                isConfirmed = cm.trips[0].Bookings[0].Status === 1;
            }
            mybTrack.track('MYB - Booking Dashboard', {
                Reciepted: isConfirmed
            });
        }
        function bookingSelected(bookingId) {
            $location.path("dashboard/" + cm.redirectUrlPostBookingSelect + "/" + bookingId);
        }
        function getCrossSellTeaserText(productType) {
            return resourceService.get(productType.toUpperCase() + "_CROSSSELL_TEASER");
        }
        function getCrossSellStartingFromText(productType) {
            return resourceService.get(productType.toUpperCase() + "_CROSSSELL_STARTING_FROM");
        }
        function getCrossSellTitle(productType) {
            return resourceService.get(productType.toUpperCase() + "_CROSSSELL_TITLE");
        }
    }
})();
var Dashboard;
(function (Dashboard) {
    var DashboardBookingDetails = /** @class */ (function () {
        function DashboardBookingDetails($routeParams, dashboardBookingService, imageService, dateUtil, resourceService, paymentsService, mybTrack, authService) {
            this.$routeParams = $routeParams;
            this.dashboardBookingService = dashboardBookingService;
            this.imageService = imageService;
            this.dateUtil = dateUtil;
            this.resourceService = resourceService;
            this.paymentsService = paymentsService;
            this.mybTrack = mybTrack;
            this.authService = authService;
            this.bookingId = parseInt($routeParams['bookingId'], 10);
            this.bookingTypeMap = dashboardBookingService.getBookingTypeMap();
            this.bookingInfoItemType = dashboardBookingService.getBookingInfoItemType();
            this.getBookingInfo();
            this.getBookingDetail();
        }
        DashboardBookingDetails.prototype.getBookingInfo = function () {
            var _this = this;
            this.dashboardBookingService.getBookingInfo(this.bookingId)
                .then(function (booking) {
                _this.booking = booking;
                _this.pah = _this.dashboardBookingService.getPahFromNotifications(booking.Notifications);
                if (booking.BookingOptions && booking.BookingOptions.Actions) {
                    _this.childActions = _this.dashboardBookingService
                        .getChildActions(booking.BookingOptions.Actions, 'VIEWBOOKINGDETAILS');
                }
            });
        };
        DashboardBookingDetails.prototype.resendEmailToLead = function () {
            var _this = this;
            this.dashboardBookingService.sendConfirmationEmail([this.leadPassengerEmail], this.bookingId).then(function (res) {
                _this.emailSent = true;
                _this.mybTrack.track('MYB - Resend Email');
            });
            ;
        };
        DashboardBookingDetails.prototype.getBookingDetail = function () {
            var _this = this;
            this.dashboardBookingService.getBookingDetail(this.bookingId, true)
                .then(function (data) {
                _this.bk = data;
                _this.leadPassengerEmail = data.LeadPassenger.Email;
                _this.template = data.Itineraries ?
                    "partials/dashboard/ItineraryTemplate?Type=" + data.Booking.LongType.template : null;
                _this.displaySupplierRef = data.BalanceDueInfo ?
                    !(data.Booking.Type === 1 && data.BalanceDueInfo.BalanceDueAmount >
                        TRPCONFIG.Domain.SupplierRefBalanceThreshold) : true;
                if (data.BookedItemAndPackageCost) {
                    _this.packageCost = (TRPCONFIG.Domain.PackagePrice || data.PackageId)
                        && data.BookedItemAndPackageCost.PackageCost;
                    _this.isAtolProtectedBooking = data.BookedItemAndPackageCost.IsAtolProtected;
                    _this.bookedItems = data.BookedItemAndPackageCost.BookedItems;
                }
                _this.mybTrack.track('MYB - View Booking Details', {
                    PaidInFull: _this.bk.BalanceDueInfo === null ? true : false
                });
                _.forEach(_this.bk.ClearedPayments, function (p) {
                    p.LogoName = _.first(_this.paymentsService.getLogosList([{ Title: p.CardTypeTitle }])) || 'external';
                });
            });
        };
        DashboardBookingDetails.prototype.actionClick = function (action, bk) {
            this.dashboardBookingService.actionClick(action, bk);
        };
        DashboardBookingDetails.prototype.getResourceValue = function (resource) {
            return this.resourceService.get(resource);
        };
        DashboardBookingDetails.prototype.getPaymentTitle = function (payment) {
            return "" + (payment.CardTypeTitle != null ?
                payment.CardTypeTitle : payment.Title != null ? payment.Title : '');
        };
        DashboardBookingDetails.prototype.signOut = function () {
            this.authService.signOut();
        };
        return DashboardBookingDetails;
    }());
    Dashboard.DashboardBookingDetails = DashboardBookingDetails;
    angular
        .module('dashboard')
        .controller('DashboardBookingDetails', DashboardBookingDetails);
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('ResendVoucher', ResendVoucher);
    function ResendVoucher(dashboardBookingService, $routeParams, $rootScope, resourceService) {
        var cm = this;
        var bookingId = $routeParams.bookingId;
        cm.sendConfirmationEmail = sendConfirmationEmail;
        var validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        dashboardBookingService.getContact(bookingId).then(function (contactDetail) {
            cm.Emails = contactDetail.data.Email;
        });
        dashboardBookingService.getBookingInfo(bookingId).then(function (booking) {
            cm.bk = booking;
        });
        function sendConfirmationEmail() {
            var emailsArray = cm.Emails.split(',');
            for (var i = emailsArray.length - 1; i >= 0; i--) {
                var email = emailsArray[i].trim();
                if (!validEmail.test(email)) {
                    $rootScope.$broadcast('flash:error', String.format(resourceService.get('VOUCHERINVALID'), email));
                    return;
                }
            }
            dashboardBookingService.sendConfirmationEmail(emailsArray, bookingId).then(function () {
                //$rootScope.$broadcast('flash:success', resourceService.get('VOUCHERSENT'));
                cm.isEmailSent = true;
            }, function () {
                $rootScope.$broadcast('flash:error', resourceService.get('VOUCHERSENTERROR'));
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('DashboardReview', DashboardReview);
    function DashboardReview($q, $location, $routeParams, dashboardService, dashboardReviewService, dashboardBookingService, preferences, dateUtil, imageService, reviewService, scrollService, broker, action, resourceService, mybTrack, currentUser) {
        var cm = this;
        cm.bookingReviewStatus = {
            CannotLeaveReview: 0,
            CanLeaveReview: 1,
            HasLeftReview: 2
        };
        cm.showMoreReviews = showMoreReviews;
        cm.getRatingTitleText = getRatingTitleText;
        cm.saveReview = saveReview;
        cm.editReview = dashboardReviewService.editReview;
        cm.ratingRange = dashboardReviewService.ratingRange;
        cm.sutabilityAnswers = dashboardReviewService.sutabilityAnswers;
        cm.recommendTRPAnswers = dashboardReviewService.recommendTRPAnswers;
        cm.recommendTRPChange = dashboardReviewService.recommendTRPChange;
        cm.reviewLater = reviewLater;
        cm.reviews = [];
        cm.limitToNumber = 10;
        cm.reviewsPage = 0; //--for client pagination
        cm.loadingReviews = true;
        cm.loadingHotelReviews = true;
        cm.reviewsVisibleCount = 0;
        cm.sortOptions = dashboardReviewService.getReviewSortCriteria();
        cm.getResourceValue = function (resource) { return resourceService.get(resource); };
        cm.showBookingBreadcrumb = 'review-hotel' === action;
        cm.bookingType = dashboardBookingService.getBookingTypeMap();
        cm.hideHotelHeader = true;
        if (action !== 'review-submitted') {
            mybTrack.track('MYB - My Reviews');
            var urlSource = $location.search().source ? $location.search().source : 'MYB';
            if (!($routeParams.userId && $routeParams.token && urlSource === 'MYB')) {
                // the extra condition is a work around, because url from email reloads the page twice,
                // so to ignore the tracking in second reload, using this condition, Will remove the condition when the reloading issue is fixed
                mybTrack.track('HotelReviewForm Landing', { source: urlSource });
            }
        }
        $q.all([dashboardReviewService.getRatingTitles(), dashboardReviewService.getStatements()]).then(function () {
            cm.reviewEnable = true;
            var objectId = $routeParams.objectId;
            if (action === 'review-hotel') {
                //not great but we want to follow a slightly different path if we are doing a non authenticated booking
                if ($routeParams.bookingId && $routeParams.userId && $routeParams.token) {
                    //we need to have a booking id, user id and token
                    _checkEnterReviewPage($routeParams.bookingId, $routeParams.token, $routeParams.userId);
                    $location.search({});
                    cm.showBookingBreadcrumb = false;
                }
                else {
                    _checkEnterReviewPage($routeParams.bookingId, null, null);
                }
            }
            else if (action === 'review-submitted' && !objectId) {
                dashboardBookingService.getBookingInfo($routeParams.bookingId).then(function (bk) {
                    if (bk.Type === cm.bookingType.accommodation) {
                        _reviewPageFactory(bk.ObjectId, $routeParams.bookingId, null, null);
                    }
                    else {
                        cm.reviewStatus = cm.bookingReviewStatus.CannotLeaveReview;
                        cm.notHotelBooking = true;
                    }
                });
            }
            else {
                _reviewPageFactory(objectId, $routeParams.bookingId, null, null);
            }
        });
        //for default sort by likes
        cm.sortoption = cm.sortOptions[1].val;
        cm.showUnreviewedHotels = true;
        cm.reviewNow = reviewNow;
        cm.cancelReview = cancelReview;
        cm.selectVisitedHotel = selectVisitedHotel;
        function _reviewPageFactory(objectId, bookingId) {
            var user = currentUser.get();
            if (action === 'review-submitted') {
                _prepareReviewCompletePage(bookingId, objectId);
            }
            else if (user && user.HardSignedIn) {
                _processDashboardAggregateData();
            }
            else {
                _errorCallback();
            }
        }
        function _errorCallback() {
            cm.loadingReviews = false;
            cm.reviewsLoadError = true;
        }
        function _checkEnterReviewPage(bookingId, token, userId) {
            var dim = TRPCONFIG.DeviceSettings.LandingImageHeight;
            var processData = function (data) {
                //do some checks to make sure the review hasn't already been submitted / they can leave a review
                var getSelectedHotelInfo = function (reviewData) {
                    var estabId = reviewData.EstabId;
                    return dashboardService.getHotelsById([estabId]).then(function (hotels) {
                        return {
                            EstablishmentDetail: hotels[0],
                            ImageUrl: imageService.getMainImageUrl(estabId, dim, dim),
                            BookingDetail: {
                                StartDate: reviewData.CheckInDate,
                                BookingRef: reviewData.BookingRef,
                                BookingId: bookingId,
                                LeadPassengerContact: {
                                    Title: reviewData.LeadContact.Title,
                                    FirstName: reviewData.LeadContact.FirstName,
                                    Surname: reviewData.LeadContact.LastName
                                }
                            },
                            reviewSaved: false
                        };
                    });
                };
                var status = data.ReviewStatus;
                if (status === reviewService.reviewStatus.CanLeaveReview) {
                    getSelectedHotelInfo(data).then(function (selectedHotel) {
                        cm.selectedHotel = selectedHotel;
                        cm.feedback = dashboardReviewService.getBookingFeedback();
                        cm.hideHotelHeader = false;
                    });
                }
                else if (status === reviewService.reviewStatus.HasLeftReview) {
                    var user = currentUser.get();
                    if (user && user.SignedIn) {
                        $q.all([
                            dashboardReviewService.getReview(bookingId),
                            getSelectedHotelInfo(data)
                        ]).then(function (results) {
                            cm.existingReview = results[0];
                            cm.selectedHotel = results[1];
                            cm.hideHotelHeader = false;
                        });
                    }
                }
                cm.reviewStatus = status;
            };
            //we need to make different calls depending on what params we have
            if (token && userId) {
                reviewService.getReviewDetailsUsingToken(bookingId, token, userId).then(function (d) { return processData(d); });
            }
            else {
                reviewService.getReviewDetails(bookingId).then(function (d) { return processData(d); });
            }
        }
        function _prepareReviewHeader(bookingId, objectId) {
            dashboardReviewService.getReviewHeaderData(bookingId, objectId).then(function (result) {
                cm.loadingReviewHeader = false;
                cm.selectedHotel = result;
                if (!cm.selectedHotel.EstablishmentDetail) {
                    $location.path('dashboard/reviews');
                }
            });
        }
        function _processDashboardAggregateData() {
            dashboardService.getAggregate().then(function (result) {
                _splitByReviewed(result);
                cm.reviewsVisibleCount = ((cm.reviews.length / cm.limitToNumber) > 1 ? cm.limitToNumber : cm.reviews.length);
                _prepareMyReviewPageData(cm.unreviewedHotels[0]);
            }, _errorCallback);
        }
        function _prepareMyReviewPageData(unreviewedHotel) {
            if (unreviewedHotel) {
                _canShowUnreviewedHotels().then(function (result) {
                    cm.loadingReviews = false;
                    cm.showUnreviewedHotels = result;
                    cm.selectedHotel = unreviewedHotel;
                    cm.selectedHotel.BookingDetail.BookingRef = cm.selectedHotel.BookingDetail.BookingType + "/" + cm.selectedHotel.BookingDetail.BookingId;
                    cm.feedback = dashboardReviewService.getBookingFeedback();
                    cm.selectedHotelIndex = 0;
                    cm.reviewStatus = cm.bookingReviewStatus.CanLeaveReview;
                    cm.reviewLaterEnable = true;
                    cm.hideHotelHeader = false;
                }, _errorCallback);
            }
            else {
                cm.loadingReviews = false;
            }
        }
        function _prepareReviewCompletePage(bookingId, objectId) {
            if (bookingId) {
                //get review site details
                dashboardReviewService.getReviewSiteDetails(bookingId).then(function (result) {
                    cm.reviewSiteDetails = result;
                    cm.reviewSiteDetails.Image = "/build/img/otherlogo" + result.Image.substr(result.Image.lastIndexOf('/'));
                });
                if (objectId) {
                    _prepareReviewHeader(bookingId, objectId);
                    reviewService.getReviews({ Id: objectId }, 0).then(function (result) {
                        cm.hotelReviews = result.reviews;
                        cm.loadingHotelReviews = false;
                    });
                }
            }
        }
        function saveReview() {
            dashboardReviewService.saveReview(cm.selectedHotel, cm.feedback, $routeParams.token, $routeParams.userId)
                .then(function (result) {
                if (result) {
                    broker.publish('reviewEntered');
                    mybTrack.track('MYB - Review submitted', { UserRating: cm.feedback.rating });
                    //goto submitted review page
                    $location.path("dashboard/reviews/submitted/" + cm.selectedHotel.BookingDetail.BookingId + "/" + cm.selectedHotel.EstablishmentDetail.Id);
                }
                else {
                    scrollService.scrollTo('#reviews-container');
                }
            });
        }
        function _splitByReviewed(aggregate) {
            //Reviewed Hotels
            cm.reviews = aggregate.reviews;
            cm.ReviewAggregates = {
                TotalReviews: cm.reviews.length,
                TotalLikeCount: countLikes()
            };
            //Unreviewed Hotels
            aggregate.estabs.UnreviewedHotels.sort(_dateSortReview);
            cm.unreviewedHotels = angular.copy(aggregate.estabs.UnreviewedHotels);
            cm.reviewedHotels = angular.copy(aggregate.estabs.ReviewedHotels);
        }
        function _dateSortReview(a, b) {
            var aDate = new Date(a.BookingDetail.EndDate);
            var bDate = new Date(b.BookingDetail.EndDate);
            return aDate >= bDate ? -1 : aDate < bDate ? 1 : 0;
        }
        function countLikes() {
            var likeCount = 0;
            angular.forEach(cm.reviews, function (review) {
                likeCount += review.LikeCount;
            });
            return likeCount;
        }
        function showMoreReviews() {
            cm.reviewsPage += 1;
            var count = cm.limitToNumber * (cm.reviewsPage + 1);
            cm.reviewsVisibleCount = ((cm.reviews.length / count) > 1 ? (count) : cm.reviews.length);
        }
        function getRatingTitleText(n) {
            return dashboardReviewService.getRatingTitleText(n);
        }
        function _canShowUnreviewedHotels() {
            return preferences.get('reviewReminder').then(function (reminderDate) {
                return !(reminderDate && dateUtil.parseDate(reminderDate) > new Date());
            });
        }
        function reviewLater() {
            cm.showUnreviewedHotels = false;
            var dt = dateUtil.todayPlus(0, TRPCONFIG.Domain.ReviewReminderHours, true);
            preferences.set('reviewReminder', dt);
            scrollService.scrollTo('#reviews-container');
        }
        function reviewNow() {
            $location.path("review-hotel/" + cm.selectedHotel.BookingDetail.BookingId);
        }
        function cancelReview() {
            $location.path('dashboard/reviews');
        }
        function selectVisitedHotel(index) {
            cm.selectedHotel = cm.unreviewedHotels[index];
            cm.selectedHotelIndex = index;
        }
    }
})();
var Dashboard;
(function (Dashboard) {
    var DashboardSeatSelection = /** @class */ (function (_super) {
        __extends(DashboardSeatSelection, _super);
        function DashboardSeatSelection($location, $q, $routeParams, $scope, $window, broker, customCurrencyFilter, dashboardBookingService, flightExtrasService, mybTrack, paymentDetailsService, paymentsService, paymentsUtilService, resourceService, rootPath, urlUtils, dateUtil, currentUser) {
            var _this = _super.call(this, $location, $q, $routeParams, $scope, $window, broker, customCurrencyFilter, dashboardBookingService, flightExtrasService, mybTrack, paymentDetailsService, paymentsService, paymentsUtilService, resourceService, rootPath, urlUtils, dateUtil, currentUser) || this;
            _this.$location = $location;
            _this.$q = $q;
            _this.$routeParams = $routeParams;
            _this.$scope = $scope;
            _this.$window = $window;
            _this.broker = broker;
            _this.customCurrencyFilter = customCurrencyFilter;
            _this.dashboardBookingService = dashboardBookingService;
            _this.flightExtrasService = flightExtrasService;
            _this.mybTrack = mybTrack;
            _this.paymentDetailsService = paymentDetailsService;
            _this.paymentsService = paymentsService;
            _this.paymentsUtilService = paymentsUtilService;
            _this.resourceService = resourceService;
            _this.rootPath = rootPath;
            _this.urlUtils = urlUtils;
            _this.dateUtil = dateUtil;
            _this.currentUser = currentUser;
            return _this;
        }
        DashboardSeatSelection.prototype.selectSeats = function (seats, seatsPostAdd) {
            this.selectedSeats = seatsPostAdd;
        };
        DashboardSeatSelection.prototype.getSelectedSeats = function () {
            return [];
        };
        DashboardSeatSelection.prototype.analyticsTrackOpenOption = function () {
            this.mybTrack.track('MYB - Add Seats Payment', {
                PaymentMethod: this.paymentMethodText[this.paymentTab] || '',
                Source: this.$routeParams.source === 'noneml' ? 'email' : 'cross-Sell',
                SuplierIds: this.supplierIds
            });
        };
        DashboardSeatSelection.prototype.getConfig = function () {
            return {
                completeUrl: 'dashboard/seat-selection/complete/{0}',
                optionsType: 'SeatPlan',
                availableOptionsBinding: 'seatPlan',
                selectedOptionsBinding: 'selectedSeats',
                selectedOptionsRequest: 'SelectedSeats',
                analyticsTag: 'MYB - Open Add Seats',
                pageUrl: 'dashboard/seat-selection'
            };
        };
        DashboardSeatSelection.prototype.canAddOption = function (optionsData) {
            return !!(optionsData && optionsData.CanAddSeats);
        };
        return DashboardSeatSelection;
    }(Dashboard.AddOption));
    angular
        .module('dashboard')
        .controller('DashboardSeatSelection', DashboardSeatSelection);
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('DashboardSettings', Settings);
    function Settings($rootScope, $scope, userSettingsService, preferences, currentUser, authService, resourceService, arrayUtil, broker, paymentDetailsService, paymentsService, tokeniser, $timeout, $q, mybTrack) {
        var cm = this;
        var thisYear = new Date().getFullYear();
        var confirmed = false;
        cm.starRatings = userSettingsService.getStarRatings();
        cm.smokingRoom = userSettingsService.getSmokingRoomOptions();
        cm.footerToolbar = userSettingsService.getFooterToolbarOptions();
        cm.flightClass = userSettingsService.getFlightClassOptions();
        cm.hotelSortOrder = userSettingsService.getHotelCriteria();
        cm.flightSortOrder = userSettingsService.getFlightCriteria();
        cm.priceMode = userSettingsService.getPricMode();
        cm.titles = userSettingsService.getAdultTitles();
        cm.canceledBooking = userSettingsService.getCanceledBookingOprions();
        cm.savePreferences = saveUserPreferences;
        cm.cancelPreferences = cancelPreferences;
        cm.openChangePasswordPanel = openChangePasswordPanel;
        cm.closeChangePassword = closeChangePassword;
        cm.openChangeEmailPanel = openChangeEmailPanel;
        cm.changeContactDetails = changeContactDetails;
        cm.openEditContact = openEditContact;
        cm.changeEmail = changeEmail;
        cm.closeChangeEmail = closeChangeEmail;
        cm.changePassword = changePassword;
        cm.confirmRemoveCard = confirmRemoveCard;
        cm.closeEditRemoveCard = closeEditRemoveCard;
        cm.addCardDetails = addCardDetails;
        cm.addNewCard = addNewCard;
        cm.removeCard = removeCard;
        cm.cancelLoginDetailsChange = cancelLoginDetailsChange;
        cm.user = $rootScope.user;
        cm.months = arrayUtil.numberArray(1, 12);
        cm.years = arrayUtil.numberArray(thisYear, thisYear + 20);
        cm.deleteAccount = deleteAccount;
        cm.deleteButton = resourceService.getDeferred('DELETEACCOUNT');
        cm.deleteAccountConfirmed = deleteAccountConfirmed;
        cm.closeConfirmDeleteAccount = closeConfirmDeleteAccount;
        cm.showConfirmDeleteAccount = showConfirmDeleteAccount;
        cm.padZero = padZero;
        cm.getResourceValue = function (resource) { return resourceService.get(resource); };
        var prefrenceOptionsMap = {
            starRatings: cm.starRatings,
            flightSortOrder: cm.flightSortOrder,
            hotelSortOrder: cm.hotelSortOrder,
            smokingRoom: cm.smokingRoom,
            priceMode: cm.priceMode,
            footerToolbar: cm.footerToolbar,
            flightClass: cm.flightClass,
            canceledBooking: cm.canceledBooking
        };
        var savedFrom = {
            SettingsTab: 1,
            BookingForm: 2
        };
        var userPreferenceBeforeChange = null;
        mybTrack.track('MYB - My Settings');
        function getPreferences() {
            var prefs = {};
            prefs.starRatings = cm.starRatings[0];
            prefs.flightSortOrder = cm.flightSortOrder[0];
            prefs.hotelSortOrder = cm.hotelSortOrder[0];
            prefs.smokingRoom = cm.smokingRoom[0];
            prefs.footerToolbar = cm.footerToolbar[1];
            prefs.priceMode = cm.priceMode[0];
            prefs.flightClass = cm.flightClass[0];
            prefs.canceledBooking = cm.smokingRoom[1];
            return preferences.getAllPreferences(cm.user).then(function (result) {
                prefs = organiseUserPreferenceData(prefs, result);
                userPreferenceBeforeChange = angular.copy(prefs);
                return prefs;
            });
        }
        getPreferences().then(function (p) { cm.userPreferences = p; });
        function savePreferences(prefs) {
            var prefsToBeSaved = {};
            angular.forEach(prefs, function (v, k) {
                prefsToBeSaved[k] = v.val instanceof Array ? v.val[0] : v.val;
            });
            preferences.setAllPreferences(prefsToBeSaved, cm.user).then(function () {
                cm.userPreferences = organiseUserPreferenceData(cm.userPreferences, prefsToBeSaved);
                userPreferenceBeforeChange = angular.copy(cm.userPreferences);
                cm.editHotelPref = false;
                cm.editFlightPref = false;
                cm.editSitePref = false;
            });
        }
        function saveUserPreferences() {
            if (cm.userPreferences.footerToolbar !== userPreferenceBeforeChange.footerToolbar) {
                broker.publish('footerToolbarChanged', cm.userPreferences.footerToolbar.val);
            }
            savePreferences(cm.userPreferences);
        }
        function cancelPreferences() {
            angular.forEach((userPreferenceBeforeChange), function (value, key) {
                var arrayToLook = prefrenceOptionsMap[key];
                var index = arrayUtil.indexOf(arrayToLook, function (item) {
                    var itemVal = item.val instanceof Array ? item.val[0] : item.val;
                    var valueVal = value.val instanceof Array ? value.val[0] : value.val;
                    return itemVal === valueVal;
                });
                cm.userPreferences[key] = arrayToLook[index];
            });
            cm.editHotelPref = false;
            cm.editFlightPref = false;
            cm.editSitePref = false;
        }
        function organiseUserPreferenceData(prefs, userPreferences) {
            for (var key in prefs) {
                setModelForPreference(key, prefs, userPreferences);
            }
            return prefs;
        }
        function setModelForPreference(key, prefs, userPreferences) {
            var arrayToLook = prefrenceOptionsMap[key];
            if (arrayToLook && userPreferences[key] !== undefined) {
                for (var i = 0; i < arrayToLook.length; i++) {
                    var checkVal = arrayToLook[i].val instanceof Array ? arrayToLook[i].val[0] : arrayToLook[i].val;
                    if (userPreferences[key].toString() === checkVal.toString()) {
                        prefs[key] = arrayToLook[i];
                        break;
                    }
                }
            }
            else if (arrayToLook) {
                prefs[key] = arrayToLook[0];
            }
        }
        function openChangePasswordPanel() {
            cm.showChangePassword = true;
        }
        function closeChangePassword() {
            cm.showChangePassword = false;
        }
        function openChangeEmailPanel() {
            cm.userEdit = angular.copy(cm.user);
            cm.showChangeEmail = true;
        }
        function closeChangeEmail() {
            cm.showChangeEmail = false;
        }
        function changeContactDetails() {
            authService.changeContactDetails(cm.userEdit).then(function () {
                cm.editContact = false;
                currentUser.set(cm.userEdit);
                $rootScope.user = currentUser.get();
                cm.user = $rootScope.user;
            });
        }
        function openEditContact() {
            cm.editContact = true;
            cm.userEdit = angular.copy(cm.user);
        }
        function changeEmail(model) {
            authService.changeEmail({
                Password: model.currentPassword,
                NewEmail: model.email
            }).then(function (res) {
                if (res.Result !== 0) {
                    $scope.$broadcast('flash:error', resourceService.get('CHANGEEMAILFAILURE'));
                }
            });
        }
        function changePassword(model) {
            authService.changePassword({
                Password: model.currentPassword,
                NewPassword: model.newPassword
            }).then(function (res) {
                if (res.Result === 0) {
                    $scope.$broadcast('flash:success', resourceService.get('CHANGEPASSWORDSUCCESS'));
                    closeChangePassword();
                }
                else {
                    $scope.$broadcast('flash:error', resourceService.get('CHANGEPASSWORDFAILURE'));
                }
            });
        }
        function cancelLoginDetailsChange() {
            cm.showChangeEmail = false;
            cm.showChangePassword = false;
            cm.changeEmailModel = null;
            cm.changePasswordModel = null;
            $scope.$broadcast('flash:hide');
        }
        broker.subscribe('dashboardSettingsCtrl', 'footerToolbarChanged', function (ev) {
            cm.userPreferences.footerToolbar = ev.data ? cm.footerToolbar[0] : cm.footerToolbar[1];
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('dashboardSettingsCtrl', 'footerToolbarChanged');
        });
        function confirmRemoveCard(card) {
            card.showConfirmRemoveCard = true;
        }
        function closeEditRemoveCard(card) {
            card.showConfirmRemoveCard = false;
        }
        function _refreshPaymentCards() {
            paymentDetailsService.getPaymentCards().then(function (result) {
                cm.paymentCards = result;
            });
        }
        function addNewCard() {
            cm.addCard = true;
            cm.cardChangedTo = undefined;
            cm.paymentSuccess = false;
        }
        function addCardDetails(card) {
            var today = new Date();
            if (card.ExpiryDate.Year === today.getFullYear() && card.ExpiryDate.Month < today.getMonth() + 1) {
                cm.CardHasExpired = true;
            }
            else {
                cm.addingCard = true;
                cm.CardHasExpired = false;
                paymentsService.addCardDetails(card, savedFrom.SettingsTab).then(function () {
                    cm.addCard = false;
                    cm.newCard = null;
                    cm.addingCard = false;
                    _refreshPaymentCards();
                    cm.paymentSuccess = true;
                    $timeout(function () {
                        cm.paymentSuccess = false;
                    }, 5000);
                });
            }
        }
        function removeCard(card) {
            paymentsService.removeCard(card.CardId).then(function () {
                _refreshPaymentCards();
                closeEditRemoveCard(card);
            });
        }
        if (TRPCONFIG.Domain.SavedCardsEnabled) {
            var uniqueMasterCards = true; // if uniqueMasterCards is requested. return unique types with respect to MasterdCardId.
            paymentDetailsService.getPaymentTypes(uniqueMasterCards).then(function (result) {
                cm.paymentTypes = result;
            });
            paymentDetailsService.getPaymentTypes().then(function (result) {
                cm.allPaymentTypes = result;
            });
            _refreshPaymentCards();
        }
        cm.generateTokens = function () {
            //figure out if we need to generate tokens and if there should be an expiry
            //if pci compliant
            var requireTokens = TRPCONFIG.Domain.PCICompliant;
            var newCard = cm.newCard || { ExpiryDate: {} };
            var month = newCard.ExpiryDate ? newCard.ExpiryDate.Month : null;
            var year = newCard.ExpiryDate ? newCard.ExpiryDate.Year : null;
            var expiryDate = month != null && year != null ? new Date(year, month) : null;
            if (!expiryDate) {
                return $q.when(); //no point tokenising because the form is not valid
            }
            if (requireTokens) {
                return tokeniser.execute(expiryDate ? expiryDate.toISOString() : null);
            }
            return $q.when();
        };
        cm.checkCreditCardNumber = function (cardNumber) {
            cm.cardChangedTo = undefined;
            if (!cardNumber) {
                return;
            }
            paymentsService
                .checkCardNumber(cm.allPaymentTypes, cardNumber, cm.newCard.paymentType)
                .then(undefined, function setCorrectCard(correctId) {
                for (var i = 0; i < cm.allPaymentTypes.length; i++) {
                    if (cm.allPaymentTypes[i].CardTypeId === correctId && cm.newCard.paymentType !== cm.allPaymentTypes[i].MasterCardTypeId) {
                        cm.newCard.paymentType = cm.allPaymentTypes[i].MasterCardTypeId;
                        cm.cardChangedTo =
                            paymentsService.getCardTitle(cm.allPaymentTypes, correctId);
                        break;
                    }
                }
            });
        };
        cm.updateCardType = function () {
            cm.newCard.CardNumber = undefined;
            cm.cardChangedTo = undefined;
        };
        function deleteAccount(password) {
            if (!confirmed) {
                cm.deleteButton = resourceService.getDeferred('CONFIRMDELETE');
                confirmed = true;
                return;
            }
            authService.deleteAccount({
                Password: password
            }).then(function (resp) {
                if (!resp.Success) {
                    cm.deleteButton = resourceService.getDeferred('DELETEACCOUNT');
                    confirmed = false;
                    cm.showconfirmDeleteAccount = false;
                    $scope.$broadcast('flash:error', resourceService.get('DELETEACCOUNTFAILURE'));
                }
            });
        }
        function deleteAccountConfirmed(password) {
            confirmed = true;
            deleteAccount(password);
        }
        function showConfirmDeleteAccount() {
            cm.showconfirmDeleteAccount = true;
            $scope.$broadcast('flash:hide');
        }
        function closeConfirmDeleteAccount() {
            cm.showconfirmDeleteAccount = false;
            confirmed = false;
        }
        function padZero(n) {
            return (n < 10) ? ("0" + n) : n;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('MemberDetails', MemberDetails);
    function MemberDetails($rootScope, dashboardNotificationService) {
        var md = this;
        md.user = $rootScope.user;
        //Notifications
        md.notificationClicked = function (notification) { return dashboardNotificationService.notificationClicked(notification); };
        md.formatNotification = function (notification) { return dashboardNotificationService.formatNotification(notification); };
        dashboardNotificationService.getNotifications().then(function (data) { return md.alerts = data; });
    }
})();
(function () {
    'use strict';
    angular.module('dashboard').controller('OnlineCheckin', OnlineCheckin);
    function OnlineCheckin(onlineCheckinService, arrayUtil, $routeParams, $scope, resourceService, $rootScope, dashboardBookingService) {
        var cm = this;
        cm.legs = [];
        cm.SupplierConditionsList = [];
        cm.bookingId = $routeParams.bookingId;
        cm.checkinSelected = false;
        cm.loadingCheckinOptions = true;
        cm.checkinInProgress = false;
        cm.checkinError = false;
        cm.showProceedBtn = false;
        cm.checkedInLegs = 0;
        cm.legCheckinAllSelected = legCheckinAllSelected;
        cm.printBoardingPass = printBoardingPass;
        cm.doCheckin = doCheckin;
        $rootScope.lockScreen($scope, {
            title: resourceService.get('ONLINECHECKIN_FETCHINGCHECKININFO'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'default-onlineCheckinCtrl'
        });
        dashboardBookingService.getBookingInfo($routeParams.bookingId).then(function (booking) {
            cm.booking = booking;
        });
        onlineCheckinService.getOnlineCheckinOptions(cm.bookingId).then(function (result) {
            cm.loadingCheckinOptions = false;
            $rootScope.unlockScreen($scope);
            cm.bookingRef = result.BookingRef;
            cm.leadPassengerLastname = result.LeadPassengerLastName;
            angular.forEach(result.Legs, function (leg) {
                leg.checkinAll = false;
                leg.showSeatWarning = false;
                if (leg.CheckinState === 'Available') {
                    cm.showProceedBtn = true;
                    leg.checkinAll = true;
                    if (leg.SupplierConditions) {
                        _formatSupplierConditions(leg.SupplierConditions, leg.LegType);
                    }
                }
                else if (leg.CheckinState === 'CheckedIn') {
                    cm.checkedInLegs++;
                }
                angular.forEach(leg.Passengers, function (passenger) {
                    if (passenger.OptionalCharges) {
                        passenger.OptionalCharges[0].Quantity = null;
                        var maxQuantity = passenger.OptionalCharges[0].MaximumQuantity;
                        if (maxQuantity > 0) {
                            passenger.showBaggageSelection = true;
                            passenger.maxBags = arrayUtil.numberArray(0, passenger.OptionalCharges[0].MaximumQuantity);
                        }
                    }
                    if (passenger.SeatSelections) {
                        passenger.seats = passenger.SeatSelections.join(', ');
                    }
                    else {
                        leg.showSeatWarning = true;
                    }
                });
                cm.checkinSelected = cm.checkinSelected || leg.checkinAll;
            });
            if (result.Legs) {
                cm.legs = result.Legs;
            }
        });
        function _formatSupplierConditions(conditions, legType) {
            var supplierConditions = { header: '', text: [] };
            supplierConditions.header = legType.toLowerCase();
            if (conditions.indexOf('\n') !== -1) {
                supplierConditions.text = conditions.split('\n');
                supplierConditions.text.pop();
            }
            else {
                supplierConditions.text[0] = conditions;
            }
            cm.SupplierConditionsList.push(supplierConditions);
        }
        cm.showBagsError = false;
        function doCheckin() {
            if (!cm.checkinSelected) {
                return false;
            }
            var legsToCheckin = arrayUtil.filter(cm.legs, function (leg) {
                return leg.checkinAll;
            });
            angular.forEach(legsToCheckin, function (leg) {
                angular.forEach(leg.Passengers, function (passenger) {
                    if (passenger.OptionalCharges) {
                        if (passenger.OptionalCharges[0].Quantity === null) {
                            cm.showBagsError = true;
                        }
                    }
                });
            });
            if (cm.showBagsError) {
                return false;
            }
            cm.checkinInProgress = true;
            onlineCheckinService.doCheckin(cm.bookingId, legsToCheckin).then(function (data) {
                cm.checkinInProgress = false;
                if (data.Result === 'Success') {
                    angular.forEach(legsToCheckin, function (leg) {
                        leg.CheckinState = 'CheckedIn';
                        onlineCheckinService.getCheckinType(leg);
                        leg.checkinAll = false;
                        legCheckinAllSelected();
                    });
                }
                else {
                    cm.checkinError = true;
                }
            });
        }
        function legCheckinAllSelected() {
            cm.showBagsError = false;
            cm.checkinSelected = false;
            angular.forEach(cm.legs, function (leg) {
                cm.checkinSelected = cm.checkinSelected || leg.checkinAll;
            });
        }
        function printBoardingPass(leg) {
            window.open("/api2/flightscheckin/boardingpass?bookingId=" + cm.bookingId + "&leg=" + leg.LegType, '', 'width=768, height=700, location=no');
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('PayBalance', PayBalance);
    function PayBalance($scope, $q, $routeParams, $location, broker, rootPath, $rootScope, dashboardBookingService, paymentDetailsService, paymentsService, paymentsUtilService, resourceService, urlUtils, mybTrack, currentUser) {
        var _this = this;
        var cm = this;
        var threeDSecure = null;
        var root = urlUtils.getOrigin() + rootPath.getRootPath();
        var completeUrl = 'dashboard/pay-balance/complete/{0}';
        var bookingReferenceUrl = 'dashboard/bookings/reference/{0}';
        var payPalCallbackUrl = '{0}paybalancepaypalcallback?paymentId={1}&bookingId={2}&ppResp={3}';
        cm.threeDS2Enabled = TRPCONFIG.Domain.ThreeDS2EnabledMYB;
        cm.bookingId = parseInt($routeParams.bookingId);
        cm.threedsRedirecting = false;
        cm.payFull = true;
        mybTrack.track('MYB - Open Pay Balance', {
            ReferralMethod: $routeParams.ReferralMethod
        });
        cm.paymentModel = paymentsUtilService.createEmptyPaymentModel();
        dashboardBookingService.getBookingInfo(cm.bookingId).then(function (booking) {
            cm.bk = booking;
        });
        //Get booking detail for the common ManageHeader
        dashboardBookingService.getBookingDetail(cm.bookingId).then(function (data) {
            _processBalanceDue(data.BalanceDueInfo);
            cm.isPartOfHoliday = data.IsPartOfHoliday;
            //getsavedbookingcards is obsolete now. So calling get and joining with PaymentOptions
            var getOptions = paymentDetailsService.getPaymentOptions(data.Booking.Type, cm.bookingId, data.BalanceDueInfo.ClientCurrencyCode);
            var getCards = TRPCONFIG.Domain.SavedCardsEnabled && $scope.user.HardSignedIn ? paymentDetailsService.getPaymentCards() : null;
            $q.all([getOptions, getCards]).then(function (results) {
                cm.paymentOptions = paymentsUtilService.convertMybPaymentOptions(results[0]);
                if (results[1]) {
                    cm.savedCards = paymentsUtilService.convertMybSavedCards(results[1], results[0]);
                }
                if (cm.paymentOptions) {
                    cm.paymentOptions = cm.paymentOptions.filter(function (o) {
                        return TRPCONFIG.Domain2.CPGIframeUpdate ? o.Id === 370 : o.Id !== 370;
                    });
                }
                cm.dataLoaded = true;
            });
            if ($routeParams.ppResp) {
                _showError(resourceService.get(paymentsService.getPayPalResponseMessage([$routeParams.ppResp])));
            }
        });
        cm.preBookCommands = [];
        cm.addPreBookCommand = function (command) {
            if (!cm.preBookCommands.includes(command)) {
                cm.preBookCommands.push(command);
            }
        };
        cm.generateTokens = function () {
            return paymentsService.generateTokens(cm.paymentModel.cardDetail.expiryDate.month, cm.paymentModel.cardDetail.expiryDate.year, cm.paymentModel.saveCard);
        };
        cm.addPreBookCommand(cm.generateTokens);
        cm.executePrebookCommands = function () { return __awaiter(_this, void 0, void 0, function () {
            var onloadCommands, onloadCommands, _a, id, refId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!cm.paymentModel.isPayPalPayment) return [3 /*break*/, 2];
                        onloadCommands = cm.preBookCommands.slice(0, 1).slice();
                        return [4 /*yield*/, Promise.all(onloadCommands.map(function (preBookCommand) { return preBookCommand(); }))];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        onloadCommands = cm.preBookCommands.slice(0, 2).slice();
                        return [4 /*yield*/, Promise.all(onloadCommands.map(function (preBookCommand) { return preBookCommand(); }))];
                    case 3:
                        _a = _b.sent(), id = _a[1];
                        refId = id || $rootScope.dfReferenceId;
                        if (refId) {
                            cm.DfReferenceId = id;
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        function paymentFunction() {
            var expires = cm.paymentModel.cardDetail.expiryDate;
            var today = new Date();
            if (expires &&
                expires.year
                && expires.month
                && expires.year <= today.getFullYear()
                && expires.month < (today.getMonth() + 1)) {
                _showError(resourceService.get('CARDHASEXPIRED'));
                return;
            }
            _block(true);
            var requireValidation = cm.paymentModel.cardDetail.isSavedCard === false
                && cm.paymentModel.isPayPalPayment === false
                && cm.paymentModel.externalFop === undefined;
            paymentDetailsService.clearPayment(_formatClearRequestPayload(), requireValidation).then(function (result) {
                if (result.Success) {
                    if (result.AcsRedirectRequired) {
                        if (cm.paymentModel.isPayPalPayment) {
                            //Paypal redirection
                            window.location = result.AcsUrl;
                        }
                        else {
                            //3ds redirection
                            _redirectTo3dSecurePayment(result);
                        }
                    }
                    else {
                        //Show complete page
                        $location.path(String.format(completeUrl, cm.bookingId));
                    }
                }
                else {
                    var message = result.ReasonCode ? paymentDetailsService.getcardFailureReasonMessage(result.ReasonCode) : result.PaymentMessage;
                    _handleFailurePayment(message);
                }
            }, function () {
                _showError(resourceService.get('PAYBALANCEERROR'));
            });
            mybTrack.track('MYB - Pay Balance', {
                PaymentType: cm.paymentModel.isPayPalPayment ? 'PayPal' : 'Card',
                PartPayment: !cm.payFull
            });
        }
        function getDfReferenceId() {
            return __awaiter(this, void 0, void 0, function () {
                var newCommands, id;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            newCommands = [cm.preBookCommands[cm.preBookCommands.length - 1]];
                            return [4 /*yield*/, Promise.all(newCommands.map(function (preBookCommand) { return preBookCommand(); }))];
                        case 1:
                            id = (_a.sent())[0];
                            return [2 /*return*/, id];
                    }
                });
            });
        }
        function threeDS2Book() {
            return __awaiter(this, void 0, void 0, function () {
                var id, dfReferenceId, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            _block(true);
                            return [4 /*yield*/, getDfReferenceId()];
                        case 1:
                            id = _a.sent();
                            dfReferenceId = id || $rootScope.dfReferenceId;
                            cm.DfReferenceId = dfReferenceId;
                            paymentFunction();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            broker.publish('unblock');
                            $scope.$emit('unblock');
                            console.log('err', err_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        cm.makePayment = function () {
            if (cm.paymentModel.isPayPalPayment) {
                cm.DfReferenceId = null;
                paymentFunction();
            }
            else if (cm.DfReferenceId && cm.threeDS2Enabled) {
                paymentFunction();
            }
            else if (!cm.DfReferenceId && cm.threeDS2Enabled) {
                threeDS2Book();
            }
            else {
                paymentFunction();
            }
        };
        cm.updateDfReferenceId = function (dfReferenceId) { return cm.DfReferenceId = dfReferenceId; };
        cm.bypassThreeDS = function () {
            var data = {
                paRes: '',
                md: '',
                prePaymentId: threeDSecure.PrePaymentID
            };
            _authorisePayment(data, false);
        };
        //Watches
        $scope.$on('3DSValidationComplete', function (ev, data) {
            _authorisePayment(data, true);
        });
        $scope.$watch('cm.paymentAmount', function (val) {
            val = val && !isNaN(val) ? val : 0;
            cm.paymentAmountDecimal = parseFloat(val);
            _updateBlanceDueDetail();
        });
        $scope.$watch('cm.paymentModel.fee', function () {
            _updateBlanceDueDetail();
        });
        //Private methods
        function _formatClearRequestPayload() {
            var request = {
                BookingId: cm.bookingId,
                PaymentId: 0,
                CurrencyCode: cm.currencyCode,
                Amount: cm.totalPaymentAmount,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                PayPalCallbackUrl: String.format(payPalCallbackUrl, root, '$PaymentId', cm.bookingId, 'success'),
                PayPalCancellationUrl: String.format(payPalCallbackUrl, root, 0, cm.bookingId, 'cancel'),
                ApplicationType: TRPCONFIG.ApplicationType,
                DfReferenceId: cm.DfReferenceId,
                ReturnUrl: String.format('{0}threedsecure?prePaymentID=', root),
            };
            //add in our payment details
            paymentsUtilService.addPaymentDetailsToClearRequest(cm.paymentModel, request);
            return request;
        }
        function _formatAuthoriseRequestPayload(data) {
            return {
                PaymentId: data.paymentId && data.paymentId.length ? data.paymentId : data.prePaymentId,
                PaRes: decodeURIComponent(data.paRes),
                MD: data.md,
                ChallengeJWT: data.challengeJwt,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode
            };
        }
        function _authorisePayment(data, threeDSecure) {
            if (threeDSecure === void 0) { threeDSecure = false; }
            _block(true);
            paymentDetailsService.authorisePayment(_formatAuthoriseRequestPayload(data)).then(function (result) {
                if (threeDSecure) {
                    $scope.$broadcast('3DSValidationFinished', result.Success);
                }
                if (result.Success) {
                    $location.path(String.format(completeUrl, cm.bookingId));
                }
                else {
                    _handleFailurePayment(result.PaymentMessage);
                }
            }, function () {
                _showError(resourceService.get('AUTHORISEEERROR'));
            });
            $scope.$apply(function () {
                cm.threedsRedirecting = false;
            });
        }
        function _redirectTo3dSecurePayment(result) {
            //Create threeDSecure object
            threeDSecure = {
                PaReq: result.PaReq,
                MD: result.MD,
                TermUrl: String.format('{0}threedsecure?prePaymentID={1}', root, result.PaymentId),
                AcsUrl: result.AcsUrl,
                CanByPass: result.AllowThreeDSecureBypass,
                ChallengeJWT: result.ChallengeJWT,
                PrePaymentID: result.PaymentId
            };
            $scope.$broadcast('request3DSValidation', threeDSecure, {
                Journey: 'PostBooking',
                BookingID: cm.bookingId,
                SignedIn: currentUser.get().SignedIn
            });
            cm.threedsRedirecting = true;
            cm.ThreeDSecure = threeDSecure;
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
        function _handleFailurePayment(msg) {
            var messages = [resourceService.get('PAYMENTFAILED') + msg, String.format(resourceService.get('PAYMENTASSISTENCE'), resourceService.get('TELEPHONENUMBER'))];
            _showError(messages);
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
        function _showError(msg) {
            $scope.$broadcast('flash:error', msg);
        }
        function _block(completing) {
            $scope.$emit('block', {
                title: resourceService.get(completing ? 'COMPLETINGPAYMENT' : 'PREPARINGPAYMENT'),
                loadingScreenStyle: 'default-payBalance'
            });
        }
        function _processBalanceDue(balanceDue) {
            _initDueDetails(balanceDue);
            _updateBlanceDueDetail();
            cm.BalanceDueDate = balanceDue.DueDate;
        }
        function _updateBlanceDueDetail() {
            cm.totalPaymentAmount = cm.paymentAmountDecimal + cm.paymentModel.fee;
            cm.balanceDueAfterPayment = cm.balanceDue - cm.paymentAmountDecimal;
        }
        function _initDueDetails(dueDetail) {
            if (!dueDetail) {
                //If there is no due amount redirect to booking reference page.
                $location.path(String.format(bookingReferenceUrl, cm.bookingId));
            }
            else {
                cm.balanceDue = dueDetail.BalanceDueAmount - dueDetail.PendingElvPayments;
                //cm.balanceDue = cm.balanceDue.toFixed(2);
                cm.currencyCode = dueDetail.ClientCurrencyCode;
                cm.paymentAmount = cm.balanceDue.toFixed(2);
                cm.paymentAmountDecimal = parseFloat(cm.paymentAmount);
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('PayBalanceComplete', PayBalanceComplete);
    function PayBalanceComplete($scope, $routeParams, broker, dashboardBookingService, resourceService) {
        var cm = this;
        cm.bookingId = parseInt($routeParams.bookingId);
        cm.bookingActions = dashboardBookingService.getBookingActions();
        cm.getResourceValue = function (resource) { return resourceService.get(resource); };
        broker.publish('paymentComplete');
        dashboardBookingService.getBookingDetail(cm.bookingId).then(function (data) {
            if (data) {
                var paymentData = _.last(data.Payments.filter(function (p) { return p.Status === 1; }));
                var dueDetail = data.BalanceDueInfo;
                cm.amountPaid = paymentData.Amount;
                cm.currencyCode = paymentData.ClientCurrencyCode;
                if (dueDetail) {
                    cm.balanceDueAfterPayment = dueDetail.BalanceDueAmount - dueDetail.PendingElvPayments;
                    cm.BalanceDueDate = dueDetail.DueDate;
                }
            }
        });
        //dashboardBookingService.getBookingInfo(cm.bookingId).then(function (booking) {
        //    cm.bk = booking;
        //});
        broker.publish('unblock');
        $scope.$emit('unblock');
    }
})();
var Dashboard;
(function (Dashboard) {
    var AmendBookingPreviousSummary = /** @class */ (function () {
        function AmendBookingPreviousSummary($scope, hotelService, dashboardBookingService) {
            this.$scope = $scope;
            this.hotelService = hotelService;
            this.dashboardBookingService = dashboardBookingService;
            dashboardBookingService.getMybBooking()
                .then(function (booking) {
                $scope.booking = booking;
                var estabId = _.get(booking, 'Itinerary.Stays[0].Hotel.EstabId');
                return hotelService.getHotel(undefined, estabId, undefined);
            })
                .then(function (hotel) {
                $scope.hotel = hotel;
                hotel.BookingRef = $scope.booking.BookingCore.BookingRef;
            });
        }
        return AmendBookingPreviousSummary;
    }());
    angular
        .module('dashboard')
        .directive('amendBookingPreviousSummary', function () { return ({
        restrict: 'E',
        controller: AmendBookingPreviousSummary,
        scope: {},
        templateUrl: 'partials/home/directivetemplate?type=amendBookingPreviousSummary'
    }); });
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var DashboardBookingItinerary = /** @class */ (function () {
        function DashboardBookingItinerary(imageService, dashboardBookingService, resourceService) {
            this.imageService = imageService;
            this.dashboardBookingService = dashboardBookingService;
            this.resourceService = resourceService;
            this.templateMap = {
                1: 'flight',
                2: 'tickets',
                4: 'car-hire',
                8: 'accommodation',
                9: 'holiday',
                16: 'parking',
                32: 'transfer',
                64: 'insurance',
                128: 'package-holidays',
                256: 'marhaba',
                1024: 'bundle',
                2048: 'adhoc'
            };
            this.template = this.templateMap[this.bookingType];
            this.bookingTypes = dashboardBookingService.getBookingTypeMap();
            this.itineraryType = dashboardBookingService.getItineraryType();
            if (this.bookingType === this.bookingTypes.travelInsurance) {
                this.insuranceProvider = this.bookingTitle.split(':')[0];
            }
        }
        DashboardBookingItinerary.prototype.getResourceValue = function (resource) {
            return this.resourceService.get(resource);
        };
        DashboardBookingItinerary.prototype.filterTransfer = function (itinerary) {
            return itinerary.Type === this.itineraryType['TransferArrival'] ||
                itinerary.Type === this.itineraryType['TransferReturn'];
        };
        DashboardBookingItinerary.prototype.getImage = function (estabId) {
            return this.imageService.getImageUrl(estabId, 180, 180, 1);
        };
        DashboardBookingItinerary.prototype.getAcommImage = function (estabId) {
            return this.imageService.getMainImageUrl(estabId, 370, 370);
        };
        DashboardBookingItinerary.prototype.getContentUrl = function () {
            return 'partials/dashboard/ItineraryTemplate?Type=' + this.template;
        };
        return DashboardBookingItinerary;
    }());
    angular
        .module('dashboard')
        .component('dashboardBookingItinerary', {
        bindings: {
            bookingTitle: '=',
            itineraries: '=',
            bookingType: '='
        },
        controller: DashboardBookingItinerary,
        controllerAs: 'bi',
        template: '<div ng-include="bi.getContentUrl()"></div>'
    });
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .directive('dashboardBookingSummary', dashboardBookingSummary);
    function dashboardBookingSummary(dashboardBookingService, resourceService, authService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/dashboard/bookingsummary',
            scope: {
                bk: '=',
                bnd: '=',
                currentUser: '=',
                passenger: '=',
                showTripDate: '@',
                bookingMessage: '@',
                showActions: '@'
            },
            link: function (scope) {
                scope.bookingType = dashboardBookingService.getBookingTypeMap();
                var stopWatch = scope.$watch('bk', function (val) {
                    if (val) {
                        dashboardBookingService.formatTitle(val);
                        stopWatch();
                    }
                });
                scope.showTripDate = scope.showTripDate === 'true';
                scope.getResourceValue = function (resource) { return resourceService.get(resource); };
                scope.formatBookingMessage = dashboardBookingService.formatBookingMessage;
                scope.bookingMessage = scope.bookingMessage === 'true';
                scope.showActions = scope.showActions === 'true';
                scope.actionClick = dashboardBookingService.actionClick;
                scope.signOut = function () {
                    authService.signOut();
                };
                function revealOptions(bk) {
                    bk.showOptions = true;
                }
                function hideOptions(bk) {
                    bk.showOptions = false;
                }
                scope.toggleOptions = function (bk) {
                    if (bk.showOptions) {
                        hideOptions(bk);
                    }
                    else {
                        revealOptions(bk);
                    }
                };
                function canAccessBooking(bnd) {
                    var access = true;
                    // Checks bundle has a BookingUIStatus of 'OK'
                    var type = _.get(bnd, '[0].Status');
                    if (type !== 1) {
                        return false;
                    }
                    // Checks bundle components are not BookingUIStatus of 'Pending'
                    access = _.every(bnd, function (item) {
                        return item.Status !== 2;
                    });
                    return access;
                }
                if (scope.bnd !== undefined) {
                    scope.canAccessBooking = canAccessBooking(scope.bnd);
                }
            }
        };
    }
})();
var Dashboard;
(function (Dashboard) {
    var DashboardBreadcrumb = /** @class */ (function () {
        function DashboardBreadcrumb(dashboardBreadCrumbDetails, dashboardBookingService, $routeParams) {
            var _this = this;
            this.dashboardBreadCrumbDetails = dashboardBreadCrumbDetails;
            this.dashboardBookingService = dashboardBookingService;
            this.$routeParams = $routeParams;
            this.bookingId = parseInt(this.$routeParams.bookingId, 10);
            this.dashboardBookingService.getBookingInfo(this.bookingId).then(function (booking) {
                _this.crumbs = _this.dashboardBreadCrumbDetails.get(_this.pages, booking);
            });
        }
        return DashboardBreadcrumb;
    }());
    angular
        .module('dashboard')
        .directive('dashboardBreadcrumb', function () {
        return {
            restrict: 'E',
            bindToController: {
                pages: '@'
            },
            controller: DashboardBreadcrumb,
            controllerAs: 'dbc',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=DashboardBreadcrumb'
        };
    });
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var DashboardCarousel = /** @class */ (function () {
        function DashboardCarousel() {
            var _this = this;
            this.selected = 0;
            this.formatedItem = function (item) { return _this.formatItem({ item: item }); };
            this.onItemClick = function (item) { _this.itemClick({ item: item }); };
        }
        DashboardCarousel.prototype.init = function (scope, carousel, prev, next) {
            this.carousel = carousel;
            this.scope = scope;
            this.prev = prev;
            this.next = next;
        };
        DashboardCarousel.prototype.initCarousel = function () {
            var _this = this;
            this.carousel.slick({
                prevArrow: this.prev,
                nextArrow: this.next,
                infinite: false
            });
            this.carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                _this.selected = nextSlide;
                _this.onCarouselChange({ index: nextSlide });
                _this.scope.$apply();
            });
            this.scope.$on('$destroy', function () {
                _this.carousel.off('beforeChange');
            });
        };
        return DashboardCarousel;
    }());
    angular
        .module('dashboard')
        .directive('dashboardCarousel', function () {
        return {
            scope: {},
            bindToController: {
                itemlist: '=',
                onCarouselChange: '&',
                itemClick: '&',
                itemPartial: '=',
                formatItem: '&'
            },
            controller: DashboardCarousel,
            controllerAs: 'dc',
            templateUrl: function (el, attrs) {
                if (attrs.itemPartial) {
                    return 'partials/dashboard/DashboardCarousel?itemPartial=' + attrs.itemPartial;
                }
                return 'partials/dashboard/DashboardCarousel';
            },
            link: function (scope, el, attr, controller) {
                controller.init(scope, $('.dashboard-carousel'), $('#arrow-prev'), $('#arrow-next'));
            }
        };
    }).directive('carouselItem', function ($timeout) {
        return {
            restrict: 'A',
            transclude: false,
            require: '^dashboardCarousel',
            link: function (scope, el, attr, controller) {
                // wait for the last item in the ng-repeat then call init
                if (scope.$last) {
                    $timeout(function () {
                        controller.initCarousel();
                    });
                }
            }
        };
    });
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var DashboardCsrConversation = /** @class */ (function () {
        function DashboardCsrConversation($scope, dashboardCsrService, $timeout) {
            var _this = this;
            this.$scope = $scope;
            this.dashboardCsrService = dashboardCsrService;
            this.$timeout = $timeout;
            this.isInProgress = false;
            this.submitMessage = function (csr) {
                _this.isInProgress = true;
                _this.dashboardCsrService.submitMessage(csr).then(function () { return _this.isInProgress = false; });
            };
            this.getSenderTitle = function (conversation) { return _this.dashboardCsrService.getSenderTitle(conversation); };
            $('.header-main').addClass('unfix');
            $scope.$watch('csd.csr.newMessage', function () { return _this.moveConversationWithTextbox(); });
        }
        DashboardCsrConversation.prototype.goToBottom = function () {
            this.$timeout(function () {
                scrollTo(0, document.body.scrollHeight);
            }, 2000);
        };
        DashboardCsrConversation.prototype.moveConversationWithTextbox = function () {
            //to move the conversation are when the input are height increases.
            var el = $('.csr-conversation');
            el.css('padding-bottom', $('.csr-send-message').css('height'));
        };
        return DashboardCsrConversation;
    }());
    angular
        .module('dashboard')
        .component('dashboardCsrConversation', {
        bindings: {
            csr: '='
        },
        controller: DashboardCsrConversation,
        controllerAs: 'csd',
        templateUrl: 'partials/dashboard/CsrConversation'
    });
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var CsrSummary = /** @class */ (function () {
        function CsrSummary($scope, $q, $routeParams, scrollService, $location, dashboardCsrService) {
            var _this = this;
            this.$scope = $scope;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.scrollService = scrollService;
            this.$location = $location;
            this.dashboardCsrService = dashboardCsrService;
            this.getCsrStatusClass = function (status) { return _this.dashboardCsrService.getCsrStatusClass(status); };
            this.returnUrl = '/dashboard/csr/' + this.$routeParams.bookingId;
            this.baseUrl = '/dashboard';
            var killTheWatch = $scope.$watchCollection(function () { return _this.csrlist; }, function (val) {
                if (val && val.length > 0) {
                    killTheWatch();
                }
            });
        }
        CsrSummary.prototype.view = function (csr) {
            this.$location.path(this.baseUrl + '/csr-details/' + csr.BookingId + '/' + csr.CsrId);
        };
        return CsrSummary;
    }());
    angular
        .module('dashboard')
        .directive('dashboardCsrSummary', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            templateUrl: 'partials/dashboard/csrSummary',
            bindToController: {
                csrlist: '='
            },
            scope: {},
            controller: CsrSummary,
            controllerAs: 'cs'
        };
    });
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .directive('gravatarImage', function (resourceService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                email: '='
            },
            template: '<div class="avatar"><a class="edit-avatar" href="{{gravatarProfile}}" target="_blank">{{changeText}}</a></div>',
            link: function (scope, element) {
                scope.gravatarProfile = 'https://gravatar.com/profiles/no-such-user';
                scope.$watch('email', function (email) {
                    if (email) {
                        scope.changeText = resourceService.get('CHANGE');
                        // eslint-disable-next-line new-cap
                        var hash = window.md5(email);
                        var image_1 = new Image();
                        image_1.onload = function () {
                            element.append(image_1);
                        };
                        //fallback to mysterymen avatar
                        image_1.src = "https://www.gravatar.com/avatar/" + hash + "?d=mm";
                        image_1.alt = 'user avatar';
                        scope.gravatarProfile = "https://www.gravatar.com/profiles/" + hash;
                    }
                });
            }
        };
    });
})();
var Dashboard;
(function (Dashboard) {
    angular
        .module('dashboard')
        .directive('elastic', function ($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, element, attrs) {
                var initialHeight = element[0].style.height;
                var maxRows = $scope.$eval(attrs.elastic);
                var maxHeight = (element[0].clientHeight - 18) * maxRows;
                var resize = _.debounce(function () {
                    element[0].style.height = initialHeight;
                    element[0].style.height = (maxHeight <= element[0].scrollHeight ?
                        maxHeight : element[0].scrollHeight) + 'px';
                }, 250);
                element.on('input change', resize);
                $timeout(resize, 0);
            }
        };
    });
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    var DS = angular.module('dashboard');
    DS.directive('visitedHotelItem', function () {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: 'partials/dashboard/VisitedHotelDetails',
            scope: {
                item: '='
            }
        };
    });
})();
var Dashboard;
(function (Dashboard) {
    var AddAPIService = /** @class */ (function () {
        function AddAPIService($http, $q, resourceService) {
            this.$http = $http;
            this.$q = $q;
            this.resourceService = resourceService;
            this.documentTypes = [
                {
                    id: 1,
                    label: this.resourceService.getDeferred('PASSPORT')
                },
                {
                    id: 2,
                    label: this.resourceService.getDeferred('IDENTITYCARD')
                }
            ];
        }
        AddAPIService.prototype.getDocumentTypes = function () {
            return this.documentTypes;
        };
        AddAPIService.prototype.addAPI = function (bookingId, passengers) {
            return this.$http.post('/api/bookings/flights/apis/update', {
                BookingId: bookingId,
                PassengerInfo: passengers
            });
        };
        AddAPIService.prototype.getAPI = function (bookingId) {
            return this.$http.get('/api/bookings/flights/apis/get?' + $.param({
                BookingId: bookingId
            })).then(function (r) { return r.data; });
        };
        AddAPIService.prototype.getPassengers = function (bookingId) {
            return this.$http.get('api/bookings/myb/get?' + $.param({
                bookingId: bookingId,
                fields: 'passengers'
            })).then(function (r) { return r.data.Passengers; });
        };
        AddAPIService.prototype.getPassengerInfo = function (bookingId) {
            return this.$q.all([
                this.getPassengers(bookingId),
                this.getAPI(bookingId)
            ]).then(function (_a) {
                var passengers = _a[0], passengersFromAPI = _a[1];
                return passengers.map(function (p) {
                    var pa = _.find(passengersFromAPI, function (pa) { return pa.PassengerId === p.Id; });
                    var passenger = {
                        PassengerId: p.Id,
                        Name: p.Title + " " + p.FirstName + " " + p.SurName
                    };
                    if (pa) {
                        _.assign(passenger, {
                            DocumentNumber: pa.DocumentNumber,
                            Nationality: pa.Nationality,
                            DocumentIssuingCountry: pa.DocumentIssuingCountry,
                            CountryOfBirth: pa.CountryOfBirth,
                            DocumentType: pa.DocumentType,
                            DateOfBirth: pa.DateOfBirth,
                            DocumentIssuedDate: pa.DocumentIssuedDate,
                            DocumentExpiryDate: pa.DocumentExpiryDate,
                            DetailsSubmitted: true
                        });
                    }
                    return passenger;
                });
            });
        };
        return AddAPIService;
    }());
    angular
        .module('dashboard')
        .service('addAPIService', AddAPIService);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var BookingStatus;
    (function (BookingStatus) {
        BookingStatus[BookingStatus["Pending"] = 1] = "Pending";
        BookingStatus[BookingStatus["Receipted"] = 2] = "Receipted";
        BookingStatus[BookingStatus["Ticketed"] = 4] = "Ticketed";
        BookingStatus[BookingStatus["Complete"] = 5] = "Complete";
        BookingStatus[BookingStatus["CancelledByCustomer"] = 6] = "CancelledByCustomer";
        BookingStatus[BookingStatus["Void"] = 7] = "Void";
        BookingStatus[BookingStatus["HoldAwaitingConfirmation"] = 8] = "HoldAwaitingConfirmation";
        BookingStatus[BookingStatus["DeclinedByEstab"] = 9] = "DeclinedByEstab";
        BookingStatus[BookingStatus["ConfirmedByEstab"] = 10] = "ConfirmedByEstab";
        BookingStatus[BookingStatus["CancellationConfirmedByEstab"] = 11] = "CancellationConfirmedByEstab";
        BookingStatus[BookingStatus["CancellationDeclinedByEstab"] = 12] = "CancellationDeclinedByEstab";
        BookingStatus[BookingStatus["FailedSecurityCheck"] = 13] = "FailedSecurityCheck";
        BookingStatus[BookingStatus["HoldSwap"] = 14] = "HoldSwap";
    })(BookingStatus = Dashboard.BookingStatus || (Dashboard.BookingStatus = {}));
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('dashboardReviewService', dashboardReviewService);
    function dashboardReviewService($http, $q, dashboardService, dashboardBookingService, imageService, resourceService, authService, currentUser) {
        var reviewUrl = '/api2/users/reviews/';
        var userReviewUrl = '/api2/users/reviews/user/';
        var ratingRange = {
            Min: 0,
            Max: 10
        };
        var sutabilityAnswers = [
            {
                name: resourceService.getDeferred('YES'),
                val: true
            },
            {
                name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'),
                val: false
            },
            {
                name: resourceService.getDeferred('DASHBOARDRESOURCE_UNSURE'),
                val: 'Unsure'
            }
        ];
        var recommendTRPAnswers = [
            {
                name: resourceService.getDeferred('YES'),
                val: true
            },
            {
                name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'),
                val: false
            }
        ];
        var reviewCriteria = [
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_CHECKINDATE'), val: 'ReviewerCheckInDate' },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_MOSTLIKES'), val: 'LikeCount' },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_MYRATING'), val: 'Rating' },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_FEEDBACKDATE'), val: 'FeedBackDate' }
        ];
        var ratingTitles = null;
        var hotelSuitabilityTypes = null;
        var service = {
            getBookingFeedback: getBookingFeedback,
            editReview: editReview,
            saveReview: saveReview,
            recommendTRPChange: recommendTRPChange,
            ratingRange: ratingRange,
            recommendTRPAnswers: recommendTRPAnswers,
            sutabilityAnswers: sutabilityAnswers,
            getRatingTitles: getRatingTitles,
            getRatingTitleText: getRatingTitleText,
            getStatements: getStatements,
            getReviewSortCriteria: getReviewSortCriteria,
            getReviewSiteDetails: getReviewSiteDetails,
            getReview: getReview,
            getReviewHeaderData: getReviewHeaderData,
            getReviewStatus: getReviewStatus
        };
        function getStatements() {
            if (hotelSuitabilityTypes === null) {
                return $http.get(reviewUrl + "getstatements?" + $.param({
                    CultureCode: TRPCONFIG.Domain.CultureCode
                })).then(function (result) {
                    addDefaultAnswerToStatements(result.data);
                    hotelSuitabilityTypes = result.data;
                    return hotelSuitabilityTypes;
                });
            }
            return hotelSuitabilityTypes;
        }
        function addDefaultAnswerToStatements(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].SelectedOpinion = sutabilityAnswers[2].val;
            }
        }
        function getRatingTitles() {
            if (ratingTitles === null) {
                return $http.get(reviewUrl + "getratingcategories?" + $.param({
                    CultureCode: TRPCONFIG.Domain.CultureCode
                })).then(function (result) {
                    ratingTitles = result.data;
                    return ratingTitles;
                });
            }
            return $q.when(ratingTitles);
        }
        function BookingFeedback() {
            var feedback = {
                rating: 0,
                comments: '',
                topTip: '',
                notRecommendUsComment: '',
                statements: null
            };
            return feedback;
        }
        function getBookingFeedback() {
            var feedback = new BookingFeedback();
            feedback.statements = angular.copy(hotelSuitabilityTypes);
            feedback.recommendTRP = true;
            return feedback;
        }
        function editReview(hotel) {
            hotel.reviewSaved = false;
        }
        function saveReview(hotel, feedback, token, userId) {
            if (feedback.rating === 0) {
                hotel.submitTry = true;
                return $q.when(false);
            }
            return _saveReview(hotel.EstablishmentDetail.Id, hotel.BookingDetail.BookingId, feedback, token, userId).then(function () {
                hotel.reviewSaved = true;
                dashboardService.clearAggregate();
                _setFeedbackStatements(hotel.BookingDetail.BookingId, hotel.EstablishmentDetail.Id, feedback.statements, token, userId);
                return true;
            });
        }
        function _saveReview(estabId, bookingId, reviewData, token, userId) {
            var url = '';
            var request = {
                BookingId: bookingId,
                ObjectId: estabId,
                RatingDecimal: reviewData.rating,
                Comments: reviewData.comments,
                TopTip: reviewData.topTip,
                RecommendTRP: reviewData.recommendTRP,
                NotRecommendUsComment: reviewData.notRecommendUsComment,
                DomainDefaultCultureCode: TRPCONFIG.Domain.CultureCode
            };
            if (token && userId) {
                request.VerificationToken = token;
                request.UserId = userId;
                url = userReviewUrl + "settoken";
            }
            else {
                url = userReviewUrl + "set";
            }
            return $http.post(url, request, { ignoreErrors: true });
        }
        function recommendTRPChange(feedback) {
            if (!feedback.recommendTRP) {
                feedback.showNotRecommendTRPComment = true;
                document.getElementById('review-content').scrollTop += 150;
                document.getElementById('notRecommendUsComment').focus();
            }
            else {
                feedback.showNotRecommendTRPComment = false;
            }
        }
        function getRatingTitleText(n) {
            if (n !== undefined) {
                var i = 0;
                if (n === 0) {
                    return ratingTitles[i].Description;
                }
                for (i = 1; i < ratingTitles.length; i++) {
                    if (n < ratingTitles[i].MinimumRating) {
                        return ratingTitles[i - 1].Description;
                    }
                }
                return ratingTitles[i - 1].Description;
            }
            return '';
        }
        function getReviewSortCriteria() {
            return reviewCriteria;
        }
        function _setFeedbackStatements(bookingId, objectId, statements, token, userId) {
            var filteredStatements = _.filter(statements, function (s) {
                delete s.Description;
                return s.SelectedOpinion !== 'Unsure';
            });
            var request = {
                BookingId: bookingId,
                ObjectId: objectId,
                Statements: filteredStatements
            };
            if (filteredStatements.length > 0) {
                var url = '';
                if (token && userId) {
                    request.VerificationToken = token;
                    request.UserId = userId;
                    url = userReviewUrl + "setstatementstoken";
                }
                else {
                    url = userReviewUrl + "setstatements";
                }
                return $http.post(url, request, { ignoreErrors: true });
            }
            return $q.when();
        }
        function getReviewSiteDetails(bookingId) {
            return $http.get(userReviewUrl + "getreviewsite?bookingId=" + bookingId + "&domainId=" + TRPCONFIG.Domain.DomainId, { ignoreErrors: true }).then(function (result) {
                var reviewSiteDetails = result.data;
                return reviewSiteDetails;
            });
        }
        function getReview(bookingId) {
            return $http.get(userReviewUrl + "booking/" + bookingId + "?cultureCode=" + TRPCONFIG.Domain.CultureCode, { ignoreErrors: true })
                .then(function (result) {
                return result.data;
            });
        }
        function getReviewHeaderData(bookingId, objectId) {
            var dim = TRPCONFIG.DeviceSettings.LandingImageHeight;
            var hotelDetail = dashboardService.getHotelsById([objectId]);
            var bookingDetail = dashboardBookingService.getBookingSummary(bookingId);
            var contactDetail = dashboardBookingService.getContact(bookingId);
            return $q.all([hotelDetail, bookingDetail, contactDetail]).then(function (results) {
                var hotel = (results[0]) ? results[0][0] : null;
                var contact = results[2] && results[2].data;
                return {
                    EstablishmentDetail: hotel,
                    ImageUrl: imageService.getMainImageUrl(objectId, dim, dim),
                    BookingDetail: {
                        StartDate: results[1].Booking.StartDate,
                        BookingRef: results[1].Booking.BookingRef,
                        BookingId: bookingId,
                        LeadPassengerContact: {
                            Title: contact.Title,
                            FirstName: contact.FirstName,
                            Surname: contact.LastName
                        }
                    }
                };
            });
        }
        function getReviewStatus(bookingId) {
            var user = currentUser.get();
            return (user.AnonSignedIn ? authService.getSignedinBooking() : $.when()).then(function (booking) {
                if (booking && booking.Summary && booking.Summary.BookingId) {
                    var url = "/api/bookings/" + booking.Summary.BookingId + "/trip?culturecode=" + TRPCONFIG.Domain.CultureCode;
                    return $http.get(url).then(function (response) {
                        var bk = _.find(response.data.Bookings, function (bk) {
                            return bk.BookingId === parseInt(bookingId);
                        });
                        return bk.ReviewStatus;
                    });
                }
            });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('dashboardService', dashboardService);
    function dashboardService($http, arrayUtil, imageService, fieldGroupService) {
        var domain = TRPCONFIG.Domain;
        var dashBoardAggPromise = null;
        var fieldTypes = fieldGroupService.getFieldTypes();
        var service = {
            getAggregate: getAggregate,
            clearAggregate: clearAggregate,
            getHotelsById: getHotelsById
        };
        function clearAggregate() {
            dashBoardAggPromise = null;
        }
        function _getDashBoardAggregates() {
            if (dashBoardAggPromise == null) {
                dashBoardAggPromise = $http.post('website/userdashboard/getestabbookings', {
                    SortCriterion: 'Likes',
                    CultureCode: domain.CultureCode,
                    DomainId: domain.DomainId
                }, { ignoreErrors: true }).then(function (result) {
                    var allEstabs = result.data.EstabBookingDetails;
                    var userReviews = result.data.Reviews;
                    var visitedEstabInfo = {
                        ReviewedHotels: [],
                        UnreviewedHotels: []
                    };
                    enrichData(allEstabs);
                    angular.forEach(allEstabs, function (estab) {
                        estab.EstablishmentDetail.Url = estab.EstablishmentDetail.Url.replace('/', '');
                        if (estab.IsReviewedByUser) {
                            visitedEstabInfo.ReviewedHotels.push(estab);
                        }
                        else {
                            visitedEstabInfo.UnreviewedHotels.push(estab);
                        }
                    });
                    var estabDict = arrayUtil.toDict(allEstabs, function (e) { return e.EstablishmentDetail.Id; }, function (e) {
                        e.EstablishmentDetail.ImageUrl = e.ImageUrl;
                        return e.EstablishmentDetail;
                    });
                    arrayUtil.map(userReviews, function (r) {
                        r.Establishment = estabDict[r.EstabId];
                        return r;
                    });
                    return {
                        estabs: visitedEstabInfo,
                        reviews: userReviews
                    };
                });
            }
            return dashBoardAggPromise;
        }
        function enrichData(estabs) {
            angular.forEach(estabs, function (estab) {
                var dim = TRPCONFIG.DeviceSettings.LandingImageHeight;
                estab.ImageUrl = imageService.getMainImageUrl(estab.EstablishmentDetail.Id, dim, dim);
            });
        }
        function getHotelsById(estabIds) {
            return $http.post('/api/hotels/static/gethotelsbyid', {
                Ids: estabIds,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                FieldFlags: fieldGroupService.getFieldGroup([
                    fieldTypes.Global,
                    fieldTypes.Titles
                ])
            }, { ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        function getAggregate() {
            return _getDashBoardAggregates();
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('dashboardBookingService', dashboardBookingService);
    function dashboardBookingService($http, $q, $routeParams, resourceService, dateUtil, broker, $location, crossSellService, customCurrencyFilter, dashboardBookingsErrorMessage, authService, bookingActionLink, imageService, $interpolate, unadjustedDateFilter, mybTrack) {
        var bookingActions = {
            VIEWBOOKINGDETAILS: {
                label: 'DASHBOARDRESOURCE_VIEWDETAILS',
                icon: 'icon-menu'
            },
            CSR: {
                label: 'DASHBOARDRESOURCE_CSR',
                icon: 'icon-support'
            },
            VOUCHERACTIONS: {
                label: 'DASHBOARDRESOURCE_RESENDEMAIL',
                icon: 'icon-email',
                trackEvent: 'MYB - Resend Email'
            },
            CHANGECONTACTDETAILS: {
                label: 'DASHBOARDRESOURCE_CHANGECONTACTDETAILS',
                icon: 'icon-edit'
            },
            CANCELBOOKINGS: {
                label: 'DASHBOARDRESOURCE_CANCELBOOKINGS',
                icon: 'icon-close',
                trackEvent: 'MYB - Cancel Click'
            },
            PAYBALANCE: {
                label: 'DASHBOARDRESOURCE_PAYBALANCE',
                icon: TRPCONFIG.Domain.CurrencyCode === 'EUR' ? 'icon-symbol-eur' : 'icon-symbol-gbp' //TODO: only two currencies?
            },
            ENTERAPI: {
                label: 'DASHBOARDRESOURCE_ENTERPASSENGERDETAILS',
                icon: 'icon-passenger'
            },
            PRINTVOUCHER: {
                label: 'DASHBOARDRESOURCE_PRINTVOUCHER',
                icon: 'icon-print',
                trackEvent: 'MYB - Print Booking'
            },
            PRINTRECEIPT: {
                label: 'DASHBOARDRESOURCE_PRINTRECEIPT',
                icon: 'icon-print',
                trackEvent: 'MYB - Print Booking'
            },
            AMENDBOOKING: {
                label: 'DASHBOARDRESOURCE_AMENDBOOKING',
                icon: 'icon-edit-booking',
                trackEvent: 'MYB - Amend Click'
            },
            ENTERREVIEW: {
                label: 'DASHBOARDRESOURCE_ENTERREVIEW',
                icon: 'icon-reviews'
            },
            ADDBAGGAGE: {
                label: 'ADDBAGGAGE',
                icon: 'icon-baggage'
            },
            DERWENTLINK: {
                label: 'DASHBOARDRESOURCE_DERWENTLINK',
                icon: 'icon-menu'
            },
            PRINTINVOICE: {
                label: 'DASHBOARDRESOURCE_PRINTINVOICE',
                icon: 'icon-print'
            }
        };
        var bookingTypes = {
            1: { template: 'flight', code: 'MANAGEFLIGHT', ticket: 'TICKETS', icon: 'icon-flights' },
            2: { template: 'tickets', code: 'MANAGETICKETS', ticket: 'TICKETS', icon: 'icon-attractions', defaultImage: '/build/img/assets/product/attractions.jpg' },
            4: { template: 'car-hire', code: 'MANAGECARHIRE', ticket: 'VOUCHERS', icon: 'icon-car-hire', defaultImage: '/build/img/assets/car_hire.jpg' },
            8: { template: 'accommodation', code: 'MANAGEACCOMODATION', ticket: 'VOUCHERS', icon: 'icon-hotels' },
            9: { template: 'holiday', code: 'MANAGEHOLIDAY' },
            16: { template: 'parking', code: 'MANAGEPARKING', icon: 'icon-parking', defaultImage: '/build/img/assets/product/parking.jpg' },
            32: { template: 'transfer', code: 'MANAGETRANSFER', icon: 'icon-transfers', defaultImage: '/build/img/assets/product/transfers.jpg' },
            64: { template: 'insurance', code: 'MANAGEINSURANCE', icon: 'icon-insurance', defaultImage: '/build/img/assets/product/travel-insurance.jpg' },
            128: { template: 'package-holidays', code: 'MANAGEPACKAGE' },
            256: { template: 'marhaba', code: 'MANAGEMARHARBA', icon: 'icon-marhaba', defaultImage: '/build/img/assets/product/marhaba.jpg' },
            1024: { template: 'bundle', code: 'MANAGEBUNDLE', icon: 'icon-stack', defaultImage: '/build/img/assets/product/bundle.jpg' },
            2048: { template: 'adhoc', code: 'MANAGEADHOC', icon: 'icon-attractions', defaultImage: '/build/img/assets/product/adhoc.jpg' }
        };
        var bookingTypeMap = {
            accommodation: 8,
            flight: 1,
            attraction: 2,
            carhire: 4,
            transfer: 32,
            travelInsurance: 64,
            bundle: 1024
        };
        var bookingInfoItemType = {
            Generic: 1,
            CancellationCondition: 2
        };
        var baseManageUrl = '/api2/managebooking';
        var v2ManageUrl = '/api2/bookings/manage';
        var bookingStatus = {
            confirmed: 1,
            pending: 2,
            canceled: 3
        };
        var limitBooking = 10;
        var itineraryType = {
            FlightOutbound: 1,
            FlightInbound: 2,
            CarHire: 3,
            HotelRoom: 4,
            AttractionTicket: 5,
            FlightInfo: 6,
            CarParking: 7,
            TransferArrival: 8,
            TransferReturn: 9,
            Insurance: 10,
            PackageHoliday: 11,
            Marhaba: 13
        };
        var tripsPromiseCache = {};
        var destinationType = {
            None: 0,
            Establishment: 1,
            Location: 2,
            Province: 3,
            Country: 4,
            Place: 5,
            Polygon: 10,
            Universal: 12
        };
        var bookingImageWidth = 300;
        var bookingImageHeight = 190;
        var service = {
            getBookingDetailsForTrip: getBookingDetailsForTrip,
            getOutstandingTrips: getOutstandingTrips,
            getBookingStatus: function () { return angular.copy(bookingStatus); },
            getBookingTypeMap: function () { return angular.copy(bookingTypeMap); },
            getBookingInfoItemType: function () { return angular.copy(bookingInfoItemType); },
            getLimitBooking: function () { return limitBooking; },
            getItineraryType: function () { return angular.copy(itineraryType); },
            getBookingDetail: getBookingDetail,
            getFuturePayments: getFuturePayments,
            getBookingSummary: getBookingSummary,
            getConfirmationEmailInfo: getConfirmationEmailInfo,
            getActionLinks: function () { return bookingActionLink.get(); },
            formatTitle: formatTitle,
            sendConfirmationEmail: sendConfirmationEmail,
            getContact: getContact,
            putContact: putContact,
            removeCanceledBookings: removeCanceledBookings,
            calculateType: calculateType,
            formatBookingMessage: formatBookingMessage,
            setLimitBooking: setLimitBooking,
            getBookingInfo: getBookingInfo,
            getObjectFromBooking: getObjectFromBooking,
            actionClick: actionClick,
            getChildActions: getChildActions,
            getPahFromNotifications: getPahFromNotifications,
            getBookingActions: getBookingActions,
            translateActionLink: translateActionLink,
            getTripTitle: getTripTitle,
            getFlightBooking: getFlightBooking,
            isPartOfHoliday: isPartOfHoliday,
            getMybBooking: getMybBooking,
            getTripDateText: getTripDateText
        };
        function calculateType(abbr) {
            return bookingTypes[abbr] || abbr;
        }
        function getBookingActions() {
            return angular.copy(bookingActions);
        }
        // Gets the list of trips linked to the user
        function _getTripsInformation(period, tripId) {
            return $http.post('website/dashboard/trips/information', {
                Period: period,
                TripId: tripId
            }).then(function (res) {
                if (!res || !res.data || !res.data.Trips || (!res.data.Trips.length && tripId) || res.data.InValidOwner) {
                    return _bookingOwnershipRejection(tripId);
                }
                return res.data.Trips;
            });
        }
        function getBookingDetailsForTrip(tripId) {
            return $http.post(v2ManageUrl + "/getbookingdetailsfortrip", { TripId: tripId, CultureCode: TRPCONFIG.Domain.CultureCode })
                .then(function (res) {
                var bookingDetails = angular
                    .copy(res.data.BookingDetails)
                    .filter(function (d) { return d.BookedItems && d.BookedItems.length && d.Booking && d.LeadPassenger; });
                bookingDetails.forEach(function (detail) {
                    if (detail.Booking) {
                        detail.Booking.LongType = calculateType(detail.Booking.Type);
                    }
                });
                return bookingDetails;
            });
        }
        function getOutstandingTrips(period, tripId, crossSell) {
            if (crossSell === void 0) { crossSell = false; }
            if (tripsPromiseCache[period]) {
                return tripsPromiseCache[period];
            }
            if (tripId && tripsPromiseCache.reference && tripsPromiseCache.reference[tripId]) {
                return tripsPromiseCache.reference[tripId];
            }
            var tripsPromise = _getTripsInformation(period, tripId)
                .then(function _parseOutstandingTrip(trips) {
                ['userSet', 'bookingComplete', 'paymentComplete', 'reviewEntered', 'csrRaised', 'apiAdded']
                    .forEach(function (event) { return broker.subscribe('dashboardBookingService', event, function () { return tripsPromiseCache = {}; }); });
                if (trips && trips.length) {
                    trips[0].isExpanded = true;
                    if (tripId && trips.length === 1) {
                        trips[0].Bookings[0].showOptions = true;
                    }
                    trips.forEach(function (tr) {
                        tr.Bookings.forEach(function (bk) {
                            bk.LongType = calculateType(bk.Type);
                            _createActionList(bk);
                            _addBookingImage(bk);
                        });
                        _processPackageTripIfNeeded(tr);
                    });
                    var flightBooking_2 = _.find(trips[0].Bookings, function (b) { return b.Type === 1; });
                    if (flightBooking_2 && !flightBooking_2.ObjectId) {
                        service.getObjectFromBooking(flightBooking_2.BookingId).then(function (obj) {
                            return flightBooking_2.ImageUrl = imageService.getDestinationImage(obj, bookingImageWidth, bookingImageHeight);
                        });
                    }
                    if (crossSell) {
                        crossSellService.addExtrasAndCrossSells(trips[0]);
                    }
                }
                return trips;
            });
            if (period) {
                tripsPromiseCache[period] = tripsPromise;
            }
            else {
                if (!tripsPromiseCache.reference) {
                    tripsPromiseCache.reference = {};
                }
                tripsPromiseCache.reference[tripId] = tripsPromise;
            }
            return tripsPromise;
        }
        function getTripTitle(tr) {
            return _.uniqBy(tr.Bookings, 'Type').reduce(function (title, bk, index) {
                return title + (index ? ' + ' : '') + resourceService.get(bk.LongType.code);
            }, '');
        }
        function isPartOfHoliday(bookingId) {
            return getOutstandingTrips(null, bookingId).then(function (trips) {
                return _.every(trips, function (tr) { return _.some(tr.Bookings, function (bk) { return bk.Type === bookingTypeMap.flight; })
                    && _.some(tr.Bookings, function (bk) { return bk.Type === bookingTypeMap.accommodation; }); });
            });
        }
        function getTripDateText(tr) {
            var bookings = angular.copy(tr.Bookings);
            var cancelled = _.remove(bookings, function (bk) { return bk.Status === bookingStatus.canceled; });
            var oldBookings = _.remove(bookings, function (bk) { return dateUtil.compareDates(bk.ReturnDate, dateUtil.todayPlus(0, 0, true)) === -1; });
            if (cancelled.length === tr.Bookings.length) {
                return resourceService.get('TRIPCANCELLED');
            }
            var bookingsForTrip = bookings.length ? bookings : oldBookings;
            if (bookingsForTrip.length > 0) {
                return resourceService.get('TRIPDATE') + " " + unadjustedDateFilter(_.reduce(bookingsForTrip, function (startDate, bk) {
                    return (dateUtil.compareDates(bk.StartDate, startDate) === -1) ? bk.StartDate : startDate;
                }, bookingsForTrip[0].StartDate), 'dd MMM yyyy');
            }
        }
        function _createActionList(booking) {
            booking.BookingOptions.Actions.map(function (a) {
                var action = bookingActions[a.Name];
                a.label = action ? action.label : a.Name;
                if (action) {
                    a.icon = action.icon;
                    a.trackEvent = action.trackEvent;
                }
                return a;
            });
        }
        function _addBookingImage(bk) {
            if (bk.Type === bookingTypeMap.accommodation) {
                bk.ImageUrl = imageService.getMainImageUrl(bk.ObjectId, bookingImageWidth, bookingImageHeight, true);
            }
            if (!bk.ImageUrl) {
                bk.ImageUrl = bookingTypes[bk.Type].defaultImage;
            }
        }
        function _processPackageTripIfNeeded(trip) {
            var _a = [8, 1].map(function (type) { return _.chain(trip)
                .get('Bookings')
                .find(['Type', type]); }), hotelBooking = _a[0], flightBooking = _a[1];
            var removePayBalance = [hotelBooking, flightBooking].every(function (booking) {
                return booking.get('PackageId').value();
            });
            if (removePayBalance) {
                var messages = _.chain([flightBooking, hotelBooking])
                    .map(function (booking) { return booking.pick(['BalanceDueInfo', 'BookingId']).value(); })
                    .filter('BalanceDueInfo')
                    .value();
                var actions = _.chain([flightBooking, hotelBooking]).flatMap(function (booking) {
                    booking.unset('BalanceDueInfo')
                        .value();
                    booking.get('TopInfoTexts')
                        .remove(function (info) { return info && info.type === 8; })
                        .value();
                    return booking.get('BookingOptions.Actions')
                        .remove(function (action) { return action && action.Name === 'PAYBALANCE'; })
                        .value();
                }).value();
                trip.packagePaymentsData = _.zipWith(messages, actions, function (message, action) { return _.defaults(message, { Action: action }); });
            }
        }
        function getObjectFromBooking(bookingId) {
            var obj = {};
            return service.getFlightBooking(bookingId).then(function (result) {
                var bookedItems = result.data;
                var destinationAirportCode = _.find(bookedItems.Itineraries, function (i) { return i.ItineraryTypeId === 1; }).DestinationAiport;
                return $http.get("/api2/destination/airports/getairportlocation?" + $.param({
                    airportCode: destinationAirportCode,
                    cultureCode: TRPCONFIG.Domain.CultureCode
                }), { ignoreErrors: true }).then(function (r) {
                    var destination = r.data;
                    obj.ObjectId = destination.LocationId !== 0 ? destination.LocationId : destination.ProvinceId;
                    obj.ObjectTypeId = destination.LocationId !== 0 ? destinationType.Location : destinationType.Province;
                    return obj;
                });
            });
        }
        function getFlightBooking(bookingId) {
            return $http.get("/api2/flightsnew/booking/" + bookingId, { cache: true, ignoreErrors: true });
        }
        function getBookingInfo(bookingId) {
            return getOutstandingTrips(null, bookingId, true).then(function (trips) {
                return _.find(trips[0].Bookings, function (bk) {
                    return bk.BookingId === parseInt(bookingId);
                });
            });
        }
        function setLimitBooking(n) {
            limitBooking = n;
        }
        function actionClick(action, booking) {
            var actionLink = service.getActionLinks();
            if (action.disabled) {
                return false;
            }
            if (TRPCONFIG.Domain2.BookingCtaRedirectEnabled) {
                var enableRedirect = ['CANCELBOOKINGS', 'CSR', 'AMENDBOOKING'].includes(action.Name);
                if (enableRedirect) {
                    window.open(TRPCONFIG.Domain2.BookingCtaRedirectUrl, '_blank');
                    return false;
                }
            }
            if (actionLink) {
                if (action.trackEvent) {
                    mybTrack.track(action.trackEvent);
                }
                var path = translateActionLink(actionLink[action.Name], booking);
                if (action.OpenNewTab) {
                    window.open(path, '_blank');
                    return false;
                }
                $location.url(path);
            }
        }
        function translateActionLink(link, booking) {
            return link ? $interpolate(link)(booking) : '';
        }
        var TopInfo = {
            PayAtHotel: 7
        };
        var notificationData = {
            3: 'BalanceDue',
            7: 'PayAtHotel'
        };
        function formatBookingMessage(info, bk) {
            var resourceVal = resourceService.get(info.text);
            if (info.action.Name) {
                var actionLink = service.getActionLinks();
                var actionPath = translateActionLink(actionLink[info.action.Name], bk);
                resourceVal = String.format(resourceVal, actionPath);
            }
            switch (info.type) {
                case TopInfo.PayAtHotel: {
                    var pah = getPahFromNotifications(bk.Notifications);
                    return pah ? String.format(resourceVal, customCurrencyFilter(pah.Amount, pah.CurrencyCode)) : '';
                }
            }
            return resourceVal;
        }
        function getPahFromNotifications(notifications) {
            return _.reduce(notifications, function (pah, n) {
                if (TopInfo.PayAtHotel === TopInfo[notificationData[n.Type]]) {
                    pah.Amount += n.Amount;
                    pah.CurrencyCode = n.CurrencyCode;
                }
                return pah;
            }, { Amount: 0 });
        }
        function removeCanceledBookings(trips) {
            var filteredTrips = [];
            _.forEach(trips, function (t) {
                t.Bookings = _.filter(t.Bookings, function (b) { return b.Status !== bookingStatus.canceled; });
                if (t.Bookings.length > 0) {
                    filteredTrips.push(t);
                }
            });
            return filteredTrips;
        }
        // Gets details regarding a booking and adds full booking type
        function getBookingDetail(bookingId, viewDetail) {
            if (viewDetail === void 0) { viewDetail = false; }
            var cultureCode = TRPCONFIG.Domain.CultureCode;
            var promise = viewDetail
                ? $http.get("website/bookingdetails/" + bookingId + "/" + cultureCode) : $http.post(v2ManageUrl + "/getbookingdetailv2", { BookingId: bookingId, Culture: cultureCode });
            return promise.then(function (res) {
                if (!res || !res.data) {
                    return;
                }
                if (res.data.InValidOwner) {
                    return _bookingOwnershipRejection(bookingId);
                }
                if (viewDetail) {
                    return parseBooking(res.data);
                }
                return res.data;
            });
        }
        function getFuturePayments(booking) {
            if (!booking) {
                return $q.when();
            }
            return getBookingDetail(booking.BookingId, true).then(function (details) { return _.get(details, 'FuturePayments'); })
                .then(function (fp) { return booking.FuturePayments = fp; });
        }
        function parseBooking(detail) {
            var booking = detail.Booking;
            booking.LongType = calculateType(booking.Type);
            var passengerTitles = {
                accommodation: {
                    plural: 'GUESTS',
                    singular: 'LEADGUEST'
                },
                tickets: {
                    plural: 'VISITORS',
                    singular: 'VISITOR'
                },
                defaultTitle: {
                    plural: 'PASSENGERS',
                    singular: 'PASSENGER'
                }
            };
            var titles = passengerTitles[booking.LongType.template] || passengerTitles.defaultTitle;
            booking.PassengersTitlePlural = resourceService.get(titles.plural);
            booking.PassengersTitleSingular = resourceService.get(titles.singular);
            return detail;
        }
        // Gets booking summary
        function getBookingSummary(bookingId) {
            return $http.get(v2ManageUrl + "/bookingsummary?bookingId=" + bookingId, { ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        // Gets details regarding the confirmation email
        function getConfirmationEmailInfo(bookingId) {
            var cultureCode = TRPCONFIG.Domain.CultureCode;
            return $http.post(baseManageUrl + "/getconfirmationemailinfo", { BookingId: bookingId, Culture: cultureCode });
        }
        // Gets contact
        function getContact(bookingId) {
            return $http.get(v2ManageUrl + "/contactdetails/" + bookingId);
        }
        // updates contact
        function putContact(bookingId, contactDetail, updateRelatedBookings) {
            if (updateRelatedBookings) {
                contactDetail.BookingId = bookingId;
                return $http.post(String.format('{0}/{1}/{2}', v2ManageUrl, 'contactdetails', 'updatecontactdetailsforlinkedbookings'), contactDetail);
            }
            return $http.put(String.format('{0}/{1}/{2}', v2ManageUrl, 'contactdetails', bookingId), contactDetail);
        }
        // Format the Title by removing the supplier name
        function formatTitle(bk) {
            //If not Insurance booking
            if (bk.Type !== bookingTypeMap.travelInsurance && bk.Type !== bookingTypeMap.bundle && bk.Title) {
                var titleArray = bk.Title.split(':');
                bk.Title = (titleArray.length > 1) ? titleArray[1].trim() : titleArray[0];
            }
        }
        //Resend Email Confirmation
        function sendConfirmationEmail(emails, bookingId) {
            return $http.post(baseManageUrl + "/sendconfirmationemail", {
                BookingId: bookingId,
                Culture: TRPCONFIG.Domain.CultureCode,
                Emails: emails
            });
        }
        function _bookingOwnershipRejection(id) {
            dashboardBookingsErrorMessage.setMessage(id);
            var user = authService.getUser();
            if (user.HardSignedIn) {
                $location.path('/dashboard/bookings/current');
            }
            var bookingId = authService.getSignedInBookingId();
            if (bookingId) {
                $location.path("/dashboard/bookings/reference/" + bookingId);
            }
            return $q.reject();
        }
        function getChildActions(actions, parent) {
            return _.filter(actions, function (a) {
                return a.ParentActionName === parent;
            });
        }
        function getMybBooking(BookingId) {
            if (BookingId === void 0) { BookingId = $routeParams.BookingId; }
            return $http.get('/api/bookings/myb/getbooking', {
                params: {
                    BookingId: BookingId,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                },
                cache: true,
            })
                .then(function (_a) {
                var data = _a.data;
                return data;
            });
        }
        return service;
    }
})();
var Dashboard;
(function (Dashboard) {
    var DashboardBookingsErrorMessage = /** @class */ (function () {
        function DashboardBookingsErrorMessage() {
        }
        DashboardBookingsErrorMessage.prototype.setMessage = function (bookingId) {
            this.bookingNotYours = bookingId;
        };
        DashboardBookingsErrorMessage.prototype.getMessage = function () {
            var bookingId = this.bookingNotYours;
            this.bookingNotYours = null;
            return bookingId;
        };
        return DashboardBookingsErrorMessage;
    }());
    Dashboard.DashboardBookingsErrorMessage = DashboardBookingsErrorMessage;
    angular
        .module('dashboard')
        .service('dashboardBookingsErrorMessage', DashboardBookingsErrorMessage);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var DashboardBreadCrumb = /** @class */ (function () {
        function DashboardBreadCrumb(resourceService, unadjustedDateFilter, dashboardBookingService, currentUser, $routeParams) {
            this.resourceService = resourceService;
            this.unadjustedDateFilter = unadjustedDateFilter;
            this.dashboardBookingService = dashboardBookingService;
            this.currentUser = currentUser;
            this.$routeParams = $routeParams;
            this.extraCrumbs = {
                MYBOOKINGS: {
                    label: this.resourceService.get(this.currentUser.get().HardSignedIn
                        ? 'DASHBOARDRESOURCE_MYBOOKINGS'
                        : 'DASHBOARDRESOURCE_MYBOOKING'),
                    PagePath: this.currentUser.get().HardSignedIn ?
                        'dashboard/bookings/current' : 'dashboard/bookings/reference/{{::BookingId}}'
                },
                RAISECSR: {
                    label: 'DASHBOARDRESOURCE_RAISECSR',
                    PagePath: 'dashboard/create-csr/{{::BookingId}}'
                },
                CSRDETAILS: {
                    label: this.resourceService.get('CSRREF') + ': {{::CsrId}}',
                    PagePath: 'dashboard/csr-details/{{::BookingId}}/{{::CsrId}}'
                },
                SEATSELECTION: {
                    label: this.resourceService.get('SEATSELECTIONBREADCRUMB'),
                    PagePath: 'dashboard/seat-selection/{{::BookingId}}'
                }
            };
            this.bookingTypes = dashboardBookingService.getBookingTypeMap();
        }
        DashboardBreadCrumb.prototype.get = function (pages, bk) {
            var _this = this;
            if (bk) {
                var bookingType = this.getBookingTypeText(bk);
                var title = bk.Title ? (bk.Title + ' ') : '';
                this.extraCrumbs['VIEWBOOKINGDETAILS'] = {
                    label: "" + title + bookingType + " " + this.unadjustedDateFilter(bk.StartDate, 'dd MMM yyyy'),
                    PagePath: 'dashboard/booking-details/{{::BookingId}}'
                };
            }
            var actions = _.extend(this.dashboardBookingService.getBookingActions(), this.extraCrumbs);
            if (pages) {
                var actionLinks_1 = this.dashboardBookingService.getActionLinks();
                var crumbTrail = pages.split('|').map(function (page) { return ({
                    Title: _this.dashboardBookingService.translateActionLink(actions[page]
                        && _this.resourceService.get(actions[page].label), {
                        BookingId: bk && bk.BookingId,
                        CsrId: _this.$routeParams.csrId
                    }),
                    PagePath: _this.dashboardBookingService.translateActionLink(actions[page] && actions[page].PagePath
                        || actionLinks_1[page], {
                        BookingId: bk && bk.BookingId,
                        CsrId: _this.$routeParams.csrId
                    })
                }); }).filter(function (page) { return page.PagePath && page.Title; });
                return crumbTrail;
            }
            return [];
        };
        DashboardBreadCrumb.prototype.getBookingTypeText = function (bk) {
            return _.includes([
                this.bookingTypes.transfer,
                this.bookingTypes.accommodation,
                this.bookingTypes.attraction,
            ], bk.Type) ? '' : this.resourceService.get(bk.LongType.code);
        };
        return DashboardBreadCrumb;
    }());
    Dashboard.DashboardBreadCrumb = DashboardBreadCrumb;
    angular
        .module('dashboard')
        .service('dashboardBreadCrumbDetails', DashboardBreadCrumb);
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('dashboardCsrService', dashboardCsrService);
    function dashboardCsrService($http, $q, resourceService, dateUtil, dashboardBookingService) {
        var csrStatus = {
            1: 'CSRUNALLOCATED',
            2: 'CSRINPROGRESS',
            3: 'CSRSTATUSCOMPLETED',
            4: 'CSRAWAITINGRESPONSE',
            5: 'CSRAWAITINGACKNOWLEDGEMENT'
        };
        var csrStatusClass = {
            1: 'csr-unallocated',
            2: 'csr-inprogress',
            3: 'csr-completed',
            4: 'csr-awaiting-response',
            5: 'csr-waiting-acknowledge'
        };
        var baseCsrUrl = '/api2/csr/customer';
        var service = {
            getCSRStatus: getCSRStatus,
            getCSRStatusCode: getCSRStatusCode,
            getCSRSummary: getCSRSummary,
            getCSRDetail: getCSRDetail,
            getCsrCategories: getCsrCategories,
            createCsr: createCsr,
            getAllCSRs: getAllCSRs,
            htmlifyLineBreaks: htmlifyLineBreaks,
            getCsrStatusClass: getCsrStatusClass,
            getConvertationFromCsr: getConvertationFromCsr,
            addCsrToBooking: addCsrToBooking,
            getSenderTitle: getSenderTitle,
            submitMessage: submitMessage
        };
        function getAllCSRs() {
            return $http.get(baseCsrUrl + "?domainId=" + TRPCONFIG.Domain.DomainId, { ignoreErrors: true }).then(function (res) {
                return _.map(res.data, function (csr) { return _enrichCSR(csr); });
            });
        }
        function getCSRStatus(id) {
            return resourceService.get(csrStatus[id]);
        }
        function getCSRStatusCode(id) {
            return angular.copy(csrStatus[id]);
        }
        function getCsrStatusClass(id) {
            return angular.copy(csrStatusClass[id]);
        }
        function getCSRSummary(bookingId) {
            return $http.get(baseCsrUrl + "/booking/" + bookingId).then(_parseCSRSummary);
        }
        function getCSRDetail(bookingId) {
            return $http.get(baseCsrUrl + "/" + bookingId).then(function (r) { return _enrichCSR(r.data); });
        }
        function _parseCSRSummary(res) {
            var csr = {
                completed: [],
                pending: []
            };
            res.data.forEach(function (item) {
                _enrichCSR(item);
                if (item.Status === 3) {
                    csr.completed.push(item);
                }
                else {
                    csr.pending.push(item);
                }
            });
            csr.pending = _.orderBy(csr.pending, function (csr) { return csr.lastUpdated; }, 'desc');
            return csr;
        }
        function _enrichCSR(item) {
            item.conversation = getConvertationFromCsr(item);
            item.openQuestion = _.find(item.Questions, function (q) { return !q.Answer; });
            item.lastUpdated = _.reduce(item.conversation, function (updatedDate, c) {
                return (dateUtil.compareDates(c.date, updatedDate) === 1) ? c.date : updatedDate;
            }, item.CreatedDate);
            item.StatusResource = getCSRStatus(item.Status);
            item.AddNoteAllowed = item.Status !== 3;
            return item;
        }
        function getCsrCategories(bookingType, bookingId) {
            return $http.get("/api2/csr/categories?" + $.param({
                BookingType: bookingType,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                BookingId: bookingId
            })).then(function (result) {
                return result.data;
            });
        }
        function createCsr(csr, bookingId, mobileTel) {
            return $http.post(baseCsrUrl, {
                DomainId: TRPCONFIG.Domain.DomainId,
                BookingId: bookingId,
                CategoryId: csr.Category.Id,
                TextAlerts: csr.TextAlerts,
                Subject: csr.Subject,
                Text: csr.Text,
                MobileTel: mobileTel
            }).then(function (res) {
                return res.data;
            });
        }
        function _answerToQuestion(questionId, answerText) {
            return $http.post(baseCsrUrl + "/question/" + questionId + "/answer", {
                AnswerText: answerText
            });
        }
        function _addLogToCsr(log, csrId) {
            return $http.post(baseCsrUrl + "/" + csrId + "/log", log);
        }
        function submitMessage(csr) {
            var question = _.find(csr.conversation, function (c) { return c.openQuestion; });
            if (question && (question.questionId > -1)) {
                return _answerToQuestion(question.questionId, csr.newMessage).then(function () {
                    csr.conversation.push({
                        text: htmlifyLineBreaks(csr.newMessage),
                        createdByCustomer: true
                    });
                    csr.newMessage = null;
                    question.openQuestion = null;
                    return true;
                });
            }
            if (csr.AddNoteAllowed) {
                return _addLogToCsr({ Text: csr.newMessage }, csr.CsrId).then(function () {
                    csr.conversation.push({
                        text: htmlifyLineBreaks(csr.newMessage),
                        createdByCustomer: true
                    });
                    csr.newMessage = null;
                    return true;
                });
            }
            return $q.when(false);
        }
        function htmlifyLineBreaks(text) {
            return text ? text.replace(/<br\/>\s*\n|\n\s*<br\/>/g, '<br/>').replace(/\n/g, '<br/>') : text;
        }
        function getConvertationFromCsr(csr) {
            var openQuestion = _.find(csr.Questions, function (q) { return !q.Answer; });
            var sortedCoversation = _.orderBy(_.concat(csr.Questions, csr.Logs), function (c) { return c.QuestionDate || c.CreatedDate; });
            var initialText = {
                text: htmlifyLineBreaks(csr.Text),
                date: csr.CreatedDate,
                createdByCustomer: !csr.AgentName,
                agentName: csr.AgentName
            };
            var conversations = _.flatMap(sortedCoversation, function (c) {
                if (c.QuestionDate) {
                    //c is a question and answer
                    if (c.Answer) {
                        var q = {
                            text: htmlifyLineBreaks(c.QuestionText),
                            date: c.QuestionDate,
                            agentName: c.AgentName
                        };
                        var a = {
                            text: htmlifyLineBreaks(c.Answer),
                            date: c.AnswerDate,
                            createdByCustomer: true
                        };
                        return [q, a];
                    }
                }
                else {
                    // c is a log
                    var l = {
                        text: htmlifyLineBreaks(c.Text),
                        date: c.CreatedDate,
                        createdByCustomer: c.CreatedByCustomer,
                        agentName: c.AgentName
                    };
                    return l;
                }
            });
            if (openQuestion) {
                var q = {
                    text: htmlifyLineBreaks(openQuestion.QuestionText),
                    date: openQuestion.QuestionDate,
                    questionId: openQuestion.Id,
                    openQuestion: true,
                    agentName: openQuestion.AgentName
                };
                conversations.push(q);
            }
            var validConversation = _.filter(conversations, function (c) { return c != null; });
            if (initialText.text != null && initialText.text.length > 0) {
                validConversation.unshift(initialText);
            }
            return validConversation;
        }
        function getSenderTitle(conversation) {
            return conversation.createdByCustomer ?
                resourceService.get('CSRYOUASKED') :
                String.format(resourceService.get('CSRAGENTASKED'), conversation.agentName);
        }
        function addCsrToBooking(trips) {
            service.getAllCSRs().then(function (csrs) {
                var allCsrs = _.orderBy(csrs, 'lastUpdated', 'desc');
                _.each(trips, function (tr) {
                    _.each(tr.Bookings, function (bk) {
                        bk.csr = {
                            message: _getCsrMessage(bk.BookingId, allCsrs),
                            statusClass: _getCsrStatusClass(bk.BookingId, allCsrs)
                        };
                    });
                });
            });
        }
        function _getCsrMessage(bookingId, allCsrs) {
            var csr = _.find(allCsrs, ['BookingId', bookingId]);
            var resourceVal = csr ? resourceService.get("MYB" + service.getCSRStatusCode(csr.Status)) : '';
            var actionPath = dashboardBookingService.translateActionLink('dashboard/csr/{{BookingId}}', { BookingId: bookingId });
            if (csr) {
                if (csr.Status === 4) {
                    var openQuestion = _.find(csr.Questions, function (q) { return !q.Answer; });
                    resourceVal = String.format(decodeURI(resourceVal), openQuestion.AgentName, actionPath);
                }
                else {
                    resourceVal = String.format(decodeURI(resourceVal), actionPath);
                }
            }
            return resourceVal;
        }
        function _getCsrStatusClass(bookingId, allCsrs) {
            var csr = _.find(allCsrs, ['BookingId', bookingId]);
            return csr ? service.getCsrStatusClass(csr.Status) : '';
        }
        return service;
    }
})();
var Dashboard;
(function (Dashboard) {
    var Notification;
    (function (Notification) {
        Notification[Notification["CreateProfile"] = 0] = "CreateProfile";
        Notification[Notification["TravelChange"] = 1] = "TravelChange";
        Notification[Notification["CsrQuestion"] = 2] = "CsrQuestion";
        Notification[Notification["DuePayment"] = 3] = "DuePayment";
        Notification[Notification["PassengerApi"] = 4] = "PassengerApi";
        Notification[Notification["NewsletterSignup"] = 5] = "NewsletterSignup";
        Notification[Notification["HotelReview"] = 6] = "HotelReview";
        Notification[Notification["PayAtHotel"] = 7] = "PayAtHotel";
        Notification[Notification["OutboundFlightCheckin"] = 8] = "OutboundFlightCheckin";
        Notification[Notification["InboundFlightCheckin"] = 9] = "InboundFlightCheckin";
    })(Notification || (Notification = {}));
    ;
    var DashboardNotificationService = /** @class */ (function () {
        //private _notificationLinks: _.Dictionary<T> = {1:'a'};
        function DashboardNotificationService($http, $location, $interpolate, $filter, dateUtil, resourceService, dashboardBookingService, notificationLink) {
            var _this = this;
            this.$http = $http;
            this.$location = $location;
            this.$interpolate = $interpolate;
            this.$filter = $filter;
            this.dateUtil = dateUtil;
            this.resourceService = resourceService;
            this.dashboardBookingService = dashboardBookingService;
            this.notificationLink = notificationLink;
            this._notificationTypes = {
                1: function () { return _.identity('NOTICSRCHANGE'); },
                2: function () { return _.identity('NOTICSR'); },
                3: function (n) { return _this._getPaymentDueString(n); },
                4: function () { return _.identity('NOTIAPI'); },
                6: function () { return _.identity('NOTIREVIEW'); },
                10: function () { return _.identity('NOTICREATEPROFILE'); }
            };
            this._notificationActionTypes = {
                1: 'NOTICSRCHANGE_ACTION',
                2: 'NOTICSR_ACTION',
                3: 'NOTIPAYMENT_DUE_ACTION',
                4: 'NOTIAPI_ACTION',
                6: 'NOTIREVIEW_ACTION',
                10: 'NOTICREATEPROFILE_ACTION'
            };
            this._paymentDueType = {
                hotelDue: 'NOTIDUEHOTEL',
                hotelOverDue: 'NOTIOVERDUEHOTEL',
                flightDue: 'NOTIDUEFLIGHT',
                flightOverDue: 'NOTIOVERDUEFLIGHT',
                transferDue: 'NOTIDUETRANSFER',
                transferOverDue: 'NOTIOVERDUETRANSFER'
            };
            this._desktopUrl = 'desktop-url/{{SiteId}}/{{BookingId}}/{{LastName}}';
            this.getNotificationLinks = function () { return _this.notificationLink.get(); };
        }
        DashboardNotificationService.prototype.getNotifications = function () {
            var _this = this;
            return this.$http.post('/api2/bookings/manage/getbookingnotifications', {
                Culture: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId
            }, { ignoreErrors: true }).then(function (result) { return _this._postProcess(result); });
        };
        //getNotificationLinks() {
        //    return angular.copy(this._notificationLinks);
        //}
        DashboardNotificationService.prototype.notificationClicked = function (notification) {
            var path = this._translateActionLink(this.getNotificationLinks()[notification.Type], notification);
            this.$location.url(path);
        };
        DashboardNotificationService.prototype.formatNotification = function (noti) {
            var resourceVal = this.resourceService.get(noti.templateString);
            var bookingType = this.resourceService.get(this.dashboardBookingService.calculateType(noti.BookingType).code);
            switch (noti.Type) {
                case Notification.TravelChange:
                    return String.format(resourceVal, bookingType, noti.DestinationName);
                case Notification.CsrQuestion:
                    return String.format(resourceVal, noti.AgentName, bookingType, noti.DestinationName);
                case Notification.DuePayment:
                    var dueDateText = this.dueDateText(noti);
                    return String.format(resourceVal, this.$filter('customCurrency')(noti.Amount, noti.CurrencyCode), noti.DestinationName, dueDateText);
                case Notification.PassengerApi:
                    return String.format(resourceVal, noti.DestinationName);
                case Notification.HotelReview:
                    return String.format(resourceVal, noti.DestinationName);
            }
            return resourceVal;
        };
        DashboardNotificationService.prototype.dueDateText = function (noti) {
            var days = this.dateUtil.dayDiff(this.dateUtil.todayPlus(0, 0, true), noti.DueDate) - 1;
            if (days > 1) {
                var daysWithin = this.resourceService.get('DAYSWITHIN');
                return String.format(daysWithin, days);
            }
            if (days === 1) {
                return this.resourceService.get('TOMORROW');
            }
            if (days === 0) {
                return this.resourceService.get('TODAY');
            }
            return '';
        };
        DashboardNotificationService.prototype._translateActionLink = function (link, booking) {
            return link ? this.$interpolate(link)(booking) : '';
        };
        DashboardNotificationService.prototype._getPaymentDueString = function (n) {
            var accommodationBooking = 8;
            var transferBooking = 32;
            var dayDiff = this.dateUtil.compareDates(this.dateUtil.todayPlus(1), n.DueDate);
            if (n.BookingType === accommodationBooking) {
                return (dayDiff === 1)
                    ? this._paymentDueType.hotelOverDue : this._paymentDueType.hotelDue;
            }
            if (n.BookingType === transferBooking) {
                return (dayDiff === 1)
                    ? this._paymentDueType.transferOverDue : this._paymentDueType.transferDue;
            }
            return (dayDiff === 1)
                ? this._paymentDueType.flightOverDue : this._paymentDueType.flightDue;
        };
        DashboardNotificationService.prototype._postProcess = function (result) {
            var _this = this;
            var notifications = result.data.Notifications;
            var validNoti = [];
            _.each(notifications, function (n) {
                if (_this._notificationTypes[n.Type]) {
                    n.templateString = _this._notificationTypes[n.Type](n);
                    n.actionString = _this.resourceService.get(_this._notificationActionTypes[n.Type]);
                    validNoti.push(n);
                }
            });
            return validNoti;
        };
        return DashboardNotificationService;
    }());
    Dashboard.DashboardNotificationService = DashboardNotificationService;
    angular
        .module('dashboard')
        .service('dashboardNotificationService', DashboardNotificationService);
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('deliveryAddressService', deliveryAddressService);
    function deliveryAddressService($http) {
        var url = '/api2/attractions/deliveryaddress/';
        return {
            get: function (bookingId) {
                return $http.get(url + bookingId);
            },
            put: function (bookingId, deliveryAddress) {
                return $http.put(String.format('{0}/{1}', url, bookingId), deliveryAddress);
            }
        };
    }
})();
var Dashboard;
(function (Dashboard) {
    var PassengerType = Core.Booking.PassengerType;
    var CrossSellType = Core.Booking.CrossSellType;
    var FlightExtrasService = /** @class */ (function () {
        function FlightExtrasService($http, dateUtil, paymentDetailsService, flightSeatPlanService, $q, broker) {
            var _this = this;
            this.$http = $http;
            this.dateUtil = dateUtil;
            this.paymentDetailsService = paymentDetailsService;
            this.flightSeatPlanService = flightSeatPlanService;
            this.$q = $q;
            this.broker = broker;
            this.extraProperties = {
                Bags: {
                    Icon: 'icon-baggage',
                    Code: 'HOLDBAGS'
                },
                Seats: {
                    Icon: 'icon-seating',
                    Code: 'SEATS'
                }
            };
            this.extrasCache = {};
            // make sure cross sells are updated after a payment
            broker.subscribe('flightExtraService', 'paymentComplete', function () { return _this.extrasCache = {}; });
        }
        FlightExtrasService.prototype.getOptionsData = function (bookingId) {
            var _this = this;
            return this.$http.post('/api2/bookings/flights/checkoptions', {
                BookingId: bookingId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DomainId: TRPCONFIG.Domain.DomainId
            }).then(function (_a) {
                var data = _a.data;
                // multi sector seat selection not yet supported
                var legs = data && data.Flight && data.Flight.Legs;
                var numberOfInfants = _.remove(data.Passengers, function (p) { return p.Type === PassengerType.Infant; }).length;
                var SeatPlan = legs && legs.length && legs.length <= 2
                    ? {
                        Segments: {
                            Outbound: legs[0].Segments,
                            Inbound: legs[1].Segments
                        },
                        Passengers: _.sortBy(data.Passengers, 'Type')
                            .map(function (p, pIndex) { return _.defaults({
                            Id: p.Id,
                            Seats: _.flatMap(legs, function (leg) { return leg.Segments.map(function (seg) { return ({
                                Number: null,
                                Price: 0,
                                LegId: leg.LegId,
                                Segement: seg.SegmentHash //intentionally misspelt
                            }); }); }),
                            IsChild: p.Type === PassengerType.Child,
                            HasInfant: p.Type === PassengerType.Adult && pIndex < numberOfInfants
                        }, p); })
                    }
                    : null;
                SeatPlan && _this.flightSeatPlanService.addMinCostPerPerson(SeatPlan);
                return _.defaults(data, { SeatPlan: SeatPlan });
            });
        };
        FlightExtrasService.prototype.getExtrasCrossSell = function (bookingId) {
            var _this = this;
            if (this.extrasCache[bookingId]) {
                return this.$q.when(this.extrasCache[bookingId]);
            }
            var extras = [];
            return this.getOptionsData(bookingId).then(function (options) {
                if (options && options.CanAddBags && options.BagOptions && options.BagOptions.length > 0) {
                    var extraBags = {
                        CrossSellType: CrossSellType.Baggage,
                        Price: {
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            Value: options.BagOptions[0].UnitAmount / 2
                        },
                        Priority: null,
                        IsFlightExtra: true,
                        BookingId: bookingId,
                        Name: 'ADDBAGGAGE',
                        Icon: _this.extraProperties.Bags.Icon,
                        Code: _this.extraProperties.Bags.Code
                    };
                    extraBags.Priority = extras.push(extraBags) - 1;
                }
                if (TRPCONFIG.Domain.DashboardAddSeatsEnabled && options && options.CanAddSeats) {
                    var extraSeats = {
                        CrossSellType: CrossSellType.Seats,
                        Price: {
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            Value: options.SeatPlan.minCostPerPerson
                        },
                        Priority: null,
                        IsFlightExtra: true,
                        BookingId: bookingId,
                        Name: 'ADDSEATS',
                        Icon: _this.extraProperties.Seats.Icon,
                        Code: _this.extraProperties.Seats.Code
                    };
                    extraSeats.Priority = extras.push(extraSeats) - 1;
                }
                _this.extrasCache[bookingId] = extras;
                return extras;
            }, function () { return extras; });
        };
        //Transaction
        FlightExtrasService.prototype.addOptionsToBooking = function (request, requireCardValidation) {
            var _this = this;
            if (requireCardValidation) {
                var paymentRequest = request.PaymentRequest;
                var validateRequest = {
                    CardNumber: TRPCONFIG.Domain.PCICompliant ?
                        paymentRequest.CardNumberMasked : paymentRequest.CardNumber,
                    StartDate: paymentRequest.CardStartYear && paymentRequest.CardEndMonth
                        && this.dateUtil.serialiseDate(new Date(paymentRequest.CardStartYear, paymentRequest.CardStartMonth)),
                    ExpiryDate: this.dateUtil.serialiseDate(new Date(paymentRequest.CardEndYear, paymentRequest.CardEndMonth)),
                    CV2: paymentRequest.CardCvc,
                    IssueNumber: paymentRequest.CardIssueNumber
                };
                return this.paymentDetailsService.validateCard(validateRequest).then(function (response) {
                    if (response.Success) {
                        return _this._clear(request);
                    }
                    return _this.$q.when(response);
                });
            }
            return this._clear(request);
        };
        FlightExtrasService.prototype._clear = function (request) {
            return this.$http.post('/api2/bookings/flights/addoptions', request).then(function (result) { return result.data; });
        };
        FlightExtrasService.prototype.finaliseOptions = function (request) {
            return this.$http.post('/api2/bookings/flights/finaliseoptions', request).then(function (result) { return result.data; });
        };
        return FlightExtrasService;
    }());
    Dashboard.FlightExtrasService = FlightExtrasService;
    angular
        .module('dashboard')
        .service('flightExtrasService', FlightExtrasService);
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var MybTrack = /** @class */ (function () {
        function MybTrack(analytics, currentUser) {
            this.analytics = analytics;
            this.currentUser = currentUser;
        }
        MybTrack.prototype.track = function (event, props) {
            if (props == null) {
                props = {};
            }
            props.SignIn = !!this.currentUser.get().HardSignedIn;
            this.analytics.track('mixpanel', event, props);
        };
        return MybTrack;
    }());
    Dashboard.MybTrack = MybTrack;
    angular
        .module('dashboard')
        .service('mybTrack', MybTrack);
})(Dashboard || (Dashboard = {}));
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('onlineCheckinService', onlineCheckinService);
    function onlineCheckinService($http, $filter, resourceService) {
        var checkinURL = '/api2/flightscheckin';
        var service = {
            getOnlineCheckinOptions: getOnlineCheckinOptions,
            doCheckin: doCheckin,
            getCheckinAvailability: getCheckinAvailability,
            getCheckinType: getCheckinType,
            addCheckinData: addCheckinData
        };
        var flightClass = {
            1: resourceService.getDeferred('ECONOMYCLASS'),
            2: resourceService.getDeferred('PREMIUMECONOMYCLASS'),
            4: resourceService.getDeferred('FIRSTCLASS'),
            8: resourceService.getDeferred('BUSINESSCLASS')
        };
        var checkinType = {
            Unknown: { label: resourceService.getDeferred('ONLINECHECKIN_CHECKINSTATUSUNKNOWN'), isEnabled: false, isSupported: false, isCheckedIn: false, apiRequired: false },
            NotSupported: { label: resourceService.getDeferred('ONLINECHECKIN_ONLINECHECKINNOTSUPPORTED'), isEnabled: false, isSupported: false, isCheckedIn: false, apiRequired: false },
            Available: { label: resourceService.getDeferred('ONLINECHECKIN_CANCHECKIN'), isEnabled: true, isSupported: true, isCheckedIn: false, apiRequired: false },
            CheckedIn: { label: resourceService.getDeferred('ONLINECHECKIN_ALREADYCHECKEDIN'), isEnabled: false, isSupported: false, isCheckedIn: true, apiRequired: false },
            ApiRequired: { label: resourceService.getDeferred('ONLINECHECKIN_PENDINGPASSENGERDETAILS'), isEnabled: false, isSupported: true, isCheckedIn: false, apiRequired: true },
            Closed: { label: resourceService.getDeferred('ONLINECHECKIN_CHECKINCLOSED'), isEnabled: false, isSupported: false, isCheckedIn: false, apiRequired: false },
            WaitingToOpen: { label: resourceService.getDeferred('ONLINECHECKIN_NOTINCHECKINWINDOW'), isEnabled: false, isSupported: true, isCheckedIn: false, apiRequired: false }
        };
        function getOnlineCheckinOptions(bookingId) {
            return $http.post(checkinURL + "/options", bookingId).then(function (result) {
                angular.forEach(result.data.Legs, function (leg) {
                    getCheckinType(leg);
                    leg.flightClass = flightClass[leg.FlightClass];
                    angular.forEach(leg.Passengers, function (passenger) {
                        passenger.passengerType = resourceService.get(passenger.Type);
                    });
                });
                return result.data;
            });
        }
        function doCheckin(bookingId, legs) {
            return $http.post(checkinURL + "/checkin", { BookingId: bookingId, Legs: legs }).then(function (response) {
                return response.data;
            });
        }
        function getCheckinAvailability(bookingIds) {
            return $http.post(checkinURL + "/availability", { BookingIds: bookingIds }, { ignoreErrors: true }).then(function (result) {
                var data = result.data;
                angular.forEach(data, function (legs, bookingId) {
                    var checkinData = {};
                    var startTime;
                    angular.forEach(legs, function (leg) {
                        var isLegEarlier = (leg && (leg.CheckinStartTime < startTime)) || !startTime;
                        startTime = leg && isLegEarlier ? leg.CheckinStartTime : startTime;
                    });
                    checkinData.checkinDisabled = !(startTime && (new Date() > new Date(startTime)));
                    checkinData.checkinMessage = !checkinData.checkinDisabled ? resourceService.get('ONLINECHECKIN_CHECKINENABLED') : String.format(resourceService.get('ONLINECHECKIN_CHECKINSTARTFROM'), $filter('date')(startTime, 'dd MMM yyyy'), $filter('date')(startTime, 'HH:mm'));
                    data[bookingId] = checkinData;
                });
                return data;
            });
        }
        function getCheckinType(leg) {
            leg.checkinType = checkinType[leg.CheckinState] ? checkinType[leg.CheckinState] : checkinType.Unknown;
        }
        function addCheckinData(trips) {
            var bookingIds = [];
            angular.forEach(trips, function (trip) {
                var booking = _.find(trip.Bookings, function (bk) { return bk.Status !== 2 && bk.DoesSupportOnlineCheckin; });
                if (booking) {
                    bookingIds.push(booking.BookingId);
                }
            });
            if (bookingIds.length > 0) {
                getCheckinAvailability(bookingIds).then(function (checkinData) {
                    angular.forEach(trips, function (trip) {
                        angular.forEach(trip.Bookings, function (bk) {
                            if (checkinData[bk.BookingId]) {
                                var checkinAction = _.find(bk.BookingOptions.Actions, function (action) {
                                    return action.Name === 'ONLINECHECKIN';
                                });
                                if (checkinAction) {
                                    checkinAction.disabled = checkinData[bk.BookingId].checkinDisabled;
                                    checkinAction.disabledInfo = checkinData[bk.BookingId].checkinMessage;
                                }
                            }
                        });
                    });
                });
            }
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('paymentDetailsService', paymentDetailsService);
    function paymentDetailsService($http, $q, dateUtil, resourceService, currentUser, bookingService) {
        var url = '/api2/payments/cards/customer/';
        var cardUrl = '/api2/payments/cards/';
        var transactionUrl = '/api2/payments/transactions/';
        var baseUrl = '/api2/payments/';
        var ddcTokenUrl = TRPCONFIG.Domain2.CPGIframeUpdate ? '/api2/payments/transactions/getcpgclienttoken' : '/api2/payments/tokens/ddctoken';
        var service = {
            getPaymentTypes: getPaymentTypes,
            getPaymentCards: getPaymentCards,
            getPaymentOptions: getPaymentOptions,
            getSavedPaymentCards: getSavedPaymentCards,
            clearPayment: clearPayment,
            authorisePayment: authorisePayment,
            getcardFailureReasonCode: getcardFailureReasonCode,
            getcardFailureReasonMessage: getcardFailureReasonMessage,
            getPaymentLogos: getPaymentLogos,
            convertToPaymentCards: convertToPaymentCards,
            validateCard: validateCard,
            getDeviceDataCollectionToken: getDeviceDataCollectionToken
        };
        var cardFailureReasonCode = {
            Unknown: 0,
            InvalidCardNumber: 1,
            InvalidCardNumberLength: 2,
            CardHasExpired: 3,
            CardNotYetValid: 4,
            InvalidIssueNumber: 5
        };
        var cardFailureReasonMessage = {
            0: 'INVALIDCARD',
            1: 'INVALIDCARDNUMBER',
            2: 'INVALIDCARDNUMBERLENGTH',
            3: 'CARDHASEXPIRED',
            4: 'CARDNOTYETVALID',
            5: 'INVALIDISSUENUMBER'
        };
        function getcardFailureReasonCode() {
            return cardFailureReasonCode;
        }
        function getcardFailureReasonMessage(reasonCode) {
            return resourceService.get(cardFailureReasonMessage[reasonCode]);
        }
        //Payment Details
        function getPaymentCards() {
            return $http.get(url + "get", { ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        function getPaymentTypes(uniqueMasterCards, bookingType) {
            var allTypeOfCards = 0;
            return $http.get(cardUrl + "gettypes?" + $.param({
                domainId: TRPCONFIG.Domain.DomainId,
                currencyCode: TRPCONFIG.Domain.CurrencyCode,
                bookingTypeId: bookingType || allTypeOfCards
            }), { cache: true, ignoreErrors: true }).then(function (result) {
                if (uniqueMasterCards) {
                    //if uniqueMasterCards is requested. return unique types with respect to MasterdCardId.
                    return _uniqueMasterCards(result.data);
                }
                //else return result as it is.
                return result.data;
            });
        }
        function _uniqueMasterCards(allCards) {
            var uniqueCards = [];
            var seen = {};
            var len = allCards.length;
            var j = 0;
            for (var i = 0; i < len; i++) {
                var card = allCards[i];
                var masterId = card.MasterCardTypeId;
                if (seen[masterId] !== 1) {
                    seen[masterId] = 1;
                    uniqueCards[j++] = card;
                }
            }
            return uniqueCards;
        }
        //End- Payment Details
        function getSavedPaymentCards(bookingType, bookingId, clientCurrencyCode) {
            //getsavedbookingcards is obsolete now. So calling get and joining with PaymentOptions
            var getOptions = service.getPaymentOptions(bookingType, bookingId, clientCurrencyCode);
            var getCards = TRPCONFIG.Domain.SavedCardsEnabled && currentUser.get() && currentUser.get().HardSignedIn ? service.getPaymentCards() : null;
            return $q.all([getOptions, getCards]).then(function (results) {
                return convertToPaymentCards.apply(void 0, results);
            });
        }
        function convertToPaymentCards(options, cards) {
            var paymentCards = [];
            _.each(cards, function (card) {
                var paymentOption = _.find(options, function (o) { return o.CardType === card.MasterCardTypeId; });
                if (paymentOption && !card.IsExpired) {
                    card.CardTypeId = paymentOption.Id; //In payment directive PaymentOptionId is named as CardTypeId
                    paymentCards.push(card);
                }
            });
            return paymentCards;
        }
        function getCardTypeId() {
            document.addEventListener('click', function (e) {
                var seEl = document.querySelectorAll('select[name="paymentType"]')[0];
                if (e.target.classList.value.includes('button')) {
                    var cardTypeId = seEl.value;
                    if (cardTypeId !== '') {
                        cardTypeId = cardTypeId.split(':');
                        cardTypeId = Number(cardTypeId[1]);
                        TRPCONFIG.Domain.CardTypeId = cardTypeId;
                    }
                }
            }, true);
        }
        function getPaymentOptions(bookingType, bookingId, currencyCode) {
            if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                TRPCONFIG.Domain.CardTypeId = 370;
            }
            else if (TRPCONFIG.Domain.WPIframeUpdate) {
                TRPCONFIG.Domain.CardTypeId = 369;
            }
            else {
                getCardTypeId();
            }
            return $http.get(baseUrl + "getpaymentoptionsforbooking?" + $.param({
                DomainId: TRPCONFIG.Domain.DomainId,
                CurrencyCode: currencyCode,
                BookingTypeId: bookingType,
                BookingId: bookingId
            }), { cache: true, ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        function validateCard(request) {
            return $http.post(cardUrl + "validate", request).then(function (result) {
                return result.data;
            });
        }
        function getDeviceDataCollectionToken(cardTypeId, timeout) {
            return __awaiter(this, void 0, void 0, function () {
                var requestParams, networkParams, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestParams = {
                                domainId: TRPCONFIG.Domain.DomainId,
                                currencyCode: TRPCONFIG.Domain.CurrencyCode,
                                cardTypeId: cardTypeId
                            };
                            networkParams = {
                                ignoreErrors: true
                            };
                            if (timeout) {
                                networkParams.timeout = timeout;
                            }
                            if (!TRPCONFIG.Domain2.CPGIframeUpdate) return [3 /*break*/, 2];
                            return [4 /*yield*/, $http.get(ddcTokenUrl + "?domainId=" + requestParams.domainId + "&cardTypeId=" + requestParams.cardTypeId + "&currencyCode=" + requestParams.currencyCode)
                                    .then(function (result) { return result.data; })];
                        case 1:
                            res = _a.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, $http.post("" + ddcTokenUrl, requestParams, networkParams)];
                        case 3:
                            res = _a.sent();
                            _a.label = 4;
                        case 4: return [2 /*return*/, res];
                    }
                });
            });
        }
        //Transaction
        function clearPayment(request, requireCardValidation) {
            if (TRPCONFIG.Domain2.CPGIframeUpdate || TRPCONFIG.Domain.WPIframeUpdate) {
                return _clear(request);
            }
            if (requireCardValidation) {
                var validateRequest = {
                    CardNumber: TRPCONFIG.Domain.PCICompliant ?
                        request.CardNumberMasked : request.CardNumber,
                    StartDate: dateUtil.serialiseDate(new Date(request.CardStartYear, request.CardStartMonth)),
                    ExpiryDate: dateUtil.serialiseDate(new Date(request.CardEndYear, request.CardEndMonth)),
                    CV2: request.CardCvc,
                    IssueNumber: request.CardIssueNumber
                };
                return validateCard(validateRequest).then(function (response) {
                    if (response.Success) {
                        return _clear(request);
                    }
                    return $q.when(response);
                });
            }
            return _clear(request);
        }
        function _clear(request) {
            var updatedReq = __assign({}, request, { BrowserDetails: bookingService.browserDetails() });
            if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                updatedReq.PaymentOptionId = 370;
                updatedReq.PaymentTypeId = 36;
            }
            if (TRPCONFIG.Domain.WPIframeUpdate) {
                updatedReq.PaymentOptionId = 369;
                updatedReq.PaymentTypeId = 35;
            }
            return $http.post(transactionUrl + "clear", updatedReq).then(function (result) {
                return result.data;
            });
        }
        function authorisePayment(request) {
            return $http.post(transactionUrl + "authorise", request).then(function (result) {
                return result.data;
            });
        }
        function getPaymentLogos() {
            var parameters = $.param({
                domainId: TRPCONFIG.Domain.DomainId,
                currencyCode: TRPCONFIG.Domain.CurrencyCode,
                bookingTypeId: 8
            });
            var url = baseUrl + "getpaymentoptions?" + parameters;
            return $http.get(url, { cache: true, ignoreErrors: true }).then(function (result) { return result.data; });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .factory('userSettingsService', userSettingsService);
    function userSettingsService(resourceService) {
        var starRatings = [
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_ANY'), val: 1 },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_2STARSANDHIGHER'), val: 2 },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_3STARSANDHIGHER'), val: 3 },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_4STARSANDHIGHER'), val: 4 },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_5STARS'), val: 5 }
        ];
        var smokingRoom = [
            { name: resourceService.getDeferred('NOPREFERENCE'), val: 0 },
            { name: resourceService.getDeferred('YES'), val: 1 },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'), val: 2 }
        ];
        var boolianOptions = [
            { name: resourceService.getDeferred('YES'), val: true },
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'), val: false }
        ];
        var priceMode = [
            { name: resourceService.getDeferred('PERPERSON'), val: 0 },
            { name: resourceService.getDeferred('TOTALPRICE'), val: 1 }
        ];
        var flightClass = [
            { name: resourceService.getDeferred('DASHBOARDRESOURCE_ANY'), val: 0 },
            { name: resourceService.getDeferred('BUSINESSCLASS'), val: 8 },
            { name: resourceService.getDeferred('ECONOMYCLASS'), val: 1 },
            { name: resourceService.getDeferred('PREMIUMECONOMYCLASS'), val: 2 },
            { name: resourceService.getDeferred('FIRSTCLASS'), val: 4 }
        ];
        var hotelCriteria = [
            { name: resourceService.getDeferred('OURRECOMMENDATIONS'), val: 1 },
            { name: resourceService.getDeferred('CUSTOMERRATING'), val: 2 },
            { name: resourceService.getDeferred('PRICELOWTOHIGH'), val: 5 },
            { name: resourceService.getDeferred('PRICEHIGHTOLOW'), val: 6 },
            { name: resourceService.getDeferred('STARRATINGLOWTOHIGH'), val: 7 },
            { name: resourceService.getDeferred('STARRATINGHIGHTOLOW'), val: 8 }
        ];
        var flightCriteria = [
            { name: resourceService.getDeferred('OURRECOMMENDATIONS'), val: [10] },
            { name: resourceService.getDeferred('PRICELOWTOHIGH'), val: 1 },
            { name: resourceService.getDeferred('PRICEHIGHTOLOW'), val: 2 },
            { name: resourceService.getDeferred('DEPARTURETIMELOWTOHIGH'), val: 4 },
            { name: resourceService.getDeferred('DEPARTURETIMEHIGHTOLOW'), val: 5 },
            { name: resourceService.getDeferred('RETURNTIMELOWTOHIGH'), val: 6 },
            { name: resourceService.getDeferred('RETURNTIMEHIGHTOLOW'), val: 7 },
            { name: resourceService.getDeferred('TOTALJOURNEYTIMELOWTOHIGH'), val: 9 },
            { name: resourceService.getDeferred('TOTALJOURNEYTIMEHIGHTOLOW'), val: 8 }
        ];
        var adultTitles = resourceService.getDeferred('ADULTTITLES');
        var service = {
            getAdultTitles: getAdultTitles,
            getStarRatings: getStarRatings,
            getSmokingRoomOptions: getSmokingRoomOptions,
            getPricMode: getPricMode,
            getFooterToolbarOptions: getFooterToolbarOptions,
            getFlightClassOptions: getFlightClassOptions,
            getHotelCriteria: getHotelCriteria,
            getFlightCriteria: getFlightCriteria,
            getCanceledBookingOprions: getCanceledBookingOprions
        };
        function getStarRatings() {
            return starRatings;
        }
        function getSmokingRoomOptions() {
            return smokingRoom;
        }
        function getFooterToolbarOptions() {
            return boolianOptions;
        }
        function getCanceledBookingOprions() {
            return boolianOptions;
        }
        function getPricMode() {
            return priceMode;
        }
        function getFlightClassOptions() {
            return flightClass;
        }
        function getAdultTitles() {
            return adultTitles;
        }
        function getHotelCriteria() {
            return hotelCriteria;
        }
        function getFlightCriteria() {
            return flightCriteria;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular.module('deals').directive('dealTypeCards', dealTypeCards);
    function dealTypeCards(holidayDeals) {
        var imgUrl = TRPCONFIG.DestinationImagesClientDomain + "api2/destination/images/getfromobject";
        function link(scope) {
            scope.holidayDealsEnabled = TRPCONFIG.Domain.HolidayDealsEnabled;
            scope.cruiseEnabled = TRPCONFIG.Domain.HolidayDealsCruisesEnabled;
            if (scope.holidayDealsEnabled && !scope.cruiseEnabled) {
                bestDestination().then(function (dest) { return scope.dest = dest; });
            }
        }
        function bestDestination() {
            var depAir = TRPCONFIG.Domain.HolidayDealsDefaultAirports;
            return holidayDeals.getAggregates(false, { depAir: depAir })
                .then(function (response) { return _.get(response, 'Aggregates.HotelsByChildDestination'); })
                .then(function (destMap) { return _.chain(destMap)
                .mapValues(function (dest, key) { return _.merge(dest, { id: key }); })
                .values()
                .sortBy('Position')
                .first()
                .value(); })
                .then(function (dest) {
                var _a = _.chain(dest).get('id').split('|').value(), type = _a[0], id = _a[1];
                var href = "holidaydeals?depAir=" + depAir + "&ChildDestinations=" + type + "|" + id;
                return {
                    title: _.get(dest, 'Title'),
                    image: imgUrl + "?" + jQuery.param({
                        height: 316,
                        useDealsImages: true,
                        type: type,
                        id: id
                    }),
                    href: window.encodeURI(href),
                    minPrice: _.get(dest, 'MinPrice')
                };
            });
        }
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'partials/home/directivetemplate?type=DealTypeCards',
            link: link
        };
    }
})();
var Insurance;
(function (Insurance) {
    var InsuranceResults = /** @class */ (function () {
        function InsuranceResults($location, resourceService, $scope, tripService, $routeParams, insuranceService, broker, basketService, $q, analytics) {
            var _this = this;
            this.$location = $location;
            this.resourceService = resourceService;
            this.$scope = $scope;
            this.tripService = tripService;
            this.$routeParams = $routeParams;
            this.insuranceService = insuranceService;
            this.broker = broker;
            this.basketService = basketService;
            this.$q = $q;
            this.analytics = analytics;
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGINSURANCE'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-insuranceSearchCtrl'
            });
            analytics.track('mixpanel', 'TransferPage');
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                var insuranceReq = trip && trip.InsuranceRequest;
                if (insuranceReq) {
                    var searchId_1 = insuranceReq.AvailabilitySearchId;
                    _this.$q.all([
                        insuranceService.getSearchResults(searchId_1, trip.TripId),
                        tripService.getInsuranceRequestSummary($routeParams.tripId)
                    ]).then(function (results) {
                        _this.insuranceQuotes = results[0];
                        _this.summary = results[1];
                        _this.typeSummary = _this.summary && _this.summary.Destination && _this.summary.PolicyType ?
                            _this.summary.PolicyType.Name + ' - '
                                + _this.summary.Destination.Name + ' - ' : '';
                        broker.publish('unblock');
                        $scope.$emit('unblock');
                    });
                    _this.selectPolicy = function (policy) {
                        var data = {
                            Title: policy.QuoteType.Type,
                            CostTotal: policy.Price,
                            TotalOptions: this.insuranceQuotes.length,
                            SupplierName: policy.SupplierName
                        };
                        analytics.track('mixpanel', 'OptionsInsuranceSelected', data);
                        basketService.selectInsurance(policy, searchId_1, trip.BasketId, trip.TripId);
                        this.selectedInsurance = policy;
                    };
                    _this.documentPaths = insuranceService.getDocumentPaths();
                }
            });
        }
        return InsuranceResults;
    }());
    angular.module('insurance')
        .controller('InsuranceResults', InsuranceResults);
})(Insurance || (Insurance = {}));
(function () {
    'use strict';
    angular
        .module('insurance')
        .service('insuranceService', insuranceService);
    function insuranceService($http, $browser, tripService, $filter, resourceService, analytics, searchUnitService, occupancyService, $q, insuranceSearchValidator, broker, $cacheFactory, loggingService) {
        var domain = TRPCONFIG.Domain;
        var service = {
            getInsuranceQuotes: getInsuranceQuotes,
            getInsuranceQuotesFromSession: getInsuranceQuotesFromSession,
            getDocumentPaths: getDocumentPaths,
            passengerInsuranceBand: passengerInsuranceBand,
            composeOptionId: composeOptionId,
            decomposeOptionId: decomposeOptionId,
            clearSearchResults: clearSearchResults,
            validateSearchCriteria: validateSearchCriteria,
            search: search,
            getSearchResults: getSearchResults,
            getInsuranceDetails: getInsuranceDetails,
            rehydrate: rehydrate,
            isVatMessageInclusive: isVatMessageInclusive
        };
        var results;
        var inProgress;
        var url = '/api2/insurance/availability/';
        var detailsUrl = '/api2/insurance/details/';
        var timeout;
        var promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');
        function _doRequest(r, tripId, newSearch) {
            return newSearch ?
                getInsuranceQuotes(tripId, r) :
                getInsuranceQuotesFromSession(r.AvailabilitySearchId);
        }
        function passengerInsuranceBand(insuranceBands, bandId, costOnly) {
            if (!bandId) {
                return costOnly ?
                    '-'
                    : String.format('{0} ({1}: -)', resourceService.get('INSURANCENOTREQUIRED'), resourceService.get('INSURANCECOST'));
            }
            var option = _.find(insuranceBands, { Id: bandId });
            var priceString = $filter('customCurrency')(option.Price);
            if (!option.Available) {
                priceString = resourceService.get('INSURANCECOSTNA');
            }
            return costOnly ?
                priceString
                : String.format('{0} ({1}: {2})', option.Label, resourceService.get('INSURANCECOST'), priceString);
        }
        function validateSearchCriteria() {
            return insuranceSearchValidator.validate(searchUnitService.getPolicyType(), searchUnitService.getTravelDestination(), searchUnitService.startDate(searchUnitService.insurance), searchUnitService.endDate(searchUnitService.insurance), occupancyService.reduceOccupancy());
        }
        function search(args) {
            if (inProgress != null && !args.newSearch) {
                return inProgress;
            }
            var tripId = args.tripId;
            var request = {
                AvailabilitySearchId: args.searchId,
                TripId: tripId
            };
            if (args.newSearch) {
                //request for standalone insurance search
                request.SearchType = 1;
                request.TripType = searchUnitService.getPolicyType();
                request.TravelDestination = searchUnitService.getTravelDestination();
                request.StartDate = searchUnitService.startDate(searchUnitService.insurance);
                request.EndDate = searchUnitService.endDate(searchUnitService.insurance);
                request.PolicyExtras = searchUnitService.getPolicyExtra();
            }
            inProgress = tripService.getTripReducedOccupancy(tripId).then(function (o) {
                o = o || occupancyService.reduceOccupancy();
                var ages = _.concat(o.AdultAges ? o.AdultAges : _.times(o.Adults, function () { return 21; }), o.ChildAges);
                request.Ages = ages;
                return _doRequest(request, tripId, args.newSearch).then(function (res) {
                    inProgress = null;
                    results = res;
                    return results;
                }, function () {
                    inProgress = null;
                    results = null;
                });
            });
            return inProgress;
        }
        function getInsuranceQuotes(tripId, request) {
            var req = angular.extend({
                DomainId: domain.DomainId,
                Currency: domain.CurrencyCode,
                CultureCode: domain.CultureCode
            }, request);
            tripService.recordInsuranceSearch(tripId, request);
            analytics.startTimer('InsuranceAvailabilityRequest');
            return $http.post(url + "get", req, { ignoreErrors: true }).then(function (res) {
                analytics.endTimer('InsuranceAvailabilityRequest');
                return enrichData(res.data.Quotes);
            });
        }
        function getInsuranceQuotesFromSession(availabilitySearchId) {
            return $http.post(url + "getfromsession", {
                AvailabilitySearchId: availabilitySearchId
            }, { ignoreErrors: true }).then(function (res) {
                return enrichData(res.data.Quotes);
            });
        }
        function getDocumentPaths() {
            //these paths should probably be coming back from the service call really and
            //the docs be served from the service ideally.
            var baseRoute = $browser.baseHref() + "build/docs/BookingConditions/";
            return {
                PolicyWording: "" + baseRoute + TRPCONFIG.Domain.InsurancePolicyWordingDoc,
                SilverPolicyWording: "" + baseRoute + TRPCONFIG.Domain2.InsuranceSilverPolicyWordingDoc,
                Disclosure: "" + baseRoute + TRPCONFIG.Domain.StatusDisclosureDoc,
                PolicySummary: "" + baseRoute + TRPCONFIG.Domain.InsuranceKeyFactsDoc,
                InsuranceProductInformation: TRPCONFIG.Domain.InsuranceProductInformation ?
                    "" + baseRoute + TRPCONFIG.Domain.InsuranceProductInformation : '',
            };
        }
        function enrichData(quotes) {
            if (TRPCONFIG.Domain.InsurancePerPersonPricing === false) {
                return quotes;
            }
            angular.forEach(quotes, function (quote) {
                quote.PerPersonPrice = quote.Price / (quote.AdultCount + quote.ChildCount + quote.InfantCount);
            });
            return quotes;
        }
        function composeOptionId(schemeId, typeId, supplierId) {
            return schemeId + "|" + typeId + "|" + supplierId;
        }
        function decomposeOptionId(id) {
            //takes a key like 1|1|208 and returns a correctly set object
            var parts = id.split('|');
            var obj = {
                schemeId: parseInt(parts[0]),
                typeId: parseInt(parts[1]),
                supplierId: parseInt(parts[2])
            };
            if (parts[3]) {
                obj.relationshipId = parseInt(parts[3]);
            }
            else {
                loggingService.logWarn("RelationshipId - insurance.service.js, decomposeOptionId() warn " + id);
            }
            return obj;
        }
        function clearSearchResults() {
            results = null;
        }
        function getSearchResults(searchId, tripId) {
            if (results && results !== 'null') {
                return $q.when(_.cloneDeep(results));
            }
            return search({ searchId: searchId, tripId: tripId });
        }
        function getInsuranceDetails(params) {
            if (timeout != null) {
                timeout.resolve('CANCELLED');
            }
            timeout = $q.defer();
            return $http.get(detailsUrl + "get", {
                timeout: timeout.promise,
                params: {
                    availabilityId: params.AvailabilityId,
                    schemeId: params.SchemeId,
                    tripTypeId: params.TripTypeId,
                    supplierId: params.SupplierId,
                    destinationId: params.DestinationId,
                    relationshipId: params.RelationshipId
                },
                customErrCallback: function (args) {
                    if (args.status) {
                        broker.publish('insuranceRequestFailed');
                    }
                    return true;
                }
            }).then(function (res) {
                promiseCache.remove(res.data.DetailSearchId);
                timeout = null;
                return res.data;
            });
        }
        function rehydrate(id) {
            if (!promiseCache.get(id)) {
                promiseCache.put(id, $http.post(detailsUrl + "getfromsession?detailSearchId=" + id, { ignoreErrors: true }).then(function (res) {
                    return res.data;
                }));
            }
            return promiseCache.get(id);
        }
        function isVatMessageInclusive(insuranceQuotes, isMultiple) {
            if (!isMultiple && (insuranceQuotes && insuranceQuotes.length === 1)) {
                return true;
            }
            else if (isMultiple && (insuranceQuotes && insuranceQuotes.length > 1)) {
                return true;
            }
            return false;
        }
        return service;
    }
})();
var liveChatSnapInModule;
(function (liveChatSnapInModule) {
    var LiveChatSnapInService = /** @class */ (function () {
        function LiveChatSnapInService(cookieService, dateUtil, $http, $q) {
            var _this = this;
            this.cookieService = cookieService;
            this.dateUtil = dateUtil;
            this.$http = $http;
            this.$q = $q;
            this.config = TRPCONFIG.Domain.LiveChat;
            this.domains = { com: 'dnatatravel.com', comsa: 'dnatatravel.com.sa' };
            this.contact = {
                fName: '',
                lName: '',
                phone: '',
                email: '',
                subject: '',
                chatKey: ''
            };
            this.sentFlag = false;
            $(window).on('message', function (event) {
                var data = _.get(event, 'originalEvent.data.data', {});
                if (_.get(data, 'chasitorData.details.prechatDetails.length', 0) > 0 &&
                    _.get(data, 'params.getType', null) === 'error' &&
                    _.get(data, 'params.getErrorReason', null) === 'Unavailable') {
                    _this.updateContactDetails(event);
                    _this.setPostChatMissedForm(_this.contact);
                }
            });
        }
        LiveChatSnapInService.prototype.initialise = function () {
            var _this = this;
            if (!window['embedded_svc']) {
                var script = document.createElement('script');
                script.setAttribute('src', this.config.SnapInScript);
                script.onload = function () {
                    _this.initESW(null);
                };
                document.body.appendChild(script);
            }
            else {
                this.initESW(this.config.SnapInConfig.initScriptUrl);
            }
            this.waitFor(this.getButton, 500, 20).then(function () { _this.updateClickHandler(); }, function (msg) { _this.log(msg); });
        };
        LiveChatSnapInService.prototype.getButton = function () {
            var button = $('#esw_button_online');
            if (button.length) {
                return true;
            }
            return false;
        };
        LiveChatSnapInService.prototype.updateClickHandler = function () {
            var _this = this;
            var button = $('#esw_button_online');
            button.removeAttr('onclick');
            button.on('click', function () {
                _this.chatInitiate();
            });
        };
        LiveChatSnapInService.prototype.log = function (errorMsg) {
            if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                console.log("LIVECHAT | " + errorMsg);
            }
        };
        LiveChatSnapInService.prototype.waitFor = function (cb, duration, maxCount) {
            if (duration === void 0) { duration = 500; }
            if (maxCount === void 0) { maxCount = 10; }
            var deferred = this.$q.defer();
            if (!cb) {
                deferred.reject('Callback not supplied');
            }
            var counter = 0;
            var interval;
            var callback = function () {
                if (counter === maxCount) {
                    clearInterval(interval);
                    deferred.reject("Attempt failed after " + maxCount + " attempts");
                }
                else {
                    if (!cb()) {
                        counter++;
                    }
                    else {
                        clearInterval(interval);
                        deferred.resolve();
                    }
                }
            };
            interval = setInterval(callback, duration);
            return deferred.promise;
        };
        LiveChatSnapInService.prototype.makeid = function () {
            /*------Generate Chat Key-----*/
            var text = '';
            var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            for (var i = 0; i < 15; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
            /*-----------------------------------*/
        };
        LiveChatSnapInService.prototype.setCookie = function (cookieValue) {
            var cookieDuration = this.config.SnapInConfig.settings.cookieDuration || 365;
            var hostname = window.location.hostname;
            hostname = hostname.indexOf('m.') === 0 ? hostname.substr(2) : hostname;
            hostname = hostname.replace('pp.', '').replace('pp2.', '');
            hostname = hostname.replace('m.', '').replace('www.', '');
            this.cookieService.set(_.get(TRPCONFIG, 'Domain.LiveChat.SnapInConfig.cookieName', 'key'), cookieValue, this.dateUtil.addDays(new Date(), cookieDuration), hostname);
        };
        LiveChatSnapInService.prototype.proactiveChat = function () {
            var _this = this;
            if (this.config.SnapInConfig.settings.runProactiveScript) {
                //Proactive Button Start
                var btnOnline_1 = document.getElementById('esw_button_online'); //AgentOnline
                var btnOffline_1 = document.getElementById('esw_button_offline'); //AgentOffline
                var checkTimer_1;
                var checkStatus = function () {
                    btnOnline_1 = document.getElementById('esw_button_online');
                    btnOffline_1 = document.getElementById('esw_button_offline');
                    if (btnOnline_1 == null && btnOffline_1 == null) {
                        return;
                    }
                    if ((btnOnline_1 && _.get(btnOnline_1, 'style.display') === '')
                        || (btnOffline_1 && _.get(btnOffline_1, 'style.display') === '')) {
                        //Agent is online/offline
                        clearInterval(checkTimer_1);
                        // Checks if agent online
                        if (btnOffline_1 && _.get(btnOffline_1, 'style.display') === 'none') {
                            setTimeout(function () {
                                if ($(_this.config.SnapInConfig.settings.containerCheck).length === 0) {
                                    btnOnline_1 && btnOnline_1.click();
                                }
                                //Open the chat window after 5 minutes
                            }, _this.config.SnapInConfig.settings.proactiveScriptTimeout || 300000);
                        }
                    }
                };
                //TimeLoop to check change agent online/offline
                var timeout = _.get(this.config, 'SnapInConfig.settings.proactiveScriptCheckTimeout') || 500;
                checkTimer_1 = setInterval(checkStatus, timeout);
                if (btnOffline_1) {
                    btnOffline_1.style.display = 'none';
                }
                //Proactive Button End
            }
        };
        LiveChatSnapInService.prototype.initESW = function (baseUrl) {
            var settings = _.assign({}, _.get(window, 'embedded_svc.settings') || {}, this.config.SnapInConfig.settings);
            this.chatkey = Date.now() + this.makeid();
            this.log("initESW " + baseUrl + " chatkey " + this.chatkey);
            if (_.get(settings, 'extraPrechatFormDetails')) {
                for (var i in settings.extraPrechatFormDetails) {
                    if (settings.extraPrechatFormDetails[i].label === 'URL') {
                        settings.extraPrechatFormDetails[i].value = window.location.href;
                    }
                    if (settings.extraPrechatFormDetails[i].value === 'chatkey' ||
                        new RegExp('chat key', 'gi').test(settings.extraPrechatFormDetails[i].label)) {
                        settings.extraPrechatFormDetails[i].value = this.chatkey;
                    }
                }
            }
            var dynamicStorageDomain = _.get(this.config.SnapInConfig, 'dynamicStorageDomain', false);
            if (dynamicStorageDomain) {
                var storageDomain = _.get(settings, 'storageDomain', '');
                var splitStorageDomain = (window.location.hostname || storageDomain).split(storageDomain);
                var newStorageDomain = [storageDomain];
                if (splitStorageDomain.length > 1) {
                    newStorageDomain = newStorageDomain.concat(splitStorageDomain.slice(1));
                }
                settings.storageDomain = newStorageDomain.join('');
            }
            var hostname = window.location.hostname;
            hostname = hostname + (hostname.indexOf('m.') === 0 ? '' : settings.redirectBase);
            settings.postChatUrl = window.location.protocol + '//' + hostname + settings.postchatRedirect;
            window['embedded_svc'].settings = settings;
            window['embedded_svc'].init(this.config.SnapInConfig.baseCoreUrl, this.config.SnapInConfig.baseLiveAgentUrl, this.config.SnapInConfig.baseLiveAgentContentUrl, this.config.SnapInConfig.communityEndpointUrl, this.config.SnapInConfig.deploymentId, this.config.SnapInConfig.orgId, this.config.SnapInConfig.buttonId, this.config.SnapInConfig.releaseVersion, baseUrl, this.config.SnapInConfig.chasitorJsVersion, this.config.SnapInConfig.eswConfigDevName, this.config.SnapInConfig.eswLiveAgentDevName);
            this.proactiveChat();
        };
        //Contact Object to store contact information
        LiveChatSnapInService.prototype.updateContactDetails = function (event) {
            var data = _.get(event, 'originalEvent.data.data.chasitorData.details.prechatDetails', []);
            this.contact.fName = _.get(data, '[0].value', this.contact.fName);
            this.contact.lName = _.get(data, '[1].value', this.contact.lName);
            this.contact.email = _.get(data, '[2].value', this.contact.email);
            this.contact.phone = _.get(data, '[3].value', this.contact.phone);
            this.contact.subject = _.get(data, '[4].value', this.contact.subject);
            this.contact.chatKey = this.chatkey;
            return this.contact;
        };
        //Custom method to initiate and reinitiate the chat in order to reinitialize the chat key each time the customer
        //clicks on the online button without refreshing the page.
        LiveChatSnapInService.prototype.chatInitiate = function () {
            this.chatkey = Date.now() + this.makeid();
            window['embedded_svc'].settings.extraPrechatFormDetails[1].value = this.chatkey;
            window['embedded_svc'].settings.extraPrechatFormDetails[2].value = this.chatkey;
            if (this.config.SnapInConfig.settings.dropCookie) {
                this.setCookie(this.chatkey);
            }
            this.sentFlag = false;
            window['embedded_svc'].initInteraction();
        };
        LiveChatSnapInService.prototype.setPostChatMissedForm = function (contact) {
            var _this = this;
            var params = {
                chkey: contact.chatKey,
                fName: contact.fName,
                lName: contact.lName,
                email: contact.email,
                pNumber: contact.phone,
                subject: contact.subject
            };
            this.$http.get(this.config.SnapInConfig.PostChatFeedbackForm + '?' + $.param(params))
                .then(function () { return _this.sentFlag = true; });
        };
        return LiveChatSnapInService;
    }());
    liveChatSnapInModule.LiveChatSnapInService = LiveChatSnapInService;
    angular
        .module('liveChatSnapInModule')
        .service('liveChatSnapInService', LiveChatSnapInService);
})(liveChatSnapInModule || (liveChatSnapInModule = {}));
var Marhaba;
(function (Marhaba) {
    var MarhabaAirports = /** @class */ (function () {
        function MarhabaAirports(searchUnitService, $location, $route) {
            this.searchUnitService = searchUnitService;
            this.$location = $location;
            this.$route = $route;
        }
        MarhabaAirports.prototype.setMarhabaAirport = function (a) {
            this.searchUnitService.setMarhabaAirport(a);
            if (this.$route.current) {
                this.$location.path(this.$route.current.area);
            }
        };
        return MarhabaAirports;
    }());
    angular
        .module('marhaba')
        .controller('MarhabaAirports', MarhabaAirports);
})(Marhaba || (Marhaba = {}));
var Marhaba;
(function (Marhaba) {
    var MarhabaSearchUnitCtrl = /** @class */ (function () {
        /**
         * @param  {searchUnitService} private unit
         * @param  {broke} private broker
         * @param  {$log} private $log
         */
        function MarhabaSearchUnitCtrl(MarhabaSearchUnit, //Marhaba.MarhabaSearchUnit,
        $scope, dateUtil) {
            var _this = this;
            this.MarhabaSearchUnit = MarhabaSearchUnit;
            this.$scope = $scope;
            this.dateUtil = dateUtil;
            this.minDate = dateUtil.todayPlus(2, null, true);
            this.initial = null;
            this.services = this.MarhabaSearchUnit.services;
            this.service = this.MarhabaSearchUnit.service;
            this.processTerminals();
            $scope.$watch(function () { return _this.service; }, function (val) {
                _this.MarhabaSearchUnit.setService(val);
            });
        }
        /**
         * Setting date method for ngjs
         * @param  {Date} date
         */
        MarhabaSearchUnitCtrl.prototype.setDate = function (date) {
            this.MarhabaSearchUnit.date = date;
        };
        MarhabaSearchUnitCtrl.prototype.getDate = function () {
            return this.MarhabaSearchUnit.date;
        };
        MarhabaSearchUnitCtrl.prototype.processTerminals = function () {
            var _this = this;
            this.MarhabaSearchUnit.terminals.then(function (terminals) { return _this.terminals = terminals; });
        };
        Object.defineProperty(MarhabaSearchUnitCtrl.prototype, "terminal", {
            get: function () {
                return this.MarhabaSearchUnit.terminal;
            },
            set: function (value) {
                this.MarhabaSearchUnit.terminal = value;
            },
            enumerable: true,
            configurable: true
        });
        MarhabaSearchUnitCtrl.prototype.setDeparture = function (value) {
            this.MarhabaSearchUnit.transfer = value;
        };
        MarhabaSearchUnitCtrl.prototype.setArrival = function (value) {
            this.MarhabaSearchUnit.transfer = value;
        };
        MarhabaSearchUnitCtrl.prototype.getAirport = function (value) {
            return this.MarhabaSearchUnit.transfer;
        };
        Object.defineProperty(MarhabaSearchUnitCtrl.prototype, "occupancy", {
            get: function () {
                return this.MarhabaSearchUnit.occupancy;
            },
            set: function (value) {
                this.MarhabaSearchUnit.occupancy = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnitCtrl.prototype, "staffRates", {
            get: function () {
                return this.MarhabaSearchUnit.staffRates;
            },
            set: function (value) {
                this.MarhabaSearchUnit.staffRates = value;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Starting search
         */
        MarhabaSearchUnitCtrl.prototype.search = function () {
            var errors = this.MarhabaSearchUnit.search();
            this.$scope.$emit('flash:error', errors);
        };
        return MarhabaSearchUnitCtrl;
    }());
    Marhaba.MarhabaSearchUnitCtrl = MarhabaSearchUnitCtrl;
    angular
        .module('marhaba')
        .controller('MarhabaSearchUnitCtrl', MarhabaSearchUnitCtrl);
})(Marhaba || (Marhaba = {}));
var Marhaba;
(function (Marhaba) {
    /**
     * MarhabaSearchUnit service represent wrapper over related services
     * and assigning logic for these services (according to refactoring strategy to ng2)
     */
    var MarhabaSearchUnit = /** @class */ (function () {
        function MarhabaSearchUnit(searchUnitService, 
        //private Area,
        //private $route,
        occupancyService, broker, basketService, resourceService) {
            this.searchUnitService = searchUnitService;
            this.occupancyService = occupancyService;
            this.broker = broker;
            this.basketService = basketService;
            this.resourceService = resourceService;
            this.services = this.searchUnitService.getFlightTypes();
            this.setService(this.services[0]);
            this.terminal = this.searchUnitService.getTerminal();
        }
        MarhabaSearchUnit.prototype.setService = function (value) {
            this.service = value;
            this.searchUnitService.setFlightType(value);
        };
        Object.defineProperty(MarhabaSearchUnit.prototype, "terminal", {
            get: function () {
                var terminal = this._terminal;
                // First item in options menu is prompt
                if (terminal.Id === 0) {
                    terminal = null;
                }
                return terminal;
            },
            set: function (value) {
                this.searchUnitService.setTerminal(value);
                this._terminal = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "transfer", {
            get: function () {
                return this.searchUnitService.getMarhabaAirport();
            },
            set: function (value) {
                this.searchUnitService.setMarhabaAirport(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "date", {
            get: function () {
                return this.searchUnitService.startDate(this.mode);
            },
            set: function (value) {
                this.searchUnitService.startDate(this.mode, value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "occupancy", {
            get: function () {
                var occupancy = this.occupancyService.getOccupancy();
                if (occupancy && occupancy.length > 1) {
                    this.occupancyService.setOccupancy([this.occupancyService.reduceOccupancy()]);
                    occupancy = this.occupancyService.getOccupancy();
                }
                return occupancy;
            },
            set: function (value) {
                this.occupancyService.setOccupancy(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "staffRates", {
            get: function () {
                return this.searchUnitService.getStaffRates();
            },
            set: function (value) {
                this.searchUnitService.setStaffRates(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "terminals", {
            get: function () {
                return this.searchUnitService.getTerminals();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "flow", {
            get: function () {
                // return this.Area[this.$route.current.$$route.Area].flow; // Dynamic value according to tab
                return 3;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MarhabaSearchUnit.prototype, "mode", {
            get: function () {
                // return this.Area[this.$route.current.$$route.Area].mode; // Dynamic value according to tab
                return 3;
            },
            enumerable: true,
            configurable: true
        });
        MarhabaSearchUnit.prototype.objectify = function () {
            return {
                terminal: {
                    message: this.resourceService.get('VALIDATESELECTTERMINAL'),
                    value: this.terminal
                },
                transfer: {
                    message: this.resourceService.get('VALIDATESELECTAIRPORT'),
                    value: this.transfer
                },
                date: {
                    message: this.resourceService.get('SELECTDATE'),
                    value: this.date
                }
            };
        };
        /**
         * Validate this.fields with correct values
         * invalid forms messages are published to broker services
         * @return {boolean} is form valid?
         */
        MarhabaSearchUnit.prototype.validate = function () {
            var errors = [], fields = this.objectify();
            for (var name_3 in fields) {
                if (fields.hasOwnProperty(name_3)) {
                    var field = fields[name_3];
                    if (field.value == null) {
                        errors.push(field.message);
                    }
                }
            }
            if (!this.occupancyService.childAgesPopulated(this.occupancy)) {
                errors.push(this.resourceService.get('CHILDAGESERROR'));
            }
            return errors;
        };
        /**
         * Starting search
         */
        MarhabaSearchUnit.prototype.search = function () {
            var errors = this.validate();
            var valid = !(errors.length > 0);
            if (valid) {
                this.basketService.startWorkflow(this.flow, null);
            }
            return valid ? null : errors;
        };
        return MarhabaSearchUnit;
    }());
    Marhaba.MarhabaSearchUnit = MarhabaSearchUnit;
    angular
        .module('marhaba')
        .service('MarhabaSearchUnit', MarhabaSearchUnit);
})(Marhaba || (Marhaba = {}));
(function () {
    'use strict';
    angular
        .module('parking')
        .controller('Parking', Parking);
    function Parking($filter, $routeParams, $scope, arrayUtil, basketService, basketStore, broker, extraProductsService, parkingDetailsService, scrollService, tripService, flightsTerminalService) {
        var ap = this;
        ap.noneParking = '-1';
        ap.currentParkingLimit = ap.parkingLimit = 5;
        ap.parkingAvailabilityBusy = true;
        broker.subscribe('Parking', 'parkingRequestFailed', function () {
            ap.showDetailsError = true;
            ap.parking = angular.copy(ap.noneParking);
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('Parking');
        });
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var basketId = trip.BasketId;
            var tripId = trip.TripId;
            var parkingSearchId = trip.ParkingRequest ? trip.ParkingRequest.AvailabilitySearchId : null;
            var onewayonly = trip.FlightsRequest.OneWayOnly;
            basketStore.parking(basketId, $routeParams.productId).then(function (results) {
                var parking = results ? results.Details.AirportParkingQuoteId : null;
                if (parking) {
                    ap.parking = angular.copy(parking);
                }
                else if (TRPCONFIG.Domain.DefaultAirportParkingSelection) {
                    ap.parking = ap.noneParking;
                }
                if (TRPCONFIG.Domain.AirportParkingEnabled && !onewayonly) {
                    basketService.getParkingQuotes(parkingSearchId, basketId, tripId).then(function (parkingQuotes) {
                        var setResults = function (results) {
                            ap.parkingQuotes = results;
                            _updateSubtitle();
                            ap.parkingAvailabilityBusy = false;
                            $scope.$watch('ap.parking', function (val) {
                                if (val == null) {
                                    return;
                                }
                                _updateSubtitle();
                                if (TRPCONFIG.Domain.EnforceParkingOptionSelection && results.length > 0) {
                                    $scope.$emit('sendParkingSelection', val);
                                }
                                else {
                                    $scope.$emit('sendParkingSelection', { CarParkCode: '0', SupplierId: 0 });
                                }
                                if (val !== ap.noneParking) {
                                    var quote_1 = arrayUtil.first(ap.parkingQuotes, function (q) {
                                        return angular.equals(q.QuoteId, val);
                                    });
                                    if (quote_1) {
                                        quote_1.parkingBusy = !quote_1.Details;
                                        ap.showDetailsError = false;
                                        tripService.getTrip(tripId).then(function (t) {
                                            parkingSearchId = t.ParkingRequest.AvailabilitySearchId;
                                            basketService.selectParking(val, parkingSearchId, basketId).then(function (d) {
                                                ap.showDetailsError = false;
                                                quote_1.Details = d.Details;
                                                quote_1.parkingBusy = false;
                                                quote_1.viewDetails = true;
                                                basketService.updateBasket();
                                            }, function () {
                                                quote_1.parkingBusy = false;
                                                quote_1.showDetailsError = true;
                                            });
                                        });
                                    }
                                    else {
                                        ap.parking = ap.noneParking;
                                    }
                                }
                                else {
                                    basketStore.removeParking(basketId).then(basketService.updateBasket);
                                }
                            }, true);
                        };
                        if (parkingQuotes && parkingQuotes.length) {
                            parkingQuotes = arrayUtil.sort(parkingQuotes, 'Price');
                            setResults(parkingQuotes);
                        }
                        else {
                            ap.parkingAvailabilityBusy = false;
                            $scope.$emit('sendParkingSelection', { CarParkCode: '0', SupplierId: 0 });
                        }
                    }, function () {
                        ap.parkingAvailabilityBusy = false;
                        $scope.$emit('sendParkingSelection', { CarParkCode: '0', SupplierId: 0 });
                    });
                }
            }).then(null, basketService.restartHolidayWorkflow);
            // get flight departure terminal
            basketStore.flight(trip.BasketId).then(function (flight) {
                var leg = flight.Details.Itinerary.Legs[0];
                flightsTerminalService.getTerminalForFlight(leg.DepartureAirport.Code, leg.Segments[0].FlightNumber, leg.DepartureDate)
                    .then(function (terminal) {
                    if (terminal) {
                        ap.terminal = terminal;
                    }
                });
            });
            ap.appendDetails = function (quote, $event) {
                if ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
                tripService.getTrip(tripId).then(function (trip) { return parkingDetailsService.appendDetails(quote, angular.copy(trip)); }).then(function () { ap.currentInfo = quote; });
            };
            ap.showMoreOrLess = function () {
                var moreParkingQuotes = ap.currentParkingLimit !== ap.parkingQuotes.length;
                var currentParkingLimit = moreParkingQuotes ? ap.parkingQuotes.length : 5;
                if (!moreParkingQuotes) {
                    scrollService.scrollTo('#parking-product-expander', { animate: true, offset: 70 }).then(function () {
                        ap.moreParkingQuotes = false;
                        ap.currentParkingLimit = currentParkingLimit;
                    });
                }
                else {
                    ap.moreParkingQuotes = true;
                    ap.currentParkingLimit = currentParkingLimit;
                }
            };
            ap.filterQuotes = extraProductsService.filterQuotes;
            function _updateSubtitle() {
                if (ap.parkingQuotes && ap.parking) {
                    var parkingQuote = arrayUtil.first(ap.parkingQuotes, function (p) {
                        return angular.equals(p.QuoteId, ap.parking);
                    });
                    ap.parkingQuoteDescription = parkingQuote ? parkingQuote.CarPark + " (" + $filter('customCurrency')(parkingQuote.Price) + ")" : null;
                }
            }
        }, basketService.bookingAlreadyDone("parking: '" + $routeParams.tripId + "'"));
    }
})();
(function () {
    'use strict';
    angular
        .module('parking')
        .controller('ParkingResults', ParkingResults);
    function ParkingResults($scope, parkingService, parkingDetailsService, $location, broker, tripService, $routeParams, basketService) {
        var cm = this;
        var tripId = $routeParams.tripId;
        cm.appendDetails = appendDetails;
        tripService.getTrip(tripId).then(function (trip) {
            var parkingRq = trip && trip.ParkingRequest;
            if (parkingRq) {
                parkingService.getSearchResults(tripId)
                    .then(function (data) {
                    cm.parkingQuotes = data;
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }, function () { return $location.path('parking'); })
                    .then(function () { return tripService.getParkingRequestSummary(tripId); })
                    .then(function (summary) { return cm.summary = summary; });
                cm.selectParking = function (parking) {
                    basketService.selectParking(parking.QuoteId, parkingRq.AvailabilitySearchId, trip.BasketId, tripId);
                    cm.selectedParking = parking.QuoteId;
                };
            }
        });
        function appendDetails(quote) {
            tripService.getTrip(tripId).then(function (trip) { return parkingDetailsService.appendDetails(quote, angular.copy(trip)); });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('parking')
        .controller('ParkingSearchUnit', Parking);
    function Parking(searchUnitService, dateUtil, $window, $scope, resourceService, broker, basketService, $timeout) {
        var cm = this;
        var mode = searchUnitService.parking;
        $timeout(function () {
            var selectedDepartureAirport = searchUnitService.getSelectedDepartureAirport();
            if (selectedDepartureAirport && selectedDepartureAirport.Code && selectedDepartureAirport.Code.indexOf(',') > -1) {
                searchUnitService.clearDepartureAirports();
            }
            cm.summary = searchUnitService.getSummary(mode);
        });
        var minimumDate = dateUtil.todayPlus(1, 0, true);
        var minimumDatePlusOne = dateUtil.addDays(minimumDate, 1, true) || dateUtil.todayPlus(1, 0, true);
        var initStartPlusOne;
        cm.setStartDate = setStartDate;
        cm.setEndDate = setEndDate;
        cm.search = search;
        cm.startDate = searchUnitService.startDate(mode);
        cm.endDate = searchUnitService.endDate(mode);
        if (cm.startDate) {
            initStartPlusOne = dateUtil.addDays(cm.startDate, 1, true);
        }
        cm.minDates = {
            minimumDate: minimumDate,
            startPlusOne: initStartPlusOne || minimumDatePlusOne
        };
        function setStartDate(date, back) {
            if (date) {
                cm.minDates.startPlusOne = dateUtil.addDays(date, 1, true);
            }
            searchUnitService.startDate(mode, date);
            cm.summary = searchUnitService.getSummary(mode);
            if (back) {
                setTimeout(function () {
                    $window.history.back();
                }, 0);
            }
        }
        function setEndDate(date, back) {
            searchUnitService.endDate(mode, date);
            cm.summary = searchUnitService.getSummary(mode);
            cm.showEndCalendar = false;
            if (back) {
                setTimeout(function () {
                    $window.history.back();
                }, 0);
            }
        }
        var flow = basketService.parkingBooking;
        /*Can be moved to a directive*/
        function search() {
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGPARKING'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-parkingSearchUnit'
            });
            basketService.startWorkflow(flow).then(null, function (errors) {
                broker.publish('unblock');
                $scope.$emit('unblock');
                $scope.$emit('flash:error', errors);
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('parking')
        .service('parkingService', parkingService);
    function parkingService($http, $q, analytics, dateUtil, guidService, occupancyService, parkingSearchValidator, searchUnitService, tripService, loggingService) {
        var domain = TRPCONFIG.Domain;
        var service = {
            getParkingQuotes: getParkingQuotes,
            getParkingQuotesFromSession: getParkingQuotesFromSession,
            validateSearchCriteria: validateSearchCriteria,
            clearSearchResults: clearSearchResults,
            getSearchResults: getSearchResults
        };
        var results;
        function clearSearchResults() {
            results = null;
        }
        function getSearchResults(tripId) {
            if (results && results !== 'null') {
                return $q.when(results);
            }
            return getParkingQuotes(tripId);
        }
        function getParkingQuotes(tripId, request) {
            if (request === void 0) { request = _buildStandaloneParkingRequest(); }
            // `request` argument supplied in holiday mode i.e. basketService.getParkingQuotes()
            // Availability request format
            var availabilityReq = angular.extend({
                DomainId: domain.DomainId,
                CultureCode: domain.CultureCode
            }, request);
            // Trip service format
            var tripServiceReq = angular.extend({
                Airport: searchUnitService.getSelectedDepartureAirport()
            }, request);
            delete tripServiceReq.AirportCode;
            tripService.recordParkingSearch(tripId, tripServiceReq);
            analytics.startTimer('ParkingAvailabilityRequest');
            return $http.post('/api2/airportparking/availability/get', availabilityReq, { ignoreErrors: true })
                .then(function (res) {
                if (res.data.CarParkingQuotes.length === 0) {
                    loggingService.logError("No airport parking information found for " + tripId + ", fn.getParkingQuotes");
                }
                analytics.endTimer('ParkingAvailabilityRequest');
                return _enrichData(res.data.CarParkingQuotes, availabilityReq.DepartureDate, availabilityReq.ReturnDate);
            }, function () {
                return null;
            });
        }
        function getParkingQuotesFromSession(availabilitySearchId, availabilityRequest) {
            return $http.post('/api2/airportparking/availability/getfromsession', { AvailabilitySearchId: availabilitySearchId }, { ignoreErrors: true }).then(function (results) {
                if (results.data.CarParkingQuotes.length === 0) {
                    loggingService.logError("No airport parking information found for " + availabilitySearchId + ", fn.getParkingQuotesFromSession");
                }
                return _enrichData(results.data.CarParkingQuotes, availabilityRequest.DepartureDate, availabilityRequest.ReturnDate);
            }, function () {
                return null;
            });
        }
        function validateSearchCriteria() {
            return parkingSearchValidator.validate(searchUnitService.getSelectedDepartureAirport(), searchUnitService.startDate(searchUnitService.parking), searchUnitService.endDate(searchUnitService.parking));
        }
        function _buildStandaloneParkingRequest() {
            var departureAirport = searchUnitService.getSelectedDepartureAirport();
            return {
                AvailabilitySearchId: guidService.uuid(),
                DepartureDate: searchUnitService.startDate(searchUnitService.parking),
                ReturnDate: searchUnitService.endDate(searchUnitService.parking),
                AirportCode: departureAirport && departureAirport.Code,
                PassengerCount: occupancyService.getPassengerCount()
            };
        }
        function _enrichData(parkings, fromDate, toDate) {
            var days = dateUtil.getDifferenceInDays(dateUtil.parseDate(fromDate), dateUtil.parseDate(toDate));
            angular.forEach(parkings, function (parking) {
                parking.PerDayPrice = parking.Price / days;
            });
            return parkings;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('parking')
        .service('parkingDetailsService', parkingDetailsService);
    function parkingDetailsService($http, $cacheFactory, $q, broker) {
        var url = '/api2/airportparking/details/';
        var timeout;
        var promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');
        var service = {
            getParkingDetails: getParkingDetails,
            appendDetails: appendDetails,
            rehydrate: rehydrate
        };
        function getParkingDetails(quote) {
            if (quote.AirportParkingQuoteId.Details) {
                return $q.when(quote.AirportParkingQuoteId.Details);
            }
            if (timeout != null) {
                timeout.resolve('CANCELLED');
            }
            var request = {
                AvailabilitySearchId: quote.AvailabilitySearchId,
                AirportParkingQuoteId: quote.AirportParkingQuoteId,
                DomainId: TRPCONFIG.Domain.DomainId
            };
            timeout = $q.defer();
            return $http.post(url + "get", request, {
                customErrCallback: function (args) {
                    if (args.status) {
                        broker.publish('parkingRequestFailed');
                    }
                    return true;
                },
                timeout: timeout.promise
            }).then(function (res) {
                promiseCache.remove(res.data.DetailsSearchId);
                timeout = null;
                return res.data;
            });
        }
        function appendDetails(quote, t) {
            if (!quote.Details) {
                quote.parkingBusy = true;
                var parkingSearchId = t.ParkingRequest.AvailabilitySearchId;
                service.getParkingDetails({ AvailabilitySearchId: parkingSearchId, AirportParkingQuoteId: quote.QuoteId }, true).then(function (d) {
                    quote.viewDetails = true;
                    quote.Details = d;
                    quote.parkingBusy = false;
                    quote.showDetailsError = false;
                }, function () {
                    quote.parkingBusy = false;
                    quote.showDetailsError = true;
                });
            }
            else {
                quote.viewDetails = true;
            }
        }
        function rehydrate(id) {
            if (!promiseCache.get(id)) {
                promiseCache.put(id, $http.post(url + "getfromsession", { DetailsSearchId: id }).then(function (res) {
                    return res.data;
                }));
            }
            return promiseCache.get(id);
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('parking')
        .service('parkingSearchValidator', parkingSearchValidator);
    function parkingSearchValidator(resourceService, dateUtil) {
        var service = {
            validate: validate
        };
        function validate(departureAirport, startDate, endDate) {
            var errors = [];
            if (departureAirport == null) {
                errors.push(resourceService.get('SELECTDEPARTUREAIRPORT'));
            }
            if (startDate == null) {
                errors.push(resourceService.get('SELECTARRIVALDATE'));
            }
            else if (!dateUtil.atLeastOneDayInTheFuture(startDate)) {
                errors.push(resourceService.get('ARRIVALDATEMUSTBEFUTURE'));
            }
            if (endDate == null) {
                errors.push(resourceService.get('SELECTRETURNDATE'));
            }
            else if (endDate <= startDate) {
                errors.push(resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
            }
            return errors;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('quote')
        .controller('Quote', Quote);
    function Quote(quoteService, tripService, bookingService, hotelRehydrator, $routeParams, $location, $filter, dateUtil, flightDetail, $q) {
        var qc = this;
        qc.quoteCreationError = false;
        qc.quoteNotFound = false;
        qc.quoteRefreshEnabled = TRPCONFIG.Domain.QuoteRefreshEnabled;
        qc.quoteManager = !($routeParams.quoteRef && $routeParams.quoteNo);
        qc.quoteRefreshError = false;
        qc.validForDays = 30; //maybe the API should tell us this
        if (!qc.quoteManager) {
            quoteService.getQuoteByReference($routeParams.quoteRef + "/" + $routeParams.quoteNo).then(function (result) {
                if (result === null) {
                    qc.quoteNotFound = true;
                }
                else {
                    qc.quote = result;
                    if (!qc.quote) {
                        qc.quoteNotFound = true;
                    }
                    else {
                        qc.validForDays = quoteService.validForDays(qc.quote.Products);
                        enrichProducts();
                    }
                }
            });
        }
        var productNames = {
            accommodation: 0,
            flight: 1,
            transfer: 2,
            airportparking: 3,
            attractionticket: 4,
            carhire: 5,
            marhaba: 6,
            insurance: 7
        };
        function getNumFromType(type) {
            var typeStr = type.toLowerCase().replace(/\s/g, '');
            return productNames[typeStr] >= 0 ? productNames[typeStr] : Object.keys(productNames).length;
        }
        function sortProducts(products) {
            var sorted = products && products.sort(function (a, b) {
                var typeA = getNumFromType(a.Type);
                var typeB = getNumFromType(b.Type);
                a.TypeId = typeA;
                b.TypeId = typeB;
                return typeA > typeB ? 1 : -1;
            });
            return sorted;
        }
        qc.refreshQuote = function () {
            qc.refreshClicked = true;
            qc.quoteRefreshError = false;
            return quoteService.refreshQuote(qc.quote.Id, qc.quote.ProductIds).then(function (result) {
                qc.refreshClicked = false;
                if (result.Error) {
                    qc.quoteRefreshError = true;
                }
                else {
                    qc.quote = result;
                    if (!qc.quote) {
                        qc.quoteNotFound = true;
                        qc.quoteCreationError = true;
                    }
                    else {
                        qc.validForDays = quoteService.validForDays(qc.quote.Products);
                        return enrichProducts();
                    }
                }
            });
        };
        qc.getQuoteByReference = function (quoteRef, quoteNo) {
            $location.path("quote/manage/" + quoteRef + "/" + quoteNo);
        };
        qc.replaceProduct = function (quoteId, productId, replacementId) {
            quoteService.replaceProduct(quoteId, productId, replacementId).then(function (result) {
                qc.quote = result;
                if (!qc.quote) {
                    qc.quoteNotFound = true;
                    qc.quoteCreationError = true;
                }
                else {
                    qc.validForDays = quoteService.validForDays(qc.quote.Products);
                    enrichProducts();
                }
            });
        };
        qc.gotoBasket = function () { return $location.path('dp/basket'); };
        qc.bookQuote = function () {
            //redirection url
            var bookingRedirectPath = 'holidays/book';
            if (qc.quote.Products && qc.quote.Products.length === 1) {
                if (qc.quote.Products[0].Type === 'Accommodation') {
                    bookingRedirectPath = 'hotels/book';
                }
                else if (qc.quote.Products[0].Type === 'Transfer') {
                    bookingRedirectPath = 'transfers/book';
                }
                else if (qc.quote.Products[0].Type === 'Marhaba') {
                    bookingRedirectPath = 'marhaba/book';
                }
                else if (qc.quote.Products[0].Type === 'Insurance') {
                    bookingRedirectPath = 'insurance/book';
                }
                else if (qc.quote.Products[0].Type === 'Airport Parking') {
                    bookingRedirectPath = 'parking/book';
                }
            }
            //get trip
            tripService.getTripFromQuote(qc.quote).then(function (result) {
                qc.tripFromQuote = result;
                bookingService.prepareBooking(qc.quote.BasketId, qc.tripFromQuote.BookingId, qc.tripFromQuote.TripId)
                    .then(function () {
                    if (bookingRedirectPath === 'marhaba/book') {
                        $location.path("marhaba/book/" + qc.tripFromQuote.TripId + "/" + qc.quote.Products[0].Id);
                    }
                    else {
                        $location.path(bookingRedirectPath + "/" + qc.tripFromQuote.TripId);
                    }
                });
            });
        };
        qc.searchAgain = function () {
            //select tab from search unit
            var searchRedirectPath = '/holidays';
            if (qc.quote.Products.length === 1) {
                searchRedirectPath = qc.quote.Products[0].searchRedirectPath;
            }
            //get trip id
            tripService.getTripFromQuote(qc.quote).then(function (result) {
                qc.tripFromQuote = result;
                if (qc.tripFromQuote) {
                    tripService.restoreSearchUnit(qc.tripFromQuote.TripId).then(function () {
                        $location.path(searchRedirectPath);
                    });
                }
                else {
                    document.location.href = '/';
                }
            });
        };
        function getDetailsForAllFlights(products) {
            return $q.all(products
                .map(function (p) {
                return p.Type === 'Flight'
                    ? flightDetail.mapLegs(p)
                    : $q.when(p);
            }));
        }
        function enrichProducts() {
            return getDetailsForAllFlights(qc.quote.Products)
                .then(function (p) {
                var products = sortProducts(p);
                qc.quote.ProductIds = [];
                qc.quote.RestoreFailed = false;
                qc.quote.totalQuotedHolidayCost = 0;
                qc.quote.totalCurrentHolidayCost = 0;
                qc.failedRestore = products && products.filter(function (p) { return p.RestoreFailed; });
                angular.forEach(products, function (product) {
                    qc.quote.ProductIds.push(product.Id);
                    if (product.RestoreFailed) {
                        qc.quote.RestoreFailed = true;
                    }
                    if (product.Type === 'Flight') {
                        product.iconClass = 'icon-flights';
                        getFlightDetails(product);
                        product.searchRedirectPath = '/flights';
                    }
                    else if (product.Type === 'Accommodation') {
                        product.iconClass = 'icon-hotels';
                        getHotelDetails(product);
                        product.searchRedirectPath = '/hotels';
                        if (Array.isArray(product.SpecialOffers)) {
                            product.HasSpecialOffers = product.SpecialOffers.some(function (so) { return so; });
                        }
                    }
                    else if (product.Type === 'Transfer') {
                        product.iconClass = 'icon-transfers';
                        product.searchRedirectPath = '/transfers';
                    }
                    else if (product.Type === 'Car Hire') {
                        product.searchRedirectPath = '/car-hire';
                        getCarHireDetails(product);
                    }
                    else if (product.Type === 'Marhaba') {
                        if (product.Options.length > 0) {
                            getTotalProductCost(product);
                        }
                        product.searchRedirectPath = '/marhaba';
                    }
                    else if (product.Type === 'Insurance') {
                        product.searchRedirectPath = '/insurance';
                    }
                    qc.quote.totalQuotedHolidayCost += product.TotalQuotedCost ? product.TotalQuotedCost : product.QuotedCost;
                    qc.quote.totalCurrentHolidayCost += product.TotalCurrentCost ? product.TotalCurrentCost : product.CurrentCost;
                });
                qc.quote.Products = products;
            });
        }
        function getCarHireDetails(product) {
            angular.forEach(product.Options, function (option) {
                if (option.OnRequest) {
                    product.ShowOnRequest = true;
                }
                option.PayableLocally = (option.CurrentUnitCost === 0 && option.QuotedUnitCost === 0 && option.Quantity >= 1 && option.OnRequest === true);
                option.UnitCurrentAmountString = $filter('customCurrency')(option.CurrentUnitCost, option.Currency);
                option.TotalCurrentAmountString = $filter('customCurrency')((option.CurrentUnitCost * option.Quantity), option.Currency);
            });
        }
        function getFlightDetails(product) {
            getTotalProductCost(product);
            product.Options = _.filter(product.Options, function (option) {
                var title = "" + parseInt(option.Title);
                return option.CurrentOptionCost > 0 || option.Title !== title;
            });
        }
        function getHotelDetails(product) {
            hotelRehydrator.staticHotel(product.EstablishmentId).then(function (d) {
                product.extraDetails = d;
            });
        }
        function getTotalProductCost(product) {
            var totalQuotedProductCost = 0;
            var totalCurrentProductCost = 0;
            angular.forEach(product.Options, function (option) {
                option.CurrentOptionCost = option.Quantity * option.CurrentUnitCost;
                option.QuotedOptionCost = option.Quantity * option.QuotedUnitCost;
                totalQuotedProductCost += option.QuotedOptionCost;
                totalCurrentProductCost += option.CurrentOptionCost;
                option.UnitCurrentAmountString = $filter('customCurrency')(option.CurrentUnitCost);
                option.TotalCurrentAmountString = $filter('customCurrency')((option.CurrentUnitCost * option.Quantity));
            });
            product.TotalCurrentCost = product.CurrentCost + totalCurrentProductCost;
            product.TotalQuotedCost = product.QuotedCost + totalQuotedProductCost;
        }
    }
})();
var Quote;
(function (Quote) {
    var QuoteControllerStatus;
    (function (QuoteControllerStatus) {
        QuoteControllerStatus[QuoteControllerStatus["Busy"] = 0] = "Busy";
        QuoteControllerStatus[QuoteControllerStatus["NotFound"] = 1] = "NotFound";
        QuoteControllerStatus[QuoteControllerStatus["Ready"] = 2] = "Ready";
        QuoteControllerStatus[QuoteControllerStatus["RefreshError"] = 3] = "RefreshError";
        QuoteControllerStatus[QuoteControllerStatus["RefreshFailed"] = 4] = "RefreshFailed";
    })(QuoteControllerStatus = Quote.QuoteControllerStatus || (Quote.QuoteControllerStatus = {}));
    var QuotePublicController = /** @class */ (function () {
        function QuotePublicController($location, $routeParams, analytics, basketService, basketStore, bookingService, dateUtil, tripService, quoteService) {
            var _this = this;
            this.$location = $location;
            this.$routeParams = $routeParams;
            this.analytics = analytics;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.bookingService = bookingService;
            this.dateUtil = dateUtil;
            this.tripService = tripService;
            this.quoteService = quoteService;
            this.controllerStatus = QuoteControllerStatus;
            this.currentStatus = QuoteControllerStatus.Busy;
            this.priceDifference = 0;
            this.priceDifferencePercentage = 0;
            this.validForDays = 30; //maybe the API should tell us this
            this.hasEssentials = false;
            this.productsLength = 0;
            this.analytics.track('mixpanel', 'EmailMeLanding');
            var url = $routeParams.quoteRef + "/" + $routeParams.quoteNo;
            this.quoteStatusPromise = quoteService.getQuoteByReference(url)
                .then(function (quote) {
                if (!quote || quote.Error) {
                    return _this.currentStatus = QuoteControllerStatus.NotFound;
                }
                //get the product ids
                var productIds = _.map(quote.Products, function (p) { return p.Id; });
                //seems that we can't do a single thing going forward without a trip being setup. As we are refreshing
                //the quote we might as well create a trip from the quote too. Unfortunately the trip service
                //relies on the basket and the basket is there until the refresh has happened :(
                return quoteService.refreshQuote(quote.Id, productIds).then(function (refreshedQuote) {
                    if (refreshedQuote.Error) {
                        return _this.currentStatus = QuoteControllerStatus.RefreshError;
                    }
                    else {
                        var restoreFailed = _.some(refreshedQuote.Products, { 'RestoreFailed': true });
                        _this.productsLength = refreshedQuote.Products.length;
                        if (restoreFailed) {
                            _this.quote = quote;
                            return _this.currentStatus = QuoteControllerStatus.RefreshFailed;
                        }
                        _this.hasEssentials = _.some(refreshedQuote.Products, function (_a) {
                            var Ty = _a.Ty;
                            return Ty === 'Transfer' || Ty === 'Car Hire' || Ty === 'Marhaba' || Ty === 'Insurance';
                        });
                        return tripService.getTripFromQuote(refreshedQuote).then(function (trip) {
                            _this.trip = trip;
                            _this.quote = refreshedQuote;
                            _this.validForDays = quoteService.validForDays(refreshedQuote.Products);
                            _this._setPriceDifference(refreshedQuote.Products);
                            return _this.currentStatus = QuoteControllerStatus.Ready;
                        });
                    }
                });
            });
        }
        QuotePublicController.prototype._setPriceDifference = function (products) {
            var _a = this.quoteService.getPriceDifference(products), priceDifferenceAbs = _a.priceDifferenceAbs, priceDifferencePercentage = _a.priceDifferencePercentage;
            this.priceDifference = priceDifferenceAbs;
            this.priceDifferencePercentage = priceDifferencePercentage;
        };
        QuotePublicController.prototype.searchAgain = function () {
            var _this = this;
            if (this.trip) {
                this.tripService.restoreSearchUnit(this.trip.TripId).then(function () {
                    _this.$location.path('/holidays');
                });
            }
            else {
                this.$location.path('/');
            }
        };
        ;
        QuotePublicController.prototype.bookQuote = function (position) {
            var _this = this;
            var bookingRedirectPath = 'holidays/book';
            var _a = this.trip, BookingId = _a.BookingId, TripId = _a.TripId;
            var BasketId = this.quote.BasketId;
            this.basketService
                .bookBasket(TripId, BasketId);
            this.bookingService
                .prepareBooking(BasketId, BookingId, TripId)
                .then(function () {
                _this.$location.path(bookingRedirectPath + "/" + TripId);
            });
            if (position) {
                this.analytics.track('mixpanel', 'EmailMeBookButton', { position: position });
            }
        };
        QuotePublicController.prototype.hideLoadingScreenOverlay = function () {
            var _a = this, quote = _a.quote, currentStatus = _a.currentStatus, controllerStatus = _a.controllerStatus;
            return quote && (currentStatus === controllerStatus.Ready ||
                currentStatus === controllerStatus.RefreshError ||
                currentStatus === controllerStatus.RefreshFailed);
        };
        return QuotePublicController;
    }());
    angular
        .module('quote')
        .controller('QuotePublic', QuotePublicController);
})(Quote || (Quote = {}));
var Quote;
(function (Quote) {
    var AdvancedQuoteSearch = /** @class */ (function () {
        function AdvancedQuoteSearch(quoteService, $scope, resourceService, agentModeService, dateUtil, $location, broker, $q, localStorageProvider) {
            var _this = this;
            this.quoteService = quoteService;
            this.$scope = $scope;
            this.resourceService = resourceService;
            this.agentModeService = agentModeService;
            this.dateUtil = dateUtil;
            this.$location = $location;
            this.broker = broker;
            this.$q = $q;
            this.localStorageProvider = localStorageProvider;
            this.busy = false;
            this.toggleSearchForm = true;
            this.page = function (num, e) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                _this.search(num);
            };
            this.initSearch(quoteService.getCachedSearch());
        }
        AdvancedQuoteSearch.prototype.searchAgain = function () {
            this.searching = false;
            this.showSearchForm = true;
            this.toggleSearchForm = true;
        };
        AdvancedQuoteSearch.prototype.initSearch = function (cache) {
            var _this = this;
            this.searching = false;
            this.showSearchForm = true;
            this.allowToggleAdvancedSearch = 'function' === typeof this.hideAdvancedSearch;
            this.today = this.dateUtil.todayPlus(0, 0, true);
            this.dateLimits = {
                startMaxDate: this.today,
                endMaxDate: this.dateUtil.todayPlus(1, 0, true)
            };
            this.toggleSearchForm = true;
            this.quoteSearch = {
                searchModel: {
                    domainId: TRPCONFIG.Domain.DomainId,
                    page: 1,
                    limit: 9,
                    sortDirection: 'DESC'
                },
                searchResponse: null
            };
            if (cache != null) {
                this.quoteSearch = cache;
                this.showSearchForm = false;
                this.toggleSearchForm = false;
            }
            this.agentModeService.getCoworkers().then(function (data) { _this.agents = data; });
        };
        AdvancedQuoteSearch.prototype.search = function (pgIndex) {
            var _this = this;
            this.noPermission = false;
            this.quoteSearch.searchModel.page = pgIndex;
            this.quoteSearch.searchModel.reference = this.quoteSearch.searchModel.quoteNo
                ? "QUO/" + this.quoteSearch.searchModel.quoteNo
                : '';
            this.searching = true;
            this.showSearchForm = false;
            var onRequestFinished = function (searchResponse) {
                _this.searching = false;
                _this.toggleSearchForm = false;
                _this.quoteSearch.searchResponse = searchResponse;
            };
            return this.quoteService.search(this.quoteSearch.searchModel).then(function (res) {
                onRequestFinished(res);
            }, function (err) {
                if (err.status === 400) {
                    _this.showError('QUOTEADVANCESEARCH_NOTSPECIFIC');
                    _this.searching = false;
                    _this.showSearchForm = true;
                    return;
                }
                onRequestFinished(null);
                _this.noPermission = 401 === err.status;
            });
        };
        AdvancedQuoteSearch.prototype.showError = function (error) {
            this.$scope.$broadcast('flash:error', this.resourceService.get(error));
        };
        AdvancedQuoteSearch.prototype.manageQuote = function (reference) {
            this.broker.publish('quoteSelected', reference);
            this.localStorageProvider.setItem('quoteSelected', reference);
            this.$location.path('quote/manage/' + reference);
        };
        AdvancedQuoteSearch.prototype.setStartDate = function (date) {
            this.quoteSearch.searchModel.from = date;
            this.dateLimits.endMinDate = date;
        };
        AdvancedQuoteSearch.prototype.setEndDate = function (date) {
            this.quoteSearch.searchModel.to = date;
        };
        AdvancedQuoteSearch.prototype.selectAgent = function (agent) {
            if (agent) {
                this.quoteSearch.searchModel.quotedById = agent.Id;
                this.selectedAgent = agent;
            }
        };
        AdvancedQuoteSearch.prototype.selectCustomer = function (customer) {
            if (customer) {
                this.selectedCustomer = customer;
                this.quoteSearch.searchModel.userId = customer.UserId;
            }
        };
        AdvancedQuoteSearch.prototype.selectTravelAgent = function (agent) {
            if (agent) {
                this.selectedTravelAgent = agent;
                this.quoteSearch.searchModel.externalAgentId = agent.Id;
            }
        };
        AdvancedQuoteSearch.prototype.filterAgent = function (prefix) {
            return _.filter(this.agents, function (agent) { return _.includes(_.toLower(agent.FullName), _.toLower(prefix)); });
        };
        AdvancedQuoteSearch.prototype.autoCompleterDeselect = function (prop) {
            this.quoteSearch.searchModel[prop] = null;
            if (prop === 'externalAgentId') {
                this.selectedTravelAgent = undefined;
            }
            if (prop === 'userId') {
                this.selectedCustomer = undefined;
            }
            if (prop === 'quotedById') {
                this.selectedAgent = undefined;
            }
        };
        AdvancedQuoteSearch.prototype.getTravelAgentNameForQuote = function (quote) {
            return this.quoteService.getTravelAgentNameForQuote(quote) || '-';
        };
        AdvancedQuoteSearch.prototype.getTravelAgentAgencyNameForQuote = function (quote) {
            if (this.travelAgentDetails && this.travelAgentDetails[quote.TravelAgentId]) {
                return this.travelAgentDetails[quote.TravelAgentId].Name;
            }
            return '-';
        };
        AdvancedQuoteSearch.prototype.getCustomerNameForQuote = function (quote) {
            return this.quoteService.getCustomerNameForQuote(quote, this.getContactByUserId(quote.UserId)) || '-';
        };
        AdvancedQuoteSearch.prototype.getCustomerEmailForQuote = function (quote) {
            return this.quoteService.getCustomerEmailForQuote(quote, this.getContactByUserId(quote.UserId) ||
                this.getTravelAgentContactById(quote.TravelAgentId)) || '-';
        };
        AdvancedQuoteSearch.prototype.getCustomerPhoneNumberForQuote = function (quote) {
            return this.quoteService.getCustomerPhoneNumberForQuote(this.getContactByUserId(quote.UserId) ||
                this.getTravelAgentContactById(quote.TravelAgentId) || quote) || '-';
        };
        AdvancedQuoteSearch.prototype.getCustomerSkywardNumberForQuote = function (quote) {
            return this.quoteService.getCustomerSkywardNumberForQuote(this.getContactByUserId(quote.UserId) || quote) || '-';
        };
        AdvancedQuoteSearch.prototype.getContactByUserId = function (userId) {
            if (userId && this.userDetails && this.userDetails[userId]) {
                return this.userDetails[userId].Contact;
            }
            return null;
        };
        AdvancedQuoteSearch.prototype.getTravelAgentContactById = function (agentId) {
            if (agentId && this.travelAgentDetails && this.travelAgentDetails[agentId]) {
                return this.travelAgentDetails[agentId].Contact;
            }
            return null;
        };
        AdvancedQuoteSearch.prototype.hideSearch = function ($e) {
            $e.preventDefault();
            if (this.allowToggleAdvancedSearch) {
                this.hideAdvancedSearch();
            }
        };
        return AdvancedQuoteSearch;
    }());
    angular
        .module('quote')
        .directive('advancedQuoteSearch', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'partials/quote/directivetemplate?type=advancedquotesearch',
            controller: AdvancedQuoteSearch,
            controllerAs: 'aqs',
            bindToController: {
                hideAdvancedSearch: '&?',
                showTravelAgencyDetail: '=?',
                showLoyaltyNumber: '=?',
                showLinkedBookings: '=?',
            }
        };
    });
})(Quote || (Quote = {}));
var Quote;
(function (Quote) {
    var BasketNotes = /** @class */ (function () {
        function BasketNotes(quoteService, basketStore) {
            this.quoteService = quoteService;
            this.basketStore = basketStore;
        }
        BasketNotes.prototype.createNote = function () {
            this.newNote = { Text: '' };
        };
        BasketNotes.prototype.addNote = function () {
            var _this = this;
            if (!this.newNote) {
                return;
            }
            var text = this.newNote.Text;
            var promise;
            if (this.basketType === 'basket') {
                promise = this.basketStore.addNote(this.basketId, text);
            }
            else if (this.basketType === 'quote') {
                promise = this.quoteService.addNote(this.basketId, text);
            }
            promise.then(function (basket) {
                _this.newNote = null;
                _this.notes = basket.Notes;
            });
        };
        BasketNotes.prototype.getDate = function (note) {
            return new Date(note.Created + '+00:00');
        };
        return BasketNotes;
    }());
    angular
        .module('quote')
        .directive('basketNotes', function () {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                notes: '=',
                basketId: '=',
                basketType: '@'
            },
            templateUrl: 'partials/quote/directivetemplate?type=notes',
            controller: BasketNotes,
            controllerAs: 'n'
        };
    });
})(Quote || (Quote = {}));
var QuoteCreator;
(function (QuoteCreator_1) {
    var QuoteCreator = /** @class */ (function () {
        function QuoteCreator($scope, analytics, quoteManager, broker, quoteService, $location, resourceService, currentUser, localStorageProvider) {
            var _this = this;
            this.$scope = $scope;
            this.analytics = analytics;
            this.quoteManager = quoteManager;
            this.broker = broker;
            this.quoteService = quoteService;
            this.$location = $location;
            this.resourceService = resourceService;
            this.currentUser = currentUser;
            this.localStorageProvider = localStorageProvider;
            this.contactEmail = '';
            this.sendEmail = TRPCONFIG.Domain.EnableAgentSendQuoteEmail;
            this.quoteCreated = false;
            this.showLink = true;
            this.newsletterSignup = false;
            this.createClicked = false;
            this.quoteCreationError = false;
            this.quoteEmailAttempts = 0;
            this.quoteEmailAttemptsLimit = 3;
            this.emailPattern = /^\S+@\S+\.\S+[^\.]$/;
            this._initContact();
            this.$scope.$on('form:submitted-invalid', function (event, form) {
                if (form.$name === 'quoteForm') {
                    _this.invalidUser = true;
                }
            });
        }
        QuoteCreator.prototype._initContact = function () {
            var currentUser = this.currentUser.get();
            var contact = currentUser && currentUser.Contact || {};
            this.contact = {
                Title: contact.Title || '',
                FirstName: contact.FirstName || '',
                LastName: contact.LastName || '',
                Email: contact.Email || '',
                MobileTel: contact.MobileTel || ''
            };
        };
        QuoteCreator.prototype._newPostCreateQuote = function (response) {
            if (response.Error) {
                this.quoteCreationError = true;
                this.quoteCreated = false;
            }
            else {
                this.quote = response.Payload;
                this.quoteCreated = true;
                this.quoteEmailAttempts++;
                this.localStorageProvider.removeItem('trackingTag');
                this.refEmail = this.$scope.qc.contact.Email;
                if (this.formName === 'quoteFormNonReg') {
                    this.$scope.qc.contact.Email = '';
                }
            }
            this.createClicked = false;
        };
        QuoteCreator.prototype._newCreateQuote = function (contact, noUserCheck, trackingTag, formName) {
            if (contact === void 0) { contact = null; }
            if (noUserCheck === void 0) { noUserCheck = false; }
            var EmailAddress = contact ? contact.Email : null;
            var email = EmailAddress ? { Email: EmailAddress } : null;
            var request = {
                QuoteId: '',
                BasketId: this.basketId,
                SharedUse: this.sharedUseFlag,
                SendEmail: noUserCheck ? false : this.sendEmail,
                TrackingTag: trackingTag,
                EmailAddress: EmailAddress,
                EmailSignUp: this.newsletterSignup,
                User: noUserCheck || !this.registerUser ? email : contact
            };
            this.formName = formName ? formName : '';
            return this.quoteManager.create(request);
        };
        QuoteCreator.prototype.create = function (contact, noUserCheck, mixPanelTag, formName) {
            var _this = this;
            if (noUserCheck === void 0) { noUserCheck = false; }
            this.quoteCreationError = false;
            this.createClicked = true;
            this.quoteCreated = false;
            if (mixPanelTag) {
                this.analytics.track('mixpanel', mixPanelTag);
            }
            return this.localStorageProvider.getItem('trackingTag')
                .then(function (trackingTag) { return _this._newCreateQuote(contact, noUserCheck, trackingTag, formName); })
                .then(function (result) { return _this._newPostCreateQuote(result); });
        };
        QuoteCreator.prototype.manageQuote = function (reference) {
            this.broker.publish('quoteSelected', reference);
            this.localStorageProvider.setItem('quoteSelected', reference);
            this.$location.path('quote/manage/' + reference);
        };
        QuoteCreator.prototype.getName = function (str) {
            return this.resourceService.get(str.toUpperCase());
        };
        QuoteCreator.prototype.isQuoteEmailDisabled = function () {
            return this.quoteEmailAttempts >= this.quoteEmailAttemptsLimit;
        };
        return QuoteCreator;
    }());
    angular.module('quote').directive('quoteCreator', function () {
        return {
            restrict: 'E',
            replace: false,
            scope: {},
            controllerAs: 'qc',
            bindToController: {
                sharedUse: '=',
                basketId: '=',
                registerUser: '=',
                expanded: '=',
                expandable: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=Agent/QuoteCreator&version='
                        + attr.templateVersion;
                }
                return 'partials/quote/quotecreator';
            },
            controller: QuoteCreator,
            transclude: true
        };
    });
})(QuoteCreator || (QuoteCreator = {}));
var Recommendations;
(function (Recommendations) {
    //A structure of destination to help with serialising bd4 destinations.
    var Bd4Destination = /** @class */ (function () {
        // The type system around destinations has become insane.
        // Try to parse a wide range of inputs.
        function Bd4Destination(x) {
            if (angular.isString(x) && x.indexOf('tr') === 0) {
                x = x.match(/tr(\d+):(\d+)/);
                x = {
                    Type: parseInt(x[1], 10),
                    Id: parseInt(x[2], 10)
                };
            }
            else {
                x = x || {};
                x = x.searchModel || x;
                x = x.destination || x;
                x = x.object || x;
                x = x[0] || x;
                x = {
                    Type: x.Type || x.ObjectTypeId || (x.idType || '').replace('tr', ''),
                    Id: x.Id || x.ObjectId || x.id
                };
            }
            x.fullyQualifiedId = "tr" + x.Type + ":" + x.Id;
            return x;
        }
        return Bd4Destination;
    }());
    Recommendations.Bd4Destination = Bd4Destination;
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    function HomeRecommender($location, $q, houseRecommender, recommender, recommenderUiHelper) {
        return {
            scope: {
                placementId: '@',
                hideDestinations: '=',
                imgWidth: '@'
            },
            replace: true,
            templateUrl: 'partials/recommendations/homerecommender',
            link: function ($scope, $element) {
                $q.all([
                    recommender.getHotelsForLanding($scope.placementId, { imgWidth: $scope.imgWidth }),
                    houseRecommender.getHouseRecs()
                ])
                    .then(function (_a) {
                    var _b = _a[0], hotels = _b.hotels, trackView = _b.trackView, trackClick = _b.trackClick, destinations = _a[1];
                    if (!hotels || !hotels.length) {
                        trackView(0, 0, 0, []);
                        return $scope.hotels = [];
                    }
                    _.assign($scope, {
                        track: houseRecommender.trackHouseClick,
                        hotels: hotels,
                        destinations: destinations,
                        selectHotel: function (hotel) {
                            trackClick(hotel, recommenderUiHelper.getPageSize());
                            $location.path(hotel.Url);
                        }
                    });
                    recommenderUiHelper.bindCarouselEvents($element, hotels, trackView);
                });
            }
        };
    }
    angular
        .module('recommendations')
        .directive('homeRecommender', HomeRecommender);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    function HotelListRecommender($routeParams, basketService, broker, preferences, recommender, recommenderUiHelper, $q, $timeout, tripService) {
        function init($scope, $element) {
            $scope.hotels = [];
            var timeoutToAvoidPageFlicker = $timeout(angular.noop, 500);
            tripService
                .usePackageRates()
                .then(function (usePackageRates) {
                if (usePackageRates) {
                    return $q.reject();
                }
            })
                .then(function () { return tripService.getTrip($routeParams.tripId); })
                .then(function (trip) {
                var isHotel = trip && trip.TripType === Core.Trip.TripType.Hotel;
                var isHotelPage = !!$scope.currentEstab;
                var placementId = recommender.createPlacementId(isHotel, isHotelPage);
                var searchModel = {
                    destination: _.get(trip, 'HotelsRequest.Destination'),
                    startDate: _.get(trip, 'HotelsRequest.CheckInDate'),
                    endDate: _.get(trip, 'HotelsRequest.CheckOutDate'),
                    occupancy: _.get(trip, 'HotelsRequest.Rooms')
                };
                return recommender.continueSearch($scope.currentEstab, searchModel, isHotel, placementId, $routeParams.tripId);
            })
                .then(function (response) { return timeoutToAvoidPageFlicker.then(function () { return response; }); })
                .then(function (_a) {
                var hotels = _a.hotels, trackView = _a.trackView, trackClick = _a.trackClick;
                if (!hotels || !hotels.length) {
                    trackView(0, 0, 0, []);
                    return;
                }
                _.assign($scope, {
                    hotels: hotels,
                    selectHotel: function (hotel) {
                        hotel.loading = true;
                        trackClick(hotel, recommenderUiHelper.getPageSize());
                        tripService
                            .getTrip($routeParams.tripId)
                            .then(function (trip) {
                            return trip.TripType === Core.Trip.TripType.Hotel
                                ? recommenderUiHelper.toNewTrip(hotel)
                                : basketService.selectHotel(trip.TripId, hotel, trip.BasketId);
                        })
                            .then(function () { return hotel.loading = false; });
                    }
                });
                recommenderUiHelper.bindCarouselEvents($element, hotels, trackView);
            });
        }
        return {
            scope: {
                currentEstab: '='
            },
            templateUrl: 'partials/recommendations/hotellistrecommender',
            link: function ($scope, $element) {
                var bouncedInit = _.debounce(function () { return init($scope, $element); }, 2500);
                init($scope, $element);
                broker.subscribe('hotelListRecommender', 'searchCriteriaModified', bouncedInit);
                preferences.get('priceMode').then(function (p) {
                    $scope.priceMode = p;
                    broker.subscribe('hotelListRecommender', 'priceModeChanged', function (_a) {
                        var data = _a.data;
                        return $scope.priceMode = data;
                    });
                });
            }
        };
    }
    angular
        .module('recommendations')
        .directive('hotelListRecommender', HotelListRecommender);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    function HouseRecommender(houseRecommender) {
        return {
            scope: {
                wrapperClass: '@'
            },
            templateUrl: 'partials/recommendations/houserecommender',
            link: function ($scope) {
                houseRecommender
                    .getHouseRecs()
                    .then(function (destinations) { return _.assign($scope, {
                    destinations: destinations,
                    track: houseRecommender.trackHouseClick
                }); });
            }
        };
    }
    angular
        .module('recommendations')
        .directive('houseRecommender', HouseRecommender);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    var RecommendedHotelGroups = /** @class */ (function () {
        function RecommendedHotelGroups($location, tripService, dateUtil, recommenderTracker, $http) {
            var _this = this;
            this.$location = $location;
            this.tripService = tripService;
            this.dateUtil = dateUtil;
            this.recommenderTracker = recommenderTracker;
            // [ Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.IndicativePrice,
            //   Core.FieldType.Distances, Core.FieldType.Url ]
            var FieldFlags = 583;
            $http.post('api/hotels/landingpages/recommendedhotelgroups', {
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                DestinationType: this.destinationType,
                DestinationId: this.destinationId,
                HotelCountPerGroup: 3,
                FieldFlags: FieldFlags,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            }, { ignoreErrors: true })
                .then(function (_a) {
                var data = _a.data;
                _this.tabItems = data;
                _this.isPopulated = !!_.get(_this.tabItems, '[0].Hotels[0]');
                _this.trackRecommendedHotelGroups =
                    recommenderTracker.trackRecommendedHotelGroupsFactory(_this.tabItems);
                if (_this.tabItems.length) {
                    _this.trackRecommendedHotelGroups.trackView(_this.tabItems[0]);
                }
                _.forEach(_this.tabItems, function (tab) {
                    _.forEach(tab.Hotels, function (hotel) {
                        hotel.Title = hotel.ShortTitle || hotel.Title;
                        hotel.__bd4reco = _this.trackRecommendedHotelGroups.__bd4reco(tab, hotel);
                    });
                });
            });
        }
        RecommendedHotelGroups.prototype.getDealUrl = function (hotel) {
            var _this = this;
            var getDate = function (weeksFromNow) {
                return _this.dateUtil.serialiseDate(_this.dateUtil.getNextSaturday(weeksFromNow)).split('T')[0];
            };
            var deal = _.get(hotel, 'Deals[0]');
            if (deal) {
                return '';
            }
            else {
                return hotel.Url + '?' + $.param({
                    startDate: deal ? deal.CheckInDate : getDate(2),
                    endDate: deal ? deal.CheckOutDate : getDate(3),
                    autoSearch: '1',
                    __bd4reco: hotel.__bd4reco,
                });
            }
        };
        RecommendedHotelGroups.prototype.goToDeal = function (tabItem, hotel) {
            var _this = this;
            var deal = _.get(hotel, 'Deals[0]');
            if (deal) {
                this.tripService
                    .getTripIdForDeal(deal, 'recommendedHotelGroups')
                    .then(function (tripId) {
                    _this.$location.path("/hotels/" + tripId + "/" + hotel.Id)
                        .search('__bd4reco', hotel.__bd4reco);
                });
            }
            this.trackRecommendedHotelGroups.trackClick(tabItem, hotel);
        };
        RecommendedHotelGroups.prototype.tabClick = function (tabItem) {
            this.trackRecommendedHotelGroups.trackView(tabItem);
        };
        return RecommendedHotelGroups;
    }());
    angular
        .module('recommendations')
        .directive('recommendedHotelGroups', function () {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                destinationType: '@',
                destinationId: '@',
                destinationTitle: '@',
                isPopulated: '=',
            },
            controller: RecommendedHotelGroups,
            controllerAs: 'rhg',
            templateUrl: 'partials/recommendations/recommendedHotelGroups',
        };
    });
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    function Bd4Helper(bd4t, $q, $http) {
        var getUserId = _.memoize(function () {
            var def = $q.defer();
            bd4t('get', 'config', function (cfg) { return def.resolve(cfg && cfg.userId); });
            return def.promise;
        });
        function getRecommendedDestinations(placementId, context, currentDestination, limit) {
            var bd4 = TRPCONFIG.Domain.BD4TrackingId;
            return getUserId()
                .then(function (userId) { return ({
                userId: userId,
                limit: limit,
                placementId: placementId,
                context: context
            }); })
                .then(function (options) { return $http.post("https://api1.bd4travel.com/recommender/" + bd4 + "/v3/categories/tr" + currentDestination.Type, options, { ignoreErrors: true }); })
                .then(function (response) {
                var elements = _.get(response, 'data.elements');
                var destinations = _.map(elements, Recommendations.Bd4Destination);
                if (destinations && destinations.length) {
                    return destinations;
                }
                else {
                    return $q.reject('no destinations');
                }
            });
        }
        function getRecommendations(placementId, limit, context, destinationsFilter) {
            if (context === void 0) { context = {}; }
            var options = {
                limit: limit,
                placementId: placementId,
                context: context,
            };
            if (destinationsFilter) {
                options.query = {
                    categories: _.map(destinationsFilter, function (d) { return ({ type: 'tr' + d.Type, id: d.Id }); })
                };
            }
            return getUserId()
                .then(function (userId) { return options.userId = userId; })
                .then(function () { return $http.post("https://api1.bd4travel.com/recommender/" + TRPCONFIG.Domain.BD4TrackingId + "/v3", options, { ignoreErrors: true }); })
                .then(function (response) {
                var elements = _.get(response, 'data.elements');
                var estabIds = _.map(elements, function (e) { return e.object.id; });
                if (estabIds && estabIds.length) {
                    return {
                        estabIds: estabIds,
                        ptoken: _(response).get('data.ptoken')
                    };
                }
                else {
                    return $q.reject('no estabIds');
                }
            });
        }
        return {
            getUserId: getUserId,
            getRecommendedDestinations: getRecommendedDestinations,
            getRecommendations: getRecommendations
        };
    }
    angular
        .module('recommendations')
        .service('bd4Helper', Bd4Helper);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    //These two functions are writen by TR/Christina (as opposed to made by DB4).
    //They can be deleted once the DB4 implementation is finished.
    function HouseRecommender($http, broker, imageService) {
        var cachedGet;
        broker.subscribe('houseRecommender', 'hotelSearchCreated', function () { return cachedGet = null; });
        function getHouseRecs() {
            if (!cachedGet) {
                cachedGet = $http.get('website/recommendations/get', { ignoreErrors: true });
            }
            return cachedGet
                .then(_.partialRight(_.get, 'data'))
                .then(function (res) { return _enrichTrRecs(_.get(res, 'Destinations'), _.get(res, 'Type')); });
        }
        function _enrichTrRecs(recs, type) {
            return _(recs)
                .map(function (r) {
                // Map the API response to a DestinationContentCard view model
                return {
                    Id: r.ObjectId,
                    Type: r.ObjectTypeId,
                    Title: r.Title,
                    ImageUrl: imageService.getDestinationImage({ Id: r.ObjectId, Type: r.ObjectTypeId }),
                    HolidayEnabled: r.HolidayEnabled,
                    HotelCount: r.HotelCount,
                    MinFlightPrice: r.MinFlightPrice,
                    MinHotelPrice: r.MinHotelPrice,
                    PagePath: r.PagePath,
                    Searchable: r.Searchable,
                    RecommendationType: type
                };
            })
                .take(8)
                .value();
        }
        function trackHouseClick(d) {
            var params = {
                type: d.RecommendationType,
                destinationId: d.Id,
                destinationType: d.Type
            };
            return $http.get("website/recommendations/track?" + $.param(params), { ignoreErrors: true });
        }
        return {
            getHouseRecs: getHouseRecs,
            trackHouseClick: trackHouseClick
        };
    }
    angular
        .module('recommendations')
        .service('houseRecommender', HouseRecommender);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    function Recommender($q, $http, $window, broker, fieldGroupService, imageService, bd4travel, bd4Helper, destinationService, occupancyService, recommenderTracker) {
        var IMAGE_WIDTH = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
        var IMAGE_HEIGHT = 200;
        var HOTEL_PROPERTIES = 'Country,CustomerRating,CustomerRatingCount,Id,Province,StarRating,Title,Url';
        var HOTEL_FIELDS = [Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.Characteristics,
            Core.FieldType.Destinations, Core.FieldType.Url, Core.FieldType.IndicativePrice];
        //This needs to be versioned whenever the cookie serialization format changes.
        var COOKIE_NAME = 'reco_search_3';
        var DESTINATIONS_MAX = 3;
        var HOTEL_SUGGESTIONS_MAX = 16;
        var DESTINATION_SUGGESTIONS_MAX = 64;
        var cookie = (function () {
            var _cookie;
            return function (values) {
                if (values) {
                    // set _cookie
                    _cookie = values;
                    var expiration = new Date();
                    expiration.setMinutes(expiration.getMinutes() + 10);
                    var destinations = _(values.destinations).map(function (d) { return d.fullyQualifiedId; }).join('_').replace(/:/g, '-');
                    document.cookie =
                        COOKIE_NAME + "=" + values.guid + "|" + destinations + "; expires=" + expiration.toUTCString() + "; path=/";
                }
                if (!_cookie) {
                    // get _cookie
                    var cookieValues = document.cookie.match(COOKIE_NAME + "=(.*?);");
                    if (cookieValues) {
                        var split = cookieValues[1].split('|');
                        var destinations = _.map((split[1] || '').replace(/-/g, ':').split('_'), Recommendations.Bd4Destination);
                        _cookie = {
                            guid: split[0] || '',
                            destinations: destinations
                        };
                    }
                }
                return _cookie || {
                    guid: '',
                    destinations: []
                };
            };
        })();
        broker.subscribe('recommender', 'recommender.startSearch', function (_a) {
            var data = _a.data;
            var toHotelPage = new Recommendations.Bd4Destination(data).Type === 1;
            var placementId = createPlacementId(data.isHotel, toHotelPage);
            startSearch(data.searchModel, data.isHotel, placementId);
        });
        function startSearch(searchModel, isHotel, placementId) {
            var destinations;
            var bd4Destination = new Recommendations.Bd4Destination(searchModel);
            return validate(searchModel, placementId)
                .then(function () {
                if (isHotel) {
                    //This context is used for bd4's tracking:
                    var context = bd4travel.getContextFromSearch(searchModel, isHotel);
                    return bd4Helper.getRecommendedDestinations(placementId, context, bd4Destination, 5);
                }
                else {
                    return [bd4Destination];
                }
            })
                .then(function (x) {
                if (x.length > 1) {
                    destinations = x.filter(function (x) { return x.fullyQualifiedId !== bd4Destination.fullyQualifiedId; });
                }
                else {
                    destinations = x;
                }
            })
                .then(function () { return $http.post('/api/hotels/availability/searchbymultipledestinations', {
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                Destinations: destinations,
                DomainId: TRPCONFIG.Domain.DomainId,
                CheckInDate: _.get(searchModel, 'startDate'),
                CheckOutDate: _.get(searchModel, 'endDate'),
                Rooms: _.get(searchModel, 'occupancy'),
                IsFlightPlus: !isHotel
            }, { ignoreErrors: true }); })
                .then(function (res) {
                cookie({ guid: res.data, destinations: destinations });
            });
        }
        function continueSearch(currentEstab, searchModel, isHotel, placementId, tripId) {
            var cookieValues, token;
            var promise = validate(searchModel, placementId)
                .then(function () { return cookie().guid || startSearch(searchModel, isHotel, placementId); })
                .then(function () { return cookieValues = cookie(); })
                .then(function () { return bd4travel.getContextFromSearch(searchModel, isHotel); })
                .then(function (context) { return bd4Helper.getRecommendations(placementId, HOTEL_SUGGESTIONS_MAX, context, cookieValues.destinations); })
                .then(function (_a) {
                var estabIds = _a.estabIds, ptoken = _a.ptoken;
                token = ptoken;
                return $http.post("/api/hotels/availability/gethotelsbyid?fields=" + HOTEL_PROPERTIES + ",MinCost&testing=1", {
                    AvailabilitySearchId: cookieValues.guid,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                    EstabIds: estabIds,
                    TripId: tripId,
                    FieldFlags: fieldGroupService.getFieldGroup.apply(fieldGroupService, HOTEL_FIELDS.concat([Core.FieldType.Pricing]))
                }, { ignoreErrors: true });
            })
                .then(_.partialRight(_.get, 'data'))
                .then(_.partialRight(_.filter, function (h) { return h.Id !== currentEstab; }))
                .then(_.partialRight(_.take, 8))
                .then(addHotelDetails)
                .then(function (hotels) { return ({ hotels: hotels, placementId: placementId, token: token }); });
            return recommenderTracker.appendHotelTracking(promise);
        }
        function getHotelsForLanding(placementId, options) {
            if (options === void 0) { options = {}; }
            var token;
            var promise = bd4Helper.getRecommendations(placementId, HOTEL_SUGGESTIONS_MAX)
                .then(function (_a) {
                var estabIds = _a.estabIds, ptoken = _a.ptoken;
                token = ptoken;
                if (_.isUndefined(estabIds) || _.isEmpty(estabIds)) {
                    return $q.resolve([]);
                }
                return $http.post("/api/hotels/static/gethotelsbyid?fields=" + HOTEL_PROPERTIES + ",IndicativeMinPrice&testing=1", {
                    Ids: estabIds,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                    DomainId: TRPCONFIG.Domain.DomainId,
                    FieldFlags: fieldGroupService.getFieldGroup.apply(fieldGroupService, HOTEL_FIELDS)
                }, { ignoreErrors: true });
            })
                .then(_.partialRight(_.get, 'data'))
                .then(_.partialRight(_.filter, function (h) { return h.IndicativeMinPrice > 0; }))
                .then(_.partialRight(_.take, 8))
                .then(_.partialRight(addHotelDetails, options))
                .then(function (hotels) { return ({ hotels: hotels, placementId: placementId, token: token }); });
            return recommenderTracker.appendHotelTracking(promise);
        }
        function addDestinationDetails(destinations, options) {
            return destinations.map(function (destination) { return (__assign({}, (_.omit(destination, 'Title')), { Title: destination.Province, ImageUrl: destinationService.destinationThumb(destination) })); });
        }
        function getDestinationsForLanding(placementId, landingOptions, destination) {
            if (landingOptions === void 0) { landingOptions = {}; }
            var token;
            var promise = bd4Helper.getRecommendations(placementId, DESTINATION_SUGGESTIONS_MAX)
                .then(function (_a) {
                var estabIds = _a.estabIds, ptoken = _a.ptoken;
                token = ptoken;
                if (_.isUndefined(estabIds) || _.isEmpty(estabIds)) {
                    return $q.resolve([]);
                }
                return $http.post("/api/hotels/static/gethotelsbyid?fields=" + HOTEL_PROPERTIES + ",ProvinceId&testing=1", {
                    Ids: estabIds,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                    DomainId: TRPCONFIG.Domain.DomainId,
                    FieldFlags: fieldGroupService.getFieldGroup.apply(fieldGroupService, HOTEL_FIELDS)
                }, { ignoreErrors: true });
            })
                .then(_.partialRight(_.get, 'data'))
                .then(_.partialRight(_.uniqBy, 'ProvinceId'))
                .then(_.partialRight(_.take, DESTINATIONS_MAX))
                .then(_.partialRight(addDestinationDetails, landingOptions))
                .then(function (destinations) { return ({ destinations: destinations, placementId: placementId, token: token }); });
            return recommenderTracker.appendDestinationTracking(promise);
        }
        function createPlacementId(isHotel, toHotelPage) {
            return (isHotel ? 'HOTELS' : 'HOLIDAYS') + "_" + (toHotelPage ? 'SELECT_ROOM' : 'HOTELS_LIST');
        }
        function validate(searchModel, placementId) {
            var isPlacementIdEnabled = _.includes(TRPCONFIG.Domain.BD4TRecommenders, placementId);
            var destination = searchModel &&
                searchModel.destination &&
                (searchModel.destination[0] || searchModel.destination);
            var isValid = searchModel && placementId && isPlacementIdEnabled &&
                !_.isEmpty(destination) && searchModel.startDate;
            return isValid ? $q.when() : $q.reject();
        }
        function addHotelDetails(hotels, options) {
            if (options === void 0) { options = {}; }
            return _.map(hotels, function (h, idx) {
                h.ImageUrl = imageService.getMainImageUrl(h.Id, options.imgWidth || IMAGE_WIDTH, IMAGE_HEIGHT);
                h.Position = idx;
                var minCost = h.MinCost || h.IndicativeMinPrice;
                if (minCost) {
                    var people = occupancyService.getNumberOfNonInfantPassengers();
                    h.PricePerPerson = minCost / people;
                    h.TotalPrice = minCost;
                }
                return h;
            });
        }
        return {
            startSearch: startSearch,
            continueSearch: continueSearch,
            createPlacementId: createPlacementId,
            getHotelsForLanding: getHotelsForLanding,
            getDestinationsForLanding: getDestinationsForLanding
        };
    }
    angular
        .module('recommendations')
        .service('recommender', Recommender);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    function RecommenderTracker(searchUnitService, bd4t, $q, analytics) {
        function appendHotelTracking(promise) {
            return promise
                .then(function (_a) {
                var hotels = _a.hotels, placementId = _a.placementId, token = _a.token;
                return ({
                    hotels: hotels,
                    trackView: trackView(placementId, hotels, token),
                    trackClick: trackClick(placementId, token)
                });
            })
                .catch(function () { return $q.resolve({
                hotels: [],
                trackView: angular.noop,
                trackClick: angular.noop
            }); });
        }
        function appendDestinationTracking(promise) {
            return promise
                .then(function (_a) {
                var destinations = _a.destinations, placementId = _a.placementId, token = _a.token;
                return ({
                    destinations: destinations,
                    trackView: trackView(placementId, destinations, token),
                    trackClick: trackClick(placementId, token)
                });
            })
                .catch(function () { return $q.resolve({
                destinations: [],
                trackView: angular.noop,
                trackClick: angular.noop
            }); });
        }
        function trackView(placementId, hotels, ptoken) {
            if (!_.isUndefined(hotels) && !_.isEmpty(hotels)) {
                analytics.track('mixpanel', 'RecommenderLoaded', {
                    placement: placementId,
                    estabIds: _.map(hotels, function (h) { return h.Id; }),
                    prices: _.map(hotels, function (h) { return h.IndicativeMinPrice; }),
                    ShortTitleLookedFor: _.get(searchUnitService.getDestination(), 'Title')
                });
            }
            return function (listOffset, listPreviousOffset, pageSize, elements) {
                bd4t('send', 'recoview', {
                    listId: placementId,
                    ptoken: ptoken,
                    listOffset: listOffset,
                    listPreviousOffset: listPreviousOffset,
                    pageSize: pageSize,
                    total: _.size(hotels),
                    elements: _.map(elements, function (e) { return ({ id: e.Id.toString(), prices: { default: e.PricePerPerson, total: e.TotalPrice } }); })
                });
            };
        }
        function trackClick(placement, ptoken) {
            return function (hotel, pageSize) {
                bd4t('send', 'engagement', {
                    listId: placement,
                    ptoken: ptoken,
                    listPosition: hotel.Position % pageSize,
                    listOffset: pageSize * Math.round(hotel.Position / pageSize),
                    medium: 'recommender-card',
                    type: 'reco:selection',
                    element: { id: hotel.Id, prices: { default: hotel.PricePerPerson, total: hotel.TotalPrice } }
                });
                analytics.track('mixpanel', 'RecommenderClicked', {
                    placement: placement,
                    position: hotel.Position,
                    estabId: hotel.Id,
                    price: hotel.IndicativeMinPrice,
                    ShortTitleLookedFor: _.get(searchUnitService.getDestination(), 'Title'),
                    ShortTitleClicked: hotel.Province + ", " + hotel.Country
                });
            };
        }
        function trackRecommendedHotelGroupsFactory(allTabItems) {
            var listId = 'recommended_hotel_groups';
            var groups = _.map(allTabItems, function (tab) {
                return tab.GroupId = tab.Title.toLowerCase().replace(/\s+/g, '-');
            });
            var previousGroupId;
            function mapHotelToBd4Format(hotel) {
                return { id: hotel.Id, prices: { 'hotel.pp': hotel.IndicativeMinPrice, }, };
            }
            ;
            return {
                trackView: function (tab) {
                    bd4t('send', 'recoview', {
                        listId: listId,
                        ptoken: tab.RankingScoresToken,
                        listOffset: 0,
                        listPreviousOffset: 0,
                        pageSize: tab.Hotels.length,
                        total: tab.Hotels.length,
                        elements: _.map(tab.Hotels, mapHotelToBd4Format),
                        groupId: tab.GroupId,
                        title: tab.Title,
                        groups: groups,
                        previousGroupId: previousGroupId,
                    });
                    previousGroupId = tab.GroupId;
                },
                trackClick: function (tab, hotel) {
                    bd4t('send', 'engagement', {
                        type: 'reco:selection',
                        listId: listId,
                        ptoken: tab.RankingScoresToken,
                        listPosition: hotel.HotelIndex - 1,
                        listOffset: 0,
                        element: mapHotelToBd4Format(hotel),
                        groupId: tab.GroupId,
                        title: tab.Title,
                        groups: groups,
                    });
                },
                __bd4reco: function (tab, hotel) {
                    var experimentBucket = '';
                    var absolutePosition = hotel.HotelIndex - 1;
                    return listId + "|" + experimentBucket + "|" + absolutePosition + "|" + tab.ptoken;
                },
            };
        }
        return {
            appendHotelTracking: appendHotelTracking,
            appendDestinationTracking: appendDestinationTracking,
            trackRecommendedHotelGroupsFactory: trackRecommendedHotelGroupsFactory,
        };
    }
    angular
        .module('recommendations')
        .service('recommenderTracker', RecommenderTracker);
})(Recommendations || (Recommendations = {}));
var Recommendations;
(function (Recommendations) {
    var RecommenderUiHelper = /** @class */ (function () {
        function RecommenderUiHelper(guidService, basketService, hotelSearch, searchUnitService, rootPath) {
            this.guidService = guidService;
            this.basketService = basketService;
            this.hotelSearch = hotelSearch;
            this.searchUnitService = searchUnitService;
            this.rootPath = rootPath;
        }
        RecommenderUiHelper.prototype.getPageSize = function (windowWidth) {
            if (windowWidth === void 0) { windowWidth = window.innerWidth; }
            return windowWidth < 1100 ? 3 : 4;
        };
        RecommenderUiHelper.prototype.toNewTrip = function (hotel) {
            var _this = this;
            var newTab = window.open('recommendations/loading');
            var tripId = this.guidService.uuid();
            return this.basketService
                .createTrip(tripId, Core.Trip.TripType.Hotel)
                .then(function (_a) {
                var TripId = _a.TripId;
                _this.hotelSearch.buildHotelsRequest({
                    Destination: { Type: 1, Id: hotel.Id },
                    IsFlightPlus: false,
                    TripId: TripId
                }, _this.searchUnitService.hotel);
                return _this.hotelSearch.createSearch();
            })
                .then(function () {
                if (newTab && newTab.location) {
                    newTab.location.href = _this.rootPath.getRootPath() +
                        _this.basketService.getHotelUrl({ tripId: tripId, hotel: hotel });
                }
            });
        };
        RecommenderUiHelper.prototype.bindCarouselEvents = function ($carousel, hotels, trackView) {
            var _this = this;
            var listOffset = 0;
            $carousel.off('init');
            $carousel.off('breakpoint');
            $carousel.off('afterChange');
            $carousel.on('init', function () {
                var pageSize = _this.getPageSize();
                var items = _.slice(hotels, 0, pageSize);
                trackView(0, 0, pageSize, items);
            });
            // This breakpoint is triggered when resizing the screen beyond a responsive CSS Breakpoint:
            $carousel.on('breakpoint afterChange', function (event, slick) {
                var pageSize = _this.getPageSize();
                var currentSlide = getCurrentSlide(slick, pageSize);
                var items = _.slice(hotels, currentSlide, currentSlide + pageSize);
                listOffset = currentSlide;
            });
            function getCurrentSlide(slick, pageSize) {
                //Fix bug where current slide does not take into account
                //that there might not be the full number of items.
                var maxCurrentSlide = _.max([hotels.length - pageSize, 0]);
                return _.min([slick.currentSlide, maxCurrentSlide]);
            }
        };
        return RecommenderUiHelper;
    }());
    Recommendations.RecommenderUiHelper = RecommenderUiHelper;
    angular
        .module('recommendations')
        .service('recommenderUiHelper', RecommenderUiHelper);
})(Recommendations || (Recommendations = {}));
var Reviews;
(function (Reviews) {
    var ReviewStatus;
    (function (ReviewStatus) {
        ReviewStatus[ReviewStatus["CannotLeaveReview"] = 0] = "CannotLeaveReview";
        ReviewStatus[ReviewStatus["CanLeaveReview"] = 1] = "CanLeaveReview";
        ReviewStatus[ReviewStatus["HasLeftReview"] = 2] = "HasLeftReview";
    })(ReviewStatus = Reviews.ReviewStatus || (Reviews.ReviewStatus = {}));
    var TagType;
    (function (TagType) {
        TagType[TagType["Hotel"] = 1] = "Hotel";
        TagType[TagType["Location"] = 2] = "Location";
    })(TagType = Reviews.TagType || (Reviews.TagType = {}));
    var RatingType;
    (function (RatingType) {
        RatingType[RatingType["Hotel"] = 1] = "Hotel";
        RatingType[RatingType["Location"] = 2] = "Location";
        RatingType[RatingType["Service"] = 3] = "Service";
    })(RatingType = Reviews.RatingType || (Reviews.RatingType = {}));
    var TravellerType;
    (function (TravellerType) {
        TravellerType[TravellerType["Solo"] = 1] = "Solo";
        TravellerType[TravellerType["Couple"] = 2] = "Couple";
        TravellerType[TravellerType["Family"] = 3] = "Family";
        TravellerType[TravellerType["Friends"] = 4] = "Friends";
        TravellerType[TravellerType["Business"] = 5] = "Business";
    })(TravellerType = Reviews.TravellerType || (Reviews.TravellerType = {}));
    /*
    * Classes and Interfaces used by controllers, directives
     */
    var TagLists = /** @class */ (function () {
        function TagLists() {
            this.hotel = [];
            this.location = [];
        }
        return TagLists;
    }());
    Reviews.TagLists = TagLists;
    var ReviewData = /** @class */ (function () {
        function ReviewData() {
            var _this = this;
            this.dateReviewed = function () {
                return new Date().toISOString().slice(0, 10);
            };
            this.overallRating = function () {
                var _a = _this.ratings, location = _a.location, room = _a.room, service = _a.service;
                return Math.floor((location + room + service) / 3);
            };
            this.getRatingData = function () {
                return {
                    OverallRating: _this.overallRating(),
                    Location: _this.ratings.location,
                    Room: _this.ratings.room,
                    Service: _this.ratings.service
                };
            };
            this.anonymous = false;
            this.ratings = { location: 0, room: 0, service: 0 };
            this.tags = { hotel: [], location: [] };
            this.travellerType = this.title = this.text = '';
        }
        return ReviewData;
    }());
    Reviews.ReviewData = ReviewData;
    var ContactDetails = /** @class */ (function () {
        function ContactDetails() {
            this.county = this.firstname = this.lastname = this.title = '';
        }
        return ContactDetails;
    }());
    Reviews.ContactDetails = ContactDetails;
    var HotelInformation = /** @class */ (function () {
        function HotelInformation() {
            this.address = this.imageUrl = this.location = this.title = '';
            this.id = this.starRating = 0;
        }
        return HotelInformation;
    }());
    Reviews.HotelInformation = HotelInformation;
    var ReviewDetails = /** @class */ (function () {
        function ReviewDetails() {
            this.contactDetails = new ContactDetails();
            this.checkedInDate = '';
            this.hotelDetails = new HotelInformation();
        }
        return ReviewDetails;
    }());
    Reviews.ReviewDetails = ReviewDetails;
})(Reviews || (Reviews = {}));
var Reviews;
(function (Reviews) {
    var ReviewHotel = /** @class */ (function () {
        function ReviewHotel($location, $q, $routeParams, $window, analytics, dashboardService, reviewPreviewStoreService, reviewsService) {
            var _this = this;
            this.$location = $location;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$window = $window;
            this.analytics = analytics;
            this.dashboardService = dashboardService;
            this.reviewPreviewStoreService = reviewPreviewStoreService;
            this.reviewsService = reviewsService;
            this.canLeaveReview = false;
            this.loading = true;
            this.previewDisplay = false;
            this.reviewAlreadyLeft = false;
            this.userInput = new Reviews.ReviewData();
            //there should only be two possible ways of getting here:
            //1. we are signed in and have selected to leave a review for a previous stay
            //2. we have received an email link
            this.bookingId = $routeParams.bookingId;
            if ($routeParams.bookingId && $routeParams.userId && $routeParams.token) {
                //2. we need to have a booking id, user id and token from the email
                this.userId = $routeParams.userId;
                this.token = $routeParams.token;
                this.reviewsService.getReviewDetailsUsingToken(this.bookingId, this.token, this.userId)
                    .then(function (d) { return _this.setReviewDetails(d); })
                    .finally(function () { return _this.loading = false; });
            }
            else {
                //1. already signed in
                this.reviewsService.getReviewDetails(this.bookingId)
                    .then(function (d) { return _this.setReviewDetails(d); })
                    .finally(function () { return _this.loading = false; });
            }
        }
        ReviewHotel.prototype.setReviewDetails = function (reviewDetails) {
            var _this = this;
            //do some checks to make sure the review hasn't already been submitted / they can leave a review
            var status = reviewDetails.reviewStatus;
            if (status === Reviews.ReviewStatus.CanLeaveReview) {
                return this.reviewsService.getPredefinedTags().then(function (tagLists) {
                    _this.tagLists = tagLists;
                    _this.reviewDetails = reviewDetails;
                    _this.canLeaveReview = true;
                    //if we are on mobile we may have returned to this page after previewing the review
                    //so check if we have data and use that
                    var savedData = _this.reviewPreviewStoreService.getUserInput();
                    if (savedData) {
                        _this.userInput = savedData;
                    }
                    return;
                });
            }
            else if (status === Reviews.ReviewStatus.HasLeftReview) {
                this.reviewAlreadyLeft = true;
            }
            return this.$q.when();
        };
        ReviewHotel.prototype.trackEvent = function (name, data) {
            this.analytics.track('mixpanel', name, data);
        };
        /**
         * NOTE: we need slightly different functionality for mobile and desktop when displaying the preview
         * and submitting the review. So have created methods named as such to avoid ambiguity
        **/
        //DESKTOP only methods
        ReviewHotel.prototype.desktopPreviewClose = function () {
            this.previewDisplay = false;
        };
        ReviewHotel.prototype.desktopPreviewReview = function (form) {
            if (!form.$valid) {
                return;
            }
            this.previewDisplay = true;
        };
        ReviewHotel.prototype.desktopSubmitReview = function () {
            var _this = this;
            this.reviewsService.submitReview(this.userInput, this.bookingId, this.token).then(function () {
                //not keen on this event name, but to keep reporting comparable we have used it
                _this.analytics.track('mixpanel', 'MYB - Review submitted', _this.userInput.getRatingData());
                _this.$location.path("/review-hotel/submitted/" + _this.reviewDetails.hotelDetails.id);
            });
        };
        //MOBILE only methods
        ReviewHotel.prototype.mobilePreviewReview = function (form) {
            if (!form.$valid) {
                return;
            }
            this.reviewPreviewStoreService.storeReviewInfo(this.reviewDetails, this.userInput);
            this.$location.path("/review-hotel/preview/" + this.bookingId + "/" + this.userId + "/" + this.token);
        };
        return ReviewHotel;
    }());
    angular
        .module('reviews')
        .controller('ReviewHotel', ReviewHotel);
})(Reviews || (Reviews = {}));
var Reviews;
(function (Reviews) {
    var ReviewPreview = /** @class */ (function () {
        function ReviewPreview($location, $routeParams, analytics, reviewPreviewStoreService, reviewsService) {
            this.$location = $location;
            this.$routeParams = $routeParams;
            this.analytics = analytics;
            this.reviewPreviewStoreService = reviewPreviewStoreService;
            this.reviewsService = reviewsService;
            this.bookingId = $routeParams.bookingId;
            this.token = $routeParams.token;
            this.userId = $routeParams.userId;
            this.reviewDetails = reviewPreviewStoreService.getReviewDetails();
            this.userInput = reviewPreviewStoreService.getUserInput();
            if (!this.reviewDetails) {
                this.gotoReviewPage();
            }
        }
        ReviewPreview.prototype.makeChange = function () {
            this.gotoReviewPage();
        };
        ReviewPreview.prototype.submitReview = function () {
            var _this = this;
            this.reviewsService.submitReview(this.userInput, this.bookingId, this.token).then(function () {
                //not keen on this event name, but to keep reporting comparable we have used it
                _this.analytics.track('mixpanel', 'MYB - Review submitted', _this.userInput.getRatingData());
                _this.$location.path("/review-hotel/submitted/" + _this.reviewDetails.hotelDetails.id);
            });
        };
        ReviewPreview.prototype.gotoReviewPage = function () {
            this.$location.path("/review-hotel/" + this.bookingId + "/" + this.userId + "/" + this.token);
        };
        return ReviewPreview;
    }());
    angular
        .module('reviews')
        .controller('ReviewPreview', ReviewPreview);
})(Reviews || (Reviews = {}));
var Reviews;
(function (Reviews) {
    var ReviewSubmitted = /** @class */ (function () {
        function ReviewSubmitted($q, $routeParams, reviewService, reviewsService) {
            var _this = this;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.reviewService = reviewService;
            this.reviewsService = reviewsService;
            //there should be a hotel id as part of the route params
            var hotelId = $routeParams.hotelId;
            $q.all([
                this.reviewsService.getHotelInformation(hotelId),
                this.reviewService.getReviews({ Id: hotelId }, 0)
            ]).then(function (results) {
                _this.hotelDetails = results[0];
                _this.reviews = results[1].reviews;
            });
        }
        return ReviewSubmitted;
    }());
    angular
        .module('reviews')
        .controller('ReviewSubmitted', ReviewSubmitted);
})(Reviews || (Reviews = {}));
var Reviews;
(function (Reviews) {
    /**
     * Service used on the mobile site to help me maintain state (i know) between the review entry and preview pages
     */
    var ReviewPreviewStoreService = /** @class */ (function () {
        function ReviewPreviewStoreService() {
            var _this = this;
            //Save the review locally
            this.storeReviewInfo = function (review, userInput) {
                _this.review = review;
                _this.userInput = userInput;
            };
            //Get the stored review if any
            this.getReviewDetails = function () {
                return _this.review;
            };
            this.getUserInput = function () {
                return _this.userInput;
            };
        }
        ;
        return ReviewPreviewStoreService;
    }());
    Reviews.ReviewPreviewStoreService = ReviewPreviewStoreService;
    angular.module('reviews').service('reviewPreviewStoreService', ReviewPreviewStoreService);
})(Reviews || (Reviews = {}));
var Reviews;
(function (Reviews) {
    var ReviewsService = /** @class */ (function () {
        function ReviewsService($http, $q, fieldGroupService, imageService) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.fieldGroupService = fieldGroupService;
            this.imageService = imageService;
            this.getPredefinedTags = function () {
                //do api stuff
                var lists = new Reviews.TagLists();
                lists.hotel = ['Free Wifi', 'Comfy beds', 'Infinity pool', 'Clean', 'Good value', 'Wonderful staff',
                    'Good Food', 'Close to beach'];
                lists.location = ['Bars & Pubs', 'Sight-seeing', 'Walking', 'Beautiful scenery', 'Romance',
                    'Outdoor Activities'];
                return _this.$q.when(lists);
            };
            this.getHotelInformation = function (hotelId) {
                return _this.getHotelDetails(hotelId).then(function (hotel) {
                    var hi = new Reviews.HotelInformation();
                    hi.address = hotel.Address;
                    hi.id = hotel.Id;
                    hi.imageUrl = _this.imageService.getMainImageUrl(hotel.Id, _this.imageDim, _this.imageDim);
                    hi.location = hotel.Location;
                    hi.starRating = hotel.StarRating;
                    hi.title = hotel.Title;
                    return hi;
                });
            };
            this.getReviewDetailsUsingToken = function (bookingId, token, userId) {
                return _this.$http.post(_this.url + "user/reviewdetailstoken", {
                    BookingId: bookingId,
                    VerificationToken: token,
                    UserId: userId,
                    CultureCode: _this.domain.CultureCode
                }).then(function (res) { return _this.convertReviewDetailsSuccess(res.data); }, function (err) { return _this.processReviewDetailsError(err.status); });
            };
            this.getReviewDetails = function (bookingId) {
                return _this.$http.post(_this.url + "user/reviewdetails", { BookingId: bookingId, CultureCode: _this.domain.CultureCode }).then(function (res) { return _this.convertReviewDetailsSuccess(res.data); }, function (err) { return _this.processReviewDetailsError(err.status); });
            };
            this.submitReview = function (data, bookingId, token) {
                return _this.$http.post("" + _this.submitUrl, { Token: token, Review: _this.convertUserDataToApiReview(data, bookingId) });
            };
            ///Get basic details about a hotel given it's id
            this.getHotelDetails = function (hotelId) {
                return _this.$http.post('/api/hotels/static/gethotelsbyid', {
                    Ids: [hotelId],
                    CultureCode: _this.domain.CultureCode,
                    DomainId: _this.domain.DomainId,
                    FieldFlags: _this.fieldGroupService.getFieldGroup(Core.FieldType.Global, Core.FieldType.Titles)
                }, { ignoreErrors: true }).then(function (result) {
                    return result.data[0];
                });
            };
            this.convertReviewDetailsSuccess = function (reviewDetails) {
                var hotelInfo = new Reviews.HotelInformation();
                hotelInfo.address = reviewDetails.Hotel.Address;
                hotelInfo.id = reviewDetails.Hotel.EstabId;
                hotelInfo.imageUrl =
                    _this.imageService.getMainImageUrl(reviewDetails.Hotel.EstabId, _this.imageDim, _this.imageDim);
                hotelInfo.location = _.find(reviewDetails.Hotel.Destinations, function (d) { return d.Type === 2; }).Title;
                hotelInfo.starRating = reviewDetails.Hotel.StarRating;
                hotelInfo.title = reviewDetails.Hotel.Title;
                var details = new Reviews.ReviewDetails();
                details.checkedInDate = reviewDetails.CheckInDate;
                details.hotelDetails = hotelInfo;
                details.contactDetails = {
                    county: reviewDetails.LeadContact.County,
                    firstname: reviewDetails.LeadContact.FirstName,
                    lastname: reviewDetails.LeadContact.LastName,
                    title: reviewDetails.LeadContact.Title
                };
                details.reviewStatus = reviewDetails.ReviewStatus;
                return details;
            };
            this.processReviewDetailsError = function (errCode) {
                //we can have a number of different states but just return the correct enum value
                var details = new Reviews.ReviewDetails();
                details.reviewStatus = Reviews.ReviewStatus.CannotLeaveReview;
                if (errCode === 401) {
                    details.reviewStatus = Reviews.ReviewStatus.CannotLeaveReview;
                }
                return details;
            };
            this.convertUserDataToApiReview = function (data, bookingId) {
                var ratings = [
                    { Type: Reviews.RatingType.Location, Score: data.ratings.location },
                    { Type: Reviews.RatingType.Hotel, Score: data.ratings.room },
                    { Type: Reviews.RatingType.Service, Score: data.ratings.service },
                ];
                var hotelTags = _.map(data.tags.hotel, function (t) { return { Type: Reviews.TagType.Hotel, Title: t }; });
                var locationTags = _.map(data.tags.location, function (t) { return { Type: Reviews.TagType.Location, Title: t }; });
                return {
                    Anonymous: data.anonymous,
                    BookingId: bookingId,
                    Title: data.title,
                    Comments: data.text,
                    TravellerType: Reviews.TravellerType[data.travellerType],
                    Ratings: ratings,
                    Tags: hotelTags.concat(locationTags)
                };
            };
            this.domain = TRPCONFIG.Domain;
            this.imageDim = TRPCONFIG.DeviceSettings.LandingImageHeight;
            this.submitUrl = '/api/bookings/reviews';
            this.url = '/api2/users/reviews/';
        }
        return ReviewsService;
    }());
    Reviews.ReviewsService = ReviewsService;
    angular.module('reviews').service('reviewsService', ReviewsService);
})(Reviews || (Reviews = {}));
var Core;
(function (Core) {
    var ScAccordion = /** @class */ (function () {
        function ScAccordion($scope) {
            this.$scope = $scope;
            this.tabs = [];
        }
        ScAccordion.prototype.init = function (element) {
            this.element = element;
        };
        ScAccordion.prototype.addTab = function (tab) {
            this.tabs.push(tab);
        };
        ScAccordion.prototype.selectTab = function (tab) {
            if (this.activeTab) {
                this.activeTab.isActive = false;
                if (tab === this.activeTab) {
                    this.activeTab = null;
                    return;
                }
            }
            tab.isActive = true;
            this.activeTab = tab;
        };
        return ScAccordion;
    }());
    var ScAccordionTab = /** @class */ (function () {
        function ScAccordionTab($scope, animationUtil) {
            var _this = this;
            this.$scope = $scope;
            this.animationUtil = animationUtil;
            this.isActive = false;
            this.open = false;
            this.events = {
                'click': function () {
                    _this.parentAccordion.selectTab(_this);
                }
            };
        }
        ScAccordionTab.prototype.init = function (element, panelElement, accordion) {
            var _this = this;
            this.element = element;
            this.panelElement = panelElement;
            this.wrapperElement = panelElement.children().first();
            this.parentAccordion = accordion;
            // Add tab to the accordion
            this.parentAccordion.addTab(this);
            if (this.tabId === undefined) {
                throw 'tabId not specified for ScAccordionTab';
            }
            this.tabButtonId = "accordion-tab-" + this.tabId;
            this.tabPanelId = "accordion-tabpanel-" + this.tabId;
            this.panelElement.css({ height: "0px" });
            // watch `active` state
            this.$scope.$watch('tab.isActive', function (val) {
                if (!_.isUndefined(val)) {
                    val ? _this.handleOpen() : _this.handleClose();
                }
            });
        };
        ScAccordionTab.prototype.handleOpen = function () {
            var _this = this;
            if (this.open) {
                return;
            }
            // animate the panel IN
            this.open = true;
            this.panelElement.css({ height: this.wrapperElement[0].clientHeight + "px" });
            this.animationUtil.waitForTransition(this.element).then(function (el) {
                _this.panelElement.css({ height: 'auto' });
            });
        };
        ScAccordionTab.prototype.handleClose = function () {
            var _this = this;
            if (!this.open) {
                return;
            }
            // animate the panel OUT
            this.open = false;
            this.panelElement.css({ height: this.wrapperElement[0].clientHeight + "px" });
            setTimeout(function () {
                _this.panelElement.css({ height: "0px" });
            });
        };
        return ScAccordionTab;
    }());
    angular
        .module('core')
        .directive('scAccordion', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScAccordion,
            controllerAs: 'accordion',
            bindToController: {
                title: '@'
            },
            template: "<ul class=\"sc-c-option-list\"\n                            role=\"tablist\"\n                            id=\"{{accordion.title.toLowerCase().replace(' ', '-')}}\"\n                            ng-attr-aria-label=\"{{accordion.title || undefined}}\"\n                            ng-transclude>\n                     </ul>",
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    })
        .directive('scAccordionTab', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scAccordion',
            replace: true,
            transclude: true,
            controller: ScAccordionTab,
            controllerAs: 'tab',
            bindToController: {
                heading: '@',
                tabId: '@'
            },
            template: "<span>\n                        <div\n                            role=\"tab\"\n                            class=\"sc-c-option\"\n                            ng-click=\"tab.events.click($event)\"\n                            id=\"{{tab.tabButtonId}}\"\n                            aria-selected=\"{{tab.isActive}}\"\n                            aria-controls=\"{{tab.tabPanelId}}\"\n                            ng-attr-tabindex=\"{{tab.isActive ? undefined : '-1'}}\"\n                        >\n                            <div class=\"sc-c-option__primary-content\">\n                                <span class=\"star-rating sc-u-color-primary sc-u-bold\">\n                                    {{tab.heading}}\n                                </span>\n                            </div>\n                            <sc-svg-inline\n                                ng-if=\"!tab.isActive\"\n                                name=\"chevron-down\"\n                                class=\"sc-o-svg-icon sc-o-svg-icon--xs sc-c-option__action-icon\"\n                            />\n                            <sc-svg-inline\n                                ng-if=\"tab.isActive\"\n                                name=\"chevron-up\"\n                                class=\"sc-o-svg-icon sc-o-svg-icon--xs sc-c-option__action-icon\"\n                            />\n                        </div>\n                        <div\n                            role=\"tabpanel\"\n                            id=\"{{tab.tabPanelId}}\"\n                            ng-style=\"{\n                                minHeight: '0px',\n                                overflow: 'hidden',\n                                transition: 'height 300ms linear',\n                            }\"\n                        >\n                            <div ng-style=\"{display: 'flex'}\" class=\"sc-u-padding-x-m\" ng-transclude />\n                        </div>\n                    </span>\n                    ",
            link: function (scope, el, attr, accordionCtrl) {
                scope.tab.init(el, el.find('[role=tabpanel]'), accordionCtrl);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var AccountNav = /** @class */ (function () {
        function AccountNav($rootScope, $scope, authService, dashboardNotificationService) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.authService = authService;
            this.dashboardNotificationService = dashboardNotificationService;
            this.notifications = [];
            this.settingsOpen = false;
            $scope.$on('auth:signin', function () {
                _this.refreshUser();
                _this.parentSidebar.shut();
            });
            $scope.$on('auth:signout', function () {
                _this.refreshUser();
                _this.parentSidebar.shut();
            });
        }
        AccountNav.prototype.refreshUser = function () {
            var _this = this;
            this.user = this.authService.getUser();
            // get user name
            this.userName = this.user.SignedIn ? this.user.FirstName : undefined;
            // get booking Id
            this.bookingId = this.user.AnonSignedIn
                ? this.user.Contact.SiteId + "/" + this.authService.getSignedInBookingId()
                : undefined;
            // get notifications
            if (this.user.AnonSignedIn || this.user.HardSignedIn) {
                this.dashboardNotificationService.getNotifications()
                    .then(function (notifications) {
                    _this.notifications = notifications;
                    _this.$rootScope.alerts = notifications;
                });
            }
            else {
                this.notifications = [];
                this.$rootScope.alerts = null;
            }
        };
        AccountNav.prototype.init = function (element, sidebar) {
            var _this = this;
            this.element = element;
            this.parentSidebar = sidebar;
            this.refreshUser();
            this.$scope.$watch('an.parentSidebar.isOpen', function (val) {
                // sidebar was opened - make sure user is up to date
                val && _this.refreshUser();
            });
        };
        AccountNav.prototype.signOut = function () {
            this.authService.signOut();
        };
        AccountNav.prototype.close = function () {
            this.parentSidebar.toggle();
        };
        AccountNav.prototype.openSettingsDialog = function () {
            this.settingsOpen = true;
            this.close();
        };
        AccountNav.prototype.closeSettingsDialog = function () {
            this.settingsOpen = false;
        };
        return AccountNav;
    }());
    angular
        .module('core')
        .directive('accountNav', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scSidebar',
            replace: true,
            transclude: true,
            controller: AccountNav,
            controllerAs: 'an',
            bindToController: {},
            templateUrl: "partials/home/directivetemplate?type=accountnav",
            link: function (scope, el, attr, controller) {
                scope.an.init(el, controller);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScDialog = /** @class */ (function () {
        function ScDialog($scope, animationUtil) {
            var _this = this;
            this.$scope = $scope;
            this.animationUtil = animationUtil;
            this.visible = false;
            this.animatingIn = false;
            this.animatingOut = false;
            this.getDialogClasses = function () {
                return {
                    'sc-c-dialog--full-screen': _this.fullScreen,
                    'u-fade-enter-active': _this.animatingIn,
                    'u-fade-exit-active': _this.animatingOut,
                    'u-transparent': !_this.visible
                };
            };
        }
        ScDialog.prototype.init = function (element, modal) {
            var _this = this;
            this.element = element;
            this.parentModal = modal;
            // watch open state
            this.$scope.$watch('d.parentModal.open', function (val) {
                if (!_.isUndefined(val)) {
                    val ? _this.handleOpen() : _this.handleClose();
                }
            });
        };
        ScDialog.prototype.handleOpen = function () {
            var _this = this;
            if (this.visible) {
                return;
            }
            // animate the dialog IN
            this.animatingIn = true; // applies class with transition
            this.visible = true;
            this.animationUtil.waitForTransition(this.element).then(function (el) {
                _this.animatingIn = false;
            });
        };
        ScDialog.prototype.handleClose = function () {
            var _this = this;
            if (!this.visible) {
                return;
            }
            // animate the dialog OUT
            this.animatingOut = true; // applies class with transition
            this.animationUtil.waitForTransition(this.element).then(function (el) {
                _this.animatingOut = false;
                _this.visible = false;
            });
        };
        ScDialog.prototype.close = function () {
            this.parentModal.onClose();
        };
        return ScDialog;
    }());
    Core.ScDialog = ScDialog;
    angular
        .module('core')
        .directive('scDialog', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scModal',
            replace: true,
            transclude: true,
            controller: ScDialog,
            controllerAs: 'd',
            bindToController: {
                fullScreen: '=',
            },
            template: "<div class=\"sc-c-dialog\" ng-class=\"d.getDialogClasses()\" />",
            link: function (scope, el, attr, modalCtrl, transcludeFn) {
                // transclude manually so we can access dialog's scope from the tanscluded content
                transcludeFn(scope, function (contents) {
                    angular.forEach(contents, function (node) {
                        el.append(node);
                    });
                });
                scope.d.init(el, modalCtrl);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScNav = /** @class */ (function () {
        function ScNav($scope, $window, $timeout, componentUtil) {
            this.$scope = $scope;
            this.$window = $window;
            this.$timeout = $timeout;
            this.componentUtil = componentUtil;
            this.jWindow = $(this.$window);
            this.items = [];
            this.eventNamespace = "." + this.componentUtil.getRandomID('sc-nav');
            this.scrollOffset = 100;
            this.scrollDuration = 400;
            this.isStuck = false;
        }
        ScNav.prototype.init = function (element) {
            var _this = this;
            this.element = element;
            this.firstItem = _.head(this.items);
            this.lastItem = _.last(this.items);
            // Include only the first item to the tab sequence
            this.firstItem.isTabbable = true;
            // set active item on scroll/resize
            var throttledScroll = _.throttle(function () { return _this.setActiveItem(); }, 100);
            this.jWindow.on("scroll" + this.eventNamespace, function () { return throttledScroll(); });
            this.jWindow.on("resize" + this.eventNamespace, function () { return throttledScroll(); });
            // set initial active item
            this.setActiveItem();
            this.$scope.$on('$destroy', function () { return _this.destroy(); });
        };
        ScNav.prototype.addItem = function (item) {
            this.items.push(item);
        };
        ScNav.prototype.setTabbableItem = function (item) {
            var tabbable = _.find(this.items, function (item) { return item.isTabbable; });
            tabbable.isTabbable = false;
            item.isTabbable = true;
        };
        ScNav.prototype.setFocusToItem = function (item) {
            item.setFocus();
        };
        ScNav.prototype.setFocusToPreviousItem = function (item) {
            var next = item === this.firstItem
                ? this.lastItem
                : this.items[this.items.indexOf(item) - 1];
            this.setFocusToItem(next);
        };
        ScNav.prototype.setFocusToNextItem = function (item) {
            var next = item === this.lastItem
                ? this.firstItem
                : this.items[this.items.indexOf(item) + 1];
            this.setFocusToItem(next);
        };
        ScNav.prototype.setFocusTofirstItem = function () {
            this.setFocusToItem(this.firstItem);
        };
        ScNav.prototype.setFocusTolastItem = function () {
            this.setFocusToItem(this.lastItem);
        };
        ScNav.prototype.setActiveItem = function () {
            var _this = this;
            // We want to activate the last item whose target element has breached our scroll offset
            var item = _.findLast(this.items, function (item, index) {
                // get top of item
                var top = item.targetElement[0].getBoundingClientRect().top;
                return top <= _this.scrollOffset;
            });
            // if no item qualified then we are presumably above the first item so select that
            !item && (item = this.items[0]);
            if (item !== this.activeItem) {
                // Deselect the active item
                this.activeItem && (this.activeItem.isActive = false);
                this.$timeout(function () {
                    item.isActive = true;
                });
                this.activeItem = item;
            }
        };
        ScNav.prototype.scrollToItemTarget = function (item) {
            if (item.targetElement) {
                var top_1 = (item.targetElement.offset().top - this.scrollOffset) + 1;
                $('html, body').animate({ scrollTop: top_1 }, { duration: this.scrollDuration, queue: false });
                // TODO change focus to target after animation?
                //https://css-tricks.com/snippets/jquery/smooth-scrolling/
            }
        };
        ScNav.prototype.setStuck = function (value) {
            var _this = this;
            this.$timeout(function () {
                _this.isStuck = value;
            });
        };
        ScNav.prototype.destroy = function () {
            this.jWindow.off(this.eventNamespace);
        };
        return ScNav;
    }());
    var ScNavItem = /** @class */ (function () {
        function ScNavItem() {
            var _this = this;
            // Public
            this.isActive = false;
            // Focus is managed using Roving tabindex
            // https://www.w3.org/TR/2017/WD-wai-aria-practices-1.1-20170628/#kbd_roving_tabindex
            // By default a nav item is focusable but not included in the tab sequence (tabindex="-1").
            // On page load the first nav item will be included in the tab sequence (tabindex="0").
            // If another item receives focus, its tabindex will be set to 0 and all other items will be set to -1.
            this.isTabbable = false;
            this.events = {
                'click': function (event) {
                    event.preventDefault();
                    // scroll to target
                    _this.parentNav.scrollToItemTarget(_this);
                },
                'keydown': function (event) {
                    switch (event.keyCode) {
                        case TR.KeyCode.SPACE:
                        case TR.KeyCode.RETURN:
                            _this.parentNav.scrollToItemTarget(_this);
                            break;
                        case TR.KeyCode.LEFT:
                            _this.parentNav.setFocusToPreviousItem(_this);
                            break;
                        case TR.KeyCode.RIGHT:
                            _this.parentNav.setFocusToNextItem(_this);
                            break;
                        case TR.KeyCode.HOME:
                            event.preventDefault();
                            _this.parentNav.setFocusTolastItem();
                            break;
                        case TR.KeyCode.END:
                            event.preventDefault();
                            _this.parentNav.setFocusTofirstItem();
                            break;
                        default:
                    }
                },
                'focus': function (event) {
                    _this.parentNav.setTabbableItem(_this);
                }
            };
        }
        ScNavItem.prototype.init = function (element, targetElement, nav) {
            this.element = element;
            if (targetElement.length === 0) {
                throw 'Target element not found for ScNavItem';
            }
            this.targetElement = targetElement;
            this.parentNav = nav;
            // Add item to it's parent
            this.parentNav.addItem(this);
        };
        ScNavItem.prototype.setFocus = function () {
            this.element.focus();
        };
        return ScNavItem;
    }());
    angular
        .module('core')
        .directive('scInPageNav', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScNav,
            controllerAs: 'nav',
            template: "<div>\n                        <div sc-sticky-el\n                            data-on-stick=\"nav.setStuck(true)\"\n                            data-on-unstick=\"nav.setStuck(false)\"\n                            data-sticky-class=\"u-sticky-bar\">\n                            <nav \n                                class=\"sc-c-tabs sc-c-tabs--centered sc-c-tabs--contained\" \n                                ng-class=\"{'sc-c-tabs--dark sc-c-tabs--elevated': nav.isStuck}\"\n                                >\n                                <div class=\"sc-c-tabs__scroller\">\n                                    <div class=\"sc-c-tabs__tablist\"\n                                        ng-transclude>\n                                    </div>\n                                </div>\n                            </nav>\n                        </div>\n                    </div>",
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    })
        .directive('scInPageNavItem', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scInPageNav',
            replace: true,
            transclude: true,
            controller: ScNavItem,
            controllerAs: 'item',
            bindToController: {
                heading: '@',
                targetId: '@'
            },
            template: "<a class=\"sc-c-tab sc-c-tab--l\" \n                        ng-class=\"{'is-selected': item.isActive}\"\n                        href=\"#{{item.target}}\"\n                        ng-click=\"item.events.click($event)\"\n                        ng-keydown=\"item.events.keydown($event)\"\n                        ng-focus=\"item.events.focus($event)\"\n                        ng-attr-tabindex=\"{{item.isTabbable ? '0' : '-1'}}\">\n                        <span class='sc-c-tab__label'>{{item.heading}}</span>\n                     </a>\n                    ",
            link: function (scope, el, attr, navCtrl) {
                var target = $("#" + attr['targetId']);
                scope.item.init(el, target, navCtrl);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Culture = /** @class */ (function () {
        function Culture(cultureCode, titleResource) {
            this.CultureCode = cultureCode;
            this.TitleResource = titleResource;
        }
        return Culture;
    }());
    Core.Culture = Culture;
    var Location = /** @class */ (function () {
        function Location(domainId, titleResource, cultures, countryCode) {
            this.Cultures = [];
            this.DomainId = domainId;
            this.TitleResource = titleResource;
            this.Cultures = cultures;
            this.CountryCode = countryCode;
        }
        return Location;
    }());
    Core.Location = Location;
    var Settings = /** @class */ (function () {
        function Settings(domainId, cultureCode) {
            this.DomainId = domainId;
            this.CultureCode = cultureCode;
        }
        return Settings;
    }());
    Core.Settings = Settings;
    var LocationSettings = /** @class */ (function () {
        function LocationSettings(languageService, $scope, $route, $q, cookieService, $location) {
            this.languageService = languageService;
            this.$scope = $scope;
            this.$route = $route;
            this.$q = $q;
            this.cookieService = cookieService;
            this.$location = $location;
        }
        LocationSettings.prototype.init = function (element) {
            var _this = this;
            this.getLocations().then(function (options) {
                var regions = TRPCONFIG.Domain.EnabledRegionOnLangSelector.split(',');
                var newOptions = regions && regions.length > 0 && regions.map(function (region) {
                    return options.filter(function (op) { return op.CountryCode === region; });
                }).flat() || [];
                var doNotApplyConfigForThisDomainSuffix = TRPCONFIG.Domain.EnabledRegionOnLangSelectorOverride;
                var domainHost = _this.$location.host();
                var domainMatch = domainHost && domainHost.endsWith(doNotApplyConfigForThisDomainSuffix);
                _this.locations = domainMatch ? options : newOptions;
                var culture = _this.cookieService.get('LANG') || TRPCONFIG.Domain.CultureCode;
                if (/^[a-z]{2}-[a-z]{2}$/i.test(culture)) {
                    culture = culture.substr(0, 3) + culture.substr(3, 5).toUpperCase();
                }
                _this.model = new Settings(TRPCONFIG.Domain.DomainId, culture);
            });
            // watch selected location
            this.$scope.$watch('ls.model.DomainId', function (val, old) {
                if (!_.isUndefined(val)) {
                    _this.onSetLocation(val);
                }
            });
        };
        LocationSettings.prototype.getLocations = function () {
            // Options will remain hardcoded for now, but we will mock a service response.
            var deferred = this.$q.defer();
            var response = [
                new Location(34, 'DISPLAYUNITEDARABEMIRATES', [
                    new Culture('ar-AE', 'DISPLAYARABIC'),
                    new Culture('en-BZ', 'DISPLAYENGLISH')
                ], 'AE'),
                new Location(35, 'DISPLAYSAUDIARABIA', [
                    new Culture('ar-SA', 'DISPLAYARABIC'),
                    new Culture('en-TT', 'DISPLAYENGLISH')
                ], 'SA')
            ];
            deferred.resolve(response);
            return deferred.promise;
        };
        LocationSettings.prototype.onSetLocation = function (domainId) {
            var _this = this;
            var matchLocation = _.find(this.locations, function (location) {
                return location.DomainId === domainId;
            });
            // Get cultures for this location
            this.cultures = matchLocation.Cultures;
            // Attempt to match previous selected culture
            var matchCulture = _.find(this.cultures, function (culture) {
                return culture.CultureCode === _this.model.CultureCode;
            });
            if (!matchCulture) {
                // select the first culture option
                this.model.CultureCode = this.cultures[0].CultureCode;
            }
        };
        LocationSettings.prototype.handleLocationClick = function (event, location) {
            this.setDomain(location.DomainId);
        };
        LocationSettings.prototype.handleLocationKeydown = function (event, location) {
            event.keyCode === TR.KeyCode.SPACE && this.setDomain(location.DomainId);
        };
        LocationSettings.prototype.handleCultureClick = function (event, culture) {
            this.setCulture(culture.CultureCode);
        };
        LocationSettings.prototype.handleCultureKeydown = function (event, culture) {
            event.keyCode === TR.KeyCode.SPACE && this.setCulture(culture.CultureCode);
        };
        LocationSettings.prototype.setDomain = function (domainId) {
            this.model.DomainId = domainId;
        };
        LocationSettings.prototype.setCulture = function (cultureCode) {
            this.model.CultureCode = cultureCode;
        };
        LocationSettings.prototype.save = function () {
            var _this = this;
            this.languageService.setLanguage(this.model.CultureCode, this.model.DomainId).then(function () {
                if (TRPCONFIG.Domain.RedirectLanguageChangeToHomepage &&
                    TRPCONFIG.Domain.DomainId !== Number(_this.model.DomainId)) {
                    window.location.href = '/?rl=1';
                }
                else {
                    window.location.href = _this.$location.absUrl();
                }
            });
        };
        return LocationSettings;
    }());
    angular
        .module('core')
        .directive('locationSettings', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: false,
            transclude: false,
            controller: LocationSettings,
            controllerAs: 'ls',
            bindToController: {
                onClose: '&',
            },
            templateUrl: "partials/home/directivetemplate?type=LocationSettings",
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScModal = /** @class */ (function () {
        function ScModal($scope, componentUtil, animationUtil) {
            var _this = this;
            this.$scope = $scope;
            this.componentUtil = componentUtil;
            this.animationUtil = animationUtil;
            this.eventNamespace = "." + this.componentUtil.getRandomID('sc-c-modal-');
            this.repositioned = false;
            this.visible = false;
            this.animatingIn = false;
            this.animatingOut = false;
            this.bind = {
                focus: function () {
                    //$(document).on(`focus${this.eventNamespace}`, this.enforceFocus);
                },
                keydown: function () {
                    $(document).on("keydown" + _this.eventNamespace, _this.handleDocumentKeyDown);
                },
                scrollLock: function () {
                    // disable browser scroll bar
                    _this.lastContextOverflow = _this.container.css('overflow');
                    _this.container.css('overflow', 'hidden');
                }
            };
            this.unbind = {
                focus: function () {
                    //$(document).off(this.eventNamespace);
                },
                keydown: function () {
                    $(document).off(_this.eventNamespace);
                },
                scrollLock: function () {
                    // enable browser scroll bar
                    _this.container.css('overflow', _this.lastContextOverflow);
                    _this.lastContextOverflow = '';
                }
            };
            this.handleBackdropClick = function (event) {
                if (!_this.disableBackdropClick) {
                    _this.onClose();
                }
            };
            this.handleDocumentKeyDown = function (event) {
                var isEscape = (event.keyCode === 27);
                if (!isEscape) {
                    return;
                }
                if (!_this.disableEscapeKeyDown) {
                    _this.$scope.$apply(function () { return _this.onClose(); });
                }
            };
            this.autoFocus = function () {
                var currentActive = document.activeElement;
                if (!$.contains(_this.content[0], currentActive)) {
                    _this.lastFocus = currentActive;
                    _this.content.focus();
                }
            };
            this.restoreLastFocus = function () {
                if (_this.lastFocus) {
                    $(_this.lastFocus).focus();
                    _this.lastFocus = null;
                }
            };
            // private enforceFocus = () => {
            //     console.log('enforceFocus');
            //
            //     // Prevent focus from leaving the modal
            //     const currentActive = document.activeElement;
            //     if (!$.contains(this.content[0], currentActive)) {
            //         console.log('preventing');
            //         this.content.focus();
            //     }
            // }
            this.getBackdropClasses = function () {
                return {
                    'u-fade-enter-active': _this.animatingIn,
                    'u-fade-exit-active': _this.animatingOut,
                    'u-transparent': !_this.visible
                };
            };
            this.destroy = function () {
                _this.open && _this.handleClose();
                _this.repositioned && _this.element.remove();
            };
        }
        ScModal.prototype.init = function (element, content, backdrop) {
            var _this = this;
            this.element = element;
            this.content = content;
            this.backdrop = backdrop;
            // for now, presume container is the body.
            // (this could become a param)
            this.container = $(document.body);
            if (this.element.parent() !== this.container) {
                this.repositioned = true;
                this.element.appendTo(this.container);
            }
            // decorate contents with additional properties
            this.content.attr('tabindex', '-1');
            this.content.attr('role', 'document');
            this.$scope.$on('$destroy', this.destroy);
            // watch open state
            this.$scope.$watch('m.open', function (val) {
                if (!_.isUndefined(val)) {
                    val ? _this.handleOpen() : _this.handleClose();
                }
            });
        };
        ScModal.prototype.handleOpen = function () {
            var _this = this;
            if (this.visible) {
                return;
            }
            // bind handlers
            _.forEach(this.bind, function (handler) {
                handler();
            });
            // animate the backdrop IN
            this.animatingIn = true; // applies class with transition
            this.visible = true;
            this.animationUtil.waitForTransition(this.backdrop).then(function (el) {
                _this.animatingIn = false;
                _this.autoFocus();
            });
        };
        ScModal.prototype.handleClose = function () {
            var _this = this;
            if (!this.visible) {
                return;
            }
            // animate the backdrop OUT
            this.animatingOut = true; // applies class with transition
            this.animationUtil.waitForTransition(this.backdrop).then(function (el) {
                _this.animatingOut = false;
                _this.visible = false;
                // unbind handlers
                _.forEach(_this.unbind, function (handler) {
                    handler();
                });
                _this.restoreLastFocus();
            });
        };
        return ScModal;
    }());
    Core.ScModal = ScModal;
    angular
        .module('core')
        .directive('scModal', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScModal,
            controllerAs: 'm',
            bindToController: {
                open: '=',
                onClose: '&',
                disableBackdropClick: '=',
                disableEscapeKeyDown: '=',
            },
            template: "<div class=\"sc-c-modal\" \n                                ng-class=\"{'u-invisible': !m.visible}\">\n                                <div class=\"sc-c-modal__backdrop\" \n                                     ng-class=\"m.getBackdropClasses()\"\n                                     aria-hidden=\"true\"\n                                     ng-click=\"m.handleBackdropClick($event)\" />\n                           </div>",
            link: function (scope, el, attr, controller, transcludeFn) {
                // transclude the content node directly to root element, so
                // that it is a sibling of the backdrop node.
                transcludeFn(scope, function (contents) {
                    angular.forEach(contents, function (node) {
                        el.append(node);
                    });
                });
                var backdrop = el.children().first();
                var content = el.children().last();
                controller.init(el, content, backdrop);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScNumberPicker = /** @class */ (function () {
        function ScNumberPicker() {
            var _this = this;
            this.link = function (scope, element, attrs, ngModel) {
                var radix = 10;
                var increment = parseInt(scope.increment || 1, radix);
                var max = parseInt(scope.max, radix);
                var min = parseInt(scope.min, radix);
                if (scope.disabled !== 'true') {
                    scope.$watch('max', function (val) {
                        max = Number(val);
                    });
                    scope.$watch('min', function (val) {
                        min = Number(val);
                    });
                }
                //Used to apply a unique id to the element for ARIA purposes
                scope.componentId = _this.getRandomID(_this.prefix);
                if (scope.model === undefined) {
                    ngModel.$setViewValue(0);
                }
                if (scope.disabled === 'true') {
                    max = min = scope.model;
                }
                if (scope.onChange) {
                    scope.$watch('model', function () {
                        scope.onChange();
                    });
                }
                scope.click = {
                    increase: function () {
                        if (scope.disabled === 'true') {
                            return;
                        }
                        if (scope.model < max) {
                            ngModel.$setViewValue(Number(scope.model) + increment);
                        }
                    },
                    decrease: function () {
                        if (scope.disabled === 'true') {
                            return;
                        }
                        if (scope.model > min) {
                            ngModel.$setViewValue(Number(scope.model) - increment);
                        }
                    }
                };
            };
            this.restrict = 'E';
            this.replace = true;
            this.require = 'ngModel';
            this.scope = {
                model: '=ngModel',
                max: '=',
                min: '=',
                increment: '=',
                disabled: '@',
                onChange: '&'
            };
            this.template = "<form class=\"c-number-picker\">\n                                <button \n                                    href=\"#\" \n                                    ng-click=\"click.decrease()\" \n                                    ng-disabled=\"model <= min || disabled === 'true'\" \n                                    class=\"c-number-picker__part--minus\"\n                                    aria-controls=\"{{componentId}}\"\n                                    aria-label=\"Decrease\">\n                                </button>\n                                <input \n                                    id=\"{{componentId}}\"\n                                    type=\"text\" \n                                    class=\"c-number-picker__label\" \n                                    ng-model=\"model\" \n                                    aria-live=\"assertive\"\n                                    readonly/>\n                                <button \n                                    href=\"#\" \n                                    ng-click=\"click.increase()\" \n                                    ng-disabled=\"model >= max || disabled === 'true'\" \n                                    class=\"c-number-picker__part--plus\"\n                                    aria-controls=\"{{componentId}}\"\n                                    aria-label=\"Increase\">\n                                </button>\n                              </form>";
            /**
             * Prefix for randomised ID on each directive

             * @private
             */
            this.prefix = 'c-number-picker--';
            /**
             * Generate random ID
             *
             * @param {string} prefix BEMIT formatted identifier. e.g. 'c-component--'
             * @returns {string} Prefix + Random string
             */
            this.getRandomID = function (prefix) {
                return prefix + Math.random().toString(36).substr(2, 7);
            };
        }
        ScNumberPicker.factory = function () {
            var directive = function () { return new ScNumberPicker(); };
            directive.$inject = [];
            return directive;
        };
        return ScNumberPicker;
    }());
    var TR = angular.module('TR');
    TR.directive('scNumberPicker', ScNumberPicker.factory());
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScReviewRating = /** @class */ (function () {
        function ScReviewRating() {
            this.link = function (scope, element, attrs, ngModel) {
                var radix = 10;
                var min = parseInt(scope.min, radix), max = parseInt(scope.max, radix), step = parseInt(scope.step || 1, radix);
                //basic checks of our min, max and step values
                if (!(min < max) || step === 0 || (max - min) % step !== 0) {
                    throw 'Rating picker - Invalid parameters';
                }
                //used for creating our datalist, used in UI only need to start counting
                //at min + step
                scope.range = _.range(min + step, max + step, step);
                var containerClasses = [];
                if (scope.size && scope.size.length > 0) {
                    containerClasses.push("sc-c-range-bar--" + scope.size);
                }
                scope.containerClasses = containerClasses.join(' ');
            };
            this.restrict = 'E';
            this.replace = true;
            this.scope = {
                caption: '@',
                value: '=',
                max: '@',
                min: '@',
                step: '@',
                size: '@'
            };
            this.template = "<div class=\"sc-c-range-bar\n                                        sc-c-range-bar--readonly\n                                        sc-c-range-bar--no-rating\"\n                                 ng-class=\"containerClasses\">\n                                <label class=\"sc-c-range-bar__label\">{{::caption}}</label> \n                                <div class=\"sc-c-range-bar__block-wrapper\">\n                                    <label class=\"sc-c-range-bar__block\"\n                                          ng-class=\"{'sc-c-range-bar__block--selected' : r <= value}\"\n                                          ng-click=\"click.setValue(r)\"\n                                          ng-repeat=\"r in range\">\n                                    </label> \n                                </div>\n                             </div>";
        }
        ScReviewRating.factory = function () {
            var directive = function () { return new ScReviewRating(); };
            directive.$inject = [];
            return directive;
        };
        return ScReviewRating;
    }());
    var TR = angular.module('TR');
    TR.directive('scReviewRating', ScReviewRating.factory());
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScReviewRatingSelector = /** @class */ (function () {
        function ScReviewRatingSelector() {
            var _this = this;
            this.link = function (scope, element, attrs, ngModel) {
                var radix = 10;
                var min = parseInt(scope.min, radix), max = parseInt(scope.max, radix), step = parseInt(scope.step || 1, radix);
                //Used to apply a unique id to the element for ARIA purposes
                scope.componentId = _this.getRandomID(_this.prefix);
                scope.unset = !scope.model || scope.model === min;
                //basic checks of our min, max and step values
                if (!(min < max) || step === 0 || (max - min) % step !== 0) {
                    throw 'Review Rating picker - Invalid parameters';
                }
                //used for creating our datalist, used in UI only need to start counting
                //at min + step
                scope.range = _.range(min + step, max + step, step);
                scope.click = {
                    setValue: function (value) {
                        var firstValue = min + step;
                        scope.unset = false;
                        //this is to handle the fact that we start our display min+step and that there is no actual
                        //min block to select
                        if (value === firstValue && scope.model === firstValue) {
                            value = min;
                        }
                        ngModel.$setViewValue(value);
                    }
                };
                var containerClasses = [];
                if (scope.size && scope.size.length > 0) {
                    containerClasses.push("sc-c-range-bar--" + scope.size);
                }
                scope.containerClasses = containerClasses.join(' ');
            };
            this.restrict = 'E';
            this.replace = true;
            this.require = 'ngModel';
            this.scope = {
                caption: '@',
                model: '=ngModel',
                max: '@',
                min: '@',
                step: '@',
                size: '@'
            };
            this.template = "<div class=\"sc-c-range-bar\"\n                                 ng-class=\"containerClasses\">\n                                <label class=\"sc-c-range-bar__label\" for=\"{{componentId}}\">{{::caption}}</label>\n                                <div class=\"sc-c-range-bar__block-wrapper\">\n                                    <input class=\"sc-c-range-bar__range\"\n                                           id=\"{{componentId}}\"\n                                           min=\"{{min}}\"\n                                           max=\"{{max}}\"\n                                           step=\"{{step}}\"\n                                           type=\"range\" \n                                           ng-model=\"model\" \n                                    />\n                                    <label class=\"sc-c-range-bar__block\"\n                                          for=\"{{componentId}}\"\n                                          ng-class=\"{'sc-c-range-bar__block--selected' : r <= model}\"\n                                          ng-click=\"click.setValue(r)\"\n                                          ng-repeat=\"r in range\">\n                                    </label>\n                                </div>\n                                <div class=\"sc-c-range-bar__rating-wrapper\">\n                                    <span class=\"sc-c-range-bar__rating\"\n                                             ng-class=\"{'sc-c-range-bar__rating--pristine' : unset}\">\n                                             {{model}}\n                                     </span>\n                                    <i class=\"sc-c-range-bar__rating-icon icon-smiley-rating-{{model}}\"></i>\n                                </div>\n                             </div>";
            /**
             * Prefix for randomised ID on each directive

             * @private
             */
            this.prefix = 'c-review-rating-picker--';
            /**
             * Generate random ID
             *
             * @param {string} prefix BEMIT formatted identifier. e.g. 'c-component--'
             * @returns {string} Prefix + Random string
             */
            this.getRandomID = function (prefix) {
                return prefix + Math.random().toString(36).substr(2, 7);
            };
        }
        ScReviewRatingSelector.factory = function () {
            var directive = function () { return new ScReviewRatingSelector(); };
            directive.$inject = [];
            return directive;
        };
        return ScReviewRatingSelector;
    }());
    var TR = angular.module('TR');
    TR.directive('scReviewRatingSelector', ScReviewRatingSelector.factory());
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScSidebar = /** @class */ (function () {
        function ScSidebar($scope, broker, animationUtil, $rootScope, $location, componentUtil) {
            var _this = this;
            this.$scope = $scope;
            this.broker = broker;
            this.animationUtil = animationUtil;
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.componentUtil = componentUtil;
            this.isOpen = false;
            this.animating = false;
            this.visible = false;
            this.componentNamespace = 'sc-c-sidebar-';
            this.eventNamespace = "." + this.componentUtil.getRandomID(this.componentNamespace);
            this.event = {
                clickaway: function (event) {
                    event.preventDefault();
                    _this.$scope.$apply(function () { return _this.close(true); });
                },
                escape: function (event) {
                    var isEscape = (event.keyCode === 27);
                    if (isEscape) {
                        _this.$scope.$apply(function () { return _this.close(true); });
                    }
                }
            };
            this.bind = {
                clickaway: function () {
                    _this.backdrop
                        .on("click" + _this.eventNamespace, _this.event.clickaway)
                        .on("touchend" + _this.eventNamespace, _this.event.clickaway);
                },
                keydown: function () {
                    _this.context
                        .on("keydown" + _this.eventNamespace, _this.event.escape);
                },
                scrollLock: function () {
                    // disable browser scroll bar
                    _this.lastContextOverflow = _this.context.css('overflow');
                    _this.context.css('overflow', 'hidden');
                }
            };
            this.unbind = {
                clickaway: function () {
                    _this.backdrop.off(_this.eventNamespace);
                },
                keydown: function () {
                    _this.context.off(_this.eventNamespace);
                },
                scrollLock: function () {
                    // enable browser scroll bar
                    _this.context.css('overflow', _this.lastContextOverflow);
                    _this.lastContextOverflow = '';
                }
            };
        }
        ScSidebar.prototype.init = function (element) {
            var _this = this;
            this.element = element;
            // presume context is the parent element (most likely the body)
            this.context = this.element.parent();
            // create a hidden backdrop and append it to our context element
            this.backdrop = $('<div class="sc-o-backdrop sc-o-backdrop--sidebar is-hidden"></div>');
            this.backdrop.appendTo(this.context);
            this.broker.subscribe('SidebarToggle', this.toggleEvent, function (e) {
                _this.$scope.$apply(function () { return _this.toggle(); });
            });
            this.$scope.$on('$destroy', this.destroy);
            this.$rootScope.$on('$routeChangeStart', function () {
                _this.shut();
            });
            this.sidebarStyle = {
                'visibility': "hidden"
            };
        };
        ScSidebar.prototype.destroy = function () {
            _.forEach(this.unbind, function (handler) {
                handler();
            });
            this.backdrop && this.backdrop.remove();
        };
        ScSidebar.prototype.toggle = function () {
            this.isOpen ? this.close(true) : this.open();
        };
        ScSidebar.prototype.open = function () {
            var _this = this;
            if (this.isOpen) {
                return;
            }
            this.isOpen = true;
            // animate the backdrop
            this.backdrop.removeClass('is-hidden').addClass('is-dimmed');
            this.bind.scrollLock();
            // animate the sidebar
            this.animating = true;
            this.visible = true;
            this.sidebarStyle = {
                'visibility': "visible"
            };
            this.animationUtil.waitForTransition(this.element).then(function (el) {
                _this.animating = false;
                _this.bind.clickaway();
                _this.bind.keydown();
            });
        };
        ScSidebar.prototype.close = function (animate) {
            var _this = this;
            if (!this.isOpen) {
                return;
            }
            if (animate) {
                // animate backdrop
                this.backdrop.removeClass('is-dimmed');
                this.animationUtil.waitForTransition(this.backdrop).then(function (el) {
                    // hide the backdrop
                    _this.backdrop.addClass('is-hidden');
                });
                // animate sidebar
                this.animating = true;
                this.visible = false;
                this.animationUtil.waitForTransition(this.element).then(function (el) {
                    _this.animating = false;
                    _this.isOpen = false;
                    _this.sidebarStyle = {
                        'visibility': "hidden"
                    };
                });
            }
            else {
                // hide the backdrop and hide sidebar
                this.backdrop.removeClass('is-dimmed').addClass('is-hidden');
                this.visible = false;
                this.isOpen = false;
                this.sidebarStyle = {
                    'visibility': "hidden"
                };
            }
            this.unbind.clickaway();
            this.unbind.keydown();
            this.unbind.scrollLock();
        };
        ScSidebar.prototype.shut = function () {
            this.close(false);
        };
        return ScSidebar;
    }());
    Core.ScSidebar = ScSidebar;
    angular
        .module('core')
        .directive('scSidebar', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScSidebar,
            controllerAs: 'sb',
            bindToController: {
                toggleEvent: '='
            },
            template: "<div class=\"sc-c-sidebar\"\n                                ng-class=\"{'is-animating': sb.animating, 'is-visible': sb.visible}\"\n                                ng-style=\"sb.sidebarStyle\"\n                                ng-transclude>                   \n                           </div>",
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScSidebarNav = /** @class */ (function () {
        function ScSidebarNav($scope, animationUtil) {
            this.$scope = $scope;
            this.animationUtil = animationUtil;
            this.menuLevel = 0;
            this.menus = [];
            this.animating = false;
            this.selector = {
                viewport: '.c-sidebar-nav-viewport'
            };
        }
        ScSidebarNav.prototype.init = function (element, sidebar) {
            var _this = this;
            this.element = element;
            this.parentSidebar = sidebar;
            this.viewport = element.find(this.selector.viewport);
            // open the top-level menu
            this.openMainMenu();
            this.$scope.$watch('sn.parentSidebar.isOpen', function (val, old) {
                if (old && !val) {
                    // sidebar has closed so reset the menu
                    _this.openMainMenu();
                }
            });
        };
        ScSidebarNav.prototype.addMenu = function (menu) {
            this.menus.push(menu);
        };
        ScSidebarNav.prototype.showMenu = function (menu) {
            var _this = this;
            this.activeMenu = menu;
            this.menuLevel = this.activeMenu.getMenuLevel();
            // changing menu level triggers a CSS class swap on the viewport
            this.animating = true;
            this.animationUtil.waitForTransition(this.viewport).then(function (el) {
                _this.animating = false;
                _.each(_this.menus, function (m) {
                    // close any other open menus that are not the active menu or one of it's ancestors
                    if (m.isOpen && m !== _this.activeMenu && !_.includes(_this.activeMenu.getAncestors(), m)) {
                        m.close();
                    }
                });
            });
        };
        ScSidebarNav.prototype.back = function (event) {
            if (!(this.activeMenu && this.activeMenu.parentMenuItem)) {
                return;
            }
            this.activeMenu.parentMenuItem.parentMenu.open();
        };
        ScSidebarNav.prototype.close = function (event) {
            this.parentSidebar.toggle();
        };
        ScSidebarNav.prototype.openMainMenu = function () {
            _.find(this.menus, { 'isSubmenu': false }).open();
        };
        return ScSidebarNav;
    }());
    var ScSidebarMenu = /** @class */ (function () {
        function ScSidebarMenu() {
            this.parentMenuItem = null;
            this.isSubmenu = false;
            this.isOpen = false;
            this.menuLevel = null; // this is set upon first "open" request
        }
        ScSidebarMenu.prototype.init = function (parents) {
            this.parentNav = parents[0];
            this.parentNav.addMenu(this);
            if (parents[1]) {
                // this is a submenu of a menu item
                this.isSubmenu = true;
                this.parentMenuItem = parents[1];
                this.parentMenuItem.assignSubmenu(this);
            }
        };
        ScSidebarMenu.prototype.open = function () {
            this.isOpen = true;
            this.parentNav.showMenu(this);
        };
        ScSidebarMenu.prototype.close = function () {
            this.isOpen = false;
        };
        ScSidebarMenu.prototype.getMenuLevel = function () {
            return this.menuLevel || this.getAncestors().length;
        };
        ScSidebarMenu.prototype.getAncestors = function () {
            var ancestors = [];
            if (this.parentMenuItem) {
                var menuItem = this.parentMenuItem, menu = void 0;
                while (menuItem != null) {
                    menu = menuItem.parentMenu;
                    menuItem = menu.parentMenuItem ? menu.parentMenuItem : null;
                    ancestors.push(menu);
                }
            }
            return ancestors;
        };
        return ScSidebarMenu;
    }());
    var ScSidebarMenuItem = /** @class */ (function () {
        function ScSidebarMenuItem(analytics) {
            this.analytics = analytics;
            this.modifierClasses = [];
            this.hasIcon = false;
            this.className = {
                link: 'c-sidebar-nav-list-link',
                hasIcon: 'has-icon'
            };
        }
        ScSidebarMenuItem.prototype.init = function (menu) {
            this.parentMenu = menu;
            this.cssModifier && this.modifierClasses.push(this.className.link + "--" + this.cssModifier);
            if (this.iconName) {
                this.modifierClasses.push(this.className.link + "--" + this.className.hasIcon);
                this.iconClass = "icon-" + this.iconName;
                this.hasIcon = true;
            }
        };
        ScSidebarMenuItem.prototype.assignSubmenu = function (submenu) {
            this.submenu = submenu;
        };
        ScSidebarMenuItem.prototype.linkClick = function (event) {
            if (this.submenu) {
                this.submenu.open();
            }
            else {
                // navigation link clicked
                this.trackNavigation();
                this.parentMenu.parentNav.parentSidebar.shut();
            }
        };
        ScSidebarMenuItem.prototype.trackNavigation = function () {
            // Mixpanel link tracking
            var data = {};
            _.each(this.trackingPath.split('|'), function (item, index) {
                data["Depth " + (index + 1)] = item;
            });
            this.analytics.track('mixpanel', 'MobileNavMenuClick', data);
        };
        return ScSidebarMenuItem;
    }());
    angular
        .module('core')
        .directive('scSidebarNav', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '?^scSidebar',
            replace: true,
            transclude: true,
            controller: ScSidebarNav,
            controllerAs: 'sn',
            bindToController: {},
            template: "<nav id=\"main-navigation\">\n                        <div class=\"sc-c-app-header sc-c-app-header--primary\">\n                            <div class=\"sc-o-flex-grid sc-o-flex-grid--items-center sc-o-flex-grid--spacing-xxxs\">\n                                <div\n                                    class=\"sc-o-flex-grid-item sc-u-drag-start-xxxs\"\n                                    ng-if=\"sn.menuLevel > 0\"\n                                >\n                                    <button\n                                        class=\"sc-c-icon-button sc-c-icon-button--white sc-c-icon-button--xs\"\n                                        type=\"button\"\n                                        ng-click=\"sn.back($event)\"\n                                        aria-label=\"Go back to {{sn.activeMenu.parentMenuItem.parentMenu.menuTitle}}\"\n                                    >\n                                        <sc-svg-inline\n                                            name=\"chevron-left\"\n                                            class=\"sc-o-svg-icon sc-o-svg-icon--bi-directional sc-o-svg-icon--xs\"\n                                        />\n                                    </button>\n                                </div>\n                                <div class=\"sc-o-flex-grid-item sc-o-flex-grid-item--fill-space\">\n                                    <h3 class=\"sc-o-heading sc-u-color-white sc-o-heading--s\">\n                                        {{sn.activeMenu.menuTitle}}\n                                    </h3>\n                                </div>\n                                <div class=\"sc-o-flex-grid-item sc-u-drag-end-xxxs\">\n                                    <button\n                                        class=\"sc-c-icon-button sc-c-icon-button--white sc-c-icon-button--xs\"\n                                        type=\"button\"\n                                        ng-click=\"sn.close($event)\"\n                                        aria-label=\"Close main menu\"\n                                     >\n                                        <sc-svg-inline\n                                            name=\"close\"\n                                            class=\"sc-o-svg-icon sc-o-svg-icon--xs\"\n                                        />\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"c-sidebar-nav-viewport level-{{sn.menuLevel}}\"\n                             ng-class=\"{'animating': sn.animating}\"\n                             ng-transclude>\n                        </div>\n                    </nav>",
            link: function (scope, el, attr, controller) {
                scope.sn.init(el, controller);
            }
        };
    })
        .directive('scSidebarMenu', function () {
        return {
            scope: {},
            restrict: 'E',
            require: ['^scSidebarNav', '?^scSidebarMenuItem'],
            replace: true,
            transclude: true,
            controller: ScSidebarMenu,
            controllerAs: 'sm',
            bindToController: {
                menuTitle: '@'
            },
            template: "<ul class=\"c-sidebar-nav-list\"\n                                    aria-expanded=\"{{sm.isOpen}}\"\n                                    aria-label=\"{{sm.menuTitle}}\"\n                                    role=\"menu\"\n                                    ng-transclude>\n                             </ul>",
            link: function (scope, el, attr, controllers) {
                scope.sm.init(controllers);
            }
        };
    })
        .directive('scSidebarMenuItem', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            require: '^scSidebarMenu',
            controller: ScSidebarMenuItem,
            controllerAs: 'smi',
            bindToController: {
                label: '@',
                url: '@',
                iconName: '@',
                cssModifier: '@',
                trackingPath: '@',
                hasSubmenu: '='
            },
            template: "<li class=\"c-sidebar-nav-list__item\"\n                                role=\"none\">\n                                <a class=\"c-sidebar-nav-list-link\"\n                                   ng-class=\"smi.modifierClasses.join(' ')\"\n                                   role=\"menuitem\"\n                                   tabindex=\"-1\"\n                                   ng-attr-aria-haspopup=\"{{smi.hasSubmenu || undefined}}\"\n                                   ng-attr-aria-expanded=\"{{smi.hasSubmenu ? smi.submenu.isOpen : undefined}}\"\n                                   ng-attr-href=\"{{smi.hasSubmenu ? '#' : smi.url}}\"\n                                   ng-click=\"smi.linkClick($event)\">\n                                   <i ng-if=\"smi.hasIcon\"\n                                      class=\"c-sidebar-nav-list-link__icon\"\n                                      ng-class=\"smi.iconClass\">\n                                   </i>\n                                   <i ng-if=\"smi.hasSubmenu\"\n                                      class=\"c-sidebar-nav-list-link__submenu-icon icon-chevron-forward\">\n                                   </i>\n                                    <span>{{smi.label}}</span>\n                                </a>\n                                <div ng-if=\"smi.hasSubmenu\"\n                                     class=\"c-sidebar-submenu\"\n                                     ng-class=\"{'open': smi.submenu.isOpen}\"\n                                     ng-transclude>\n                                </div>\n                            </li>",
            link: function (scope, el, attr, menuCtrl) {
                scope.isLinkItem = function () {
                    if (!scope.smi.hasSubmenu) {
                        var linkEl = el.children();
                        var labelEl = linkEl.find('span');
                        linkEl.attr('itemprop', 'url');
                        labelEl.attr('itemprop', 'name');
                    }
                };
                scope.smi.init(menuCtrl);
                scope.isLinkItem();
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScMenubar = /** @class */ (function () {
        function ScMenubar($scope, $window, animationUtil) {
            this.$scope = $scope;
            this.$window = $window;
            this.animationUtil = animationUtil;
            this.menubarItems = [];
            this.backdropVisible = false;
            this.backdropCloseDelay = 300;
            this.eventNamespace = 'scmenubar';
        }
        ScMenubar.prototype.init = function (element) {
            this.element = element;
            this.firstItem = _.head(this.menubarItems);
            this.lastItem = _.last(this.menubarItems);
            // create a backdrop but don't append it to the DOM
            this.backdrop = $('<div class="sc-o-backdrop sc-o-backdrop--header"></div>');
            this.$scope.$on('$destroy', this.destroy);
        };
        ScMenubar.prototype.setFocusToItem = function (newItem) {
            newItem.link.focus();
        };
        ScMenubar.prototype.setFocusToFirstItem = function (currentItem) {
            this.setFocusToItem(this.firstItem);
        };
        ScMenubar.prototype.setFocusToLastItem = function (currentItem) {
            this.setFocusToItem(this.lastItem);
        };
        ScMenubar.prototype.setFocusToNextItem = function (currentItem) {
            var nextItem = currentItem === this.lastItem
                ? this.firstItem
                : this.menubarItems[this.menubarItems.indexOf(currentItem) + 1];
            this.setFocusToItem(nextItem);
        };
        ScMenubar.prototype.setFocusToPreviousItem = function (currentItem) {
            var nextItem = currentItem === this.firstItem
                ? this.lastItem
                : this.menubarItems[this.menubarItems.indexOf(currentItem) - 1];
            this.setFocusToItem(nextItem);
        };
        ScMenubar.prototype.addItem = function (menubarItem) {
            // add the item to the array
            this.menubarItems.push(menubarItem);
        };
        ScMenubar.prototype.closeMegamenus = function () {
            // close any open megamenus
            _.each(this.menubarItems, function (item) {
                if (item.hasMegamenu && item.megamenu.isOpen) {
                    item.megamenu.close(true);
                }
            });
        };
        ScMenubar.prototype.showBackdrop = function () {
            var _this = this;
            // Cancel any 'hide' request that may not have executed yet.
            clearTimeout(this.backdropCloseTimeout);
            this.backdropVisible = true;
            // append the backdrop to the body
            if (this.backdrop.parent('body').length === 0) {
                this.backdrop.appendTo($('body'));
            }
            // animate the backdrop
            setTimeout(function () { return _this.backdrop.addClass('is-dimmed'); });
        };
        ScMenubar.prototype.hideBackdrop = function (animate) {
            var _this = this;
            // Pause before we hide. If we receive another 'show' request then the 'hide' request will be cancelled.
            this.backdropCloseTimeout = setTimeout(function () {
                _this.backdropVisible = false;
                if (animate) {
                    // animate backdrop
                    _this.backdrop.removeClass('is-dimmed');
                    _this.animationUtil.waitForTransition(_this.backdrop).then(function (el) {
                        // check we still want to remove (a new show request may have been received)
                        !_this.backdropVisible && _this.backdrop.remove();
                    });
                }
                else {
                    _this.backdrop.remove();
                }
            }, this.backdropCloseDelay);
        };
        ScMenubar.prototype.destroy = function () {
            this.backdrop && this.backdrop.remove();
        };
        return ScMenubar;
    }());
    var ScMenubarItem = /** @class */ (function () {
        function ScMenubarItem($scope, $window, analytics) {
            var _this = this;
            this.$scope = $scope;
            this.$window = $window;
            this.analytics = analytics;
            this.hasFocus = false;
            this.hoverDelay = 200;
            this.linkEvents = {
                'click': function (event) {
                    if (_this.$window.TRPCONFIG.IsTouchDevice) {
                        // TOUCH BEHAVIOUR
                        //====================
                        if (_this.megamenu && !_this.megamenu.isOpen) {
                            event.preventDefault();
                            _this.megamenu.open();
                        }
                    }
                    _this.trackNavigation();
                },
                'focus': function (event) {
                    _this.hasFocus = true;
                },
                'blur': function (event) {
                    _this.hasFocus = false;
                }
            };
            this.itemEvents = {
                'keydown': function (event) {
                    if (_this.$window.TRPCONFIG.IsTouchDevice) {
                        return;
                    }
                    var preventDefault = true;
                    switch (event.keyCode) {
                        case TR.KeyCode.SPACE:
                        case TR.KeyCode.RETURN:
                            if (_this.megamenu && !_this.megamenu.isOpen) {
                                _this.megamenu.open();
                            }
                            break;
                        case TR.KeyCode.LEFT:
                            _this.parentMenubar.setFocusToPreviousItem(_this);
                            break;
                        case TR.KeyCode.RIGHT:
                            _this.parentMenubar.setFocusToNextItem(_this);
                            break;
                        case TR.KeyCode.HOME:
                        case TR.KeyCode.PAGEUP:
                            _this.parentMenubar.setFocusToLastItem(_this);
                            break;
                        case TR.KeyCode.END:
                        case TR.KeyCode.PAGEDOWN:
                            _this.parentMenubar.setFocusToFirstItem(_this);
                            break;
                        case TR.KeyCode.ESC:
                            if (_this.megamenu && _this.megamenu.isOpen) {
                                _this.megamenu.close(true);
                            }
                        default:
                    }
                    if (preventDefault) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                },
                'mouseenter': function (event) {
                    if (_this.$window.TRPCONFIG.IsTouchDevice || !_this.megamenu) {
                        return;
                    }
                    _this.hoverTimeout = setTimeout(function () {
                        _this.$scope.$apply(function () { return _this.megamenu.open(); });
                    }, _this.hoverDelay);
                },
                'mouseleave': function (event) {
                    if (_this.$window.TRPCONFIG.IsTouchDevice || !_this.megamenu) {
                        return;
                    }
                    clearTimeout(_this.hoverTimeout);
                    _this.megamenu.close(true);
                }
            };
        }
        ScMenubarItem.prototype.init = function (element, menubar) {
            this.element = element;
            this.parentMenubar = menubar;
            this.link = this.element.children('a');
            this.parentMenubar.addItem(this);
        };
        ScMenubarItem.prototype.assignMegamenu = function (megamenu) {
            this.megamenu = megamenu;
        };
        ScMenubarItem.prototype.trackNavigation = function () {
            // Mixpanel link tracking
            var data = {};
            _.each(this.trackingPath.split('|'), function (item, index) {
                data["Depth " + (index + 1)] = item;
            });
            this.analytics.track('mixpanel', 'NavMenuClick', data);
        };
        return ScMenubarItem;
    }());
    var ScMegamenu = /** @class */ (function () {
        function ScMegamenu($document, $scope, $rootScope, animationUtil) {
            this.$document = $document;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.animationUtil = animationUtil;
            this.categories = [];
            this.isOpen = false;
            this.animating = false;
            this.visible = false;
            this.eventNamespace = 'smegamenu';
        }
        ScMegamenu.prototype.init = function (element, menubarItem) {
            var _this = this;
            this.element = element;
            this.parentMenubarItem = menubarItem;
            this.parentMenubar = menubarItem.parentMenubar;
            this.parentMenubarItem.assignMegamenu(this);
            this.firstCategory = _.head(this.categories);
            this.lastCategory = _.last(this.categories);
            // Select the first category
            if (this.firstCategory && this.firstCategory.popup) {
                this.firstCategory.popup.open();
            }
            this.$rootScope.$on('$routeChangeStart', function () {
                _this.shut();
            });
        };
        ScMegamenu.prototype.open = function () {
            var _this = this;
            if (this.isOpen) {
                return;
            }
            // close any open megamenus
            this.parentMenubar.closeMegamenus();
            this.isOpen = true;
            // animate the backdrop
            this.parentMenubar.showBackdrop();
            // animate the megamenu
            this.animating = true;
            this.visible = true;
            this.animationUtil.waitForTransition(this.element).then(function (el) {
                _this.animating = false;
                _this.$document.on("mousedown." + _this.eventNamespace, function (e) {
                    if ($(e.target).closest(_this.parentMenubarItem.element).length === 0) {
                        //console.log('close on doc click');
                        _this.close(true);
                    }
                });
            });
        };
        ScMegamenu.prototype.close = function (animate) {
            var _this = this;
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            if (animate) {
                // animate backdrop
                this.parentMenubar.hideBackdrop(true);
                // animate mega menu
                this.animating = true;
                this.visible = false;
                this.animationUtil.waitForTransition(this.element).then(function (el) {
                    _this.animating = false;
                });
            }
            else {
                // remove backdrop and hide without animating
                this.parentMenubar.hideBackdrop(false);
                this.visible = false;
            }
            this.$document.off("." + this.eventNamespace);
        };
        ScMegamenu.prototype.shut = function () {
            this.close(false);
        };
        ScMegamenu.prototype.addCategory = function (category) {
            // add the item to the array
            this.categories.push(category);
        };
        return ScMegamenu;
    }());
    var ScMegamenuCategory = /** @class */ (function () {
        function ScMegamenuCategory($window) {
            var _this = this;
            this.$window = $window;
            this.hasFocus = false;
            this.linkEvents = {
                'click': function (event) {
                    if (!_this.popup) {
                        return;
                    }
                    if (_this.$window.TRPCONFIG.IsTouchDevice) {
                        // TOUCH BEHAVIOUR
                        //====================
                        _this.popup.open();
                    }
                },
                'focus': function (event) {
                    _this.hasFocus = true;
                },
                'blur': function (event) {
                    _this.hasFocus = false;
                }
            };
            this.itemEvents = {
                'mouseenter': function (event) {
                    if (_this.$window.TRPCONFIG.IsTouchDevice || !_this.popup) {
                        return;
                    }
                    _this.popup.open();
                }
            };
        }
        ScMegamenuCategory.prototype.init = function (element, megamenu) {
            this.element = element;
            this.parentMegamenu = megamenu;
            this.link = this.element.children('a');
            this.link
                .attr('tabIndex', -1);
            this.parentMegamenu.addCategory(this);
        };
        ScMegamenuCategory.prototype.assignPopup = function (popup) {
            this.popup = popup;
        };
        return ScMegamenuCategory;
    }());
    var ScMegamenuCategoryPanel = /** @class */ (function () {
        function ScMegamenuCategoryPanel() {
            this.isOpen = false;
        }
        ScMegamenuCategoryPanel.prototype.init = function (element, megamenuCategory) {
            this.element = element;
            this.parentCategory = megamenuCategory;
            this.parentCategory.assignPopup(this);
        };
        ScMegamenuCategoryPanel.prototype.open = function () {
            if (this.isOpen) {
                return;
            }
            // close any other open categories
            _.each(this.parentCategory.parentMegamenu.categories, function (category) {
                if (category.popup && category.popup.isOpen) {
                    category.popup.close();
                }
            });
            this.isOpen = true;
        };
        ScMegamenuCategoryPanel.prototype.close = function () {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
        };
        return ScMegamenuCategoryPanel;
    }());
    var ScMegamenuLink = /** @class */ (function () {
        function ScMegamenuLink($scope, analytics) {
            this.$scope = $scope;
            this.analytics = analytics;
            this.eventNamespace = 'scmegamenulink';
        }
        ScMegamenuLink.prototype.init = function (element) {
            var _this = this;
            this.element = element;
            this.element.on("click." + this.eventNamespace, function (event) {
                _this.trackNavigation();
            });
            this.$scope.$on('$destroy', this.destroy);
        };
        ScMegamenuLink.prototype.trackNavigation = function () {
            // Mixpanel link tracking
            var data = {};
            _.each(this.trackingPath.split('|'), function (item, index) {
                data["Depth " + (index + 1)] = item;
            });
            this.analytics.track('mixpanel', 'NavMenuClick', data);
        };
        ScMegamenuLink.prototype.destroy = function () {
            this.element.off("." + this.eventNamespace);
        };
        return ScMegamenuLink;
    }());
    angular
        .module('core')
        .directive('scMenubar', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScMenubar,
            controllerAs: 'mb',
            bindToController: {
                label: '@'
            },
            template: "<nav id=\"main-navigation\"\n                          class=\"sc-c-container\">\n                        <ul class=\"sc-c-menubar__list\"\n                            role=\"menubar\"\n                            itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\"\n                            aria-label=\"{{mb.label}}\"\n                            ng-transclude>\n                        </ul>\n                    </nav>",
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    })
        .directive('scMenubarItem', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scMenubar',
            replace: true,
            transclude: true,
            controller: ScMenubarItem,
            controllerAs: 'mbi',
            bindToController: {
                label: '@',
                url: '@',
                target: '@',
                trackingPath: '@',
                hasMegamenu: '='
            },
            template: "<li class=\"sc-c-menubar__item\"\n                        role=\"none\"\n                        ng-mouseenter=\"mbi.itemEvents.mouseenter($event)\"\n                        ng-mouseleave=\"mbi.itemEvents.mouseleave($event)\"\n                        ng-keydown=\"mbi.itemEvents.keydown($event)\">\n                        <a class=\"sc-c-menubar-link\"\n                           role=\"menuitem\"\n                           ng-attr-tabindex=\"{{mbi.hasFocus ? '0' : '-1'}}\"\n                           ng-attr-href=\"{{mbi.url ? mbi.url : '#'}}\"\n                           ng-attr-target=\"{{mbi.target || undefined}}\"\n                           ng-attr-aria-haspopup=\"{{mbi.hasMegamenu || undefined}}\"\n                           ng-attr-aria-expanded=\"{{mbi.hasMegamenu ? mbi.megamenu.isOpen : undefined}}\"\n                           ng-click=\"mbi.linkEvents.click($event)\"\n                           ng-focus=\"mbi.linkEvents.focus($event)\"\n                           ng-blur=\"mbi.linkEvents.blur($event)\">\n                           <i ng-if=\"mbi.hasMegamenu\"\n                              ng-show=\"!mbi.megamenu.isOpen\"\n                              class=\"sc-c-menubar-link__megamenu-icon icon-chevron-down\"></i>\n                           <i ng-if=\"mbi.hasMegamenu\"\n                              ng-show=\"mbi.megamenu.isOpen\"\n                              class=\"sc-c-menubar-link__megamenu-icon icon-chevron-up\"></i>\n                            <span>\n                              {{mbi.label}}\n                            </span>\n                        </a>\n                    </li>",
            link: function (scope, el, attr, menubarCtrl, transcludeFn) {
                scope.mbi.init(el, menubarCtrl);
                // transclude directly to root element
                transcludeFn(scope, function (contents) {
                    angular.forEach(contents, function (node) {
                        el.append(node);
                    });
                });
                scope.isLinkItem = function () {
                    if (scope.mbi.url) {
                        var linkEl = el.children();
                        var labelEl = linkEl.find('span');
                        linkEl.attr('itemprop', 'url');
                        labelEl.attr('itemprop', 'name');
                    }
                };
                scope.isLinkItem();
            }
        };
    })
        .directive('scMegamenu', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scMenubarItem',
            replace: true,
            transclude: true,
            controller: ScMegamenu,
            controllerAs: 'mm',
            bindToController: {
                menuTitle: '@',
                targetSelf: '@',
                url: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=ScMegaMenu',
            link: function (scope, el, attr, menubarItemCtrl) {
                scope.mm.init(el, menubarItemCtrl);
            }
        };
    })
        .directive('scMegamenuCategory', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scMegamenu',
            replace: true,
            transclude: true,
            controller: ScMegamenuCategory,
            controllerAs: 'mmc',
            bindToController: {
                label: '@'
            },
            template: "<li class=\"sc-c-megamenu-categories__item\"\n                         role=\"none\"\n                         ng-mouseenter=\"mmc.itemEvents.mouseenter($event)\">\n                        <a class=\"sc-c-megamenu-categories__button\" \n                           href=\"#\"\n                           role=\"menuitem\"\n                           aria-haspopup=\"true\"\n                           ng-attr-aria-expanded=\"{{mmc.popup.isOpen}}\"\n                           ng-attr-tabindex=\"{{mmc.hasFocus ? '0' : '-1'}}\"\n                           ng-click=\"mmc.linkEvents.click($event)\"\n                           ng-focus=\"mmc.linkEvents.focus($event)\"\n                           ng-blur=\"mmc.linkEvents.blur($event)\">\n                            {{mmc.label}}\n                        </a>\n                        <div class=\"sc-c-megamenu-category-panel\"\n                             ng-class=\"{'open': mmc.popup.isOpen}\"\n                             ng-transclude>\n                        </div>\n                    </div>",
            link: function (scope, el, attr, megamenuCtrl) {
                scope.mmc.init(el, megamenuCtrl);
            }
        };
    })
        .directive('scMegamenuCategoryPanel', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scMegamenuCategory',
            replace: true,
            transclude: true,
            controller: ScMegamenuCategoryPanel,
            controllerAs: 'mmcp',
            template: "<div aria-expanded=\"{{mmcp.isOpen}}\"\n                            ng-transclude>\n                     </div>",
            link: function (scope, el, attr, megamenuCategoryCtrl) {
                scope.mmcp.init(el, megamenuCategoryCtrl);
            }
        };
    })
        .directive('scMegamenuLink', function () {
        return {
            scope: {},
            restrict: 'A',
            controller: ScMegamenuLink,
            controllerAs: 'mml',
            bindToController: {
                trackingPath: '@'
            },
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScStarRating = /** @class */ (function () {
        function ScStarRating($scope) {
            var _this = this;
            this.$scope = $scope;
            this.iconClass = 'icon-star';
            this.$scope.$watch('sr.rating', function (val) {
                if (!(_this.rating > -1)) {
                    return;
                }
                var ceiling = Math.ceil(_this.rating);
                var hasHalf = _this.rating < ceiling;
                if (ceiling) {
                    _this.stars = _.map(new Array(ceiling), function (v, index) {
                        var classes = [];
                        classes.push(_this.iconClass);
                        if (hasHalf && (index === ceiling - 1)) {
                            classes.push('star-rating__half');
                        }
                        return classes;
                    });
                }
            });
        }
        return ScStarRating;
    }());
    angular
        .module('core')
        .directive('scStarRating', function () {
        return {
            scope: {},
            controller: ScStarRating,
            controllerAs: 'sr',
            bindToController: {
                rating: '='
            },
            template: "<span class=\"star-rating\">\n                                <i ng-class=\"r.join(' ')\" ng-repeat=\"r in sr.stars track by $index\"></i>\n                            </span>",
            replace: true
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScSticky = /** @class */ (function () {
        function ScSticky($window, $scope, componentUtil, scrollService) {
            this.$window = $window;
            this.$scope = $scope;
            this.componentUtil = componentUtil;
            this.scrollService = scrollService;
            this.isStuck = false;
            this.eventNamespace = "." + this.componentUtil.getRandomID('sticky-el');
        }
        ScSticky.prototype.init = function (element, attributes) {
            var _this = this;
            this.element = element;
            // Classes
            this.stickyClass = attributes.stickyClass || '';
            $(this.$window).on("scroll" + this.eventNamespace, function () { return _this.checkPosition(); });
            this.$scope.$on('$destroy', function () { return _this.destroy(); });
        };
        ScSticky.prototype.checkPosition = function () {
            if (!this.isStuck) {
                // Get the element's position from the top of the viewport
                var offsetFromTop = this.element.offset().top;
                this.stickingPoint = offsetFromTop;
            }
            if (this.stickingPoint) {
                var scrollbarPosition = this.scrollService.getScrollOffsets(this.$window).y;
                scrollbarPosition > this.stickingPoint
                    ? this.stick()
                    : this.unstick();
            }
        };
        ScSticky.prototype.stick = function () {
            if (this.isStuck) {
                return;
            }
            this.isStuck = true;
            this.$scope.onStick && this.$scope.onStick();
            this.showPlaceholder();
            this.element.addClass(this.stickyClass);
        };
        ScSticky.prototype.unstick = function () {
            if (!this.isStuck) {
                return;
            }
            this.isStuck = false;
            this.$scope.onUnstick && this.$scope.onUnstick();
            this.placeholder && this.placeholder.remove();
            this.element.removeClass(this.stickyClass);
        };
        ScSticky.prototype.showPlaceholder = function () {
            if (!this.placeholder) {
                // create a placeholder which matches the height of the nav bar
                this.placeholder = $('<div>');
                var style = this.$window.getComputedStyle(this.element[0]);
                var height = this.element[0].offsetHeight;
                height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
                this.placeholder.css('height', height + "px");
            }
            this.element.after(this.placeholder);
        };
        ScSticky.prototype.destroy = function () {
            $(this.$window).off(this.eventNamespace);
            this.placeholder && this.placeholder.remove();
        };
        return ScSticky;
    }());
    angular
        .module('core')
        .directive('scStickyEl', function () {
        return {
            restrict: 'A',
            controller: ScSticky,
            controllerAs: 'ctrl',
            scope: {
                onStick: '&',
                onUnstick: '&'
            },
            link: function (scope, el, attr, controller) {
                controller.init(el, attr);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScSvgInline = /** @class */ (function () {
        function ScSvgInline() {
            var _this = this;
            this.setSvgAttributes = function (el, scope) {
                scope.svgHeight ? el.attr('height', scope.svgHeight) : null;
                scope.svgWidth ? el.attr('width', scope.svgWidth) : null;
                scope.svgFill ? el.attr('fill', scope.svgFill) : null;
                scope.class ? el.addClass(scope.class) : null;
                el.unwrap();
            };
            this.link = function (scope, element, attrs) {
                var path = scope.path ? scope.path : '/build/fonts/sandcastle-icons/svgs';
                var url = path + "/" + attrs.name + ".svg";
                scope.svgInline = url;
                scope.callback = function () {
                    var parent = element[0].nextSibling;
                    if (parent !== null && parent instanceof Element) {
                        var childEl = parent.querySelector('svg');
                        var child = angular.element(childEl);
                        var el = angular.element(child);
                        _this.setSvgAttributes(el, scope);
                    }
                };
            };
            this.restrict = 'E';
            this.scope = {
                name: '@',
                svgWidth: '@',
                svgHeight: '@',
                svgFill: '@',
                class: '@',
                path: '@'
            };
            this.replace = true;
            this.template = '<span ng-include="svgInline" onload="callback()"></span>';
        }
        ScSvgInline.factory = function () {
            var directive = function () { return new ScSvgInline(); };
            directive.$inject = [];
            return directive;
        };
        return ScSvgInline;
    }());
    var TR = angular.module('TR');
    TR.directive('scSvgInline', ScSvgInline.factory());
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScTabset = /** @class */ (function () {
        function ScTabset($window, broker, $scope) {
            this.$window = $window;
            this.broker = broker;
            this.$scope = $scope;
            this.tabs = [];
        }
        ScTabset.prototype.init = function (element) {
            var _this = this;
            this.element = element;
            this.firstTab = _.head(this.tabs);
            this.lastTab = _.last(this.tabs);
            this.$scope.$watch('tabset.tabs[0]', function (val) {
                if (!_this.activeTab && val) {
                    _this.selectTab(val);
                }
            });
            // watch "activeTabId" (this can be set programatically)
            this.$scope.$watch('tabset.activeTabId', function (val, old) {
                var tab = angular.isDefined(val)
                    ? _.find(_this.tabs, function (tab) { return tab.tabId === _this.activeTabId; })
                    : _this.tabs[0];
                tab && _this.selectTab(tab);
            });
        };
        ScTabset.prototype.addTab = function (tab) {
            this.tabs.push(tab);
        };
        ScTabset.prototype.selectTab = function (tab) {
            if (this.activeTab) {
                if (tab === this.activeTab) {
                    return;
                }
                this.activeTab.isActive = false;
            }
            tab.isActive = true;
            this.activeTab = tab;
            this.broker.publish('LazySrcRetry');
        };
        ScTabset.prototype.setFocusToTab = function (tab) {
            tab.element.focus();
        };
        ScTabset.prototype.setFocusToPreviousTab = function (tab) {
            var next = tab === this.firstTab
                ? this.lastTab
                : this.tabs[this.tabs.indexOf(tab) - 1];
            this.setFocusToTab(next);
        };
        ScTabset.prototype.setFocusToNextTab = function (tab) {
            var next = tab === this.lastTab
                ? this.firstTab
                : this.tabs[this.tabs.indexOf(tab) + 1];
            this.setFocusToTab(next);
        };
        ScTabset.prototype.setFocusToFirstTab = function () {
            this.setFocusToTab(this.firstTab);
        };
        ScTabset.prototype.setFocusToLastTab = function () {
            this.setFocusToTab(this.lastTab);
        };
        ScTabset.prototype.scrollToView = function (tab) {
            var tablistScroller = this.element.find('.sc-c-tabs__scroller'), scrollLeft = tablistScroller.scrollLeft(), duration = 500, tabOuterWidth = tab.element.outerWidth(), tabOffsetLeft = tab.element.offset().left;
            if ((tabOuterWidth + tabOffsetLeft) > this.$window.innerWidth) {
                scrollLeft += tabOuterWidth;
            }
            if (tabOffsetLeft < 0) {
                scrollLeft -= tabOuterWidth;
            }
            tablistScroller.animate({ scrollLeft: scrollLeft }, duration);
        };
        return ScTabset;
    }());
    var ScTab = /** @class */ (function () {
        function ScTab() {
            var _this = this;
            this.isActive = false;
            this.hasIcon = false;
            this.events = {
                'click': function () {
                    _this.parentTabset.selectTab(_this);
                    _this.parentTabset.scrollToView(_this);
                },
                'keydown': function (event) {
                    switch (event.keyCode) {
                        case TR.KeyCode.SPACE:
                        case TR.KeyCode.RETURN:
                            _this.parentTabset.selectTab(_this);
                            break;
                        case TR.KeyCode.LEFT:
                            _this.parentTabset.setFocusToPreviousTab(_this);
                            break;
                        case TR.KeyCode.RIGHT:
                            _this.parentTabset.setFocusToNextTab(_this);
                            break;
                        case TR.KeyCode.HOME:
                            event.preventDefault();
                            _this.parentTabset.setFocusToLastTab();
                            break;
                        case TR.KeyCode.END:
                            event.preventDefault();
                            _this.parentTabset.setFocusToFirstTab();
                            break;
                        default:
                    }
                }
            };
        }
        ScTab.prototype.init = function (element, tabset, transcludeFn) {
            this.element = element;
            this.parentTabset = tabset;
            // Add tab to the tabset
            this.parentTabset.addTab(this);
            this.transcludeFn = transcludeFn;
            if (this.iconName) {
                this.hasIcon = true;
            }
            if (this.tabId === undefined) {
                throw 'tabId not specified for ScTab';
            }
            this.tabButtonId = "tab--" + this.tabId;
            this.tabPanelId = "tabpanel--" + this.tabId;
        };
        return ScTab;
    }());
    angular
        .module('core')
        .directive('scTabset', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScTabset,
            controllerAs: 'tabset',
            bindToController: {
                title: '@',
                activeTabId: '@',
                fullWidth: '@',
                centered: '@',
                contained: '@',
                large: '@',
                tabsClass: '@'
            },
            template: "<div>\n                        <div \n                            class=\"sc-c-tabs\"\n                            ng-class=\"[\n                                tabset.tabsClass, {\n                                'sc-c-tabs--centered': tabset.centered && !tabset.fullWidth, \n                                'sc-c-tabs--full-width': tabset.fullWidth,\n                                'sc-c-tabs--scrollable': !tabset.fullWidth,\n                                'sc-c-tabs--contained': tabset.contained, \n                              }]\"\n                            >\n                            <div class=\"sc-c-tabs__scroller\">\n                                <div class=\"sc-c-tabs__tablist\"\n                                     role=\"tablist\"\n                                     id=\"{{tabset.title.toLowerCase().replace(' ', '-')}}\"\n                                     ng-attr-aria-label=\"{{tabset.title || undefined}}\"\n                                     ng-transclude>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"sc-c-tab-panel\"\n                             ng-repeat=\"tab in tabset.tabs\"\n                             role=\"tabpanel\"\n                             ng-attr-hidden=\"{{!tab.isActive || undefined}}\"\n                             aria-labelledby=\"{{tab.tabButtonId}}\"\n                             id=\"{{tab.tabPanelId}}\"\n                             tabindex=\"0\"\n                             sc-tab-content-transclude=\"tab\">\n                        </div>\n                    </div>",
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    })
        .directive('scTab', function () {
        return {
            scope: {},
            restrict: 'E',
            require: '^scTabset',
            replace: true,
            transclude: true,
            controller: ScTab,
            controllerAs: 'tab',
            bindToController: {
                heading: '@',
                iconName: '@',
                tabId: '@'
            },
            template: "<button role=\"tab\"\n                             class=\"sc-c-tab\"\n                             ng-class=\"{\n                                 'sc-c-tab--l': tab.parentTabset.large, \n                                 'sc-c-tab--full-width': tab.parentTabset.fullWidth, \n                                 'is-selected': tab.isActive\n                             }\"\n                             ng-click=\"tab.events.click($event)\"\n                             ng-keydown=\"tab.events.keydown($event)\"\n                             id=\"{{tab.tabButtonId}}\"\n                             aria-selected=\"{{tab.isActive}}\"\n                             aria-controls=\"{{tab.tabPanelId}}\"\n                             ng-attr-tabindex=\"{{tab.isActive ? undefined : '-1'}}\">\n                             \n                        <sc-svg-inline \n                            ng-if=\"tab.hasIcon\"\n                            name=\"{{tab.iconName}}\"\n                            class=\"sc-c-tab__icon\" \n                        />\n                        <span class=\"sc-c-tab__label\">{{tab.heading}}</span>\n                    </button>\n                    ",
            link: function (scope, el, attr, tabsetCtrl, transcludeFn) {
                scope.tab.init(el, tabsetCtrl, transcludeFn);
            }
        };
    })
        .directive('scTabContentTransclude', function () {
        return {
            restrict: 'A',
            require: '^scTabset',
            link: function (scope, el, attr) {
                var tab = scope.$eval(attr.scTabContentTransclude);
                tab.transcludeFn(scope, function (contents) {
                    angular.forEach(contents, function (node) {
                        el.append(node);
                    });
                });
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScTextCropper = /** @class */ (function () {
        function ScTextCropper($scope) {
            this.$scope = $scope;
            this.cropped = false;
            this.expanded = false;
        }
        ScTextCropper.prototype.init = function (contentElement) {
            var _this = this;
            setTimeout(function () {
                var contentHeight = contentElement.outerHeight();
                _this.cropped = (contentHeight > _this.height);
            }, 0);
            this.$scope.$watch('ctrl.expanded', function () {
                _this.toggleText = _this.expanded ? _this.lessCaption : _this.moreCaption;
            });
        };
        ScTextCropper.prototype.toggle = function () {
            this.expanded = !this.expanded;
        };
        return ScTextCropper;
    }());
    Core.ScTextCropper = ScTextCropper;
    angular
        .module('core')
        .directive('scTextCropper', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ScTextCropper,
            controllerAs: 'ctrl',
            bindToController: {
                height: '=',
                moreCaption: '@',
                lessCaption: '@',
                align: '@'
            },
            template: "<div class=\"sc-c-content-cropper sc-c-content-cropper--{{ctrl.align}}\"\n                                 ng-class=\"{'is-cropped': ctrl.cropped}\">\n                                <div class=\"sc-c-content-cropper__content\" \n                                        ng-class=\"{'is-cropped': ctrl.cropped}\"\n                                        ng-style=\"!ctrl.expanded && {'max-height': ctrl.height + 'px'}\"\n                                        aria-expanded=\"ctrl.expanded\"\n                                        ng-transclude>\n                                </div>\n                                <div class=\"sc-c-content-cropper__fader\"\n                                    ng-if=\"ctrl.cropped\"\n                                    ng-attr-hidden=\"{{ctrl.expanded || undefined}}\"></div>\n                                <button \n                                    class=\"sc-c-content-cropper__toggle\"\n                                    ng-if=\"ctrl.cropped\"\n                                    ng-click=\"ctrl.toggle()\">\n                                    {{ctrl.toggleText}}\n                                </button>\n                            </div>",
            link: function (scope, el, attr, controller) {
                if (!attr.align) {
                    attr.$set('align', 'center');
                }
                controller.init(el.find('.sc-c-content-cropper__content'));
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ScToggleSwitch = /** @class */ (function () {
        function ScToggleSwitch() {
            var _this = this;
            this.link = function (scope) {
                //Used to apply a unique id to the element for ARIA purposes
                scope.componentId = _this.getRandomID(_this.prefix);
                scope.class = function () {
                    return scope.model === scope.rightVal ? 'c-toggle-switch__checkbox--on' : '';
                };
                scope.toggle = function () {
                    scope.model = (scope.model === scope.leftVal ? scope.rightVal : scope.leftVal);
                };
            };
            this.restrict = 'E';
            this.replace = true;
            this.transclude = true;
            this.scope = {
                model: '=',
                leftVal: '=',
                rightVal: '=',
                leftLabel: '@',
                leftSubtext: '@',
                rightLabel: '@',
                rightSubtext: '@',
            };
            this.template = "<form class=\"c-toggle-switch\">\n                                    <label\n                                        class=\"c-toggle-switch__label\"\n                                        ng-class=\"{'c-toggle-switch__label--active': model === leftVal}\"\n                                        ng-mousedown=\"model = leftVal\"\n                                        aria-controls=\"{{componentId}}\"\n                                        aria-label=\"Toggle for {{leftLabel}}\">\n                                        {{leftLabel}}\n                                        <sub class=\"c-toggle-switch__sublabel\" ng-if=\"leftSubtext\">\n                                            {{leftSubtext}}\n                                        </sub>\n                                    </label>\n                                    <div class=\"c-toggle-switch__container\">\n                                        <input\n                                            id=\"{{componentId}}\"\n                                            class=\"c-toggle-switch__checkbox\"\n                                            type=\"checkbox\"\n                                            ng-class=\"class()\"\n                                            ng-click=\"toggle()\"\n                                            readonly>\n                                        <span class=\"c-toggle-switch__handle\" ng-click=\"toggle()\"></span>\n                                    </div>\n                                    <label\n                                        class=\"c-toggle-switch__label\"\n                                        ng-class=\"{'c-toggle-switch__label--active': model === rightVal}\"\n                                        ng-mousedown=\"model = rightVal\"\n                                        aria-controls=\"{{componentId}}\"\n                                        aria-label=\"Toggle for {{rightLabel}}\">\n                                        {{rightLabel}}\n                                        <sub class=\"c-toggle-switch__sublabel\" ng-if=\"rightSubtext\">\n                                            {{rightSubtext}}\n                                        </sub>\n                                    </label>\n                                 </form>";
            /**
             * Prefix for randomised ID on each directive

             * @private
             */
            this.prefix = 'c-number-picker--';
            /**
             * Generate random ID
             *
             * @param {string} prefix BEMIT formatted identifier. e.g. 'c-component--'
             * @returns {string} Prefix + Random string
             */
            this.getRandomID = function (prefix) {
                return prefix + Math.random().toString(36).substr(2, 7);
            };
        }
        ScToggleSwitch.factory = function () {
            var directive = function () { return new ScToggleSwitch(); };
            directive.$inject = [];
            return directive;
        };
        return ScToggleSwitch;
    }());
    var TR = angular.module('TR');
    TR.directive('scToggleSwitch', ScToggleSwitch.factory());
})(Core || (Core = {}));
var Search;
(function (Search) {
    var SearchOccupancy = /** @class */ (function () {
        function SearchOccupancy() {
            this.Adults = 2;
            this.ChildAges = [];
        }
        return SearchOccupancy;
    }());
    Search.SearchOccupancy = SearchOccupancy;
    var OccupancyConfig = /** @class */ (function () {
        function OccupancyConfig() {
        }
        return OccupancyConfig;
    }());
    Search.OccupancyConfig = OccupancyConfig;
    var DateRange = /** @class */ (function () {
        function DateRange() {
        }
        return DateRange;
    }());
    Search.DateRange = DateRange;
    var Cabin = /** @class */ (function () {
        function Cabin(resource, value, queryStringCode, resourceService) {
            this.resource = resource;
            this.value = value;
            this.queryStringCode = queryStringCode;
            this.resourceService = resourceService;
            this.name = this.resourceService.getDeferred(resource);
        }
        return Cabin;
    }());
    Search.Cabin = Cabin;
})(Search || (Search = {}));
var Search;
(function (Search) {
    var UnifiedSearchType;
    (function (UnifiedSearchType) {
        UnifiedSearchType[UnifiedSearchType["Holidays"] = 1] = "Holidays";
        UnifiedSearchType[UnifiedSearchType["Hotels"] = 2] = "Hotels";
        UnifiedSearchType[UnifiedSearchType["Flights"] = 3] = "Flights";
        UnifiedSearchType[UnifiedSearchType["Transfers"] = 4] = "Transfers";
        UnifiedSearchType[UnifiedSearchType["Cruises"] = 5] = "Cruises";
        UnifiedSearchType[UnifiedSearchType["Marhaba"] = 6] = "Marhaba";
        UnifiedSearchType[UnifiedSearchType["HolidayDeals"] = 7] = "HolidayDeals";
        UnifiedSearchType[UnifiedSearchType["Insurance"] = 8] = "Insurance";
    })(UnifiedSearchType = Search.UnifiedSearchType || (Search.UnifiedSearchType = {}));
    var UnifiedSearchModel = /** @class */ (function () {
        function UnifiedSearchModel() {
        }
        return UnifiedSearchModel;
    }());
    Search.UnifiedSearchModel = UnifiedSearchModel;
})(Search || (Search = {}));
var Search;
(function (Search) {
    var DateRangePicker = /** @class */ (function () {
        function DateRangePicker($scope, $timeout, dateUtil, animationUtil) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.dateUtil = dateUtil;
            this.animationUtil = animationUtil;
            this.enabledDates = {};
            this.durations = [];
            this.datePicker = null;
            this.nextDateToSet = 'start';
            this.localStartDate = undefined;
            this.localEndDate = undefined;
            this.shadowStartDate = undefined;
            this.shadowEndDate = undefined;
            this.duration = 0;
            this.html = $('html');
        }
        DateRangePicker.prototype.init = function (elements) {
            var _this = this;
            this.elements = elements;
            this.$scope.$watch('drp.show', function (val) {
                if (val != null) {
                    if (val) {
                        _this.open();
                    }
                    else {
                        _this.close();
                    }
                }
            });
            // set shadow dates on hover
            // (disabled for touch as it requires the user to press twice to select a date)
            if (!TRPCONFIG.IsTouchDevice) {
                this.elements.datepickerEl.on('mouseover.datetangepicker', 'td.drp-date', function (event) {
                    var $cell = $(event.currentTarget), date = _this.getDateFromCalendarCell($cell);
                    if ($cell.hasClass('ui-datepicker-unselectable')) {
                        _this.resetShadowDates();
                        _this.$scope.$apply(function () {
                            _this.setDuration();
                        });
                        return;
                    }
                    $cell.addClass('hover hover-' + _this.nextDateToSet);
                    if (_this.nextDateToSet === 'start') {
                        _this.shadowStartDate = date;
                        _this.shadowEndDate = undefined;
                    }
                    else {
                        _this.shadowEndDate = date;
                        _this.shadowStartDate = _this.localStartDate;
                    }
                    if (_this.shadowStartDate && _this.shadowEndDate) {
                        _this.durations.length === 0 && _this.highlightShadowDates();
                        _this.$scope.$apply(function () {
                            _this.setDuration();
                        });
                    }
                });
            }
            this.elements.datepickerEl.on('mouseleave.datetangepicker', 'td.drp-date', function (event) {
                var $cell = $(event.currentTarget);
                $cell.removeClass('hover');
            });
            // reset shadow dates when calendar loses hover focus
            this.elements.datepickerEl.on('mouseleave.datetangepicker', 'table.ui-datepicker-calendar', function (event) {
                _this.resetShadowDates();
                _this.$scope.$apply(function () {
                    _this.setDuration();
                });
            });
            // close if overlay is clicked
            this.elements.overlay.on('click.datetangepicker', function (event) {
                _this.$scope.$apply(function () {
                    _this.closeClicked(null);
                });
            });
            this.elements.stage.on('click.datetangepicker', function (event) {
                event.stopPropagation();
            });
            this.$scope.$on('$destroy', function () {
                // unbind event listeners by namespace
                _this.elements.datepickerEl.off('.datetangepicker');
                _this.elements.overlay.off('.datetangepicker');
                _this.elements.stage.off('.datetangepicker');
                _this.html.off('.datetangepicker');
                $(window).unbind('resize');
            });
        };
        DateRangePicker.prototype.highlightShadowDates = function () {
            var _this = this;
            this.elements.datepickerEl.find('.drp-date:not(.ui-datepicker-unselectable)').each(function (i, val) {
                var $cell = $(val);
                var date = _this.getDateFromCalendarCell($cell);
                var isInShadow = _this.shadowStartDate !== undefined
                    && _this.shadowEndDate !== undefined
                    && (date >= _this.shadowStartDate)
                    && (date <= _this.shadowEndDate);
                $cell.toggleClass('in-shadow-range', isInShadow);
            });
        };
        DateRangePicker.prototype.getDateFromCalendarCell = function ($td) {
            // get the date from the css class we set previously
            var match = $td.attr('class').match(/drp-date-\S+/), date = match[0].replace('drp-date-', '');
            return this.dateUtil.parseDate(date);
        };
        DateRangePicker.prototype.setDuration = function () {
            var start = this.localStartDate ? this.localStartDate : this.shadowStartDate, end = this.localEndDate ? this.localEndDate : this.shadowEndDate;
            this.duration = start && end ? this.dateUtil.numberOfNights(start, end) : 0;
        };
        DateRangePicker.prototype.isStartDateEnabled = function (date) {
            var enabled;
            if (this.enabledDates && Object.keys(this.enabledDates).length > 0) {
                var dateStr = this.dateUtil.format(date, 'yyyy-MM-dd');
                enabled = !_.isUndefined(this.enabledDates[dateStr]);
            }
            else {
                enabled = true;
            }
            return enabled;
        };
        DateRangePicker.prototype.applyDatePicker = function (element) {
            var _this = this;
            var options = {
                numberOfMonths: 2,
                dateFormat: 'dd-M-yy',
                firstDay: 1,
                isRTL: TRPCONFIG.Rtl,
                prevText: '',
                nextText: '',
                onSelect: function () {
                    _this.$scope.$apply(function () {
                        var selectedDate = _this.datePicker('getDate');
                        // a date has been selected on the calendar
                        if (_this.nextDateToSet === 'start') {
                            _this.localStartDate = selectedDate;
                            // clear the end date
                            _this.localEndDate = undefined;
                        }
                        else if (_this.nextDateToSet === 'end') {
                            _this.localEndDate = selectedDate;
                        }
                        _this.nextDateToSet = _this.oneWay || _this.nextDateToSet === 'end' ? 'start' : 'end';
                        if (_this.nextDateToSet === 'start') {
                            // a range has now been selected
                            _this.setRange();
                            // timeout allows model to update
                            _this.$timeout(function () { return _this.select(); });
                        }
                    });
                },
                beforeShowDay: function (date) {
                    var selectable;
                    // tag this cell with a class denoting the serialised date
                    var classes = [
                        'drp-date',
                        'drp-date-' + _this.dateUtil.serialiseDate(date)
                    ];
                    if (_this.nextDateToSet === 'start') {
                        // is this a permitted start date?
                        selectable = _this.isStartDateEnabled(date);
                    }
                    else {
                        // is this a permitted end date?
                        selectable = _this.localStartDate !== undefined && date > _this.localStartDate;
                        if (selectable && _this.durations.length > 0) {
                            var duration = _this.dateUtil.numberOfNights(_this.localStartDate, date);
                            selectable = _.includes(_this.durations, duration);
                            selectable && classes.push('valid-duration');
                        }
                    }
                    // set range highlights
                    var isRangeSet = _this.localStartDate && _this.localEndDate, isDateInRange = isRangeSet
                        && _this.localStartDate !== undefined
                        && _this.localEndDate !== undefined
                        && (date >= _this.localStartDate)
                        && (date <= _this.localEndDate);
                    if (isDateInRange) {
                        classes.push('in-range');
                    }
                    if (isDateInRange || (!isRangeSet && _this.localStartDate)) {
                        if (_this.dateUtil.sameDay(date, _this.localStartDate)) {
                            classes.push('start-date');
                        }
                    }
                    if (isDateInRange || (!isRangeSet && _this.localEndDate)) {
                        if (_this.dateUtil.sameDay(date, _this.localEndDate)) {
                            classes.push('end-date');
                        }
                    }
                    return [selectable, classes.join(' ')];
                }
            };
            element.datepicker(options);
            return element.datepicker.bind(element);
        };
        DateRangePicker.prototype.setRange = function () {
            this.startDate = this.dateUtil.serialiseDate(this.localStartDate);
            this.endDate = this.dateUtil.serialiseDate(this.localEndDate);
        };
        DateRangePicker.prototype.open = function () {
            var _this = this;
            if (this.datePicker == null) {
                // create the datepicker if has not been previously opened
                this.datePicker = this.applyDatePicker(this.elements.datepickerEl);
            }
            // ensure the datepicker reflects our model
            this.localStartDate = this.dateUtil.parseDate(this.startDate);
            this.localEndDate = this.oneWay ? undefined : this.dateUtil.parseDate(this.endDate);
            this.nextDateToSet = 'start';
            this.datePicker('option', 'minDate', this.dateUtil.parseDate(this.minDate));
            this.datePicker('option', 'maxDate', this.dateUtil.parseDate(this.maxDate));
            // set the start date to invoke "beforeShowDay" and highlight the initial date range
            this.datePicker('setDate', this.localStartDate);
            this.animationUtil.lockScroll();
            this.elements.overlay.addClass('fade-in');
            this.html.on('keyup.datetangepicker', function (event) {
                // ESCAPE to close
                if (event.which === 27 && _this.show) {
                    _this.$scope.$apply(function () {
                        _this.closeClicked(null);
                    });
                }
            });
        };
        DateRangePicker.prototype.close = function () {
            this.animationUtil.restoreScroll();
            this.elements.overlay.removeClass('fade-in');
            this.html.off('keyup.datetangepicker');
        };
        DateRangePicker.prototype.closeClicked = function (event) {
            if (event) {
                event.preventDefault();
            }
            this.show = false;
            $(window).unbind('resize');
        };
        DateRangePicker.prototype.resetShadowDates = function () {
            this.shadowStartDate = undefined;
            this.shadowEndDate = undefined;
            this.highlightShadowDates();
        };
        DateRangePicker.prototype.resetRange = function (event) {
            event.preventDefault();
            this.localStartDate = undefined;
            this.localEndDate = undefined;
            this.setRange();
            this.nextDateToSet = 'start';
            this.duration = 0;
            this.datePicker('setDate', null);
        };
        return DateRangePicker;
    }());
    angular
        .module('search')
        .directive('dateRangePicker', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: DateRangePicker,
            controllerAs: 'drp',
            bindToController: {
                startDate: '=',
                endDate: '=',
                minDate: '=',
                maxDate: '=',
                enabledDates: '=',
                select: '&',
                show: '=',
                durations: '=',
                oneWay: '=',
            },
            templateUrl: 'partials/search/daterangepicker',
            link: function (scope, el, attr, controller) {
                var elements = {
                    overlay: el,
                    stage: el.find('.date-range-picker'),
                    datepickerEl: el.find('.datepicker-parent')
                };
                controller.init(elements);
            }
        };
    });
})(Search || (Search = {}));
;
var Search;
(function (Search) {
    var DurationPicker = /** @class */ (function () {
        function DurationPicker($scope, $timeout, animationUtil) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.animationUtil = animationUtil;
            this.eventNamespace = 'durationpicker';
            this.options = [3, 4, 7, 10, 14, 21];
            this.html = $('html');
        }
        DurationPicker.prototype.init = function (elements) {
            var _this = this;
            this.elements = elements;
            this.$scope.$watch('dp.show', function (val) {
                if (val != null) {
                    if (val) {
                        _this.open();
                    }
                    else {
                        _this.close();
                    }
                }
            });
            // close if overlay is clicked
            this.elements.overlay.on('click.' + this.eventNamespace, function (event) {
                _this.$scope.$apply(function () {
                    _this.show = false;
                });
            });
            this.elements.durationPicker.on('click.' + this.eventNamespace, function (event) {
                event.stopPropagation();
            });
            this.$scope.$on('$destroy', function () {
                // unbind event listeners by namespace
                _this.elements.overlay.off('.' + _this.eventNamespace);
                _this.elements.durationPicker.off('.' + _this.eventNamespace);
                _this.html.off('.' + _this.eventNamespace);
            });
        };
        DurationPicker.prototype.selectDuration = function (duration) {
            var _this = this;
            // set the model
            this.duration = duration;
            this.$timeout(function () {
                // timeout allows model to update
                _this.select();
            });
        };
        DurationPicker.prototype.open = function () {
            var _this = this;
            this.animationUtil.lockScroll();
            this.elements.overlay
                .addClass('fade-in')
                .removeClass('fade-out');
            this.html.on('keyup.' + this.eventNamespace, function (event) {
                // ESCAPE to close
                if (event.which === 27 && _this.show) {
                    _this.$scope.$apply(function () {
                        _this.show = false;
                    });
                }
            });
        };
        DurationPicker.prototype.close = function () {
            this.elements.overlay
                .addClass('fade-out')
                .removeClass('fade-in');
            this.html.off('.' + this.eventNamespace);
        };
        return DurationPicker;
    }());
    angular
        .module('search')
        .directive('durationPicker', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: DurationPicker,
            controllerAs: 'dp',
            bindToController: {
                duration: '=',
                select: '&',
                show: '='
            },
            templateUrl: 'partials/search/durationpicker',
            link: function (scope, el, attr, controller) {
                var elements = {
                    overlay: el,
                    durationPicker: el.find('.duration-picker')
                };
                controller.init(elements);
            }
        };
    });
})(Search || (Search = {}));
/*
    Handles focus on search unit on small screens
*/
var TR;
(function (TR) {
    var ErrorFocusHandler = /** @class */ (function () {
        function ErrorFocusHandler($scope, $element, $window) {
            this.$scope = $scope;
            this.$element = $element;
            this.$window = $window;
            $scope.$on('flash:error', function (ev, msg) {
                if (msg) {
                    var header = $('#navbarcont');
                    if (header) {
                        var targetHeight = $element.offset().top - header.outerHeight();
                        if ($window.scrollY > targetHeight) {
                            $window.scrollTo(0, targetHeight);
                        }
                    }
                }
            });
        }
        return ErrorFocusHandler;
    }());
    angular
        .module('TR')
        .directive('errorFocusHandler', function () {
        return {
            restrict: 'A',
            controller: ErrorFocusHandler,
            controllerAs: 'ef',
        };
    });
})(TR || (TR = {}));
var Search;
(function (Search) {
    var InputWithIcon = /** @class */ (function () {
        function InputWithIcon($scope) {
            this.$scope = $scope;
            this.eventNamespace = 'inputwithicon';
            this.active = false;
        }
        InputWithIcon.prototype.init = function (el) {
            var _this = this;
            var input = el.find('input');
            //this.iconName && el.addClass('icon-' + this.iconName);
            this.addToggle && el.addClass('toggle');
            if (this.iconName) {
                el.prepend('<span class="field-icon icon-' + this.iconName + '"></span>');
            }
            input.on('focus.' + this.eventNamespace, function () {
                _this.$scope.$apply(function () {
                    el.addClass('with-focus');
                });
            }).on('blur.' + this.eventNamespace, function () {
                _this.$scope.$apply(function () {
                    el.removeClass('with-focus');
                });
            });
            this.$scope.$on('$destroy', function () {
                // unbind event listeners by namespace
                input.off('.' + _this.eventNamespace);
            });
        };
        return InputWithIcon;
    }());
    angular
        .module('search')
        .directive('inputWithIcon', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            transclude: true,
            template: "<div class=\"input-with-icon\" \n                            ng-class=\"{'no-icon': iwi.iconName === ''}\" ng-transclude />",
            controller: InputWithIcon,
            controllerAs: 'iwi',
            bindToController: {
                iconName: '@',
                addToggle: '='
            },
            link: function (scope, el, attr, controller) {
                controller.init(el);
            }
        };
    });
})(Search || (Search = {}));
/* tslint:disable:max-line-length */
/// <reference path='../../core/services/resource.service.ts'/>
var Search;
(function (Search) {
    var IntegratedSearchTab = /** @class */ (function () {
        function IntegratedSearchTab(searchType, tabPanel, titleResource, icons) {
            this.searchType = searchType;
            this.tabPanel = tabPanel;
            this.titleResource = titleResource;
            this.icons = icons;
        }
        return IntegratedSearchTab;
    }());
    var IntegratedSearch = /** @class */ (function () {
        function IntegratedSearch($route, $scope, $q, searchUnitService) {
            var _this = this;
            this.$route = $route;
            this.$scope = $scope;
            this.$q = $q;
            this.searchUnitService = searchUnitService;
            // Private
            this.tabs = [];
            this.prepareTabs();
            // select the initial tab
            $q.when(this.preselectTab
                ? parseInt(this.preselectTab, 10)
                : this.searchUnitService.getLastSearchType()).then(function (result) {
                _this.searchType = result || Search.UnifiedSearchType.Holidays; // todo: this should use a "default search type" config setting
                _this.tabPanel = _this.getTabPanel(_this.searchType);
                //select the first supported tab by default;
                if (!_this.tabPanel) {
                    _this.searchType = _this.tabs[0].searchType;
                    _this.tabPanel = _this.getTabPanel(_this.searchType);
                }
            });
            if (!TRPCONFIG.Domain.NoDatesYetEnabled) {
                this.overrideAllowNoDatesYet = 'false';
            }
        }
        ;
        IntegratedSearch.prototype.getClearForm = function () {
            return !!(TRPCONFIG.Domain.isAgentMode && this.clearFormInAgentMode === 'true');
        };
        IntegratedSearch.prototype.selectTab = function (tab) {
            if (!tab.href) {
                this.searchType = tab.searchType;
                this.tabPanel = tab.tabPanel;
            }
        };
        ;
        IntegratedSearch.prototype.prepareTabs = function () {
            var _this = this;
            var push = function (tab) {
                var isSupported = _.filter(TRPCONFIG.Domain.SupportedProductNames, function (t) { return t === Search.UnifiedSearchType[tab.searchType]; }).length;
                if (isSupported) {
                    tab.isVisible = !_this.includedTabs || _this.includedTabs.indexOf(tab.searchType) > -1;
                    _this.tabs.push(tab);
                }
            };
            push(new IntegratedSearchTab(Search.UnifiedSearchType.Holidays, 'unified', 'SEARCHUNITTITLEHOLIDAYS', ['flights', 'hotels']));
            push(new IntegratedSearchTab(Search.UnifiedSearchType.Hotels, 'unified', 'SEARCHUNITTITLEHOTELS', ['hotels']));
            push(new IntegratedSearchTab(Search.UnifiedSearchType.Flights, 'unified', 'SEARCHUNITTITLEFLIGHTS', ['flights']));
            push(new IntegratedSearchTab(Search.UnifiedSearchType.Transfers, 'transfers', 'SEARCHUNITTITLETRANSFERS', ['transfers']));
            var cruiseTab = new IntegratedSearchTab(Search.UnifiedSearchType.Cruises, 'cruises', 'SEARCHUNITTITLECRUISES', ['cruise']);
            cruiseTab.href = TRPCONFIG.Domain.CruiseRootUrl + "/?utm_source=Cruise%20Button&utm_medium=TR%20Homepage&utm_campaign=Travel%20Republic%20Cruise%20Button";
            push(cruiseTab);
            push(new IntegratedSearchTab(Search.UnifiedSearchType.HolidayDeals, 'holidaydeals', 'MENUDEALS', ['sun']));
            push(new IntegratedSearchTab(Search.UnifiedSearchType.Marhaba, 'marhaba', 'MARHABA', ['marhaba-outline']));
            push(new IntegratedSearchTab(Search.UnifiedSearchType.Insurance, 'insurance', 'INSURANCE', ['insurance']));
        };
        IntegratedSearch.prototype.getTabPanel = function (searchType) {
            var tab = _.find(this.tabs, { searchType: searchType });
            return tab && tab.tabPanel;
        };
        return IntegratedSearch;
    }());
    angular
        .module('search')
        .directive('integratedSearch', function () {
        return {
            scope: {},
            controller: IntegratedSearch,
            controllerAs: 'is',
            bindToController: {
                preselectTab: '@',
                includedTabs: '=?',
                hiddenQueryString: '@',
                fid: '@',
                trackDefaultParameters: '@',
                clearFormInAgentMode: '@',
                overrideAllowNoDatesYet: '@',
                isFlexibleTripType: '=?',
                disableResetOptions: '@?'
            },
            templateUrl: 'partials/search/integratedsearch',
            replace: true,
            restrict: 'E'
        };
    });
})(Search || (Search = {}));
var Search;
(function (Search) {
    var OccupancyPicker = /** @class */ (function () {
        function OccupancyPicker($scope, $route, $timeout, animationUtil, unifiedSearchService) {
            this.$scope = $scope;
            this.$route = $route;
            this.$timeout = $timeout;
            this.animationUtil = animationUtil;
            this.unifiedSearchService = unifiedSearchService;
            this.invalid = false;
            this.ranges = {
                rooms: [],
                childAges: [],
                adults: [],
                children: [],
                adultsInAdditionalRooms: [],
                childrenInAdditionalRooms: []
            };
            this.eventNamespace = 'occupancypicker';
            this.html = $('html');
        }
        OccupancyPicker.prototype.init = function (elements) {
            var _this = this;
            this.elements = elements;
            this.$scope.$watch('op.show', function (val) {
                if (val != null) {
                    if (val) {
                        _this.open();
                    }
                    else {
                        _this.close();
                    }
                }
            });
            this.$scope.$watch('op.localModel', function (val) {
                if (val) {
                    // sanity check each room and sum children
                    _this.children = 0;
                    _.each(val, function (room, index) {
                        room = room || new Search.SearchOccupancy;
                        room.ChildAges = room.ChildAges || [];
                        room.Adults = room.Adults || 2;
                        val[index] = room;
                        _this.children += room.ChildAges.length;
                    });
                    // assume we are no longer invalid
                    _this.invalid = false;
                }
            }, true);
            this.$scope.$on('$destroy', function () {
                // unbind event listeners by namespace
                _this.elements.overlay.off('.' + _this.eventNamespace);
                _this.elements.occupancyPicker.off('.' + _this.eventNamespace);
                _this.html.off('.' + _this.eventNamespace);
            });
        };
        OccupancyPicker.prototype.open = function () {
            var _this = this;
            // ensure that numerical ranges are consistent with the current parameter attribues
            this.setRanges();
            // create a local copy of our model
            this.localModel = _.cloneDeep(this.model);
            this.checkRooms();
            this.animationUtil.lockScroll();
            this.elements.overlay.addClass('fade-in');
            this.html.on('keyup.' + this.eventNamespace, function (event) {
                // ESCAPE to close
                if (event.which === 27 && _this.show) {
                    _this.$scope.$apply(function () {
                        _this.show = false;
                    });
                }
            });
            // close if overlay is clicked
            this.elements.overlay.on('click.' + this.eventNamespace, function (event) {
                _this.$scope.$apply(function () { return _this.closeClicked(null); });
            });
            this.elements.stage.on('click.' + this.eventNamespace, function (event) { return event.stopPropagation(); });
        };
        OccupancyPicker.prototype.checkRooms = function () {
            if (this.maxRooms === 0 && this.localModel.length > 1) {
                // we need to reduce the occupancy array to a single room, summing values therein
                var mergedRoom = new Search.SearchOccupancy;
                mergedRoom.Adults = 0;
                mergedRoom = _.reduce(this.localModel, merge, mergedRoom);
                this.localModel = [mergedRoom];
            }
            function merge(memo, next) {
                memo.Adults += next.Adults;
                memo.ChildAges = memo.ChildAges.concat(next.ChildAges);
                return memo;
            }
        };
        OccupancyPicker.prototype.setRanges = function () {
            this.ranges.rooms = _.range(1, this.maxRooms + 1);
            this.ranges.adults = _.range(1, this.maxAdults + 1);
            this.ranges.adultsInAdditionalRooms = _.range(1, this.maxAdultsInAdditionalRooms + 1);
            this.ranges.children = _.range(0, this.maxChildren + 1);
            this.ranges.childrenInAdditionalRooms = _.range(0, this.maxChildrenInAdditionalRooms + 1);
            this.ranges.childAges = _.range(0, this.maxChildAge + 1);
        };
        OccupancyPicker.prototype.getAdultsPerRoom = function (index) {
            return index === 0 ? this.ranges.adults : this.ranges.adultsInAdditionalRooms;
        };
        OccupancyPicker.prototype.getChidrenPerRoom = function (index) {
            return index === 0 ? this.ranges.children : this.ranges.childrenInAdditionalRooms;
        };
        OccupancyPicker.prototype.close = function () {
            this.animationUtil.restoreScroll();
            this.elements.overlay.removeClass('fade-in');
            this.html.off('.' + this.eventNamespace);
        };
        OccupancyPicker.prototype.closeClicked = function (event) {
            if (event) {
                event.preventDefault();
            }
            this.show = false;
            $(window).unbind('resize');
        };
        OccupancyPicker.prototype.done = function () {
            var _this = this;
            // validate
            if (!this.unifiedSearchService.validateOccupancy(this.localModel)) {
                this.invalid = true;
                return;
            }
            // apply changes from our local model to the true model
            this.model = _.cloneDeep(this.localModel);
            this.$timeout(function () {
                _this.show = false;
            });
        };
        OccupancyPicker.prototype.addRoom = function ($event) {
            // required to prevent unexpected scrolling
            $event.stopPropagation();
            $event.preventDefault();
            this.localModel.push(new Search.SearchOccupancy);
        };
        OccupancyPicker.prototype.removeRoom = function (index, $event) {
            $event.stopPropagation();
            $event.preventDefault();
            this.localModel.splice(index, 1);
        };
        return OccupancyPicker;
    }());
    angular
        .module('search')
        .directive('occupancyPicker', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: OccupancyPicker,
            controllerAs: 'op',
            bindToController: {
                model: '=',
                maxRooms: '=',
                maxAdults: '=',
                maxChildren: '=',
                maxChildAge: '=',
                maxAdultsInAdditionalRooms: '=',
                maxChildrenInAdditionalRooms: '=',
                select: '&',
                show: '='
            },
            templateUrl: 'partials/search/occupancypicker',
            link: function (scope, el, attr, controller) {
                var stage = el.find('.occupancy-picker');
                var elements = {
                    overlay: el,
                    stage: stage,
                    occupancyPicker: stage
                };
                controller.init(elements);
            }
        };
    });
})(Search || (Search = {}));
/* tslint:disable:max-line-length */
/// <reference path='../../core/services/resource.service.ts'/>
/// <reference path='../../core/services/resource.service.ts'/>
var Search;
(function (Search_1) {
    var Tab = /** @class */ (function () {
        function Tab(id, type, name, options) {
            this.id = id;
            this.type = type;
            this.name = name;
            angular.extend(this, options);
        }
        return Tab;
    }());
    var Search = /** @class */ (function () {
        function Search($route, $q, broker, searchUnitService, unifiedSearchService, $scope, destinationService, searchQueryString, $timeout, bd4travel, preferences) {
            var _this = this;
            this.$route = $route;
            this.$q = $q;
            this.broker = broker;
            this.searchUnitService = searchUnitService;
            this.unifiedSearchService = unifiedSearchService;
            this.$scope = $scope;
            this.destinationService = destinationService;
            this.searchQueryString = searchQueryString;
            this.$timeout = $timeout;
            this.bd4travel = bd4travel;
            this.preferences = preferences;
            this.tabs = {
                1: new Tab(1, Search_1.UnifiedSearchType.Holidays, 'holidays', { maxAge: TRPCONFIG.Domain.MaxChildAgeForHolidays }),
                2: new Tab(2, Search_1.UnifiedSearchType.Hotels, 'hotels'),
                3: new Tab(3, Search_1.UnifiedSearchType.Flights, 'flights', { maxAge: TRPCONFIG.Domain.MaxChildAgeForFlights, multiRoomDisabled: true }),
                4: new Tab(4, null, 'transfers', ''),
                5: new Tab(5, null, 'cruises', ''),
                6: new Tab(6, null, 'marhaba', ''),
                7: new Tab(7, null, 'holidayDeals', ''),
                8: new Tab(8, null, 'insurance', '')
            };
            this.allowNoDatesYet = true;
            this.currencyOptions = TRPCONFIG.Domain.CurrencyOptions.split('|');
            this.expandedOptions = false;
            if (TRPCONFIG.Domain.PassThroughSearchToIntegratedSearch) {
                return;
            }
            this.model = this.unifiedSearchService.getDefaultModel();
            this.cabins = searchUnitService.getCabinOptions();
            this.updateNoDatesYet();
            this.airlines = searchQueryString.allAirlines;
            this.supportedTabIds = _.chain(TRPCONFIG.Domain.SupportedProductNames)
                .map(function (name) { return _this.findTabId(name); })
                .filter(function (tabId) { return !!tabId; })
                .value();
            var intersection = this.includedTabIds ? _.intersection(this.supportedTabIds, this.includedTabIds) : this.supportedTabIds;
            this.showTabs = intersection.length > 1;
            var tabIdToSelect = this.getPreselectTabId();
            this.selectTab(tabIdToSelect);
            var clearForm = TRPCONFIG.Domain.isAgentMode && this.clearFormInAgentMode === 'true';
            if (!clearForm) {
                this.unifiedSearchService.getQueryStringValues(this.hiddenQueryString).then(function (queryStringValues) {
                    _this.unifiedSearchService
                        .prepopulateModel(_this.model, queryStringValues)
                        .then(function (m) {
                        if (_this.trackDefaultParameters) {
                            _this.bd4travel.trackInitialParameters(m, _this.trackDefaultParameters);
                        }
                    });
                    _this.expandedOptions = (function () {
                        if (!angular.isUndefined(queryStringValues.expandedOptions)) {
                            return queryStringValues.expandedOptions;
                        }
                        if (TRPCONFIG.Domain.PrefilterAirlineEnabled && _this.model.airlines && _this.model.airlines.length) {
                            return true;
                        }
                        if (TRPCONFIG.Domain.PrefilterDirectFlightsEnabled && _this.model.prefilterDirectFlights) {
                            return true;
                        }
                        return false;
                    })();
                    if (queryStringValues.autoSearch) {
                        if (queryStringValues.sortOrder) {
                            _this.preferences.setHotelSortOrder(parseInt(queryStringValues.sortOrder, 10));
                        }
                        _this.$timeout(function () { return _this.search(true); }, 1000);
                    }
                });
            }
            this.$scope.$watchCollection(function () { return _this.model.destination; }, function (val) {
                //Ensure that destination is always an array.
                if (val && angular.isUndefined(val.length)) {
                    val = _this.model.destination = [val];
                }
                if (val && val[0]) {
                    //This call mutates the destination:
                    _this.destinationService.getDetails(val[0]).then(function (dest) {
                        broker.publish('destinationChanged', dest);
                        _this.loadOutboundDates(_this.model.airports, dest);
                    });
                }
                var searchLookupType = val && val[0] && val[0].searchLookupType;
                _this.updateNoDatesYet(searchLookupType);
            });
            this.$scope.$watchCollection(function () { return _this.model.airports; }, function (val) { return _this.loadOutboundDates(val, _this.model.destination); });
            if (!_.isEmpty(TRPCONFIG.Domain.FixedDepartureAirportOptions)) {
                this.broker.subscribe('holidaySearch', 'departureAirportsChanged', function (v) {
                    var currentAirports = _this.model.airports.reduce(function (acc, airport) {
                        return acc[airport.Code] = airport;
                    }, {});
                    var updatedAirports = v.data.Code.split(',').map(function (code) { return currentAirports[code] || ({ Code: code }); });
                    _this.model.airports = updatedAirports;
                });
            }
            this.broker.subscribe('holidaySearch', 'RegionalContextSelected', function () {
                //reset the preferences when switching between POS
                _this.model.airports = [];
                _this.unifiedSearchService.saveSearchModel(_this.model);
            });
        }
        ;
        Search.prototype.selectTab = function (tabId) {
            this.$scope.$broadcast('flash:hide');
            this.tab = this.tabs[tabId];
            if (this.$route.current && this.$route.current['$$route']) {
                this.$route.current['$$route'].area = this.tab.name;
            }
            this.loadOutboundDates(this.model.airports, this.model.destination);
        };
        ;
        Search.prototype.includeTab = function (tabId) {
            var isIncluded = !this.includedTabIds || !this.includedTabIds.length || this.includedTabIds.indexOf(tabId) >= 0, isSupported = !this.supportedTabIds || !this.supportedTabIds.length || this.supportedTabIds.indexOf(tabId) >= 0;
            return isIncluded && isSupported;
        };
        Search.prototype.getPreselectTabId = function () {
            var _this = this;
            var tabId = this.findTabId(this.preselectTab);
            if (tabId && this.includeTab(tabId)) {
                return tabId;
            }
            return _.find(this.tabs, function (t) { return _this.includeTab(t.id); }).id;
        };
        Search.prototype.findTabId = function (tabNameOrNumber) {
            if (!tabNameOrNumber) {
                return;
            }
            var tabId = parseInt(tabNameOrNumber, 10);
            if (tabId > 0 && this.tabs[tabId]) {
                return tabId;
            }
            tabNameOrNumber = (tabNameOrNumber + '').toLowerCase();
            var tab = _.find(this.tabs, function (t) { return t.name.toLowerCase() === tabNameOrNumber; });
            if (tab) {
                return tab.id;
            }
        };
        Search.prototype.updateNoDatesYet = function (searchLookupType) {
            if (this.overrideAllowNoDatesYet) {
                this.allowNoDatesYet = this.overrideAllowNoDatesYet === 'true';
            }
            else {
                this.allowNoDatesYet = !searchLookupType || searchLookupType === 'hotels';
            }
            if (!this.allowNoDatesYet) {
                this.model.noDatesYet = false;
            }
        };
        Search.prototype.search = function (isAutoSearch) {
            var _this = this;
            return this.destinationService.getDetails(this.model.destination[0]).then(function (dest) {
                return _this.loadOutboundDates(_this.model.airports, dest).then(function () { return dest; });
            }).then(function (dest) {
                //creating a copy of the model to use to run a search.
                var destination = _.assign({}, _this.model.destination[0], dest);
                var model = _.assign({}, _this.model, { destination: [destination] });
                return _this.unifiedSearchService.launchSearch(model, _this.tab.type || Search_1.UnifiedSearchType.Holidays, _this.fid, !isAutoSearch, false, false);
            });
        };
        ;
        Search.prototype.loadOutboundDates = function (airports, destination) {
            var _this = this;
            var getRequest = function () {
                if (_this.tab.id !== 1 && _this.tab.id !== 3) {
                    return _this.$q.when(null);
                }
                if (!airports || !airports.length) {
                    return _this.$q.when(null);
                }
                var DepartureAirportCodes = _.map(airports, function (a) { return a.Code; });
                destination = destination && destination[0] || destination;
                var codes = destination && (destination.Code || destination.DestinationAirports);
                var DestinationAirportCodes = codes && codes.split(',');
                if (DestinationAirportCodes && DestinationAirportCodes.length) {
                    return _this.$q.when({
                        DepartureAirportCodes: DepartureAirportCodes,
                        DestinationAirportCodes: DestinationAirportCodes
                    });
                }
                return _this.$q.when(null);
            };
            return getRequest()
                .then(function (r) { return _this.searchUnitService.loadOutboundDates(r); })
                .then(function (outboundDates) {
                _this.enabledDates = outboundDates;
            });
        };
        return Search;
    }());
    angular
        .module('search')
        .directive('search', function () {
        return {
            scope: {},
            controller: Search,
            controllerAs: 'search',
            bindToController: {
                moreOptions: '=',
                preselectTab: '@',
                overrideAllowNoDatesYet: '@',
                includedTabIds: '=?',
                fid: '=?',
                clearFormInAgentMode: '@',
                hiddenQueryString: '@',
                trackDefaultParameters: '@',
                resetDuration: '=?',
                isFlexibleTripType: '=?',
                disableResetOptions: '@?'
            },
            templateUrl: TRPCONFIG.Domain.PassThroughSearchToIntegratedSearch
                || new RegExp(/[a-z]{3,4}:[a-z]{3,4}/g).test(TRPCONFIG.Domain.RedirectTemplates)
                ? 'partials/search/integrated'
                : 'partials/search/search',
            replace: true,
            restrict: 'E',
        };
    });
})(Search || (Search = {}));
var Core;
(function (Core) {
    var SelectBoxItem = /** @class */ (function () {
        function SelectBoxItem() {
        }
        return SelectBoxItem;
    }());
    var selectBoxItemId = 0;
    var SelectBox = /** @class */ (function () {
        function SelectBox($scope, $document) {
            var _this = this;
            this.$scope = $scope;
            this.$document = $document;
            this.eventNamespace = 'selectbox';
            this.isOpen = false;
            this.isMenuRendered = false;
            this.buttonEvents = {
                'click': function (event) {
                    _this.toggle(event);
                },
                'keydown': function (event) {
                    var preventDefault = true;
                    switch (event.keyCode) {
                        // Tab / Escape
                        case 9:
                        case 27:
                            _this.close();
                            preventDefault = false;
                            break;
                        // Enter
                        case 13:
                            _this.toggle(event);
                            break;
                        // Up
                        case 38:
                            if (event.altKey) {
                                _this.toggle(event);
                            }
                            else {
                                _this.move('prev', event);
                            }
                            break;
                        // Down
                        case 40:
                            if (event.altKey) {
                                _this.toggle(event);
                            }
                            else {
                                _this.move('next', event);
                            }
                            break;
                        // Home / Page Up
                        case 36:
                        case 33:
                            _this.move('first', event);
                            break;
                        // End / Page Down
                        case 35:
                        case 34:
                            _this.move('last', event);
                            break;
                        default:
                            var prev = _this.previousFilter || '';
                            var skip = false;
                            // Support number pad values
                            var character = event.keyCode >= 96 && event.keyCode <= 105 ?
                                (event.keyCode - 96).toString() : String.fromCharCode(event.keyCode);
                            clearTimeout(_this.filterTimer);
                            if (character === prev) {
                                skip = true;
                            }
                            else {
                                character = prev + character;
                            }
                            var matching = _this.filterMenuItems(character);
                            //match = skip && match.index(this.active.next()) !== -1 ?
                            // this.active.nextAll( ".ui-menu-item" ) : match;
                            // If no matches on the current filter, reset to the last character pressed
                            // to move down the menu to the first item that starts with that character
                            if (!matching.length) {
                                character = String.fromCharCode(event.keyCode);
                                matching = _this.filterMenuItems(character);
                            }
                            if (matching.length) {
                                var match = matching[0];
                                _this.select(match);
                                _this.previousFilter = character;
                                _this.filterTimer = setTimeout(function () {
                                    delete _this.previousFilter;
                                }, 1000);
                            }
                            else {
                                delete _this.previousFilter;
                            }
                            //this.menu.trigger(event);
                            preventDefault = false;
                    }
                    preventDefault && event.preventDefault();
                }
            };
            this.menuEvents = {
                'mousedown': function (event) {
                    // Prevent the menu from recieving focus. We want to retain focus on the button.
                    event.preventDefault();
                    var menuItem = $(event.currentTarget);
                    _this.select(menuItem.data('SelectBoxItem'));
                    _this.close();
                },
                'mouseover': function (event) {
                    var menuItem = $(event.currentTarget);
                    _this.setActiveItem(menuItem);
                }
            };
        }
        SelectBox.prototype.init = function (el, attrs) {
            var _this = this;
            this.element = el;
            var id = this.element.attr('id');
            this.ids = {
                element: id,
                button: id + '-button',
                menu: id + '-menu'
            };
            this.drawWrapper();
            this.drawButton();
            this.drawMenu();
            // watch the model
            this.$scope.$watch('sb.model', function (val, old) {
                _this.setButtonText();
                if (_this.isMenuRendered) {
                    _this.setActiveItem(_this.getSelectedMenuItem());
                }
            });
            this.$scope.$on('$destroy', function () {
                // unbind event listeners by namespace
                _this.button.off('.' + _this.eventNamespace);
                _this.menu.off('.' + _this.eventNamespace);
            });
        };
        SelectBox.prototype.drawWrapper = function () {
            var div = $('<div>').addClass('select-box');
            this.element.wrap(div);
            this.wrapper = this.element.parent();
        };
        SelectBox.prototype.drawButton = function () {
            var _this = this;
            // Hide the original select element
            this.element.hide();
            // Create new button
            this.button = $('<span>', {
                class: 'select-box-button',
                tabindex: 0,
                id: this.ids.button,
                role: 'combobox',
                'aria-expanded': 'false',
                'aria-autocomplete': 'list',
                'aria-owns': this.ids.menu,
                'aria-haspopup': 'true',
                title: this.element.attr('title')
            }).insertAfter(this.element);
            var label = $('<span>', {
                class: 'select-box-button-label'
            }).appendTo(this.button);
            // pre-text
            if (this.labelText) {
                $('<span>', {
                    class: 'select-box-pre-text',
                    text: this.labelText + ':'
                }).appendTo(label);
            }
            // dynamic text (matches selected option)
            this.buttonText = $('<span>', {
                class: 'select-box-text'
            }).appendTo(label);
            // // icon
            // if (this.iconName) {
            //     $('<i>', {
            //         class: 'select-box-icon icon-' + this.iconName
            //     }).appendTo(this.button);
            // }
            // assign button event listeners
            _.forEach(this.buttonEvents, function (handler, eventName) {
                _this.button.on(eventName + '.' + _this.eventNamespace, handler);
            });
            this.button.one('focusin', function () {
                // Rendering the menu items when the button receives focus
                _this.refreshMenu();
            });
        };
        SelectBox.prototype.drawMenu = function () {
            var _this = this;
            // Create menu
            this.menu = $('<ul>', {
                'aria-hidden': 'true',
                'aria-labelledby': this.ids.button,
                id: this.ids.menu
            });
            var menuWrap = $('<div>', {
                class: 'select-box-menu'
            })
                .append(this.menu)
                .insertAfter(this.button);
            // assign menu event listeners
            _.forEach(this.menuEvents, function (handler, eventName) {
                _this.menu.on(eventName + '.' + _this.eventNamespace, '.select-box-option', handler);
            });
        };
        SelectBox.prototype.toggle = function (event) {
            if (this.isOpen) {
                this.close();
            }
            else {
                this.open(event);
            }
        };
        SelectBox.prototype.open = function (event) {
            var _this = this;
            this.isOpen = true;
            this.setOpen();
            this.setActiveItem(this.getSelectedMenuItem());
            // close if document is clicked
            this.$document.on('mousedown.' + this.eventNamespace, function (event) {
                if (!_this.isOpen) {
                    return;
                }
                if (!$(event.target).closest('.select-box-menu, #' + _this.ids.button).length) {
                    _this.close();
                }
            });
        };
        SelectBox.prototype.close = function () {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this.setOpen();
            this.$document.off('.' + this.eventNamespace);
        };
        SelectBox.prototype.refreshMenu = function () {
            this.menu.empty();
            // get the native select options
            var options = this.element.find('option');
            this.parseOptions(options);
            this.renderMenu(this.menu, this.selectBoxItems);
            this.menuItems = this.menu.find('.select-box-option');
            // set the active menu item
            var menuItem = this.getSelectedMenuItem();
            this.isMenuRendered = true;
            this.setActiveItem(menuItem);
        };
        SelectBox.prototype.renderMenu = function (ul, items) {
            var _this = this;
            _.each(items, function (item, index) {
                _this.renderItem(ul, item);
            });
        };
        SelectBox.prototype.renderItem = function (ul, item) {
            selectBoxItemId += 1; // unique id across all instances
            // create new menu item
            var li = $('<li>');
            var menuItem = $('<div>', {
                id: 'select-box-option-' + selectBoxItemId,
                role: 'option',
                class: 'select-box-option'
            });
            // set text
            this.setText(menuItem, item.label);
            // tag data
            menuItem.data('SelectBoxItem', item);
            // append to menu
            li.append(menuItem).appendTo(ul);
        };
        SelectBox.prototype.parseOptions = function (options) {
            var _this = this;
            var data = [];
            options.each(function (index, item) {
                data.push(_this.parseOption($(item), index));
            });
            this.selectBoxItems = data;
        };
        SelectBox.prototype.parseOption = function (option, index) {
            var item = new SelectBoxItem;
            item.element = option;
            item.index = index;
            item.value = option.val();
            item.label = option.text();
            item.disabled = option.prop('disabled');
            return item;
        };
        SelectBox.prototype.getSelectedMenuItem = function () {
            // get the menu item corresponding to the native selected option
            return this.menuItems.eq(this.element[0].selectedIndex);
        };
        SelectBox.prototype.setOpen = function () {
            this.button.attr('aria-expanded', String(this.isOpen));
            this.menu.attr('aria-hidden', String(!this.isOpen));
            if (this.isOpen) {
                this.wrapper.addClass('select-box-open');
            }
            else {
                this.wrapper.removeClass('select-box-open');
            }
        };
        SelectBox.prototype.setText = function (element, value) {
            if (value) {
                element.text(value);
            }
            else {
                element.html('&#160;');
            }
        };
        SelectBox.prototype.move = function (direction, event) {
            var index = this.element[0].selectedIndex;
            var current = this.menuItems.eq(index);
            var filter = '.select-box-option';
            var nextIndex = undefined;
            switch (direction) {
                case 'prev':
                    nextIndex = index - 1;
                    break;
                case 'next':
                    nextIndex = index + 1;
                    break;
                case 'first':
                    nextIndex = 0;
                    break;
                case 'last':
                    nextIndex = this.menuItems.length - 1;
                    break;
                default:
            }
            if (nextIndex > -1 && nextIndex < (this.menuItems.length)) {
                var menuItem = this.menuItems.eq(nextIndex);
                this.select(menuItem.data('SelectBoxItem'));
            }
        };
        SelectBox.prototype.setActiveItem = function (menuItem) {
            // highlight this menu item
            var className = 'select-box-option-active';
            this.menuItems.filter('.' + className).removeClass(className);
            menuItem.addClass(className);
            // set the focus index
            var selectBoxItem = menuItem.data('SelectBoxItem');
            this.setAriaActive(selectBoxItem);
        };
        SelectBox.prototype.select = function (item) {
            // Change the native select element
            this.element[0].selectedIndex = item.index;
            // let angular know that the select box has changed programattically
            // this will trigger the model update
            this.element.trigger('change');
        };
        SelectBox.prototype.setAriaActive = function (item) {
            var id = this.menuItems.eq(item.index).attr('id');
            this.button.attr({
                'aria-labelledby': id,
                'aria-activedescendant': id
            });
            this.menu.attr('aria-activedescendant', id);
        };
        SelectBox.prototype.filterMenuItems = function (character) {
            var escapedCharacter = character.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), regex = new RegExp('^' + escapedCharacter, 'i');
            var matching = _.filter(this.selectBoxItems, function (item) {
                return regex.test(item.label);
            });
            return matching;
        };
        SelectBox.prototype.setButtonText = function () {
            // get the selected item from the native control
            var selectBoxItem = this.parseOption(this.element.find('option:selected'), this.element[0].selectedIndex);
            // set the button text
            this.setText(this.buttonText, selectBoxItem.label);
        };
        return SelectBox;
    }());
    angular
        .module('core')
        .directive('selectBox', function () {
        return {
            restrict: 'A',
            scope: {},
            replace: true,
            controller: SelectBox,
            controllerAs: 'sb',
            bindToController: {
                model: '=ngModel',
                labelText: '@labelText',
                iconName: '@iconName'
            },
            link: function (scope, el, attrs, controller) {
                controller.init(el, attrs);
            }
        };
    });
})(Core || (Core = {}));
var Search;
(function (Search) {
    var UnifiedSearch = /** @class */ (function () {
        function UnifiedSearch($route, $routeParams, $q, $scope, broker, searchUnitService, unifiedSearchService, searchQueryString, destinationService, occupancyService, holidayDeals, dateUtil, animationUtil, $timeout, bd4travel, $location) {
            var _this = this;
            this.$route = $route;
            this.$routeParams = $routeParams;
            this.$q = $q;
            this.$scope = $scope;
            this.broker = broker;
            this.searchUnitService = searchUnitService;
            this.unifiedSearchService = unifiedSearchService;
            this.searchQueryString = searchQueryString;
            this.destinationService = destinationService;
            this.occupancyService = occupancyService;
            this.holidayDeals = holidayDeals;
            this.dateUtil = dateUtil;
            this.animationUtil = animationUtil;
            this.$timeout = $timeout;
            this.bd4travel = bd4travel;
            this.$location = $location;
            this.showDatePicker = false;
            this.showOccupancyPicker = false;
            this.clearParams = function () {
                //cleardown query params - as otherwise params will override values search unit values when not necessary
                _this.$location.replace()
                    .search('startDate', null)
                    .search('endDate', null)
                    .search('depAir', null)
                    .search('occ', null)
                    .search('autoSearch', null)
                    .search('cabin', null);
            };
            this.cabinOptions = searchUnitService.getCabinOptions();
            this.currencyOptions = searchUnitService.getCurrencyOptions();
            this.airlineOptions = searchQueryString.allAirlines;
            this.IsRebook = !!$routeParams.BookingRef;
        }
        ;
        UnifiedSearch.prototype.init = function (elements) {
            var _this = this;
            this.elements = elements;
            this.model = this.unifiedSearchService.getDefaultModel();
            this.setSearchType();
            // watch search type
            this.$scope.$watch('us.searchType', function (val, old) {
                if (val !== old) {
                    _this.setSearchType();
                }
            });
            this.$scope.$watchCollection('us.model.destination', _.debounce(function (val) {
                // Watch is debounced because autocompleter selection is causing two updates.
                if (val && val[0]) {
                    // This call mutates the destination
                    _this.destinationService
                        .getDetails(val[0])
                        .then(function (dest) { return _this.addAirportCodeToDestination(dest, _this.searchType); });
                }
                _this.setEnabledDurations();
            }, 200));
            this.$scope.$watchCollection('us.model.airports', function (val) {
                if (val && val[0]) {
                    _this.setEnabledStartDates(_this.model.destination, _this.model.airports);
                }
            });
            this.$scope.$watchCollection('us.model.occupancy', function (val) {
                if (val && val[0]) {
                    _this.occupancyCaption = _this.occupancyService.getOccupancyString(val);
                }
            });
            this.$scope.$watchCollection('us.model.airlines', function (val) {
                if (val.length > 1) {
                    // This search unit only supports a single airline
                    // selection, so just keep the first option.
                    _this.model.airlines.splice(1, 1);
                }
                if (val[0] == null) {
                    // This is result of selecting the "All airlines" option from
                    // the select box control - just remove it.
                    _this.model.airlines.splice(0, 1);
                }
            });
            this.$scope.$watchGroup(['us.model.startDate', 'us.model.endDate'], function (_a) {
                var startDate = _a[0], endDate = _a[1];
                if (startDate && !endDate) {
                    var index = 1;
                    switch (_this.searchType) {
                        case Search.UnifiedSearchType.Hotels:
                            index = 0;
                            break;
                        case Search.UnifiedSearchType.Transfers:
                            index = 2;
                            break;
                        case Search.UnifiedSearchType.Marhaba:
                            index = 3;
                            break;
                    }
                    _this.searchUnitService.endDate(index, null);
                    _this.searchUnitService.startDate(index, startDate);
                    _this.model.endDate = _this.searchUnitService.endDate(index);
                }
            });
            if (this.clearForm !== 'true') {
                // prepopulate the model
                this.unifiedSearchService.getQueryStringValues(this.hiddenQueryString).then(function (result) {
                    var queryStringValues = result;
                    _this.unifiedSearchService
                        .prepopulateModel(_this.model, queryStringValues, _this.disableResetOptions)
                        .then(function (model) {
                        if (_this.trackDefaultParameters) {
                            _this.bd4travel.trackInitialParameters(model, _this.trackDefaultParameters);
                        }
                        if (queryStringValues.autoSearch) {
                            _this.$timeout(function () {
                                _this.search(true);
                                _this.clearParams();
                            }, 1000);
                        }
                    });
                });
            }
        };
        UnifiedSearch.prototype.setSearchType = function () {
            this.$scope.$broadcast('flash:hide');
            // get "area" associated with this search type
            this.areaName = this.unifiedSearchService.getAreaName(this.searchType);
            // get occupancy parameters
            this.occupancyConfig = this.searchUnitService.getOccupancyConfig(this.areaName);
            // get min start date for date range picker
            this.minStartDate = this.searchUnitService.getMinStartDate(this.areaName);
            if (this.$route.current && this.$route.current['$$route']) {
                this.$route.current['$$route'].area = this.areaName;
            }
            // set labels
            this.setLabels();
            this.setEnabledStartDates(this.model.destination, this.model.airports);
        };
        UnifiedSearch.prototype.setEnabledStartDates = function (destination, departureAirports) {
            var _this = this;
            var dest = destination[0];
            if (dest) {
                this.destinationService.getDetails(dest).then(function (enhancedDest) {
                    if (_this.flightIncluded() && departureAirports[0] && enhancedDest) {
                        // get enabled dates
                        var dest_1 = enhancedDest;
                        var DestinationAirportCodes = (dest_1.Code || dest_1.DestinationAirports || '').split(',');
                        if (DestinationAirportCodes && DestinationAirportCodes.length) {
                            var request = {
                                DepartureAirportCodes: _.map(departureAirports, 'Code'),
                                DestinationAirportCodes: DestinationAirportCodes
                            };
                            return _this.searchUnitService.loadOutboundDates(request)
                                .then(function (dates) {
                                _this.enabledStartDates = dates;
                                return dates;
                            });
                        }
                    }
                    _this.enabledStartDates = undefined;
                    return _this.$q.when(null);
                });
            }
        };
        UnifiedSearch.prototype.setEnabledDurations = function () {
            // if (!this.model.destination[0]) {
            //     // limit to holiday deal durations
            //     this.durations = _.clone(this.holidayDeals.DURATIONS);
            // } else {
            //    this.durations.length = 0;
            //}
            this.durations = [];
        };
        UnifiedSearch.prototype.setDuration = function () {
            var start = this.model.startDate, end = this.model.endDate;
            this.model.duration = start && end ? this.dateUtil.numberOfNights(start, end) : 0;
        };
        UnifiedSearch.prototype.setEndDate = function () {
            var d = this.model.duration;
            if (this.model.startDate && d && d > 0) {
                var start = this.dateUtil.parseDate(this.model.startDate);
                this.model.endDate = this.dateUtil.addDays(start, d, true);
            }
        };
        UnifiedSearch.prototype.setLabels = function () {
            this.destinationLabel = this.hotelIncluded() ?
                'UNIFIEDSEARCHDESTINATIONLABEL' : 'UNIFIEDSEARCHDESTINATIONAIRPORTLABEL';
            this.destinationPlaceholder = this.hotelIncluded() ?
                'UNIFIEDSEARCHDESTINATIONPLACEHOLDER' : 'UNIFIEDSEARCHDESTINATIONAIRPORTPLACEHOLDER';
            this.searchTypeName = this.unifiedSearchService.getAreaName(this.searchType);
        };
        UnifiedSearch.prototype.getHotelSearchButtonLabel = function () {
            return this.searchType === Search.UnifiedSearchType.Hotels && this.model.noDatesYet ?
                'FINDHOTELS' : 'SEARCHBUTTONTEXT';
        };
        UnifiedSearch.prototype.addAirportCodeToDestination = function (d, searchType) {
            // if airport code is missing add it (this has started happening with holidays)
            var dest;
            if (searchType !== Search.UnifiedSearchType.Hotels) {
                dest = Object.assign({}, d);
                if (!dest.Code) {
                    dest.Code = d.DestinationAirports.split(',')[0];
                }
                return this.setEnabledStartDates([dest], this.model.airports);
            }
        };
        UnifiedSearch.prototype.search = function (isAutoSearch, isFlexibleTripType) {
            var _this = this;
            this.bd4travel.clearContext();
            var dest;
            return this.destinationService.getDetails(this.model.destination[0])
                .then(function (d) {
                dest = d;
                return _this.addAirportCodeToDestination(d, _this.searchType);
            })
                .then(function () {
                //creating a copy of the model to use to run a search.
                var destination = _.assign({}, _this.model.destination[0], dest);
                var modelCopy = _.assign({}, _this.model, {
                    destination: [destination]
                });
                modelCopy.onewayonly = _this.oneWayFlightIncluded() && _this.model.onewayonly;
                _this.unifiedSearchService.launchSearch(modelCopy, _this.searchType, _this.fid, !isAutoSearch, false, isFlexibleTripType);
            });
        };
        UnifiedSearch.prototype.reset = function () {
            // reset the search unit
            this.model = this.unifiedSearchService.getDefaultModel();
        };
        UnifiedSearch.prototype.selectDestination = function () {
        };
        UnifiedSearch.prototype.selectDateRange = function () {
            this.setDuration();
            this.showDatePicker = false;
        };
        UnifiedSearch.prototype.openDatePicker = function (event) {
            this.showDatePicker = true;
            this.openPicker(event, $('.date-range-picker'), 12, 0);
        };
        UnifiedSearch.prototype.openOccupancyPicker = function (event) {
            this.showOccupancyPicker = true;
            this.openPicker(event, $('.occupancy-picker'), -47, -(2 * event.target.getBoundingClientRect().height) - 15);
        };
        // common function for occupancyPicjer and DatePicker
        UnifiedSearch.prototype.openPicker = function (event, picker, adjust, pixelsForHeightExpand) {
            if (this.hotelOnly()) {
                picker.addClass('hotelOnlyCalendar');
            }
            else {
                picker.removeClass('hotelOnlyCalendar');
            }
            picker.css({
                'opacity': '0'
            });
            setTimeout(function () {
                var winHeight = $(window).height();
                var evTop = event.target.getBoundingClientRect().top;
                var eventHeight = event.target.getBoundingClientRect().height;
                var evTopPlusWin = evTop + picker.outerHeight() + eventHeight +
                    Math.abs(pixelsForHeightExpand);
                if (evTopPlusWin > winHeight) {
                    var scrollAdjust = 0;
                    if (window.innerHeight > picker.outerHeight()) {
                        scrollAdjust = window.innerHeight - picker.outerHeight() -
                            $('.integrated-search-unit').height();
                    }
                    scrollAdjust += pixelsForHeightExpand;
                    $('html,body').animate({ 'scrollTop': $('.integrated-search-unit').offset().top - scrollAdjust + 'px' }, { 'complete': function () {
                            picker.css({
                                'top': adjust + event.target.getBoundingClientRect().top + 'px',
                                'opacity': '1'
                            });
                        }
                    });
                }
                else {
                    picker.css({
                        'top': adjust + event.target.getBoundingClientRect().top + 'px',
                        'opacity': '1'
                    });
                }
            }, 50);
            $(window).resize(function () {
                picker.css({
                    'top': adjust + event.target.getBoundingClientRect().top + 'px'
                });
            });
        };
        UnifiedSearch.prototype.resetDestination = function () {
            this.searchUnitService.setDestination(null, null, null);
            this.searchUnitService.setDestinationAirport(null);
            this.model.destination = [];
        };
        UnifiedSearch.prototype.oneWayFlightIncluded = function () {
            return TRPCONFIG.Domain.OneWayFlightsEnabled && this.searchType === Search.UnifiedSearchType.Flights;
        };
        UnifiedSearch.prototype.flightIncluded = function () {
            return this.searchType === Search.UnifiedSearchType.Flights || this.searchType === Search.UnifiedSearchType.Holidays;
        };
        UnifiedSearch.prototype.hotelIncluded = function () {
            return this.searchType === Search.UnifiedSearchType.Hotels || this.searchType === Search.UnifiedSearchType.Holidays;
        };
        UnifiedSearch.prototype.hotelOnly = function () {
            return this.searchType === Search.UnifiedSearchType.Hotels;
        };
        UnifiedSearch.prototype.flexibleDatesDisabled = function () {
            return TRPCONFIG.Domain2.FlexibleDatesFlowsDisabled.indexOf(Search.UnifiedSearchType[this.searchType]) !== -1;
        };
        UnifiedSearch.prototype.showAirlineFilter = function () {
            return !TRPCONFIG.Domain.HideAirlineFilter;
        };
        return UnifiedSearch;
    }());
    angular
        .module('search')
        .directive('unifiedSearch', function () {
        return {
            scope: {},
            controller: UnifiedSearch,
            controllerAs: 'us',
            bindToController: {
                searchType: '=',
                fid: '=?',
                hiddenQueryString: '@',
                trackDefaultParameters: '@',
                clearForm: '@',
                overrideAllowNoDatesYet: '@',
                isFlexibleTripType: '=?',
                disableResetOptions: '@?'
            },
            templateUrl: 'partials/search/unifiedSearch',
            replace: true,
            restrict: 'E',
            link: function (scope, el, attr, controller) {
                var elements = {
                    container: el
                };
                controller.init(elements);
            }
        };
    });
})(Search || (Search = {}));
var Search;
(function (Search) {
    var SearchQueryString = /** @class */ (function () {
        function SearchQueryString($location, $q, dateUtil, occupancyService, searchUnitService, destinationService, autocompleter) {
            this.$location = $location;
            this.$q = $q;
            this.dateUtil = dateUtil;
            this.occupancyService = occupancyService;
            this.searchUnitService = searchUnitService;
            this.destinationService = destinationService;
            this.autocompleter = autocompleter;
            this.allAirlines = _.map((TRPCONFIG.Domain.PrefilterAirlines || '').split('|').filter(function (val) { return val !== ''; }), function (a) {
                var parts = a.split(',');
                return {
                    Title: parts[0],
                    Code: parts[1],
                    IsPostfilter: parts[2] === '1'
                };
            });
        }
        SearchQueryString.prototype.getQueryStringValues = function (paramsOptional) {
            if (paramsOptional === void 0) { paramsOptional = {}; }
            var params = this.getCompleteParamsObj(paramsOptional);
            var _a = this.applyDatesOffset(params.startdate, params.enddate, params.startoffset, params.duration), startDate = _a.startDate, endDate = _a.endDate;
            return this.$q.all({
                startDate: this.dateUtil.parseDate(startDate),
                endDate: this.dateUtil.parseDate(endDate),
                occupancy: this.occupancyService.parseOccupancyString(params.occ),
                airports: params.depair && params.depair.indexOf(',') > -1
                    ? this.getAirportCodes(params.depair) : this.lookupAirports(params.depair),
                destination: this.getDestination(params),
                cabin: ('cabin' in params) ? this.lookupCabin(params.cabin) : undefined,
                prefilterDirectFlights: params.direct === '1' ? true : params.direct === '0' ? false : undefined,
                autoSearch: params.autosearch === '1',
                expandedOptions: ('expandedoptions' in params) ? params.expandedoptions === '1' : undefined,
                airlines: ('airlines' in params) ? this.lookupAirlines(params.airlines) : undefined,
                prefilterAirlines: ('airlines' in params) ? this.prefilterAirlines(params.airlines) : undefined,
                resetForm: params.resetform === '1' ? true : params.resetform === '0' ? false : undefined,
                sortOrder: parseInt(params.sortorder, 10) > 0 ? parseInt(params.sortorder, 10) : 0,
                dealsOnly: params.dealsonly,
                currency: params.currency && params.currency.toUpperCase(),
            });
        };
        SearchQueryString.prototype.lookupDestination = function (query) {
            if (query) {
                var destObj = this.parseDestinationParam(query);
                return this.destinationService.getDetails(destObj)
                    .then(function (d) { return d ? [d] : undefined; });
            }
        };
        SearchQueryString.prototype.getAirportCodes = function (query) {
            var airports = query.split(',').map(function (prefix) {
                return { Code: prefix };
            });
            return this.$q.when(airports);
        };
        SearchQueryString.prototype.lookupAirports = function (query) {
            if (query) {
                return this.autocompleter.lookup('flights', query).then(function (response) {
                    var firstItem = response.data && response.data[0];
                    var codes = firstItem && response.data[0].Code && response.data[0].Code.split(',');
                    if (codes) {
                        if (codes.length === 1) {
                            return [firstItem];
                        }
                        return _.map(codes, function (c) { return ({ Code: c }); });
                    }
                });
            }
        };
        SearchQueryString.prototype.lookupAirlines = function (query) {
            query = query || '';
            var airlineQueryArray = _.map(query.split(','), function (q) { return ({ Title: q, Code: q, IsPostfilter: undefined }); });
            return this.verifyAirlineModels(airlineQueryArray);
        };
        SearchQueryString.prototype.prefilterAirlines = function (query) {
            query = query || '';
            var prefilterAirlinesArray = _.map(query.split(','), function (q) { return (q); });
            return prefilterAirlinesArray;
        };
        SearchQueryString.prototype.lookupCabin = function (query) {
            var result = _.find(this.searchUnitService.getCabinOptions(), function (c) { return c.queryStringCode === query; });
            return result ? result.value : undefined;
        };
        SearchQueryString.prototype.verifyAirlineModels = function (airlineQueryArray) {
            airlineQueryArray = _.map(airlineQueryArray, function (q) { return ({
                Title: (q.Title || '').toUpperCase(),
                Code: (q.Code || '').toUpperCase(),
                IsPostfilter: q.IsPostfilter
            }); });
            var isInQuery = function (airline) {
                return _.some(airlineQueryArray, function (q) {
                    return airline.Title.toUpperCase() === q.Title || airline.Code === q.Code;
                });
            };
            return _.filter(this.allAirlines, isInQuery);
        };
        SearchQueryString.prototype.getCompleteParamsObj = function (params) {
            var searchParams = this.$location.search();
            if (searchParams.dealsOnly) {
                params.dealsOnly = 1;
            }
            else {
                params = angular.merge(params, searchParams);
            }
            params = _.mapKeys(params, function (value, key) {
                return key.toLowerCase();
            });
            return params;
        };
        SearchQueryString.prototype.parseDestinationParam = function (dest) {
            var parts = dest.split('-');
            return {
                Type: parts[0],
                Id: parts[1],
            };
        };
        SearchQueryString.prototype.getAirportListCodes = function (depair) {
            var depAirpts = depair && depair.split(',') || [];
            return depAirpts.map(function (depAirpt) {
                return depAirpt.toUpperCase().trim();
            });
        };
        SearchQueryString.prototype.getDestination = function (params) {
            return this.$q.all({
                destAir: this.lookupAirports(params.destair),
                dest: this.lookupDestination(params.dest)
            })
                .then(function (_a) {
                var destAir = _a.destAir, dest = _a.dest;
                return destAir || dest;
            });
        };
        SearchQueryString.prototype.applyDatesOffset = function (startDate, endDate, startOffset, duration) {
            if (startOffset && duration) {
                return {
                    startDate: this.dateUtil.format(this.dateUtil.todayPlus(parseInt(startOffset, 10)), 'yyyy-MM-dd'),
                    endDate: this.dateUtil.format(this.dateUtil.addDays(startDate, parseInt(duration, 10)), 'yyyy-MM-dd')
                };
            }
            return { startDate: startDate, endDate: endDate };
        };
        SearchQueryString.prototype.getDeepLinkQSParams = function () {
            var params = this.getCompleteParamsObj({});
            var _a = this.applyDatesOffset(params.startdate, params.enddate, params.startoffset, params.duration), startDate = _a.startDate, endDate = _a.endDate;
            return {
                TenantId: TRPCONFIG.Domain.TenantId,
                DepartureAirports: this.getAirportListCodes(params.depair),
                Cabin: this.lookupCabin(params.cabin),
                CountryCode: TRPCONFIG.Domain.CountryCode.toUpperCase(),
                CultureCode: TRPCONFIG.Domain.CultureCode.toUpperCase(),
                StartDate: startDate,
                EndDate: endDate,
                Rooms: this.occupancyService.parseOccupancyString(params.occ),
                Destination: this.parseDestinationParam(params.dest)
            };
        };
        return SearchQueryString;
    }());
    Search.SearchQueryString = SearchQueryString;
    angular
        .module('search')
        .service('searchQueryString', SearchQueryString);
})(Search || (Search = {}));
var Search;
(function (Search) {
    var SearchUnitService = /** @class */ (function () {
        function SearchUnitService(destinationService, occupancyService, dateUtil, arrayUtil, resourceService, loggingService, $http, $q, broker, $timeout, geo, unadjustedDateFilter, currentUser, preferences, $location) {
            var _this = this;
            this.destinationService = destinationService;
            this.occupancyService = occupancyService;
            this.dateUtil = dateUtil;
            this.arrayUtil = arrayUtil;
            this.resourceService = resourceService;
            this.loggingService = loggingService;
            this.$http = $http;
            this.$q = $q;
            this.broker = broker;
            this.$timeout = $timeout;
            this.geo = geo;
            this.unadjustedDateFilter = unadjustedDateFilter;
            this.currentUser = currentUser;
            this.preferences = preferences;
            this.$location = $location;
            this.dates = [];
            this.url = '/api2/flights/static/';
            this.webUrl = 'website/flights/';
            this.defaultCabin = TRPCONFIG.Domain.DefaultCabin;
            this.pointType = {
                Unknown: 0,
                Airport: 1,
                Location: 2,
                Point: 3,
                Estab: 4,
                Resort: 5
            };
            this.transferTypes = {
                AirportTransfer: 0,
                ResortToResort: 1
            };
            this.direction = 1;
            this.currencyOptions = (TRPCONFIG.Domain.CurrencyOptions || 'GBP|EUR|USD').split('|');
            this.flightRoutes = [];
            this.legs = null;
            this.isMultiSector = false;
            this.isMultiReturning = true;
            this.hotel = 0;
            this.flight = 1;
            this.transfer = 2;
            this.marhaba = 3;
            this.parking = 4;
            this.attractions = 5;
            this.insurance = 6;
            this.setDefaultCabin = function () {
                _this.cabin = _this.defaultCabin;
            };
            this.setDefaultCurrency = function () {
                _this.currency = TRPCONFIG.Domain.CurrencyCode;
            };
            this.getDurationOptions = function () {
                var options = [];
                var mp = TRPCONFIG.Domain.SearchUnitDurationMostPopular;
                for (var n = 0; n < mp.length; n++) {
                    options.push({
                        index: options.length,
                        value: mp[n],
                        label: mp[n] + ' ' + _this.resourceService.get('SEARCHNIGHTS'),
                        group: _this.resourceService.get('SEARCHMOSTPOPULAR')
                    });
                }
                var nn = TRPCONFIG.Domain.SearchUnitDurationNoOfNights;
                for (var p = 0; p < nn.length; p++) {
                    options.push({
                        index: options.length,
                        value: nn[p],
                        label: nn[p] + ' ' + _this.resourceService.get('SEARCHNIGHTS'),
                        group: _this.resourceService.get('SEARCHNOOFNIGHTS')
                    });
                }
                return options;
            };
            this._translateDirection = function (d) {
                return _this.getDirectionStrings()[d];
            };
            this._loadDepartureAirports = function () {
                var domain = TRPCONFIG.Domain;
                _this.clearDepartureAirports();
                _this.availableDepartureAirports = _this.$http.post(_this.url + 'getdepartureairports', {
                    CultureCode: domain.CultureCode,
                    DepartureCountryCode: domain.CountryCode,
                    Destination: _this.destination
                }).then(function (result) {
                    return result.data.Airports;
                });
            };
            this._loadResorts = function (a) {
                _this.resort = null;
                var domain = TRPCONFIG.Domain;
                if (!a) {
                    return _this.$q.reject(_this.resourceService.get('MUSTSELECTAIRPORTFIRST'));
                }
                return _this.$http.get('/api3/transfers/resorts/getbyairport?' + jQuery.param({
                    CultureCode: domain.CultureCode,
                    AirportCode: a.Code,
                    DomainId: domain.DomainId,
                    IncludeHotels: domain.IncludeHotelsInTransfersAutocompleter
                }), {
                    ignoreErrors: true
                }).then(function (result) {
                    return result.data;
                }, angular.noop);
            };
            this.startDate = function (index, val, defaultTime) {
                index = index || 0;
                if (val !== undefined) {
                    _this.dates[index].setStart(val, defaultTime);
                }
                return _this.dates[index].start;
            };
            this.endDate = function (index, val) {
                index = index || 0;
                if (val !== undefined) {
                    _this.dates[index].setEnd(val);
                }
                return _this.dates[index].end;
            };
            this.isStartTimeApprovedByCustomer = function (index, val) {
                index = index || 0;
                if (val) {
                    _this.dates[index].isStartTimeApprovedByCustomer = true;
                }
                return _this.dates[index].isStartTimeApprovedByCustomer;
            };
            this.isEndTimeApprovedByCustomer = function (index, val) {
                index = index || 0;
                if (val) {
                    _this.dates[index].isEndTimeApprovedByCustomer = true;
                }
                return _this.dates[index].isEndTimeApprovedByCustomer;
            };
            this.duration = function (index, val) {
                index = index || 0;
                if (val !== undefined) {
                    _this.dates[index].duration = val;
                }
                return _this.dates[index].duration;
            };
            this.getAirport = function (airportCode) {
                var domain = TRPCONFIG.Domain;
                return _this.$http.post(_this.url + 'getairport', {
                    CultureCode: domain.CultureCode,
                    AirportCode: airportCode
                }).then(function (result) {
                    return result.data.Airport;
                });
            };
            this.getAirports = function () {
                if (_this.allAirports) {
                    _this.$q.when(_this.allAirports);
                }
                var domain = TRPCONFIG.Domain;
                return _this.$http.post('/api3/transfers/airports/get', {
                    CultureCode: domain.CultureCode,
                    DomainId: domain.DomainId
                }).then(function (result) {
                    _this.allAirports = result.data.Airports;
                    return _this.allAirports;
                });
            };
            this.getTerminals = function () {
                if (_this.availableTerminals) {
                    _this.$q.when(_this.availableTerminals);
                }
                return _this.$http.get("/api2/marhaba/terminals/get?cultureCode=" + TRPCONFIG.Domain.CultureCode)
                    .then(function (res) { return res.data.Terminals; });
            };
            this.setTerminal = function (t) {
                _this.terminal = t;
            };
            this.setCabin = function (c) {
                _this.cabin = c;
            };
            this.setCurrency = function (c) {
                _this.currency = c;
            };
            this.getCabin = function () {
                return _this.cabin || _this.defaultCabin;
            };
            this.getCurrency = function () {
                return _this.currency || TRPCONFIG.Domain.CurrencyCode;
            };
            this.getTerminal = function () {
                return _this.terminal || { Id: 0, Name: _this.resourceService.get('SELECTTERMINAL') };
            };
            this.getFlightTypes = function () {
                return [
                    { Id: 1, Name: _this.resourceService.get('ARRIVAL'), Label: _this.resourceService.get('ORIGIN') },
                    { Id: 2, Name: _this.resourceService.get('DEPARTURE'), Label: _this.resourceService.get('DESTINATION') }
                ];
            };
            this.getMarhabaFlightType = function (type) {
                switch (type) {
                    case 1:
                        return 'ARRIVAL';
                    case 2:
                        return 'DEPARTURE';
                }
            };
            this.setFlightType = function (f) {
                _this.flightType = f;
            };
            this.setOneWayFlightEnabled = function (v) {
                _this.oneWayFlightEnabled = v;
            };
            this.isOneWayFlightEnabled = function () {
                return _this.oneWayFlightEnabled;
            };
            this.setStaffRates = function (v) {
                _this.staffRates = v;
            };
            this.getStaffRates = function () {
                return _this.staffRates;
            };
            this.setMarhabaAirport = function (v) {
                _this.marhabaAirport = v;
            };
            this.getMarhabaAirport = function () {
                return _this.marhabaAirport;
            };
            this.getFlightType = function () {
                return _this.flightType || _this.getFlightTypes()[0];
            };
            this.setDestinationAirport = function (a, lr) {
                if (lr === void 0) { lr = false; }
                _this.destinationAirport = a;
                _this.availableResorts = _this.resort = null;
                if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                    _this.setTransferPickUpPoint(a ? {
                        Type: _this.pointType.Airport,
                        Code: a.Code,
                        Description: a.Title
                    } : null);
                }
                if (lr) {
                    _this.availableResorts = _this._loadResorts(a);
                    return _this.availableResorts;
                }
                return _this.$q.when();
            };
            this.getDestinationAirport = function () {
                return _this.destinationAirport;
            };
            this.getOutboundDates = function (mode) {
                return mode === _this.flight ? _this.outboundDates : {};
            };
            //Only used by searches:
            this.loadOutboundDates = function (request) {
                if (!request) {
                    return _this.$q.when();
                }
                return _this.$http.get(_this.webUrl + "departuredates?" + _this.serialiseDatesRequest(request), { cache: true })
                    .then(function (res) {
                    return _this.outboundDates = _this.arrayUtil.toDict(res.data.DepartureDates, function (x) { return x; }, function (x) { return true; });
                });
            };
            this.getDestination = function () {
                return angular.copy(_this.destination);
            };
            this.requiresStartDate = function () {
                return _this.direction === 1 || _this.direction === 2;
            };
            this.requiresEndDate = function () {
                return _this.direction === 1 || _this.direction === 3;
            };
            this.getSearchArea = function () {
                return _this.searchArea;
            };
            this.updateSearchArea = function () {
                if (_this.searchArea) {
                    return _this.geo.getSearchArea().then(function (sa) {
                        return _this.setSearchArea(sa);
                    });
                }
                return _this.$q.when();
            };
            this.setSearchArea = function (sa) {
                _this.searchArea = sa;
                //can either have searchArea set or destination, not both
                if (sa != null) {
                    _this.destination = null;
                }
            };
            this.setDestination = function (d, departureAirportsRequired, enrich) {
                _this.destination = d;
                if (d != null) {
                    _this.searchArea = null;
                }
                if (departureAirportsRequired) {
                    _this._loadDepartureAirports();
                }
                if (enrich) {
                    return _this.destinationService.getDetails(d).then(function (dest) {
                        _this.destination = dest;
                        _this.broker.publish('destinationChanged', dest);
                        return _this.destination;
                    });
                }
                return _this.$q.when(_this.destination);
            };
            this.getDestinationAirports = function (dest) {
                var get = function (d) {
                    if (d) {
                        if (d[0]) {
                            d = d[0];
                        }
                        var code = d.DestinationAirports || d.Code;
                        if (code) {
                            return code.split(',');
                        }
                    }
                };
                return get(dest) || get(_this.getDestinationAirport());
            };
            this.getDepartureAirports = function () {
                return _this.departureAirports;
            };
            this.clearDepartureAirports = function () {
                _this.outboundDates = {};
                _this.departureAirports = [];
                _this.selectedDepartureAirport = null;
            };
            this.getAvailableResorts = function () {
                if (_this.destinationAirport
                    && _this.destinationAirport.Code
                    && _this.destinationAirport.Code.indexOf(',') > -1) {
                    return _this.setDestinationAirport(null, false);
                }
                if (_this.availableResorts == null) {
                    _this.availableResorts = _this._loadResorts(_this.destinationAirport);
                }
                return _this.availableResorts;
            };
            this.getAvailableDepartureAirports = function () {
                var d = _this.$q.defer();
                if (_this.availableDepartureAirports == null) {
                    if (_this.destination == null) {
                        _this.$timeout(function () {
                            d.reject(_this.resourceService.get('MUSTSELECTDESTINATIONFIRST'));
                        }, 0);
                    }
                    else {
                        _this._loadDepartureAirports();
                        return _this.availableDepartureAirports;
                    }
                }
                else {
                    return _this.availableDepartureAirports;
                }
                return d.promise;
            };
            this.setMultipleDepartureAirports = function (airports) {
                if (airports && airports.length) {
                    if (_.isString(airports[0])) {
                        airports = _.map(airports, function (a) { return ({ Code: a, Title: a }); });
                    }
                    var strMulti_1 = _this.resourceService.get('MULTIPLEAIRPORTS'); // '{0} + {1} more'
                    strMulti_1 = String.format(strMulti_1, airports[0].Code, airports.length - 1);
                    _this.setDepartureAirports(
                    // Single entry is unchanged (no initial value arg)
                    airports.reduce(function (prev, curr) { return ({
                        Code: prev.Code + ',' + curr.Code,
                        Title: strMulti_1
                    }); }));
                }
            };
            this.setDepartureAirports = function (airport) {
                if (airport.Code) {
                    _this.departureAirports = airport.Code.split(',');
                    _this.selectedDepartureAirport = _this._setShortTitle(airport);
                    _this.broker.publish('departureAirportsChanged', airport);
                }
                else {
                    _this.loggingService.logError('airport.Code: ' +
                        airport.Code + ' | ' + window.location.href);
                }
            };
            this.getSelectedDepartureAirport = function () {
                return _this.selectedDepartureAirport;
            };
            this._setShortTitle = function (o) {
                if (o.Title) {
                    o.ShortTitle = o.Title.split(',')[0];
                }
                return o;
            };
            this.getDirection = function () {
                return _this.direction;
            };
            this.getDirectionStrings = function () {
                if (!_this.directionStrings) {
                    _this.directionStrings = {
                        1: _this.resourceService.get('RETURN'),
                        2: _this.resourceService.get('AIRPORTTORESORT'),
                        3: _this.resourceService.get('RESORTTOAIRPORT')
                    };
                }
                return _this.directionStrings;
            };
            this.setDirection = function (d) {
                _this.direction = d;
                if (_this.direction === 3) {
                    _this.startDate(_this.transfer, null);
                    return;
                }
                if (_this.direction === 2) {
                    _this.endDate(_this.transfer, null);
                }
            };
            this.setResort = function (r) {
                _this.resort = r;
                if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                    _this.setTransferDropOffPoint(r);
                }
            };
            this.getResort = function () {
                return _this.resort;
            };
            this.getRoute = function () {
                var airport = _this.getDestinationAirport();
                var resort = _this.getResort();
                if (!airport || !resort) {
                    return null;
                }
                return {
                    PickUpPoint: {
                        Type: 1,
                        Code: airport.Code,
                        Description: airport.Title
                    },
                    DropOffPoint: resort
                };
            };
            this.setLocationId = function (l) {
                _this.locationId = l;
                if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                    _this.setTransferDropOffPoint(l ? {
                        Type: _this.pointType.Location,
                        Code: l
                    } : null);
                }
            };
            this.getLocationId = function () {
                return _this.locationId;
            };
            this.getSummary = function (mode) {
                return {
                    Destination: _this.destination && _this.destination.Searchable ?
                        _this.destination.Title : null,
                    DestinationAirport: (mode === _this.marhaba) ?
                        (_this.marhabaAirport ?
                            _this.marhabaAirport.Title : null) :
                        (_this.destinationAirport ?
                            _this.destinationAirport.Title : null),
                    Resort: _this.resort ?
                        _this.resort.Description : null,
                    Departure: _this.selectedDepartureAirport ?
                        _this.selectedDepartureAirport.Title : null,
                    Direction: _this._translateDirection(_this.direction),
                    StartDate: _this.dates[mode].start ?
                        _this.unadjustedDateFilter(_this.dates[mode].start, _this.dates[mode].timeSupport ?
                            'dd MMM yyyy HH:mm' :
                            'dd MMM yyyy') : null,
                    StartMonth: _this.dates[mode].start ?
                        _this.unadjustedDateFilter(_this.dates[mode].start, 'MMM yyyy') : null,
                    EndDate: _this.dates[mode].end ?
                        _this.unadjustedDateFilter(_this.dates[mode].end, _this.dates[mode].timeSupport ?
                            'dd MMM yyyy HH:mm' :
                            'dd MMM yyyy') : null,
                    OccupancyString: _this.occupancyService.getOccupancyString(),
                    PassengerCount: _this.occupancyService.getPassengerCount(),
                    OutboundDates: _this.outboundDates || {},
                    HolidayEnabled: _this.destination ?
                        _this.destination.HolidayEnabled :
                        true,
                    NumericDirection: _this.direction,
                    Terminal: _this.getTerminal().Name,
                    FlightType: _this.getFlightType().Name,
                    Airlines: _.map(_this.airlines, function (a) { return a.Title; }).join(', '),
                    MarhabaAirport: _this.marhabaAirport ?
                        _this.marhabaAirport.Title : null,
                    PolicyType: _this.policyType ? _this.policyType.Name : null,
                    TravelDestination: _this.travelDestination ? _this.travelDestination.Name : null
                };
            };
            this.getUrl = function () {
                return _this.url;
            };
            this.setLegs = function (l) {
                _this.legs = l;
            };
            this.getLegs = function () {
                return _this.legs;
            };
            this.setFlightRoutes = function (routes) {
                _this.flightRoutes = routes.map(function (route) { return ({
                    DepartureAirport: { Code: route.DepartureAirport, Title: route.DepartureAirport },
                    DepartureDate: route.DepartureDate,
                    DestinationAirport: { Code: route.DestinationAirport, Title: route.DestinationAirport }
                }); });
            };
            this.getFlightRoutes = function () {
                return _this.flightRoutes;
            };
            this.setIsMultiSector = function (isMS) {
                _this.isMultiSector = isMS;
            };
            this.getIsMultiSector = function () {
                return _this.isMultiSector;
            };
            this.setIsMultiReturning = function (isMR) {
                _this.isMultiReturning = isMR;
            };
            this.getIsMultiReturning = function () {
                return _this.isMultiReturning;
            };
            this.restoreHotelSearch = function (trip) {
                if (trip && trip.HotelsRequest) {
                    _this.startDate(_this.hotel, trip.HotelsRequest.CheckInDate);
                    _this.endDate(_this.hotel, trip.HotelsRequest.CheckOutDate);
                    _this.occupancyService.setOccupancy(trip.HotelsRequest.Rooms);
                    _this.setCurrency(trip.HotelsRequest.CurrencyCode);
                    if (trip.HotelsRequest.Destination != null) {
                        return _this.setDestination(trip.HotelsRequest.Destination, false, true);
                    }
                    _this.setSearchArea(trip.HotelsRequest.SearchArea);
                }
                return _this.$q.when();
            };
            this.restoreFlightSearch = function (trip) {
                if (trip && trip.FlightsRequest) {
                    _this.startDate(_this.flight, trip.FlightsRequest.DepartureDate);
                    _this.endDate(_this.flight, trip.FlightsRequest.OneWayOnly ?
                        null :
                        trip.FlightsRequest.ReturnDate);
                    _this.occupancyService.setOccupancy([{
                            Adults: trip.FlightsRequest.Adults,
                            ChildAges: trip.FlightsRequest.ChildAges
                        }]);
                    _this.setMultipleDepartureAirports([trip.FlightsRequest.SelectedDepartureAirport]);
                    _this.setDestinationAirport(trip.FlightsRequest.SelectedDestinationAirport);
                    _this.setOneWayFlightEnabled(trip.FlightsRequest.OneWayOnly);
                    _this.setCabin(trip.FlightsRequest.Cabin);
                }
                return _this.$q.when();
            };
            this.restoreMultiFlightSearch = function (trip) {
                if (trip && trip.MultiFlightsRequest) {
                    _this.occupancyService.setOccupancy([{
                            Adults: trip.MultiFlightsRequest.Adults,
                            ChildAges: trip.MultiFlightsRequest.ChildAges
                        }]);
                    _this.setCabin(trip.MultiFlightsRequest.Cabin);
                    _this.setFlightRoutes(trip.MultiFlightsRequest.FlightRoutes);
                    _this.setIsMultiSector(true);
                }
                return _this.$q.when();
            };
            this.restoreTransferSearch = function (trip) {
                if (trip && trip.TransfersRequest) {
                    _this.startDate(_this.transfer, trip.TransfersRequest.ArrivalDate);
                    _this.endDate(_this.transfer, trip.TransfersRequest.ReturnDate);
                    _this.occupancyService.setOccupancy([{
                            Adults: trip.TransfersRequest.Adults,
                            ChildAges: trip.TransfersRequest.ChildAges
                        }]);
                    _this.setDestinationAirport(trip.TransfersRequest.DestinationAirport);
                    _this.setResort({
                        ResortId: trip.TransfersRequest.ResortId,
                        Name: trip.TransfersRequest.ResortTitle
                    });
                    _this.setLocationId(trip.TransfersRequest.LocationId);
                }
                return _this.$q.when();
            };
            this.restoreMarhabaSearch = function (trip) {
                if (trip && trip.MarhabaRequest) {
                    _this.startDate(_this.marhaba, trip.MarhabaRequest.DateAndTime);
                    _this.setTerminal(trip.MarhabaRequest.Terminal);
                    _this.setMarhabaAirport(trip.MarhabaRequest.Airport);
                    _this.occupancyService.setOccupancy([trip.MarhabaRequest.Occupancy]);
                    var ft = _this.getFlightTypes()[trip.MarhabaRequest.FlightType - 1];
                    _this.setFlightType(ft);
                }
                return _this.$q.when();
            };
            this.restoreParkingSearch = function (trip) {
                if (trip && trip.ParkingRequest) {
                    _this.setDepartureAirports(trip.ParkingRequest.Airport);
                    _this.startDate(_this.parking, trip.ParkingRequest.DepartureDate);
                    _this.endDate(_this.parking, trip.ParkingRequest.ReturnDate);
                    _this.occupancyService.setPassengerCount(trip.ParkingRequest.PassengerCount);
                }
                return _this.$q.when();
            };
            this.restoreInsuranceSearch = function (trip) {
                if (trip && trip.InsuranceRequest) {
                    _this.startDate(_this.insurance, trip.InsuranceRequest.StartDate);
                    _this.endDate(_this.insurance, trip.InsuranceRequest.EndDate);
                    _this.setPolicyExtra(trip.InsuranceRequest.PolicyExtras);
                    _this.setPolicyType(trip.InsuranceRequest.PolicyType);
                    _this.setTravelDestination(trip.InsuranceRequest.TravelDestination);
                }
                return _this.$q.when();
            };
            this.getCabinOptions = function () {
                var cabins = [];
                var defaultCabinList = ['ECONOMYCLASS', 'PREMIUMECONOMYCLASS', 'BUSINESSCLASS', 'FIRSTCLASS'];
                var approvedCabinList = TRPCONFIG.Domain.ValidFlightClasses || defaultCabinList;
                return approvedCabinList.map(function (approvedCabin) {
                    var value = undefined;
                    var code = undefined;
                    switch (approvedCabin) {
                        case 'ECONOMYCLASS':
                            value = 1;
                            code = 'e';
                            break;
                        case 'PREMIUMECONOMYCLASS':
                            value = 2;
                            code = 'p';
                            break;
                        case 'BUSINESSCLASS':
                            value = 8;
                            code = 'b';
                            break;
                        case 'FIRSTCLASS':
                            value = 4;
                            code = 'f';
                            break;
                        case 'FLIGHTCLASS':
                            value = -1;
                            code = 'x';
                            break;
                    }
                    return new Search.Cabin(approvedCabin, value, code, _this.resourceService);
                });
            };
            this.getCurrencyOptions = function () {
                return angular.copy(_this.currencyOptions);
            };
            this.chooseSeachUnitModel = function (target, source, service, queryString) {
                return queryString || service || source || target;
            };
            this.getTransferTypeStrings = function () {
                if (!_this.transferTypeStrings) {
                    _this.transferTypeStrings = {
                        0: _this.resourceService.get('TRANSFERTYPE_AIRPORTTORESORT'),
                        1: _this.resourceService.get('TRANSFERTYPE_RESORTTORESORT')
                    };
                }
                return _this.transferTypeStrings;
            };
            this.getTransferType = function () {
                return _this.transferType;
            };
            this.setTransferType = function (t) {
                _this.transferType = t;
            };
            this.setTransferPickUpPoint = function (p) {
                _this.transferPickUpPoint = p;
            };
            this.getTransferPickUpPoint = function () {
                return _this.transferPickUpPoint;
            };
            this.setTransferDropOffPoint = function (d) {
                _this.transferDropOffPoint = d;
            };
            this.getTransferDropOffPoint = function () {
                return _this.transferDropOffPoint;
            };
            this.getMinStartDate = function (areaName) {
                var startDate;
                if (areaName && areaName === 'hotels') {
                    // HOTELS
                    // determine offset
                    var offSetDays = TRPCONFIG.Domain.HotelSearchOffsetDate;
                    if (offSetDays === 0 &&
                        (new Date()).getUTCHours() >= TRPCONFIG.Domain.TimeCutoffForSameDayHotelSearch) {
                        // If we have no offset and the current time exceeds the same day search cutoff,
                        // set min date to next day.
                        offSetDays = 1;
                    }
                    startDate = _this.dateUtil.todayPlus(offSetDays, 0, true);
                }
                else if (areaName && (areaName === 'holidays' || areaName === 'flights')) {
                    // HOLIDAYS or FLIGHTS
                    startDate = _this.dateUtil.todayPlus(_this.getHolidaysSearchOffsetDate(), 0, true);
                }
                else {
                    // default to today
                    startDate = _this.dateUtil.zeroTime(new Date());
                }
                return startDate;
            };
            this.getMinEndDate = function (startDate, areaName) {
                return _this.dateUtil.addDays(startDate, 1, true);
            };
            this.getHolidaysSearchOffsetDate = function () {
                return _this.currentUser.Agent ? 1 : TRPCONFIG.Domain.HolidaysSearchOffsetDate;
            };
            this.getTravelDestinations = function () {
                if (_this.travelDestinations) {
                    return _this.travelDestinations;
                }
                var urlqs = "cultureCode=" + TRPCONFIG.Domain.CultureCode + "&domainId=" + TRPCONFIG.Domain.DomainId;
                _this.travelDestinations = _this.$http.get("/api2/insurance/static/gettraveldestination?" + urlqs)
                    .then(function (res) { return res.data; });
                return _this.travelDestinations;
            };
            this.setTravelDestination = function (t) {
                _this.travelDestination = t;
            };
            this.getTravelDestination = function () {
                return _this.travelDestination;
            };
            this.getPolicyTypes = function () {
                if (_this.policyTypes) {
                    return _this.policyTypes;
                }
                var cc = TRPCONFIG.Domain.CultureCode;
                var id = TRPCONFIG.Domain.DomainId;
                var policyUrl = "/api2/insurance/static/getpolicytype?cultureCode=" + cc + "&domainId=" + id;
                _this.policyTypes = _this.$http.get(policyUrl).then(function (res) { return res.data; });
                return _this.policyTypes;
            };
            this.setPolicyType = function (p) {
                _this.policyType = p;
            };
            this.getPolicyType = function () {
                return _this.policyType;
            };
            this.getPolicyExtras = function () {
                if (_this.policyExtras) {
                    return _this.policyExtras;
                }
                var urlqs = "cultureCode=" + TRPCONFIG.Domain.CultureCode + "&domainId=" + TRPCONFIG.Domain.DomainId;
                _this.policyExtras = _this.$http.get("/api2/insurance/static/getextras?" + urlqs)
                    .then(function (res) { return res.data; });
                return _this.policyExtras;
            };
            this.setPolicyExtra = function (e) {
                _this.policyExtra = e;
            };
            this.getPolicyExtra = function () {
                return _this.policyExtra;
            };
            this.capitalize = function (str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            };
            this.hotelDateRange = new dateUtil.DateRange(null, null, false);
            this.flightHolidayDateRange = TRPCONFIG.Domain.DeviceType === 'Mobile' ?
                new dateUtil.DateRange(null, null, false) :
                this.hotelDateRange;
            this.dates = [
                this.hotelDateRange,
                this.flightHolidayDateRange,
                new dateUtil.DateRange(null, null, true),
                new dateUtil.DateRange(null, null, true),
                new dateUtil.DateRange(null, null, true),
                new dateUtil.DateRange(null, null, false),
                new dateUtil.DateRange(null, null, false) // insurance
            ];
            this.transferType = this.transferTypes.AirportTransfer;
        }
        SearchUnitService.prototype.serialiseDatesRequest = function (req) {
            var destQs = req.DestinationAirportCodes.reduce(function (qs, c) { return qs + "dest=" + c + "&"; }, '');
            var depAndDestQs = req.DepartureAirportCodes.reduce(function (qs, c) { return qs + "dep=" + c + "&"; }, destQs);
            return depAndDestQs.slice(0, -1);
        };
        SearchUnitService.prototype.getArrivalAirports = function () {
            var airports = this.$location.search()['arrAir'];
            if (airports) {
                return airports.split(',');
            }
            return;
        };
        SearchUnitService.prototype.getOccupancyConfig = function (areaName) {
            var config = new Search.OccupancyConfig;
            var limits = TRPCONFIG.Domain.OccupancyLimits[areaName];
            var includesHotel = (areaName === 'holidays' || areaName === 'hotels');
            config.MaxAdults = limits.maxAdults;
            config.MaxChildren = limits.maxChildren;
            config.MaxRooms = includesHotel ? TRPCONFIG.Domain.MaxRoomsForOccupancy : 0;
            config.MaxAdultsInAdditionalRooms = includesHotel ? TRPCONFIG.Domain.MaxAdultsInAdditionalRooms : 0;
            config.MaxChildrenInAdditionalRooms = includesHotel ? TRPCONFIG.Domain.MaxChildrenInAdditionalRooms : 0;
            switch (areaName) {
                case 'holidays':
                    config.MaxChildAge = TRPCONFIG.Domain.MaxChildAgeForHolidays;
                    break;
                case 'flights':
                    config.MaxChildAge = TRPCONFIG.Domain.MaxChildAgeForFlights;
                    break;
                default:
                    config.MaxChildAge = TRPCONFIG.Domain.MaximumChildAge;
            }
            return config;
        };
        SearchUnitService.prototype.getLastSearchType = function () {
            return this.preferences.get('searchType').then();
        };
        return SearchUnitService;
    }());
    Search.SearchUnitService = SearchUnitService;
    angular
        .module('search')
        .service('searchUnitService', SearchUnitService);
})(Search || (Search = {}));
var Search;
(function (Search) {
    var UnifiedSearchService = /** @class */ (function () {
        function UnifiedSearchService($http, $location, $route, $q, searchUnitService, occupancyService, resourceService, sharedSearchUnitService, destinationService, currentDestination, holidayDeals, preferences, tripService, searchQueryString, geo, analytics, fidParser) {
            this.$http = $http;
            this.$location = $location;
            this.$route = $route;
            this.$q = $q;
            this.searchUnitService = searchUnitService;
            this.occupancyService = occupancyService;
            this.resourceService = resourceService;
            this.sharedSearchUnitService = sharedSearchUnitService;
            this.destinationService = destinationService;
            this.currentDestination = currentDestination;
            this.holidayDeals = holidayDeals;
            this.preferences = preferences;
            this.tripService = tripService;
            this.searchQueryString = searchQueryString;
            this.geo = geo;
            this.analytics = analytics;
            this.fidParser = fidParser;
        }
        UnifiedSearchService.prototype.getSearchMessage = function (type) {
            var msg = '';
            switch (type) {
                case Search.UnifiedSearchType.Holidays:
                    msg = 'SEARCHINGFLIGHTSANDHOTELS';
                    break;
                case Search.UnifiedSearchType.Hotels:
                    msg = 'SEARCHINGHOTELS';
                    break;
                case Search.UnifiedSearchType.Flights:
                    msg = 'SEARCHINGFLIGHTS';
                    break;
                default:
            }
            return msg;
        };
        UnifiedSearchService.prototype.getAreaName = function (type) {
            var name = '';
            switch (type) {
                case Search.UnifiedSearchType.Holidays:
                    name = 'holidays';
                    break;
                case Search.UnifiedSearchType.Hotels:
                    name = 'hotels';
                    break;
                case Search.UnifiedSearchType.Flights:
                    name = 'flights';
                    break;
                default:
            }
            return name;
        };
        UnifiedSearchService.prototype.populateSearchUnitService = function (model) {
            var destination = model.destination;
            if (destination && destination[0] && Object.keys(destination[0]).length !== 0) {
                this.searchUnitService.setDestination(destination[0]);
                this.searchUnitService.setDestinationAirport(destination[0]);
            }
            model.airports && this.searchUnitService.setMultipleDepartureAirports(model.airports);
            model.startDate && this.searchUnitService.startDate(this.searchUnitService.flight, model.startDate);
            model.endDate && this.searchUnitService.endDate(this.searchUnitService.flight, model.endDate);
            model.occupancy && this.occupancyService.setOccupancy(model.occupancy);
            model.currency && this.searchUnitService.setCurrency(model.currency);
            model.cabin && this.searchUnitService.setCabin(model.cabin);
        };
        UnifiedSearchService.prototype.populateModelFromSearchUnitService = function (trip, model) {
            if (trip) {
                if (trip.HotelsRequest) {
                    model.destination[0] = this.searchUnitService.getDestination();
                }
                else if (trip.FlightsRequest) {
                    model.destination[0] = this.searchUnitService.getDestinationAirport();
                }
                if (trip.FlightsRequest) {
                    var filterCriteriaAirline = trip.FlightsRequest.FilterCriteria
                        && trip.FlightsRequest.FilterCriteria.Airline;
                    var airlines = _.union(filterCriteriaAirline, trip.FlightsRequest.PreferredCarrierCodes).join(',');
                    if (TRPCONFIG.Domain2.NoAirlinesResetOnSearchPanelFixEnabled) {
                        model.airlines = airlines ? this.searchQueryString.lookupAirlines(airlines) : model.airlines;
                    }
                    else {
                        model.airlines = this.searchQueryString.lookupAirlines(airlines);
                    }
                }
            }
            if (trip.TripType === this.tripService.tripTypes.MultiDestHoliday) {
                // API populates multiple FlightRequests with SelectedDepartureAirport by user's IP
                var flightRequests = trip.MultiDestinationFlightRequests;
                var first = flightRequests && flightRequests[0];
                if (first) {
                    this.searchUnitService.setDepartureAirports(first.SelectedDepartureAirport);
                }
            }
            var airports = this.searchUnitService.getDepartureAirports();
            model.airports = (model.domainId === TRPCONFIG.Domain.DomainId)
                ? _.map(airports, function (a) { return ({ Code: a }); })
                : [];
            model.startDate = this.searchUnitService.startDate();
            model.endDate = this.searchUnitService.endDate();
            model.occupancy = this.occupancyService.getOccupancy();
            model.currency = this.searchUnitService.getCurrency();
            model.cabin = this.searchUnitService.getCabin();
            if (typeof this.searchUnitService.flexibleDates === 'boolean') {
                model.flexibleDates = this.searchUnitService.flexibleDates;
            }
        };
        UnifiedSearchService.prototype.launchSearch = function (model, searchType, fid, savePreferences, allowDealsSearch, isFlexibleTripType) {
            var _this = this;
            model.domainId = TRPCONFIG.Domain.DomainId;
            if (savePreferences) {
                this.saveSearchModel(model);
                this.saveSearchType(searchType);
            }
            if (allowDealsSearch && (searchType === Search.UnifiedSearchType.Holidays && !model.destination[0])) {
                // shortcircuit into holiday deals funnel
                this.holidayDealsSearch(model);
                return;
            }
            var areaName = this.getAreaName(searchType);
            this.sharedSearchUnitService.lockScreen(this.getSearchMessage(searchType), areaName + '-searchDirective');
            this.populateSearchUnitService(model);
            var modelCopy = angular.copy(model);
            var callSearch = function (options) {
                options.areaOverride = areaName;
                options.fid = fid || _this.fidParser.parse();
                options.fbt = _this.$location.search().boardType;
                _this.sharedSearchUnitService.search(undefined, _this.sharedSearchUnitService.showErrors, options, modelCopy, isFlexibleTripType);
            };
            var options;
            switch (searchType) {
                case Search.UnifiedSearchType.Holidays:
                    if (modelCopy.destination && this.destinationService.destinationIsCountry(modelCopy.destination)) {
                        delete modelCopy.destination;
                    }
                    options = this.prepareFlightSearchOptions(modelCopy);
                    callSearch(options);
                    break;
                case Search.UnifiedSearchType.Hotels:
                    if (TRPCONFIG.Domain.NoDatesYetEnabled && modelCopy.noDatesYet) {
                        if (modelCopy.destination && modelCopy.destination[0]) {
                            // navigate to destination page
                            this.$location.path(modelCopy.destination[0].PagePath);
                        }
                        else {
                            this.sharedSearchUnitService.showErrors([this.resourceService.get('SELECTDESTINATION')]);
                        }
                    }
                    else {
                        callSearch({ defaultFilters: true });
                    }
                    break;
                case Search.UnifiedSearchType.Flights:
                    options = this.prepareFlightSearchOptions(modelCopy);
                    callSearch(options);
                    break;
                default:
            }
        };
        UnifiedSearchService.prototype.holidayDealsSearch = function (model) {
            // convert model to deals search format
            var params = {
                airportsCodes: model.airports,
                startDate: model.startDate,
                duration: model.duration,
                occupancy: model.occupancy
            };
            // mixpanel tracking
            this.analytics.track('mixpanel', 'Search', {
                Nights: params.duration,
                DepartureAirports: params.airportsCodes,
                TypeTitle: 'Holiday Deals',
                FromDate: { Date: params.startDate },
                Rooms: params.occupancy
            });
            //if (!_validateParameters(params)) { return; }
            var serialised = this.holidayDeals.serialiseParameters(params, false);
            this.sharedSearchUnitService.lockScreen('SEARCHINGDEALS');
            for (var param in serialised) {
                this.$location.search(param, serialised[param]);
            }
            this.$location.path("/holidaydeals");
        };
        UnifiedSearchService.prototype.prepareFlightSearchOptions = function (model) {
            var options = {};
            options.onewayonly = model.onewayonly;
            options.flexibleDates = TRPCONFIG.Domain.FlexibleDatesEnabled ? model.flexibleDates : true;
            options.prefilterDirectFlights = TRPCONFIG.Domain.PrefilterDirectFlightsEnabled
                && model.prefilterDirectFlights;
            var isPrefilter = TRPCONFIG.Domain.PrefilterAirlineEnabled && !_.some(model.airlines, function (a) { return a.IsPostfilter; });
            options.prefilterAirlines = isPrefilter ? _.map(model.airlines, function (a) { return a.Code; }) : [];
            options.postfilterAirlines = !isPrefilter ? _.map(model.airlines, function (a) { return a.Title; }) : [];
            return options;
        };
        UnifiedSearchService.prototype.prepopulateModel = function (model, queryStringValues, disableResetOptions) {
            var _this = this;
            var tripId = this.$route.current &&
                this.$route.current.params &&
                this.$route.current.params.tripId;
            var currentDestination = this.currentDestination.getCurrentDestination({ useSearchUnitService: false });
            var searchableDestination = this.getSearchableDestination(currentDestination);
            return this.$q.all({
                searchableDestination: searchableDestination,
                preferences: queryStringValues.resetForm ? null : this.preferences.get('search'),
                trip: this.tripService.restoreSearchUnit(tripId)
            }).then(function (_a) {
                var searchableDestination = _a.searchableDestination, preferences = _a.preferences, trip = _a.trip;
                if (!model.destination || !model.destination[0]) {
                    model.destination = [];
                    if (preferences && !angular.isString(preferences)) {
                        var searchArea = _this.sharedSearchUnitService.getAreaInfo();
                        if (searchArea && searchArea.mode && !queryStringValues.dealsOnly) {
                            preferences.startDate = _this.searchUnitService.startDate(searchArea.mode)
                                || preferences.startDate;
                            preferences.endDate = _this.searchUnitService.endDate(searchArea.mode)
                                || preferences.endDate;
                        }
                        angular.extend(model, _.omit(preferences, ['domainId'])); //ensure the domainID is preserved
                        model.noDatesYet = false;
                        model.airlines = _this.searchQueryString.verifyAirlineModels(model.airlines);
                    }
                    if (trip) {
                        _this.populateModelFromSearchUnitService(trip, model);
                    }
                }
                if (!disableResetOptions && TRPCONFIG.Domain2.ClearSearchPanelOptionsEnabled) {
                    model.airlines = [];
                    model.prefilterDirectFlights = false;
                    model.flexibleDates = false;
                    model.cabin = 1;
                    model.noDatesYet = false;
                    if (!searchableDestination) {
                        model.destination = [];
                        // workaround to clear destination, because validation should fail with empty destination
                        _this.searchUnitService.setDestination(null, null, null);
                        _this.searchUnitService.setDestinationAirport(null);
                    }
                }
                if (searchableDestination && _.some(searchableDestination, function (value) { return value; })) {
                    model.destination[0] = searchableDestination;
                }
                _(['airports', 'startDate', 'endDate', 'occupancy', 'cabin', 'destination', 'currency'])
                    .forEach(function (key) {
                    var value = queryStringValues[key];
                    if (value) {
                        model[key] = value;
                    }
                });
                if (model.domainId !== TRPCONFIG.Domain.DomainId) {
                    model.airports = [];
                }
                _.forEach(['airlines', 'prefilterDirectFlights'], function (key) {
                    var value = queryStringValues[key];
                    if (!angular.isUndefined(value)) {
                        model[key] = value;
                    }
                });
                if (TRPCONFIG.Domain.EnableNearestDepartureAirports) {
                    if (!model.airports || !model.airports.length) {
                        _this.geo.getNearestAirports().then(function (airports) {
                            if (airports && (!model.airports || !model.airports.length)) {
                                model.airports = airports;
                            }
                        });
                    }
                }
                var currencyOptions = _this.searchUnitService.getCurrencyOptions();
                if (model.currency && currencyOptions.indexOf(model.currency) === -1) {
                    model.currency = TRPCONFIG.Domain.CurrencyCode;
                }
                return model;
            });
        };
        UnifiedSearchService.prototype.getSearchableDestination = function (destinationPromise) {
            var _this = this;
            return destinationPromise.then(function (destination) {
                if (!destination || destination.Searchable !== false || !destination.Type || !destination.Id) {
                    return destination;
                }
                var childDestinationPromise = _this.$http.get('/api2/destination/v2/gettopchildrenV2', {
                    params: {
                        Count: 1,
                        CultureCode: TRPCONFIG.Domain.CultureCode,
                        DomainId: TRPCONFIG.Domain.DomainId,
                        PageStrand: destination.PageStrand,
                        Type: destination.Type,
                        Id: destination.Id,
                    },
                    ignoreErrors: true,
                })
                    .then(function (response) { return response.data[0]; })
                    .then(_this.destinationService.enhanceLegacyDestination)
                    .then(_this.destinationService.getDetails);
                return _this.getSearchableDestination(childDestinationPromise);
            });
        };
        UnifiedSearchService.prototype.getDefaultModel = function () {
            var model = new Search.UnifiedSearchModel;
            model.occupancy = [new Search.SearchOccupancy()];
            model.cabin = TRPCONFIG.Domain.DefaultSelectedFlightCabin || 1;
            model.destination = [];
            model.airports = [];
            model.airlines = [];
            model.flexibleDates = !TRPCONFIG.Domain.isAgentMode;
            model.prefilterDirectFlights = false;
            model.onewayonly = false;
            model.duration = 0;
            model.domainId = TRPCONFIG.Domain.DomainId;
            model.currency = TRPCONFIG.Domain.CurrencyCode;
            return model;
        };
        UnifiedSearchService.prototype.getQueryStringValues = function (hiddenQueryString) {
            var params = {};
            _.forEach((hiddenQueryString || '').split('&'), function (x) {
                var parts = x.split('=');
                params[parts[0]] = parts[1];
            });
            return this.searchQueryString.getQueryStringValues(params);
        };
        UnifiedSearchService.prototype.saveSearchModel = function (model) {
            this.preferences.set('search', model);
        };
        UnifiedSearchService.prototype.saveSearchType = function (searchType) {
            this.preferences.set('searchType', searchType);
        };
        UnifiedSearchService.prototype.validateOccupancy = function (occupancy) {
            // check child ages are set
            var childAges = [];
            _.each(occupancy, function (o) {
                childAges = _.concat(childAges, o.ChildAges);
            });
            var isValidOccupancy = _.every(childAges, function (ca) { return typeof ca !== 'undefined'; });
            return isValidOccupancy;
        };
        return UnifiedSearchService;
    }());
    Search.UnifiedSearchService = UnifiedSearchService;
    angular
        .module('search')
        .service('unifiedSearchService', UnifiedSearchService);
})(Search || (Search = {}));
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .controller('SharedSearchUnit', SharedSearchUnit);
    function SharedSearchUnit(sharedSearchUnitService) {
        var su = this;
        su.showErrors = function (errors) { return sharedSearchUnitService.showErrors(errors); };
        su.lockScreen = function (searchMsg) { return sharedSearchUnitService.lockScreen(searchMsg); };
        su.unlockScreen = function () { return sharedSearchUnitService.unlockScreen(); };
    }
})();
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .directive('datesSearchUnit', datesSearchUnit);
    function datesSearchUnit(searchUnitService, sharedSearchUnitService, dateUtil, $window, $route) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                startDate: '=',
                endDate: '=?',
                startDateLabel: '@',
                endDateLabel: '@',
                isStartTimeApprovedByCustomer: '=?',
                isEndTimeApprovedByCustomer: '=?',
                requiresTimeApproval: '=?',
                enabledDates: '=',
                oneWay: '=',
                outboundOnly: '=',
                returnOnly: '=',
                showTime: '=',
                defaultTime: '=',
                templateOverride: '@',
                areaOverride: '@',
                select: '&',
                resetDuration: '=?'
            },
            templateUrl: function (tElement, tAttrs) { return "partials/" + (tAttrs.templateOverride || 'searchunit/dates'); },
            controller: 'SharedSearchUnit',
            link: _linker
        };
        function _linker(scope) {
            var currentArea;
            var dateLimits = {};
            var halt = scope.$watch('startDate', function (val) {
                if (val === undefined) {
                    return;
                }
                updateMinDates();
                halt();
            });
            updateCurrentArea(getAreaOverride());
            scope.$watch(getAreaOverride, updateCurrentArea);
            scope.setStartDate = setStartDate;
            scope.setEndDate = setEndDate;
            scope.dateLimits = dateLimits;
            scope.$watch('oneWay', function (value, old) {
                if (value == null || value === old) {
                    return;
                }
                searchUnitService.setOneWayFlightEnabled(value);
            });
            scope.$watch('isStartTimeApprovedByCustomer', function (value) { return searchUnitService.isStartTimeApprovedByCustomer(currentArea.mode, value); });
            scope.$watch('isEndTimeApprovedByCustomer', function (value) { return searchUnitService.isEndTimeApprovedByCustomer(currentArea.mode, value); });
            function getAreaOverride() {
                return scope.areaOverride || scope.$parent.areaOverride ||
                    ($route.current && $route.current.$$route && $route.current.$$route.area);
            }
            function updateCurrentArea(areaOverride) {
                // observation: if areaOverride = 'holidayDeals' then currentArea does not change
                // 'holidayDeals' is not described as an area in area.factory.ts
                currentArea = sharedSearchUnitService.getAreaInfo(areaOverride);
                updateMinDates();
            }
            function updateMinDates() {
                var areaName = currentArea && currentArea.name;
                dateLimits.startDateMin = searchUnitService.getMinStartDate(areaName);
                dateLimits.endDateMin = searchUnitService.getMinEndDate(scope.startDate || dateLimits.startDateMin, areaName);
            }
            function setStartDate(date) {
                if (!date || !currentArea) {
                    return;
                }
                searchUnitService.startDate(currentArea.mode, date, scope.defaultTime);
                searchUnitService.isStartTimeApprovedByCustomer(currentArea.mode, scope.isStartTimeApprovedByCustomer);
                scope.startDate = date;
                dateLimits.endDateMin = searchUnitService.getMinEndDate(date, currentArea.name);
                if (TRPCONFIG.Domain.DurationEnable || scope.resetDuration === true) {
                    var duration = searchUnitService.duration(currentArea.mode);
                    var endDateOffset = duration ? duration.value : null;
                    scope.endDate = dateUtil.addDays(scope.startDate, endDateOffset || TRPCONFIG.Domain.HolidaysSearchEndOffsetDate, true);
                    searchUnitService.endDate(currentArea.mode, scope.endDate);
                }
                else {
                    //need to refresh the end date because it is possible it has been adjusted
                    scope.endDate = searchUnitService.endDate(currentArea.mode);
                }
            }
            function setEndDate(date) {
                if (!date) {
                    return;
                }
                searchUnitService.endDate(currentArea.mode, date);
                searchUnitService.isEndTimeApprovedByCustomer(currentArea.mode, scope.isEndTimeApprovedByCustomer);
                scope.endDate = date;
            }
            function initDurationInput() {
                scope.options = searchUnitService.getDurationOptions();
                scope.$watch('duration', function () {
                    if (scope.duration) {
                        // changed : console.log('$watch CHANGED scope.duration ', scope.duration);
                        searchUnitService.duration(currentArea.mode, scope.duration);
                        scope.endDate = dateUtil.addDays(scope.startDate, searchUnitService.duration(currentArea.mode).value, true);
                        searchUnitService.endDate(currentArea.mode, scope.endDate);
                    }
                    else if (searchUnitService.duration(currentArea.mode)) {
                        // retrieve : console.log('$watch RETRIEVE resourceService.SearchUnitDuration ', searchUnitService.duration(currentArea.mode));
                        scope.duration = scope.options[searchUnitService.duration(currentArea.mode).index];
                    }
                    else {
                        // init : console.log('$watch INIT scope.duration ', scope.duration);
                        scope.duration = scope.options[0];
                    }
                });
            }
            if (TRPCONFIG.Domain.DurationEnable) {
                initDurationInput();
            }
        }
    }
})();
angular
    .module('searchUnit')
    .directive('dealsSearchUnit', dealsSearchUnit);
function dealsSearchUnit($location, holidayDeals, searchUnitService, sharedSearchUnitService, broker, resourceService, dateUtil, scrollTo, analytics) {
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'dealsSearchUnit');
    return {
        restrict: 'E',
        replace: true,
        scope: {
            areaOverride: '@',
            refresh: '=',
            noButton: '=',
            hideButton: '=',
            tracking: '=',
            pickMonths: '=',
            ldp: '=',
            writeToUrl: '='
        },
        templateUrl: 'partials/searchunit/deals',
        controller: 'SharedSearchUnit',
        link: function (scope, el, attr, controller) {
            broker.subscribe('dealsSearchUnit', 'autocompleterReady', function (e) {
                if (!$(e.data).isOnScreen()) {
                    var container = ($('.horizontal-search-wrapper').length !== 0)
                        ? '.horizontal-search-wrapper'
                        : '.search-panel';
                    scrollTo(container);
                }
            });
            scope.$on('$destroy', function () {
                broker.unsubscribe('dealsSearchUnit');
            });
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'dealsSearchUnit');
        }
    };
    function _delayedLinker(scope) {
        var currentArea = sharedSearchUnitService.getAreaInfo(scope.areaOverride);
        scope.area = currentArea.name;
        scope.durations = holidayDeals.DURATIONS.map(function (d) { return ({
            name: d + " " + resourceService.get('NIGHTS'),
            value: d
        }); });
        scope.airportDeselect = function () { return searchUnitService.clearDepartureAirports(); };
        scope.search = function () {
            var params = {
                airportsCodes: scope.airports,
                startDate: searchUnitService.startDate(currentArea.mode),
                duration: scope.duration,
                occupancy: scope.occupancy
            };
            analytics.track('mixpanel', 'Search', {
                Nights: params.duration,
                DepartureAirports: params.airportsCodes,
                TypeTitle: 'Holiday Deals',
                FromDate: { Date: params.startDate },
                Rooms: params.occupancy
            });
            if (!_validateParameters(params)) {
                return;
            }
            scope.refresh
                ? _refreshSearch(holidayDeals.serialiseParameters(params, false))
                : _startSearch(holidayDeals.serialiseParameters(params, false));
        };
        _restoreSearchCriteria(false);
        scope.$watch(function () { return _.size($location.search()); }, function (value) {
            if (value === 0) {
                _restoreSearchCriteria(true);
            }
        });
        function _restoreSearchCriteria(noWatch) {
            holidayDeals.getFullParameters(!!scope.writeToUrl).then(function (params) {
                scope.airports = params.depAir.map(function (a) { return ({ Code: a }); });
                searchUnitService.setMultipleDepartureAirports(scope.airports);
                scope.startDate = searchUnitService.startDate(currentArea.mode, params.startDate);
                scope.duration = params.duration;
                scope.occupancy = params.occupancy;
                if (scope.refresh && !noWatch) {
                    scope.$watch(function () { return searchUnitService.startDate(currentArea.mode); }, function (n, o) {
                        _autoStartSearch(n, o);
                        if (scope.tracking && !angular.equals(n, o)) {
                            var date = dateUtil.parseDate(n);
                            var month = date.getMonth() + 1;
                            var year = date.getFullYear();
                            _trackChange('startDate', "month-" + month + "-" + year);
                        }
                    }, true);
                    scope.$watch('occupancy', function (n, o) {
                        _autoStartSearch(n, o);
                        if (scope.tracking && !angular.equals(n, o)) {
                            n = n[0] || n;
                            var value = {
                                Adults: n.Adults,
                                Children: (n.ChildAges || []).length
                            };
                            _trackChange('Occupancy', value);
                        }
                    }, true);
                    scope.$watch('duration', function (n, o) {
                        _autoStartSearch(n, o);
                        if (scope.tracking && !angular.equals(n, o)) {
                            _trackChange('Duration', n);
                        }
                    });
                    scope.$watch('airports', function (n, o) {
                        if (_.size(n) === 0) {
                            return;
                        }
                        searchUnitService.setMultipleDepartureAirports(n);
                        if (scope.tracking && !angular.equals(n, o)) {
                            _trackChange('Airports');
                        }
                        return _autoStartSearch(n, o);
                    }, true);
                }
            });
        }
        function _autoStartSearch(newValue, oldValue) {
            if (newValue && scope.refresh && !angular.equals(newValue, oldValue)) {
                scope.search();
            }
        }
        function _trackChange(type, value) {
            return value
                ? analytics.track('mixpanel', "HolidayDealsInsp" + type, { value: value })
                : analytics.track('mixpanel', "HolidayDealsInsp" + type);
        }
        function _refreshSearch(params) {
            for (var param in params) {
                $location.search(param, params[param]);
                $location.replace();
            }
            var position = $('body').scrollTop();
            broker.publish('REFRESHSEARCH', { newSearch: true });
            var listener = scope.$on('$locationChangeSuccess', function () {
                $('body').scrollTop(position);
                listener();
            });
        }
        function _startSearch(params) {
            scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-dealsSearchUnit'
            });
            for (var param in params) {
                $location.search(param, params[param]);
            }
            $location.path("/holidaydeals");
        }
        function _validateParameters(params) {
            if (_getNumberOfNonInfantPassengers(params.occupancy[0]) > 12) {
                scope.$emit('flash:error', String.format(decodeURI(resourceService.get('TOOMANYPASSENGERS')), TRPCONFIG.DesktopUrlRoot + "/Help/Groupbookings.aspx", resourceService.get('TELEPHONENUMBER')));
                return false;
            }
            var childAges = _.get(params, 'occupancy[0].ChildAges');
            var isValidOccupancy = _.every(childAges, function (ca) { return typeof ca !== 'undefined'; });
            if (!isValidOccupancy) {
                scope.$emit('flash:error', resourceService.get('CHILDAGESERROR'));
            }
            else {
                scope.$emit('flash:hide', resourceService.get('CHILDAGESERROR'));
            }
            return isValidOccupancy;
        }
        function _getNumberOfNonInfantPassengers(occ) {
            function _isolateNonInfants(value) {
                return value >= 2;
            }
            var childrenNumber = occ.ChildAges.filter(_isolateNonInfants).length;
            return occ.Adults + childrenNumber;
        }
        function _getNextMonth() {
            var today = new Date();
            var month = today.getMonth();
            var year = month === 11 ? today.getFullYear() + 1 : today.getFullYear();
            month = month === 11 ? 0 : month + 1;
            return new Date(year, month, 15, 0, 0, 0, 0);
        }
    }
}
//Requires configuration options
//HTMLHelpers - UseStaticDepartureDropdown : true
//WebConfig   - EnableStaticDepartureDropdown: true
//WebConfig   - FixedDepartureAirportOptions : (string value )
var SearchUnit;
(function (SearchUnit) {
    var FixedDepartureDropdown = /** @class */ (function () {
        function FixedDepartureDropdown(searchUnitService, $q) {
            var _this = this;
            this.searchUnitService = searchUnitService;
            this.$q = $q;
            this.airports = {
                options: [],
                selected: null
            };
            $q.all(this.data.split(',').map(searchUnitService.getAirport)).then(function (results) {
                _this.airports.options = results.map(function (r) { return _.assign(r, { titleCode: r.Title + ", " + r.Code }); });
                if (_this.selected && _this.selected.length > 0) {
                    _.each(_this.airports.options, function (airport) {
                        if (_this.selected[0].Code === airport.Code) {
                            _this.airports.selected = airport;
                        }
                    });
                }
                //ensure search criteria is persisted
                var preSelectedAirport = searchUnitService.getSelectedDepartureAirport();
                if (preSelectedAirport) {
                    var preSelectedIndex = _this.airports.options.filter(function (airport) {
                        return airport.Code === preSelectedAirport.Code;
                    });
                    if (preSelectedIndex.length) {
                        _this.airports.selected = preSelectedIndex[0];
                    }
                }
            });
        }
        FixedDepartureDropdown.prototype.onDepartureAirportChange = function () {
            this.searchUnitService.setDepartureAirports(this.airports.selected);
        };
        ;
        return FixedDepartureDropdown;
    }());
    angular
        .module('searchUnit')
        .directive('fixedDepartureDropdown', fixedDepartureDropdown);
    function fixedDepartureDropdown(searchUnitService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'dd',
            bindToController: {
                data: '=',
                selected: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=FixedDepartureDropdown',
            controller: FixedDepartureDropdown
        };
    }
})(SearchUnit || (SearchUnit = {}));
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .directive('flightSearchUnit', flightSearchUnit);
    function flightSearchUnit(searchUnitService, sharedSearchUnitService, occupancyService, preferences, dateUtil, $q) {
        // Configuration part, mandatory in every searchunit directive with delayed linker
        sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'flightSearchUnit');
        return {
            restrict: 'E',
            replace: true,
            scope: {
                moreOptions: '@',
                areaOverride: '@'
            },
            templateUrl: 'partials/searchunit/flight',
            controller: 'SharedSearchUnit',
            link: function (scope, el, attr, controller) {
                return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'flightSearchUnit');
            }
        };
        function _delayedLinker(scope, $element, attr, ssu) {
            scope.destinationAirportSelect = destinationAirportSelect;
            scope.destinationAirportDeselect = destinationAirportDeselect;
            scope.search = search;
            scope.getMultiSectorMinDate = getMultiSectorMinDate;
            scope.selectLegDate = selectLegDate;
            scope.selectLegAirport = selectLegAirport;
            scope.addLeg = addLeg;
            scope.rmLeg = rmLeg;
            scope.onSearchModeChange = onSearchModeChange;
            scope.onReturningToggle = onReturningToggle;
            scope.searchMode = searchUnitService.isOneWayFlightEnabled() ? 'oneway' : 'return';
            scope.onewayonly = searchUnitService.isOneWayFlightEnabled() || false;
            scope.isMultiSector = false;
            scope.isMultiReturning = true;
            scope.legs = [{
                    DepartureDate: null,
                    DepartureAirport: null,
                    DestinationAirport: null,
                    Cabin: TRPCONFIG.Domain.DefaultCabin
                }];
            scope.toggleOptions = function () {
                scope.expandedOptions = !scope.expandedOptions;
            };
            scope.airportSelect = function (items) {
                searchUnitService.setMultipleDepartureAirports(items);
                loadOutboundDates();
            };
            scope.airportDeselect = function () {
                searchUnitService.clearDepartureAirports();
            };
            if (scope.moreOptions === 'true') {
                scope.updateCabin = updateCabin;
                scope.cabins = searchUnitService.getCabinOptions();
            }
            else {
                searchUnitService.setDefaultCabin();
            }
            _restoreSearchCriteria();
            function loadOutboundDates() {
                function getRequest() {
                    var DepartureAirportCodes = searchUnitService.getDepartureAirports();
                    if (!DepartureAirportCodes || !DepartureAirportCodes.length) {
                        return null;
                    }
                    var destinationAirport = searchUnitService.getDestinationAirport();
                    if (!destinationAirport || !destinationAirport.Code) {
                        return null;
                    }
                    var DestinationAirportCodes = destinationAirport.Code.split(',');
                    if (!DestinationAirportCodes.length) {
                        return null;
                    }
                    return {
                        DepartureAirportCodes: DepartureAirportCodes,
                        DestinationAirportCodes: DestinationAirportCodes
                    };
                }
                var request = getRequest();
                searchUnitService.loadOutboundDates(request).then(function (outboundDates) { return scope.enabledDates = outboundDates; });
            }
            function destinationAirportSelect(item) {
                var availableResorts = searchUnitService.setDestinationAirport(item, false);
                loadOutboundDates();
                return availableResorts;
            }
            function destinationAirportDeselect() {
                var availableResorts = searchUnitService.setDestinationAirport(null, false);
                scope.enabledDates = {};
                return availableResorts;
            }
            function search() {
                ssu.lockScreen('SEARCHINGFLIGHTS');
                var flightSearch = {};
                mapSearchTerms(flightSearch);
                preferences.set('flightSearch', flightSearch);
                sharedSearchUnitService.search(undefined, ssu.showErrors, scope.isMultiSector
                    ? { multi: true, legs: scope.legs, areaOverride: scope.areaOverride }
                    : { onewayonly: scope.onewayonly, areaOverride: scope.areaOverride });
            }
            function updateCabin(cabin) {
                searchUnitService.setCabin(cabin);
            }
            function getMultiSectorMinDate(legIndex) {
                return legIndex === 0
                    ? dateUtil.todayPlus(1, 0, true)
                    : dateUtil.addDays(scope.legs[legIndex - 1].DepartureDate, 1, true);
            }
            function selectLegDate(leg, date) {
                leg.DepartureDate = date;
            }
            function selectLegAirport(leg, airport, type) {
                leg[type] = airport;
                if (!scope.isMultiReturning) {
                    return;
                }
                var i = scope.legs.indexOf(leg);
                if (i === 0 && scope.legs.length > 1 && type === 'DepartureAirport') {
                    scope.legs[scope.legs.length - 1].DestinationAirport = airport;
                }
                else if (i > 0 && i === scope.legs.length - 1 && type === 'DestinationAirport') {
                    scope.legs[0].DepartureAirport = airport;
                }
            }
            function addLeg() {
                var prevLeg = scope.legs[scope.legs.length - 1];
                if (scope.isMultiReturning && scope.legs.length > 1) {
                    prevLeg.DestinationAirport = null;
                }
                scope.legs.push({
                    DepartureDate: dateUtil.addDays(prevLeg.DepartureDate, 7, true),
                    DepartureAirport: null,
                    DestinationAirport: scope.isMultiReturning ? scope.legs[0].DepartureAirport : null,
                    Cabin: prevLeg.Cabin
                });
            }
            function rmLeg(leg) {
                var legs = scope.legs;
                var i = legs.indexOf(leg);
                legs.splice(i, 1);
                if (legs.length > 1 && scope.isMultiReturning) {
                    if (i === 0) {
                        legs[0].DepartureAirport = legs[legs.length - 1].DestinationAirport;
                    }
                    else if (i === legs.length) {
                        legs[legs.length - 1].DestinationAirport = legs[0].DepartureAirport;
                    }
                }
            }
            function onSearchModeChange() {
                scope.onewayonly = scope.searchMode === 'oneway';
                scope.isMultiSector = scope.searchMode === 'multisector';
            }
            function onReturningToggle() {
                if (scope.isMultiReturning && scope.legs.length > 1) {
                    scope.legs[scope.legs.length - 1].DestinationAirport = scope.legs[0].DepartureAirport;
                }
                searchUnitService.setIsMultiReturning(scope.isMultiReturning);
            }
            function mapSearchTerms(target, source) {
                if (!target) {
                    return;
                }
                if (!source) {
                    source = {};
                }
                var selectedDepartureAirport = searchUnitService.getSelectedDepartureAirport();
                if (selectedDepartureAirport) {
                    selectedDepartureAirport = [selectedDepartureAirport];
                }
                else {
                    selectedDepartureAirport = searchUnitService.getDepartureAirports();
                }
                target.airports = searchUnitService.chooseSeachUnitModel(target.airports, source.airports, selectedDepartureAirport);
                target.destinationAirport = searchUnitService.chooseSeachUnitModel(target.destinationAirport, source.destinationAirport, searchUnitService.getDestinationAirport());
                target.startDate = searchUnitService.chooseSeachUnitModel(target.startDate, source.startDate, searchUnitService.startDate(searchUnitService.flight));
                target.endDate = searchUnitService.chooseSeachUnitModel(target.endDate, source.endDate, searchUnitService.endDate(searchUnitService.flight));
                var occupancy = target.occupancy || source.occupancy || occupancyService.getOccupancy();
                target.occupancy = [occupancy.reduce(function (a, b) {
                        return {
                            Adults: a.Adults + b.Adults,
                            ChildAges: a.ChildAges.concat(b.ChildAges)
                        };
                    })];
                target.cabin = target.cabin || source.cabin || searchUnitService.getCabin();
                target.onewayonly = _.isBoolean(source.onewayonly) ? source.onewayonly : scope.onewayonly;
                target.isMultiSector = searchUnitService.getIsMultiSector() || scope.isMultiSector;
                target.searchMode = target.isMultiSector ? 'multisector' : target.onewayonly ? 'oneway' : 'return';
                target.isMultiReturning = searchUnitService.getIsMultiReturning();
                target.legs = searchUnitService.getLegs() || scope.legs;
                target.airports && searchUnitService.setMultipleDepartureAirports(target.airports);
                target.destinationAirport && searchUnitService.setDestinationAirport(target.destinationAirport);
                target.startDate && searchUnitService.startDate(searchUnitService.flight, target.startDate);
                target.endDate && searchUnitService.endDate(searchUnitService.flight, target.endDate);
                target.occupancy && occupancyService.setOccupancy(target.occupancy);
                target.cabin && searchUnitService.setCabin(target.cabin < 0 ? 1 : target.cabin); /// -1 caused API to return unhandled exception
                searchUnitService.setIsMultiSector(scope.isMultiSector);
                searchUnitService.setLegs(target.legs);
            }
            function _restoreSearchCriteria() {
                var promise = TRPCONFIG.Domain.isAgentMode ? $q.when() : preferences.get('flightSearch');
                promise.then(function (flightSearch) {
                    mapSearchTerms(scope, flightSearch);
                });
                // Airports may be changed by other multi search forms
                scope.$watch(function () { return searchUnitService.getSelectedDepartureAirport(); }, function (v) {
                    scope.airports = v;
                    scope.airportsCount = _getAirportsCount(v);
                });
            }
            function _getAirportsCount(airports) {
                if (airports && airports.Code) {
                    return airports.Code.split(',').length;
                }
                return 0;
            }
        }
    }
})();
angular.module('searchUnit')
    .directive('insuranceSearchUnit', insuranceSearchUnit);
function insuranceSearchUnit($location, searchUnitService, sharedSearchUnitService, occupancyService, dateUtil) {
    // Configuration part, mandatory in every searchunit directive with delayed linker
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'insuranceSearchUnit');
    return {
        restrict: 'E',
        replace: true,
        scope: {
            areaOverride: '@'
        },
        templateUrl: 'partials/searchunit/insurance',
        controller: 'SharedSearchUnit',
        link: function (scope, el, attr, controller) {
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'insuranceSearchUnit');
        }
    };
    function _delayedLinker(scope, el, attr, ssu) {
        var mode = sharedSearchUnitService.getAreaInfo(scope.areaOverride).mode;
        scope.model = {};
        scope.policyTypeSelect = policyTypeSelect;
        scope.travelDestinationSelect = travelDestinationSelect;
        scope.search = search;
        // Initialise form
        _restoreSearchCriteria();
        function _restoreSearchCriteria() {
            scope.startDate = searchUnitService.startDate(mode);
            scope.endDate = searchUnitService.endDate(mode);
            scope.travelDestination = searchUnitService.getTravelDestination();
            scope.policyType = searchUnitService.getPolicyType();
            scope.occupancy = [occupancyService.reduceOccupancy()];
        }
        searchUnitService.getPolicyTypes().then(function (res) {
            scope.policyTypes = res;
        });
        searchUnitService.getTravelDestinations().then(function (res) {
            scope.travelDestinations = res;
        });
        searchUnitService.getPolicyExtras().then(function (res) {
            scope.policyExtras = res;
        });
        function travelDestinationSelect() {
            searchUnitService.setTravelDestination(scope.travelDestination);
        }
        function policyTypeSelect() {
            searchUnitService.setPolicyType(scope.policyType);
        }
        function search() {
            //set selected polict extras
            var selectedPolicyExtras = [];
            scope.policyExtras.forEach(function (e) {
                if (e.Selected) {
                    selectedPolicyExtras.push({ Id: e.Id, Name: e.Name });
                }
            });
            searchUnitService.setPolicyExtra(selectedPolicyExtras);
            //set default end date for annual policy
            if (scope.policyType && scope.policyType.Id === 2) {
                scope.endDate = dateUtil.addDays(scope.startDate, 365, true);
                searchUnitService.endDate(mode, scope.endDate);
            }
            occupancyService.setOccupancy(scope.occupancy);
            ssu.lockScreen('SEARCHINGINSURANCE');
            sharedSearchUnitService.search(undefined, ssu.showErrors, {
                areaOverride: scope.areaOverride
            });
        }
    }
}
(function () {
    'use strict';
    angular.module('TR')
        .directive('marhabaSearchUnit', function () {
        return {
            templateUrl: 'partials/searchunit/marhaba',
            controller: 'MarhabaSearchUnitCtrl',
            controllerAs: 'msu',
            replace: true,
            scope: {
                areaOverride: '@'
            },
            restrict: 'E',
            link: function () {
                // do nothing
            }
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .directive('parkingSearchUnit', parkingSearchUnit);
    function parkingSearchUnit(searchUnitService, sharedSearchUnitService, occupancyService) {
        // Configuration part, mandatory in every searchunit directive with delayed linker
        sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'parkingSearchUnit');
        return {
            restrict: 'E',
            replace: true,
            scope: {
                areaOverride: '@'
            },
            templateUrl: 'partials/searchunit/parking',
            controller: 'SharedSearchUnit',
            link: function (scope, el, attr, controller) {
                return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'parkingSearchUnit');
            }
        };
        function _delayedLinker(scope, el, attr, ssu) {
            var currentArea = sharedSearchUnitService.getAreaInfo(scope.areaOverride);
            var mode = currentArea.mode;
            var minPassengers = 1;
            var maxPassengers = occupancyService.adultRange(currentArea.name).max || 7;
            // Props on scope
            scope.passengerRange = _.range(minPassengers, maxPassengers + 1);
            // Methods on scope
            scope.departureAirportSelect = searchUnitService.setDepartureAirports;
            scope.departureAirportDeselect = departureAirportDeselect;
            scope.passengerSelect = passengerSelect;
            scope.search = search;
            // Initialise form
            _restoreSearchCriteria();
            function _restoreSearchCriteria() {
                scope.passengerCount = occupancyService.getPassengerCount() || 1;
                scope.departureAirport = searchUnitService.getSelectedDepartureAirport();
                scope.startDate = searchUnitService.startDate(mode);
                scope.endDate = searchUnitService.endDate(mode);
                passengerSelect();
            }
            function departureAirportDeselect() {
                return searchUnitService.clearDepartureAirports();
            }
            function passengerSelect() {
                occupancyService.setPassengerCount(scope.passengerCount);
            }
            function search() {
                ssu.lockScreen('SEARCHINGPARKING');
                sharedSearchUnitService.search(undefined, ssu.showErrors);
            }
        }
    }
})();
(function () {
    /*
        Injects an input field for filtering resorts based on `destinationAirport`.
        HTML for results is not injected to allow any UI implementation using `scope.resorts`.
    */
    'use strict';
    angular
        .module('searchUnit')
        .directive('resortField', function (searchUnitService, $filter, $rootScope, $timeout) {
        return {
            restrict: 'E',
            scope: {
                select: '&',
                deselect: '&',
                loadOnce: '=',
                currentValue: '=',
                placeholder: '@'
            },
            transclude: true,
            replace: true,
            templateUrl: 'partials/searchunit/resortfield',
            link: function (scope, el) {
                var currDest;
                var loadingClass = 'small-spinner';
                var inputField = el.find('.resort-input');
                // Props on scope
                scope.resorts = undefined;
                scope.allResorts = undefined;
                scope.resortInput = inputField;
                // Methods on scope
                scope.setResort = function (r) {
                    scope.resortTerm = r.Description;
                    scope.select({ item: r });
                };
                init(scope.loadOnce);
                function init(once) {
                    // Set any existing field value
                    var unwatchCurrent = scope.$watch('currentValue', function (v) {
                        if (v) {
                            if (!scope.resortTerm) {
                                scope.resortTerm = v.Description;
                            }
                            // Remove watch when value is found
                            unwatchCurrent();
                        }
                    });
                    // Filter resorts
                    scope.$watch('resortTerm', function (v) {
                        scope.resorts = filterResorts(v);
                        // If user cleared field that contained a value
                        if (!v && inputField.hasClass('ng-touched')) {
                            scope.deselect();
                        }
                    });
                    if (once) {
                        // Load resorts once only i.e. Mobile
                        // Timer ensures view has initialised
                        $timeout(updateResorts);
                    }
                    else {
                        // Watch destination airport for changes
                        scope.$watch('$parent.destinationAirport', function (v) {
                            if (!v) {
                                scope.allResorts =
                                    scope.resorts =
                                        scope.resortTerm =
                                            currDest = undefined;
                            }
                            else if (!currDest || v.Title !== currDest.Title) {
                                updateResorts();
                                currDest = v;
                            }
                        });
                    }
                }
                function updateResorts() {
                    inputField.addClass(loadingClass);
                    fetchResorts().then(function () {
                        inputField.removeClass(loadingClass);
                    });
                }
                function fetchResorts() {
                    scope.allResorts =
                        scope.resorts = undefined;
                    return searchUnitService.getAvailableResorts()
                        .then(function (res) {
                        var resMatch;
                        var currTerm = scope.resortTerm;
                        scope.allResorts = // Keep a copy of all resorts
                            scope.resorts = res; // This will change to filtered results
                        // Re-select term if it exists in results
                        if (currTerm && _.some(res, function (o) {
                            if (o.Description.toLowerCase() === currTerm.toLowerCase()) {
                                resMatch = o;
                                return true; // Quits at first match
                            }
                        })) {
                            scope.setResort(resMatch);
                        }
                        else {
                            scope.resortTerm = undefined;
                        }
                    }, function (msg) {
                        $rootScope.$broadcast('flash:error', msg);
                    });
                }
                function filterResorts(str) {
                    // Equivalent to 'allResorts|filter:str|limitTo:30'
                    return $filter('limitTo')($filter('filter')(scope.allResorts, str), 30);
                }
            }
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .directive('roomSearchUnit', roomSearchUnit);
    function roomSearchUnit($routeParams, broker, searchUnitService, sharedSearchUnitService, occupancyService, bd4travel, unifiedSearchService, scrollService) {
        // Configuration part, mandatory in every searchunit directive with delayed linker
        sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'roomSearchUnit');
        return {
            restrict: 'E',
            replace: true,
            scope: {
                landing: '@'
            },
            templateUrl: 'partials/searchunit/room',
            controller: 'SharedSearchUnit',
            link: function (scope, el, attr, controller) {
                return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'roomSearchUnit');
            }
        };
        function _delayedLinker(scope, $element, attr, ssu) {
            var notModel = {};
            unifiedSearchService
                .prepopulateModel(notModel, {})
                .then(function (m) { return bd4travel.trackInitialParameters(m, 'productDetails,hotel'); });
            var currentArea = sharedSearchUnitService.getAreaInfo();
            scope.dateRangeMetadata = {
                minStartDate: searchUnitService.getMinStartDate(currentArea.name),
                enabledStartDates: {},
                durations: {},
                showDatePicker: false,
                selectDateRange: function () {
                    searchUnitService.startDate(currentArea.mode, scope.startDate);
                    searchUnitService.endDate(currentArea.mode, scope.endDate);
                    scope.dateRangeMetadata.showDatePicker = false;
                }
            };
            scope.occupancyMetadata = searchUnitService.getOccupancyConfig(currentArea.name);
            scope.occupancyMetadata.showOccupancyPicker = false;
            scope.$watchCollection('occupancy', function (val) {
                if (val && val[0]) {
                    scope.occupancyMetadata.occupancyCaption = occupancyService.getOccupancyString(val);
                    occupancyService.setOccupancy(val);
                }
            });
            _restoreSearchCriteria();
            scope.updateCurrency = updateCurrency;
            scope.currencyOptions = searchUnitService.getCurrencyOptions();
            scope.toggleOptions = function () { scope.expandedOptions = !scope.expandedOptions; };
            scope.searchRooms = searchRooms;
            scope.searching = false;
            function searchRooms() {
                scope.searching = true;
                broker.publish('roomSearchStarted');
                scope.$emit('flash:error', null);
                if (scope.landing) {
                    ssu.lockScreen('SEARCHINGFORROOMSPROMPT');
                }
                scrollService.setScrollTarget('#roomsPanel');
                sharedSearchUnitService.search(null, _showRoomErrors, {
                    roomSearch: true,
                    estabId: $routeParams.estabId
                });
            }
            function _showRoomErrors(errors) {
                scope.searching = false;
                broker.publish('roomSearchEnded');
                scope.$emit('flash:error', errors);
                ssu.unlockScreen();
            }
            function _restoreSearchCriteria() {
                scope.startDate = searchUnitService.startDate(currentArea.mode);
                scope.endDate = searchUnitService.endDate(currentArea.mode);
                scope.occupancy = occupancyService.getOccupancy();
                scope.currency = searchUnitService.getCurrency();
            }
            function updateCurrency() {
                searchUnitService.setCurrency(scope.currency);
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .directive('transferSearchUnit', transferSearchUnit);
    function transferSearchUnit($location, searchUnitService, sharedSearchUnitService, occupancyService, autocompleter, $rootScope, transferSearch) {
        // Configuration part, mandatory in every searchunit directive with delayed linker
        sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'transferSearchUnit');
        return {
            restrict: 'E',
            replace: true,
            scope: {
                areaOverride: '@'
            },
            templateUrl: 'partials/searchunit/transfer',
            controller: 'SharedSearchUnit',
            link: function (scope, el, attr, controller) {
                return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'transferSearchUnit');
            }
        };
        function _delayedLinker(scope, el, attr, ssu) {
            var mode = sharedSearchUnitService.getAreaInfo(scope.areaOverride).mode;
            scope.model = {};
            scope.$watch(function () { return transferSearch.getTransfersTimeApprovalRequired(TRPCONFIG.Domain.EnableTransfersTimeApproval); }, function (value) {
                scope.requiresTimeApproval = value;
            });
            // ab-test code:
            // var $root = angular.element(document.body).scope().$root;
            // $root.transferDirectionStyle = 'radio';
            // $root.$evalAsync();
            scope.transferDirectionStyle = function () { return $rootScope.transferDirectionStyle || TRPCONFIG.Domain.TransferDirectionStyle; };
            // Props on scope
            scope.directionOps = _.mapValues(
            // Numbers are required by `searchUnitService` but numeric keys are always strings
            // Swap key/value and coerce to number
            _.invert(searchUnitService.getDirectionStrings()), function (v) { return v * 1; });
            scope.transferTypes = _.mapValues(_.invert(searchUnitService.getTransferTypeStrings()), function (v) { return v * 1; });
            var destinationTypePointTypeMap = {
                0: searchUnitService.pointType.Unknown,
                1: searchUnitService.pointType.Estab,
                2: searchUnitService.pointType.Location,
                3: searchUnitService.pointType.Unknown,
                4: searchUnitService.pointType.Unknown,
                5: searchUnitService.pointType.Unknown,
                10: searchUnitService.pointType.Unknown
            };
            var pointTypeDestinationTypeMap = (_a = {},
                _a[searchUnitService.pointType.Unknown] = 0,
                _a[searchUnitService.pointType.Estab] = 1,
                _a[searchUnitService.pointType.Location] = 2,
                _a);
            // Methods on scope
            scope.destinationAirportSelect = destinationAirportSelect;
            scope.destinationAirportDeselect = destinationAirportDeselect;
            scope.resortSelect = searchUnitService.setResort;
            scope.resortDeselect = resortDeselect;
            scope.directionSelect = directionSelect;
            scope.search = search;
            scope.transferTypeSelect = transferTypeSelect;
            scope.dropOffPointDeselect = dropOffPointDeselect;
            scope.pickUpPointDeselect = pickUpPointDeselect;
            scope.pickUpPointSelect = pickUpPointSelect;
            scope.dropOffPointSelect = dropOffPointSelect;
            scope.pointToPointOneWay = pointToPointOneWay;
            // Initialise form
            _restoreSearchCriteria();
            function _restoreSearchCriteria() {
                var destination = searchUnitService.getDestinationAirport() || {};
                var airportCode = destination.Code || destination.DestinationAirports || $location.search().air || '';
                if (airportCode && airportCode.indexOf(',') === -1) {
                    autocompleter.lookup('transfers', airportCode).then(function (response) {
                        destinationAirportSelect(_.filter(response.data, { Code: airportCode })[0]);
                    });
                }
                scope.resort = searchUnitService.getResort();
                scope.model.direction = searchUnitService.getDirection();
                scope.startDate = searchUnitService.startDate(mode);
                scope.endDate = searchUnitService.endDate(mode);
                scope.isStartTimeApprovedByCustomer = searchUnitService.isStartTimeApprovedByCustomer(mode);
                scope.isEndTimeApprovedByCustomer = searchUnitService.isEndTimeApprovedByCustomer(mode);
                scope.occupancy = [occupancyService.reduceOccupancy()];
                directionSelect();
                scope.transferType = searchUnitService.getTransferType();
                transferTypeSelect();
                if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                    var pickUpPoint = searchUnitService.getTransferPickUpPoint();
                    var dropOffPoint = searchUnitService.getTransferDropOffPoint();
                    if (pickUpPoint) {
                        pickUpPoint.Type = pointTypeDestinationTypeMap[pickUpPoint.Type];
                    }
                    if (dropOffPoint) {
                        dropOffPoint.Type = pointTypeDestinationTypeMap[dropOffPoint.Type];
                    }
                    pickUpPointSelect(pickUpPoint);
                    dropOffPointSelect(dropOffPoint);
                }
            }
            function destinationAirportSelect(a) {
                scope.destinationAirport = a;
                searchUnitService.setDestinationAirport(a, true);
            }
            function destinationAirportDeselect() {
                scope.destinationAirport = null;
                return searchUnitService.setDestinationAirport(null);
            }
            function resortDeselect() {
                searchUnitService.setResort(null);
            }
            function directionSelect() {
                var dir = scope.model.direction;
                if (dir != null) {
                    scope.isOneWay = (dir === 2); // Airport to resort only
                    scope.isReturnOnly = (dir === 3); // Resort to airport only
                    // Restore any existing search dates
                    // `setDirection()` below may have set them to `null`
                    restoreDates();
                    // Update search
                    searchUnitService.setDirection(dir);
                }
            }
            function restoreDates() {
                if (!scope.isReturnOnly && scope.startDate) {
                    searchUnitService.startDate(mode, scope.startDate);
                }
                if (!scope.isOneWay && scope.endDate) {
                    searchUnitService.endDate(mode, scope.endDate);
                }
            }
            function search() {
                occupancyService.setOccupancy(scope.occupancy);
                ssu.lockScreen('SEARCHINGTRANSFERS');
                sharedSearchUnitService.search(undefined, ssu.showErrors, {
                    areaOverride: scope.areaOverride,
                    enableTransfersTimeApproval: TRPCONFIG.Domain.EnableTransfersTimeApproval
                });
            }
            function transferTypeSelect() {
                scope.isAirportTransfer = (scope.transferType === searchUnitService.transferTypes.AirportTransfer);
                searchUnitService.setTransferType(scope.transferType);
            }
            function pickUpPointDeselect() {
                scope.pickUpPoint = null;
                searchUnitService.setTransferPickUpPoint(null);
            }
            function dropOffPointDeselect() {
                scope.dropOffPoint = null;
                searchUnitService.setTransferDropOffPoint(null);
            }
            function pickUpPointSelect(p) {
                scope.pickUpPoint = p;
                if (p) {
                    searchUnitService.setTransferPickUpPoint({
                        Type: destinationTypePointTypeMap[p.Type],
                        Code: p.Code,
                        Description: p.Description || p.Title
                    });
                }
            }
            function dropOffPointSelect(d) {
                scope.dropOffPoint = d;
                if (d) {
                    searchUnitService.setTransferDropOffPoint({
                        Type: destinationTypePointTypeMap[d.Type],
                        Code: d.Code,
                        Description: d.Description || d.Title
                    });
                }
            }
            function pointToPointOneWay() {
                if (scope.isPointToPointOneWay) {
                    scope.model.direction = 2;
                    scope.isOneWay = true;
                }
                else {
                    scope.model.direction = 1;
                    scope.isOneWay = false;
                }
                searchUnitService.setDirection(scope.model.direction);
            }
            var _a;
        }
    }
})();
var Area;
(function (Area_1) {
    function Area(searchUnitService, basketService) {
        return {
            'hotels': {
                name: 'hotels',
                mode: searchUnitService.hotel,
                flow: basketService.hotelBooking,
                searchMsg: 'SEARCHINGHOTELS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Hotels,
                timeSupport: false,
            },
            'transfers': {
                name: 'transfers',
                mode: searchUnitService.transfer,
                flow: basketService.transferBooking,
                searchMsg: 'SEARCHINGTRANSFERS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Transfers,
                timeSupport: true,
            },
            'holidays': {
                name: 'holidays',
                mode: searchUnitService.flight,
                flow: basketService.holidayBooking,
                searchMsg: 'SEARCHINGFLIGHTSANDHOTELS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.FlightsAndHolidays,
                timeSupport: false,
            },
            'flights': {
                name: 'flights',
                mode: searchUnitService.flight,
                flow: basketService.flightBooking,
                searchMsg: 'SEARCHINGFLIGHTS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.FlightsAndHolidays,
                timeSupport: false,
            },
            'marhaba': {
                name: 'marhaba',
                mode: searchUnitService.marhaba,
                flow: basketService.marhabaBooking,
                searchMsg: 'SEARCHINGMARHABA',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Marhaba,
                timeSupport: true,
            },
            'emirates': {
                name: 'emirates',
                mode: searchUnitService.hotel,
                flow: basketService.hotelBooking,
                searchMsg: 'SEARCHINGHOTELS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Hotels,
                timeSupport: false,
            },
            'parking': {
                name: 'parking',
                mode: searchUnitService.parking,
                flow: basketService.parkingBooking,
                searchMsg: 'SEARCHINGPARKING',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Parking,
                timeSupport: true,
            },
            'attractions': {
                name: 'attractions',
                mode: searchUnitService.attractions,
                flow: basketService.attractionsBooking,
                searchMsg: 'SEARCHINGATTRACTIONS',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Attractions,
                timeSupport: false,
            },
            'insurance': {
                name: 'insurance',
                mode: searchUnitService.insurance,
                flow: basketService.insuranceBooking,
                searchMsg: 'SEARCHINGINSURANCE',
                endDateOffset: TRPCONFIG.Domain.SearchUnitEndDateOffsets.Insurance,
                timeSupport: false,
            }
        };
    }
    angular
        .module('TR')
        .factory('Area', Area);
})(Area || (Area = {}));
(function () {
    'use strict';
    angular
        .module('searchUnit')
        .factory('sharedSearchUnitService', sharedSearchUnitService);
    function sharedSearchUnitService($route, $routeParams, $q, tripService, basketService, Area, broker, $rootScope, resourceService) {
        var delayedLinkers = {};
        var areasInfo = Area;
        var service = {
            addDelayedLinker: addDelayedLinker,
            getAreaInfo: getAreaInfo,
            initializeArea: initializeArea,
            search: search,
            showErrors: showErrors,
            lockScreen: lockScreen,
            unlockScreen: unlockScreen
        };
        function addDelayedLinker(linkerFn, key) {
            delayedLinkers[key] = linkerFn;
        }
        function getAreaInfo(areaOverride) {
            return areasInfo[(areaOverride || ($route.current && $route.current.$$route ? $route.current.$$route.area : ''))];
        }
        function initializeArea(scope, el, attr, controller, key) {
            var tripId = $routeParams.tripId;
            var areaPromise = tripId ? tripService.getTrip(tripId) : $q.when();
            areaPromise.then(function loadCriteriaWrapper() {
                _loadCriteria(scope, el, attr, controller, key);
            });
        }
        function search(getSearchResultsFn, showErrorsFn, options, searchModel, isFlexibleTripType) {
            if (!options) {
                options = {};
            }
            var params = {
                multi: options.multi || false,
                legs: options.legs || null,
                samePage: options.samePage,
                oneWayOnly: options.onewayonly,
                estabId: options.estabId,
                defaultFilters: options.defaultFilters,
                roomSearch: options.roomSearch,
                fid: options.fid,
                fbt: options.fbt,
                flexibleDates: options.flexibleDates,
                prefilterAirlines: options.prefilterAirlines,
                prefilterDirectFlights: options.prefilterDirectFlights,
                enableTransfersTimeApproval: options.enableTransfersTimeApproval,
                postfilterAirlines: options.postfilterAirlines,
                searchModel: searchModel,
                isFlexibleTripType: isFlexibleTripType
            };
            basketService.startWorkflow(getAreaInfo(options.areaOverride).flow, params)
                .then(getSearchResultsFn, showErrorsFn);
        }
        function _loadCriteria(scope, el, attr, controller, key) {
            function _delayedLinkerWrapper() {
                delayedLinkers[key].call(undefined, scope, el, attr, controller);
            }
            _delayedLinkerWrapper();
        }
        function showErrors(errors) {
            broker.publish('unblock');
            $rootScope.$emit('unblock');
            $rootScope.$broadcast('flash:error', errors);
        }
        function lockScreen(searchMsg, loadingScreenStyle) {
            $rootScope.$emit('block', {
                title: resourceService.get(searchMsg),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: loadingScreenStyle
            });
            $rootScope.$broadcast('flash:hide');
        }
        function unlockScreen() {
            $rootScope.unlockScreen($rootScope);
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .controller('Resorts', Resorts);
    function Resorts(searchUnitService, $window) {
        this.setResort = function (item) {
            searchUnitService.setResort(item);
            // Timer avoids infinite digest loops
            setTimeout(function () {
                $window.history.back();
            }, 0);
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .controller('TransferAirports', TransferAirports);
    function TransferAirports(searchUnitService, destinationService, $location, $route) {
        var cm = this;
        cm.setDestinationAirport = setDestinationAirport;
        cm.setDestinations = setDestinations;
        searchUnitService.getAirports().then(function (airports) {
            cm.airports = airports;
        });
        function setDestinationAirport(airport) {
            searchUnitService.setDestinationAirport(airport, $route.current.area === 'transfers');
            $location.path($route.current.area);
        }
        function setDestinations(airport) {
            if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                destinationService.getDetails(airport).then(function (destination) {
                    searchUnitService.setDestination(destination);
                    setDestinationAirport(destination);
                });
            }
            else {
                setDestinationAirport(airport);
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .controller('TransferDirection', TransferDirection);
    function TransferDirection($scope, searchUnitService, $location, $route, resourceService) {
        var cm = this;
        cm.directions = [
            { val: 1, name: resourceService.get('RETURN') },
            { val: 2, name: resourceService.get('AIRPORTTORESORT') },
            { val: 3, name: resourceService.get('RESORTTOAIRPORT') }
        ];
        cm.transfer = {
            direction: searchUnitService.getDirection()
        };
        $scope.$on('radio-clicked', function () {
            searchUnitService.setDirection(cm.transfer.direction);
            $location.path($route.current.area);
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .controller('TransferSearch', TransferSearch);
    function TransferSearch($scope, $location, transferSearch, $routeParams, basketService, tripService, resourceService, broker, occupancyService, analytics) {
        var cm = this;
        $scope.$emit('block', {
            title: resourceService.get('SEARCHINGTRANSFERS'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'default-transferSearchCtrl'
        });
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var transferRq = trip && trip.TransfersRequest;
            if (transferRq) {
                var searchId_2 = transferRq.AvailabilitySearchId;
                transferSearch.getSearchResults(searchId_2, trip.TripId).then(function (data) {
                    cm.transfers = data;
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                }, function () {
                    $location.path('transfers');
                });
                tripService.getTransfersRequestSummary($routeParams.tripId)
                    .then(function (summary) { return cm.summary = summary; });
                cm.getPricePP = function (totalPrice) {
                    var numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
                    return totalPrice / numPassengers;
                };
                analytics.track('mixpanel', 'TransferPage');
                cm.selectTransfer = function (transfer) {
                    var data = {
                        Title: transfer.Type,
                        CostPP: transfer.PerPersonPrice,
                        CostTotal: transfer.TotalPrice,
                        TotalOptions: cm.transfers.length,
                        MinOptionCostTotal: _.first(cm.transfers).TotalPrice,
                        MaxOptionCostTotal: _.last(cm.transfers).TotalPrice,
                        SupplierName: transfer.SupplierName
                    };
                    analytics.track('mixpanel', 'OptionsTransferSelected', data);
                    basketService.selectTransfer(transfer.TransferId, searchId_2, trip.BasketId, trip.TripId);
                    cm.selectedTransfer = transfer.TransferId;
                };
            }
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .service('transferDetail', transferDetail);
    function transferDetail($http, $cacheFactory, $q, broker) {
        var url = '/api3/transfers/details/';
        var timeout;
        var promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');
        var service = {
            getTransferDetails: getTransferDetails,
            rehydrate: rehydrate
        };
        function getTransferDetails(request) {
            if (timeout != null) {
                timeout.resolve('CANCELLED');
            }
            timeout = $q.defer();
            return $http.post(url + "get", request, {
                timeout: timeout.promise,
                customErrCallback: function (args) {
                    if (args.status && args.status !== -1) {
                        broker.publish('transferRequestFailed');
                    }
                    return true;
                }
            }).then(function (res) {
                promiseCache.remove(res.data.DetailsSessionId);
                timeout = null;
                return res.data;
            });
        }
        function rehydrate(id) {
            if (!promiseCache.get(id)) {
                promiseCache.put(id, $http.post(url + "getfromsession", { DetailsSessionId: id }, { ignoreErrors: true }).then(function (res) {
                    return res.data;
                }));
            }
            return promiseCache.get(id);
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .service('transferSearch', transferSearch);
    function transferSearch($http, occupancyService, transferSearchValidator, searchUnitService, $q, tripService, analytics) {
        var domain = TRPCONFIG.Domain;
        var req = {
            CultureCode: domain.CultureCode,
            CurrencyCode: domain.CurrencyCode,
            DomainId: domain.DomainId,
            TradingGroupId: domain.TradingGroup
        };
        var results;
        var inProgress;
        var url = '/api3/transfers/availability/';
        var service = {
            validateSearchCriteria: validateSearchCriteria,
            clearSearchResults: clearSearchResults,
            getSearchResults: getSearchResults,
            search: search,
            getAvailabilityRequest: getAvailabilityRequest,
            getUrl: getUrl,
            getTransfersTimeApprovalRequired: getTransfersTimeApprovalRequired
        };
        function _doRequest(r, newSearch) {
            return newSearch ?
                $http.post(url + "get", r) :
                $http.post(url + "getfromsession", { AvailabilitySearchId: r.AvailabilitySearchId }, { ignoreErrors: true });
        }
        function validateSearchCriteria(options) {
            options = options || {};
            var start = searchUnitService.startDate(searchUnitService.transfer);
            var end = searchUnitService.endDate(searchUnitService.transfer);
            var transfersTimeApprovalRequired = getTransfersTimeApprovalRequired(options.enableTransfersTimeApproval);
            if (transfersTimeApprovalRequired) {
                if (!searchUnitService.isStartTimeApprovedByCustomer(searchUnitService.transfer)) {
                    start = null;
                }
                if (!searchUnitService.isEndTimeApprovedByCustomer(searchUnitService.transfer)) {
                    end = null;
                }
            }
            return transferSearchValidator.validate(searchUnitService.getDestinationAirport(), searchUnitService.getResort(), searchUnitService.getDirection(), start, end, occupancyService.reduceOccupancy(), searchUnitService.getLocationId(), searchUnitService.getTransferType(), searchUnitService.getTransferPickUpPoint(), searchUnitService.getTransferDropOffPoint());
        }
        function clearSearchResults() {
            results = null;
        }
        function getSearchResults(searchId, tripId) {
            if (results && results !== 'null') {
                return $q.when(_.cloneDeep(results));
            }
            return search({ searchId: searchId, tripId: tripId });
        }
        function search(args) {
            if (inProgress != null && !args.newSearch) {
                return inProgress;
            }
            req.AvailabilitySearchId = args.searchId;
            req.TripId = args.tripId;
            if (args.newSearch) {
                var transferType = searchUnitService.getTransferType();
                if (!TRPCONFIG.Domain.PointToPointTransferSearchEnabled && transferType === searchUnitService.transferTypes.AirportTransfer) {
                    req.DestinationAirport = searchUnitService.getDestinationAirport();
                    req.AirportCode = req.DestinationAirport.Code;
                    var route = searchUnitService.getRoute();
                    if (route) {
                        req.Route = route;
                    }
                    else {
                        var location_1 = searchUnitService.getLocationId();
                        req.LocationId = location_1 || 0;
                    }
                }
                else {
                    var pickUpPoint = searchUnitService.getTransferPickUpPoint();
                    var dropOffPoint = searchUnitService.getTransferDropOffPoint();
                    req.Route = {
                        PickUpPoint: pickUpPoint,
                        DropOffPoint: dropOffPoint
                    };
                }
                req.IsFlightPlus = args.isFlightPlus;
                //Note we are deliberately cocking up the dates because we have to
                req.ArrivalDate = searchUnitService.requiresStartDate() ? searchUnitService.startDate(searchUnitService.transfer) : null;
                req.ReturnDate = searchUnitService.requiresEndDate() ? searchUnitService.endDate(searchUnitService.transfer) : null;
                req.BalanceDueDateOverride = args.BalanceDueDateOverride;
            }
            else if (args.searchId === '00000000-0000-0000-0000-000000000000') {
                //we get an empty guid back from the availability call when there are no results.
                //This means that there will be nothing in the session so we can just return an empty array
                return $q.when([]);
            }
            analytics.startTimer('TransfersAvailabilityRequest');
            inProgress = tripService.getTripReducedOccupancy(req.TripId).then(function (occ) {
                occ = occ || occupancyService.reduceOccupancy();
                req.Adults = occ.Adults;
                req.ChildAges = occ.ChildAges;
                var pax = req.Adults + req.ChildAges.length;
                if (args.newSearch) {
                    tripService.recordTransferSearch(args.tripId, req);
                }
                return _doRequest(req, args.newSearch)
                    .then(function (res) {
                    analytics.endTimer('TransfersAvailabilityRequest');
                    req.AvailabilitySearchId = res.data.AvailabilitySearchId;
                    results = res.data.Transfers;
                    inProgress = null;
                    enrichData(results, pax);
                    return _.cloneDeep(results);
                }, function () {
                    inProgress = null;
                    results = null;
                });
            });
            return inProgress;
        }
        function getAvailabilityRequest() {
            return req;
        }
        function getUrl() {
            return url;
        }
        function enrichData(transfers, totalPax) {
            angular.forEach(transfers, function (transfer) {
                transfer.PerPersonPrice = transfer.TotalPrice / totalPax;
            });
        }
        function getTransfersTimeApprovalRequired(enableTransfersTimeApproval) {
            return enableTransfersTimeApproval && TRPCONFIG.Domain.DeviceType !== 'Mobile';
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('transfers')
        .service('transferSearchValidator', transferSearchValidator);
    function transferSearchValidator(resourceService, dateUtil, occupancyService) {
        var service = {
            validate: validate
        };
        function validate(destinationAirport, resort, direction, arrivalDate, returnDate, occupancy, locationId, transferType, pickUpPoint, dropOffPoint) {
            var errors = [];
            var airportToResort = 2;
            var resortToAirport = 3;
            var airportTransferType = 0;
            if (occupancyService.moreInfantsThanAdults()) {
                errors.push(resourceService.get('TOOMANYINFANTS'));
            }
            if (!occupancyService.childAgesPopulated()) {
                errors.push(resourceService.get('CHILDAGESERROR'));
            }
            if (transferType && transferType !== airportTransferType) {
                if (pickUpPoint == null) {
                    errors.push(resourceService.get('SELECTPICKUPPOINT'));
                }
                if (dropOffPoint == null) {
                    errors.push(resourceService.get('SELECTDROPOFFPOINT'));
                }
            }
            else {
                if (destinationAirport == null) {
                    errors.push(resourceService.get('SELECTDESTINATIONAIRPORT'));
                }
                if (resort == null && locationId == null) {
                    errors.push(resourceService.get('SELECTRESORT'));
                }
            }
            if (direction !== resortToAirport) {
                if (arrivalDate == null) {
                    errors.push(resourceService.get('SELECTARRIVALDATETIME'));
                }
                else if (!dateUtil.atLeastOneDayInTheFuture(arrivalDate)) {
                    errors.push(resourceService.get('ARRIVALDATEMUSTBEFUTURE'));
                }
            }
            if (direction !== airportToResort) {
                if (returnDate == null) {
                    errors.push(resourceService.get('SELECTRETURNDATETIME'));
                }
                else if (direction !== airportToResort && returnDate <= arrivalDate) {
                    errors.push(resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
                }
            }
            return errors;
        }
        return service;
    }
})();
var TR;
(function (TR) {
    'use strict';
    var Review = /** @class */ (function () {
        function Review() {
        }
        return Review;
    }());
    var AppPromo = /** @class */ (function () {
        function AppPromo(analytics) {
            this.analytics = analytics;
            this.analytics.track('mixpanel', 'AppPromoLanding');
            this.benefits = _.map(TRPCONFIG.Domain.AppPromoBenefits, function (b) {
                var _a = _.split(b, '|'), icon = _a[0], title = _a[1];
                return { icon: icon, title: title };
            });
            this.why = TRPCONFIG.Domain.AppPromoWhy;
            this.androidReviews = _.map(TRPCONFIG.Domain.AppPromoAndroidReviews, this._parseReview);
            this.IOSReviews = _.map(TRPCONFIG.Domain.AppPromoIOSReviews, this._parseReview);
            this.overlay = {
                image: "url(\"" + TRPCONFIG.Domain.AppPromoOverlayImage + "\")",
                text: TRPCONFIG.Domain.AppPromoOverlayText
            };
            $.each({
                'title': "<title>" + TRPCONFIG.Domain.AppPromoMetaTitle + "</title>",
                'meta[name=title]': "<meta name=\"title\" content=\"" + TRPCONFIG.Domain.AppPromoMetaTitle + "\">",
                'meta[name=description]': "<meta name=\"description\" content=\"" + TRPCONFIG.Domain.AppPromoMetaDescription + "\">"
            }, function (selector, htmlStr) {
                $(selector).remove();
                $('head').append(htmlStr);
            });
        }
        AppPromo.prototype.trackClick = function (appStore) {
            this.analytics.track('mixpanel', 'AppPromoClick', { appStore: appStore });
        };
        AppPromo.prototype._parseReview = function (review) {
            var _a = _.split(review, '|'), author = _a[0], date = _a[1], rating = _a[2], comment = _a[3];
            return {
                author: author,
                date: date,
                rating: parseInt(rating, 10),
                comment: comment
            };
        };
        return AppPromo;
    }());
    angular
        .module('TR')
        .controller('AppPromo', AppPromo);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Home', Home);
    function Home($route, broker, occupancyService, publicityService, criteoService) {
        var cm = this;
        var area = $route.current.area;
        publicityService.getStats({
            StatisticTypes: 'All'
        }).then(function (data) {
            cm.stats = {
                numberOfAirlines: data.AirlineCount.Value,
                numberOfHotels: data.EstabCount.Value
            };
        });
        occupancyService.enforceAreaLimits(area);
        // if we arrive at this route we must cancel any outstanding searches
        broker.publish('homePageHit');
        criteoService.enqueue({}, 'home', area === 'holidays' ? 4 : 2);
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('LandingPage', LandingPage);
    function LandingPage($injector, resourceService, imageService, $rootScope, $timeout, pageStrand, loggingService, holidayDeals, filtering, $location, $scope, recentHotels, hotelService, $route, $filter, $routeParams, destinationService, searchUnitService, currentDestination, $q, broker, supportedProducts, analytics, occupancyService, tripService, objectTypeService, bd4travel, fidParser, v2v3HandoverService) {
        var lp = this;
        var seoData = {};
        var destination;
        var currentPath = $location.path();
        var redirectEstabLandingPath = v2v3HandoverService.redirectEstabLandingPath(currentPath);
        var redirectDestLandingPath = v2v3HandoverService.redirectDestLandingPath(currentPath);
        var isV2Request = v2v3HandoverService.isV2Request();
        bd4travel.clearContext();
        $rootScope.lockScreen($scope, {
            loadingScreenStyle: 'default-landingPageCtrl'
        });
        if ((redirectEstabLandingPath || redirectDestLandingPath) && !isV2Request) {
            return;
        }
        $scope.landingPageV2Loaded = function () {
            if ($location.search().autoSearch !== '1') {
                broker.publish('landingPageV2Loaded');
                loadDeals();
                getSimilarDestinations(lp.destination);
            }
        };
        delete $route.current.$$route.area;
        function loadDeals() {
            $q.all([
                holidayDeals.find({ pageSize: 8, destination: destination, saveToUrl: false, includeCruises: false }),
                filtering.getFilters(holidayDeals.getDefaultFilters(), pageStrand.get('Holiday'))
            ]).then(function (_a) {
                var deals = _a[0], filters = _a[1];
                _.forEach(deals.Products, function (deal) { return deal.ImageUrl = deal.CroppedImage; });
                $scope.deals = {
                    Products: deals.Products,
                    Aggregates: deals.Aggregates,
                    Filters: filters
                };
            });
        }
        $scope.goToDeal = function (deal) {
            var selected = deal.HolidayDeals[0];
            var estabId = deal.Id;
            var occupancy = occupancyService.getOccupancy();
            $scope.$emit('block', {
                title: resourceService.get('LOADINGHOTELS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-landingPageCtrl-selectRecommendation'
            });
            tripService
                .getTripIdForHolidayDeal(selected, occupancy)
                .then(function (tripId) { return $location.path("/holidays/" + tripId + "/" + estabId); });
        };
        currentDestination.getCurrentDestination()
            .then(updateDest)
            .then(updateNoIndexFollow)
            .then(getSeoData)
            .then(setDOMContent)
            .then(function () {
            if ($location.search().autoSearch !== '1') {
                broker.publish('unblock');
            }
        });
        function updateDest(dest) {
            if (dest == null) {
                loggingService.logWarn("failed to look up destination for friendly url " + $routeParams.landingPage);
                $rootScope.unlockScreen($scope);
                $location.replace();
                $location.path('pagenotfound');
                return dest;
            }
            lp.destination = dest;
            //if this is a hotel it's always going to have pagestrand 1 so we need to customer for the tm=1 qs param
            if (destinationService.destinationIsEstab(dest)) {
                analytics.track('mixpanel', dest.PageStrand === 1 ? 'HotelLandingPage' : 'HolidayLandingPage');
                analytics.incrementPeopleEvent(dest.PageStrand === 1 ? 'HotelLandingPage visit' : 'HolidayLandingPage visit');
            }
            function supportedProduct() {
                if (dest.PageStrand === 1) {
                    return supportedProducts.isProductSupported(supportedProducts.products.hotels);
                }
                return supportedProducts.isProductSupported(supportedProducts.products.holidays);
            }
            if (!supportedProduct()) {
                $location.replace();
                $location.path('/');
                $rootScope.unlockScreen($scope);
                $q.reject();
                return;
            }
            destination = { Type: dest.Type, Id: dest.Id };
            $route.current.$$route.area = pageStrand.toRoute(dest.PageStrand);
            //we might be coming back here from selecting a new destination from the autocompleter in mobile
            //so we need to check whether destination is already and we are just changing it in the search unit
            var currentDest = searchUnitService.getDestination();
            if (currentDest == null || !currentDest.changed) {
                return searchUnitService.setDestination(dest, false, true).then(setTemplate);
            }
            return setTemplate(dest);
        }
        function getSeoData(dest) {
            // Get available SEO data once `setTemplate` has run
            if (dest == null) {
                return;
            }
            var subscriberName = 'landingPageCtrl';
            // Get resource strings
            seoData.inOrNearStr = resourceService.get(dest.IsPOI ? 'NearDestination' : 'InDestination');
            // Hotel
            if ($scope.hotel) {
                return dest; // No extra data needed
            }
            else if (destinationService.destinationIsCountry(dest)) {
                // Get lowest price when data is ready
                analytics.track('mixpanel', 'CountryLandingPage');
                analytics.incrementPeopleEvent('CountryLandingPage visit');
                return $q(function (resolve) {
                    broker.subscribeOnce(subscriberName, 'landingPageV2Loaded', function () {
                        resolve(dest);
                    });
                    broker.subscribeOnce(subscriberName, 'destTopChildrenRetrieved', function (results) {
                        seoData.price = getLowestPrice(results && results.data, 'MinHotelPrice');
                        resolve(dest);
                    });
                });
            }
            // Not Hotel or Country
            // Get lowest price when data is ready
            return $q(function (resolve) {
                broker.subscribeOnce(subscriberName, 'landingPageV2Loaded', function () {
                    resolve(dest);
                });
                broker.subscribeOnce(subscriberName, 'hotelResultsModified', function (results) {
                    var data = results && results.data;
                    seoData.price = getLowestPrice(data && data.Hotels, 'IndicativeMinPrice');
                    resolve(dest);
                });
            });
        }
        function getSimilarDestinations(dest) {
            if (dest.Type === 2 && TRPCONFIG.Domain.BD4Enabled && $injector.has('bd4Helper')) {
                var bd4Dest_1 = new window.Recommendations.Bd4Destination(dest);
                $scope.bd4SimilarDestinations = [];
                var context = {
                    filter: {
                        destination: [
                            bd4Dest_1.fullyQualifiedId
                        ]
                    }
                };
                $injector.get('bd4Helper').getRecommendedDestinations('HOLIDAYS_DESTINATION_LANDINGPAGE', context, bd4Dest_1, 4)
                    .then(function (similarDestinations) {
                    _(similarDestinations)
                        .filter(function (similarDestination) { return similarDestination.fullyQualifiedId !== bd4Dest_1.fullyQualifiedId; })
                        .forEach(function (similarDestination) {
                        destinationService.getDetails(similarDestination)
                            .then(function (d) { return _.last(d.BreadcrumbTrail); })
                            .then(function (d) {
                            d.ImageUrl = TRPCONFIG.DestinationImagesClientDomain + "api2/destination/images/getfromobject?Type=" + d.ObjectTypeId + "&Id=" + d.ObjectId;
                            $scope.bd4SimilarDestinations.push(d);
                        });
                    });
                });
            }
        }
        function setDOMContent(dest) {
            if (dest == null) {
                return;
            }
            var dataPoints = [
                // `alt` is resource name to use if transformed string exceeds `max` length
                { name: 'MetaTitle', max: 59, alt: 'AltMetaTitle' },
                { name: 'MetaDescription', max: 159, alt: 'AltMetaDescription' },
                { name: 'PageTitle' },
                { name: 'PageHeading' }
            ];
            var hotel = $scope.hotel;
            dest.IsPreview = ($routeParams.ispreview !== undefined && $routeParams.ispreview.toLowerCase() === 'true');
            // Create content from string templates
            destinationService.getText(dest)
                .then(function (templStrings) {
                // Get values from available data
                var varMap = getVarMap(hotel, dest);
                var descStrings = {};
                // Replace {vars} in `templStrings`
                dataPoints.forEach(function (dataPoint) {
                    var dataName = dataPoint.name;
                    var maxChars = dataPoint.max;
                    var templStr = templStrings[dataName] || '{name}';
                    var transformedStr = String.supplant(templStr, varMap) || '';
                    // If `max` chars specified, use `alt` template if it exists
                    if (maxChars && transformedStr.length > maxChars) {
                        var altTemplStr = templStrings[dataPoint.alt];
                        if (altTemplStr) {
                            transformedStr = String.supplant(altTemplStr, varMap);
                        }
                    }
                    descStrings[dataName] = transformedStr;
                });
                // Add HotelSummary if available
                descStrings.HotelSummary = hotel && hotel.Summary || undefined;
                descStrings.MetaRobots = templStrings.MetaRobots || undefined;
                // Image url i.e. `og:image`
                descStrings.imageURL = imageService.getLandingPageImage(dest);
                // Update HTML elements
                updateDOM(descStrings);
            });
        }
        function getAbParam() {
            var qs = $location.search();
            var fid = fidParser.parse();
            if (fid || qs.fbt) {
                return 1;
            }
            return qs.ab || TRPCONFIG.Domain.LandingPagesV2Control || 1;
        }
        function getTemplate(dest, ab) {
            var strand = pageStrand.toRoute(dest.PageStrand);
            var params = objectTypeService.getObjectTypeAndId(dest);
            params.ab = ab;
            switch (destinationService.getDestinationType(dest)) {
                case destinationService.country:
                    return $q.when("partials/" + strand + "/country?" + $.param(params));
                case destinationService.estab:
                    recentHotels.set(dest.EstablishmentId);
                    return hotelService.getHotel(null, dest.EstablishmentId).then(function (hotel) {
                        broker.publish('hotelCacheReady', hotel);
                        delete hotel.Rooms;
                        $scope.hotel = hotel;
                        return "partials/" + strand + "/hotellanding?landing=true";
                    });
                default:
                    params.landing = true;
                    return $q.when("partials/" + strand + "/hotelsearch?" + $.param(params));
            }
        }
        function setTemplate(dest) {
            var ab = getAbParam(dest);
            return getTemplate(dest, ab).then(function (template) {
                lp.template = template;
                return dest;
            });
        }
        function getLowestPrice(hotels, priceProp) {
            var prices = [];
            if (Array.isArray(hotels)) {
                hotels.forEach(function (hotel) {
                    var price = hotel && hotel[priceProp];
                    if (price) {
                        prices.push(price);
                    }
                });
            }
            return _.min(prices) || undefined;
        }
        function getVarMap(hotel, dest) {
            // Variable mapping in string templates i.e. {name}
            // Also supports legacy numeric vars i.e. {0}
            var getBcTitle = destinationService.getBreadcrumbTitle;
            // If hotel data exists
            if (hotel) {
                return {
                    0: hotel.Title,
                    1: seoData.inOrNearStr,
                    2: hotel.Province + ", " + hotel.Country,
                    name: hotel.Title,
                    in: seoData.inOrNearStr,
                    price: $filter('roundedCurrency')(hotel.IndicativeMinPrice),
                    province: hotel.Province,
                    country: hotel.Country,
                    location: hotel.Location
                };
            }
            // Else get destination data
            return {
                0: dest.Title,
                1: seoData.inOrNearStr,
                name: dest.ShortTitle,
                in: seoData.inOrNearStr,
                price: $filter('roundedCurrency')(seoData.price),
                country: getBcTitle(dest, function (bc) { return bc.ObjectId === dest.CountryId; }),
                province: getBcTitle(dest, function (bc) { return bc.ObjectId === dest.ProvinceId; }),
                number: "" + dest.HotelCount // String for continuity
            };
        }
        function updateDOM(descStrings) {
            // Update page title
            document.title = descStrings.PageTitle;
            // Replace or create DOM <head> elements: {selector: htmlStr, ...}
            $.each({
                'meta[name=title]': "<meta name=\"title\" content=\"" + descStrings.MetaTitle + "\">",
                'meta[name=description]': "<meta name=\"description\" content=\"" + descStrings.MetaDescription + "\">",
                'meta[property="og:title"]': "<meta property=\"og:title\" content=\"" + descStrings.MetaTitle + "\">",
                'meta[property="og:description"]': "<meta property=\"og:description\" content=\"" + (descStrings.HotelSummary || descStrings.MetaDescription) + "\">"
            }, function (selector, htmlStr) {
                $(selector).remove();
                $('head').append(htmlStr);
            });
            //Update meta robots
            if (_.get(descStrings, 'MetaRobots.length') > 0) {
                var robots = $('meta[name="robots"]');
                if (robots.length > 0) {
                    robots.attr('content', descStrings.MetaRobots);
                }
                else {
                    $('head').append("<meta name=\"robots\" content=\"" + descStrings.MetaRobots + "\">");
                }
            }
            // Update or create og:image
            // If present replace the standard site logo, otherwise add the 'og:image' tag from scratch
            var ogImage = $('meta[name="og:image"]');
            if (ogImage) {
                ogImage.attr('content', descStrings.imageURL);
            }
            else {
                $('head').append("<meta property=\"og:image\" content=\"" + descStrings.imageURL + "\">");
            }
        }
        function updateNoIndexFollow(dest) {
            if (dest && dest.HotelCount === 1) {
                var destinationType = destinationService.getDestinationType(dest);
                if (destinationType !== destinationService.estab) {
                    broker.publish('ISNOINDEXFOLLOW', { isNoIndexFollow: true });
                }
            }
            return dest;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('LoadingScreen', LoadingScreen);
    function LoadingScreen($scope, resourceService, publicityService, searchUnitService, currentDestination, broker, tripService, $route, funcUtil, $timeout, $rootScope, analytics) {
        var cm = this;
        var properties = { name: resourceService.getDeferred('PROPERTIES'), icon: 'icon-hotels' };
        var reviews = { name: resourceService.getDeferred('HOTELREVIEWS'), icon: 'icon-reviews' };
        var airlines = { name: resourceService.getDeferred('AIRLINES'), icon: 'icon-flights' };
        if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
            publicityService.getStats({
                CultureCode: TRPCONFIG.Domain.CultureCode,
                StatisticTypes: 'All',
                SearchDate: searchUnitService.startDate(searchUnitService.flight) || searchUnitService.startDate(searchUnitService.hotel)
            }).then(function (data) {
                cm.stats = data;
                properties.count = data.EstabCount;
                reviews.count = data.ReviewCount;
                airlines.count = data.AirlineCount;
            });
        }
        $scope.$watch('searching', function (v) {
            if (v) {
                currentDestination.getCurrentDestination().then(function (dest) {
                    cm.destination = dest;
                });
            }
        });
        broker.subscribe('LoadingScreen', 'tripUpdated', function (trip) {
            (trip.data.TripId ? tripService.getTripDestination(trip.data.TripId)
                : currentDestination.getCurrentDestination())
                .then(function (dest) { return cm.destination = dest; });
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('LoadingScreen');
        });
        cm.chooseStyles = function (loadingScreenStyle) {
            if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
                if (window.logLoadingScreenStyle) {
                    console.log('loadingScreenStyle: ', loadingScreenStyle);
                }
                var strippedloadingScreenStyle = (loadingScreenStyle || '').split('-')[0];
                switch (strippedloadingScreenStyle) {
                    case 'booking':
                        cm.showBookMessage = true;
                        cm.scalemessages = [];
                        if (!cm.usp) {
                            cm.usp = ['USPHOLIDAYDEPOSIT', 'USPFLEXIBLEPAYMENT', 'USPLOWESTPRICES'];
                        }
                        break;
                    case 'hotels':
                        cm.showBookMessage = false;
                        cm.scalemessages = [properties, reviews];
                        cm.usp = ['USPDEPOSIT', 'USPFLEXIBLEPAYMENT', 'USPLOWESTPRICES'];
                        break;
                    case 'flights':
                        cm.showBookMessage = false;
                        cm.scalemessages = [airlines];
                        cm.usp = ['USPLOWESTPRICES'];
                        break;
                    default:
                        cm.showBookMessage = false;
                        cm.scalemessages = [properties, reviews, airlines];
                        cm.usp = ['USPHOLIDAYDEPOSIT', 'USPFLEXIBLEPAYMENT', 'USPLOWESTPRICES'];
                        break;
                }
            }
        };
        $timeout(function () {
            var area = $route.current && $route.current.$$route && $route.current.$$route.area;
            cm.chooseStyles(area + "-loadingScreenCtrl");
        });
        var windowPrerenderReadyTrue = _.debounce(function () { return window.prerenderReady = true; }, 1000);
        var key = 'timer';
        var scrollTimeout;
        $rootScope.$on('block', function (ev, data) {
            window.prerenderReady = false;
            analytics.endTimer(key);
            scrollTimeout = $timeout(function () {
                // This will be cancelled if unblock runs immediately
                // Avoids scroll during form validation
                scrollTo(0, 0);
            });
            $scope.title = data.title;
            $scope.subtitle = data.subtitle;
            $rootScope.searching = true;
            $scope.searching = true;
            if ($scope.cm && $scope.cm.chooseStyles) {
                $scope.cm.chooseStyles(data.loadingScreenStyle);
            }
            key = $scope.title || 'timer';
            analytics.startTimer(key);
        });
        function unblock() {
            windowPrerenderReadyTrue();
            $rootScope.searching = false;
            $scope.searching = false;
            $timeout.cancel(scrollTimeout);
            analytics.endTimer(key);
        }
        $rootScope.$on('unblock', unblock);
        broker.subscribe('LoadingScreenDirective', 'unblock', unblock);
        $scope.$on('$destroy', function () { return broker.unsubscribe('LoadingScreenDirective'); });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('NotFound', NotFound);
    function NotFound(basketService, analytics, broker, occupancyService, $scope, $location, $route, savedSearchService) {
        broker.publish('unblock');
        var cm = this;
        var type = {
            3: basketService.holidayBooking,
            2: basketService.hotelBooking,
            4: basketService.transferBooking
        };
        cm.area = $route.current.area;
        savedSearchService.getSavedSearches().then(function (searches) {
            cm.mostRecent = _.head(searches);
            if (cm.mostRecent) {
                cm.mostRecent.occupancyStr = occupancyService.getOccupancyString(cm.mostRecent.Rooms);
            }
        });
        cm.restore = function () {
            if (cm.mostRecent == null) {
                $location.path("/" + cm.area);
            }
            else {
                $scope.$emit('block', {
                    title: null,
                    loadingScreenStyle: 'default-notFoundCtrl'
                });
                savedSearchService.restoreSearch(cm.mostRecent).then(function () {
                    basketService.startWorkflow(type[cm.mostRecent.SearchType]);
                    analytics.trackEvent({ label: 'rescued from trip 404' });
                });
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Occupancy', Occupancy);
    function Occupancy($window, occupancyService, arrayUtil, $route) {
        var cm = this;
        var area = $route.current.area;
        cm.adultRange = occupancyService.adultRange(area);
        cm.ages = occupancyService.ages;
        cm.applyOccupancy = occupancyService.applyOccupancy;
        cm.childRange = occupancyService.childRange(area);
        cm.childrenChanged = childrenChanged;
        cm.maxAge = area === 'marhaba' ? 12 : 17;
        cm.occupancyAgeConfig = {
            Min: 0,
            Max: cm.maxAge
        };
        cm.addRoom = addRoom;
        cm.removeRoom = removeRoom;
        cm.showRoom = showRoom;
        cm.isActive = isActive;
        cm.occupancy = occupancyService.getOccupancy();
        cm.passengerCount = occupancyService.getPassengerCount();
        //if this is transfers / marhaba / insurance occupancy then rooms don't make sense and we need to merge the occupancy into one room
        if (area === 'transfers' || area === 'marhaba' || area === 'insurance' || area === 'flights') {
            cm.occupancy = [occupancyService.reduceOccupancy()];
        }
        cm.currentRoom = cm.occupancy[0];
        _countChildren();
        occupancyService.onApplyOccupancy(function () {
            setTimeout(function () {
                occupancyService.setOccupancy(cm.occupancy);
                occupancyService.setPassengerCount(cm.passengerCount);
                $window.history.back();
            }, 0);
        });
        function isActive(room) {
            return room === cm.currentRoom ? 'active' : '';
        }
        function childrenChanged() {
            arrayUtil.addOrRemove(cm.currentRoom.ChildAges, cm.currentRoom.numChildren, function () {
                // Default child age
                return 8;
            });
        }
        function addRoom() {
            cm.occupancy = occupancyService.addRoom();
            cm.currentRoom = cm.occupancy[cm.occupancy.length - 1];
            _countChildren();
        }
        function removeRoom(index) {
            cm.occupancy = occupancyService.removeRoom(index);
            cm.currentRoom = cm.occupancy[cm.occupancy.length - 1];
        }
        function showRoom(index) {
            cm.currentRoom = cm.occupancy[index];
        }
        function _countChildren() {
            cm.occupancy.forEach(function (o) {
                o.numChildren = (o.ChildAges || []).length;
            });
        }
    }
})();
var TR;
(function (TR) {
    var PromotionTermsPageConfig = /** @class */ (function () {
        function PromotionTermsPageConfig() {
        }
        return PromotionTermsPageConfig;
    }());
    var PromotionTerm = /** @class */ (function () {
        function PromotionTerm() {
        }
        return PromotionTerm;
    }());
    var PromotionTerms = /** @class */ (function () {
        function PromotionTerms(hotelSearch) {
            var _this = this;
            this.hotelSearch = hotelSearch;
            this.promotionTermsPageConfig = TRPCONFIG.Domain.PromotionTermsPageConfig;
            this.hotelSearch.getPromotionTerms().then(function (res) {
                _this.promotionsTermsList = res;
            })
                .catch(function () { return false; });
        }
        return PromotionTerms;
    }());
    angular
        .module('TR')
        .controller('PromotionTerms', PromotionTerms);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('RootController', RootController);
    function RootController($rootScope, $scope, $location, $route, $interval, bootstrapper, publicityService, locationService, imageService, modalService, currentDestination, agentModeService, broker, globalisationService, cookieService, analytics) {
        var rc = this;
        var sidebarMenuOpen = false;
        bootstrapper.init();
        $scope.$on('$routeChangeStart', function (scope, next) {
            rc.hideDistractionLinks = !!next.hideDistractionLinks;
            rc.hideTravelAgentLinks = !!next.hideTravelAgentLinks;
            rc.hideSiteFooter = !!next.hideSiteFooter;
            rc.hideFooterToolbar = !!next.hideFooterToolbar;
            rc.inTransactionalFlow = !!next.inTransactionalFlow;
            rc.bodyUncontained = !!next.bodyUncontained;
            rc.minimalHeader = false;
            rc.closeModal();
            rc.hideSiteMailingSignUp();
            rc.showSfChat = !!next.pathParams.tripId;
        });
        broker.subscribe('RootController', 'hideFooter', function () { return rc.hideSiteFooter = true; });
        broker.subscribe('RootController', 'stripHeader', function () { return rc.minimalHeader = true; });
        rc.showPopup = false;
        rc.popupUrl = '';
        rc.impersonatedUserName = false;
        rc.preventPopupClose = true;
        rc.hideHeaderBar = false;
        rc.modalParams = null;
        rc.agentModeEnabled = TRPCONFIG.Domain.isAgentMode;
        rc.DomainHostName = TRPCONFIG.Domain.HostName;
        rc.hideFooterToolBar = TRPCONFIG.Domain2.FooterToolBarABTest;
        $scope.$on('$routeChangeSuccess', function () {
            var regEx = /.*\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}[0-9a-fA-F]{0,1}[/]*?/;
            var abtesttUrl = ($location.$$path.match(regEx) || $location.$$path.match(/attractions/));
            var abtesttUrlMatched = abtesttUrl && abtesttUrl.input;
            if (abtesttUrlMatched) {
                rc.hideMinimalHeader = window.TRPCONFIG.Domain2.HideMinimalHeader;
            }
            else {
                rc.hideMinimalHeader = false;
            }
            // this is needed to poll for when the googletag api is ready and then we force a refresh
            var googletagPoll;
            if ((TRPCONFIG.Domain2.Platform195EnabledPages.includes('home') ||
                TRPCONFIG.Domain2.Platform195MobileEnabledPages.includes('home')) &&
                window.googletag &&
                $location.path() === '/') {
                googletagPoll = $interval(function () {
                    if (window.googletag && window.googletag.apiReady) {
                        var slots = document.querySelectorAll('.platform-195-slot');
                        var refreshSlots_1 = 0;
                        slots.forEach(function (_a) {
                            var innerHTML = _a.innerHTML;
                            if (/googletag\.cmd\.push/.test(innerHTML) && (!/google_ads_iframe/.test(innerHTML))) {
                                refreshSlots_1++;
                            }
                        });
                        if (refreshSlots_1 > 0) {
                            window.googletag.pubads().refresh();
                        }
                        $interval.cancel(googletagPoll);
                    }
                }, 10);
            }
        });
        if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain.ShowAgentOfficeSelector) {
            agentModeService.getAgentInformation().then(function (data) {
                if (data) {
                    var officeLocations = data.OfficeLocations;
                    if (officeLocations && officeLocations.length > 0) {
                        rc.enableOfficeChange = officeLocations.length > 1;
                        officeLocations.forEach(function (loc) {
                            if (loc.Id === data.CurrentOfficeLocation) {
                                rc.selectedOfficeLocation = loc.Name;
                            }
                        });
                    }
                    var permittedDomains_1 = data.PermittedDomains;
                    var permittedRegions_1;
                    if (permittedDomains_1) {
                        globalisationService.getAllDomains().then(function (allDomains) {
                            var currentDomain = allDomains.filter(function (d) { return d.Id === TRPCONFIG.Domain.DomainId; })[0];
                            var parentDomainId = currentDomain.ParentId ? currentDomain.ParentId : TRPCONFIG.Domain.DomainId;
                            var parentSubDomains = allDomains.filter(function (d) { return d.ParentId === parentDomainId; });
                            if (permittedDomains_1.length === 0) {
                                permittedRegions_1 = parentSubDomains;
                            }
                            else {
                                permittedRegions_1 = parentSubDomains.filter(function (d) { return permittedDomains_1.indexOf(d.Id) !== -1; });
                            }
                            rc.enableDomainChange = permittedRegions_1.length > 1;
                        });
                    }
                }
            });
        }
        rc.queryString = function () {
            return location.search.replace('?', '');
        };
        rc.filmCampaignTrack = function (event, channel) {
            var Page = $location.path().match('[^/]+$')[0];
            var data = { Page: Page };
            if (channel) {
                data.Channel = channel;
            }
            analytics.track('mixpanel', event, data);
        };
        modalService.onLaunch(function (val, preventClose, hideHeaderBar) {
            rc.modal(val, preventClose, hideHeaderBar);
        });
        modalService.onClose(function () {
            rc.closeModal();
        });
        rc.modal = function (path, preventClose, hideHeaderBar, modalParams) {
            rc.preventPopupClose = preventClose;
            rc.popupUrl = path;
            rc.showPopup = true;
            rc.hideHeaderBar = hideHeaderBar;
            rc.modalParams = modalParams;
        };
        rc.enableHotelSearchResultsPageDesignChangeABTest = function () {
            return window.TRPCONFIG.Domain2.EnableHotelSearchResultsPageDesignChange;
        };
        rc.closeModal = function () {
            rc.popupUrl = '';
            rc.showPopup = false;
        };
        if (TRPCONFIG.DeviceSettings.PublicityMessagingEnabled) {
            publicityService.getStats({
                StatisticTypes: 'All'
            }).then(function (stats) {
                rc.stats = stats;
            });
        }
        rc.home = function () {
            locationService.home();
        };
        rc.go = function (path) {
            $location.path(path);
        };
        rc.menuClicked = function (e) {
            sidebarMenuOpen = !sidebarMenuOpen;
            $scope.$broadcast('menuClicked');
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        rc.hideOverflow = function () {
            return sidebarMenuOpen ? 'hide-overflow' : '';
        };
        rc.hideSiteMailingSignUp = function () {
            var url = $location.path();
            if (!url.match(/prefetch/gi)) {
                if (TRPCONFIG.IsMobileDevice) {
                    rc.hideSiteMailingListSignUp = url === '/' || !!url.match(TRPCONFIG.Domain.HideSiteMailingSignUpMobile, 'gi');
                }
                else {
                    rc.hideSiteMailingListSignUp = url === '/' || !!url.match(TRPCONFIG.Domain.HideSiteMailingSignUpDesktop, 'gi');
                }
            }
        };
        broker.subscribe('RootController', 'hideNavigationDrawer', function () {
            sidebarMenuOpen = false;
        });
        broker.subscribe('RootController', 'userExtended', function (extendedUser) {
            if (!extendedUser || !extendedUser.data) {
                return;
            }
            var customer = extendedUser.data;
            if (customer.FirstName && customer.LastName) {
                rc.impersonatedUserName = customer.FirstName + " " + customer.LastName;
            }
            if (customer.Contact && customer.Contact.FirstName && customer.Contact.LastName) {
                return rc.impersonatedUserName = customer.Contact.FirstName + " " + customer.Contact.LastName;
            }
        });
        broker.subscribe('RootController', 'userDeimpersonated', function () {
            rc.impersonatedUserName = false;
        });
        rc.brokerPublish = function (key, val) {
            broker.publish(key, val);
        };
        $(window).on('resize', _.debounce(function () {
            /*this doesn't do anything but it appears to trigger a digest on
            windows resize which is what we want.*/
        }, 100));
        broker.subscribe('RootController', 'destinationChanged', _updateShowCaseStyle);
        function _updateShowCaseStyle() {
            currentDestination.getCurrentDestination().then(function (dest) {
                var url = imageService.getLandingPageImage(dest);
                rc.showcaseStyle = url ? { 'background-image': "url(" + url + ")" } : undefined; //prevent bindonce from giving up until we have a value
                var hero = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.MobileDestinationOverlay.ImageSrc');
                rc.promoOverlayStyle = hero && dest ? { 'background-image': "url(" + hero + ")" } : { display: 'none' };
                rc.destination = dest;
                var mobileBannerImage = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.MobileBanner.ImageSrc');
                rc.sale = mobileBannerImage && !rc.destination;
                url = url || mobileBannerImage;
                if (url) {
                    rc.heroStyle = { 'background-image': "url(" + url + ")" };
                }
                rc.heroStyleSkip = rc.destination == null ? { 'background-image': 'url(build/img/beach-background.png)' } : rc.heroStyle;
            });
        }
        _updateShowCaseStyle();
        rc.backgroundStyle = function () {
            var loadingScreenBackground = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.ResponsiveInterstitialBackground.ImageSrc');
            //if get image from cms enabled then return null
            if (TRPCONFIG.Domain.CMSInterstitialImagesEnabled) {
                return null;
            }
            return loadingScreenBackground ? { 'background-image': "url(" + loadingScreenBackground + ")" } : { 'background-image': 'url(build/img/beach-background.png)' };
        };
        rc.bannerStyle = function () {
            var loadingScreenBanner = _.get(TRPCONFIG, 'Domain.SaleBannerUrls.ResponsiveInterstitialBanner.ImageSrc');
            return loadingScreenBanner ? { 'background-image': "url(" + loadingScreenBanner + ")" } : '';
        };
        $rootScope.lockScreen = function (scope, data) {
            scope.$emit('block', data || {});
        };
        $rootScope.unlockScreen = function (sc) {
            broker.publish('unblock');
            sc.$emit('unblock');
        };
        $rootScope.$on('$routeChangeStart', function (_, next) {
            rc.showStrapLine = _getStrapLine($location.$$path, next.strapLine);
        });
        /*
         * Return logic only for all page except "/pages/terms"
         * @param path
         * @param strapLine
         * @returns {boolean}
         * @private
         */
        function _getStrapLine(path, strapLine) {
            return path === '/pages/terms' ? null : !!strapLine;
        }
        $scope.$on('$destroy', function () {
            broker.unsubscribe('RootController');
        });
        rc.signout = function () {
            agentModeService.signout().then(function () {
                window.location.href = $location.search().Dest || '/';
            });
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('SearchUnit', SearchUnit);
    function SearchUnit(pageStrand, $timeout, $scope, resourceService, searchUnitService, $route, $location, dateUtil, $window, basketService, broker, geo, analytics, currentDestination, occupancyService, holidayDeals, searchQueryString, destinationService) {
        var cm = this;
        cm.showTabs = !TRPCONFIG.Domain.CompactMobileTabs || _.includes(['hotels', 'holidays'], $route.current.area);
        var searchMsgs = ['SEARCHINGFLIGHTS', 'SEARCHINGHOTELS', 'SEARCHINGTRANSFERS', 'MARHABASEARCHING', 'SEARCHINGFLIGHTS', 'SEARCHINGINSURANCE'];
        var minimumDate = dateUtil.todayPlus(1, 0, true);
        //none of this needs be done if we're already in the availability path
        //because we will not be displaying the search unit
        if (cm.hotel && cm.hotel.Rooms != null) {
            return;
        }
        cm.supportsGeo = geo.supported();
        cm.autoCompleterSelect = autoCompleterSelect;
        cm.getEndDate = getEndDate;
        cm.getStartDate = getStartDate;
        cm.setStartDate = setStartDate;
        cm.setEndDate = setEndDate;
        cm.showStartDate = showStartDate;
        cm.showEndDate = showEndDate;
        cm.flexibleDates = searchUnitService.flexibleDates === undefined ? true : searchUnitService.flexibleDates;
        cm.searchType = $route.current.area;
        cm.onewayonly = false;
        cm.productToggle = productToggle;
        cm.nearby = nearby;
        cm.search = search;
        var mode = searchUnitService.flight;
        var flow = basketService.holidayBooking;
        switch ($route.current.area) {
            case 'hotels':
                minimumDate = dateUtil.todayPlus(TRPCONFIG.Domain.HotelSearchOffsetDate, 0, true);
                if ((new Date()).getUTCHours() >= TRPCONFIG.Domain.TimeCutoffForSameDayHotelSearch) {
                    //if current time exceeds same day search cutoff, set min date to next day for hotel searches
                    minimumDate = dateUtil.todayPlus(1, 0, true);
                }
                mode = searchUnitService.hotel;
                flow = basketService.hotelBooking;
                break;
            case 'transfers':
                if (searchUnitService.getDirection() === 3) {
                    minimumDate = null;
                }
                mode = searchUnitService.transfer;
                flow = basketService.transferBooking;
                break;
            case 'marhaba':
                minimumDate = dateUtil.todayPlus(2, 0, true);
                mode = searchUnitService.marhaba;
                flow = basketService.marhabaBooking;
                break;
            case 'flights':
                mode = searchUnitService.flight;
                flow = basketService.flightBooking;
                break;
            case 'insurance':
                mode = searchUnitService.insurance;
                flow = basketService.insuranceBooking;
                break;
        }
        var minimumDatePlusOne = dateUtil.addDays(minimumDate, 1, true) || dateUtil.todayPlus(1, 0, true);
        cm.durations = holidayDeals.DURATIONS.map(function (d) { return ({
            name: d + " " + resourceService.get('NIGHTS'),
            value: d
        }); });
        cm.duration = searchUnitService.duration(mode);
        cm.updateDuration = function () {
            searchUnitService.duration(mode, cm.duration);
        };
        cm.focusOnDuration = function () {
            $('.duration select[name="duration"]').focus();
        };
        // Cabin
        cm.cabin = searchUnitService.getCabin();
        cm.cabinOptions = searchUnitService.getCabinOptions();
        cm.updateCabin = function () {
            searchUnitService.setCabin(cm.cabin);
        };
        broker.subscribe('SearchUnit', 'savedSearchRestored', function () {
            cm.summary = searchUnitService.getSummary(mode);
        });
        cm.deselectAllAirlines = function () {
            delete searchUnitService.airlines;
            $location.search('airlines', null);
            cm.summary = searchUnitService.getSummary(mode);
        };
        $scope.$on('$destroy', function () {
            broker.unsubscribe('SearchUnit');
        });
        var waiting = false;
        cm.startDate = searchUnitService.startDate(mode);
        cm.endDate = searchUnitService.endDate(mode);
        cm.dealsFlexibility = searchUnitService.dealsFlexibility;
        cm.outboundDates = searchUnitService.getOutboundDates(mode);
        if (cm.startDate) {
            cm.startPlusOne = dateUtil.addDays(cm.startDate, 1, true);
        }
        cm.minDates = {
            minimumDate: minimumDate,
            startPlusOne: cm.startPlusOne || minimumDatePlusOne
        };
        cm.flexibleDatesDisabled = function () {
            return TRPCONFIG.Domain2.FlexibleDatesFlowsDisabled.indexOf(searchUnitService.capitalize(cm.searchType)) !== -1;
        };
        $scope.$watch('cm.startDate', function (val) {
            if (val) {
                cm.showStartCalendar = false;
                cm.setStartDate(val);
            }
        });
        $scope.$watch('cm.dealsFlexibility', function (val) { return searchUnitService.dealsFlexibility = val; });
        loadNearestAirports();
        var clearParams = function () {
            //cleardown query params - as otherwise params will override values search unit values when not necessary
            $location.replace()
                .search('startDate', null)
                .search('endDate', null)
                .search('depAir', null)
                .search('occ', null)
                .search('autoSearch', null)
                .search('cabin', null);
        };
        searchQueryString.getQueryStringValues().then(function (queryString) {
            searchUnitService.airlines = queryString.airlines;
            if (queryString.startDate != null) {
                cm.setStartDate(queryString.startDate, false);
            }
            if (queryString.endDate != null) {
                cm.setEndDate(queryString.endDate, false);
            }
            if (cm.startDate) {
                cm.startPlusOne = dateUtil.addDays(cm.startDate, 1, true);
            }
            if (queryString.airports) {
                if (queryString.airports.length === 1) {
                    searchUnitService.setDepartureAirports(queryString.airports[0]);
                }
                else {
                    searchUnitService.setDepartureAirports(queryString.airports);
                }
            }
            if (queryString.occupancy != null) {
                occupancyService.setOccupancy(queryString.occupancy);
            }
            if (queryString.autoSearch) {
                //set the current destination to run the search against
                currentDestination.getCurrentDestination().then(function (dest) {
                    if (dest != null) {
                        cm.autoCompleterSelect(dest, false);
                    }
                    else if (queryString.destination) {
                        destinationService.getDetails(queryString.destination[0]).then(function (destination) {
                            if (destination != null) {
                                searchUnitService.setDestination(destination);
                                searchUnitService.setDestinationAirport(destination);
                            }
                        });
                        searchUnitService.setDestinationAirport(queryString.destination[0]);
                    }
                    $timeout(function () {
                        cm.search();
                        clearParams();
                    }, 1000);
                });
            }
            else {
                clearParams();
            }
            cm.summary = searchUnitService.getSummary(mode);
        });
        $timeout(function () {
            if ($route.current.area === 'transfers') {
                var destinationAirports = searchUnitService.getDestinationAirports();
                if (destinationAirports && destinationAirports.length > 1) {
                    searchUnitService.setDestinationAirport();
                }
            }
            currentDestination.getCurrentDestination().then(function (dest) {
                if (dest && !dest.HolidayEnabled && flow === basketService.holidayBooking) {
                    $scope.$emit('flash:error', String.format(resourceService.get('NOTHOLIDAYENABLED'), dest.Title));
                }
                cm.summary = searchUnitService.getSummary(mode);
                cm.flightType = searchUnitService.getFlightType().Label;
                if (TRPCONFIG.Domain.DurationEnable) {
                    initDurationInput();
                }
            });
        }, 0);
        function autoCompleterSelect(item, back) {
            if (back === void 0) { back = true; }
            if (!waiting) {
                waiting = true;
                return searchUnitService.setDestination(item, false, true).then(function (d) {
                    waiting = false;
                    d.changed = true;
                    if (back) {
                        //this has to go in a setTimeout so that it does not take place in the context of a call to
                        //$apply. If it does it causes infinite digest loops in some phones
                        setTimeout(function () {
                            $window.history.back();
                        }, 0);
                    }
                }); //yuck yak
            }
        }
        function getStartDate() {
            return searchUnitService.startDate(mode);
        }
        function getEndDate() {
            return searchUnitService.endDate(mode);
        }
        function setEndUsingDuration(durationLength) {
            var duration = searchUnitService.duration(mode, durationLength);
            duration = duration && duration.value || TRPCONFIG.Domain.SearchUnitDurationDefault;
            var endDate = dateUtil.addDays(getStartDate(), duration, true);
            setEndDate(endDate, null);
        }
        function setStartDate(date, back) {
            if (date) {
                cm.minDates.startPlusOne = dateUtil.addDays(date, 1, true);
            }
            searchUnitService.startDate(mode, date);
            cm.summary = searchUnitService.getSummary(mode);
            cm.showStartCalendar = false;
            if (TRPCONFIG.Domain.DurationEnable) {
                setEndUsingDuration();
            }
            if (back) {
                setTimeout(function () {
                    $window.history.back();
                }, 0);
            }
        }
        function setEndDate(date, back) {
            searchUnitService.endDate(mode, date);
            cm.summary = searchUnitService.getSummary(mode);
            cm.showEndCalendar = false;
            if (back) {
                setTimeout(function () {
                    $window.history.back();
                }, 0);
            }
        }
        function initDurationInput() {
            cm.options = searchUnitService.getDurationOptions();
            $scope.$watch('cm.duration', function () {
                if (cm.duration) {
                    setEndUsingDuration(cm.duration || TRPCONFIG.Domain.SearchUnitDurationDefault);
                }
                else if (searchUnitService.duration(mode)) {
                    cm.duration = cm.options[searchUnitService.duration(mode).index];
                }
                else {
                    cm.duration = cm.options[0];
                }
            });
        }
        function showStartDate() {
            return $route.current.area !== 'transfers' || searchUnitService.requiresStartDate();
        }
        function showEndDate() {
            return $route.current.area !== 'transfers' || searchUnitService.requiresEndDate();
        }
        function productToggle(r) {
            if ($route.current.landing) {
                var currentStrand = pageStrand.fromRoute();
                var strand = pageStrand.opposite(currentStrand);
                $location.url(pageStrand.adjustUrl($location.url(), strand));
                $route.reload();
            }
            else {
                $location.path(r);
            }
        }
        function nearby(e) {
            e.stopPropagation();
            cm.gettingLocation = true;
            $scope.$emit('flash:error');
            geo.getSearchArea().then(function (sa) {
                analytics.trackEvent({ label: 'search nearby' });
                searchUnitService.setSearchArea(sa);
                cm.summary = searchUnitService.getSummary(mode);
                cm.gettingLocation = false;
            }, function () {
                cm.gettingLocation = false;
                $scope.$emit('flash:error', resourceService.get('POSITIONUNAVAILABLE'));
            });
        }
        function search() {
            $scope.$emit('block', {
                title: resourceService.get(searchMsgs[flow]),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-searchUnitCtrl'
            });
            searchUnitService.flexibleDates = TRPCONFIG.Domain.FlexibleDatesEnabled ? cm.flexibleDates : true;
            searchUnitService.onewayonly = TRPCONFIG.Domain.OneWayFlightsEnabled ? cm.onewayonly : false;
            var isAirlinesPrefilter = !_.some(searchUnitService.airlines, function (a) { return a.IsPostfilter; });
            var params = {
                flexibleDates: searchUnitService.flexibleDates,
                oneWayOnly: searchUnitService.onewayonly,
                prefilterAirlines: isAirlinesPrefilter ? _.map(searchUnitService.airlines, function (a) { return a.Code; }) : [],
                postfilterAirlines: !isAirlinesPrefilter ? _.map(searchUnitService.airlines, function (a) { return a.Title; }) : []
            };
            basketService.startWorkflow(flow, params).then(null, function (errors) {
                broker.publish('unblock');
                $scope.$emit('unblock');
                $scope.$emit('flash:error', errors);
            });
        }
        function loadNearestAirports() {
            var departureAirports = searchUnitService.getDepartureAirports();
            if (!departureAirports || !departureAirports.length) {
                geo.getNearestAirports().then(function (airports) {
                    // Check a second time to not overwrite a departure airport
                    // that could have been selected before this promise resolved.
                    var departureAirports = searchUnitService.getDepartureAirports();
                    if (!departureAirports || !departureAirports.length) {
                        searchUnitService.setMultipleDepartureAirports(airports);
                        cm.summary = searchUnitService.getSummary(mode);
                    }
                });
            }
        }
    }
})();
var TR;
(function (TR) {
    var SelectDomain = /** @class */ (function () {
        function SelectDomain(cookieService, $location, agentModeService, globalisationService, dateUtil) {
            var _this = this;
            this.cookieService = cookieService;
            this.$location = $location;
            this.agentModeService = agentModeService;
            this.globalisationService = globalisationService;
            this.dateUtil = dateUtil;
            this.lightbox = false;
            this.lightbox = true;
            this.agentModeService.getAgentInformation().then(function (data) {
                var permittedDomains = data.PermittedDomains;
                _this.officeLocations = data.OfficeLocations;
                _this.globalisationService.getAllDomains().then(function (allDomains) {
                    var currentDomain = allDomains.filter(function (d) { return d.Id === TRPCONFIG.Domain.DomainId; })[0];
                    var parentDomainId = currentDomain.ParentId ? currentDomain.ParentId : TRPCONFIG.Domain.DomainId;
                    var parentSubDomains = allDomains.filter(function (d) { return d.ParentId === parentDomainId; });
                    if (permittedDomains.length === 0) {
                        _this.permittedRegions = parentSubDomains;
                    }
                    else {
                        _this.permittedRegions = parentSubDomains.filter(function (d) { return permittedDomains.indexOf(d.Id) !== -1; });
                        if (_this.permittedRegions.length === 1) {
                            _this.setSelectedDomain(_this.permittedRegions[0].Id);
                        }
                    }
                });
            });
        }
        SelectDomain.prototype.setSelectedDomain = function (selectedDomain) {
            var _this = this;
            this.cookieService.set('SubDomainID', selectedDomain, this.dateUtil.addDays(new Date(), 365));
            if (this.officeLocations.length === 1) {
                this.agentModeService.setOfficeLocation(this.officeLocations[0].Id).then(function () {
                    window.location.href = _this.$location.absUrl().replace('selectdomain', '');
                });
            }
            else {
                this.$location.path('selectoffice');
            }
        };
        return SelectDomain;
    }());
    angular
        .module('TR')
        .controller('SelectDomain', SelectDomain);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var SelectOffice = /** @class */ (function () {
        function SelectOffice(agentModeService, $location) {
            var _this = this;
            this.agentModeService = agentModeService;
            this.$location = $location;
            this.lightbox = false;
            this.lightbox = true;
            this.agentModeService.getAgentInformation().then(function (data) {
                _this.OfficeLocations = data.OfficeLocations;
                _this.selectedOffice = data.CurrentOfficeLocation;
                if (_this.OfficeLocations.length === 1) {
                    _this.setSelectedOffice(_this.OfficeLocations[0].Id);
                }
            });
        }
        SelectOffice.prototype.setSelectedOffice = function (office) {
            var _this = this;
            this.agentModeService.setOfficeLocation(office).then(function () {
                window.location.href = _this.$location.absUrl().replace('selectoffice', '');
            });
        };
        return SelectOffice;
    }());
    angular
        .module('TR')
        .controller('SelectOffice', SelectOffice);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('TestDestination', TestDestination);
    function TestDestination() {
        var cm = this;
        cm.LocationName = 'Alcatraz';
        //cm.activeTabId = 'cakes';
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('TestHome', TestHome);
    function TestHome() {
        var cm = this;
        cm.activeTabId = 'aaa';
        cm.dialogOpen = false;
        cm.dialogTwoOpen = false;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('TestPage', TestPage);
    function TestPage() {
        var cm = this;
        cm.fruits = [];
        cm.selectedMammals = [];
        cm.activeTabId = 'cakes';
        cm.mammals = [
            {
                Value: 1,
                Text: 'Bear'
            },
            {
                Value: 2,
                Text: 'Marmot'
            },
            {
                Value: 3,
                Text: 'Porcupine'
            }
        ];
    }
})();
var Core;
(function (Core) {
    var CountBadge = /** @class */ (function () {
        function CountBadge($scope) {
            var _this = this;
            this.$scope = $scope;
            this.$scope.$watch('cb.count', function (val) {
                if (val) {
                    _this.output = val < 10
                        ? val.toString()
                        : '9+';
                }
            });
        }
        return CountBadge;
    }());
    angular
        .module('core')
        .directive('countBadge', function () {
        return {
            scope: {},
            controller: CountBadge,
            controllerAs: 'cb',
            bindToController: {
                count: '='
            },
            template: "<span class=\"sc-c-badge\">{{cb.output}}</span>",
            replace: true
        };
    });
})(Core || (Core = {}));
var FilterAllButton = /** @class */ (function () {
    function FilterAllButton() {
    }
    FilterAllButton.prototype.clearFilter = function (filter) {
        filter.splice(0, filter.length);
    };
    return FilterAllButton;
}());
angular
    .module('TR')
    .directive('filterAllButton', function () {
    return {
        controller: FilterAllButton,
        controllerAs: 'fab',
        bindToController: {
            model: '='
        },
        replace: true,
        template: "\n                <label\n                    class=\"checkbox-btn full-width\"\n                    ng-click=\"fab.clearFilter(fab.model)\"\n                    ng-class=\"{'checked': !fab.model.length}\">\n                    <div class=\"icon\"></div>\n                    <div class=\"label-content\"><span>{{'FILTERALLBUTTON'|resource}}</span></div>\n                </label>"
    };
});
(function () {
    'use strict';
    angular.module('TR')
        .directive('acceptCookiesBanner', function ($timeout, cookieService) { return ({
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/home/directivetemplate?type=acceptcookiesbanner',
        controllerAs: 'ac',
        controller: function ($rootScope) {
            var cookiesAccepted = cookieService.get('CookiesAccepted') || false;
            this.hide = cookiesAccepted;
            this.if = !cookiesAccepted;
            this.acceptCookies = function () {
                var _this = this;
                cookieService.set('CookiesAccepted', true, Infinity);
                this.if = false;
                $timeout(function () { return _this.if = false; }, 1000);
                $rootScope.$emit('cookiesAccepted');
            };
        }
    }); });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('accountMenu', function ($rootScope, $location, authService, urlUtils, dateUtil, cookieService, languageService, modalService, dashboardNotificationService, $route, accountMenuService, broker, postBookingLookup, resourceService, $window, $document) {
        return {
            restrict: 'E',
            replace: true,
            priority: 200,
            templateUrl: function (el, attrs) { return "partials/home/directivetemplate?type=accountmenu" + (attrs.forNavigationDrawer === 'true' ? 'sidebar' : ''); },
            link: function (scope, el, attrs) {
                var menuOpen = false;
                scope.forNavigationDrawer = (attrs.forNavigationDrawer === 'true');
                scope.IsTouchDevice = $window.TRPCONFIG.IsTouchDevice;
                scope.selectedLanguage = cookieService.get('LANG') || 'en-GB';
                scope.limitAlerts = 2;
                scope.formatNotification = function (noti) { return dashboardNotificationService.formatNotification(noti); };
                scope.showDashboardMenu = false;
                scope.showNotifications = false;
                scope.showDashboardMenuSidebar = true;
                scope.setLanguage = setLanguage;
                scope.setLanguagePreference = setLanguagePreference;
                scope.sidebarClass = function () { return menuOpen ? 'open' : ''; };
                scope.signOut = signOut;
                scope.user = authService.getUser();
                scope.userName = userName;
                scope.launchNotification = launchNotification;
                scope.notificationClicked = notificationClicked;
                scope.toggleDashboardMenuSidebar = function () { return scope.showDashboardMenuSidebar = !scope.showDashboardMenuSidebar; };
                scope.toggleNotification = function () {
                    scope.showNotifications = !scope.showNotifications;
                    scope.showDashboardMenu = false;
                };
                scope.toManage = toManage;
                scope.getResourceValue = function (resource) { return resourceService.get(resource); };
                scope.formatNotification = function (notification) { return dashboardNotificationService.formatNotification(notification); };
                //For EKH agent website
                scope.launchUserProfileSearch = launchUserProfileSearch;
                scope.launchUserProfileView = launchUserProfileView;
                scope.launchUserProfileCreate = launchUserProfileCreate;
                scope.bookingName = bookingName;
                scope.customerName = customerName;
                scope.manageBooking = manageBooking;
                scope.showSignOutAlert = false;
                scope.$on('auth:signin', function () {
                    resetNotifications();
                    scope.user = authService.getUser();
                });
                scope.$on('auth:signout', function () {
                    menuOpen = false;
                    $rootScope.alerts = null;
                    scope.user = authService.getUser();
                });
                scope.$on('menuClicked', function () {
                    menuOpen = !menuOpen;
                    if (menuOpen) {
                        resetNotifications();
                    }
                });
                resetNotifications();
                function setLanguagePreference(lang, id) {
                    var _this = this;
                    languageService.setLanguage(lang, id)
                        .then(function () {
                        if (TRPCONFIG.Domain.RedirectLanguageChangeToHomepage) {
                            window.location.href = '/?rl=1';
                        }
                        else {
                            //window.location.href = this.$location.absUrl();
                            _this.$route.reload();
                        }
                    });
                }
                function setLanguage() {
                    cookieService.set('LANG', scope.selectedLanguage, dateUtil.addDays(new Date(), 365));
                    window.location.href = $location.absUrl();
                }
                function launchUserProfileSearch() {
                    modalService.launch('partials/userprofile/Search', { promptUserSelection: false });
                }
                function launchUserProfileView() {
                    modalService.launch('partials/userprofile/UpdateUserProfileModal');
                }
                function launchUserProfileCreate() {
                    modalService.launch('partials/userprofile/CreateUserProfileModal');
                }
                function launchNotification() {
                    accountMenuService.launchNotification(scope.alerts);
                    scope.closeMenu();
                }
                function userName() {
                    if (!scope.user) {
                        return '';
                    }
                    if (scope.user.FirstName && scope.user.LastName) {
                        return scope.user.FirstName + " " + scope.user.LastName;
                    }
                    var bookingId = authService.getSignedInBookingId();
                    if (bookingId && scope.user.Contact && scope.user.Contact.SiteId) {
                        return scope.user.Contact.SiteId + "/" + bookingId;
                    }
                    return scope.user.Email;
                }
                function bookingName() {
                    var bookingId = authService.getSignedInBookingId();
                    if (bookingId) {
                        return this.user.Contact.SiteId + "/" + bookingId;
                    }
                }
                function customerName() {
                    if (scope.user.SignedIn && scope.user.LastName) {
                        return scope.user.FirstName + " " + scope.user.LastName;
                    }
                }
                function manageBooking() {
                    if (scope.user.AnonSignedIn) {
                        return postBookingLookup.redirect();
                    }
                }
                function resetNotifications() {
                    var user = authService.getUser();
                    if (TRPCONFIG.Domain.DashboardBookingEnabled && TRPCONFIG.Domain.SideBarNotificationEnabled && (user.AnonSignedIn || user.HardSignedIn)) {
                        dashboardNotificationService.getNotifications()
                            .then(function (data) { return $rootScope.alerts = data; });
                    }
                }
                function notificationClicked(noti) {
                    scope.closeMenu();
                    scope.showDashboardMenu = false;
                    scope.showNotifications = false;
                    dashboardNotificationService.notificationClicked(noti);
                }
                function signOut() {
                    var isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
                    var enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');
                    var path = '/v3';
                    var currentPath = $location.path();
                    var dashboardPath = currentPath && currentPath.startsWith('/dashboard');
                    return authService.signOut().then(function () {
                        broker.publish('hideNavigationDrawer');
                        scope.showDashboardMenu = false;
                        if (enableV3SignIn && !isAgentMode && dashboardPath) {
                            var _a = window.location, hostname = _a.hostname, protocol = _a.protocol;
                            var search = window.location.search;
                            if (search) {
                                search = '';
                            }
                            window.location.href = protocol + "//" + hostname + path + search;
                        }
                    });
                }
                function toManage() {
                    scope.closeMenu();
                    var cookieName = authService.createCookieName();
                    authService.doesHttpOnlyCookieExist(cookieName);
                    scope.showDashboardMenu = false;
                    scope.showNotifications = false;
                    if (scope.user.AnonSignedIn && !scope.user.SignedIn) {
                        return postBookingLookup.redirect();
                    }
                    if (!scope.user.AnonSignedIn && scope.user.SignedIn) {
                        return $location.path('dashboard/bookings/current');
                    }
                    return accountMenuService.launchOption('bookingsignin');
                }
                scope.subMenuTriggerMouseenter = function (e, booleanName) {
                    // open on mouseenter for non-touch only
                    if (!scope.forNavigationDrawer && !scope.IsTouchDevice) {
                        scope[booleanName] = true;
                    }
                };
                scope.subMenuTriggerMouseleave = function (e, booleanName) {
                    // close on mouseleave for non-touch only
                    if (!scope.forNavigationDrawer && !scope.IsTouchDevice) {
                        scope[booleanName] = false;
                    }
                };
                scope.subMenuTriggerClick = function (e, booleanName) {
                    e.preventDefault();
                    // toggle on click for touch devices only
                    if (!scope.forNavigationDrawer && scope.IsTouchDevice) {
                        scope[booleanName] = !scope[booleanName];
                        if (scope[booleanName]) {
                            e.stopPropagation();
                            // close sub menu when anything else is clicked
                            $document.one('click.accountMenu', function () {
                                scope.$apply(scope[booleanName] = false);
                            });
                        }
                    }
                };
                scope.dashboardLinkClick = function () {
                    broker.publish('hideNavigationDrawer');
                    scope.showDashboardMenu = false;
                };
                scope.hideSignOutAlert = function () {
                    scope.showSignOutAlert = false;
                };
                scope.signOutAlert = function () {
                    scope.showSignOutAlert = true;
                };
                scope.closeMenu = function () {
                    menuOpen = false;
                    broker.publish('hideNavigationDrawer');
                };
            }
        };
    });
})();
var TR;
(function (TR) {
    var AccountSignIn = /** @class */ (function () {
        function AccountSignIn($location, $route, accountMenuService, authService, urlUtils, currentUser) {
            var _this = this;
            this.$location = $location;
            this.$route = $route;
            this.accountMenuService = accountMenuService;
            this.authService = authService;
            this.urlUtils = urlUtils;
            this.currentUser = currentUser;
            this.noBufferUrls = ['signin', 'signup', 'bookingsignin'];
            this.popupSignIn = function (event) {
                var isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
                var enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');
                var user = _this.currentUser.get();
                if (!user.SignedIn && (!isAgentMode && enableV3SignIn)) {
                    var _a = window.location, hostname = _a.hostname, protocol = _a.protocol;
                    var search = window.location.search;
                    var path = '/signin';
                    if (search) {
                        search = '';
                    }
                    window.location.href = protocol + "//" + hostname + path + search;
                    return;
                }
                event.preventDefault();
                var parsedUrl = _this.urlUtils.parse(_this.$location.url());
                parsedUrl.url = _this.urlUtils.stripLeadingSlash(parsedUrl.url);
                parsedUrl.qs.pb = 1;
                var cookieName = _this.authService.createCookieName();
                _this.authService.doesHttpOnlyCookieExist(cookieName);
                var bufferRedirect = _this.noBufferUrls.every(function (bUrl) { return parsedUrl.url.indexOf(bUrl) < 0; })
                    && _this.noBufferUrls.some(function (bUrl) { return _this.path.indexOf(bUrl) > -1; });
                var redirect = _this.urlUtils.format(parsedUrl);
                var currentRoute = _this.$route && _this.$route.current && _this.$route.current.$$route;
                _this.authService.bufferRoute(redirect);
                _this.authService.bufferRoute(bufferRedirect
                    && currentRoute
                    && !currentRoute.requiresAnonAuth
                    && !currentRoute.requiresHardAuth
                    ? redirect : '/');
                //redirect here is only used in the mobile version of accountMenuService
                _this.accountMenuService.launchOption(_this.path, _this.options, redirect);
                if (_this.postSignIn) {
                    _this.postSignIn();
                }
            };
        }
        return AccountSignIn;
    }());
    angular
        .module('TR')
        .directive('accountSignIn', function () {
        return {
            scope: {},
            bindToController: {
                path: '@',
                postSignIn: '&',
                options: '='
            },
            controller: AccountSignIn,
            controllerAs: 'as',
            restrict: 'E',
            replace: true,
            template: "<a href=\"#\" ng-click=\"as.popupSignIn($event)\" ng-transclude></a>",
            transclude: true
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('advert', function (advertService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                dest: '=',
                onPopulate: '&',
                maxToDisplay: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=Advert',
            link: function (scope, el, attr) {
                var pos = parseInt(attr.position) || 1;
                scope.$watch('dest', function (v) {
                    if (v == null) {
                        return;
                    }
                    init(v);
                });
                function init(dest) {
                    advertService.getAdvertsForPosition(pos, dest).then(function (adverts) {
                        var selection = null;
                        if (scope.maxToDisplay && adverts.length > scope.maxToDisplay) {
                            //randomly return the number requested
                            selection = [];
                            while (selection.length < scope.maxToDisplay) {
                                selection.push(adverts.splice(Math.floor(Math.random() * adverts.length), 1)[0]);
                            }
                        }
                        scope.adverts = selection || adverts;
                        scope.serviceUrl = advertService.getUrl();
                        if (scope.adverts.length) {
                            scope.onPopulate();
                        }
                    });
                }
            }
        };
    });
})();
var TR;
(function (TR) {
    var AttractionSelection = /** @class */ (function () {
        function AttractionSelection($scope) {
            var _this = this;
            this.$scope = $scope;
            this.productPeopleCountMap = {};
            var wait = $scope.$watch('as.bookingLoaded', function (b) {
                if (b) {
                    _this.init();
                    wait();
                }
            });
        }
        AttractionSelection.prototype.init = function () {
            var _this = this;
            if (this.attractions.length > 0) {
                this.show = true;
                //set up map of product Id and number of tickets per passenger type
                _.each(this.attractions, function (a) { _.assign(_this.productPeopleCountMap, a.Details.AttractionRequests); });
                this.dateCaptureRequired = _.some(this.model, { 'CaptureDate': true, 'PreferredDate': !null });
            }
        };
        return AttractionSelection;
    }());
    angular
        .module('TR')
        .directive('attractionSelection', function () {
        return {
            bindToController: true,
            controller: AttractionSelection,
            controllerAs: 'as',
            restrict: 'E',
            replace: true,
            scope: {
                bookingLoaded: '=',
                attractions: '=',
                maxDate: '=',
                minDate: '=',
                model: '=',
                rootForm: '=',
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=AttractionSelection&version='
                        + attr.templateVersion;
                }
                else {
                    return 'partials/home/directivetemplate?type=AttractionSelection';
                }
            }
        };
    });
})(TR || (TR = {}));
;
var Attractions;
(function (Attractions) {
    var Overlay = /** @class */ (function () {
        function Overlay(clickFn) {
            this.isActive = false;
            var className = 'attractions-calendar-overlay';
            this.el = $("." + className);
            if (!this.el.length) {
                this.el = $("<div class=\"" + className + "\" />")
                    .appendTo('body')
                    .click(clickFn);
            }
            this.elParent = this.el.parent();
        }
        Overlay.prototype.show = function () {
            this.isActive = true;
            this.el.show();
        };
        Overlay.prototype.resize = function (winWidth) {
            // Sets width to window unless window is smaller than parent
            this.el.css({
                width: Math.max(this.elParent.width(), winWidth)
            });
        };
        Overlay.prototype.hide = function () {
            this.isActive = false;
            this.el.hide();
        };
        return Overlay;
    }());
    var AttractionsCalendar = /** @class */ (function () {
        function AttractionsCalendar($scope, $filter, $window, $q, dateUtil, attractionService, resourceService) {
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.$window = $window;
            this.$q = $q;
            this.dateUtil = dateUtil;
            this.attractionService = attractionService;
            this.resourceService = resourceService;
            this.legend = [];
            this.eventNs = '.ac';
            this.htmlCss = {};
            this.enabledDates = {};
            this.renderedDates = {};
            this.selectedDate = this.dateUtil.parseDate(this.currentDate);
            $(function () {
                if (!$.datepicker._updateDatepicker_original) {
                    // Add `afterShow` event to jquery datepicker
                    // https://bugs.jqueryui.com/ticket/6885
                    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
                    $.datepicker._updateDatepicker = function (inst) {
                        $.datepicker._updateDatepicker_original(inst);
                        var afterShow = this._get(inst, 'afterShow');
                        if (afterShow) {
                            afterShow.apply((inst.input ? inst.input[0] : null));
                        }
                    };
                }
                _this.win = $($window);
                _this.html = $('html');
                _this.debouncedOnRender = _.debounce(function () { return _this.onRender(); }, 100);
                _this.debouncedSetLayout = _.debounce(function () { return _this.setLayout(); }, 100);
                _this.overlay = new Overlay(function () { return _this.datepicker('hide'); });
            });
        }
        AttractionsCalendar.prototype.init = function (inputEl) {
            var _this = this;
            this.$q.when(this.selectedDate || this.getFirstPopulatedDate(0))
                .then(function (date) { return _this.selectedDate = date; })
                .then(function () { return _this._init(inputEl); });
        };
        AttractionsCalendar.prototype._init = function (inputEl) {
            var _this = this;
            var currDate = new Date();
            // Initialise jQuery datepicker http://api.jqueryui.com/datepicker/
            inputEl.datepicker({
                numberOfMonths: 1,
                dateFormat: 'dd-M-yy',
                firstDay: 1,
                defaultDate: this.selectedDate,
                minDate: this.dateUtil.parseDate(this.minDate),
                maxDate: this.dateUtil.parseDate(this.maxDate),
                beforeShowDay: function (date) { return _this.filterDate(date); },
                beforeShow: function () {
                    _this.enabledDates = {};
                    _this.datepickerEl.addClass('attractions-calendar');
                    _this.suppressPositioning();
                    _this.lockScroll();
                    _this.getAvailability(_this.selectedDate ||
                        _this.activeDateFrom ||
                        new Date(currDate.getFullYear(), currDate.getMonth()));
                    _this.overlay.show();
                    return !inputEl.lastDisplay ||
                        (new Date().getTime() - inputEl.lastDisplay > 100);
                },
                afterShow: function () {
                    if (_this.overlay.isActive) {
                        inputEl.blur(); // IE fix cursor showing through overlay
                        _this.createHeader();
                        _this.debouncedOnRender();
                        _this.win.on('resize' + _this.eventNs, function () { return _this.debouncedSetLayout(); });
                    }
                },
                onChangeMonthYear: function (y, m) {
                    if (_this.overlay.isActive) {
                        _this.getAvailability(new Date(y, m - 1)); // Month is 0 based
                    }
                },
                onSelect: function () {
                    _this.selectDate();
                    // http://www.objectpartners.com/2012/06/18/jquery-ui-datepicker-ie-focus-fix/
                    inputEl.lastDisplay = new Date().getTime();
                    inputEl.blur();
                },
                onClose: function () {
                    _this.win.off(_this.eventNs);
                    _this.overlay.hide();
                    _this.renderedDates = {};
                    _this.datepickerEl.removeClass('active');
                    _this.restoreScroll();
                    // This deals with anything typed into the field that changed the value
                    var dpDate = _this.datepicker('getDate') || '', expected = _this.selectedDate || '';
                    if (dpDate.toString() !== expected.toString()) {
                        _this.selectDate();
                    }
                    else {
                        _this.syncField();
                    }
                    // Put back positioning for any other datepickers
                    _this.restorePositioning();
                },
                isRTL: TRPCONFIG.Rtl
            });
            if (TRPCONFIG.IsTouchDevice) {
                inputEl.attr('readonly', 'true');
            }
            this.datepicker = inputEl.datepicker.bind(inputEl);
            this.datepickerEl = $('#ui-datepicker-div');
            this.watchDateAttr('minDate', 'maxDate');
            this.$scope.$watch('ac.parentForm.formModel.date', function (value) {
                if (value == null) {
                    _this.clearDate();
                }
            });
        };
        AttractionsCalendar.prototype.getFirstPopulatedDate = function (monthsFromToday) {
            var _this = this;
            if (monthsFromToday > 12) {
                return null;
            }
            var date = this.dateUtil.todayPlus({ months: monthsFromToday });
            return this.attractionService.getAvailability(this.parentForm.productId, angular.extend({}, this.parentForm.formModel, { date: date }))
                .then(function (res) {
                var dateIdx = _this.getFirstAvailableDateWithTicketsIdx(res);
                var firstDateWithTickets = _.get(res, "Dates[" + dateIdx + "].Date");
                var firstDate = _.get(res, 'Dates[0].Date');
                if (_this.activeDateFrom) {
                    if (_this.dateUtil.compareDates(_this.activeDateFrom, firstDateWithTickets) === -1) {
                        firstDate = firstDateWithTickets;
                    }
                    else {
                        firstDate = _this.activeDateFrom;
                    }
                }
                if (firstDate) {
                    return _this.dateUtil.parseDate(firstDate);
                }
                else {
                    return _this.getFirstPopulatedDate(monthsFromToday + 1);
                }
            });
        };
        AttractionsCalendar.prototype.getFirstAvailableDateWithTicketsIdx = function (res) {
            return _.findIndex(res.Dates, function (obj) {
                return obj.Tickets && obj.Tickets.length > 0;
            });
        };
        AttractionsCalendar.prototype.getDateKey = function (date) {
            return this.dateUtil.format(date, 'yyyy-MM-dd');
        };
        AttractionsCalendar.prototype.filterDate = function (date) {
            var isEnabled = true; // Default to allowing date
            if (this.enabledDates) {
                if (!this.enabledDates[this.getDateKey(date)]) {
                    isEnabled = false;
                }
                if (this.activeDateFrom && this.dateUtil.compareDates(this.activeDateFrom, date) === 1
                    && this.dateUtil.compareDates(date, this.dateUtil.addDays(this.minDate, -1, null)) === 1) {
                    return [isEnabled, 'ui-datepicker-inactive', ''];
                }
            }
            return [isEnabled, '', ''];
        };
        AttractionsCalendar.prototype.watchDateAttr = function () {
            var _this = this;
            var attr = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                attr[_i] = arguments[_i];
            }
            this.$scope.$watchGroup(attr.map(function (k) { return 'ac.' + k; }), function (vals) {
                vals.forEach(function (v, i) {
                    if (_this.datepicker && v != null) {
                        _this.datepicker('option', attr[i], _this.dateUtil.parseDate(v));
                    }
                });
            });
        };
        AttractionsCalendar.prototype.showLoading = function (delay) {
            var _this = this;
            var spinnerHtml = '<div class="preloader circular large">', i = 8;
            while (i--) {
                spinnerHtml += "<div class=\"cell cell-" + (i + 1) + "\"></div>";
            }
            return setTimeout(function () {
                $(spinnerHtml + '</div>').hide().fadeIn(1000)
                    .appendTo(_this.datepickerEl);
            }, delay);
        };
        AttractionsCalendar.prototype.hideLoading = function () {
            this.datepickerEl.find('.preloader').hide();
        };
        AttractionsCalendar.prototype.lockScroll = function () {
            this.htmlCss = {
                overflowY: this.html.css('overflowY'),
                width: 'auto'
            };
            this.html.css({
                overflowY: 'hidden',
                width: $('body').outerWidth()
            });
        };
        AttractionsCalendar.prototype.restoreScroll = function () {
            this.html.css(this.htmlCss);
        };
        AttractionsCalendar.prototype.setLayout = function () {
            var winWidth = this.win.width(), winHeight = TRPCONFIG.Domain.DeviceType === 'Mobile' ?
                screen.height : // ios fix
                this.win.height();
            // Allow for mobile fixed header
            var header = $('.header-main'), headerOffset = header.css('position') === 'fixed' ?
                header.outerHeight() : 0;
            this.overlay.resize(winWidth);
            this.win.scrollLeft(0); // input focus can cause window to scroll away
            this.datepickerEl.css({
                left: winWidth / 2,
                top: $(document).scrollTop() - headerOffset,
                'max-width': winWidth,
                'max-height': winHeight
            });
        };
        AttractionsCalendar.prototype.onRender = function () {
            // For new months this may run both before and after `getAvailability()`
            this.datepickerEl.addClass('active');
            this.populateDates();
            this.setLayout();
        };
        AttractionsCalendar.prototype.getAvailability = function (date) {
            var _this = this;
            // `renderedDates` suppresses re-rendering a month until calendar is closed
            var dateKey = this.getDateKey(date);
            if (!this.renderedDates[dateKey]) {
                var spinnerTimer_1 = this.showLoading(300);
                return this.attractionService.getAvailability(this.parentForm.productId, angular.extend({}, this.parentForm.formModel, { date: date }))
                    .then(function (res) {
                    var dates = res.Dates;
                    clearTimeout(spinnerTimer_1);
                    if (res.error) {
                        _this.hideLoading();
                    }
                    else {
                        _this.legend = _.filter(res.Legend, function (o) { return o.Abbreviation; });
                        dates.forEach(function (o) {
                            var dateStr = _this.getDateKey(o.Date);
                            if (dateStr && _.get(o, 'Tickets.length', 0) > 0) {
                                _this.enabledDates[dateStr] = _this.sortTickets(o.Tickets, _this.legend.reduce(function (o, l, i) { return (o[l.Label] = i + 1) && o; }, {}));
                            }
                        });
                        _this.renderedDates[dateKey] = true;
                        _this.datepicker('refresh'); // Destroys spinner
                    }
                });
            }
        };
        AttractionsCalendar.prototype.sortTickets = function (tickets, order) {
            return tickets.sort(function (a, b) {
                return order[a.Label] < order[b.Label] ? -1 :
                    order[a.Label] > order[b.Label] ? 1 : 0;
            });
        };
        AttractionsCalendar.prototype.syncField = function () {
            // Ensure field contains current value
            this.datepicker('setDate', this.selectedDate);
        };
        AttractionsCalendar.prototype.getLegendChar = function (key) {
            return (_.find(this.legend, {
                Key: key
            }) || {}).Abbreviation || '';
        };
        AttractionsCalendar.prototype.getPriceHtml = function (key) {
            var _this = this;
            var htmlStr = '', enabledDates = this.enabledDates[key];
            if (enabledDates) {
                if (enabledDates.length < 3) {
                    // Placeholder for spacing
                    htmlStr += '<div class="price"></div><br>';
                }
                htmlStr += enabledDates.reduce(function (str, ticket) {
                    return str + "<div class=\"label\">" + _this.getLegendChar(ticket.Key) + "</div><div class=\"price\">" + _this.$filter('roundedCurrency')(ticket.Price) + "</div><br>";
                }, '');
            }
            return htmlStr;
        };
        AttractionsCalendar.prototype.zeroPad = function (n) {
            n += '';
            return ('00' + n).substr(n.length);
        };
        AttractionsCalendar.prototype.populateDates = function () {
            var _this = this;
            // Populate data on active calendar DOM elements (only)
            $('.attractions-calendar [data-month]').each(function (i, el) {
                var $el = $(el), key = $el.attr('data-year') + '-' +
                    _this.zeroPad(Number($el.attr('data-month')) + 1) + '-' + // Month is 1 based
                    _this.zeroPad($el.text()); // Seems jQuery datepicker is designed this way `_selectDay()`
                // NOTE: <div> required even if there's no price data
                $el.append("<div class=\"price-wrapper\">\n                                <div class=\"price-text\">" + _this.getPriceHtml(key) + "</div>\n                            </div>");
            });
        };
        AttractionsCalendar.prototype.createHeader = function () {
            var _this = this;
            var closeBtn = $("<div class=\"close\"><i class=\"icon-close\"></i></div>")
                .click(function () { return _this.datepicker('hide'); });
            var legendArea = !this.legend.length ? '' :
                "<ul class=\"legend\">" + this.legend.reduce(function (str, o) { return str + "\n                        <li><span class=\"label\">" + o.Abbreviation + "</span>" + o.Label + "</li>\n                    "; }, '') + "</ul>";
            var headerArea = $("\n                    <div class=\"header-area\">\n                        <h5>" + this.resourceService.get('ATTRACTIONSCALENDARHEADER') + "</h5>\n                        <div class=\"header-area-notification sc-c-notification sc-c-notification--highlight\">\n                            " + this.resourceService.get('ATTRACTIONBOOKINGNOTE') + "\n                        </div>\n                    </div>");
            var legendAreaConainer = $("\n                <div class=\"header-area\">\n                    " + legendArea + "\n                </div>\n            ");
            this.datepickerEl.append(legendAreaConainer);
            headerArea.append(closeBtn);
            this.datepickerEl.prepend(headerArea);
        };
        AttractionsCalendar.prototype.clearDate = function () {
            this.selectedDate = null;
            this.syncField();
            this.selectDate();
        };
        AttractionsCalendar.prototype.selectDate = function () {
            var _this = this;
            var dateOb;
            this.selectedDate = this.datepicker('getDate') || this.selectedDate;
            if (this.dateUtil.isValid(this.selectedDate)) {
                dateOb = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate());
            }
            this.$scope.$evalAsync(function () {
                if (_this.selectedDate == null) {
                    _this.select({ date: null });
                }
                else {
                    // Add price data to parent form for displaying total
                    var dateData = _this.enabledDates[_this.getDateKey(_this.selectedDate)];
                    if (dateData) {
                        dateData.forEach(function (d) {
                            _this.parentForm.setPriceData(d.Key, d.Price);
                        });
                    }
                    _this.select({
                        date: _this.dateUtil.serialiseDate(dateOb)
                    });
                }
                _this.syncField();
            });
        };
        AttractionsCalendar.prototype.suppressPositioning = function () {
            // Suppress datepicker absolute positioning
            this.dpPosFn = $.datepicker._checkOffset;
            $.datepicker._checkOffset = function () { return ({ left: '', top: '' }); };
        };
        AttractionsCalendar.prototype.restorePositioning = function () {
            $.datepicker._checkOffset = this.dpPosFn;
        };
        AttractionsCalendar.prototype.deregister = function () {
            // Clear class for any other datepickers
            this.datepickerEl.removeClass('attractions-calendar');
            this.win.off(this.eventNs);
            $.datepicker._updateDatepicker = $.datepicker._updateDatepicker_original;
            delete $.datepicker._updateDatepicker_original;
        };
        return AttractionsCalendar;
    }());
    angular
        .module('TR')
        .directive('attractionsCalendar', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: AttractionsCalendar,
            controllerAs: 'ac',
            bindToController: {
                select: '&',
                minDate: '=',
                maxDate: '=',
                currentDate: '=',
                activeDateFrom: '=',
                placeholder: '@'
            },
            require: '^attractionsProductForm',
            template: "<div class=\"date-picker\">\n                        <div class=\"input-with-icon toggle\">\n                            <span class=\"field-icon icon-calendar\"></span>\n                            <input type=\"text\" placeholder=\"{{ac.placeholder}}\" />\n                        </div>\n                    </div>",
            link: function (scope, el, attr, attractionsProductForm) {
                scope.ac.parentForm = attractionsProductForm;
                scope.ac.init(el.find('input'));
                scope.$on('$destroy', function () { return scope.ac.deregister(); });
            }
        };
    });
})(Attractions || (Attractions = {}));
;
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('basketBar', function ($q, tripService, $routeParams, basketStore, broker, customCurrencyFilter, bookingService, arrayUtil) {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=BasketBar',
            scope: {
                hideButton: '=',
                buttonHandler: '&',
                buttonDisabler: '&',
                isDeposit: '=?'
            },
            link: function (scope) {
                if ($routeParams.pb) {
                    return;
                }
                scope.costBreakdowns = [];
                scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
                broker.subscribe('basketBarDirective', 'feesUpdated', _setPaymentTotalPlusFees);
                function _setPaymentTotalPlusFees(fees) {
                    var cardFee = (fees && fees.data && fees.data.CardHandlingFee) || 0;
                    //creating clean data object
                    scope.fees = fees && fees.data ? { data: angular.copy(fees.data) } : null;
                    scope.totalDepositWithCardFee = (scope.deposit || 0) + cardFee;
                }
                tripService.getTrip($routeParams.tripId).then(function (trip) {
                    function getCostbreakdowns() {
                        var reqs = [basketStore.totalDeposit(trip.BasketId, $routeParams.productId),
                            basketStore.costBreakdownGrouped(trip.BasketId),
                            basketStore.getTaxAdjustmentValue(trip.BasketId)];
                        if (trip.BookingId) {
                            reqs.push(bookingService.getBooking(trip.BookingId));
                        }
                        $q.all(reqs).then(function (_a) {
                            var totalDeposit = _a[0], costBreakdownGrouped = _a[1], taxAdjustments = _a[2], booking = _a[3];
                            var costType = {
                                Unknown: 0,
                                Accommodation: 1,
                                Discount: 20,
                                AccommodationCancellationProtection: 21,
                                AccommodationLocalFeesAndTaxes: 22,
                                AccommodationExtraTransfer: 23,
                                AccommodationExtraEvent: 24,
                                AccommodationExtraAttraction: 25,
                                AccommodationExtra: 26,
                            };
                            if (!costBreakdownGrouped.isPackage && (trip.TripType === tripService.tripTypes.Hotel)) {
                                var _b = (costBreakdownGrouped[0] || {}).costBreakdown, costBreakdown = _b === void 0 ? [] : _b;
                                var extraCostItems = costBreakdown.filter(function (cost) {
                                    var match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') ===
                                        (costType.AccommodationExtraTransfer || costType.AccommodationExtraEvent
                                            || costType.AccommodationExtraAttraction || costType.AccommodationExtra || costType.AccommodationExtra || costType.AccommodationLocalFeesAndTaxes || costType.AccommodationCancellationProtection || costType.Discount);
                                    return match;
                                }).filter(function (extra) { return extra; });
                                var roomCostItems = costBreakdown.filter(function (cost) { return !_.get(cost, 'ParentId')
                                    && _.get(cost, 'TypeId') === costType.Accommodation; }).map(function (room, LinkId) {
                                    return __assign({}, room, { LinkId: LinkId });
                                });
                                if (extraCostItems && extraCostItems.length > 0 && roomCostItems && roomCostItems.length > 0) {
                                    var updatedRoomCostItems_2 = roomCostItems.map(function (room) {
                                        return { RoomId: room.Id, RoomDescription: room.Description };
                                    });
                                    var enhancedExtras = extraCostItems.map(function (extras) {
                                        return __assign({}, extras, updatedRoomCostItems_2.find(function (acc) { return acc.RoomId === extras.ParentId; }));
                                    });
                                    var updatedExtrasCostItems = enhancedExtras.map(function (extra, LinkId) {
                                        var splitDescription = _.get(extra, 'RoomDescription').split('(');
                                        var Description = splitDescription[1] ? extra.Description + " (" + splitDescription[1] : extra.Description;
                                        return __assign({}, extra, { Description: Description,
                                            LinkId: LinkId });
                                    });
                                    var updatedCostBreakdown = roomCostItems.concat(updatedExtrasCostItems);
                                    var costsSortedById = updatedCostBreakdown.sort(function (a, b) { return (a.LinkId >= b.LinkId) ? 1 : -1; });
                                    costBreakdownGrouped[0].costBreakdown = costsSortedById;
                                }
                            }
                            scope.costBreakdowns = costBreakdownGrouped;
                            scope.total = costBreakdownGrouped.total;
                            scope.taxAdjustment = taxAdjustments;
                            scope.isPackage = costBreakdownGrouped.isPackage;
                            var deposit = totalDeposit;
                            if (booking) {
                                deposit += booking.UserData.PaymentDetails.DepositAmount;
                            }
                            scope.deposit = deposit;
                            if (scope.binRangeDiscount != null) {
                                scope.total -= scope.binRangeDiscount.DiscountValue;
                                if (!scope.isDeposit) {
                                    scope.deposit -= scope.binRangeDiscount.DiscountValue;
                                }
                            }
                            tripService.getCurrency($routeParams.tripId).then(function (currency) {
                                scope.currency = currency;
                                scope.totalDeposit = customCurrencyFilter(scope.deposit, currency);
                                _setPaymentTotalPlusFees(scope.fees);
                            });
                        });
                        // persist any open content panel
                        var i = arrayUtil.indexOf(scope.costBreakdowns, function (cb) {
                            return cb.open;
                        });
                        if (i >= 0) {
                            scope.costBreakdowns[i].open = true;
                        }
                    }
                    getCostbreakdowns();
                    broker.subscribe('basketBarDirective', 'basketUpdated', _.debounce(getCostbreakdowns, 100));
                    broker.subscribe('basketBarDirective', 'paymentDataUpdated', _.debounce(getCostbreakdowns, 100));
                    broker.subscribe('basketBarDirective', 'discountUpdated', _setBinRangeDiscount);
                    function _setBinRangeDiscount(discount) {
                        if (discount.data != null) {
                            scope.binRangeDiscount = discount.data[0];
                        }
                        else {
                            scope.binRangeDiscount = null;
                        }
                        getCostbreakdowns();
                    }
                    scope.$on('$destroy', function () {
                        broker.unsubscribe('basketBarDirective');
                    });
                });
                scope.sectionClass = function (index) {
                    return scope.costBreakdowns[index].open ? 'expanded' : '';
                };
                scope.toggleSection = function (index) {
                    scope.costBreakdowns.forEach(function (cb, i) {
                        if (i !== index) {
                            cb.open = false;
                        }
                    });
                    scope.costBreakdowns[index].open = !scope.costBreakdowns[index].open;
                };
            }
        };
    });
})();
(function () {
    var BasketToolbar = /** @class */ (function () {
        function BasketToolbar($scope, attractionService, basketStore, broker) {
            var _this = this;
            this.$scope = $scope;
            this.attractionService = attractionService;
            this.basketStore = basketStore;
            this.broker = broker;
            this.hide = false;
            this.basketTotal = 0;
            this.basketCount = 0;
            basketStore.getAttractionsBasket()
                .then(function (res) { return _this.updateAttractionsBasket(res.LineItems); });
            broker.subscribe('basketToolbarDirective', 'attractionsBasketUpdated', function (e) { return _this.updateAttractionsBasket(e.data && e.data.Basket && e.data.Basket.LineItems); });
            broker.subscribe('basketToolbarDirective', 'basketCleared', function () { return _this.updateAttractionsBasket(); });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('basketToolbarDirective');
            });
        }
        BasketToolbar.prototype.updateAttractionsBasket = function (lineItems) {
            var totals = this.attractionService.getProductTotals(lineItems);
            this.basketTotal = totals.price;
            this.basketCount = totals.count;
        };
        return BasketToolbar;
    }());
    angular.module('TR')
        .directive('basketToolbar', function ($rootScope, broker) {
        return {
            restrict: 'E',
            controller: BasketToolbar,
            controllerAs: 'bt',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=BasketToolbar',
            link: function (scope, el, attr, ctrl) {
                $rootScope.$on('$routeChangeSuccess', function (_, next) {
                    ctrl.hide = !!next.hideDistractionLinks;
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('bd4Track', bd4Track);
    function bd4Track($location, bd4t) {
        return {
            restrict: 'E',
            link: function ($scope) {
                function bd4PageView() {
                    var path = $location.path();
                    if (path === '/') {
                        bd4t('initPage', { type: 'home', section: 'home' });
                    }
                    else if (path === '/holidays') {
                        bd4t('initPage', { type: 'home', section: 'holidays' });
                    }
                    else if (path === '/hotels') {
                        bd4t('initPage', { type: 'home', section: 'hotels' });
                    }
                    bd4t('send', 'pageview');
                }
                $scope.$on('$routeChangeStart', bd4PageView);
            }
        };
    }
})();
var TR;
(function (TR) {
    var BookingCompleteTracking = /** @class */ (function () {
        function BookingCompleteTracking($scope, $routeParams, $location, analytics, authService, basketService, bookingCompleteTrackingService, trackingPixelsService, tripService) {
            this.$scope = $scope;
            this.$routeParams = $routeParams;
            this.$location = $location;
            this.analytics = analytics;
            this.authService = authService;
            this.basketService = basketService;
            this.bookingCompleteTrackingService = bookingCompleteTrackingService;
            this.trackingPixelsService = trackingPixelsService;
            this.tripService = tripService;
            this.pixelsWithTracking = [];
            this.initTracking();
        }
        BookingCompleteTracking.prototype.onPixelLoad = function (name) {
            this.trackingPixelsService.report('load', name);
        };
        BookingCompleteTracking.prototype.onPixelLoadError = function (name) {
            this.trackingPixelsService.report('error', name);
        };
        BookingCompleteTracking.prototype.initTracking = function () {
            var _this = this;
            var bookingRef = this.$routeParams.ref.split('|')[0]; //for multi bookings 1st id is good enough
            var setTrackingUrls = function (bookingRef, basket) {
                // some pixels require additional information sourced form basket, we will pass it as options object
                var options = {};
                if (basket) {
                    var cancellationPrefix_1 = 'canxp_';
                    var offer = basket.h || basket.f;
                    options['cancellationProtectionRef'] = _.chain(offer.Options)
                        .filter(function (item) { return item.OptionId.indexOf(cancellationPrefix_1) > -1; })
                        .head()
                        .get('OptionId')
                        .replace(cancellationPrefix_1, '')
                        .value();
                }
                //we have two sets of pixels doing slightly different things ones where we track
                //if they have loaded or errored and others where we do not track this
                var pixels = _this.trackingPixelsService.getAllProviderUrls(bookingRef, options);
                _this.pixels = _.map(_.filter(pixels, function (p) { return p.trackingLabel.length === 0; }), 'url');
                _this.pixelsWithTracking = _.filter(pixels, function (p) { return p.trackingLabel.length > 0; });
            };
            //if we have come back from PayPal we need to do a little extra work recording conversion values etc...
            //ref: the full booking reference string e.g. TRN/1234567%7CEUF/11488101%7CPRK/123456%7CACM/123656
            var tripId = this.$routeParams.tripId || this.$location.search().tripId;
            if (tripId) {
                var bookingRefs_1 = this.$routeParams.ref.split('|');
                return this.tripService.getTrip(tripId).then(function (trip) {
                    var user = _this.authService.getUser();
                    return _this.bookingCompleteTrackingService.trackConversion(trip, bookingRefs_1, _this.$routeParams.source, user.Email, null).then(function () { return _this.basketService.completeWorkflow(bookingRefs_1, trip.BasketId); })
                        .then(function (_a) {
                        var basket = _a[0];
                        return basket;
                    });
                })
                    .then(function (basket) {
                    var basketHasContent = _.reduce(basket.all, function (bool, elem) {
                        if (elem != null) {
                            if ((elem instanceof Array && elem.length > 0) || !(elem instanceof Array)) {
                                return true;
                            }
                        }
                        return bool;
                    }, false);
                    if (basketHasContent) {
                        //by this point setData on tracking pixel service would have been called
                        //so we can get the urls now.
                        setTrackingUrls(bookingRef, basket);
                    }
                });
            }
            else {
                if (!TRPCONFIG.Domain2.NewTransactionTracking) {
                    this.analytics.trackConversion();
                }
                setTrackingUrls(bookingRef);
            }
        };
        return BookingCompleteTracking;
    }());
    angular.module('TR')
        .directive('bookingCompleteTracking', function () {
        return {
            restrict: 'E',
            replace: false,
            scope: true,
            template: "<img ng-repeat=\"url in bct.pixels\"\n                                    ng-src=\"{{url}}\"\n                                    width=\"1\" height=\"1\" style=\"position:absolute; bottom:0;\" />\n                                <img ng-repeat=\"pixel in bct.pixelsWithTracking\"\n                                     ng-src=\"{{pixel.url}}\"\n                                     name=\"{{pixel.trackingLabel}}\"\n                                     image-loader\n                                     data-onload=\"bct.onPixelLoad(pixel.trackingLabel)\"\n                                     data-onerror=\"bct.onPixelLoadError(pixel.trackingLabel)\"\n                                     width=\"1\" height=\"1\" style=\"position:absolute; bottom:0;\" />",
            controller: BookingCompleteTracking,
            controllerAs: 'bct'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var BookingLookup = /** @class */ (function () {
        function BookingLookup(accountMenuService, authService, resourceService) {
            var _this = this;
            this.accountMenuService = accountMenuService;
            this.authService = authService;
            this.resourceService = resourceService;
            this.popupSignIn = function (event) {
                event.preventDefault();
                _this.authService.bufferRoute(null);
                //redirect here is only used in the mobile version of accountMenuService
                _this.accountMenuService.launchOption('bookingsignin');
            };
            this.tooltip = this.resourceService.get('MANAGEMYBOOKINGTOOLTIP');
        }
        return BookingLookup;
    }());
    angular
        .module('TR')
        .directive('bookingLookup', function () {
        return {
            scope: {},
            controller: BookingLookup,
            controllerAs: 'as',
            restrict: 'E',
            replace: true,
            template: "\n                    <a href=\"#\" \n                        event-tracker\n                        event-category=\"MYB\"\n                        event-action=\"click\"\n                        event-label=\"'MYB_HomePage'\"\n                        ng-click=\"as.popupSignIn($event)\" \n                        title=\"{{as.tooltip}}\" ng-transclude></a>",
            transclude: true
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('bookingTracker', function (bookingService) {
        //booking may be on an ancester scope
        function findBooking(s) {
            if (s.cm) {
                if (s.cm.booking) {
                    return s.cm.booking;
                }
            }
            return s.$parent ? findBooking(s.$parent) : null;
        }
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, el, attr, c) {
                var update = _.debounce(function () {
                    var b = findBooking(scope);
                    if (b) {
                        bookingService.updateBooking(b, attr.bookingDescription + " changed to: " + c.$modelValue);
                    }
                }, 1000);
                if (c != null) {
                    c.$viewChangeListeners.push(update);
                    c.$updateBooking = update;
                }
                else {
                    var bw_1 = scope.$watch('cm.booking', function (b, oldB) {
                        if (b != null && !angular.equals(b, oldB)) {
                            bw_1();
                            return;
                        }
                        scope.$watch(attr.bookingTracker, _.debounce(function (val, prev) {
                            if (!angular.equals(val, prev) && !!b) {
                                bookingService.updateBooking(scope.cm.booking, attr.bookingDescription + " changed to: " + val);
                            }
                        }, 1000), true);
                    }, true);
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('breadcrumb', function (broker, $route, $routeParams, basketService, analytics, breadcrumbDetailsService, $timeout) {
        var text;
        if (breadcrumbDetailsService.getText) {
            text = breadcrumbDetailsService.getText();
        }
        //let's optionally get the breadcrumb from the scope so that we can override the route if necessary
        return {
            restrict: 'E',
            replace: true,
            scope: {
                useText: '=',
                showBreadcrumb: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=Breadcrumb',
            link: function (scope, element) {
                var bc = $route.current.$$route.breadcrumb;
                if (bc && bc.crumb === 10 && TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                    bc.crumb = 25;
                }
                var tripId = $routeParams.tripId;
                if (tripId) {
                    basketService.getArea().then(function (a) {
                        var area = scope.area = a;
                        scope.baseAreaUrl = "" + TRPCONFIG.Domain.SearchUnitHomePath + area;
                        scope.click = function clickBreadcrumb(c) {
                            /*
                            The number 10 is used to select a flight, and the number 25 is used to change the flight,
                            the names for the crumbs are different, but the functionality is the same,
                            so if the flight was previously chosen, we must use the name of crumbs 25 and the functionality of crumbs 10.
                            This expression was added to avoid code duplication
                            */
                            bc.crumb = basketService.isFlightPreselected() && bc.crumb === 10 ? 25 : bc.crumb;
                            if (c < bc.crumb || (c === bc.crumb)) {
                                analytics.trackEvent({ label: 'breadcrumb nav', value: c });
                                basketService.changeJourneyUrl(c);
                            }
                        };
                        broker.subscribe('breadcrumb', 'ChangeWorkflowState', function (ev) {
                            basketService.changeJourneyUrl(ev.data);
                        });
                        scope.$on('$destroy', function () {
                            broker.unsubscribe('breadcrumb');
                        });
                    });
                }
                scope.show = bc != null;
                if (bc != null) {
                    breadcrumbDetailsService.getCrumbs(scope.useText).then(function (crumbs) {
                        scope.crumbs = crumbs;
                        scope.width = function () {
                            return { width: 100 / scope.crumbs.length + "%" };
                        };
                    });
                    scope.class = breadcrumbDetailsService.getClasses(bc, scope.useText);
                    if (text) {
                        scope.text = function (c) {
                            return text[c];
                        };
                    }
                }
                scope.shortText = function (crumb) {
                    return breadcrumbDetailsService.getTextShort()[crumb];
                };
                $timeout(function () {
                    var wrapperClass = 'breadcrumb-wrapper';
                    var wrapper = element.hasClass(wrapperClass) ? element : element.find("." + wrapperClass);
                    var activeCrumb = element.find('.is-active');
                    var wrapperOffsetLeft = _.get(wrapper, '[0].offsetLeft');
                    var crumbsOffsetLeft = _.get(activeCrumb, '[0].offsetLeft');
                    var offsetPosition = crumbsOffsetLeft - wrapperOffsetLeft;
                    if (crumbsOffsetLeft && offsetPosition) {
                        wrapper[0].scrollLeft = offsetPosition;
                    }
                }, 1000);
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('cardCvv', function (paymentsService) {
        return {
            restrict: 'E',
            replace: false,
            scope: {
                modal: '=',
                cardType: '=',
                paymentOptions: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return "partials/booking/template?name=CardCvv&version=" + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=CardCvv';
            },
            link: function (scope) {
                var reAmex = /American\sExpress/i;
                scope.$watch('cardType', function (cardTypeId) {
                    scope.isAmex = null; //Hides all messages
                    //Amex message shows if card name matches regex
                    //Otherwise, default message shows whenever `cardTypeId` is truthy
                    //Message is hidden if `cardTypeId` is falsy
                    if (cardTypeId) {
                        var paymentOptions = scope.paymentOptions;
                        var cardSpec = paymentOptions && paymentsService.getCardFromId(paymentOptions, cardTypeId);
                        //Title has been renamed to Name in new API.
                        scope.isAmex = reAmex.test(cardSpec && (cardSpec.Title || cardSpec.Name));
                    }
                });
            }
        };
    });
})();
var TR;
(function (TR) {
    var Dictionary = Core.Collections.Dictionary;
    var DriverType = Core.Booking.DriverType;
    var CarHireSelection = /** @class */ (function () {
        function CarHireSelection($scope, resourceService) {
            var _this = this;
            this.$scope = $scope;
            this.resourceService = resourceService;
            this.drivers = new Dictionary();
            var wait = $scope.$watch('chs.bookingLoaded', function (b) {
                if (b) {
                    _this.init();
                    wait();
                }
            });
            $scope.$watch('chs.userData.Rooms', function (u) {
                if (u) {
                    _this.updateDriverTitles(_this.drivers, u);
                }
            }, true);
        }
        CarHireSelection.prototype.updateDriverType = function (value, newDriverId, oldDriverId) {
            //find the new and old driver ids and update our user data accordingly
            this.findAndUpdateDriverType(this.userData.Rooms, oldDriverId, DriverType.NotADriver);
            this.findAndUpdateDriverType(this.userData.Rooms, newDriverId, value);
        };
        CarHireSelection.prototype.init = function () {
            if (this.captureDrivers) {
                this.updateDriverTitles(this.drivers, this.userData.Rooms);
                if (this.drivers.count() === 0) {
                    this.captureDrivers = false;
                    return;
                }
                var guests = this.getGuestList(this.userData.Rooms);
                this.driverTypeModels = [
                    {
                        title: this.resourceService.get('MAINDRIVER'),
                        type: DriverType.MainDriver,
                        driverId: this.getGuestIdForDriverType(guests, DriverType.MainDriver),
                        ineligible: false
                    }
                ];
                if (this.additionalDrivers > 0 && guests.length >= 1) {
                    var adults = guests.filter(function (g) { return g.Type === 1; });
                    this.driverTypeModels.push({
                        title: this.resourceService.get('ADDITIONALDRIVER'),
                        type: DriverType.AdditionalDriver,
                        driverId: this.getGuestIdForDriverType(guests, DriverType.AdditionalDriver),
                        ineligible: adults.length === 1
                    });
                }
            }
        };
        CarHireSelection.prototype.findAndUpdateDriverType = function (rooms, guestId, driverType) {
            _.each(rooms, function (r) {
                var keepGoing = true;
                _.each(r.Guests, function (g) {
                    if (g.Id === guestId - 1) {
                        g.DriverType = driverType;
                        keepGoing = false;
                        return keepGoing;
                    }
                });
                return keepGoing;
            });
            //check the same driver is not assigned to another driver type
            //clear it if he is
            if (driverType !== DriverType.NotADriver) {
                var models = _.filter(this.driverTypeModels, { 'driverId': guestId });
                if (models.length > 1) {
                    _.find(models, function (d) { return d.type !== driverType; }).driverId = 0;
                }
            }
        };
        CarHireSelection.prototype.getGuestIdForDriverType = function (guests, type) {
            //get the guest id for the given type
            //NOTE ids start at 0 but this is not what we want as 0 is counted as a blank/unset value so bump the
            //guest Id to be something we can work with
            var g = _.find(guests, { 'Type': 1, 'Age': 21, 'DriverType': type });
            if (g) {
                return g.Id + 1;
            }
            return 0;
        };
        CarHireSelection.prototype.updateDriverTitles = function (dict, rooms) {
            //update the driver titles we have stored
            _.each(rooms, function (room) {
                _.each(_.filter(room.Guests, { 'Type': 1, 'Age': 21 }), function (guest) {
                    var name = (guest.Title && guest.FirstName && guest.LastName) ?
                        guest.Title + " " + guest.FirstName + " " + guest.LastName :
                        guest.Label;
                    var id = guest.Id + 1;
                    if (dict.containsKey(id.toString())) {
                        var driver = dict.item(id.toString());
                        if (driver.name !== name) {
                            driver.name = name;
                        }
                    }
                    else {
                        dict.add(id.toString(), { name: name, id: id });
                    }
                });
            });
        };
        CarHireSelection.prototype.getGuestList = function (rooms) {
            return _.reduce(rooms, function (result, room) {
                return result.concat(room.Guests);
            }, []);
        };
        return CarHireSelection;
    }());
    angular
        .module('TR')
        .directive('carhireSelection', function () {
        return {
            bindToController: true,
            controller: CarHireSelection,
            controllerAs: 'chs',
            restrict: 'E',
            replace: true,
            scope: {
                additionalDrivers: '=',
                bookingLoaded: '=',
                captureDrivers: '=',
                carhire: '=',
                requestedItemsCosts: '=',
                rootForm: '=',
                userData: '=',
                templateVersion: '@'
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=CarHireSelection&version='
                        + attr.templateVersion;
                }
                else {
                    return 'partials/home/directivetemplate?type=CarHireSelection';
                }
            }
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    function Carousel(funcUtil, $timeout) {
        return {
            scope: {
                data: '=',
                autoplay: '=',
                autoplaySpeed: '=',
                slidesToShow: '=',
                slidesToScroll: '=',
                arrows: '=',
                dots: '=',
                infinite: '=',
                asNavFor: '@',
                fade: '@',
                speed: '@',
                responsive: '=',
                variableWidth: '=',
                centerMode: '='
            },
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=CarouselDirective',
            transclude: true,
            replace: true,
            link: link
        };
        function link($scope, $e) {
            $scope.fade = $scope.fade === 'true';
            $scope.speed = angular.isUndefined($scope.speed) ? undefined : parseInt($scope.speed, 10);
            var carousel = $e.find('.carousel-content');
            $scope.show = false;
            var DEFAULT_OPTIONS = {
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: true,
                rtl: TRPCONFIG.Rtl,
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: undefined,
                fade: undefined,
                speed: undefined,
                infinite: true,
                variableWidth: false,
                centerMode: false
            };
            // HEADSUP this has been set up to support 4 cards on TR
            var DEFAULT_RESPONSIVE = [
                {
                    breakpoint: 1023,
                    settings: { slidesToShow: 3, slidesToScroll: 3 }
                },
                {
                    breakpoint: 769,
                    settings: { slidesToShow: 2, slidesToScroll: 2 }
                }
            ];
            var options = _.assignWith(_.pick($scope, _.keys(DEFAULT_OPTIONS)), DEFAULT_OPTIONS, function (opt, def) { return _.isUndefined(opt) ? def : opt; });
            options.autoplay = false;
            options.responsive = !$scope.responsive && parseInt(options.slidesToShow, 10) === 4
                ? DEFAULT_RESPONSIVE
                : $scope.responsive;
            funcUtil.waitForValue(function () { return !_.isEmpty(carousel[0].children) && carousel.is(':visible'); })
                .then(function () { return $timeout(function () {
                $scope.show = true;
                carousel.slick(options);
                $scope.$on('$destroy', function () { return carousel.slick('unslick'); });
            }); });
        }
    }
    angular
        .module('TR')
        .directive('carousel', Carousel);
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('checkbox', function (arrayUtil, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                model: '=',
                name: '@?',
                val: '=',
                disabled: '=',
                onToggle: '&',
                onClick: '&',
                onInit: '&?',
                templateVersion: '=',
                mandatory: '<?'
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return "partials/booking/template?name=checkbox&version=" + attr.templateVersion;
                }
                return 'partials/home/checkbox';
            },
            link: function (scope) {
                scope.toggle = function () {
                    if (scope.disabled) {
                        return;
                    }
                    if (Array.isArray(scope.model)) {
                        var index = indexOfVal(scope.model);
                        if (index > -1) {
                            scope.model.splice(index, 1);
                        }
                        else {
                            scope.model.push(scope.val);
                        }
                    }
                    else {
                        scope.model = !scope.model;
                    }
                    $timeout(scope.onClick); // `model` not updated in parent context without $timeout
                };
                scope.$watchCollection('model', function (model) {
                    if (model !== undefined) {
                        scope.checked = Array.isArray(model) ? indexOfVal(model) > -1 : model;
                        scope.onToggle();
                    }
                });
                if (scope.onInit) {
                    scope.onInit();
                }
                function indexOfVal(array) {
                    return arrayUtil.indexOf(array, function (i) {
                        // Need angular.equals to compare { OptionId: "4":, Quantity: 1 } with { OptionId: "4":, Quantity: 1 }
                        return scope.val === String(i) || angular.equals(scope.val, i);
                    });
                }
            }
        };
    });
})();
var Core;
(function (Core) {
    var CheckboxAll = /** @class */ (function () {
        function CheckboxAll($scope) {
            this.$scope = $scope;
        }
        CheckboxAll.prototype.init = function (el) {
            var _this = this;
            var checkbox = el;
            // watch checkbox changes
            checkbox.change(function () {
                // empty the list
                _this.$scope.$apply(function () { return _this.list.splice(0, _this.list.length); });
            });
            // watch the list
            this.$scope.$watchCollection('ca.list', function (list) {
                if (list) {
                    // if list has items then check and disable the checkbox
                    var checked = (_this.list.length === 0);
                    checkbox.prop('checked', checked);
                    checkbox.prop('disabled', checked);
                }
            });
        };
        return CheckboxAll;
    }());
    angular
        .module('core')
        .directive('checkboxAll', function () {
        return {
            restrict: 'A',
            controller: CheckboxAll,
            controllerAs: 'ca',
            bindToController: {
                list: '=checkboxAll'
            },
            link: function (scope, el, attrs, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var CheckboxArray = /** @class */ (function () {
        function CheckboxArray($scope) {
            this.$scope = $scope;
        }
        CheckboxArray.prototype.init = function (el) {
            var _this = this;
            var checkbox = el;
            // watch checkbox changes
            checkbox.change(function () {
                var index = _this.indexOfVal(_this.list, _this.value);
                // modify the list
                var action = index > -1
                    ? function () { return _this.list.splice(index, 1); }
                    : function () { return _this.list.push(_this.value); };
                _this.$scope.$apply(action());
            });
            // watch the list
            this.$scope.$watchCollection('ca.list', function (list) {
                // sync checkbox state to the list
                if (list) {
                    var checked = _this.indexOfVal(list, _this.value) > -1;
                    checkbox.prop('checked', checked);
                }
            });
        };
        CheckboxArray.prototype.indexOfVal = function (array, value) {
            return _.findIndex(array, function (i) {
                return value === String(i) || _.isEqual(value, i);
            });
        };
        return CheckboxArray;
    }());
    angular
        .module('core')
        .directive('checkboxArray', function () {
        return {
            restrict: 'A',
            controller: CheckboxArray,
            controllerAs: 'ca',
            bindToController: {
                list: '=checkboxArray',
                value: '='
            },
            link: function (scope, el, attrs, controller) {
                controller.init(el);
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var ClickPublisher = /** @class */ (function () {
        function ClickPublisher($scope, broker) {
            this.$scope = $scope;
            this.broker = broker;
            this.eventNamespace = 'clickpublisher';
        }
        ClickPublisher.prototype.init = function (element, eventName) {
            var _this = this;
            element.on("click." + this.eventNamespace, function (e) {
                e.preventDefault();
                _this.broker.publish(eventName);
            });
            this.$scope.$on('$destroy', function () {
                element.off("click." + _this.eventNamespace);
            });
        };
        return ClickPublisher;
    }());
    angular
        .module('core')
        .directive('clickPublisher', function () {
        return {
            scope: {},
            restrict: 'A',
            controller: ClickPublisher,
            controllerAs: 'cp',
            bindToController: {
                toggleEvent: '='
            },
            link: function (scope, el, attr, controller) {
                controller.init(el, attr['clickPublisher']);
            }
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('combobox', function ($document) {
        return {
            restrict: 'E',
            replace: true,
            priority: 1,
            scope: {
                term: '=',
                listData: '=',
                textProperty: '@',
                click: '&',
                placeholder: '@',
                triggerLabel: '@',
                triggerClick: '&',
                inputClass: '@',
                enableAutocomplete: '@',
                rootForm: '=',
                lookupEnabled: '='
            },
            transclude: true,
            controller: _controller,
            templateUrl: function (element, attr) {
                var base = 'partials';
                if (attr.templateVersion) {
                    return base + "/booking/template?name=Combobox&version=" + attr.templateVersion;
                }
                return base + "/home/directivetemplate?type=ComboBox";
            },
            link: _linker
        };
        function _controller($scope, $element) {
            this.element = $element;
        }
        function _linker(scope, e) {
            scope.autocomplete = !TRPCONFIG.Domain.isAgentMode && scope.enableAutocomplete || 'off';
            function toggleMenu(val) {
                scope.$evalAsync(function () {
                    scope.menu = val;
                });
            }
            e.on('focusin', function () {
                if (scope.listData && scope.listData.length > 0) {
                    toggleMenu(true);
                }
            });
            function mousedown(e) {
                if ($(e.target).closest('.cmb-menu').length === 0) {
                    toggleMenu(false);
                }
            }
            // This is needed to hide the menu on a sort of focus-out event
            // (basically if the user does not click on the menu-list this will hide it)
            $document.on('mousedown', mousedown);
            scope.$on('$destroy', function () {
                e.off('focusin');
                $document.off('mousedown', mousedown);
            });
            scope.clickHandler = function (d) {
                scope.click({ item: d });
                scope.loading = true;
            };
            scope.$watch('term', function () {
                scope.listData = [];
            });
            scope.triggerClickHandler = function () {
                scope.submitted = true;
                scope.triggerClick({ term: scope.term });
                e.find('input').focus();
            };
            // If the listData has changed (mainly due to a new filter being
            // applied) this will make it visible
            scope.$watch('listData', function (value) {
                scope.loading = false;
                if (!value || value.length === 0) {
                    scope.menu = false;
                }
                else {
                    scope.menu = true;
                }
            });
        }
    });
})();
var TR;
(function (TR) {
    angular
        .module('TR')
        .component('crossSellAttractions', {
        bindings: {
            isHotelJourney: '<',
            hotel: '<?'
        },
        controller: 'Attractions',
        controllerAs: 'at',
        templateUrl: 'partials/home/directivetemplate?type=CrossSellAttractions'
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var CarHireItem = /** @class */ (function () {
        function CarHireItem(code) {
            this.selectedOptions = [];
            this.carHireCode = code;
        }
        CarHireItem.createItemFromQuote = function (quote) {
            var item = new CarHireItem(quote.CarHireId.CarHireCode);
            item.quote = quote;
            return item;
        };
        return CarHireItem;
    }());
    var ViewMode;
    (function (ViewMode) {
        ViewMode[ViewMode["Results"] = 1] = "Results";
        ViewMode[ViewMode["Options"] = 2] = "Options";
        ViewMode[ViewMode["Terms"] = 3] = "Terms";
    })(ViewMode || (ViewMode = {}));
    var CrossSellCarHire = /** @class */ (function () {
        function CrossSellCarHire($q, $routeParams, $scope, analytics, arrayUtil, basketService, basketStore, dateUtil, tripService) {
            var _this = this;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.analytics = analytics;
            this.arrayUtil = arrayUtil;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.dateUtil = dateUtil;
            this.tripService = tripService;
            this.optionsPromise = this.$q.when();
            this.driverAge = 30;
            this.driverAges = [];
            this.items = [];
            this.fromPrice = 0;
            this.noneSelection = new CarHireItem('-1');
            this.payLocallyCosts = [];
            //properties used to control the UI state
            this.isBusy = true;
            this.viewMode = ViewMode; //so we can use it in the template
            this.view = ViewMode.Results;
            this.carsAvailabilityBusy = true;
            this.driverAges = arrayUtil.createRange(90, 21);
            this.selectedItem = this.noneSelection;
            this.tripId = $routeParams.tripId;
            tripService.getTrip(this.tripId)
                .then(function (trip) {
                _this.basketId = trip.BasketId;
                if (trip.CarHireRequest) {
                    _this.setLocalPropertiesFromRequest(trip.CarHireRequest);
                    _this.searchId = trip.CarHireRequest.AvailabilitySearchId;
                }
                $q.all([
                    basketStore.carHire(_this.basketId),
                    basketStore.carHireOptions(_this.basketId, $routeParams),
                    _this.retrieveQuotes(_this.searchId, _this.basketId, _this.tripId, _this.driverAge)
                ]).then(function (results) {
                    var selected = results[0];
                    _this.setResults(results[2]); //set this.items
                    //find the car hire item from our quotes so that we can select it
                    if (selected) {
                        var item = _this.findCarHireItem(_this.items, selected.Details.CarHireId.CarHireCode);
                        item.details = selected.Details;
                        item.selectedOptions = results[1];
                        _this.selectedItem = item;
                        _this.updateTotalCost();
                    }
                    if (!_this.searchId) {
                        tripService.getTrip(_this.tripId)
                            .then(function (trip) {
                            _this.setLocalPropertiesFromRequest(trip.CarHireRequest);
                            _this.searchId = trip.CarHireRequest.AvailabilitySearchId;
                        });
                    }
                    // Watch the additional options collection and update the basket when this changes
                    $scope.$watchCollection('$ctrl.selectedItem.selectedOptions', function (val, old) {
                        if (_this.selectedItem.carHireCode === '-1') {
                            // no car selected
                            return;
                        }
                        if (val !== old) {
                            _this.updateOptions();
                        }
                    });
                }).finally(function () {
                    _this.isBusy = false;
                    _this.carsAvailabilityBusy = false;
                });
            }, this.basketService.bookingAlreadyDone("crosssellCarHire: '" + this.tripId + "'"));
        }
        CrossSellCarHire.prototype.retrieveQuotes = function (searchId, basketId, tripId, age) {
            var mapQuotes = function (quotes) {
                return _.map(_.sortBy(quotes, 'Price'), function (q) { return CarHireItem.createItemFromQuote(q); });
            };
            if (searchId != null) {
                return this.basketService.getCarQuotesFromSession(searchId, 0)
                    .then(function (quotes) { return mapQuotes(quotes); });
            }
            else {
                return this.basketService.getCarQuotes(basketId, tripId, age)
                    .then(function (quotes) { return mapQuotes(quotes); });
            }
        };
        CrossSellCarHire.prototype.findCarHireItem = function (list, carCode) {
            return _.find(list, { 'carHireCode': carCode });
        };
        CrossSellCarHire.prototype.setResults = function (list) {
            this.items = list;
            this.carsAvailabilityBusy = false;
            //this should really be done service side not a problem for now as long as we do not show more than
            // one page worth of results
            this.fromPrice = this.items.length ? _.minBy(this.items, 'quote.Price').quote.Price : 0;
        };
        CrossSellCarHire.prototype.setLocalPropertiesFromRequest = function (request) {
            this.driverAge = request.DriverAge;
            this.dropOffDate = request.DropOffDate;
            this.pickUpDate = request.PickUpDate;
        };
        //CHECKOUT-47 : extra param just to do some mixpanel tracking
        //will be removed once the test is finished
        CrossSellCarHire.prototype.showModal = function (show, logMixPanelEvent) {
            this.showResults = show;
            if (show === false) {
                this.view = ViewMode.Results;
                this.showError = false;
            }
            if (logMixPanelEvent === true) {
                this.analytics.track('mixpanel', 'OptionsCarHireChooseClick');
            }
        };
        CrossSellCarHire.prototype.previousView = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            this.view -= 1;
        };
        CrossSellCarHire.prototype.displayTerms = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            this.view = ViewMode.Terms;
        };
        CrossSellCarHire.prototype.selectCar = function (carHireCode) {
            var _this = this;
            this.isBusy = true;
            this.showError = false;
            if (this.selectedItem.carHireCode === carHireCode) {
                //we already have it selected move the user along to the next page
                this.view = ViewMode.Options;
                this.isBusy = false;
                this.getCarInsuranceInfo(this.selectedItem.details.AdditionalOptions);
                this.duration = this.getDuration(this.selectedItem.details.HireDetails);
            }
            else {
                //find the quote from our list and select it
                var item_1 = this.findCarHireItem(this.items, carHireCode);
                item_1.selectedOptions = []; //clear it out, may have been previously selected
                this.basketService.selectCar(item_1.quote, this.searchId, this.basketId)
                    .then(function (carDetails) {
                    item_1.details = carDetails.Details;
                    _this.selectedItem = item_1;
                    _this.isBusy = false;
                    _this.view = ViewMode.Options;
                    _this.getCarInsuranceInfo(_this.selectedItem.details.AdditionalOptions);
                    _this.duration = _this.getDuration(_this.selectedItem.details.HireDetails);
                })
                    .then(function () { return _this.updateTotalCost(); })
                    .catch(function () {
                    _this.selectedItem = _this.noneSelection;
                    _this.showError = true;
                    _this.isBusy = false;
                });
            }
        };
        CrossSellCarHire.prototype.removeCar = function () {
            var _this = this;
            return this.basketStore.removeCar(this.basketId)
                .then(function () {
                _this.selectedItem = _this.noneSelection;
                _this.view = ViewMode.Results;
            })
                .then(function () { return _this.basketService.updateBasket(); });
        };
        CrossSellCarHire.prototype.updateOptions = function () {
            var _this = this;
            this.optionsPromise = this.optionsPromise
                .then(function () { return _this.updateBasketOptions(_this.selectedItem.selectedOptions, _this.selectedItem.details.DetailsSearchId); }).then(function () { return _this.updateTotalCost(); });
        };
        CrossSellCarHire.prototype.updateBasketOptions = function (options, detailsSearchId) {
            var _this = this;
            return this.basketStore.carHireOptions(this.basketId).then(function (basketOptions) {
                var _createBasketOption = function (id, quantity) {
                    return { OptionId: id, ChosenQuantity: quantity };
                };
                var optionsToRemove = _.map(_this.arrayUtil.difference(basketOptions, options), function (o) { return _createBasketOption(o, 1); });
                var optionsToAdd = _.map(_this.arrayUtil.difference(options, basketOptions), function (o) { return _createBasketOption(o, 1); });
                return _this.basketStore.removeOptions(_this.basketStore.productType.CarHire, detailsSearchId, optionsToRemove, _this.basketId)
                    .then(function () { return _this.basketStore.addOptions(_this.basketStore.productType.CarHire, detailsSearchId, optionsToAdd, _this.basketId); })
                    .then(function () { return _this.basketService.updateBasket(); });
            });
        };
        CrossSellCarHire.prototype.updateTotalCost = function () {
            var _this = this;
            this.$q.all([
                this.basketStore.carHireCost(this.basketId),
                this.basketStore.carHireRequestedItemsCosts(this.basketId)
            ])
                .then(function (results) {
                _this.payNowCost = results[0];
                _this.payLocallyCosts = results[1];
                //this is ok currently as car hire extras are in the same currency as the original request
                _this.totalCost = _.reduce(_this.payLocallyCosts, function (s, n) { return s + n.Total; }, _this.payNowCost);
            });
        };
        CrossSellCarHire.prototype.driverAgeChanged = function () {
            var _this = this;
            this.isBusy = true;
            this.searchId = null;
            //remove any existing selection and get the new list and new search id
            this.$q.all([
                this.removeCar(),
                this.retrieveQuotes(this.searchId, this.basketId, this.tripId, this.driverAge)
            ]).then(function (results) {
                _this.setResults(results[1]); //set this.items
                _this.tripService.getTrip(_this.tripId)
                    .then(function (trip) {
                    _this.searchId = trip.CarHireRequest.AvailabilitySearchId;
                    _this.isBusy = false;
                });
            });
        };
        CrossSellCarHire.prototype.getCarInsuranceInfo = function (options) {
            // get insurance information data from option where it`s declared
            if (options) {
                options = options.filter(function (item) { return item.Price.PayableLocally === false; });
                this.carInsuranceInfo = options[0].InsuranceInformation;
            }
            ;
        };
        CrossSellCarHire.prototype.showInsuranceExplained = function (show) {
            // open insurance explained modal and close insurance info modal
            this.showExplained = show;
            this.removeFlashing();
            if (!show) {
                this.showModal(true, true);
                this.view = ViewMode.Options;
            }
            else {
                var docName = '/build/docs/BookingConditions/IPID-DocumentCarTrawlerDamageRefund.pdf';
                this.showModal(false, null);
                this.carInsuranceInfo.DemageRefundDoc = docName;
            }
        };
        CrossSellCarHire.prototype.viewTerms = function () {
            // close insurance explained modal and go to open car hire terms modal
            this.showExplained = false;
            this.removeFlashing();
            this.showModal(true, true);
            this.view = ViewMode.Terms;
        };
        CrossSellCarHire.prototype.removeFlashing = function () {
            // hack to remove flashing of background when switching to another popup
            $('.modal-overlay').stop().fadeOut();
        };
        CrossSellCarHire.prototype.getDuration = function (hireDetails) {
            var parsedDateFrom = this.dateUtil.parseDate(hireDetails.PickUpTime);
            var parsedDateTo = this.dateUtil.parseDate(hireDetails.DropOffTime);
            return this.dateUtil.getDifferenceInDays(parsedDateFrom, parsedDateTo);
        };
        return CrossSellCarHire;
    }());
    angular
        .module('TR')
        .component('crossSellCarHire', {
        bindings: {},
        controller: CrossSellCarHire,
        templateUrl: 'partials/home/directivetemplate?type=CrossSellCarHire'
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var CrossSellInsurance = /** @class */ (function () {
        function CrossSellInsurance($filter, $routeParams, $scope, arrayUtil, basketService, basketStore, insuranceService, broker, resourceService, tripService) {
            var _this = this;
            this.noneInsurance = { QuoteId: '-1' };
            this.insuranceAvailabilityBusy = false;
            this.documentPaths = {};
            this.showTotal = false;
            this.showFrom = true;
            this.showCoverDetails = false;
            this.noSuperQuotes = false;
            this.singleVat = false;
            this.multipleVat = false;
            broker.subscribe('crossSellInsurance', 'ShowInsuranceTotalPrice', function () {
                _this.showTotal = true;
            });
            broker.subscribe('crossSellInsurance', 'ShowInsuranceCoverDetails', function () {
                _this.showCoverDetails = true;
            });
            broker.subscribe('crossSellInsurance', 'HideInsuranceSuperQuote', function () {
                _this.noSuperQuotes = true;
                _this._removeSuperQuotes();
            });
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                var basketId = trip.BasketId;
                var tripId = trip.TripId;
                var insuranceSearchId = trip.InsuranceRequest ? trip.InsuranceRequest.AvailabilitySearchId : null;
                basketStore.insurance(basketId, $routeParams.productId).then(function (results) {
                    var insurance = results || _this.noneInsurance;
                    _this.insurance = angular.copy(insurance);
                    var _updateSubtitle = function () {
                        if (_this.insuranceQuotes && _.get(_this, 'insurance.QuoteId', false)) {
                            var insuranceQuote = arrayUtil.first(_this.insuranceQuotes, function (i) {
                                return angular.equals(i.QuoteId, _this.insurance.QuoteId);
                            });
                            _this.insuranceQuoteDescription = insuranceQuote ?
                                insuranceQuote.AdultCount + insuranceQuote.ChildCount + insuranceQuote.InfantCount + " x " + insuranceQuote.QuoteType.Destination + " - " + insuranceQuote.QuoteType.Scheme + " " + insuranceQuote.QuoteType.Type + " (" + resourceService.get('FROM') + " " + $filter('customCurrency')(insuranceQuote[TRPCONFIG.Domain.InsurancePerPersonPricing ?
                                    'PerPersonPrice' :
                                    'Price']) + " " + resourceService.get('PERPERSON_ABBREVIATION') + ")"
                                : null;
                        }
                    };
                    if (TRPCONFIG.Domain.CrossSellInsuranceEnabled) {
                        var getInsurance_1 = function (insuranceSearchId, params) {
                            _this.insuranceAvailabilityBusy = true;
                            return basketService.getInsuranceQuotes(insuranceSearchId, basketId, tripId, params)
                                .then(function (insuranceQuotes) {
                                if (insuranceQuotes != null && insuranceQuotes.length > 0) {
                                    _this.insuranceQuotes = insuranceQuotes;
                                    _this.hasPpPrices = !!insuranceQuotes[0].PerPersonPrice;
                                    if (insuranceQuotes && insurance.Options) {
                                        var key_1 = insuranceService
                                            .decomposeOptionId(insurance.Options[0].OptionId);
                                        _this.insurance = angular.copy(arrayUtil.first(_this.insuranceQuotes, function (i) {
                                            return i.SupplierId === key_1.supplierId
                                                && i.QuoteType.TypeId === key_1.typeId
                                                && i.QuoteType.SchemeId === key_1.schemeId
                                                && (i.QuoteType.RelationshipId === key_1.relationshipId
                                                    || key_1.relationshipId === 0);
                                        }));
                                    }
                                    if (_this.noSuperQuotes) {
                                        _this._removeSuperQuotes();
                                    }
                                }
                                _this.singleVat = insuranceService
                                    .isVatMessageInclusive(_this.insuranceQuotes, false);
                                _this.multipleVat = insuranceService
                                    .isVatMessageInclusive(_this.insuranceQuotes, true);
                                _updateSubtitle();
                                _this.insuranceAvailabilityBusy = false;
                            }, function (error) {
                                _this.insuranceAvailabilityBusy = false;
                                _this.insuranceQuotes = [];
                            });
                        };
                        if (_this.isHotelJourney) {
                            basketStore.hotel(basketId)
                                .then(function (hotel) {
                                _this.dates = {
                                    arrivalDate: _.get(hotel, 'Details.Itinerary.CheckInDate'),
                                    departureDate: _.get(hotel, 'Details.Itinerary.CheckOutDate')
                                };
                                getInsurance_1(null, {
                                    airport: _.get(hotel, 'Details.LinkedAirports[0]'),
                                    dates: _this.dates
                                });
                            });
                        }
                        if (insuranceSearchId || !_this.isHotelJourney) {
                            getInsurance_1(insuranceSearchId, {});
                        }
                        //get the document paths
                        _this.documentPaths = insuranceService.getDocumentPaths();
                        $scope.$watch('ins.insurance.QuoteId', function (val, old) {
                            if (val == null || old === undefined) {
                                if (val || val === -1) {
                                    _this.onUpdate({ value: true, type: 'insurance' });
                                }
                                ;
                                return;
                            }
                            _updateSubtitle();
                            if (val !== _this.noneInsurance.QuoteId) {
                                var quote_2 = arrayUtil.first(_this.insuranceQuotes, function (i) {
                                    return i.QuoteId === val;
                                });
                                //we need to re-check the trip here in case we have just generated the search id
                                tripService.getTrip(tripId).then(function (t) {
                                    insuranceSearchId = t.InsuranceRequest.AvailabilitySearchId;
                                    _this.onUpdate({ value: false, type: 'insurance' });
                                    return basketService.selectInsurance(quote_2, insuranceSearchId, basketId)
                                        .then(function () {
                                        basketService.updateBasket();
                                        _this.onUpdate({ value: true, type: 'insurance' });
                                    });
                                });
                            }
                            else {
                                _this.onUpdate({ value: false, type: 'insurance' });
                                basketStore.removeInsurance(basketId).then(function () {
                                    basketService.updateBasket();
                                    _this.onUpdate({ value: true, type: 'insurance' });
                                });
                            }
                        });
                    }
                }).then(null, basketService.restartHolidayWorkflow);
                _this.viewInfo = function (quoteId, $event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    _this.currentInfoId = quoteId;
                };
            }, basketService.bookingAlreadyDone("insurance: '" + $routeParams.tripId + "'"));
        }
        CrossSellInsurance.prototype._removeSuperQuotes = function () {
            this.insuranceQuotes = [_.find(this.insuranceQuotes, ['QuoteType.SchemeId', 1])];
        };
        return CrossSellInsurance;
    }());
    angular
        .module('TR')
        .component('crossSellInsurance', {
        bindings: {
            isHotelJourney: '<',
            onUpdate: '&'
        },
        controller: CrossSellInsurance,
        controllerAs: 'ins',
        templateUrl: 'partials/home/directivetemplate?type=CrossSellInsurance'
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var CrossSellParking = /** @class */ (function () {
        function CrossSellParking($q, $routeParams, $scope, basketService, basketStore, flightsTerminalService, resourceService, tripService) {
            var _this = this;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.flightsTerminalService = flightsTerminalService;
            this.resourceService = resourceService;
            this.tripService = tripService;
            this.isBusyAvailability = true;
            this.items = [];
            this.noneSelectionId = { CarParkCode: '-1', SupplierId: -1 };
            this.selectedItemId = this.noneSelectionId;
            this.tripId = $routeParams.tripId;
            tripService.getTrip(this.tripId)
                .then(function (trip) {
                _this.basketId = trip.BasketId;
                var isOneWay = trip.FlightsRequest && trip.FlightsRequest.OneWayOnly;
                if (isOneWay) {
                    _this.show = false;
                    return;
                }
                if (trip.ParkingRequest) {
                    _this.searchId = trip.ParkingRequest.AvailabilitySearchId;
                }
                $q.all([
                    basketStore.parking(_this.basketId),
                    _this.retrieveQuotes(_this.searchId, _this.basketId, _this.tripId),
                    basketStore.flight(trip.BasketId)
                ]).then(function (results) {
                    var selected = results[0];
                    _this.items = results[1];
                    var leg = results[2].Details.Itinerary.Legs[0];
                    _this.airportTitle = leg.DepartureAirport.Title;
                    flightsTerminalService.getTerminalForFlight(leg.DepartureAirport.Code, leg.Segments[0].FlightNumber, leg.DepartureDate).then(function (terminal) {
                        if (terminal) {
                            _this.terminalTitle = terminal.Title;
                        }
                    });
                    //find the parking item from our quotes so that we can select it
                    if (selected) {
                        var item = _this.findParkingItem(_this.items, selected.Details.Quote.QuoteId);
                        _this.selectedItemId = item.QuoteId;
                    }
                    if (!_this.searchId) {
                        tripService.getTrip(_this.tripId)
                            .then(function (trip) {
                            return _this.searchId = trip && trip.ParkingRequest
                                && trip.ParkingRequest.AvailabilitySearchId;
                        });
                    }
                    $scope.$watch('$ctrl.selectedItemId', function (n, o) {
                        if (n && !angular.equals(n, o)) {
                            _this.selectParking();
                        }
                    });
                }).finally(function () { return _this.isBusyAvailability = false; });
            }, this.basketService.bookingAlreadyDone("crossSellParking: '" + this.tripId + "'"));
        }
        CrossSellParking.prototype.retrieveQuotes = function (searchId, basketId, tripId) {
            var _this = this;
            return this.basketService.getParkingQuotes(searchId, basketId, tripId)
                .then(function (quotes) {
                var bestQuotes = [];
                bestQuotes = _this.addBestQuote(bestQuotes, quotes, false, false); // off airport
                bestQuotes = _this.addBestQuote(bestQuotes, quotes, false, true); // on airport
                bestQuotes = _this.addBestQuote(bestQuotes, quotes, true, null); // meet and greet
                return bestQuotes;
            });
        };
        CrossSellParking.prototype.findParkingItem = function (list, quoteId) {
            return _.find(list, function (i) { return i.QuoteId.CarParkCode === quoteId.CarParkCode; });
        };
        CrossSellParking.prototype.addBestQuote = function (bestQuotes, quotes, meetAndGreet, onAirport) {
            var best = _.maxBy(_.filter(quotes, function (quote) {
                return quote.Facilities.MeetAndGreet === meetAndGreet &&
                    (onAirport == null || quote.Facilities.OnAirport === onAirport);
            }), 'Ranking');
            if (best) {
                return bestQuotes.concat([best]);
            }
            return bestQuotes.slice();
        };
        CrossSellParking.prototype.selectParking = function () {
            var _this = this;
            this.isBusySelection = true;
            if (this.selectedItemId === this.noneSelectionId) {
                this.removeParking().finally(function () { return _this.isBusySelection = false; }); //remove it
            }
            else {
                this.basketService.selectParking(this.selectedItemId, this.searchId, this.basketId)
                    .then(angular.noop, function () { return _this.selectedItemId = _this.noneSelectionId; })
                    .finally(function () { return _this.isBusySelection = false; });
            }
        };
        CrossSellParking.prototype.removeParking = function () {
            var _this = this;
            return this.basketStore.removeParking(this.basketId)
                .then(function () { return _this.basketService.updateBasket(); });
        };
        CrossSellParking.prototype.getFrequencyText = function (frequencyInfo) {
            var description = '';
            if (frequencyInfo && (frequencyInfo.Duration || frequencyInfo.Frequency)) {
                if (frequencyInfo.Duration === '0') {
                    description = this.resourceService.get('OPTIONSPARKINGDURATIONONAIRPORT');
                }
                else {
                    description = String.format(this.resourceService.get('OPTIONSPARKINGDURATIONTOAIRPORT'), frequencyInfo.Duration);
                }
                if (frequencyInfo.Frequency) {
                    var frequencyText = String.format(this.resourceService.get('OPTIONSPARKINGFREQUENCY'), frequencyInfo.Frequency);
                    if (frequencyInfo.Duration !== '0') {
                        description = String.format('{0} ({1})', description, frequencyText);
                    }
                    else if (!frequencyInfo.Duration) {
                        description = String.format('{0} {1}', description, frequencyText);
                    }
                }
            }
            return description;
        };
        return CrossSellParking;
    }());
    angular
        .module('TR')
        .component('crossSellParking', {
        bindings: {
            show: '='
        },
        controller: CrossSellParking,
        templateUrl: 'partials/home/directivetemplate?type=CrossSellParking'
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var CrossSellTransfers = /** @class */ (function () {
        function CrossSellTransfers($q, $routeParams, $scope, analytics, basketService, basketStore, hotelFromSession, broker, customCurrencyFilter, resourceService, tripService, mandatoryTransferService, hotelRoomService) {
            var _this = this;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.analytics = analytics;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.hotelFromSession = hotelFromSession;
            this.broker = broker;
            this.customCurrencyFilter = customCurrencyFilter;
            this.resourceService = resourceService;
            this.tripService = tripService;
            this.mandatoryTransferService = mandatoryTransferService;
            this.hotelRoomService = hotelRoomService;
            this.showInitialMessage = false;
            this.transfersAvailabilityBusy = true;
            this.transfersSelectionBusy = true;
            this.total = 0;
            this.mandatoryExtrasEnabled = false;
            this.isMandatoryExtra = false;
            this.noneTransfer = { Details: { TransferId: '-1' } };
            this.emptyTransfer = { Details: { TransferId: null } };
            this.mandatoryExtrasEnabled = TRPCONFIG.Domain.MandatoryExtrasEnabled;
            this.mandatoryTransfer = [];
            if (this.isHotelJourney) {
                this.showInitialMessage = true;
                this.transfersAvailabilityBusy = false;
            }
            broker.subscribe('Transfers', 'ProductHotelReceivedFromBasket', function (e) {
                _this.basketId = e.data.basketId;
                _this.hotelProductId = e.data.productId;
            });
            $scope.$watch('tran.hotelExtrasSelectedTransfer', function (val) {
                if (val && _this.hotelProductId && _this.basketId) {
                    _this.OptionId = _this.mandatoryTransferService
                        .generateOptionId(undefined, val.HotelExtraId, val.HotelExtraOptionId);
                    var type_1 = 2;
                    basketStore.addOption(type_1, _this.hotelProductId, _this.OptionId, _this.basketId)
                        .then(function () {
                        var hemt = _this.hotelExtrasMandatoryTransfers;
                        var hest = _this.hotelExtrasSelectedTransfer;
                        var options = _this._getExpiredOptions(hemt, hest);
                        basketStore.removeOptions(type_1, _this.hotelProductId, options, _this.basketId).then(function () {
                            basketService.updateBasket();
                        });
                    });
                }
            });
            broker.subscribe('Transfers', 'transferRequestFailed', function () {
                _this.showDetailsError = true;
                if (!_this.isTransferMandatory) {
                    _this.transfer = angular.copy(_this.noneTransfer);
                }
            });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('Transfers');
            });
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                _this.basketId = trip.BasketId;
                var tripId = trip.TripId;
                var transferSearchId = _.get(trip, 'TransfersRequest.AvailabilitySearchId');
                $q.all([
                    basketStore.transfer(_this.basketId, $routeParams.productId),
                    basketStore.hotel(_this.basketId, $routeParams.productId)
                ]).then(function (results) {
                    var transfer = results[0] || _this.noneTransfer;
                    $scope.$emit('sendTransferSelection', transfer);
                    _this.transfer = angular.copy(transfer);
                    var hotel = results[1];
                    if (_this.mandatoryExtrasEnabled && hotel) {
                        _this.hotelFromSession.getHotel(hotel.AvailabilitySearchId, hotel.Details.Id, tripId)
                            .then(function (res) {
                            _this.hotelData = angular.copy(res);
                            if (_this.hotelData) {
                                _this._initMandatoryTransfers(hotel, trip);
                            }
                        });
                    }
                    _this.transfersEnabled = _([_this.tripService.tripTypes.Holiday, _this.tripService.tripTypes.Hotel])
                        .includes(trip.TripType) && hotel && !hotel.isVilla;
                    var getTransfers = function (transferSearchId, params) {
                        basketService.getTransfers(transferSearchId, _this.basketId, tripId, params).then(function (r) {
                            if (r && r.length > 0 && _this.isTransferMandatory) {
                                _this.transfer.Details.TransferId = r[0].TransferId;
                            }
                            _this.setResults(r, hotel);
                        });
                    };
                    if (_this.isHotelJourney) {
                        broker.subscribe('Transfers', 'flightDataUpdated', function (e) {
                            _this.transfersAvailabilityBusy = true;
                            _this.transfer = angular.copy(_this.noneTransfer);
                            getTransfers(null, e && e.data);
                        });
                    }
                    if (transferSearchId || !_this.isHotelJourney) {
                        getTransfers(transferSearchId, {});
                    }
                    if (hotel && trip.FlightsRequest && trip.FlightsRequest.Destination) {
                        _this._checkIstransferMandatory(trip.FlightsRequest);
                    }
                    if (_this.mandatoryExtrasEnabled) {
                        _this._setMandatoryTransferWatcher(trip, hotel);
                    }
                    else {
                        _this._setTransfersWatcher(trip, tripId, transferSearchId);
                    }
                }).then(angular.noop, basketService.restartHolidayWorkflow);
            }, basketService.bookingAlreadyDone);
        }
        CrossSellTransfers.prototype._getExpiredOptions = function (transfers, currentTransfer) {
            var _this = this;
            var expiredOptionsIds = Array();
            if (currentTransfer && transfers.length && transfers.length > 0) {
                var expiredTransfers = transfers.filter(function (t) {
                    return t.HotelExtraId === currentTransfer.HotelExtraId
                        && t.HotelExtraOptionId !== currentTransfer.HotelExtraOptionId;
                });
                expiredTransfers.forEach(function (et) {
                    var OptionId = _this.mandatoryTransferService
                        .generateOptionId(undefined, et.HotelExtraId, et.HotelExtraOptionId);
                    expiredOptionsIds.push({ OptionId: OptionId });
                });
            }
            return expiredOptionsIds;
        };
        CrossSellTransfers.prototype.setResults = function (r, hotel) {
            if (r != null) {
                this.transfers = _.sortBy(r, 'TotalPrice');
                this._updateSubtitle();
                //so that we can test both versions of the page
                // we need to create a secondary limited list of transfers to use on the new design
                this.rankedResults = _.sortBy(_.take(r, 3), 'TotalPrice');
                this.isAvailableTransfer = (this.rankedResults && this.rankedResults.length > 0) ||
                    this.showInitialMessage;
            }
            if (hotel != null) {
                var hotelDetails = _.get(hotel, 'Details');
                var bookedItems = _.get(hotelDetails, 'BookedItems');
                var mandatoryTransfers = _.get(bookedItems[0], 'mandatoryTransfers');
                if (mandatoryTransfers) {
                    this.isAvailableTransfer = true;
                }
            }
            if (TRPCONFIG.Domain.EnforceTransferOptionSelection && this.isNoneTransfer(this.transfer)) {
                this.transfer = angular.copy(this.emptyTransfer);
            }
            this.transfersAvailabilityBusy = false;
            //tracking
            if (r != null && r.length > 0) {
                this._trackingTransferSelection(this.transfer.Details.TransferId);
            }
            else {
                this.analytics.track('mixpanel', 'OptionsTransferNoAvailability');
            }
        };
        CrossSellTransfers.prototype.isNoneTransfer = function (transfer) {
            return angular.equals(transfer, this.noneTransfer);
        };
        CrossSellTransfers.prototype._setMandatoryTransferWatcher = function (trip, hotel) {
            var _this = this;
            if (this.tripService.supportsTransfers(trip)) {
                this.$scope.$watchCollection('tran.mandatoryTransfer', function () {
                    var transfersWrapper = { transfers: _this.mandatoryTransfer };
                    var options = _this.mandatoryTransferService
                        .generateOptionsForMultiRooms(transfersWrapper, _this.roomsWithMandatoryTransfer);
                    _this._changeMandatoryTransfer(options, hotel);
                });
            }
        };
        CrossSellTransfers.prototype._setTransfersWatcher = function (trip, tripId, transferSearchId) {
            var _this = this;
            if (this.tripService.supportsTransfers(trip)) {
                this.$scope.$watch('tran.transfer.Details.TransferId', function (val) {
                    if (TRPCONFIG.Domain.EnforceTransferOptionSelection) {
                        if (_this.transfers && _this.transfers.length > 0) {
                            _this.$scope.$emit('sendTransferSelection', val);
                        }
                        else {
                            _this.$scope.$emit('sendTransferSelection', _this.noneTransfer);
                        }
                    }
                    if (val == null) {
                        return;
                    }
                    _this.$scope.$emit('flash:hide');
                    _this.transfersSelectionBusy = true;
                    if (_this.transfers && _this.transfers.length > 0) {
                        _this._trackingTransferSelection(val);
                    }
                    _this._updateSubtitle();
                    if (val !== _this.noneTransfer.Details.TransferId) {
                        //we need to re-check the trip here in case we have just generated the search id
                        _this.tripService.getTrip(tripId).then(function (t) {
                            transferSearchId = _.get(t, 'TransfersRequest.AvailabilitySearchId');
                            _this.basketService.selectTransfer(val, transferSearchId, _this.basketId, tripId)
                                .then(function () {
                                _this.basketService.updateBasket();
                                _this.showDetailsError = false;
                                _this.transfersSelectionBusy = false;
                            });
                        });
                    }
                    else {
                        _this.basketStore.removeTransfer(_this.basketId).then(_this.basketService.updateBasket);
                        _this.transfersSelectionBusy = false;
                    }
                });
                this.nullTransferText = this.resourceService.getDeferred('NOTRANSFERREQUIRED');
            }
        };
        CrossSellTransfers.prototype._trackingTransferSelection = function (transferId) {
            var _this = this;
            var data = {
                Title: null,
                CostPP: null,
                CostTotal: null,
                OptionIndex: null,
                TotalOptions: this.transfers.length + 1,
                MinOptionCostTotal: _.first(this.transfers).TotalPrice,
                MaxOptionCostTotal: _.last(this.transfers).TotalPrice,
                HotelAndFlightCost: null,
                SupplierName: null
            };
            if (transferId == null) {
                data.Title = 'Nothing selected';
            }
            else if (transferId !== '-1') {
                var index_1 = 0;
                var quote = _.find(this.transfers, function (t, i) {
                    index_1 = i;
                    return angular.equals(t.TransferId, transferId);
                });
                data.Title = quote.Type;
                data.CostPP = quote.PerPersonPrice;
                data.CostTotal = quote.TotalPrice;
                data.OptionIndex = index_1 + 1; //0-based index will confuse end user
                data.SupplierName = quote.SupplierName;
            }
            else if (transferId === '-1') {
                data.Title = 'No Transfer';
            }
            this.$q.all([
                this.basketStore.hotelCost(this.basketId),
                this.basketStore.flightCost(this.basketId)
            ]).then(function (res) {
                data.HotelAndFlightCost += res[0] + res[1];
                _this.analytics.track('mixpanel', 'OptionsTransferSelected', data);
            });
        };
        CrossSellTransfers.prototype._updateSubtitle = function () {
            var _this = this;
            if (this.transfers && this.transfer.Details.TransferId) {
                var transferQuote = _.find(this.transfers, function (t) {
                    return angular.equals(t.TransferId, _this.transfer.Details.TransferId);
                });
                this.total = transferQuote ? transferQuote.TotalPrice : 0;
                this.transferQuoteDescription = transferQuote
                    ? transferQuote.Quantity + " x " + transferQuote.Type
                    : '';
                this.transferQuoteDescriptionWithPrice = transferQuote
                    ? this.transferQuoteDescription + " (" + this.customCurrencyFilter(this.total) + ")"
                    : '';
            }
        };
        CrossSellTransfers.prototype._checkIstransferMandatory = function (flight) {
            var destinationAiports = flight.DestinationAirports ? flight.DestinationAirports
                : flight.Destination.DestinationAirports.split(',');
            this.isTransferMandatory = destinationAiports.includes.apply(destinationAiports, TRPCONFIG.Domain.IsTransferMandatory);
        };
        CrossSellTransfers.prototype._initMandatoryTransfers = function (hotel, trip) {
            this.roomsWithMandatoryTransfer = this.mandatoryTransferService
                .getHolidayRoomsWithTransfers(hotel.Details) || [];
            this.roomsWithMandatoryTransfer.length > 0 ? this.transfersSelectionBusy = false : null;
            this.bookedMandatoryOptions = [];
            for (var i = 0; i < this.roomsWithMandatoryTransfer.length; i++) {
                this.bookedMandatoryOptions = this.mandatoryTransferService
                    .getSelectedTransfers(hotel, this.roomsWithMandatoryTransfer);
                this.mandatoryTransfer[i] = this.bookedMandatoryOptions[i]
                    || this.roomsWithMandatoryTransfer[i].mandatoryTransfers[0];
            }
            if (this.mandatoryTransfer.length > 0 || this.roomsWithMandatoryTransfer.length > 0) {
                this.isAvailableTransfer = true;
            }
            if (this.roomsWithMandatoryTransfer.length === 0) {
                var tripId = trip.TripId;
                var transferSearchId = _.get(trip, 'TransfersRequest.AvailabilitySearchId');
                this._setTransfersWatcher(trip, tripId, transferSearchId);
            }
            if (this.bookedMandatoryOptions && this.bookedMandatoryOptions.length > 0) {
                this.bookedMandatoryOptions = this.mandatoryTransferService
                    .generateOptionsForMultiRooms({ transfers: this.bookedMandatoryOptions }, this.roomsWithMandatoryTransfer);
            }
        };
        CrossSellTransfers.prototype._changeMandatoryTransfer = function (options, hotel) {
            var _this = this;
            if (options.length > 0 && JSON.stringify(this.bookedMandatoryOptions) !== JSON.stringify(options)) {
                var productType_1 = this.basketStore.productType.Transfer;
                var productId_1 = hotel.ProductId;
                this.basketStore.removeOptions(productType_1, productId_1, this.bookedMandatoryOptions, this.basketId)
                    .then(function () {
                    _this.bookedMandatoryOptions = options;
                    _this.basketStore.addOptions(productType_1, productId_1, options, _this.basketId)
                        .then(function () { return _this.basketService.updateBasket(); });
                });
            }
        };
        return CrossSellTransfers;
    }());
    angular
        .module('TR')
        .component('crossSellTransfers', {
        bindings: {
            isHotelJourney: '<',
            isTransferMandatory: '=?',
            isAvailableTransfer: '=?',
            isMandatoryExtra: '@'
        },
        controller: CrossSellTransfers,
        controllerAs: 'tran',
        templateUrl: 'partials/home/directivetemplate?type=CrossSellTransfers'
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('datePicker', datepicker);
    function datepicker(resourceService, $timeout, dateUtil) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: function (element, attr) {
                var base = 'partials';
                if (attr.templateVersion) {
                    return base + "/booking/template?name=DatePicker&version=" + attr.templateVersion;
                }
                return base + "/home/directivetemplate?type=DatePicker";
            },
            scope: {
                select: '&',
                minDate: '=',
                maxDate: '=',
                defaultTime: '=',
                currentDate: '=',
                dates: '=',
                showApplyButton: '=',
                showTime: '=',
                isTimeApprovedByCustomer: '=?',
                requiresTimeApproval: '=',
                timeLabelKey: '@',
                timeErrorMsg: '@',
                placeholder: '@',
                noInitialDate: '@',
                numberOfMonths: '@',
                datepickerClass: '=',
                focusTracker: '@',
                isDisabled: '=?',
                isDisabledPlaceholder: '@',
                isRequired: '=?',
                isReadonly: '=?'
            },
            link: _linker,
            controller: _controller,
            transclude: true
        };
        function _controller($scope, $element) {
            this.dateEl = $element.find('.datepicker-wrapper');
        }
        function _linker(scope, el, attr) {
            var selectedDate = parseCurrentDate();
            var dateEl = el.find('.datepicker-wrapper');
            if (TRPCONFIG.IsTouchDevice) {
                dateEl.attr('readonly', 'true');
            }
            // Used as `ng-model` primarily to enable `ng-invalid` etc. on field
            scope.fieldVals = {
                date: {}
            };
            // Re-wire 'focus-tracker' attr to input field
            if (scope.focusTracker && scope.$parent.ft) {
                scope.$parent.ft.init(dateEl);
            }
            // `required` attr has no value
            if (attr.hasOwnProperty('required')) {
                scope.isRequired = true;
            }
            scope.timeValue = {};
            var dp = dateEl.datepicker({
                numberOfMonths: parseInt(scope.numberOfMonths) || 1,
                dateFormat: 'dd-M-yy',
                firstDay: 1,
                minDate: parseMinDate(scope.minDate),
                maxDate: dateUtil.parseDate(scope.maxDate),
                beforeShowDay: beforeShowDay,
                // http://www.objectpartners.com/2012/06/18/jquery-ui-datepicker-ie-focus-fix/
                // http://bugs.jqueryui.com/ticket/9125 is not important enough apparently
                lastDisplay: null,
                onSelect: function () {
                    selectDate();
                    this.lastDisplay = new Date().getTime();
                    this.blur();
                },
                onClose: function () {
                    // This deals with anything typed into the field that changed the value
                    var dpDate = dp.datepicker('getDate') || '';
                    var expected = selectedDate || '';
                    if (dpDate.toString() !== expected.toString()) {
                        selectDate();
                    }
                    else {
                        syncField();
                    }
                },
                beforeShow: function () {
                    return !this.lastDisplay || (new Date().getTime()) - this.lastDisplay > 100;
                },
                prevText: '',
                nextText: '',
                isRTL: TRPCONFIG.Rtl
            });
            function selectDate() {
                selectedDate = dp.datepicker('getDate');
                // $apply avoiding $digest errors
                scope.$evalAsync(function () {
                    if (selectedDate == null) {
                        scope.select({ date: null });
                    }
                    else if (!scope.showTime) {
                        scope.select({ date: dateUtil.serialiseDate(selectedDate) });
                    }
                    else if (!scope.showApplyButton) {
                        scope.setDepartureDateAndTime();
                    }
                    syncField();
                });
            }
            if (scope.showTime && !scope.showApplyButton) {
                scope.$watchGroup(['tp.hours', 'tp.minutes'], function (vals) {
                    if (vals[0] && vals[1]) {
                        // Timer ensures field is ready
                        $timeout(selectDate);
                    }
                });
            }
            //  terrible hack to prevent the default behaviour of jQuery datepicker
            //  so we can have no selected and highlighted date
            $timeout(function () {
                var currDate = parseCurrentDate();
                if (scope.noInitialDate === 'true') {
                    scope.$apply(function () {
                        if (!scope.currentDate || !dateUtil.isValid(currDate)) {
                            dp.datepicker('setDate', null);
                            $(el).find('td.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
                        }
                        else {
                            dp.datepicker('setDate', currDate);
                            scope.currentDate = dateUtil.serialiseDate(currDate);
                        }
                    });
                }
                else {
                    dp.datepicker('setDate', currDate);
                }
            });
            scope.$watch('minDate', function (val) {
                if (val != null) {
                    dateEl.datepicker('option', 'minDate', parseMinDate(val));
                    // If select date is called on mobile then the datepicker freezes up.
                    if (TRPCONFIG.Domain.DeviceType === 'Desktop') {
                        selectDate();
                    }
                }
            });
            scope.$watch('maxDate', function (val) {
                if (val != null) {
                    dateEl.datepicker('option', 'maxDate', dateUtil.parseDate(val));
                }
            });
            scope.setDepartureDateAndTime = function () {
                var dateOb = null;
                if (scope.tp && (!scope.tp.hours || !scope.tp.minutes)) {
                    scope.$emit('flash:error', resourceService.get(scope.timeErrorMsg));
                }
                if (dateUtil.isValid(selectedDate)) {
                    var hours = scope.tp && scope.tp.hours ? scope.tp.hours : selectedDate.getHours();
                    var minutes = scope.tp && scope.tp.minutes ? scope.tp.minutes : selectedDate.getMinutes();
                    dateOb = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hours, minutes);
                }
                var serialisedDate = dateUtil.serialiseDate(dateOb);
                if (_.isFunction(scope.select)) {
                    scope.select({ date: serialisedDate, back: true });
                }
                else {
                    scope.select = serialisedDate;
                }
            };
            if (scope.showTime) {
                //this is sort of a nextTick hack
                $timeout(function () {
                    el.find('button').text(resourceService.get('APPLYDATEANDTIME'));
                }, 0);
            }
            function syncField() {
                // Ensure field contains current value
                dp.datepicker('setDate', selectedDate);
                dateEl.trigger('input');
            }
            function parseCurrentDate() {
                return dateUtil.parseDate(scope.currentDate);
            }
            function parseMinDate(val) {
                return val === true ?
                    dateUtil.zeroTime(new Date()) :
                    dateUtil.parseDate(val);
            }
            function beforeShowDay(date) {
                var allowed = true;
                if (scope.dates && Object.keys(scope.dates).length > 0) {
                    var dateStr = dateUtil.format(date, 'yyyy-MM-dd');
                    allowed = scope.dates[dateStr] !== undefined;
                }
                return [allowed, '', ''];
            }
        }
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('destination', function (searchUnitService) {
        return {
            restrict: 'A',
            link: function (scope, el, attr) {
                if (attr.destination != null) {
                    searchUnitService.setDestination(angular.extend({ landing: true }, JSON.parse(attr.destination)));
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var FILTERLINKCONTENTTYPE = 11;
    var TR = angular.module('TR');
    TR.directive('destinationContent', function (broker, destinationContent, currentDestination, urlUtils, fidParser) {
        return {
            restrict: 'E',
            replace: false,
            scope: {
                containerClass: '@',
                sitemapLink: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=DestinationContent',
            link: function (scope) {
                currentDestination.getCurrentDestination().then(function (dest) {
                    if (dest != null) {
                        init(dest);
                    }
                });
                function init(dest) {
                    destinationContent.get(dest).then(function (contents) {
                        contents = _.sortBy(contents, contentOrderRank);
                        contents.forEach(function (content, index) {
                            if (Array.isArray(content.Items)) {
                                content.Items.forEach(function (item, name) {
                                    if (!_.isNull(item.Url) && !_.isUndefined(item.Url)) {
                                        contents[index].Items[name].Url = urlUtils.stripLeadingSlash(item.Url);
                                    }
                                });
                            }
                        });
                        // if the url we are being hit with matches one of the seo
                        // content urls, The fid is considered canonical.  Fire off
                        //a message to update the canonical tag.
                        var currentFid = fidParser.parse();
                        if (currentFid) {
                            var matchedSeoItem = _.find(contents, function (ci) {
                                if (ci.ContentType !== FILTERLINKCONTENTTYPE) {
                                    return false;
                                }
                                return _.find(ci.Items, function (i) {
                                    var parsedUrl = urlUtils.parse(i.Url);
                                    // no query string object or parameters, exist early.
                                    if (!parsedUrl.qs || parsedUrl.qs.length === 0) {
                                        return false;
                                    }
                                    return currentFid === _.toNumber(parsedUrl.qs.fid);
                                });
                            });
                            if (!_.isUndefined(matchedSeoItem)) {
                                broker.publish('seoCanonicalDetected', {
                                    fid: currentFid
                                });
                            }
                        }
                        // Don't render filter link content.
                        scope.items = _.filter(contents, function (ci) {
                            return ci.ContentType !== FILTERLINKCONTENTTYPE;
                        });
                        broker.publish('seoContentLoaded');
                    });
                }
                function contentOrderRank(content) {
                    // The order should be:
                    // First: SEO Content Types, in alphabetical order
                    // Then: The other content types, in id order.
                    if (content.ContentType > 7) {
                        return "0" + content.Title;
                    }
                    return "1" + content.ContentType;
                }
            }
        };
    });
})();
var DestinationPromoMessage = /** @class */ (function () {
    function DestinationPromoMessage(currentDestination, $interpolate) {
        var _this = this;
        this.currentDestination = currentDestination;
        this.$interpolate = $interpolate;
        currentDestination.getCurrentDestination().then(function (dest) {
            var text = dest.PromoText;
            var matches = text && text.match(/\S*\d+\S*/);
            _this.price = matches && matches[0];
            _this.text = _this.price && text.split(_this.price);
        });
    }
    return DestinationPromoMessage;
}());
angular
    .module('TR')
    .directive('destinationPromoMessage', function () {
    return {
        controller: DestinationPromoMessage,
        controllerAs: 'dpm',
        bindToController: {
            className: '='
        },
        replace: true,
        template: "<p class=\"destination-promo-message\" ng-if=\"dpm.price\">\n                        {{dpm.text[0]}} <span class=\"price\">{{dpm.price}}</span>{{dpm.text[1]}}\n                        </p>"
    };
});
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('destinationTitle', function (resourceService, pageStrand, loggingService, destinationService) {
        return {
            restrict: 'E',
            replace: true,
            template: '<span>{{ title }}</span>',
            scope: {
                title: '@?',
                dest: '=',
                allowEstab: '=' // Required on estab page because search pages display parent dest
            },
            link: function (scope) {
                var strandResources = {
                    1: resourceService.getDeferred('HOTELSIN'),
                    2: resourceService.getDeferred('HOLIDAYSIN')
                };
                var reVarStr = /{/;
                var strand;
                var countryId;
                var bc;
                // Destination object receives async updates
                scope.$watch('dest', init, true);
                function _destTitleFallback(dest) {
                    scope.title = (strandResources[strand] || strandResources[1])() + " " + dest.Title;
                    return true;
                }
                function init(dest) {
                    if (!dest || !dest.BreadcrumbTrail) {
                        return;
                    }
                    strand = pageStrand.fromRoute(dest);
                    // Values may be removed by `getParentDestination()`
                    bc = dest.BreadcrumbTrail;
                    countryId = dest.CountryId;
                    if (!scope.allowEstab) {
                        // Display estab parent destination by default
                        // i.e. 'choose a different hotel' results
                        dest = getParentDestination(dest);
                    }
                    dest.PageStrand = strand;
                    destinationService.getText(dest, {
                        customErrCallback: {
                            404: function () {
                                _destTitleFallback(dest);
                            },
                            400: function () {
                                _destTitleFallback(dest);
                            }
                        }
                    }).then(function (result) {
                        // `PageHeading` template should exist ideally
                        var titleStr = String.supplant(
                        // Non-estab: fall back to PageTitle, Estab: fall back to hotel name
                        result.PageHeading || (!scope.allowEstab && result.PageTitle) || '{name}', getVarMap(dest));
                        if (reVarStr.test(titleStr)) {
                            // Error if any vars are not transformed
                            var logMsg = "Untransformed template: " + titleStr + " | " + window.location.href + " | getText: " + angular.toJson(result);
                            loggingService.logError(logMsg);
                        }
                        else {
                            scope.title = titleStr;
                        }
                    });
                }
                function getParentDestination(dest) {
                    //if the destination is an estab, walk back one level up the breadcrumb and the return the parent destination
                    var pDest = (dest.EstablishmentId && bc && bc.length > 1) ? bc[bc.length - 2] : dest;
                    // Add properties required by `getVarMap()` (returns a new object)
                    return angular.extend({
                        ShortTitle: pDest.Title,
                        SummaryTitle: pDest.Title
                    }, pDest);
                }
                function getVarMap(dest) {
                    // Variable mapping in string templates i.e. {name}
                    // Also supports legacy numeric vars i.e. {0}
                    var inResource = resourceService.get(dest.IsPOI ? 'NearDestination' : 'InDestination');
                    return {
                        0: dest.Title,
                        1: inResource,
                        name: dest.ShortTitle,
                        in: inResource,
                        location: dest.SummaryTitle,
                        country: destinationService.getBreadcrumbTitle(dest, function (bc) { return bc.ObjectId === countryId; })
                    };
                }
            }
        };
    });
})();
var TR;
(function (TR) {
    var DEVICE_DATA_COLLECTOR_URL = '/partials/home/directivetemplate?type=DeviceDataCollector';
    var DDCController = /** @class */ (function () {
        function DDCController($element, paymentDetailsService, $window, $timeout, $rootScope) {
            this.$element = $element;
            this.paymentDetailsService = paymentDetailsService;
            this.$window = $window;
            this.$timeout = $timeout;
            this.$rootScope = $rootScope;
            this.MESSAGE_EVENT = 'message';
            this.TIMEOUT = TRPCONFIG.Domain.ThreeDS2RetryTimeout;
            this.THRESHOLD = TRPCONFIG.Domain.ThreeDS2RetryThreshold;
            this.IFRAMETIMER = TRPCONFIG.Domain.ThreeDS2AwaitDDC;
            this.retryCount = 0;
        }
        DDCController.prototype.$onInit = function () {
            this.setUpHandlers();
        };
        DDCController.prototype.$onDestroy = function () {
            this.$window.removeEventListener(this.MESSAGE_EVENT, this.messageEventListener);
        };
        DDCController.prototype.startGetToken = function () {
            return __awaiter(this, void 0, void 0, function () {
                var jwtTokenData, dfReferenceId;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dfReferenceId = null;
                            /*
                            retry to get to get JWT token.
                            _getDeviceData() returns promise which may be rejected
                            because of network errors or because of timeout (this.TIMEOUT)
                            */
                            this.retryCount = 0;
                            _a.label = 1;
                        case 1:
                            if (!(!jwtTokenData && this.retryCount < this.THRESHOLD)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this._getDeviceData()];
                        case 2:
                            jwtTokenData = _a.sent();
                            this.retryCount++;
                            return [3 /*break*/, 1];
                        case 3:
                            // What is onRecieve?
                            if (!jwtTokenData) {
                                this.onReceive({ dfReferenceId: dfReferenceId });
                                return [2 /*return*/, dfReferenceId];
                            }
                            /*
                            retry to submit form with JWT token and receive ReferenceId.
                            _submitForm() returns promise which may be rejected
                            because of problems to load iframe from the URL or
                            because of not receiving POST Message from iframe.
                            */
                            this.retryCount = 0;
                            _a.label = 4;
                        case 4:
                            if (!(!dfReferenceId && this.retryCount < this.THRESHOLD)) return [3 /*break*/, 6];
                            return [4 /*yield*/, this._getIdReference(jwtTokenData.jwtToken)];
                        case 5:
                            dfReferenceId = _a.sent();
                            this.retryCount++;
                            return [3 /*break*/, 4];
                        case 6:
                            this.onReceive({ dfReferenceId: dfReferenceId });
                            return [2 /*return*/, dfReferenceId];
                    }
                });
            });
        };
        DDCController.prototype.startGetToken2 = function () {
            return __awaiter(this, void 0, void 0, function () {
                var dfReferenceId, jwtTokenData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._getDeviceData()];
                        case 1:
                            jwtTokenData = _a.sent();
                            if (jwtTokenData.jwtToken) {
                                this.jwtToken = jwtTokenData.jwtToken;
                            }
                            return [4 /*yield*/, this._getIdReference2(this.jwtToken)];
                        case 2:
                            dfReferenceId = _a.sent();
                            return [2 /*return*/, dfReferenceId];
                    }
                });
            });
        };
        DDCController.prototype._reloadIframe = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var reloadTimer;
                _this.$element.attr('src', '');
                _this.$timeout(function (_) {
                    _this.$element[0].onload = function (_) {
                        _this.$element[0].onload = angular.noop;
                        _this.$timeout.cancel(reloadTimer);
                        //below block is to ensure that iframe template is loaded successfully
                        //if 404 error it is not able to get form
                        if (_this.getForm(_this.$element[0])) {
                            resolve();
                        }
                        else {
                            reject();
                        }
                    };
                    _this.$element.attr('src', DEVICE_DATA_COLLECTOR_URL);
                }, _this.IFRAMETIMER);
                /*
                Reject iframe reloadIframePromise if its not possible
                to get template because of network problems and try again
                */
                reloadTimer = _this.$timeout(function (_) {
                    _this.$element[0].onload = angular.noop;
                    reject(null);
                }, _this.TIMEOUT);
            });
        };
        DDCController.prototype._getIdReference = function (jwtToken) {
            return __awaiter(this, void 0, void 0, function () {
                var idReference, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            idReference = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, this._reloadIframe()];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this._submitForm(jwtToken)];
                        case 3:
                            idReference = _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            err_2 = _a.sent();
                            console.log('err', err_2);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, idReference];
                    }
                });
            });
        };
        DDCController.prototype._getIdReference2 = function (jwtToken) {
            return __awaiter(this, void 0, void 0, function () {
                var idReference, err_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            idReference = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, this._reloadIframe()];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this._submitForm2(jwtToken)];
                        case 3:
                            idReference = _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            err_3 = _a.sent();
                            console.log('err', err_3);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, idReference];
                    }
                });
            });
        };
        DDCController.prototype._getDeviceData = function () {
            return __awaiter(this, void 0, void 0, function () {
                var tokenResponse, err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.getDDCToken()];
                        case 1:
                            tokenResponse = _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_4 = _a.sent();
                            tokenResponse = null;
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/, tokenResponse];
                    }
                });
            });
        };
        DDCController.prototype._completeForm = function (cardNumber, jwtValue) {
            var binValue = cardNumber && cardNumber.slice(0, 6);
            if (binValue && jwtValue) {
                this.form = this.getForm(this.$element[0]);
                this.setFieldValue(this.getField(this.form, 'bin'), binValue);
                this.setFieldValue(this.getField(this.form, 'jwt'), jwtValue);
            }
        };
        DDCController.prototype._completeForm2 = function (cardNumber, jwtValue) {
            var _this = this;
            return new Promise(function (resolve) {
                var binValue = cardNumber && cardNumber.slice(0, 6);
                if (binValue && jwtValue) {
                    _this.form = _this.getForm(_this.$element[0]);
                    _this.setFieldValue(_this.getField(_this.form, 'bin'), binValue);
                    _this.setFieldValue(_this.getField(_this.form, 'jwt'), jwtValue);
                    resolve();
                }
            });
        };
        DDCController.prototype.setUpHandlers = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.addCommand({ command: this.startGetToken.bind(this) })];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.addCommand({ command: this.startGetToken2.bind(this) })];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        DDCController.prototype._submitForm = function (jwtToken) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this._completeForm(this.cardNumber, jwtToken);
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var getTimer;
                            _this._clearMessageListener();
                            _this.messageEventListener = function (event) {
                                _this.$timeout.cancel(getTimer);
                                if (event.origin === TRPCONFIG.Domain.ThreeDS2PaymentGatewayDomain) {
                                    var data = JSON.parse(event.data);
                                    console.warn('Merchant received a message:', data);
                                    if (data && data.Status) {
                                        _this.$rootScope.dfReferenceId = data.SessionId;
                                        var dfReferenceId = data.SessionId;
                                        _this.onReceive({ dfReferenceId: dfReferenceId });
                                        resolve(data.SessionId);
                                    }
                                    else {
                                        _this.$rootScope.dfReferenceId = null;
                                        reject(null);
                                    }
                                }
                            };
                            _this.$window.addEventListener(_this.MESSAGE_EVENT, _this.messageEventListener, false);
                            getTimer = _this.$timeout(function (_) {
                                _this._clearMessageListener();
                                reject(null);
                            }, _this.TIMEOUT);
                            _this.form.submit();
                        })];
                });
            });
        };
        DDCController.prototype._submitForm2 = function (jwtToken) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._completeForm2(this.cardNumber, jwtToken)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    var getTimer;
                                    _this._clearMessageListener();
                                    _this.messageEventListener = function (event) {
                                        _this.$timeout.cancel(getTimer);
                                        if (event.origin === TRPCONFIG.Domain.ThreeDS2PaymentGatewayDomain) {
                                            var data = JSON.parse(event.data);
                                            console.warn('Merchant received a message:', data);
                                            if (data && data.Status) {
                                                _this.$rootScope.dfReferenceId = data.SessionId;
                                                resolve(data.SessionId);
                                                return data.SessionId;
                                            }
                                            else {
                                                _this.$rootScope.dfReferenceId = null;
                                                reject(null);
                                            }
                                        }
                                    };
                                    _this.$window.addEventListener(_this.MESSAGE_EVENT, _this.messageEventListener, false);
                                    getTimer = _this.$timeout(function (_) {
                                        _this._clearMessageListener();
                                        reject(null);
                                    }, _this.TIMEOUT);
                                    _this.form.submit();
                                })];
                    }
                });
            });
        };
        DDCController.prototype._clearMessageListener = function () {
            if (this.messageEventListener) {
                this.$window.removeEventListener(this.MESSAGE_EVENT, this.messageEventListener);
            }
        };
        DDCController.prototype.getDDCToken = function () {
            return __awaiter(this, void 0, void 0, function () {
                var ddcResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.cardType) {
                                return [2 /*return*/, Promise.reject('Card details are invalid')];
                            }
                            return [4 /*yield*/, this.paymentDetailsService.getDeviceDataCollectionToken(this.cardType, this.TIMEOUT)];
                        case 1:
                            ddcResponse = _a.sent();
                            return [2 /*return*/, ddcResponse && ddcResponse.data];
                    }
                });
            });
        };
        DDCController.prototype.getForm = function (iframe) {
            return iframe.contentWindow.document.getElementById('collectionForm');
        };
        DDCController.prototype.getField = function (form, className) {
            return form.getElementsByClassName(className)[0];
        };
        DDCController.prototype.setFieldValue = function (field, value) {
            field.value = value;
        };
        return DDCController;
    }());
    angular
        .module('TR')
        .directive('deviceDataCollectorTr', function () {
        return {
            replace: true,
            scope: {},
            bindToController: {
                cardNumber: '=',
                cardType: '=',
                addCommand: '&',
                onReceive: '&'
            },
            controller: DDCController,
            controllerAs: 'ddc',
            template: "<iframe height=\"1\" width=\"1\" style=\"display:none;\" src=\"" + DEVICE_DATA_COLLECTOR_URL + "\"></iframe>"
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('dobPicker', function (dateUtil, arrayUtil, $locale, broker) {
        var days = arrayUtil.numberArray(1, 31);
        var months = arrayUtil.map($locale.DATETIME_FORMATS.SHORTMONTH, function (m, i) {
            return { index: i, label: m };
        });
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            templateUrl: function (element, attr) {
                var base = 'partials';
                if (attr.templateVersion) {
                    return base + "/booking/template?name=DobPicker&version=" + attr.templateVersion;
                }
                return base + "/home/directivetemplate?type=DobPicker";
            },
            link: function (scope, el, attr, c) {
                if (!c) {
                    return;
                }
                scope.dobField = attr.field;
                var thisYear = new Date().getFullYear();
                var minAge = parseInt(scope.$eval(attr.minAge));
                var age = parseInt(scope.$eval(attr.age));
                var maxAge = attr.maxAge ? parseInt(scope.$eval(attr.maxAge)) : 100;
                if (attr.ageCheck != null) {
                    var date = scope.$eval(attr.ageCheck).split('T')[0];
                    thisYear = new Date(date).getFullYear();
                }
                scope.days = days;
                scope.months = months;
                scope.years = arrayUtil.numberArray(thisYear - (age >= 0 ? age : minAge), age >= 0 ? thisYear - age - 1 : thisYear - maxAge);
                c.$formatters.unshift(function (val) {
                    if (val == null) {
                        return val;
                    }
                    var d = dateUtil.parseDate(val);
                    if (dateUtil.isValid(d)) {
                        scope.dob = scope.dob || {};
                        scope.dob = {
                            year: d.getFullYear(),
                            month: d.getMonth(),
                            day: d.getDate()
                        };
                    }
                    return val;
                });
                function parse(val) {
                    if (val == null || val.day == null || val.month == null || val.year == null) {
                        return null;
                    }
                    var d = dateUtil.zeroTime(val.year + "-" + padZero(val.month + 1) + "-" + padZero(val.day), false);
                    return (dateUtil.isValid(d)) ? dateUtil.serialiseDate(d) : null;
                }
                function padZero(n) {
                    return (n < 10) ? ("0" + n) : n;
                }
                scope.$watch('dob', function (val) {
                    if (val == null) {
                        return;
                    }
                    c.$setViewValue(parse(val));
                    broker.publish('dobUpdated', val);
                }, true);
            }
        };
    });
})();
var Core;
(function (Core) {
    var DropdownCheckboxList = /** @class */ (function () {
        function DropdownCheckboxList($scope, $document, resourceService) {
            this.$scope = $scope;
            this.$document = $document;
            this.resourceService = resourceService;
            this.isOpen = false;
            this.eventNamespace = 'dropdowncheckboxlist';
        }
        DropdownCheckboxList.prototype.init = function (el, attrs) {
            var _this = this;
            this.element = el;
            var id = this.element.attr('id');
            this.ids = {
                button: id + '-button',
                menu: id + '-menu'
            };
            this.$scope.$watchCollection('dcl.model', function (val) {
                if (val) {
                    _this.setButtonText();
                }
            });
            this.$scope.$watchCollection('dcl.options', function (val) {
                if (val) {
                    _this.setButtonText();
                }
            });
        };
        DropdownCheckboxList.prototype.toggle = function (event) {
            this.isOpen ? this.close() : this.open(event);
        };
        DropdownCheckboxList.prototype.keydown = function (event) {
            switch (event.keyCode) {
                // Escape
                case 27:
                    this.close();
                    break;
                // Enter
                case 13:
                    this.toggle(event);
                    break;
                default:
            }
        };
        DropdownCheckboxList.prototype.setButtonText = function () {
            var _this = this;
            var label;
            if (!this.model || !this.options) {
                return;
            }
            if (this.model.length === this.options.length || this.model.length === 0) {
                label = this.resourceService.getDeferred('ANY')();
            }
            else if (this.model.length === 1) {
                var match = _.find(this.options, function (o) {
                    return o[_this.valueProperty] === _this.model[0];
                });
                label = String(match[this.labelProperty]);
            }
            else {
                label = this.model.length + " " + this.pluralLabel;
            }
            this.selection = label;
        };
        DropdownCheckboxList.prototype.close = function () {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this.$document.off('.' + this.eventNamespace);
        };
        DropdownCheckboxList.prototype.open = function (event) {
            var _this = this;
            this.isOpen = true;
            // close if background is clicked
            this.$document.on('mousedown.' + this.eventNamespace, function (event) {
                if (!_this.isOpen) {
                    return;
                }
                // close if click target isn't the menu or the button
                if (!$(event.target).closest("#" + _this.ids.menu + ", #" + _this.ids.button).length) {
                    _this.$scope.$apply(function () {
                        _this.close();
                    });
                }
            });
        };
        return DropdownCheckboxList;
    }());
    angular
        .module('core')
        .directive('dropdownCheckboxList', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: DropdownCheckboxList,
            controllerAs: 'dcl',
            bindToController: {
                model: '=',
                options: '=',
                caption: '@',
                valueProperty: '@',
                labelProperty: '@',
                singularLabel: '@',
                pluralLabel: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=dropdowncheckboxlist',
            link: function (scope, el, attrs, controller) {
                controller.init(el, attrs);
            }
        };
    });
})(Core || (Core = {}));
/*
    Check whether the tenants email address is valid in the booking form
 */
var TR;
(function (TR) {
    var EmailAllowed = /** @class */ (function () {
        function EmailAllowed($q, bookingService) {
            this.$q = $q;
            this.bookingService = bookingService;
        }
        EmailAllowed.prototype.init = function (scope, el, attr, ctrl) {
            var _this = this;
            ctrl.$asyncValidators.emailAllowed = function (modelValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    return _this.$q.resolve();
                }
                //do fetch from some service here
                return _this.bookingService.checkValidEmail(modelValue);
            };
        };
        return EmailAllowed;
    }());
    angular
        .module('TR')
        .directive('emailAllowed', function () {
        return {
            restrict: 'A',
            controller: EmailAllowed,
            controllerAs: 'ea',
            require: 'ngModel',
            link: function (scope, el, attr, ctrl) {
                return scope.ea.init(scope, el, attr, ctrl);
            }
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('eventTracker', eventTracker);
    function eventTracker(analytics, $parse) {
        return {
            restrict: 'A',
            link: _linker
        };
        function _linker(scope, elem, attr) {
            var label = null;
            var category = attr.eventCategory;
            var type = attr.eventType;
            function _fireEvent() {
                var eventData = {
                    label: label,
                    category: category,
                    value: 1
                };
                if (attr.eventAction) {
                    eventData.action = attr.eventAction;
                }
                analytics.trackEvent(eventData);
            }
            function _destroyHandlers(events) {
                scope.$on('destroy', function () {
                    elem.off(events);
                });
            }
            if (type !== 'textbox') {
                elem.on('click', function (e) {
                    // only register left clicks
                    if (e && e.button !== 0) {
                        return;
                    }
                    var attrLabel = $parse(attr.eventLabel)(scope);
                    var attrTag = attr.eventTag ? attr.eventTag + ": " : '';
                    label = attrLabel ? ("" + attrTag + attrLabel) : attr.eventTag;
                    _fireEvent();
                });
                _destroyHandlers('click');
            }
            else {
                elem.on('keypress keydown', _.debounce(function () {
                    label = $parse(attr.eventLabel)(scope);
                    _fireEvent();
                }, 1500));
                _destroyHandlers('keypress keydown');
            }
        }
    }
})();
var Core;
(function (Core) {
    var FareRulesLink = /** @class */ (function () {
        function FareRulesLink(modalService) {
            this.modalService = modalService;
        }
        FareRulesLink.prototype.showFareRules = function () {
            var fareRulesText = this.details || '';
            if (fareRulesText) {
                this.modalService.launch('partials/popups/farerules', { fareRulesText: fareRulesText });
            }
        };
        ;
        return FareRulesLink;
    }());
    angular
        .module('TR')
        .directive('fareRulesLink', function (modalService) {
        return {
            restrict: 'E',
            bindToController: {
                text: '@',
                details: '='
            },
            controllerAs: 'fr',
            controller: FareRulesLink,
            template: '<div><a href="#" ng-click="fr.showFareRules()">{{fr.text}}</a></div>'
        };
    });
})(Core || (Core = {}));
var TR;
(function (TR) {
    var FareRulesText = /** @class */ (function () {
        function FareRulesText(modalService) {
            this.modalService = modalService;
            this.text = this.modalService.get('fareRulesText');
        }
        return FareRulesText;
    }());
    angular
        .module('TR')
        .directive('fareRulesText', function (modalService) {
        return {
            restrict: 'E',
            controllerAs: 'frt',
            controller: FareRulesText,
            template: '<div ng-bind-html="frt.text"></div>'
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('filterCriterion', function () {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                close: '&',
                show: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=FilterCriterion'
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('flashMessage', function ($timeout, $filter, resourceService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return "partials/booking/template?name=FlashMessage&version=" + attr.templateVersion;
                }
                var templateName = attr.templateName || 'FlashMessage';
                return "partials/home/directivetemplate?type=" + templateName;
            },
            link: function (scope) {
                var err = null;
                var success = null;
                var info = null;
                var tryStopPropagation = function (ev) {
                    if (typeof ev.stopPropagation === 'function') {
                        ev.stopPropagation();
                    }
                };
                scope.visible = false;
                scope.getClass = function () {
                    return (err ? 'error-message' : (success ? 'success-message' : (info ? 'info-message' : 'closed')));
                };
                scope.$on('flash:error', function (ev, msg) {
                    err = success = info = null;
                    if (msg == null) {
                        return;
                    }
                    scope.visible = true;
                    if (!(msg instanceof Array)) {
                        msg = [msg];
                    }
                    err = msg;
                    scope.message = msg.map(function (m) {
                        if (_.isObject(m)) {
                            //Escape the unexpected backend error:
                            var backendError = $('<div/>').text($filter('json')(m)).html();
                            var errorMessage = resourceService.get('UNEXPECTEDSEARCHERROR');
                            m = errorMessage + " <span class=\"ng-hide\">" + backendError + "</span>";
                        }
                        return "<li>" + m + "</li>";
                    }).join('');
                    tryStopPropagation(ev);
                });
                scope.$on('flash:success', function (ev, msg) {
                    scope.message = success = msg;
                    scope.visible = true;
                    err = info = null;
                    $timeout(function () {
                        scope.message = success = null;
                    }, 3000);
                    tryStopPropagation(ev);
                });
                scope.$on('flash:info', function (ev, msg) {
                    scope.message = info = msg;
                    scope.visible = true;
                    err = success = null;
                    tryStopPropagation(ev);
                });
                scope.$on('flash:hide', function () {
                    scope.visible = false;
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('footerCarousel', function ($timeout, $q) {
        return {
            restrict: 'A',
            transclude: true,
            link: function (scope, element, attributes, controller, $transclude) {
                var $element = $(element);
                var carousel = false;
                function processItem(item) {
                    var deferred = $q.defer();
                    $transclude(function (clone, scope) {
                        scope.item = item;
                        deferred.resolve($element.append(clone));
                    });
                    return deferred.promise;
                }
                scope.$watchCollection(attributes.footerCarousel, function (elem) {
                    //ensure this only runs when the section is open
                    if (!elem.open) {
                        return;
                    }
                    if (carousel) {
                        $element.slick('unslick');
                        carousel = false;
                    }
                    $element.empty();
                    var filteredThings = elem.things.filter(function (hotel) { return !hotel.deleted; });
                    if (!filteredThings.length) {
                        return;
                    }
                    $q.all(filteredThings.map(processItem)).then(function () {
                        $timeout(function () {
                            $element.slick({
                                rtl: TRPCONFIG.Rtl,
                                prevArrow: $element.siblings('.slick-prev'),
                                nextArrow: $element.siblings('.slick-next'),
                                infinite: false,
                                slidesToShow: 5,
                                slidesToScroll: 1,
                                swipeToSlide: true,
                                variableWidth: true,
                                responsive: [{
                                        breakpoint: 1760,
                                        settings: {
                                            slidesToShow: 4
                                        }
                                    }, {
                                        breakpoint: 1425,
                                        settings: {
                                            slidesToShow: 3
                                        }
                                    }, {
                                        breakpoint: 1000,
                                        settings: {
                                            slidesToShow: 2
                                        }
                                    }]
                            });
                            carousel = true;
                            //turn off all new flags to reveal added element
                            filteredThings.forEach(function (thing) { return thing.new = false; });
                            scope.$apply();
                        }, 200);
                    });
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('footerToolbar', function (urlUtils, $rootScope, preferences, imageService, $timeout, arrayUtil, hotelRehydrator, broker, $q, recentHotels, shortlistService, resourceService, savedSearchService, basketService, analytics, attractionService, basketStore) {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=FooterToolbar',
            link: function (scope) {
                scope.open = false;
                scope.$on('auth:signout', fetch);
                scope.$on('auth:signin', fetch);
                scope.stripLeadingSlash = urlUtils.stripLeadingSlash;
                var initialised = false;
                var busy = false;
                var icons = {
                    1: 'icon-flight',
                    3: 'icon-holidays',
                    2: 'icon-hotel',
                    4: 'icon-transfer',
                    6: 'icon-parking'
                };
                var sectionIndex = {
                    recentHotels: 0,
                    shortlist: 1,
                    savedSearches: 2
                };
                $rootScope.$on('$routeChangeSuccess', function (event, current) {
                    scope.hide = current.hideDistractionLinks;
                    if (initialised) {
                        closeAllSections();
                    }
                    else if (!scope.hide) {
                        init();
                    }
                });
                if (!scope.rc.hideDistractionLinks) {
                    init();
                }
                function addHotelToSection(section, hotel) {
                    if (section == null || section.things == null) {
                        return;
                    }
                    //make sure this hotel is not already in the list
                    if (arrayUtil.any(section.things, function (t) {
                        return t.Id === hotel.Id && !t.deleted;
                    }) || arrayUtil.any(section.estabIds, function (estabId) {
                        return estabId === hotel.Id;
                    })) {
                        return;
                    }
                    if (hotel.Name == null) {
                        hotel.Name = hotel.Title;
                    }
                    hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, 80, 80);
                    hotel.hide = true;
                    hotel.deleted = false;
                    hotel.new = true;
                    section.things.unshift(hotel);
                    $timeout(function () {
                        hotel.hide = false;
                        section.count += 1;
                    }, 0);
                }
                function removeHotelFromSection(section, hotel) {
                    for (var i = 0, l = section.things.length; i < l; i++) {
                        if (section.things[i].Id === hotel.Id) {
                            section.count -= 1;
                            section.things[i].hide = true;
                            section.things[i].deleted = true;
                            break;
                        }
                    }
                }
                function setToolbarOpen(isOpen) {
                    scope.open = isOpen;
                    preferences.set('footerToolbar', scope.open);
                }
                function deleteSearch(s, ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    savedSearchService.removeSavedSearch(s.SavedSearchId);
                    scope.sections[2].count -= 1;
                    removeSearch(s);
                }
                function removeSearch(search) {
                    search.hide = true;
                    search.deleted = true;
                }
                function addSearch(section, s) {
                    //force close of search on add as element has no layout
                    if (scope.sections[2].open) {
                        scope.sections[2].open = false;
                    }
                    //make sure this search is not already in the list
                    var isSearchInTheList = arrayUtil.any(section.things, function (t) { return t.SavedSearchId === s.SavedSearchId && !t.deleted; });
                    if (isSearchInTheList) {
                        return;
                    }
                    s.hide = true;
                    s.deleted = false;
                    s.new = true;
                    extendSearch(s);
                    section.things.unshift(s);
                    $timeout(function () {
                        s.hide = false;
                        section.count += 1;
                    }, 0);
                }
                function restoreSearch(s, ev) {
                    ev.preventDefault();
                    if (!busy) {
                        busy = true;
                        savedSearchService.restoreSearch(s).then(function () {
                            basketService.startWorkflow(basketService.workflowType[s.SearchType]).then(function () {
                                busy = false;
                                removeSearch(s);
                            });
                            analytics.trackEvent({ label: 'restore saved search' });
                        }, function () {
                            busy = false;
                        });
                    }
                }
                function rehydrateIfNecessaryAndThen(section, then, hotel) {
                    if (section.needsHydrating) {
                        rehydrate(section).then(function () {
                            then(section, hotel);
                        });
                    }
                    else {
                        then(section, hotel);
                    }
                }
                function setupSubscriptions() {
                    broker.subscribe('footerToolbarDirective', 'hotelAddedToShortlist', function (ev) {
                        var hotel = angular.copy(ev.data);
                        hotel.onDelete = deleteFromShortlist;
                        rehydrateIfNecessaryAndThen(scope.sections[1], addHotelToSection, hotel);
                    });
                    broker.subscribe('footerToolbarDirective', 'hotelRemovedFromShortlist', function (ev) {
                        var hotel = ev.data;
                        hotel.inShortlist = false;
                        scope.$emit('hotelShortlistStatusUpdated', hotel);
                        rehydrateIfNecessaryAndThen(scope.sections[1], removeHotelFromSection, hotel);
                    });
                    broker.subscribe('footerToolbarDirective', 'recentHotelAdded', function (ev) {
                        rehydrateIfNecessaryAndThen(scope.sections[0], function (section, hotel) {
                            rehydrateHotel(section, hotel).then(function (hotel) {
                                addHotelToSection(section, hotel);
                            });
                        }, ev.data);
                    });
                    broker.subscribe('footerToolbarDirective', 'recentHotelRemoved', function (ev) {
                        rehydrateIfNecessaryAndThen(scope.sections[0], function (section, hotel) {
                            removeHotelFromSection(section, hotel);
                        }, { Id: ev.data });
                    });
                    broker.subscribe('footerToolbarDirective', 'savedSearchAdded', function (ev) {
                        addSearch(scope.sections[2], angular.copy(ev.data));
                    });
                    broker.subscribe('footerToolbarDirective', 'footerToolbarChanged', function (ev) {
                        scope.open = ev.data;
                    });
                    broker.subscribe('footerToolbarDirective', 'attractionsBasketUpdated', function (e) {
                        var basket = e && e.data && e.data.Basket;
                        updateAttractionsBasket(basket && basket.LineItems);
                    });
                    broker.subscribe('footerToolbarDirective', 'basketCleared', function () { return updateAttractionsBasket(); });
                }
                function closeAllSections() {
                    if (scope.sections) {
                        scope.sections.forEach(function (s) { return s.open = false; });
                    }
                }
                function section(identifier, title, estabIds, things, emptyPrompt, icon, template, needsRehydrating, index, showCount, onDelete) {
                    return {
                        identifier: identifier,
                        title: title,
                        things: things || [],
                        estabIds: estabIds || [],
                        emptyPrompt: emptyPrompt,
                        count: estabIds.length || things.length || 0,
                        needsHydrating: needsRehydrating,
                        icon: icon,
                        template: template,
                        index: index,
                        showCount: showCount,
                        onDelete: onDelete
                    };
                }
                function deleteFromShortlist(hotel, ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    shortlistService.removeFromShortlist(hotel);
                }
                function shortlistSection(hotels) {
                    return section('shortlist', resourceService.get('SHORTLIST'), hotels, [], resourceService.get('NOSHORTLISTEDHOTELS'), 'favourite', 'partials/footertoolbar/toolbarhotel', true, sectionIndex.shortlist, true, deleteFromShortlist);
                }
                function deleteFromRecent(_a, ev) {
                    var Id = _a.Id;
                    ev.preventDefault();
                    ev.stopPropagation();
                    recentHotels.remove(Id);
                }
                function recentHotelsSection(hotels) {
                    return section('recent', resourceService.get('RECENTHOTELS'), hotels, [], resourceService.get('NORECENTHOTELS'), 'timer', 'partials/footertoolbar/toolbarhotel', true, sectionIndex.recentHotels, true, deleteFromRecent);
                }
                function savedSearchesSection(searches) {
                    return section('searches', resourceService.get('RECENTSEARCHES'), [], arrayUtil.map(searches, extendSearch), resourceService.get('NORECENTSEARCHES'), 'search', 'partials/footertoolbar/toolbarsearch', false, sectionIndex.savedSearches, false);
                }
                function extendSearch(s) {
                    return angular.extend(s, {
                        icon: icons[s.SearchType],
                        onClick: restoreSearch,
                        onDelete: deleteSearch
                    });
                }
                function fetch() {
                    return __awaiter(this, void 0, void 0, function () {
                        var _a, recentHotelIds, shortlistEstabIds, savedSearches, footerToolbarPreferences;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    initialised = true;
                                    return [4 /*yield*/, $q.all([
                                            recentHotels.getIds(),
                                            shortlistService.getShortlistEstabIds(),
                                            savedSearchService.getSavedSearches(),
                                            preferences.get('footerToolbar')
                                        ])];
                                case 1:
                                    _a = _b.sent(), recentHotelIds = _a[0], shortlistEstabIds = _a[1], savedSearches = _a[2], footerToolbarPreferences = _a[3];
                                    scope.sections = [
                                        recentHotelsSection(recentHotelIds),
                                        shortlistSection(shortlistEstabIds),
                                        savedSearchesSection(savedSearches)
                                    ];
                                    return [2 /*return*/, footerToolbarPreferences];
                            }
                        });
                    });
                }
                function initAttractionsBasket() {
                    basketStore.getAttractionsBasket()
                        .then(function (res) { return updateAttractionsBasket(res.LineItems); });
                }
                function updateAttractionsBasket(lineItems) {
                    var totals = attractionService.getProductTotals(lineItems);
                    scope.attractionsBasketTotal = totals.price;
                    scope.attractionsBasketCount = totals.count;
                    if (totals.count) {
                        setToolbarOpen(true);
                    }
                }
                function rehydrate(section) {
                    return hotelRehydrator.hotels(section.estabIds, {
                        fields: [
                            'Id', 'Title', 'Location', 'StarRating', 'CustomerRating', 'CustomerRatingTitle', 'Url'
                        ]
                    }).then(function (hotels) {
                        for (var i = 0, l = hotels.length; i < l; i++) {
                            section.things[i] = hotels[i];
                            section.things[i].onDelete = section.onDelete;
                        }
                        section.needsHydrating = false;
                    });
                }
                function rehydrateHotel(section, id) {
                    return hotelRehydrator.hotels([id], {
                        fields: [
                            'Id', 'Title', 'Location', 'StarRating', 'CustomerRating', 'CustomerRatingTitle', 'Url'
                        ]
                    }).then(function (hotels) {
                        var hotel = hotels[0];
                        hotel.onDelete = section.onDelete;
                        return hotel;
                    });
                }
                function init() {
                    fetch().then(function (open) {
                        scope.open = open;
                        setupSubscriptions();
                        initAttractionsBasket();
                    });
                }
                scope.select = function (index) {
                    scope.sections[index].open = false;
                };
                scope.sectionClass = function (index) {
                    return scope.sections[index].open ? 'expanded' : '';
                };
                scope.toggleBar = function () { return setToolbarOpen(!scope.open); };
                scope.toggleSection = function (index) {
                    scope.sections.forEach(function (s, i) {
                        if (i !== index) {
                            s.open = false;
                        }
                    });
                    if (!scope.sections[index].open && scope.sections[index].needsHydrating) {
                        rehydrate(scope.sections[index]).then(function () {
                            scope.sections[index].open = true;
                        });
                    }
                    else {
                        scope.sections[index].open = !scope.sections[index].open;
                    }
                };
                scope.$watch('open', function (v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    broker.publish('footerToolbarChanged', scope.open);
                });
                scope.$on('$destroy', function () {
                    broker.unsubscribe('footerToolbarDirective');
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('globalWaiverText', GlobalWaiverText);
    function GlobalWaiverText() {
        return {
            restrict: 'E',
            scope: {
                waiverText: '=',
            },
            controllerAs: 'cm',
            templateUrl: 'partials/home/directivetemplate?type=GlobalWaiverText',
            link: function ($scope, $element) {
                if (!$scope.waiverText || $scope.waiverText == null) {
                    return;
                }
                $scope.showImportantInfo = false;
                function fetchWaiverText() {
                    return __awaiter(this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, $scope.waiverText];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    });
                }
                function waiverTextReady() {
                    return __awaiter(this, void 0, void 0, function () {
                        function attachLightbox(e) {
                            e.preventDefault();
                            $scope.selectedImportantInfo = '';
                            $scope.showImportantInfo = true;
                            $scope.$apply();
                        }
                        var getWaiverText, el, globalWaiverTerms;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, fetchWaiverText()];
                                case 1:
                                    getWaiverText = _a.sent();
                                    if (!getWaiverText.length) {
                                        return [2 /*return*/];
                                    }
                                    el = $element[0];
                                    globalWaiverTerms = el.querySelector('.globalWaiverTerms');
                                    globalWaiverTerms.addEventListener('click', attachLightbox);
                                    $scope.$on('$destroy', function () {
                                        globalWaiverTerms.removeEventListener('click', attachLightbox);
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
                waiverTextReady();
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('googleMap', function ($window, $timeout, searchUnitService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                key: '@',
                model: '='
            },
            template: '<div></div>',
            link: function (scope, el) {
                var headerHeight = 95;
                var throttle = 100;
                var pos = searchUnitService.getSearchArea();
                var map;
                var initialised = false;
                var centre;
                var promise = null;
                scope.$on('mapTabSelected', function () {
                    if (!$window.google || !$window.google.maps) {
                        $("<script type=\"text/javascript\" id=\"googleScript\" src=\"https://maps.googleapis.com/maps/api/js?client=" + TRPCONFIG.Domain.GoogleClientId + "&sensor=false&callback=googleMapLoadedCallback\" />")
                            .appendTo($('head'));
                    }
                    else {
                        $timeout($window.googleMapLoadedCallback, 50);
                    }
                });
                scope.$on('$destroy', function () {
                    delete $window.googleMapLoadedCallback;
                    $($window).off('resize', windowResize);
                });
                function windowResize() {
                    if (promise !== null) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(resizeMap, throttle);
                }
                $window.googleMapLoadedCallback = function () {
                    if (!initialised && !map) {
                        resizeMap();
                        centre = new google.maps.LatLng(scope.model.Latitude, scope.model.Longitude);
                        map = new google.maps.Map(el[0], {
                            zoom: 18,
                            scrollwheel: false,
                            overviewMapControl: false,
                            center: centre,
                            mapTypeControl: false,
                            streetViewControl: true,
                            scaleControl: true
                        });
                        var hotelMarker_1 = new google.maps.Marker({
                            position: centre,
                            map: map,
                            icon: 'build/img/Maps/map-pin.svg',
                            animation: google.maps.Animation.DROP
                        });
                        var hotelInfoWindow_1 = new google.maps.InfoWindow({
                            content: "<div class=\"no-scrollbars\">" + scope.model.Title + "</div>"
                        });
                        hotelInfoWindow_1.open(map, hotelMarker_1);
                        google.maps.event.addListener(hotelMarker_1, 'click', function () {
                            hotelInfoWindow_1.open(map, hotelMarker_1);
                        });
                        if (pos) {
                            var bounds = new google.maps.LatLngBounds();
                            bounds.extend(centre);
                            var me = new google.maps.LatLng(pos.Latitude, pos.Longitude);
                            new google.maps.Marker({
                                position: me,
                                map: map,
                                icon: 'build/img/Maps/marker-icon.png',
                                animation: google.maps.Animation.DROP
                            });
                            bounds.extend(me);
                            map.fitBounds(bounds);
                        }
                        $($window).on('resize', windowResize);
                        initialised = true;
                    }
                    resizeMap();
                };
                function resizeMap() {
                    el.width('100%');
                    el.height($($window).height() - headerHeight);
                    if (map) {
                        google.maps.event.trigger(map, 'resize');
                    }
                }
            }
        };
    });
})();
var TR;
(function (TR) {
    function HeadingOverlayBanner() {
        return {
            restrict: 'C',
            link: function ($scope, $element) {
                if ($element.is('[no-heading-overlay-banner]')) {
                    return;
                }
                var text = $element.text().toLowerCase().indexOf('sale') > -1 ?
                    TRPCONFIG.Domain.HeadingOverlayBannerMessageShort :
                    TRPCONFIG.Domain.HeadingOverlayBannerMessage;
                var classes = 'sc-c-panel--quinary sc-c-panel--lighten80 sc-c-panel--gutters-xs u-text--centered';
                var html = "<div class=\"" + classes + "\">\n                            <h6 class=\"sc-o-hero-heading \">" + text + "</h6>\n                           </div>";
                var div = $(html);
                div.insertBefore($element);
            },
        };
    }
    if (TRPCONFIG.Domain.HeadingOverlayBannerMessage) {
        angular
            .module('TR')
            .directive('scCHero', HeadingOverlayBanner)
            .directive('heroImage', HeadingOverlayBanner);
    }
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('heroImage', function ($location, resourceService, $route) {
        function getResource(k) {
            switch (k.toLowerCase()) {
                case 'rc':
                    return resourceService.get('RECOMMENDEDHOTELSIN');
                case 'tr':
                    return resourceService.get('TOPRATEDHOTELSIN');
                case 'bh':
                    return resourceService.get('BUDGETHOTELSIN');
                case 'lh':
                    return resourceService.get('LUXURYHOTELSIN');
                default:
                    return "{0} " + resourceService.get('IN') + " {1}";
            }
        }
        function getArea() {
            switch ($route.current.area) {
                case 'hotels':
                    return resourceService.get('HOTELS');
                case 'holidays':
                    return resourceService.get('HOLIDAYS');
                case 'flights':
                    return resourceService.get('FLIGHTS');
                case 'transfers':
                    return resourceService.get('TRANSFERS');
            }
            return '';
        }
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=heroimage',
            link: function (scope, el, attrs) {
                scope.overrideOverlay = attrs.overrideOverlay === 'true';
                scope.overlayTitle = function () {
                    if (scope.overrideOverlay) {
                        return getArea();
                    }
                    if (scope.destination == null) {
                        return '';
                    }
                    var k = $location.search().k;
                    if (k == null || scope.destination.EstablishmentId > 0) {
                        return scope.destination.Title;
                    }
                    return String.format(getResource(k), getArea(), scope.destination.Title);
                };
            }
        };
    });
})();
var TR;
(function (TR) {
    var HolidayDealListing = /** @class */ (function () {
        function HolidayDealListing(dateUtil, reviewService, pagingService, broker, $scope, filtering, holidayDeals) {
            this.dateUtil = dateUtil;
            this.reviewService = reviewService;
            this.pagingService = pagingService;
            this.broker = broker;
            this.$scope = $scope;
            this.filtering = filtering;
        }
        HolidayDealListing.prototype.showDeals = function (deals) {
            this.broker.publish('SHOWDEALS', { hotel: this.hotel });
        };
        HolidayDealListing.prototype.getFirstDate = function (deals) {
            return (deals && deals[0] && deals[0].HotelDeal) ?
                this.dateUtil.parseDate(deals[0].HotelDeal.CheckInDate) : '';
        };
        return HolidayDealListing;
    }());
    angular
        .module('TR')
        .directive('holidayDealListing', function () {
        return {
            scope: {},
            templateUrl: function (element, attrs) {
                return 'partials/home/directivetemplate?type=' + (attrs.templateOverride || 'HolidayDealListing');
            },
            replace: true,
            bindToController: {
                hotel: '=',
                priceMode: '=',
                eagerLoadImage: '=',
                duration: '=',
                discountPercentage: '=',
                dealPriceFormat: '='
            },
            controller: HolidayDealListing,
            controllerAs: 'hl'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var HotelOptionsSearchUnit = /** @class */ (function () {
        function HotelOptionsSearchUnit(basketStore, tripService, $routeParams, $scope, resourceService, broker, $q, dateUtil, analytics) {
            var _this = this;
            this.basketStore = basketStore;
            this.tripService = tripService;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.resourceService = resourceService;
            this.broker = broker;
            this.$q = $q;
            this.dateUtil = dateUtil;
            this.analytics = analytics;
            this.isArrivalTimeApproved = false;
            this.isDepartureTimeApproved = false;
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                if (!trip) {
                    return;
                }
                $q.all({
                    hotel: basketStore.hotel(trip.BasketId, $routeParams.productId),
                    checkInDate: tripService.getHotelsRequestCheckInDate(trip.TripId, true),
                    checkOutDate: tripService.getHotelsRequestCheckOutDate(trip.TripId, true)
                }).then(function (_a) {
                    var hotel = _a.hotel, checkInDate = _a.checkInDate, checkOutDate = _a.checkOutDate;
                    var transferArrivalDate = _.get(trip, 'TransfersRequest.ArrivalDate');
                    var transferDepartureDate = _.get(trip, 'TransfersRequest.ReturnDate');
                    _this.arrivalDate = checkInDate || transferArrivalDate;
                    _this.departureDate = checkOutDate || transferDepartureDate;
                    _this.minFlightArrivalDate = _this.arrivalDate;
                    _this.minFlightDepartureDate = _this.dateUtil.addDays(_this.arrivalDate, 1);
                    _this.isArrivalTimeApproved = !!transferArrivalDate;
                    _this.isDepartureTimeApproved = !!transferDepartureDate;
                    _this.airports = _.get(hotel, 'Details.LinkedAirports', []);
                    _this.selectedAirport =
                        _.find(_this.airports, function (a) { return a.Code === _.get(trip, 'TransfersRequest.AirportCode'); })
                            || _this.airports[0];
                    // if (this.selectedAirport) {
                    //     this.broker.publish('flightDataUpdated', {
                    //         airport: this.selectedAirport
                    //     });
                    // }
                });
            });
            this.$scope.$watch('$ctrl.arrivalDate', function () {
                _this.validateDates('arrival');
            });
            this.$scope.$watch('$ctrl.departureDate', function () {
                _this.validateDates('departure');
            });
        }
        HotelOptionsSearchUnit.prototype.validateDates = function (type) {
            if (this.dateUtil.compareDates(this.arrivalDate, this.departureDate) >= 0) {
                switch (type) {
                    case 'arrival':
                        this.departureDate = this.dateUtil.addDays(this.arrivalDate, 1);
                        break;
                    case 'departure':
                        this.arrivalDate = this.dateUtil.addDays(this.departureDate, -1);
                        break;
                }
            }
        };
        HotelOptionsSearchUnit.prototype.setArrivalDate = function (date) { this.arrivalDate = date; };
        HotelOptionsSearchUnit.prototype.setDepartureDate = function (date) { this.departureDate = date; };
        HotelOptionsSearchUnit.prototype.search = function () {
            var _this = this;
            var errors = _([this.isArrivalTimeApproved, this.isDepartureTimeApproved]).zip(['SELECTARRIVALDATETIME', 'SELECTRETURNDATETIME'])
                .filter(function (z) { return !z[0]; })
                .map(function (z) { return _this.resourceService.get(z[1]); })
                .value();
            if (errors.length) {
                this.analytics.track('mixpanel', 'OptionsTransferSearch', {
                    ValidationFail: errors
                });
            }
            this.$scope.$emit(errors.length ? 'flash:error' : 'flash:hide', errors);
            this.analytics.track('mixpanel', 'OptionsTransferSearch', {
                Airport: this.selectedAirport.Title
            });
            this.isArrivalTimeApproved &&
                this.isDepartureTimeApproved &&
                this.broker.publish('flightDataUpdated', {
                    airport: this.selectedAirport,
                    dates: {
                        arrivalDate: this.arrivalDate,
                        departureDate: this.departureDate
                    }
                });
        };
        return HotelOptionsSearchUnit;
    }());
    angular
        .module('TR')
        .component('hotelOptionsSearchUnit', {
        controller: HotelOptionsSearchUnit,
        templateUrl: 'partials/home/directivetemplate?type=hotelOptionsSearchUnit'
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('hotelReview', hotelReview);
    function hotelReview($location, authService, reviewService, $routeParams, modalService) {
        var domain = TRPCONFIG.Domain;
        function cultureMatches(review) {
            if (review == null || (review && review.CultureCode == null)) {
                return true;
            }
            return review.CultureCode.toLowerCase().substring(0, 2) ===
                domain.CultureCode.toLowerCase().substring(0, 2);
        }
        return {
            restrict: 'E',
            replace: true,
            scope: {
                review: '=',
                hotelName: '=',
                parentShown: '=',
                localShowHotelname: '@showHotelname',
                localShowHelpfulPrompt: '@showHelpfulPrompt'
            },
            templateUrl: 'partials/hotels/review',
            link: function (scope) {
                scope.showTranslation = 1;
                scope.showOriginal = 0;
                scope.translating = false;
                scope.review.ShowingTranslation = 1;
                scope.hotelName = scope.hotelName || '';
                scope.reviewTranslated = reviewTranslated;
                scope.organicLike = function () { _like('organic'); };
                scope.postSubmissionLike = function () { _like('postSubmission'); };
                scope.signIn = signIn;
                scope.modalSignIn = modalSignIn;
                scope.showHelpfulPrompt = true;
                scope.showHotelname = false;
                if (scope.localShowHotelname === 'true') {
                    scope.showHotelname = true;
                }
                if (scope.localShowHelpfulPrompt === 'false') {
                    scope.showHelpfulPrompt = false;
                }
                scope.$watch('review.ShowingTranslation', function (val, prev) {
                    if (val === prev) {
                        return;
                    }
                    if (val === scope.showOriginal) {
                        if (scope.review.OriginalComments == null) {
                            scope.translating = true;
                            reviewService.getOriginalText(scope.review.ReviewId).then(function (data) {
                                scope.review.OriginalComments = scope.review.Comments = data.Comments;
                                scope.review.OriginalTopTip = scope.review.TopTip = data.TopTip;
                                scope.translating = false;
                            });
                        }
                        else {
                            scope.review.Comments = scope.review.OriginalComments;
                            scope.review.TopTip = scope.review.OriginalTopTip;
                        }
                    }
                    else if (val === scope.showTranslation) {
                        scope.review.Comments = scope.review.TranslatedComments;
                        scope.review.TopTip = scope.review.TranslatedTopTip;
                    }
                });
                if ((scope.review.Comments || scope.review.TopTip) &&
                    !cultureMatches(scope.review) &&
                    !scope.review.Translated &&
                    !scope.review.TranslationFailed &&
                    !TRPCONFIG.IsBot) {
                    //we need to try to translate this one
                    scope.translating = true;
                    reviewService.setTranslation(scope.review).then(function (data) {
                        scope.review.OriginalComments = scope.review.Comments;
                        scope.review.OriginalTopTip = scope.review.TopTip;
                        scope.review.Comments = scope.review.TranslatedComments = data.Comments;
                        scope.review.TopTip = scope.review.TranslatedTopTip = data.TopTip;
                        scope.review.ShowingTranslation = scope.showTranslation;
                        scope.review.Translated = true;
                        scope.translating = false;
                    }, function () {
                        scope.review.TranslationFailed = true;
                        scope.translating = false;
                    });
                }
                if ((scope.review.Comments || scope.review.TopTip) && !cultureMatches(scope.review) && scope.review.Translated) {
                    scope.review.TranslatedComments = scope.review.Comments;
                    scope.review.TranslatedTopTip = scope.review.TopTip;
                }
                if ($routeParams.lr && parseInt($routeParams.lr) === scope.review.ReviewId) {
                    scope.organicLike();
                }
                function reviewTranslated() {
                    return (scope.review.Comments || scope.review.TopTip) &&
                        !cultureMatches(scope.review) &&
                        scope.review.Translated;
                }
                function _like(reviewLikeType) {
                    if (!scope.review.LikedByUser) {
                        reviewService.likeReview[reviewLikeType](scope.review.ReviewId, true).then(_postLike);
                    }
                }
                function _postLike() {
                    scope.review.LikedByUser = true;
                    scope.review.LikeCount++;
                }
                function modalSignIn() {
                    if (typeof scope.parentShown !== 'undefined') {
                        scope.parentShown = false;
                    }
                    var url = $location.path();
                    authService.bufferRoute(url);
                    modalService.launch('partials/auth/SignInPopUp', {
                        tab: 'signin',
                        cb: function () {
                            scope.organicLike();
                            if (typeof scope.parentShown !== 'undefined') {
                                scope.parentShown = true;
                            }
                        }
                    });
                }
                function signIn() {
                    var url = $location.path() + "?pd=rv&lr=" + scope.review.ReviewId;
                    authService.bufferRoute(url);
                    $location.url("signin?cb=" + encodeURIComponent(url));
                }
            }
        };
    }
})();
angular
    .module('TR')
    .directive('imageLoader', function () {
    return {
        restrict: 'A',
        scope: {
            onload: '&',
            onerror: '&'
        },
        link: function (scope, element, attrs) {
            element.on('load', function () {
                scope.onload({ name: attrs.name });
            });
            element.on('error', function () {
                scope.onerror({ name: attrs.name });
            });
        }
    };
});
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('importantInfo', importantInfo);
    function importantInfo(arrayUtil, $rootScope) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                info: '=',
                agentModeEnabled: '=?',
                contentCollapsible: '=',
                specialOfferText: '=?'
            },
            templateUrl: 'partials/home/directivetemplate?type=importantinfo',
            transclude: true,
            link: _linker
        };
        function _linker(scope) {
            scope.agentModeEnabled = !!$rootScope.user.Agent;
            // Special offer text
            if (scope.specialOfferText) {
                var offers = arrayUtil.wrapNonArray(scope.specialOfferText);
                scope.specialOfferHtml = offers.reduce(function (html, t) {
                    if (t) {
                        return html + " <div>" + t + "</div>";
                    }
                    return html;
                }, '');
            }
        }
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('injectParams', function () {
        return {
            restrict: 'A',
            link: function (scope, el, attr) {
                if (attr.injectParams != null) {
                    var obj = JSON.parse(attr.injectParams);
                    for (var prop in obj) {
                        if (obj.hasOwnProperty(prop)) {
                            scope[prop] = obj[prop];
                        }
                    }
                }
            }
        };
    });
})();
var TR;
(function (TR) {
    var InsuranceSelection = /** @class */ (function () {
        function InsuranceSelection($scope, basketService, broker, insuranceService, $filter, resourceService) {
            var _this = this;
            this.$scope = $scope;
            this.basketService = basketService;
            this.broker = broker;
            this.insuranceService = insuranceService;
            this.$filter = $filter;
            this.resourceService = resourceService;
            this.defaultBandCostForType = {};
            this.insuranceConfirmation = false;
            this.insuranceOptionId = '';
            this.adultsWithInsurance = 0;
            this.children = 0;
            this.insurees = [];
            this.filteredInsurees = [];
            var ignoreRooms = $scope.$watch('is.bookingLoaded', function (b) {
                if (b) {
                    _this.init();
                    ignoreRooms();
                }
            });
        }
        InsuranceSelection.prototype.init = function () {
            var _this = this;
            if (this.captureInsurance && this.insurance) {
                //fill our insurees list
                _.each(this.userData.Rooms, function (r) {
                    _.each(r.Guests, function (g) {
                        if (g.Type === 1) {
                            _this.adultsWithInsurance++;
                        }
                        _this.insurees.push(g);
                    });
                });
                if (!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands
                    && this.insuranceOptions && !_.some(this.insuranceOptions, function (io) { return io.Id === -1; })) {
                    //will have to find a better way to set this
                    this.insuranceOptions.push({ Id: -1,
                        Label: this.resourceService.get('PLEASESELECT'),
                        PassengerType: 1 });
                }
                this.basketService.getInsuranceQuotes(this.insurance.AvailabiltySearchId, this.trip.BasketId, this.trip.TripId, { onewayOnly: this.oneWay }).then(function (insuranceQuotes) {
                    _this.insuranceOptionId = _this.insurance.Options[0].OptionId;
                    var optionKey = _this.insuranceService.decomposeOptionId(_this.insuranceOptionId);
                    var quote = _.find(insuranceQuotes, function (q) {
                        return q.SupplierId === optionKey.supplierId
                            && q.QuoteType.SchemeId === optionKey.schemeId
                            && q.QuoteType.TypeId === optionKey.typeId
                            && (q.QuoteType.RelationshipId === optionKey.relationshipId
                                || optionKey.relationshipId === 0);
                    });
                    _this.description =
                        quote.QuoteType.Destination + " " + quote.QuoteType.Scheme + " " + quote.QuoteType.Type;
                });
                this.filteredInsurees = this.$filter('orderBy')(this.insurees, ['Type', '-Age'])
                    .map(function (insuree) {
                    insuree.priceDifference = _this.getPriceDifference(insuree);
                    insuree.passengerType = _this.getPassengerType(insuree.Type);
                    insuree.price = _this.getPrice(insuree);
                    if (!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands) {
                        insuree.InsuranceBandId = -1;
                    }
                    return insuree;
                });
            }
            ;
        };
        InsuranceSelection.prototype.updateInsuranceBandSelections = function () {
            //if the insurance band price is 0 && it is an adult passenger treat it as not available
            var excludedBandIds = _.map(_.filter(this.insuranceOptions, { Available: false }), 'Id');
            var _a = _.reduce(this.insurees, function (acc, person) {
                if (person.InsuranceBandId > 0
                    && _.indexOf(excludedBandIds, person.InsuranceBandId) === -1) {
                    if (person.Type === 1) {
                        acc.adultAges.push(person.InsuranceBandId);
                    }
                    else {
                        acc.childAges.push(person.InsuranceBandId);
                    }
                }
                return acc;
            }, { childAges: [], adultAges: [] }), childAges = _a.childAges, adultAges = _a.adultAges;
            if (adultAges.length === 0 && childAges.length > 0) {
                //clear child insurance ages
                this.insurees.forEach(function (i) {
                    if (i.Type !== 1) {
                        i.InsuranceBandId = null;
                    }
                });
                childAges = [];
            }
            this.adultsWithInsurance = adultAges.length;
            return adultAges.concat(childAges);
        };
        InsuranceSelection.prototype.getInsuranceLabel = function (guestId) {
            var i = _.find(this.insurees, { Id: guestId });
            return (i.Title && i.FirstName && i.LastName) ?
                i.Title + " " + i.FirstName + " " + i.LastName : i.Label;
        };
        InsuranceSelection.prototype.getPriceDifference = function (insuree) {
            var guestType = insuree.Type;
            var bandId = insuree.InsuranceBandId;
            //check to see if we have calculated this already
            if (!(this.defaultBandCostForType[guestType] && this.defaultBandCostForType[guestType][bandId])) {
                //find base (cheapest) options for this user type
                var defaultOption = _.first(_.filter(this.insuranceOptions, { 'PassengerType': guestType }));
                var newPrice = bandId > 0 ? _.find(this.insuranceOptions, { Id: bandId }).Price : 0;
                if (!this.defaultBandCostForType[guestType]) {
                    this.defaultBandCostForType[guestType] = {};
                }
                this.defaultBandCostForType[guestType][bandId] = newPrice - defaultOption.Price;
            }
            return this.defaultBandCostForType[guestType][bandId];
        };
        InsuranceSelection.prototype.getPrice = function (insuree) {
            return insuree && insuree.InsuranceBandId > 0 ?
                _.find(this.insuranceOptions, { Id: insuree.InsuranceBandId }).Price : 0;
        };
        InsuranceSelection.prototype.updateInsuranceQuote = function (userData) {
            var _this = this;
            var ages = this.updateInsuranceBandSelections();
            this.filteredInsurees.map(function (insuree) {
                insuree.priceDifference = _this.getPriceDifference(insuree);
                insuree.price = _this.getPrice(insuree);
            });
            return this.basketService.updateInsuranceQuote(this.trip.BasketId, this.trip.TripId, this.insuranceOptionId, { oneWayOnly: this.oneWay, ages: ages }).then(function () {
                _this.broker.publish('bookingBasketUpdated', angular.copy(userData));
                _this.broker.publish('basketUpdated');
                return;
            });
        };
        InsuranceSelection.prototype.getPassengerType = function (type) {
            if (type > 0) {
                switch (type) {
                    case Core.Booking.PassengerType.Adult:
                        return this.resourceService.get('ADULT');
                    case Core.Booking.PassengerType.Child:
                        return this.resourceService.get('CHILD');
                    case Core.Booking.PassengerType.Infant:
                        return this.resourceService.get('INFANT');
                }
            }
            return '';
        };
        return InsuranceSelection;
    }());
    angular
        .module('TR')
        .directive('insuranceSelection', function () {
        return {
            bindToController: true,
            controller: InsuranceSelection,
            controllerAs: 'is',
            restrict: 'E',
            replace: true,
            scope: {
                bookingLoaded: '=',
                captureInsurance: '=',
                insurance: '=',
                insuranceOptions: '=',
                oneWay: '=',
                trip: '=',
                userData: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=InsuranceSelection&version='
                        + attr.templateVersion;
                }
                else {
                    return 'partials/home/directivetemplate?type=InsuranceSelection';
                }
            }
        };
    });
})(TR || (TR = {}));
/*
    Creates a link that scrolls to another element on the same page
    i.e. <internal-link target="#abc">ABC</internal-link>

    Tabs created by `tabset` directive are activated automatically.
*/
var TR;
(function (TR) {
    var InternalLink = /** @class */ (function () {
        function InternalLink(scrollService, $timeout) {
            this.scrollService = scrollService;
            this.$timeout = $timeout;
        }
        InternalLink.prototype.navigate = function () {
            var _this = this;
            var targetEl = $(this.target), tabSet = targetEl.closest('.tab-set'), contentSelector = '.tab-content';
            if (tabSet.length) {
                var tabContent_1 = targetEl.find(contentSelector) ||
                    targetEl.closest(contentSelector);
                // Select tab then scroll
                if (tabContent_1) {
                    this.$timeout(function () {
                        // Shows tab with no anim
                        tabContent_1.triggerHandler('dblclick');
                        _this.scrollToTarget();
                    });
                }
            }
            else {
                this.scrollToTarget();
            }
        };
        InternalLink.prototype.scrollToTarget = function () {
            var $target = $(this.target);
            if ($target.length) {
                /// Here we are taking the tab-bar height, and adding it to the offset of the scroll. This way, scroll
                /// will stop when it comes to the top of the tabs and they will remain visible. If our target is lower
                /// in the tab panel, the height of the tabs will not be taken into consideration.
                /// 'TargetAndTabDiff' is the difference between the top of the tabs, and top of the target, and if this
                /// difference is larger than tab height (plus some additional delta), we do not consider tab height.
                var targetTop_1 = $target.offset().top;
                var $tabSet = $target.closest('.tab-set');
                var tabOffset = _.reduce($tabSet.toArray(), function (memo, el) {
                    var $tabBar = $(el).find('.tab-bar:first');
                    if ($tabBar.length) {
                        var diffDelta = 50;
                        var tabTop = $tabBar.offset().top;
                        var tabHeight = $tabBar.outerHeight();
                        var targetAndTabDiff = Math.abs(targetTop_1 - tabTop);
                        return 'none' !== $tabBar.css('display') && targetAndTabDiff <= tabHeight + diffDelta
                            ? memo + tabHeight : memo;
                    }
                    else {
                        return memo;
                    }
                }, 1);
                /// Get all sticky elements in the page and reduce them to the value of the height of the tallest one,
                /// which comes before our scroll target in the dom tree. We are calculating the offset, which is equal
                /// to the height of tallest sticky element. This is because the sticky elements do not stack, so we
                /// have to stop with the scrolling 'stickyElementHeight' pixels before reaching our target, otherwise
                /// our sticky element would cover the target element.
                var $stickyElements = $('.sticky-wrapper');
                var stickyOffset = _.reduce($stickyElements.toArray(), function (memo, el) {
                    var $el = $(el);
                    var elTopOffset = $el.offset().top;
                    var elHeight = $el.outerHeight();
                    /// We are also taking into consideration if the sticky element has a bottom limit before our
                    /// target. Sticky element bottom limit is a point at which the sticky element is not scrolled with
                    /// the page anymore. Sticky elements with the bottom limits before our target are not taken into
                    /// customer when calculating the offset.
                    var isStickyLimitBeforeTarget = false;
                    var bottomAutoId = $el.data('bottomLimitId');
                    if (bottomAutoId) {
                        var $stickyLimit = $("[data-id=\"" + bottomAutoId + "\"]");
                        if ($stickyLimit.length) {
                            var stickyLimitBottom = $stickyLimit.offset().top + $stickyLimit.outerHeight();
                            isStickyLimitBeforeTarget = stickyLimitBottom < targetTop_1;
                        }
                    }
                    return elTopOffset < targetTop_1 && elHeight > memo && !isStickyLimitBeforeTarget ? elHeight : memo;
                }, 0);
                /// On mobile we need to take into customer also the fixed header.
                var $header = $('.header-main');
                var headerOffset = 0;
                if ('fixed' === $header.css('position')) {
                    headerOffset = $header.outerHeight();
                }
                var navBar = $('.header-wrapper');
                var navBarOffset = navBar ? navBar.outerHeight() : 0;
                this.scrollService.scrollTo(this.target, {
                    animate: true,
                    offset: (parseInt(this.offset, 10) || 0) + stickyOffset + tabOffset + headerOffset + navBarOffset
                });
            }
        };
        return InternalLink;
    }());
    angular
        .module('TR')
        .directive('internalLink', function () {
        return {
            restrict: 'E',
            scope: {},
            transclude: true,
            replace: true,
            controller: InternalLink,
            controllerAs: 'il',
            bindToController: {
                target: '@',
                offset: '@'
            },
            template: "<a ng-click=\"il.navigate()\" ng-transclude></a>"
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    /* global L */
    var TR = angular.module('TR');
    TR.directive('leafletMap', function ($window, $timeout, searchUnitService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                key: '@',
                model: '='
            },
            template: '<div><div>',
            link: function (scope, el) {
                var headerHeight = 95;
                var throttle = 100;
                var pos = searchUnitService.getSearchArea();
                var map;
                var initialised = false;
                var centre;
                var promise = null;
                scope.$on('mapTabSelected', function () {
                    if (!$window.L) {
                        $('<link rel=\'stylesheet\' href=\'build/vendor/leaflet/leaflet.css\' />')
                            .appendTo($('head'));
                        $.getScript('build/vendor/leaflet/leaflet.js', function () {
                            $timeout($window.mapLoadedCallback, 50);
                        });
                    }
                    else {
                        $timeout($window.mapLoadedCallback, 50);
                    }
                });
                scope.$on('$destroy', function () {
                    delete $window.mapLoadedCallback;
                    $($window).off('resize', windowResize);
                });
                function windowResize() {
                    if (promise !== null) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(resizeMap, throttle);
                }
                $window.mapLoadedCallback = function () {
                    if (!initialised && !map) {
                        resizeMap();
                        centre = [scope.model.Latitude, scope.model.Longitude];
                        map = L.map(el[0], {
                            center: centre,
                            zoom: scope.model.ZoomLevel || 15,
                            scrollWheelZoom: false
                        });
                        L.control.scale({ position: 'bottomright' }).addTo(map);
                        L.tileLayer("https://ssl_tiles.cloudmade.com/" + scope.key + "/997/256/{z}/{x}/{y}.png", {
                            attribution: 'Map data &copy; OpenStreetMap contributors, Imagery &copy; CloudMade',
                            name: 'Map'
                        }).addTo(map);
                        var hotelIcon = L.icon({
                            iconUrl: 'build/img/Maps/hotel-pin.png',
                            shadowUrl: 'build/img/Maps/hotel-pin-shadow.png',
                            iconSize: [46, 57],
                            iconAnchor: [23, 56],
                            popupAnchor: [0, -56]
                        });
                        var bounds = [centre];
                        L.marker(centre, { icon: hotelIcon }).addTo(map)
                            .bindPopup(scope.model.Title)
                            .openPopup();
                        if (pos) {
                            var me = [pos.Latitude, pos.Longitude];
                            L.marker(me, { icon: L.icon({
                                    iconUrl: 'build/img/Maps/marker-icon.png',
                                    shadowUrl: 'build/img/Maps/marker-shadow.png',
                                    iconSize: [25, 41],
                                    iconAnchor: [12, 41],
                                    popupAnchor: [0, -41]
                                }) }).addTo(map);
                            bounds.push(me);
                        }
                        map.fitBounds(bounds);
                        $($window).on('resize', windowResize);
                        initialised = true;
                    }
                    else {
                        resizeMap();
                    }
                };
                function resizeMap() {
                    el.width('100%');
                    el.height($($window).height() - headerHeight);
                    if (map) {
                        map.invalidateSize();
                    }
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var openLightboxCount = 0;
    angular.module('TR')
        .directive('lightbox', lightbox);
    function lightbox($timeout, broker) {
        return {
            restrict: 'E',
            replace: true,
            transclude: {
                // Modal title may be provided either by `headerText` attribute
                // or named transclusion i.e. `<modal-title> Details </modal-title>`
                title: '?modalTitle'
            },
            scope: {
                close: '&',
                include: '=',
                show: '=',
                busy: '=?',
                busyMsg: '@',
                innerClass: '@',
                headerText: '=',
                lightboxClass: '@',
                hideHeaderBar: '=',
                appendToBody: '@',
                preventClose: '=',
                renderEachLaunch: '=',
                additionalContent: '=',
                modalOverlayClass: '@',
                mandatoryTransfers: '='
            },
            template: '<div class="modal-overlay" ng-class="modalOverlayClass">' +
                '<div class="lightbox" ng-class="lightboxClass">' +
                '   <div class="lightbox-inner">' +
                '       <div class="stage" ng-class="innerClass">' +
                '           <div class="modal-header" ng-if="!hideHeaderBar">' +
                '               <span class="modal-title" ng-transclude="title"></span> {{::headerText}}' +
                '               <a ng-hide="preventClose" href="#" class="close" ng-click="closeClicked($event)"></a>' +
                '           </div>' +
                '           <div ng-show="busy" class="loader"><preloader class="circular subtle large"></preloader></div>' +
                '           <div class="transclude modal-content" ng-transclude />' +
                '           <div class="modal-content" onload="params = $parent && $parent.rc ? $parent.rc.modalParams : null" ng-include="include"></div>' +
                '           <div class="modal-content-additional" ng-if="additionalContent" ng-bind-html="additionalContent"></div>' +
                '       </div>' +
                '   </div>' +
                '</div>' +
                '</div>',
            link: function (scope, el, attr, ctrl, transclude) {
                var overlay = el;
                var domOverlay = overlay.get(0);
                var $body = $('body, html');
                var lightbox = el.find('.lightbox');
                var stage = el.find('.stage');
                var open = false;
                var transcludeElement = el.find('.transclude.modal-content');
                var previousScrollY = 0;
                scope.$watch('show', function (v) {
                    /// When we open the lightbox for the first time after the page load, it will have to include the partial
                    /// template content, which means loading it from the url. During that time "busy" will be set to true.
                    /// Once the template is loaded it will change the "busy" value to false, and if we are showing the lightbox,
                    /// a lightbox ready event will be published.
                    if (!scope.busy && v) {
                        broker.publish('modal:ready');
                    }
                    else if (!v) {
                        broker.publish('modal:close');
                    }
                    if (v == null) {
                        return;
                    }
                    if (v) {
                        open = true;
                        openLightboxCount++;
                        if (scope.renderEachLaunch) {
                            transclude(function (clone) {
                                transcludeElement.html(clone);
                            });
                        }
                        //disable browser scroll bar
                        if (!previousScrollY) {
                            previousScrollY = window.scrollY;
                        }
                        if (scope.mandatoryTransfers !== 'enabled') {
                            $body.css({
                                marginTop: -previousScrollY,
                                overflow: 'hidden',
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            });
                        }
                        if (scope.appendToBody) {
                            domOverlay._parent = overlay.parent();
                            $body.append(overlay);
                        }
                        overlay.fadeIn(300, 'swing', function () {
                            broker.publish('lightboxOpened');
                            $(window).resize(); //not particularly thrilled with this
                        });
                        // close if background is clicked
                        if (!scope.preventClose) {
                            lightbox.on('click.lightbox', function () {
                                scope.$apply(scope.close);
                            });
                            // support keyboard commands
                            $('html').on('keyup.lightbox', function (e) {
                                // escape to close
                                if (e.which === 27 && open) {
                                    scope.$apply(scope.close);
                                }
                            });
                        }
                    }
                    else {
                        closeLightbox();
                    }
                });
                function closeLightbox() {
                    if (open) {
                        open = false;
                        openLightboxCount--;
                    }
                    overlay.fadeOut(200, 'swing', function () {
                        if (scope.appendToBody) {
                            $(domOverlay._parent).append(overlay);
                        }
                    });
                    // re-enable browser scroll bar
                    if (!openLightboxCount) {
                        $body.css({
                            marginTop: '',
                            overflow: '',
                            position: '',
                            top: '',
                            left: '',
                            right: '',
                            bottom: ''
                        });
                        window.scrollTo(0, previousScrollY);
                    }
                }
                scope.closeClicked = function (e) {
                    e.preventDefault();
                    broker.publish('lightboxCloseClicked');
                    scope.close();
                };
                stage.on('click.lightbox', function (e) {
                    if (!$(e.target).hasClass('lightbox-propagate')) {
                        e.stopPropagation();
                    }
                });
                scope.$on('$destroy', function () {
                    closeLightbox();
                    // unbind jquery event listeners
                    $('html').off('keyup.lightbox');
                    lightbox.off('click.lightbox');
                    stage.off('click.lightbox');
                });
                if (scope.include) {
                    scope.$on('$includeContentRequested', function () {
                        // we may be re-using a lightbox so ensure title is removed
                        el.find('.modal-title').empty();
                        scope.busy = true;
                    });
                }
                scope.$on('$includeContentLoaded', function () {
                    scope.busy = false;
                    /// Loading of the partial for the modal is finished. Publish an event indicating that the lightbox
                    /// content is loaded and that it's ready for any kind of operation.
                    $timeout(function () {
                        if (scope.show) {
                            // Transclusion from within include file
                            el.find('modal-title').detach().last().appendTo(el.find('.modal-title'));
                            broker.publish('modal:ready');
                        }
                    }, 0);
                });
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('listButton', function ($location, resourceService, actionTemplateService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                path: '@',
                click: '&',
                template: '='
            },
            template: "<li ng-click=\"onclick($event)\">\n                       <span ng-transclude></span>\n                       <div class=\"template-action\" ng-show=\"open\" ng-include=\"templateUrl\"></div>\n                   </li>",
            link: function (scope, el, attr) {
                var click = attr.click != null;
                var path = attr.path != null;
                scope.open = false;
                scope.getResourceValue = function (code) {
                    return resourceService.get(code);
                };
                scope.onclick = function (e) {
                    if (click) {
                        el.addClass('clicked');
                        scope.click({ e: e });
                    }
                    else if (path && scope.path) {
                        $location.path(scope.path);
                    }
                    else if (scope.template && !scope.open) {
                        scope.templateData = scope.template.Data;
                        scope.utils = actionTemplateService.getUtils(scope.template.Name);
                        scope.templateUrl = "partials/manage/ActionTemplate?type=" + scope.template.Name;
                        scope.open = true;
                    }
                    else if (scope.open) {
                        scope.open = false;
                    }
                };
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('loading', function ($interval, $interpolate) {
        return {
            restrict: 'A',
            scope: {
                loading: '=',
                hide: '@'
            },
            link: function (scope, el, attr) {
                var val = el.text();
                var hide = attr.hide === 'true';
                var p = null;
                var i = 0;
                var dots = '';
                function reset() {
                    $interval.cancel(p);
                    el.text($interpolate(val)(scope.$parent));
                    if (hide) {
                        el.hide();
                    }
                    i = 0;
                }
                scope.$watch('loading', function (v) {
                    if (v) {
                        if (hide) {
                            el.show();
                        }
                        $interval.cancel(p);
                        p = $interval(function () {
                            dots = (i++ % 5 === 0) ? '' : dots + ".";
                            el.text($interpolate(val + dots)(scope.$parent));
                        }, 200);
                    }
                    else {
                        reset();
                    }
                });
                scope.$on('$destroy', function () {
                    reset();
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('loadingScreenNumbers', function (arrayUtil) {
        return {
            restrict: 'E',
            template: '<span></span>',
            scope: { chars: '=' },
            link: function (scope, el) {
                if (scope.chars) {
                    el.html(arrayUtil.map(scope.chars, function (c) {
                        return "<span class=\"number-image c-" + c + "\"></span>";
                    }).join(''));
                }
            }
        };
    });
})();
var Core;
(function (Core) {
    var MailingListSignUp = /** @class */ (function () {
        function MailingListSignUp(authService, $scope, $rootScope, broker, abTest, analytics) {
            var _this = this;
            this.authService = authService;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.broker = broker;
            this.abTest = abTest;
            this.analytics = analytics;
            this.emailPattern = /^\S+@\S+\.\S+[^\.]$/;
            this.success = false;
            this.error = false;
            this.showOptOut = false;
            this.$rootScope.$on('$routeChangeStart', function () {
                _this.success = false;
                _this.error = false;
                _this.resetForm();
            });
            this.$scope.$on('$destroy', function () {
                _this.broker.unsubscribe('mailingListSignUp');
            });
        }
        MailingListSignUp.prototype.openOptOut = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.showOptOut = true;
            this.analytics.track('mixpanel', 'GDPRUnsubscribe');
        };
        MailingListSignUp.prototype.closeOptOut = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.showOptOut = false;
        };
        MailingListSignUp.prototype.submit = function () {
            var _this = this;
            var data = {
                Email: this.email,
                ContextTag: 'Source:Website-Newsletter',
                Source: 'TravelRepublic',
                SignupReason: 'Newsletter Signup Footer'
            };
            this.authService
                .registerForNewsletter(data)
                .success(function () {
                _this.success = true;
                _this.error = false;
                _this.resetForm();
            })
                .error(function () {
                _this.error = true;
            });
        };
        MailingListSignUp.prototype.resetForm = function () {
            if (this.$scope.mailingListForm) {
                this.$scope.mailingListForm.$setPristine();
                this.$scope.mailingListForm.$setUntouched();
            }
            this.email = '';
        };
        return MailingListSignUp;
    }());
    angular
        .module('core')
        .directive('mailingListSignUp', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            controller: MailingListSignUp,
            controllerAs: 'msu',
            templateUrl: function (el, attr) {
                var templateName = attr.templateVersion ? attr.templateVersion : 'mailinglistsignup';
                return "partials/home/directivetemplate?type=" + templateName;
            },
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var MailingListUnsubscribe = /** @class */ (function () {
        function MailingListUnsubscribe(authService, $scope, analytics, modalService) {
            this.authService = authService;
            this.$scope = $scope;
            this.analytics = analytics;
            this.modalService = modalService;
            this.emailPattern = /^\S+@\S+\.\S+[^\.]$/;
            this.success = false;
            this.error = false;
        }
        MailingListUnsubscribe.prototype.submit = function () {
            var _this = this;
            var data = {
                Email: this.email,
                Source: 'TravelRepublic',
                SourceDetail: 'Newsletter Unsubscribe Footer'
            };
            this.analytics.track('mixpanel', 'GDPRSubmit');
            this.authService
                .unsubscribeFromNewsletter(data)
                .success(function () {
                _this.success = true;
                _this.error = false;
                _this.resetForm();
            })
                .error(function () {
                _this.error = true;
            });
        };
        MailingListUnsubscribe.prototype.continueBrowsing = function (event) {
            this.success = false;
            this.modalService.close();
            this.closeFn({ event: event });
        };
        MailingListUnsubscribe.prototype.resetForm = function () {
            this.$scope.unsubscribeListForm.$setPristine();
            this.$scope.unsubscribeListForm.$setUntouched();
            this.email = '';
        };
        return MailingListUnsubscribe;
    }());
    angular
        .module('core')
        .directive('mailingListUnsubscribe', function () {
        return {
            scope: {},
            bindToController: {
                closeFn: '&'
            },
            restrict: 'E',
            replace: true,
            controller: MailingListUnsubscribe,
            controllerAs: 'mus',
            templateUrl: 'partials/home/directivetemplate?type=mailinglistunsubscribe'
        };
    });
})(Core || (Core = {}));
var TR;
(function (TR) {
    var MonthYear = /** @class */ (function () {
        function MonthYear() {
            this.clear();
        }
        MonthYear.prototype.clear = function () {
            this.month = 0;
            this.year = 0;
        };
        MonthYear.prototype.isNotEmpty = function () {
            return this.month && this.year && this.month !== 0 && this.year !== 0;
        };
        return MonthYear;
    }());
    var MonthYearPicker = /** @class */ (function () {
        function MonthYearPicker($scope) {
            var _this = this;
            this.$scope = $scope;
            this.my = new MonthYear();
            this.init = function (c) {
                _this.$scope.$watch('myp.my', function (val) {
                    if (val && val.isNotEmpty()) {
                        c.$setViewValue(angular.copy(val));
                    }
                    else {
                        c.$setViewValue(new MonthYear());
                    }
                }, true);
            };
        }
        return MonthYearPicker;
    }());
    angular
        .module('TR')
        .directive('monthYearPicker', function () {
        return {
            scope: {},
            replace: true,
            require: 'ngModel',
            bindToController: {
                months: '=',
                years: '=',
                bookingTrackerPrefix: '@?',
                enableBookingTracking: '@?'
            },
            controller: MonthYearPicker,
            controllerAs: 'myp',
            templateUrl: function (ele, att) { return "partials/home/MonthYearPicker?form=" + att.enableBookingTracking; },
            link: function (scope, el, attr, controller) {
                scope.myp.init(controller);
            }
        };
    });
})(TR || (TR = {}));
/// <reference path="../../../mobile/core/services/broker.service.ts"/>
/**
 * Created by bdickson on 22/01/2016.
 */
var core;
(function (core) {
    var NavigationDrawer = /** @class */ (function () {
        function NavigationDrawer() {
        }
        NavigationDrawer.prototype.init = function (scope, broker) {
            var _this = this;
            this.open = false;
            // subscribe to toggle request from external source (e.g. a button in the site header)
            broker.subscribe('NavigationDrawer', 'toggleNavigationDrawer', function () {
                _this.open = !_this.open;
            });
            scope.$on('$destroy', function () {
                broker.unsubscribe('NavigationDrawer');
            });
        };
        return NavigationDrawer;
    }());
    angular
        .module('core')
        .directive('navigationDrawer', function (broker) {
        var config = {
            controller: NavigationDrawer,
            controllerAs: 'nd',
            bindToController: true,
            transclude: TRPCONFIG.Domain.ResponsiveNavDrawer
        };
        var templateUrl = TRPCONFIG.Domain.ResponsiveNavDrawer ? '<div><div ng-transclude></div></div>'
            : 'partials/home/directivetemplate?type=NavigationDrawer';
        var directive = TRPCONFIG.Domain.ResponsiveNavDrawer
            ? angular.merge(config, { template: templateUrl })
            : angular.merge(config, { templateUrl: templateUrl });
        directive.link = function (scope, el, attr, controller) {
            controller.init(scope, broker);
        };
        return directive;
    });
})(core || (core = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('navigationDrawerToggle', function (broker) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                scope.toggle = function () {
                    broker.publish('toggleNavigationDrawer');
                };
                element.on('click.navigationDrawerToggle', function (e) {
                    e.preventDefault();
                    scope.$apply(scope.toggle());
                });
                scope.$on('$destroy', function () {
                    // unbind jquery event listeners
                    element.off('click.navigationDrawerToggle');
                });
            }
        };
    });
})();
var TR;
(function (TR) {
    var NewHomeRecommenders = /** @class */ (function () {
        function NewHomeRecommenders($location, $scope, $rootScope, broker, savedSearchService, basketService, occupancyService, destinationService, searchTypesService, analytics, resourceService, recommender, recommenderUiHelper) {
            this.$location = $location;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.broker = broker;
            this.savedSearchService = savedSearchService;
            this.basketService = basketService;
            this.occupancyService = occupancyService;
            this.destinationService = destinationService;
            this.searchTypesService = searchTypesService;
            this.analytics = analytics;
            this.resourceService = resourceService;
            this.recommender = recommender;
            this.recommenderUiHelper = recommenderUiHelper;
            this.recommendationLength = 3;
            this.recommendations = new Array(this.recommendationLength).fill({ ImageUrl: '' });
            this.initSlider();
            this.initSubscriptions();
        }
        NewHomeRecommenders.prototype.$onDestroy = function () {
            this.broker.unsubscribe('newHomeRecommenders', 'savedSearchRemoved');
        };
        NewHomeRecommenders.prototype.initSlider = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var _a, Hotels, Holidays, allSearches, filteredSearches, Destination, filteredSearchesExist, search, Rooms, _b, Duration, Dates, options, _c, destinations, trackClick, trackView;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _a = this.searchTypesService.searchType, Hotels = _a.Hotels, Holidays = _a.Holidays;
                            return [4 /*yield*/, this.savedSearchService.getSavedSearches()];
                        case 1:
                            allSearches = _d.sent();
                            filteredSearches = allSearches.filter(function (_a) {
                                var SearchType = _a.SearchType;
                                return SearchType === Hotels || SearchType === Holidays;
                            });
                            Destination = null;
                            filteredSearchesExist = filteredSearches.length > 0;
                            if (filteredSearchesExist) {
                                search = filteredSearches[0];
                                Destination = search.Destination;
                                Rooms = search.Rooms;
                                _b = search.Duration.split(', '), Duration = _b[0], Dates = _b[1];
                                this.recommendations[0] = __assign({}, search, { Title: Destination.Title, Duration: Duration,
                                    Dates: Dates, Occupancy: this.occupancyService.getOccupancyString(Rooms), ImageUrl: this.destinationService.destinationThumb(Destination), isPreviousSearch: true, ngClick: this.ngClickSearch(search) });
                            }
                            options = { imgWidth: this.$scope.imgWidth };
                            return [4 /*yield*/, this.recommender.getDestinationsForLanding('HomePageNewRecommender', options, Destination)];
                        case 2:
                            _c = _d.sent(), destinations = _c.destinations, trackClick = _c.trackClick, trackView = _c.trackView;
                            this.recommendations = this.recommendations.map(function (recommendation, index) {
                                if (filteredSearchesExist && (index === 0)) {
                                    return __assign({}, recommendation, { ngClick: _this.ngClickSearch(recommendation) });
                                }
                                else {
                                    var filteredSearchIndex = filteredSearchesExist ? index - 1 : index;
                                    var similarDestination = destinations[filteredSearchIndex];
                                    return __assign({}, similarDestination, { isRecommended: true, ngClick: _this.ngClickDestination(similarDestination, trackClick, trackView) });
                                }
                            }).slice(0, this.recommendationLength);
                            this.$scope.$apply();
                            return [2 /*return*/];
                    }
                });
            });
        };
        NewHomeRecommenders.prototype.initRecommender = function () {
            this.recommendations = new Array(this.recommendationLength).fill({ ImageUrl: '' });
            this.initSlider();
        };
        NewHomeRecommenders.prototype.initSubscriptions = function () {
            var _this = this;
            this.broker.subscribe('newHomeRecommenders', 'savedSearchRemoved', function () { return _this.initRecommender(); });
            this.$rootScope.$on('auth:signout', function () { return _this.initRecommender(); });
            this.$rootScope.$on('auth:signin', function () { return _this.initRecommender(); });
        };
        NewHomeRecommenders.prototype.ngClickSearch = function (search) {
            var _this = this;
            var SearchType = search.SearchType;
            var _a = this.searchTypesService.searchType, Hotels = _a.Hotels, Holidays = _a.Holidays;
            var _b = (_c = {},
                _c[Hotels] = {
                    title: this.resourceService.get('SEARCHINGHOTELS'),
                    loadingScreenStyle: 'hotels-newHomeRecommendersHotel-select'
                },
                _c[Holidays] = {
                    title: this.resourceService.get('SEARCHINGFLIGHTSANDHOTELS'),
                    loadingScreenStyle: 'hotels-newHomeRecommendersHolidays-select'
                },
                _c)[SearchType], title = _b.title, loadingScreenStyle = _b.loadingScreenStyle;
            var subtitle = this.resourceService.get('THISMAYTAKE');
            return function (ev) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.$scope.$emit('block', {
                                title: title,
                                subtitle: subtitle,
                                loadingScreenStyle: loadingScreenStyle
                            });
                            this.analytics.trackEvent({ label: 'restore saved search' });
                            return [4 /*yield*/, this.savedSearchService.restoreSearch(search)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.basketService.startWorkflow(this.basketService.workflowType[SearchType])];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
            var _c;
        };
        NewHomeRecommenders.prototype.ngClickDestination = function (destination, trackClick, trackView) {
            var _this = this;
            return function (ev) { return __awaiter(_this, void 0, void 0, function () {
                var PagePath;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ev.preventDefault();
                            ev.stopPropagation();
                            return [4 /*yield*/, this.destinationService.getDetails(destination)];
                        case 1:
                            PagePath = (_a.sent()).PagePath;
                            trackClick(destination, this.recommenderUiHelper.getPageSize());
                            this.$location.path(PagePath);
                            return [2 /*return*/];
                    }
                });
            }); };
        };
        return NewHomeRecommenders;
    }());
    angular.module('TR')
        .component('newHomeRecommenders', {
        bindings: {
            imgWidth: '@'
        },
        controller: NewHomeRecommenders,
        controllerAs: 'nhr',
        templateUrl: 'partials/home/directivetemplate?type=NewHomeRecommenders'
    });
})(TR || (TR = {}));
var Core;
(function (Core) {
    var NewsletterModal = /** @class */ (function () {
        function NewsletterModal($scope, $rootScope, modalService, authService, $timeout, resourceService) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.modalService = modalService;
            this.authService = authService;
            this.$timeout = $timeout;
            this.resourceService = resourceService;
            this.name = '';
            this.userData = {
                Email: '',
                FirstName: '',
                LastName: '',
                Source: this.resourceService.get('NEWSLETTER_MODAL_SOURCE'),
                SourceDetail: this.resourceService.get('NEWSLETTER_MODAL_SOURCE_DETAILS'),
                SignUpReason: this.resourceService.get('NEWSLETTER_MODAL_SIGNUP_REASON'),
            };
            this.success = false;
            this.error = false;
            this.isNewsletter = false;
            this.iconUrl = this.resourceService.get('NEWSLETTER_MODAL_ICON_URL');
            this.altLogo = this.resourceService.get('NEWSLETTER_MODAL_ALT_LOGO');
            this.trustpilotLogo = "<img class=\"trust-pilot-logo\" src=\"" + this.iconUrl + "\"/>";
            this.altBottomLogo = this.altLogo !== 'NEWSLETTER_MODAL_ALT_LOGO' ? this.altLogo : '';
            this.resourcesObj = {
                title: this.resourceService.get('NEWSLETTER_MODAL_TITLE'),
                subTitle: this.resourceService.get('NEWSLETTER_MODAL_SUBTITLE'),
                policyText: this.resourceService.get('NEWSLETTER_MODAL_POLICYTEXT'),
            };
            this.resourcesSuccessObj = {
                title: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_TITLE'),
                subTitle: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_SUBTITLE'),
                subTitle1: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_SUBTITLE1'),
                policyText: this.resourceService.get('NEWSLETTER_MODAL_SUCCESS_POLICYTEXT'),
            };
        }
        NewsletterModal.prototype.submit = function () {
            var _this = this;
            this.formatName();
            this.authService
                .registerForNewsletter(this.userData)
                .success(function () {
                _this.userSubscribed();
            })
                .error(function () {
                _this.error = true;
            });
        };
        NewsletterModal.prototype.formatName = function () {
            var fullName = this.name.split(' ');
            this.userData.FirstName = fullName[0];
            this.userData.LastName = fullName[1] || '';
        };
        ;
        NewsletterModal.prototype.userSubscribed = function () {
            this.success = true;
            this.error = false;
            this.resourcesObj = this.resourcesSuccessObj;
            localStorage.setItem('isAllreadySubscribed', 'true');
        };
        NewsletterModal.prototype.openNewsletter = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.isNewsletter = true;
        };
        NewsletterModal.prototype.closeNewsletter = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            angular.element(document).unbind('scroll');
            this.isNewsletter = false;
            localStorage.setItem('isAllreadySubscribed', 'true');
        };
        return NewsletterModal;
    }());
    angular
        .module('core')
        .directive('newsletterModal', function ($timeout) {
        return {
            scope: {},
            bindToController: {
                openOn: '@'
            },
            restrict: 'E',
            replace: true,
            controller: NewsletterModal,
            controllerAs: 'nm',
            templateUrl: 'partials/home/directivetemplate?type=NewsletterModal',
            link: function (scope, element, attrs) {
                var superHero = $('.sc-c-superhero');
                var superHeroHeight = superHero ? superHero[0]['clientHeight'] : null;
                var doc = $(document);
                if (scope.nm.openOn === 'scroll' && localStorage.getItem('isAllreadySubscribed') !== 'true'
                    && superHeroHeight) {
                    angular.element(document).bind('scroll', function () {
                        if (doc.scrollTop() > superHeroHeight) {
                            scope.nm.openNewsletter();
                        }
                    });
                }
                else if (scope.nm.openOn === 'idle' && localStorage.getItem('isAllreadySubscribed') !== 'true') {
                    var idleTime_1 = 0;
                    var idleInterval_1;
                    idleInterval_1 = setInterval(function () {
                        idleTime_1 = idleTime_1 + 1;
                        if (idleTime_1 > TRPCONFIG.Domain.NewSubscribeModalABtestInactivityTimeout) {
                            scope.nm.isNewsletter = true;
                            scope.$apply();
                            clearInterval(idleInterval_1);
                        }
                    }, 1000);
                    doc.mousemove(function (e) {
                        idleTime_1 = 0;
                    });
                    doc.keypress(function (e) {
                        idleTime_1 = 0;
                    });
                }
            }
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    /*
     * Directive for newsletter signup
     */
    angular
        .module('TR')
        .directive('newsletterSignUp', function (authService, $timeout, $location, analytics, adFormService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=newslettersignup',
            controllerAs: 'nsu',
            bindToController: {
                allowUnsubscribe: '='
            },
            controller: function ($scope) {
                var _this = this;
                this.email = null;
                this.success = false;
                this.error = false;
                this.change = function () {
                    _this.success = false;
                };
                this.openOptOut = function (e) {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    _this.showOptOut = true;
                    analytics.track('mixpanel', 'GDPRUnsubscribe');
                };
                this.closeOptOut = function (e) {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    _this.showOptOut = false;
                };
                this.submit = function (email) {
                    var data = {
                        Email: email,
                        ContextTag: 'Source:Website-Newsletter',
                        Source: 'TravelRepublic',
                        SignupReason: 'Newsletter Signup Header'
                    };
                    authService
                        .registerForNewsletter(data)
                        .success(function () {
                        $scope.$emit('newsletterSignUp');
                        _this.success = true;
                        _this.error = false;
                        if (TRPCONFIG.Domain.TrackNewsletterSignup) {
                            var page = $location.path();
                            analytics.trackEvent({
                                category: 'newsletterSignup',
                                action: 'signedUp',
                                label: page,
                                dimension9: 'newsletterSignup'
                            });
                        }
                        if (adFormService.isNewsletterSignUpEventEnabled()) {
                            analytics.trackAdformClick({
                                eventName: 'Newslettersignup',
                                trackingId: adFormService.getTrackingId()
                            });
                        }
                        $timeout(function () {
                            _this.success = false;
                        }, 2000);
                    })
                        .error(function () {
                        _this.success = false;
                        _this.error = true;
                    });
                };
            }
        };
    });
})();
var Core;
(function (Core) {
    var NumberPicker = /** @class */ (function () {
        function NumberPicker() {
            this.restrict = 'E';
            this.replace = true;
            this.require = 'ngModel';
            this.scope = {
                model: '=ngModel',
                max: '=',
                min: '=',
                increment: '=',
                disabled: '@',
                onChange: '&'
            };
            this.template = "<div class=\"number-picker\">\n                        <a  href=\"#\" \n                            ng-click=\"click.decrease()\" \n                            ng-disabled=\"model <= min || disabled === 'true'\" \n                            class=\"number-picker-part number-picker-minus\">\n                        </a>\n                        <span \n                            class=\"number-picker-part number-picker-label\">\n                            {{model || 0}}\n                        </span>\n                        <a  href=\"#\" \n                            ng-click=\"click.increase()\" \n                            ng-disabled=\"model >= max || disabled === 'true'\" \n                            class=\"number-picker-part number-picker-plus\">\n                        </a>\n                    </div>";
            this.link = function (scope, element, attrs, ngModel) {
                var radix = 10;
                var increment = parseInt(scope.increment || 1, radix);
                var max = parseInt(scope.max, radix);
                var min = parseInt(scope.min, radix);
                if (scope.disabled !== 'true') {
                    scope.$watch('max', function (val) {
                        max = Number(val);
                    });
                    scope.$watch('min', function (val) {
                        min = Number(val);
                    });
                }
                if (scope.model === undefined) {
                    ngModel.$setViewValue(0);
                }
                if (scope.disabled === 'true') {
                    max = min = scope.model;
                }
                if (scope.onChange) {
                    scope.$watch('model', function () {
                        scope.onChange();
                    });
                }
                scope.click = {
                    increase: function () {
                        if (scope.disabled === 'true') {
                            return;
                        }
                        if (scope.model < max) {
                            ngModel.$setViewValue(Number(scope.model) + increment);
                        }
                    },
                    decrease: function () {
                        if (scope.disabled === 'true') {
                            return;
                        }
                        if (scope.model > min) {
                            ngModel.$setViewValue(Number(scope.model) - increment);
                        }
                    }
                };
            };
        }
        NumberPicker.factory = function () {
            var directive = function () { return new NumberPicker(); };
            directive.$inject = [];
            return directive;
        };
        return NumberPicker;
    }());
    var TR = angular.module('TR');
    TR.directive('numberPicker', NumberPicker.factory());
})(Core || (Core = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('packagePrice', function (resourceService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                basePrice: '=',
                flightPrice: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=PackagePrice',
            link: function (scope) {
                function calcPriceInformation(flightPrice) {
                    var priceInformation = {};
                    priceInformation.comparison = Math.round(scope.basePrice - flightPrice);
                    priceInformation.absolutePrice = Math.abs(priceInformation.comparison);
                    priceInformation.divPosition = { top: priceInformation.absolutePrice === 0 ? '3px' : '-6px' };
                    scope.sign = priceInformation.comparison > 0 ? '&minus;' : '+';
                    switch (true) {
                        case scope.basePrice === 0:
                            //There is no base price to compare to, so comparison text would not make sense.
                            priceInformation.text = '';
                            break;
                        case priceInformation.comparison < 0:
                            priceInformation.text = resourceService.get('ADDITIONAL');
                            break;
                        case priceInformation.comparison === 0:
                            priceInformation.text = resourceService.get('SAMEPRICE');
                            break;
                        case priceInformation.comparison > 0:
                            priceInformation.text = resourceService.get('SAVE');
                    }
                    scope.pi = priceInformation;
                    scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax && scope.pi.absolutePrice !== 0 || false;
                }
                scope.$watch('flightPrice', calcPriceInformation);
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('paginator', function (urlUtils, $location, scrollService, $q, analyticsTracker) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                total: '=',
                pageSize: '=',
                currentPage: '=',
                change: '&',
                scrollTarget: '@',
                scrollContainer: '@',
                maxButtons: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=paginator',
            link: function (scope) {
                var path = urlUtils.stripLeadingSlash($location.path());
                scope.change = scope.change();
                if (scope.maxButtons === undefined) {
                    scope.maxButtons = 7;
                }
                scope.goToPage = function (page, e) {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    if (scope.currentPage === page) {
                        return;
                    }
                    scope.currentPage = page;
                    analyticsTracker.resetStatus(false);
                    var res = $q.when(scope.change(scope.currentPage, e));
                    if (scope.scrollTarget) {
                        res.then(function () { return scrollService.scrollTo(scope.scrollTarget, { duration: 500, animate: true, container: scope.scrollContainer }); });
                    }
                };
                function preparePages() {
                    scope.totalPages = Math.floor((scope.total / scope.pageSize) + 0.999);
                    var pageButtons = scope.maxButtons > scope.totalPages ? scope.totalPages : scope.maxButtons;
                    var currentPageIndex = scope.currentPage - 1;
                    function addPage(pageNo) {
                        return {
                            page: pageNo,
                            isSpacer: false,
                            url: pageNo > 1 ? path + "?pi=" + (pageNo - 1) + "&pt=" + scope.totalPages : "" + path,
                            isCurrent: pageNo === scope.currentPage
                        };
                    }
                    // prepare array of pages
                    var pages = [];
                    // add first page
                    pages.push(addPage(1));
                    // add additional pages
                    var extraButtons = pageButtons - 2;
                    var start = scope.currentPage - Math.floor(extraButtons / 2);
                    start = Math.max(start, 2);
                    var stop = start + extraButtons - 1;
                    stop = Math.min(stop, scope.totalPages - 1);
                    start = Math.min(start, stop + 1 - extraButtons);
                    for (var page = start; page <= stop; page++) {
                        pages.push(addPage(page));
                    }
                    // add last page
                    if (scope.totalPages > 1) {
                        pages.push(addPage(scope.totalPages));
                    }
                    // if required, convert second and penultimate page into spacers
                    if (pages.length > 2) {
                        if (pages[1].page !== 2) {
                            pages[1].isSpacer = true;
                        }
                        if (pages[pages.length - 2].page !== (scope.totalPages - 1)) {
                            pages[pages.length - 2].isSpacer = true;
                        }
                    }
                    scope.prevUrl = currentPageIndex > 1
                        ? path + "?pi=" + (currentPageIndex - 1) + "&pt=" + scope.totalPages : "" + path;
                    scope.nextUrl = currentPageIndex < scope.totalPages
                        ? path + "?pi=" + (currentPageIndex + 1) + "&pt=" + scope.totalPages : "" + path;
                    scope.pages = pages;
                }
                function updateOnWatch(v) {
                    if (v != null && scope.total > 0) {
                        preparePages();
                    }
                }
                // watch for external changes to the total
                scope.$watch('total', updateOnWatch);
                scope.$watch('currentPage', updateOnWatch);
                preparePages();
            }
        };
    });
})();
var TR;
(function (TR) {
    angular
        .module('TR')
        .directive('parkingSelection', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                captureParking: '=',
                model: '=',
                parking: '=',
                rootForm: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=ParkingSelection'
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var PassengerSelection = /** @class */ (function () {
        function PassengerSelection(resourceService, bookingService, broker, basketService, insuranceService, attractionService, dateUtil, $scope, $location) {
            var _this = this;
            this.resourceService = resourceService;
            this.bookingService = bookingService;
            this.broker = broker;
            this.basketService = basketService;
            this.insuranceService = insuranceService;
            this.attractionService = attractionService;
            this.dateUtil = dateUtil;
            this.$scope = $scope;
            this.$location = $location;
            this.insuranceConfirmation = false;
            this.isCrossSell = false;
            this.enforceAgeValidation = TRPCONFIG.Domain.EnforceInsuranceAgeValidation;
            this.guestMinAge = TRPCONFIG.Domain.GuestMinAge;
            this.adultTitles = resourceService.getDeferred('ADULTTITLES');
            this.childTitles = resourceService.getDeferred('CHILDTITLES');
            this.detailsMatch = bookingService.detailsMatch;
            var ignoreBooking = $scope.$watch('ps.bookingLoaded', function (b) {
                if (b) {
                    _this.bookingInit();
                    ignoreBooking();
                }
            });
            this.$scope.$on('cpgStatusAPIError', function (_, errorType) {
                if (errorType) {
                    this.hideForm = true;
                }
            });
        }
        PassengerSelection.prototype.passengerInsuranceBand = function (bandId, costOnly) {
            return this.insuranceService.passengerInsuranceBand(this.insuranceOptions, bandId, costOnly);
        };
        PassengerSelection.prototype.copyFromContact = function (e) {
            this.bookingService.copyFromContact(this.booking, e);
        };
        PassengerSelection.prototype.getAttractionsDesc = function (id) {
            return this.attractionService.getAttractionsDesc(this.attractions, this.booking.UserData.AttractionDetails, id);
        };
        PassengerSelection.prototype.bookingInit = function () {
            var _this = this;
            if (_.get(this, 'trip.FlightsRequest') && this.flight) {
                var legs = this.flight.Details.Itinerary.Legs;
                this.ageCheckDate = (legs[legs.length - 1].DepartureDate);
            }
            this.requiredRooms = this.mapRooms(_.get(this, 'booking.UserData.Rooms', []), this.rules);
            this.requiredRooms.additionalDrivers = _.get(this, 'carHire.AdditionalDrivers', 0);
            this.requiredRooms.map(function (room) {
                var counts = _this.resetPassengerCounts();
                room.Guests.map(function (guest) {
                    counts[guest.Type]++;
                    guest.count = counts[guest.Type];
                    if (!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands) {
                        guest.InsuranceBandId = -1;
                    }
                });
                return room;
            });
            if (this.flight && TRPCONFIG.Domain.AllowFillingFromCompanions === true) {
                this.companions = _.get(this, 'booking.UserData.Companions', [])
                    .map(this.enhanceCompanion);
                this.companions = this.companions.length
                    ? this.companions.concat({
                        FirstName: '0',
                        LastName: '0',
                        Fullname: this.resourceService.get('ENTERANEWCOMPANION')
                    })
                    : null;
            }
            this.driverOptions = [
                { name: this.resourceService.get('NOTADRIVER'), value: Core.Booking.DriverType.NotADriver },
                { name: this.resourceService.get('MAINDRIVER'), value: Core.Booking.DriverType.MainDriver }
            ];
            if (this.requiredRooms.additionalDrivers) {
                this.driverOptions.push({
                    name: this.resourceService.get('ADDITIONALDRIVER'),
                    value: Core.Booking.DriverType.AdditionalDriver
                });
            }
            if (this.insurance) {
                if (!this.flight && _.get(this, 'trip.InsuranceRequest') && !this.ageCheckDate) {
                    this.ageCheckDate = (this.insurance.EndDate);
                }
                this.isCrossSell = !this.flight && /hotels/.test(this.$location.path());
                this.adultsWithInsurance = 0;
                this.insuranceOptions = this.booking.InsuranceBands;
                if (!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands
                    && this.insuranceOptions && !_.some(this.insuranceOptions, function (io) { return io.Id === -1; })) {
                    //will have to find a better way to set this
                    this.insuranceOptions.push({ Id: -1,
                        Label: this.resourceService.get('PLEASESELECT'),
                        PassengerType: 1 });
                }
                this.selectedOptionId = _.get(this, 'insurance.Options[0].OptionId');
                this.adultsWithInsurance = _.reduce(this.booking.UserData.Rooms, function (acc, r) {
                    return _.some(r.Guests, { Type: 1 }) ? acc + 1 : acc;
                }, 0);
                if (TRPCONFIG.Domain.CheckInsuranceForceAge) {
                    this.broker.subscribe('passengerSelection', 'dobUpdated', function () {
                        if (_this.enforceAgeValidation && _this.flight) {
                            //update quotes only for cross sell
                            _this.updateInsuranceQuote(_this.booking);
                        }
                    });
                }
            }
        };
        PassengerSelection.prototype.resetPassengerCounts = function () {
            var counts = {};
            counts[Core.Booking.PassengerType.Adult] = 0;
            counts[Core.Booking.PassengerType.Child] = 0;
            counts[Core.Booking.PassengerType.Infant] = 0;
            return counts;
        };
        PassengerSelection.prototype.enhanceCompanion = function (c) {
            return _.assign(c, { Fullname: c.Title + " " + c.FirstName + " " + c.LastName });
        };
        PassengerSelection.prototype.titles = function (p) {
            switch (p.Type) {
                case Core.Booking.PassengerType.Child:
                case Core.Booking.PassengerType.Infant:
                    return this.childTitles().split(',');
                case Core.Booking.PassengerType.Adult:
                case Core.Booking.PassengerType.AdultSwimmer:
                case Core.Booking.PassengerType.AdultNonSwimmer:
                case Core.Booking.PassengerType.ChildSwimmer:
                case Core.Booking.PassengerType.ChildNonSwimmer:
                    return this.adultTitles().split(',');
                default: return [''];
            }
        };
        PassengerSelection.prototype.getPassengerType = function (type) {
            if (type > 0) {
                switch (type) {
                    case Core.Booking.PassengerType.Adult:
                        return this.resourceService.get('ADULT');
                    case Core.Booking.PassengerType.Child:
                        return this.resourceService.get('CHILD');
                    case Core.Booking.PassengerType.Infant:
                        return this.resourceService.get('INFANT');
                }
            }
            return '';
        };
        PassengerSelection.prototype.mapRooms = function (rooms, rules) {
            var _this = this;
            if (rules.hotelOnly && !TRPCONFIG.Domain.AllGuestDetailsRequired) {
                return rooms.map(function (r) {
                    return ({ Guests: [_.assign(r.Guests[0], { Label: _this.resourceService.get('LEADGUEST') })] });
                });
            }
            return rooms;
        };
        PassengerSelection.prototype.passengerSelected = function (guest) {
            //update the names etc with that of the chosen one
            if (guest.PrefillFrom != null) {
                if (guest.PrefillFrom.FirstName === '0' &&
                    guest.PrefillFrom.LastName === '0') {
                    guest.FirstName = guest.LastName = guest.Title = '';
                }
                else {
                    _.assign(guest, guest.PrefillFrom);
                }
            }
        };
        PassengerSelection.prototype.back = function (booking) {
            this.broker.publish('PassengersSelected', booking);
        };
        PassengerSelection.prototype.ok = function () {
            var _this = this;
            this.bookingService.updateBooking(this.booking).then(function () {
                if (_this.insurance) {
                    _this.updateInsuranceQuote(_this.booking);
                }
                _this.back(_this.booking);
            });
        };
        PassengerSelection.prototype.updateInsuranceQuote = function (booking) {
            var _this = this;
            var ages = this.updateInsuranceBandSelections(booking);
            var params = this.flight
                ? {
                    oneWayOnly: this.flight.OneWayOnly
                }
                : {
                    airport: _.get(this, 'hotel.Details.LinkedAirports[0]'),
                    dates: {
                        arrivalDate: _.get(this, 'hotel.Details.Itinerary.CheckInDate'),
                        departureDate: _.get(this, 'hotel.Details.Itinerary.CheckOutDate')
                    }
                };
            return this.basketService.updateInsuranceQuote(this.trip.BasketId, this.trip.TripId, this.selectedOptionId, __assign({ ages: ages }, params)).then(function () {
                _this.broker.publish('bookingBasketUpdated', angular.copy(booking.UserData));
                _this.broker.publish('basketUpdated');
                return;
            });
        };
        PassengerSelection.prototype.getPassengerLabel = function (label) {
            // AT-286 remove child age for standalone attractions
            if (this.rules == null) {
                return undefined;
            }
            return this.rules.isAttractionsStandalone
                ? label.replace(/ \(age 3\)/, '')
                : label;
        };
        PassengerSelection.prototype.updateInsuranceBandSelections = function (booking) {
            var _this = this;
            //if the insurance band price is 0 && it is an adult passenger treat it as not available
            var excludedBandIds = _.map(_.filter(this.insuranceOptions, { Available: false }), 'Id');
            var _a = _.reduce(this.booking.UserData.Rooms, function (acc, r) {
                return _.reduce(r.Guests, function (acc, g) {
                    //set the band depending on the dob selected, check if the guest does not want insurance
                    if (g.DateOfBirth && g.InsuranceBandId > 0) {
                        var age_1 = _this.dateUtil.getAge(g.DateOfBirth, _this.ageCheckDate);
                        var selectedInsuranceBand = _.find(_this.insuranceOptions, function (option) {
                            return age_1 <= option.EndAge && age_1 >= option.StartAge;
                        });
                        if (selectedInsuranceBand) {
                            g.InsuranceBandId = selectedInsuranceBand.Id;
                        }
                        else {
                            g.InsuranceBandId = null;
                        }
                    }
                    if (g.InsuranceBandId > 0 && _.indexOf(excludedBandIds, g.InsuranceBandId) === -1) {
                        if (g.Type === 1) {
                            acc.adultAges.push(g.InsuranceBandId);
                        }
                        else {
                            acc.childAges.push(g.InsuranceBandId);
                        }
                    }
                    return acc;
                }, acc);
            }, { childAges: [], adultAges: [] }), childAges = _a.childAges, adultAges = _a.adultAges;
            if (adultAges.length === 0 && childAges.length > 0) {
                //clear child insurance ages
                booking.UserData.Rooms.forEach(function (r) {
                    r.Guests.forEach(function (g) {
                        if (g.Type !== 1) {
                            g.InsuranceBandId = null;
                        }
                    });
                });
                childAges = [];
            }
            this.adultsWithInsurance = adultAges.length;
            return adultAges.concat(childAges);
        };
        return PassengerSelection;
    }());
    angular
        .module('TR')
        .directive('passengerSelection', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                rootForm: '=',
                trip: '=',
                booking: '=',
                rules: '=',
                carHire: '=',
                insurance: '=',
                flight: '=',
                hotel: '=',
                attractions: '=',
                roomIndex: '=',
                passengerIndex: '=',
                visible: '=',
                bookingLoaded: '=',
                hideForm: '='
            },
            bindToController: true,
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return 'partials/booking/template?name=PassengerSelection&version=' + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=PassengerSelection';
            },
            controller: PassengerSelection,
            controllerAs: 'ps'
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('platform195ConvTracking', platform195ConvTracking);
    function platform195ConvTracking($timeout) {
        return {
            restrict: 'A',
            scope: '@',
            link: function () {
                var getJSON = function (obj) {
                    return obj && JSON.parse(obj);
                };
                var generatePixel = function (url) {
                    if (!url) {
                        return;
                    }
                    var img = new Image();
                    img.src = url;
                    return img;
                };
                var getPlatform195Conv = function (id) {
                    if (!id) {
                        return;
                    }
                    var value = localStorage.getItem("platform195Conv" + id);
                    var serialized = value !== null ? value : '';
                    return serialized;
                };
                var removeConvCookie = function (id) {
                    var ls = getPlatform195Conv(id);
                    ls && $timeout(localStorage.removeItem("platform195Conv" + id), 5000);
                };
                var initConversionPixel = function (id, url, callback) {
                    if (!id) {
                        return;
                    }
                    url && generatePixel(url);
                    callback(id);
                };
                var bookingRef = sessionStorage.getItem('preselectedHotelData');
                var bookingData = bookingRef !== null ? bookingRef : '';
                var getEstabId = function (data) {
                    if (!data) {
                        return;
                    }
                    var json = getJSON(data);
                    if (!json) {
                        return;
                    }
                    var d = json.d;
                    var id = _.get(d, '.Itinerary.EstabId');
                    return id;
                };
                var getPreSelectedData = function (data, id) {
                    if (!data) {
                        return;
                    }
                    var bookingData = getPlatform195Conv(id);
                    if (!bookingData) {
                        return;
                    }
                    return getJSON(bookingData);
                };
                var platform195Conv = function (bookingData) {
                    if (!bookingData) {
                        return;
                    }
                    var estabId = getEstabId(bookingData);
                    var _a = getPreSelectedData(bookingData, estabId) || {}, hotelId = _a.hotelId, conversionUrl = _a.conversionUrl, isSponsoredEstab = _a.isSponsoredEstab;
                    if ((!conversionUrl && !isSponsoredEstab) || (estabId !== hotelId)) {
                        return;
                    }
                    initConversionPixel(estabId, conversionUrl, removeConvCookie);
                };
                if (!bookingData) {
                    return;
                }
                platform195Conv(bookingData);
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('platform195Pill', platform195Pill);
    function platform195Pill() {
        return {
            restrict: 'A',
            scope: '@',
            estabId: '@',
            link: function ($scope, $el, $attrs) {
                var el = $el[0];
                var parent = el && el.closest('.pills-container');
                var internalPill = parent && parent.querySelector('.sc-c-pill__label--not-sponsored');
                var estabId = $attrs.estabId;
                var getDataFromJSON = function (obj) {
                    return JSON.parse(obj);
                };
                // Move into the estab page
                var getSponsoredEstab = function (_a) {
                    var estabId = _a.estabId;
                    var json = localStorage.getItem("platform195Estab" + estabId);
                    var serialized = json !== null ? json : '';
                    var _b = getDataFromJSON(serialized).hotelId, hotelId = _b === void 0 ? '' : _b;
                    hotelId = parseInt(hotelId);
                    estabId = parseInt(estabId);
                    if (estabId !== hotelId) {
                        return false;
                    }
                    return true;
                };
                var platform195settings = { estabId: estabId };
                var platform195Estab = localStorage.getItem("platform195Estab" + estabId) && getSponsoredEstab(platform195settings);
                if (!platform195Estab) {
                    el && el.classList.add('hidden');
                }
                if (platform195Estab) {
                    internalPill && internalPill.closest('.pills_hotel--facilities').classList.add('hidden');
                }
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('platform195Tracking', platform195Tracking);
    function platform195Tracking() {
        return {
            restrict: 'A',
            scope: '@',
            hotel: '=',
            link: function ($scope, $el) {
                var el = $el[0];
                var button = el.querySelector('.sc-c-button');
                var titleLink = el && el.querySelector('h4 a');
                var _a = $scope.hotel, Id = _a.Id, IsSponsoredEstab = _a.IsSponsoredEstab, ImpressionUrl = _a.ImpressionUrl, ClickUrl = _a.ClickUrl, ConversionUrl = _a.ConversionUrl;
                var estabId = Id;
                var isSponsoredEstab = IsSponsoredEstab;
                var impressionUrl = ImpressionUrl;
                var clickUrl = ClickUrl;
                var conversionUrl = ConversionUrl;
                var hotelId = estabId;
                var generatePixel = function (url) {
                    if (!url) {
                        return;
                    }
                    var img = new Image();
                    img.src = url;
                    return img;
                };
                // Impression pixel tracking
                impressionUrl && generatePixel(impressionUrl);
                var setConversionPixel = function (_a) {
                    var isSponsoredEstab = _a.isSponsoredEstab, conversionUrl = _a.conversionUrl, hotelId = _a.hotelId;
                    if (!isSponsoredEstab && !conversionUrl && !hotelId) {
                        return;
                    }
                    var conversionPixelSerialized = JSON.stringify({ isSponsoredEstab: isSponsoredEstab, conversionUrl: conversionUrl, hotelId: hotelId });
                    var conversionData = localStorage.setItem("platform195Conv" + hotelId, conversionPixelSerialized);
                    return conversionData;
                };
                // for the estab page pill
                var setPlatform195Estab = function (_a) {
                    var isSponsoredEstab = _a.isSponsoredEstab, hotelId = _a.hotelId;
                    if (!isSponsoredEstab && !hotelId) {
                        return;
                    }
                    var serialized = JSON.stringify({ hotelId: hotelId });
                    var platform195Estab = localStorage.setItem("platform195Estab" + hotelId, serialized);
                    return platform195Estab;
                };
                // for the estab page pill maybe change to a loop
                var isPlatform195Estab = { isSponsoredEstab: isSponsoredEstab, hotelId: hotelId };
                var platform195EstabEnabled = isSponsoredEstab && hotelId;
                // for the conversion pixel
                var convPixelEnabled = conversionUrl && isSponsoredEstab && hotelId;
                var conversionUrlSettings = {
                    isSponsoredEstab: isSponsoredEstab,
                    conversionUrl: conversionUrl,
                    hotelId: hotelId
                };
                var handleClick = function () {
                    clickUrl && generatePixel(clickUrl);
                    convPixelEnabled && setConversionPixel(conversionUrlSettings);
                    platform195EstabEnabled && setPlatform195Estab(isPlatform195Estab);
                };
                button && button.addEventListener('click', handleClick);
                titleLink && titleLink.addEventListener('click', handleClick);
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('postcode', function (postcodeService, globalisationService) {
        return {
            restrict: 'E',
            replace: true,
            priority: 100,
            scope: {
                address: '=',
                form: '=',
                isReadonly: '=',
                isPostcodeRequired: '=',
                dontCaptureAddress: '='
            },
            templateUrl: function (element, attr) {
                if (attr.templateVersion) {
                    return "partials/booking/template?name=Postcode&version=" + attr.templateVersion;
                }
                else if (attr.templateUrl) {
                    return "partials/home/directivetemplate?type=" + attr.templateUrl;
                }
                return 'partials/home/directivetemplate?type=Postcode';
            },
            link: function (scope) {
                postcodeService.setKey(scope.key);
                scope.isLookupEnabled = TRPCONFIG.Domain.IsPostcodeLookupEnabled;
                scope.showSearch = TRPCONFIG.Domain.IsPostcodeLookupEnabled;
                function foundAndBound(data) {
                    scope.results = data.Items;
                }
                function Appender(base) {
                    this.Result = base;
                }
                Appender.prototype.append = function (str) {
                    return str ? new Appender(this.Result + ", " + str) : this;
                };
                function retrievedAndBound(data) {
                    var detail = data.Items[0];
                    scope.results = [];
                    scope.address.PostCode = detail.PostalCode;
                    scope.address.Address = new Appender(detail.Line1).append(detail.Line2).append(detail.Line3).Result;
                    if (detail.Company) {
                        scope.address.Address = detail.Company + " " + scope.address.Address;
                    }
                    scope.address.City = detail.City;
                    scope.showSearch = false;
                }
                scope.next = function (item) {
                    if (item.Type !== 'Address') {
                        postcodeService.find(item.Text, scope.address.CountryCode, item.Id).then(foundAndBound);
                    }
                    else if (item.Type === 'Address') {
                        postcodeService.retrieve(item.Id).then(retrievedAndBound);
                    }
                };
                scope.resetAddress = function (isSearchVisible) {
                    scope.showSearch = isSearchVisible;
                    scope.address.PostCode = '';
                    scope.address.Address = '';
                    scope.address.City = '';
                    scope.address.County = '';
                };
                scope.findAddress = function (val) {
                    if (val && val.length >= 2) {
                        postcodeService.find(val, scope.address.CountryCode).then(foundAndBound);
                    }
                };
                scope.$on('auth:signout', function () { return scope.showSearch = TRPCONFIG.Domain.IsPostcodeLookupEnabled; });
                scope.$on('form:submitted-invalid', function (event, form) {
                    // ensuring that we are only setting showSearch on the correct form when there are multiple forms on page
                    if (form && scope.form && form.$name !== scope.form.$name) {
                        return;
                    }
                    if (scope.addressForm.$invalid) {
                        scope.showSearch = false;
                    }
                });
                scope.$watch('address.CountryCode', function () {
                    if (TRPCONFIG.Domain.FilterCountryList) {
                        scope.countries = filterCountries();
                    }
                    scope.results = [];
                    if (TRPCONFIG.Domain.EnableContactState && scope.address && scope.address.CountryCode) {
                        globalisationService.getStates(scope.address.CountryCode).then(function (s) {
                            scope.states = s;
                        });
                    }
                });
                scope.$watch('address', function (value) {
                    if (value &&
                        (value.PostCode ||
                            value.Address ||
                            value.City ||
                            value.County)) {
                        scope.showSearch = false;
                    }
                }, true);
                function filterCountries() {
                    var countryCodesArr = TRPCONFIG.Domain.FilterCountryList.split(',').map(function (el) {
                        return el.trim();
                    });
                    var filteredCountries = scope.countries.filter(function (country) {
                        return countryCodesArr.includes(country.Code);
                    });
                    return filteredCountries;
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('preloader', function () {
        return {
            restrict: 'E',
            replace: true,
            template: '<div class="preloader">' +
                '<div class="cell cell-1"></div>' +
                '<div class="cell cell-2"></div>' +
                '<div class="cell cell-3"></div>' +
                '<div class="cell cell-4"></div>' +
                '<div class="cell cell-5"></div>' +
                '<div class="cell cell-6"></div>' +
                '<div class="cell cell-7"></div>' +
                '<div class="cell cell-8"></div>' +
                '</div>'
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('priceMode', function (broker, preferences, analytics) {
        var inst = 0;
        //we need to give each instance of the price mode directive a unique id so that each one can have its own broker
        //subscription
        function getInstance() {
            inst += 1;
            return inst;
        }
        return {
            restrict: 'E',
            replace: true,
            scope: {
                forcePriceMode: '=',
                ignorePreference: '=',
                isKidsFree: '=?'
            },
            templateUrl: 'partials/home/directivetemplate?type=PriceMode',
            link: function (scope) {
                var i = getInstance();
                var timeDirectiveRendered = new Date();
                scope.$watch('priceMode', function (v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    broker.publish('priceModeChanged', scope.priceMode);
                    preferences.set('priceMode', scope.priceMode);
                    //Track in mixpannel.  Need to ignore the case when pricemode is being initalised or set in an ab-test.
                    var timespan = new Date() - timeDirectiveRendered;
                    if (timespan > 2000) {
                        analytics.track('mixpanel', 'PriceModeToggle', {
                            newValue: v === 0 ? 'perPerson' : 'totalPrice'
                        });
                    }
                });
                if (scope.forcePriceMode !== undefined) {
                    scope.priceMode = scope.forcePriceMode;
                }
                if (!scope.ignorePreference) {
                    preferences.get('priceMode').then(function (p) {
                        scope.priceMode = p;
                    });
                }
                broker.subscribe("priceModeDirective" + i, 'priceModeChanged', function (ev) {
                    scope.priceMode = ev.data; //because we may have more than one price mode directive on the screen and the must be in sync
                });
                scope.$on('$destroy', function () {
                    broker.unsubscribe("priceModeDirective" + i, 'priceModeChanged');
                });
            }
        };
    });
})();
var TR;
(function (TR) {
    var PriorityBoarding = /** @class */ (function () {
        function PriorityBoarding($routeParams, basketService, basketStore, tripService) {
            var _this = this;
            this.$routeParams = $routeParams;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.tripService = tripService;
            this.isSelected = false;
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                _this.basketId = trip.BasketId;
            });
            this.totalPrice = this.details.optionDetails.UnitAmount * this.details.optionDetails.Quantity;
        }
        PriorityBoarding.prototype.updatePriorityBoarding = function (pbSelectedStatus) {
            var _this = this;
            this.basketStore.updatePriorityBoarding(this.basketId, this.details.optionDetails, pbSelectedStatus)
                .then(function () {
                _this.basketService.updateBasket();
                _this.details.isSelected = pbSelectedStatus;
            });
        };
        return PriorityBoarding;
    }());
    angular
        .module('TR')
        .component('priorityBoarding', {
        bindings: {
            details: '<'
        },
        controller: PriorityBoarding,
        controllerAs: 'pb',
        templateUrl: 'partials/home/directivetemplate?type=PriorityBoarding'
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('publicityMessages', function (arrayUtil, $interval, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                stats: '=',
                loop: '='
            },
            template: '<div class="publicity-messages"><p class="publicity-message"></p></div>',
            link: function (scope, el) {
                var fade = 500;
                var cycle = 5000;
                var p = el.find('p:first');
                var msgs;
                var i = 0;
                var loop;
                function showMsg() {
                    i += 1;
                    p.addClass('faded');
                    $timeout(function () {
                        p.text(msgs[i % msgs.length].Text);
                        p.removeClass('faded');
                    }, fade);
                }
                scope.$watch('loop', function (v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    $interval.cancel(loop);
                    if (v && msgs != null && msgs.length > 1) {
                        loop = $interval(showMsg, cycle);
                    }
                });
                var cancel = scope.$watch('stats', function (data) {
                    if (data != null) {
                        msgs = arrayUtil.filter([data.BookingsInLastHour, data.CustomersCurrentlyOnHoliday,
                            data.CustomersGoingOnHoliday, data.SearchesInLastHour], function (msg) {
                            return msg != null && msg.Text != null && msg.Value > 1;
                        });
                        if (msgs.length > 0) {
                            p.text(msgs[i].Text);
                        }
                        cancel();
                    }
                });
                scope.$on('$destroy', function () {
                    $interval.cancel(loop);
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('radioButton', function ($timeout) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                model: '=',
                val: '=',
                group: '@',
                property: '@',
                disabled: '=',
                onChange: '&'
            },
            templateUrl: 'partials/home/radiobutton',
            link: function (scope, el) {
                var chk = el.find('input');
                var val;
                function checked(c) {
                    chk.prop('checked', c);
                    if (c) {
                        el.addClass('checked');
                    }
                    else {
                        el.removeClass('checked');
                    }
                }
                // Verifies if we're dealing with an object or a direct value
                function safeCheck(modelValue) {
                    if (scope.property) {
                        checked(modelValue[scope.property] === val[scope.property]);
                    }
                    else {
                        checked(angular.equals(modelValue, val));
                    }
                }
                var canc = scope.$watch('val', function (v) {
                    if (v != null) {
                        val = scope.val;
                        safeCheck(scope.model);
                        canc();
                    }
                });
                scope.$watch('model', function (v) {
                    safeCheck(v);
                    if (scope.onChange) {
                        scope.onChange();
                    }
                });
                scope.toggle = function () {
                    if (!scope.disabled) {
                        // Changes the model only if the value is new, emits the click
                        // event anyway.
                        var sameSelection = angular.equals(scope.model, val);
                        if (!sameSelection) {
                            scope.model = val;
                        }
                        $timeout(function () { scope.$emit('radio-clicked'); });
                    }
                };
            }
        };
    });
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('rating', rating);
    function rating() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                stars: '@',
                full: '='
            },
            template: '<span class="star-rating">' +
                '<i ng-repeat="starClass in rating track by $index" class="{{starClass}}" />' +
                '</span>',
            link: function (scope) {
                var starsNumber = parseFloat(scope.stars);
                var hasHalf = starsNumber - _.floor(starsNumber) > 0;
                scope.rating = _.map(new Array(5), function (v, idx) {
                    var currentStar = idx + 1;
                    if (currentStar <= starsNumber) {
                        return 'icon-star';
                    }
                    if (hasHalf) {
                        return 'icon-star half';
                    }
                    if (scope.full) {
                        return 'icon-star greyed';
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('recentSearches', function (savedSearchService, basketService, analytics) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=RecentSearches',
            scope: {
                maxItems: '@',
                searchType: '='
            },
            link: function (scope) {
                scope.busy = false;
                scope.$on('auth:signout', load);
                function load(searchType) {
                    savedSearchService.getSavedSearches(searchType).then(function (searches) {
                        //scope.searches = scope.maxItems ? searches.slice(0, scope.maxItems) : searches;
                        /// If trying to load only specific type of search, but it returns empty, repeat search without type
                        if (searchType && !searches.length) {
                            load();
                        }
                        else {
                            scope.searches = searches;
                        }
                    });
                }
                load(scope.searchType);
                scope.restoreSearch = function (s) {
                    if (!scope.busy) {
                        scope.selectedId = s.SavedSearchId;
                        scope.busy = true;
                        savedSearchService.restoreSearch(s).then(function () {
                            basketService.startWorkflow(basketService.workflowType[s.SearchType]).then(function () { return scope.busy = false; }, function () { return scope.busy = false; });
                            analytics.trackEvent({ label: 'restore saved search' });
                        }, function () {
                            scope.busy = false;
                        });
                    }
                };
                scope.deleteSearch = function (ev, s) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    var track = $(ev.target).closest('.slick-track');
                    var slide = $(ev.target).closest('.slick-slide');
                    var index = track.children().index(slide);
                    $(ev.target).closest('.slick-slider').slick('slickRemove', index);
                    savedSearchService.removeSavedSearch(s.SavedSearchId);
                    //filtering out searches from the result set
                    scope.searches = scope.searches.filter(function (item) { return item.SavedSearchId !== s.SavedSearchId; });
                };
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('resourceStrings', function (resourceService) {
        return {
            restrict: 'A',
            link: function (scope, el, attr) {
                if (attr.resourceStrings != null) {
                    resourceService.set(JSON.parse(attr.resourceStrings));
                }
            }
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('salesBanner', salesBanner);
    function salesBanner() {
        return {
            restrict: 'E',
            scope: {
                imageType: '@',
                onPopulate: '&',
                fallbackTagetUrl: '@',
                imgClass: '@',
            },
            link: _linker,
            template: "\n<span gtm-namespace=\"sales-banner\">\n    <a ng-href=\"{{::targetUrl}}\" ng-if=\"::imageSrc && targetUrl\">\n        <img ng-src=\"{{::imageSrc}}\" ng-class=\"imgClass\" />\n    </a>\n    <img ng-if=\"::imageSrc && !targetUrl\" ng-src=\"{{::imageSrc}}\" ng-class=\"imgClass\" />\n</span>",
        };
        function _linker(scope) {
            var graphic = TRPCONFIG.Domain.SaleBannerUrls[scope.imageType];
            if (graphic) {
                scope.imageSrc = graphic.ImageSrc;
                scope.targetUrl = graphic.TargetUrl || scope.fallbackTagetUrl;
            }
            if (scope.imageSrc) {
                scope.onPopulate();
            }
        }
    }
})();
// partly duplicated by seatPlanCtrl.js which will go away with the options v1 page
var TR;
(function (TR) {
    var SeatPlanUnit = /** @class */ (function () {
        function SeatPlanUnit() {
            this.minCostPerPerson = 0;
            this.totalPrice = 0;
        }
        SeatPlanUnit.prototype.selectSeatsParent = function (seats, seatsPostAdd) {
            this.selectSeats({ seats: seats, seatsPostAdd: seatsPostAdd });
        };
        SeatPlanUnit.prototype.closePlan = function () {
            this.showPlan = false;
        };
        SeatPlanUnit.prototype.resetSeats = function () {
            for (var _i = 0, _a = this.flightSeatPlan.Passengers; _i < _a.length; _i++) {
                var p = _a[_i];
                for (var _b = 0, _c = p.Seats; _b < _c.length; _b++) {
                    var s = _c[_b];
                    s.Number = null;
                    s.Price = 0;
                }
            }
            this.totalPrice = 0;
        };
        return SeatPlanUnit;
    }());
    angular
        .module('core')
        .component('seatPlanUnit', {
        bindings: {
            flightSeatPlan: '=',
            selectSeats: '&',
            getSelectedSeats: '&',
            totalPrice: '=?'
        },
        controller: SeatPlanUnit,
        controllerAs: 'sp',
        templateUrl: 'partials/holidays/seatplanunit'
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('seatSelection', function (resourceService, customCurrencyFilter, scrollService, $timeout) {
        return {
            restrict: 'E',
            scope: {
                flightSeatPlan: '=',
                getSelectedSeats: '&',
                selectSeats: '&',
                closePlan: '&',
                totalPrice: '='
            },
            templateUrl: 'partials/holidays/seatselection',
            link: function (scope) {
                var seatToConfirm = null;
                var cancel = scope.$watch('flightSeatPlan', function (val) {
                    if (val == null) {
                        return;
                    }
                    scope.flights = val.Segments.Outbound.concat(val.Segments.Inbound || []);
                    scope.selectedFlight = val.Segments.Outbound[0];
                    scope.passengers = val.Passengers;
                    scope.selectedPassenger = val.Passengers[0];
                    scope.showSafetyMsg = false;
                    generatePlanRows();
                    restoreSelectedSeats();
                    cycleNextPassenger();
                    cancel();
                });
                scope.$watch('totalPrice', function (price, oldPrice) {
                    if (price === 0 && oldPrice > 0) {
                        // the seats have been removed
                        scope.selectSeats({ seats: [] });
                        scope.changeSeats();
                    }
                });
                function restoreSelectedSeats() {
                    // Seats should be in the format 'Seat::Adult 1 2A,3A'
                    scope.getSelectedSeats().forEach(function (selectedSeat) {
                        var tokens = selectedSeat.OptionId.split(' ');
                        var isChild = tokens[0] === 'Seat::Child';
                        var sequence = +tokens[1];
                        var passenger = scope.passengers
                            .filter(function (p) { return p.IsChild === isChild && p.Sequence === sequence; })[0];
                        tokens[2].split(',').forEach(function (seatNumber, i) {
                            var flight = scope.flights[i];
                            var seat = findSeatInFlight(flight, seatNumber);
                            confirmSeat(passenger, flight, seat);
                        });
                    });
                    scope.totalPrice = scope.getTotalPrice();
                }
                function findSeatInFlight(flight, seatNumber) {
                    for (var _i = 0, _a = flight.SeatPlan.Rows; _i < _a.length; _i++) {
                        var row = _a[_i];
                        for (var _b = 0, _c = row.Blocks; _b < _c.length; _b++) {
                            var block = _c[_b];
                            for (var _d = 0, _e = block.Seats; _d < _e.length; _d++) {
                                var seat = _e[_d];
                                if (seat.Number === seatNumber) {
                                    return seat;
                                }
                            }
                        }
                    }
                }
                function saveSelectedSeats() {
                    scope.selectSeats({
                        seats: scope.passengers.map(function (p) {
                            var type = p.HasInfant === true ? 'Adult-with-Infant' : p.Description;
                            var seats = p.Seats.map(function (s) { return s.Number; });
                            return {
                                OptionId: "Seat::" + type + " " + p.Sequence + " " + seats.join(),
                                Quantity: 1
                            };
                        }),
                        seatsPostAdd: _.flatMap(scope.passengers, function (p) {
                            return p.Seats.map(function (seat) { return ({
                                SeatNumber: seat.Number,
                                PassengerID: p.Id,
                                LegId: seat.LegId,
                                SegmentHash: seat.Segement,
                                IncludesInfant: p.HasInfant
                            }); });
                        })
                    });
                    scope.totalPrice = scope.getTotalPrice();
                }
                scope.canConfirm = function () {
                    if (!scope.flightSeatPlan) {
                        return false;
                    }
                    for (var _i = 0, _a = scope.flightSeatPlan.Passengers; _i < _a.length; _i++) {
                        var p = _a[_i];
                        for (var _b = 0, _c = p.Seats; _b < _c.length; _b++) {
                            var s = _c[_b];
                            if (!s.Number) {
                                return false;
                            }
                        }
                    }
                    return true;
                };
                scope.confirm = function () {
                    saveSelectedSeats();
                    scope.closePlan();
                };
                scope.getFlightSegmentType = function (flight) {
                    if (scope.flightSeatPlan.Segments.Outbound.indexOf(flight) !== -1) {
                        return 'out';
                    }
                    return 'in';
                };
                scope.selectFlight = function (flight) {
                    if (scope.selectedFlight !== flight) {
                        scope.selectedFlight = flight;
                        scope.selectedPassenger = scope.passengers[0];
                        generatePlanRows();
                    }
                };
                scope.selectPassenger = function (flight, passenger) {
                    if (scope.selectedFlight !== flight) {
                        scope.selectedFlight = flight;
                        generatePlanRows();
                    }
                    scope.selectedPassenger = passenger;
                };
                scope.getSelectedPassengerIndex = function () {
                    return _.findIndex(scope.passengers, scope.selectedPassenger);
                };
                function getFlightIndex(flight) {
                    return scope.flights.indexOf(flight);
                }
                scope.getPassengerSeatForFlight = function (passenger, flight) {
                    return passenger.Seats[getFlightIndex(flight)];
                };
                scope.getTotalPrice = function () {
                    return scope.flightSeatPlan && _.chain(scope.flightSeatPlan.Passengers)
                        .flatMap(function (p) { return p.Seats; })
                        .sumBy('Price')
                        .round(2)
                        .value();
                };
                function getRowPrices(seats) {
                    var rowAdultMinPrice = 0;
                    var rowAdultMaxPrice = 0;
                    var rowChildMinPrice = 0;
                    var rowChildMaxPrice = 0;
                    var rowAdultWithInfantMinPrice = 0;
                    var rowAdultWithInfantMaxPrice = 0;
                    for (var _i = 0, seats_1 = seats; _i < seats_1.length; _i++) {
                        var s = seats_1[_i];
                        if (!s || !s.IsAvailable) {
                            continue;
                        }
                        var AdultPrice = s.AdultPrice, ChildPrice = s.ChildPrice, AdultWithInfantPrice = s.AdultWithInfantPrice, AvailableForChild = s.AvailableForChild, AvailableForInfant = s.AvailableForInfant;
                        if (rowAdultMaxPrice < AdultPrice) {
                            rowAdultMaxPrice = AdultPrice;
                        }
                        if (rowChildMaxPrice < ChildPrice) {
                            rowChildMaxPrice = ChildPrice;
                        }
                        if (rowAdultWithInfantMaxPrice < AdultWithInfantPrice) {
                            rowAdultWithInfantMaxPrice = AdultWithInfantPrice;
                        }
                        if (!rowAdultMinPrice || rowAdultMinPrice > AdultPrice) {
                            rowAdultMinPrice = AdultPrice;
                        }
                        if (AvailableForChild && (!rowChildMinPrice || rowChildMinPrice > ChildPrice)) {
                            rowChildMinPrice = ChildPrice;
                        }
                        if (AvailableForInfant && (!rowAdultWithInfantMinPrice || rowAdultWithInfantMinPrice > AdultWithInfantPrice)) {
                            rowAdultWithInfantMinPrice = AdultWithInfantPrice;
                        }
                    }
                    return {
                        rowAdultMinPrice: rowAdultMinPrice,
                        rowAdultMaxPrice: rowAdultMaxPrice,
                        rowChildMinPrice: rowChildMinPrice,
                        rowChildMaxPrice: rowChildMaxPrice,
                        rowAdultWithInfantMinPrice: rowAdultWithInfantMinPrice,
                        rowAdultWithInfantMaxPrice: rowAdultWithInfantMaxPrice
                    };
                }
                function blocksToCols(blocks) {
                    return blocks.reduce(function (cols, block) {
                        if (cols.length) {
                            cols.push(null);
                        }
                        return cols.concat(block.Seats);
                    }, []);
                }
                function generatePlanRows() {
                    var rows = [];
                    var headerCols = blocksToCols(scope.selectedFlight.SeatPlan.HeaderRow.Blocks);
                    var headers = headerCols.map(function (h) { return h && h.Number; });
                    rows.push({
                        type: 'head',
                        cols: headerCols
                    });
                    var groupAdultMinPrice = 0;
                    var groupAdultMaxPrice = 0;
                    var groupChildMinPrice = 0;
                    var groupChildMaxPrice = 0;
                    var groupAdultWithInfantMinPrice = 0;
                    var groupAdultWithInfantMaxPrice = 0;
                    scope.selectedFlight.SeatPlan.Rows.forEach(function (row) {
                        var cols = blocksToCols(row.Blocks);
                        var _a = getRowPrices(cols), rowAdultMinPrice = _a.rowAdultMinPrice, rowAdultMaxPrice = _a.rowAdultMaxPrice, rowChildMinPrice = _a.rowChildMinPrice, rowChildMaxPrice = _a.rowChildMaxPrice, rowAdultWithInfantMinPrice = _a.rowAdultWithInfantMinPrice, rowAdultWithInfantMaxPrice = _a.rowAdultWithInfantMaxPrice;
                        if (rowAdultMinPrice !== groupAdultMinPrice
                            || rowAdultMaxPrice !== groupAdultMaxPrice
                            || rowChildMinPrice !== groupChildMinPrice
                            || rowChildMaxPrice !== groupChildMaxPrice
                            || rowAdultWithInfantMinPrice !== groupAdultWithInfantMinPrice
                            || rowAdultWithInfantMaxPrice !== groupAdultWithInfantMaxPrice) {
                            groupAdultMinPrice = rowAdultMinPrice;
                            groupAdultMaxPrice = rowAdultMaxPrice;
                            groupChildMinPrice = rowChildMinPrice;
                            groupChildMaxPrice = rowChildMaxPrice;
                            groupAdultWithInfantMinPrice = rowAdultWithInfantMinPrice;
                            groupAdultWithInfantMaxPrice = rowAdultWithInfantMaxPrice;
                            rows.push({
                                type: 'group',
                                cols: [{
                                        AdultMinPrice: rowAdultMinPrice,
                                        AdultMaxPrice: rowAdultMaxPrice,
                                        ChildMinPrice: rowChildMinPrice,
                                        ChildMaxPrice: rowChildMaxPrice,
                                        AdultWithInfantMinPrice: rowAdultWithInfantMinPrice,
                                        AdultWithInfantMaxPrice: rowAdultWithInfantMaxPrice
                                    }]
                            });
                        }
                        rows.push({
                            type: 'seats',
                            label: cols[0].Number.match(/\d+/)[0],
                            cols: headers.map(function (h) {
                                if (!h) {
                                    return 'label';
                                }
                                for (var i = 0; i < cols.length; i++) {
                                    var col = cols[i];
                                    if (col && h === col.Number.match(/[a-z]+/i)[0]) {
                                        return col;
                                    }
                                }
                                return null;
                            })
                        });
                    });
                    scope.planColspan = headerCols.length;
                    scope.planRows = rows;
                }
                function isSeatAvailable(seat) {
                    if (!seat.IsAvailable) {
                        return false;
                    }
                    if (scope.selectedPassenger.IsChild && !seat.AvailableForChild) {
                        return false;
                    }
                    if (scope.selectedPassenger.HasInfant && !seat.AvailableForInfant) {
                        return false;
                    }
                    var i = getFlightIndex(scope.selectedFlight);
                    for (var _i = 0, _a = scope.flightSeatPlan.Passengers; _i < _a.length; _i++) {
                        var p = _a[_i];
                        if (p.Seats[i].Number === seat.Number && p !== scope.selectedPassenger) {
                            return false;
                        }
                    }
                    return true;
                }
                scope.getSeatClass = function (seat) {
                    var i = getFlightIndex(scope.selectedFlight);
                    var isSelected = false;
                    for (var _i = 0, _a = scope.passengers; _i < _a.length; _i++) {
                        var p = _a[_i];
                        if (p.Seats[i].Number === seat.Number) {
                            isSelected = true;
                            break;
                        }
                    }
                    return {
                        selected: isSelected,
                        restricted: !!seat.RestrictionTextId,
                        unavailable: !isSeatAvailable(seat),
                        xl: seat.HasExtraLegRoom
                    };
                };
                function getSeatMessage(Id) {
                    for (var _i = 0, _a = scope.selectedFlight.SeatPlan.SeatMessages; _i < _a.length; _i++) {
                        var m = _a[_i];
                        if (m.Id === Id) {
                            return m.Information;
                        }
                    }
                }
                scope.getSeatTip = function (seat) {
                    if (isSeatAvailable(seat)) {
                        return getSeatMessage(seat.AdditionalInfoTextId);
                    }
                };
                function confirmSeat(passenger, flight, seat) {
                    var selectedSeat = scope.getPassengerSeatForFlight(passenger, flight);
                    selectedSeat.Number = seat.Number;
                    if (scope.selectedPassenger.IsChild) {
                        selectedSeat.Price = seat.ChildPrice;
                    }
                    else if (scope.selectedPassenger.HasInfant) {
                        selectedSeat.Price = seat.AdultWithInfantPrice;
                    }
                    else {
                        selectedSeat.Price = seat.AdultPrice;
                    }
                }
                function cycleNextPassenger(wait) {
                    if (wait === void 0) { wait = false; }
                    $timeout(function () {
                        for (var i = 0; i < scope.flights.length; i++) {
                            for (var _i = 0, _a = scope.passengers; _i < _a.length; _i++) {
                                var p = _a[_i];
                                if (!p.Seats[i].Number) {
                                    scope.selectPassenger(scope.flights[i], p);
                                    return;
                                }
                            }
                            scope.selectedFlight === scope.flights[i] && $('.body-content-inner-wrapper').scrollTop(0);
                        }
                        scope.allSeatsSelected = true;
                    }, wait && 700);
                }
                scope.setPassengerSeat = function (seat, wait) {
                    if (!isSeatAvailable(seat)) {
                        return;
                    }
                    var selectedSeat = scope.getPassengerSeatForFlight(scope.selectedPassenger, scope.selectedFlight);
                    seatToConfirm = null;
                    if (selectedSeat.Number === seat.Number) {
                        // de-select the seat
                        selectedSeat.Number = null;
                        selectedSeat.Price = 0;
                    }
                    else if (seat.RestrictionTextId) {
                        seatToConfirm = seat;
                        scope.restrictionText = getSeatMessage(seat.RestrictionTextId);
                        scope.showSafetyMsg = true;
                    }
                    else {
                        confirmSeat(scope.selectedPassenger, scope.selectedFlight, seat);
                        cycleNextPassenger(wait);
                    }
                };
                scope.confirmRestrictedSeat = function () {
                    confirmSeat(scope.selectedPassenger, scope.selectedFlight, seatToConfirm);
                    cycleNextPassenger();
                    scope.closeRestrictionSeat();
                };
                scope.closeRestrictionSeat = function () {
                    seatToConfirm = null;
                    scope.showSafetyMsg = false;
                };
                scope.addPassengerSelectionText = function (passenger, index) {
                    var pType = resourceService.get(passenger.HasInfant
                        ? 'ADULTWITHINFANT'
                        : !passenger.IsChild && !passenger.HasInfant
                            ? 'ADULT'
                            : 'CHILD');
                    var _a = scope.getPassengerSeatForFlight(passenger, scope.selectedFlight), Number = _a.Number, Price = _a.Price;
                    passenger.description = pType + " " + (parseInt(index) + 1);
                    passenger.selectionText = passenger.description +
                        (Number ? ", " + Number : '') +
                        (Price ? ", " + customCurrencyFilter(Price) : '');
                    passenger.selection = {
                        Number: Number,
                        Price: Price && customCurrencyFilter(Price) || ''
                    };
                    return passenger;
                };
                scope.getPassengersGrouped = function () {
                    return _.chain(scope.passengers)
                        .reject(['Type', 3])
                        .groupBy('Type')
                        .flatMap(function (group) { return group.map(scope.addPassengerSelectionText); })
                        .value();
                };
                scope.changeSeats = function () {
                    scope.passengers.forEach(function (p) { return p.Seats.forEach(function (s) {
                        s.Number = null;
                        s.Price = null;
                    }); });
                    scope.selectedFlight = scope.flights[0];
                    scope.selectedPassenger = scope.passengers[0];
                    scope.allSeatsSelected = false;
                };
                scope.showRestrictionText = function (row) {
                    return seatToConfirm && seatToConfirm.Number
                        && row.cols && row.cols.some(function (c) { return c && c.Number === seatToConfirm.Number; });
                };
            }
        };
    });
})();
var Core;
(function (Core) {
    var SelectedFlight = /** @class */ (function () {
        function SelectedFlight($routeParams, $scope, baggageService, basketService, basketStore, broker, occupancyService, preferences, tripService) {
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.baggageService = baggageService;
            this.basketService = basketService;
            this.basketStore = basketStore;
            this.broker = broker;
            this.occupancyService = occupancyService;
            this.preferences = preferences;
            this.tripService = tripService;
            if (this.$routeParams.tripId) {
                this._init(this.$routeParams.tripId);
            }
            else if (this.tripId) {
                this._init(this.tripId);
            }
            else {
                return;
            }
        }
        SelectedFlight.prototype._init = function (tripId) {
            var _this = this;
            this.preferences.get('priceMode').then(function (p) {
                _this.priceMode = p;
            });
            this.addingFlight = this.basketStore.addingFlight();
            this.noFlight = false;
            this.detailExpanded = false;
            this.buttonType = this.showButton ? 'keep' : 'none';
            this.tripService.usePackageRates(tripId).then(function (packagePrice) {
                _this.detailOpen = TRPCONFIG.Domain.isAgentMode
                    || TRPCONFIG.Domain.FlightDetailsExpanded
                    || TRPCONFIG.Domain.BestFitFlightSelection
                    || packagePrice;
                _this.isPackagePrice = packagePrice;
            });
            this.tripService.getTrip(tripId).then(function (trip) {
                var basketId = trip.BasketId;
                _this.basketService.getFlight(basketId).then(function (flight) {
                    if (flight) {
                        _this.flight = flight.Details.Itinerary;
                        _this._updateFlightWithTrip(trip);
                        _this.flight.DepositAllowed = !_.isEmpty(flight.FuturePayments);
                        _this._flightCost(trip);
                        _this._hasBaggage(trip, _this.flight);
                        _this.oneWayOnly = _this.flight.Legs.length === 1;
                    }
                    else {
                        _this.noFlight = true;
                    }
                });
                //we need to listen out for the flight to be ready here as well as requesting it directly because
                //it might be in the process of being added to the basket
                _this.broker.subscribe('SelectedFlight', 'flightAddedToBasket', function (f) {
                    _this.flight = f.data.Details.Itinerary;
                    _this.tripService.getTrip(tripId).then(_this._updateFlightWithTrip.bind(_this));
                    _this._flightCost(trip);
                    _this._hasBaggage(trip, _this.flight);
                });
                _this.broker.subscribe('SelectedFlight', 'basketUpdated', _.debounce(function () {
                    _this._flightCost(trip);
                    _this._hasBaggage(trip, _this.flight);
                }, 100));
                _this.broker.subscribe('SelectedFlight', 'priceModeChanged', function (event) {
                    _this.priceMode = event.data;
                });
                _this.$scope.$on('$destroy', function () {
                    _this.broker.unsubscribe('SelectedFlight');
                });
            });
        };
        SelectedFlight.prototype.keepFlight = function (params) {
            if (TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                return this.basketService.changeJourneyUrl(40, this.tripId);
            }
            var opts = {
                bags: this.flight.bags,
                maxbags: this.occupancyService.getNumberOfNonInfantPassengers() || 1,
            };
            return this.basketService.selectFlight(this.flight, this.$routeParams.tripId, opts, this.$routeParams);
        };
        SelectedFlight.prototype._updateFlightWithTrip = function (trip) {
            var selectedFlight = _.get(trip, 'FlightsRequest.SelectedFlight');
            if (selectedFlight) {
                this.flight.FlightId = selectedFlight.FlightId;
                this.flight.LeadAdultPrice = selectedFlight.LeadAdultPrice;
                this.flight.LeadAdultTax = selectedFlight.LeadAdultTax;
                this.flight.LeadBaggagePrice = selectedFlight.LeadBaggagePrice;
                this.flight.AllBagsOrNone = selectedFlight.AllBagsOrNone;
                this.flight.PriorityForPreSelection = selectedFlight.PriorityForPreSelection;
            }
        };
        SelectedFlight.prototype.flightImage = function (fallback) {
            if (!this.flight) {
                return fallback + " ...";
            }
            var count = 0;
            var images = '';
            var img = '<img src="/build/img/Airline/Small/{0}" />';
            this.flight.AirlineImages.forEach(function (i) {
                if (count < 3) {
                    images += String.format(img, i);
                    count++;
                }
            });
            return images;
        };
        SelectedFlight.prototype._flightCost = function (trip) {
            var _this = this;
            this.basketStore.flightCost(trip.BasketId).then(function (c) {
                _this.tripService.getTripReducedOccupancy(trip.TripId).then(function (passengers) {
                    var totalPassengers = _.get(passengers, 'Adults', 0)
                        || _this.occupancyService.getNumberOfNonInfantPassengers();
                    _this.totalFlightCost = c;
                    _this.flightCostPerPerson = c / totalPassengers;
                    _this.addingFlight = false;
                });
            });
        };
        SelectedFlight.prototype._hasBaggage = function (trip, flight) {
            if (flight) {
                this.baggageService.getBaggageInfo(trip.TripId).then(function (bagInfo) {
                    flight.Legs.forEach(function (l, i) {
                        if (l.BagsIncludedCount > 0) {
                            //this means that the leg already comes with bags
                            //(though we may not have known this at the time we selected the flight
                            l.passengerBagCount = l.BagsIncludedCount;
                        }
                        else {
                            //if the leg does not include baggage, we use the number of bags that
                            //the user has currently selected
                            l.passengerBagCount = bagInfo[i]
                                ? bagInfo[i].holdBagCount
                                : bagInfo[0] && bagInfo[0].holdBagCount || 0;
                        }
                    });
                });
            }
        };
        SelectedFlight.prototype.toggleDetail = function () {
            this.detailOpen = !this.detailOpen;
        };
        ;
        SelectedFlight.prototype.expandDetail = function () {
            this.detailExpanded = !this.detailExpanded;
        };
        ;
        SelectedFlight.prototype.showDetails = function () {
            this.broker.publish('showModalFlightDetails', { flight: this.flight });
        };
        ;
        return SelectedFlight;
    }());
    angular
        .module('TR')
        .directive('selectedFlight', function () {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: SelectedFlight,
            controllerAs: 'sf',
            bindToController: {
                expanded: '=',
                showButton: '=',
                showChangeFlight: '=',
                displayAlternative: '=',
                changeFlightTracking: '=',
                trackingPage: '@',
                tripId: '=?',
                skipRedirectionUpgradeFare: '=?',
                showBrandedFareTypes: '=?'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedFlight',
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('seoRoomGrid', function (hotelRoomService) {
        return {
            restrict: 'E',
            scope: {
                hotel: '=',
                seoRoomsLanding: '=',
                seoRoomLoader: '=',
                seoHideRooms: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=SeoRoomGrid',
            link: function ($scope, $element) {
                var modalInner = null;
                var modalOuter = null;
                var lastFocus = null;
                var hotelTitle = $scope.hotel.Title;
                var SeoRoomsLanding = $scope.seoRoomsLanding;
                var filteredRooms = SeoRoomsLanding.map(function (room) {
                    var SeoImgUrl = hotelRoomService.getImageUrl(room) || '';
                    return __assign({}, room, { SeoImgUrl: SeoImgUrl });
                }).filter(function (room) { return room && !room.Title.toLowerCase().startsWith('x'); });
                $scope.roomDetails = filteredRooms;
                if (filteredRooms.length === 0) {
                    $scope.seoHideRooms = true;
                }
                function fetchRoomDetails() {
                    return __awaiter(this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, filteredRooms];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    });
                }
                function handleError(err) {
                    console.log('Seo room details not fetched.');
                    console.log(err);
                }
                function initRoomModal() {
                    return __awaiter(this, void 0, void 0, function () {
                        function handleCloseModalBtn(event) {
                            var isClosebutton = event.target.classList.contains('close');
                            lastFocus.setAttribute('aria-pressed', false);
                            modalInner.removeAttribute('role');
                            modalInner.removeAttribute('aria-label');
                            modalInner.removeAttribute('tab-index');
                            event.target.setAttribute('aria-hidden', true);
                            if (isClosebutton) {
                                closeModal();
                            }
                        }
                        function handleClickOutsideCloseModal(event) {
                            var isOutside = !event.target.closest('.modal-inner');
                            if (isOutside) {
                                closeModal();
                            }
                        }
                        function handleCloseModalKeyPress(event) {
                            if (event.key === 'Escape' || event.keyCode === 27) {
                                closeModal();
                            }
                        }
                        var RoomDetails, element, roomCards;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, fetchRoomDetails().catch(handleError)];
                                case 1:
                                    RoomDetails = _a.sent();
                                    if (!RoomDetails.length) {
                                        return [2 /*return*/];
                                    }
                                    $scope.seoRoomLoader = false;
                                    element = $element[0];
                                    roomCards = element.querySelectorAll('.sc-c-box');
                                    modalInner = element.querySelector('.modal-inner');
                                    modalOuter = element.querySelector('.modal-outer');
                                    modalInner.setAttribute('role', 'dialog');
                                    modalInner.setAttribute('aria-label', 'Enter Dialogue');
                                    modalInner.setAttribute('tab-index', 0);
                                    _.forEach(roomCards, function (button) {
                                        var moreInfoLink = button.querySelector('.sc-c-box__body--room-info');
                                        if (moreInfoLink) {
                                            moreInfoLink.addEventListener('click', handleCardButtonClick);
                                        }
                                    });
                                    _.forEach(roomCards, function (button) {
                                        var showPricesButton = button.querySelector('.sc-c-button--accent');
                                        if (showPricesButton) {
                                            showPricesButton.addEventListener('click', scrollToSearch);
                                        }
                                    });
                                    modalOuter.addEventListener('click', handleClickOutsideCloseModal);
                                    modalOuter.addEventListener('click', handleCloseModalBtn);
                                    window.addEventListener('keydown', handleCloseModalKeyPress);
                                    $scope.$on('$destroy', function () {
                                        _.forEach(roomCards, function (button) {
                                            var moreInfoLink = button.querySelector('.sc-c-box__body--room-info');
                                            if (moreInfoLink) {
                                                moreInfoLink.removeEventListener('click', handleCardButtonClick);
                                            }
                                        });
                                        _.forEach(roomCards, function (button) {
                                            var showPricesButton = button.querySelector('.sc-c-button--accent');
                                            if (showPricesButton) {
                                                showPricesButton.removeEventListener('click', scrollToSearch);
                                            }
                                        });
                                        modalOuter.removeEventListener('click', handleCloseModalBtn);
                                        modalOuter.removeEventListener('click', handleClickOutsideCloseModal);
                                        window.removeEventListener('keydown', handleCloseModalKeyPress);
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
                initRoomModal();
                function handleCardButtonClick(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    modalInner.innerHTML = '';
                    lastFocus = event.target;
                    var link = event.target;
                    link.setAttribute('aria-pressed', true);
                    var card = link.closest('.sc-c-box');
                    var cardContent = card.querySelector('.sc-c-box__content--js');
                    var imgSrc = cardContent.querySelector('img') && cardContent.querySelector('img').src;
                    var bodyContent = cardContent.querySelector('.sc-c-box__body-text') && cardContent.querySelector('.sc-c-box__body-text').textContent;
                    var name = card.querySelector('h2').textContent;
                    var modalName = card.querySelector('.sc-c-box__body--room-info').textContent;
                    var imgSrcEl = (imgSrc) ? "<img src=\"" + imgSrc + "\" class=\"sc-c-box__image\" aria-label=\"" + hotelTitle + " - " + name + "\" title=\"" + hotelTitle + " - " + name + "\" alt=\"" + hotelTitle + " - " + name + "\" itemprop=\"photo\" />" : '';
                    var descEl = (bodyContent) ? "<div class=\"sc-c-box__body-text\" itemprop=\"description\">" + bodyContent + "</div>" : '';
                    // populate the modal with the new info
                    modalInner.innerHTML = "\n                        <div class=\"sc-c-box\">\n                            <h2 class=\"sc-c-box__header\" aria-label=\"" + modalName + "\"><span>" + modalName + "</span><button type=\"button\" class=\"close\" aria-label=\"Close\" aria-hidden=\"false\" aria-disabled=\"false\" tabindex=\"0\">&times;</button></h2>\n                            <div class=\"sc-c-box__content-container\" itemscope itemtype=\"http://schema.org/HotelRoom\">\n                                <div class=\"sc-c-box__content\">\n                                <h3 aria-label=\"" + name + "\" itemprop=\"name\">" + name + "</h3>\n                                </div>\n                                <div class=\"sc-c-box__content sc-c-box__content--flex sc-c-box__content--alignTop\">\n                                    " + imgSrcEl + "\n                                    " + descEl + "\n                                </div>\n                            </div>\n                        </div>\n                        ";
                    // show the modal
                    modalOuter.classList.add('open');
                }
                function scrollToSearch() {
                    var searchBox = document.querySelector('.integrated-search-unit') || document.querySelector('.search-unit');
                    var scrollIntoViewOptions = {
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    };
                    searchBox.scrollIntoView(scrollIntoViewOptions);
                }
                function closeModal() {
                    lastFocus.focus();
                    modalOuter.classList.remove('open');
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('similarHotels', SimilarHotels);
    function SimilarHotels(hotelService) {
        return {
            restrict: 'E',
            scope: {
                hotel: '=',
                similarHotelsLoader: '=',
                showSimilarHotels: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=SimilarHotelGrid',
            link: function ($scope, $element) {
                $scope.similarHotels = {};
                function getSimilarHotelsInfo(_a) {
                    var Id = _a.Id;
                    return __awaiter(this, void 0, void 0, function () {
                        var SimilarHotels_1, elem, similarHotels, err_5;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, hotelService.getSimilarHotels(Id)];
                                case 1:
                                    SimilarHotels_1 = _b.sent();
                                    elem = $element[0];
                                    if (!SimilarHotels_1.length) {
                                        elem.classList.add('u-hidden');
                                    }
                                    if (!SimilarHotels_1.length) {
                                        return [2 /*return*/];
                                    }
                                    $scope.showSimilarHotels = true;
                                    $scope.similarHotelsLoader = false;
                                    similarHotels = SimilarHotels_1.map(function (hotel) {
                                        var SubTitle = hotel.Province + ", " + hotel.Location;
                                        var AltText = hotel.Title + ", " + SubTitle + ", " + hotel.Country;
                                        var TitleText = hotel.Title + ", " + SubTitle + ", " + hotel.Country;
                                        var AriaLabel = hotel.Title + ", " + SubTitle + ", " + hotel.Country;
                                        var ImgSrcUrl = "https://hi-cdn.t-rp.co.uk/images/hotels/" + hotel.Id + "/0?width=400&amp;height=225&amp;crop=true";
                                        return __assign({}, hotel, { SubTitle: SubTitle, AriaLabel: AriaLabel, AltText: AltText, TitleText: TitleText, ImgSrcUrl: ImgSrcUrl });
                                    });
                                    $scope.similarHotels = similarHotels;
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_5 = _b.sent();
                                    $scope.showSimilarHotels = false;
                                    $scope.similarHotelsLoader = false;
                                    console.log('Similar Hotel details not fetched.');
                                    console.log(err_5);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                }
                getSimilarHotelsInfo($scope.hotel);
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('slider', slider);
    function slider() {
        return {
            restrict: 'A',
            scope: {
                config: '=',
                model: '=',
                dual: '@',
                range: '@',
                step: '@',
                showLabel: '@',
                slidecomplete: '&',
            },
            link: function (scope, elem, attrs) {
                var modelWatcher;
                var setSliderPosition;
                var dual = attrs.dual === 'true';
                var showLabel = attrs.showLabel === 'true';
                var configWatcher = scope.$watch('config', function (config) {
                    if (!_.isEmpty(config)) {
                        configWatcher();
                        var setup = {
                            range: attrs.range,
                            dual: dual,
                            step: parseFloat(scope.step),
                            min: config.Min,
                            max: config.Max,
                            edgesBecomeNull: config.edgesBecomeNull || {},
                            slide: function (event, ui) {
                                scope.$apply(function () {
                                    scope.model = dual ? ui.model : _.get(ui.model, 'Min', null);
                                });
                            },
                            stop: function () {
                                scope.$apply(function () { return scope.slidecomplete(); });
                            }
                        };
                        setSliderPosition = $(elem).rtlSlider(setup);
                        watchModel();
                    }
                }, true);
                function watchModel() {
                    modelWatcher && modelWatcher();
                    modelWatcher = scope.$watch('model', function (val, old) {
                        if (setSliderPosition.hasBeenCalled && angular.equals(val, old)) {
                            return;
                        }
                        var model = angular.isNumber(val) ? { Min: val, Max: val, } : val;
                        setSliderPosition(model);
                        setSliderPosition.hasBeenCalled = true;
                        if (showLabel) {
                            $(elem).children().text(val);
                        }
                    }, true);
                }
            }
        };
    }
})();
var Core;
(function (Core) {
    var StarRating = /** @class */ (function () {
        function StarRating($scope) {
            var _this = this;
            this.$scope = $scope;
            this.$scope.$watch('sr.rating', function (val) {
                // create array of icon class names to iterate
                _this.stars = _.map(new Array(_this.rating), function (v, idx) {
                    return 'icon-star';
                });
            });
        }
        return StarRating;
    }());
    angular
        .module('core')
        .directive('starRating', function () {
        return {
            scope: {},
            controller: StarRating,
            controllerAs: 'sr',
            bindToController: {
                rating: '='
            },
            template: "<span class=\"star-rating\">\n                                <i class=\"{{r}}\" ng-repeat=\"r in sr.stars track by $index\"></i>\n                            </span>",
            replace: true
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('staticBreadcrumb', function ($rootScope, arrayUtil, $location, currentDestination, urlUtils, pageStrand, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=StaticBreadcrumb',
            replace: true,
            link: function (scope, element) {
                currentDestination.getCurrentDestination().then(function (dest) {
                    if (dest == null || dest.BreadcrumbTrail == null) {
                        return;
                    }
                    scope.class = function (index) {
                        return index === dest.BreadcrumbTrail.length - 1 ? 'active' : '';
                    };
                    scope.category = dest.PageStrand;
                    scope.categoryRoute = pageStrand.toRoute(dest.PageStrand);
                    scope.show = dest.BreadcrumbTrail != null;
                    scope.crumbs = arrayUtil.numberArray(0, dest.BreadcrumbTrail.length - 1);
                    scope.text = function (index) {
                        return dest.BreadcrumbTrail[index].Title;
                    };
                    scope.getUrl = function (index, full) {
                        var d = dest.BreadcrumbTrail[index];
                        if (full) {
                            return $location.absUrl();
                        }
                        return urlUtils.stripLeadingSlash(d.PagePath);
                    };
                    scope.click = function (index, event) {
                        event.preventDefault();
                        event.stopPropagation();
                        if (index >= dest.BreadcrumbTrail.length - 1) {
                            return; //we would just end up where we already are in that case.
                        }
                        $location.url(scope.getUrl(index));
                    };
                    $timeout(function () {
                        var wrapperClass = 'sc-c-breadcrumb-scroller';
                        var wrapper = element.hasClass(wrapperClass) ? element : element.find("." + wrapperClass);
                        var activeCrumb = element.find('.is-active');
                        var wrapperOffsetLeft = _.get(wrapper, '[0].offsetLeft');
                        var crumbsOffsetLeft = _.get(activeCrumb, '[0].offsetLeft');
                        var offsetPosition = crumbsOffsetLeft - wrapperOffsetLeft;
                        if (crumbsOffsetLeft && offsetPosition) {
                            wrapper[0].scrollLeft = offsetPosition;
                        }
                    }, 1000);
                });
            }
        };
    });
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('staticMap', staticMap);
    function staticMap(googleStaticMap, $window, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                lon: '=',
                lat: '=',
                width: '@',
                height: '@',
                zoom: '=?',
                click: '&?',
                showMarker: '@?',
                class: '@?',
                responsive: '@?'
            },
            template: function () {
                return '<div class="google-map" gtm-namespace="google-map" ng-transclude ng-style="{\'background-image\' : \'url(\' + mapUrl + \')\'}" ng-click="click()" ng-class="{clickable: click !== null}" ></div>';
            },
            transclude: true,
            link: function (scope, element) {
                scope.$watch('lon', function (v) {
                    if (v == null) {
                        return;
                    }
                    init();
                });
                function init() {
                    if (TRPCONFIG.IsBot) {
                        return;
                    }
                    function loadMapLazy() {
                        if (!scope.responsive) {
                            scope.width *= 1.5;
                            scope.height *= 1.5;
                        }
                        var baseUrl = 'https://maps.googleapis.com/maps/api/staticmap?';
                        var zoom = "zoom=" + (scope.zoom || 15);
                        var center = "&center=" + encodeURIComponent(scope.lat + "," + scope.lon);
                        var size = "&size=" + scope.width + "x" + scope.height;
                        var markers = "&markers=" + encodeURIComponent(scope.lat + "," + scope.lon);
                        var client = '&client=gme-travelrepublic';
                        var url = baseUrl + zoom + center + size + client;
                        if (scope.showMarker) {
                            url += url.concat(markers);
                        }
                        scope.mapUrl = '';
                        googleStaticMap.getStaticMapUrl(url)
                            .then(function (data) {
                            $timeout(function () { return scope.mapUrl = data; });
                        });
                    }
                    var win = $($window);
                    function isScrolledIntoView(elem) {
                        var docViewTop = win.scrollTop();
                        var docViewBottom = docViewTop + win.height();
                        var elemTop = elem.offset().top;
                        var elemBottom = elemTop + elem.height();
                        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
                    }
                    var deb = _.debounce(function () {
                        var el = $(element);
                        if (!isScrolledIntoView(el)) {
                            return false;
                        }
                        win.off('scroll', deb);
                        loadMapLazy();
                    }, 100);
                    deb();
                    win.on('scroll', deb);
                }
            }
        };
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('sticky', function ($window, scrollService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                customClass: '@',
                specificPosition: '@'
            },
            template: '<div ng-style="style" ng-transclude></div>',
            link: function (scope, element) {
                scope.style = {};
                var isStuck = false;
                var contentY = 0; //to track the position of the element before we changed it's style
                function stick() {
                    if (scope.customClass) {
                        if (scope.specificPosition) {
                            // apply custom class and fade in
                            element
                                .stop()
                                .css({ opacity: 0 })
                                .addClass(scope.customClass)
                                .animate({ opacity: 1 }, 300);
                        }
                        else {
                            // just apply custom class
                            element.addClass(scope.customClass);
                        }
                    }
                    else {
                        scope.style = { position: 'fixed', top: '0', width: element.width() + "px" };
                    }
                    isStuck = true;
                }
                function unstick() {
                    if (scope.customClass) {
                        if (scope.specificPosition) {
                            // fade out and remove custom class
                            element
                                .stop()
                                .animate({ opacity: 0 }, 300, function () {
                                element.removeClass(scope.customClass);
                            });
                        }
                        else {
                            // just remove custom class
                            element.removeClass(scope.customClass);
                        }
                    }
                    else {
                        scope.style = {};
                    }
                    isStuck = false;
                }
                function checkPosition() {
                    var scrollY = scrollService.getScrollOffsets($window).y;
                    if (scope.specificPosition) {
                        if (!isStuck && scrollY >= scope.specificPosition) {
                            scope.$apply(function () { stick(); });
                        }
                        else if (isStuck && scrollY < scope.specificPosition) {
                            scope.$apply(function () { unstick(); });
                        }
                    }
                    else {
                        var origContentY_1 = element.offset().top; //get actual position
                        if (!isStuck && scrollY > origContentY_1) {
                            scope.$apply(function () {
                                stick();
                                contentY = origContentY_1;
                            });
                        }
                        else if (isStuck && scrollY < contentY) {
                            scope.$apply(function () {
                                unstick();
                            });
                        }
                    }
                }
                $(window).on('scroll.sticky', checkPosition);
                scope.$on('$destroy', function () {
                    $(window).off('scroll.sticky');
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('strandSwap', function ($route, urlUtils, destinationService, $location, pageStrand, currentDestination, $routeParams, resourceService, v2v3HandoverService) {
        function oppositeUrl(path, oppStrand, isEstab) {
            if (isEstab) {
                if ($routeParams.landingPageV2) {
                    var matches = $routeParams.landingPageV2.match(/(\d+-\d+)-?(\d+)?/) || [];
                    var strandParam = matches[2];
                    //if the strand param is 1, remove it
                    if (strandParam === '1') {
                        return matches[1] + "/" + $routeParams.urlText;
                    }
                    //if the strand param is absent or something other than 1, add 1 or replace it with 1
                    return matches[1] + "-1/" + $routeParams.urlText;
                }
                return urlUtils.stripLeadingSlash(pageStrand.adjustUrl(path, oppStrand));
            }
            return path;
        }
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=StrandSwap',
            scope: {
                hideIcon: '@',
                holidayMessage: '@',
                button: '='
            },
            link: function (scope) {
                currentDestination.getCurrentDestination().then(function (dest) {
                    var isEstab = destinationService.destinationIsEstab(dest);
                    scope.strand = dest.PageStrand;
                    scope.holidayEnabled = dest.HolidayEnabled;
                    scope.active = function (ps) {
                        return ps === scope.strand ? 'active' : '';
                    };
                    var oppStrand = pageStrand.opposite(scope.strand);
                    if (isEstab) {
                        scope.altStrandUrl = oppositeUrl(dest.PagePath, oppStrand, isEstab);
                    }
                    else {
                        destinationService.getDetails(dest, undefined, { pageStrandOverride: oppStrand }).then(function (d) {
                            dest = _.assign({}, dest, d);
                            var targetPath = d.PagePath;
                            var redirectEstabLandingPath = v2v3HandoverService.redirectEstabLandingPath(targetPath);
                            var redirectDestLandingPath = v2v3HandoverService.redirectDestLandingPath(targetPath);
                            if (TRPCONFIG.IsMobileDevice && dest.PageStrand === 2) {
                                scope.altStrandUrl = 'holidays';
                            }
                            if (redirectDestLandingPath || redirectEstabLandingPath) {
                                scope.altStrandUrl = urlUtils.stripLeadingSlash(d.PagePath);
                            }
                            else {
                                scope.altStrandUrl = urlUtils.stripLeadingSlash(urlUtils.appendExistingQueryString(d.PagePath));
                            }
                        });
                    }
                    scope.toggle = function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        $location.url(scope.altStrandUrl);
                        if (isEstab) {
                            //this will not cause a reload because the route is set to prevent that so we need to force a reload
                            $route.reload();
                        }
                    };
                    scope.pageStrandEquals = function (ps) { return scope.strand ? scope.strand === ps : undefined; };
                    scope.message =
                        scope.pageStrandEquals(1) ? resourceService.get('LOOKINGFORFLIGHTSANDHOTEL') :
                            scope.pageStrandEquals(2) ? (scope.holidayMessage || resourceService.get('LOOKINGFORHOTEL')) :
                                null;
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('strengthGauge', function (resourceService) {
        return {
            restrict: 'A',
            link: function (scope, el) {
                el.addClass('strength-gauge');
                el.append('<div class="text"></div>');
                el.append('<div class="status"><span /><span /><span /><span /><span /><span /></div>');
                scope.$on('passwordStrength', function (ev, data) {
                    el.find('.text').text(resourceService.get(data.label));
                    el.find('.status').removeClass().addClass("status " + data.label).find('span').each(function (i, elem) {
                        if (i < data.strength) {
                            $(elem).addClass('on');
                        }
                        else {
                            $(elem).removeClass();
                        }
                    });
                });
            }
        };
    });
})();
/*
  Tabset and Tab directives
  i.e.
    <tabset>
        <tab heading="Tab1"> ... </tab>
        ...
    </tabset>
*/
var TR;
(function (TR) {
    var isMobile = TRPCONFIG.DeviceCategory === 'Phone';
    var Tabset = /** @class */ (function () {
        function Tabset($scope, $element, $location, cmsUtils) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.$location = $location;
            this.cmsUtils = cmsUtils;
            this.nextIndex = 0;
            this.tabs = [];
            this.denyAnim = false;
            this.qsTags = this.$location.search();
            // Add placeholders to avoid very wide tabs
            var minTabs = this.minTabs ? parseInt(this.minTabs, 10) : 3;
            while (minTabs--) {
                var placeholder = new Tab();
                placeholder.isPlaceholder = true;
                this.tabs.push(placeholder);
            }
            if (this.externalTriggers === 'true') {
                $scope.$watch(function () { return _this.activeTabId; }, function (val) {
                    if (val) {
                        var foundTab = _.find(_this.tabs, function (tab) { return tab.tabId === val; });
                        if (foundTab) {
                            _this.select(foundTab);
                        }
                    }
                });
            }
        }
        // Don't open tab automatically on mobile, but inherit from attributes
        Tabset.prototype._isDeniedInitActivation = function () {
            if (this.hasOwnProperty('denyInitActivation')) {
                return this.denyInitActivation === 'true';
            }
            return isMobile;
        };
        Tabset.prototype.addTab = function (tab) {
            var index = this.nextIndex++;
            if (this.tabs[index]) {
                this.tabs[index] = tab; // Overwrite
                if (!this._isDeniedInitActivation() && index === 0) {
                    tab.active = true;
                }
            }
            else {
                this.tabs.push(tab);
            }
            // Select tab if `productOption` attr is matched in query string
            if (!this._isDeniedInitActivation() && this.isActiveProductOption(tab.productOption)) {
                this.select(tab);
            }
        };
        Tabset.prototype.isActiveProductOption = function (productOption) {
            return this.cmsUtils.propsMatch(this.qsTags, productOption);
        };
        Tabset.prototype.select = function (selectedTab) {
            angular.forEach(this.tabs, function (tab) {
                if (tab.active && tab !== selectedTab) {
                    tab.active = false;
                }
            });
            selectedTab.active = true;
            this.activeTabId = selectedTab.tabId;
        };
        return Tabset;
    }());
    var Tab = /** @class */ (function () {
        function Tab(broker, cmsUtils) {
            var _this = this;
            this.broker = broker;
            this.cmsUtils = cmsUtils;
            this.active = false;
            this.isPlaceholder = false;
            // Sync tabs to attractions product form on desktop only
            if (!isMobile && this.productOption) {
                this.broker.subscribe('tab' + angular.toJson(this.productOption), 'attractionsProductUpdate', _.debounce(function (e) {
                    if (_this.cmsUtils.propsMatch(e.data, _this.productOption)) {
                        _this.show(null, true, true, true);
                    }
                }, 100));
            }
        }
        Tab.prototype.show = function (event, noAnim, // Only applies in accordion view
        noClose, noPublish // Avoid infinite loop from other events
        ) {
            if (noAnim === void 0) { noAnim = false; }
            if (noClose === void 0) { noClose = false; }
            if (noPublish === void 0) { noPublish = false; } // Avoid infinite loop from other events
            if (event) {
                event.preventDefault();
            }
            if (!this.isPlaceholder) {
                this.parentCtrl.denyAnim = noAnim;
                if (!noClose && this.active) {
                    this.active = false;
                }
                else {
                    this.parentCtrl.select(this);
                    if (!noPublish && this.productOption) {
                        this.broker.publish('tabProductOptionSelected', this.productOption);
                    }
                }
            }
        };
        return Tab;
    }());
    angular
        .module('TR')
        .directive('tabset', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {},
            controller: Tabset,
            controllerAs: 'ts',
            bindToController: {
                headline: '@',
                externalTriggers: '@',
                templateOverride: '@',
                minTabs: '@',
                activeTabId: '=?',
                denyInitActivation: '@?'
            },
            templateUrl: function (element, attrs) {
                return 'partials/home/directivetemplate?type=' + (attrs.templateOverride || 'TabSet');
            },
        };
    })
        .directive('tab', function ($timeout) {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {},
            controller: Tab,
            controllerAs: 'tb',
            require: '^tabset',
            bindToController: {
                heading: '@',
                imageUrl: '@',
                tabId: '@',
                productOption: '=',
                icon: '@',
                eventCategory: '@',
                eventAction: '@',
                eventLabel: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=Tab',
            link: function (scope, el, attr, tabsetCtrl) {
                scope.tb.parentCtrl = tabsetCtrl;
                tabsetCtrl.addTab(scope.tb);
                // Accordion animation
                $timeout(function () {
                    var inlineTabBtn = el.find('.tab-button-inline'), contentEl = el.find('.tab-content');
                    if (contentEl.length) {
                        scope.$watch('tb.active', function (isActive) {
                            var isAnim = inlineTabBtn.is(':visible') && !tabsetCtrl.denyAnim;
                            if (isAnim) {
                                contentEl.animate({ height: isActive ? contentEl[0].scrollHeight : 0 }, 120, isActive ? function () {
                                    var tabTop = inlineTabBtn.offset().top;
                                    // Set height back to 'auto' after expand anim
                                    contentEl.height('auto');
                                    // Ensure tab is on screen (also customer for any sticky elements)
                                    var stickyOffset = $('.sticky-wrapper').toArray().reduce(function (offset, el) {
                                        return Math.max($(el).outerHeight(), offset);
                                    }, 0);
                                    /// On mobile we need to take into customer also the fixed header.
                                    var $header = $('.header-main');
                                    var headerOffset = 0;
                                    if ('fixed' === $header.css('position')) {
                                        headerOffset = $header.outerHeight();
                                    }
                                    if (tabTop < $(document).scrollTop() + stickyOffset + headerOffset) {
                                        $(document).scrollTop(tabTop - stickyOffset - headerOffset);
                                    }
                                } : undefined);
                            }
                            else {
                                contentEl.height(isActive ? 'auto' : 0);
                            }
                        });
                    }
                });
            }
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('textCropper', function ($anchorScroll) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                text: '=',
                htmlSupport: '@',
                maxlength: '@',
                showMoreText: '@',
                showLessText: '@',
                expanded: '@',
                preventCollapse: '=',
                id: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=TextCropper',
            link: function (scope) {
                scope.maxlength = parseInt(scope.maxlength || 0);
                scope.htmlSupport = scope.htmlSupport === 'true';
                scope.showMore = scope.expanded === 'true';
                scope.more = function (e) {
                    e.preventDefault();
                    scope.showMore = true;
                };
                scope.less = function (e) {
                    e.preventDefault();
                    if (!scope.preventCollapse) {
                        scope.showMore = false;
                        scope.scroll();
                    }
                };
                scope.scroll = function () {
                    var el = document.getElementsByClassName('header-wrapper');
                    if (el.length !== 0) {
                        if (scope.id) {
                            $anchorScroll.yOffset = (el[0].clientHeight * 2);
                            $anchorScroll(scope.id);
                        }
                    }
                };
                scope.splitText = function () {
                    // split the original text into visible and hidden parts
                    var visibleText;
                    var stop = scope.text.lastIndexOf(' ', scope.maxlength);
                    if (stop > 0 && stop <= scope.maxlength) {
                        visibleText = $.trim(scope.text.slice(0, stop));
                    }
                    var lastChar = visibleText.charAt(visibleText.length);
                    if (lastChar === '.' || lastChar === ',') {
                        visibleText = visibleText.slice(0, -1);
                        stop--;
                    }
                    scope.visiblePart = visibleText;
                    scope.hiddenPart = scope.text.slice(stop);
                };
                scope.splitHtml = function () {
                    var currentPosition = 0;
                    scope.visiblePart = scope.hiddenPart = '';
                    scope.htmlContent.children().each(function (i, el) {
                        if (currentPosition + el.textContent.length >= scope.maxlength) {
                            scope.hiddenPart = scope.htmlContent.children().slice(i).toArray().reduce(function (content, el) { return content + (el.outerHTML || el.textContent); }, '');
                            return false;
                        }
                        scope.visiblePart += (el.outerHTML || el.textContent);
                        currentPosition += el.textContent.length;
                    });
                };
                scope.$watch('text', function (t) {
                    if (!t) {
                        return;
                    }
                    if (scope.htmlSupport) {
                        scope.htmlContent = $('<span/>').html(scope.text);
                    }
                    scope.cropping = (scope.htmlSupport ?
                        scope.htmlContent[0].textContent.length :
                        scope.text.length) > scope.maxlength;
                    if (scope.cropping) {
                        scope[scope.htmlSupport ? 'splitHtml' : 'splitText']();
                    }
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('threedsBridge', function ($http, $window, $rootScope, analytics) {
        var hidden = '<input type="hidden" name="{0}" value="{1}" />';
        return {
            restrict: 'E',
            scope: {
                challengeUrl: '='
            },
            template: '<iframe id="threeframe" name="threeframe" frameBorder="0" width="100%" height="550px"></iframe>',
            link: function (scope) {
                // var frame = angular.element('#threeframe');
                //id="challengeForm" method="post"
                /*function back() {
                    scope.$emit('3DSValidationCancelled');
                    $($window).off('popstate', back);
                }*/
                //evil global used to obtain the results from 3ds validation. There's not really any other way.
                $window.threed3Callback = function (paRes, prePaymentId, md, paymentId) {
                    //console.log('arguments', arguments);
                    if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                        paRes = paRes.replaceAll('^', '');
                        if (paRes === 'CANCELLED') {
                            scope.$emit('3DSValidationCancel');
                        }
                        else if (paRes !== 'CANCELLED') {
                            scope.$emit('3DSValidationComplete', {
                                paRes: paRes,
                                prePaymentId: prePaymentId,
                                md: md,
                                paymentId: paymentId
                            });
                        }
                        else {
                            document.querySelector('.threeds-wrapper-new .close').click();
                        }
                    }
                    else {
                        scope.$emit('3DSValidationComplete', {
                            paRes: paRes,
                            prePaymentId: prePaymentId,
                            md: md,
                            paymentId: paymentId
                        });
                    }
                };
                scope.$on('3DSValidationFinished', function (ev, isSuccess) {
                    if (!_.isEmpty(scope.mixpanelData)) {
                        analytics.track('mixpanel', (isSuccess ? '3DS Finished' : '3DS Failed'), scope.mixpanelData);
                    }
                });
                function getAuth(domainId, cardTypeId, currencyCode, orderCode) {
                    try {
                        if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                            cardTypeId = 370;
                        }
                        var url = "/api2/payments/transactions/getcpgclienttoken?domainId=" + domainId + "&cardTypeId=" + cardTypeId + "&currencyCode=" + currencyCode + "&orderCode=" + orderCode;
                        return fetch(url)
                            .then(function (res) { return res.json(); })
                            .then(function (data) {
                            var at = null;
                            if (data && data.AccessToken) {
                                at = data.AccessToken;
                            }
                            return at;
                        })
                            .catch(function (error) {
                            console.log('error', error);
                            return null;
                        });
                    }
                    catch (error) {
                        console.log('error', error);
                        return null;
                    }
                }
                scope.$on('request3DSValidation', function (ev, threedsData, mixpanelData) {
                    if (mixpanelData === void 0) { mixpanelData = {}; }
                    return __awaiter(this, void 0, void 0, function () {
                        var threeDsVersion, challengeUrl, actionUrl, secureForm, domainId, cardTypeId, currencyCode, orderCode, authToken;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    /* we can't do this as long as this bug is in effect:
                                    //https://github.com/angular/angular.js/issues/3924
                                    if($sniffer.history) {
                                        $window.history.pushState(null, '', $location.path());
                                        $($window).on('popstate', back);
                                    }
                                    */
                                    if (!_.isEmpty(mixpanelData)) {
                                        scope.mixpanelData = mixpanelData;
                                        analytics.track('mixpanel', '3DS Started', mixpanelData);
                                    }
                                    threeDsVersion = threedsData.ChallengeJWT !== '' && threedsData.ChallengeJWT !== 'ChallengeJWT' ? 2 : 1;
                                    challengeUrl = TRPCONFIG.Domain2.ThreeDS2ChallengeUrl;
                                    actionUrl = threeDsVersion === 2 ? challengeUrl : threedsData.AcsUrl;
                                    secureForm = angular.element(document.getElementById('threeform')).empty();
                                    secureForm.attr('target', 'threeframe');
                                    secureForm.attr('method', 'POST');
                                    secureForm.attr('action', actionUrl);
                                    secureForm.append(String.format(hidden, 'MD', threedsData.MD));
                                    secureForm.append(String.format(hidden, 'TermUrl', threedsData.TermUrl));
                                    secureForm.append(String.format(hidden, 'PaReq', threedsData.PaReq));
                                    secureForm.append(String.format(hidden, 'JWT', threedsData.ChallengeJWT));
                                    if (!TRPCONFIG.Domain2.UseCpgUpdate) return [3 /*break*/, 2];
                                    domainId = TRPCONFIG.Domain.DomainId;
                                    cardTypeId = TRPCONFIG.Domain.CardTypeId;
                                    currencyCode = TRPCONFIG.Domain.CurrencyCode;
                                    orderCode = threedsData.MD;
                                    return [4 /*yield*/, getAuth(domainId, cardTypeId, currencyCode, orderCode)];
                                case 1:
                                    authToken = _a.sent();
                                    secureForm.append(String.format(hidden, 'token', authToken));
                                    _a.label = 2;
                                case 2:
                                    secureForm[0].submit();
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('timePicker', function (dateUtil) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: function (element, attr) {
                var base = 'partials';
                if (attr.templateVersion) {
                    return base + "/booking/template?name=TimePicker&version=" + attr.templateVersion;
                }
                return base + "/home/directivetemplate?type=TimePicker";
            },
            scope: {
                value: '=',
                timeLabelKey: '@',
                timeErrorMessage: '@',
                currentDate: '=',
                maxDate: '=',
                minDate: '=',
                defaultTime: '=',
                isDisabled: '=',
                isTimeApprovedByCustomer: '=?',
                requiresTimeApproval: '=?',
                isRequired: '@'
            },
            controllerAs: 'tp',
            controller: function () {
                this.focusTrackerHours = {};
                this.focusTrackerMinutes = {};
            },
            link: function (scope) {
                var minuteSkip = 5;
                scope.value = {};
                scope.ownButton = scope.ownButton === 'true';
                scope.vm = {};
                function times(num1, num2, fn) {
                    for (var i = num1; i <= num2; i++) {
                        fn(i);
                    }
                }
                function frontPad(num) {
                    return num < 10 ? "0" + num : "" + num;
                }
                function roundMinutes(mins) {
                    if (scope.defaultTime && scope.defaultTime.minutes === mins) {
                        return mins;
                    }
                    return minuteSkip * Math.round(mins / minuteSkip) % 60;
                }
                scope.h = [];
                scope.m = [];
                if (scope.maxDate && scope.minDate && dateUtil.sameDay(scope.maxDate, scope.minDate)) {
                    times(scope.minDate.getHours(), scope.maxDate.getHours(), function (i) {
                        scope.h.push(frontPad(i));
                    });
                }
                else {
                    times(0, 23, function (i) {
                        scope.h.push(frontPad(i));
                    });
                }
                times(0, 11, function (i) {
                    var m = i * minuteSkip;
                    scope.m.push(frontPad(m));
                });
                if (scope.defaultTime && scope.defaultTime.minutes % minuteSkip) {
                    var i = 0;
                    while (i < scope.m.length) {
                        if (scope.m[i] > scope.defaultTime.minutes) {
                            break;
                        }
                        i++;
                    }
                    scope.m.splice(i, 0, frontPad(scope.defaultTime.minutes));
                }
                // `currentDate` may be initialised by parent scopes async
                var unwatchInit = scope.$watch('currentDate', function (v, o) {
                    if (v) {
                        //reset default time only if date has changed
                        var resetDefaultTime = true;
                        if (o) {
                            resetDefaultTime = !(dateUtil.sameDay(v, o));
                        }
                        var date = dateUtil.parseDate(v);
                        if (dateUtil.isValid(date)) {
                            setTime(date);
                            // set hour and minute range
                            //setMinuteRange();
                            if (scope.maxDate && scope.minDate) {
                                setMinuteRange();
                                setTimeRange(resetDefaultTime);
                            }
                            else {
                                // Remove watch on first value
                                unwatchInit();
                            }
                        }
                    }
                    else {
                        // Initialise with default
                        setDefaultTime();
                    }
                });
                scope.$watch(function () { return ({
                    isTimeApprovedByCustomer: scope.isTimeApprovedByCustomer,
                    requiresTimeApproval: scope.requiresTimeApproval,
                    vm: scope.vm,
                    value: scope.value
                }); }, function (next, old) {
                    var sync = function () {
                        if (next.vm.hours && next.vm.minutes && !angular.equals(next.vm, old.vm)) {
                            scope.vm.hours = scope.value.hours = next.vm.hours;
                            scope.vm.minutes = scope.value.minutes = next.vm.minutes;
                            return;
                        }
                        if (next.value.hours && next.value.minutes && !angular.equals(next.value, old.value)) {
                            scope.vm.hours = scope.value.hours = next.value.hours;
                            scope.vm.minutes = scope.value.minutes = next.value.minutes;
                        }
                    };
                    if (!next.requiresTimeApproval) {
                        sync();
                        return;
                    }
                    if (!next.isTimeApprovedByCustomer && !old.requiresTimeApproval) {
                        delete scope.vm.hours;
                        delete scope.value.hours;
                        delete next.vm.hours;
                        delete next.value.hours;
                        delete scope.vm.minutes;
                        delete scope.value.minutes;
                        delete next.vm.minutes;
                        delete next.value.minutes;
                        return;
                    }
                    scope.isTimeApprovedByCustomer = next.isTimeApprovedByCustomer || !!(next.vm.hours && next.vm.minutes);
                    if (scope.isTimeApprovedByCustomer) {
                        sync();
                    }
                }, true);
                function setDefaultTime() {
                    var date = new Date();
                    if (scope.defaultTime) {
                        date.setHours(scope.defaultTime.hours, scope.defaultTime.minutes);
                    }
                    else {
                        date.setHours(11, 30);
                    }
                    setTime(date);
                }
                function setTime(dateOb) {
                    scope.$evalAsync(function () {
                        scope.value.hours = frontPad(dateOb.getHours());
                        scope.value.minutes = frontPad(roundMinutes(dateOb.getMinutes()));
                    });
                }
                function setMinuteRange() {
                    scope.m = [];
                    var date = dateUtil.parseDate(scope.currentDate);
                    if (scope.minDate.getHours() === date.getHours()) {
                        times(scope.minDate.getMinutes() / minuteSkip, 11, function (i) {
                            var m = i * minuteSkip;
                            scope.m.push(frontPad(m));
                        });
                        scope.value.minutes = scope.minDate.getMinutes();
                    }
                    else if (scope.maxDate.getHours() === date.getHours()) {
                        times(0, scope.maxDate.getMinutes() / minuteSkip, function (i) {
                            var m = i * minuteSkip;
                            scope.m.push(frontPad(m));
                        });
                        scope.value.minutes = scope.maxDate.getMinutes();
                    }
                    else {
                        times(0, 11, function (i) {
                            var m = i * minuteSkip;
                            scope.m.push(frontPad(m));
                        });
                        scope.value.minutes = 0;
                    }
                }
                function setTimeRange(resetDefaultTime) {
                    if (!(dateUtil.sameDay(scope.maxDate, scope.minDate))) {
                        scope.h = [];
                        if (dateUtil.sameDay(scope.currentDate, scope.minDate)) {
                            times(scope.minDate.getHours(), 23, function (i) {
                                scope.h.push(frontPad(i));
                            });
                            if (resetDefaultTime) {
                                setTime(scope.minDate);
                            }
                        }
                        else if (dateUtil.sameDay(scope.currentDate, scope.maxDate)) {
                            times(0, scope.maxDate.getHours(), function (i) {
                                scope.h.push(frontPad(i));
                            });
                            if (resetDefaultTime) {
                                setTime(scope.maxDate);
                            }
                        }
                    }
                }
            }
        };
    });
})();
var Core;
(function (Core) {
    var ToggleSwitch = /** @class */ (function () {
        function ToggleSwitch() {
            this.restrict = 'E';
            this.replace = true;
            this.transclude = true;
            this.scope = {
                model: '=',
                leftVal: '=',
                rightVal: '=',
                leftLabel: '@',
                rightLabel: '@'
            };
            this.templateUrl = 'partials/home/directivetemplate?type=ToggleSwitch';
            this.link = function (scope) {
                scope.class = function () {
                    return scope.model === scope.rightVal ? 'on' : '';
                };
                scope.toggle = function () {
                    scope.model = (scope.model === scope.leftVal ? scope.rightVal : scope.leftVal);
                };
            };
        }
        ToggleSwitch.factory = function () {
            var directive = function () { return new ToggleSwitch(); };
            directive.$inject = [];
            return directive;
        };
        return ToggleSwitch;
    }());
    var TR = angular.module('TR');
    TR.directive('toggleSwitch', ToggleSwitch.factory());
})(Core || (Core = {}));
angular
    .module('TR')
    .directive('tokenisingField', function ($timeout, $window, $parse, $q, guidService, tokeniser, $rootScope, broker) {
    return {
        replace: true,
        require: 'ngModel',
        scope: {
            model: '=ngModel',
            tokenErrors: '=',
            focusTracker: '=',
            cls: '@',
            rootForm: '=',
            placeholder: '@',
            invalidMsg: '@',
            requiredMsg: '@',
            fieldType: '@',
            validateAs: '@',
            alwaysShowErrors: '=',
            maskModel: '=',
            manual: '=',
            onMask: '&',
            instantValidation: '='
        },
        templateUrl: function (el, attr) {
            if (attr.templateVersion) {
                return 'partials/booking/template?name=TokeniserFrame&version=' + attr.templateVersion;
            }
            return 'partials/home/directivetemplate?type=TokeniserFrame';
        },
        link: function ($scope, el, attr, controller) {
            var placeholder = attr.placeholder, fieldType = attr.fieldType, validateAs = attr.validateAs, clientId = guidService.uuid();
            var frame, deferred;
            if ($scope['manual']) {
                //if we're in manual mode, we need to register a tokenise function
                $scope.$on('$destroy', tokeniser.register(function (expiry) {
                    deferred = $q.defer();
                    postMessage({
                        type: 'gettoken',
                        expiry: expiry
                    });
                    return deferred.promise;
                }));
            }
            function parseMessage(ev) {
                try {
                    return JSON.parse(ev.data);
                }
                catch (err) {
                    return {};
                }
            }
            function receiveMessage(ev) {
                var msg = parseMessage(ev);
                if (msg.clientId === clientId) {
                    switch (msg.type) {
                        case 'blur':
                            // Can't use `$scope.$parent.ft` as overwritten each time
                            $scope['focusTracker'].ft.blurHandler();
                            broker.publish('pciFrameBlur');
                            break;
                        case 'focus':
                            $scope['focusTracker'].ft.focusHandler();
                            broker.publish('pciFrameFocus');
                            break;
                        case 'mask':
                            $scope.$evalAsync(function () {
                                $scope['tokenErrors'] = null;
                                $scope['maskModel'] = msg.mask;
                                if ($scope['onMask']) {
                                    $timeout(function () {
                                        $scope['onMask']();
                                    }, 0);
                                }
                            });
                            break;
                        case 'token':
                            $scope.$evalAsync(function () {
                                $scope['tokenErrors'] = null;
                                controller.$setViewValue(msg.token);
                                if (msg.mask) {
                                    $scope['maskModel'] = msg.mask;
                                }
                                if (deferred) {
                                    deferred.resolve();
                                }
                            });
                            break;
                        case 'error':
                            $scope.$evalAsync(function () {
                                $scope['tokenErrors'] = msg.errors;
                                controller.$setViewValue(null);
                                $scope['maskModel'] = msg.mask;
                                if (deferred) {
                                    deferred.resolve();
                                }
                            });
                            break;
                    }
                }
            }
            function postMessage(msg) {
                msg.clientId = clientId;
                frame.contentWindow.postMessage(JSON.stringify(msg), '*');
            }
            frame = $('iframe', el).on('load', function () {
                postMessage({
                    type: 'init',
                    fieldType: fieldType,
                    manual: $scope['manual'],
                    validateAs: validateAs,
                    placeholder: placeholder,
                    rtl: TRPCONFIG.Rtl,
                    style: {
                        fontSize: '14px'
                    }
                });
            })[0];
            $window.addEventListener('message', receiveMessage);
            $scope.$on('$destroy', function () {
                $window.removeEventListener('message', receiveMessage);
            });
            $scope['getToken'] = function () {
                postMessage({
                    type: 'requestToken'
                });
            };
            //hideous hack to deal with the fact that angular sucks
            $scope.$watch('model', function () {
                $scope.$eval(attr.ngModel + ' = model');
            });
            $scope.$watch(attr.ngModel, function (val) {
                $scope['model'] = val;
            });
            $scope['showErrors'] = function () {
                return $scope['tokenErrors'] != null &&
                    (($scope['focusTracker'] &&
                        $scope['focusTracker']['focused']) || $scope['alwaysShowErrors']) &&
                    ($rootScope['submittedForm'] === $scope['rootForm'] && !$scope['rootForm'].$valid) ||
                    ($scope['tokenErrors'] != null && $scope['focusTracker']['focused'] === false &&
                        $scope.instantValidation);
            };
            $scope['showSuccess'] = function () {
                return ($scope['tokenErrors'] == null && $scope.instantValidation);
            };
        }
    };
});
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('translateKey', function (reviewService) {
        return {
            restrict: 'A',
            link: function (scope, el, attr) {
                reviewService.setTranslationKey(attr.translateKey);
            }
        };
    });
})();
var TR;
(function (TR) {
    angular
        .module('TR')
        .directive('trustPilotSeo', function () {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                unitId: '@',
                reviewTheme: '@',
                reviewStars: '@',
                widgetHeight: '@'
            },
            template: "<div class=\"trustpilot-widget trustpilot-theme-{{ reviewTheme }}\" data-locale=\"en-GB\"\n                    data-template-id=\"53aa8912dec7e10d38f59f36\" data-businessunit-id=\"{{unitId}}\"\n                    data-style-height=\"{{widgetHeight}}px\" data-style-width=\"100%\" data-theme=\"{{reviewTheme}}\"\n                    data-stars=\"{{reviewStars}}\" data-schema-type=\"Organization\">\n                        <a href=\"{{ hostName }}\" target=\"_blank\">Trustpilot</a>\n                    </div>",
            link: function ($scope) {
                $scope.hostName = 'https://uk.trustpilot.com/review/www.' + TRPCONFIG.Domain.HostName;
                setTimeout(function () {
                    var widgetManagement = _.get(window, 'Trustpilot.Modules.WidgetManagement');
                    if (widgetManagement && widgetManagement.initializeOnPageLoad) {
                        widgetManagement.initializeOnPageLoad();
                    }
                    else {
                        $(document.body).append("<script type=\"text/javascript\"\n                                src=\"//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js\" async></script>");
                    }
                }, 1500);
            }
        };
    });
})(TR || (TR = {}));
var TR;
(function (TR) {
    var USP = /** @class */ (function () {
        function USP() {
            this.breakpoint = 1025;
            this.classFirst = 'slick-first';
            this.classLast = 'slick-last';
            this.settings = {
                mobileFirst: true,
                rtl: TRPCONFIG.Rtl,
                slidesToShow: 1,
                infinite: false,
                dots: false,
                speed: 250
            };
            this.breakpointSettings = {
                responsive: [
                    {
                        breakpoint: this.breakpoint,
                        settings: 'unslick'
                    }
                ]
            };
        }
        USP.prototype.setup = function (el) {
            this.list = el.find('.slick-usps:first');
            this.initSlick();
            if (this.useBreakpoint) {
                this.onResize();
            }
        };
        USP.prototype.initSlick = function () {
            var _this = this;
            this.destroy();
            var count = this.list.find('.usps-item').length;
            if (count > 1) {
                this.list.addClass(this.classFirst).removeClass(this.classLast);
                this.list.slick(this.useBreakpoint
                    ? _.extend({}, this.settings, this.breakpointSettings) : this.settings);
                this.list.on('afterChange', function (e, slick, current) {
                    if (0 === current) {
                        _this.list.addClass(_this.classFirst);
                    }
                    else if (slick.slideCount - 1 === current) {
                        _this.list.addClass(_this.classLast);
                    }
                    else {
                        _this.list.removeClass(_this.classFirst + " " + _this.classLast);
                    }
                });
            }
        };
        USP.prototype.onResize = function () {
            var _this = this;
            $(window).resize(_.debounce(function () {
                var w = $('body').innerWidth();
                if (!_this.list.hasClass('slick-initialized') && w < _this.breakpoint) {
                    _this.initSlick();
                }
            }, 300));
        };
        USP.prototype.destroy = function () {
            if (this.list.hasClass('slick-initialized')) {
                this.list.slick('unslick');
            }
        };
        return USP;
    }());
    angular.module('TR')
        .directive('uniqueSellingPoints', function () {
        return {
            restrict: 'E',
            controllerAs: 'usp',
            controller: USP,
            scope: {},
            bindToController: {
                useBreakpoint: '@'
            },
            link: function (scope, el, attr, controller) {
                controller.setup(el);
                scope.$on('$destroy', function () {
                    controller.destroy();
                });
            }
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('urgencyMessages', function (urgencyMessaging, arrayUtil, $interval, $timeout) {
        return {
            restrict: 'E',
            scope: {
                estabId: '='
            },
            template: '<p class="hotel-urgency-message"></p>',
            link: function (scope, el) {
                var fade = 500;
                var cycle = 5000;
                var p = el.find('p:first');
                var msgs;
                var i = 0;
                var loop;
                function showMsg() {
                    i += 1;
                    p.addClass('faded');
                    $timeout(function () {
                        p.text(msgs[i % msgs.length]);
                        p.removeClass('faded');
                    }, fade);
                }
                urgencyMessaging.get(scope.estabId).then(function (stats) {
                    if (stats != null) {
                        msgs = arrayUtil.filter([stats.CurrentViewsText, stats.LastBookedDateText, stats.ShortlistCountText], function (msg) {
                            return msg != null;
                        });
                        if (msgs.length > 0) {
                            p.text(msgs[i]);
                            if (msgs.length > 1) {
                                loop = $interval(showMsg, cycle);
                            }
                        }
                    }
                });
                scope.$on('$destroy', function () {
                    $interval.cancel(loop);
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('user', function ($rootScope, authService, agentModeService) {
        return {
            restrict: 'A',
            link: function (scope, el, attr) {
                if (attr.user && attr.user.length > 0) {
                    $rootScope.user = JSON.parse(attr.user);
                    authService.setUser($rootScope.user);
                    ($rootScope.user.AnonSignedIn ? authService.getSignedinBooking() : $.when()).then(function (booking) {
                        if (booking) {
                            $rootScope.user.Contact = booking.Contact;
                            $rootScope.user.BookingSummary = booking.Summary;
                        }
                    });
                    if ($rootScope.user.Agent && !$rootScope.agent) {
                        agentModeService
                            .getAgentInformation()
                            .then(function setAgent(data) {
                            $rootScope.agent = data;
                        });
                    }
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    var lettersOnly = /^[À-ÿa-zA-Z_\-'. ]*$/;
    var alphaNumericTenDigits = /^[A-Za-z0-9]{10}$/;
    var numericFiveDigits = /^[0-9]{5}$/;
    var notEnglishLetter = /[À-ÿĀ-ſƀ-ɏɐ-ʯΑ-ϿЀ-ӿԀ-ԯԱ-ևא-ת؀-ۿႠ-ჿ]/;
    var multiLangLetters = /^[A-Za-zẞßÀ-ÿĀ-ſƀ-ɏɐ-ʯΑ-ϿЀ-ӿԀ-ԯԱ-ևא-ת؀-ۿႠ-ჿ-.,' ]*$/;
    var numbersOnly = /^(\d+\.?\d{0,2}|\.\d{1,2})$/;
    var numbersSymbols = /[0-9!#$%&@*+/=?^_`{|}~\\[\]]/;
    var phoneNum = /^[()0-9 -]+$/;
    var flightNumber = /^(([A-Za-z]{2,3})|([A-Za-z]\d)|(\d[A-Za-z]))(\d{1,})([A-Za-z]?)$/;
    var email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    var postcodes = {
        Default: /^[A-Za-z\d\s]{1,}$/,
        GB: /^[A-Za-z\d\s]{5,8}$/,
        IE: /^[A-Za-z\d\s]{2,}$/
    };
    var requiredLengthRangeRegExp = /^\[?(\d+)(?:,(\d+))?]?$/;
    function nullOrEmpty(val) {
        return val == null || val.length === 0;
    }
    function validator(name, watches, failTest, deep, isPureValidator, isObserved) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return {
                require: 'ngModel',
                link: function (scope, el, attr, c) {
                    if (!c) {
                        return;
                    }
                    if (isPureValidator || attr.pureValidator !== undefined) {
                        c.$validators[name] = function () {
                            return !failTest(scope, el, attr, c, c.$viewValue, args);
                        };
                    }
                    else {
                        angular.forEach(watches, function (watch) {
                            scope.$watch(attr[watch], function () {
                                c.$setValidity(name, !failTest(scope, el, attr, c, c.$viewValue, args));
                            }, deep);
                        });
                    }
                    if (isObserved) {
                        attr.$observe(name, function () {
                            c.$setValidity(name, !failTest(scope, el, attr, c, c.$viewValue, args));
                        });
                    }
                }
            };
        };
    }
    function objectValidator(name, failTest) {
        return function () {
            return {
                require: 'ngModel',
                link: function (scope, el, attr, c) {
                    function validate(value) {
                        return !failTest(scope, el, attr, c, value);
                    }
                    //For DOM -> model validation
                    c.$parsers.unshift(function (value) {
                        var valid = validate(value);
                        c.$setValidity(name, valid);
                        return valid ? value : undefined;
                    });
                    //For model -> DOM validation
                    c.$formatters.unshift(function (value) {
                        c.$setValidity(name, validate(value));
                        return value;
                    });
                }
            };
        };
    }
    TR.directive('emailAddress', [validator('emailAddress', ['ngModel'], function (scope, el, attr, c, value) {
            return !c.$isEmpty(value) && !email.test(value);
        })]);
    TR.directive('requiredGuest', [objectValidator('requiredGuest', function (scope, el, attr, c, value) {
            return attr.requiredGuest && scope.$eval(attr.requiredGuest) && (nullOrEmpty(value) || nullOrEmpty(value.Title) || nullOrEmpty(value.FirstName) || nullOrEmpty(value.LastName));
        })]);
    TR.directive('lettersOnly', [validator('lettersOnly', ['ngModel'], function (scope, el, attr, c, value) {
            return !c.$isEmpty(value) && !lettersOnly.test(value);
        })]);
    TR.directive('requiredDate', ['dateUtil', validator('requiredDate', ['ngModel'], function (scope, el, attr, c, value, dependencies) {
            return !dependencies[0].isValid(value);
        })]);
    TR.directive('oneMainDriver', [validator('oneMainDriver', ['ngModel'], function (scope, el, attr, c, value) {
            if (attr.oneMainDriver && !scope.$eval(attr.oneMainDriver)) {
                return false;
            }
            if (value) {
                var mainDrivers_1 = 0;
                angular.forEach(value, function (room) {
                    angular.forEach(room.Guests, function (guest) {
                        if (guest.DriverType === 1) {
                            mainDrivers_1 += 1;
                        }
                    });
                });
                return mainDrivers_1 !== 1;
            }
            return true;
        }, true)]);
    TR.directive('numberOfAdditionalDrivers', [validator('numberOfAdditionalDrivers', ['ngModel'], function (scope, el, attr, c, value) {
            if (attr.numberOfAdditionalDrivers && !scope.$eval(attr.numberOfAdditionalDrivers)) {
                return false;
            }
            if (value) {
                var additionalDrivers_2 = 0;
                angular.forEach(value, function (room) {
                    angular.forEach(room.Guests, function (guest) {
                        if (guest.DriverType === 2) {
                            additionalDrivers_2++;
                        }
                    });
                });
                return additionalDrivers_2 !== value.additionalDrivers;
            }
            return true;
        }, true)]);
    TR.directive('ageCheck', ['dateUtil', validator('ageCheck', ['ngModel'], function (scope, el, attr, c, value, dependencies) {
            if (value == null) {
                return false;
            }
            var returnDate = dependencies[0].zeroTime(new Date(scope.$eval(attr.ageCheck)));
            if (scope.$eval(attr.validateAge) || scope.guest.Type !== 1) {
                return dependencies[0].getAge(value, returnDate) !== scope.guest.Age;
            }
            return false;
        })]);
    TR.directive('expiryCheck', [validator('expiryCheck', ['ngModel'], function (scope, el, attr, c, value) {
            var today = new Date();
            if (value.year && value.month) {
                if (value.year > today.getFullYear()) {
                    return false;
                }
                else if (value.year === today.getFullYear()) {
                    return value.month < (today.getMonth() + 1);
                }
            }
            return true;
        })]);
    TR.directive('notDefaultMonthYearIf', [validator('notDefaultMonthYearIf', ['notDefaultMonthYearIf', 'ngModel'], function (scope, el, attr, c, value) {
            if (scope.$eval(attr.notDefaultMonthYearIf)) {
                return !value.year && !value.year > 0 && !value.month && !value.month > 0;
            }
            return false;
        })]);
    TR.directive('notDefault', [validator('notDefault', ['ngModel'], function (scope, el, attr, c) {
            return !c.$modelValue || parseInt(c.$modelValue) === 0;
        })]);
    TR.directive('mustCheck', [validator('mustCheck', ['ngModel'], function (scope, el, attr, c) {
            return !c.$modelValue;
        })]);
    TR.directive('notDefaultIf', [validator('notDefaultIf', ['notDefaultIf', 'ngModel'], function (scope, el, attr, c) {
            return attr.notDefaultIf && scope.$eval(attr.notDefaultIf) && (c.$modelValue == null || c.$modelValue === 0);
        })]);
    TR.directive('numbersOnly', [function () {
            return (validator('numbersOnly', ['ngModel'], function (scope, el, attr, c) {
                return !c.$isEmpty(c.$modelValue) && !numbersOnly.test(c.$modelValue);
            })());
        }]);
    TR.directive('alphaNumericTenDigits', [function () {
            return (validator('alphaNumericTenDigits', ['ngModel'], function (scope, el, attr, c) {
                return !c.$isEmpty(c.$modelValue) && !alphaNumericTenDigits.test(c.$modelValue);
            })());
        }]);
    TR.directive('numericFiveDigits', [function () {
            return (validator('numericFiveDigits', ['ngModel'], function (scope, el, attr, c) {
                return !c.$isEmpty(c.$modelValue) && !numericFiveDigits.test(c.$modelValue);
            })());
        }]);
    TR.directive('phoneNum', [validator('phoneNum', ['ngModel'], function (scope, el, attr, c, value) {
            return !c.$isEmpty(value) && !phoneNum.test(value);
        })]);
    TR.directive('postcodeIf', [validator('postcodeIf', ['postcodeIf', 'ngModel'], function (scope, el, attr, c, value) {
            if (scope.$eval(attr.postcodeIf)) {
                var exp = _.get(postcodes, scope.$eval(attr.postcodeCountry), postcodes.Default);
                return !exp.test(value);
            }
            return false;
        })]);
    TR.directive('flightNumber', [validator('flightNumber', ['ngModel'], function (scope, el, attr, c, value) {
            return !c.$isEmpty(value) && !flightNumber.test(value);
        })]);
    TR.directive('requiredIf', [validator('requiredIf', ['requiredIf', 'ngModel'], function (scope, el, attr, c, value) {
            return attr.requiredIf && scope.$eval(attr.requiredIf) && c.$isEmpty(value);
        })]);
    TR.directive('mustPassCreditCheck', [validator('mustPassCreditCheck', ['mustPassCreditCheck', 'ngModel'], function (scope, el, attr) {
            return scope.$eval(attr.mustPassCreditCheck) !== 'green';
        })]);
    TR.directive('sameAs', [validator('sameAs', ['sameAs', 'ngModel'], function (scope, el, attr, c, value) {
            return attr.sameAs && scope.$eval(attr.sameAs) !== value;
        })]);
    TR.directive('minValue', [validator('minValue', ['minValue', 'ngModel'], function (scope, el, attr, c) {
            return !!attr.minValue && (Number(attr.minValue).toFixed(2)) > Number(c.$modelValue);
        })]);
    TR.directive('maxValue', [validator('maxValue', ['maxValue', 'ngModel'], function (scope, el, attr, c) {
            return !!attr.maxValue && (Number(attr.maxValue)).toFixed(2) < Number(c.$modelValue);
        }, false, false, true)]);
    //required-length=[minValue, maxValue] or required-length=exactValue
    //required-length=[3 ,5] means 3<=length<=5
    //required-length=5 means length = 5
    TR.directive('requiredLength', [validator('requiredLength', ['ngModel'], function (scope, el, _a, c, value) {
            var requiredLength = _a.requiredLength;
            if (c.$isEmpty(value)) {
                value = '';
            }
            if (c.$isEmpty(requiredLength)) {
                throw new Error('For "required-length" directive it is not specifed value for length. Must be either "=[minValue, maxValue]" or ="exactValue"');
            }
            requiredLength = requiredLength.toString().replace(/\s/g, '');
            var rangeArray = (new RegExp(requiredLengthRangeRegExp)).exec(requiredLength);
            //if no any correctly parsed values - validation failing function returns always false, meaning no impact just as validation is absent
            if (!rangeArray || rangeArray.length < 3) {
                return false;
            }
            //for exact value, we have only one parsed value, which is minValue and maxValue at once;
            if (rangeArray[2] === undefined) {
                rangeArray[2] = rangeArray[1];
            }
            var minValue = rangeArray[1], maxValue = rangeArray[2];
            return value.length < minValue || value.length > maxValue;
        }, false, true)]);
    TR.directive('nameValidation', [validator('nameValidation', ['ngModel'], function (scope, el, attr, c, value) {
            if (c.$isEmpty(value)) {
                return true;
            }
            var regExpPattern = new RegExp(/^[a-zA-Z ',.-]{2,255}$/);
            return !regExpPattern.test(value);
        }, false, true)]);
    /*
    TR.directive('customFailIf', [validator('customFailIf', ['customFailIf', 'ngModel'], function(scope, el, attr, c, value) {
        let r = attr.customFailIf && scope.$eval(attr.customFailIf);
        console.log('customFailIf', attr.customFailIf, scope.$eval(attr.customFailIf), r);
        return r;
    })]);
    */
    TR.directive('containsEnglishLetters', [validator('containsEnglishLetters', ['ngModel'], function (scope, el, attr, c, value) {
            if (c.$isEmpty(value)) {
                return false;
            }
            var r = new RegExp(notEnglishLetter);
            return r.test(value);
        }, false, true)]);
    TR.directive('containsNumbersSymbols', [validator('containsNumbersSymbols', ['ngModel'], function (scope, el, attr, c, value) {
            if (c.$isEmpty(value)) {
                return false;
            }
            var r = new RegExp(numbersSymbols);
            return r.test(value);
        }, false, true)]);
    TR.directive('onlyMultilangLetters', [validator('onlyMultilangLetters', ['ngModel'], function (scope, el, attr, c, value) {
            if (c.$isEmpty(value)) {
                return false;
            }
            var r = new RegExp(multiLangLetters);
            return !r.test(value);
        }, false, true)]);
    TR.directive('currencyInput', ['numberFilter', '$locale', function (numberFilter, $locale) {
            return {
                restrict: 'A',
                require: 'ngModel',
                priority: 1,
                link: function (scope, el, attra, c) {
                    c.$parsers.unshift(parseCurrency);
                    c.$formatters.unshift(formatCurrency);
                    el.blur(function () {
                        var v = formatCurrency(parseCurrency(c.$viewValue));
                        c.$setViewValue(v);
                        el.val(v);
                    });
                    el.keypress(function (e) {
                        var code = e.keyCode || e.which;
                        if ($.inArray(code, [9, 13, 27]) !== -1) {
                            el.blur();
                            return;
                        }
                        if (code >= 48 && code <= 57 ||
                            code === $locale.NUMBER_FORMATS.GROUP_SEP.charCodeAt(0) ||
                            $locale.NUMBER_FORMATS.DECIMAL_SEP.charCodeAt(0) === code && e.key !== 'Del' && c.$viewValue.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) === -1 ||
                            //backspace & delete
                            code === 8 || code === 46 && e.key === 'Del' ||
                            //Ctrl+A
                            code === 65 && e.ctrlKey === true ||
                            // home, end, left, right
                            code >= 35 && code <= 39) {
                            return;
                        }
                        e.preventDefault();
                    });
                    scope.$on('$destroy', function () {
                        el.off('keydown');
                        el.off('blur');
                    });
                    function parseCurrency(value) {
                        if (!value) {
                            return '';
                        }
                        var index = value.lastIndexOf($locale.NUMBER_FORMATS.DECIMAL_SEP);
                        if (index !== -1) {
                            var first = value.substr(0, index);
                            var second = value.substr(index + 1);
                            return parseFloat(first.replace(/\D/g, '') + "." + second.replace(/\D/g, '')).toFixed(2);
                        }
                        return parseFloat(value.replace(/\D/g, '')).toFixed(2);
                    }
                    function formatCurrency(value) {
                        if (value) {
                            return numberFilter(parseFloat(value), 2);
                        }
                    }
                }
            };
        }]);
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('validPassword', function () {
        var total = 0;
        var upperCase = new RegExp('[A-Z]');
        var lowerCase = new RegExp('[a-z]');
        var numbers = new RegExp('[0-9]');
        var specialchars = new RegExp('([!,%,&,@,#,$,^,*,?,_,-,~,+])');
        var twoOrMoreUpperCase = new RegExp('[A-Z]', 'g');
        var twoOrMoreNumbers = new RegExp('[0-9]', 'g');
        var twoOrMoreNumbersSpecialchars = new RegExp('([!,%,&,@,#,$,^,*,?,_,-,~,+])', 'g');
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, el, a, c) {
                c.$parsers.unshift(function (value) {
                    checkStrength(value);
                    return value;
                });
                scope.strength = function () {
                    if (total <= 0) {
                        return 'EMPTY';
                    }
                    else if (total === 1) {
                        return 'POOR';
                    }
                    else if (total === 2) {
                        return 'VERYWEAK';
                    }
                    else if (total === 3) {
                        return 'WEAK';
                    }
                    else if (total === 4) {
                        return 'MEDIUM';
                    }
                    else if (total === 5) {
                        return 'GOOD';
                    }
                    else if (total > 5) {
                        return 'STRONG';
                    }
                };
                function boolToInt(b) {
                    return b ? 1 : 0;
                }
                function checkStrength(val) {
                    total = 0;
                    if (val !== null && val !== undefined) {
                        total = boolToInt(val.length >= 8) +
                            boolToInt(val.match(upperCase)) +
                            boolToInt(val.match(lowerCase)) +
                            boolToInt(val.match(numbers)) +
                            boolToInt(val.match(specialchars)) +
                            boolToInt((val.match(twoOrMoreUpperCase) || []).length > 1) +
                            boolToInt((val.match(twoOrMoreNumbers) || []).length > 1) +
                            boolToInt((val.match(twoOrMoreNumbersSpecialchars) || []).length > 1);
                    }
                    scope.$emit('passwordStrength', { strength: total, label: scope.strength() });
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('wpHostedPayment', function ($window) {
        return {
            restrict: 'E',
            scope: {
                challengeUrl: '='
            },
            template: '<div data-iframe="true" id="hosted-payment-fields"></div>',
            link: function (scope) {
                function loadScript(src) {
                    return new Promise(function (resolve, reject) {
                        var script = document.createElement('script');
                        script.src = src;
                        script.async = true;
                        script.onload = resolve;
                        script.onerror = reject;
                        document.head.appendChild(script);
                    });
                }
                scope.$on('wpHostedPaymentInit', function (ev, threedsData) {
                    loadScript('https://payments.worldpay.com/resources/hpp/integrations/embedded/js/hpp-embedded-integration-library.js').then(function () {
                        var customOptions = {
                            url: "" + decodeURI(threedsData.AcsUrl),
                            type: 'iframe',
                            inject: 'immediate',
                            target: 'hosted-payment-fields',
                            accessibility: true,
                            debug: false,
                            language: 'en',
                            country: 'gb',
                            preferredPaymentMethod: 'VISA-SSL',
                            resultCallback: function (response) {
                                scope.$emit('WPHostedResponseHandler', { response: response, prepaymentid: "" + threedsData.PrePaymentID });
                            }
                        };
                        //initialise the library and pass options
                        if (typeof $window.WPCL !== 'undefined') {
                            var libraryObject = new $window.WPCL.Library();
                            libraryObject.setup(customOptions);
                        }
                    })
                        .catch(function (err) {
                        console.error('Failed to load third-party script:', err);
                    });
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.filter('relativeCurrency', function ($filter) {
        return function (amount, relativeTo) {
            var diff = amount - relativeTo;
            return $filter('roundedCurrency')(diff);
        };
    });
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('actionTemplateService', actionTemplateService);
    function actionTemplateService(dateUtil, $http, $rootScope, resourceService) {
        var validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var actionUtils = {
            PAYBALANCE: {
                format: String.format,
                addDays: (function () {
                    var today = new Date();
                    return function (days) {
                        return dateUtil
                            .addDays(today, days)
                            .toDateString();
                    };
                })()
            },
            VOUCHERACTIONS: {
                sendConfirmationEmail: (function () {
                    var cultureCode = TRPCONFIG.Domain.CultureCode;
                    return function (emails, bookingId) {
                        var emailsArray = emails.split(',');
                        for (var i = emailsArray.length - 1; i >= 0; i--) {
                            var email = emailsArray[i].trim();
                            if (!validEmail.test(email)) {
                                $rootScope.$broadcast('flash:error', String.format(resourceService.get('VOUCHERINVALID'), email));
                                return;
                            }
                        }
                        $http.post('/api2/managebooking/sendconfirmationemail', { BookingId: bookingId, Culture: cultureCode, Emails: emailsArray });
                        $rootScope.$broadcast('flash:success', resourceService.get('VOUCHERSENT'));
                    };
                })()
            }
        };
        var service = {
            getUtils: function (name) { return actionUtils[name]; }
        };
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('advertService', advertService);
    function advertService($http, pageStrand) {
        var service = {
            getAdvertsForPosition: getAdvertsForPosition,
            getUrl: getUrl
        };
        function getUrl() {
            return TRPCONFIG.AdvertImagesClientDomain + "/api2/squibs/";
        }
        function getAdvertsForPosition(positionId, destination) {
            return $http.get(TRPCONFIG.AdvertServiceClientDomain + "/api2/squibs/getsquibsforposition?" + $.param({
                CountryId: destination.CountryId,
                ProvinceId: destination.ProvinceId,
                LocationId: destination.LocationId,
                PlaceId: destination.PlaceId,
                EstablishmentId: destination.EstablishmentId,
                PolygonId: destination.PolygonId,
                PageStrand: pageStrand.fromRoute(destination),
                PositionId: positionId,
                DomainId: TRPCONFIG.Domain.DomainId,
                v: TRPCONFIG.CurrentVersion,
                Domain: location.host
            }), { cache: true, ignoreErrors: true }).then(function (res) {
                return res.data;
            });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('analytics', analytics);
    function analytics(broker, $http, $timeout, $document, $location, $q, $rootScope, $route, abTest, loggingService, searchUnitService, currentUser, tripService, cookieService, unadjustedDateFilter, costBreakdownCodes) {
        var lastUrl;
        var lastAbs;
        var timer;
        var timers = [];
        var url = '/api2/analytics/';
        var _defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.setTimeout;
        var skipAnalytics = (/prerender/i.test(navigator.userAgent) || !TRPCONFIG.Domain.GoogleTagManagerEnabled) && !TRPCONFIG.IsUnitTestForAnalytics;
        var searchTypes = {
            1: 'FlightSearch',
            2: 'HotelSearch',
            3: 'HolidaySearch',
            4: 'TransferSearch',
            6: 'ParkingSearch'
        };
        var service = {
            trackEvent: trackEvent,
            trackTiming: trackTiming,
            trackConversion: trackConversion,
            trackSearchOrigin: trackSearchOrigin,
            pageLoad: pageLoad,
            routeChange: routeChange,
            startTimer: startTimer,
            endTimer: endTimer,
            track: track,
            incrementPeopleEvent: incrementPeopleEvent,
            trackRequestedHotelNotAvailable: trackRequestedHotelNotAvailable,
            setMixpanelEmail: setMixpanelEmail,
            trackAdformClick: trackAdformClick
        };
        var noop = function () { return $q.when(); };
        if (skipAnalytics) {
            for (var func in service) {
                service[func] = noop;
            }
        }
        var utmId;
        var _mixPanelReady = subscribeOnceAsPromise('userSet')
            .then(function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ config: TRPCONFIG });
            utmId = currentUser.get() ? currentUser.get().UtmId : null;
            if (utmId === '') {
                return $q.reject();
            }
        })
            .then(function () {
            window.dataLayer.push({ utmId: utmId });
            return TRPCONFIG.MixPanelLoaded || subscribeOnceAsPromise('MixPanelLoaded');
        })
            .then(function () {
            window.mixpanel.register({ 'Device Category': TRPCONFIG.DeviceCategory, 'Platform': TRPCONFIG.Domain.DeviceType + "Web" });
            window.mixpanel.register({ Domain: extractDomain() });
            window.mixpanel.register({ BookingLanguage: TRPCONFIG.Domain.CultureCode });
            var distinctId = window.mixpanel.get_distinct_id();
            window.mixpanel.identify(distinctId.indexOf('-') > -1 ? utmId : distinctId);
            TRPCONFIG.MixPanelReady = true;
        });
        function extractDomain() {
            var match = window.location.href.match(/([a-z]+.(com|co.uk|ru|ae)\/*[a-z]+_[a-z0-9]+\/)/g);
            if (match) {
                return match[0];
            }
            match = window.location.hostname.match(/\..+\..+/g);
            if (match) {
                return match[0].slice(1);
            }
            return window.location.hostname;
        }
        function startTimer(key) {
            var opts = {
                action: key,
                category: 'performance',
                label: 'loading screen timeout'
            };
            if (timers[key] != null) {
                $timeout.cancel(timers[key][0]);
            }
            timers[key] = [
                $timeout(function () {
                    trackEvent(opts);
                    var utm = currentUser.get().UtmId;
                    loggingService.logWarn("customer with utm " + utm + " and userAgent " + navigator.userAgent + " experienced a loading screen timeout with key \"" + opts.action + "\"");
                }, 30000), new Date().getTime()
            ];
        }
        function endTimer(key) {
            timer = timers[key];
            if (timer != null) {
                $timeout.cancel(timer[0]);
                var opts = {
                    timingCategory: 'performance',
                    timingVar: key,
                    timingValue: new Date().getTime() - timer[1],
                    timingLabel: 'LoadingScreen'
                };
                trackTiming(opts);
                delete timers[key];
            }
        }
        function trackTiming(opts) {
            opts = angular.extend({ timingCategory: 'performance', timingVar: 'timer', timingLabel: null, timingValue: null }, opts || {});
            _defer(function () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'timingEvent',
                    category: opts.timingCategory,
                    variable: opts.timingVar || '',
                    time: opts.timingValue,
                    label: opts.timingLabel
                });
            });
        }
        function trackEvent(opts) {
            opts = angular.extend({ category: 'button', action: 'click', label: null, value: null }, opts || {});
            _defer(function () {
                window.dataLayer = window.dataLayer || [];
                var obj = {
                    event: 'clickEvent',
                    category: opts.category,
                    action: opts.action,
                    value: opts.value,
                    label: opts.label
                };
                if (TRPCONFIG.Domain.TenantId === 3) {
                    obj = angular.extend(obj, _.pick(opts, 'dimension3', 'dimension4', 'dimension5', 'dimension6', 'dimension7', 'dimension8'));
                }
                window.dataLayer.push(obj);
            });
        }
        function trackConversion(value) {
            if (TRPCONFIG.Domain.GoogleConversionId !== 0) {
                /* eslint-disable camelcase */
                var conversionObject = {
                    google_conversion_id: TRPCONFIG.Domain.GoogleConversionId,
                    google_conversion_language: 'en',
                    google_conversion_color: 'ffffff',
                    google_remarketing_only: false,
                    google_conversion_value: value || 1,
                    google_conversion_format: 1
                };
                if (TRPCONFIG.Domain.GoogleConversionLabel) {
                    conversionObject.google_conversion_label = TRPCONFIG.Domain.GoogleConversionLabel;
                }
                if (TRPCONFIG.Domain.GoogleConversionFormat) {
                    conversionObject.google_conversion_format = TRPCONFIG.Domain.GoogleConversionFormat;
                }
                if (window.google_trackConversion) {
                    window.google_trackConversion(conversionObject);
                }
                /* eslint-enable camelcase */
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'bookingcomplete' });
        }
        function trackSearchOrigin(tripId, requestedUrl) {
            if (TRPCONFIG.Domain.TrackSearchOriginEnabled) {
                return tripService.getTrip(tripId).then(function (trip) {
                    var request = {
                        RequestedUrl: requestedUrl,
                        AcomSearchId: trip && trip.HotelsRequest && trip.HotelsRequest.AvailabilitySearchId,
                        FlightSearchId: trip && trip.FlightsRequest && trip.FlightsRequest.AvailabilitySearchId
                    };
                    if (request.AcomSearchId || request.FlightSearchId) {
                        return $http.post(url + "tracksearchorigin", request, { ignoreErrors: true });
                    }
                });
            }
        }
        function trackAdformClick(options) {
            if (window.adf) {
                // eslint-disable-next-line new-cap
                window.adf.ClickTrack(this, options.trackingId, options.eventName, {});
            }
        }
        function pageLoad(pageUrl) {
            _defer(function () {
                $http.post(url + "trackpageloadtimings", {
                    DomainId: TRPCONFIG.Domain.DomainId,
                    Url: pageUrl,
                    Timings: window.performance ? window.performance.timing : null
                }, { ignoreErrors: true });
                updateCriteoId();
            });
            var query = $location.search();
            updateSalesForceParameters(query);
            if (query.source != null && query.dlid != null) {
                _defer(function () {
                    $http.post(url + "trackdeeplink", {
                        DeepLinkId: query.dlid
                    }, { ignoreErrors: true });
                });
                var h = window.location.hostname;
                var cookieDomain = h.slice(h.indexOf('.'));
                if (query.source === 'TV') {
                    var date = new Date();
                    date.setTime(date.getTime() + (30 * 60 * 60 * 24 * 1000));
                    cookieService.set('trivago_referral', query.dlid, date.toUTCString(), cookieDomain);
                }
                else if (query.source === 'TVMETA' || query.source === 'TVMOTA') {
                    if (query.taid && query.taid.length === 24) {
                        cookieService.set('tripadvisor_referral', query.taid, null, cookieDomain);
                    }
                }
                else if (_.indexOf(['KY', 'KYH', 'KYHDNUAE'], query.source) > -1) {
                    if (!(_.isEmpty(query.kayakclickid))) {
                        cookieService.set('kayak_referral', query.kayakclickid, null, cookieDomain);
                        cookieService.set('kayak_source', query.source, null, cookieDomain);
                    }
                }
                else if (query.source === 'SKYH') {
                    if (query.fclid) {
                        cookieService.set('skyscanner_referral', query.fclid, null, cookieDomain);
                    }
                }
                else if (query.source === 'WE' || query.source === 'WEKSA' || query.source === 'WEG') {
                    if (query.wego_click_id) {
                        cookieService.set('wego_referral', query.wego_click_id, null, cookieDomain);
                    }
                }
                else if (query.source === 'CLICKWISE') {
                    if (query.refid) {
                        cookieService.set('clickwise_referral', query.refid, null, cookieDomain);
                    }
                }
            }
        }
        function updateSalesForceParameters(queryParams) {
            var hostName = window.location.hostname;
            var cookieDomain = hostName.slice(hostName.indexOf('.'));
            var params = _.pick(queryParams, ['j', 'sfmc_sub', 'l', 'u', 'jb', 'mid', 'e']);
            if (params.j && params.sfmc_sub && params.l && params.jb && params.mid && params.u) {
                var salesForceParams = _.entries(params).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    delete queryParams[key];
                    return key + "=" + value;
                }).join('&');
                cookieService.set('salesforce', salesForceParams, null, cookieDomain);
                $location.search(queryParams);
            }
        }
        function updateCriteoId() {
            var ctoOptOut = cookieService.get('cto_optout');
            var optOut = ctoOptOut === '1';
            var criteoId = optOut ? '' : cookieService.get('cto_axid');
            if (optOut || criteoId) {
                $http.post(url + "updatecriteoid", {
                    CriteoId: criteoId,
                    OptOut: optOut
                }, {
                    ignoreErrors: true
                });
            }
        }
        function routeChange(absUrl, relUrl) {
            //double check that the route has actually changed because we suspect that this may
            //get called repeatedly when we go into an infinite digest loop which we have not yet resolved.
            if (relUrl === lastUrl) {
                return;
            }
            lastUrl = relUrl;
            if (relUrl && relUrl === '/' || relUrl === '/v2/') {
                track('mixpanel', 'HomePage');
                _mixPanelReady.then(function () { return window.mixpanel.people.increment('Home Page Visit'); });
            }
            _defer(function () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'virtualPageView', virtualPageURL: relUrl });
                // abTest.executeTrackingCode('body');
                $http.post('website/monkey/tennis', {
                    Url: absUrl,
                    ReferrerUrl: lastAbs == null ? $document[0].referrer : lastAbs
                }, { ignoreErrors: true }).then(function checkVersionMismatch(res) {
                    if (res.data !== TRPCONFIG.CurrentVersion) {
                        _inactivityTime();
                    }
                });
                lastAbs = absUrl;
            });
        }
        function track(type, event, props) {
            switch (type) {
                case 'mixpanel':
                    _mixPanelTrack(event, props);
                    break;
                case 'Search':
                    _searchCompleted(event, props);
                    break;
                case 'Event':
                    _pushTripTypeToDataLayer().then(function () { return window.dataLayer.push(_.assignIn({ event: event }, props)); });
                    break;
                case 'mixpanelPeople':
                    _trackPeople(event, props);
                    break;
                case 'Roomerflex':
                    _trackRoomerflexQuote(event, props);
                    break;
                case 'Facebook':
                    _facebookTrack(event, props);
                    break;
                case 'eCommerce':
                    _ecommerce(event, props);
                    break;
                case 'eCommercePaypal':
                    _ecommercePaypal(event, props);
                    break;
            }
        }
        function _ecommerce(event, data) {
            if (TRPCONFIG.Domain2.BookingCompleteEcommerceLogEnabled) {
                console.log('ecommerce data', _collectEcommerceData(event, data));
            }
            if (TRPCONFIG.Domain2.BookingCompleteEcommercePushEnabled) {
                var ecommerceData = _collectEcommerceData(event, data);
                sessionStorage.setItem('eCommercePurchaseData', JSON.stringify(ecommerceData));
            }
        }
        function _ecommercePaypal(event, paypalData) {
            if (TRPCONFIG.Domain2.BookingCompleteEcommerceLogEnabled) {
                console.log('ecommerce paypal data', _collectEcommercePaypalData(event, paypalData));
            }
            if (TRPCONFIG.Domain2.BookingCompleteEcommercePushEnabled) {
                var ecommercePaypalData = _collectEcommercePaypalData(event, paypalData);
                window.dataLayer.push(ecommercePaypalData);
            }
        }
        function _collectEcommerceData(event, data) {
            return {
                event: event,
                ecommerce: {
                    purchase: {
                        actionField: _collectActionData(data, function (_a) {
                            var BookingReferences = _a.BookingReferences, Trip = _a.Trip;
                            return ({
                                id: BookingReferences.sort()[0],
                                revenue: Math.round(Trip.Bookings.reduce(function (acc, _a) {
                                    var Balance = _a.Balance;
                                    return acc + Balance.ClientTotalCost;
                                }, 0) * 100) / 100
                            });
                        }),
                        products: _collectProductData(data, function (_a) {
                            var Trip = _a.Trip;
                            return Trip.Bookings.map(function (_a) {
                                var Balance = _a.Balance, BookingCore = _a.BookingCore, Itinerary = _a.Itinerary;
                                var BookingRef = BookingCore.BookingRef;
                                var category = _getCategoryFromBookingRef(BookingRef);
                                var name = {
                                    Accommodation: function (_a) {
                                        var FirstStay = _a.Stays[0];
                                        return FirstStay.Hotel.Title;
                                    },
                                    Flight: function (_a) {
                                        var OutboundFlight = _a.Flights[0];
                                        return OutboundFlight.Segments[OutboundFlight.Segments.length - 1].ArrivalAirport.Title;
                                    },
                                    Transfer: function (_a) {
                                        var Transfers = _a.Transfers;
                                        return _getTransferName(Transfers);
                                    },
                                    Insurance: function (_a) {
                                        var Description = _a.Description;
                                        return Description;
                                    },
                                    Car: function (_a) {
                                        var PickUpPointName = _a.PickUpPointName, DropOffPointName = _a.DropOffPointName;
                                        return PickUpPointName + " " + DropOffPointName;
                                    },
                                    Attractions: function (_a) {
                                        var FirstTicket = _a.Tickets[0];
                                        return FirstTicket.Description;
                                    },
                                    Parking: function (_a) {
                                        var ParkingSiteName = _a.ParkingSiteName;
                                        return ParkingSiteName;
                                    },
                                    Bundle: function () { return 'Bundle'; }
                                }[category](Itinerary);
                                return {
                                    id: BookingRef,
                                    category: category,
                                    name: name,
                                    price: Balance.ClientTotalCost
                                };
                            });
                        })
                    }
                }
            };
        }
        function _collectEcommercePaypalData(event, data) {
            return {
                event: event,
                ecommerce: {
                    purchase: {
                        actionField: _collectActionData(data, function (data) {
                            var reducedData = data.reduce(function (acc, _a) {
                                var Ref = _a.Ref, Cost = _a.Cost;
                                acc.id.push(Ref);
                                acc.revenue += Cost;
                                return acc;
                            }, {
                                id: [],
                                revenue: 0
                            });
                            return {
                                id: reducedData.id.sort()[0],
                                revenue: Math.round(reducedData.revenue * 100) / 100,
                            };
                        }),
                        products: _collectProductData(data, function (data) { return data.map(function (_a) {
                            var Cost = _a.Cost, Desc = _a.Desc, Ref = _a.Ref;
                            var category = _getCategoryFromBookingRef(Ref);
                            return {
                                id: Ref,
                                category: category,
                                name: Desc,
                                price: Cost
                            };
                        }); })
                    }
                }
            };
        }
        function _collectActionData(data, _collectActionVariations) {
            var variations = _collectActionVariations(data);
            return __assign({}, variations, { affiliation: TRPCONFIG.Domain.DomainId, tax: '0', shipping: '', coupon: '' });
        }
        function _collectProductData(data, _collectProductVariations) {
            var variations = _collectProductVariations(data);
            var products = variations.map(function (variation) { return (__assign({}, variation, { quantity: 1 })); });
            var holidayCategories = [{ category: 'Accommodation' }, { category: 'Flight' }];
            var holidayComparator = function (a, b) { return a.category === b.category; };
            var holidayCollection = _.intersectionWith(products, holidayCategories, holidayComparator);
            if (holidayCollection.length === holidayCategories.length) {
                var category = 'Holiday';
                var holidayData = holidayCollection.reduce(function (acc, _a) {
                    var id = _a.id, name = _a.name, price = _a.price;
                    acc.id.push(id);
                    acc.name.push(name);
                    acc.price += price;
                    return acc;
                }, {
                    id: [],
                    name: [],
                    price: 0,
                });
                return _.concat({
                    id: holidayData.id.join('|'),
                    category: category,
                    name: holidayData.name.join('|'),
                    price: Math.round(holidayData.price * 100) / 100,
                    quantity: 1
                }, _.differenceWith(products, holidayCategories, holidayComparator));
            }
            return products;
        }
        function _getCategoryFromBookingRef(bookingRef) {
            return {
                ACM: 'Accommodation',
                SCH: 'Flight',
                EUF: 'Flight',
                TRN: 'Transfer',
                INS: 'Insurance',
                AUT: 'Car',
                OLF: 'Attractions',
                PRK: 'Parking',
                BND: 'Bundle'
            }[_getBookingPrefixFromBookingRef(bookingRef)];
        }
        function _getBookingPrefixFromBookingRef(bookingRef) {
            return bookingRef.match(/[a-zA-Z]+/g)[0];
        }
        function _getTransferName(_a) {
            var itinerary = _a[0];
            if (itinerary.DropOffPoint && itinerary.PickUpPoint) {
                return itinerary.DropOffPoint.ResortName + " | Return";
            }
            if (itinerary.DropOffPoint) {
                return itinerary.DropOffPoint.ResortName + " | One way (Resort to Airport)";
            }
            if (itinerary.PickUpPoint) {
                return itinerary.PickUpPoint.AirportName + " | One way (Airport to Resort)";
            }
        }
        function _pushTripTypeToDataLayer() {
            var tripId = $route && $route.current && $route.current.params && $route.current.params.tripId;
            if (tripId) {
                return tripService.getTrip(tripId).then(function (t) {
                    if (t && t.TripType) {
                        window.dataLayer.push({ tripType: t.TripType });
                    }
                });
            }
            return $q.when();
        }
        function _facebookTrack(event, props) {
            if (TRPCONFIG.Domain.FacebookPixelEnabled && window.fbq) {
                window.fbq('track', event, props);
            }
        }
        function _searchCompleted(event, props) {
            var config = {
                event: searchTypes[event],
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                CountryCode: 'UK'
            };
            window.dataLayer.push(_.assignIn(config, props));
        }
        function _trackRoomerflexQuote(event, props) {
            var config = { event: event };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(_.assignIn(config, props));
        }
        var mixPanelBookingInfoPropsCache = {};
        function _mixPanelTrack(event, props) {
            _mixPanelReady.then(function () {
                if (props == null) {
                    window.mixpanel.track(event);
                }
                else {
                    var formattedProps = void 0;
                    switch (event) {
                        case 'Search':
                            formattedProps = _formatMixpanelSearch(props);
                            break;
                        case 'BookingComplete':
                        case 'BookingForm':
                            mixPanelBookingInfoPropsCache = formattedProps = _formatMixpanelBookingInfo(props);
                            break;
                        case 'FormValidation':
                            formattedProps = _formatMixpanelFormValidation(props, mixPanelBookingInfoPropsCache);
                            break;
                        default:
                            formattedProps = _flattenObject(props);
                    }
                    window.mixpanel.track(event, formattedProps);
                }
            });
        }
        function _flattenObject(obj) {
            var newObj = {};
            if (typeof obj !== 'object') {
                return obj;
            }
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) {
                    continue;
                }
                if (Array.isArray(obj[i])) {
                    newObj[i] = [];
                    for (var j = 0; j < obj[i].length; j++) {
                        newObj[i].push(_flattenObject(obj[i][j]));
                    }
                }
                else if ((typeof obj[i]) === 'object') {
                    var flatObject = _flattenObject(obj[i]);
                    for (var x in flatObject) {
                        if (!flatObject.hasOwnProperty(x)) {
                            continue;
                        }
                        newObj[i + "." + x] = flatObject[x];
                    }
                }
                else {
                    newObj[i] = obj[i];
                }
            }
            return newObj;
        }
        function _formatMixpanelSearch(search) {
            var counts = { Adults: 0, Children: 0, Rooms: 0 };
            var Nights = search.Nights;
            var DepartureAirports = search.DepartureAirports;
            var TypeTitle = search.TypeTitle;
            var Destination = _.pick(search.Destination, 'CountryId', 'LocationId', 'PlaceId', 'PolygonId', 'ProvinceId', 'EstablishmentId', 'ShortTitle');
            var dateTimeFormat = 'dd MMM yyyy HH:mm';
            var FromDate = search.FromDate ? unadjustedDateFilter(search.FromDate.Date, dateTimeFormat) : undefined;
            var ToDate = search.ToDate ? unadjustedDateFilter(search.ToDate.Date, dateTimeFormat) : undefined;
            if (search.Rooms) {
                search.Rooms.reduce(function (c, r) {
                    c.Adults += r.Adults;
                    c.Children += (r.ChildAges || []).length;
                    c.Rooms += 1;
                    return c;
                }, counts);
            }
            var result = _.assignIn({
                Nights: Nights,
                TypeTitle: TypeTitle,
                DepartureAirports: DepartureAirports,
                FromDate: FromDate,
                ToDate: ToDate,
            }, counts, Destination);
            if (search.SearchType === 3 || search.SearchType === 1) {
                var cabinId = search.Cabin || _.get(search, 'searchModel.cabin');
                result.Cabin = ({ 1: 'Economy', 2: 'PremiumEconomy', 8: 'Business', 4: 'First' })[cabinId];
                result.FlexibleDates = _.get(search, 'searchModel.flexibleDates');
                if (angular.isUndefined(result.FlexibleDates)) {
                    result.FlexibleDates = searchUnitService.flexibleDates;
                }
                if (search.searchModel) {
                    result.CarrierAirlines = _.map(search.searchModel.airlines, function (a) { return a.Title; });
                    result.DirectFlightsOnly = search.searchModel.prefilterDirectFlights;
                }
            }
            return result;
        }
        function _formatMixpanelBookingInfo(data) {
            var result = {
                TotalCost: data.TotalCost,
                HasHotel: !!(data.Hotel && data.Hotel.ProductId),
                HasFlight: !!(data.Flight && data.Flight.ProductId),
                HasBags: !!_.get(data, 'Flight.ProductSpecificFields.OptionCounts.HoldBags'),
                HasSeats: !!_.get(data, 'Flight.ProductSpecificFields.OptionCounts.Seats'),
                HasAttraction: !!(data.Attractions && data.Attractions.length > 0),
                HasCarHire: !!(data.CarHire && data.CarHire.ProductId),
                HasInsurance: !!(data.Insurance && data.Insurance.ProductId),
                HasParking: !!(data.Parking && data.Parking.ProductId),
                HasTransfer: !!(data.Transfer && data.Transfer.ProductId),
                HasMarhaba: !!(data.Marhaba && data.Marhaba.ProductId),
                HasRoomerFlex: !!(data.Hotel && data.Hotel.CostBreakdown.some(function (cost) {
                    return cost.TypeId === costBreakdownCodes.CancellationProtection;
                })),
                PageVersion: data.PageVersion || null,
                Source: data.Source || 'default'
            };
            if (result.HasTransfer === true) {
                result.TransferCostTotal = _.reduce(data.Transfer.CostBreakdown, function (result, v) { return result + (v.UnitAmount * v.Quantity); }, 0);
            }
            return result;
        }
        function _formatMixpanelFormValidation(props, mixPanelBookingInfoPropsCache) {
            var result = _.merge({}, mixPanelBookingInfoPropsCache);
            var uniqueErrors = {};
            iterate(props.form, 0);
            result.ValidationFail = Object.keys(uniqueErrors);
            _.forEach(props.validationMessages, function (m) { return result.ValidationFail.push(m); });
            return result;
            function iterate(element, stackDepth) {
                if (element && stackDepth < 5) {
                    _.forEach(element.$error, function (error, key) {
                        if (error === true) {
                            key = key.replace('If', '');
                            key = key + " - " + element.$name;
                            uniqueErrors[key] = true;
                        }
                        else {
                            _.forEach(error, iterate, stackDepth + 1);
                        }
                    });
                }
            }
        }
        var _inactivityTimeToken;
        function _inactivityTime() {
            if (!_inactivityTimeToken) {
                $(document)
                    .on('mousemove', _resetTimer)
                    .on('keypress', _resetTimer);
                $(document.body)
                    .on('touchstart', _resetTimer)
                    .on('touchmove', _resetTimer)
                    .on('touchend', _resetTimer);
                _resetTimer();
            }
            function _reload() {
                document.location.reload();
            }
            function _resetTimer() {
                clearTimeout(_inactivityTimeToken);
                _inactivityTimeToken = setTimeout(_reload, 10 * 1000);
            }
        }
        function _trackPeople(event, props) {
            _mixPanelReady.then(function () {
                switch (event) {
                    case 'Search':
                        _trackPeopleSearch(props);
                        break;
                    case 'BookingComplete':
                        _trackPeopleBookingCompleter(props);
                        break;
                }
            });
        }
        function _trackPeopleSearch(props) {
            window.mixpanel.people.increment('Total Searches');
            window.mixpanel.people.set({ 'Last Search Date': new Date() });
            if (props.Destination) {
                window.mixpanel.people.append('Search terms', props.Destination.ShortTitle ? props.Destination.ShortTitle : props.Destination.Title);
            }
        }
        function _trackPeopleBookingCompleter(props) {
            window.mixpanel.people.increment('Bookings Completed');
            window.mixpanel.people.append('Total value per booking', props.TotalCost);
            window.mixpanel.people.increment('Lifetime value', props.TotalCost);
        }
        function incrementPeopleEvent(event, value) {
            if (value === void 0) { value = 1; }
            _mixPanelReady.then(function () { return window.mixpanel.people.increment(event, value); });
        }
        function setMixpanelEmail(email) {
            _mixPanelReady.then(function () { return window.mixpanel.people.set({
                $email: email
            }); });
        }
        trackRequestedHotelNotAvailable.idCache = {};
        function trackRequestedHotelNotAvailable(destinationEstabId) {
            if (!trackRequestedHotelNotAvailable.idCache[destinationEstabId]) {
                trackRequestedHotelNotAvailable.idCache[destinationEstabId] = true;
                track('mixpanel', 'RequestedHotelNotAvailable', { destinationEstabId: destinationEstabId });
            }
        }
        function subscribeOnceAsPromise(topic) {
            return $q(function (resolve) { return broker.subscribeOnce('analytics', topic, function () { return resolve(); }); });
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var AnalyticsTracker = /** @class */ (function () {
        function AnalyticsTracker() {
            this.isTrackingCounted = false;
        }
        AnalyticsTracker.prototype.isEnabled = function () {
            return TRPCONFIG.Domain.EnableAnalyticsTracking;
        };
        AnalyticsTracker.prototype.isCounted = function () {
            return this.isTrackingCounted;
        };
        AnalyticsTracker.prototype.resetStatus = function (status) {
            this.isTrackingCounted = status;
        };
        return AnalyticsTracker;
    }());
    TR.AnalyticsTracker = AnalyticsTracker;
    angular
        .module('TR')
        .service('analyticsTracker', AnalyticsTracker);
})(TR || (TR = {}));
(function () {
    'use strict';
    // Not at all happy about hard-coding these, but the api is still outstanding: API-827
    var localAirports = (function () {
        if (TRPCONFIG.Domain.EnableStaticDepartureAirports) {
            return [
                { Title: 'London - All Airports', Code: 'LGW,LHR,STN' },
                { Title: 'London Gatwick (LGW)', Code: 'LGW' },
                { Title: 'London Heathrow (LHR)', Code: 'LHR' },
                { Title: 'London Stansted (STN)', Code: 'STN' },
                { Title: 'Birmingham (BHX)', Code: 'BHX' },
                { Title: 'Manchester (MAN)', Code: 'MAN' },
                { Title: 'Newcastle (NCL)', Code: 'NCL' },
                { Title: 'Glasgow (GLA)', Code: 'GLA' },
                { Title: 'Edinburgh (EDI)', Code: 'EDI' }
            ];
        }
        if (TRPCONFIG.Domain.DomainId === 2) {
            return [
                { Title: 'Belfast and Dublin - All Airports', Code: 'BFS,BHD,DUB' },
                { Title: 'Ireland - All Airports', Code: 'BHD,BFS,ORK,LDY,KIR,NOC,DUB,CFN,SNN' },
                { Title: 'Belfast City', Code: 'BHD' },
                { Title: 'Belfast International', Code: 'BFS' },
                { Title: 'Dublin', Code: 'DUB' },
                { Title: 'Cork', Code: 'ORK' },
                { Title: 'Derry', Code: 'LDY' },
                { Title: 'Donegal', Code: 'CFN' },
                { Title: 'Kerry', Code: 'KIR' },
                { Title: 'Knock', Code: 'NOC' },
                { Title: 'Shannon', Code: 'SNN' },
                //{ Title: 'Waterford', Code: 'WAT' },
                { Title: 'London - All Airports', Code: 'LGW,LHR,LTN,SEN,STN,LCY' },
                { Title: 'Midlands - All Airports', Code: 'BHX,EMA' },
                { Title: 'North West - All Airports', Code: 'LPL,MAN' },
                { Title: 'North East - All Airports', Code: 'DSA,HUY,LBA,MME,NCL' },
                { Title: 'South East - All Airports', Code: 'LGW,LHR,SOU' },
                { Title: 'South West - All Airports', Code: 'BOH,BRS,CWL,EXT,NQY,SOU' },
                { Title: 'Scotland - All Airports', Code: 'ABZ,EDI,GLA,INV,PIK' },
                { Title: 'Aberdeen (ABZ)', Code: 'ABZ' },
                { Title: 'Belfast City George Best (BHD)', Code: 'BHD' },
                { Title: 'Belfast International (BFS)', Code: 'BFS' },
                { Title: 'Birmingham (BHX)', Code: 'BHX' },
                { Title: 'Bournemouth (BOH)', Code: 'BOH' },
                { Title: 'Bristol (BRS)', Code: 'BRS' },
                { Title: 'Cardiff (CWL)', Code: 'CWL' },
                { Title: 'Derry (LDY)', Code: 'LDY' },
                { Title: 'Dublin (DUB)', Code: 'DUB' },
                { Title: 'East Midlands (EMA)', Code: 'EMA' },
                { Title: 'Edinburgh (EDI)', Code: 'EDI' },
                { Title: 'Exeter (EXT)', Code: 'EXT' },
                { Title: 'Glasgow (GLA)', Code: 'GLA' },
                { Title: 'Glasgow Prestwick (PIK)', Code: 'PIK' },
                { Title: 'Guernsey (GCI)', Code: 'GCI' },
                { Title: 'Humberside (HUY)', Code: 'HUY' },
                { Title: 'Inverness (INV)', Code: 'INV' },
                { Title: 'Isle of Man (IOM)', Code: 'IOM' },
                { Title: 'Jersey (JER)', Code: 'JER' },
                { Title: 'Leeds (LBA)', Code: 'LBA' },
                { Title: 'Liverpool John Lennon (LPL)', Code: 'LPL' },
                { Title: 'London City (LCY)', Code: 'LCY' },
                { Title: 'London Gatwick (LGW)', Code: 'LGW' },
                { Title: 'London Heathrow (LHR)', Code: 'LHR' },
                { Title: 'London Luton (LTN)', Code: 'LTN' },
                { Title: 'London Southend (SEN)', Code: 'SEN' },
                { Title: 'London Stansted (STN)', Code: 'STN' },
                { Title: 'Manchester (MAN)', Code: 'MAN' },
                { Title: 'Newcastle (NCL)', Code: 'NCL' },
                { Title: 'Newquay (NQY)', Code: 'NQY' },
                { Title: 'Norwich (NWI)', Code: 'NWI' },
                { Title: 'Robin Hood Airport Doncaster (DSA)', Code: 'DSA' },
                { Title: 'Southampton (SOU)', Code: 'SOU' },
                { Title: 'Teesside International (MME)', Code: 'MME' }
            ];
        }
        return [
            { Title: 'London - All Airports', Code: 'LGW,LHR,LTN,SEN,STN,LCY' },
            { Title: 'Midlands - All Airports', Code: 'BHX,EMA' },
            { Title: 'North West - All Airports', Code: 'LPL,MAN' },
            { Title: 'North East - All Airports', Code: 'DSA,HUY,LBA,MME,NCL' },
            { Title: 'South East - All Airports', Code: 'LGW,LHR,SOU' },
            { Title: 'South West - All Airports', Code: 'BOH,BRS,CWL,EXT,NQY,SOU' },
            { Title: 'Scotland - All Airports', Code: 'ABZ,EDI,GLA,INV,PIK' },
            { Title: 'Belfast - All Airports', Code: 'BFS,BHD' },
            { Title: 'Aberdeen (ABZ)', Code: 'ABZ' },
            { Title: 'Belfast City George Best (BHD)', Code: 'BHD' },
            { Title: 'Belfast International (BFS)', Code: 'BFS' },
            { Title: 'Birmingham (BHX)', Code: 'BHX' },
            { Title: 'Bournemouth (BOH)', Code: 'BOH' },
            { Title: 'Bristol (BRS)', Code: 'BRS' },
            { Title: 'Cardiff (CWL)', Code: 'CWL' },
            { Title: 'Derry (LDY)', Code: 'LDY' },
            { Title: 'East Midlands (EMA)', Code: 'EMA' },
            { Title: 'Edinburgh (EDI)', Code: 'EDI' },
            { Title: 'Exeter (EXT)', Code: 'EXT' },
            { Title: 'Glasgow (GLA)', Code: 'GLA' },
            { Title: 'Glasgow Prestwick (PIK)', Code: 'PIK' },
            { Title: 'Guernsey (GCI)', Code: 'GCI' },
            { Title: 'Humberside (HUY)', Code: 'HUY' },
            { Title: 'Inverness (INV)', Code: 'INV' },
            { Title: 'Isle of Man (IOM)', Code: 'IOM' },
            { Title: 'Jersey (JER)', Code: 'JER' },
            { Title: 'Leeds (LBA)', Code: 'LBA' },
            { Title: 'Liverpool John Lennon (LPL)', Code: 'LPL' },
            { Title: 'London City (LCY)', Code: 'LCY' },
            { Title: 'London Gatwick (LGW)', Code: 'LGW' },
            { Title: 'London Heathrow (LHR)', Code: 'LHR' },
            { Title: 'London Luton (LTN)', Code: 'LTN' },
            { Title: 'London Southend (SEN)', Code: 'SEN' },
            { Title: 'London Stansted (STN)', Code: 'STN' },
            { Title: 'Manchester (MAN)', Code: 'MAN' },
            { Title: 'Newcastle (NCL)', Code: 'NCL' },
            { Title: 'Newquay (NQY)', Code: 'NQY' },
            { Title: 'Norwich (NWI)', Code: 'NWI' },
            { Title: 'Robin Hood Airport Doncaster (DSA)', Code: 'DSA' },
            { Title: 'Southampton (SOU)', Code: 'SOU' },
            { Title: 'Teesside International (MME)', Code: 'MME' }
        ];
    })();
    angular
        .module('TR')
        .service('autocompleter', autocompleter);
    function autocompleter($http, $q, $filter, $route, globalisationService) {
        var domain = TRPCONFIG.Domain;
        var httpStatus = { BadRequest: 400 };
        var airports = null;
        var service = {
            lookup: lookup,
            initialDepartureAirports: initialDepartureAirports
        };
        function _filteredAirports(prefix) {
            if (airports) {
                var d = $q.defer();
                d.resolve({
                    data: $filter('filter')(airports, prefix),
                    prefix: prefix
                });
                return d.promise;
            }
            return $http.post('/api3/transfers/airports/get', {
                CultureCode: domain.CultureCode,
                DomainId: domain.DomainId
            }).then(function (result) {
                airports = result.data.Airports;
                return {
                    data: $filter('filter')(airports, prefix),
                    prefix: prefix
                };
            });
        }
        function lookup(type, prefix, filterFunction) {
            //Use filterFunction returned data as promise incase if it presents and ignore everything else.
            if (filterFunction) {
                return $q.when({
                    data: filterFunction({ prefix: prefix }),
                    prefix: prefix
                });
            }
            if (!type) {
                throw new Error('type have not been supplied');
            }
            return _lookup(type, prefix).then(function (result) {
                if (result && _.isArray(result.data)) {
                    _.forEach(result.data, function (d) { return d.searchLookupType = type; });
                }
                return result;
            });
        }
        function _autoCompleterApiCall(url, prefix) {
            return globalisationService.getSelectedRegionalContext()
                .then(function (regionalContext) { return $http.get(url + $.param({
                TenantId: TRPCONFIG.Domain.TenantId,
                PointOfSaleId: regionalContext.PointOfSale.Id,
                CultureCode: regionalContext.Language.Code,
                MaxResults: 15,
                Term: prefix
            }), { ignoreErrors: true }); });
        }
        function _getDepartureAirportsByPointOfSale(prefix) {
            return _autoCompleterApiCall('/api/flights/autocompleter/departureairports?', prefix);
        }
        function _lookup(type, prefix) {
            if (type === 'transfers') {
                return _filteredAirports(prefix);
            }
            else if (type === 'marhaba') {
                return $http.post('/api2/marhaba/airports/getairports', {
                    CultureCode: domain.CultureCode,
                    SearchTerm: prefix
                }).then(function (result) {
                    return {
                        data: result.data.Airports,
                        prefix: prefix
                    };
                });
            }
            else if (type === 'parking') {
                return $http
                    .post('/api2/airportparking/airports/get')
                    .then(function (result) {
                    var filteredResult = $filter('filter')(result.data.Airports, prefix);
                    return {
                        data: _.map(filteredResult, function (a) {
                            // Have to map `AirportCode` to `Code`
                            if (a.AirportCode) {
                                a.Code = a.AirportCode;
                                delete a.AirportCode;
                            }
                            return a;
                        }),
                        prefix: prefix
                    };
                });
            }
            else if (type === 'flights-departure' && TRPCONFIG.Domain.LimitDepartureAirportsToLocalOnly) {
                var airports_1 = prefix ? $filter('filter')(localAirports, { Title: prefix }) : localAirports;
                airports_1 = buildUpChildAirports(airports_1);
                return $q.when(mapDepartureAirports(airports_1, prefix));
            }
            else if (['flights-departure', 'flights-destination', 'flights'].indexOf(type) > -1) {
                if (TRPCONFIG.Domain.PointOfSaleAutocompleterEnabled) {
                    return _getDepartureAirportsByPointOfSale(prefix).then(function (r) {
                        return mapDepartureAirports(r.data.d.map(function (a) {
                            return { Title: a.t, Code: a.v };
                        }), prefix);
                    });
                }
                var postData = {
                    SearchTerm: prefix,
                    MaxResults: 15,
                    CultureCode: domain.CultureCode,
                    RestrictToFlightDestinations: false
                };
                return $http
                    .post('/api2/flights/static/getdestinationairports', postData)
                    .then(function (result) { return mapDepartureAirports(result.data.Airports, prefix); });
            }
            else if (type === 'non-grouped-airports') {
                return _lookup('flights', prefix).then(function (res) {
                    res.data = res.data.filter(function (airport) { return airport.Code.indexOf(',') === -1; });
                    return res;
                });
            }
            else if (type === 'businesscustomers') {
                return $http
                    .get(TRPCONFIG.AutocompleterClientDomain + "/api2/businesscustomers/get?" + $.param({
                    DomainId: domain.DomainId,
                    MaxResults: 400,
                    MaxStringDistance: 4,
                    CultureCode: domain.CultureCode,
                    SearchTerm: prefix
                }))
                    .then(function (result) {
                    return {
                        data: result.data,
                        prefix: prefix
                    };
                });
            }
            else if (type === 'travelAgents') {
                return $http
                    .get(TRPCONFIG.AutocompleterClientDomain + "/api2/travelagents/search?" + $.param({
                    tenantId: TRPCONFIG.Domain.TenantId,
                    pageSize: 10,
                    searchQuery: prefix
                }), { ignoreErrors: true })
                    .then(function (result) {
                    return {
                        data: result.data.map(function (t) { t.Title = t.Name; return t; }),
                        prefix: prefix
                    };
                }, function (error) {
                    if (error.status === httpStatus.BadRequest) {
                        return { data: [], prefix: prefix };
                    }
                });
            }
            else if ('attractions' === type) {
                return $http.post(TRPCONFIG.AutocompleterClientDomain + "/api2/attractions/bookingfunnel/find", {
                    DestinationId: TRPCONFIG.Domain.DomainId,
                    Fragment: prefix,
                    TenantId: TRPCONFIG.Domain.TenantId
                }).then(function (result) {
                    return {
                        data: result.data,
                        prefix: prefix
                    };
                });
            }
            else if (type === 'resorts') {
                return _autoCompleterApiCall('/api/hotels/autocompleter/transferdestinations?', prefix)
                    .then(function (result) {
                    if (result && result.data && result.data.d) {
                        return {
                            data: result.data.d.map(function (d) {
                                d.Title = d.t;
                                d.Code = d.v.i;
                                d.Type = d.v.t;
                                return d;
                            }),
                            prefix: prefix
                        };
                    }
                });
            }
            else if (type === 'userAccounts') {
                var nameParts = prefix.split(' ');
                var params = {
                    tenantId: TRPCONFIG.Domain.TenantId,
                    pageSize: 10,
                    firstName: nameParts[0] || '',
                    lastName: nameParts[1] || ''
                };
                return $http
                    .get(TRPCONFIG.AutocompleterClientDomain + "/api2/useraccounts/search?" + $.param(params))
                    .then(function (result) {
                    if (result && result.data && result.data.Results) {
                        return {
                            data: result.data.Results.map(function (t) {
                                t.Title = t.FirstName + " " + t.LastName;
                                return t;
                            }),
                            prefix: prefix
                        };
                    }
                });
            }
            return $http
                .get(TRPCONFIG.AutocompleterClientDomain + "/api/destinationsautocompleter/search?" + $.param({
                SearchTerm: prefix,
                MaxResults: 15,
                CultureCode: domain.CultureCode,
                HolidaySearch: type === 'holidays',
                DomainId: TRPCONFIG.Domain.DomainId,
                v: TRPCONFIG.CurrentVersion
            }), { ignoreErrors: true })
                .then(function (result) {
                return {
                    data: result.data.Destinations,
                    prefix: prefix
                };
            });
        }
        function mapDepartureAirports(airports, prefix) {
            if ($route.current.noGroup) {
                airports =
                    airports.filter(function removeGroups(cv) {
                        return cv.Code.indexOf(',') === -1;
                    });
            }
            return {
                data: _.map(airports, function (a) {
                    if (a.Title) {
                        a.ShortTitle = a.Title.indexOf(',') >= 0 ? a.Title.split(',')[0] : a.Title;
                    }
                    a.icon = 'flights';
                    return a;
                }),
                prefix: prefix
            };
        }
        function initialDepartureAirports() {
            var airports = buildUpChildAirports(localAirports);
            return $q.when(mapDepartureAirports(airports, ''));
        }
        function buildUpChildAirports(airports) {
            var result = [];
            _.forEach(airports, function (a) {
                result.push(a);
                var codes = a.Code.split(',');
                if (codes.length > 1) {
                    a.isGroup = true;
                    _.forEach(codes, function (c) {
                        var match = _.find(localAirports, function (a) { return a.Code === c; });
                        if (match) {
                            match = angular.copy(match);
                            match.isChild = true;
                            result.push(match);
                        }
                        else {
                            console.log('match could not be found for ', a.Code);
                        }
                    });
                }
            });
            result = result.filter(function (a) {
                if (a.isChild || a.isGroup) {
                    return true;
                }
                return !_.some(result, function (aa) { return aa.isChild && aa.Code === a.Code; });
            });
            return result;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('baggageService', baggageService);
    function baggageService(occupancyService, tripService, basketStore) {
        var service = {
            getBaggageInfo: getBaggageInfo
        };
        function getBaggageInfo(tripId) {
            return tripService.getTrip(tripId).then(function (trip) {
                if (trip == null) {
                    return [];
                }
                return basketStore.flightSpecificInfo(trip.BasketId).then(function (flightDetail) {
                    if (flightDetail) {
                        return _.map(flightDetail.Sectors, function (sector) { return mapBaggageInfo(trip, sector); });
                    }
                    return [];
                });
            });
        }
        function mapBaggageInfo(trip, sector) {
            var bagInfo = {
                holdBagsIncluded: false,
                holdBagCount: 0,
                passengerHoldBags: []
            };
            var flight = trip.FlightsRequest && trip.FlightsRequest.SelectedFlight || {};
            bagInfo.holdBagsIncluded = flight.LeadBaggagePrice === 0;
            if (bagInfo.holdBagsIncluded) {
                bagInfo.holdBagCount = occupancyService.getNumberOfNonInfantPassengers() || 1;
            }
            else {
                if (sector && sector.PassengerBagCounts) {
                    bagInfo.holdBagCount = _.reduce(sector.PassengerBagCounts, function (total, bags) { return total + bags.Quantity; }, 0);
                    bagInfo.passengerHoldBags = sector.PassengerBagCounts || [];
                }
                if (flight.AllBagsOrNone && bagInfo.holdBagCount > 0) {
                    bagInfo.holdBagCount = occupancyService.getNumberOfNonInfantPassengers() || 1;
                }
            }
            return bagInfo;
        }
        return service;
    }
})();
(function () {
    'use strict';
    /*
        For the moment the basket service is going to fulfill the workflow role
        i.e. it will act like a state machine to control the transitions that we require
        This might turn out to be wrong but we have no better way to track that state
        at the moment.
    */
    angular
        .module('TR')
        .service('basketService', basketService);
    function basketService($location, $q, $routeParams, $timeout, $rootScope, $filter, analytics, attractionService, basketStore, bd4travel, bookingService, broker, carHireService, cookieService, criteoService, currentDestination, dateUtil, enumService, flightSearch, flightsTerminalService, guidService, holidaySearch, hotelSearch, hotelService, insuranceService, loggingService, marhabaSearch, multiSectorSearch, parkingService, savedSearchService, searchUnitService, transferSearch, tripService, urlUtils, windowUtil, $window, urlStoreService, mandatoryTransferService) {
        var holidayBooking = 0;
        var hotelBooking = 1;
        var transferBooking = 2;
        var marhabaBooking = 3;
        var flightBooking = 4;
        var parkingBooking = 6;
        var attractionsBooking = 7;
        var insuranceBooking = 9;
        var autoSearch = 10;
        var workflowType = {
            1: flightBooking,
            2: hotelBooking,
            3: holidayBooking,
            4: transferBooking,
            6: parkingBooking
        };
        var flightUnavailable = false;
        var flightIncompleteDates = false;
        var holidaySearchProgress;
        var flightChanged = true;
        var oldAndNewFlightDatesMatch = false;
        broker.subscribe('basketService', 'flightNotAvailable', function (e) {
            flightUnavailable = true;
            tripService.getTrip(e.data)
                .then(function (trip) {
                var holiday = trip.TripType === tripService.tripTypes.Holiday;
                var flightsRoute = holiday ? 'holidays/flights/' : 'flights/';
                trip.FlightsRequest.SelectedFlight.Unavailable = true;
                tripService.persist(trip.TripId, trip).then(function () { return $location.url(flightsRoute + trip.TripId); });
            });
        });
        broker.subscribe('basketService', 'handOverToV3', function (e) {
            tripService.getTrip(e.data)
                .then(function (trip) {
                tripService.persist(trip.TripId, trip).then(function () { return $location.url("holidays/hotels/" + trip.TripId); });
            });
        });
        broker.subscribe('basketService', 'HotelOptionsAllowed', function () { return TRPCONFIG.DeviceSettings.HotelOptionsEnabled = true; });
        var service = {
            createTrip: createTrip,
            hotelBooking: hotelBooking,
            holidayBooking: holidayBooking,
            transferBooking: transferBooking,
            marhabaBooking: marhabaBooking,
            flightBooking: flightBooking,
            parkingBooking: parkingBooking,
            attractionsBooking: attractionsBooking,
            insuranceBooking: insuranceBooking,
            autoSearch: autoSearch,
            workflowType: workflowType,
            startWorkflow: startWorkflow,
            startMultiDestHolidayWorkflow: startMultiDestHolidayWorkflow,
            completeWorkflow: completeWorkflow,
            redirectToComplete: redirectToComplete,
            selectTransfer: selectTransfer,
            selectInsurance: selectInsurance,
            selectCar: selectCar,
            selectParking: selectParking,
            selectMarhaba: selectMarhaba,
            prepareMarhabaBooking: prepareMarhabaBooking,
            getHotelUrl: getHotelUrl,
            selectHotel: selectHotel,
            restartCurrentWorkflow: restartCurrentWorkflow,
            restartHolidayWorkflow: restartHolidayWorkflow,
            getFlight: getFlight,
            getHotel: getHotel,
            getInsuranceQuotes: getInsuranceQuotes,
            updateInsuranceQuote: updateInsuranceQuote,
            changeFlight: changeFlight,
            getTransfers: getTransfers,
            getCarQuotes: getCarQuotes,
            getCarQuotesFromSession: getCarQuotesFromSession,
            getParkingQuotes: getParkingQuotes,
            getAttractionQuotes: getAttractionQuotes,
            getMarhaba: getMarhaba,
            bookBasket: bookBasket,
            bookAttractionsBasket: bookAttractionsBasket,
            selectHotelRooms: selectHotelRooms,
            selectFlight: selectFlight,
            changeToFlightWorkflow: changeToFlightWorkflow,
            changeToHolidayTripType: changeToHolidayTripType,
            selectMultiFlight: selectMultiFlight,
            updateBasket: updateBasket,
            updateFlight: updateFlight,
            bookingAlreadyDone: bookingAlreadyDone,
            waitForFlight: waitForFlight,
            changeJourneyUrl: changeJourneyUrl,
            getHolidaySearchProgress: getHolidaySearchProgress,
            bookHotelBasket: bookHotelBasket,
            getArea: getArea,
            isFlightPreselected: isFlightPreselected,
            getHotelDatesFromFlight: getHotelDatesFromFlight,
            getNumberOfNightsFromFlights: getNumberOfNightsFromFlights,
            updateBrandedFare: updateBrandedFare
        };
        function changeJourneyUrl(breadcrumb, tripId) {
            var breadcrumbTrail = {
                0: _changeToHome,
                5: _changeToDeal,
                10: _changeToFlight,
                20: _changeToHotel,
                21: _changeToRoom,
                25: _changeToFlight,
                30: _changeToTransfer,
                35: _changeToParking,
                40: _changeToOptions,
                45: _changeToMarhaba,
                50: _changeToInsurance
            };
            if (breadcrumbTrail[breadcrumb] != null) {
                return service.getArea(tripId)
                    .then(function (area) { return breadcrumbTrail[breadcrumb](tripId || $routeParams.tripId || null, area); })
                    .then(function () { return handleMultiDestHolidayExit(tripId); });
            }
            loggingService.logError("changeJourneyUrl: breadcrumb: \"" + breadcrumb + "\" doesnt exist for tripId: \"" + $routeParams.tripId + "\"");
            return null;
        }
        function getArea(tripId) {
            return tripService.getTrip(tripId || $routeParams.tripId)
                .then(function (trip) {
                switch (trip.TripType) {
                    case 1://flight
                        return 'flights';
                    case 2://hotel
                        return 'hotels';
                    case 3://transfer
                        return 'transfers';
                    case 4://holiday
                        return 'holidays';
                    case 5:// marhaba
                        return 'marhaba'; // ?
                    case 6:// parking
                        return 'parking';
                    case 9:// insurance
                        return 'insurance';
                    default:
                        return '';
                }
            });
        }
        function _startHotelWorkflow(tripId, parameters) {
            sessionStorage.removeItem('preselectedHotelData');
            sessionStorage.removeItem('PreselectFlight');
            hotelSearch.clearSearchResults(parameters.defaultFilters);
            broker.publish('recommender.startSearch', { searchModel: parameters.searchModel, isHotel: true });
            var errors = hotelSearch.validateSearchCriteria();
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            var createSearchPromise;
            var hotelAvailabilityId;
            var dest;
            var estabId;
            return service.createTrip(tripId, tripService.tripTypes.Hotel)
                .then(function () { return searchUnitService.updateSearchArea(); })
                .then(function () {
                broker.publish('newSearchTriggered');
                return parameters.roomSearch ? currentDestination.getCurrentDestination() : searchUnitService.getDestination();
            })
                .then(function (d) {
                dest = d;
                var customRequest = { TripId: tripId, Destination: dest };
                hotelSearch.buildHotelsRequest(customRequest, searchUnitService.hotel);
                createSearchPromise = hotelSearch.createSearch().then(function (x) { return hotelAvailabilityId = x; });
                return TRPCONFIG.Domain.ImmediateSearch ? undefined : createSearchPromise;
            })
                .then(function () {
                estabId = parameters.estabId || (dest && dest.EstablishmentId);
                if (parameters.nextUrl !== false) {
                    var url = getHotelUrl({
                        tripId: tripId,
                        estabId: estabId,
                        isRoomSearch: parameters.roomSearch
                    });
                    $location.url(optionallyAppendParam(url, 'fid', parameters.fid));
                }
                return createSearchPromise;
            })
                .then(function () {
                if (estabId) {
                    hotelService.trackHotelClick(estabId, 0, undefined, undefined, hotelAvailabilityId);
                }
                return savedSearchService.saveHotelSearch(tripId);
            })
                .then(function () { return ({ hotelAvailabilityId: hotelAvailabilityId, tripId: tripId }); });
        }
        function _startAutoSearchWorkflow(tripId, parameters) {
            var isEstabSearch = _.get(parameters, 'destination[0].Type', 0) === 1;
            return isEstabSearch ? _startHotelWorkflow(tripId, parameters) : _startHolidayWorkflow(tripId, parameters);
        }
        function _startHolidayWorkflow(tripId, parameters) {
            return _startFlightPlusWorkflow(tripId, parameters, tripService.tripTypes.Holiday, false)
                .then(function () { return savedSearchService.saveHolidaySearch(tripId, parameters.searchModel); });
        }
        function _startChangeableFlightWorkflowWithProgress(tripId, parameters, progress) {
            return _startFlightPlusWorkflow(tripId, parameters, tripService.tripTypes.Flight, true)
                .then(function () { return savedSearchService.saveFlightSearch(tripId, parameters.searchModel); })
                .then(function () { return progress && progress.resolve(); })
                .finally(function () { return progress = null; });
        }
        function _startFlightPlusWorkflow(tripId, parameters, tripType, isFlexibleTripType) {
            broker.publish('recommender.startSearch', { searchModel: parameters.searchModel, isHotel: false });
            sessionStorage.removeItem('PreselectFlight');
            sessionStorage.removeItem('preselectedHotelData');
            sessionStorage.removeItem('storeSelectedFlight');
            var errors = flightSearch.validateSearchCriteria(true);
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            return holidaySearch.createSearch(parameters)
                .then(function (_a) {
                var data = _a.data;
                var preselectFlight = (data.PreselectFlight !== undefined && data.PreselectFlight
                    && data.PackageId === undefined
                    && TRPCONFIG.Domain.PreselectFlight
                    && TRPCONFIG.Domain.DeviceType === 'Desktop'
                    && !TRPCONFIG.Domain.isAgentMode) ||
                    (data.PreselectFlight !== undefined
                        && data.PreselectFlight
                        && data.PackageId === undefined
                        && TRPCONFIG.Domain.PreselectFlight
                        && TRPCONFIG.Domain.DeviceType === 'Desktop'
                        && TRPCONFIG.Domain.isAgentMode
                        && TRPCONFIG.Domain.isAgentModePreselectFlightEnabled) ||
                    TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled;
                sessionStorage.setItem('PreselectFlight', !!preselectFlight);
                parameters.FlightSearchId = data && data.FlightSearchId;
                return _startFlightWorkflow(tripId, tripType, function () {
                    hotelSearch.buildHotelsRequest({
                        AvailabilitySearchId: data.HotelSearchId,
                        TripId: tripId,
                        IsFlightPlus: true
                    }, searchUnitService.flight);
                    hotelSearch.setAirportCodeFilter(null);
                    return tripService.recordHotelSearch(tripId, hotelSearch.getAvailabilityRequest())
                        .then(function () { return tripService.setKidsFree(tripId, data.KidsGoFree); });
                }, _.defaults(parameters, { packageId: data.PackageId }), isFlexibleTripType);
            });
        }
        function optionallyAppendParam(path, param, value) {
            var querySymbol = path.indexOf('?') >= 0 ? '&' : '?';
            return value ? "" + path + querySymbol + param + "=" + value : path;
        }
        function _startFlightWorkflow(tripId, flow, hotelSearchFunc, params, isFlexibleTripType) {
            var isFlightType = flow === tripService.tripTypes.Flight;
            var isHolidayType = flow === tripService.tripTypes.Holiday;
            if (!isHolidayType) {
                sessionStorage.setItem('PreselectFlight', false);
            }
            var oneWayOnly = !!searchUnitService.isOneWayFlightEnabled() && isFlightType;
            if (params != null && params.oneWayOnly != null) {
                oneWayOnly = params.oneWayOnly;
            }
            var errors = flightSearch.validateSearchCriteria(!isFlightType, oneWayOnly);
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            flightSearch.clearSearchResults();
            hotelSearch.clearSearchResults(true);
            var isBestFit = (TRPCONFIG.Domain.BestFitFlightSelection || params.packageId && TRPCONFIG.Domain.DestinationBasedPackageRates) &&
                isHolidayType;
            var isBestFitOverride = TRPCONFIG.Domain2.IsBestFitOverride || false;
            return service.createTrip(tripId, flow, null, params.packageId, isFlexibleTripType).then(function () {
                broker.publish('newSearchTriggered');
                if (isBestFit) {
                    $location.search('bestfitdeal170', '1');
                }
                // Features that are permanently enabled to all users
                var parasolEnabledFeatures = _.get(TRPCONFIG, 'Domain.ParasolEnabledFeatures');
                var includesEnabledFeature = parasolEnabledFeatures && parasolEnabledFeatures.includes('holidays');
                // Features that are part of a test and can only be access by authenticated users
                var parasolTestingFeatures = _.get(TRPCONFIG, 'Domain2.ParasolTestingFeatures');
                var includesTestingFeature = parasolTestingFeatures && parasolTestingFeatures.includes('holidays');
                var testUserAuthenticated = cookieService.get('x-v3') === 'true' || cookieService.get('x-v3') === _.get(TRPCONFIG, 'Domain.ParasolVWOTestId');
                var isV3HolidayRoute = TRPCONFIG.IsMobileView && (params.packageId === undefined) && (includesEnabledFeature || (testUserAuthenticated && includesTestingFeature));
                var promises = $q.all({
                    hotelSearch: hotelSearchFunc ? hotelSearchFunc(tripId) : null,
                    flightSearch: flightSearch.search({
                        searchId: params.FlightSearchId || guidService.uuid(),
                        tripId: tripId,
                        newSearch: isFlightType,
                        oneWayOnly: oneWayOnly,
                        flightOnly: isFlightType,
                        flexibleDates: isFlightPreselected() ? false : params.flexibleDates,
                        isV3HolidayRoute: isV3HolidayRoute,
                        prefilterAirlines: params.prefilterAirlines,
                        postfilterAirlines: params.postfilterAirlines,
                        prefilterDirectFlights: params.prefilterDirectFlights,
                        sortOrder: _getSortOrder(isBestFit, isFlightPreselected(), isBestFitOverride),
                        useSearchUnit: true
                    })
                });
                return promises.then(function (data) {
                    if (isBestFit || isFlightPreselected()) {
                        if (data.flightSearch.CombinedDates.AvailableFlights.length) {
                            service.selectFlight(validateNextDayFlight(data.flightSearch.CombinedDates.AvailableFlights), tripId, null, params);
                        }
                        else {
                            $location.url(optionallyAppendParam("holidays/flights/" + tripId, 'fid', params.fid));
                        }
                    }
                    else if (isHolidayType) {
                        $location.url(optionallyAppendParam("holidays/flights/" + tripId, 'fid', params.fid));
                    }
                    else {
                        $location.url(optionallyAppendParam("flights/" + tripId, 'fid', params.fid));
                    }
                    criteoService.enqueue([], 'flightlist', flow);
                });
            });
        }
        function _getSortOrder(isBestFit, isHotelFirst, isBestFitOverride) {
            var recommendedSortId = 10;
            var lowestFirstSortId = 1;
            var sortId;
            if (isBestFitOverride && isBestFit && !TRPCONFIG.Domain.isAgentMode) {
                sortId = lowestFirstSortId;
            }
            else if (isBestFit) {
                sortId = recommendedSortId;
            }
            if (isHotelFirst) {
                sortId = lowestFirstSortId;
            }
            return sortId;
        }
        function getCheckInDateForFlight(flightArrival) {
            var landsAfterCutOff = flightArrival.getHours() >= TRPCONFIG.Domain.DepartureFlightCutOff;
            var zeroTime = dateUtil.zeroTime(flightArrival, true);
            return landsAfterCutOff ? zeroTime : dateUtil.addDays(zeroTime, -1, true);
        }
        function getCheckOutDateForFlight(flightReturn) {
            if (TRPCONFIG.Domain.ReturnFlightCutOff < 0) {
                return dateUtil.zeroTime(flightReturn, true);
            }
            var departsBeforeCutOff = flightReturn.getHours() < TRPCONFIG.Domain.ReturnFlightCutOff;
            var zeroTime = dateUtil.zeroTime(flightReturn, true);
            return departsBeforeCutOff ? dateUtil.addDays(zeroTime, -1, true) : zeroTime;
        }
        function validateNextDayFlight(flights) {
            // To avoid the problem of next day flight causing hotel checkin/checkout dates to be the same
            var returnFlightCutOffHours = TRPCONFIG.Domain.ReturnFlightCutOff;
            var flightsDepartAfterCutOffTime = flights.filter(function (flight) {
                var returnFlight = flight && flight.Legs && flight.Legs[flight.Legs.length - 1];
                var inboundFlight = flight && dateUtil.parseDate(returnFlight.DepartureDate);
                var getHoursOfReturnFlights = inboundFlight && inboundFlight.getHours();
                return getHoursOfReturnFlights >= returnFlightCutOffHours;
            });
            var overrideCheckoutMinusOneDay = TRPCONFIG.Domain2.overrideCheckoutMinusOneDay;
            var preSelectedFlight = overrideCheckoutMinusOneDay && flightsDepartAfterCutOffTime.length > 0 ? flightsDepartAfterCutOffTime[0] : flights[0];
            if (dateUtil.atLeastTwoDaysInTheFuture(preSelectedFlight.DepartureDate)) {
                return preSelectedFlight;
            }
            var validFlight = _.find(flights, function (f) {
                var legs = f.Legs;
                var flightArrival = dateUtil.parseDate(legs[0].Segments[legs[0].Segments.length - 1].ArrivalDate);
                var flightReturn = legs.length > 1 ? dateUtil.parseDate(legs[legs.length - 1].Segments[0].DepartureDate) : null;
                return dateUtil.getDifferenceInDays(new Date(getCheckInDateForFlight(flightArrival)), new Date(getCheckOutDateForFlight(flightReturn))) > 0;
            });
            return validFlight;
        }
        function _startMultiFlightWorkflow(tripId, params) {
            var errors = multiSectorSearch.validateSearchCriteria(params);
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            return createTrip(tripId, tripService.tripTypes.Flight)
                .then(function () {
                $location.path("multiflights/" + tripId);
                return multiSectorSearch.search(tripId, params);
            });
        }
        function _startTransferWorkflow(tripId, parameters) {
            transferSearch.clearSearchResults();
            if (!TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                searchUnitService.setLocationId(null);
            }
            var errors = transferSearch.validateSearchCriteria({ enableTransfersTimeApproval: parameters.enableTransfersTimeApproval });
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            return service.createTrip(tripId, tripService.tripTypes.Transfer).then(function () {
                $location.path("transfers/" + tripId);
                return transferSearch.search({ searchId: guidService.uuid(), tripId: tripId, newSearch: true, isFlightPlus: false }).then(savedSearchService.saveTransferSearch);
            });
        }
        function _startMarhabaWorkflow(tripId) {
            marhabaSearch.clearSearchResults();
            var errors = marhabaSearch.validateSearchCriteria();
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            return service.createTrip(tripId, tripService.tripTypes.Marhaba).then(function () {
                $location.path("marhaba/" + tripId);
                return marhabaSearch.search({ searchId: guidService.uuid(), tripId: tripId, newSearch: true });
            });
        }
        function _startParkingWorkflow(tripId) {
            parkingService.clearSearchResults();
            var errors = parkingService.validateSearchCriteria();
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            return service.createTrip(tripId, tripService.tripTypes.Parking)
                .then(function () { return parkingService.getParkingQuotes(tripId); })
                .then(function () { return $location.path("parking/" + tripId); })
                .then(function () { return savedSearchService.saveParkingSearch(tripId); });
        }
        function _startAttractionsWorkflow(params) {
            return basketStore.getAttractionsBasketId()
                .then(function (basketId) { return basketStore.addAttraction(params.productId, params.productTags, basketId); })
                .then(function (basketData) {
                if (basketData.error) {
                    return;
                }
                var changeData = basketData.Change;
                var lineItems = changeData && changeData.New || [];
                if (!lineItems.length) {
                    // No new items, check if a product already in the basket was modified
                    lineItems = attractionService.getLineItemChanges(basketData);
                }
                return lineItems;
            });
        }
        function _startInsuranceWorkflow(tripId) {
            insuranceService.clearSearchResults();
            var errors = insuranceService.validateSearchCriteria();
            if (errors.length > 0) {
                return $q.reject(errors);
            }
            return service.createTrip(tripId, tripService.tripTypes.Insurance).then(function () {
                $location.path("insurance/results/" + tripId);
                return insuranceService.search({ searchId: guidService.uuid(), tripId: tripId, newSearch: true })
                    .then(savedSearchService.saveInsuranceSearch);
            });
        }
        function _prepareBooking(tripId, path, v3) {
            if (v3 === void 0) { v3 = false; }
            return tripService.setBookingId(tripId, guidService.uuid())
                .then(function (trip) {
                return bookingService.prepareBooking(trip.BasketId, trip.BookingId, tripId)
                    .then(function (preparedBooking) {
                    if (v3) {
                        $window.location.href = "booking/summary/" + tripId + "?gov=3";
                    }
                    else {
                        $location.path(path + "/" + tripId);
                    }
                    return preparedBooking;
                });
            });
        }
        function startWorkflow(type, parameters) {
            var honeycombDeeplink = getHoneycombDeepLink(type, parameters);
            if (honeycombDeeplink && location && location.href) {
                location.href = honeycombDeeplink;
                return;
            }
            var tripId = guidService.uuid();
            var requestedUrl = $location.url();
            var source = $routeParams.source;
            var result = startWorkflowInternal(type, parameters, tripId);
            if (result && type !== attractionsBooking) {
                result.then(function () {
                    analytics.trackSearchOrigin(tripId, requestedUrl);
                    if (source) {
                        $location.search('source', source);
                    }
                });
            }
            return result;
        }
        function startMultiDestHolidayWorkflow() {
            return __awaiter(this, void 0, void 0, function () {
                var query, variantKey, variant, basket, basketId, tripId, trip, err_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 6, , 7]);
                            query = $location.search();
                            variantKey = 'variant';
                            variant = query && variantKey in query && Number(query[variantKey]) || undefined;
                            return [4 /*yield*/, basketStore.createBasket(true /* ForHoliday */)];
                        case 1:
                            basket = _a.sent();
                            basketId = basket.BasketId;
                            return [4 /*yield*/, hotelSearch.createMultiDestHolidaySearch(basketId, variant)];
                        case 2:
                            tripId = _a.sent();
                            if (!(basketId && tripId)) return [3 /*break*/, 5];
                            searchUnitService.setDestination(null);
                            return [4 /*yield*/, tripService.getTrip(tripId)];
                        case 3:
                            trip = _a.sent();
                            return [4 /*yield*/, tripService.persist(tripId, Object.assign({}, trip, { BasketId: basketId }))];
                        case 4:
                            _a.sent();
                            analytics.trackSearchOrigin(tripId, $location.url());
                            $location.path("/holidays/january-sale/" + tripId).search(_.omit(query, variantKey));
                            _a.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            err_6 = _a.sent();
                            loggingService.logError('Multi destination holiday search failed', JSON.stringify(err_6));
                            $location.path('/error');
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
        function handleMultiDestHolidayExit(tripId) {
            if (tripId === void 0) { tripId = $routeParams.tripId; }
            return __awaiter(this, void 0, void 0, function () {
                var trip;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, tripService.getTrip(tripId)];
                        case 1:
                            trip = _a.sent();
                            if (trip.TripType === tripService.tripTypes.MultiDestHoliday) {
                                return [2 /*return*/, tripService.changeTripType(tripId, tripService.tripTypes.Holiday)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function getHolidaySearchProgress() {
            return holidaySearchProgress && holidaySearchProgress.promise || $q.when();
        }
        function startWorkflowInternal(type, parameters, tripId) {
            if (!parameters) {
                parameters = {};
            }
            if (type === flightBooking) {
                var flightDestinationKeys = _.keys(searchUnitService.getDestination());
                var isntFlexibleFlightDestination = flightDestinationKeys[0] === 'Title' && flightDestinationKeys.length === 1;
                if (parameters.multi) {
                    return _startMultiFlightWorkflow(tripId, parameters);
                }
                if (isntFlexibleFlightDestination) {
                    return _startFlightWorkflow(tripId, tripService.tripTypes.Flight, null, parameters, false)
                        .then(function () { return savedSearchService.saveFlightSearch(tripId, parameters.searchModel); });
                }
                if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                    holidaySearchProgress = $q.defer();
                    return _startChangeableFlightWorkflowWithProgress(tripId, parameters, holidaySearchProgress);
                }
                return _startFlightWorkflow(tripId, tripService.tripTypes.Flight, null, parameters, false)
                    .then(function () { return savedSearchService.saveFlightSearch(tripId, parameters.searchModel); });
            }
            if (type === hotelBooking) {
                hotelSearch.setAirportCodeFilter(null);
                return _startHotelWorkflow(tripId, parameters);
            }
            searchUnitService.setDefaultCurrency();
            if (type === holidayBooking) {
                holidaySearchProgress = $q.defer();
                if (parameters.isFlexibleTripType) {
                    return _startChangeableFlightWorkflowWithProgress(tripId, parameters, holidaySearchProgress);
                }
                return _startHolidayWorkflow(tripId, parameters)
                    .then(function () { return holidaySearchProgress && holidaySearchProgress.resolve(); })
                    .finally(function () { return holidaySearchProgress = null; });
            }
            if (type === transferBooking) {
                return _startTransferWorkflow(tripId, parameters);
            }
            if (type === marhabaBooking) {
                return _startMarhabaWorkflow(tripId, parameters);
            }
            if (type === parkingBooking) {
                return _startParkingWorkflow(tripId, parameters);
            }
            if (type === attractionsBooking) {
                return _startAttractionsWorkflow(parameters);
            }
            if (type === insuranceBooking) {
                return _startInsuranceWorkflow(tripId, parameters);
            }
            if (type === autoSearch) {
                return _startAutoSearchWorkflow(tripId, parameters);
            }
        }
        function createTrip(TripId, TripType, basketId, PackageId, FlexibleTripType) {
            return $q.when(basketId ||
                basketStore.createBasket(TripType === tripService.tripTypes.Holiday)
                    .then(function (_a) {
                    var BasketId = _a.BasketId;
                    return BasketId;
                }))
                .then(function (BasketId) { return tripService.persist(TripId, {
                BasketId: BasketId,
                FlexibleTripType: FlexibleTripType,
                PackageId: PackageId,
                TripId: TripId,
                TripType: TripType
            }); });
        }
        function completeWorkflow(refs, basketId) {
            return $q.all([
                basketStore.all(basketId),
                basketStore.totalCost(basketId),
                basketStore.getBasketCurrency(basketId)
            ]).then(function (_a) {
                var basket = _a[0], total = _a[1], currency = _a[2];
                broker.publish('bookingComplete', { refs: refs, basket: basket, total: total, currency: currency });
                return basketStore.clearBasket(basketId).then(function () {
                    return [basket, total, currency];
                });
            });
        }
        function redirectToComplete(refs, basketId, totalCost, tripId) {
            var refRoute = refs.join('|');
            var url = "/booking/complete/" + refRoute + "?tripId=" + tripId;
            if (TRPCONFIG.Domain.BuyNowPayLaterEnabled && totalCost > TRPCONFIG.Domain.BuyNowPayLaterCost) {
                url = url + "&pl=1";
            }
            if (TRPCONFIG.Domain.ParasolBookingComplete) {
                //Leave some time for tracking to complete:
                setTimeout(function () { return window.location = url; }, 333);
            }
            else {
                $location.url(url);
            }
        }
        function _changeToHome(tripId, area) {
            $location.url(TRPCONFIG.Domain.SearchUnitHomePath + area);
        }
        function _changeToDeal(tripId) {
            return tripService.getTrip(tripId).then(function (trip) {
                if (trip && trip.Deal) {
                    $location.url(urlUtils.stripLeadingSlash(trip.Deal.OriginPath));
                }
            });
        }
        function _changeToFlight(tripId) {
            return tripService.getTrip(tripId)
                .then(function (_a) {
                var FlexibleTripType = _a.FlexibleTripType, TripType = _a.TripType, HotelsRequest = _a.HotelsRequest;
                if (TripType === tripService.tripTypes.MultiDestHoliday ||
                    // On the booking form, TripType changes to Holiday so test for Destinations prop
                    (HotelsRequest && HotelsRequest.Destinations)) {
                    return searchUnitService.setDestination(HotelsRequest.Destination)
                        .then(function () { return startWorkflow(holidayBooking); });
                }
                return $location.path((TripType === tripService.tripTypes.Holiday && !FlexibleTripType ? 'holidays/' : '') + "flights/" + tripId);
            });
        }
        function _changeToHotel(tripId, area) {
            return tripService.setDirectToHotel(tripId, false).then(function () {
                $location.path(area + "/" + (area === 'holidays' ? 'hotels/' : '') + tripId);
            });
        }
        function _changeToRoom(tripId, area) {
            return tripService.getTrip(tripId).then(function (trip) {
                basketStore.hotel(trip.BasketId).then(function (hotel) {
                    $location.path(area + "/" + tripId + "/" + hotel.Details.Id);
                });
            });
        }
        function _changeToTransfer(tripId) {
            $location.path("transfers/" + tripId);
        }
        function _changeToParking(tripId) {
            $location.path("parking/" + tripId);
        }
        function _changeToMarhaba(tripId) {
            $location.path("marhaba/" + tripId);
        }
        function _changeToInsurance(tripId) {
            $location.path("insurance/results/" + tripId);
        }
        function _changeToOptions(tripId, area) {
            $location.path(area + "/options/" + tripId);
        }
        function getBookingPath(trip) {
            var isMeta = _.get($location.search(), 'source') === 'TV';
            var isHolidayDeal = _.get(trip, 'FromHolidayDeal');
            var isHoliday = _.get(trip, 'TripType') === 4;
            if (isHolidayDeal) {
                return isHoliday ? 4 : 3;
            }
            if (isMeta) {
                return isHoliday ? 6 : 5;
            }
            return isHoliday ? 2 : 1;
        }
        function selectTransfer(id, searchId, basketId, tripId) {
            return basketStore.transfer(basketId).then(function (t) {
                if (t == null || t.Details.TransferId !== id) {
                    return basketStore.addTransfer(searchId, id, basketId).then(function (transfer) {
                        service.updateBasket();
                        return basketStore.all(basketId).then(function (products) {
                            if (products.t && !products.h && !products.f) {
                                _prepareBooking(tripId, 'transfers/book');
                            }
                            return transfer;
                        });
                    });
                }
                return t;
            });
        }
        function selectInsurance(quote, searchId, basketId, tripId) {
            return basketStore.insurance(basketId)
                .then(function () {
                return basketStore.addInsurance(searchId, quote, basketId).then(function (insurance) {
                    service.updateBasket();
                    return basketStore.all(basketId).then(function (products) {
                        if (products.i && !products.h && !products.f) {
                            _prepareBooking(tripId, 'insurance/book');
                        }
                        return insurance;
                    });
                });
            });
        }
        function selectCar(quote, searchId, basketId) {
            return basketStore.addCar(searchId, quote, basketId).then(function (carhire) {
                service.updateBasket();
                return carhire;
            });
        }
        function selectParking(id, searchId, basketId, tripId) {
            var parking;
            return basketStore.addParking(searchId, id, basketId)
                .then(function (p) {
                parking = p;
                service.updateBasket();
                return basketStore.all(basketId);
            })
                .then(function (_a) {
                var p = _a.p, h = _a.h, f = _a.f;
                // Assume standalone parking if no hotel or flight
                if (p && !h && !f) {
                    _prepareBooking(tripId, 'parking/book');
                }
                return parking;
            });
        }
        function selectMarhaba(tripId, parameters) {
            return _startMarhabaWorkflow(tripId, parameters);
        }
        function prepareMarhabaBooking(tripId, productId) {
            return tripService.setBookingId(tripId, guidService.uuid())
                .then(function (trip) {
                return bookingService.prepareBooking(trip.BasketId, trip.BookingId, tripId)
                    .then(function (preparedBooking) {
                    $location.path("marhaba/book/" + tripId + "/" + productId);
                    return preparedBooking;
                });
            });
        }
        function getHotelUrl(_a) {
            var tripId = _a.tripId, hotel = _a.hotel, flight = _a.flight, estabId = _a.estabId, _b = _a.isRoomSearch, isRoomSearch = _b === void 0 ? true : _b, TripType = _a.TripType;
            estabId = estabId || _.get(hotel, 'Id');
            var isAmmendBooking = !!$routeParams.BookingRef;
            var isHolidays = flight || TripType === tripService.tripTypes.Holiday;
            var url = isAmmendBooking ? "dashboard/amend-booking/" + $routeParams.BookingRef + "/" + $routeParams.BookingId :
                isHolidays ? 'holidays' :
                    'hotels';
            url += "/" + tripId;
            if (estabId && (TRPCONFIG.Domain.HotelSearchNoResultsPage !== 'availability' || isRoomSearch)) {
                url += "/" + estabId;
            }
            var search = _.omit($location.search(), '__bd4sort');
            var hotelIndex = _.get(hotel, 'HotelIndex');
            if (hotelIndex != null && bd4travel.currentHotelRankingScoresToken) {
                var bd4ListId = flight ? 'holidays_list' : 'hotel_list';
                search.__bd4sort = bd4ListId + "|" + hotelIndex + "|" + bd4travel.currentHotelRankingScoresToken;
            }
            var querystring = $.param(search);
            if (querystring) {
                url += "?" + querystring;
            }
            return url;
        }
        function selectHotel(tripId, hotel, basketId, area, sameWindow, newTab) {
            tripService.setDirectToHotel(tripId, false);
            basketStore.flight(basketId)
                .then(function (flight) {
                if (flightUnavailable) {
                    return;
                }
                var url = getHotelUrl({ tripId: tripId, hotel: hotel, flight: flight });
                if (newTab) {
                    windowUtil.open(url);
                }
                else if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow && !sameWindow) {
                    windowUtil.open(url);
                }
                else {
                    $location.url(url);
                }
            });
        }
        function restartCurrentWorkflow(tripId) {
            tripService.getTrip(tripId)
                .then(function (trip) {
                basketStore.all(trip.BasketId)
                    .then(function (products) {
                    if (products.t != null) {
                        $location.path('transfers');
                    }
                    else if (products.f != null) {
                        $location.path('holidays');
                    }
                    else {
                        $location.path('hotels');
                    }
                });
            });
        }
        function restartHolidayWorkflow() {
            $location.path('holidays');
        }
        function getFlight(basketId) {
            return basketStore.flight(basketId);
        }
        function getHotel(basketId) {
            return basketStore.hotel(basketId);
        }
        function changeFlight(tripId) {
            $location.path("holidays/flights/" + tripId);
        }
        function getTransfers(searchId, basketId, tripId, params) {
            if (params === void 0) { params = {}; }
            if (searchId) {
                return transferSearch.getSearchResults(searchId, tripId);
            }
            return basketStore.all(basketId).then(function (products) {
                if (params.airport && params.dates) {
                    searchUnitService.startDate(searchUnitService.transfer, _(params).get('dates.arrivalDate'));
                    searchUnitService.endDate(searchUnitService.transfer, _(params).get('dates.departureDate'));
                    searchUnitService.setDestinationAirport(params.airport);
                }
                else {
                    var legs = _.get(products, 'f.Details.Itinerary.Legs', []);
                    searchUnitService.startDate(searchUnitService.transfer, legs[0].ArrivalDate);
                    if (legs.length > 1) {
                        searchUnitService.endDate(searchUnitService.transfer, legs[legs.length - 1].DepartureDate);
                    }
                    searchUnitService.setDestinationAirport(legs[0].ArrivalAirport);
                }
                if (products.h != null) {
                    searchUnitService.setLocationId(products.h.Details.LocationId);
                }
                var errors = transferSearch.validateSearchCriteria();
                if (errors.length > 0) {
                    return $q.when([]);
                }
                var args = { searchId: guidService.uuid(), newSearch: true, tripId: tripId, isFlightPlus: true };
                if (products.h && products.h.FuturePayments.length) {
                    args.BalanceDueDateOverride = products.h.FuturePayments[products.h.FuturePayments.length - 1].Due;
                }
                return transferSearch.search(args);
            });
        }
        function getInsuranceQuotes(searchId, basketId, tripId, params) {
            if (params === void 0) { params = {}; }
            if (searchId) {
                return insuranceService.getInsuranceQuotesFromSession(searchId);
            }
            return $q.all({
                flight: basketStore.flight(basketId),
                hotel: basketStore.hotel(basketId)
            }).then(function (_a) {
                var flight = _a.flight, hotel = _a.hotel;
                if (flight == null && hotel == null) {
                    return $q.when([]);
                }
                var legs = _.get(flight, 'Details.Itinerary.Legs');
                var search = function (ageList) {
                    var request = {
                        AvailabilitySearchId: guidService.uuid(),
                        DestinationAirportCode: _.get(params, 'airport.Code') || legs[0].ArrivalAirport.Code,
                        StartDate: _.get(params, 'dates.arrivalDate') || legs[0].DepartureDate,
                        Ages: ageList
                    };
                    request.EndDate = _.get(params, 'dates.departureDate') || (params.oneWayOnly ? legs[0].ArrivalDate
                        : legs[legs.length - 1].ArrivalDate);
                    return insuranceService.getInsuranceQuotes(tripId, request);
                };
                if (params.ages) {
                    return search(params.ages);
                }
                return tripService.getTripReducedOccupancy(tripId).then(function (o) {
                    var ages = _.concat(_.times(o.Adults, function () { return 21; }), o.ChildAges);
                    return search(ages);
                });
            });
        }
        function updateInsuranceQuote(basketId, tripId, selectedOptionId, params) {
            // tackle a scenario when quote is updated by navigating to booking form rather than user action
            // in that case do not remove it
            if (!selectedOptionId) {
                return $q.when([]);
            }
            if (!params.ages || params.ages.length === 0) {
                return basketStore.removeInsurance(basketId);
            }
            //need to update the quote we have
            // get existing quote, make a new request, find the selected option and add it to the basket
            var key = insuranceService.decomposeOptionId(selectedOptionId);
            //remove existing
            return basketStore.removeInsurance(basketId).then(function () {
                //get new quotes
                return getInsuranceQuotes(null, basketId, tripId, params);
            }).then(function (insuranceQuotes) {
                //find the same type
                return _.filter(insuranceQuotes, function (q) {
                    return q.SupplierId === key.supplierId && q.QuoteType.SchemeId === key.schemeId && q.QuoteType.TypeId === key.typeId;
                });
            }).then(function (quotes) {
                //add it to our basket
                return tripService.getTrip(tripId).then(function (trip) {
                    return selectInsurance(quotes[0], trip.InsuranceRequest.AvailabilitySearchId, basketId, tripId);
                });
            });
        }
        function getMarhaba(searchId, basketId, tripId, parameters) {
            if (!searchId) {
                searchId = guidService.uuid();
            }
            $location.url("marhaba/" + tripId);
            return marhabaSearch.search({ searchId: searchId, tripId: tripId, newSearch: true, parameters: parameters });
        }
        function bookBasket(tripId, basketId) {
            return basketStore.flight(basketId)
                .then(function (f) {
                if (f) {
                    return _prepareBooking(tripId, 'holidays/book');
                }
            });
        }
        function bookAttractionsBasket(tripId) {
            if (tripId === void 0) { tripId = guidService.uuid(); }
            basketStore.getAttractionsBasketId()
                .then(function (basketId) { return createTrip(tripId, tripService.tripTypes.Attractions, basketId); })
                .then(function () { return _prepareBooking(tripId, 'attractions/book'); });
        }
        function selectHotelRooms(hotel, roomIds, tripId) {
            if (flightUnavailable) {
                return;
            }
            var selectRoomFirstTime = sessionStorage.getItem('preselectedHotelData') === null;
            $q.all({
                trip: tripService.clearOptionalExtras(tripId),
                numberOfNights: tripService.getHotelsRequestNumberOfNights(tripId),
                currency: tripService.getCurrency(tripId)
            })
                .then(function (_a) {
                var trip = _a.trip, numberOfNights = _a.numberOfNights, currency = _a.currency;
                if (trip && trip.HotelsRequest) {
                    var bookingPath = getBookingPath(trip);
                    var rebookId = $routeParams.BookingId;
                    basketStore.addHotel(trip.HotelsRequest.AvailabilitySearchId, hotel.Id, roomIds, trip.BasketId, bookingPath, trip.PackageId, rebookId)
                        .then(function (res) {
                        basketStore.flight(trip.BasketId)
                            .then(function (f) {
                            var options = mandatoryTransferService.getOptions();
                            if (TRPCONFIG.Domain.MandatoryExtrasEnabled && options) {
                                basketStore.addOptions(basketStore.productType.Transfer, res.ProductId, options, trip.BasketId);
                            }
                            broker.publish('roomsAddedToBasket', hotel);
                            service.updateBasket();
                            bd4travel.availabilityCheck(trip, hotel.Id);
                            if (f) {
                                if (isFlightPreselected() && (!flightChanged || selectRoomFirstTime)) {
                                    $location.path("holidays/flights/" + tripId);
                                }
                                else {
                                    $location.path("holidays/options/" + tripId);
                                }
                            }
                            else if (TRPCONFIG.DeviceSettings.HotelOptionsEnabled
                                && TRPCONFIG.Domain.CurrencyCode === currency
                                && TRPCONFIG.Domain.HotelOptionsMinDuration
                                && numberOfNights >= TRPCONFIG.Domain.HotelOptionsMinDuration
                                && hotel.LinkedAirports
                                && hotel.LinkedAirports.length
                                && !_.intersection(hotel.LinkedAirports.map(function (a) { return a.Code; }), TRPCONFIG.Domain.HotelOptionsFilterOutAirportCodes).length) {
                                $location.path("hotels/options/" + tripId);
                            }
                            else {
                                var totalRooms = trip.HotelsRequest.Rooms && trip.HotelsRequest.Rooms.length || 0;
                                var singleRoomOnly = TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly
                                    && totalRooms === 1;
                                var isMobile = TRPCONFIG.IsMobileView;
                                var goV3 = isMobile && (TRPCONFIG.Domain.ParasolHotelBooking && singleRoomOnly)
                                    || (TRPCONFIG.Domain.ParasolHotelBooking && !TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly);
                                _prepareBooking(tripId, 'hotels/book', goV3);
                            }
                        });
                    }, function (res) { return bd4travel.availabilityCheck(trip, hotel.Id, res); });
                }
            });
        }
        function bookHotelBasket(tripId) {
            _prepareBooking(tripId, 'hotels/book');
        }
        function updateBrandedFare(params) {
            return basketStore.updateBrandedFare(params)
                .then(function (f) {
                broker.publish('flightAddedToBasket', f);
                service.updateBasket();
            });
        }
        function selectFlight(flight, tripId, opts, params, mobileParams) {
            if (mobileParams === void 0) { mobileParams = {}; }
            //if the flight does not contain full date information (AVRO), then we
            //have to wait until after the detail call has completed before moving on to
            //the hotel route
            var HasFullDates = flight.HasFullDates, Legs = flight.Legs;
            var airportCodeFilter = TRPCONFIG.Domain.AutoFilterByAirport ? Legs[0].ArrivalAirport.Code : null;
            var storeSelectedFlight = sessionStorage.getItem('storeSelectedFlight');
            storeSelectedFlight = JSON.parse(storeSelectedFlight !== null ? storeSelectedFlight : '{}');
            var flightComparisonResult = _compareFlights(storeSelectedFlight, flight);
            flightChanged = flightComparisonResult.isDifferentFlights;
            oldAndNewFlightDatesMatch = flightComparisonResult.isDatesMatch;
            var preselectedHotelData = sessionStorage.getItem('preselectedHotelData');
            flightUnavailable = false;
            flightIncompleteDates = !HasFullDates;
            hotelSearch.setAirportCodeFilter(airportCodeFilter);
            sessionStorage.setItem('storeSelectedFlight', JSON.stringify(flight));
            if (!oldAndNewFlightDatesMatch) {
                sessionStorage.removeItem('preselectedHotelData');
            }
            return tripService.getTrip(tripId).then(function (trip) {
                if (trip) {
                    var BasketId_1 = trip.BasketId, FlexibleTripType = trip.FlexibleTripType, FlightsRequest_1 = trip.FlightsRequest, HotelsRequest = trip.HotelsRequest, PackageId_1 = trip.PackageId, TripType = trip.TripType;
                    var isFlightType = TripType === tripService.tripTypes.Flight;
                    var isHolidayType_1 = TripType === tripService.tripTypes.Holiday;
                    var isMultiDestHolidayType_1 = TripType === tripService.tripTypes.MultiDestHoliday;
                    var isDirectFlight = _.reduce(Legs, function (result, value) { return result.NumberOfStops + value.NumberOfStops; }) === 0;
                    var isOneRoomOccupency = HotelsRequest && HotelsRequest.Rooms && HotelsRequest.Rooms.length === 1;
                    var isHotelsOnFlights_1 = TRPCONFIG.Domain.HotelsOnFlightsEnabled && isFlightType && FlexibleTripType && !PackageId_1 && isDirectFlight && isOneRoomOccupency;
                    var nextRoute_1 = getRedirectUrlAfterSelectFlight(isHolidayType_1, isHotelsOnFlights_1, tripId, oldAndNewFlightDatesMatch, preselectedHotelData);
                    if (isHolidayType_1 || isHotelsOnFlights_1) {
                        var paramsCopy = __assign({}, params, mobileParams);
                        nextRoute_1 = optionallyAppendParam(nextRoute_1, 'fid', paramsCopy && paramsCopy.fid);
                    }
                    return tripService.clearOptionalExtras(tripId).then(function () {
                        if (FlightsRequest_1) {
                            tripService.setSelectedFlight(tripId, flight, opts);
                            var addFlightPromise = (flight.isMultiDestHolidayLinked
                                ? basketStore.addMultiDestHolidayFlight
                                : basketStore.addFlight)(FlightsRequest_1.AvailabilitySearchId, flight, BasketId_1, tripId, true, opts, PackageId_1);
                            if (!isMultiDestHolidayType_1 && isFlightPreselected() && trip.TripType === 4) {
                                if (isHolidayType_1 || isHotelsOnFlights_1) {
                                    nextRoute_1 = optionallyAppendParam(nextRoute_1, 'fbt', params && params.fbt);
                                }
                                $location.url(nextRoute_1);
                            }
                            //if we are in flight only mode here, we need to make sure that this cannot trigger a hotel search
                            //due to dates being adjusted.
                            return addFlightPromise.then(function (addFlightResponse) {
                                if (addFlightResponse) {
                                    broker.publish('flightAddedToBasket', addFlightResponse);
                                    service.updateBasket();
                                    if (opts && opts.skipRedirection) {
                                        return;
                                    }
                                    if (!isMultiDestHolidayType_1) {
                                        if (isHolidayType_1 || isHotelsOnFlights_1) {
                                            nextRoute_1 = optionallyAppendParam(nextRoute_1, 'fbt', params && params.fbt);
                                        }
                                        $location.url(nextRoute_1);
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
        function getRedirectUrl(tripId, oldAndNewFlightDatesMatch, estabId) {
            if (urlStoreService.isPreviousUrlHotelDetails(tripId)) {
                return urlStoreService.getPreviousURL();
            }
            if (urlStoreService.isPreviousUrlHotelOptions(tripId) || urlStoreService.isPreviousUrlHotelBook(tripId)) {
                if (oldAndNewFlightDatesMatch) {
                    return urlStoreService.getPreviousURL();
                }
                return estabId ? "holidays/" + tripId + "/" + estabId : '';
            }
            return '';
        }
        function getRedirectUrlHotelFirstJourney(tripId, oldAndNewFlightDatesMatch, estabId) {
            if (oldAndNewFlightDatesMatch) {
                return "holidays/options/" + tripId;
            }
            return estabId ? "holidays/" + tripId + "/" + estabId : '';
        }
        function getRedirectUrlAfterSelectFlight(isHolidayType, isHotelsOnFlights, tripId, oldAndNewFlightDatesMatch, hotelData) {
            var hotelDataJson = hotelData && JSON.parse(hotelData);
            var estabId = _.get(hotelDataJson, 'd.Itinerary.EstabId');
            var nextPath = (isHolidayType || isHotelsOnFlights) && sessionStorage.getItem('preselectedHotelData') === null ? 'hotels' : 'options';
            var backwardCompatibilityUrl = "holidays/" + nextPath + "/" + tripId;
            switch (true) {
                case TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled:
                    return getRedirectUrlHotelFirstJourney(tripId, oldAndNewFlightDatesMatch, estabId) || backwardCompatibilityUrl;
                case TRPCONFIG.Domain2.EnableChangeFlightRedirectionToPrevious:
                    return getRedirectUrl(tripId, oldAndNewFlightDatesMatch, estabId) || backwardCompatibilityUrl;
                default:
                    return backwardCompatibilityUrl;
            }
        }
        function _compareFlights(selectedFlight, newFlight) {
            var isDifferentFlights = true;
            var isDatesMatch = false;
            if (selectedFlight.FlightId !== undefined && newFlight.FlightId !== undefined) {
                isDifferentFlights = selectedFlight.FlightId !== newFlight.FlightId;
            }
            if (selectedFlight.Legs !== undefined && selectedFlight.Legs[0] !== undefined && selectedFlight.Legs[1] !== undefined) {
                isDatesMatch = isCheckOutDatesMatched(selectedFlight.Legs[1].DepartureDate, newFlight.Legs[1].DepartureDate)
                    && isCheckInDatesMatched(selectedFlight.Legs[0].ArrivalDate, newFlight.Legs[0].ArrivalDate);
            }
            return { isDifferentFlights: isDifferentFlights, isDatesMatch: isDatesMatch };
        }
        function isCheckInDatesMatched(date1, date2) {
            date1 = getCheckInDateForFlight(new Date(date1));
            date2 = getCheckInDateForFlight(new Date(date2));
            return $filter('date')(date1, 'dd MM yy') === $filter('date')(date2, 'dd MM yy');
        }
        function isCheckOutDatesMatched(date1, date2) {
            date1 = getCheckOutDateForFlight(new Date(date1));
            date2 = getCheckOutDateForFlight(new Date(date2));
            return $filter('date')(date1, 'dd MM yy') === $filter('date')(date2, 'dd MM yy');
        }
        function getHotelDatesFromFlight(flight) {
            var checkInDate = _.get(flight, 'Legs[0].ArrivalDate');
            var checkOutDate = _.get(flight, 'Legs[1].DepartureDate');
            if (checkInDate && checkOutDate) {
                checkInDate = getCheckInDateForFlight(new Date(checkInDate));
                checkOutDate = getCheckOutDateForFlight(new Date(checkOutDate));
            }
            return [checkInDate, checkOutDate];
        }
        function getNumberOfNightsFromFlights() {
            var flights = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                flights[_i] = arguments[_i];
            }
            return flights.map(function (flight) {
                var checkInDate = _.get(flight, 'Legs[0].ArrivalDate');
                var checkOutDate = _.get(flight, 'Legs[1].DepartureDate');
                if (checkInDate && checkOutDate) {
                    checkInDate = getCheckInDateForFlight(new Date(checkInDate));
                    checkOutDate = getCheckOutDateForFlight(new Date(checkOutDate));
                    return dateUtil.numberOfNights(checkInDate, checkOutDate);
                }
                return undefined;
            });
        }
        function changeToFlightWorkflow(tripId) {
            return __awaiter(this, void 0, void 0, function () {
                var TripType, isHolidayType, BasketId, basketStoreFlightResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, tripService.getTrip(tripId)];
                        case 1:
                            TripType = (_a.sent()).TripType;
                            isHolidayType = TripType === tripService.tripTypes.Holiday;
                            if (!(TRPCONFIG.Domain.HotelsOnFlightsEnabled && isHolidayType)) return [3 /*break*/, 5];
                            return [4 /*yield*/, tripService.changeTripType(tripId, tripService.tripTypes.Flight)];
                        case 2:
                            BasketId = (_a.sent()).BasketId;
                            return [4 /*yield*/, basketStore.removeAccomodation(BasketId)];
                        case 3:
                            _a.sent();
                            return [4 /*yield*/, basketStore.flight(BasketId)];
                        case 4:
                            basketStoreFlightResponse = _a.sent();
                            broker.publish('flightAddedToBasket', basketStoreFlightResponse);
                            service.updateBasket();
                            _a.label = 5;
                        case 5:
                            $timeout(function () { return $location.url(optionallyAppendParam("/holidays/options/" + tripId, 'fid', $routeParams && $routeParams.fid)); });
                            return [2 /*return*/];
                    }
                });
            });
        }
        function changeToHolidayTripType(tripId) {
            return __awaiter(this, void 0, void 0, function () {
                var packagePrice, TripType, isFlightType;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!TRPCONFIG.Domain.HotelsOnFlightsEnabled) return [3 /*break*/, 3];
                            return [4 /*yield*/, tripService.usePackageRates(tripId)];
                        case 1:
                            packagePrice = _a.sent();
                            if (!!packagePrice) return [3 /*break*/, 3];
                            return [4 /*yield*/, tripService.getTrip(tripId)];
                        case 2:
                            TripType = (_a.sent()).TripType;
                            isFlightType = TripType === tripService.tripTypes.Flight;
                            if (isFlightType) {
                                return [2 /*return*/, tripService.changeTripType(tripId, tripService.tripTypes.Holiday)];
                            }
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function updateFlight(flight, tripId, opts, numBags) {
            tripService.getTrip(tripId).then(function (trip) {
                var holiday = trip.TripType === tripService.tripTypes.Holiday;
                if (trip) {
                    tripService.clearOptionalExtras(tripId).then(function () {
                        if (trip.FlightsRequest) {
                            tripService.setSelectedFlight(tripId, flight, opts);
                            basketStore.addFlight(trip.FlightsRequest.AvailabilitySearchId, flight, trip.BasketId, tripId, holiday, opts, trip.PackageId)
                                .then(function (f) {
                                f.Details.Itinerary = _.assign({}, flight, f.Details.Itinerary);
                                broker.publish('flightAddedToBasket', f);
                                flightSearch.modifyBags(numBags);
                            });
                        }
                    });
                }
            });
        }
        function selectMultiFlight(option, tripId) {
            var nextRoute = 'dp/basket/';
            tripService.getTrip(tripId).then(function (trip) {
                if (!trip || !trip.MultiFlightsRequest) {
                    return;
                }
                basketStore.addMultiFlight(trip.MultiFlightsRequest.AvailabilitySearchId, option, trip.BasketId, tripId).then(function () {
                    $location.path(nextRoute + tripId);
                });
            });
        }
        function getCarQuotes(basketId, tripId, driverAge) {
            return basketStore.flight(basketId).then(function (flight) {
                if (flight == null) {
                    return $q.when([]);
                }
                return tripService.getTripReducedOccupancy(tripId).then(function (occ) {
                    var legs = flight.Details.Itinerary.Legs;
                    var request = _addCommonCarHireRequestCriteria({
                        AvailabilitySearchId: guidService.uuid(),
                        PickUpLocation: {
                            Type: 2,
                            Code: legs[0].ArrivalAirport.Code
                        },
                        DropOffLocation: {
                            Type: 2,
                            Code: legs[0].ArrivalAirport.Code
                        },
                        PickUpDate: dateUtil.roundedToStartOfHour(dateUtil.addHours(legs[0].ArrivalDate, TRPCONFIG.CarHireFlightDepartureOffset), true),
                        DropOffDate: dateUtil.roundedToStartOfHour(dateUtil.addHours(legs[legs.length - 1].DepartureDate, TRPCONFIG.CarHireFlightReturnOffset), true),
                        DriverAge: driverAge,
                        PassengerCount: occ.Adults + occ.ChildAges.length
                    }, 0);
                    return carHireService.getCarQuotes(tripId, request);
                });
            });
        }
        function getCarQuotesFromSession(searchId, pageIndex) {
            var request = _addCommonCarHireRequestCriteria({ AvailabilitySearchId: searchId }, pageIndex);
            return carHireService.getCarQuotesFromSession(request);
        }
        function _addCommonCarHireRequestCriteria(request, pageIndex) {
            return _.assign(request, {
                SortCriterion: enumService.CarHireSortOrder.Recommended,
                Paging: {
                    PageIndex: pageIndex,
                    PageSize: 5
                }
            });
        }
        function getParkingQuotes(searchId, basketId, tripId) {
            var _tidyAirportParkingTitles = function (quotes) {
                if (!quotes || quotes.length === 0) {
                    return;
                }
                _.forEach(quotes, function (q) {
                    q.CarPark = q.CarPark.replace(/\s+\(.*?\)\s*/g, '');
                    q.CarPark = q.CarPark.replace(/(\s*-\s?(on|off)\sairport\s*)/gi, '');
                });
                return quotes;
            };
            if (!searchId) {
                return basketStore.flight(basketId).then(function (flight) {
                    if (flight == null) {
                        return $q.when([]);
                    }
                    var legs = flight.Details.Itinerary.Legs;
                    var request = {
                        AvailabilitySearchId: guidService.uuid(),
                        DepartureDate: legs[0].DepartureDate,
                        ReturnDate: legs.length > 1 ? legs[legs.length - 1].ArrivalDate : null,
                        AirportCode: legs[0].DepartureAirport.Code,
                        DepartureFlightNumber: legs[0].Segments[0].FlightNumber,
                        ReturnFlightNumber: legs.length > 1 ? legs[legs.length - 1].Segments[0].FlightNumber : null,
                        PassengerCount: flight.CostBreakdown[0].Quantity + 1,
                        DepartureTerminalCode: null
                    };
                    if (TRPCONFIG.Domain.AirportParkingUseTerminal === true) {
                        return flightsTerminalService.getTerminalsForAirport(request.AirportCode)
                            .then(function (airport) {
                            //if we know about the airport and it has more than one terminal use the terminal code
                            //to filter down our parking otherwise assume only one terminal
                            if (airport && airport.Terminals.length > 1) {
                                return flightsTerminalService.getTerminalForFlight(request.AirportCode, request.DepartureFlightNumber, request.DepartureDate)
                                    .then(function (terminal) {
                                    if (terminal) {
                                        request.DepartureTerminalCode = terminal.Code;
                                        return parkingService.getParkingQuotes(tripId, request)
                                            .then(function (quotes) { return _tidyAirportParkingTitles(quotes); });
                                    }
                                    //record it if we don't have info on the terminal a flight is going from
                                    loggingService.logInfo("No terminal information found for " + request.AirportCode + " : " + request.DepartureFlightNumber + " on " + request.DepartureDate);
                                    return $q.when(null);
                                });
                            }
                            return parkingService.getParkingQuotes(tripId, request)
                                .then(function (quotes) { return _tidyAirportParkingTitles(quotes); });
                        });
                    }
                    return parkingService.getParkingQuotes(tripId, request);
                });
            }
            return tripService.getTrip(tripId)
                .then(function (trip) {
                return parkingService.getParkingQuotesFromSession(searchId, trip.ParkingRequest)
                    .then(function (quotes) {
                    if (TRPCONFIG.Domain.AirportParkingUseTerminal === true) {
                        return _tidyAirportParkingTitles(quotes);
                    }
                    return quotes;
                });
            });
        }
        function getAttractionQuotes(searchId, basketId, tripId) {
            if (searchId) {
                return attractionService.getAttractionQuotesFromSession(searchId);
            }
            return $q.all([
                currentDestination.getCurrentDestination(),
                basketStore.hotel(basketId),
                attractionService.getOccupancy(tripId),
                tripService.getHotelsRequestCheckInDate(tripId, true),
                tripService.getHotelsRequestCheckOutDate(tripId, true),
                tripService.getFlightsRequestDepartureDate(tripId, true),
                tripService.getFlightsRequestReturnDate(tripId, true)
            ]).then(function (_a) {
                var dest = _a[0], hotel = _a[1], occ = _a[2], checkInDate = _a[3], checkOutDate = _a[4], departureDate = _a[5], returnDate = _a[6];
                //Exactly one of ProvinceId and LocationId must be non-zero
                //we might be dealing with a polygon therefore try to fill in the details from the hotel
                if (!dest) {
                    return;
                }
                var locationId = dest.LocationId;
                var locationType = dest.Type;
                if (!locationId) {
                    if (hotel) {
                        locationId = hotel.Details.LocationId;
                        locationType = 2;
                    }
                    else {
                        locationId = dest.Id;
                    }
                }
                return getQuotes();
                function getQuotes() {
                    return attractionService.getAttractionQuotes(tripId, {
                        AvailabilitySearchId: guidService.uuid(),
                        Visitors: occ,
                        LocationId: locationId,
                        LocationType: locationType,
                        ProvinceId: 0,
                        StartDate: checkInDate || departureDate,
                        EndDate: checkOutDate || returnDate,
                        // to be removed
                        ProductItemId: 1
                    });
                }
            });
        }
        function waitForFlight() {
            return flightIncompleteDates;
        }
        function updateBasket() {
            broker.publish('basketUpdated');
        }
        function bookingAlreadyDone(path) {
            return function (reason) {
                if (path != null && ("" + $location.url()).search(/[\\/]options[\\/]/) >= 0) {
                    var reasonString = 'unknown';
                    try {
                        reasonString = JSON.stringify(reason || 'nothing');
                    }
                    catch (e) { }
                    loggingService.logError("Booking Already Done: " + path + ", DomainId: " + TRPCONFIG.Domain.DomainId + ", href: " + $location.absUrl() + "}, reason: " + reasonString);
                }
                $location.path('bookingalreadydone');
            };
        }
        function isFlightPreselected() {
            return JSON.parse(sessionStorage.getItem('PreselectFlight'));
        }
        function convertRoomsQueryString(occupancy) {
            return occupancy
                .map(function (room, index) {
                var adults = "rooms." + index + ".adults=" + room.Adults;
                var childAges = "rooms." + index + ".childAges=" + room.ChildAges.join(',');
                return room.ChildAges.length
                    ? adults + "&" + childAges
                    : adults;
            })
                .join('&');
        }
        function getHoneycombDeepLink(type, params) {
            try {
                var cookieName_1 = 'HCRouteEnabledFunnels';
                var cookiesArray = document.cookie
                    ? document.cookie.split(';')
                    : [];
                var cookie = cookiesArray.length &&
                    cookiesArray
                        .map(function (e) { return e.trim(); })
                        .find(function (e) { return e.includes(cookieName_1); });
                var hCRouteEnabledFunnels = cookie
                    ? cookie.substring((cookieName_1 + "=").length)
                    : TRPCONFIG.Domain.HCRouteEnabledFunnels;
                var enabledFunnelsArr = hCRouteEnabledFunnels
                    ? hCRouteEnabledFunnels
                        .split(',')
                        .map(function (e) { return (e ? Number(e) : -1); })
                    : [];
                if (!(!TRPCONFIG.Domain.isAgentMode &&
                    TRPCONFIG.Domain.CultureCode.includes('en-') &&
                    params &&
                    enabledFunnelsArr.length &&
                    enabledFunnelsArr.includes(type))) {
                    return null;
                }
                var dateRange = type === hotelBooking
                    ? searchUnitService.hotelDateRange
                    : searchUnitService.flightHolidayDateRange;
                var startDate = dateRange ? dateRange.start : '';
                var endDate = dateRange ? dateRange.end : '';
                var destination = searchUnitService.destination
                    ? searchUnitService.destination
                    : null;
                var occupancy = searchUnitService.occupancyService
                    ? searchUnitService.occupancyService.getOccupancy()
                    : [];
                var cabin = searchUnitService.cabin
                    ? searchUnitService.cabin
                    : null;
                var onewayonly = params.searchModel
                    ? params.searchModel.onewayonly
                    : searchUnitService.onewayonly;
                var legacyDestinationId = destination && destination.Id ? destination.Id : null;
                var legacyDestinationType = destination && destination.Type ? destination.Type : null;
                var depAirports = searchUnitService.departureAirports &&
                    searchUnitService.departureAirports.length
                    ? searchUnitService.departureAirports.join(',')
                    : '';
                var stDate = startDate ? startDate.substring(0, 10) : '';
                var edDate = endDate ? endDate.substring(0, 10) : '';
                if (type === hotelBooking) {
                    var hotelErrors = hotelSearch.validateSearchCriteria();
                    if (hotelErrors.length) {
                        return null;
                    }
                    return "/hotels?tripType=HOTEL&checkIn=" + stDate + "&checkOut=" + edDate + "&destinations=" + legacyDestinationId + ":" + legacyDestinationType + "&" + convertRoomsQueryString(occupancy);
                }
                else if (type === holidayBooking) {
                    var holidayErrors = flightSearch.validateSearchCriteria(true);
                    if (holidayErrors.length) {
                        return null;
                    }
                    return "/holidays/hotels?tripType=HOLIDAY&checkIn=" + stDate + "&checkOut=" + edDate + "&destinations=" + legacyDestinationId + ":" + legacyDestinationType + "&" + convertRoomsQueryString(occupancy) + "&depAirports=" + depAirports + "&cabin=" + cabin;
                }
                else if (type === flightBooking) {
                    var flightErrors = flightSearch.validateSearchCriteria(false, onewayonly);
                    if (flightErrors.length ||
                        !occupancy.length ||
                        !searchUnitService.destinationAirport) {
                        return null;
                    }
                    var checkOut = onewayonly ? '' : edDate;
                    var flightJourneyType = onewayonly ? 'ONEWAY' : 'RETURN';
                    var adults = occupancy[0].Adults;
                    var childAges = occupancy[0].ChildAges.length
                        ? occupancy[0].ChildAges.join(',')
                        : '';
                    var arrivalAirport = null;
                    if (searchUnitService.destinationAirport.Code) {
                        arrivalAirport = searchUnitService.destinationAirport.Code;
                    }
                    else if (searchUnitService.destinationAirport.Airports) {
                        arrivalAirport = searchUnitService.destinationAirport
                            .Airports.length
                            ? searchUnitService.destinationAirport.Airports.map(function (e) { return (e ? e.Code : ''); })
                                .filter(function (e) { return e; })
                                .join(',')
                            : '';
                    }
                    if (!arrivalAirport) {
                        return null;
                    }
                    return "/flights?tripType=FLIGHT&checkIn=" + stDate + "&checkOut=" + checkOut + "&flightJourneyType=" + flightJourneyType + "&depAirports=" + depAirports + "&arrivalAirport=" + arrivalAirport + "&adults=" + adults + "&childAges=" + childAges + "&cabin=" + cabin + "&dateSearchType=CHOOSE_DATE";
                }
                return null;
            }
            catch (error) {
                console.error(error);
                return null;
            }
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('basketStore', basketStore);
    function basketStore($filter, $routeParams, flightDetail, searchUnitService, $http, $location, commonErrors, arrayUtil, $q, $rootScope, hotelService, transferDetail, dateUtil, broker, marhabaService, resourceService, carHireDetailsService, parkingDetailsService, attractionDetailsService, adHocService, tripService, insuranceService, cookieService, analyticsTracker, v2v3HandoverService) {
        var productType = {
            Accommodation: 0,
            Flight: 1,
            Transfer: 2,
            Parking: 3,
            Attractions: 4,
            CarHire: 5,
            Marhaba: 6,
            Insurance: 7,
            ProductBundle: 8,
            AdHoc: 9
        };
        var productGroup = {
            Hotel: 1,
            Flight: 2,
            Extra: 3,
            Transfer: 4,
            Parking: 6,
            Attractions: 7
        };
        var productResultMap = {
            h: 'Hotel',
            f: 'Flight',
            t: 'Transfer',
            p: 'Parking',
            a: 'Attractions'
        };
        var basket;
        var attractionsBasket;
        var url = '/api2/basket/';
        var productNames = {
            0: 'ACCOMODATION',
            1: 'FLIGHT',
            2: 'TRANSFER',
            3: 'AIRPORTPARKING',
            4: 'ATTRACTIONS',
            5: 'CARHIRE',
            6: 'MARHABA',
            7: 'TRAVELINSURANCE',
            9: 'ADHOC'
        };
        var productIcons = {
            0: 'icon-hotels',
            1: 'icon-flights',
            2: 'icon-transfers',
            3: 'icon-parking',
            5: 'icon-car-hire',
            6: 'icon-marhaba',
            7: 'icon-insurance',
            9: 'icon-stack'
        };
        var costBreakdownResult;
        var addingFlightResult;
        var titles = {
            1: resourceService.getDeferred('HOTEL'),
            2: resourceService.getDeferred('FLIGHTS'),
            3: resourceService.getDeferred('EXTRAS'),
            4: resourceService.getDeferred('TRANSFER'),
            6: resourceService.getDeferred('PARKING'),
            7: resourceService.getDeferred('ATTRACTIONS'),
            9: resourceService.getDeferred('ADHOC')
        };
        var service = {
            getBasket: getBasket,
            addHotel: addHotel,
            addVoucher: addVoucher,
            addingFlight: addingFlight,
            addFlight: addFlight,
            updateBrandedFare: updateBrandedFare,
            addMultiDestHolidayFlight: addMultiDestHolidayFlight,
            addMultiFlight: addMultiFlight,
            addTransfer: addTransfer,
            addMarhaba: addMarhaba,
            addCar: addCar,
            addParking: addParking,
            updateProduct: updateProduct,
            putAttractionExtras: putAttractionExtras,
            addAttraction: addAttraction,
            updateAttraction: updateAttraction,
            getAttractionsBasket: getAttractionsBasket,
            getAttractionsBasketId: getAttractionsBasketId,
            addInsurance: addInsurance,
            addCancellationProtection: addCancellationProtection,
            removeCancellationProtection: removeCancellationProtection,
            balancesDue: balancesDue,
            removeInsurance: removeInsurance,
            removeParking: removeParking,
            removeAttraction: removeAttraction,
            removeAttractionsLineItem: removeAttractionsLineItem,
            insurance: insurance,
            removeMarhaba: removeMarhaba,
            addMarhabaOption: addMarhabaOption,
            marhaba: marhaba,
            marhabaHolidayPath: marhabaHolidayPath,
            hotel: hotel,
            flight: flight,
            transfer: transfer,
            flightSpecificInfo: flightSpecificInfo,
            flightOptions: flightOptions,
            optionConditions: optionConditions,
            carHireOptions: carHireOptions,
            carHire: carHire,
            parking: parking,
            attraction: attraction,
            adHoc: adHoc,
            clearBasket: clearBasket,
            destroyBasket: destroyBasket,
            setPaymentMethod: setPaymentMethod,
            createBasket: createBasket,
            removeProductById: removeProductById,
            removeAccomodation: removeAccomodation,
            removeFlight: removeFlight,
            removeTransfer: removeTransfer,
            all: all,
            removeCar: removeCar,
            removeOption: removeOption,
            addOption: addOption,
            addOptions: addOptions,
            removeOptions: removeOptions,
            getNotes: getNotes,
            addNote: addNote,
            addAdHoc: addAdHoc,
            addAdjustment: addAdjustment,
            getPriceAdjustments: getPriceAdjustments,
            getAddedPriceAdjustments: getAddedPriceAdjustments,
            removePriceAdjustment: removePriceAdjustment,
            costBreakdown: costBreakdown,
            costBreakdownGrouped: costBreakdownGrouped,
            applyCancelations: applyCancelations,
            payments: payments,
            payDirectTotal: payDirectTotal,
            totalDeposit: totalDeposit,
            payDepositAggregates: payDepositAggregates,
            totalCost: totalCost,
            totalDiscount: totalDiscount,
            totalCostFromBasket: totalCostFromBasket,
            sumCosts: sumCosts,
            attractionCost: attractionCost,
            carHireCost: carHireCost,
            carHireRequestedItemsCosts: carHireRequestedItemsCosts,
            flightCost: flightCost,
            flightBaggageCostings: flightBaggageCostings,
            hotelCost: hotelCost,
            hotelDeposit: hotelDeposit,
            insuranceCost: insuranceCost,
            isAtolProtected: isAtolProtected,
            parkingCost: parkingCost,
            transferCost: transferCost,
            rules: rules,
            productType: productType,
            productGroup: productGroup,
            marhabaCost: marhabaCost,
            getBasketId: getBasketId,
            getProductCount: getProductCount,
            getDynamicPackage: getDynamicPackage,
            simplifiedBaggageCount: simplifiedBaggageCount,
            updateBaggageOptions: updateBaggageOptions,
            updatePriorityBoarding: updatePriorityBoarding,
            setProductVisibility: setProductVisibility,
            setAdjustmentVisibility: setAdjustmentVisibility,
            checkBasketBookingAllowed: checkBasketBookingAllowed,
            setBasketIdentity: setBasketIdentity,
            getBasketIdentity: getBasketIdentity,
            productNames: productNames,
            getTitle: getTitle,
            getTitleForProduct: getTitleForProduct,
            getBasketCurrency: getBasketCurrency,
            getIconForProduct: getIconForProduct,
            getCancellationProtectionQuote: getCancellationProtectionQuote,
            getTaxAdjustmentValue: getTaxAdjustmentValue,
            extrasBreakdown: extrasBreakdown,
            rehydrateBasketForPUP: rehydrateBasketForPUP
        };
        function getTitle(type) {
            return titles[type]();
        }
        function getTitleForProduct(p) {
            return (p.group ? titles[p.group]() : productNames[p.ProductType]) || titles[productGroup.Extra]();
        }
        function getIconForProduct(p) {
            return productIcons[p.ProductType];
        }
        function _enrichPayments(b) {
            var data = {
                totalBalances: 0,
                minimumDeposit: 0,
                totalCosts: 0,
                products: []
            };
            var currency = searchUnitService.getCurrency();
            angular.forEach(b.Products, function (prod) {
                data.minimumDeposit += prod.ImmediatePayment.Amount;
                var balance = 0;
                var p = {
                    cost: _aggregateCosts(prod.CostBreakdown),
                    productType: prod.ProductType,
                    productTitle: resourceService.get(productNames[prod.ProductType]),
                    initialDeposit: prod.ImmediatePayment.Amount,
                    currentDeposit: prod.ImmediatePayment.Amount,
                    schedule: arrayUtil.map(prod.FuturePayments, function (pay) {
                        data.totalBalances += pay.Amount;
                        balance += pay.Amount;
                        return {
                            amount: pay.Amount,
                            balance: pay.Amount,
                            due: pay.Due
                        };
                    }),
                    directPayments: arrayUtil.map(prod.DirectPayments, function (pay) {
                        return {
                            localAmount: pay.LocalAmount,
                            localCurrency: pay.LocalCurrency,
                            amount: pay.Amount,
                            currency: currency
                        };
                    }),
                    payableLocally: prod.RequestedItems || null
                };
                data.totalCosts += p.cost;
                //for flights we need to include any direct payments in the pay now figure because the payment will always be taken immediately.
                if (prod.ProductType === 1 && prod.DirectPayments.length > 0) {
                    p.initialDeposit = p.currentDeposit = prod.ImmediatePayment.Amount + arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(prod.DirectPayments, function (pay) {
                        return pay.Amount;
                    }));
                }
                else if (prod.ProductType === 7) {
                    p.productTitle += " " + resourceService.get('IPTINCLUDED');
                }
                p.balance = balance;
                data.products.push(p);
            });
            var attractions = data.products.filter(function (item) { return 4 === item.productType; });
            if (attractions.length) {
                var squashedAttractions = attractions.reduce(function (prev, curr) { return ({
                    balance: prev.balance + curr.balance,
                    currentDeposit: prev.currentDeposit + curr.currentDeposit,
                    initialDeposit: prev.initialDeposit + curr.initialDeposit,
                    directPayments: prev.directPayments.concat(curr.directPayments),
                    payableLocally: prev.directPayments.concat(curr.directPayments),
                    schedule: prev.schedule.concat(curr.schedule),
                    productTitle: curr.productTitle,
                    productType: curr.productType
                }); });
                data.products = data.products.filter(function (item) { return productType.Attractions !== item.productType; });
                data.products.push(squashedAttractions);
            }
            return data;
        }
        function _productsByType(t, basketId, firstOnly) {
            return _getBasket(basketId)
                .then(function (b) { return b == null ? null : _[firstOnly ? 'find' : 'filter'](b.Products, { ProductType: t }); });
        }
        function _optionsByType(type, basketId) {
            return _productsByType(type, basketId, true).then(function (p) {
                if (p && p.Options) {
                    return arrayUtil.map(p.Options, function (o) {
                        return { OptionId: o.OptionId, Quantity: o.ChosenQuantity || 1 };
                    });
                }
                return [];
            });
        }
        function _getBasket(id) {
            if (basket != null) {
                return basket.then(function (r) {
                    if (r.BasketId !== id) {
                        basket = _getBasketById(id);
                    }
                    return basket;
                });
            }
            basket = _getBasketById(id);
            return basket;
        }
        function getBasket(id) {
            return _getBasket(id);
        }
        function _getBasketById(id) {
            costBreakdownResult = null;
            return $http.get(url + "get?basketId=" + id)
                .then(function (result) {
                return result.data === 'null' ? null : result.data;
            })
                .then(function (data) {
                if (data && data.Products && data.Products.length && data.Products.length > 0) {
                    var hotelProduct = data.Products.find(function (p) {
                        return p.ProductType !== undefined && p.ProductType !== null
                            ? p.ProductType === productType.Accommodation
                            : false;
                    });
                    if (hotelProduct) {
                        broker.publish('ProductHotelReceivedFromBasket', { productId: hotelProduct.ProductId, basketId: id });
                    }
                }
                return data;
            });
        }
        function _addProduct(type, searchId, detailsId, basketId, options, packageId, rebookId, replaceBrandedFareType) {
            var params = {
                BasketId: basketId,
                AvailabilitySearchId: searchId,
                ProductType: type,
                ProductId: detailsId,
                Options: options,
                PackageId: packageId,
                RebookId: rebookId,
            };
            if (replaceBrandedFareType) {
                params.IsBrandedFareUpdate = true;
            }
            return $http.post(url + "addproduct", params, {
                customErrCallback: TRPCONFIG.Domain.HandleDatesMismatchError ? function (err) {
                    if (err.status === 400 && err.data.Message === 'Mismatch between flight and hotel dates') {
                        $location.url('errordatesmismatch');
                    }
                    else {
                        commonErrors.fourHundred(err);
                    }
                } : undefined
            }).then(function (result) {
                basket = $q.when(result.data);
                costBreakdownResult = null;
                broker.publish('productAddedToBasket');
            });
        }
        function updateProduct(detailsId, basketId) {
            return $http.post(url + "updateproduct", {
                BasketId: basketId,
                ProductId: detailsId
            })
                .then(function (result) {
                basket = $q.when(result.data);
                costBreakdownResult = null;
            });
        }
        function addAdHoc(detailsRequest) {
            return adHocService.getDetails(detailsRequest)
                .then(function (response) {
                var d = response.data;
                if (d && d.AvailabilityId && d.DetailsId) {
                    return getBasketId().then(function (basketId) {
                        if (basketId) {
                            return _addProduct(productType.AdHoc, d.AvailabilityId, d.DetailsId, basketId, []);
                        }
                        return $q.when(null);
                    });
                }
            });
        }
        function getPriceAdjustments(basketId) {
            return _getBasket(basketId).then(function (basket) { return basket && basket.AvailableAdjustments || []; });
        }
        function getAddedPriceAdjustments(bId) {
            return _getBasket(bId).then(function (basket) {
                return (basket && Array.isArray(basket.Adjustments) ? basket.Adjustments : [])
                    .map(function (item) {
                    return {
                        Id: item.Id,
                        Title: item.Title,
                        CostBreakdown: [{
                                Description: item.Title,
                                Quantity: item.Quantity,
                                NetUnitAmount: item.NetUnitAmount,
                                UnitAmount: item.UnitAmount,
                                ManualCommission: item.ManualCommission || 0,
                                TravelAgentCommissionRate: item.TravelAgentCommissionRate || 0,
                                IsHiddenFromDocumentation: item.IsHidden,
                                IsPriceHidden: item.IsPriceHidden
                            }]
                    };
                });
            });
        }
        function getCancellationProtectionQuote(basketId) {
            var protectionDisabled = {
                IsApplicable: false
            };
            if (!TRPCONFIG.Domain.CancellationProtectionEnabled) {
                return protectionDisabled;
            }
            return $http.get("api/hotels/cancellationprotection/quote?basketId=" + basketId)
                .then(function (res) { return res.data; })
                .catch(function () { return protectionDisabled; });
        }
        function getTaxAdjustmentValue(basketId) {
            return getAddedPriceAdjustments(basketId).then(function (result) {
                var value = 0;
                if (result) {
                    var adjustments = result.filter(function (item) {
                        return item.CostBreakdown && item.CostBreakdown.length;
                    });
                    if (adjustments && adjustments.length) {
                        _.forEach(adjustments, function (adjustment) {
                            value += _.get(adjustment, 'CostBreakdown[0].UnitAmount', 0);
                        });
                    }
                }
                return value;
            });
        }
        function addAdjustment(adjustmentRequest) {
            return $http.post(url + "addadjustment", adjustmentRequest)
                .then(function (res) { return _updateBasketPromise(res.data); });
        }
        function removePriceAdjustment(basketId, adjustmentId) {
            var req = {
                BasketId: basketId,
                AdjustmentId: adjustmentId,
                ExpectedVersion: 0
            };
            return $http.post(url + "removeadjustment", req)
                .then(function (res) { return _updateBasketPromise(res.data); });
        }
        function _updateBasketPromise(newBasket) {
            basket = $q.when(newBasket);
            costBreakdownResult = null;
            broker.publish('productRemovedFromBasket');
            return newBasket;
        }
        function _aggregateCosts(cs) {
            var cost = 0;
            angular.forEach(cs, function (c) {
                cost += (c.Quantity * c.UnitAmount);
            });
            return cost;
        }
        function _costByProduct(type, basketId) {
            return _productsByType(type, basketId, true)
                .then(function (p) {
                return p ? _aggregateCosts(p.CostBreakdown) : 0;
            });
        }
        //[ { CurrencyCode: String, Total: Number } ]
        function _requestedItemsCostsByProduct(type, basketId) {
            return _productsByType(type, basketId, true)
                .then(function (product) {
                var costs = {};
                var costList = [];
                if (product) {
                    _.each(product.RequestedItems, function (i) {
                        var val = costs[i.LocalCurrency] || 0;
                        costs[i.LocalCurrency] = val + (i.UnitAmount * i.Quantity);
                    });
                    _.forOwn(costs, function (value, key) {
                        costList.push({ CurrencyCode: key, Total: value });
                    });
                }
                return costList;
            });
        }
        function _optionIndex(options, id) {
            return arrayUtil.indexOf(options, function (o) {
                return o.OptionId === id;
            });
        }
        function _removeProduct(type, basketId) {
            return _productsByType(type, basketId, true)
                .then(function (p) {
                if (p != null) {
                    return removeProductById(p.ProductId, basketId);
                }
            });
        }
        function removeProductById(productId, basketId) {
            return $http.post(url + "removeproduct", {
                BasketId: basketId,
                ProductId: productId
            })
                .then(function (result) {
                basket = $q.when(result.data);
                costBreakdownResult = null;
                broker.publish('productRemovedFromBasket');
            });
        }
        function _addProductDetails(p, rehydrator) {
            if (p && !p.Details) {
                return rehydrator(p.ProductId).then(function (p2) {
                    p.Details = p2;
                    return p;
                });
            }
            return p;
        }
        function _rehydrateProducts(type, rehydrator, basketId, firstOnly) {
            return _productsByType(type, basketId)
                .then(function (products) {
                if (firstOnly) {
                    return _addProductDetails(products[0], rehydrator);
                }
                return $q.all(products.reduce(function (promises, p) {
                    promises.push(_addProductDetails(p, rehydrator));
                    return promises;
                }, []));
            });
        }
        function _concatCostBreakdowns(products) {
            var result = [];
            _.keys(_.omit(products, 'all')).forEach(function (p) {
                arrayUtil.wrapNonArray(products[p])
                    .forEach(function (product) {
                    var cb = product && product.CostBreakdown;
                    if (cb) {
                        result = result.concat(cb);
                    }
                });
            });
            return result;
        }
        function _changeOption(type, productId, optionId, operation, basketId, quantity) {
            return $http.post(url + operation, {
                BasketId: basketId,
                ProductId: productId,
                OptionId: optionId,
                ChosenQuantity: quantity
            }).then(function (result) {
                basket = $q.when(result.data);
                costBreakdownResult = null;
                return _optionsByType(type, basketId);
            });
        }
        function _changeOptions(type, productId, options, operation, basketId) {
            return $http.post(url + operation, {
                BasketId: basketId,
                ProductId: productId,
                Options: options
            }).then(function (result) {
                basket = $q.when(result.data);
                costBreakdownResult = null;
                return _optionsByType(type, basketId);
            });
        }
        function _checkChauffeur(marhaba) {
            if (!marhaba) {
                return false;
            }
            function isChauffeur(availableOption, selectedOption) {
                if (availableOption.Type === 4 && availableOption.Id === selectedOption.OptionId) {
                    return true;
                }
                return false;
            }
            var selectedOptions = marhaba.Options;
            var availableOptions = marhaba.Details.AvailableOptions;
            for (var x = availableOptions.length - 1; x >= 0; x--) {
                for (var i = selectedOptions.length - 1; i >= 0; i--) {
                    if (isChauffeur(availableOptions[x], selectedOptions[i])) {
                        return true;
                    }
                }
            }
            return false;
        }
        function _calculateProductTotals(products) {
            products.total = 0;
            products.totalNet = 0;
            products.totalTravelAgentCommission = 0;
            var currency = searchUnitService.getCurrency();
            angular.forEach(products, function (product) {
                product.total = 0;
                product.totalNet = 0;
                product.totalTravelAgentCommission = 0;
                product.costBreakdown = (product.costBreakdown ? product.costBreakdown : product.CostBreakdown);
                angular.forEach(product.costBreakdown, function (item) {
                    product.total += (item.UnitAmount * item.Quantity);
                    product.totalNet += (item.NetUnitAmount * item.Quantity);
                    item.TravelAgentCommission = (item.ManualCommission ? item.ManualCommission : item.TravelAgentCommission);
                    product.totalTravelAgentCommission += (item.TravelAgentCommission * item.Quantity);
                    item.Margin = item.UnitAmount - item.NetUnitAmount;
                });
                product.totalStr = $filter('customCurrency')(product.total, currency);
                product.totalNetStr = $filter('customCurrency')(product.totalNet, currency);
                product.totalTravelAgentCommissionStr = $filter('customCurrency')(product.totalTravelAgentCommission, currency);
                product.totalMargin = product.total - product.totalNet;
                product.totalMarginStr = $filter('customCurrency')(product.totalMargin, currency);
                product.title = (product.group ? titles[product.group]() : productNames[product.ProductType])
                    || titles[productGroup.Extra](); // Default title to 'Extras' when missing
                product.icon = productIcons[product.ProductType];
                products.total += product.total;
                products.totalNet += product.totalNet;
                products.totalTravelAgentCommission += product.totalTravelAgentCommission;
            });
            products.totalStr = $filter('customCurrency')(products.total, currency);
            products.totalNetStr = $filter('customCurrency')(products.totalNet, currency);
            products.totalTravelAgentCommissionStr = $filter('customCurrency')(products.totalTravelAgentCommission, currency);
            products.totalMargin = products.total - products.totalNet;
            products.totalMarginStr = $filter('customCurrency')(products.totalMargin, currency);
            return products;
        }
        function getCheckInDateForFlight(flightArrival) {
            var landsAfterCutOff = flightArrival.getHours() >= TRPCONFIG.Domain.DepartureFlightCutOff;
            var zeroTime = dateUtil.zeroTime(flightArrival, true);
            return landsAfterCutOff ? zeroTime : dateUtil.addDays(zeroTime, -1, true);
        }
        function getCheckOutDateForFlight(flightReturn) {
            if (TRPCONFIG.Domain.ReturnFlightCutOff < 0) {
                return dateUtil.zeroTime(flightReturn, true);
            }
            var departsBeforeCutOff = flightReturn.getHours() < TRPCONFIG.Domain.ReturnFlightCutOff;
            var zeroTime = dateUtil.zeroTime(flightReturn, true);
            return departsBeforeCutOff ? dateUtil.addDays(zeroTime, -1, true) : zeroTime;
        }
        //the problem with this is that if the user refreshes the flights list, we will hit this before the
        //hotel search request has been restored. Proglem.
        function _adjustSearchDatesIfNecessary(f, tripId) {
            return $q.all([
                tripService.getHotelsRequestCheckInDate(tripId),
                tripService.getHotelsRequestCheckOutDate(tripId)
            ])
                .then(function (dates) {
                var _a = dates.map(function (d) { return dateUtil.serialiseDate(d); }), checkIn = _a[0], checkOut = _a[1];
                var newHotelsRequestDates = {};
                var legs = f.Legs;
                var flightArrival = dateUtil.parseDate(legs[0].Segments[legs[0].Segments.length - 1].ArrivalDate);
                var flightReturn = legs.length > 1 ? dateUtil.parseDate(legs[legs.length - 1].Segments[0].DepartureDate) : null;
                var requiredCheckIn = getCheckInDateForFlight(flightArrival);
                var requiredCheckOut = getCheckOutDateForFlight(flightReturn);
                if (checkIn == null && checkOut == null && TRPCONFIG.Domain2.ResetAdjustingDatesFixEnabled) {
                    return newHotelsRequestDates;
                }
                if (requiredCheckIn !== checkIn) {
                    newHotelsRequestDates.CheckInDate = requiredCheckIn;
                }
                if (requiredCheckOut !== checkOut) {
                    newHotelsRequestDates.CheckOutDate = requiredCheckOut;
                }
                return newHotelsRequestDates;
            });
        }
        function addVoucher(basketId, voucherCode) {
            var req = {
                VoucherCode: voucherCode || '',
                BasketId: basketId,
            };
            return $http.post('/api2/basket/addvoucher', req)
                .then(function (res) {
                var data = res.data;
                var discountMsg = data.DiscountMessages && data.DiscountMessages.length > 0 && data.DiscountMessages[0] || '';
                cookieService.set('VoucherWarnMessage', JSON.stringify(discountMsg));
                return data;
            });
        }
        function addHotel(searchId, estabId, roomIds, basketId, bookingPath, packageId, rebookId, discountCode, voucherCode) {
            //reclaim price difference only for single - room hotel bookings
            var reclaimPriceDifference = TRPCONFIG.Domain.ReclaimPriceDifferenceEnabledFE && roomIds.length === 1;
            return hotelService.getHotelDetails({
                AvailabilitySearchId: searchId,
                EnableTracking: analyticsTracker.isEnabled(),
                EstabId: estabId,
                RoomAndBoardIds: roomIds,
                DiscountCode: discountCode || TRPCONFIG.DiscountCode || '',
                VoucherCode: voucherCode || '',
                BookingPath: bookingPath,
                BasketId: basketId,
                ReclaimPriceDifference: reclaimPriceDifference
            })
                .then(function (d) {
                sessionStorage.setItem('preselectedHotelData', JSON.stringify({
                    Accommodation: productType.Accommodation,
                    searchId: searchId,
                    DetailsId: d.DetailsId,
                    basketId: basketId,
                    options: undefined,
                    packageId: packageId,
                    rebookId: rebookId,
                    d: d
                }));
                return _addProduct(productType.Accommodation, searchId, d.DetailsId, basketId, undefined, packageId, rebookId);
            })
                .then(function () { return service.hotel(basketId); });
        }
        function addingFlight() {
            return addingFlightResult != null;
        }
        function buildBaggageArray(opExtras, bagOpts, type, baggageOptions) {
            //for best fit flight selection this will come through as null
            if (bagOpts == null) {
                return;
            }
            switch (type) {
                case 'multi':
                    for (var i = 0; i < bagOpts.bags; i++) {
                        if (opExtras[i].Options.length > 1) {
                            var option = null;
                            //this is just needed for our initial release so we can go out without being coupled to flights
                            //once they have their data updated we should pick the default bag rather that just the 1st one
                            // in the list (only applies to multi options
                            if (TRPCONFIG.BaggageUseDefaultOption === true) {
                                var defaultOption = _.find(opExtras[i].Options, { IsDefault: true });
                                option = {
                                    OptionId: defaultOption.OptionId,
                                    ChosenQuantity: defaultOption.Quantity
                                };
                            }
                            else {
                                option = {
                                    OptionId: opExtras[i].Options[1].OptionId,
                                    ChosenQuantity: opExtras[i].Options[1].Quantity
                                };
                            }
                            baggageOptions.push(option);
                        }
                    }
                    break;
                case 'single':
                    for (var j = 0; j < bagOpts.bags; j++) {
                        if (opExtras[j] != null) {
                            baggageOptions.push({
                                OptionId: opExtras[j].OptionId,
                                ChosenQuantity: opExtras[j].Quantity
                            });
                        }
                    }
                    break;
            }
        }
        function getCheckInOptions(sector) {
            return arrayUtil.first(sector.OptionalExtras, function (o) {
                return o.Type === 4;
            });
        }
        function getSpecificCheckInOption(options, typeName) {
            return arrayUtil.first(options.MultiOptionalExtras[0].Options, function (o) {
                return o.Type === typeName;
            });
        }
        function addCheckInOptionsIfNecessary(sector, opts, baggageOptions) {
            //if the flight has CheckInOptions we need to add default online checkin options as well
            var checkInOptions = getCheckInOptions(sector);
            if (checkInOptions && opts) {
                var nobags = getSpecificCheckInOption(checkInOptions, 'OnlineCheckinNoBaggage');
                var withbags = getSpecificCheckInOption(checkInOptions, 'OnlineCheckinWithBaggage');
                if (opts.bags > 0 && withbags != null) {
                    baggageOptions.push({
                        OptionId: withbags.OptionId,
                        ChosenQuantity: opts.bags
                    });
                }
                if (opts.bags < opts.maxbags) {
                    baggageOptions.push({
                        OptionId: nobags.OptionId,
                        ChosenQuantity: opts.maxbags - opts.bags
                    });
                }
            }
        }
        function updateBrandedFare(params) {
            var searchId = params.searchId, basketId = params.basketId, packageId = params.packageId, details = params.details;
            var baggageOptions = [];
            _.forEach(details.FlightSectorOptionalExtras, function (sector) {
                addBaggageOptions(sector, params, baggageOptions);
            });
            return _addProduct(productType.Flight, searchId, details.DetailsId, basketId, baggageOptions, packageId, undefined, true)
                .then(function () {
                return service.flight(basketId);
            });
        }
        function addFlight(searchId, flight, basketId, tripId, verifyDates, opts, packageId) {
            var checkDates = !flight.HasFullDates;
            var adjustingDates = $q.when();
            if (verifyDates && flight.HasFullDates && flight.Legs.length > 1) {
                adjustingDates = _adjustSearchDatesIfNecessary(flight, tripId).then(function (newHotelsRequestDates) {
                    if (!_.isEmpty(newHotelsRequestDates)) {
                        checkDates = false;
                        broker.publish('searchDatesAdjusted', { tripId: tripId, dates: newHotelsRequestDates });
                    }
                });
            }
            var isAgentMode = TRPCONFIG.Domain.isAgentMode;
            var isV2Request = v2v3HandoverService.isV2Request();
            var activateV2FlightDetailsRequest = TRPCONFIG.Domain2.ActivateV2FlightDetailsRequest;
            var continueV2FlightDetailsRequest = activateV2FlightDetailsRequest || isV2Request || isAgentMode;
            addingFlightResult = adjustingDates.then(function () {
                return flightDetail.getFlightDetails(tripId, continueV2FlightDetailsRequest, {
                    AvailabilitySearchId: searchId,
                    FlightId: flight.FlightId,
                    IncludeSeatPlan: TRPCONFIG.DeviceSettings.SeatPlanEnabled,
                }).then(function (d) {
                    if (d != null) {
                        var baggageOptions_1 = [];
                        _.forEach(d.FlightSectorOptionalExtras, function (sector) {
                            addBaggageOptions(sector, opts, baggageOptions_1);
                        });
                        return _addProduct(productType.Flight, searchId, d.DetailsId, basketId, baggageOptions_1, packageId)
                            .then(function (res) {
                            var preselectedHotelData = sessionStorage.getItem('preselectedHotelData');
                            return preselectedHotelData !== null ? _addProduct.apply(void 0, Object.values(JSON.parse(preselectedHotelData))) : res;
                        })
                            .then(function () {
                            addingFlightResult = null;
                            return service.flight(basketId).then(function (f) {
                                //in the case where the flight did not have full dates we need to defer checking that the hotel search
                                //dates match until we have the full info i.e. after the details call
                                if (verifyDates && checkDates && flight.Legs.length > 1) {
                                    return _adjustSearchDatesIfNecessary(f.Details.Itinerary, tripId).then(function (newHotelsRequestDates) {
                                        if (!_.isEmpty(newHotelsRequestDates)) {
                                            broker.publish('searchDatesAdjusted', {
                                                tripId: tripId,
                                                dates: newHotelsRequestDates
                                            });
                                        }
                                        return f;
                                    });
                                }
                                return f;
                            });
                        });
                    }
                    return null;
                });
            });
            return addingFlightResult;
        }
        function addMultiDestHolidayFlight(searchId, flight, basketId, tripId, verifyDates, opts, packageId) {
            // Duplicate of addFlight() with no getFlightDetails() because it already ran immediately prior
            var checkDates = !flight.HasFullDates;
            var adjustingDates = $q.when();
            if (verifyDates && flight.HasFullDates && flight.Legs.length > 1) {
                adjustingDates = _adjustSearchDatesIfNecessary(flight, tripId).then(function (newHotelsRequestDates) {
                    if (!_.isEmpty(newHotelsRequestDates)) {
                        checkDates = false;
                        broker.publish('searchDatesAdjusted', { tripId: tripId, dates: newHotelsRequestDates });
                    }
                });
            }
            addingFlightResult = adjustingDates.then(function () {
                var baggageOptions = [];
                _.forEach(flight.FlightSectorOptionalExtras, function (sector) {
                    addBaggageOptions(sector, opts, baggageOptions);
                });
                return _addProduct(productType.Flight, searchId, flight.DetailsId, basketId, baggageOptions, packageId)
                    .then(function () {
                    addingFlightResult = null;
                    return service.flight(basketId).then(function (f) {
                        if (verifyDates && checkDates && flight.Legs.length > 1) {
                            return _adjustSearchDatesIfNecessary(f.Details.Itinerary, tripId).then(function (newHotelsRequestDates) {
                                if (!_.isEmpty(newHotelsRequestDates)) {
                                    broker.publish('searchDatesAdjusted', { tripId: tripId, dates: newHotelsRequestDates });
                                }
                                return f;
                            });
                        }
                        return f;
                    });
                });
            });
            return addingFlightResult;
        }
        function addMultiFlight(searchId, option, basketId, tripId) {
            return flightDetail.getFlightDetails(tripId, {
                AvailabilitySearchId: searchId,
                FlightId: option.FlightId,
                IncludeSeatPlan: false,
                MultiSector: true
            }).then(function (d) {
                if (!d) {
                    return null;
                }
                return _addProduct(productType.Flight, searchId, d.DetailsId, basketId);
            });
        }
        function addBaggageOptions(sector, opts, baggageOptions) {
            var optionalExtras = arrayUtil.first(sector.OptionalExtras, function (o) { return o.Type === 0; });
            if (optionalExtras != null) {
                if (optionalExtras.MultiOptionalExtras.length > 0) {
                    buildBaggageArray(optionalExtras.MultiOptionalExtras, opts, 'multi', baggageOptions);
                }
                else {
                    buildBaggageArray(optionalExtras.SingleOptionalExtras, opts, 'single', baggageOptions);
                }
                addCheckInOptionsIfNecessary(sector, opts, baggageOptions);
            }
        }
        function addTransfer(searchId, transferId, basketId) {
            return transferDetail.getTransferDetails({
                AvailabilitySearchId: searchId,
                TransferId: transferId
            }).then(function (d) {
                return _addProduct(productType.Transfer, searchId, d.DetailsId, basketId)
                    .then(function () {
                    return service.transfer(basketId);
                });
            });
        }
        function addMarhaba(searchId, productId, basketId, options) {
            return marhabaService.getProductDetails(searchId, productId)
                .then(function (details) {
                return _addProduct(productType.Marhaba, searchId, details.DetailsSearchId, basketId, options)
                    .then(function () {
                    return service.marhaba(basketId, productId);
                });
            });
        }
        function removeMarhaba(basketId) {
            return _removeProduct(productType.Marhaba, basketId);
        }
        function addMarhabaOption(productId, optionId, quantity, basketId) {
            return _productsByType(productType.Marhaba, basketId, true)
                .then(function (p) {
                if (p && p.Options) {
                    var i = _optionIndex(p.Options, optionId);
                    if (i < 0) {
                        p.Options.push({ OptionId: optionId });
                    }
                }
                return _changeOption(productType.Marhaba, productId, optionId, 'addoption', basketId, quantity);
            });
        }
        function marhaba(basketId, productId) {
            return _productsByType(productType.Marhaba, basketId, true).then(function (p) {
                if (p && !p.Details) {
                    return marhabaService.rehydrate(productId, p.AvailabilitySearchId)
                        .then(function (res) {
                        p.Details = res;
                        return p;
                    });
                }
                return p;
            });
        }
        function marhabaHolidayPath(basketId) {
            return _getBasket(basketId)
                .then(function (b) {
                return b.Products.length > 1;
            });
        }
        function hotel(basketId) {
            return _rehydrateProducts(productType.Accommodation, hotelService.rehydrate.bind(hotelService), basketId, true); // `firstOnly` when not dynamic packaging
        }
        function flight(basketId) {
            if (addingFlightResult) {
                return addingFlightResult
                    .then(function (f) {
                    return f;
                });
            }
            return _rehydrateProducts(productType.Flight, flightDetail.rehydrate.bind(flightDetail), basketId, true); // `firstOnly` when not dynamic packaging
        }
        function transfer(basketId) {
            return _rehydrateProducts(productType.Transfer, transferDetail.rehydrate.bind(transferDetail), basketId, true); // `firstOnly` when not dynamic packaging
        }
        function carHire(basketId) {
            return _rehydrateProducts(productType.CarHire, carHireDetailsService.rehydrate.bind(carHireDetailsService), basketId, true);
        }
        function optionConditions(basketId) {
            return service.flight(basketId).then(function (f) {
                if (f) {
                    return f.Details.OptionConditions;
                }
                return {};
            });
        }
        function flightOptions(basketId) {
            if (addingFlightResult != null) {
                return addingFlightResult.then(function () {
                    return _optionsByType(productType.Flight, basketId);
                });
            }
            return _optionsByType(productType.Flight, basketId);
        }
        function carHireOptions(basketId) {
            return _optionsByType(productType.CarHire, basketId).then(function (options) {
                return arrayUtil.map(options, function (o) {
                    return o.OptionId;
                });
            });
        }
        function _flushBasket() {
            basket = null;
            attractionsBasket = null;
        }
        function _refreshBasket(basketId) {
            return $q.when(basketId || getBasketId())
                .then(function (bId) {
                _flushBasket();
                return _getBasket(bId);
            })
                .then(function () { return broker.publish('basketRefreshed'); });
        }
        function destroyBasket() {
            _flushBasket();
            TRPCONFIG.BasketId = null;
        }
        function clearBasket(basketId) {
            destroyBasket();
            return $http.post(url + "clearbasket", JSON.stringify(basketId))
                .then(function (res) {
                broker.publish('basketCleared');
                return res;
            });
        }
        function setPaymentMethod(cardTypeId, basketId) {
            TRPCONFIG.Domain.CardTypeId = cardTypeId;
            return _getBasket(basketId)
                .then(function (b) {
                if (b.CardTypeId !== cardTypeId) {
                    return $http.post(url + "setpaymentmethod", {
                        BasketId: basketId,
                        CardTypeId: cardTypeId
                    }).then(function (result) {
                        result.data.CardTypeId = cardTypeId;
                        basket = $q.when(result.data);
                        return {
                            CardHandlingFee: result.data.CardHandlingFee,
                            AirlineSurcharge: result.data.AirlineSurcharge
                        };
                    });
                }
                return {
                    CardHandlingFee: b.CardHandlingFee,
                    AirlineSurcharge: b.AirlineSurcharge
                };
            });
        }
        function createBasket(forHoliday) {
            var domain = TRPCONFIG.Domain;
            var reqParams = {
                AccountingCurrencyCode: domain.AccountingCurrencyCode,
                CurrencyCode: searchUnitService.getCurrency(),
                DomainId: domain.DomainId,
                ForHoliday: forHoliday,
                CultureCode: domain.CultureCode
            };
            basket = $http.post(url + "create", reqParams)
                .then(function (result) {
                TRPCONFIG.BasketId = result.data.BasketId;
                broker.publish('attractionsBasketUpdated');
                broker.publish('basketCreated');
                return result.data;
            });
            return basket;
        }
        function removeAccomodation(basketId) {
            return _removeProduct(productType.Accommodation, basketId);
        }
        function removeFlight(basketId) {
            return _removeProduct(productType.Flight, basketId);
        }
        function removeTransfer(basketId) {
            return _removeProduct(productType.Transfer, basketId);
        }
        function all(basketId, productId) {
            var p = [
                service.flight(basketId),
                service.hotel(basketId),
                service.transfer(basketId),
                service.insurance(basketId),
                service.carHire(basketId),
                service.parking(basketId),
                service.attraction(basketId)
            ];
            if (TRPCONFIG.Domain.MarhabaEnabled) {
                p.push(service.marhaba(basketId, productId));
            }
            return $q.all(p)
                .then(function (results) {
                return {
                    f: results[0],
                    h: results[1],
                    t: results[2],
                    i: results[3],
                    c: results[4],
                    p: results[5],
                    a: results[6],
                    m: TRPCONFIG.Domain.MarhabaEnabled ? results[7] : null,
                    all: results
                };
            });
        }
        function _rehydrateDynamicPackage() {
            // Rehydrate `Details` data on `basket.Products` entries
            return getBasketId().then(function (bId) {
                var services = [
                    service.flight(bId),
                    service.hotel(bId),
                    service.transfer(bId),
                    service.adHoc(bId)
                ];
                if (TRPCONFIG.Domain.MarhabaEnabled) {
                    services.push(service.marhaba(bId));
                }
                return $q.all(services);
            });
        }
        function getDynamicPackage(flatList) {
            // Rehydrates and returns `basket.Products` grouped by type (or `flatList`)
            return _rehydrateDynamicPackage()
                .then(function (res) {
                // Normalise entries to [{}, {}, ...]
                res = res.map(function (p) { return arrayUtil.wrapNonArray(p); });
                return flatList ? _.flatten(res) : {
                    f: res[0],
                    h: res[1],
                    t: res[2],
                    ah: res[3],
                    m: TRPCONFIG.Domain.MarhabaEnabled ? res[4] : null
                };
            });
        }
        function removeOption(type, productId, optionId, basketId) {
            return _productsByType(type, basketId, true)
                .then(function (p) {
                if (p && p.Options) {
                    var i = _optionIndex(p.Options, optionId);
                    if (i >= 0) {
                        p.Options.splice(i, 1);
                    }
                }
                return _changeOption(type, productId, optionId, 'removeoption', basketId);
            });
        }
        function addOption(type, productId, optionId, basketId, quantity) {
            return _productsByType(type, basketId, true)
                .then(function (p) {
                if (p && p.Options) {
                    var i = _optionIndex(p.Options, optionId);
                    if (i < 0) {
                        p.Options.push({
                            OptionId: optionId,
                            ChosenQuantity: quantity
                        });
                    }
                }
                return _changeOption(type, productId, optionId, 'addoption', basketId, quantity);
            });
        }
        function addOptions(type, productId, options, basketId) {
            return options.length === 0 ?
                _optionsByType(type, basketId) :
                _changeOptions(type, productId, options, 'addoptions', basketId);
        }
        function removeOptions(type, productId, options, basketId) {
            return options.length === 0 ?
                _optionsByType(type, basketId) :
                _changeOptions(type, productId, options, 'removeoptions', basketId);
        }
        function getNotes(basketId) {
            return _getBasket(basketId).then(function (b) { return b.Notes; });
        }
        function addNote(basketId, text) {
            var payload = JSON.stringify({
                BasketId: basketId,
                NoteText: text
            });
            var conf = {
                ignoreErrors: true
            };
            return $http.post(url + "addnote", payload, conf)
                .then(function (res) {
                basket = $q.when(res.data);
                return res.data;
            })
                .catch(function () { return ({}); });
        }
        function _hidePricesIfNecessary(products) {
            return tripService.usePackageRates().then(function (packagePrice) {
                if (packagePrice) {
                    //check whether flight cost breakdown needs to be shown
                    var productsToHidePrice = TRPCONFIG.Domain.PackageFlightPrice ? [products.h, products.f] : products.h;
                    angular.forEach([productsToHidePrice], function (product) {
                        arrayUtil.wrapNonArray(product).forEach(function (p) {
                            if (p) {
                                angular.forEach(p.CostBreakdown, function (el) {
                                    el.HidePrice = true;
                                });
                            }
                        });
                    });
                }
                return products;
            });
        }
        function groupProducts(products, excluded) {
            if (excluded === void 0) { excluded = {}; }
            var results = [];
            _.forEach(productResultMap, function (groupName, k) {
                if (!excluded[k]) {
                    arrayUtil.wrapNonArray(products[k]).forEach(function (p) {
                        if (p && p.CostBreakdown) {
                            var groupEntry = _.find(results, {
                                group: productGroup[groupName]
                            });
                            if (groupEntry) {
                                groupEntry.costBreakdown = (groupEntry.costBreakdown || []).concat(p.CostBreakdown);
                                groupEntry.futurePaymentAdminFees = (groupEntry.futurePaymentAdminFees || []).concat(p.FuturePaymentAdminFees);
                            }
                            else {
                                results.push({
                                    costBreakdown: p.CostBreakdown,
                                    futurePaymentAdminFees: p.FuturePaymentAdminFees,
                                    group: productGroup[groupName]
                                });
                            }
                        }
                    });
                }
            });
            return results;
        }
        function costBreakdownGrouped(basketId) {
            return service.all(basketId)
                .then(function (products) {
                var extras = {};
                var exclusions;
                // Extras
                return _hidePricesIfNecessary(products).then(function (es) {
                    if (products.h || products.f) {
                        extras = _enhanceCostBreakdownsWithProductTypes(angular.copy(es));
                        delete extras.h;
                        delete extras.f;
                        exclusions = { t: true, p: true, a: true };
                    }
                }).then(function () {
                    var results = groupProducts(_enhanceCostBreakdownsWithProductTypes(products), exclusions);
                    if (!_.isEmpty(extras)) {
                        results.push({
                            costBreakdown: _concatCostBreakdowns(extras),
                            group: productGroup.Extra
                        });
                    }
                    return tripService.usePackageRates().then(function (packagePrice) {
                        results.isPackage = packagePrice;
                        return _calculateProductTotals(results);
                    });
                });
            });
        }
        function _enhanceCostBreakdownsWithProductTypes(products) {
            _.forEach(products, function (value) {
                if (value && value.ProductType) {
                    var x_1 = value.ProductType;
                    _.forEach(value.CostBreakdown, function (value) {
                        value.ProductType = x_1;
                    });
                }
            });
            return products;
        }
        function costBreakdown(basketId, productId) {
            if (costBreakdownResult) {
                return costBreakdownResult;
            }
            costBreakdownResult = service.all(basketId, productId)
                .then(_getAllCostBreakdowns);
            return costBreakdownResult;
        }
        function payments(basketId) {
            return _getBasket(basketId)
                .then(function (b) {
                return _enrichPayments(b);
            });
        }
        function payDirectTotal(basketId) {
            return service.payments(basketId).then(function (payment) {
                var directAmount = 0;
                _.forEach(payment.products, function (p) {
                    directAmount = _.reduce(p.directPayments, function (result, value) {
                        return result + value.amount;
                    }, directAmount);
                });
                return directAmount;
            });
        }
        function balancesDue(basketId, productId) {
            var s = function (b1, b2) { return b1.Due > b2.Due ? 1 : -1; };
            return service.all(basketId, productId)
                .then(function (products) {
                var balances = {};
                if (products.all) {
                    products.all.forEach(function (product) {
                        arrayUtil.wrapNonArray(product).forEach(function (p) {
                            if (p && p.FuturePayments && p.FuturePayments.length > 0) {
                                p.FuturePayments.forEach(function (fp) {
                                    if (balances[fp.Due] == null) {
                                        balances[fp.Due] = {
                                            Due: fp.Due,
                                            Amount: 0
                                        };
                                    }
                                    balances[fp.Due].Amount += fp.Amount;
                                });
                            }
                        });
                    });
                }
                var balancesArray = Object.keys(balances).map(function (d) { return balances[d]; });
                balancesArray.sort(s);
                return balancesArray;
            });
        }
        function totalDeposit(basketId) {
            return payDepositAggregates(basketId)
                .then(function (pda) { return pda.TotalImmediatePayment; });
        }
        function payDepositAggregates(basketId) {
            return _getBasket(basketId)
                .then(function (b) { return b.PayDepositAggregates; });
        }
        function totalDiscount(basketId) {
            return service.costBreakdown(basketId)
                .then(sumDiscounts);
        }
        function sumDiscounts(cb) {
            return cb.reduce(function (sum, c) {
                /* select only discounts. id 20 is discounts */
                return c.UnitAmount < 0 && c.TypeId === 20
                    ? sum + (c.Quantity * c.UnitAmount) :
                    sum;
            }, 0);
        }
        function totalCost(basketId) {
            return TRPCONFIG.Domain.EnableAmendBookingV2
                ? totalAmount(basketId)
                : service.costBreakdown(basketId).then(sumCosts);
        }
        function totalAmount(basketId) {
            return service.all(basketId)
                .then(function (_a) {
                var all = _a.all;
                return _(all).map(function (a) { return a ? a.TotalAmount : 0; }).sum();
            });
        }
        function _getAllCostBreakdowns(products) {
            return _hidePricesIfNecessary(products).then(_concatCostBreakdowns);
        }
        function sumCosts(cb) {
            return cb.reduce(function (sum, c) { return sum + (c.Quantity * c.UnitAmount); }, 0).toFixed(2);
        }
        function totalCostFromBasket(products) {
            return $q.when(products).then(_getAllCostBreakdowns).then(sumCosts);
        }
        function attractionCost(basketId) {
            return _costByProduct(productType.Attractions, basketId);
        }
        function carHireCost(basketId) {
            return _costByProduct(productType.CarHire, basketId);
        }
        function carHireRequestedItemsCosts(basketId) {
            return _requestedItemsCostsByProduct(productType.CarHire, basketId);
        }
        function marhabaCost(basketId) {
            return _costByProduct(productType.Marhaba, basketId);
        }
        function _productSpecificFields(type, basketId) {
            return _productsByType(type, basketId, true)
                .then(function (p) {
                return (p && p.ProductSpecificFields) || null;
            });
        }
        function flightSpecificInfo(basketId) {
            return _productSpecificFields(productType.Flight, basketId);
        }
        function flightCost(basketId) {
            return _costByProduct(productType.Flight, basketId);
        }
        function flightBaggageCostings(basketId) {
            return flightSpecificInfo(basketId)
                .then(function (i) {
                var costings = {
                    total: 0,
                    discount: 0
                };
                var baggageCosts = i.BaggageCostings;
                if (baggageCosts) {
                    costings.total = baggageCosts.Total;
                    costings.discount = baggageCosts.Discount;
                }
                else {
                    costings.total = i.TotalBaggageCost;
                    //this is to be removed, here so that we don't have to tie the flights release
                    // to the website release HJ-64 HJ-57
                }
                return costings;
            });
        }
        function hotelCost(basketId) {
            return _costByProduct(productType.Accommodation, basketId);
        }
        function hotelDeposit(basketId) {
            return service.hotel(basketId)
                .then(function (hotel) { return (hotel && hotel.ImmediatePayment) ? hotel.ImmediatePayment.Amount : 0; });
        }
        function insuranceCost(basketId) {
            return _costByProduct(productType.Insurance, basketId);
        }
        function isAtolProtected(basketId) {
            return _getBasket(basketId)
                .then(function (basket) { return basket.IsAtolProtected; });
        }
        function parkingCost(basketId) {
            return _costByProduct(productType.Parking, basketId);
        }
        function transferCost(basketId) {
            return _costByProduct(productType.Transfer, basketId);
        }
        function rules(basketId, productId) {
            return service.all(basketId, productId)
                .then(function (products) {
                var hotelOnly = products.h != null && products.f == null && products.t == null && products.m == null && products.i == null && !arrayUtil.count(products.a);
                var hasTransfer = products.t != null;
                var hasOutboundTransfer = products.t != null && products.t.Details.Itinerary.OutboundLeg != null;
                var hasInboundTransfer = products.t != null && products.t.Details.Itinerary.InboundLeg != null;
                var hasParking = products.p != null;
                var hasCarHire = products.c != null;
                var hasCarHirePayableLocally = products.c && products.c.RequestedItems && products.c.RequestedItems.length;
                var hasInsurance = products.i != null;
                var productList = [products.f, products.h, products.i, products.t, products.m, products.p].concat(products.a);
                var isOriginOpenJaw = products.f && products.f.Details && products.f.Details.Itinerary && products.f.Details.Itinerary.IsOriginOpenJaw;
                var hasConnectingFlight = products.m != null && products.m.Details.MarhabaQuote.Type === 2;
                var isAttractionsStandalone = !products.h && !products.f && products.a && !!products.a.length;
                return {
                    captureMainDriver: hasCarHire,
                    hasChauffeur: _checkChauffeur(products.m),
                    hasAttraction: products.a != null,
                    hotelOnly: hotelOnly,
                    hasMarhaba: products.m != null,
                    captureConnectingFlight: hasConnectingFlight,
                    captureFlight: (products.f == null && hasTransfer),
                    hasTransfer: hasTransfer,
                    hasOutboundTransfer: hasOutboundTransfer,
                    hasInboundTransfer: hasInboundTransfer,
                    captureOutboundFlight: hasOutboundTransfer,
                    captureInboundFlight: hasInboundTransfer,
                    captureSpecialRequests: (products.h != null || products.m != null),
                    captureHotel: (products.h == null && products.t != null),
                    captureInsurance: hasInsurance,
                    captureVehicle: hasParking,
                    showPayableNow: arrayUtil.count(productList, function (p) { return p && p.ImmediatePayment && p.ImmediatePayment.Amount > 0; }) > 0,
                    showPayableLocally: hasCarHirePayableLocally,
                    depositAllowed: arrayUtil.count(productList, function (p) { return p && p.FuturePayments && p.FuturePayments.length > 0; }) > 0,
                    showDirectPayments: arrayUtil.count(productList, function (p) { return p && p.DirectPayments && p.DirectPayments.length > 0; }) > 0,
                    showOptionalExtras: products.f != null && _.some(products.f.Details.FlightSectorOptionalExtras, function (sector) { return sector.OptionalExtras.length > 0; }),
                    empty: products.f === null && products.h === null && products.i == null && products.t === null,
                    showParkingQuotes: _.get(products, 'f.Details.Itinerary.Legs.length') > 1 && !isOriginOpenJaw,
                    isAttractionsStandalone: isAttractionsStandalone
                };
            });
        }
        function insurance(basketId) {
            return _rehydrateProducts(productType.Insurance, insuranceService.rehydrate.bind(insuranceService), basketId, true);
            //return _productsByType(productType.Insurance, basketId, true);
        }
        function parking(basketId) {
            return _rehydrateProducts(productType.Parking, parkingDetailsService.rehydrate.bind(parkingDetailsService), basketId, true);
            //return _productsByType(productType.Parking, basketId, true);
        }
        function attraction(basketId) {
            return _rehydrateProducts(productType.Attractions, attractionDetailsService.rehydrate.bind(attractionDetailsService), basketId);
        }
        function adHoc(basketId) {
            return _rehydrateProducts(productType.AdHoc, adHocService.rehydrate.bind(adHocService), basketId);
        }
        function removeInsurance(basketId) {
            return _removeProduct(productType.Insurance, basketId);
        }
        function removeParking(basketId) {
            return _removeProduct(productType.Parking, basketId);
        }
        function removeAttraction(basketId) {
            return _removeProduct(productType.Attractions, basketId);
        }
        function addInsurance(searchId, quote, basketId) {
            return insuranceService.getInsuranceDetails({
                AvailabilityId: searchId,
                SchemeId: quote.QuoteType.SchemeId,
                TripTypeId: quote.QuoteType.TypeId,
                SupplierId: quote.SupplierId,
                DestinationId: quote.QuoteType.DestinationId,
                RelationshipId: quote.QuoteType.RelationshipId
            }).then(function (d) {
                var opt = [{ OptionId: quote.QuoteType.SchemeId + "|" + quote.QuoteType.TypeId + "|" + quote.SupplierId + "|" + quote.QuoteType.RelationshipId }];
                return _addProduct(productType.Insurance, searchId, d.DetailSearchId, basketId, opt).then(function () {
                    return service.insurance(basketId);
                });
            });
        }
        function addCancellationProtection(productId, quote, basketId, quantity) {
            return addOption(productType.Accommodation, productId, quote.QuoteId, basketId, quantity)
                .then(function () {
                broker.publish('basketUpdated');
            });
        }
        function removeCancellationProtection(productId, quote, basketId) {
            return removeOption(productType.Accommodation, productId, quote.QuoteId, basketId)
                .then(function () {
                broker.publish('basketUpdated');
            });
        }
        function rehydrateBasketForPUP(basketId) {
            _flushBasket();
            basket = _getBasketById(basketId);
            return basket;
        }
        function addCar(searchId, quote, basketId) {
            return carHireDetailsService.getCarDetails({
                AvailabilitySearchId: searchId,
                CarHireQuote: quote
            }).then(function (d) {
                return _addProduct(productType.CarHire, searchId, d.DetailsSearchId, basketId)
                    .then(function () {
                    return service.carHire(basketId);
                });
            });
        }
        function addParking(searchId, parking, basketId) {
            return parkingDetailsService.getParkingDetails({
                AvailabilitySearchId: searchId,
                AirportParkingQuoteId: parking
            }).then(function (d) {
                return _addProduct(productType.Parking, searchId, d.DetailsSearchId, basketId).then(function () {
                    return service.parking(basketId);
                });
            });
        }
        function putAttractionExtras(searchId, attractions, basketId) {
            // Create or replace attraction extras entry in basket
            var atts = [];
            angular.forEach(attractions.selected, function (a) {
                atts.push({
                    AttractionId: a,
                    TicketTypesCount: attractions.occupancy[a]
                });
            });
            return removeAttraction(basketId)
                .then(function () {
                return attractionDetailsService.getAttractionDetails({
                    AvailabilitySearchId: searchId,
                    AttractionRequests: atts
                });
            })
                .then(function (details) { return _addProduct(productType.Attractions, searchId, details.DetailsSearchId, basketId); })
                .then(function () { return service.attraction(basketId); });
        }
        function addAttraction(productId, productTags, basketId) {
            // Add standalone attractions product to basket
            var domain = TRPCONFIG.Domain;
            return $http.post('/api2/attractions/bookingfunnel/addtobasket', {
                BasketId: basketId,
                AvailabilityRequest: {
                    Id: productId,
                    DomainId: domain.DomainId,
                    Tags: productTags,
                    Currency: domain.CurrencyCode
                }
            }, { ignoreErrors: true }).then(function (res) { return _refreshAttractionsBasket(res.data, basketId); }, function (err) { return ({ error: err }); });
        }
        function updateAttraction(lineItemId, updates, basketId) {
            // Modify standalone attractions product in basket
            return $http.post('/api2/attractions/bookingfunnel/updatebasket', {
                BasketId: basketId,
                LineItemId: lineItemId,
                Updates: updates,
                DomainId: TRPCONFIG.Domain.DomainId
            }, { ignoreErrors: true }).then(function (res) { return _refreshAttractionsBasket(res.data, basketId); }, function (err) { return ({ error: err }); });
        }
        function removeAttractionsLineItem(lineItemId, basketId) {
            // Remove standalone attractions product from basket
            return $http.post('/api2/attractions/bookingfunnel/removefrombasket', {
                BasketId: basketId,
                LineItemId: lineItemId
            }, { ignoreErrors: true }).then(function (res) { return _refreshAttractionsBasket(res.data, basketId); }, function (err) { return ({ error: err }); });
        }
        function getAttractionsBasket() {
            // Get all standalone attractions products in basket
            return attractionsBasket || (attractionsBasket = getAttractionsBasketId()
                .then(function (id) { return $http.post("/api2/attractions/bookingfunnel/getbasket?basketId=" + id); })
                .then(function (res) { return res.data; }));
        }
        function getAttractionsBasketId() {
            return $q.when(TRPCONFIG.BasketId ||
                service.createBasket()
                    .then(function (b) { return TRPCONFIG.BasketId = b.BasketId; }));
        }
        function _refreshAttractionsBasket(basketData, basketId) {
            // `attractions/bookingfunnel/...` API makes back-end changes to the basket
            var responseBasketId = basketData.Basket.BasketId;
            basket = null;
            attractionsBasket = null;
            attractionDetailsService.purge();
            // Back-end creates a new basket if existing contains non-attractions products
            if (responseBasketId !== basketId) {
                TRPCONFIG.BasketId = responseBasketId;
            }
            return _getBasket(responseBasketId)
                .then(function () { return service.attraction(responseBasketId); }) // Rehydrate `basket` products
                .then(function () {
                // Can't use `basketService.updateBasket()` due to circular dependency error
                broker.publish('basketUpdated');
                // Publish/return 'attractions/bookingfunnel' data format
                broker.publish('attractionsBasketUpdated', basketData);
                return basketData;
            });
        }
        function removeCar(basketId) {
            return _removeProduct(productType.CarHire, basketId);
        }
        function getBasketId(tripId) {
            if (tripId) {
                return tripService.getTrip(tripId).then(function (trip) {
                    if (trip) {
                        return trip.BasketId;
                    }
                    return $q.when();
                });
            }
            else if (TRPCONFIG.BasketId) {
                return $q.when(TRPCONFIG.BasketId);
            }
            return createBasket().then(function (basket) {
                TRPCONFIG.BasketId = basket.BasketId;
                return basket.BasketId;
            });
        }
        function getProductCount() {
            return getBasketId()
                .then(function (basketId) { return _getBasket(basketId); })
                .then(function (basket) { return _.filter(basket.Products, function (p) { return p.CostBreakdown.length > 0; }).length; });
        }
        function _simplifiedBaggageOptions(basketId) {
            return flight(basketId).then(function (f) {
                var baggageOptionsSimplified = [];
                var addToArray = function (arr, index, bagOption, price, weight) {
                    if (arr.length <= index) {
                        arr.push({ TotalPrice: 0, Bags: [], UnitWeightKg: [] });
                    }
                    arr[index].Bags.push(bagOption);
                    arr[index].TotalPrice += price;
                    arr[index].UnitWeightKg.push(weight);
                };
                //for multiple sectors adding 1 bag will mean multiple options being added under the hood
                //so 1 bag option may contain an array of options
                // e.g if you add a bag to your out leg your are more than likely going to need it on the way back
                _.forEach(f.Details.FlightSectorOptionalExtras, function (extras) {
                    var baggageOptions = _.find(extras.NonCheckInOptions, ['Type', 0]);
                    if (baggageOptions) {
                        _.forEach(baggageOptions.MultiOptionalExtras, function (multi, index) {
                            var opt = _.find(multi.Options, { IsDefault: true });
                            addToArray(baggageOptionsSimplified, index, opt.Key, opt.UnitAmount, opt.UnitWeightKg);
                        });
                        var options = _.filter(baggageOptions.SingleOptionalExtras, { IsDefault: true });
                        _.forEach(options, function (opt, index) {
                            addToArray(baggageOptionsSimplified, index, opt.Key, opt.UnitAmount, opt.UnitWeightKg);
                        });
                    }
                });
                return baggageOptionsSimplified;
            });
        }
        function _baggageOptionComparer(o1, o2) {
            var o1qty = o1.Quantity || o1.ChoosenQuantity;
            var o2qty = o2.Quantity || o2.ChoosenQuantity;
            return o1.OptionId === o2.OptionId && o1qty === o2qty;
        }
        function simplifiedBaggageCount(basketId) {
            //figure out how many bags from our possible list
            //are actually selected
            return $q.all([
                flightOptions(basketId),
                _simplifiedBaggageOptions(basketId)
            ]).then(function (results) {
                var bagsSelected = 0;
                var basketOptions = results[0];
                var bagOptions = results[1];
                //check the whole option is in our basket
                _.forEach(bagOptions, function (option) {
                    var selected = _.every(option.Bags, function (opt) {
                        return _.some(basketOptions, function (bo) {
                            return _baggageOptionComparer(opt, bo);
                        });
                    });
                    if (selected) {
                        bagsSelected++;
                    }
                });
                var minWeight = (bagOptions.length > 0) ? _.min(_.flatMap(bagOptions, function (o) { return o.UnitWeightKg; })) : 0;
                return {
                    selected: bagsSelected,
                    maxAllowed: bagOptions.length,
                    price: (bagOptions.length > 0) ? bagOptions[0].TotalPrice : 0,
                    unitWeightKg: minWeight
                };
            });
        }
        function updateBaggageOptions(basketId, count, model) {
            return $q.all([
                flight(basketId),
                flightOptions(basketId),
                _simplifiedBaggageOptions(basketId)
            ]).then(function (results) {
                var flight = results[0];
                var bagOptions = results[2];
                var allBagOptions = flight.Details.FlightSectorOptionalExtras.reduce(function (res, cur) {
                    var baggageNonCheckInOptions = _.find(cur.NonCheckInOptions, ['Type', 0]);
                    return res.concat(baggageNonCheckInOptions.MultiOptionalExtras.reduce(function (res, cur) {
                        return res.concat(cur.Options.map(function (op) { return op.Key; }));
                    }, []).concat(baggageNonCheckInOptions.SingleOptionalExtras.map(function (option) { return option.Key; })));
                }, []);
                var basketOptions = _.intersectionBy(results[1], allBagOptions, 'OptionId');
                var selectedOptions = [];
                var createBasketOption = function (option) {
                    return {
                        OptionId: option.OptionId,
                        ChosenQuantity: option.Quantity
                    };
                };
                //use the count to figure out which bags we need to select
                _.times(count, function (i) {
                    selectedOptions = selectedOptions.concat(bagOptions[i].Bags);
                });
                //compare what we want with what we have and add/remove accordingly
                var optionsToRemove = _.map(arrayUtil.difference(basketOptions, selectedOptions, _baggageOptionComparer), function (o) { return createBasketOption(o); });
                var optionsToAdd = _.map(arrayUtil.difference(selectedOptions, basketOptions, _baggageOptionComparer), function (o) { return createBasketOption(o); });
                return removeOptions(productType.Flight, flight.ProductId, optionsToRemove, basketId)
                    .then(function () { return addOptions(productType.Flight, flight.ProductId, optionsToAdd, basketId); })
                    .then(function (options) {
                    _.pullAllBy(model[0], optionsToRemove, 'OptionId');
                    //not great, a bit of a band aid while we still use the 'old' options page and have all flight
                    //options handled together (seats, meals) using the code in optionsCtrl
                    var optionsOldFormat = _.map(optionsToAdd, function (o) {
                        return {
                            OptionId: o.OptionId,
                            Quantity: o.ChosenQuantity
                        };
                    });
                    (_a = model[0]).push.apply(_a, optionsOldFormat);
                    return options;
                    var _a;
                });
            });
        }
        function updatePriorityBoarding(basketId, pbDetails, pbSelectedStatus) {
            return flight(basketId).then(function (flight) {
                var pbBasketOptions = [{
                        OptionId: pbDetails.OptionId,
                        ChosenQuantity: pbDetails.Quantity
                    }];
                return pbSelectedStatus
                    ? addOptions(productType.Flight, flight.ProductId, pbBasketOptions, basketId)
                    : removeOptions(productType.Flight, flight.ProductId, pbBasketOptions, basketId);
            });
        }
        function setProductVisibility(userRequest) {
            return $http.post(url + "setproductvisibility", userRequest);
        }
        function setAdjustmentVisibility(adjustmentRequest) {
            return $http.post(url + "setadjustmentvisibility", adjustmentRequest);
        }
        function checkBasketBookingAllowed(basketId) {
            return _getBasket(basketId)
                .then(function (basket) {
                return basket.Products.every(function (p) {
                    return (p.ProductSpecificFields == null) || (p.ProductSpecificFields.IsBookable == null) || (p.ProductSpecificFields.IsBookable);
                });
            });
        }
        function setBasketIdentity(basketId, userRequest) {
            var validateTravelAgent = function (req) { return !_.isEmpty(req)
                && !_.isEmpty(req.TravelAgent)
                && !_.isEmpty(_.trim(req.TravelAgent.FirstName))
                && !_.isEmpty(_.trim(req.TravelAgent.LastName)); };
            return !validateTravelAgent(userRequest)
                ? $q.reject('bad request')
                : $http.post(url + "setidentities", {
                    BasketId: basketId,
                    TravelAgent: userRequest ? userRequest.TravelAgent : null,
                    TravelAgentCustomer: userRequest ? userRequest.TravelAgentCustomer : {}
                }).then(function (result) {
                    basket = $q.when(result.data);
                    return getBasketIdentity(result.data.BasketId);
                });
        }
        function getBasketIdentity(basketId) {
            return _getBasket(basketId)
                .then(function (basket) {
                return {
                    TravelAgent: basket.TravelAgent,
                    TravelAgentCustomer: basket.TravelAgentCustomer
                };
            });
        }
        function getBasketCurrency(basketId) {
            return _getBasket(basketId).then(function (basket) { return basket && basket.Currency || ''; });
        }
        function applyCancelations(basketId, legacyBasketId) {
            if (!$routeParams.BookingRef) {
                return $q.when();
            }
            return $http.post(url + "applycancellations", {
                CultureCode: TRPCONFIG.Domain.CultureCode,
                BasketId: basketId,
                DomainId: TRPCONFIG.Domain.DomainId,
                LegacyBasketId: legacyBasketId,
            })
                .then(function (_a) {
                var data = _a.data;
                basket = $q.when(data);
            });
        }
        function extrasBreakdown(arr) {
            var extras = {
                transfersCost: 0,
                insuranceCost: 0,
                parkingCost: 0,
                carHireCost: 0,
                marhabaCost: 0
            };
            _.each(arr, function (cb) {
                if (cb.ProductType === productType.Transfer) {
                    extras.transfersCost += cb.Quantity * cb.UnitAmount;
                }
                if (cb.ProductType === productType.Insurance) {
                    extras.insuranceCost += cb.Quantity * cb.UnitAmount;
                }
                if (cb.ProductType === productType.Parking) {
                    extras.parkingCost += cb.Quantity * cb.UnitAmount;
                }
                if (cb.ProductType === productType.CarHire) {
                    extras.carHireCost += cb.Quantity * cb.UnitAmount;
                }
                if (cb.ProductType === productType.Marhaba) {
                    extras.marhabaCost += cb.Quantity * cb.UnitAmount;
                }
            });
            return extras;
        }
        /*
          Subscriptions
        */
        broker.subscribe('basketStore', 'travelAgentSignIn', function () { return _refreshBasket(); });
        broker.subscribe('basketStore', 'agentSignedInToBooking', function (_a) {
            var data = _a.data;
            return setBasketIdentity(TRPCONFIG.BasketId, {
                TravelAgent: data.TravelAgent,
                TravelAgentCustomer: _.omit(data.Contact, ['Email', 'BookingId', 'SiteId'])
            });
        });
        return service;
    }
})();
var TR;
(function (TR) {
    function Bd4t(funcUtil) {
        var ready = funcUtil.waitForValue(function () {
            //There are unfortunatly two functions called bd4t and need to wait for the second one.
            return window['bd4t'] && window['bd4t'] !== window['firstBd4t'];
        });
        return function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            ready.then(function () {
                try {
                    // Uncomment for testing.
                    // window['bd4tLoggingDate'] = window['bd4tLoggingDate'] || new Date();
                    //
                    // let d:any = new Date();
                    // d = d - window['bd4tLoggingDate'];
                    // d = ('0000' + d);
                    // d.substring(d.length - 5);
                    //
                    // let s = angular.toJson(rest);
                    // s = s.substring(1, s.length-1);
                    // s = `bd4t(${s})`;
                    //
                    // console.log(d, s);
                    window['bd4t'].apply(window, rest);
                }
                catch (er) { }
            });
        };
    }
    angular
        .module('TR')
        .factory('bd4t', Bd4t);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var BD4Travel = /** @class */ (function () {
        function BD4Travel(bd4t, $filter, $q, $location, dateUtil, filtering, sortCriteria, basketStore, tripService, preferences, hotelFromSession, currentUser, $routeParams, currentDestination, objectTypeService, localStorageProvider, occupancyService) {
            var _this = this;
            this.bd4t = bd4t;
            this.$filter = $filter;
            this.$q = $q;
            this.$location = $location;
            this.dateUtil = dateUtil;
            this.filtering = filtering;
            this.sortCriteria = sortCriteria;
            this.basketStore = basketStore;
            this.tripService = tripService;
            this.preferences = preferences;
            this.hotelFromSession = hotelFromSession;
            this.currentUser = currentUser;
            this.$routeParams = $routeParams;
            this.currentDestination = currentDestination;
            this.objectTypeService = objectTypeService;
            this.localStorageProvider = localStorageProvider;
            this.occupancyService = occupancyService;
            this.trackEngagementClick = _.debounce(function (hotelId) {
                try {
                    _this.tripService.getTrip(_this.$routeParams.tripId)
                        .then(function (trip) {
                        var tripType = _.get(trip, 'TripType');
                        if (tripType) {
                            _this._engagement({
                                type: 'productDetails',
                                product: {
                                    type: 'hotel',
                                    id: "tr:" + hotelId
                                },
                                listId: tripType === 2 ? 'hotel_list' : 'holidays_list',
                            });
                        }
                    });
                }
                catch (e) { }
            }, 200, { leading: true, trailing: false });
            this._pageview = _.throttle(function () { return _this._pageviewImmediate(); }, 250, { leading: false, trailing: true });
            this.dateFormatter = function (date) {
                if (!date) {
                    return;
                }
                return _this.$filter('date')(date, 'yyyy-MM-dd');
            };
            this.trackFlightsResults = _.debounce(this._trackFlightsResults, 800);
            this.initPrivacyLevel();
        }
        BD4Travel.prototype.initPrivacyLevel = function () {
            var isOptIn = this.isOptIn();
            if (!isOptIn) {
                this.bd4t('privacy', {
                    level: 'non-personal'
                });
            }
        };
        BD4Travel.prototype.isOptIn = function () {
            try {
                if (!document.cookie.length) {
                    return false;
                }
                var cookie = 'bd4t-cookie-test=' + new Date().getTime();
                document.cookie = cookie;
                return document.cookie.indexOf(cookie) > -1;
            }
            catch (err) {
                return false;
            }
        };
        BD4Travel.prototype.trackInitialParameters = function (searchModel, pageType) {
            var _this = this;
            if (!searchModel || !pageType) {
                return;
            }
            var origin = _.get(searchModel, 'airports');
            var destination = _.get(searchModel, 'destination[0]');
            var startDate = this.dateUtil.parseDate(_.get(searchModel, 'startDate'));
            var endDate = this.dateUtil.parseDate(_.get(searchModel, 'endDate'));
            var isFlexible = _.get(searchModel, 'flexibleDates');
            var duration = this.dateUtil.getDifferenceInDays(startDate, endDate);
            var occupancy = _.get(searchModel, 'occupancy');
            var filter = {
                origin: _.map(origin, function (a) { return a.Code; }),
                destination: this._normaliseDestination(destination),
                period: {
                    from: this.dateFormatter(this.dateUtil.addDays(startDate, isFlexible ? -3 : 0)),
                    to: this.dateFormatter(this.dateUtil.addDays(endDate, isFlexible ? 3 : 0)),
                },
                duration: {
                    min: duration,
                    max: duration
                },
                rooms: _.map(occupancy, function (o) { return ({ adults: o.Adults, childAges: o.ChildAges }); })
            };
            var types = pageType.split(',');
            if (types[0] === 'categoryDetails') {
                var currentPath = _.camelCase(this.$location.path().split('/').pop());
                types[0] = types[0] + ":" + currentPath;
            }
            this._initPage(types[0], types[1] || 'landingpage');
            this.getCurrentProduct()
                .then(function (product) {
                _this._setContext({
                    product: product,
                    filter: filter,
                }, false);
            })
                .catch(angular.noop)
                .then(function () { return _this._pageview(); });
        };
        BD4Travel.prototype.getCurrentProduct = function () {
            var _this = this;
            return this.currentDestination.getCurrentDestination({
                useTrip: false,
                useLandingPage: true,
                useSearchUnitService: false
            })
                .then(function (d) {
                if (d && d.Type === 1) {
                    return {
                        type: d.PageStrand === 1 ? 'hotel' : 'package',
                        id: "tr:" + d.Id
                    };
                }
                if (_this.$routeParams.estabId) {
                    return {
                        type: _this.$location.url().indexOf('hotels') > -1 ? 'hotel' : 'package',
                        id: "tr:" + _this.$routeParams.estabId
                    };
                }
            });
        };
        BD4Travel.prototype.trackHotelResults = function (trip, results, currentRequest) {
            var _this = this;
            this.currentSort = (results.RankingScoresToken && results.RankingScoresToken.indexOf('_X') === -1)
                ? 'relevance' : this.sortCriteria.translateHotelSort(currentRequest.SortCriterion).label;
            this.currentHotelRankingScoresToken =
                results.RankingScoresToken && results.RankingScoresToken.replace('_X', '');
            this.$q.when()
                .then(function () {
                var basketId = _.get(trip, 'BasketId');
                if (basketId) {
                    return _this.basketStore.flight(basketId);
                }
            })
                .then(function (f) { return _this._buildHotelResults(trip, results, currentRequest, f); });
        };
        BD4Travel.prototype.trackHotelAvailability = function (tripId, estabId, pageType) {
            var _this = this;
            this.tripService.getTrip(tripId).then(function (trip) {
                var tripType = _.get(trip, 'TripType');
                var tripTypes = _this.tripService.tripTypes;
                _this.$q.all([
                    _this.basketStore.flight(trip.BasketId),
                    _this.hotelFromSession.getHotel(_.get(trip, 'HotelsRequest.AvailabilitySearchId'), estabId, _.get(trip, 'TripId')),
                    _this.basketStore.costBreakdownGrouped(_.get(trip, 'BasketId'))
                ]).then(function (_a) {
                    var flight = _a[0], hotel = _a[1], cost = _a[2];
                    if (tripType !== tripTypes.Hotel && tripType !== tripTypes.Holiday) {
                        return;
                    }
                    var offer = _this.extractOfferFromTrip(trip, flight, hotel, cost);
                    var product = {
                        type: tripType === tripTypes.Hotel ? 'hotel' : 'package',
                        id: "tr:" + estabId
                    };
                    _this._initPage(pageType, tripType === tripTypes.Hotel ? 'hotel' : 'holidays');
                    _this._setContext({ offer: offer, product: product }, false);
                    _this._pageview();
                });
            });
        };
        BD4Travel.prototype.trackCategory = function (childDestinations) {
            childDestinations = this._normaliseDestination(childDestinations);
            this._setContext({ category: childDestinations });
            this._pageview();
        };
        BD4Travel.prototype.availabilityCheck = function (trip, estabId, errorResponse) {
            var _this = this;
            return this.basketStore
                .flight(trip.BasketId)
                .then(function (f) { return _this.$q.all([
                _this.basketStore.hotel(trip.BasketId),
                _this._enrichBasketInformation(estabId, f, trip)
            ]); })
                .then(function (_a) {
                var hotel = _a[0], _b = _a[1], costBreakDown = _b.costBreakDown, roomsList = _b.roomsList, flight = _b.flight;
                return _this._buildAvailabilityCheck(estabId, hotel, flight, trip, costBreakDown, roomsList, errorResponse);
            });
        };
        BD4Travel.prototype.trackBookingForm = function (confirmed, hotel, flight, trip, fees) {
            var _this = this;
            var tripType = _.get(trip, 'TripType');
            if (tripType !== 2 && tripType !== 4) {
                return this.$q.when();
            }
            return this._enrichBasketInformation(_.get(hotel, 'Details.Id'), flight, trip)
                .then(function (res) {
                var costBreakDown = res.costBreakDown, roomsList = res.roomsList;
                return _this._buildBookingForm(confirmed, hotel, flight, trip, costBreakDown, roomsList, fees);
            });
        };
        BD4Travel.prototype.extractOfferFromTrip = function (trip, flight, hotel, cost) {
            var depDate = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            var returnDate = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            var rooms = _.get(trip, 'HotelsRequest.Rooms', []);
            var outboundLeg = _.get(flight, 'Details.Itinerary.Legs[0]', {});
            var total = flight && flight.TotalAmount && hotel.MinCost ?
                flight.TotalAmount + hotel.MinCost : _.get(cost, 'total', 0);
            var occupancy = this.occupancyService.reduceOccupancy(rooms);
            return {
                period: {
                    from: this.dateFormatter(depDate),
                    to: this.dateFormatter(returnDate)
                },
                occupancy: {
                    adults: occupancy.Adults,
                    children: occupancy.ChildAges
                },
                price: {
                    total: total,
                    pp: parseFloat((total / this.occupancyService.getNumberOfNonInfantPassengers(occupancy)).toFixed(2))
                },
                origin: _.get(outboundLeg, 'DepartureAirport.Code', ''),
                airline: _.get(outboundLeg, 'Segments[0].CodeshareAirlineName', ''),
                arrivalAirport: _.get(outboundLeg, 'ArrivalAirport.Code', ''),
                rooms: _.map(rooms, function (room) { return ({
                    occupancy: {
                        children: room.ChildAges,
                        adults: room.Adults
                    }
                }); }),
            };
        };
        BD4Travel.prototype.extractFilterFromTrip = function (trip, isFlexible) {
            if (isFlexible === void 0) { isFlexible = false; }
            var airportsCodes = _.get(trip, 'FlightsRequest.SelectedDepartureAirport.Code');
            var destination = _.get(trip, 'HotelsRequest.Destination');
            var depDate = this.dateUtil.parseDate(_.get(trip, 'FlightsRequest.DepartureDate'));
            var returnDate = this.dateUtil.parseDate(_.get(trip, 'FlightsRequest.ReturnDate'));
            if (!depDate && !returnDate) {
                depDate = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
                returnDate = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            }
            var duration = this.dateUtil.getDifferenceInDays(depDate, returnDate);
            var rooms = _.get(trip, 'HotelsRequest.Rooms');
            return {
                origin: _.split(airportsCodes, ','),
                destination: this._normaliseDestination(destination),
                period: {
                    from: this.dateFormatter(this.dateUtil.addDays(depDate, isFlexible ? -3 : 0)),
                    to: this.dateFormatter(this.dateUtil.addDays(returnDate, isFlexible ? 3 : 0)),
                },
                duration: {
                    min: duration,
                    max: duration
                },
                rooms: _.map(rooms, function (o) { return ({ adults: o.Adults, childAges: o.ChildAges }); })
            };
        };
        BD4Travel.prototype.getContextFromSearch = function (searchModel, isHotel) {
            var filter = this.getFiltersFromSearch(searchModel, isHotel);
            filter = angular.copy(_.merge({}, this.filter, filter));
            return { filter: filter };
        };
        BD4Travel.prototype.getFiltersFromSearch = function (searchModel, isHotel) {
            if (isHotel === void 0) { isHotel = false; }
            if (!searchModel) {
                return;
            }
            var origin = !isHotel ? _.get(searchModel, 'airports') : undefined;
            var destination = _.get(searchModel, 'destination[0]') || _.get(searchModel, 'destination');
            var startDate = this.dateUtil.parseDate(_.get(searchModel, 'startDate'));
            var endDate = this.dateUtil.parseDate(_.get(searchModel, 'endDate'));
            var isFlexible = _.get(searchModel, 'flexibleDates') && !isHotel;
            var duration = this.dateUtil.getDifferenceInDays(startDate, endDate);
            var occupancy = _.get(searchModel, 'occupancy');
            return {
                origin: _.map(origin, function (a) { return a.Code; }),
                destination: this._normaliseDestination(destination),
                period: {
                    from: this.dateFormatter(this.dateUtil.addDays(startDate, isFlexible ? -3 : 0)),
                    to: this.dateFormatter(this.dateUtil.addDays(endDate, isFlexible ? 3 : 0)),
                },
                duration: {
                    min: duration,
                    max: duration
                },
                rooms: _.map(occupancy, function (o) { return ({ adults: o.Adults, childAges: o.ChildAges }); })
            };
        };
        BD4Travel.prototype.clearContext = function () {
            return this.localStorageProvider.removeItem('bd4-context');
        };
        BD4Travel.prototype._enrichBasketInformation = function (estabId, flight, trip) {
            return this.$q.all([
                this.hotelFromSession.getHotel(_.get(trip, 'HotelsRequest.AvailabilitySearchId'), estabId, _.get(trip, 'TripId')),
                this.basketStore.costBreakdownGrouped(_.get(trip, 'BasketId'))
            ])
                .then(function (res) {
                var hotelFromSession = res[0], costBreakDown = res[1];
                var roomsList = _.get(hotelFromSession, 'RequestedRooms[0].Availability');
                return { costBreakDown: costBreakDown, roomsList: roomsList, flight: flight };
            });
        };
        BD4Travel.prototype._trackFlightsResults = function (tripId) {
            var _this = this;
            this.$q.all([
                this.tripService.getTrip(tripId),
                this.preferences.get('search')
            ])
                .then(function (_a) {
                var trip = _a[0], searchModel = _a[1];
                var flexibleDates = _.get(searchModel, 'flexibleDates');
                var filter = _this.extractFilterFromTrip(trip, flexibleDates);
                var tripType = _.get(trip, 'TripType');
                _this._initPage('flightList', tripType === 2 ? 'hotel' : 'holidays');
                _this._setContext({ filter: filter });
                _this._pageview();
            });
        };
        BD4Travel.prototype._buildHotelResults = function (trip, results, currentRequest, flight) {
            var _this = this;
            var filters = _.get(currentRequest, 'FilterCriteria');
            var boardTypes = _.get(filters, 'BoardTypes');
            var stars = _.get(filters, 'Stars') || [];
            var nearTo = _.get(filters, 'ChildDestinations') || [];
            var holidayTypes = _.get(filters, 'FacilityCodes') || [];
            var propertyTypes = _.get(filters, 'PropertyTypes') || [];
            var rating = _.get(filters, 'RatingRange') || _.get(results, 'Aggregates.RatingRange');
            var price = _.get(filters, 'PriceRange') || _.get(results, 'Aggregates.PriceRange');
            var tripType = _.get(trip, 'TripType');
            var filter = _.merge(this.extractFilterFromTrip(trip), {
                board: _.map(boardTypes, function (bt) { return "tr:" + _this.filtering.getBoardTypeName(parseInt(bt, 10)); }),
                categoryStars: _.map(stars, function (s) { return parseInt(s, 10); }),
                rating10: {
                    min: rating ? _.get(rating, 'Min') * 10 : undefined,
                    max: rating ? _.get(rating, 'Max') * 10 : undefined
                },
                price: {
                    min: _.get(price, 'Min'),
                    max: _.get(price, 'Max')
                },
                categories: _.map(nearTo, function (nt) { return "nearto:" + nt; }).concat(_.map(holidayTypes, function (ht) { return "holiday:" + ht; }), _.map(propertyTypes, function (pt) { return "proptype:" + pt; }))
            });
            var hotels = _.get(results, 'Hotels');
            var sortValue = this.sortCriteria.translateHotelSort(_.get(currentRequest, 'SortCriterion'));
            var checkIn = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            var checkOut = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            var departureAirport = _.get(flight, 'Details.Itinerary.Legs[0].DepartureAirport.Code');
            var productList = {
                listId: tripType === 2 ? 'hotel_list' : 'holidays_list',
                pageIndex: _.get(currentRequest, 'Paging.Index'),
                pageSize: _.get(currentRequest, 'Paging.Size'),
                totalResults: _.get(results, 'Aggregates.FilteredHotelCount'),
                sort: [{
                        field: (results.RankingScoresToken && results.RankingScoresToken.indexOf('_X') === -1)
                            ? 'relevance' : _.get(sortValue, 'label'),
                        direction: _.get(sortValue, 'direction')
                    }],
                tracking: {
                    activeExperiments: ['Amsterdam (new):test'],
                    activeConfigurations: ['Amsterdam']
                },
                elements: _.map(hotels, function (h) { return ({
                    type: tripType === 2 ? 'hotel' : 'package',
                    id: "tr:" + _.get(h, 'Id'),
                    offer: {
                        period: {
                            from: _this.dateFormatter(checkIn),
                            to: _this.dateFormatter(checkOut)
                        },
                        origin: departureAirport,
                        price: _this.getPriceObjectFromHotel(h)
                    }
                }); })
            };
            this._initPage('productList', tripType === 2 ? 'hotel' : tripType === 4 ? 'holidays' : 'landingpage');
            this._setContext({ filter: filter, productList: productList });
            this._pageview();
        };
        BD4Travel.prototype.getPriceObjectFromHotel = function (h) {
            var total = (_.get(h, 'MinHolidayPrice'));
            var pp = (_.get(h, 'MinCostPerPerson') || _.get(h, 'TeaserStr') || '').toString();
            pp = pp.replace(/[^0-9.]/g, '');
            return {
                pp: parseFloat(pp),
                total: total
            };
        };
        BD4Travel.prototype._buildAvailabilityCheck = function (estabId, hotel, flight, trip, costBreakdown, roomsList, res) {
            var totalCost = _.get(costBreakdown, 'total');
            var rooms = _.get(trip, 'HotelsRequest.Rooms');
            var occupancy = this.occupancyService.reduceOccupancy(rooms);
            var totalPeople = this.occupancyService.getNumberOfNonInfantPassengers(occupancy);
            var checkIn = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            var checkOut = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            var boardTypeName = this._getBoardTypeName(hotel, roomsList);
            var tripType = _.get(trip, 'TripType');
            var product = {
                type: tripType === 2 ? 'hotel' : 'package',
                id: "tr:" + estabId
            };
            var offer = {
                occupancy: {
                    adults: occupancy.Adults,
                    children: occupancy.ChildAges
                },
                price: {
                    pp: (totalCost / totalPeople).toFixed(2)
                },
                period: {
                    from: this.dateFormatter(checkIn),
                    to: this.dateFormatter(checkOut)
                },
                origin: _.get(flight, 'Details.Itinerary.Legs[0].DepartureAirport.Code'),
                rooms: _.map(rooms, function (o) { return ({ adults: o.Adults, childAges: o.ChildAges }); }),
            };
            if (boardTypeName) {
                offer.board = "tr:" + boardTypeName;
            }
            this._initPage('engagement', 'holidays');
            var ac = {
                type: 'ac',
                section: tripType === 2 ? 'hotel' : 'holidays',
                product: product,
                offer: offer
            };
            var err = { code: _.get(res, 'status'), message: _.get(res, 'statusText') };
            this._engagement(res
                ? _.set(ac, 'nonAvailability', err)
                : _.set(ac, 'actualPrice', { total: totalCost }));
        };
        BD4Travel.prototype._buildBookingForm = function (confirmed, hotel, flight, trip, costBreakDown, roomsList, fees) {
            var _this = this;
            var rooms = _.get(trip, 'HotelsRequest.Rooms');
            var checkIn = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckInDate'));
            var checkOut = this.dateUtil.parseDate(_.get(trip, 'HotelsRequest.CheckOutDate'));
            var boardTypeName = this._getBoardTypeName(hotel, roomsList);
            var tripType = _.get(trip, 'TripType');
            var outboundLeg = _.get(flight, 'Details.Itinerary.Legs[0]', {});
            var occupancy = this.occupancyService.reduceOccupancy(rooms);
            var total = _.get(costBreakDown, 'total');
            var final = total + (_.get(fees, 'CardHandlingFee') || 0);
            var product = {
                type: tripType === 2 ? 'hotel' : 'package',
                id: "tr:" + _.get(hotel, 'Details.Id')
            };
            var offer = {
                occupancy: {
                    adults: occupancy.Adults,
                    children: occupancy.ChildAges,
                },
                price: {
                    total: total,
                    final: final,
                    pp: parseFloat((total / this.occupancyService.getNumberOfNonInfantPassengers(occupancy)).toFixed(2))
                },
                period: {
                    from: this.dateFormatter(checkIn),
                    to: this.dateFormatter(checkOut)
                },
                origin: _.get(outboundLeg, 'DepartureAirport.Code', ''),
                airline: _.get(outboundLeg, 'Segments[0].CodeshareAirlineName', ''),
                arrivalAirport: _.get(outboundLeg, 'ArrivalAirport.Code', ''),
                board: "tr:" + boardTypeName,
                rooms: _.map(_.get(hotel, 'Details.BookedItems', []), function (room) { return ({
                    type: room.RoomDescription,
                    board: boardTypeName,
                    occupancy: {
                        children: room.ChildAges,
                        adults: room.Adults
                    }
                }); })
            };
            this._initPage("booking:" + (confirmed ? 'confirmation' : 'form'), tripType === 2 ? 'hotel' : 'holidays', confirmed ? 2 : 1, 2);
            var context = { product: product, offer: offer };
            if (confirmed) {
                _.set(context, 'transactionId', _.get(trip, 'TripId'));
            }
            this._setContext(context, false)
                .then(function () { return _this._pageviewImmediate(); });
        };
        BD4Travel.prototype._initPage = function (type, section, funnelStep, totalFunnelSteps) {
            if (section === void 0) { section = undefined; }
            if (funnelStep === void 0) { funnelStep = undefined; }
            if (totalFunnelSteps === void 0) { totalFunnelSteps = undefined; }
            var data = { type: type };
            if (section) {
                _.set(data, 'section', section);
            }
            if (funnelStep) {
                _.set(data, 'funnelStep', funnelStep);
            }
            if (totalFunnelSteps) {
                _.set(data, 'totalFunnelSteps', totalFunnelSteps);
            }
            this.bd4t('initPage', data);
        };
        BD4Travel.prototype._setContext = function (data, mergeContext) {
            var _this = this;
            if (mergeContext === void 0) { mergeContext = true; }
            var user = this.currentUser.get() || {};
            this.filter = angular.copy(_.assign({}, this.filter, data.filter));
            if (!mergeContext) {
                this.bd4t('context', data);
                return this.$q.resolve();
            }
            return this.localStorageProvider.getItem('bd4-context')
                .then(function (context) {
                context = __assign({}, context, data, {
                    uhandles: {
                        userIdHash: user.UserIdHash,
                        utmId: user.UtmId,
                    },
                    uhandle: user.UtmId,
                    filter: _this.filter,
                });
                _this.bd4t('context', context);
                return _this.localStorageProvider.setItem('bd4-context', context);
            });
        };
        BD4Travel.prototype._pageviewImmediate = function () {
            this.bd4t('send', 'pageview');
        };
        //Who is ac?
        BD4Travel.prototype._engagement = function (ac) {
            this.bd4t('send', 'engagement', ac);
        };
        BD4Travel.prototype._getBoardTypeName = function (hotel, roomsList) {
            var _this = this;
            var boardDescription = this._normaliseName(_.get(hotel, 'Details.BookedItems[0].BoardDescription'));
            var boardType;
            _.each(roomsList, function (room) {
                _.each(room.BoardOptions, function (boardOption) {
                    if (_this._normaliseName(boardOption.BoardDescription) === boardDescription) {
                        boardType = boardOption.BoardType;
                    }
                });
            });
            return this.filtering.getBoardTypeName(boardType);
        };
        BD4Travel.prototype._normaliseName = function (name) {
            return _.chain(name).lowerCase().replace(/\s/g, '').value();
        };
        BD4Travel.prototype._normaliseDestination = function (destination) {
            var _this = this;
            if (!angular.isArray(destination)) {
                destination = [destination];
            }
            return _(destination)
                .map(function (d) {
                if (d) {
                    d = _this.objectTypeService.getObjectTypeAndId(d);
                    if (d.Type > 1 && d.Id) {
                        return "tr" + d.Type + ":" + d.Id;
                    }
                }
            })
                .filter(function (d) { return d; })
                .value();
        };
        return BD4Travel;
    }());
    TR.BD4Travel = BD4Travel;
    angular
        .module('TR')
        .service('bd4travel', BD4Travel);
})(TR || (TR = {}));
var Core;
(function (Core) {
    //service to hold common bits required for tracking data when completing a booking.
    //two routes for us to handle booking complete from the booking form and complete after
    //coming from payment via PayPal
    var BookingCompleteTrackingService = /** @class */ (function () {
        function BookingCompleteTrackingService($q, abTest, analytics, basketStore, criteoService, ecommerceService, quoteService, trackingPixelsService) {
            this.$q = $q;
            this.abTest = abTest;
            this.analytics = analytics;
            this.basketStore = basketStore;
            this.criteoService = criteoService;
            this.ecommerceService = ecommerceService;
            this.quoteService = quoteService;
            this.trackingPixelsService = trackingPixelsService;
        }
        BookingCompleteTrackingService.prototype.trackConversion = function (trip, refs, source, userEmail, rooms) {
            var _this = this;
            return this.basketStore.all(trip.BasketId).then(function (basket) {
                //dont bother running analytics code as we dont have a basket anymore!
                if (basket.f == null && basket.h == null && basket.t == null && basket.c == null &&
                    basket.a == null && basket.p == null) {
                    return;
                }
                return _this.trackTotalCost(trip.BasketId, basket, refs, source, userEmail, trip.TripId, trip.TripType, trip.QuoteId, rooms);
            });
        };
        BookingCompleteTrackingService.prototype.trackTotalCost = function (basketId, basket, refs, source, userEmail, tripId, tripType, quoteId, rooms) {
            var _this = this;
            return this.$q.all([
                this.basketStore.totalCostFromBasket(basket),
                this.basketStore.getBasketCurrency(basketId)
            ]).then(function (results) {
                var totalCost = results[0];
                var currency = results[1];
                var criteoData = {
                    ref: refs.join('|'),
                    items: {
                        hotel: basket.h,
                        flight: basket.f
                    },
                    price: totalCost
                };
                _this.criteoService.enqueue(criteoData, 'bookingcomplete', tripType);
                var trackingData = {
                    TotalCost: totalCost,
                    Hotel: basket.h,
                    Flight: basket.f,
                    CarHire: basket.c,
                    Transfer: basket.t,
                    Attractions: basket.a,
                    Insurance: basket.i,
                    Parking: basket.p,
                    Marhaba: basket.m,
                    FirstBookingId: refs[0].split('/')[1],
                    Source: source
                };
                _this.analytics.track('mixpanel', 'BookingComplete', trackingData);
                _this.analytics.track('mixpanelPeople', 'BookingComplete', trackingData);
                _this.analytics.setMixpanelEmail(userEmail);
                return _this.ecommerceService.pushBasket(tripId, basket, totalCost, refs)
                    .then(function () {
                    _this.trackingPixelsService.setData(refs, currency, totalCost, basket.h, rooms, tripType);
                    _this.abTest.recordRevenue(totalCost);
                    var run = $.when();
                    if (TRPCONFIG.Domain.QuoteEnabled && quoteId) {
                        run.then(function () { return _this.quoteService.linkQuote(refs, quoteId); });
                    }
                    return run;
                });
            });
        };
        return BookingCompleteTrackingService;
    }());
    Core.BookingCompleteTrackingService = BookingCompleteTrackingService;
    angular
        .module('TR')
        .service('bookingCompleteTrackingService', BookingCompleteTrackingService);
})(Core || (Core = {}));
(function () {
    'use strict';
    /*
        this is a horrible hack to make sure that all the services
        that we need to be constructed and listening for events are
        alive and ready
    */
    angular
        .module('TR')
        .service('bootstrapper', bootstrapper);
    function bootstrapper($injector) {
        var service = {
            init: init
        };
        function init() {
            $injector.get('hotelService');
            $injector.get('flightSearch');
            $injector.get('hotelSearch');
            $injector.get('transferSearch');
            $injector.get('authService');
            $injector.get('searchUnitService');
            $injector.get('basketService');
            $injector.get('urgencyMessaging');
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular.module('TR')
        .service('cancellerService', cancellerService);
    function cancellerService($q, broker) {
        var supervisors = [];
        var service = {
            add: add,
            process: processFunc
        };
        function add() {
            var validRoutes = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                validRoutes[_i] = arguments[_i];
            }
            var supervisor = { validRoutes: validRoutes, canceller: $q.defer() };
            supervisors.push(supervisor);
            return supervisor.canceller;
        }
        function processFunc(nextRoute) {
            var remainingSupervisors = [];
            supervisors.forEach(function (s) {
                var valid = s.validRoutes.some(function (r) {
                    if (r instanceof RegExp) {
                        return r.test(nextRoute);
                    }
                    return r === nextRoute;
                });
                if (!valid) {
                    broker.publish('unblock');
                    s.canceller.resolve('CANCELLED');
                }
                else {
                    remainingSupervisors.push(s);
                }
            });
            supervisors = remainingSupervisors;
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var KeyCode;
    (function (KeyCode) {
        KeyCode[KeyCode["TAB"] = 9] = "TAB";
        KeyCode[KeyCode["RETURN"] = 13] = "RETURN";
        KeyCode[KeyCode["ESC"] = 27] = "ESC";
        KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
        KeyCode[KeyCode["PAGEUP"] = 33] = "PAGEUP";
        KeyCode[KeyCode["PAGEDOWN"] = 34] = "PAGEDOWN";
        KeyCode[KeyCode["END"] = 35] = "END";
        KeyCode[KeyCode["HOME"] = 36] = "HOME";
        KeyCode[KeyCode["LEFT"] = 37] = "LEFT";
        KeyCode[KeyCode["UP"] = 38] = "UP";
        KeyCode[KeyCode["RIGHT"] = 39] = "RIGHT";
        KeyCode[KeyCode["DOWN"] = 40] = "DOWN";
    })(KeyCode = TR.KeyCode || (TR.KeyCode = {}));
})(TR || (TR = {}));
(function () {
    'use strict';
    angular.module('TR')
        .service('countryService', countryService);
    function countryService(hotelSearch, $filter, $http, destinationService, imageService, $q, arrayUtil, broker, fieldGroupService, objectTypeService) {
        var service = {
            getTopDeals: getTopDeals
        };
        var fieldTypes = fieldGroupService.getFieldTypes();
        var fieldFlags = fieldGroupService.getFieldGroup([
            fieldTypes.Global,
            fieldTypes.Titles,
            fieldTypes.IndicativePrice,
            fieldTypes.ReviewSnippets,
            fieldTypes.Url,
            fieldTypes.Summary,
            fieldTypes.Recommendations
        ]);
        //yes this looks a lot like what the hotelSearch service does, but in this case we need to run n searches
        //concurrently which the hotelSearch service is specifically designed to prevent.
        function _getHotelsForDestination(dest) {
            var domain = TRPCONFIG.Domain;
            dest.loading = true;
            var objectTypeAndId = objectTypeService.getObjectTypeAndId(dest);
            return $http.post('/api/hotels/static/gethotelsbydestination', {
                DestinationType: objectTypeAndId.Type,
                DestinationId: objectTypeAndId.Id,
                CultureCode: domain.CultureCode,
                DomainId: domain.DomainId,
                CurrencyCode: domain.CurrencyCode,
                Paging: {
                    Index: 0,
                    Size: 2
                },
                SortCriterion: 1,
                FilterCriteria: hotelSearch.getFilter(),
                FieldFlags: fieldFlags
            }).then(function (result) {
                return arrayUtil.map(result.data.Hotels, function (hotel) {
                    var dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
                    hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, dim, dim);
                    hotel.MinCostStr = $filter('roundedCurrency')(hotel.MinCost);
                    hotel.OriginalCostStr = $filter('roundedCurrency')(hotel.OriginalCost);
                    hotel.TeaserStr = $filter('roundedCurrency')(hotel.IndicativeMinPrice);
                    return hotel;
                });
            });
        }
        function getTopDeals(topn, destination, children) {
            function getHotels(children) {
                return hotelSearch.updateFilterFromFid().then(function () {
                    return $q.all(arrayUtil.map(children, _getHotelsForDestination)).then(function (results) {
                        var all = [];
                        results.forEach(function (hotels, i) {
                            children[i].hotels = hotels;
                            all = all.concat(hotels);
                        });
                        broker.publish('hotelsReturnedFromSearch', all); //make sure we publish the results so that
                        return children; //urgency messaging works efficiently
                    });
                });
            }
            if (children == null) {
                return destinationService.getTopChildren(topn, destination).then(getHotels);
            }
            return getHotels(children);
        }
        return service;
    }
})();
(function () {
    /* eslint-disable camelcase */
    'use strict';
    angular
        .module('TR')
        .factory('criteoService', criteoService);
    function criteoService($q, dateUtil, funcUtil, currentUser, searchUnitService, destinationAirport, currentDestination, broker) {
        var productTypes = {
            hotel: 1,
            tailorMade: 2,
            flight: 3
        };
        var userLanguages = {
            en: 'english',
            ar: 'arabic'
        };
        var language = TRPCONFIG.Domain.CultureCode != null
            ? userLanguages[TRPCONFIG.Domain.CultureCode.substring(0, 2)]
            : 'en';
        var service = {
            enqueue: enqueue
        };
        var getCustomerIdComplete;
        broker.subscribe('criteoService', 'userExtended', function (ev) {
            if (getCustomerIdComplete) {
                getCustomerIdComplete.resolve(ev.data.UserIdHash);
            }
        });
        function _getCustomerId() {
            var user = currentUser.get();
            var isUserComplete = user && (user.Email !== undefined || !user.SignedIn);
            if (isUserComplete) {
                return $q.when(user.UserIdHash);
            }
            getCustomerIdComplete = $q.defer();
            return getCustomerIdComplete.promise;
        }
        function _getSearchDates(type) {
            var product = (type === 'hotel' ? searchUnitService.hotel : searchUnitService.flight);
            return {
                checkInDate: dateUtil.format(searchUnitService.startDate(product), 'yyyy-MM-dd'),
                checkOutDate: dateUtil.format(searchUnitService.endDate(product), 'yyyy-MM-dd')
            };
        }
        function _buildConfirmationId(items) {
            var id = '';
            if (items.hotel) {
                id += items.hotel.Details.Id;
            }
            if (items.flight && !items.hotel) {
                id += '::';
                id += searchUnitService.getDepartureAirports();
            }
            return id;
        }
        function _getIds(items, type) {
            var ids = [];
            switch (type) {
                case 'hotels':
                    items = items.Hotels;
                    angular.forEach(items, function (hotel) {
                        ids.push(hotel.Id);
                    });
                    break;
                case 'flights':
                    angular.forEach(items, function (flight) {
                        ids.push(flight.FlightId);
                    });
            }
            return ids;
        }
        var _config = function (type, tripType) {
            var promises = {
                customerId: _getCustomerId(),
                emailHash: (function () {
                    var getEmailHash = function () { return currentUser.get() && currentUser.get().EmailHash; };
                    return type === 'bookingcomplete' ? funcUtil.waitForValue(getEmailHash) : getEmailHash();
                })()
            };
            return $q.all(promises).then(function (results) {
                results.customerId = results.customerId || '';
                var config = [
                    { event: 'setCustomerId', id: results.customerId },
                    { event: 'setAccount', account: TRPCONFIG.Domain.CriteoPartnerId },
                    { event: 'setSiteType', type: (TRPCONFIG.IsMobileView) ? 'm' : 'd' }
                ];
                if (results.emailHash) {
                    config.push({ event: 'setHashedEmail', m: results.emailHash, hash_method: 's2m' });
                }
                if (tripType != null) {
                    switch (tripType) {
                        case 4:
                            config.push({ event: 'setData', append_to_landing_url: 'tm=1' });
                            break;
                        default:
                            config.push({ event: 'setData', append_to_landing_url: 'tm=' });
                            break;
                    }
                }
                return config;
            });
        };
        function enqueue(data, type, tripType) {
            if (TRPCONFIG.Domain.isAgentMode) {
                return;
            }
            $('#criteo-tags-div').empty();
            if (TRPCONFIG.Domain.CriteoEnabled) {
                window.criteo_q = window.criteo_q || [];
                _config(type, tripType).then(function (conf) {
                    var airports;
                    var product;
                    var title = null;
                    switch (type) {
                        case 'home':
                            _homeTag(conf);
                            break;
                        case 'hotel':
                            product = {
                                dates: _getSearchDates('hotel'),
                                type: productTypes.hotel,
                                id: data.Id
                            };
                            _productTag(product, conf);
                            break;
                        case 'hotellist':
                            currentDestination.getCurrentDestination().then(function (dest) {
                                if (dest) {
                                    title = dest.Title;
                                }
                                else if (searchUnitService.getSearchArea() && data.Hotels) {
                                    title = data.Hotels[0].Location;
                                }
                                product = {
                                    dates: _getSearchDates('hotel'),
                                    items: _getIds(data, 'hotels'),
                                    type: productTypes.hotel
                                };
                                _productListTag(product, title, conf);
                            });
                            break;
                        case 'flightlist':
                            airports = searchUnitService.getDepartureAirports() || [];
                            destinationAirport.getTopEstabsForAirport(airports[0]).then(function (data) {
                                var ids = [];
                                angular.forEach(data.Hotels, function (estab) {
                                    ids.push(estab.Id);
                                });
                                product = {
                                    dates: _getSearchDates('flight'),
                                    items: ids,
                                    type: productTypes.flight
                                };
                                _productListTag(product, null, conf);
                            });
                            break;
                        case 'basket':
                            product = {
                                id: _buildConfirmationId(data.items),
                                price: data.price
                            };
                            _basketTag(product, conf);
                            break;
                        case 'bookingcomplete': {
                            var id = _buildConfirmationId(data.items);
                            if (id != null) {
                                product = {
                                    id: id,
                                    price: data.price
                                };
                                _confirmationTag(data.ref || data.ref[0], product, conf);
                            }
                            break;
                        }
                        case 'signin':
                            _signinTag(data, conf);
                    }
                });
            }
        }
        function _confirmationTag(transaction, product, conf) {
            window.criteo_q.push(conf, {
                event: 'trackTransaction',
                id: transaction || transaction.id,
                item: [{
                        id: product.id,
                        price: product.price,
                        quantity: 1
                    }],
                section: language
            });
        }
        function _homeTag(conf) {
            window.criteo_q.push(conf, {
                event: 'viewHome',
                section: language
            });
        }
        function _signinTag(data, conf) {
            window.criteo_q.push(conf, {
                event: 'setHashedEmail',
                m: data && data.EmailHash,
                hash_method: 's2m'
            });
        }
        function _productTag(product, conf) {
            window.criteo_q.push(conf, { event: 'setData', user_segment: product.type }, { event: 'viewItem', item: product.id, section: language });
            if (product.dates.checkInDate || product.dates.checkOutDate) {
                window.criteo_q.push({
                    event: 'viewSearch',
                    checkin_date: product.dates.checkInDate,
                    checkout_date: product.dates.checkOutDate
                });
            }
        }
        function _productListTag(product, keywords, conf) {
            window.criteo_q.push(conf, { event: 'setData', user_segment: product.type }, {
                event: 'viewList',
                item: product.items,
                section: language,
                keywords: keywords
            }, {
                event: 'viewSearch',
                checkin_date: product.dates.checkInDate,
                checkout_date: product.dates.checkOutDate
            });
        }
        function _basketTag(product, conf) {
            window.criteo_q.push(conf, {
                event: 'viewBasket',
                section: language,
                retarget: 0,
                item: [{
                        id: product.id,
                        price: product.price,
                        quantity: 1
                    }]
            });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular.module('TR')
        .service('currentDestination', currentDestination);
    function currentDestination($routeParams, tripService, searchUnitService, destinationService, $q) {
        var service = {
            getCurrentDestination: getCurrentDestination
        };
        function getCurrentDestination(options) {
            return destinationFn(options).then(function (destination) {
                if (destination == null) {
                    return null;
                }
                return destinationService.enhanceDestinationFromPreferences(destination).then(function () { return destination; });
            });
        }
        var defaults = {
            useTrip: true,
            useLandingPage: true,
            useSearchUnitService: true
        };
        function destinationFn(options) {
            options = angular.extend({}, defaults, options);
            if (options.useTrip && $routeParams.tripId) {
                return tripService.getTripDestination($routeParams.tripId);
            }
            if (options.useLandingPage && $routeParams.landingPageV4) {
                return destinationService.fromUrl("/" + $routeParams.urlText + "/" + $routeParams.landingPageV4, $routeParams.tm)
                    .then(destinationService.enhanceLegacyDestination)
                    .then(destinationService.getDetails);
            }
            if (options.useLandingPage && ($routeParams.landingPageV2 || $routeParams.landingPageV3)) {
                var tmParam = $routeParams.tm || '2';
                var route = '';
                if ($routeParams.landingPageV3) {
                    var possibleParam = $routeParams.landingPageV3 && $routeParams.landingPageV3.match(/(?:\d+-\d+-)(\d+)(?:-\d+)/) || [];
                    tmParam = possibleParam && possibleParam[1] !== '1' ? '1' : tmParam;
                    route = $routeParams.landingPageV3;
                }
                else if ($routeParams.landingPageV2) {
                    var possibleParam = $routeParams.landingPageV2 && $routeParams.landingPageV2.match(/(?:\d+-\d+-)(\d+)?/) || [];
                    tmParam = possibleParam && possibleParam[1] !== '1' ? '1' : tmParam;
                    route = $routeParams.landingPageV2;
                }
                return destinationService.fromUrl("/" + route + "/" + $routeParams.urlText, tmParam)
                    .then(destinationService.setFidFromDestinationFilter)
                    .then(destinationService.enhanceLegacyDestination)
                    .then(destinationService.getDetails);
            }
            if (options.useLandingPage && $routeParams.landingPage) {
                return destinationService.fromUrl("/" + $routeParams.landingPage + ".html", $routeParams.tm)
                    .then(destinationService.enhanceLegacyDestination)
                    .then(destinationService.getDetails);
            }
            if (options.useSearchUnitService) {
                return $q.when(searchUnitService.getDestination());
            }
            return $q.when();
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('dateUtil', dateUtil);
    function dateUtil($injector, $filter, $route, resourceService) {
        var oneDay = 24 * 60 * 60 * 1000;
        var service = {
            addDays: addDays,
            addMinutes: addMinutes,
            addHours: addHours,
            atLeastOneDayInTheFuture: atLeastOneDayInTheFuture,
            atLeastTwoDaysInTheFuture: atLeastTwoDaysInTheFuture,
            DateRange: DateRange,
            format: format,
            getAge: getAge,
            getDurationSummary: getDurationSummary,
            isValid: isValid,
            minutesToHoursAndMinutes: minutesToHoursAndMinutes,
            numberOfNights: numberOfNights,
            parseDate: parseDate,
            serialiseDate: serialiseDate,
            alignDates: alignDates,
            sameDay: sameDay,
            sameMonth: sameMonth,
            todayPlus: todayPlus,
            defaultTime: defaultTime,
            zeroTime: zeroTime,
            roundedToStartOfHour: roundedToStartOfHour,
            dayDiff: dayDiff,
            thisWeek: thisWeek,
            nextWeek: nextWeek,
            thisMonth: thisMonth,
            specificMonth: specificMonth,
            oneDay: function () { return oneDay; },
            compareDates: compareDates,
            totalMinutes: totalMinutes,
            getWeeksString: getWeeksString,
            getDifferenceInDays: getDifferenceInDays,
            getDateInterval: getDateInterval,
            checkZonedDateFromat: checkZonedDateFromat,
            getNextSaturday: getNextSaturday
        };
        function getWeeksString(date1, date2) {
            var oneweek = 604800000; //ms in one week
            var weeks = Math.ceil((new Date(date2).setHours(0, 0, 0, 0).valueOf() - new Date(date1).setHours(0, 0, 0, 0).valueOf()) / oneweek);
            return weeks.toString() + " " + ((weeks > 1) ? resourceService.get('WEEKS') : resourceService.get('WEEK'));
        }
        function DateRange(start, end, timeSupport) {
            if (timeSupport === void 0) { timeSupport = false; }
            this.start = serialiseDate(start);
            this.end = serialiseDate(end);
            this.timeSupport = timeSupport;
            this.isStartTimeApprovedByCustomer = timeSupport ? false : undefined;
            this.isEndTimeApprovedByCustomer = timeSupport ? false : undefined;
        }
        DateRange.prototype.setStart = function (val, defaultTimeObj) {
            this.start = serialiseDate(val);
            if ((this.end == null && this.start != null) ||
                (this.end != null && this.start != null && numberOfNights(this.start, this.end) < 1)) {
                var areaInfo = getAreaInfo();
                var endDateOffset = areaInfo && areaInfo.endDateOffset || 1;
                var endDate = addDays(this.start, endDateOffset, true);
                if (this.timeSupport) {
                    this.end = defaultTime(endDate, true, defaultTimeObj);
                }
                else {
                    this.end = endDate;
                }
            }
            this.durationSummary = null;
            this.nights = null;
        };
        DateRange.prototype.setEnd = function (val) {
            this.end = serialiseDate(val);
            this.durationSummary = null;
            this.nights = null;
        };
        DateRange.prototype.getDurationSummary = function () {
            if (this.durationSummary) {
                return this.durationSummary;
            }
            this.durationSummary = getDurationSummary(this.start, this.end);
            return this.durationSummary;
        };
        DateRange.prototype.numberOfNights = function () {
            if (this.nights) {
                return this.nights;
            }
            this.nights = numberOfNights(this.start, this.end);
            return this.nights;
        };
        function today() {
            return zeroTime(new Date());
        }
        function zeroTime(date, serialised) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            d.setMilliseconds(0);
            return _serialiseIfNecessary(d, serialised);
        }
        function defaultTime(date, serialised, defaultTimeObj) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (defaultTimeObj) {
                d.setHours(defaultTimeObj.hours, defaultTimeObj.minutes);
            }
            else {
                d.setHours(11, 30);
            }
            return _serialiseIfNecessary(d, serialised);
        }
        function _toUtc(date, serialised) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            return _serialiseIfNecessary(new Date(date.getTime() - (date.getTimezoneOffset() * 60000)), serialised);
        }
        function todayPlus(options) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            if (!_.isObject(options)) {
                options = {
                    days: options,
                    hours: rest[0],
                    serialised: rest[1]
                };
            }
            var d = zeroTime(new Date());
            if (options.months) {
                d.setMonth(d.getMonth() + options.months);
            }
            if (options.days) {
                d.setDate(d.getDate() + options.days);
            }
            if (options.hours) {
                d.setHours(options.hours);
            }
            return _serialiseIfNecessary(d, options.serialised);
        }
        function numberOfNights(earliest, latest) {
            if (earliest && latest) {
                var _a = alignDates([earliest, latest], true), e = _a[0], l = _a[1];
                return Math.ceil((l.getTime() - e.getTime()) / oneDay);
            }
            return -1;
        }
        function format(date, fmt) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            return $filter('unadjustedDate')(date, fmt || 'd MMM yyyy');
        }
        function atLeastOneDayInTheFuture(date) {
            return _xDaysInTheFuture(date, 1);
        }
        function atLeastTwoDaysInTheFuture(date) {
            return _xDaysInTheFuture(date, 2);
        }
        function addDays(date, days, serialised) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            var d = new Date(date);
            d.setDate(date.getDate() + days);
            return _serialiseIfNecessary(d, serialised);
        }
        function addMinutes(date, minutes, serialised) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            var d = new Date(date);
            d.setMinutes(d.getMinutes() + minutes);
            return _serialiseIfNecessary(d, serialised);
        }
        function addHours(date, hours, serialised) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            var d = new Date(date);
            d.setHours(d.getHours() + hours);
            return _serialiseIfNecessary(d, serialised);
        }
        function getAge(birthDate, returnDate) {
            if (!birthDate || !returnDate) {
                return null;
            }
            birthDate = parseDate(birthDate);
            returnDate = parseDate(returnDate);
            var age = returnDate.getFullYear() - birthDate.getFullYear();
            var m = returnDate.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && returnDate.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }
        function getDurationSummary(from, to) {
            from = parseDate(from);
            to = parseDate(to);
            if (!from || !isValid(from)) {
                return '';
            }
            if (to == null) {
                return format(from);
            }
            if (to.getTime() === 0) {
                return format(from);
            }
            if (!isValid(to)) {
                return '';
            }
            var days = numberOfNights(from, to);
            return days + " " + (days > 1 ? resourceService.get('NIGHTS') : resourceService.get('NIGHT')) + ", (" + format(from) + ") - (" + format(to) + ")";
        }
        function minutesToHoursAndMinutes(m, leadingZero) {
            if (leadingZero === void 0) { leadingZero = true; }
            var hours = leadingZero ? $filter('frontPad')(Math.floor(m / 60)) : Math.floor(m / 60);
            var minutes = $filter('frontPad')(m % 60);
            return hours + resourceService.get('HOURABBR') + " " + minutes + resourceService.get('MINUTEABBR');
        }
        function isValid(d) {
            d = parseDate(d);
            return d instanceof Date && isFinite(d);
        }
        //this function will treat all datetime strings as if they are GMT
        //if there is no timezone we add 'Z', if there is any other timezone
        //we replace with 'Z'. This allows us to then parse the date and
        //then undo the browser's adjustment meaning that we end up with whatever
        //we started with, regardless of timezone.
        function parseDate(str) {
            if (!str) {
                return null;
            }
            if (str instanceof Date) {
                return str;
            }
            if (typeof str === 'string' && /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(str)) {
                str += 'T00:00:00Z';
            }
            //we are expecting an ISO string but we need to check if it ends with a timezone
            //if it doesn't we must add Z for GMT because firefox does not assume Z as it should
            //according to http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
            if (typeof str === 'string' && !/^.+((\+|-)[0-9]{2}:[0-9]{2}|Z)$/.test(str)) {
                str += 'Z';
            }
            //if the date string contains a timezone string other than 'Z' we need to replace it with 'Z'
            if (typeof str === 'string') {
                str = str.replace(/^(.+)((\+|-)[0-9]{2}:[0-9]{2})$/, function (m, p1) {
                    return p1 + "Z";
                });
            }
            //parse the date into a new local timezone date object
            var d = new Date(str);
            //undo the offset that the browser *may* have applied so that we end up with
            //a date time that looks like the original string - yucky
            return new Date(d.getTime() + (d.getTimezoneOffset() * 60000));
        }
        function sameDay(d1, d2) {
            if (!d1 || !d2) {
                return null;
            }
            return zeroTime(d1, false).getTime() === zeroTime(d2, false).getTime();
        }
        function sameMonth(d1, d2) {
            if (!d1 || !d2) {
                return null;
            }
            return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
        }
        function roundedToStartOfHour(date, serialised) {
            if (!date) {
                return null;
            }
            date = parseDate(date);
            var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0);
            var minutes = date.getMinutes();
            if (minutes < 15) {
                return _serialiseIfNecessary(newDate, serialised);
            }
            if (minutes < 45) {
                return service.addMinutes(newDate, 30, serialised);
            }
            return service.addHours(newDate, 1, serialised);
        }
        function dayDiff(date1, date2) {
            if (!date1 || !date2) {
                return null;
            }
            date1 = parseDate(date1);
            date2 = parseDate(date2);
            var _a = alignDates([date1, date2], true), a = _a[0], b = _a[1];
            return Math.abs(Math.floor((a - b) / oneDay));
        }
        function thisWeek() {
            var t = today();
            var y = t.getFullYear();
            var m = t.getMonth();
            var d = t.getDate();
            var dow = t.getDay();
            var startDay = 1; // monday
            var startDate = (d - dow) + startDay;
            var start = zeroTime(new Date(y, m, startDate));
            var end = addDays(start, 6);
            return new DateRange(start, end);
        }
        function nextWeek() {
            var dateRange = thisWeek();
            return new DateRange(addDays(dateRange.start, 7), addDays(dateRange.end, 7));
        }
        function thisMonth() {
            var d = today();
            var y = d.getFullYear();
            var m = d.getMonth();
            var start = zeroTime(new Date(y, m, 1));
            var end = zeroTime(new Date(y, m + 1, 0));
            return new DateRange(start, end);
        }
        function specificMonth(month, year) {
            var start = zeroTime(new Date(year, month, 1));
            var end = zeroTime(new Date(year, month + 1, 0));
            return new DateRange(start, end);
        }
        function serialiseDate(date) {
            date = parseDate(date);
            if (isValid(date)) {
                return _toUtc(date).toISOString();
            }
            return null;
        }
        function _serialiseIfNecessary(d, serialised) {
            return (serialised ? serialiseDate : parseDate)(d);
        }
        function _xDaysInTheFuture(date, days) {
            if (!date) {
                return null;
            }
            var t = today();
            _a = alignDates([date, t], true), date = _a[0], t = _a[1];
            return date.getTime() - t.getTime() >= (oneDay * days);
            var _a;
        }
        // to be used exclusively for dates comparisons && calculations
        function alignDates(dates, zeroTime) {
            if (zeroTime === void 0) { zeroTime = false; }
            return dates.map(_.flowRight(_toUtc, zeroTime ? service.zeroTime : function (d) { return d; }));
        }
        /*
            returns -1 when d1<d2,
            returns 1 when d1>d2,
            return 0 when d1=d2
        */
        function compareDates(d1, d2) {
            var _a = alignDates([d1, d2]), a1 = _a[0], a2 = _a[1];
            if (a1 < a2) {
                return -1;
            }
            if (a1 > a2) {
                return 1;
            }
            return 0;
        }
        function totalMinutes(d1, d2) {
            var start = parseDate(d1);
            var end = parseDate(d2);
            var diffMs = end - start; // milliseconds between start & end
            return Math.floor(diffMs / 60000);
        }
        function getDifferenceInDays(d1, d2) {
            if (!d1 || !d2) {
                return 0;
            }
            var startTime = angular.copy(d1).setHours(0, 0, 0, 0);
            var endTime = angular.copy(d2).setHours(0, 0, 0, 0);
            return Math.floor((endTime - startTime) / (1000 * 60 * 60 * 24));
        }
        function getDateInterval(date, rangeLength, skipPivot) {
            var minimumDate = todayPlus(1, 0, false);
            var halfRange = Math.floor(rangeLength / 2);
            var initialDate = skipPivot ? date : addDays(date, -halfRange);
            var comparison = compareDates(initialDate, minimumDate);
            var startingDate = zeroTime(comparison === -1 ? minimumDate : initialDate);
            var dates = [];
            for (var i = 0, ii = rangeLength; i < ii; i++) {
                var d = addDays(startingDate, i).setHours(0, 0, 0, 0);
                dates.push(d);
            }
            return dates;
        }
        function getNextSaturday(weeks) {
            // This function finds your weekend in the future.
            var theFuture = todayPlus(weeks * 7);
            var howMaynDaysYet = 6 - theFuture.getDay();
            return addDays(theFuture, howMaynDaysYet, true);
        }
        var _Area;
        function getAreaInfo() {
            if (!_Area) {
                //I know $injector is not awesome but I'm trying to limit how much I refactor.
                _Area = $injector.get('Area');
            }
            var area = $route.current && $route.current.$$route && $route.current.$$route.area;
            return _Area[area];
        }
        function checkZonedDateFromat(str) {
            // Time-zoned date strings must have a four digit time zone in order to be parsed successfully by new Date()
            // valid formats: 'YYYY-MM-DDThh:mm:ss+hhmm' or 'YYYY-MM-DDThh:mm:ss+hh:mm'
            // eg: '2016-08-07T15:05:00+0100' or '2016-08-07T15:05:00+01:00'
            if (str === null) {
                return;
            }
            var time = str.substring(str.indexOf('T') + 1);
            var pos = time.indexOf('+');
            if (pos === -1) {
                pos = time.indexOf('-');
            }
            if (time.substring(pos + 1).length === 2) {
                // the time zone only specifies hours so we need to add minutes
                str += ':00';
            }
            return (new Date(str)).toISOString();
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var DealsBoxService = /** @class */ (function () {
        function DealsBoxService($filter, holidayDeals, dateUtil, hotelFromSession, occupancyService, analytics) {
            this.$filter = $filter;
            this.holidayDeals = holidayDeals;
            this.dateUtil = dateUtil;
            this.hotelFromSession = hotelFromSession;
            this.occupancyService = occupancyService;
            this.analytics = analytics;
            this.hotelInfoBackTracked = false;
            this.singleEditTrack = {};
        }
        DealsBoxService.prototype.enrichSelected = function (selected) {
            var _this = this;
            return this.holidayDeals
                .getCurrentFilters()
                .then(function (f) {
                var boardTypeFilter = f.BoardTypes.map(function (bt) { return parseInt(bt, 10); });
                return _.first(_this.holidayDeals.enrichDeals([selected], boardTypeFilter));
            });
        };
        DealsBoxService.prototype.getDealsForCalendar = function (estabId, duration, dates, selectedDate) {
            var _this = this;
            var boardTypeFilter;
            return this.holidayDeals
                .getCurrentFilters()
                .then(function (f) {
                boardTypeFilter = f.BoardTypes.map(function (bt) { return parseInt(bt, 10); });
                return _this.holidayDeals.getDealsForHotel(estabId, [duration], dates);
            })
                .then(function (h) {
                return h && h.HolidayDeals
                    ? _this.holidayDeals.enrichDeals(h.HolidayDeals, boardTypeFilter)
                    : [];
            });
        };
        DealsBoxService.prototype.getTransfersMap = function (transferTimes) {
            if (!transferTimes) {
                return;
            }
            return transferTimes.reduce(function (p, c) {
                p[c.Airport] = c.Minutes;
                return p;
            }, {});
        };
        DealsBoxService.prototype.getRoomsForDeal = function (estabId, searchId, oldRoom, oldBoardType, persist) {
            var _this = this;
            var boardTypeFilter;
            return this.holidayDeals
                .getCurrentFilters()
                .then(function (f) {
                boardTypeFilter = f.BoardTypes.map(function (bt) { return parseInt(bt, 10); });
                return _this.hotelFromSession.getRoomTypes(estabId, searchId, boardTypeFilter);
            })
                .then(function (r) {
                var dealsRooms = {};
                dealsRooms.rooms = (r || r.length) ? _this._sortRoomsByPrice(r) : [];
                if (r.length) {
                    dealsRooms.best = _this._pickBestRoom(dealsRooms.rooms, boardTypeFilter, oldRoom, oldBoardType, persist);
                }
                return dealsRooms;
            });
        };
        DealsBoxService.prototype.updatePriceLabels = function (rooms, selectedRoomId, currentBoardTypes, selectedBt, priceMode) {
            var _this = this;
            var updatedBoardTypes = currentBoardTypes.map(function (bt) {
                var _a = _this._calcDifference(bt.Cost, selectedBt.Cost, priceMode), diff = _a.diff, label = _a.label;
                bt.NamePrice = diff === 0
                    ? bt.BoardDescription
                    : bt.BoardDescription + " (" + (diff < 0 ? '-' : '+') + label + ")";
                return bt;
            });
            var updatedRooms = rooms.map(function (r) {
                var current = _.find(r.BoardOptions, function (bt) { return bt.BoardType === selectedBt.BoardType; });
                var boardCost = current ? current.Cost : r.BoardOptions[0].Cost;
                var _a = _this._calcDifference(boardCost, selectedBt.Cost, priceMode), diff = _a.diff, label = _a.label;
                r.PriceDiffLabel = "" + (diff < 0 ? '-' : '+') + label;
                r.NamePrice = diff === 0 || r.MasterId === selectedRoomId
                    ? r.RoomDescription
                    : r.RoomDescription + " (" + r.PriceDiffLabel + ")";
                return r;
            });
            return { updatedBoardTypes: updatedBoardTypes, updatedRooms: updatedRooms };
        };
        DealsBoxService.prototype.findTemperature = function (selectedDate, temperatures) {
            if (!selectedDate || !temperatures) {
                return 0;
            }
            var weather = _.find(temperatures, function (t) { return t.Month === (selectedDate.getMonth() + 1); });
            return weather ? Math.round(weather.Temperature) : 0;
        };
        DealsBoxService.prototype.getTabCounter = function (entryPoint) {
            var tracking = { entryPoint: entryPoint };
            return function (tab) {
                if (!tab) {
                    return tracking;
                }
                tracking[tab] = _.has(tracking, tab) ? tracking[tab] + 1 : 1;
                return tracking;
            };
        };
        DealsBoxService.prototype.sendTabTracking = function (tabsStat) {
            if (!tabsStat || !_.has(tabsStat, 'entryPoint')) {
                return;
            }
            this.analytics.track('mixpanel', 'HolidayDealsHotelDetails', tabsStat);
        };
        DealsBoxService.prototype.trackHotelInfoBack = function () {
            if (!this.hotelInfoBackTracked) {
                this.analytics.track('mixpanel', 'HolidayDealsHotelDetailsBack');
                this.hotelInfoBackTracked = true;
            }
        };
        DealsBoxService.prototype.trackOpenBox = function (hotel, dealsNumber, dealsMiss) {
            this.hotelInfoBackTracked = false;
            this.singleEditTrack = {};
            this.analytics.track('mixpanel', 'HolidayDealsDetails', {
                EstabId: hotel.Id,
                EstabName: hotel.Title,
                ProvinceId: hotel.ProvinceId,
                Province: hotel.Province,
                CountryId: hotel.CountryId,
                Country: hotel.Country,
                StarRating: hotel.StarRating,
                DealsOnCalendar: dealsNumber,
                DealsMiss: dealsMiss
            });
        };
        DealsBoxService.prototype.trackDateChange = function (newDeal, oldDeal) {
            if (!oldDeal || !oldDeal.Price) {
                return;
            }
            var dow = this.$filter('date')(newDeal.HotelDeal.CheckInDate, 'EEE');
            var delta = newDeal.Price - oldDeal.Price;
            this.analytics.track('mixpanel', 'HolidayDealsChangedDate', {
                DayOfWeek: dow,
                Delta: delta
            });
        };
        DealsBoxService.prototype.trackDealEdit = function (type) {
            if (!this.singleEditTrack[type]) {
                this.analytics.track('mixpanel', "HolidayDealsChanged" + type);
                this.singleEditTrack[type] = true;
            }
        };
        DealsBoxService.prototype._findSelected = function (deals, preselected) {
            var cheapest;
            for (var i = 0, ii = deals.length; i < ii; i++) {
                // pick perfect selection
                if (preselected && deals[i].DepartureEpoch === preselected.DepartureEpoch) {
                    return deals[i];
                }
                // pick absolute cheapest in the grid
                if (!cheapest || deals[i].Price < cheapest.Price) {
                    cheapest = deals[i];
                }
            }
            return cheapest;
        };
        DealsBoxService.prototype._sortRoomsByPrice = function (rooms) {
            for (var i = 0, ii = rooms.length; i < ii; i++) {
                var r = rooms[i];
                r.BoardOptions = _.sortBy(r.BoardOptions, function (b) { return b.Cost; });
                r.MinCost = r.BoardOptions[0].Cost;
            }
            return _.sortBy(rooms, function (r) { return r.MinCost; });
        };
        DealsBoxService.prototype._pickBestRoom = function (rooms, boardTypes, oldRoom, oldBt, persist) {
            var pRoom;
            var pBoardType;
            if (persist) {
                var persisted = this._persistSelection(rooms, oldRoom, oldBt);
                pRoom = persisted.pRoom;
                pBoardType = persisted.pBoardType;
            }
            if ((!boardTypes || !boardTypes.length) || (pRoom && pBoardType)) {
                return { room: pRoom || rooms[0], bt: pBoardType || rooms[0].BoardOptions[0] };
            }
            var bestSelection;
            for (var i = 0, ii = rooms.length; i < ii; i++) {
                var room = rooms[i];
                for (var j = 0, jj = room.BoardOptions.length; j < jj; j++) {
                    var bt = room.BoardOptions[j];
                    if (boardTypes.indexOf(bt.BoardType) > -1) {
                        if (!bestSelection || bestSelection.bt.Cost > bt.Cost) {
                            bestSelection = { room: pRoom || room, bt: bt };
                        }
                    }
                }
            }
            return bestSelection;
        };
        DealsBoxService.prototype._persistSelection = function (rooms, oldRoom, oldBt) {
            var pRoom = oldRoom
                ? _.find(rooms, function (r) { return r.MasterId === oldRoom; })
                : undefined;
            var pBoardType;
            if (pRoom) {
                pBoardType = _.find(pRoom.BoardOptions, function (bt) { return bt.BoardType === oldBt; });
            }
            return { pRoom: pRoom, pBoardType: pBoardType };
        };
        DealsBoxService.prototype._calcDifference = function (priceToCompare, currentPrice, priceMode) {
            var diff = priceToCompare - currentPrice;
            if (priceMode === 0) {
                diff = diff / this.occupancyService.getNumberOfNonInfantPassengers();
            }
            var label = this.$filter('roundedCurrency')(Math.abs(diff));
            return { diff: diff, label: label };
        };
        return DealsBoxService;
    }());
    TR.DealsBoxService = DealsBoxService;
    angular
        .module('TR')
        .service('dealsBoxService', DealsBoxService);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular.module('TR')
        .service('destinationService', destinationService);
    function destinationService(loggingService, objectTypeService, pageStrand, fieldFilterParser, $http, $location, $q, broker, imageService, supportedProducts, currentUser, preferences, resourceService, $cacheFactory, rootPath, fidParser) {
        var url = TRPCONFIG.DestinationServiceClientDomain + "/api2/destination/v2/";
        var cultureCode = TRPCONFIG.Domain.CultureCode;
        var strands = {
            hotel: 1,
            holiday: 2
        };
        var tiles = [];
        var textUrl = "" + TRPCONFIG.DestinationServiceClientDomain + rootPath.getRootPath() + "website/destinations/text?";
        var tileUrl = TRPCONFIG.DestinationServiceClientDomain + "/api2/destination/tiles/";
        var tileImageUrl = TRPCONFIG.DestinationImagesClientDomain + "/api2/destination/images/";
        var websiteUrl = 'website/destinations/';
        var airportCache = $cacheFactory.get('airports') || $cacheFactory('airports');
        var service = {
            country: 0,
            estab: 1,
            region: 2,
            getDetails: getDetails,
            getTopChildren: getTopChildren,
            getAllChildren: getAllChildren,
            fromUrl: fromUrl,
            destinationIsEstab: destinationIsEstab,
            destinationIsCountry: destinationIsCountry,
            destinationThumb: destinationThumb,
            getDestinationType: getDestinationType,
            getBreadcrumbTitle: getBreadcrumbTitle,
            isHoliday: isHoliday,
            getText: getText,
            getAirport: getAirport,
            getAirportDestination: getAirportDestination,
            getHeroImage: getHeroImage,
            getTiles: getTiles,
            //getTileImageUrl : getTileImageUrl,
            sortByTitle: sortByTitle,
            getCountries: getCountries,
            enhanceDestinationFromPreferences: enhanceDestinationFromPreferences,
            // isLongHaul,
            enhanceLegacyDestination: enhanceLegacyDestination,
            setFidFromDestinationFilter: setFidFromDestinationFilter,
            getAllCountries: getAllCountries,
            getDestinationInfo: getDestinationInfo,
            rootPath: rootPath
        };
        var detailsSearch = {};
        function setFidFromDestinationFilter(destination) {
            var fid = fidParser.parse();
            if (destination.FilterId !== fid) {
                $location.replace();
                $location.search('fid', null);
                if (destination.FilterId > 0) {
                    if (destination.LegacyType !== 1 && !TRPCONFIG.Domain.UseIdBasedUrls) {
                        $location.search('fid', destination.FilterId);
                    }
                    else if (destination.LegacyType === 1) {
                        $location.search('fid', destination.FilterId);
                    }
                }
            }
            return destination;
        }
        function enhanceLegacyDestination(destination) {
            var type = parseInt(destination.LegacyType) || parseInt(destination.Type);
            var id = destination.LegacyId || destination.Id;
            return $q.when({
                PageStrand: destination.PageStrand,
                Type: type,
                Id: id,
                EstablishmentId: type === 1 ? id : 0,
                LocationId: type === 2 ? id : 0,
                ProvinceId: type === 3 ? id : 0,
                CountryId: type === 4 ? id : 0,
                PlaceId: type === 5 ? id : 0,
                PolygonId: type === 10 ? id : 0,
                DestinationId: destination.DestinationId
            });
        }
        function sortByTitle(dests) {
            return _.sortBy(dests, 'Title');
        }
        function getText(dest, errorHandler) {
            var fid = fidParser.parse();
            errorHandler = errorHandler || { ignoreErrors: true };
            errorHandler.cache = true;
            return $http.get(textUrl + $.param({
                ObjectTypeId: objectTypeService.get(dest),
                FilterId: fid || 0,
                PageStrandId: dest.PageStrand,
                DomainId: TRPCONFIG.Domain.DomainId,
                Path: dest.PagePath,
                IsPreview: (dest.IsPreview !== undefined && dest.IsPreview === true),
                v: TRPCONFIG.CurrentVersion
            }), errorHandler).then(function (result) {
                result.data.PageTitle = resourceService.getDeferred(result.data.PageTitle)();
                return result.data;
            });
        }
        function getTiles(req) {
            if (tiles[req.ControlId]) {
                return tiles[req.ControlId];
            }
            tiles[req.ControlId] = $http.get(tileUrl + "get?" + $.param({
                DomainId: TRPCONFIG.Domain.DomainId,
                ControlId: req.ControlId
            }), { cache: true, ignoreErrors: true }).then(function (result) {
                var tiles = result.data;
                var baseImageReq = _.constant({
                    Height: 600,
                    Width: 600
                });
                return tiles.map(function (tile) {
                    var infoTile = _.flowRight(JSON.parse, JSON.parse, JSON.stringify)(tile.TitlePattern);
                    infoTile.ImageUrl = getTileImageUrl(_.assignIn(baseImageReq(), {
                        ObjectId: tile.ObjectId,
                        ObjectTypeId: tile.ObjectTypeId
                    }));
                    infoTile.mainUrl = infoTile.ImageUrl;
                    infoTile.thumbUrl = infoTile.ImageUrl;
                    return infoTile;
                });
            });
            function getTileImageUrl(req) {
                return tileImageUrl + "gettileimage?" + $.param(req);
            }
            return tiles[req.ControlId];
        }
        function isHoliday(dest) {
            return dest && dest.PageStrand != null && dest.PageStrand === strands.holiday;
        }
        function getDestinationType(dest) {
            if (dest == null) {
                return service.region;
            }
            if (destinationIsCountry(dest)) {
                return service.country;
            }
            if (destinationIsEstab(dest)) {
                return service.estab;
            }
            return service.region;
        }
        function logWarning(apiName, err, params) {
            var utm = currentUser.get().UtmId;
            loggingService.logWarn("Got back err: " + err.status + " for utm " + utm + " and userAgent " + navigator.userAgent + " for api " + apiName + " with params " + params);
        }
        function fromUrl(from, tm) {
            return $http.get(url + "fromurlv2?" + $.param({
                PagePath: from,
                DomainId: TRPCONFIG.Domain.DomainId,
                v: TRPCONFIG.CurrentVersion
            }), { cache: true, ignoreErrors: true }).then(function (result) {
                if (result.data && tm === '1') {
                    result.data.PageStrand = 2;
                }
                if (result.data && result.data.PageStrand > 1 && !supportedProducts.isProductSupported(supportedProducts.products.holidays)) {
                    result.data.PageStrand = 1;
                }
                return result.data;
            }, function (err) {
                logWarning('fromUrl', err, from);
                return null;
            });
        }
        function getDestinationInfo(id, type, pagestrand) {
            return $http.get(url + "getdetailsv2?" + $.param({
                CultureCode: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                PageStrand: pagestrand,
                Id: id,
                Type: type
            })).then((function (result) { return result.data; }), (function (err) {
                logWarning('getdetailsv2', err);
                return null;
            }));
        }
        function destinationIsEstab(dest) {
            if (dest == null) {
                return false;
            }
            return dest.EstablishmentId > 0;
        }
        function destinationIsCountry(dest) {
            if (dest == null) {
                return false;
            }
            if (dest.Searchable) {
                return false;
            }
            if (dest.PolygonId > 0 &&
                dest.TagIds &&
                dest.TagIds.indexOf(1) >= 0) {
                return true;
            }
            return dest.CountryId > 0 &&
                dest.ProvinceId === 0 &&
                dest.LocationId === 0 &&
                dest.PlaceId === 0 &&
                dest.PolygonId === 0;
        }
        function destinationThumb(dest) {
            var objectTypeAndId = objectTypeService.getObjectTypeAndId(dest);
            return tileImageUrl + "getfromobject?" + $.param(_.assignIn({
                height: 190
            }, objectTypeAndId), { cache: true, ignoreErrors: true });
        }
        function getTopChildren(n, d) {
            var fid = fidParser.parse();
            return $http.get(url + "gettopchildren?" + $.param({
                CountryId: d.CountryId,
                ProvinceId: d.ProvinceId,
                LocationId: d.LocationId,
                PlaceId: d.PlaceId,
                EstablishmentId: d.EstablishmentId,
                PolygonId: d.PolygonId,
                Count: n,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                FilterId: fid || 0,
                PageStrand: d.PageStrand,
                v: TRPCONFIG.CurrentVersion
            }), { cache: true, ignoreErrors: true }).then(function (result) {
                // Publish topic with data
                broker.publish('destTopChildrenRetrieved', result.data);
                return result.data;
            });
        }
        function getAllChildren(d) {
            return $http.get(url + "getallchildren?" + $.param(childRequest(d)), { cache: true, ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        function childRequest(d) {
            var fid = fidParser.parse();
            return _.assignIn(objectTypeService.getObjectTypeAndId(d), {
                CultureCode: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                FilterId: fid || 0,
                PageStrand: d.PageStrand,
                v: TRPCONFIG.CurrentVersion
            });
        }
        function getAllCountries() {
            return $http.get(url + "getallchildren?" + $.param({ CultureCode: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                PageStrand: 2,
                Type: 12 }), { cache: true, ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        function getBreadcrumbTitle(dest, comparatorFn) {
            // `comparatorFn` example: `(bc) => bc.ObjectTypeId === 1`
            var bcTrail = dest && dest.BreadcrumbTrail;
            var i = bcTrail && bcTrail.length;
            while (i--) {
                var bc = dest.BreadcrumbTrail[i];
                if (comparatorFn(bc)) {
                    return bc.Title;
                }
            }
        }
        function getCountryOwnId(dest) {
            var bcTrail = dest && dest.BreadcrumbTrail;
            var i = bcTrail && bcTrail.length;
            if (i > 0) {
                return dest.BreadcrumbTrail[0].ObjectId;
            }
        }
        function getDetails(dest, fieldsFilter, options) {
            if (_.isEmpty(dest)) {
                return $q.when();
            }
            var _isAirport = isAirport(dest);
            var get = function (isAirport) { return isAirport ? getDetailsForAirport(dest) : getDetailsForDestination(dest, fieldsFilter, options); };
            return $q.when()
                .then(function () { return get(_isAirport); })
                .then(function (result) { return result || get(!_isAirport); });
        }
        function getDetailsForDestination(dest, fieldsFilter, options) {
            var d = _.assign({}, dest);
            options = options || {};
            if (!d.Type) {
                angular.extend(d, objectTypeService.getObjectTypeAndId(d));
            }
            // eslint-disable-next-line
            if (d.Type == 1 && d.Id && !d.EstablishmentId) {
                d.EstablishmentId = d.Id;
            }
            var ps = options.pageStrandOverride || pageStrand.fromRoute(d);
            var fid = fidParser.parse();
            var params = $.param({
                Type: d.Type,
                Id: d.Id,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                IncludeBreadcrumb: true,
                PageStrand: ps,
                v: TRPCONFIG.CurrentVersion,
                domainId: TRPCONFIG.Domain.DomainId,
                auth: currentUser.get().HardSignedIn,
                filterId: fid || 0
            });
            var filter = fieldFilterParser.parse(fieldsFilter);
            if (filter != null) {
                params += "&" + filter;
            }
            var key = websiteUrl + "getdetails?" + params;
            if (!_.isUndefined(detailsSearch[key])) {
                return detailsSearch[key];
            }
            detailsSearch[key] = $http.get(key, { cache: true, ignoreErrors: true }).then(function (result) {
                if (result.data == null) {
                    return null;
                }
                d.HolidayEnabled = result.data.HolidayEnabled;
                d.Searchable = result.data.Searchable;
                d.BreadcrumbTrail = result.data.BreadcrumbTrail;
                d.Title = result.data.Title;
                // Last non-hotel breadcrumb text
                d.SummaryTitle = getBreadcrumbTitle(d, function (bc) { return bc.ObjectTypeId !== strands.hotel; }) || d.Title;
                // Hotel name, or `SummaryTitle`
                d.ShortTitle = getBreadcrumbTitle(d, function (bc) { return bc.ObjectTypeId === strands.hotel; }) || d.SummaryTitle;
                d.CountryOwnId = getCountryOwnId(d) || 0;
                d.DestinationAirports = result.data.DestinationAirports;
                d.AirportCount = result.data.AirportCount;
                d.HotelCount = result.data.HotelCount;
                d.Longitude = result.data.Longitude;
                d.Latitude = result.data.Latitude;
                d.ZoomLevel = result.data.ZoomLevel;
                d.IsPOI = result.data.IsPOI;
                d.PagePath = result.data.PagePath;
                d.TagIds = result.data.TagIds;
                d.Price = result.data.Price;
                d.PromoText = result.data.PromoText;
                d.Airports = result.data.Airports;
                d.PageStrand = ps;
                return d;
            }, function (err) {
                logWarning('getDetails', err, key);
                return null;
            });
            return detailsSearch[key];
        }
        function getDetailsForAirport(dest) {
            var d = _.assign({}, dest);
            var airportKey = $.param(d);
            if (!_.isUndefined(detailsSearch[airportKey])) {
                return detailsSearch[airportKey];
            }
            function getAirportCode() {
                var airportCode = d.Code && d.Code.split(',')[0];
                if (airportCode) {
                    return $q.when(airportCode);
                }
                var params = d.PolygonId ? { id: d.PolygonId, type: 10 } : { id: d.Id, type: d.Type };
                var url = TRPCONFIG.DestinationServiceClientDomain + "/api/landingpages/destinations/airports?" + $.param(params);
                return $http.get(url, { cache: true, ignoreErrors: true }).then(function (result) {
                    var airports = result.data;
                    if (airports && airports[0]) {
                        d.Code = _(airports).map(function (a) { return a.Code; }).reduce(function (memo, a) { return memo + "," + a; });
                        return airports[0].Code;
                    }
                }, function (err) {
                    logWarning('airports', err, url);
                    return $q.when(airportCode);
                });
            }
            function getDestinationIds(airportCode) {
                if (angular.isNumber(d.PolygonId) || !/^[a-zA-Z]{3}$/.test(airportCode)) {
                    return $q.when();
                }
                var params = $.param({
                    airportCode: airportCode
                });
                var url = TRPCONFIG.DestinationServiceClientDomain + "/api2/destination/airports/getdestinationservedbyairport?" + params;
                return $http.get(url, { cache: true, ignoreErrors: true }).then(function (result) {
                    if (result.data == null) {
                        return null;
                    }
                    d.CountryId = result.data.CountryId;
                    d.ProvinceId = result.data.ProvinceId;
                    d.LocationId = result.data.LocationId;
                    d.PlaceId = result.data.PlaceId;
                    d.EstablishmentId = result.data.EstablishmentId;
                    d.PolygonId = result.data.PolygonId;
                }, function (err) {
                    logWarning('getdestinationservedbyairport', err, url);
                    return $q.when();
                });
            }
            return getAirportCode()
                .then(function (airportCode) { return getDestinationIds(airportCode); })
                .then(function () { return service.enhanceDestinationFromPreferences(d); })
                .then(function () {
                var code = shorten(d.Code, ',');
                if (!d.Title && code) {
                    return getAirport(code).then(function (airport) {
                        if (airport) {
                            d.Title = shorten(airport.Title, '(');
                            d.ShortTitle = shorten(airport.ShortTitle, '(');
                        }
                    });
                }
            })
                .then(function () {
                d.Title = d.Title || d.ShortTitle || d.SummaryTitle || d.Code || '';
                d.ShortTitle = d.ShortTitle || d.SummaryTitle || shorten(d.Title, ',');
                d.SummaryTitle = d.SummaryTitle || d.ShortTitle;
                d.HolidayEnabled = true; //Because this is a flight search, all destinations will be near an airport.
                d.Searchable = true;
                d.AirportCount = d.Code && d.Code.split(',').length;
                d.BreadcrumbTrail = [{
                        Title: d.Title,
                        //PagePath: '/holidays/gatwick-airport-lgw-west-sussex-united-kingdom.html',
                        ObjectId: d.PolygonId,
                        ObjectTypeId: 10
                    }];
                angular.extend(d, objectTypeService.getObjectTypeAndId(d));
                return d;
            });
        }
        function isAirport(d) {
            var isAirport;
            if (d.searchLookupType) {
                isAirport = d.searchLookupType === 'flights';
            }
            else if (d.PageStrand) {
                isAirport = false;
            }
            else if (d.Code) {
                isAirport = !angular.isNumber(d.PolygonId) || d.PolygonId > 0;
            }
            else {
                isAirport = false;
            }
            return isAirport;
        }
        function shorten(title, separator) {
            return (title || '').split(separator)[0];
        }
        function enhanceDestinationFromPreferences(destination) {
            objectTypeService.populateObjectTypeAndId(destination);
            return preferences.get('search').then(function (preferences) {
                var preferencesDest = preferences && preferences.destination && preferences.destination[0];
                if (preferencesDest && preferencesDest.Id && preferencesDest.Id === destination.Id) {
                    _.forEach(['Title', 'Code', 'ShortTitle', 'SummaryTitle', 'icon', 'searchLookupType', 'AirportCount'], function (key) {
                        if (typeof preferencesDest[key] !== undefined) {
                            destination[key] = preferencesDest[key];
                        }
                    });
                }
                return destination;
            });
        }
        function getAirport(airportCode) {
            var k = airportCode + "_" + TRPCONFIG.Domain.CultureCode;
            if (!airportCache.get(k)) {
                airportCache.put(k, $http.post('/api2/flights/static/getairport', {
                    AirportCode: airportCode,
                    CultureCode: TRPCONFIG.Domain.CultureCode
                }, {
                    ignoreErrors: true
                })
                    .then(function (result) { return result.data.Airport; }, angular.noop));
            }
            return airportCache.get(k);
        }
        function getAirportDestination(airportCode) {
            var params = {
                airportCode: airportCode,
                cultureCode: TRPCONFIG.Domain.CultureCode
            };
            return $http.get("/api2/destination/airports/getairportlocation?" + $.param(params), { ignoreErrors: true }).then(function (result) {
                return result.data;
            });
        }
        function getHeroImage(destination) {
            return imageService.getLandingPageImage(destination);
        }
        function getCountries() {
            return $http.get("/api2/destination/countries/get?CultureCode=" + cultureCode, { cache: true, ignoreErrors: true }).then(function (res) {
                return res.data;
            });
        }
        // function isLongHaul(destination) {
        //     return _.includes(destination && destination.TagIds, 12)
        //         ? $q.when(true)
        //         : $http.get(`/api/destinations/${destination.Id}/ancestors?${$.param({
        //             tenantId: TRPCONFIG.Domain.TenantId,
        //             pointOfSaleId: TRPCONFIG.Domain.PointOfSaleId,
        //             culture: TRPCONFIG.Domain.CultureCode,
        //             fields: 'Tags'
        //         })}`, { cache: true }).then(result =>
        //             _.chain(result.data)
        //                 .flatMap(ancestor => ancestor.Tags)
        //                 .includes(12)
        //                 .value());
        // }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('destinationContent', destinationContent);
    function destinationContent($http, pageStrand, objectTypeService, fidParser) {
        var url = '/api2/destination/content?';
        var service = {
            get: get
        };
        function get(destination) {
            var _a = objectTypeService.getObjectTypeAndId(destination), Type = _a.Type, Id = _a.Id;
            return $http.get(url + $.param({
                Id: Id,
                Type: Type,
                FilterId: fidParser.parse() || 0,
                DomainId: TRPCONFIG.Domain.DomainId,
                ApplicationType: TRPCONFIG.ApplicationType,
                TenantId: TRPCONFIG.Domain.TenantId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                PageStrand: pageStrand.fromRoute(destination)
            }), { cache: true, ignoreErrors: true }).then(function (res) {
                return res.data.Contents;
            });
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var Friend = /** @class */ (function () {
        function Friend() {
            this.Name = '';
            this.Email = '';
        }
        return Friend;
    }());
    TR.Friend = Friend;
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .factory('ecommerceService', ecommerceService);
    function ecommerceService(tripService, basketStore, attractionService, carHireService, $q, loaderService, $window, cookieService, $http) {
        var productType = {
            0: function getHotelInfo(transactionId, hotel) {
                if (hotel && hotel.Details) {
                    var hotelDetails = hotel.Details;
                    var hotelInfo = {
                        id: transactionId,
                        category: 'Accommodation',
                        name: hotelDetails.EstablishmentId,
                        price: basketStore.sumCosts(hotel.CostBreakdown),
                        quantity: 1,
                        sku: hotelDetails.ProvinceTitle
                    };
                    return $q.when([hotelInfo]);
                }
                return $q.when(null);
            },
            1: function getFlightInfo(transactionId, flight) {
                if (flight && flight.Details) {
                    var flightLeg = flight.Details.Itinerary.Legs[0];
                    var segmentInfo = flightLeg.Segments[0];
                    var flightInfo = {
                        id: transactionId,
                        category: 'Flight',
                        name: segmentInfo.CarrierName,
                        price: basketStore.sumCosts(flight.CostBreakdown),
                        quantity: 1,
                        sku: segmentInfo.DestinationAirportTitle
                    };
                    return $q.when([flightInfo]);
                }
                return $q.when(null);
            },
            2: function getTransferInfo(transactionId, transfer) {
                if (transfer && transfer.Details) {
                    var transferDetails = transfer.Details;
                    var transferInfo = {
                        id: transactionId,
                        category: 'Transfer',
                        name: transferDetails.TransferId.SupplierId,
                        price: basketStore.sumCosts(transfer.CostBreakdown),
                        quantity: 1,
                        sku: (transferDetails.Itinerary.OutboundLeg || transferDetails.Itinerary.InboundLeg).DeparturePoint
                    };
                    return $q.when([transferInfo]);
                }
                return $q.when(null);
            },
            3: function getParkingInfo(transactionId, parking) {
                if (parking && parking.Details) {
                    var parkingDetails = parking.Details;
                    var parkingInfo = {
                        id: transactionId,
                        category: 'Parking',
                        name: parkingDetails.AirportParkingQuoteId.SupplierId,
                        price: basketStore.sumCosts(parking.CostBreakdown),
                        quantity: 1,
                        sku: parkingDetails.AirportParkingQuoteId.CarParkCode
                    };
                    return $q.when([parkingInfo]);
                }
                return $q.when(null);
            },
            4: function getAttractionInfo(transactionId, attraction, flight) {
                if (attraction && attraction.Details && flight && flight.Details) {
                    var flightLeg = flight.Details.Itinerary.Legs[0];
                    var segmentInfo = flightLeg.Segments[0];
                    var sku_1 = segmentInfo.DestinationAirportTitle;
                    var attractionDetails_1 = attraction.Details;
                    var attractionInfo_1 = {
                        id: transactionId,
                        category: 'Attractions',
                        price: basketStore.sumCosts(attraction.CostBreakdown),
                        quantity: 1
                    };
                    return attractionService.getAttractionQuotesFromSession(attraction.AvailabilitySearchId).then(function (attractions) {
                        var attractionBreakdown = _.map(attractionDetails_1.AttractionIds, function (element, index) {
                            var cost = attraction.CostBreakdown[index];
                            var price = basketStore.sumCosts([cost]);
                            var res = _.findIndex(attractions, function (a) { return a.AttractionId === element; });
                            if (res >= 0) {
                                var attr = attractions[res];
                                return _.assignIn({}, attractionInfo_1, { name: attr.ShortTitle, sku: sku_1, price: price });
                            }
                            return $q.when(null);
                        });
                        return $q.when(attractionBreakdown);
                    });
                }
                return $q.when(null);
            },
            5: function getCarHireInfo(transactionId, carHire) {
                if (carHire && carHire.Details) {
                    var carHireDetails_1 = carHire.Details;
                    var carHireInfo_1 = {
                        id: transactionId,
                        category: 'Car Hire',
                        price: basketStore.sumCosts(carHire.CostBreakdown),
                        quantity: 1,
                        sku: carHireDetails_1.HireDetails.PickUpPoint
                    };
                    return carHireService.getCarQuotesFromSession(carHire.AvailabilitySearchId).then(function (carhire) {
                        var hireProvider = _.filter(carhire, function (elem) { return elem.CarHireId.CarHireCode === carHireDetails_1.CarHireId.CarHireCode; });
                        carHireInfo_1 = _.assignIn({}, carHireInfo_1, {
                            name: hireProvider[0].SupplierName
                        });
                        return $q.when(carHireInfo_1);
                    });
                }
                return $q.when(null);
            },
            6: function getMarhabaInfo(transactionId, marhaba) {
                if (marhaba && marhaba.CostBreakdown) {
                    var marhabaInfo = {
                        id: transactionId,
                        category: 'Marhaba',
                        price: basketStore.sumCosts(marhaba.CostBreakdown),
                        quantity: 1,
                        name: 'Marhaba',
                        sku: 'Marhaba'
                    };
                    return $q.when(marhabaInfo);
                }
                return $q.when(null);
            },
            7: function getInsuranceInfo(transactionId, insurance) {
                if (insurance && insurance.CostBreakdown) {
                    var insuranceInfo = {
                        id: transactionId,
                        category: 'Insurance',
                        price: basketStore.sumCosts(insurance.CostBreakdown),
                        quantity: 1,
                        name: 'Insurance',
                        sku: 'Insurance'
                    };
                    return $q.when(insuranceInfo);
                }
                return $q.when(null);
            }
        };
        var basketData = {};
        function pushBasket(tripId, baskets, totalCost, bookingRefs) {
            if (TRPCONFIG.Domain.TripAdvisorTrackingPixelEnabled && TRPCONFIG.Domain.TripAdvisorPartnerId !== '') {
                var taid = cookieService.get('tripadvisor_referral');
                if (taid && taid.length === 24) {
                    basketData.tripAdvisor = {
                        totalCost: totalCost,
                        bookingRefs: bookingRefs,
                        taid: taid
                    };
                    loaderService.loadJS($window.document, 'script', 'tripAdvisor', '//static.tacdn.com/js3/taevents-c.js', false, onScriptLoaded);
                }
            }
            if (_tagManagerEnabled()) {
                return _pushGABasket(tripId, baskets, totalCost);
            }
            return $q.when();
        }
        function onScriptLoaded() {
            switch (this.id) {
                case 'tripAdvisor':
                    _pushTripAdvisorBasket(basketData.tripAdvisor);
                    break;
            }
        }
        function _pushTripAdvisorBasket(data) {
            if (!data.totalCost || !data.bookingRefs || !data.taid) {
                return false;
            }
            var bookingReferences = (data.bookingRefs || []).join('|');
            var _taq = window.taq;
            var track = {
                partner: TRPCONFIG.Domain.TripAdvisorPartnerId,
                refid: data.taid,
                gbv: parseFloat(data.totalCost) * 100,
                bbv: parseFloat(data.totalCost) * 100,
                currency: TRPCONFIG.Domain.CurrencyCode,
                currency_format: 0,
                order_id: bookingReferences,
                is_app: TRPCONFIG.Domain.DeviceType === 'Desktop' ? 0 : 1 // eslint-disable-line
            };
            _taq('init', TRPCONFIG.Domain.TripAdvisorPixelId);
            _taq('track', 'BOOKING_CONFIRMATION', track);
            _clearCookie('tripadvisor_referral');
        }
        function _clearCookie(key) {
            var h = window.location.hostname;
            var cookieDomain = h.slice(h.indexOf('.'));
            cookieService.set(key, '', (new Date()).toUTCString(), cookieDomain);
        }
        function _pushGABasket(tripId, baskets, totalCost) {
            return addTransaction(tripId, "" + totalCost, "" + 0).then(function (transaction) {
                var basketInfo = _.map(_.omit(baskets, 'all'), function (b) {
                    var entries = _.flatten([b]); // Normalise single entries and arrays
                    for (var i = 0, len = entries.length; i < len; i++) {
                        var basket = entries[i];
                        if (basket == null) {
                            return $q.when(null);
                        }
                        var product = productType[basket.ProductType];
                        var info = product != null ? product(transaction.transactionId, basket, baskets.f) : null;
                        if (info == null) {
                            return $q.when(null);
                        }
                        return info
                            .then(function (result) { return result; })
                            .catch(function () { return null; });
                    }
                });
                return $q.all(basketInfo).then(function (basketResult) {
                    var output = _.reduce(basketResult, function (memo, elem) {
                        if (elem) {
                            return memo.concat(elem);
                        }
                        return memo;
                    }, []);
                    return tripService.getCurrency(tripId).then(function (currency) {
                        _.forEach(output, function (item) {
                            var _a = TRPCONFIG.SelectedRegionalContext ? TRPCONFIG.SelectedRegionalContext : { CountryCode: null, Language: null }, CountryCode = _a.CountryCode, Language = _a.Language;
                            var newItem = addItem(item.id, "" + item.name, "" + item.sku, "" + item.category, "" + item.price, "" + item.quantity, "" + currency, CountryCode, Language);
                            transaction.transactionProducts.push(newItem);
                        });
                        if (!TRPCONFIG.Domain2.NewTransactionTracking) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(transaction);
                        }
                        // Create rollup transaction
                        var transactionRollup = JSON.parse(JSON.stringify(transaction));
                        transactionRollup.event = 'pushTransactionRollup';
                        if (transaction.transactionCurrency !== 'AED' && TRPCONFIG.Domain.EnableAnalyticsCurrencyConversion === true) {
                            updateTransactionAed(transactionRollup);
                        }
                        else if (!TRPCONFIG.Domain2.NewTransactionTracking) {
                            window.dataLayer.push(transactionRollup);
                        }
                    });
                });
            });
        }
        function updateTransactionAed(t) {
            getExchangeRate(t.transactionCurrency, 'AED').then(function (rate) {
                t.transactionTotal = calCurrency(t.transactionTotal, rate);
                t.transactionCurrency = 'AED';
                for (var i = 0; i < t.transactionProducts.length; i++) {
                    t.transactionProducts[i].currency = 'AED';
                    t.transactionProducts[i].price = calCurrency(t.transactionProducts[i].price, rate);
                }
                window.dataLayer.push(t);
            });
        }
        function calCurrency(val, rate) {
            var x = parseInt(val);
            var convertedTotal = x * rate.data;
            return convertedTotal.toFixed(2);
        }
        function getExchangeRate(from, to) {
            return $http.get("/api2/fxrates/get?request.currencyFrom=" + from + "&request.currencyTo=" + to + "&request.futureMonth=0");
        }
        function addTransaction(transactionId, transactionTotal, transactionTax, transactionAffiliation) {
            transactionAffiliation = transactionAffiliation || TRPCONFIG.Domain.DomainId;
            return tripService.getCurrency(transactionId).then(function (transactionCurrency) {
                var transaction = {
                    event: 'pushTransaction',
                    transactionId: transactionId,
                    transactionAffiliation: transactionAffiliation,
                    transactionTotal: transactionTotal,
                    transactionTax: transactionTax,
                    transactionCurrency: transactionCurrency,
                    transactionProducts: []
                };
                return transaction;
            });
        }
        function addItem(id, name, sku, category, price, quantity, currency, dimension1, dimension2) {
            var item = {
                id: id,
                name: name,
                sku: sku,
                category: category,
                price: price,
                quantity: quantity,
                currency: currency,
                dimension1: dimension1,
                dimension2: dimension2
            };
            return item;
        }
        var service = {
            addTransaction: addTransaction,
            addItem: addItem,
            pushBasket: pushBasket
        };
        function _tagManagerEnabled() {
            return !!TRPCONFIG.Domain.GoogleTagManagerEnabled;
        }
        var noop = function () { return $q.when(); };
        if (!_tagManagerEnabled()) {
            for (var func in service) {
                service[func] = noop;
            }
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .config(config);
    function config($provide, $httpProvider) {
        $provide.factory('errInterceptor', errInterceptor);
        errInterceptor.$inject = ['$location', '$q', 'commonErrors'];
        function errInterceptor($location, $q, commonErrors) {
            var _errCallbacksCollection = {};
            var googlebot = /googlebot/i.test(navigator.userAgent);
            var prerender = /prerender/i.test(navigator.userAgent);
            var _counter = 0;
            var service = {
                addErrCallback: addErrCallback,
                responseError: responseError
            };
            function logError(data) {
                if (googlebot || prerender) {
                    return;
                }
                var utm = JSON.parse($('body').attr('user')).UtmId;
                $.ajax({
                    type: 'POST',
                    url: 'website/logging/log',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        Message: "Customer ended up on the error page with error: " + JSON.stringify({
                            utmId: utm,
                            userAgent: navigator.userAgent,
                            status: data.status,
                            url: data.config.url,
                            data: data.config.data
                        }),
                        LogLevel: 1 // Warning
                    })
                });
            }
            // Basic error handling
            function _defaultError(data) {
                if (data.status === -1) {
                    return;
                }
                $location.replace();
                // $location.path('error');
                logError(data);
            }
            // Retrieves submitted custom callback
            function _getCustomCallback(headers) {
                var _callbackName = headers['x-callback'] || '';
                return _errCallbacksCollection[_callbackName];
            }
            // Tries to invoke custom callback
            function _invokeCustomCallback(data) {
                if (!data.config) {
                    return false;
                }
                var _errCallback = _getCustomCallback(data.config.headers);
                // no custom callback available
                if (!_errCallback || data.status === 401) {
                    return false;
                }
                // dealing with partial callbacks
                if (typeof _errCallback === 'object') {
                    if (!_errCallback[data.status]) {
                        return false;
                    }
                    _errCallback[data.status](data);
                }
                else if (typeof _errCallback === 'function') {
                    // dealing with full callbacks
                    _errCallback(data);
                }
                else {
                    // dealing with weird things
                    return false;
                }
                return true;
            }
            function addErrCallback(cb) {
                _errCallbacksCollection[++_counter] = cb;
                return _counter;
            }
            var callbacksHandled = {};
            function responseError(data) {
                //a hack to make sure that we don't handle the same error twice which can happen with the retry interceptor
                if (callbacksHandled[data.config.headers['x-callback']]) {
                    return $q.reject(data);
                }
                callbacksHandled[data.config.headers['x-callback']] = true;
                if (!_invokeCustomCallback(data)) {
                    // common error handling
                    (commonErrors[data.status] || _defaultError)(data);
                }
                return $q.reject(data);
            }
            return service;
        }
        if ($httpProvider.interceptors.indexOf('errInterceptor') < 0) {
            $httpProvider.interceptors.unshift('errInterceptor');
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .factory('$exceptionHandler', $exceptionHandler);
    function $exceptionHandler(broker, $log, $window, currentUser) {
        var ie9 = /msie 9.0/i.test(navigator.userAgent);
        var success = function () {
            // do nothing
        };
        var skipErrorsLogging = false;
        var digestErrors = 0;
        var errorQueue = [];
        $window.addEventListener('beforeunload', function () {
            skipErrorsLogging = true;
        });
        function error(err, type, msg) {
            errorQueue = []; //clear the queue if there is a problem - we don't want to kill the client
            $log.warn('Error logging failed');
            $log.log(msg || err);
        }
        (function tick() {
            if (errorQueue.length !== 0) {
                //de-dupe into a dictionary
                var errorDict_1 = {};
                var deduped_1 = [];
                errorQueue.forEach(function (err) {
                    if (errorDict_1[err.errorMessage] == null) {
                        err.count = 0;
                        errorDict_1[err.errorMessage] = err;
                    }
                    errorDict_1[err.errorMessage].count += 1;
                });
                //convert back to an array
                Object.keys(errorDict_1).forEach(function (msg) {
                    deduped_1.push(errorDict_1[msg]);
                });
                try {
                    $.ajax({
                        type: 'POST',
                        url: 'website/logging/logbatch',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            Messages: deduped_1.map(function (err) { return JSON.stringify(err); }),
                            LogLevel: ie9 ? 2 : 1 //warn for ie9, otherwise error
                        }),
                        success: success,
                        error: error
                    });
                    errorQueue = [];
                }
                catch (loggingError) {
                    error(loggingError);
                }
            }
            setTimeout(tick, 2000);
        })();
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var exception = args[0];
            var cause = args[1];
            $log.error.apply($log, args);
            broker.publish('unblock');
            if (TRPCONFIG.IsBot) {
                return;
            }
            try {
                var stackTrace = printStackTrace({ e: exception });
                var errorMessage = exception.toString();
                var user = currentUser.get();
                user = user == null ? 'user is unexpectedly null' : (user.SignedIn ? { Email: user.Email, UtmId: user.UtmId } : user);
                if (skipErrorsLogging) {
                    return;
                }
                //note that we can't use $http or $location here because it causes a circular dependency which is a bit annoying
                if (errorMessage.indexOf('$rootScope:infdig') >= 0 ||
                    errorMessage.indexOf('$rootScope:inprog') >= 0) {
                    digestErrors += 1;
                }
                if (digestErrors > 5) {
                    errorMessage = 'Digest loop panic detected';
                    skipErrorsLogging = true;
                    success = function () {
                        $window.location.href = '/';
                    };
                }
                errorQueue.push({
                    Message: {
                        userAgent: navigator.userAgent,
                        errorUrl: $window.location.href,
                        errorMessage: errorMessage,
                        stackTrace: stackTrace,
                        cause: (cause || ''),
                        user: user
                    },
                    LogLevel: ie9 ? 2 : 1 //warn for ie9, otherwise error
                });
            }
            catch (loggingError) {
                $log.warn('Error logging failed');
                $log.log(loggingError);
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('FilterIdUtils', FilterIdUtils);
    function FilterIdUtils($http, $location, currentDestination, pageStrand) {
        var url = '/api2/destination/filters/';
        var service = {
            estabGroupFilterAvailable: estabGroupFilterAvailable,
            createEstabGroupOptions: createEstabGroupOptions,
            lookupFid: lookupFid,
            sanitiseFidFilters: sanitiseFidFilters,
            updateEstabGroupProperties: updateEstabGroupProperties,
            getFilters: getFilters
        };
        var _filterData;
        var fidSettings = {
            ignorable: ['EstabGroupIds', 'EstabGroupIds', 'EstabGroupName', 'EstablishmentName', 'FilterByEstabGroup'],
            propertyMap: {
                BoardTypes: 'HotelsByBoardType',
                FacilityCodes: 'MergedHotelsByFacility',
                PriceRange: 'PriceRange',
                HolidayPriceRange: 'HolidayPriceRange',
                RatingRange: 'RatingRange',
                PropertyTypes: 'HotelsByPropertyType',
                Stars: 'HotelsByStar'
            }
        };
        function _groupFilterAvailable(filter) {
            return filter != null && filter.EstabGroupName != null && filter.EstabGroupName !== '';
        }
        function lookupFid(fid) {
            return currentDestination
                .getCurrentDestination()
                .then(function (dest) { return getFilters(fid, pageStrand.fromRoute(dest)); });
        }
        function getFilters(fid, pageStrandId) {
            var params = {
                DomainId: TRPCONFIG.Domain.DomainId,
                FilterId: parseInt(fid),
                PageStrandId: pageStrandId
            };
            var opt = {
                cache: true,
                customErrCallback: {
                    404: function () { return true; }
                }
            };
            return $http.get(url + "get?" + jQuery.param(params), opt)
                .then(function (res) {
                var filters = _.pickBy(res.data, function (v) { return v !== null; });
                // renaming keys
                if (filters.BoardTypeCode) {
                    filters.BoardTypes = filters.BoardTypeCode;
                }
                if (filters.PropertyType) {
                    filters.PropertyTypes = filters.PropertyType;
                }
                // filter by estab group
                filters.FilterByEstabGroup = filters.EstabGroupIds &&
                    filters.EstabGroupIds.length > 0 &&
                    filters.EstabGroupName != null;
                _filterData = filters;
                return filters;
            }, function () { return null; });
        }
        //this needs to work off the original definition of the fidFilter, *not* the current
        //filter as it is at the moment because the current filter can have the estabgroupIds
        //removed by unchecking the checkbox whereupon it all goes wrong.
        function createEstabGroupOptions(groupAggregates) {
            if (_groupFilterAvailable(_filterData) && groupAggregates) {
                var hotelCount = 0;
                for (var i = 0; i < _filterData.EstabGroupIds.length; i++) {
                    var group = groupAggregates[_filterData.EstabGroupIds[i]];
                    if (_.isObject(group)) {
                        hotelCount = group.Count || 0;
                    }
                    else {
                        hotelCount += group || 0;
                    }
                }
                return [{
                        title: _filterData.EstabGroupName,
                        count: hotelCount
                    }];
            }
            return null;
        }
        function estabGroupFilterAvailable(filter) {
            return _groupFilterAvailable(filter);
        }
        function updateEstabGroupProperties(filter) {
            //we need to correctly set the estab group ids property based on the bool FilterByEstabGroup
            //and ensure the groupname is always set
            if (!filter.EstabGroupName && _filterData && _filterData.EstabGroupName) {
                filter.EstabGroupName = _filterData.EstabGroupName;
            }
            //1. if it is true don't remove the groupIds (might have to add ids in)
            //2. otherwise clear it
            if (filter.FilterByEstabGroup === true) {
                if (filter.EstabGroupIds.length === 0 && _filterData) {
                    filter.EstabGroupIds = angular.copy(_filterData.EstabGroupIds);
                }
            }
            else {
                filter.EstabGroupIds = [];
            }
        }
        function sanitiseFidFilters(f, agg, defaultFilterCriteria) {
            var propertyMap = fidSettings.propertyMap;
            function relevantFilters(f) {
                f = _.omit(f, fidSettings.ignorable);
                return _.omitBy(f, function (p, key) { return !p || _.isArray(p) && !p.length || _.isEmpty(agg[propertyMap[key]]); });
            }
            function arrayTypeFilter(key) {
                return function (x) { return _.isObject(agg[propertyMap[key]][x]) ? !_.isEmpty(agg[propertyMap[key]][x])
                    : agg[propertyMap[key]][x] != null; };
            }
            function objectFilter(filterValue, key) {
                if (agg[propertyMap[key]].Min > filterValue.Min) {
                    filterValue.Min = agg[propertyMap[key]].Min;
                }
                if (agg[propertyMap[key]].Max < filterValue.Max) {
                    filterValue.Max = agg[propertyMap[key]].Max;
                }
                return filterValue;
            }
            function compareFiltersWithAggregates(filterValue, key) {
                return _.isArray(filterValue) ? filterValue.filter(arrayTypeFilter(key))
                    : _.isObject(filterValue) && filterValue.Min != null && filterValue.Max ? objectFilter(filterValue, key)
                        : filterValue;
            }
            function filteredCriteria() {
                return _.mapValues(relevantFilters(f), compareFiltersWithAggregates);
            }
            var filteredFilter = angular.extend(defaultFilterCriteria, filteredCriteria());
            return angular.equals(filteredFilter, f) ? false : filteredFilter;
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var Filtering = /** @class */ (function () {
        function Filtering($location, $q, FilterIdUtils, fidParser) {
            this.$location = $location;
            this.$q = $q;
            this.FilterIdUtils = FilterIdUtils;
            this.fidParser = fidParser;
            this.transform = {
                Stars: { s: this._serializeArray, d: this._deserializeArray },
                BoardTypes: { s: this._serializeArray, d: this._deserializeArray },
                ChildDestinations: { s: this._serializeArray, d: this._deserializeArray },
                FacilityCodes: { s: this._serializeArray, d: this._deserializeArray },
                PropertyTypes: { s: this._serializeArray, d: this._deserializeArray },
                RatingRange: { s: this._serialiseRange, d: this._deserialiseRange },
                PriceRange: { s: this._serialiseRange, d: this._deserialiseRange },
                HolidayPriceRange: { s: this._serialiseRange, d: this._deserialiseRange }
            };
            this.boardTypes = {
                1: 'ROOMONLY',
                2: 'BEDANDBREAKFAST',
                3: 'HALFBOARD',
                4: 'FULLBOARD',
                5: 'ALLINCLUSIVE',
                6: 'SELFCATERING'
            };
        }
        Filtering.prototype.getFilters = function (defaultFilters, pageStrand) {
            var _this = this;
            if (defaultFilters === void 0) { defaultFilters = {}; }
            var params = this.$location.search();
            var fid = this.fidParser.parse();
            return fid ?
                this.FilterIdUtils.getFilters(fid, pageStrand)
                    .then(function (f) { return _this._mergeFromFid(defaultFilters, f); }) :
                this.$q.when(this._mergeFromParams(defaultFilters, params));
        };
        Filtering.prototype.deserialiseFilters = function (rawFilters) {
            var filters = {};
            for (var filter in rawFilters) {
                filters[filter] = this.transform[filter].d(rawFilters[filter]);
            }
            return filters;
        };
        Filtering.prototype.serialiseFilters = function (filterObj) {
            var updated = false;
            var paramValues = this.$location.search();
            for (var filter in filterObj) {
                // have to convert to null as non existant parameters are deleted by null value in
                // $location.search
                var paramValue = paramValues[filter] || null;
                var newParamValue = this.transform[filter].s(filterObj[filter]);
                if (paramValue !== newParamValue) {
                    updated = true;
                    this.$location.search(filter, newParamValue);
                }
            }
            return updated;
        };
        Filtering.prototype.getBoardTypeName = function (bt) {
            if (!bt) {
                return '';
            }
            return this.boardTypes[bt];
        };
        Filtering.prototype._mergeFromParams = function (defaultFilters, params) {
            var filters = {};
            for (var filter in defaultFilters) {
                var f = params[filter]
                    ? this.transform[filter].d(params[filter])
                    : defaultFilters[filter];
                filters[filter] = f;
            }
            return filters;
        };
        Filtering.prototype._mergeFromFid = function (defaultFilters, fidFilters) {
            var filters = {};
            for (var filter in defaultFilters) {
                var f = fidFilters && fidFilters[filter]
                    ? fidFilters[filter]
                    : defaultFilters[filter];
                filters[filter] = f;
            }
            return filters;
        };
        Filtering.prototype._deserializeArray = function (str) {
            return str.split(',');
        };
        Filtering.prototype._serializeArray = function (arr) {
            if (!arr.length) {
                return null;
            }
            return arr.join(',');
        };
        Filtering.prototype._deserialiseRange = function (str) {
            var rating = str.split(',');
            return { Min: parseFloat(rating[0] || '0'), Max: parseFloat(rating[1] || '0') };
        };
        Filtering.prototype._serialiseRange = function (range) {
            if (!range) {
                return null;
            }
            return range.Min + "," + range.Max;
        };
        return Filtering;
    }());
    TR.Filtering = Filtering;
    angular
        .module('TR')
        .service('filtering', Filtering);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .service('flightSearch', flightSearch);
    function flightSearch(preferences, unadjustedDateFilter, sortCriteria, $http, dateUtil, analytics, occupancyService, flightSearchValidator, baggageService, flightDetail, searchUnitService, FilterUtils, arrayUtil, $q, broker, cancellerService, tripService, currentDestination, $routeParams, $window, $rootScope) {
        var url = '/api2/flights/availability/';
        var webUrl = 'website/flights/';
        var staticUrl = '/api2/flights/static';
        var results;
        var inProgress;
        var filterCanceller;
        var filterDefer = $q.defer();
        var sortCriteriaDef = sortCriteria.getFlightCriteria();
        var filterUtil = new FilterUtils(_defaultFilterCriteria());
        var req = {
            Paging: {
                PageIndex: 0,
                PageSize: 10
            },
            OneWayOnly: false,
            NumberOfLeadBags: 0,
            WaitForResults: true
        };
        // Stop when clicking the back/forward buttons, the filters need to be cleared
        // because the next page might have completely different search results.
        $($window).on('popstate', function () {
            if (req.AvailabilitySearchId) {
                resetFilters();
            }
        });
        preferences.getFlightSortOrder(true).then(function (so) {
            req.SortCriterion = so;
        });
        var service = {
            clearSearchResults: clearSearchResults,
            filter: filter,
            filterSet: filterSet,
            getAirportTitles: getAirportTitles,
            getAvailabilityRequest: getAvailabilityRequest,
            getFilter: getFilter,
            getFilterLazy: getFilterLazy,
            getFlightsForDeals: getFlightsForDeals,
            getOccupancySummary: getOccupancySummary,
            getRouteSummary: getRouteSummary,
            getSearchResults: getSearchResults,
            getSearchSummary: getSearchSummary,
            getSortCriteria: getSortCriteria,
            getSortCriterionDescription: getSortCriterionDescription,
            getUrl: getUrl,
            rehydrateMultiDestHolidayFlight: rehydrateMultiDestHolidayFlight,
            setBags: setBags,
            modifyBags: modifyBags,
            nextPage: nextPage,
            pageSize: pageSize,
            rangeFilterSet: rangeFilterSet,
            removeArrayFilter: removeArrayFilter,
            resetArrayFilter: resetArrayFilter,
            resetBooleanFilter: resetBooleanFilter,
            resetFilters: resetFilters,
            resetPageIndex: resetPageIndex,
            resetRangeFilter: resetRangeFilter,
            search: search,
            setCabin: setCabin,
            sort: sort,
            validateSearchCriteria: validateSearchCriteria,
            trackFlightClick: trackFlightClick
        };
        function resetPageIndex() {
            req.Paging.PageIndex = 0;
            if (results) {
                results.CombinedDates.AvailableFlights = results.CombinedDates.AvailableFlights.slice(0, req.Paging.PageSize);
            }
        }
        function _emptyFilterCriteria() {
            var disableOpenJawPublicMode = TRPCONFIG.Domain2.DisableOpenJawPublicMode;
            var disableOpenJawAgentMode = TRPCONFIG.Domain2.DisableOpenJawAgentMode;
            var HideOpenJaw = TRPCONFIG.Domain.isAgentMode
                ? disableOpenJawAgentMode : !TRPCONFIG.Domain.isAgentMode
                ? disableOpenJawPublicMode : false;
            return {
                DepartureDates: [],
                DepartureAirport: [],
                Airline: [],
                Stop: [],
                PriceRange: null,
                OutboundTakeOffRange: null,
                ReturnTakeOffRange: null,
                HideOpenJaw: HideOpenJaw
            };
        }
        function _defaultFilterCriteria() {
            var newFilter = _emptyFilterCriteria();
            if (_.get(req, 'FilterCriteria.DepartureDates.length') > 0) {
                newFilter.DepartureDates = req.FilterCriteria.DepartureDates.slice(); //copy values over
            }
            return newFilter;
        }
        function _getFilterCriteriaSet() {
            //when filtering we should only pass the items a user has set, but we also want to
            //take care to not modify the actual filter object, so return a modified
            //copy of the filter
            var filterCopy = angular.copy(getFilter());
            if (results != null) {
                filterUtil.setToNullIfMatches(filterCopy, 'PriceRange', results.CombinedDates.UnfilteredAggregates);
                filterUtil.setToNullIfMatches(filterCopy, 'OutboundTakeOffRange', results.CombinedDates.UnfilteredAggregates);
                filterUtil.setToNullIfMatches(filterCopy, 'ReturnTakeOffRange', results.CombinedDates.UnfilteredAggregates);
            }
            return filterCopy;
        }
        var enableFlightPreselectionApi = TRPCONFIG.Domain2.EnableFlightPreselectionApi ? 'searchfromsessionwithprioritypreselection' : 'searchfromsession';
        function _getUrl(newSearch) {
            return newSearch ?
                webUrl + "search" :
                "" + webUrl + enableFlightPreselectionApi;
        }
        function _resetFlexibleDates(req) {
            // If DepartureDates are emty we will get the responce +-3 days using this reqest.
            // Here we use only one date from search by default so dates wil not be flexible.
            // But if user will change the date using checkbox in departure date fliter we will use dates which was choosen.
            if (req.FilterCriteria.DepartureDates === undefined || req.FilterCriteria.DepartureDates.length === 0) {
                req.FilterCriteria.DepartureDates = [unadjustedDateFilter(searchUnitService.startDate(), 'yyyy-MM-dd')];
            }
            else if (req.FilterCriteria.DepartureDates.length === 1) {
                req.FilterCriteria.DepartureDates = getFilter().DepartureDates;
            }
            return req;
        }
        function getFlightsForDeals(id, checkIn, checkOut, destAirports, depAirports) {
            var api = url + "getflightsfordeal";
            var req = {
                AvailabilitySearchId: id,
                DomainId: TRPCONFIG.Domain.DomainId,
                CheckInDate: dateUtil.serialiseDate(checkIn),
                CheckOutDate: dateUtil.serialiseDate(checkOut),
                DepartureAirports: depAirports,
                DestinationAirports: destAirports,
                FlightsCount: 3
            };
            return $http.post(api, req)
                .then(function (res) {
                if (!res.data || !res.data.Flights) {
                    return [];
                }
                return res.data.Flights;
            });
        }
        function getAirportTitles(codes) {
            var params = {
                AirportCodes: codes,
                CultureCode: TRPCONFIG.Domain.CultureCode
            };
            var url = staticUrl + "/gettitles?" + jQuery.param(params);
            return $http.get(url, { cache: true });
        }
        function getSortCriteria(oneWay) {
            return sortCriteria.getFlightCriteria(oneWay);
        }
        function getSortCriterionDescription() {
            return preferences.getFlightSortOrder().then(function (so) {
                var i = arrayUtil.indexOf(sortCriteriaDef, function (c) {
                    return c.val === so || (angular.isArray(c.val) && c.val.indexOf(so) !== -1);
                });
                return i >= 0 ? sortCriteriaDef[i].name() : '';
            });
        }
        function getFilter() {
            return filterUtil.getFilter();
        }
        function getFilterLazy() {
            return filterDefer.promise;
        }
        function filterSet(filterName) {
            return filterUtil.filterSet(filterName);
        }
        function _resetPriceRange(results) {
            filterUtil.resetRangeFilter(results, results.CombinedDates.UnfilteredAggregates, 'PriceRange', ['Min', 'Max']);
        }
        function resetFilters(dontApply) {
            filterUtil = new FilterUtils(_emptyFilterCriteria());
            filterDefer = $q.defer();
            if (!dontApply) {
                return service.filter();
            }
            return $q.when();
        }
        function rangeFilterSet(filterName, range) {
            return filterUtil.rangeFilterSet(results, results.CombinedDates.UnfilteredAggregates, filterName, range);
        }
        function resetRangeFilter(filterName, range) {
            filterUtil.resetRangeFilter(results, results.CombinedDates.UnfilteredAggregates, filterName, range);
            return service.filter();
        }
        function removeArrayFilter(filterName, item) {
            filterUtil.removeArrayFilter(filterName, item);
            return service.filter();
        }
        function resetBooleanFilter(filterName) {
            filterUtil.resetBooleanFilter(filterName);
            return service.filter();
        }
        function resetArrayFilter(filterName) {
            filterUtil.resetArrayFilter(filterName);
            return service.filter();
        }
        function getRouteSummary(tripType, tripId) {
            return $q.all([
                currentDestination.getCurrentDestination(),
                tripService.getSelectedDestinationAirport(tripId)
            ]).then(function (res) {
                var dest = res[0], destAirport = res[1];
                var to;
                if ((dest == null || tripType === 1) && destAirport) {
                    to = destAirport.ShortTitle || destAirport.Title;
                }
                else if (dest) {
                    to = dest.SummaryTitle;
                }
                return to;
                //return to ? 'Flights to ' + to : 'Flights';
            });
        }
        function getOccupancySummary() {
            return occupancyService.getRoomOccupancyString();
        }
        function getSearchSummary(tripType, tripId) {
            // TODO: use formatted resource string
            //return getRouteSummary() + ' on ' + getDurationSummary() + ', ' + getOccupancySummary();
            return $q.all([
                getRouteSummary(tripType, tripId),
                tripService.getDurationSummary(searchUnitService.flight, $routeParams.tripId)
            ]).then(function (result) { return result[0] + " on " + result[1]; });
        }
        function validateSearchCriteria(isHoliday, oneWayOnly) {
            return flightSearchValidator.validate(isHoliday, searchUnitService.getDestination(), searchUnitService.getDestinationAirport(), searchUnitService.getDepartureAirports(), searchUnitService.startDate(searchUnitService.flight), searchUnitService.endDate(searchUnitService.flight), searchUnitService.getOutboundDates(searchUnitService.flight), searchUnitService.getCabin(), occupancyService.getOccupancy(), oneWayOnly);
        }
        function clearSearchResults() {
            filterUtil = new FilterUtils(_defaultFilterCriteria());
            filterDefer = $q.defer();
            req.Paging.PageIndex = 0;
            results = null;
        }
        function getSearchResults(searchId, tripId, selectedFlightId) {
            if (results && searchId === results.AvailabilitySearchId) {
                if (selectedFlightId) {
                    var r = _.cloneDeep(results);
                    var flights = _.get(r, 'CombinedDates.AvailableFlights');
                    _.set(r, 'CombinedDates.AvailableFlights', _.filter(flights, function (f) { return f.FlightId !== selectedFlightId; }));
                    return $q.when(r);
                }
                return $q.when(results);
            }
            clearSearchResults();
            return service.search({ searchId: searchId, tripId: tripId });
        }
        function search(args) {
            if (inProgress != null && !args.newSearch) {
                return inProgress;
            }
            req.AvailabilitySearchId = args.searchId;
            req.TripId = args.tripId;
            req.CombineDates = true;
            if (args.newSearch || args.useSearchUnit || args.isV3HolidayRoute) {
                delete req.SelectedFlight;
                req.Destination = searchUnitService.getDestination();
                req.DestinationAirports = args.newSearch ? searchUnitService.getDestinationAirports() : searchUnitService.getDestinationAirports(req.Destination);
                req.SelectedDestinationAirport = searchUnitService.getDestinationAirport();
                req.DepartureAirports = searchUnitService.getDepartureAirports();
                req.SelectedDepartureAirport = searchUnitService.getSelectedDepartureAirport();
                req.DepartureDate = searchUnitService.startDate(searchUnitService.flight);
                req.ReturnDate = searchUnitService.endDate(searchUnitService.flight);
                var occ = occupancyService.reduceOccupancy();
                req.Adults = occ.Adults;
                req.ChildAges = occ.ChildAges;
                req.Paging.PageIndex = 0;
                req.OneWayOnly = args.oneWayOnly;
                req.FlightOnlySearch = args.flightOnly;
                searchUnitService.setOneWayFlightEnabled(args.oneWayOnly);
                req.Cabin = searchUnitService.getCabin();
                req.PreferredCarrierCodes = args.prefilterAirlines;
                req.IsDirectFlight = args.prefilterDirectFlights;
                if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain.ShowAgentOfficeSelector) {
                    req.OfficeLocationId = $rootScope.agent.CurrentOfficeLocation;
                }
                if (args && args.postfilterAirlines && args.postfilterAirlines.length) {
                    getFilter().Airline = args.postfilterAirlines;
                }
                if (!TRPCONFIG.Domain.FlexibleDatesEnabled || !args.flexibleDates) {
                    getFilter().DepartureDates = [unadjustedDateFilter(req.DepartureDate, 'yyyy-MM-dd')];
                }
                else {
                    getFilter().DepartureDates = [];
                }
                req.FilterCriteria = _getFilterCriteriaSet();
                tripService.recordFlightSearch(args.tripId, req);
            }
            function get() {
                if (!args.newSearch && args.isV3HolidayRoute) {
                    return;
                }
                var whitelist = [
                    /^\/holidays\/flights\/\w+/,
                    '/holidays/flightunavailable',
                    /^\/flights\/\w+/,
                    /^\/holidays\/hotels\/\w+/
                ];
                filterCanceller = cancellerService.add.apply(null, whitelist);
                filterCanceller.promise.then(function () {
                    inProgress = null;
                });
                var isHotelFirst = JSON.parse(sessionStorage.getItem('PreselectFlight'));
                if (isHotelFirst && !TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                    _resetFlexibleDates(req);
                }
                var prunedReq = pruneRequest(req);
                return $http.post(_getUrl(args.newSearch), prunedReq, { timeout: filterCanceller.promise })
                    .then(function (res) {
                    req.AvailabilitySearchId = res.data.AvailabilitySearchId;
                    getFilter().DepartureDates = res.data.FilterCriteria.DepartureDates;
                    filterUtil.copyFilterFrom('PriceRange', res.data.CombinedDates.UnfilteredAggregates);
                    filterUtil.copyFilterFrom('OutboundTakeOffRange', res.data.CombinedDates.UnfilteredAggregates);
                    filterUtil.copyFilterFrom('ReturnTakeOffRange', res.data.CombinedDates.UnfilteredAggregates);
                    if (results) {
                        results.CombinedDates.AvailableFlights = results.CombinedDates.AvailableFlights.concat(res.data.CombinedDates.AvailableFlights);
                    }
                    else {
                        results = res.data;
                    }
                    inProgress = null;
                    filterDefer.resolve(service.getFilter());
                    if (args.resetPriceRange === true) {
                        _resetPriceRange(results);
                    }
                    broker.publish('flightResultsModified', results);
                    return results;
                });
            }
            inProgress = $q.all([
                args.sortOrder || preferences.getFlightSortOrder(args.newSearch),
                tripService.getFlightsRequest(args.tripId)
            ])
                .then(function (_a) {
                var so = _a[0], fr = _a[1];
                req.SortCriterion = so;
                var selectedFlightId = _.get(fr, 'SelectedFlight.FlightId');
                _.set(req, 'FilterCriteria.SelectedFlightId', selectedFlightId);
            })
                .then(get)
                .catch(function () { return inProgress = null; });
            return inProgress;
        }
        function rehydrateMultiDestHolidayFlight(selectedFlight) {
            var _a = selectedFlight || {}, DetailsId = _a.DetailsId, FlightId = _a.FlightId;
            if (DetailsId && FlightId) {
                return flightDetail.rehydrate(DetailsId)
                    .then(function (details) {
                    if (details.Itinerary) {
                        // See holidaySearchCtrl.js
                        details.Itinerary.FlightId = FlightId;
                    }
                    return details;
                });
            }
            return $q.when();
        }
        function setBags(trip, flight) {
            if (flight) {
                return baggageService.getBaggageInfo(trip.TripId).then(function (bagInfo) {
                    flight.Legs.forEach(function (l, i) {
                        if (l.BagsIncludedCount > 0) {
                            //this means that the leg already comes with bags (though we may not have known this at the time we selected the flight
                            l.passengerBagCount = l.BagsIncludedCount;
                        }
                        else {
                            //if the leg does not include baggage, we use the number of bags that the user has currently selected
                            l.passengerBagCount = bagInfo[i]
                                ? bagInfo[i].holdBagCount
                                : bagInfo[0] && bagInfo[0].holdBagCount || 0;
                        }
                    });
                    flight.bags = _.max(flight.Legs.map(function (leg) { return leg.passengerBagCount; }));
                });
            }
            return $q.when();
        }
        function modifyBags(numberOfBags) {
            broker.publish('searchCriteriaModified');
            if (results != null) {
                _resetPriceRange(results);
            }
            req.FilterCriteria = _getFilterCriteriaSet();
            req.Paging.PageIndex = 0;
            req.NumberOfLeadBags = numberOfBags;
            results = null;
            return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId, resetPriceRange: true });
        }
        function sort(criterion) {
            broker.publish('searchCriteriaModified');
            req.FilterCriteria = _getFilterCriteriaSet();
            req.Paging.PageIndex = 0;
            results = null;
            return preferences.setFlightSortOrder(criterion).then(function () {
                return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId, sortOrder: criterion });
            });
        }
        function filter() {
            var filterDeferred = (filterCanceller || $q.defer());
            filterDeferred.resolve();
            broker.publish('searchCriteriaModified');
            req.FilterCriteria = _getFilterCriteriaSet();
            req.Paging.PageIndex = 0;
            results = null;
            return filterDeferred.promise.then(function () {
                return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId });
            });
        }
        function getAvailabilityRequest() {
            return req;
        }
        function pageSize() {
            return req.Paging.PageSize;
        }
        function nextPage() {
            req.Paging.PageIndex += 1;
            req.FilterCriteria = _getFilterCriteriaSet();
            return service.search({ searchId: req.AvailabilitySearchId, tripId: req.TripId });
        }
        function getUrl() {
            return url;
        }
        function setCabin(cabin) {
            req.Cabin = cabin;
        }
        function trackFlightClick(flight, tripId, boostReason) {
            if (boostReason === void 0) { boostReason = null; }
            var _flight = _.partial(_.get, flight);
            analytics.track('mixpanel', 'FlightListingClick', {
                RepeatFlightClicked: _flight('RecentlyViewedIndex') === 1,
                InboundCareer: _flight('Legs[0].Segments[0].CarrierName'),
                OutboundCareer: _flight('Legs[1].Segments[0].CarrierName')
            });
            return tripService.getFlightsRequest(tripId).then(function (fRequest) {
                var FreeBaggage = _(_flight('Legs')).map(function (leg) { return leg.BagsIncludedCount; }).min() > 0;
                var selectionsReq = {
                    Type: 1,
                    SearchId: _.get(fRequest, 'AvailabilitySearchId'),
                    DomainId: _.get(TRPCONFIG, 'Domain.DomainId'),
                    AdultFare: _flight('LeadAdultPrice'),
                    AdultTax: _flight('LeadAdultTax'),
                    CurrencyCode: _flight('CurrencyCode'),
                    FreeBaggage: FreeBaggage,
                    SearchResultsIndex: _flight('SearchResultsIndex'),
                    BoostReason: boostReason,
                    OutboundDepartureAirport: _flight('Legs[0].DepartureAirport.Code'),
                    OutboundDepartureDate: _flight('Legs[0].DepartureDate'),
                    OutboundArrivalAirport: _flight('Legs[0].ArrivalAirport.Code'),
                    OutboundArrivalDate: _flight('Legs[0].ArrivalDate'),
                    OutboundSegmentDetails: _.map(_flight('Legs[0].Segments'), mapSegmentForTracking),
                    InboundDepartureAirport: _flight('Legs[1].DepartureAirport.Code'),
                    InboundDepartureDate: _flight('Legs[1].DepartureDate'),
                    InboundArrivalAirport: _flight('Legs[1].ArrivalAirport.Code'),
                    InboundArrivalDate: _flight('Legs[1].ArrivalDate'),
                    InboundSegmentDetails: _.map(_flight('Legs[1].Segments'), mapSegmentForTracking)
                };
                localStorage.setItem('flightsSelections', JSON.stringify(selectionsReq));
                return $http.post('/api/useractions/selections', selectionsReq, { ignoreErrors: true });
            });
        }
        function mapSegmentForTracking(s) {
            var _s = _.partial(_.get, s);
            return {
                DepartureAirport: _s('DepartureAirportCode'),
                DepartureDate: _s('DepartureDate'),
                ArrivalAirport: _s('DestinationAirportCode'),
                ArrivalDate: _s('ArrivalDate'),
                FlightNumber: _s('FlightNumber'),
                CarrierName: _s('CarrierName'),
                Cabin: _s('Cabin'),
                AdditionalStops: _s('AdditionalStops')
            };
        }
        function pruneRequest(req) {
            req = _.pick(req, 'Adults', 'AvailabilitySearchId', 'ChildAges', 'CombineDates', 'CultureCode', 'CurrencyCode', 'DepartureAirports', 'DepartureDate', 'Destination', 'DestinationAirports', 'DomainId', 'ExcludeOpenJaw', 'FilterCriteria', 'FlightOnlySearch', 'IsAnyToAny', 'NumberOfLeadBags', 'OneWayOnly', 'Paging', 'Cabin', 'ReturnDate', 'ReturnFullResults', 'SortCriterion', 'IsSingleDaySearch', 'PreferredCarrierCodes', 'IsDirectFlight', 'OfficeLocationId', 'WaitForResults');
            req.Destination = _.pick(req.Destination, 'CountryId', 'ProvinceId', 'LocationId', 'EstablishmentId', 'PolygonId');
            req.Paging = _.pick(req.Paging, 'PageIndex', 'PageSize');
            req.FilterCriteria = _.pick(req.FilterCriteria, 'DepartureAirport', 'Airline', 'SelectedFlightId', 'Stop', 'OutboundTakeOffRange', 'OutboundLandingRange', 'ReturnTakeOffRange', 'ReturnLandingRange', 'PriceRange', 'HideAlternativeDates', 'HideOpenJaw', 'DepartureDates');
            return req;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('flightSearchValidator', flightSearchValidator);
    function flightSearchValidator(resourceService, dateUtil, occupancyService) {
        var service = {
            validate: validate
        };
        function validate(isHoliday, destination, destinationAirport, departureAirports, departureDate, returnDate, outboundDates, cabin, occupancy, oneWayOnly) {
            var errors = [];
            if (isHoliday) {
                if (_.isEmpty(destination)) {
                    errors.push(resourceService.get('SELECTDESTINATION'));
                }
                else {
                    if (!destination.HolidayEnabled) {
                        errors.push(String.format(resourceService.get('NOTHOLIDAYENABLED'), destination.Title));
                    }
                    if (!destination.Searchable) {
                        errors.push(String.format(resourceService.get('NONSEARCHABLE'), destination.Title));
                    }
                }
                if (cabin < 1) {
                    errors.push(resourceService.get('SELECTFLIGHTCLASS'));
                }
            }
            else if (_.isEmpty(destinationAirport)) {
                errors.push(resourceService.get('SELECTDESTINATIONAIRPORT'));
            }
            if (departureAirports == null ||
                departureAirports.length === 0) {
                errors.push(resourceService.get('SELECTDEPARTUREAIRPORT'));
            }
            var destinationCodes = isHoliday ? destination && destination.DestinationAirports : destinationAirport && destinationAirport.Code;
            if (destinationCodes && departureAirports) {
                destinationCodes = destinationCodes.split(',');
                var destinationAndDepartureAreSame = _.some(destinationCodes, function (dest) { return _.includes(departureAirports, dest); });
                if (destinationAndDepartureAreSame) {
                    errors.push(resourceService.get('DEPARTUREANDDESTINATIONAIRPORTSTHESAME'));
                }
            }
            if (departureDate == null) {
                errors.push(resourceService.get('SELECTDEPARTUREDATE'));
            }
            else {
                if (TRPCONFIG.Domain.HolidaysSearchOffsetDate !== 0 && !dateUtil.atLeastOneDayInTheFuture(departureDate)) {
                    errors.push(resourceService.get('DEPARTUREDATEMUSTBEFUTURE'));
                }
                if (outboundDates &&
                    Object.keys(outboundDates).length > 0 &&
                    outboundDates[dateUtil.format(departureDate, 'yyyy-MM-dd')] === undefined) {
                    errors.push(resourceService.get('DEPARTUREDATENOTAVAILABLE'));
                }
            }
            if (returnDate == null && !oneWayOnly) {
                errors.push(resourceService.get('SELECTRETURNDATE'));
            }
            else if (returnDate <= departureDate && !oneWayOnly) {
                errors.push(resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
            }
            if (occupancyService.moreInfantsThanAdults()) {
                errors.push(resourceService.get('TOOMANYINFANTS'));
            }
            if (occupancyService.getNumberOfNonInfantPassengers() > 12) {
                errors.push(String.format(decodeURI(resourceService.get('TOOMANYPASSENGERS')), TRPCONFIG.DesktopUrlRoot + "/Help/Groupbookings.aspx", resourceService.get('TELEPHONENUMBER')));
            }
            if (!occupancyService.childAgesPopulated(occupancy)) {
                errors.push(resourceService.get('CHILDAGESERROR'));
            }
            return errors;
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var FlightsFilterService = /** @class */ (function () {
        function FlightsFilterService($filter) {
            var _this = this;
            this.$filter = $filter;
            this.sortArray = function (arr, prop) {
                var sortBy = '-count';
                if (prop === 'FlightsByAirline' && TRPCONFIG.Domain.FlightsByAirlineFilterOrder) {
                    sortBy = TRPCONFIG.Domain.FlightsByAirlineFilterOrder;
                }
                if (prop === 'DepartureDates') {
                    sortBy = 'name';
                }
                return _this.$filter('orderBy')(arr, sortBy);
            };
            this.arrayifyAggregates = function (dict, props) {
                for (var i = 0; i < props.length; i++) {
                    var prop = props[i];
                    if (dict[prop + 'Array']) {
                        continue;
                    }
                    var arr = [];
                    for (var p in dict[prop]) {
                        if (dict[prop].hasOwnProperty(p)) {
                            arr.push({
                                name: p,
                                count: dict[prop][p].Count != null ? dict[prop][p].Count : dict[prop][p],
                                logo: dict[prop][p].Logo,
                                minimumPrice: dict[prop][p].MinimumPrice
                            });
                        }
                    }
                    dict[prop + 'Array'] = _this.sortArray(arr, prop);
                }
            };
            this.populateMinimumPrice = function (dict) {
                var values = _.values(dict.FlightsByAirline);
                dict.minimumPrice = (_.minBy(values, function (x) { return x.MinimumPrice; }) || {}).MinimumPrice;
            };
        }
        return FlightsFilterService;
    }());
    TR.FlightsFilterService = FlightsFilterService;
    angular.module('TR').service('flightsFilterService', FlightsFilterService);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .service('geo', geo);
    function geo($http, $q, autocompleter) {
        var service = {
            getSearchArea: getSearchArea,
            supported: supported,
            getNearestAirportTitles: getNearestAirportTitles,
            getNearestAirports: getNearestAirports
        };
        function getSearchArea() {
            var d = $q.defer();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (pos) {
                    d.resolve({
                        Latitude: pos.coords.latitude,
                        Longitude: pos.coords.longitude,
                        Radius: 10
                    });
                }, function (err) {
                    //this happens quite a lot but it is almost always because the user does not give permission
                    //analytics.trackEvent({category : 'failure', action : 'geo', label:'getCurrentPositionFailed'});
                    //loggingService.logWarn('geo.getCurrentPositionFailed with err: ' + JSON.stringify(err));
                    d.reject(err);
                });
            }
            else {
                //having tracked this for a while, it pretty much never happens.
                //analytics.trackEvent({category : 'failure', action : 'geo', label:'geolocationNotSupported'});
                d.reject('geo not supported');
            }
            return d.promise;
        }
        function supported() {
            return navigator.geolocation;
        }
        function defaultClientLocation() {
            return angular.fromJson(TRPCONFIG.Domain.ClientDefaultLocation
                || '{ "CountryCode": "GB", "Latitude": 51.4167, "Longitude": -0.2833 }');
        }
        function getLocationFromIpAddress() {
            var isPrerender = /prerender/i.test(navigator.userAgent);
            if (isPrerender) {
                return $q.when([]);
            }
            var ipAddress = TRPCONFIG.ClientIpAddress;
            var url = "/api2/globalisation/location?" + $.param({
                ipAddress: ipAddress
            });
            return $http
                .get(url, { cache: true, ignoreErrors: true })
                .then(function (response) {
                var location = response.data;
                if (angular.equals(location, { CountryCode: null, Latitude: 0, Longitude: 0 })) {
                    location = defaultClientLocation();
                }
                return location;
            });
        }
        function getNearestAirports() {
            if (TRPCONFIG.Domain.NearestAirportsStaticList) {
                return $q.when(TRPCONFIG.Domain.NearestAirportsStaticList);
            }
            return getLocationFromIpAddress()
                .then(function (location) { return $q.all({
                airportValidator: getAirportValidator(),
                nearbyAirports: getAirportsNear(location)
            }); })
                .then(function (_a) {
                var airportValidator = _a.airportValidator, nearbyAirports = _a.nearbyAirports;
                var filter = function (airports) { return _(airports)
                    .filter(airportValidator)
                    .take(6)
                    .map(function (a) { return ({ Code: a }); })
                    .value(); };
                nearbyAirports = filter(nearbyAirports);
                if (nearbyAirports && nearbyAirports.length) {
                    return nearbyAirports;
                }
                return getAirportsNear(defaultClientLocation())
                    .then(function (nearbyAirports) { return filter(nearbyAirports); });
            })
                .catch(function () { return []; });
        }
        function getNearestAirportTitles() {
            return getLocationFromIpAddress()
                .then(function (location) {
                var url = "website/flights/nearestairporttitles?" + $.param({
                    cultureCode: TRPCONFIG.Domain.CultureCode,
                    latitude: location.Latitude,
                    longitude: location.Longitude
                });
                return $http
                    .get(url, { cache: true, ignoreErrors: true })
                    .then(function (response) { return _.take(response.data, 6); });
            });
        }
        function getAirportsNear(location) {
            var params = {
                latitude: location.Latitude,
                longitude: location.Longitude
            };
            if (TRPCONFIG.Domain.NearestAirportsMaxDistance) {
                params.maxDistance = TRPCONFIG.Domain.NearestAirportsMaxDistance;
            }
            var url = "/api2/flights/static/getnearestairports?" + $.param(params);
            return $http
                .get(url, { cache: true, ignoreErrors: true })
                .then(function (response) { return response.data; });
        }
        function getAirportValidator() {
            if (TRPCONFIG.Domain.UseStaticDepartureDropdown) {
                return autocompleter.initialDepartureAirports().then(function (validAirports) {
                    var validAirportCodes = _.map(validAirports.data, function (va) { return va.Code; });
                    return function (a) { return _.some(validAirportCodes, function (va) { return va === a; }); };
                });
            }
            return $q.when(function () { return true; });
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var DealsFindParameters = /** @class */ (function () {
        function DealsFindParameters() {
        }
        return DealsFindParameters;
    }());
    var HolidayDeals = /** @class */ (function () {
        function HolidayDeals($http, $location, $filter, $q, dateUtil, resourceService, getPropertyTypeFromResKey, imageService, occupancyService, fieldGroupService, filtering, pageStrand, tripService, hotelService, analytics, flightSearch, geo, preferences) {
            this.$http = $http;
            this.$location = $location;
            this.$filter = $filter;
            this.$q = $q;
            this.dateUtil = dateUtil;
            this.resourceService = resourceService;
            this.getPropertyTypeFromResKey = getPropertyTypeFromResKey;
            this.imageService = imageService;
            this.occupancyService = occupancyService;
            this.fieldGroupService = fieldGroupService;
            this.filtering = filtering;
            this.pageStrand = pageStrand;
            this.tripService = tripService;
            this.hotelService = hotelService;
            this.analytics = analytics;
            this.flightSearch = flightSearch;
            this.geo = geo;
            this.preferences = preferences;
            this.API = '/api/holidays/deals';
            this.DURATIONS = TRPCONFIG.Domain.HolidayDealsDurations.map(function (d) { return parseInt(d, 10); });
            this.runningRequest = this.$q.defer();
        }
        HolidayDeals.prototype.find = function (_a) {
            var _this = this;
            var _b = _a.page, page = _b === void 0 ? 0 : _b, _c = _a.sort, sort = _c === void 0 ? 1 : _c, _d = _a.pageSize, pageSize = _d === void 0 ? TRPCONFIG.Domain.HolidayDealsPageSize : _d, destination = _a.destination, saveToUrl = _a.saveToUrl, _e = _a.includeAggregates, includeAggregates = _e === void 0 ? true : _e, _f = _a.discountedPricesOnly, discountedPricesOnly = _f === void 0 ? false : _f, flexibility = _a.flexibility, _g = _a.includeCruises, includeCruises = _g === void 0 ? TRPCONFIG.Domain.HolidayDealsCruisesEnabled : _g;
            var findParams = new DealsFindParameters();
            findParams.fieldFlags = this.fieldGroupService.getFieldGroup(Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.Url, Core.FieldType.Description, Core.FieldType.Summary, Core.FieldType.HolidayDeals, Core.FieldType.LegacyFacilities, Core.FieldType.Weather, Core.FieldType.Distances, Core.FieldType.Recommendations, Core.FieldType.Airports, Core.FieldType.TransferTimes);
            findParams.paging = { Size: pageSize, Index: page };
            findParams.sort = sort;
            findParams.url = this.API + "/search";
            findParams.includeCruises = includeCruises;
            findParams.destination = destination;
            findParams.discountedPricesOnly = discountedPricesOnly;
            findParams.flexibility = flexibility;
            return this.$q.all({
                params: this.getFullParameters(saveToUrl),
                filters: this.filtering.getFilters(this.getDefaultFilters(), this.pageStrand.get('Holiday'))
            })
                .then(function (res) { return _this.$q.all({
                deals: _this._findDeals(findParams, res.filters, includeAggregates, res.params),
                summary: _this.getSearchSummary(res.params),
            }); })
                .then(function (res) { return ({
                Products: _this._enrichProducts(res.deals.data.Hotels, res.deals.req),
                Aggregates: res.deals.data.Aggregates,
                Paging: {
                    Size: res.deals.req.Paging.Size,
                    Index: res.deals.req.Paging.Index,
                    Total: res.deals.data.Aggregates
                        ? res.deals.data.Aggregates.FilteredHotelCount
                        : 0,
                    UnfilteredTotal: res.deals.data.Aggregates
                        ? res.deals.data.Aggregates.HotelCount
                        : 0
                },
                Info: {
                    duration: res.deals.req.Duration,
                    searchSummary: res.summary,
                    filters: res.deals.filters,
                    airportsTitles: res.deals.data.AirportTitles
                }
            }); });
        };
        HolidayDeals.prototype.getMapCoordinates = function () {
            var _this = this;
            var findParams = new DealsFindParameters();
            var fields = 'Hotels.Id,Hotels.Latitude,Hotels.Longitude,Hotels.DealMinPrice';
            findParams.fieldFlags = this.fieldGroupService.getFieldGroup(Core.FieldType.Global);
            findParams.paging = null;
            findParams.sort = 0;
            findParams.url = this.API + "/search?fields=" + fields;
            return this.filtering
                .getFilters(this.getDefaultFilters(), this.pageStrand.get('Holiday'))
                .then(function (filters) { return _this._findDeals(findParams, filters, false); })
                .then(function (res) { return res.data.Hotels.filter(function (h) { return (h.Latitude || h.Longitude); }); });
        };
        HolidayDeals.prototype.getDealsForHotel = function (estabId, durations, dates) {
            var _this = this;
            var params = this.deserialiseParameters();
            var fieldFlags = this.fieldGroupService.getFieldGroup(Core.FieldType.HolidayDeals, Core.FieldType.Airports, Core.FieldType.TransferTimes);
            var datesAndDurations = _(dates || [params.startDate])
                .map(function (date) { return _this.dateUtil.serialiseDate(date); })
                .flatMap(function (date) {
                return _.map(durations || [params.duration], function (duration) { return ({ Date: date, Duration: duration }); });
            })
                .value();
            var request = {
                Id: estabId,
                DatesAndDurations: datesAndDurations,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                Adults: params.occupancy[0].Adults,
                ChildAges: params.occupancy[0].ChildAges,
                OriginAirports: params.depAir,
                FieldFlags: fieldFlags,
                BoardTypes: []
            };
            return this.$http.post(this.API + "/getdealsforhotel", request)
                .then(function (res) { return res.data; });
        };
        HolidayDeals.prototype.getDealsFromMap = function (estabId) {
            var startDate = this.deserialiseParameters().startDate;
            var dates = this.dateUtil.getDateInterval(startDate, 7);
            return this.getDealsForHotel(estabId, undefined, dates);
        };
        HolidayDeals.prototype.getAggregates = function (saveToUrl, presetParams) {
            var _this = this;
            if (saveToUrl === void 0) { saveToUrl = true; }
            if (presetParams === void 0) { presetParams = {}; }
            var findParams = new DealsFindParameters();
            findParams.fieldFlags = this.fieldGroupService.getFieldGroup(Core.FieldType.HolidayDeals);
            findParams.paging = { Size: 0, Index: 0 };
            findParams.sort = 5;
            findParams.url = this.API + "/search";
            findParams.includeCruises = false;
            return this.$q.all([
                this.getFullParameters(saveToUrl, presetParams),
                this.filtering.getFilters(this.getDefaultFilters(), this.pageStrand.get('Holiday'))
            ])
                .then(function (res) { return ({ params: res[0], filters: _.omit(res[1], 'ChildDestinations') }); })
                .then(function (res) { return _this._findDeals(findParams, res.filters, true, res.params); })
                .then(function (res) { return res && res.data; });
        };
        HolidayDeals.prototype.enrichDeals = function (deals, boardTypeFilters) {
            var _this = this;
            return deals.map(function (d) {
                d.HotelDeal.CheckInDate =
                    _this.dateUtil.parseDate(d.HotelDeal.CheckInDate);
                d.HotelDeal.CheckOutDate =
                    _this.dateUtil.parseDate(d.HotelDeal.CheckOutDate);
                d.DepartureEpoch = angular
                    .copy(d.HotelDeal.CheckInDate)
                    .setHours(0, 0, 0, 0);
                d.Duration = _this.dateUtil.getDifferenceInDays(d.HotelDeal.CheckInDate, d.HotelDeal.CheckOutDate);
                var bt;
                if (boardTypeFilters && boardTypeFilters.length) {
                    bt = _.chain(d.HotelDeal.BoardTypeMinPrices)
                        .filter(function (v) { return boardTypeFilters.indexOf(v.BoardType) > -1; })
                        .sortBy(function (v) { return v.MinPrice; })
                        .value()[0];
                }
                var hotelPrice = bt ? bt.MinPrice : d.HotelDeal.Price;
                d.Price = d.FlightsDeal.Price + hotelPrice;
                var num = _this.occupancyService.getNumberOfNonInfantPassengers();
                d.PricePerPerson = d.Price / num;
                return d;
            });
        };
        HolidayDeals.prototype.selectDeal = function (deal, estabId, original, originalTimes) {
            var _this = this;
            var params = this.deserialiseParameters();
            return this.hotelService.getHotelDetails({
                AvailabilitySearchId: deal.HotelDeal.AvailabilitySearchId,
                EstabId: estabId,
                RoomAndBoardIds: [deal.selectedBoardType.Id],
                DiscountCode: TRPCONFIG.DiscountCode,
                BookingPath: 4
            })
                .then(function (details) {
                deal.EstabId = estabId;
                deal.HotelDeal.ProductId = details.DetailsId;
                return deal;
            })
                .then(function (deal) { return _this.tripService.getTripIdForHolidayDeal(deal, params.occupancy); })
                .then(function (tripId) {
                _this._trackDealChanges(original, deal, originalTimes);
                return _this.$location.url("holidays/options/" + tripId + "/");
            });
        };
        HolidayDeals.prototype.serialiseParameters = function (params, toUrl) {
            var getParams = {
                depAir: params.airportsCodes ? params.airportsCodes.map(function (a) { return a.Code; }).join('-') : undefined,
                startDate: params.startDate ? this.dateUtil.format(params.startDate, 'yyyy-MM-dd') : undefined,
                duration: params.duration,
                occ: params.occupancy ? this.occupancyService.serialise(params.occupancy) : undefined,
                flex: params.flexibility
            };
            return toUrl ? jQuery.param(getParams) : getParams;
        };
        HolidayDeals.prototype.deserialiseParameters = function () {
            var params = this.$location.search();
            return {
                depAir: params.depAir ? params.depAir.split('-') : undefined,
                startDate: params.startDate
                    ? this.dateUtil.parseDate(params.startDate)
                    : undefined,
                duration: parseInt(params.duration, 10),
                occupancy: params.occ
                    ? this.occupancyService.parseOccupancyString(params.occ)
                    : undefined,
                flexibility: parseInt(params.flex || '3', 10)
            };
        };
        HolidayDeals.prototype.getFullParameters = function (saveToUrl, presetParams) {
            var _this = this;
            if (saveToUrl === void 0) { saveToUrl = true; }
            if (presetParams === void 0) { presetParams = {}; }
            var params = _.merge(this.deserialiseParameters(), presetParams);
            var queryString = this.serialiseParameters(presetParams, false);
            if (params.startDate && params.depAir && params.occupancy && params.duration) {
                return this.$q.when(params);
            }
            if (!params.startDate) {
                params.startDate =
                    this.dateUtil.getNextSaturday(TRPCONFIG.Domain.HolidayDealsDefaultWeeks);
                queryString.startDate = this.dateUtil.format(params.startDate, 'yyyy-MM-dd');
            }
            if (!params.occupancy) {
                params.occupancy = this.occupancyService.parseOccupancyString('A2');
                queryString.occ = TRPCONFIG.Domain.HolidayDealsDefaultOccupancy;
            }
            if (!params.duration) {
                params.duration = TRPCONFIG.Domain.HolidayDealsDefaultDuration;
                queryString.duration = TRPCONFIG.Domain.HolidayDealsDefaultDuration;
            }
            var promise = !params.depAir || !params.depAir.length
                ? this.preferences
                    .get('holidayaSsearch')
                    .then(function (holiday) { return holiday && holiday.airports
                    ? holiday.airports
                    : _this.geo
                        .getNearestAirports()
                        .then(function (airports) { return airports.map(function (a) { return a.Code; }); }); })
                    .then(function (airports) {
                    params.depAir = airports && airports.length > 0
                        ? airports
                        : TRPCONFIG.Domain.HolidayDealsDefaultAirports;
                    queryString.depAir = params.depAir.join('-');
                    return params;
                })
                : this.$q.when(params);
            return promise.then(function (params) {
                if (saveToUrl) {
                    var search = _this.$location.search();
                    _.merge(search, queryString, { dealsOnly: 1 });
                    _this.$location.search(search).replace();
                }
                return params;
            });
        };
        HolidayDeals.prototype.getDefaultFilters = function () {
            return {
                Stars: [],
                BoardTypes: [],
                ChildDestinations: [],
                FacilityCodes: [],
                PropertyTypes: [],
                RatingRange: null,
                PriceRange: null
            };
        };
        HolidayDeals.prototype.getCurrentFilters = function () {
            return this.filtering
                .getFilters(this.getDefaultFilters(), this.pageStrand.get('Holiday'));
        };
        HolidayDeals.prototype.getSearchSummary = function (params) {
            var _this = this;
            params.occupancy = _.first(params.occupancy);
            var appDate = this.$filter('date')(params.startDate, 'd MMM yyyy');
            var _a = this._getSummaryElements(params), nights = _a.nights, adults = _a.adults, children = _a.children;
            var summary = '';
            summary += this.resourceService.get('HOLIDAYDEALSHEADER') + " ";
            summary += params.duration + " " + nights;
            summary += ", " + appDate + ", ";
            summary += params.occupancy.Adults > 0
                ? params.occupancy.Adults + " " + adults + " "
                : '';
            summary += params.occupancy.ChildAges.length > 0
                ? params.occupancy.ChildAges.length + " " + children + " "
                : '';
            return this.flightSearch
                .getAirportTitles(params.depAir)
                .then(function (res) {
                var different = _this.resourceService
                    .get('DIFFERENTAIRPORTS')
                    .replace('{0}', res.data.length);
                var fromString = _this.resourceService.get('FROM');
                return res.data.length === 1
                    ? summary + " " + fromString + " " + res.data
                    : summary + " " + different;
            });
        };
        HolidayDeals.prototype.enrichHotel = function (hotel, request) {
            var imageW = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
            var imageH = imageW;
            var propertyType = this.getPropertyTypeFromResKey(hotel.AcomTypeId, hotel.IsVilla);
            var numberOfNonInfantPassengers = this.occupancyService.getNumberOfNonInfantPassengers();
            hotel.PropertyTypeFrom = this.resourceService.get(propertyType);
            hotel.ImageUrl = this.imageService.getMainImageUrl(hotel.Id, imageW, imageH);
            hotel.CroppedImage = this.imageService.getMainImageUrl(hotel.Id, 270, 150, true);
            hotel.MinPricePerson = hotel.DealMinPrice / numberOfNonInfantPassengers;
            if (hotel.HolidayDeals) {
                hotel.DealWasPrice = hotel.HolidayDeals[0].HotelDeal.WasPrice + hotel.HolidayDeals[0].FlightsDeal.Price;
                hotel.WasPricePerPerson = hotel.DealWasPrice / numberOfNonInfantPassengers;
                hotel.BoardType = this.resourceService.get(this.filtering.getBoardTypeName(hotel.HolidayDeals[0].HotelDeal.BoardType));
            }
            hotel.Duration = request.Duration;
            hotel.OccupancyString = this.occupancyService.getOccupancyString([_.pick(request, 'Adults', 'ChildAges')]);
            return hotel;
        };
        HolidayDeals.prototype.getMinHolidayPrice = function () {
            var _this = this;
            return this._getTeaserPriceRequest()
                .then(function (r) { return _this.$http.post(_this.API + "/getminholidayprice", r, { ignoreErrors: true }); })
                .then(function (response) { return response && response.data; });
        };
        HolidayDeals.prototype.getMinCruisePrice = function () {
            var _this = this;
            return this._getTeaserPriceRequest()
                .then(function (r) { return _this.$http.post(_this.API + "/getmincruiseprice", r, { ignoreErrors: true }); })
                .then(function (response) { return response && response.data; });
        };
        HolidayDeals.prototype._getTeaserPriceRequest = function () {
            var _this = this;
            return this.getFullParameters(false).then(function (params) { return ({
                DatesAndDurations: _this._getDatesAndDurations(_this.dateUtil.getNextSaturday(2), params.duration, 3),
                Adults: 2,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                OriginAirports: params.depAir
            }); });
        };
        HolidayDeals.prototype._trackDealChanges = function (orig, sel, originalTimes) {
            if (!orig || !orig.HotelDeal || !orig.FlightsDeal ||
                !sel || !sel.HotelDeal || !sel.FlightsDeal) {
                return;
            }
            var dow = this.$filter('date')(sel.HotelDeal.CheckInDate, 'EEE');
            var priceVariation = (sel.HotelDeal.Price + sel.FlightsDeal.Price) -
                (orig.HotelDeal.Price + orig.FlightsDeal.Price);
            this.analytics.track('mixpanel', 'HolidayDealsSelected', {
                DurationChanged: originalTimes.Duration !== sel.Duration,
                DateChanged: originalTimes.DepartureEpoch !== sel.DepartureEpoch,
                FlightChanged: orig.FlightsDeal.FlightId !== sel.FlightsDeal.FlightId,
                RoomChanged: orig.selectedRoom.MasterId !== sel.selectedRoom.MasterId,
                BoardTypeChanged: orig.selectedBoardType.BoardType !== sel.selectedBoardType.BoardType,
                PriceVariation: priceVariation,
                DayOfWeek: dow
            });
        };
        HolidayDeals.prototype._getSummaryElements = function (params) {
            var nights = this.resourceService
                .get(params.duration === 1 ? 'NIGHT' : 'NIGHTS').toLowerCase();
            var adults = this.resourceService
                .get(params.occupancy.Adults === 1 ? 'ADULT' : 'ADULTS');
            var children = this.resourceService
                .get(params.occupancy.ChildAges.length === 1 ? 'CHILDREN' : 'CHILDREN');
            return { nights: nights, adults: adults, children: children };
        };
        HolidayDeals.prototype._findDeals = function (findParams, filters, includeAggregates, params) {
            if (params === void 0) { params = undefined; }
            if (this.runningRequest && includeAggregates) {
                this.runningRequest.resolve('CANCELLED');
                this.runningRequest = this.$q.defer();
            }
            if (!params) {
                params = this.deserialiseParameters();
            }
            var flexibility = angular.isUndefined(findParams.flexibility)
                ? params.flexibility : findParams.flexibility;
            var request = {
                DatesAndDurations: this._getDatesAndDurations(params.startDate, params.duration, flexibility),
                Adults: params.occupancy[0].Adults,
                ChildAges: params.occupancy[0].ChildAges,
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                OriginAirports: params.depAir,
                FieldFlags: findParams.fieldFlags,
                FilterCriteria: filters,
                SortCriterion: findParams.sort,
                Paging: findParams.paging,
                IncludeAggregates: includeAggregates,
                IncludeCruises: findParams.includeCruises,
                DiscountedPricesOnly: findParams.discountedPricesOnly,
                Destination: findParams.destination
            };
            return this.$http.post(findParams.url, request, { timeout: this.runningRequest.promise })
                .then(function (res) {
                res.req = request;
                res.params = params;
                res.filters = filters;
                return res;
            });
        };
        HolidayDeals.prototype._enrichProducts = function (products, request) {
            var _this = this;
            return products
                .filter(function (p) { return p.IsCruise || p.HolidayDeals; })
                .map(function (p) { return p.IsCruise ? _this._enrichCruise(p) : _this.enrichHotel(p, request); });
        };
        HolidayDeals.prototype._enrichCruise = function (cruise) {
            cruise.PricePerPerson =
                cruise.DealMinPrice / this.occupancyService.getNumberOfNonInfantPassengers();
            cruise.BoardType = this.resourceService.get(this.filtering.getBoardTypeName(cruise.CheapestBoardType));
            return cruise;
        };
        HolidayDeals.prototype._getDatesAndDurations = function (date, duration, flexibility) {
            var _this = this;
            var cutoffDate = this.dateUtil.todayPlus(2);
            return _(_.range(-(flexibility), flexibility + 1))
                .map(function (x) { return _this.dateUtil.addDays(date, x); })
                .filter(function (date) { return date > cutoffDate; })
                .map(function (date) { return ({
                Date: _this.dateUtil.serialiseDate(date),
                Duration: duration
            }); })
                .value();
        };
        return HolidayDeals;
    }());
    TR.HolidayDeals = HolidayDeals;
    angular
        .module('TR')
        .service('holidayDeals', HolidayDeals);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var HolidayDealsGrouped = /** @class */ (function () {
        function HolidayDealsGrouped($http, $location, $filter, $q, dateUtil, resourceService, imageService, occupancyService, fieldGroupService, filtering, pageStrand, tripService, hotelService, analytics, flightSearch, geo, holidayDeals, preferences) {
            var _this = this;
            this.$http = $http;
            this.$location = $location;
            this.$filter = $filter;
            this.$q = $q;
            this.dateUtil = dateUtil;
            this.resourceService = resourceService;
            this.imageService = imageService;
            this.occupancyService = occupancyService;
            this.fieldGroupService = fieldGroupService;
            this.filtering = filtering;
            this.pageStrand = pageStrand;
            this.tripService = tripService;
            this.hotelService = hotelService;
            this.analytics = analytics;
            this.flightSearch = flightSearch;
            this.geo = geo;
            this.holidayDeals = holidayDeals;
            this.preferences = preferences;
            this.find = _.memoize(function (options) { return _this._find(options); }, function (options) { return angular.toJson(options).replace(/\W/g, ''); });
        }
        HolidayDealsGrouped.prototype._find = function (_a) {
            var _this = this;
            var destinations = _a.destinations, dealsPerDestination = _a.dealsPerDestination, startDate = _a.startDate, duration = _a.duration, occupancy = _a.occupancy, depAir = _a.depAir, flexibility = _a.flexibility;
            if (!destinations || !dealsPerDestination || !startDate
                || !duration || !occupancy || !depAir) {
                return this.$q.reject();
            }
            var getByDestinationsRequest = {
                Destinations: destinations,
                DealsPerDestination: dealsPerDestination,
                DatesAndDurations: this.getDates(startDate, duration, flexibility),
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                Adults: occupancy[0].Adults,
                ChildAges: occupancy[0].ChildAges || [],
                OriginAirports: depAir,
                DirectFlightsOnly: false,
                DiscountedPricesOnly: true,
                FieldFlags: this.getFieldGroup(),
                SortCriterion: 1,
            };
            return this.$http.post('/api/holidays/deals/getbydestinations', getByDestinationsRequest)
                .then(function (res) {
                return res.data;
            })
                .then(function (dealsForManyDestinations) {
                _.each(dealsForManyDestinations, function (dealsForADestination) {
                    _.each(dealsForADestination, function (deal) {
                        _this.holidayDeals.enrichHotel(deal, { Duration: duration });
                    });
                });
                return dealsForManyDestinations;
            });
        };
        HolidayDealsGrouped.prototype.getDates = function (StartDate, Duration, Flexibility) {
            var _this = this;
            var pad = function (x) {
                x = x + '';
                if (x.length === 1) {
                    x = '0' + x;
                }
                return x;
            };
            var cutOffDate = this.dateUtil.todayPlus(2);
            var dates;
            if (angular.isNumber(Flexibility)) {
                var offsets = _.range(-Flexibility, Flexibility + 1);
                dates = _(offsets).map(function (offset) { return _this.dateUtil.addDays(StartDate, offset); });
            }
            else {
                var year_1 = StartDate.getFullYear();
                var month_1 = pad(StartDate.getMonth() + 1);
                var endOfMonth = month_1 === '02' ? 29 : 31;
                var days = _.range(1, endOfMonth);
                dates = _(days).map(function (day) { return _this.dateUtil.parseDate(year_1 + "-" + month_1 + "-" + pad(day)); });
            }
            return dates
                .filter(function (date) { return date > cutOffDate; })
                .map(function (date) { return _this.dateUtil.serialiseDate(date); })
                .map(function (date) { return ({
                Date: date,
                Duration: Duration
            }); })
                .value();
        };
        HolidayDealsGrouped.prototype.getFieldGroup = function () {
            return this.fieldGroupService.getFieldGroup(Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.Url, Core.FieldType.Description, Core.FieldType.Summary, Core.FieldType.HolidayDeals, Core.FieldType.LegacyFacilities, Core.FieldType.Weather, Core.FieldType.Distances, Core.FieldType.Recommendations, Core.FieldType.Airports, Core.FieldType.TransferTimes);
        };
        return HolidayDealsGrouped;
    }());
    TR.HolidayDealsGrouped = HolidayDealsGrouped;
    angular
        .module('TR')
        .service('holidayDealsGrouped', HolidayDealsGrouped);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var HolidayDealsPromoService = /** @class */ (function () {
        function HolidayDealsPromoService($q, $filter, $location, holidayDeals, destinationService, analytics, filtering, occupancyService, resourceService, dateUtil, currencyService) {
            this.$q = $q;
            this.$filter = $filter;
            this.$location = $location;
            this.holidayDeals = holidayDeals;
            this.destinationService = destinationService;
            this.analytics = analytics;
            this.filtering = filtering;
            this.occupancyService = occupancyService;
            this.resourceService = resourceService;
            this.dateUtil = dateUtil;
            this.currencyService = currencyService;
            this.DEST_IMGS =
                "https://d2f0rb8pddf3ug.cloudfront.net/api2/destination/images/getfromobject";
            this.ALL_IMGS =
                "https://s3-eu-west-1.amazonaws.com/trp-content/.co.uk/web";
        }
        HolidayDealsPromoService.prototype.getInfoPromo = function () {
            var _this = this;
            var params;
            return this.holidayDeals.getFullParameters(true, { startDate: this._getNextMonth() })
                .then(function (p) {
                params = p;
                return _.head(p.depAir);
            })
                .then(this.destinationService.getAirport)
                .then(function (airport) {
                var plus = _.size(params.depAir) > 1 ? " (+" + _.size(params.depAir) + ")" : '';
                return {
                    summary: {
                        occupancy: _this._buildOccupancyString(params.occupancy),
                        month: _this.$filter('date')(params.startDate, 'MMMM yyyy'),
                        duration: params.duration,
                        airport: "" + airport.Title + plus,
                    },
                    blocks: _this._getBlocks(params.duration)
                };
            });
        };
        HolidayDealsPromoService.prototype._getBlocks = function (duration) {
            var num = this.occupancyService.getNumberOfNonInfantPassengers() * duration;
            var _a = _.map(TRPCONFIG.Domain.HolidayDealsPromoPrices || [',50', '50,95', '95,'], function (p) { return _(p)
                .split(',')
                .map(function (x) { return (x ? parseInt(x, 10) : 0) * num; })
                .value(); }), min = _a[0], mid = _a[1], high = _a[2];
            var cSymbol = this.currencyService.getSymbol(TRPCONFIG.Domain.CurrencyCode);
            this._adjustPriceRange(min, mid, high);
            return {
                budget: [
                    {
                        label: 'HOLIDAYDEALSPROMOSHOW',
                        img: this.ALL_IMGS + "/promo_everything.png",
                        name: 'PriceRange',
                        value: null,
                        group: 'budget'
                    },
                    {
                        label: String.format(this.resourceService.get('UPTOX'), "" + cSymbol + min[1]),
                        img: this.ALL_IMGS + "/promo_low_budget.png",
                        name: 'PriceRange',
                        value: (min[0] || '') + "," + (min[1] || ''),
                        group: 'budget',
                        type: 'low'
                    },
                    {
                        label: "" + cSymbol + mid[0] + " - " + cSymbol + mid[1],
                        img: this.ALL_IMGS + "/promo_mid_budget.png",
                        name: 'PriceRange',
                        value: (mid[0] || '') + "," + (mid[1] || ''),
                        group: 'budget',
                        type: 'mid'
                    },
                    {
                        label: " " + cSymbol + high[0] + "+",
                        img: this.ALL_IMGS + "/promo_high_budget.png",
                        name: 'PriceRange',
                        value: (high[0] || '') + "," + (high[1] || ''),
                        group: 'budget',
                        type: 'high'
                    }
                ],
                type: [
                    {
                        label: 'SEO_BEACH',
                        img: this.ALL_IMGS + "/promo_beach.png",
                        name: 'FacilityCodes',
                        value: 'HB',
                        group: 'type'
                    },
                    {
                        label: 'DEALSCITYROUTENAME',
                        img: this.ALL_IMGS + "/promo_city.png",
                        name: 'FacilityCodes',
                        value: 'HT',
                        group: 'type'
                    },
                    TRPCONFIG.Domain.HolidayDealsCruisesEnabled
                        ? {
                            label: 'MENUCRUISE',
                            img: this.ALL_IMGS + "/promo_cruise.png",
                            name: 'PropertyTypes',
                            value: '5',
                            group: 'type'
                        }
                        : {
                            label: 'FAMILY',
                            img: this.ALL_IMGS + "/promo_family.png",
                            name: 'FacilityCodes',
                            value: 'HF',
                            group: 'type'
                        },
                    {
                        label: 'LANDINGPAGEATTRACTIONSACTIVITIES_NIGHTLIFE',
                        img: this.ALL_IMGS + "/promo_nightlife.png",
                        name: 'FacilityCodes',
                        value: 'HN',
                        group: 'type'
                    },
                    {
                        label: 'SPARELAXATION',
                        img: this.ALL_IMGS + "/promo_spa.png",
                        name: 'FacilityCodes',
                        value: 'SP',
                        group: 'type'
                    },
                    {
                        label: 'ROMANTIC',
                        img: this.ALL_IMGS + "/promo_romantic.png",
                        name: 'FacilityCodes',
                        value: 'HC',
                        group: 'type'
                    },
                    {
                        label: 'ACTIVITY',
                        img: this.ALL_IMGS + "/promo_activity.png",
                        name: 'FacilityCodes',
                        value: 'HA',
                        group: 'type'
                    },
                    {
                        label: 'FARAWAY',
                        img: this.ALL_IMGS + "/promo_far_away.png",
                        name: 'ChildDestinations',
                        value: TRPCONFIG.Domain.HolidayDealsPromoDestinations,
                        group: 'type'
                    },
                ]
            };
        };
        HolidayDealsPromoService.prototype._buildOccupancyString = function (occ) {
            var o = _.first(occ);
            var childNum = _.size(occ.ChildAges);
            var adults = o.Adults + " " + this.resourceService.get(o.Adults === 1 ? 'ADULT' : 'ADULTS');
            var children = childNum + " " + this.resourceService.get(childNum === 1 ? 'CHILD' : 'CHILDREN');
            return childNum === 0 ? adults : adults + " " + children;
        };
        HolidayDealsPromoService.prototype._adjustPriceRange = function (min, mid, high) {
            var priceRange = _.get(this.$location.search(), 'PriceRange');
            if (!priceRange) {
                return;
            }
            var newPriceRange = _.startsWith(priceRange, ',') ? min : _.endsWith(priceRange, ',') ? high : mid;
            this.$location.search('PriceRange', (newPriceRange[0] || '') + "," + (newPriceRange[1] || ''));
        };
        HolidayDealsPromoService.prototype._getNextMonth = function () {
            var today = new Date();
            var month = today.getMonth();
            var year = month === 11 ? today.getFullYear() + 1 : today.getFullYear();
            month = month === 11 ? 0 : month + 1;
            return new Date(year, month, 15, 0, 0, 0, 0);
        };
        return HolidayDealsPromoService;
    }());
    angular
        .module('TR')
        .service('holidayDealsPromoService', HolidayDealsPromoService);
})(TR || (TR = {}));
var Core;
(function (Core) {
    var HolidaySearch = /** @class */ (function () {
        function HolidaySearch(searchUnitService, occupancyService, $http) {
            this.searchUnitService = searchUnitService;
            this.occupancyService = occupancyService;
            this.$http = $http;
            this.searchUrl = '/api/holidays/createsearch';
            this.adjustUrl = '/api/holidays/adjusthoteldates';
        }
        HolidaySearch.prototype.getRequest = function (parameters) {
            return {
                DepartureAirports: this.searchUnitService.getDepartureAirports(),
                DepartureDate: this.searchUnitService.startDate(this.searchUnitService.flight),
                ReturnDate: this.searchUnitService.endDate(this.searchUnitService.flight),
                Destination: this.searchUnitService.getDestination(),
                Rooms: this.occupancyService.getOccupancy(),
                Cabin: this.searchUnitService.getCabin(),
                PreferredCarrierCodes: _.get(parameters, 'prefilterAirlines', []),
                IsDirectFlight: !!_.get(parameters, 'prefilterDirectFlights'),
                DomainId: TRPCONFIG.Domain.DomainId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                ArrivalAirports: this.searchUnitService.getArrivalAirports()
            };
        };
        HolidaySearch.prototype.createSearch = function (parameters) {
            return this.$http.post(this.searchUrl, this.getRequest(parameters));
        };
        HolidaySearch.prototype.adjustHotelDates = function (HotelSearchId, dates) {
            return this.$http.post(this.adjustUrl, _.defaults({ HotelSearchId: HotelSearchId }, dates))
                .then(function (_a) {
                var data = _a.data;
                return data;
            });
        };
        return HolidaySearch;
    }());
    angular
        .module('TR')
        .service('holidaySearch', HolidaySearch);
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelRehydrator', hotelRehydrator);
    function hotelRehydrator(fieldFilterParser, $routeParams, $http, arrayUtil, imageService, $q, $filter, tripService, hotelFromSession, fieldGroupService) {
        var service = {
            hotels: hotels,
            hotel: hotel,
            staticHotel: staticHotel
        };
        var fieldTypes = fieldGroupService.getFieldTypes();
        var fieldFlags = fieldGroupService.getFieldGroup([
            fieldTypes.Global,
            fieldTypes.Titles,
            fieldTypes.IndicativePrice,
            fieldTypes.ReviewSnippets,
            fieldTypes.Url,
            fieldTypes.Summary,
            fieldTypes.Recommendations
        ]);
        function hotel(id) {
            if ($routeParams.tripId) {
                return tripService.getTrip($routeParams.tripId).then(function (trip) {
                    return hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, id, $routeParams.tripId);
                });
            }
            return staticHotel(id);
        }
        function staticHotel(id, ignoreErrors) {
            var dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
            return hotels([id], { imageWidth: dim, imageHeight: dim }, ignoreErrors).then(function (data) {
                return data[0];
            });
        }
        function hotels(ids, options, ignoreErrors) {
            options = angular.extend({ imageWidth: 80, imageHeight: 80, cropImage: false }, options);
            if (ids == null || ids.length === 0) {
                return $q.when([]);
            }
            return $http.post("/api/hotels/static/gethotelsbyid?" + fieldFilterParser.parse(options), {
                Ids: ids,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                FieldFlags: fieldFlags
            }, { ignoreErrors: !!ignoreErrors }).then(function (result) {
                return arrayUtil.map(result.data, function (hotel) {
                    hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, options.imageWidth, options.imageHeight, options.cropImage);
                    hotel.TeaserStr = $filter('roundedCurrency')(hotel.IndicativeMinPrice);
                    return hotel;
                });
            });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelResolver', hotelResolver);
    function hotelResolver(recentHotels, hotelService, $route, tripService, basketStore) {
        var service = {
            resolve: resolve
        };
        function resolve(includeRooms) {
            var tripId = $route.current.params.tripId;
            var estabId = parseInt($route.current.params.estabId);
            recentHotels.set(estabId);
            return tripService.restoreSearchUnit(tripId).then(function (trip) {
                if (trip && trip.HotelsRequest) {
                    var promise = hotelService.getHotel(includeRooms ? trip.HotelsRequest.AvailabilitySearchId : null, estabId, tripId);
                    var calculateTotalCost_1 = function (hotelInfo, costAggregator) {
                        hotelInfo.Rooms.forEach(function (rr) {
                            rr.Availability.forEach(costAggregator);
                            rr.selected = rr.Availability[0].Id;
                        });
                        return hotelInfo;
                    };
                    if (TRPCONFIG.Domain.PackagePrice && trip.FlightsRequest && trip.FlightsRequest.SelectedFlight) {
                        return promise.then(function (hotelInfo) {
                            return basketStore.flightCost(trip.BasketId).then(function (flightCost) {
                                return calculateTotalCost_1(hotelInfo, function (a) { return a.TotalCost = a.Cost + flightCost / hotelInfo.Rooms.length; });
                            });
                        });
                    }
                    return promise.then(function (hotelInfo) {
                        return calculateTotalCost_1(hotelInfo, function (a) { return a.TotalCost = a.Cost; });
                    });
                }
            });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelSearch', hotelSearch);
    function hotelSearch(loggingService, hotelFilterQueryStringParser, preferences, $routeParams, $http, roundedCurrencyFilter, arrayUtil, guidService, localStorageProvider, $q, cookieService, fieldGroupService, occupancyService, searchUnitService, destinationService, hotelSearchValidator, hotelService, FilterUtils, imageService, broker, $location, cancellerService, tripService, $timeout, sortCriteria, criteoService, FilterIdUtils, $rootScope, currentDestination, objectTypeService, resourceService, bd4travel, holidaySearch, analytics, abTest, fidParser, taxationService, flightDetail, analyticsTracker) {
        var service = {
            pruneRequest: pruneRequest,
            clearSearchResults: clearSearchResults,
            bitFilterSet: bitFilterSet,
            buildHotelsRequest: buildHotelsRequest,
            createSearch: createSearch,
            filter: filter,
            filterSet: filterSet,
            getAvailabilityRequest: getAvailabilityRequest,
            getDestinationEstabId: getDestinationEstabId,
            getDestinationTitle: getDestinationTitle,
            getOccupancySummary: getOccupancySummary,
            getFilter: getFilter,
            getFilterLazy: getFilterLazy,
            getUserSelectedFilterCriteria: getUserSelectedFilterCriteria,
            getSearchResults: getSearchResults,
            getStaticSearchResults: getStaticSearchResults,
            getSortCriteria: getSortCriteria,
            getSortCriterionDescription: getSortCriterionDescription,
            createMultiDestHolidaySearch: createMultiDestHolidaySearch,
            getTripForSelectedMultiDestHoliday: getTripForSelectedMultiDestHoliday,
            getPromotionTerms: getPromotionTerms,
            getFlightDetailsForSelectedMultiDestHoliday: getFlightDetailsForSelectedMultiDestHoliday,
            getUrl: getUrl,
            initialise: initialise,
            page: page,
            pageSize: pageSize,
            pageIndex: pageIndex,
            rangeFilterSet: rangeFilterSet,
            removeArrayFilter: removeArrayFilter,
            removeFiltersIn: removeFiltersIn,
            removeFilter: removeFilter,
            resetArrayFilter: resetArrayFilter,
            resetBitFilter: resetBitFilter,
            resetFilters: resetFilters,
            resetRangeFilter: resetRangeFilter,
            setAirportCodeFilter: setAirportCodeFilter,
            sort: sort,
            validateSearchCriteria: validateSearchCriteria,
            updateFilterFromFid: updateFilterFromFid,
            estabGroupFilterAvailable: estabGroupFilterAvailable,
            getMandatoryExtra: getMandatoryExtra
        };
        var domain = TRPCONFIG.Domain;
        var url = '/api/hotels/availability/';
        var staticUrl = '/api/hotels/static/';
        var results = null;
        var aggregatesCache;
        var inProgress;
        var inProgressStatic;
        var adjustingInProgress = $q.when();
        var canceller;
        var filterCanceller;
        var creatingSearch;
        var sortCriteriaDef = sortCriteria.getHotelCriteria();
        var filterUtil = new FilterUtils(_initialFilterCriteria());
        var filterDefer = $q.defer();
        var qs = $location.search();
        var usedIds = {};
        var req = {
            CultureCode: domain.CultureCode,
            DomainId: domain.DomainId,
            CurrencyCode: searchUnitService.getCurrency(),
            Paging: {
                Index: qs.pi || 0,
                Size: 8
            },
            IncludeAggregates: true
        };
        var fieldType = fieldGroupService.getFieldTypes();
        var availabilitySearchFlags = [
            fieldType.Global,
            fieldType.Titles,
            fieldType.ReviewSnippets,
            fieldType.Url,
            fieldType.Summary,
            fieldType.Pricing,
            fieldType.Recommendations,
            fieldType.EstabGroupIds,
            fieldType.HotelAwards,
            fieldType.RoomAvailability,
        ];
        var staticSearchFlags = [
            fieldType.Global,
            fieldType.Titles,
            fieldType.IndicativePrice,
            fieldType.ReviewSnippets,
            fieldType.Url,
            fieldType.Summary,
            fieldType.Recommendations,
            fieldType.EstabGroupIds,
            fieldType.HotelAwards
        ];
        broker.subscribe('hotelSearch', 'searchDatesAdjusted', function (ev) {
            if (canceller != null) {
                canceller.resolve('searchDatesAdjusted');
                inProgress = null;
                canceller = null;
            }
            rerun();
            function rerun() {
                service.clearSearchResults(true);
                if (filterCanceller) {
                    filterCanceller.resolve();
                }
                adjustingInProgress = tripService.getHotelsRequest(ev.data.tripId).then(function (request) {
                    holidaySearch.adjustHotelDates(request.AvailabilitySearchId, ev.data.dates).then(function (AvailabilitySearchId) {
                        service.buildHotelsRequest(_.defaults({ AvailabilitySearchId: AvailabilitySearchId }, ev.data.dates, _.pick(request, ['CheckInDate', 'CheckOutDate', 'Destination'])), searchUnitService.flight);
                        tripService.recordHotelSearch(ev.data.tripId, getAvailabilityRequest());
                    });
                });
            }
        });
        function _initialFilterCriteria() {
            return angular.extend(_defaultFilterCriteria(), hotelFilterQueryStringParser.parse());
        }
        function _setInProgress(val, stat) {
            if (stat) {
                inProgressStatic = val;
            }
            else {
                inProgress = val;
            }
        }
        function _setResults(val, stat) {
            if (!stat) {
                results = val;
            }
        }
        function estabGroupFilterAvailable() {
            return FilterIdUtils.estabGroupFilterAvailable(service.getFilter());
        }
        function updateFilterFromFid() {
            var fid = fidParser.parse();
            if (fid != null) {
                return FilterIdUtils.lookupFid(fid).then(function (f) {
                    $rootScope.canonicalSuffix = f && f.Canonical ? "?fid=" + fid : '';
                    filterUtil = new FilterUtils(angular.extend(filterUtil.getFilter(), f));
                });
            }
            //no fid so nothing to do
            return $q.when();
        }
        function _defaultFilterCriteria() {
            var existing = filterUtil ? getFilter() : null;
            var newFilter = {
                AirportCode: null,
                Stars: [],
                PropertyTypes: [],
                BoardTypes: [],
                FacilityCodes: [],
                HotelName: '',
                PriceRange: null,
                HolidayPriceRange: null,
                RatingRange: null,
                EstabGroupIds: [],
                EstabGroupName: null,
                FilterByEstabGroup: false,
                ChildDestinations: [],
                OnlyShowAvailable: true
            };
            if (existing && existing.AirportCode) {
                newFilter.AirportCode = existing.AirportCode;
            }
            return newFilter;
        }
        function getUserSelectedFilterCriteria() {
            //when filtering we should only pass the items a user has set, but we also want to
            //take care to not modify the actual filter object, so return a modified
            //copy of the filter
            var filterCopy = angular.copy(getFilter());
            if (aggregatesCache != null) {
                filterUtil.setToNullIfMatches(filterCopy, 'PriceRange', aggregatesCache);
                filterUtil.setToNullIfMatches(filterCopy, 'HolidayPriceRange', aggregatesCache);
                filterUtil.setToNullIfMatches(filterCopy, 'RatingRange', aggregatesCache);
                results && results.SearchCompletePercentage < 100 && _.assignIn(filterCopy, {
                    PriceRange: null,
                    RatingRange: null,
                    HolidayPriceRange: null
                });
            }
            //correctly set the estab group property of the copied filter also
            FilterIdUtils.updateEstabGroupProperties(filterCopy);
            return filterCopy;
        }
        function setAirportCodeFilter(code) {
            var f = getFilter();
            if (f.AirportCode !== code) {
                results = null; //we will need to re-run the results to filter by the new airport code
            }
            f.AirportCode = code;
        }
        function mergeFacilitiesFilters(aggregates) {
            aggregates.MergedHotelsByFacility = {};
            for (var group in aggregates.HotelsByFacility) {
                angular.extend(aggregates.MergedHotelsByFacility, aggregates.HotelsByFacility[group]);
            }
            return aggregates;
        }
        function enrichData(hotels, currency, isKidsFree) {
            var kidsFreeEnabled = isKidsFree &&
                (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);
            var numPeoplePaying = kidsFreeEnabled
                ? occupancyService.getOnlyPayingIndividuals()
                : occupancyService.getNumberOfNonInfantPassengers();
            angular.forEach(hotels, function (hotel) {
                var dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
                hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, dim, dim, true);
                hotel.MinCostStr = roundedCurrencyFilter(hotel.MinCost, currency);
                hotel.MinCostPerPerson = hotel.MinCost / (numPeoplePaying || 1);
                hotel.MinCostPerPersonStr = roundedCurrencyFilter(hotel.MinCostPerPerson, currency);
                hotel.OriginalCostStr = roundedCurrencyFilter(hotel.OriginalCost, currency);
                hotel.OriginalCostPerPerson = hotel.OriginalCost / (numPeoplePaying || 1);
                hotel.OriginalCostPerPersonStr = roundedCurrencyFilter(hotel.OriginalCostPerPerson, currency);
                hotel.HasReviewSnippets = !_.isEmpty(hotel.ReviewSnippets);
                hotel.TeaserStr = roundedCurrencyFilter(hotel.IndicativeMinPrice);
            });
            broker.publish('hotelsReturnedFromSearch', hotels);
        }
        function setSortCriterion(d, k, newSearch, so) {
            if (so != null) {
                return $q.when(so);
            }
            if (k != null && d.EstablishmentId <= 0) {
                switch (k.toLowerCase()) {
                    case 'tr':
                        return $q.when(2);
                    case 'bh':
                        return $q.when(5);
                    case 'lh':
                        return $q.when(8);
                }
            }
            return preferences.getHotelSortOrder(newSearch);
        }
        function resetFilters(dontApply) {
            var f = _defaultFilterCriteria();
            filterUtil = new FilterUtils(f);
            filterDefer = $q.defer();
            //make sure that when we resetAll filters we don't splat any estab group filter completely, just remove the ids
            FilterIdUtils.updateEstabGroupProperties(f);
            if (!dontApply) {
                return service.filter();
            }
            return $q.when();
        }
        function removeArrayFilter(filterName, item) {
            filterUtil.removeArrayFilter(filterName, item);
            return service.filter();
        }
        function resetArrayFilter(filterName) {
            filterUtil.resetArrayFilter(filterName);
            return service.filter();
        }
        function resetBitFilter(filterName) {
            filterUtil.resetBitFilter(filterName);
            return service.filter();
        }
        function removeFiltersIn(filterName, vals) {
            filterUtil.removeFiltersIn(filterName, vals);
            return service.filter();
        }
        function resetRangeFilter(filterName, range) {
            if (results != null) {
                var resetFrom = abTest.progressiveHotelSearchEnabled() ? null : results.Aggregates;
                filterUtil.resetRangeFilter(results, resetFrom, filterName, range);
            }
            return service.filter();
        }
        function removeFilter(filterName) {
            filterUtil.removeFilter(filterName);
            return service.filter();
        }
        function filterSet(filterName) {
            return filterUtil.filterSet(filterName);
        }
        function bitFilterSet(filterName) {
            return filterUtil.bitFilterSet(filterName);
        }
        function rangeFilterSet(filterName, range) {
            if (!results) {
                return false;
            }
            return filterUtil.rangeFilterSet(results, results.Aggregates, filterName, range);
        }
        function pageSize() {
            return req.Paging.Size;
        }
        // getter/setter
        function pageIndex(pi) {
            var key = 'hotelSearch-pageIndex';
            if (arguments.length === 0) {
                return localStorageProvider.getItem(key)
                    .then(function (item) {
                    if (item && item.path === $location.path() && $location.search().disablePaging !== '1') {
                        return item.pi;
                    }
                    return parseInt(req.Paging.Index);
                });
            }
            req.Paging.Index = pi;
            return localStorageProvider.setItem(key, {
                path: $location.path(),
                pi: pi,
            });
        }
        function validateSearchCriteria() {
            return hotelSearchValidator.validate(searchUnitService.getDestination(), searchUnitService.startDate(searchUnitService.hotel), searchUnitService.endDate(searchUnitService.hotel), searchUnitService.getSearchArea(searchUnitService.hotel), occupancyService.getOccupancy());
        }
        function getDestinationEstabId() {
            return currentDestination.getCurrentDestination().then(function (dest) {
                return dest &&
                    dest.EstablishmentId
                    ? dest.EstablishmentId
                    : dest.Type === 1
                        ? dest.Id
                        : 0;
            });
        }
        function getDestinationTitle() {
            return currentDestination.getCurrentDestination().then(function (dest) {
                return dest ? dest.SummaryTitle : '';
            });
        }
        function getOccupancySummary() {
            return occupancyService.getRoomOccupancyString();
        }
        function _checkSearchId(r) {
            if (usedIds[r.AvailabilitySearchId]) {
                loggingService.logWarn("DUPLICATESEARCHID: " + r.AvailabilitySearchId + " has been used before");
            }
            else {
                usedIds[r.AvailabilitySearchId] = true;
            }
        }
        function pruneRequest(r) {
            return _.assignIn(_.omit(r, 'Destination'), {
                Destination: _.pick(r.Destination, 'Id', 'Type'),
                StreamPrices: abTest.progressiveHotelSearchEnabled(true)
            });
        }
        function createSearch() {
            if (req.SearchArea) {
                req.SortCriterion = 4;
                creatingSearch = doSearch();
                return creatingSearch;
            }
            creatingSearch = setSortCriterion(req.Destination, $location.search().k, true, $location.search().sortOrder)
                .then(function (s) { req.SortCriterion = s; })
                .then(doSearch);
            return creatingSearch;
            function doSearch() {
                if (!TRPCONFIG.Domain.HotelAvailabilitySearchIdHashing) {
                    _checkSearchId(req);
                }
                analyticsTracker.resetStatus(false);
                canceller = cancellerService.add(/^\/holidays\/flights\/\w+/, /^\/hotels\/\w+/, /^\/holidays\/hotels\/\w+/);
                var prunedReq = pruneRequest(req);
                return $http.post(url + "createsearch", prunedReq, { timeout: canceller.promise })
                    .then(function (result) {
                    creatingSearch = null;
                    canceller = null;
                    broker.publish('hotelSearchCreated', req.AvailabilitySearchId);
                    req.AvailabilitySearchId = result && result.data;
                    tripService.recordHotelSearch(req.TripId, req);
                    return req.AvailabilitySearchId;
                }, function (res) {
                    inProgress = null;
                    canceller = null;
                    if (res.status === 400) {
                        $location.path('error');
                    }
                    if (res.status === 404) {
                        $location.path('hotels/notfound');
                    }
                });
            }
        }
        function buildHotelsRequest(request, mode) {
            req.AvailabilitySearchId = request && request.AvailabilitySearchId
                || !TRPCONFIG.Domain.HotelAvailabilitySearchIdHashing && guidService.uuid();
            req.Destination = _getDestination(request);
            req.TripId = request && request.TripId || guidService.uuid();
            req.Rooms = request && request.Rooms || occupancyService.getOccupancy();
            req.CurrencyCode = request && request.CurrencyCode || searchUnitService.getCurrency();
            req.CheckInDate = request && request.CheckInDate || searchUnitService.startDate(mode);
            req.CheckOutDate = request && request.CheckOutDate || searchUnitService.endDate(mode);
            req.Paging.Index = 0;
            req.SearchArea = searchUnitService.getSearchArea();
            req.IsFlightPlus = (request && request.IsFlightPlus);
        }
        function _getDestination(request) {
            var dest = request && request.Destination || searchUnitService.getDestination();
            return dest ? angular.extend(dest, objectTypeService.getObjectTypeAndId(dest)) : null;
        }
        function updateSortCriterion() {
            if (req.SortCriterion == null || !TRPCONFIG.IsMobileView) {
                return preferences.getHotelSortOrder().then(function (s) { return req.SortCriterion = s; });
            }
            return $q.when();
        }
        function search(options) {
            options = angular.merge({
                fidCheck: false,
                stat: false,
                refreshRankingScores: false
            }, options);
            var currentInProgress = options.stat ? inProgressStatic : inProgress;
            if (currentInProgress != null) {
                return currentInProgress;
            }
            //TODO - now that we are paging the data we should add a cache of pages by availability Id so
            //that if we revisit a page we have already asked for we don't have to go to the server.
            //Must remember to clear the cache if the filter or sort criteria are changed.
            var start = new Date().getTime();
            var interval = 1000;
            var timeout = 60000;
            var d = $q.defer();
            var notfound = {
                410: errorPath,
                404: function () {
                    var now = new Date().getTime();
                    if (now - start < timeout) {
                        $timeout(get, interval); //recurse
                        return true; //to indicate that the error condition has been handled (for now)
                    }
                    errorPath();
                }
            };
            function errorPath() {
                var supportedProducts = TRPCONFIG.Domain.SupportedProductNames.map(function (p) { return p.toLowerCase(); });
                var hotelsPathSupported = supportedProducts.indexOf('hotels') > -1;
                _setInProgress(null, options.stat);
                hotelsPathSupported
                    ? $location.path('hotels/notfound')
                    : $location.path('holidays/notfound');
                d.reject();
            }
            _setInProgress(d.promise, options.stat);
            hotelFilterQueryStringParser.format(getUserSelectedFilterCriteria());
            if (!options.stat && creatingSearch != null) {
                return creatingSearch.then(get);
            }
            return updateSortCriterion().then(function () { return get(options.fidCheck); });
            function get(fidCheck) {
                return $q.all([
                    tripService.getCurrency($routeParams.tripId),
                    currentDestination.getCurrentDestination(),
                    tripService.isKidsFree($routeParams.tripId),
                    tripService.getTrip($routeParams.tripId)
                ]).then(function (result) {
                    var trip = result[3];
                    var isMultiDestHoliday = Boolean(trip && trip.TripType === tripService.tripTypes.MultiDestHoliday);
                    filterCanceller = cancellerService.add(/^\/holidays\/flights\/\w+/, /^\/hotels\/\w+/, /^\/holidays\/hotels\/\w+/);
                    filterCanceller.promise.then(function () {
                        _setInProgress(null, options.stat);
                    });
                    if (result[1]) {
                        var objectTypeAndId = objectTypeService.getObjectTypeAndId(result[1]);
                        req.DestinationType = objectTypeAndId.Type;
                        req.DestinationId = objectTypeAndId.Id;
                        if ($location.search().bfd) {
                            req.DestinationType = 1;
                            req.DestinationId = $location.search().bfd;
                        }
                        if (result[1].PageStrand) {
                            req.PageStrand = result[1].PageStrand;
                        }
                    }
                    req.AllowIncompleteResults = abTest.progressiveHotelSearchEnabled();
                    req.CurrencyCode = result[0] || TRPCONFIG.Domain.CurrencyCode;
                    req.FieldFlags = fieldGroupService.getFieldGroup(req.AvailabilitySearchId && !options.stat ? availabilitySearchFlags : staticSearchFlags);
                    req.DiscountCode = TRPCONFIG.DiscountCode;
                    req.TripId = $routeParams.tripId;
                    req.RefreshRankingScores = options.refreshRankingScores;
                    req.EnableTracking = !analyticsTracker.isCounted() && analyticsTracker.isEnabled();
                    req.AddMeetAndGreet = TRPCONFIG.Domain2.AddMeetAndGreet;
                    var intermediateRes;
                    pageIndex()
                        .then(function (pi) {
                        req.Paging.Index = pi;
                        var notStaticSearch = req.AvailabilitySearchId && !options.stat;
                        var _url;
                        if (isMultiDestHoliday) {
                            _url = '/api/holidays/getmultidestinationsearchresults';
                            req.PlacementId = 'jan-sale';
                        }
                        else if (notStaticSearch) {
                            _url = url + "gethotels";
                        }
                        else {
                            _url = staticUrl + "gethotelsbydestination?fieldsX=Hotels.MinCost,Hotels.OriginalCost";
                        }
                        var reqCopy = angular.copy(req);
                        if (notStaticSearch && qs.selectedEstabId) {
                            var selId = parseInt(qs.selectedEstabId);
                            if (!isNaN(selId)) {
                                reqCopy.SelectedEstabId = selId;
                            }
                        }
                        delete reqCopy.Destination;
                        _(reqCopy.FilterCriteria).forEach(function (value, key) {
                            if (value == null || value === false || value.length === 0) {
                                delete reqCopy.FilterCriteria[key];
                            }
                        });
                        if (isMultiDestHoliday) {
                            // Airport Code filter from prev search causes no results
                            reqCopy.FilterCriteria = _.omit(reqCopy.FilterCriteria, 'AirportCode');
                        }
                        return $http.post(_url, reqCopy, {
                            timeout: filterCanceller.promise,
                            customErrCallback: notfound
                        });
                    }).then(function (response) {
                        intermediateRes = response;
                        intermediateRes.data.Hotels = _.map(intermediateRes.data.Hotels, function (hotel, i) {
                            if (intermediateRes.data.Hotels && intermediateRes.data.Hotels[i].RequestedRooms && intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices) {
                                var taxObj = {
                                    TotalAmount: intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices[0].CityTax,
                                    CityTaxLocalAmount: intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices[0].CityTaxLocalAmount,
                                    CurrencyCode: intermediateRes.data.Hotels[i].RequestedRooms[0].BoardTypeMinPrices[0].CityTaxLocalCurrency
                                };
                                _.merge(hotel, { Taxation: taxObj });
                            }
                            analyticsTracker.resetStatus(false);
                            return hotel;
                        });
                        return intermediateRes;
                    }, function () { return intermediateRes; }).then(function (res) {
                        enrichData(res.data.Hotels, req.CurrencyCode, !!result[2]);
                        if (!options.stat && res.data.Aggregates) {
                            res.data.Aggregates = mergeFacilitiesFilters(res.data.Aggregates);
                            //PriceRange.Min will be having only multiples of 10.
                            res.data.Aggregates.LowestPricedHotel = res.data.Aggregates.PriceRange.Min;
                            res.data.Aggregates.PriceRange.Max = Math.ceil(res.data.Aggregates.PriceRange.Max / 10) * 10;
                            res.data.Aggregates.PriceRange.Min = Math.floor(res.data.Aggregates.PriceRange.Min / 10) * 10;
                            if (!abTest.progressiveHotelSearchEnabled() && !isMultiDestHoliday) {
                                filterUtil.copyFilterFrom('RatingRange', res.data.Aggregates);
                                filterUtil.copyFilterFrom('PriceRange', res.data.Aggregates);
                                filterUtil.copyFilterFrom('HolidayPriceRange', res.data.Aggregates);
                            }
                            //we don't currently allow filtering on each individual estab group, so squash the data
                            res.data.Aggregates.HotelsByGroup = FilterIdUtils.createEstabGroupOptions(res.data.Aggregates.HotelsByGroup);
                            //Add board type title to aggregates
                            addTitleToBoardTypes(res.data.Aggregates.HotelsByBoardType);
                        }
                        var currentResults = res.data;
                        _setResults(currentResults, options.stat);
                        //Save the aggregates in their own variable, so that they arn't lost when results is nulled out.
                        aggregatesCache = currentResults.Aggregates;
                        d.resolve(currentResults);
                        if (!currentResults.Hotels.length && fidCheck && !options.stat) {
                            var filteredFilter = FilterIdUtils.sanitiseFidFilters(angular.copy(filterUtil.getFilter()), angular.copy(currentResults.Aggregates), _defaultFilterCriteria());
                            if (filteredFilter) {
                                loggingService.logWarn("Wrong filters in fid " + $location.search().fid);
                                filterUtil = new FilterUtils(filteredFilter);
                                req.FilterCriteria = getUserSelectedFilterCriteria();
                                return get();
                            }
                        }
                        var filterData = service.getFilter();
                        filterDefer.resolve(filterData);
                        currentResults.Filters = filterData;
                        currentResults.SortCriterion = sortCriteria.getHotelSortValueById(req.SortCriterion);
                        _setInProgress(null, options.stat);
                        broker.publish('hotelResultsModified', _.assign({}, currentResults, {
                            searchTriggeredBy: options.searchTriggeredBy
                        }));
                        if (!options.ignoreTracking) {
                            analytics.track('Event', 'HotelList', currentResults);
                            tripService.getTrip($routeParams.tripId)
                                .then(function (trip) {
                                var tripType = trip && trip.TripType ||
                                    (_.get(searchUnitService.getDestination(), 'PageStrand') === 2 ? 4 : 2);
                                criteoService.enqueue(currentResults, 'hotellist', tripType);
                                bd4travel.trackHotelResults(trip, currentResults, req);
                            });
                        }
                        var noUserClicksRank = _.size(_.filter(_.get(currentResults, 'Hotels'), function (h) { return _.get(h, 'UserClicksRank'); }));
                        var noRecommended = _.size(_.filter(_.get(currentResults, 'Hotels'), function (h) { return _.get(h, 'Recommended'); }));
                        var familyFriendlyOffered = _.some(_.get(currentResults, 'Hotels'), function (h) { return _.includes(h.EstabGroupIds, TRPCONFIG.Domain.FamilyFriendlyEstabGroup); });
                        var winnerOffered = _.some(_.get(currentResults, 'Hotels'), function (h) { return _.has(h, 'HotelAward'); });
                        setTimeout(function () {
                            analytics.track('mixpanel', 'HotelListing', {
                                RepeatHotelOffered: noUserClicksRank > 0,
                                TopDealsOffered: noRecommended > 0,
                                WinnerOffered: winnerOffered,
                                NoRepeatHotelsOffered: noUserClicksRank,
                                NoTopDealsOffered: noRecommended,
                                FamilyFavouriteOffered: familyFriendlyOffered,
                                IsKidsPromoEligible: !!result[2],
                                IsJanSale: isMultiDestHoliday,
                                estabIDArray: _.map(currentResults.Hotels, function (h) { return h.Id; }),
                                ppPriceArray: _.map(currentResults.Hotels, function (h) { return h.MinCostPerPerson; }),
                                TotalPriceArray: _.map(currentResults.Hotels, function (h) { return h.MinCost; }),
                                SearchID: $routeParams.tripId,
                            });
                        });
                    }, function () {
                        _setInProgress(null, options.stat);
                        return $q.reject();
                    });
                    return options.stat ? inProgressStatic : inProgress;
                });
            }
        }
        function page(index) {
            return this.pageIndex(index)
                .then(function () {
                req.FilterCriteria = getUserSelectedFilterCriteria();
                return search();
            });
        }
        function sort(criterion) {
            broker.publish('searchCriteriaModified');
            req.FilterCriteria = getUserSelectedFilterCriteria();
            results = null;
            return preferences.setHotelSortOrder(criterion)
                .then(function (fidCheck) { return search({
                fidCheck: fidCheck,
                refreshRankingScores: true,
                searchTriggeredBy: 'sort'
            }); });
        }
        function filter() {
            filterCanceller && filterCanceller.resolve();
            broker.publish('searchCriteriaModified');
            req.FilterCriteria = getUserSelectedFilterCriteria();
            _trackHotelName(_.get(req.FilterCriteria, 'HotelName'));
            results = null;
            return pageIndex(0)
                .then(function () { return search({
                refreshRankingScores: true,
                searchTriggeredBy: 'filter'
            }); });
        }
        function initialise(baseUrl) {
            url = baseUrl;
        }
        function getAvailabilityRequest() {
            return req;
        }
        function getUrl() {
            return url;
        }
        function clearSearchResults(setDefaultCriteria, setPostsCountByCountryId) {
            var qs = $location.search();
            filterUtil = new FilterUtils(setDefaultCriteria ? _defaultFilterCriteria() : _initialFilterCriteria());
            filterDefer = $q.defer();
            req.Paging.Index = qs.pi || 0;
            req.Paging.Size = setPostsCountByCountryId ? 12 : 8;
            results = null;
            return this;
        }
        function getSearchResults(searchId, options) {
            var qs = $location.search();
            if (results && searchId === results.AvailabilitySearchId) {
                broker.publish('hotelResultsRetrieved', results);
                return $q.when(results);
            }
            //we don't want to clear filters at this point, but need to clear the page index and results
            req.Paging.Index = qs.pi || 0;
            results = null;
            if (creatingSearch == null) {
                req.AvailabilitySearchId = searchId;
            }
            req.FilterCriteria = getUserSelectedFilterCriteria();
            return adjustingInProgress.then(function () { return search({
                ignoreTracking: !!_.get(options, 'ignoreTracking'),
                refreshRankingScores: true
            }); });
        }
        function getStaticSearchResults() {
            var qs = $location.search();
            //we don't want to clear filters at this point, but need to clear the page index and results
            req.Paging.Index = qs.pi || 0;
            return search({
                stat: true
            });
        }
        function createMultiDestHolidaySearch(basketId, variant) {
            var Domain = (TRPCONFIG || {}).Domain;
            return $http.post('/api/holidays/createjansalesearch', {
                BasketId: basketId,
                DomainId: Domain.DomainId,
                CultureCode: Domain.CultureCode,
                CurrencyCode: Domain.CurrencyCode,
                Variant: variant
            })
                .then(function (res) { return res && res.data; });
        }
        function getTripForSelectedMultiDestHoliday(tripId, hotel) {
            return tripService.getTrip(tripId)
                .then(function (trip) {
                var linkedFlight = hotel.LinkedFlight;
                var flightsRequest = _.find(trip.MultiDestinationFlightRequests, function (r) { return r.AvailabilitySearchId === hotel.LinkedFlight.FlightSearchId; });
                var newTripId = guidService.uuid();
                // Update trip with linked flight details
                flightsRequest.SelectedDepartureAirport = {
                    Code: linkedFlight.OutboundLeg.DepartureAirport
                };
                flightsRequest.SelectedDestinationAirport = {
                    Code: linkedFlight.InboundLeg.DepartureAirport
                };
                var newTrip = Object.assign(trip, {
                    TripId: newTripId,
                    FlightsRequest: flightsRequest
                });
                return destinationService.getDetails({ Id: hotel.Id, Type: 1 })
                    .then(function (dest) { return newTrip.HotelsRequest.Destination = dest; })
                    .then(function () { return tripService.persist(newTripId, newTrip); })
                    .then(function () { return newTripId; });
            });
        }
        function getFlightDetailsForSelectedMultiDestHoliday(tripId, hotel) {
            var linkedFlight = hotel.LinkedFlight;
            return flightDetail.getFlightDetails(tripId, {
                AvailabilitySearchId: linkedFlight.FlightSearchId,
                FlightId: linkedFlight.FlightId,
                IncludeSeatPlan: TRPCONFIG.DeviceSettings.SeatPlanEnabled,
                MultiSector: false
            }).then(function (details) {
                var flight = details.Itinerary;
                if (flight) {
                    flight.FlightId = linkedFlight.FlightId; // See holidaySearchCtrl.js
                    flight.DetailsId = details.DetailsId;
                    flight.isMultiDestHolidayLinked = true;
                }
                return flight;
            });
        }
        function getFilter() {
            return filterUtil.getFilter();
        }
        function getFilterLazy() {
            return filterDefer.promise;
        }
        function getSortCriteria() {
            return sortCriteriaDef;
        }
        function getSortCriterionDescription() {
            return preferences.getHotelSortOrder().then(function (so) {
                var i = arrayUtil.indexOf(sortCriteriaDef, function (c) {
                    return c.val === so || (angular.isArray(c.val) && c.val.indexOf(so) !== -1);
                });
                return sortCriteriaDef[i].name();
            });
        }
        function addTitleToBoardTypes(boardTypes) {
            var boardTypeStrings = {
                1: 'ROOMONLY',
                2: 'BEDANDBREAKFAST',
                3: 'HALFBOARD',
                4: 'FULLBOARD',
                5: 'ALLINCLUSIVE',
                6: 'SELFCATERING',
            };
            for (var p in boardTypes) {
                boardTypes[p].Title = resourceService.getDeferred(boardTypeStrings[p])();
            }
        }
        function getPromotionTerms() {
            return $http.get("/api/hotels/pricing/promotionterms?domainId=" + TRPCONFIG.Domain.DomainId)
                .then(function (res) { return res.data; });
        }
        function _trackHotelName(name) {
            if (name) {
                analytics.track('mixpanel', 'HotelNameFilter');
            }
        }
        function getMandatoryExtra(hotel) {
            var hasMandatoryExtras = false;
            if (domain.MandatoryExtrasEnabled) {
                if (hotel && hotel.RequestedRooms && hotel.RequestedRooms.length > 0) {
                    hotel.RequestedRooms[0].BoardTypeMinPrices.map(function (room) {
                        var roomWithMandatoryExtras = room.IncludedExtras && room.IncludedExtras.find(function (el) { return el.ExtraTypeId === '2'; });
                        return roomWithMandatoryExtras ? hasMandatoryExtras = true : null;
                    });
                }
            }
            return hasMandatoryExtras;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelSearchValidator', hotelSearchValidator);
    function hotelSearchValidator(resourceService, dateUtil, occupancyService) {
        var domain = TRPCONFIG.Domain;
        var service = {
            validateTimeOfDay: validateTimeOfDay,
            validate: validate
        };
        function dateFromRegexMatch(match) {
            var now = new Date();
            return match ? new Date(now.getFullYear(), now.getMonth(), now.getDate(), match[1], match[2]) : null;
        }
        function matchFromConfigString(cfg) {
            return /^([0-9]{2}):([0-9]{2})$/.exec(cfg);
        }
        var dateFromConfig = _.flowRight(dateFromRegexMatch, matchFromConfigString);
        function validateTimeOfDay(departureDate) {
            var now = new Date();
            var msg = null;
            if (dateUtil.sameDay(now, departureDate)) {
                var start = dateFromConfig(domain.SameDaySearchStart);
                var end = dateFromConfig(domain.SameDaySearchEnd);
                if (start && end) {
                    if (now > end || now < start) {
                        return String.format(resourceService.get('SAMEDAYBOOKINGOUTOFRANGE'), domain.SameDaySearchStart, domain.SameDaySearchEnd);
                    }
                }
                else if (start) {
                    if (now < start) {
                        return String.format(resourceService.get('SAMEDAYBOOKINGTOEARLY'), domain.SameDaySearchStart);
                    }
                }
                else if (end) {
                    if (now > end) {
                        return String.format(resourceService.get('SAMEDAYBOOKINGTOLATE'), domain.SameDaySearchEnd);
                    }
                }
            }
            return msg;
        }
        function validate(destination, departureDate, returnDate, searchArea, occupancy) {
            var errors = [];
            if (_.isEmpty(destination) && searchArea == null) {
                errors.push(resourceService.get('SELECTDESTINATION'));
            }
            if (destination && destination.Searchable === false) {
                errors.push(String.format(resourceService.get('NONSEARCHABLE'), destination.Title));
            }
            if (departureDate == null) {
                errors.push(resourceService.get('SELECTCHECKIN'));
            }
            else {
                var timeValidation = service.validateTimeOfDay(departureDate);
                if (timeValidation) {
                    errors.push(timeValidation);
                }
                var now = new Date();
                var zNow = dateUtil.zeroTime(now).getTime();
                var zDep = dateUtil.zeroTime(departureDate).getTime();
                if (zDep < zNow) {
                    errors.push(resourceService.get('CHECKINCANNOTBEPAST'));
                }
            }
            if (returnDate == null) {
                errors.push(resourceService.get('SELECTCHECKOUT'));
            }
            if (returnDate != null && departureDate != null && returnDate <= departureDate) {
                errors.push(resourceService.get('CHECKOUTAFTERCHECKIN'));
            }
            if (!occupancyService.childAgesPopulated(occupancy)) {
                errors.push(resourceService.get('CHILDAGESERROR'));
            }
            return errors;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelsSitemap', hotelsSitemap);
    function hotelsSitemap($location, searchUnitService, fieldGroupService, destinationService, $http) {
        var service = {
            getHotels: getHotels,
            getSize: getSize
        };
        var domain = TRPCONFIG.Domain;
        var req = {
            CultureCode: domain.CultureCode,
            DomainId: domain.DomainId,
            CurrencyCode: searchUnitService.getCurrency(),
            Paging: {
                Index: 0,
                Size: 100
            },
            IncludeAggregates: true
        };
        var fieldType = fieldGroupService.getFieldTypes();
        var staticSearchFlags = [
            fieldType.Global,
            fieldType.Titles,
            fieldType.IndicativePrice,
            fieldType.ReviewSnippets,
            fieldType.Url,
            fieldType.Summary,
            fieldType.Recommendations,
            fieldType.EstabGroupIds,
            fieldType.HotelAwards
        ];
        function getHotels(path, pageNum) {
            var _url = '/api/hotels/static/gethotelsbydestination';
            return destinationService.fromUrl(path)
                .then(function (data) {
                req.Paging.Index = pageNum !== undefined ? pageNum : 0;
                req.DestinationId = data.LegacyId;
                req.DestinationType = data.LegacyType;
                req.PageStrand = data.PageStrand;
                req.FieldFlags = fieldGroupService.getFieldGroup(staticSearchFlags);
                return req;
            })
                .then(function (req) {
                return $http.post(_url, req)
                    .then(function (res) {
                    return res.data;
                });
            });
        }
        function getSize() {
            return req.Paging.Size;
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var InsuranceSearchValidator = /** @class */ (function () {
        function InsuranceSearchValidator(resourceService, dateUtil) {
            this.resourceService = resourceService;
            this.dateUtil = dateUtil;
        }
        InsuranceSearchValidator.prototype.validate = function (policyType, travelDestination, startDate, endDate, occupancy) {
            var errors = [];
            if (policyType == null) {
                errors.push(this.resourceService.get('SELECTPOLICYTYPE'));
            }
            if (travelDestination == null) {
                errors.push(this.resourceService.get('SELECTTRAVELDESTINATION'));
            }
            if (startDate == null) {
                errors.push(this.resourceService.get('SELECTSTARTDATE'));
            }
            if (endDate == null) {
                errors.push(this.resourceService.get('SELECTENDDATE'));
            }
            else if (endDate <= startDate) {
                errors.push(this.resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
            }
            if (startDate && endDate &&
                this.dateUtil.compareDates(endDate, this.dateUtil.addDays(startDate, 365, true)) === 1) {
                errors.push(this.resourceService.get('RETURNDATEWITHINONEYEAR'));
            }
            /*  It has been said that breaking nested loops with labels is the worst way to break loops
            except all the others that have been tried.  ~MV */
            /* eslint-disable no-labels */
            childOccupancyLoop: for (var ca = occupancy.ChildAges.length - 1; ca >= 0; ca--) {
                if (occupancy.ChildAges[ca] == null) {
                    errors.push(this.resourceService.get('CHILDAGESERROR'));
                    break childOccupancyLoop;
                }
            }
            adultOccupancyLoop: for (var i = occupancy.AdultAges.length - 1; i >= 0; i--) {
                if (occupancy.AdultAges[i] == null) {
                    errors.push(this.resourceService.get('ADULTAGESERROR'));
                    break adultOccupancyLoop;
                }
            }
            /* eslint-enable no-labels */
            return errors;
        };
        return InsuranceSearchValidator;
    }());
    TR.InsuranceSearchValidator = InsuranceSearchValidator;
    angular
        .module('TR')
        .service('insuranceSearchValidator', InsuranceSearchValidator);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .service('mandatoryTransferService', mandatoryTransferService);
    function mandatoryTransferService($filter) {
        var service = {
            generateMandatoryOptions: generateMandatoryOptions,
            addFlightDetails: addFlightDetails,
            getTransfers: getTransfers,
            findSelectedTransfer: findSelectedTransfer,
            generateOptionId: generateOptionId,
            getRoomsWithTransfers: getRoomsWithTransfers,
            generateOptionsForMultiRooms: generateOptionsForMultiRooms,
            getOptions: getOptions,
            addDeltas: addDeltas,
            getSelectedPrices: getSelectedPrices,
            getSelectedTransfers: getSelectedTransfers,
            getHolidayRoomsWithTransfers: getHolidayRoomsWithTransfers,
            getBookedTransfersPrice: getBookedTransfersPrice
        };
        var FlightDetails;
        var Options;
        var mandatoryTransferTypeId = 23;
        function generateMandatoryOptions(roomId, flightDetails) {
            FlightDetails = flightDetails;
            Options = flightDetails.options || [{ OptionId: generateOptionId(roomId, flightDetails.transfer.HotelExtraId, flightDetails.transfer.HotelExtraOptionId) }];
        }
        function addFlightDetails(connectingFlight) {
            var fd = FlightDetails;
            var cf = connectingFlight;
            if (fd && cf && cf.InboundDate && cf.OutboundDate) {
                cf.InboundDate = _setTime(cf.InboundDate, fd.departureTime.hours, fd.departureTime.minutes);
                cf.OutboundDate = _setTime(cf.OutboundDate, fd.arrivalTime.hours, fd.arrivalTime.minutes);
                cf.InboundFlightNumber = fd.inboundFlightNum;
                cf.OutboundFlightNumber = fd.outboundFlightNum;
            }
            return cf;
        }
        function getTransfers(extras) {
            if (extras === void 0) { extras = []; }
            var transfers = [];
            extras && extras.forEach(function (item) {
                if (item && item.IsMandatory && item.HotelExtraTypeId === '2') {
                    var HotelExtraId_1 = item.HotelExtraId;
                    var options = item.Options || [];
                    if (options.length > 0) {
                        options.forEach(function (value) {
                            value.HotelExtraId = HotelExtraId_1;
                            transfers.push(value);
                        });
                    }
                }
            });
            return transfers;
        }
        function findSelectedTransfer(transfers, includedExtras) {
            if (transfers === void 0) { transfers = []; }
            if (includedExtras === void 0) { includedExtras = []; }
            var transfer;
            var includedTransfer;
            includedExtras.forEach(function (inclExt) {
                if (inclExt && inclExt.ExtraTypeId === '2') {
                    includedTransfer = inclExt;
                }
            });
            transfers.forEach(function (item) {
                if (includedTransfer && item && Math.round(includedTransfer.ClientPrice) === Math.round(item.GrossCost)
                    && includedTransfer.Title === item.Title) {
                    transfer = item;
                }
            });
            return transfer;
        }
        function getRoomsWithTransfers(hotel, roomGridData, selectedPrices) {
            var selectedRooms = [];
            var _loop_4 = function (i) {
                var selectedRoom = (hotel.Rooms[i].FilteredAvailability || hotel.Rooms[i].Availability)
                    .find(function (item) { return item.Id === selectedPrices["id" + i]; });
                selectedRoom = selectedRoom.BoardOptions.find(function (item) { return item.Id === selectedPrices["id" + i]; });
                selectedRoom.roomId = roomGridData[i].Id;
                selectedRoom.roomNumber = roomGridData[i].Id.match(/\d+/)[0];
                selectedRoom.roomTitle = "Room " + (parseInt(selectedRoom.roomNumber) + 1);
                selectedRoom.nonInfants = roomGridData[i].nonInfants;
                selectedRoom.mandatoryTransfers = getTransfers(selectedRoom.Extras) || [];
                if (selectedRoom.mandatoryTransfers.length > 0) {
                    selectedRooms.push(selectedRoom);
                }
            };
            for (var i = 0; i < hotel.Rooms.length; i++) {
                _loop_4(i);
            }
            return selectedRooms;
        }
        function getHolidayRoomsWithTransfers(hotel) {
            var selectedRooms = [];
            if (hotel.BookedItems) {
                for (var i = 0; i < hotel.BookedItems.length; i++) {
                    var includedTransfer = getTransfers(hotel.AvailableExtrasPerRoom[i]);
                    if (hotel.BookedItems[i] && Object.keys(includedTransfer).length !== 0) {
                        var roomWithTransfer = Object.assign(hotel.BookedItems[i]);
                        roomWithTransfer.roomNumber = "id" + i;
                        roomWithTransfer.roomTitle = "Room " + (i + 1);
                        roomWithTransfer.nonInfants = roomWithTransfer.Adults;
                        roomWithTransfer.mandatoryTransfers = includedTransfer;
                        selectedRooms.push(roomWithTransfer);
                    }
                }
            }
            return selectedRooms;
        }
        function generateOptionId(roomNumberId, HotelExtraId, HotelExtraOptionId) {
            if (roomNumberId === void 0) { roomNumberId = '0id'; }
            var hotelExtra = 'HotelExtra';
            var roomNumberIdPrefix = 'id';
            var roomNumber = +roomNumberId.split(roomNumberIdPrefix).pop();
            return hotelExtra + "|" + roomNumber + "|" + HotelExtraId + "|" + HotelExtraOptionId;
        }
        function generateOptionsForMultiRooms(flightDetails, rooms) {
            if (rooms === void 0) { rooms = []; }
            var options = [];
            for (var i = 0; i < rooms.length; i++) {
                var option = {};
                var hotelExtraId = flightDetails && flightDetails.transfers && flightDetails.transfers[i] && flightDetails.transfers[i].HotelExtraId;
                var hotelExtraOptionId = flightDetails && flightDetails.transfers && flightDetails.transfers[i] && flightDetails.transfers[i].HotelExtraOptionId;
                option.OptionId = generateOptionId(rooms[i].roomNumber, hotelExtraId, hotelExtraOptionId);
                options.push(option);
            }
            return options;
        }
        function getOptions() {
            return Options;
        }
        function addDeltas(transfers, cheapestTransfer) {
            return transfers.map(function (t) {
                t.deltaPrice = t.GrossCost - cheapestTransfer.GrossCost;
                return t;
            });
        }
        function _setTime(date, hours, minutes) {
            date = new Date(date);
            date.setMinutes(minutes);
            date.setHours(hours);
            return $filter('date')(date, 'yyyy-MM-ddTHH:mm:ss');
        }
        function getSelectedPrices(hotelData, bookedHotelData) {
            var selectedPrices = {};
            if (hotelData.Rooms) {
                var _loop_5 = function (i) {
                    var roomDescription = bookedHotelData.Details.BookedItems[i].RoomDescription;
                    if (hotelData.Rooms && hotelData.Rooms.length > 0) {
                        hotelData.Rooms[i].Availability.map(function (room) {
                            if (room.RoomDescription === roomDescription) {
                                selectedPrices["id" + i] = room.Id;
                            }
                            return selectedPrices;
                        });
                    }
                };
                for (var i = 0; i < hotelData.Rooms.length; i++) {
                    _loop_5(i);
                }
            }
            return selectedPrices;
        }
        function getSelectedTransfers(hotel, rooms) {
            var bookedTransfers = [];
            hotel.CostBreakdown.map(function (item) {
                if (item.TypeId === mandatoryTransferTypeId) {
                    bookedTransfers.push(item);
                }
                return bookedTransfers;
            });
            var _loop_6 = function (i) {
                bookedTransfers[i] = rooms[i].mandatoryTransfers.find(function (item) { return item.GrossCost === bookedTransfers[i].UnitAmount; });
            };
            for (var i = 0; i < bookedTransfers.length; i++) {
                _loop_6(i);
            }
            return bookedTransfers;
        }
        function getBookedTransfersPrice(costBreakdown) {
            var transfersCost = 0;
            costBreakdown && costBreakdown.map(function (item) {
                if (item.TypeId === mandatoryTransferTypeId) {
                    transfersCost += item.UnitAmount;
                }
                return transfersCost;
            });
            return transfersCost;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('marhabaService', marhabaService);
    function marhabaService(searchUnitService, occupancyService, $http) {
        var url = '/api2/marhaba/';
        var promiseCache = {};
        var service = {
            getProductDetails: getProductDetails,
            rehydrate: rehydrate,
            getMarhabaEnabledTerminals: getMarhabaEnabledTerminals,
            sort: sortMarhabaResults,
            filter: filterMarhabaResults,
            adjustMarhabaOptions: adjustMarhabaOptions
        };
        function getProductDetails(searchId, productId) {
            return $http.post(url + "details/get", { AvailabilitySearchId: searchId, MarhabaQuoteId: productId }).then(function (res) {
                return res.data;
            });
        }
        function rehydrate(productId, searchId) {
            if (promiseCache[productId + searchId]) {
                return promiseCache[productId + searchId];
            }
            promiseCache[productId + searchId] = $http.post(url + "details/getfromsession", { DetailsSearchId: searchId }).then(function (res) {
                var details = res.data || {};
                var occupancy = occupancyService.reduceOccupancy();
                var validChildren = occupancy.ChildAges.filter(function (el) { return el >= 2; }).length;
                details.Date = searchUnitService.startDate(searchUnitService.marhaba);
                details.Terminal = searchUnitService.getTerminal();
                details.maxElements = occupancy.Adults + validChildren;
                return details;
            });
            return promiseCache[productId + searchId];
        }
        function getMarhabaEnabledTerminals(airports) {
            return $http.post(url + "terminals/getforairports", { CultureCode: TRPCONFIG.Domain.CultureCode, Airports: airports });
        }
        function sortMarhabaResults(a, b) {
            var type = a.Type > b.Type ? 1 : a.Type < b.Type ? -1 : 0;
            var price = a.AdultPrice > b.AdultPrice ? 1 : a.AdultPrice < b.AdultPrice ? -1 : 0;
            var name = sortMarhabaResultsName(a, b);
            return type || price || name;
        }
        function sortMarhabaResultsName(a, b) {
            var name = a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0;
            return name;
        }
        function filterMarhabaResults(item) {
            var isLounge = item.Type === 5;
            var isFree = item.AdultPrice === 0;
            if (!isLounge || (isLounge && !isFree)) {
                return item;
            }
        }
        function adjustMarhabaOptions(productInfo, defaultChauffeurName) {
            var result = {};
            if (productInfo.Details.AvailableOptions.length === 0) {
                result.noOptions = true;
            }
            else {
                productInfo.Details.AvailableOptions
                    .sort(sortMarhabaResults)
                    .filter(filterMarhabaResults)
                    .forEach(function (p) {
                    switch (p.Type) {
                        case 3:
                            result.auxillaryProducts = result.auxillaryProducts || [];
                            result.auxillaryProducts.push(p);
                            break;
                        case 4:
                            p.Num = 0;
                            result.chauffeurs = result.chauffeurs || [];
                            result.chauffeurs.push(p);
                            break;
                        case 5:
                            result.lounges = result.lounges || [];
                            result.lounges.push(p);
                    }
                });
                if (result.chauffeurs && result.chauffeurs.length > 0) {
                    result.chauffeurs.sort(sortMarhabaResultsName);
                    result.chauffeurs.unshift({ Id: 0, Name: defaultChauffeurName });
                    result.selectedChauffeur = result.chauffeurs[0];
                }
            }
            return result;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('marhabaSearch', marhabaSearch);
    function marhabaSearch(marhabaSearchValidator, searchUnitService, occupancyService, $http, $q, tripService, analytics) {
        var url = '/api2/marhaba/';
        var domain = TRPCONFIG.Domain;
        var req = {
            CultureCode: domain.CultureCode,
            CurrencyCode: domain.CurrencyCode,
            DomainId: domain.DomainId
        };
        var inProgress;
        var results;
        var service = {
            clearSearchResults: clearSearchResults,
            getSearchResults: getSearchResults,
            search: search,
            validateSearchCriteria: validateSearchCriteria
        };
        function _doRequest(request, newSearch) {
            var simpleRequest = {
                AvailabilitySearchId: request.AvailabilitySearchId,
                CultureCode: request.CultureCode,
                CurrencyCode: request.CurrencyCode,
                DomainId: request.DomainId,
                TerminalId: request.Terminal.Id,
                FlightType: searchUnitService.getMarhabaFlightType(request.FlightType.Id),
                AirportCode: request.Airport.Code,
                DateAndTime: request.DateAndTime,
                Occupancy: request.Occupancy,
                StaffRates: request.StaffRates
            };
            return newSearch ?
                $http.post(url + "availability/get", simpleRequest) :
                $http.post(url + "availability/getfromsession", { AvailabilitySearchId: request.AvailabilitySearchId });
        }
        function _childrenAndInfants(childAges) {
            var numberOf = {};
            numberOf.children = 0;
            numberOf.infants = 0;
            for (var i = childAges.length - 1; i >= 0; i--) {
                if (childAges[i] <= 2) {
                    numberOf.infants++;
                }
                else {
                    numberOf.children++;
                }
            }
            return numberOf;
        }
        function _obtainSearchParameters() {
            req.Terminal = searchUnitService.getTerminal();
            req.FlightType = searchUnitService.getFlightType();
            req.Airport = searchUnitService.getMarhabaAirport();
            req.DateAndTime = searchUnitService.startDate(searchUnitService.marhaba);
            var occupancy = occupancyService.reduceOccupancy();
            var kiddos = _childrenAndInfants(occupancy.ChildAges);
            req.Occupancy = { Adults: occupancy.Adults, Children: kiddos.children, Infants: kiddos.infants, ChildAges: occupancy.ChildAges }; //occupancyService.getOccupancy();
            req.StaffRates = searchUnitService.getStaffRates();
        }
        function _search(newSearch) {
            if (inProgress) {
                return inProgress;
            }
            inProgress = _doRequest(req, newSearch)
                .then(function (res) {
                req.AvailabilitySearchId = res.data.AvailabilitySearchId;
                results = res.data;
                inProgress = null;
                return results;
            }, function () {
                inProgress = null;
                results = null;
            });
            return inProgress;
        }
        function clearSearchResults() {
            results = null;
        }
        function getSearchResults(searchId, trip) {
            return (results && results !== 'null') ? $q.when(results) : service.search({ searchId: searchId, trip: trip });
        }
        function search(args) {
            req.AvailabilitySearchId = args.searchId;
            // programmatically defined parameter
            if (args.parameters) {
                angular.extend(req, args.parameters);
            }
            else if (!args.parameters) {
                if (args.trip) {
                    searchUnitService.restoreMarhabaSearch(args.trip);
                }
                _obtainSearchParameters();
            }
            if (args.newSearch) {
                analytics.track('mixpanel', 'Search', _.extend({}, req, { TypeTitle: 'Marhaba' }));
                tripService.recordMarhabaSearch(args.tripId, _.mapValues(req, function (v, k) { return k === 'FlightType' ? v.Id : v; }));
            }
            return _search(args.newSearch);
        }
        function validateSearchCriteria(parameters) {
            if (parameters) {
                return marhabaSearchValidator.validate(parameters.Terminal, parameters.AirportCode, parameters.DateAndTime, parameters.Occupancy);
            }
            return marhabaSearchValidator.validate(searchUnitService.getTerminal(), searchUnitService.getMarhabaAirport(), searchUnitService.startDate(searchUnitService.marhaba), occupancyService.getOccupancy()[0]);
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('marhabaSearchValidator', marhabaSearchValidator);
    function marhabaSearchValidator(resourceService, dateUtil, occupancyService) {
        var service = {
            validate: validate
        };
        function validate(terminal, airport, date, occupancy) {
            var errors = [];
            var maxPassengers = 9;
            if (!terminal || terminal.Id === 0) {
                errors.push(resourceService.get('VALIDATESELECTTERMINAL'));
            }
            if (!airport) {
                errors.push(resourceService.get('VALIDATESELECTAIRPORT'));
            }
            if (occupancy.Adults + occupancy.ChildAges.length > maxPassengers) {
                errors.push(String.format(resourceService.get('TOOMANYTRANSFERPASSENGERS'), maxPassengers));
            }
            if (!occupancyService.childAgesPopulated(occupancy)) {
                errors.push(resourceService.get('CHILDAGESERROR'));
            }
            if (!dateUtil.atLeastTwoDaysInTheFuture(date)) {
                errors.push(resourceService.get('VALIDATETWODAYSINTHEFUTURE'));
            }
            return errors;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('multiSectorSearch', multiSectorSearch);
    function multiSectorSearch($http, occupancyService, tripService, multiSectorSearchValidator) {
        var url = 'website/flights/';
        var cache = {};
        var service = { search: search, validateSearchCriteria: validateSearchCriteria, getSearchResults: getSearchResults, filter: filter };
        function search(tripId, params) {
            var legs = params.legs;
            var occupancy = occupancyService.getOccupancy()[0];
            var req = {
                Adults: occupancy.Adults,
                AvailabilitySearchId: tripId,
                ChildAges: occupancy.ChildAges,
                Destination: {},
                DomainId: TRPCONFIG.Domain.DomainId,
                FlightRoutes: legs.map(function (leg) { return ({
                    DepartureDate: leg.DepartureDate,
                    DepartureAirport: leg.DepartureAirport.Code,
                    DestinationAirport: leg.DestinationAirport.Code,
                    Cabin: leg.Cabin
                }); })
            };
            tripService.recordMultiFlightSearch(tripId, req);
            var prom = $http.post(url + "multisectorsearch", req)
                .then(function (res) { return res.data; });
            cache[tripId] = prom;
            return prom;
        }
        function validateSearchCriteria(params) {
            return multiSectorSearchValidator.validate(params.legs);
        }
        function getSearchResults(tripId, AvailabilitySearchId) {
            if (tripId in cache) {
                return cache[tripId];
            }
            var prom = filter(AvailabilitySearchId);
            cache[tripId] = prom;
            return prom;
        }
        function filter(availabilitySearchId, filters) {
            var req = {
                AvailabilitySearchId: availabilitySearchId,
                MultiSectorFilterCriteria: {
                    SectorIdentifiers: filters
                }
            };
            return $http.post(url + "multisectorsearchfromsession", req)
                .then(function (res) { return res.data; });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('multiSectorSearchValidator', multiSectorSearchValidator);
    function multiSectorSearchValidator(dateUtil) {
        var service = {
            validate: validate
        };
        function validate(legs) {
            var errors = [];
            var minLegs = 2;
            var maxLegs = 8;
            var minDiffDate = 1;
            if (legs.length < minLegs) {
                errors.push('Not enough legs');
            }
            else if (legs.length > maxLegs) {
                errors.push('Too many legs');
            }
            legs.forEach(function (leg, i) {
                [leg.DepartureAirport, leg.DestinationAirport].forEach(function (airport, j) {
                    if (airport == null || typeof airport !== 'object' || !airport.Code) {
                        errors.push("Leg " + (i + 1) + ": Please select a " + (j ? 'destination' : 'departure') + " airport");
                    }
                    else if (airport.Code.indexOf(',') !== -1) {
                        errors.push("Leg " + (i + 1) + ": Group airports are not supported");
                    }
                });
                if (i !== 0) {
                    var date1 = dateUtil.parseDate(legs[i - 1].DepartureDate);
                    var date2 = dateUtil.parseDate(leg.DepartureDate);
                    var diff = dateUtil.getDifferenceInDays(date1, date2);
                    if (diff < minDiffDate) {
                        errors.push('Flights must happen at least 1 day apart.');
                    }
                }
            });
            return errors;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('pageStrand', pageStrand);
    function pageStrand(urlUtils, $route) {
        var ps = {
            Hotel: 1,
            Holiday: 2,
            Any: 3,
            Flight: 5
        };
        var strandToRoute = {
            1: 'hotels',
            2: 'holidays'
        };
        function adjustUrlV2(url, strand) {
            var parsed = urlUtils.parseIdBasedUrls(url);
            var matches = parsed.idPart.match(/(\d+-\d+)-?(\d+)?/) || [];
            //if the strand param is 1, remove it
            if (strand === ps.Holiday) {
                return matches[1] + "/" + parsed.urlText;
            }
            //if the strand param is absent or something other than 1, add 1 or replace it with 1
            return matches[1] + "-1/" + parsed.urlText;
        }
        return {
            get: function (name) {
                return ps[name];
            },
            opposite: function (strand) {
                return strand === ps.Hotel ? ps.Holiday : ps.Hotel;
            },
            adjustUrl: function (url, strand) {
                if (TRPCONFIG.Domain.UseIdBasedHotelUrls) {
                    return adjustUrlV2(url, strand);
                }
                var parsed = urlUtils.parse(url);
                if (strand === ps.Holiday) {
                    parsed.qs.tm = 1;
                }
                else {
                    delete parsed.qs.tm;
                }
                return urlUtils.format(parsed);
            },
            toRoute: function (strand) {
                return strandToRoute[strand] || 'hotels';
            },
            fromRoute: function (dest) {
                switch ($route.current && $route.current.area) {
                    case 'hotels':
                        return ps.Hotel;
                    case 'holidays':
                        return ps.Holiday;
                    case 'flights':
                        return ps.Flight;
                    default:
                        return dest && dest.PageStrand || ps.Hotel;
                }
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('preferences', preferences);
    function preferences($q, $rootScope, localStorageProvider, preferencesHttpProvider, funcUtil) {
        var service = {
            get: decorate(get),
            set: decorate(set),
            getAllPreferences: decorate(getAllPreferences),
            setAllPreferences: decorate(setAllPreferences),
            clear: clear,
            getFlightSortOrder: getFlightSortOrder,
            setFlightSortOrder: setFlightSortOrder,
            getHotelSortOrder: getHotelSortOrder,
            setHotelSortOrder: setHotelSortOrder
        };
        var defaultPrefs = {
            priceMode: TRPCONFIG.Domain.DefaultPriceMode,
            hotelSortOrder: getDefaultHotelSortOrder(),
            flightSortOrder: getDefaultFlightSortOrder(),
            flightClass: 0,
            smokingRoom: false,
            footerToolbar: true
        };
        var prefsPromise = getAllPreferences();
        var localPrefs = {};
        function get(key) {
            return getAllPreferences().then(function (prefs) { return prefs[key]; });
        }
        function getDefaultHotelSortOrder() {
            return TRPCONFIG.Domain.HotelSearchOrder;
        }
        function getDefaultFlightSortOrder() {
            return TRPCONFIG.Domain.BestFitFlightSelection ? 10 : TRPCONFIG.Domain.FlightsSearchOrder;
        }
        function getFlightSortOrder(initial) {
            if (TRPCONFIG.Domain.SaveSortPreferences) {
                return decorate(get)('flightSortOrder');
            }
            if (initial) {
                localPrefs.flightSortOrder = getDefaultFlightSortOrder();
            }
            return $q.when(localPrefs.flightSortOrder || getDefaultFlightSortOrder());
        }
        function setFlightSortOrder(value) {
            if (TRPCONFIG.Domain.SaveSortPreferences) {
                return decorate(set)('flightSortOrder', value);
            }
            return $q.when(value);
        }
        function getHotelSortOrder(initial) {
            if (TRPCONFIG.Domain.SaveSortPreferences) {
                return decorate(get)('hotelSortOrder');
            }
            if (initial) {
                localPrefs.hotelSortOrder = getDefaultHotelSortOrder();
            }
            return $q.when(localPrefs.hotelSortOrder || getDefaultHotelSortOrder());
        }
        function setHotelSortOrder(value) {
            if (TRPCONFIG.Domain.SaveSortPreferences) {
                return decorate(set)('hotelSortOrder', value);
            }
            localPrefs.hotelSortOrder = value;
            return $q.when(value);
        }
        function set(key, val) {
            return getUser().then(function (user) {
                var defered = [$q.defer(), $q.defer()];
                if (val === null || val === undefined) {
                    preferencesHttpProvider.remove(user, function () { return defered[0].resolve(); }, key);
                    localStorageProvider.remove(function () { return defered[1].resolve(); }, key);
                }
                else {
                    var prefs = {};
                    prefs[key] = val;
                    preferencesHttpProvider.set(user, function () { return defered[0].resolve(); }, prefs);
                    localStorageProvider.set(function () { return defered[1].resolve(); }, prefs);
                }
                return all(defered).then(clear);
            });
        }
        function getAllPreferences() {
            return getUser().then(function (user) {
                var cacheKey = user.UserIdHash || 'no-hash';
                if (prefsPromise && prefsPromise.cacheKey === cacheKey) {
                    return prefsPromise;
                }
                var defered = $q.defer();
                preferencesHttpProvider.get(user, function (prefs) {
                    if (prefs) {
                        defered.resolve(prefs);
                    }
                    else {
                        localStorageProvider.get(function (prefs) { return defered.resolve(prefs); });
                    }
                });
                prefsPromise = defered.promise.then(function (prefs) { return angular.extend({}, defaultPrefs, prefs); });
                prefsPromise.cacheKey = cacheKey;
                return prefsPromise;
            });
        }
        function setAllPreferences(prefs) {
            return getUser().then(function (user) {
                var defered = [$q.defer(), $q.defer()];
                preferencesHttpProvider.set(user, function () { return defered[0].resolve(); }, prefs);
                localStorageProvider.set(function () { return defered[1].resolve(); }, prefs);
                return all(defered).then(clear);
            });
        }
        function all(defered) {
            var promises = _.map(defered, function (d) { return d.promise; });
            return $q.all(promises);
        }
        function clear() {
            prefsPromise = null;
        }
        function getUser() {
            return funcUtil.waitForValue(function () { return $rootScope.user; });
        }
        // Copies all input/output to ensure that the preferences are not accidently mutated.
        function decorate(func) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var argumentsCopy = _.map(args, function (a) { return angular.copy(a); });
                var result = func.apply(service, argumentsCopy);
                return $q.when(result).then(function (r) { return angular.copy(r); });
            };
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var PricingService = /** @class */ (function () {
        function PricingService($http, cookieService) {
            this.$http = $http;
            this.cookieService = cookieService;
            this.domain = TRPCONFIG.Domain;
            this.apiUrl = 'api/hotels/pricing';
        }
        PricingService.prototype.hasActiveVouchers = function () {
            return this.$http.get(this.apiUrl + "/hasActiveVouchers", {
                params: { domainId: this.domain.DomainId }
            }).then(function (response) { return response.data; });
        };
        return PricingService;
    }());
    TR.PricingService = PricingService;
    angular.module('TR').service('pricingService', PricingService);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var PriorityBoardingService = /** @class */ (function () {
        function PriorityBoardingService() {
        }
        PriorityBoardingService.prototype.getPriorityBoardingInfo = function (flight, flightOptions) {
            var oneWayFlight = flight.Details.Itinerary.Legs.length === 1;
            var bothWaysFlight = flight.Details.Itinerary.Legs.length === 2;
            var extras = flight.Details.FlightSectorOptionalExtras;
            var pbInfo = {
                isSelected: false,
                outboundOnly: false,
                inboundOnly: false,
                both: false,
                oneWayFlightPB: false
            };
            if (oneWayFlight) {
                pbInfo.optionDetails = this._getPBOption(extras[0]);
                pbInfo.oneWayFlightPB = Boolean(pbInfo.optionDetails);
            }
            if (bothWaysFlight) {
                pbInfo.outboundOnly = extras.length === 2 && Boolean(this._getPBOption(extras[0]));
                pbInfo.inboundOnly = extras.length === 2 && Boolean(this._getPBOption(extras[1]));
                pbInfo.both = extras.length === 1 && Boolean(this._getPBOption(extras[0]));
                if (pbInfo.outboundOnly || pbInfo.inboundOnly || pbInfo.both) {
                    pbInfo.optionDetails = this._getPBOption(extras[0]) || this._getPBOption(extras[1]);
                }
            }
            if (pbInfo.optionDetails && pbInfo.optionDetails.OptionId) {
                pbInfo.isSelected = Boolean(_.find(flightOptions, ['OptionId', pbInfo.optionDetails.OptionId]));
            }
            return pbInfo;
        };
        ;
        PriorityBoardingService.prototype._getPBOption = function (flightExtra) {
            if (!flightExtra && !flightExtra.OptionalExtras) {
                return;
            }
            var otherOptions = _.find(flightExtra.OptionalExtras, ['Type', 2]);
            if (otherOptions && otherOptions.SingleOptionalExtras && otherOptions.SingleOptionalExtras.length) {
                return _.find(otherOptions.SingleOptionalExtras, ['Type', 'PriorityBoarding']);
            }
        };
        return PriorityBoardingService;
    }());
    TR.PriorityBoardingService = PriorityBoardingService;
    angular
        .module('TR')
        .service('priorityBoardingService', PriorityBoardingService);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .service('recentHotels', recentHotels);
    function recentHotels($http, hotelRehydrator, $window, $timeout, $rootScope, broker) {
        var url = '/api2/recentlyviewedhotels/';
        var defer = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $timeout;
        var promise;
        $rootScope.$on('auth:signout', _clearPromise);
        $rootScope.$on('auth:signin', _clearPromise);
        var service = {
            set: set,
            remove: remove,
            clear: clear,
            get: get,
            getIds: getIds
        };
        function _clearPromise() {
            promise = null;
            broker.publish('recentHotelsModified');
        }
        function set(estabId) {
            if (estabId > 0) {
                defer(function () {
                    $http
                        .post(url + "set", { EstabId: estabId }, { ignoreErrors: true })
                        .then(_clearPromise)
                        .then(function () { return broker.publish('recentHotelAdded', estabId); });
                });
            }
        }
        function remove(estabId) {
            if (estabId > 0) {
                return $http
                    .post(url + "remove", { EstabId: estabId })
                    .then(_clearPromise)
                    .then(function () { return broker.publish('recentHotelRemoved', estabId); });
            }
        }
        function clear() {
            return $http.post(url + "removeall")
                .then(_clearPromise);
        }
        function get() {
            return promise = promise || $http
                .get(url + "get", { ignoreErrors: true })
                .then(function (results) { return hotelRehydrator.hotels(results.data); });
        }
        function getIds() {
            return $http
                .get(url + "get", { ignoreErrors: true })
                .then(function (results) { return results.data; });
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('commonErrors', commonErrors);
    function commonErrors($q, $location, currentUser) {
        var service = {
            0: zero,
            400: fourHundred,
            404: fourOFour,
            401: fourOOne,
            410: fourTen
        };
        function _notFound(data) {
            var area = $location.path().split('/')[1];
            var supportedProducts = TRPCONFIG.Domain.SupportedProductNames.map(function (p) { return p.toLowerCase(); });
            if (data && data.config && data.config.url) {
                logError(data.config.url);
            }
            var areaSupported = supportedProducts.indexOf(area.toLowerCase()) > -1;
            switch (area) {
                case area:
                    areaSupported
                        ? $location.path(area + "/notfound")
                        : $location.path('holidays/notfound');
                    break;
                default:
                    $location.path('holidays/notfound');
            }
        }
        function zero() {
            return $q.reject('CANCELLED');
        }
        function logError(url) {
            var utm = currentUser.get().UtmId;
            $.ajax({
                type: 'POST',
                url: 'website/logging/log',
                contentType: 'application/json',
                data: JSON.stringify({
                    Message: "Customer with utmId " + utm + " received a 404 from " + url,
                    LogLevel: 2 // Warning
                })
            });
        }
        function fourHundred(data) {
            $location.path('error');
            return $q.reject(data);
        }
        function fourOOne(data) {
            var path = $location.path();
            var absUrl = $location.absUrl();
            var redirectUrl = String.format(TRPCONFIG.Domain.AgentLogonUrl, absUrl);
            if (data && data.headers && data.headers()['www-authenticate']) {
                if (data.headers()['www-authenticate'].indexOf('realm="Agent"') > -1 && (path !== '/agents/signin')) {
                    window.location.href = redirectUrl;
                }
            }
            return $q.reject(data);
        }
        function fourOFour(data) {
            _notFound(data);
            return $q.reject(data);
        }
        function fourTen(data) {
            _notFound(data);
            return $q.reject(data);
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('reviewService', reviewService);
    function reviewService($rootScope, $http, $q, arrayUtil, authService, $location) {
        var domain = TRPCONFIG.Domain;
        var url = '/api2/users/reviews/';
        var limit = 1750; //borrowed this limit from the jquery plugin
        var suggestedPageSize = 10; // PageSize should probably be passed as an argument to getReviews()
        var likeTypes = {
            organic: 1,
            postSubmission: 2
        };
        var apiKey;
        var reviewsCache = {};
        var service = {
            getUrl: getUrl,
            getRatingCategories: getRatingCategories,
            getStatements: getStatements,
            getOriginalText: getOriginalText,
            getReviews: getReviews,
            getReviewSnippets: getReviewSnippets,
            setTranslation: setTranslation,
            setSnippetTranslation: setSnippetTranslation,
            setTranslationKey: setTranslationKey,
            getReviewDetails: getReviewDetails,
            getReviewDetailsUsingToken: getReviewDetailsUsingToken,
            likeReview: {
                organic: organicLike,
                postSubmission: postSubmissionLike
            },
            reviewStatus: {
                CannotLeaveReview: 0,
                CanLeaveReview: 1,
                HasLeftReview: 2
            }
        };
        $rootScope.$on('auth:signout', function () {
            _clearCache();
            //remove liked review index from url so refresh won't cause redirection to sign in page
            if ($location.$$search.lr) {
                delete $location.$$search.lr;
                $location.$$compose();
            }
        });
        $rootScope.$on('auth:signin', _clearCache);
        function getUrl() {
            return url;
        }
        function getRatingCategories(cultureCode) {
            return $http.post(url + "getratingcategories", {
                CultureCode: cultureCode
            });
        }
        function getStatements(cultureCode) {
            return $http.post(url + "getstatements", {
                CultureCode: cultureCode
            });
        }
        function getOriginalText(reviewId) {
            return $http.post(url + "getoriginaltext", {
                ReviewId: reviewId
            }, { ignoreErrors: true }).then(function (res) {
                res.data.Comments = htmlifyLineBreaks(res.data.Comments);
                res.data.TopTip = htmlifyLineBreaks(res.data.TopTip);
                return res.data;
            });
        }
        function setTranslationKey(key) {
            apiKey = key;
        }
        function _truncate(val) {
            if (val != null && val.length > limit) {
                return val.substring(0, limit);
            }
            return val;
        }
        function _translate(text, source, target) {
            var googleUrl = 'https://www.googleapis.com/language/translate/v2?';
            text = $.trim(text);
            if (text === '') {
                return $q.when(null);
            }
            return $http.jsonp(googleUrl, {
                params: {
                    key: apiKey,
                    source: source,
                    target: target,
                    q: text,
                    callback: 'JSON_CALLBACK'
                }
            });
        }
        function getTranslatedText(resp) {
            if (resp != null && resp.data != null && resp.data.data != null && resp.data.data.translations && resp.data.data.translations.length > 0) {
                return resp.data.data.translations[0].translatedText;
            }
            return '';
        }
        function setTranslation(review) {
            // truncation is somewhat lame. Can we split the string up into a number of batches possibly, but it would
            // be hard to do that without messing with the meaning of the text. Perhaps breaking it into sentences?
            var promises = [];
            var source = review.CultureCode;
            var target = domain.CultureCode.substring(0, 2);
            promises.push(_translate(_truncate(review.Comments), source, target));
            promises.push(_translate(_truncate(review.TopTip), source, target));
            return $q
                .all(promises)
                .then(function (responses) {
                var result = {
                    Comments: getTranslatedText(responses[0]),
                    TopTip: getTranslatedText(responses[1])
                };
                return $http.post(url + "settranslation", {
                    ReviewId: review.ReviewId,
                    Comments: result.Comments,
                    TopTip: result.TopTip,
                    CultureCode: target
                }, { ignoreErrors: true })
                    .then(function () {
                    return result;
                });
            });
        }
        function setSnippetTranslation(snippet) {
            // Same truncation comment as above, but probably has no impact on a snippet.
            var promises = [];
            var source = snippet.CultureCode;
            var target = domain.CultureCode.substring(0, 2);
            promises.push(_translate(_truncate(snippet.Comments), source, target));
            return $q
                .all(promises)
                .then(function (responses) {
                var result = {
                    Comments: responses[0] != null ? responses[0].data.data.translations[0].translatedText : ''
                };
                return $http.post(url + "setsnippettranslation", {
                    ReviewId: snippet.ReviewId,
                    Comments: result.Comments,
                    CultureCode: target
                }, { ignoreErrors: true })
                    .then(function () {
                    return result;
                });
            });
        }
        function htmlifyLineBreaks(text) {
            return text ? text.replace(/\\n/g, '<br/>').replace(/\n/g, '<br/>') : text;
        }
        function getReviews(hotel, page) {
            var pageSize = suggestedPageSize;
            if (reviewsCache[hotel.Id] == null) {
                reviewsCache[hotel.Id] = {
                    total: hotel.CustomerReviewCount,
                    page: 1,
                    reviews: {}
                };
            }
            var cache = reviewsCache[hotel.Id];
            var d = $q.defer();
            cache.page = page;
            //is this a page that exists?
            if (((page) * pageSize) > cache.total) {
                throw new Error("there is no page " + page);
            }
            function resolve() {
                var remaining = (cache.total - (page + 1) * pageSize);
                d.resolve({
                    reviews: cache.reviews[page],
                    moreReviews: (remaining > pageSize) ? pageSize : Math.max(remaining, 0),
                    page: page
                });
            }
            //have we got the data for this page
            if (cache.reviews[page] != null) {
                resolve();
            }
            else {
                $http.post(url + "getpage", {
                    EstabId: hotel.Id,
                    CultureCode: domain.CultureCode,
                    CountryCode: domain.CountryCode,
                    Paging: {
                        PageIndex: page,
                        PageSize: pageSize
                    },
                    SortCriterion: 0,
                    FilterCriteria: {
                        ExcludeEmptyComments: true
                    }
                }, { ignoreErrors: true }).then(function (res) {
                    cache.reviews[page] = arrayUtil.map(res.data.Reviews, function (review) {
                        review.Comments = htmlifyLineBreaks(review.Comments);
                        review.TopTip = htmlifyLineBreaks(review.TopTip);
                        return review;
                    });
                    resolve();
                }, function () {
                    d.reject();
                });
            }
            return d.promise;
        }
        function getReviewSnippets(hotel, pageIndex, pageSize) {
            return $http.post(url + "getsnippetpage", {
                EstabId: hotel.Id,
                CultureCode: domain.CultureCode,
                Paging: {
                    PageIndex: pageIndex,
                    PageSize: pageSize
                }
            });
        }
        function organicLike(reviewId, like) {
            return _likeReview(reviewId, like, likeTypes.organic);
        }
        function postSubmissionLike(reviewId, like) {
            return _likeReview(reviewId, like, likeTypes.postSubmission);
        }
        function _likeReview(reviewId, like, reviewLikeType) {
            return $http.post(url + "like", {
                ReviewId: reviewId,
                Like: like,
                ReviewLikeType: reviewLikeType,
                ApplicationType: TRPCONFIG.ApplicationType
            }, {
                customErrCallback: function () {
                    return true; //make sure that the default error handling does not occur
                } //Note that we will stay in the error branch
            }).then(null, _errorLike);
            function _errorLike(resp) {
                if (resp.status === 401) {
                    _signIn();
                }
            }
            function _signIn() {
                var url = $location.path() + "?pd=rv&lr=" + reviewId;
                authService.bufferRoute(url);
                $location.url("signin?cb=" + encodeURIComponent(url));
            }
        }
        function _clearCache() {
            reviewsCache = {};
        }
        function getReviewDetailsUsingToken(bookingId, token, userId) {
            return $http.post(url + "user/reviewdetailstoken", { BookingId: bookingId, VerificationToken: token, UserId: userId, CultureCode: domain.CultureCode }).then(function (res) { return res.data; }, function (err) { return _processGetReviewError(err.status); });
        }
        function getReviewDetails(bookingId) {
            return $http.post(url + "user/reviewdetails", { BookingId: bookingId, CultureCode: domain.CultureCode }).then(function (res) { return res.data; }, function (err) { return _processGetReviewError(err.status); });
        }
        function _processGetReviewError(errCode) {
            //we can have a number of different states but just return the correct enum value
            var detail = {
                BookingRef: null,
                CheckInDate: null,
                EstabId: null,
                LeadContact: null,
                ReviewStatus: service.reviewStatus.CannotLeaveReview
            };
            if (errCode === 401) {
                detail.Status = service.reviewStatus.CannotLeaveReview;
            }
            return detail;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('savedSearchService', savedSearchService);
    function savedSearchService(hotelSearchValidator, $http, searchUnitService, dateUtil, occupancyService, resourceService, arrayUtil, $q, $routeParams, broker, $rootScope, analytics, searchTypesService, tripService, unadjustedDateFilter) {
        var url = '/api2/savedsearches/';
        var isPrerender = /prerender/i.test(navigator.userAgent);
        // cached results
        var cachedSearches;
        var cachedSearchTypes = [];
        var searchType = searchTypesService.searchType;
        var supportedSearchTypes = searchTypesService.supportedTypes();
        var title = {
            1: resourceService.getDeferred('FLIGHTS'),
            3: resourceService.getDeferred('HOLIDAYS'),
            2: resourceService.getDeferred('HOTELS'),
            4: resourceService.getDeferred('TRANSFERS'),
            6: resourceService.getDeferred('AIRPORTPARKING'),
            8: resourceService.getDeferred('INSURANCE')
        };
        var fromDateTitle = {
            1: resourceService.getDeferred('DEPART'),
            2: resourceService.getDeferred('CHECKIN'),
            3: resourceService.getDeferred('DEPART'),
            4: resourceService.getDeferred('ARRIVAL'),
            6: resourceService.getDeferred('DROPOFFDATE'),
            8: resourceService.getDeferred('DEPART')
        };
        var toDateTitle = {
            1: resourceService.getDeferred('RETURN'),
            2: resourceService.getDeferred('CHECKOUT'),
            3: resourceService.getDeferred('RETURN'),
            4: resourceService.getDeferred('RETURN'),
            6: resourceService.getDeferred('PICKUPDATE'),
            8: resourceService.getDeferred('RETURN')
        };
        var fromDateField = {
            1: 'DepartureDate',
            2: 'CheckInDate',
            3: 'DepartureDate',
            4: 'ArrivalDate',
            6: 'DepartureDate',
            8: 'DepartureDate'
        };
        var toDateField = {
            1: 'ReturnDate',
            2: 'CheckOutDate',
            3: 'ReturnDate',
            4: 'ReturnDate',
            6: 'ReturnDate',
            8: 'ReturnDate'
        };
        var cabin = {
            1: 'Economy',
            2: 'PremiumEconomy',
            4: 'First',
            8: 'Business'
        };
        $rootScope.$on('auth:signin', function () {
            cachedSearches = null;
        });
        $rootScope.$on('auth:signout', function () {
            cachedSearches = null;
        });
        var service = {
            saveFlightSearch: saveFlightSearch,
            saveHolidaySearch: saveHolidaySearch,
            saveHotelSearch: saveHotelSearch,
            saveTransferSearch: saveTransferSearch,
            saveParkingSearch: saveParkingSearch,
            saveInsuranceSearch: saveInsuranceSearch,
            restoreSearch: restoreSearch,
            getSavedSearches: getSavedSearches,
            removeSavedSearch: removeSavedSearch,
            getCabinType: getCabinType
        };
        function _getFlightSearch(tripId, SearchModel) {
            return $q.all([
                tripService.getTripDestination(tripId),
                tripService.getSelectedDepartureAirport(tripId),
                tripService.getSelectedDestinationAirport(tripId),
                tripService.isOneWayFlightEnabled(tripId),
                tripService.getFlightsRequestDepartureDate(tripId, true),
                tripService.getFlightsRequestReturnDate(tripId, true),
                tripService.getTripReducedOccupancy(tripId)
            ]).then(function (_a) {
                var Destination = _a[0], DepartureAirport = _a[1], DestinationAirport = _a[2], isOneWayFlightEnabled = _a[3], DepartureDate = _a[4], ReturnDate = _a[5], ReducedOccupancy = _a[6];
                var flightSearchRequest = {
                    DepartureAirportTitle: DepartureAirport.Title,
                    Destination: Destination,
                    DestinationAirportTitle: DestinationAirport.Title,
                    DepartureDate: DepartureDate,
                    SearchModel: SearchModel
                };
                if (DepartureAirport.Code) {
                    flightSearchRequest.DepartureAirports = DepartureAirport.Code.split(',');
                }
                // This is a a hacky fix. DestinationAirport can be in two different shapes
                // due to undetermined circumstances (probably search unit configuration)
                var destinationCodes = DestinationAirport.Code ? DestinationAirport.Code : DestinationAirport.DestinationAirports;
                if (destinationCodes) {
                    flightSearchRequest.DestinationAirports = destinationCodes.split(',');
                }
                if (isOneWayFlightEnabled) {
                    flightSearchRequest.OneWayOnly = true;
                }
                else {
                    flightSearchRequest.ReturnDate = ReturnDate;
                }
                angular.extend(flightSearchRequest, ReducedOccupancy);
                flightSearchRequest.Children = flightSearchRequest.ChildAges.length;
                return flightSearchRequest;
            });
        }
        function _getHolidaySearch(tripId, searchModel) {
            return $q.all([
                tripService.getTripDestination(tripId),
                tripService.getSelectedDepartureAirport(tripId),
                tripService.getFlightsRequestDepartureDate(tripId, true),
                tripService.getFlightsRequestReturnDate(tripId, true),
                tripService.getTripOccupancy(tripId),
                tripService.getFlightCabin(tripId)
            ]).then(function (results) {
                var values = results.every(function (result) {
                    return result !== null;
                });
                return values ?
                    $q.resolve({
                        Destination: results[0],
                        DepartureAirports: results[1].Code.split(','),
                        DepartureAirportsTitle: results[1].Title,
                        DepartureDate: results[2],
                        ReturnDate: results[3],
                        Rooms: results[4],
                        Cabin: results[5],
                        SearchModel: searchModel
                    }) : $q.reject();
            });
        }
        function _getHotelSearch(tripId) {
            return $q.all([
                tripService.getTripDestination(tripId),
                tripService.getHotelsRequestCheckInDate(tripId, true),
                tripService.getHotelsRequestCheckOutDate(tripId, true),
                tripService.getTripOccupancy(tripId)
            ]).then(function (results) { return ({
                Destination: results[0],
                CheckInDate: results[1],
                CheckOutDate: results[2],
                Rooms: results[3]
            }); });
        }
        function _getTransferSearch() {
            var airport = searchUnitService.getDestinationAirport();
            var route = searchUnitService.getRoute();
            var occ = occupancyService.reduceOccupancy();
            return {
                Airport: airport.Code,
                AirportTitle: airport.Title,
                Route: route,
                Direction: searchUnitService.getDirection(),
                ArrivalDate: searchUnitService.requiresStartDate() ? searchUnitService.startDate(searchUnitService.transfer) : null,
                ReturnDate: searchUnitService.requiresEndDate() ? searchUnitService.endDate(searchUnitService.transfer) : null,
                Passengers: {
                    Adults: occ.Adults,
                    ChildAges: occ.ChildAges
                }
            };
        }
        function _getInsuranceSearch() {
            var occ = occupancyService.reduceOccupancy();
            var policyType = searchUnitService.getPolicyType();
            var destination = searchUnitService.getTravelDestination();
            return {
                StartDate: searchUnitService.requiresStartDate() ? searchUnitService.startDate(searchUnitService.insurance) : null,
                EndDate: searchUnitService.requiresEndDate() ? searchUnitService.endDate(searchUnitService.insurance) : null,
                AdultAges: occ.AdultAges,
                ChildAges: occ.ChildAges,
                PolicyExtras: searchUnitService.getPolicyExtra(),
                PolicyType: policyType.Id,
                PolicyTypeTitle: policyType.Name,
                Destination: destination.Id,
                DestinationTitle: destination.Name
            };
        }
        function _getParkingSearch(tripId) {
            return $q.all([
                tripService.getParkingAirport(tripId),
                tripService.getParkingDropOffDate(tripId),
                tripService.getParkingPickUpDate(tripId),
                tripService.getTripOccupancy(tripId)
            ]).then(function (results) { return ({
                AirportCode: results[0].Code,
                AirportTitle: results[0].Title,
                DropOffDate: results[1],
                PickUpDate: results[2],
                Passengers: results[3]
            }); });
        }
        function _normaliseSearch(s) {
            var dateTimeFormat = 'dd MMM yyyy HH:mm';
            s.TypeTitle = title[s.SearchType]();
            window.dataLayer = window.dataLayer || [];
            switch (s.SearchType) {
                case searchType.Flight:
                    s.Duration = s.OneWayOnly ? null : dateUtil.getDurationSummary(s.DepartureDate, s.ReturnDate);
                    // If Destination is not there then we fill in what we can and then basket service will take them
                    // to the non-flexible flight workflow. If it has something then basket service will take them to a flexible
                    // flight workflow
                    if (!s.Destination) {
                        s.Destination = { Title: s.DestinationAirportTitle };
                    }
                    window.dataLayer.push({ CabinTitle: cabin[s.Cabin] });
                    break;
                case searchType.Hotels:
                    s.Duration = dateUtil.getDurationSummary(s.CheckInDate, s.CheckOutDate);
                    break;
                case searchType.Holidays:
                    s.Duration = dateUtil.getDurationSummary(s.DepartureDate, s.ReturnDate);
                    window.dataLayer.push({ CabinTitle: cabin[s.Cabin] });
                    break;
                case searchType.Transfers: {
                    var str = s.ArrivalDate != null ? dateUtil.format(s.ArrivalDate, dateTimeFormat) : '';
                    str += s.ArrivalDate != null && s.ReturnDate != null ? ' - ' : '';
                    str += s.ReturnDate != null ? dateUtil.format(s.ReturnDate, dateTimeFormat) : '';
                    s.Duration = str;
                    s.Destination = { Title: _.get(s, 'ResortTitle') || _.get(s, 'Route.DropOffPoint.Description') };
                    break;
                }
                case searchType.Parking:
                    s.Destination = { Title: s.AirportTitle };
                    s.Duration = unadjustedDateFilter(s.DropOffDate, dateTimeFormat) + " - " + unadjustedDateFilter(s.PickUpDate, dateTimeFormat);
                    break;
                case searchType.Insurance:
                    s.Duration = dateUtil.getDurationSummary(s.StartDate, s.EndDate);
            }
            // provide generic "from" and "to" dates that can be rendered by a single template
            s.FromDate = { Date: s[fromDateField[s.SearchType]], Title: fromDateTitle[s.SearchType] };
            s.ToDate = s.OneWayOnly ? null : { Date: s[toDateField[s.SearchType]], Title: toDateTitle[s.SearchType] };
            s.Nights = s.OneWayOnly ? null : dateUtil.numberOfNights(s.FromDate.Date, s.ToDate.Date);
            // sum occupancy
            if (s.Rooms) {
                var occ = _.reduce(s.Rooms, function (sum, value) {
                    return {
                        Adults: sum.Adults + value.Adults,
                        ChildAges: (sum.ChildAges || []).concat(value.ChildAges || [])
                    };
                });
                s.Adults = occ.Adults;
                s.Children = (occ.ChildAges || []).length;
            }
            delete s.SearchModel;
            return s;
        }
        function _saveSearch(type, op, getter) {
            var s = getter();
            s.SearchType = type;
            var searchModel = s.SearchModel;
            s = _normaliseSearch(s);
            if (TRPCONFIG.EnableSavedSearches) {
                cachedSearches = null;
                $http.post(url + op, s, { ignoreErrors: true }).then(function (res) {
                    s.SavedSearchId = res.data;
                    broker.publish('savedSearchAdded', s);
                });
            }
            var trackSearchEvent = { category: 'searches', action: 'run', label: op.replace('save', '') };
            if (TRPCONFIG.Domain.TenantId === 3) {
                trackSearchEvent.dimension3 = searchModel.airports.map(function (elem) { return elem.Code; }).join(',');
                trackSearchEvent.dimension4 = searchModel.destination[0].DestinationAirports;
                trackSearchEvent.dimension5 = searchModel.startDate;
                trackSearchEvent.dimension6 = searchModel.endDate;
                trackSearchEvent.dimension7 = occupancyService.getOccupancyString(searchModel.occupancy);
                trackSearchEvent.dimension8 = searchModel.cabin;
            }
            var IsAmend = $routeParams.bookingId ? true : undefined;
            analytics.track('mixpanel', 'Search', _.extend({}, s, { searchModel: searchModel, IsAmend: IsAmend }));
            analytics.track('Search', type, s);
            analytics.trackEvent(trackSearchEvent);
            analytics.track('mixpanelPeople', 'Search', s);
        }
        function _searchRestored() {
            broker.publish('savedSearchRestored');
        }
        function _restoreFlightSearch(search) {
            searchUnitService.setOneWayFlightEnabled(TRPCONFIG.Domain.OneWayFlightsEnabled && search.OneWayOnly);
            searchUnitService.startDate(searchUnitService.flight, search.DepartureDate);
            searchUnitService.endDate(searchUnitService.flight, search.ReturnDate);
            searchUnitService.setDepartureAirports({
                Code: search.DepartureAirports.join(','),
                Title: search.DepartureAirportTitle
            });
            searchUnitService.setDestination(search.Destination);
            searchUnitService.setDestinationAirport({
                Code: search.DestinationAirports.join(','),
                Title: search.DestinationAirportTitle
            });
            return $q.when();
        }
        function _restoreHotelSearch(search) {
            searchUnitService.startDate(searchUnitService.hotel, search.CheckInDate);
            searchUnitService.endDate(searchUnitService.hotel, search.CheckOutDate);
            occupancyService.setOccupancy(search.Rooms);
            return searchUnitService.setDestination(search.Destination, false, true);
        }
        function _restoreHolidaySearch(search) {
            searchUnitService.startDate(searchUnitService.flight, search.DepartureDate);
            searchUnitService.endDate(searchUnitService.flight, search.ReturnDate);
            occupancyService.setOccupancy(search.Rooms);
            searchUnitService.setDepartureAirports({
                Code: search.DepartureAirports.join(','),
                Title: search.DepartureAirportsTitle
            });
            return searchUnitService.setDestination(search.Destination, false, true);
        }
        function _restoreTransferSearch(search) {
            searchUnitService.setDirection(search.Direction);
            searchUnitService.endDate(searchUnitService.transfer, search.ReturnDate || null);
            searchUnitService.startDate(searchUnitService.transfer, search.ArrivalDate || null);
            occupancyService.setOccupancy([search.Passengers]);
            searchUnitService.setDestinationAirport({
                Code: search.Airport,
                Title: search.AirportTitle
            });
            if (search.Route) {
                searchUnitService.setResort(search.Route.DropOffPoint);
            }
            return $q.when();
        }
        function _restoreParkingSearch(search) {
            searchUnitService.setDepartureAirports({ Code: search.AirportCode, Title: search.AirportTitle });
            occupancyService.setPassengerCount(search.Passengers);
            searchUnitService.startDate(searchUnitService.parking, search.DropOffDate);
            searchUnitService.endDate(searchUnitService.parking, search.PickUpDate);
            return $q.when();
        }
        function _restoreInsuranceSearch(search) {
            searchUnitService.startDate(searchUnitService.insurance, search.StartDate);
            searchUnitService.endDate(searchUnitService.insurance, search.EndDate);
            searchUnitService.setPolicyExtra(search.PolicyExtra);
            searchUnitService.setPolicyType(search.PolicyType);
            searchUnitService.setOccupancy(search.Passengers);
            searchUnitService.setTravelDestination(search.TravelDestination);
            return $q.when();
        }
        function saveFlightSearch(tripId, searchModel) {
            return _getFlightSearch(tripId, searchModel).then(function (flightSearch) { return _saveSearch(searchType.Flight, 'saveFlightSearch', function () { return flightSearch; }); });
        }
        function saveHolidaySearch(tripId, searchModel) {
            return _getHolidaySearch(tripId, searchModel)
                .then(function (holidaySearch) { return _saveSearch(searchType.Holidays, 'saveholidaysearch', function () { return holidaySearch; }); });
        }
        function saveHotelSearch(tripId) {
            //we don't want to record geo searches
            if (searchUnitService.getSearchArea()) {
                analytics.trackEvent({ category: 'searches', action: 'run', label: 'hotelgeosearch' });
                return;
            }
            return _getHotelSearch(tripId).then(function (hotelSearch) {
                var dest = _.get(hotelSearch, 'Destination', null);
                var checkInDate = new Date(_.get(hotelSearch, 'CheckInDate', '0001-01-01T00:00:00'));
                var checkOutDate = new Date(_.get(hotelSearch, 'CheckOutDate', '0001-01-01T00:00:00'));
                var rooms = _.get(hotelSearch, 'Rooms', null);
                var today = new Date();
                if (dest === null || checkOutDate.getTime() < today.getTime() || checkInDate.getTime() > checkOutDate.getTime() || rooms === null || searchType === null) {
                    return;
                }
                return _saveSearch(searchType.Hotels, 'savehotelsearch', function () { return hotelSearch; });
            });
        }
        function saveTransferSearch() {
            //PointToPointTransferSearch does not support Saved Search yet. OR-432 to implement this in the api.
            if (!TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                _saveSearch(searchType.Transfers, 'savetransfersearch', _getTransferSearch);
            }
        }
        function saveParkingSearch(tripId) {
            _getParkingSearch(tripId).then(function (parkingSearch) { return _saveSearch(searchType.Parking, 'saveairportparkingsearch', function () { return parkingSearch; }); });
        }
        function saveInsuranceSearch() {
            _saveSearch(searchType.Insurance, 'saveinsurancesearch', _getInsuranceSearch);
        }
        function restoreSearch(search) {
            switch (search.SearchType) {
                case searchType.Flight:
                    return _restoreFlightSearch(search)
                        .then(_searchRestored);
                case searchType.Hotels:
                    return _restoreHotelSearch(search)
                        .then(_searchRestored);
                case searchType.Holidays:
                    return _restoreHolidaySearch(search)
                        .then(_searchRestored);
                case searchType.Transfers:
                    return _restoreTransferSearch(search)
                        .then(_searchRestored);
                case searchType.Parking:
                    return _restoreParkingSearch(search)
                        .then(_searchRestored);
                case searchType.Insurance:
                    return _restoreInsuranceSearch(search)
                        .then(_searchRestored);
            }
            return $q.when(); //just in case
        }
        function getSavedSearches(searchTypes) {
            if (isPrerender) {
                return $q.when([]);
            }
            if (searchTypes) {
                // 'searchTypes' must be an array
                if (!_.isArray(searchTypes)) {
                    searchTypes = [searchTypes];
                }
                // search types must be supported
                searchTypes = _.intersection(searchTypes, supportedSearchTypes);
            }
            else {
                // default to supported search types
                searchTypes = supportedSearchTypes;
            }
            if (cachedSearches == null || !_.isEqual(searchTypes.sort(), cachedSearchTypes.sort())) {
                // get searches from server
                cachedSearchTypes = searchTypes;
                cachedSearches = requestRecentSearches(searchTypes);
            }
            return cachedSearches.then(function (list) {
                //filter out any searches that are not valid because they are same day searches
                //and we are past the cut off time
                return arrayUtil.filter(list, function (s) {
                    if (s.SearchType !== searchType.Hotels ||
                        (s.SearchType === searchType.Hotels &&
                            !hotelSearchValidator.validateTimeOfDay(s.CheckInDate))) {
                        return true;
                    }
                    service.removeSavedSearch(s.SavedSearchId);
                    return false;
                });
            });
            function requestRecentSearches() {
                return $http.post(url + "getsavedsearches", { SearchTypes: searchTypes }, { ignoreErrors: true }).then(function (res) {
                    return res.data instanceof Array ? arrayUtil.map(res.data, _normaliseSearch) : [];
                });
            }
        }
        function removeSavedSearch(id) {
            cachedSearches = null;
            return $http.post(url + "removesavedsearch", { SavedSearchId: id }).then(function () {
                broker.publish('savedSearchRemoved', id);
                return null;
            });
        }
        function getCabinType(idx) {
            return cabin[idx];
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('shortlistService', shortlistService);
    function shortlistService($http, $q, arrayUtil, hotelRehydrator, $rootScope, broker) {
        var url = '/api2/hotelshortlist/';
        var shortlists;
        $rootScope.$on('auth:signout', _clearCache);
        $rootScope.$on('auth:signin', _clearCache);
        var service = {
            clear: clear,
            getHotelsInShortlist: getHotelsInShortlist,
            getShortlist: getShortlist,
            getShortlistEstabIds: getShortlistEstabIds,
            removeFromShortlist: removeFromShortlist,
            addToShortlist: addToShortlist,
            isHotelShortlisted: isHotelShortlisted,
            getUrl: getUrl,
            toggleHotel: toggleHotel
        };
        function _getShortlists() {
            if (!shortlists) {
                shortlists = $http.get(url + "getall", { ignoreErrors: true })
                    .then(function (result) {
                    return result.data.Shortlists;
                });
            }
            return shortlists;
        }
        function _clearCache() {
            shortlists = null;
        }
        function clear(id) {
            return $http.post(url + "clear", id)
                .then(function () {
                shortlists = null;
            });
        }
        function getHotelsInShortlist() {
            return getShortlist()
                .then(function (sl) {
                if (!sl) {
                    return null;
                }
                var estabIds = [];
                angular.forEach(sl.Hotels, function (h) {
                    estabIds.push(h.EstabId);
                });
                return hotelRehydrator.hotels(estabIds)
                    .then(function (hotels) {
                    return {
                        ShortlistId: sl.ShortlistId,
                        Hotels: hotels
                    };
                });
            });
        }
        function getShortlist() {
            return _getShortlists()
                .then(function (sls) {
                return sls[0];
            });
        }
        function getShortlistEstabIds() {
            return getShortlist().then(function (sl) {
                if (!sl) {
                    return [];
                }
                return arrayUtil.map(sl.Hotels, function (h) {
                    return h.EstabId;
                });
            });
        }
        function toggleHotel(hotel) {
            return isHotelShortlisted(hotel).then(function (isShortlisted) {
                var p = isShortlisted ? removeFromShortlist(hotel) : addToShortlist(hotel);
                return p.then(function () {
                    return !isShortlisted; //it worked so invert setting
                }, function () {
                    return isShortlisted; //it didn't so leave it alone
                });
            });
        }
        function removeFromShortlist(hotel) {
            if (_.get(hotel, 'Id', 0) <= 0) {
                return $q.when().then(gatherShortlist);
            }
            return $http.post(url + "removehotel", {
                EstabId: hotel.Id
            }).then(gatherShortlist);
            function gatherShortlist() {
                return _getShortlists()
                    .then(function (sls) {
                    angular.forEach(sls, function (sl) {
                        var index = arrayUtil.indexOf(sl.Hotels, function (h) {
                            return h.EstabId === hotel.Id;
                        });
                        if (index >= 0) {
                            sl.Hotels.splice(index, 1);
                            broker.publish('hotelRemovedFromShortlist', hotel);
                        }
                    });
                });
            }
        }
        function addToShortlist(hotel) {
            function add(sl) {
                return $http.post(url + "addhotel", {
                    EstabId: hotel.Id,
                    ShortlistId: sl.ShortlistId,
                    Note: ''
                }).then(function (result) {
                    sl.Hotels.push({ EstabId: hotel.Id });
                    broker.publish('hotelAddedToShortlist', hotel);
                    return result.data;
                });
            }
            return _getShortlists()
                .then(function (sls) {
                return add(sls[0]);
            });
        }
        function isHotelShortlisted(hotel) {
            return _getShortlists()
                .then(function (sls) {
                var found = false;
                angular.forEach(sls, function (sl) {
                    angular.forEach(sl.Hotels, function (h) {
                        if (h.EstabId === hotel.Id) {
                            found = true;
                        }
                    });
                });
                return found;
            });
        }
        function getUrl() {
            return url;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('sortCriteria', sortCriteria);
    function sortCriteria(resourceService, $location, hotelCriteria, flightCriteria, dealsCriteria) {
        var service = {
            getHotelCriteria: getHotelCriteria,
            getFlightCriteria: getFlightCriteria,
            getDealsCriteria: getDealsCriteria,
            saveSort: saveSort,
            getSort: getSort,
            translateHotelSort: translateHotelSort,
            getHotelSortValueById: getHotelSortValueById
        };
        function processCriteria(values, criteria) {
            var itemCriteria = {
                name: resourceService.getDeferred(criteria.name),
                val: criteria.val,
                oneWay: criteria.oneWay,
                translatedKey: criteria.name,
                trackingLabel: criteria.name
            };
            if (criteria.defaultSort) {
                itemCriteria.defaultSort = criteria.defaultSort;
            }
            if (criteria.defaultOrder) {
                itemCriteria.defaultOrder = criteria.defaultOrder;
            }
            if (criteria.ascSuffix) {
                itemCriteria.ascSuffix = resourceService.getDeferred(criteria.ascSuffix);
            }
            if (criteria.descSuffix) {
                itemCriteria.descSuffix = resourceService.getDeferred(criteria.descSuffix);
            }
            values.push(itemCriteria);
            return values;
        }
        var processedHotelCriteria = [];
        for (var i in hotelCriteria) {
            processCriteria(processedHotelCriteria, hotelCriteria[i]);
        }
        if (TRPCONFIG.Domain.ReviewsEnabled) {
            processedHotelCriteria.splice(1, 0, {
                name: resourceService.getDeferred('CUSTOMERRATING'),
                val: [2],
                trackingLabel: 'CUSTOMERRATING'
            });
        }
        var processedFlightCriteria = [];
        for (var ii in flightCriteria) {
            processCriteria(processedFlightCriteria, flightCriteria[ii]);
        }
        var processedDealsCriteria = [];
        for (var iii in dealsCriteria) {
            processCriteria(processedDealsCriteria, dealsCriteria[iii]);
        }
        function getHotelCriteria() {
            return processedHotelCriteria;
        }
        function getFlightCriteria(oneWay) {
            if (oneWay === true) {
                return processedFlightCriteria.filter(function (c) {
                    return c.oneWay;
                });
            }
            return processedFlightCriteria;
        }
        function translateHotelSort(criteriaValue) {
            if (!criteriaValue) {
                return {};
            }
            var criteria = _.find(processedHotelCriteria, function (hc) { return angular.isArray(hc.val) ? (_.get(hc, 'val') || []).indexOf(criteriaValue) > -1 : _.get(hc, 'val') === criteriaValue; });
            var defaultDir = _.get(criteria, 'defaultOrder');
            var otherDir = defaultDir === 'asc' ? 'desc' : 'asc';
            var translated = { label: criteria.translatedKey };
            if (defaultDir) {
                _.set(translated, 'direction', _.get(criteria, 'defaultSort') === criteriaValue ? defaultDir : otherDir);
            }
            return translated;
        }
        function getDealsCriteria(criteria) {
            if (criteria === void 0) { criteria = undefined; }
            if (criteria) {
                return _.find(processedDealsCriteria, function (dc) { return dc.val.indexOf(criteria) > -1; });
            }
            return processedDealsCriteria;
        }
        function saveSort(sortCriteria) {
            $location.search('sort', sortCriteria).replace();
        }
        function getSort() {
            var sort = _.get($location.search(), 'sort');
            return sort ? parseInt(sort) : undefined;
        }
        function getHotelSortValueById(id) {
            var sortObj = getHotelCriteria().filter(function (el) {
                return el.val.indexOf(id) !== -1;
            });
            return _.get(sortObj, '[0].trackingLabel');
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('trackingPixelsService', trackingPixelsService);
    function trackingPixelsService($filter, cookieService, rtbHouseTrackingService, $http) {
        var data = { bookingRef: '', costing: { totalCost: 0, currencyCode: '' }, area: '' };
        var flightBookingPrefix = 'SCH';
        var hotelBookingPrefix = 'ACM';
        var bundleBookingPrefix = 'BND';
        var marhabaBookingPrefix = 'MHB';
        var insuranceBookingPrefix = 'INS';
        var transferBookingPrefix = 'TRN';
        var service = {
            getAllProviderUrls: getAllProviderUrls,
            getProviderCheckoutUrl: getProviderCheckoutUrl,
            getProviderUrl: getProviderUrl,
            setData: setData,
            report: report
        };
        function _getBookingId(bookingId) {
            var prefixExp = new RegExp("(" + flightBookingPrefix + "|" + hotelBookingPrefix + "|" + bundleBookingPrefix + "|" + marhabaBookingPrefix + "|" + insuranceBookingPrefix + "|" + transferBookingPrefix + ")/\\d+", 'g');
            bookingId = bookingId.split('|').find(function (id) {
                return id.search(prefixExp) >= 0;
            });
            if (bookingId && bookingId.indexOf('/') > -1) {
                bookingId = bookingId.split('/')[1];
            }
            return bookingId || '';
        }
        function _getResponsysUrl(bookingRef) {
            if (TRPCONFIG.Domain.EmailTrackingResponsysEnabled === true) {
                return String.format('https://travel-emails.com/pub/cct?_ri_=X0Gzc2X%3DWQpglLjHJlTQGutsofCUcwSzgFS7mu5D0zaD6&_ei_=EphKD9rSZWWLEMSCymwyZgs&action=once&OrderId={0}&OrderTotal={1}', bookingRef, data.costing.totalCost);
            }
            return null;
        }
        function report(eventType, source) {
            var provider = _getProvider(source);
            var eventData = {
                VisitSource: source,
                EventType: eventType,
                ClickId: provider.clickId,
                BookingId: parseInt(provider.bookingId)
            };
            $http.post('/api2/b2b/tpe/', eventData);
        }
        function setData(bookingRefs, currencyCode, totalCost, hotel, rooms, tripType) {
            if (bookingRefs && totalCost) {
                data = {
                    bookingRef: bookingRefs.join('|'),
                    costing: { totalCost: totalCost, currencyCode: currencyCode }
                };
            }
            else {
                data.bookingRef = '';
            }
            if (hotel) {
                data.hotel = hotel;
            }
            if (rooms) {
                data.rooms = rooms;
            }
            if (tripType) {
                data.area = rtbHouseTrackingService.tripStates[tripType];
            }
            return data;
        }
        function _getProvider(source) {
            var provider = {
                name: 'unknown',
                source: source || 'unknown',
                bookingId: _getBookingId(data.bookingRef),
                clickId: ''
            };
            if (source) {
                switch (source.toLowerCase()) {
                    case 'kyhdnuae':
                    case 'kyh':
                    case 'ky':
                        provider.name = 'kayak';
                        break;
                    case 'tv':
                        provider.name = 'trivago';
                        break;
                    case 'skyh':
                        provider.name = 'skyscanner';
                        break;
                    case 'we':
                    case 'weksa':
                        provider.name = 'wego';
                        break;
                    case 'clickwise':
                        provider.name = 'clickwise';
                        break;
                }
                provider.clickId = cookieService.get(provider.name + "_referral");
            }
            return provider;
        }
        function getProviderCheckoutUrl(provider, bookingData) {
            var providerUrl = '';
            switch (provider.toLowerCase()) {
                case 'roomerflex':
                    providerUrl = _getRoomerFlexCheckoutUrl(bookingData.quoteId);
                    break;
            }
            return providerUrl;
        }
        function getProviderUrl(provider, bookingRef) {
            var providerUrl = '';
            switch (provider.toLowerCase()) {
                case 'responsys':
                    providerUrl = _getResponsysUrl(bookingRef);
                    break;
                case 'trivago':
                    providerUrl = _getTrivagoUrl();
                    break;
                case 'kayak':
                    providerUrl = _getKayakUrl();
                    break;
                case 'skyscanner':
                    providerUrl = _getSkyScannerUrl();
                    break;
                case 'wego':
                    providerUrl = _getWegoUrl();
                    break;
                case 'dcm':
                    providerUrl = _getDcmUrl();
                    break;
                case 'rtbhouse':
                    providerUrl = _getRtbHouseUrl();
                    break;
                case 'speeti':
                    providerUrl = _getSpeetiUrl();
                    break;
                case 'arabyads':
                    providerUrl = _getArabyadsUrl();
                    break;
                case 'clickwise':
                    providerUrl = _getClickwiseUrl();
                    break;
                case 'roomerflex':
                    providerUrl = _getRoomerFlexConfirmationUrl(bookingRef);
                    break;
            }
            return providerUrl;
        }
        function _getTrivagoUrl() {
            var domain = TRPCONFIG.Domain.CultureCode.split('-');
            domain = domain && domain.length > 1 ? domain[1].toUpperCase() : '';
            if (getProviderEnabled('trivago', ['partnerId', 'cookie']) && data.hotel) {
                return String.format('https://secde.trivago.com/page_check.php?pagetype=track&ref={0}&hotel={1}&arrival={2}&departure={3}&currency={4}&volume={5}&domain={6}&booking_id={7}&date_format=Y-m-d', TRPCONFIG.Domain.TrivagoPartnerId, data.hotel.Details.Id, $filter('date')(new Date(data.hotel.Details.Itinerary.CheckInDate), 'yyyy-MM-dd'), $filter('date')(new Date(data.hotel.Details.Itinerary.CheckOutDate), 'yyyy-MM-dd'), data.costing.currencyCode, data.costing.totalCost, domain, _getBookingId(data.bookingRef));
            }
            return null;
        }
        function _getKayakUrl() {
            if (getProviderEnabled('kayak', ['partnerId', 'cookie'])) {
                return String.format('https://www.kayak.com/s/kayakpixel/confirm/{0}?kayakclickid={1}&price={2}&currency={3}&confirmation={4}&rand={5}', TRPCONFIG.Domain.KayakPartnerId, cookieService.get('kayak_referral'), data.costing.totalCost, data.costing.currencyCode, _getBookingId(data.bookingRef), new Date().getTime());
            }
        }
        function _getSkyScannerUrl() {
            if (getProviderEnabled('skyscanner', ['partnerId', 'cookie'])) {
                if (!data.hotel || !data.rooms) {
                    var eventData = {
                        VisitSource: 'SKYH',
                        EventType: 'error',
                        ClickId: cookieService.get('skyscanner_referral'),
                        BookingId: _getBookingId(data.bookingRef),
                        Msg: 'Provider enabled, insufficient data'
                    };
                    return $http.post('/api2/b2b/tpe/', eventData).then(function () {
                        return null;
                    });
                }
                return String.format('https://t.skyscnr.com/hotels/track/booking?fclid={0}&partner={1}&order_id={2}&hotel_id={3}&hotel_name={4}&hotel_city={5}&hotel_country={6}&checkin={7}&checkout={8}&guests={9}', cookieService.get('skyscanner_referral'), TRPCONFIG.Domain.SkyscannerPartnerId, _getBookingId(data.bookingRef), data.hotel.Details.Id, data.hotel.Details.Itinerary.Title, data.hotel.Details.Itinerary.Province, data.hotel.Details.Itinerary.Country, $filter('date')(new Date(data.hotel.Details.Itinerary.CheckInDate), 'yyyy-MM-dd'), $filter('date')(new Date(data.hotel.Details.Itinerary.CheckOutDate), 'yyyy-MM-dd'), data.rooms.map(function (room) {
                    return room.Guests.length;
                }).reduce(function (total, value) {
                    return total + value;
                }) || 0)
                    .concat(String.format('&rooms={0}&amount={1}&currency={2}', data.rooms.length || 0, data.costing.totalCost, data.costing.currencyCode));
            }
        }
        function _getWegoUrl() {
            var commission = '';
            if (getProviderEnabled('wego', ['partnerId', 'cookie']) && TRPCONFIG.Domain.WegoConversionCodeID !== '') {
                return String.format('https://secure.{0}.com/analytics/v2/conversions?conversion_id={1}&click_id={2}&comm_currency_code={3}&bv_currency_code={4}&transaction_id={5}&commission={6}&total_booking_value={7}&status={8}', TRPCONFIG.Domain.WegoConversionTarget || 'wego', TRPCONFIG.Domain.WegoConversionCodeID, cookieService.get('wego_referral'), data.costing.currencyCode, data.costing.currencyCode, _getBookingId(data.bookingRef), commission, data.costing.totalCost, 'confirmed');
            }
        }
        function _getDcmUrl() {
            if (getProviderEnabled('dcm')) {
                return String.format('https://go.urtrackinglink.com/aff_l?offer_id={0}&adv_sub={1}&amount={2}', TRPCONFIG.Domain.DcmTrackingPixelOfferId, _getBookingId(data.bookingRef), data.costing.totalCost);
            }
        }
        function _getSpeetiUrl() {
            if (getProviderEnabled('speeti')) {
                return String.format('https://speetiiaffiliates.com/p.ashx?o={0}&e={1}&p={2}&t={3}&udid={2}', TRPCONFIG.Domain.SpeetiTrackingPixelDomainId, _setSpeetiBookingType(data.bookingRef), data.costing.totalCost, _getBookingId(data.bookingRef));
            }
        }
        function _getArabyadsUrl() {
            if (getProviderEnabled('arabyads')) {
                return String.format('https://www.arabytracking.net/aff_l?offer_id={0}8&amount={1}&adv_sub={2}&adv_sub2={3}', TRPCONFIG.Domain.ArabyadsTrackingPixelOfferId, data.costing.totalCost, _getBookingId(data.bookingRef), _setArabyadsBookingType(data.bookingRef));
            }
        }
        function _getClickwiseUrl() {
            if (getProviderEnabled('clickwise', ['cookie']) && TRPCONFIG.Domain.ClickwiseUrl !== '') {
                return String.format(TRPCONFIG.Domain.ClickwiseUrl, cookieService.get('clickwise_referral'), _setClickwiseBookingType(data.bookingRef), _getBookingId(data.bookingRef), data.costing.totalCost, data.costing.currencyCode);
            }
        }
        function _getRtbHouseUrl() {
            if (TRPCONFIG.Domain.EnabledRtbHouseTracking) {
                if (data.hotel) {
                    return String.format("" + TRPCONFIG.Domain.RTBHouseTrackingURL
                        + ("?type=img" + TRPCONFIG.Domain.RTBHouseOptionId + "_orderstatus2_")
                        + '{0}_{1}-{2}_{3}'
                        + ("&amp;cd=default" + TRPCONFIG.Domain.RTBHouseOptionId + "_custom_type_{1}")
                        + (TRPCONFIG.Domain.RTBHouseOptionId + "_uid_{4}"), data.costing.totalCost || null, data.area || 'hotels', _getBookingId(data.bookingRef), data.hotel.Details && data.hotel.Details.Id || null, rtbHouseTrackingService.setUID());
                }
                return rtbHouseTrackingService.getDefaultUrl();
            }
        }
        function _getRoomerFlexConfirmationUrl(bookingRef) {
            bookingRef = bookingRef || _.chain(window.dataLayer)
                .find(function (item) { return item.event === 'RoomerflexQuoteId'; })
                .get('QuoteId')
                .value();
            if (getProviderEnabled('roomerFlex', ['partnerId']) && bookingRef) {
                var roomerflexItem = _.find(window.dataLayer, function (item) { return item.event === 'RoomerflexQuoteId'; });
                if (roomerflexItem) {
                    roomerflexItem.event = null;
                }
                return String.format(TRPCONFIG.Domain.RoomerflexPixelUrl + "/register.jpg?partner={0}&token={1}", TRPCONFIG.Domain.RoomerflexPartnerId, bookingRef);
            }
        }
        function _getRoomerFlexCheckoutUrl(quoteId) {
            if (getProviderEnabled('roomerFlex', ['partnerId'])) {
                return String.format(TRPCONFIG.Domain.RoomerflexPixelUrl + "/request.jpg?partner={0}&token={1}", TRPCONFIG.Domain.RoomerflexPartnerId, quoteId);
            }
        }
        function _setSpeetiBookingType(bookingRef) {
            var speetiBookingType = 0;
            if (TRPCONFIG.Domain.TenantId === 3) {
                speetiBookingType = TRPCONFIG.Domain.SpeetiTrackingPixelBookingType;
            }
            else if (TRPCONFIG.Domain.TenantId === 2) {
                var bookingCodes = [30, 29, 31, 32, 33, 34];
                speetiBookingType = bookingCodes[(_getBookingType(bookingRef) - 1)];
            }
            return speetiBookingType;
        }
        function _setArabyadsBookingType(bookingRef) {
            return _getBookingType(bookingRef).toString();
        }
        function _setClickwiseBookingType(bookingRef) {
            var bookingTypes = ['flights', 'hotels', 'holidays', 'marhaba', 'insurance', 'transfer'];
            return bookingTypes[(_getBookingType(bookingRef) - 1)];
        }
        function _getBookingType(bookingRef) {
            var bookingTypeId = 0;
            if (bookingRef.split('|').length > 0) {
                return 3;
            }
            var bookingType = bookingRef.substring(0, 3);
            switch (bookingType.toUpperCase()) {
                case flightBookingPrefix:
                    bookingTypeId = 1;
                    break;
                case hotelBookingPrefix:
                    bookingTypeId = 2;
                    break;
                case bundleBookingPrefix:
                    bookingTypeId = 3;
                    break;
                case marhabaBookingPrefix:
                    bookingTypeId = 4;
                    break;
                case insuranceBookingPrefix:
                    bookingTypeId = 5;
                    break;
                case transferBookingPrefix:
                    bookingTypeId = 6;
                    break;
            }
            return bookingTypeId;
        }
        function getProviderEnabled(provider, checks) {
            var enabled = false;
            if (provider) {
                provider = provider.toLowerCase();
                var ucFirst_1 = provider.charAt(0).toUpperCase() + provider.slice(1);
                if (TRPCONFIG.Domain[ucFirst_1 + "TrackingPixelEnabled"]) {
                    enabled = true;
                    if (checks && checks.length) {
                        enabled = checks.every(function (check) {
                            switch (check) {
                                case 'cookie':
                                    return cookieService.get(provider + "_referral") != null;
                                case 'partnerId':
                                    return TRPCONFIG.Domain[ucFirst_1 + "PartnerId"] !== '';
                            }
                            return false;
                        });
                    }
                }
            }
            return enabled;
        }
        function getAllProviderUrls(bookingRefs, options) {
            var addUrl = function (name, url, trackingLabel) {
                if (url && url.length > 0) {
                    return { trackingLabel: trackingLabel || '', url: url, name: name };
                }
            };
            var providers = [
                {
                    name: 'responsys',
                    bookingRef: bookingRefs[0]
                },
                {
                    name: 'trivago',
                    label: 'TV'
                },
                {
                    name: 'kayak',
                    label: cookieService.get('kayak_source') || ''
                },
                {
                    name: 'skyscanner',
                    label: 'SKYH'
                },
                {
                    name: 'dcm'
                },
                {
                    name: 'speeti'
                },
                {
                    name: 'arabyads'
                },
                {
                    name: 'clickwise',
                    label: 'CLICKWISE'
                },
                {
                    name: 'rtbHouse'
                },
                {
                    name: 'wego'
                },
                {
                    name: 'roomerflex',
                    bookingRef: options && options.cancellationProtectionRef
                }
            ];
            return _.compact(providers.map(function (provider) {
                return addUrl(provider.name, service.getProviderUrl(provider.name, provider.bookingRef), provider.label);
            }));
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('urlStoreService', urlStoreService);
    function urlStoreService($location) {
        var service = {
            pushURL: pushURL,
            getPreviousURL: getPreviousURL,
            getURLHistory: getURLHistory,
            cameFromWrongPath: cameFromWrongPath,
            isTripIdChanged: isTripIdChanged,
            isPreviousUrlHotelDetails: isPreviousUrlHotelDetails,
            isPreviousUrlHotelOptions: isPreviousUrlHotelOptions,
            isPreviousUrlHotelBook: isPreviousUrlHotelBook
        };
        function pushURL() {
            var storage = sessionStorage.getItem('URLstorage');
            var currURL = $location.$$path;
            if (storage === null) {
                storage = {
                    urls: [null],
                    previous: null
                };
            }
            else {
                storage = JSON.parse(storage);
            }
            // ignore (do not push url in the storage) if user reload the page
            if (storage.urls[storage.urls.length - 1] !== currURL) {
                storage.urls.push(currURL);
                // find previous url in storage
                storage.previous = storage.urls.slice(-2)[0];
                if (storage.urls.length > 4) {
                    // delete url before previous if it equal to current url,
                    // we need this to check if user click back then forward after that back button
                    // it is no make sense to store this in the history
                    if (storage.urls[storage.urls.length - 3] === currURL) {
                        storage.urls.splice(-3, 1);
                    }
                    else {
                        // clear not needed url history to save storage memory
                        storage.urls.shift();
                    }
                }
            }
            sessionStorage.setItem('URLstorage', JSON.stringify(storage));
        }
        function getPreviousURL() {
            var storage = sessionStorage.getItem('URLstorage');
            return storage ? JSON.parse(storage).previous : null;
        }
        function getURLHistory() {
            var storage = sessionStorage.getItem('URLstorage');
            return storage ? JSON.parse(storage).urls : null;
        }
        function isTripIdChanged() {
            var previousURL = getPreviousURL();
            var changed = false;
            if (previousURL !== null) {
                var splitedCurrentPath = $location.$$path.split('/');
                var currentTripId = splitedCurrentPath.pop();
                var splitedPreviousPath = previousURL.split('/');
                var previousTripId = splitedPreviousPath.pop();
                if (JSON.stringify(splitedCurrentPath) === JSON.stringify(splitedPreviousPath) && currentTripId !== previousTripId) {
                    changed = true;
                }
            }
            return changed;
        }
        function isPreviousUrlHotelDetails(tripId) {
            var r = new RegExp("/?holidays/" + tripId + "/[^/]+", 'gi');
            return r.test(getPreviousURL());
        }
        function isPreviousUrlHotelOptions(tripId) {
            var r = new RegExp("/?holidays/options/" + tripId + "/?", 'gi');
            return r.test(getPreviousURL());
        }
        function isPreviousUrlHotelBook(tripId) {
            var r = new RegExp("/?holidays/book/" + tripId + "/?", 'gi');
            return r.test(getPreviousURL());
        }
        function cameFromWrongPath(applicablePathRegEx) {
            var previousURL = getPreviousURL();
            return previousURL !== null ? previousURL.match(applicablePathRegEx) === null : true;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('v2v3HandoverService', v2v3HandoverService);
    function v2v3HandoverService($location) {
        var service = {
            redirectEstabLandingPath: redirectEstabLandingPath,
            redirectDestLandingPath: redirectDestLandingPath,
            isV2Request: isV2Request,
            redirectLoginPaths: redirectLoginPaths
        };
        function isV2Request() {
            return $location.search().gov && $location.search().gov === '2';
        }
        function redirectLoginPaths(path) {
            var isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
            var enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');
            // exit if redirect not enabled
            if (isAgentMode || !enableV3SignIn) {
                return false;
            }
            var loginPaths = ['/signin', '/signup', '/v3'];
            var pathLowerCase = path && path.toLowerCase();
            var matchedPath = loginPaths && loginPaths.find(function (pathname) { return pathname === pathLowerCase; });
            // exit if redirect not enabled
            if (!matchedPath) {
                return false;
            }
            return matchedPath;
        }
        function redirectEstabLandingPath(path) {
            // exit if redirect not enabled
            if (!_.get(TRPCONFIG, 'Domain2.UseV3HotelEstabPage')) {
                return false;
            }
            var res = path.match(/\/2-\d*(\/|-1\/)/);
            // exit if no regex match
            if (!res) {
                return false;
            }
            var exceptions = _.get(TRPCONFIG, 'Domain2.V3HotelEstabPageExceptions');
            // return false is this an excluded estab, else true.
            return !exceptions.find(function (id) { return id === parseInt(res[1]); });
        }
        function redirectDestLandingPath(path) {
            // exit if redirect not enabled
            if (!_.get(TRPCONFIG, 'Domain2.UseV3LandingPage')) {
                return false;
            }
            var res = path.match(/\/1-([0-9]{1,5})-[1-2]{1}-0\//);
            // exit if no regex match
            if (!res) {
                return false;
            }
            var sitemap = path.match(/sitemap\//);
            // exit if actually a V2 sitemap page
            if (sitemap) {
                return false;
            }
            var exceptions = _.get(TRPCONFIG, 'Domain2.V3LandingPageExceptions');
            // return false is this an excluded dest, else true.
            return !exceptions.find(function (id) { return id === parseInt(res[1]); });
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var VoucherModalService = /** @class */ (function () {
        function VoucherModalService($http, cookieService) {
            this.$http = $http;
            this.cookieService = cookieService;
            this.domain = TRPCONFIG.Domain;
            this.apiUrl = 'api/hotels/modals';
        }
        VoucherModalService.prototype.getVoucherInfo = function (options) {
            if (options === void 0) { options = {}; }
            var bd4userId = this.cookieService.get('bd4ti') || '';
            return this.$http.post(this.apiUrl + "/query/?domainId=" + this.domain.DomainId + "&bd4userId=" + bd4userId, options).then(function (response) { return bd4userId ? response.data : {}; });
        };
        return VoucherModalService;
    }());
    TR.VoucherModalService = VoucherModalService;
    angular.module('TR').service('voucherModalService', VoucherModalService);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('AgentBookingForm', AgentBookingForm);
    function AgentBookingForm(currentUser, agentModeService) {
        var abf = this;
        abf.user = currentUser.get();
        if (TRPCONFIG.Domain.isAgentMode) {
            agentModeService.getAgentInformation().then(function (data) {
                if (data && data.OfficeLocations) {
                    abf.officeDetails = data.OfficeLocations;
                    data.OfficeLocations.forEach(function (loc) {
                        if (loc.Id === data.CurrentOfficeLocation) {
                            abf.selectedOffice = loc.Name;
                        }
                    });
                }
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('AgentPaymentBox', AgentPaymentBox);
    function AgentPaymentBox($scope, $rootScope, paymentsService, agentModeService) {
        var apb = this;
        var selectedCard;
        apb.authorizeOverride = authorizeOverride;
        apb.hideOverrideBox = hideOverrideBox;
        $scope.$watch('$parent.cm.booking.UserData.PaymentDetails.CardDetails.CardType', function (id) {
            if (!id) {
                return;
            }
            $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideUserId = undefined;
            $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideCardId = undefined;
            selectedCard = paymentsService.getCardFromId($scope.$parent.cm.paymentOptions, id);
            apb.showOverrideBox =
                selectedCard.AdminOverride &&
                    !agentModeService.hasOverridePermission($rootScope.agent);
        });
        function authorizeOverride(username, password) {
            if ($scope.$parent.form.cardFeeOverrideForm.$invalid) {
                apb.overrideErrorMessage = 'Insert username and password';
                apb.formInvalid = true;
                return;
            }
            apb.formInvalid = false;
            agentModeService
                .loginOverride(username, password)
                .then(_confirmOverride, _failedOverride);
        }
        function hideOverrideBox() {
            $scope.$parent.cm.booking.cardOption = 0;
            $scope.$parent.cm.updateCardType();
            apb.overrideErrorMessage = undefined;
            apb.formInvalid = false;
            apb.showOverrideBox = false;
        }
        function _confirmOverride(overrideInfo) {
            $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideCardId = selectedCard.cardTypeId;
            $scope.$parent.cm.booking.UserData.PaymentDetails.OverrideUserId = overrideInfo.UserName;
            apb.showOverrideBox = false;
            apb.overrideErrorMessage = undefined;
        }
        function _failedOverride(errorInfo) {
            switch (errorInfo.status) {
                case 404:
                    apb.overrideErrorMessage = 'User not found';
                    break;
                case 401:
                    apb.overrideErrorMessage = 'Unauthorised';
                    break;
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('FlightCapture', FlightCapture);
    function FlightCapture(bookingService, $routeParams, tripService, $scope, resourceService) {
        var cm = this;
        var dir;
        var inverse;
        cm.setDepartureAirport = setDepartureAirport;
        cm.setDestinationAirport = setDestinationAirport;
        cm.setDateAndTime = setDateAndTime;
        cm.resetDestinationAirport = resetDestinationAirport;
        tripService.getTransferDestinationAirport($routeParams.tripId).then(function (airport) { return cm.destinationAirport = airport; });
        function _setAirport(start, end, item, booking) {
            booking.UserData.ConnectingFlight = booking.UserData.ConnectingFlight || {};
            booking.UserData.ConnectingFlight[dir + start + "Airport"] = item.Code;
            booking.UserData.ConnectingFlight[dir + start + "AirportName"] = item.Title;
            if (booking.UserData.ConnectingFlight[inverse + end + "Airport"] == null || booking.UserData.ConnectingFlight[inverse + end + "Airport"] === '') {
                booking.UserData.ConnectingFlight[inverse + end + "Airport"] = item.Code;
                booking.UserData.ConnectingFlight[inverse + end + "AirportName"] = item.Title;
            }
            bookingService.updateBooking(booking);
        }
        function _resetAirport(start, booking) {
            booking.UserData.ConnectingFlight[dir + start + "Airport"] = null;
            booking.UserData.ConnectingFlight[dir + start + "AirportName"] = null;
        }
        function _setDirection(outbound) {
            dir = outbound === true ? 'Outbound' : 'Inbound';
            inverse = dir === 'Outbound' ? 'Inbound' : 'Outbound';
        }
        function setDepartureAirport(item, outbound, booking) {
            if (_isValidDepartureAirport(item)) {
                _setDirection(outbound);
                _setAirport('Departure', 'Destination', item, booking);
                $scope.$broadcast('flash:hide');
            }
            else {
                _setAirport('Departure', 'Destination', {}, booking);
                $scope.$broadcast('flash:error', resourceService.get('DEPARTUREAIRPORTERROR'));
            }
        }
        function _isValidDepartureAirport(airport) {
            return !cm.destinationAirport || airport && airport.Code && airport.Code !== cm.destinationAirport.Code;
        }
        function setDestinationAirport(item, outbound, booking) {
            _setDirection(outbound);
            _setAirport('Destination', 'Departure', item, booking);
        }
        function setDateAndTime(date, booking, outbound) {
            _setDirection(outbound);
            booking.UserData.ConnectingFlight[dir + "Date"] = cm.isStartTimeApprovedByCustomer ? date : null;
            bookingService.updateBooking(booking);
        }
        function resetDestinationAirport(outbound, booking) {
            _setDirection(outbound);
            _resetAirport('Destination', booking);
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('SeatPlan', SeatPlan);
    function SeatPlan(basketStore, tripService, $routeParams, flightSeatPlanService) {
        var sp = this;
        sp.showPlan = false;
        sp.totalPrice = 0;
        sp.minCostPerPerson = 0;
        sp.closePlan = function () {
            sp.showPlan = false;
        };
        sp.resetSeats = function () {
            for (var _i = 0, _a = sp.flightSeatPlan.Passengers; _i < _a.length; _i++) {
                var p = _a[_i];
                for (var _b = 0, _c = p.Seats; _b < _c.length; _b++) {
                    var s = _c[_b];
                    s.Number = null;
                    s.Price = 0;
                }
            }
            sp.totalPrice = 0;
        };
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            return basketStore.flight(trip.BasketId);
        }).then(function (flight) {
            if (!flight.Details.CanSelectSeats) {
                return;
            }
            return flightSeatPlanService.getSeatPlan({
                DetailsSessionId: flight.Details.DetailsId
            });
        }).then(function (plan) {
            if (plan) {
                sp.flightSeatPlan = plan;
            }
        });
    }
})();
var TR;
(function (TR) {
    'use strict';
    var HolidayDealsResults = /** @class */ (function () {
        function HolidayDealsResults($location, $scope, holidayDeals, broker, pagingService, resourceService, analytics, bd4t, sortCriteria) {
            var _this = this;
            this.$location = $location;
            this.$scope = $scope;
            this.holidayDeals = holidayDeals;
            this.broker = broker;
            this.pagingService = pagingService;
            this.resourceService = resourceService;
            this.analytics = analytics;
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-holidayDealsResults'
            });
            bd4t('send', 'pageview', { type: 'deals', label: 'dealsFinderResults' });
            this.page = function (page) { return _this.find(page - 1, _this.sortCriterion); };
            this.sortCriterion = sortCriteria.getSort() || 1;
            this.priceMode = 0;
            this.newSearch = true;
            this.showSearchUnit = !!_.get(this.$location.search(), 'promo');
            broker.publish('priceModeChanged', this.priceMode);
            broker.subscribe('holidayDealsResults', 'REFRESHSEARCH', function (e) {
                _this.newSearch = (e && e.data) ? e.data.newSearch : false;
                _this.find(0, _this.sortCriterion);
            });
            broker.subscribe('holidayDealsResults', 'priceModeChanged', function (e) { return _this.priceMode = e.data; });
            // This also starts the first search
            $scope.$watch('hd.sortCriterion', function (v) {
                _this.find(0, v).then(function () { return sortCriteria.saveSort(v); });
            });
            this.dealsSortCriteria = sortCriteria.getDealsCriteria();
            $scope.$on('$destroy', function () {
                broker.unsubscribe('holidayDealsResults');
            });
            broker.publish('priceModeChanged', 1);
        }
        HolidayDealsResults.prototype.toggleSearchUnit = function () {
            this.showSearchUnit = !this.showSearchUnit;
        };
        HolidayDealsResults.prototype.toggleMap = function () {
            this.showMap = !this.showMap;
        };
        HolidayDealsResults.prototype.isFiltered = function () {
            if (!this.results) {
                return false;
            }
            return !_.isEqual(this.results.Info.filters, this.holidayDeals.getDefaultFilters());
        };
        HolidayDealsResults.prototype.resetFilters = function () {
            this.results.Info.filters = this.holidayDeals.getDefaultFilters();
        };
        HolidayDealsResults.prototype.openSlideFilter = function () {
            this.showFilterBox = true;
        };
        HolidayDealsResults.prototype.find = function (page, sort) {
            var _this = this;
            if (page === void 0) { page = 0; }
            if (sort === void 0) { sort = 1; }
            this.updating = true;
            return this.holidayDeals
                .find({ page: page, sort: sort })
                .then(function (res) { return _this.results = res; })
                .then(function () {
                _this.broker.publish('hotelsReturnedFromSearch', _this.results.Products.filter(function (p) { return !p.IsCruise; }));
                _this.broker.publish('UPDATEMAP');
            })
                .then(function () {
                _this.paging = _this.pagingService.data(_this.results.Paging.Index + 1, _this.results.Paging.Size, _this.results.Paging.Total);
                _this.paging.UnfilteredTotal = _this.results.Paging.UnfilteredTotal;
                _this.updating = false;
                _this.$scope.$emit('unblock');
                if (_.has(_this.$location.search(), 'openBox')) {
                    var hotel = _.first(_this.results.Products.filter(function (p) { return !p.IsCruise; }));
                    if (hotel) {
                        _this.broker.publish('SHOWDEALS', { hotel: hotel });
                    }
                }
                if (_this.newSearch) {
                    _this.analytics.track('mixpanel', 'HolidayDealsListing', {
                        cruiseCount: (_this.results.Products.filter(function (p) { return p.IsCruise; }) || []).length,
                        hotelCount: (_this.results.Products.filter(function (p) { return !p.IsCruise; }) || []).length
                    });
                    _this.newSearch = false;
                }
                if (sort !== 1) {
                    var sortElement = _.find(_this.dealsSortCriteria, function (s) { return s.val.indexOf(sort) > -1; });
                    if (!sortElement) {
                        return;
                    }
                    var dir = _.min(sortElement.val) === sort ? 'asc' : 'desc';
                    _this.analytics.track('mixpanel', 'HolidayDealsSort', {
                        'ChangedTo': sortElement.name() + " " + dir
                    });
                }
            }, function () { return _this.$scope.$emit('unblock'); });
        };
        return HolidayDealsResults;
    }());
    angular
        .module('TR')
        .controller('HolidayDealsResults', HolidayDealsResults);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Country', Country);
    function Country(pagingService, urlUtils, $scope, $rootScope, pageStrand, destinationService, reviewService, windowUtil, imageService, countryService, broker, resourceService, bd4travel, $location, $q, currentDestination) {
        var cm = this;
        var inResource = resourceService.get('InDestination');
        cm.lightboxOpen = false;
        cm.mapReady = false;
        cm.loading = true;
        cm.loadingDestinations = true;
        cm.loadingCoords = true;
        cm.loadingReviews = true;
        cm.loadingInfo = true;
        cm.loadingChildren = true;
        cm.destinationThumb = destinationThumb;
        cm.openImageGallery = openImageGallery;
        cm.showReviews = showReviews;
        cm.popupMap = popupMap;
        cm.showAllDestinations = $location.search().allDest;
        var parsed = urlUtils.parse($location.url());
        parsed.qs.allDest = true;
        cm.allDestinationsUrl = urlUtils.stripLeadingSlash(urlUtils.format(parsed));
        cm.toggleDestinations = toggleDestinations;
        cm.pageReviews = function (page) {
            _getReviews(cm.selectedHotel, page);
        };
        function toggleDestinations(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!cm.showAllDestinations) {
                destinationService.getAllChildren(cm.destination).then(function (children) { return cm.all = buildPagePaths(children); });
                cm.showAllDestinations = !cm.showAllDestinations;
            }
        }
        broker.subscribe('CountryCtrl', 'selectHotel', function (ev) {
            selectHotel(ev.data.hotel, ev.data.event);
        });
        broker.subscribe('CountryCtrl', 'lightboxOpened', function () {
            cm.lightboxOpen = true;
        });
        broker.subscribe('CountryCtrl', 'mapReady', function () {
            cm.mapReady = true;
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('CountryCtrl');
        });
        function popupMap() {
            cm.showPopupMap = true;
        }
        function destinationThumb(dest) {
            return destinationService.destinationThumb(dest);
        }
        function buildPagePaths(children) {
            return destinationService.sortByTitle(children).map(function (child) {
                child.PagePath = urlUtils.appendExistingQueryString(urlUtils.stripLeadingSlash(child.PagePath));
                return child;
            });
        }
        currentDestination.getCurrentDestination().then(function (destination) {
            cm.destination = destination;
            var requests = [destinationService.getText(cm.destination), destinationService.getTopChildren(8, cm.destination)];
            if (cm.showAllDestinations) {
                requests.push(destinationService.getAllChildren(cm.destination));
            }
            $q.all(requests).then(function (result) {
                var text = result[0];
                var children = buildPagePaths(result[1]);
                var defaultStr = '{name}';
                if (cm.showAllDestinations) {
                    cm.all = buildPagePaths(result[2]);
                }
                cm.dealsTitle = function (dest) { return String.supplant(text.List1Title || defaultStr, _getVarMap(dest)); };
                countryService.getTopDeals(2, cm.destination, children.slice(0, 3)).then(function (deals) {
                    cm.greatDeals = deals;
                    cm.loadingDeals = false;
                });
                cm.popular = children;
                cm.loadingDestinations = false;
                bd4travel.trackCategory(children);
            }).finally(function () {
                $rootScope.unlockScreen($scope);
            });
        });
        function selectHotel(hotel, e) {
            e.preventDefault();
            e.stopPropagation();
            if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                windowUtil.open(_getHotelUrl(false, hotel));
            }
            else {
                $location.path(_getHotelUrl(true, hotel));
            }
        }
        function getHotelUrl(hotel) {
            return _getHotelUrl(false, hotel);
        }
        function _getHotelUrl(leadingSlash, hotel) {
            var url = hotel.Url;
            var index = url.indexOf('/');
            if (!leadingSlash && index === 0) {
                url = url.substring(1);
            }
            if (leadingSlash && index !== 0) {
                url = "/" + url;
            }
            return pageStrand.adjustUrl(url, cm.destination.PageStrand);
        }
        function openImageGallery(hotel, e) {
            e.preventDefault();
            e.stopPropagation();
            var w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
            var h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
            cm.hotelImageIndex = 0;
            cm.hotelImages = [];
            for (var i = 0, l = hotel.NumberOfPhotos; i < l; i++) {
                cm.hotelImages.push({
                    src: imageService.getImageUrl(hotel.Id, w, h, i, false)
                });
            }
            cm.showHotelImages = true;
        }
        function showReviews(hotel, ev) {
            ev.preventDefault();
            cm.reviews = [];
            cm.selectedHotel = hotel;
            cm.reviewPaging = pagingService.data(1, 10, hotel.CustomerRatingCount);
            _getReviews(hotel, cm.reviewPaging.page);
            cm.reviewsShowing = true;
            ev.stopPropagation();
        }
        function _getVarMap(dest) {
            // Variable mapping in string templates i.e. {name}
            // Also supports legacy numeric vars i.e. {0}
            return {
                0: dest.Title,
                1: inResource,
                name: dest.Title,
                in: inResource
            };
        }
        function _getReviews(hotel, page) {
            cm.loadingReviews = true;
            if (page === 1) {
                cm.loadingFirstReviews = true;
            }
            return reviewService.getReviews(hotel, page - 1).then(function (result) {
                cm.reviews = result.reviews;
                cm.loadingReviews = false;
                cm.loadingFirstReviews = false;
                cm.reviewPaging = pagingService.data(page, 10, hotel.CustomerRatingCount);
            });
        }
        cm.selectHotel = selectHotel;
        cm.getHotelUrl = getHotelUrl;
        cm.bookButton = function () {
            return resourceService.get('VIEWDETAILS');
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelsFilter', HotelsFilter);
    function HotelsFilter($scope, hotelSearch, broker, resourceService, hotelsFilter) {
        var hf = this;
        var agg;
        hf.newSearch = true;
        hotelSearch.getFilterLazy().then(function (filter) {
            hf.filter = filter;
        });
        broker.subscribe('HotelsFilterCtrl', 'newSearchTriggered', newSearchTriggered);
        broker.subscribe('HotelsFilterCtrl', 'hotelListUpdated', function (ev) {
            updateFilter();
            if (ev.data.Aggregates) {
                configureFilterLimits(ev.data);
            }
            watchFilter();
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('HotelsFilterCtrl');
        });
        function configureFilterLimits(results) {
            agg = results.Aggregates;
            if (hf.filterLimits == null) {
                hf.filterLimits = hotelsFilter.getFilterLimits(agg);
            }
            hf.moreLess = function (filterName) {
                if (!agg[filterName + "Array"] || (agg[filterName + "Array"].length <= hotelsFilter.config[filterName].limit)) {
                    return '';
                }
                if (hf.filterLimits[filterName] <= hotelsFilter.config[filterName].limit) {
                    return resourceService.get('MORE');
                }
                if (hf.filterLimits[filterName] > hotelsFilter.config[filterName].limit) {
                    return resourceService.get('FEWER');
                }
            };
            hf.toggleLimit = function (filterName) {
                hf.filterLimits[filterName] = (hf.filterLimits[filterName] < agg[filterName + "Array"].length) ? agg[filterName + "Array"].length : hotelsFilter.config[filterName].limit;
            };
            function toggleOpenSelected() {
                if (hf.newSearch === false) {
                    return;
                }
                for (var i in agg) {
                    if (typeof agg[i + "Array"] !== 'undefined') {
                        if (i.indexOf('HotelsBy') >= 0) {
                            var name_4 = i.replace('HotelsBy', '');
                            //check in singular and plural form of model
                            var f = hf.filter[name_4] || hf.filter[name_4 + "s"];
                            hf.filterLimits[i] = f && f.length > 0 ? agg[i + "Array"].length : hf.filterLimits[i];
                        }
                        else if (checkFacilities(i)) {
                            hf.filterLimits[i] = agg[i + "Array"].length;
                        }
                    }
                }
                hf.newSearch = false;
            }
            toggleOpenSelected();
            function checkFacilities(filterName) {
                return _.some(agg[filterName + "Array"], function (v) { return v.name && _.includes(hf.filter.FacilityCodes, v.name); });
            }
        }
        ['removeFilter', 'removeArrayFilter', 'resetArrayFilter', 'resetBitFilter', 'resetRangeFilter', 'resetFilters'].forEach(function (fn) {
            hf[fn] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                stopWatch();
                return hotelSearch[fn].apply(hotelSearch, args).then(watchFilter).then(updateFilter);
            };
        });
        hf.resetFacilityFilter = function (group) {
            stopWatch();
            var codesInGroup = [];
            for (var code in agg[group]) {
                codesInGroup.push(code);
            }
            return hotelSearch.removeFiltersIn('FacilityCodes', codesInGroup).then(watchFilter).then(updateFilter);
        };
        function updateFilter() {
            hf.filter = hotelSearch.getFilter();
        }
        var canceller;
        function stopWatch() {
            if (canceller != null) {
                canceller();
            }
        }
        function watchFilter() {
            stopWatch();
            canceller = $scope.$watch('hf.filter', _.debounce(function (f, o) {
                if (f == null || _.isEqual(f, o)) {
                    return;
                }
                //this filter has changed therefore we have to remove any estab group filter just in case
                hotelSearch.filter().then(updateFilter);
            }, 300), true);
        }
        //the reason that filters need to be reset when a new search is triggered is because the filter criteria
        //are built from the aggregates which will be completely different when the search results load. So
        //don't be tempted to remove this. Seriously.
        //Furthermore when we trigger a new search, becuase we have to reset the filters we also need to suspend
        //the watch until those results have been resolved otherwise we get double calling of the getHotelsFromSession
        //Fragile? absolutely.
        function newSearchTriggered() {
            hf.newSearch = true;
            hf.resetFilters(true).then(stopWatch);
        }
    }
})();
var Core;
(function (Core) {
    var pixelTrackingPageNames = {
        holidaysHotelsSearchResults: 'HolidaysHotelsSearchResults',
        holidaysRoomSelection: 'HolidaysRoomSelection',
        holidaysOptions: 'HolidaysOptions',
        holidaysFlightSearch: 'HolidaysFlightSearch',
        holidaysBookingForm: 'HolidaysBookingForm',
        bookingComplete: 'BookingComplete',
        termsAgency: 'TermsAgency',
        dashboardBookingReference: 'MybBookingReference',
        dashboardBookingDetails: 'DashboardBookingDetails',
        dashboardPayBalance: 'DashboardPayBalance',
        bookingAlreadyDone: 'BookingA0lreadyDone',
        landingPage: 'LandingPage',
        pageNotFound: 'PageNotFound',
        errorPage: 'ErrorPage',
        errorDatesMismatch: 'ErrorDateMismatch',
        holidaysJanuarySale: 'HolidaysJanuarySale',
        homePage: 'HomePage',
        hotelsSearchResults: 'HotelsSearchResults',
        hotelsRoomSelection: 'HotelsRoomSelection',
        hotelsOptions: 'HotelsOptions',
        hotelsBookingForm: 'HotelsBookingForm',
        flightsSearchResults: 'FlightsSearchResults',
        flightsBookingForm: 'FlightsBookingForm',
        transfersSearchResults: 'TransfersSearchResults',
        transfersBookingForm: 'TransfersBookingForm',
        marhabaSearchResults: 'MarhabaSearchResults',
        marhabaOptions: 'MarhabaOptions',
        marhabaBookingForm: 'MarhabaBookingForm',
        insuranceSearchResults: 'InsuranceSearchResults',
        insuranceBookingForm: 'InsuranceBookingForm'
    };
    var BaseTracking = /** @class */ (function () {
        function BaseTracking($scope, $rootScope, $q, $location) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.$location = $location;
        }
        BaseTracking.prototype._onInit = function () {
            var _this = this;
            this.$rootScope.$on('$routeChangeSuccess', function (e, _a) {
                var $$route = _a.$$route;
                _this.routeHasChanged = _this._isRouteChanged();
                var isTracked = _this._isRouteTracked($$route);
                if (!isTracked) {
                    _this.notTrackedRouteHandler();
                    return;
                }
                if (!_this.routeHasChanged) {
                    _this.notChangedRouteHandler();
                    return;
                }
                var page = {
                    name: pixelTrackingPageNames[$$route.pixelTrackingPageName],
                    label: $$route.pixelTrackingPageName
                };
                _this.routeChanged(page);
            });
            this.$rootScope.$on('cmsPageProps', function (e, _a) {
                var pageName = _a.pageName;
                var page = {
                    name: "CmsPage:" + pageName
                };
                if (!_this.routeHasChanged) {
                    _this.notChangedRouteHandler();
                    return;
                }
                _this.cmsRouteChanged(page);
            });
        };
        BaseTracking.prototype._isRouteTracked = function (route) {
            return route && route.pixelTrackingPageName && pixelTrackingPageNames[route.pixelTrackingPageName];
        };
        BaseTracking.prototype._isRouteChanged = function () {
            var curUrl = this.$location.path();
            if (curUrl !== this.lastPageRoute) {
                this.lastPageRoute = curUrl;
                return true;
            }
            return false;
        };
        return BaseTracking;
    }());
    Core.BaseTracking = BaseTracking;
})(Core || (Core = {}));
var Core;
(function (Core) {
    var Bd4PageTracking = /** @class */ (function (_super) {
        __extends(Bd4PageTracking, _super);
        function Bd4PageTracking($scope, $rootScope, $q, $location, bd4t) {
            var _this = _super.call(this, $scope, $rootScope, $q, $location) || this;
            _this.bd4t = bd4t;
            return _this;
        }
        Bd4PageTracking.prototype.$onInit = function () {
            this._onInit();
        };
        Bd4PageTracking.prototype.notChangedRouteHandler = function () {
        };
        Bd4PageTracking.prototype.notTrackedRouteHandler = function () {
        };
        Bd4PageTracking.prototype.routeChanged = function (page) {
        };
        Bd4PageTracking.prototype.cmsRouteChanged = function (page) {
            if (this.$location.path() === '/') {
                this.bd4t('initPage', { type: 'home', section: 'home' });
            }
            else {
                this.bd4t('initPage', { type: 'generic', section: 'package' });
            }
            this.bd4t('send', 'pageview');
        };
        return Bd4PageTracking;
    }(Core.BaseTracking));
    angular
        .module('core')
        .directive('bdfourPageTracking', function () {
        return {
            restrict: 'E',
            controller: Bd4PageTracking,
            controllerAs: 'bd4Tracking',
            template: ''
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var SalesForceTrackingPixel = /** @class */ (function (_super) {
        __extends(SalesForceTrackingPixel, _super);
        function SalesForceTrackingPixel($scope, $rootScope, cookieService, $q, $location) {
            var _this = _super.call(this, $scope, $rootScope, $q, $location) || this;
            _this.cookieService = cookieService;
            return _this;
        }
        SalesForceTrackingPixel.prototype.notChangedRouteHandler = function () {
            this.pixelUrl = '';
        };
        SalesForceTrackingPixel.prototype.notTrackedRouteHandler = function () {
            this.pixelUrl = '';
        };
        SalesForceTrackingPixel.prototype.routeChanged = function (page) {
            var _this = this;
            this.compileData(page)
                .then(function (data) {
                _this.pixelUrl = _this.createPixelUrl(_this.baseUrl, data);
            });
        };
        SalesForceTrackingPixel.prototype.cmsRouteChanged = function (page) {
            var _this = this;
            this.compileData(page)
                .then(function (data) {
                if (data) {
                    _this.pixelUrl = _this.createPixelUrl(_this.baseUrl, data);
                }
                else {
                    _this.pixelUrl = '';
                }
            });
        };
        SalesForceTrackingPixel.prototype.$onInit = function () {
            this._onInit();
        };
        SalesForceTrackingPixel.prototype.compileData = function (page) {
            var data = this.getCookiesData();
            if (!data) {
                return this.$q.reject();
            }
            data.pageName = page.name;
            data.label = page.label;
            data.dataSet = '';
            return this.addBookingData(data)
                .then(this.addLandingPageData.bind(this));
        };
        SalesForceTrackingPixel.prototype.addBookingData = function (data) {
            if (data.label && data.label === 'bookingComplete') {
                var bookingStorageObj = sessionStorage.getItem('BookingConfirmAdFormItem');
                var bookingObj = bookingStorageObj ? JSON.parse(bookingStorageObj) : {};
                var totalCost = parseInt(bookingObj.totalCost, 10);
                if (totalCost && !isNaN(totalCost)) {
                    var dataSet = "\n                            <data_set>\n                                <data \n                                    amt=\"" + totalCost + "\" \n                                    unit=\"" + TRPCONFIG.Domain.CurrencyCode + "\" \n                                    accumulate=\"true\"/>\n                            </data_set>\n                        ";
                    data.dataSet = dataSet.replace(/\s(?=\s)/g, '');
                }
                return this.$q.when(data);
            }
            return this.$q.when(data);
        };
        SalesForceTrackingPixel.prototype.addLandingPageData = function (data) {
            var url = this.$location.absUrl();
            if (data.label === 'landingPage' && url.indexOf('.html') !== -1) {
                var regExpMatch = url.match(/([^/]+)\.html/);
                var pageNameLanding = regExpMatch && regExpMatch[1] ?
                    "LandingPage:" + regExpMatch[1] : data.pageName;
                data.pageName = pageNameLanding;
            }
            return data;
        };
        SalesForceTrackingPixel.prototype.getCookiesData = function () {
            var res;
            var val = this.cookieService.get('salesforce');
            if (val) {
                try {
                    res = {};
                    val.split('&').map(function (el) { return res[el.split('=')[0]] = el.split('=')[1]; });
                }
                catch (err) {
                    res = '';
                }
            }
            return res;
        };
        SalesForceTrackingPixel.prototype.createXml = function (params) {
            params.e = params.e || '';
            return ("\n            <system>\n                <system_name>tracking</system_name>\n                <action>conversion</action>\n                <member_id>" + params.mid + "</member_id>\n                <job_id>" + params.j + "</job_id>\n                <email>" + params.e + "</email>\n                <sub_id>" + params.sfmc_sub + "</sub_id>\n                <list>" + params.l + "</list>\n                <original_link_id>" + params.u + "</original_link_id>\n                <BatchID>" + params.jb + "</BatchID>\n                <conversion_link_id>1</conversion_link_id>\n                <link_alias>" + params.pageName + "</link_alias>\n                <display_order>1</display_order>\n                " + params.dataSet + "\n            </system>\n            ").replace(/(>|^)\s*(<|$)/g, '$1$2');
        };
        SalesForceTrackingPixel.prototype.createPixelUrl = function (url, params) {
            if (!url.endsWith('/')) {
                url = url + "/";
            }
            var xml = encodeURIComponent(this.createXml(params));
            return url + "conversion.aspx?xml=" + xml;
        };
        return SalesForceTrackingPixel;
    }(Core.BaseTracking));
    angular
        .module('core')
        .directive('salesForceTrackingPixel', function () {
        return {
            restrict: 'E',
            controller: SalesForceTrackingPixel,
            controllerAs: 'sfCtrl',
            bindToController: {
                baseUrl: '@'
            },
            template: "\n                    <img ng-src=\"{{sfCtrl.pixelUrl}}\" width=\"1\" height=\"1\"/>\n                "
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var BasePopupService = /** @class */ (function () {
        function BasePopupService($compile, $q, $rootScope, $timeout) {
            this.$compile = $compile;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.defaultOptions = {
                popupContainer: 'body'
            };
        }
        BasePopupService.prototype.showPopup = function (template, popupOptions) {
            var _this = this;
            var defer = this.$q.defer();
            var options = Object.assign(this.defaultOptions, popupOptions);
            var scope = this._createScope(defer, options.popupScope || {});
            var compiledElement = this.$compile(template)(scope);
            var container = angular.element(options.popupContainer);
            this.addPopupToContainer(container, compiledElement);
            return defer.promise.then(function (val) {
                scope.showPopup = false;
                _this.removePopupFromContainer(compiledElement);
                return _this.$q.when(val);
            }, function (val) {
                scope.showPopup = false;
                _this.removePopupFromContainer(compiledElement);
                return _this.$q.reject(val);
            });
        };
        BasePopupService.prototype.addPopupToContainer = function (container, template) {
            return container.append(template);
        };
        BasePopupService.prototype.removePopupFromContainer = function (element) {
            var _this = this;
            setTimeout(function () {
                element.remove();
                _this.$rootScope.$apply();
            });
        };
        BasePopupService.prototype._createScope = function (defer, customScope) {
            var sc = this.$rootScope.$new();
            var mergedScope = Object.assign(sc, __assign({ defer: defer, showPopup: true, close: function (value) {
                    defer.reject({
                        result: 'close',
                        value: value
                    });
                },
                confirm: function (value) {
                    defer.resolve({
                        result: 'confirm',
                        value: value
                    });
                },
                cancel: function (value) {
                    defer.reject({
                        result: 'cancel',
                        value: value
                    });
                } }, customScope));
            _.functions(mergedScope).forEach(function (f) {
                mergedScope[f] = mergedScope[f].bind(mergedScope);
            });
            return mergedScope;
        };
        return BasePopupService;
    }());
    Core.BasePopupService = BasePopupService;
    angular.module('TR').service('basePopupService', BasePopupService);
})(Core || (Core = {}));
var Core;
(function (Core) {
    var template = "\n        <lightbox \n            show=\"showPopup\"\n            close=\"close()\"\n            header-text=\"popupHeader\"\n            lightbox-class=\"lightbox-confirmation-popup\"\n            >\n            <div class=\"message-container\">\n                <span ng-bind-html=\"popupMessage\"></span>\n                <div class=\"button-container\">\n                    <button class=\"cancel\" ng-click=\"cancel()\">{{cancelButtonLabel}}</button>\n                    <button ng-click=\"confirm()\">{{okButtonLabel}}</button>\n                </div>\n            </div>\n        </lightbox>\n    ";
    var ConfirmPopupService = /** @class */ (function () {
        function ConfirmPopupService(basePopupService, resourceService) {
            this.basePopupService = basePopupService;
            this.resourceService = resourceService;
            this.defaultPopupScope = {
                popupMessage: '',
                popupHeader: '',
                okButtonLabel: resourceService.get('OK'),
                cancelButtonLabel: resourceService.get('CANCEL')
            };
        }
        ConfirmPopupService.prototype.showPopup = function (customScope) {
            var defScope = this.defaultPopupScope;
            var popupParams = {
                popupContainer: 'body',
                popupScope: __assign({}, defScope, customScope)
            };
            return this.basePopupService.showPopup(template, popupParams);
        };
        return ConfirmPopupService;
    }());
    Core.ConfirmPopupService = ConfirmPopupService;
    angular.module('TR').service('confirmPopupService', ConfirmPopupService);
})(Core || (Core = {}));
var Core;
(function (Core) {
    var template = "\n        <lightbox \n            show=\"showPopup\"\n            close=\"close({isSuccess: showSuccess})\"\n            hide-header-bar=\"true\"\n            modal-overlay-class=\"signup-popup\"\n            >\n            <div class=\"signup-popup-container\" ng-style=\"styles\">\n                <div class=\"close-button\" ng-click=\"close({isSuccess: showSuccess})\">&#x2715;</div>\n                <div class=\"left-form-cell\">\n                    <div class=\"title\">{{showSuccess ? successMessage : titleLabel}}</div>\n                    <button ng-if=\"showSuccess\" ng-click=\"continue()\">{{continueButtonLabel}}</button>\n                    <newsletter-sign-up-popup-form \n                        ng-if=\"!showSuccess\"\n                        primary-button=\"true\" \n                        on-success=\"confirm()\"></newsletter-sign-up-popup-form>\n                    <div class=\"unsubscription-notes\"  ng-bind-html=\"unsubscriptionNotes\"></div>\n                </div>\n            </div>\n        </lightbox>\n    ";
    var SignUpPopupService = /** @class */ (function () {
        function SignUpPopupService(basePopupService, resourceService, analytics) {
            this.basePopupService = basePopupService;
            this.resourceService = resourceService;
            this.analytics = analytics;
            this.signUpPopupBackgroundImageUrl = this._getBackgroundImageUrl();
        }
        SignUpPopupService.prototype._getBackgroundImageUrl = function () {
            var backgroundUrl;
            var configValue = TRPCONFIG.Domain2.SignUpPopupBackgroundUrl;
            try {
                var cfg = JSON.parse(configValue);
                backgroundUrl = TRPCONFIG.Rtl ? cfg.RightToLeft : cfg.LeftToRight;
            }
            catch (err) { }
            return backgroundUrl || configValue;
        };
        SignUpPopupService.prototype._sendPopupClosedGAEvent = function (_a) {
            var value = _a.value;
            if (!value || !value.isSuccess) {
                this.analytics.trackEvent({
                    category: 'newsletterSignup',
                    action: 'click',
                    label: 'PopUp_Closed',
                    dimension9: 'newsletterSignup'
                });
            }
        };
        SignUpPopupService.prototype.showPopup = function () {
            return this.basePopupService.showPopup(template, { popupScope: {
                    showSuccess: false,
                    continueButtonLabel: this.resourceService.get('CONTINUE'),
                    successMessage: this.resourceService.get('NEWSLETTERSIGNUPREGISTRATIONSUCCESSFUL'),
                    titleLabel: this.resourceService.get('NEWSLETTERSIGNUPPOPUPTITLE'),
                    unsubscriptionNotes: this.resourceService.get('NEWSLETTERSIGNUPPOPUPUNSUBSCRIBENOTES'),
                    subscribeButtonLabel: this.resourceService.get('NEWSLETTERSIGNUPPOPUPSUBSCRIBEBUTTON'),
                    styles: {
                        'background-image': "url(" + this.signUpPopupBackgroundImageUrl + ")"
                    },
                    confirm: function () {
                        this.showSuccess = true;
                    },
                    continue: function () {
                        this.defer.resolve({
                            result: 'confirm'
                        });
                    }
                }
            })
                .catch(this._sendPopupClosedGAEvent.bind(this));
        };
        return SignUpPopupService;
    }());
    Core.SignUpPopupService = SignUpPopupService;
    angular.module('TR').service('signUpPopupService', SignUpPopupService);
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .directive('baseMap', baseMap);
    function baseMap(maps, broker) {
        // const template = `
        //     <div ng-show="visible" class="hotel-availability-map">
        //         <div class="map-canvas" ng-show="initialized"></div>
        //         <div class="spinner-overlay" ng-class="{'is-complete': initialized}">
        //              <div class="spinner"></div>
        //         </div>
        //     </div>
        // `;
        // TODO template has now become domain specific as TR uses different spinner html.
        // This can be undone when we re-align.
        return {
            restrict: 'E',
            scope: {
                zoom: '@',
                thumbnail: '=',
                visible: '=',
                dealsMode: '@',
                hotelPosition: '=',
                disableUpdates: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=BaseHotelMap',
            link: link
        };
        function link(scope, el) {
            var map = null;
            scope.$watch('visible', function (v) {
                if (!v) {
                    return;
                }
                maps.loadScript(initializeMap);
            });
            function initializeMap() {
                maps.getLocations(scope.hotelPosition, null, !!scope.dealsMode)
                    .then(populateMap);
                if (!scope.disableUpdates) {
                    broker.subscribe('baseMap', 'UPDATEMAP', function () { return maps.getLocations(!!scope.dealsMode).then(populateMap); });
                    scope.$on('$destroy', function () {
                        broker.unsubscribe('baseMap');
                    });
                }
            }
            function populateMap(mapInfo) {
                var canvas = el.find('.map-canvas')[0];
                var center = mapInfo.centre;
                var zoom = parseInt(scope.zoom || 4);
                if (!map) {
                    map = maps.buildMap(canvas, center, zoom, null, scope.thumbnail);
                }
                if (mapInfo.markers) {
                    if (scope.thumbnail) {
                        var hotelId = scope.thumbnail.activeHotel.Id;
                        var hotelMarker = null;
                        for (var _i = 0, _a = mapInfo.markers; _i < _a.length; _i++) {
                            var marker = _a[_i];
                            if (marker.estabId === hotelId) {
                                hotelMarker = marker;
                                break;
                            }
                        }
                        map = maps.buildMap(canvas, null, zoom, hotelMarker, scope.thumbnail);
                        map = maps.addMarkers(map, [hotelMarker]);
                    }
                    else {
                        map = maps.addMarkers(map, mapInfo.markers);
                        map.fitBounds(mapInfo.bounds);
                        google.maps.event.addListenerOnce(map, 'idle', function () {
                            map.fitBounds(mapInfo.bounds);
                            if (scope.zoom) {
                                map.setZoom(zoom);
                            }
                        });
                    }
                }
                broker.subscribe('baseMap', 'hotelListUpdated', initializeMap);
                broker.subscribe('baseMap', 'mapTabSelected', initializeMap);
                scope.initialized = true;
                /* If the map is hidden and the window is resized we have to build it again */
                google.maps.event.clearListeners(window, 'resize');
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .directive('comboboxMkc', comboboxMkc);
    function comboboxMkc() {
        return {
            restrict: 'E',
            link: _linker,
            require: '^combobox'
        };
        function _linker(scope, el, attr, combobox) {
            var parentElement = combobox.element;
            var searchField = parentElement.find('input');
            var list = parentElement.find('ul');
            var pScope = scope.$parent;
            var keyBehaviours = {};
            searchField.on('keydown.combo', function keySelector(e) {
                var fn = keyBehaviours[e.keyCode] || angular.noop;
                fn(e);
            });
            list.on('mouseenter.combo', 'li', function selectItem() {
                $(this).addClass('combobox-selected');
            });
            list.on('mouseleave.combo', 'li', function selectItem() {
                $('.menu-list li').removeClass('combobox-selected');
            });
            scope.$on('$destroy', function () {
                searchField.off('keydown.combo');
                list.off('mouseenter.combo');
                list.off('mouseleave.combo');
            });
            keyBehaviours[9] = function tab() {
                list.hide();
            };
            // Return
            keyBehaviours[13] = function keyboardSelection() {
                pScope.clickHandler(_getScopeFromElement());
            };
            // Up arrow
            keyBehaviours[38] = _keyboardMovement(true);
            // Down arrow
            keyBehaviours[40] = _keyboardMovement();
            // Escape
            keyBehaviours[27] = function hideMenu() {
                pScope.menu = false;
                scope.$apply();
            };
            function _getScopeFromElement() {
                var se = $('.combobox-selected').scope();
                return se.d || {};
            }
            function _scrollOffset(sel) {
                var selHeight = sel.outerHeight();
                var elementTop = sel.offset() ? sel.offset().top : 0;
                var elementBottom = elementTop + selHeight;
                var listTop = list.offset() ? list.offset().top : 0;
                var listBottom = listTop + list.innerHeight();
                switch (true) {
                    case (listTop >= elementTop):
                        return -selHeight;
                    case (listBottom <= elementBottom):
                        return selHeight;
                    default:
                        return 0;
                }
            }
            /* direction === true -> UP
               direction == false -> DOWN */
            function _keyboardMovement(direction) {
                return function () {
                    var current = list.find('.combobox-selected');
                    current.removeClass('combobox-selected');
                    current = direction ? current.prev() : current.next();
                    list[0].scrollTop += _scrollOffset(current);
                    if (!current.length) {
                        var elements = list.find('li');
                        var index = direction ? elements.length - 1 : 0;
                        current = $(elements[index]);
                        list[0].scrollTop = direction ? list[0].scrollHeight : 0;
                    }
                    current.addClass('combobox-selected');
                };
            }
        }
    }
})();
var Core;
(function (Core) {
    var FlightLeg = /** @class */ (function () {
        function FlightLeg(resourceService, $filter) {
            this.resourceService = resourceService;
            this.$filter = $filter;
            this.displayFlightViaInfo = TRPCONFIG.Domain.DisplayFlightViaInfo && this.leg.Segments
                && this.leg.Segments.length > 0;
            this.displayMixedCarrierMessage = this.leg.IsMixedCarrier &&
                this.leg.NumberOfStops > 0 &&
                this.displayFlightViaInfo === false;
            this.displayCodeShareInfo = TRPCONFIG.Domain.DisplayFlightCodeshareInfo || false;
            if (this.displayMixedCarrierMessage) {
                this.mixedCarrierMessage = this.resourceService.get('OPERATEDBYMIXED');
            }
            if (this.displayFlightViaInfo || this.displayCodeShareInfo) {
                this.viaInfo = this.getFlightViaInfo();
            }
        }
        FlightLeg.prototype.getNumberOfStops = function () {
            var msg = this.resourceService.get('NOSTOP');
            if (this.leg.NumberOfStops === 1) {
                msg = this.resourceService.get('1STOP');
            }
            else if (this.leg.NumberOfStops > 1) {
                msg = String.format(this.resourceService.get('XSTOPS'), this.leg.NumberOfStops);
            }
            return msg;
        };
        FlightLeg.prototype.getFlightViaInfo = function () {
            var _this = this;
            var info = [];
            angular.forEach(this.leg.Segments, function (segment, i) {
                if (segment.CodeshareAirlineName !== segment.CarrierName) {
                    info.push({
                        AirportCode: _this.leg.LegType === 'outbound'
                            ? segment.DestinationAirportCode
                            : segment.DepartureAirportCode,
                        FlightNumber: segment.FlightNumber,
                        CarrierTradingName: segment.CarrierTradingName
                    });
                }
            });
            return info.map(function (item) {
                var tradingName = '';
                if (item.CarrierTradingName && item.CarrierTradingName !== '') {
                    tradingName = item.CarrierTradingName.toLowerCase();
                }
                return {
                    viaflight: String.format(_this.resourceService.get('VIASUMMARY'), item.AirportCode, item.FlightNumber),
                    operatedBy: String.format(_this.resourceService.get('OPERATEDBYCARRIER'), '<span class="trading-name">' + tradingName + '</span>')
                };
            });
        };
        return FlightLeg;
    }());
    angular
        .module('core')
        .directive('flightLeg', function ($filter) {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            bindToController: {
                leg: '='
            },
            controller: FlightLeg,
            controllerAs: 'fl',
            templateUrl: 'partials/home/directivetemplate?type=FlightLeg',
            link: function (scope, el, attr, controller) {
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var FlightListing = /** @class */ (function () {
        function FlightListing(broker, resourceService, $scope, occupancyService, basketService, flightSearch, analytics, flightDetail) {
            var _this = this;
            this.broker = broker;
            this.resourceService = resourceService;
            this.$scope = $scope;
            this.occupancyService = occupancyService;
            this.basketService = basketService;
            this.flightSearch = flightSearch;
            this.analytics = analytics;
            this.flightDetail = flightDetail;
            //update properties after flight provided ( selected flight )
            if (!this.flight) {
                this.buttonType = this.buttonType ? this.buttonType : 'select';
                var flightWatch_1 = this.$scope.$watch('fl.flight', function (value) {
                    if (value) {
                        _this.update();
                        flightWatch_1();
                    }
                });
            }
            else {
                this.update();
            }
        }
        FlightListing.prototype.update = function () {
            this.priorityForPreSelection = this.flight.PriorityForPreSelection;
            this.recentlyViewed = this.isFirst && this.flight.RecentlyViewedIndex === 1;
            this.buttonType = this.buttonType ? this.buttonType : 'select';
            this.showButton = this.buttonType === 'none' ? false : true;
            this.showTax = this.showPrice && this.getTotalPrice() > 0 || false;
            this.showDeposit = this.showInfo && this.flight && this.flight.DepositAmount > 0;
            this.showBaggage = TRPCONFIG.Domain.DisplayBaggageFeesLink
                && this.flight
                && this.flight.Legs
                && this.flight.Legs.some(function (leg) { return leg.IsMixedCarrier === true; });
        };
        FlightListing.prototype.init = function () {
            this.depositMessage = this.signedIn
                ? this.resourceService.get('FLIGHTLISTINGDEPOSITCAPTIONSIGNEDIN')
                : this.resourceService.get('FLIGHTLISTINGDEPOSITCAPTION');
            this.flightButtonText = this.buttonType && this.buttonType.toLowerCase() === 'keep'
                ? this.resourceService.get('KEEPTHISFLIGHT')
                : this.resourceService.get('SELECTFLIGHTTEXT');
        };
        FlightListing.prototype.showDetails = function () {
            var passengers = this.occupancyService.getTotalPeopleCounts();
            this.broker.publish('showModalFlightDetails', { flight: this.flight, passengers: passengers });
        };
        FlightListing.prototype.changeFlight = function () {
            if (this.changeFlightTracking) {
                this.analytics.track('mixpanel', this.changeFlightTracking);
            }
            else {
                this.analytics.track('mixpanel', 'ChangeFlightClick');
            }
            if (TRPCONFIG.Domain2.ChangeFlightTrackingEnabled) {
                this.analytics.trackEvent({
                    category: "Change Flight" /* Category */ + ' ' + this.trackingPage,
                    action: "Click" /* Action */,
                    label: "Change Flight" /* Label */
                });
            }
            this.flightSearch.resetPageIndex();
            this.basketService.changeJourneyUrl(10);
        };
        FlightListing.prototype.stops = function (n) {
            return n === '' ? undefined : new Array(parseInt(n, 10));
        };
        FlightListing.prototype.selectFlightAction = function () {
            this.flightAction({ f: this.flight });
        };
        FlightListing.prototype.getTotalPrice = function () {
            return this.flight.LeadAdultPrice + this.flight.LeadAdultTax || 0;
        };
        FlightListing.prototype.isHFareFlightType = function () {
            return this.flightDetail.isHFlightType(this.flight);
        };
        return FlightListing;
    }());
    angular
        .module('core')
        .directive('flightListing', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                flight: '=',
                appliedBags: '=',
                nonInfantPassengers: '=',
                isFirst: '=',
                signedIn: '=',
                buttonType: '@',
                flightAction: '&',
                showPrice: '=',
                basePrice: '@',
                showInfo: '=',
                showChangeFlight: '=',
                changeFlightTracking: '=',
                trackingPage: '=',
                busy: '='
            },
            controller: FlightListing,
            controllerAs: 'fl',
            templateUrl: 'partials/home/directivetemplate?type=FlightListing',
            link: function (scope, el, attr, controller) {
                controller.init();
            }
        };
    });
})(Core || (Core = {}));
var Core;
(function (Core) {
    var FlightStops = /** @class */ (function () {
        function FlightStops() {
        }
        FlightStops.prototype.getStops = function () {
            return this.stops === '' ? undefined : new Array(parseInt(this.stops, 10));
        };
        return FlightStops;
    }());
    angular
        .module('core')
        .directive('flightStops', function () {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            bindToController: {
                stops: '@'
            },
            controller: FlightStops,
            controllerAs: 'fs',
            template: '<div class="flight-stops-graphic">' +
                '   <div class="stops">' +
                '       <div class="stop" ng-repeat="stop in fs.getStops() track by $index"></div>' +
                '   </div>' +
                '</div>'
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .directive('infoWindow', infoWindow);
    function infoWindow($location, $routeParams, $filter, broker, preferences, occupancyService, resourceService, tripService, basketService, currentDestination, windowUtil, pageStrand, urlUtils, holidayDeals, hotelService) {
        // TODO this is a hack to let TR have a uniqiue template. The template needs to be an embedded string or
        // else the info window has a loading delay and can fail to load altogether on some devices.
        var viewHotelButton = "\n            <div class=\"button-wrapper\" style=\"position: absolute; bottom: 12px;\"\n                ng-if=\"hotel.Id != pageHotelId\">\n                <a class=\"o-button o-button--primary o-button--sm sc-c-button sc-c-button--primary sc-c-button--hollow\"\n                    ng-click=\"selectHotel(hotel)\">\n                    View hotel\n                </a>\n            </div>";
        var templatesByTenant = {
            1: "\n                <div class=\"hotel-info-window \">\n                    <div class=\"hotel-image flex-item\" ng-style=\"hotelImage\"></div>\n                    <div class=\"hotel-info\">\n                        <div>\n                            <h4 class=\"heading-small hotel-name\">\n                                <a ng-if=\"hotel.Id != pageHotelId\" ng-click=\"selectHotel(hotel)\">\n                                    <span ng-show=\"!pageHotelId\">{{ ::hotel.Title }}</span>\n                                    <span ng-show=\"pageHotelId\">{{ ::(hotel.Name || hotel.Title) }}</span>\n                                </a>\n                                <span ng-if=\"hotel.Id == pageHotelId\">{{ ::(hotel.Name || hotel.Title) }}</span>\n                            </h4>\n                            <ul class=\"ratings\">\n                                <li>\n                                    <star-rating rating=\"::hotel.StarRating\"></star-rating>\n                                    <span ng-if=\"hotel.CustomerRatingCount > 0\">\n                                        <span class=\"customer-rating\">\n                                            <span class=\"rating\">{{ ::hotel.CustomerRating }}</span>\n                                            <span class=\"phrase\">{{ ::hotel.CustomerRatingTitle }}</span>\n                                            <span class=\"reviews\">({{ ::hotel.CustomerRatingCount }} {{ ::reviewString }})</span>\n                                        </a>\n                                    </span>                        \n                                </li>\n                                <li>\n                                    <div class=\"teaser-price\" ng-if=\"!PackagePrice\">\n                                        <span ng-if=\"hotel.OriginalCostStr && hotel.OriginalCostStr!=hotel.displayPrice\">\n                                            <span class=\"price-was\"> \n                                                <span class=\"price\">{{ hotel.OriginalCostStr }}</span>\n                                            </span>\n                                        </span>\n                                        <span class=\"price\">\n                                            {{hotel.displayPrice}}\n                                        </span>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div> \n                        " + viewHotelButton + "\n                    </div>\n                </div>"
        };
        var templateFallback = "\n            <div class=\"hotel-info-window\">\n                <div class=\"hotel-image\" ng-style=\"hotelImage\">\n                    <shortlist-toggle hotel=\"hotel\"> </shortlist-toggle>\n                </div>\n                <div class=\"hotel-info\">\n                    <h4 class=\"hotel-name ellipsis\">\n                        <a ng-if=\"hotel.Id != pageHotelId\" ng-click=\"selectHotel(hotel)\">\n                            <span ng-show=\"!pageHotelId\">{{ ::hotel.Title }}</span>\n                            <span ng-show=\"pageHotelId\">{{ ::(hotel.Name || hotel.Title) }}</span>\n                        </a>\n                        <span ng-if=\"hotel.Id == pageHotelId\">{{ ::(hotel.Name || hotel.Title) }}</span>\n                        <span ng-if=\"inlineStarsEnabled\" class =\"inline-stars stars-{{ ::hotel.StarRating }}\"><rating stars=\"{{ ::hotel.StarRating }}\"> </rating></span>\n                    </h4>\n                    <div class=\"hotel-location\">\n                        {{ ::hotel.AcomType }} | {{ ::hotel.Address }}\n                    </div>\n                    <rating stars=\"{{ ::hotel.StarRating }}\"> </rating>\n                    <div class=\"customer-rating\" ng-if=\"hotel.CustomerRating > 0\">\n                        <span class=\"phrase\"> {{ ::hotel.CustomerRating }} </span>\n                        <span class=\"phrase\"> {{ ::hotel.CustomerRatingTitle }} </span>\n                        <span class=\"reviews\" ng-if=\"::displayReviews\">\n                            ({{ ::hotel.CustomerRatingCount }} {{ ::reviewString }})\n                        </span>\n                    </div>\n                    <div class=\"teaser-price\" ng-if=\"!PackagePrice\"> {{ hotel.displayPrice }} </div>\n                    " + viewHotelButton + "\n                </div>\n            </div>";
        return {
            restrict: 'E',
            scope: true,
            template: templatesByTenant[TRPCONFIG.Domain.TenantId] ? templatesByTenant[TRPCONFIG.Domain.TenantId] : templateFallback,
            link: link
        };
        function link(scope) {
            var isTrip = !!$routeParams.tripId;
            var nonInfants = occupancyService.getNumberOfNonInfantPassengers();
            preferences.get('priceMode').then(function (pm) { return _calculatePrice(pm); });
            tripService.usePackageRates().then(function (packagePrice) { return scope.PackagePrice = packagePrice; });
            _setHotelId($routeParams.estabId);
            scope.inlineStarsEnabled = TRPCONFIG.Domain.InlineStarsEnabled;
            scope.hotelImage = { 'background-image': "url(" + scope.hotel.ImageUrl + ")" };
            scope.reviewString = resourceService.get(scope.hotelCustomerRatingCount > 1 ? 'HOTELREVIEWS' : 'HOTELREVIEW');
            scope.displayReviews = TRPCONFIG.Domain.ReviewsEnabled;
            broker.subscribe("infoWindow" + scope.$id, 'priceModeChanged', function (e) { return _calculatePrice(e.data); });
            scope.$on('$destroy', function () {
                broker.unsubscribe("infoWindow" + scope.$id);
            });
            if (isTrip) {
                _setHotelId($routeParams.estabId);
                scope.selectButton = resourceService.get('SELECTHOTELTEXT');
                scope.selectHotel = _selectTripHotel;
            }
            else if (scope.dealsMode) {
                scope.selectButton = resourceService.get('SHOWDEALS');
                scope.selectHotel = function () { return _getDeals(scope.hotel); };
            }
            else {
                scope.selectButton = resourceService.get('VIEWDETAILS');
                scope.selectHotel = _selectLandingHotel;
                currentDestination.getCurrentDestination().then(function (dest) {
                    _setHotelId(dest.EstablishmentId);
                });
            }
            function _setHotelId(id) {
                scope.pageHotelId = id || null;
            }
            function _calculatePrice(pm) {
                var costValue = pm === 0 ?
                    scope.hotel.MinCost / nonInfants :
                    scope.hotel.MinCost;
                if (costValue) {
                    scope.hotel.displayPrice = $filter('roundedCurrency')(costValue);
                }
            }
            function _selectTripHotel(h) {
                tripService.getTrip($routeParams.tripId).then(function (trip) {
                    basketService.selectHotel(trip.TripId, h, trip.BasketId);
                    hotelService.trackHotelClick(_.get(h, 'Id'), undefined, undefined, undefined, _.get(trip, 'HotelsRequest.AvailabilitySearchId'));
                });
            }
            function _getDeals(hotel) {
                holidayDeals
                    .getDealsFromMap(hotel.Id)
                    .then(function (hotelWithDeals) {
                    if (!hotelWithDeals) {
                        return;
                    }
                    hotel.HolidayDeals = hotelWithDeals.HolidayDeals;
                    hotel.TransferTimes = hotelWithDeals.TransferTimes;
                    hotel.Airports = hotelWithDeals.Airports;
                    broker.publish('SHOWDEALS', { hotel: holidayDeals.enrichHotel(hotel) });
                });
            }
            function _selectLandingHotel(h) {
                currentDestination.getCurrentDestination().then(function (dest) {
                    var url = urlUtils.stripLeadingSlash(pageStrand.adjustUrl(urlUtils.appendExistingQueryString(h.Url), dest.PageStrand));
                    if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                        windowUtil.open(url);
                    }
                    else {
                        $location.path(url);
                    }
                });
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .directive('lightboxMap', lightboxMap);
    function lightboxMap(maps, broker) {
        var template = "\n        <lightbox class=\"lightbox-map\" show=\"showModal\" busy=\"loadingMap\" close=\"close()\">\n            <div class=\"map-canvas\"> </div>\n        </lightbox>\n    ";
        return {
            restrict: 'E',
            scope: {
                zoom: '@',
                dealsMode: '@'
            },
            template: template,
            link: link
        };
        function link(scope, el) {
            var map = null;
            var data = {};
            broker.subscribe('lightboxMap', 'MAPLIGHTBOX', function (e) {
                data = e.data;
                maps.loadScript(initializeMap);
            });
            function initializeMap() {
                displayModal(true);
                displayLoader(true);
                var centre = {
                    lat: data.hotel.lat || data.hotel.Latitude,
                    lon: data.hotel.lon || data.hotel.Longitude,
                };
                maps.getLocations(null, centre, !!scope.dealsMode, data.showInfoWindow)
                    .then(function (result) { populateMap(result); });
            }
            function populateMap(mapInfo) {
                var selectedMarker = null;
                if (mapInfo.markers) {
                    selectedMarker = _.find(mapInfo.markers, function (x) { return x.estabId === data.hotel.Id; });
                }
                var canvas = el.find('.map-canvas');
                var zoom = parseInt(scope.zoom);
                var mapRendered = scope.$watch(function () { return canvas.height(); }, function (v) {
                    if (v && v !== 100) {
                        map = maps.buildMap(canvas[0], mapInfo.centre, zoom, selectedMarker);
                        map = maps.addMarkers(map, mapInfo.markers, selectedMarker, mapInfo.infoWindow);
                        mapRendered();
                    }
                });
                scope.close = onClose;
                displayLoader(false);
            }
            function onClose() {
                displayModal(false);
            }
            function displayModal(value) {
                scope.showModal = value;
            }
            function displayLoader(value) {
                scope.loadingMap = value;
            }
            scope.$on('$destroy', function () {
                broker.unsubscribe('lightboxMap');
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('core')
        .directive('lightboxMapTrigger', lightboxMapTrigger);
    function lightboxMapTrigger(broker) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                element: '=',
                searchId: '@',
                showInfoWindow: '@'
            },
            link: link
        };
        function link(scope, el) {
            var showInfoWindow = scope.showInfoWindow !== 'false';
            el.on('click', function () {
                broker.publish('MAPLIGHTBOX', {
                    hotel: scope.element,
                    searchId: scope.searchId,
                    showInfoWindow: showInfoWindow
                });
            });
            scope.$on('$destroy', function () {
                el.off('click');
            });
        }
    }
})();
var Core;
(function (Core) {
    var ModalParkingDetails = /** @class */ (function () {
        function ModalParkingDetails($scope, modalService) {
            this.$scope = $scope;
            this.modalService = modalService;
            this.Details = modalService.get('details');
            this.airport = modalService.get('airport');
            this.dropOffDate = modalService.get('dropOffDate');
            this.pickUpDate = modalService.get('pickUpDate');
        }
        return ModalParkingDetails;
    }());
    angular
        .module('core')
        .directive('parkingDetails', function () {
        return {
            scope: {},
            controller: ModalParkingDetails,
            controllerAs: 'pd',
            templateUrl: function (elem, attr) {
                return "partials/booking/template?name=ParkingDetails&version=" + attr.templateVersion;
            }
        };
    });
})(Core || (Core = {}));
(function () {
    'use strict';
    angular
        .module('core')
        .factory('maps', maps);
    function maps($window, $timeout, $rootScope, $compile, $routeParams, $q, hotelCoordinates, hotelRehydrator, holidayDeals, tripService) {
        var MAX_ZOOM = 1;
        var isMapReady = false;
        var isDealsMode = false;
        return {
            loadScript: loadScript,
            getLocations: getLocations,
            buildMap: buildMap,
            addMarkers: addMarkers
        };
        function loadScript(mapLoadedCb) {
            if (TRPCONFIG.IsBot) {
                return;
            }
            // if the script is loading go in polling mode...
            if ($window.TRPMAPS && !isMapReady) {
                return _pollingForMap(mapLoadedCb);
            }
            // ...if script is loaded just callback..
            if ($window.TRPMAPS && isMapReady) {
                return mapLoadedCb();
            }
            // ...actually load the script for maps
            $window.TRPMAPS = _.bind(_mapLoaded, {}, mapLoadedCb);
            var script = "<script type='text/javascript' id='googleScript' src='https://maps.googleapis.com/maps/api/js?client=" + TRPCONFIG.Domain.GoogleClientId + "&channel=1-Mobile&callback=TRPMAPS&v=3'/>";
            $('head').append(script);
        }
        function _mapLoaded(cb) {
            isMapReady = true;
            cb();
        }
        function _pollingForMap(cb, stop) {
            if (!stop) {
                stop = 0;
            }
            else if (stop > 10) {
                return cb();
            }
            $timeout(function () {
                if (isMapReady) {
                    cb();
                }
                else {
                    _pollingForMap(cb, stop++);
                }
            }, 50);
        }
        function getLocations(position, defaultCoordinates, dealsMode, displayInfoWindow) {
            if (dealsMode) {
                return _getDealsLocations(position);
            }
            var coordinates;
            //Try to get available hotels using the tripId.
            var positions = _getHotelPositionsForTrip().then(function (data) {
                coordinates = data;
                if (coordinates && coordinates.Hotels && coordinates.Hotels[0]) {
                    return coordinates.Hotels;
                }
                //When there are no hotels available then we should make a static call to get all hotels.
                return _getHotelPositionsWithoutTrip();
            });
            if (!positions) {
                positions = $q.when([defaultCoordinates]);
            }
            return positions.then(function (hps) {
                if (coordinates && coordinates.Destination && coordinates.Destination.EstablishmentId) {
                    //When the target establishment is not available, manually inject it into the results.
                    var targetHotel = _.find(hps, function (hp) { return hp.Id === coordinates.Destination.EstablishmentId; });
                    if (!targetHotel) {
                        targetHotel = {
                            Id: coordinates.Destination.EstablishmentId,
                            Latitude: coordinates.Destination.Latitude,
                            Longitude: coordinates.Destination.Longitude,
                            isAvailable: false
                        };
                        hps.push(targetHotel);
                    }
                }
                return _parseResults(hps, coordinates, defaultCoordinates, displayInfoWindow);
            });
        }
        function _getDealsLocations(position) {
            isDealsMode = true;
            if (position) {
                return $q.when(_parseResults([position]));
            }
            return holidayDeals.getMapCoordinates().then(_parseResults);
        }
        function _parseResults(positions, coordinates, defaultCoordinates, displayInfoWindow) {
            var infoWindow = displayInfoWindow === false ? null : new google.maps.InfoWindow();
            var clickHandler = infoWindow ? _markerClickedFactory(infoWindow, null) : null;
            var result = {
                centre: _getMapCentre(positions, coordinates, defaultCoordinates),
                infoWindow: infoWindow,
                clickHandler: clickHandler,
                markers: [],
                bounds: new google.maps.LatLngBounds()
            };
            if (positions) {
                result.markers = positions.map(function (hp) {
                    var position = new google.maps.LatLng(hp.Latitude, hp.Longitude);
                    var m = _createMarker(hp, position, displayInfoWindow);
                    result.bounds.extend(position);
                    if (result.infoWindow && result.clickHandler) {
                        google.maps.event.addListener(m, 'click', result.clickHandler);
                    }
                    return m;
                });
            }
            return result;
        }
        function _getHotelPositions(searchId, trip) {
            return hotelCoordinates.getCoordinates(searchId)
                .then(function (data) {
                data = angular.copy(data);
                _.forEach(data.Hotels, function (h) { return h.isAvailable = true; });
                if (trip) {
                    data.Destination = trip.HotelsRequest.Destination;
                }
                return data;
            });
        }
        function _getHotelPositionsForTrip() {
            if ($routeParams.tripId) {
                return tripService
                    .getTrip($routeParams.tripId)
                    .then(function (trip) { return _getHotelPositions(trip.HotelsRequest.AvailabilitySearchId, trip); });
            }
            return $q.when();
        }
        function _getHotelPositionsWithoutTrip() {
            return hotelCoordinates.getCoordinates().then(function (data) {
                data = angular.copy(data);
                var hotels = [];
                if (data && data.Hotels) {
                    hotels = data.Hotels;
                    _.forEach(hotels, function (h) {
                        h.isAvailable = false;
                    });
                }
                return hotels;
            });
        }
        function _getMapCentre(hotelPositions, hotelCoordinates, defaultCoords) {
            var centre = defaultCoords || { lat: 0, lon: 0 };
            if (hotelPositions && hotelPositions[0]) {
                centre = {
                    lat: hotelPositions[0].Latitude,
                    lon: hotelPositions[0].Longitude
                };
            }
            else if (hotelCoordinates && hotelCoordinates.CentrePosition) {
                centre = {
                    lat: hotelCoordinates.CentrePosition.Latitude,
                    lon: hotelCoordinates.CentrePosition.Longitude
                };
            }
            else if (hotelCoordinates && hotelCoordinates.Destination) {
                centre = {
                    lat: hotelCoordinates.Destination.Latitude,
                    lon: hotelCoordinates.Destination.Longitude
                };
            }
            return new google.maps.LatLng(centre.lat, centre.lon);
        }
        function _createMarker(hp, position, displayInfoWindow) {
            return new google.maps.Marker({
                position: position,
                icon: 'build/img/Maps/map-pin.svg',
                estabId: hp.Id,
                dealMinPrice: hp.DealMinPrice,
                isAvailable: hp.isAvailable,
                clickable: displayInfoWindow
            });
        }
        function _markerClickedFactory(infoWindow, map) {
            return function markerClicked() {
                var _this = this;
                infoWindow.close();
                infoWindow.setContent('<div class="hotel-info-window-loader"> </div>');
                var hotel = this.isAvailable ? hotelRehydrator.hotel(this.estabId) : hotelRehydrator.staticHotel(this.estabId, true);
                hotel.then(function (h) {
                    infoWindow.open(_this.get('map') || map, _this);
                    var t = '<info-window> </info-window>';
                    var s = $rootScope.$new(true);
                    if (_this.dealMinPrice) {
                        h.MinCost = _this.dealMinPrice;
                    }
                    s.hotel = h;
                    s.dealsMode = isDealsMode;
                    infoWindow.setContent($compile(t)(s)[0]);
                });
            };
        }
        function buildMap(canvas, center, zoom, selectedMarker, thumbnail) {
            if (thumbnail) {
                this.thumbnail = true;
                return new google.maps.Map(canvas, {
                    zoom: zoom,
                    scrollwheel: false,
                    overviewMapControl: false,
                    center: selectedMarker ? selectedMarker.getPosition() : center,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    scaleControl: false
                });
            }
            var options = {
                scrollwheel: true,
                overviewMapControl: true,
                center: selectedMarker ? selectedMarker.getPosition() : center,
                mapTypeControl: true,
                streetViewControl: true,
                fullscreenControl: true,
                scaleControl: true
            };
            if (zoom) {
                options.zoom = zoom;
            }
            return new google.maps.Map(canvas, options);
        }
        function addMarkers(map, markers, selectedMarker, infoWindow) {
            if (map.clusterer == null) {
                map.clusterer = new MarkerClusterer(map, markers, { maxZoom: MAX_ZOOM });
            }
            else if (markers && markers.length) {
                map.clusterer.clearMarkers();
                map.clusterer.addMarkers(markers);
            }
            google.maps.event.addListenerOnce(map, 'idle', function () {
                google.maps.event.trigger(map, 'resize');
                if (selectedMarker && infoWindow) {
                    _markerClickedFactory(infoWindow, map).bind(selectedMarker)();
                }
            });
            return map;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('FlightsFilter', FlightsFilter);
    function FlightsFilter($scope, flightSearch, broker, dateUtil, resourceService, $routeParams, tripService, flightsFilterService) {
        var ff = this;
        var limit = 5;
        var limitedFilters = ['FlightsByAirline', 'FlightsByDepartureAirportTitles', 'DepartureDates'];
        var agg;
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var selectedFlightId = _.get(trip, 'FlightsRequest.SelectedFlight.FlightId');
            flightSearch.getSearchResults(trip.FlightsRequest.AvailabilitySearchId, trip.TripId, selectedFlightId)
                .then(function (results) {
                if (results && trip && trip.FlightsRequest) {
                    configureFilterLimits(results);
                    configureFilterOptions(results, trip.FlightsRequest);
                }
            });
        });
        function configureFilterLimits(results) {
            agg = results.CombinedDates.UnfilteredAggregates;
            flightsFilterService.arrayifyAggregates(agg, limitedFilters);
            if (ff.filterLimits == null) {
                ff.filterLimits = {};
                limitedFilters.forEach(function (f) {
                    ff.filterLimits[f] = agg[f + "Array"].length <= limit ? agg[f + "Array"].length : limit;
                });
            }
            ff.moreLess = function (filterName) {
                if (!ff.filterLimits || agg[filterName + "Array"].length <= limit) {
                    return '';
                }
                if (ff.filterLimits[filterName] <= limit) {
                    return resourceService.get('MORE');
                }
                if (ff.filterLimits[filterName] > limit) {
                    return resourceService.get('FEWER');
                }
            };
            ff.toggleLimit = function (filterName) {
                ff.filterLimits[filterName] = (ff.filterLimits[filterName] < agg[filterName + "Array"].length) ? agg[filterName + "Array"].length : limit;
            };
        }
        function configureFilterOptions(results, request) {
            var codes = request.SelectedDepartureAirport.Code.split(',');
            ff.isAirportFilterAvailable = codes.length > 1;
            var dates = Object.keys(results.CombinedDates.UnfilteredAggregates.DepartureDates);
            ff.isDatesFilterAvailable = true;
            if (dates.length === 1) {
                tripService.getFlightsRequestDepartureDate($routeParams.tripId).then(function (date) {
                    ff.isDatesFilterAvailable = !dateUtil.sameDay(dates[0], date);
                });
            }
        }
        broker.subscribe('FlightsFilterCtrl', 'flightsListUpdated', function (ev) {
            updateFilter();
            configureFilterLimits(ev.data);
            watchFilter();
        });
        broker.subscribe('FlightsFilterCtrl', 'newSearchTriggered', newSearchTriggered);
        var canceller;
        function stopWatch() {
            if (canceller != null) {
                canceller();
            }
        }
        /* when a new search is triggered we will be reseting the filters. This means that we need to
           suspend the watch on the filter because the callback function for the new search will
           copy the new aggregate data into the (reset) filter object and trigger the watch (which
           will then trigger a call to filter) otherwise */
        function newSearchTriggered() {
            ff.filterLimits = null;
            ff.resetFilters(true).then(stopWatch);
        }
        //set up functions to delegate to the flightSearch counterparts while suspending the filter watcher
        ['removeArrayFilter', 'resetArrayFilter', 'resetRangeFilter', 'resetFilters', 'resetBooleanFilter'].forEach(function (fn) {
            ff[fn] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                stopWatch();
                return flightSearch[fn].apply(flightSearch, args).then(watchFilter).then(updateFilter);
            };
        });
        function updateFilter() {
            ff.filter = flightSearch.getFilter();
        }
        function watchFilter() {
            stopWatch();
            canceller = $scope.$watch('ff.filter', _.debounce(function (f, o) {
                if (f == null || f === o) {
                    return;
                }
                flightSearch.filter().then(updateFilter);
            }, 300), true);
        }
        flightSearch.getFilterLazy().then(function (filter) {
            ff.filter = filter;
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('FlightsFilterCtrl');
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('FlightsSort', FlightsSort);
    function FlightsSort($scope, flightSearch, preferences) {
        var fs = this;
        preferences.getFlightSortOrder().then(function (so) {
            fs.SortCriterion = so;
            $scope.$watch('fs.SortCriterion', function (f, o) {
                if (f == null || f === o) {
                    return;
                }
                flightSearch.sort(f);
            }, true);
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelsSort', HotelsSort);
    function HotelsSort($scope, hotelSearch, preferences) {
        var hs = this;
        preferences.getHotelSortOrder().then(function (so) {
            hs.SortCriterion = so;
            $scope.$watch('hs.SortCriterion', function (f, o) {
                if (f == null || f === o) {
                    return;
                }
                hotelSearch.sort(f);
            }, true);
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('AvailabilityMap', AvailabilityMap);
    function AvailabilityMap($q, pageStrand, urlUtils, windowUtil, basketService, $scope, $routeParams, tripService, hotelCoordinates, broker, $location, resourceService, currentDestination) {
        var mc = this;
        mc.popup = false;
        mc.togglePopup = togglePopup;
        mc.mapReady = false;
        function togglePopup() {
            if (mc.coords == null) {
                loadCoordinates().then(function () {
                    mc.popup = !mc.popup;
                });
            }
            else {
                mc.popup = !mc.popup;
            }
        }
        if ($location.search().pd === 'mp') {
            togglePopup();
        }
        broker.subscribe('AvailabilityMap', 'lightboxOpened', function () {
            mc.lightboxOpen = true;
        });
        broker.subscribe('AvailabilityMap', 'mapReady', function () {
            mc.mapReady = true;
        });
        function loadCoordinates() {
            function parseResults(data) {
                if (data == null) {
                    return;
                }
                mc.centre = data.CentrePosition;
                mc.zoom = data.ZoomLevel;
                mc.coords = data.Hotels;
            }
            if ($routeParams.tripId) {
                mc.bookButton = function () {
                    return resourceService.get('SELECTHOTELTEXT');
                };
                return tripService.getTrip($routeParams.tripId).then(function (trip) {
                    broker.subscribe('AvailabilityMapCtrl', 'selectHotel', function (ev) {
                        basketService.selectHotel(trip.TripId, ev.data.hotel, trip.BasketId);
                    });
                    return trip.HotelsRequest ?
                        hotelCoordinates.getCoordinates(trip.HotelsRequest.AvailabilitySearchId).then(parseResults) :
                        $q.when();
                });
            }
            //if we are not already part of a trip, just go straight through to the hotel
            //landing parge
            broker.subscribe('AvailabilityMapCtrl', 'selectHotel', function (ev) {
                var hotel = ev.data.hotel;
                currentDestination.getCurrentDestination().then(function (dest) {
                    var url = urlUtils.stripLeadingSlash(pageStrand.adjustUrl(urlUtils.appendExistingQueryString(hotel.Url || hotel.FriendlyUrl), dest.PageStrand));
                    if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                        windowUtil.open(url);
                    }
                    else {
                        $location.path(url);
                    }
                });
            });
            mc.bookButton = function () {
                return resourceService.get('VIEWDETAILS');
            };
            return hotelCoordinates.getCoordinates().then(parseResults);
        }
        broker.subscribe('AvailabilityMap', 'hotelResultsModified', loadCoordinates);
        broker.subscribe('AvailabilityMap', 'hotelResultsRetrieved', loadCoordinates);
        $scope.$on('$destroy', function () {
            broker.unsubscribe('AvailabilityMap');
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelsFilter', HotelsFilter);
    function HotelsFilter($scope, hotelSearch, broker, resourceService, hotelsFilter) {
        var hf = this;
        var agg;
        hf.newSearch = true;
        hotelSearch.getFilterLazy().then(function (filter) {
            hf.filter = filter;
        });
        broker.subscribe('HotelsFilterCtrl', 'newSearchTriggered', newSearchTriggered);
        broker.subscribe('HotelsFilterCtrl', 'hotelListUpdated', function (ev) {
            updateFilter();
            if (ev.data.Aggregates) {
                configureFilterLimits(ev.data);
            }
            watchFilter();
        });
        $scope.$on('$destroy', function () {
            broker.unsubscribe('HotelsFilterCtrl');
        });
        function configureFilterLimits(results) {
            agg = results.Aggregates;
            if (hf.filterLimits == null) {
                hf.filterLimits = hotelsFilter.getFilterLimits(agg);
            }
            hf.moreLess = function (filterName) {
                if (!agg[filterName + "Array"] || (agg[filterName + "Array"].length <= hotelsFilter.config[filterName].limit)) {
                    return '';
                }
                if (hf.filterLimits[filterName] <= hotelsFilter.config[filterName].limit) {
                    return resourceService.get('MORE');
                }
                if (hf.filterLimits[filterName] > hotelsFilter.config[filterName].limit) {
                    return resourceService.get('FEWER');
                }
            };
            hf.toggleLimit = function (filterName) {
                hf.filterLimits[filterName] = (hf.filterLimits[filterName] < agg[filterName + "Array"].length) ? agg[filterName + "Array"].length : hotelsFilter.config[filterName].limit;
            };
            function toggleOpenSelected() {
                if (hf.newSearch === false) {
                    return;
                }
                for (var i in agg) {
                    if (typeof agg[i + "Array"] !== 'undefined') {
                        if (i.indexOf('HotelsBy') >= 0) {
                            var name_5 = i.replace('HotelsBy', '');
                            //check in singular and plural form of model
                            var f = hf.filter[name_5] || hf.filter[name_5 + "s"];
                            hf.filterLimits[i] = f && f.length > 0 ? agg[i + "Array"].length : hf.filterLimits[i];
                        }
                        else if (checkFacilities(i)) {
                            hf.filterLimits[i] = agg[i + "Array"].length;
                        }
                    }
                }
                hf.newSearch = false;
            }
            toggleOpenSelected();
            function checkFacilities(filterName) {
                return _.some(agg[filterName + "Array"], function (v) { return v.name && _.includes(hf.filter.FacilityCodes, v.name); });
            }
        }
        ['removeFilter', 'removeArrayFilter', 'resetArrayFilter', 'resetBitFilter', 'resetRangeFilter', 'resetFilters'].forEach(function (fn) {
            hf[fn] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                stopWatch();
                return hotelSearch[fn].apply(hotelSearch, args).then(watchFilter).then(updateFilter);
            };
        });
        hf.resetFacilityFilter = function (group) {
            stopWatch();
            var codesInGroup = [];
            for (var code in agg[group]) {
                codesInGroup.push(code);
            }
            return hotelSearch.removeFiltersIn('FacilityCodes', codesInGroup).then(watchFilter).then(updateFilter);
        };
        function updateFilter() {
            hf.filter = hotelSearch.getFilter();
        }
        var canceller;
        function stopWatch() {
            canceller && canceller();
        }
        function watchFilter() {
            stopWatch();
            canceller = $scope.$watch('hf.filter', _.debounce(function (filter, old) {
                if (filter == null || _.isEqual(filter, old)) {
                    return;
                }
                //this filter has changed therefore we have to remove any estab group filter just in case
                hotelSearch.filter().then(updateFilter);
            }, 300), true);
        }
        //the reason that filters need to be reset when a new search is triggered is because the filter criteria
        //are built from the aggregates which will be completely different when the search results load. So
        //don't be tempted to remove this. Seriously.
        //Furthermore when we trigger a new search, becuase we have to reset the filters we also need to suspend
        //the watch until those results have been resolved otherwise we get double calling of the getHotelsFromSession
        //Fragile? absolutely.
        function newSearchTriggered() {
            hf.newSearch = true;
            hf.resetFilters().then(stopWatch);
        }
    }
})();
/*
    Creates an airport multi select field.
    Selectable options are exposed as `ac.data`.
*/
var Autocompleter;
(function (Autocompleter) {
    var AirportMultiSelectUnified = /** @class */ (function (_super) {
        __extends(AirportMultiSelectUnified, _super);
        function AirportMultiSelectUnified($scope, $route, autocompleter, resourceService, $q, $timeout, destinationService) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$route = $route;
            _this.autocompleter = autocompleter;
            _this.resourceService = resourceService;
            _this.$q = $q;
            _this.$timeout = $timeout;
            _this.destinationService = destinationService;
            _this.available = [];
            _this.isCodeSelected = function (code) { return _.find(_this.currentValue, function (v) { return code === v.Code; }); };
            _this.titleCache = {};
            if (_.isEmpty(_this.areaOverride)) {
                _this.areaOverride = 'flights';
            }
            _this.$scope.$watch('ac.currentValue', function (v) {
                if (v) {
                    _this._refreshData();
                }
            });
            // Wrap `select` attribute fn
            _this.selectAttrFn = _this.select;
            _this.select = function (item) {
                _this.selectItem(item);
                _this.selectAttrFn({ items: _this.currentValue });
            };
            if (_this.prefilled != null && _this.prefilled !== '') {
                _this.prefill(_this.prefilled);
            }
            else if (_this.getArea() === 'flights-departure') {
                _this.autocompleter.initialDepartureAirports().then(function (result) { return _this.update(result); });
            }
            return _this;
        }
        AirportMultiSelectUnified.prototype.prefill = function (data) {
            var _this = this;
            var prefill = data.split(/\s*,\s*/);
            this.prefix = data;
            this.fetch().then(function () {
                prefill.forEach(function (code) {
                    _this.available.forEach(function (item) {
                        if (item.Code === code) {
                            _this.select(item);
                        }
                    });
                });
            });
        };
        Object.defineProperty(AirportMultiSelectUnified.prototype, "placeholder", {
            get: function () {
                return this._placeholder;
            },
            set: function (placeholder) {
                if (!this.notActive) {
                    this._placeholder = placeholder;
                }
                else {
                    this._placeholder = this.resourceService.get('DEFAULTAIRPORT');
                }
            },
            enumerable: true,
            configurable: true
        });
        AirportMultiSelectUnified.prototype.update = function (result) {
            // Called by super._fetch() with autocompleter.lookup result
            this.available = result.data;
            this._refreshData();
            if (_.isEmpty(this.data) && !this.notActive) {
                this.data = null;
                this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        };
        AirportMultiSelectUnified.prototype.selectItem = function (item) {
            var _this = this;
            if (item && item.Code) {
                // Add codes which are not already selected
                var codes = item.Code.split(',');
                _.forEach(codes, function (code) {
                    if (!_this.isCodeSelected(code)) {
                        if (!_this.currentValue) {
                            _this.currentValue = [];
                        }
                        _this.currentValue.push({ Code: code, Title: item.Title });
                    }
                });
                this.prefix = '';
                this._refreshData();
            }
        };
        AirportMultiSelectUnified.prototype.removeItem = function (item) {
            if (!item) {
                return;
            }
            this.currentValue.splice(this.currentValue.indexOf(item), 1);
            if (!this.currentValue.length) {
                this.deselect();
            }
            else {
                this.selectAttrFn({ items: this.currentValue });
            }
            this._refreshData();
        };
        AirportMultiSelectUnified.prototype.blur = function () {
            var _this = this;
            this.$timeout(function () {
                if (_this.prefix) {
                    var firstItem = _.find(_this.data || [], function (d) { return !d.header; });
                    if (firstItem) {
                        _this.select(firstItem);
                    }
                }
            }, 200);
        };
        AirportMultiSelectUnified.prototype.firstTitle = function () {
            if (!this.$scope.extraFocusTrackerFocused) {
                if (this.currentValue && this.currentValue[0]) {
                    return this.getTitle(this.currentValue[0]);
                }
            }
        };
        AirportMultiSelectUnified.prototype.getTitle = function (airport) {
            var _this = this;
            if (airport.Code in this.titleCache) {
                return this.titleCache[airport.Code];
            }
            if (airport.Title) {
                return this.titleCache[airport.Code] = this.formatTitle(airport.Title);
            }
            this.destinationService
                .getAirport(airport.Code)
                .then(function (airport) { return _this.titleCache[airport.Code] = _this.formatTitle(airport.Title); });
            return this.titleCache[airport.Code] = ' ';
        };
        AirportMultiSelectUnified.prototype.formatTitle = function (title) {
            return (title || '').split('(')[0].split(',')[0];
        };
        AirportMultiSelectUnified.prototype._refreshData = function () {
            this.data = this.addHeader(this._getAvailable(), 'AIRPORTS');
        };
        AirportMultiSelectUnified.prototype._getAvailable = function () {
            var _this = this;
            // Filters out items where all codes are already selected
            return _.reject(this.available, function (item) { return _.every(item.Code.split(','), _this.isCodeSelected); });
        };
        return AirportMultiSelectUnified;
    }(Autocompleter.AutocompleterField));
    angular
        .module('TR')
        .directive('airportMultiSelectUnified', function () {
        return {
            restrict: 'E',
            replace: false,
            scope: {},
            controllerAs: 'ac',
            bindToController: {
                placeholder: '@',
                select: '&',
                deselect: '&',
                currentValue: '=',
                focusTracker: '=',
                minPrefix: '@',
                notActive: '=',
                prefilled: '@',
                disabled: '@',
                areaOverride: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=AirportMultiSelectUnified',
            controller: AirportMultiSelectUnified,
            transclude: true,
            link: function (scope, el) {
                scope.ac.inputField = el.find('input');
            }
        };
    });
})(Autocompleter || (Autocompleter = {}));
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('compactRoomGrid', function ($routeParams, scrollService, broker, hotelRoomService, occupancyService, cookieService, taxationService, analytics, mandatoryTransferService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                priceMode: '=',
                numNights: '=',
                selectRooms: '&',
                showModal: '&',
                flightCostPerPerson: '=',
                flightCostTotal: '=',
                holidayMode: '=',
                currencyCode: '@',
                roomsLeftLimit: '=',
                packagePrice: '=',
                marhabaCost: '=?',
                isKidsFree: '=',
                showCityTax: '=',
            },
            transclude: false,
            templateUrl: 'partials/home/directivetemplate?type=CompactRoomGrid',
            link: function (scope) {
                scope.roomGridData = [];
                scope.selectedPrices = {};
                scope.showAllRooms = false;
                scope.roomsToShow = 2;
                scope.selectSingleRoom = selectSingleRoom;
                scope.selectMultipleRooms = selectMultipleRooms;
                scope.totalRoomCosts = 0;
                scope.totalRoomCostsOriginal = 0;
                scope.showMessagePopup = false;
                scope.pickRooms = pickRooms;
                scope.moreRooms = 0;
                scope.toggleExtraRooms = toggleExtraRooms;
                scope.totalNonInfants = 0;
                scope.openImageGallery = openImageGallery;
                scope.roomImages = [];
                scope.showRoomImages = false;
                scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
                scope.marhabaCost = scope.marhabaCost || 0;
                scope.showDiscount = TRPCONFIG.Domain.SeasonalDeals && TRPCONFIG.Domain.SeasonalDeals.isPillVisible;
                scope.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
                scope.holidayWasAmount = function (p, room) {
                    return p.OriginalCost / (scope.priceMode === 0 ? room.nonInfants : 1) +
                        (scope.priceMode === 0 ? scope.flightCostPerPerson :
                            scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
                };
                scope.holidayAmount = function (p, room) {
                    return p.Cost / (scope.priceMode === 0 ? room.nonInfants : 1) +
                        (scope.priceMode === 0 ? scope.flightCostPerPerson :
                            scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
                };
                scope.holidayDiscountPercentage = function (p) {
                    if (!scope.packagePrice && p.DiscountPercentage > 0) {
                        return p.DiscountPercentage;
                    }
                };
                scope.getBasePrice = function (p) {
                    if (p.BoardOptions[0] && p.BoardOptions[0].Cost) {
                        return p.BoardOptions[0].Cost;
                    }
                    return 0;
                };
                scope.checkIsBasePrice = function (base, current) {
                    if (base === current) {
                        return true;
                    }
                    return false;
                };
                scope.displayBoardPrice = function (room, price, priceMode) {
                    return price.Cost / (priceMode === 0 ? room.nonInfants : 1) + (((scope.marhabaCost || 0) / (priceMode === 0
                        ? room.nonInfants : 1)) / (scope.roomGridData.length || 1)) + (priceMode === 0 ? scope.flightCostPerPerson
                        : scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
                };
                broker.subscribe('CompactRoomGrid', 'roomsSet', function (ev) {
                    scope.hotel = ev.data;
                    _restructureData();
                });
                broker.subscribe('CompactRoomGrid', 'continueToBookFromFlightDetailsModal', function (e) {
                    if (e.data.multipleRoomMode) {
                        mandatoryTransferService.generateMandatoryOptions(scope.selectedPrices, e.data.flightDetails);
                        pickRooms();
                    }
                    else {
                        mandatoryTransferService.generateMandatoryOptions(e.data.roomId, e.data.flightDetails);
                        continueToBook(e.data.roomId, e.data.priceId);
                    }
                });
                scope.$on('$destroy', function () {
                    broker.unsubscribe('CompactRoomGrid');
                });
                function _findHotelRoomPrices(hotelData, findTemplate) {
                    hotelData.forEach(function (_a) {
                        var Availability = _a.Availability, nonInfants = _a.nonInfants;
                        return Availability.forEach(function (_a) {
                            var BoardTypes = _a.BoardTypes;
                            return BoardTypes.forEach(function (_a) {
                                var Prices = _a.Prices;
                                return Prices.forEach(function (Price) { return findTemplate(Price, nonInfants); });
                            });
                        });
                    });
                }
                function _restructureData() {
                    //For the compact grid view let the usual room stuff happen and then restructure the data
                    //in to the format we want.
                    var hotelData = hotelRoomService.restructureData(scope.hotel);
                    scope.roomGridData = hotelData;
                    //set up array to hold the selected rooms, really only because of multiroom
                    scope.selectedPrices = {};
                    for (var i = 0; i < hotelData.length; i++) {
                        scope.selectedPrices[hotelData[i].Id] = (hotelData.length > 1 && hotelData[i].Availability[0])
                            ? hotelData[i].Availability[0].BoardTypes[0].Prices[0].Id : null;
                    }
                    if (hotelData.length > 0) {
                        if (scope.showCityTax && TRPCONFIG.Domain.EnableCityTax) {
                            var estabList_1 = [];
                            _findHotelRoomPrices(hotelData, function (_a, nonInfants) {
                                var Cost = _a.Cost;
                                return estabList_1.push({
                                    EstabId: scope.hotel.Id,
                                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                                    TotalCost: Cost / (scope.priceMode === 0 ? nonInfants : 1)
                                });
                            });
                        }
                        var totalRooms = _.reduce(_.map(hotelData, function (rr) { return rr.Availability.length; }), function (n, m) { return n + m; }, 0);
                        scope.moreRooms = totalRooms - (hotelData.length * scope.roomsToShow);
                        scope.totalNonInfants = scope.isKidsFree
                            ? occupancyService.getOnlyPayingIndividuals()
                            : _.reduce(hotelData, function (n, m) { return n + m.nonInfants; }, 0);
                    }
                }
                function selectSingleRoom(roomId, priceId, roomIndex, roomInfo) {
                    if (roomInfo === void 0) { roomInfo = {}; }
                    if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !scope.holidayMode) {
                        checkMandatoryTransfers(roomInfo, roomId, priceId, roomIndex);
                    }
                    else {
                        continueToBook(roomId, priceId);
                    }
                }
                function selectMultipleRooms() {
                    if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !scope.holidayMode) {
                        var roomsWithMandatoryTransfer = mandatoryTransferService.getRoomsWithTransfers(scope.hotel, scope.roomGridData, scope.selectedPrices);
                        roomsWithMandatoryTransfer.length > 0 ? selectTransferForMultiRoom(roomsWithMandatoryTransfer) : pickRooms();
                    }
                    else {
                        pickRooms();
                    }
                }
                function selectTransferForMultiRoom(rooms) {
                    var priceMode = scope.priceMode;
                    broker.publish('showModalAddFlightDetailsForMultiRooms', { rooms: rooms, priceMode: priceMode });
                }
                function checkMandatoryTransfers(roomInfo, roomId, priceId, roomIndex) {
                    var mandatoryTransfers = mandatoryTransferService.getTransfers(roomInfo.Extras);
                    var showMandatoryExtrasModal = roomInfo.Extras ?
                        mandatoryTransfers.length > 0 :
                        false;
                    var priceMode = scope.priceMode;
                    var totalNonInfants = scope.totalNonInfants;
                    showMandatoryExtrasModal ? broker.publish('showModalAddFlightDetails', { roomId: roomId, priceId: priceId, roomInfo: roomInfo, roomIndex: roomIndex, priceMode: priceMode, totalNonInfants: totalNonInfants }) : continueToBook(roomId, priceId);
                }
                function continueToBook(roomId, priceId) {
                    var isPriceIdArray = _.isArray(priceId);
                    if (isPriceIdArray && priceId.length === 1) {
                        priceId = priceId.join();
                    }
                    analytics.trackEvent({ category: 'searches', action: 'optionsPage' });
                    scope.selectedPrices[roomId] = priceId;
                    cookieService.set('SelectedPrices', scope.selectedPrices[roomId]);
                    cookieService.set('VoucherCode', '');
                    cookieService.set('VoucherWarnMessage', '');
                    pickRooms();
                }
                function pickRooms() {
                    if (_.some(scope.selectedPrices, function (p) { return p == null; })) {
                        scope.showMessagePopup = true;
                    }
                    else {
                        var arr = _.map(scope.selectedPrices);
                        scope.selectRooms({ ids: arr });
                    }
                }
                function toggleExtraRooms() {
                    if (scope.showAllRooms) {
                        scrollService.scrollTo('#roomsPanel', { animate: true }).then(function () {
                            scope.showAllRooms = !scope.showAllRooms;
                        });
                    }
                    else {
                        scope.showAllRooms = !scope.showAllRooms;
                    }
                }
                function openImageGallery(url, e) {
                    e.preventDefault();
                    scope.roomImages = [];
                    scope.roomImages.push({ src: url });
                    scope.showRoomImages = true;
                }
            }
        };
    });
})();
/*
    Tracks focus on a form field for validation.
*/
var TR;
(function (TR) {
    var FocusTracker = /** @class */ (function () {
        function FocusTracker($scope, $element, $parse, $timeout) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.$parse = $parse;
            this.$timeout = $timeout;
            $scope.$on('$destroy', function () {
                _this.deregister();
                FocusTracker.lastField = null;
            });
        }
        // May be called manually i.e. if form field is in a different scope
        FocusTracker.prototype.init = function (el) {
            var _this = this;
            if (el === void 0) { el = this.$element; }
            var field = this.field =
                this.$parse(this.focusTracker)(this.$scope);
            if (field) {
                // Handle for some places where `controllerAs` var not available
                this.field.ft = this.$scope.ft;
                if (this.el) {
                    this.deregister();
                }
                this.el = el
                    .focus(function () { return _this.focusHandler(); })
                    .blur(function () { return _this.blurHandler(); });
            }
        };
        FocusTracker.prototype.focusHandler = function () {
            var _this = this;
            this.$timeout(function () {
                _this.field.focused = true;
                _this.setLastField();
            });
        };
        FocusTracker.prototype.blurHandler = function () {
            var _this = this;
            this.$timeout(function () {
                _this.field.focused = false;
            });
        };
        FocusTracker.prototype.setLastField = function () {
            if (FocusTracker.lastField) {
                FocusTracker.lastField.lastFocused = false;
            }
            this.field.lastFocused = true;
            FocusTracker.lastField = this.field;
        };
        FocusTracker.prototype.deregister = function () {
            if (this.el) {
                this.el.off('focus blur');
            }
        };
        return FocusTracker;
    }());
    angular
        .module('TR')
        .directive('focusTracker', function () {
        return {
            restrict: 'A',
            controller: FocusTracker,
            controllerAs: 'ft',
            bindToController: {
                focusTracker: '@'
            },
            link: function (scope) {
                scope.ft.init();
            }
        };
    });
})(TR || (TR = {}));
(function () {
    'use strict';
    angular.module('TR')
        .directive('lightboxConfirmation', lightboxConfirmation);
    function lightboxConfirmation() {
        return {
            restrict: 'E',
            replace: true,
            transclude: {
                // Modal title may be provided either by `headerText` attribute
                // or named transclusion i.e. `<modal-title> Details </modal-title>`
                title: '?modalTitle'
            },
            scope: {
                show: '=',
                confirm: '&',
                confirmText: '@',
                confirmCss: '@',
                reject: '&',
                rejectText: '@',
                rejectCss: '@',
                headerText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=LightboxConfirmation',
            link: function (scope, el, attrs) {
                scope.confirmCss = angular.isUndefined(attrs.confirmCss) ? 'secondary' : attrs.confirmCss;
                scope.rejectCss = angular.isUndefined(attrs.rejectCss) ? '' : attrs.rejectCss;
                scope.ok = function () {
                    scope.show = false;
                    scope.confirm();
                };
                scope.cancel = function () {
                    scope.show = false;
                    //check the function has been specified before calling it
                    if (angular.isDefined(attrs.reject)) {
                        scope.reject();
                    }
                };
                scope.closeClicked = function (e) {
                    e.preventDefault();
                    scope.cancel();
                };
                var overlay = el;
                scope.$watch('show', function (v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    if (v) {
                        //disable browser scroll bar
                        $('body').css('overflow', 'hidden');
                        overlay.fadeIn(300, 'swing', function () {
                            $(window).resize(); //not particularly thrilled with this
                        });
                    }
                    else {
                        overlay.fadeOut(200, 'swing');
                        // re-enable browser scroll bar
                        $('body').css('overflow', '');
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('lightboxGallery', lightboxGallery);
    function lightboxGallery(broker, imageService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                close: '&',
                open: '=?',
                images: '=?',
                index: '=?',
                eventMode: '@'
            },
            template: "" + '<div>' +
                '   <div class="modal-overlay"></div>' +
                '   <div class="lightbox-gallery">' +
                '       <div class="inner">' +
                '           <div class="stage">' +
                '               <div ng-show="busy" class="loader"><preloader class="circular subtle large"></preloader></div>' +
                '               <div ng-show="!inTransition && images.length > 1" class="counter">{{index + 1}} / {{images.length}}</div>' +
                '               <a href="#" ng-show="images.length > 1" class="nav prev" ng-click="previous($event)" ng-mouseover="hoverPrev = true" ng-mouseleave="hoverPrev = false"></a>' +
                '               <a href="#" ng-show="images.length > 1" class="nav next" ng-click="next($event)" ng-mouseover="hoverNext = true" ng-mouseleave="hoverNext = false"></a>' +
                '           </div>' +
                '           <a href="#" ng-show="images.length > 1" class="nav-btn prev" ng-class="{hover: hoverPrev}" ng-click="previous($event)"><i class="icon icon-chevron-' + (TRPCONFIG.Rtl ? 'right' : 'left') + "\"></i></a>" +
                ("           <a href=\"#\" ng-show=\"images.length > 1\" class=\"nav-btn next\" ng-class=\"{hover: hoverNext}\" ng-click=\"next($event)\"><i class=\"icon icon-chevron-" + (TRPCONFIG.Rtl ? 'left' : 'right') + "\"></i></a>") +
                '           <a href="#" class="close-btn"><i class="icon icon-close"></i></a>' +
                '       </div>' +
                '   </div>' +
                '</div>',
            link: function (scope, el) {
                var overlay = el.find('.modal-overlay');
                var lightbox = el.find('.lightbox-gallery');
                var inner = el.find('.inner');
                var stage = el.find('.stage');
                var stagePadding = parseInt(stage.css('padding-left')) + parseInt(stage.css('padding-right'));
                var currentImage;
                scope.busy = true;
                scope.inTransition = false;
                scope.index = 0;
                scope.hoverPrev = false;
                scope.hoverNext = false;
                scope.close = scope.eventMode ? function () { return scope.open = false; } : scope.close;
                scope.$watch('open', function (v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    if (v) {
                        // open
                        // disable window scroll bar
                        $('body').css('overflow', 'hidden');
                        overlay.fadeIn(300, 'swing', function () {
                            lightbox.addClass('open');
                            $(window).resize(); //not particularly thrilled with this
                            // display image at the current index
                            scope.select(scope.index);
                        });
                    }
                    else {
                        // close
                        lightbox.removeClass('open');
                        overlay.fadeOut(200, 'swing');
                        // enable window scroll bar
                        $('body').css('overflow', 'scroll');
                    }
                });
                // close if background is clicked
                lightbox.on('click.lightboxGallery', function () {
                    scope.$apply(scope.close);
                });
                stage.on('click.lightboxGallery', function (e) {
                    e.stopPropagation();
                });
                broker.subscribe('lightboxGallery', 'SHOWGALLERY', openImageGallery.bind(scope, imageService));
                // support keyboard commands
                $('html').on('keyup.lightboxGallery', function (e) {
                    if (!scope.open) {
                        return;
                    }
                    if (e.which === 27) {
                        scope.$apply(scope.close); // escape
                    }
                    if (e.which === 37) {
                        scope.$apply(scope.previous(e)); // left arrow
                    }
                    if (e.which === 39) {
                        scope.$apply(scope.next(e)); // right arrow
                    }
                });
                var getNextIndex = function () {
                    return scope.index < scope.images.length - 1 ? parseInt(scope.index) + 1 : 0;
                };
                var getPreviousIndex = function () {
                    return scope.index > 0 ? parseInt(scope.index) - 1 : scope.images.length - 1;
                };
                var preloadNext = function () {
                    var image = new Image();
                    image.src = scope.images[getNextIndex()].src;
                };
                scope.next = function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    scope.select(getNextIndex());
                };
                scope.previous = function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    scope.select(getPreviousIndex());
                };
                scope.select = function (index) {
                    if (scope.inTransition) {
                        return;
                    }
                    scope.inTransition = true;
                    scope.index = index;
                    // make the current image invisible (we need to retain height or the stage collapses)
                    currentImage = stage.find('img').css({ visibility: 'hidden' });
                    scope.busy = true;
                    var image = new Image();
                    image.onload = function () {
                        // user may have closed the lightbox before the image loads
                        if (!scope.open) {
                            return;
                        }
                        // get the image dimensions
                        var width = this.width;
                        var height = this.height;
                        var aspect = width / height;
                        // lock the maximum width of the image so it can't scale up
                        $(image).css({ maxWidth: width + "px", maxHeight: height + "px" });
                        // what is the available display width?
                        var maxWidth = parseInt(inner.width()) - stagePadding;
                        // resize the stage ready to display the image
                        if (width > maxWidth) {
                            // we need to downscale
                            width = maxWidth;
                            height = width / aspect;
                        }
                        // perform the stage resize animation
                        stage.animate({
                            width: width,
                            height: height
                        }, {
                            queue: true,
                            duration: 300,
                            easing: 'swing',
                            complete: function () {
                                currentImage.remove();
                                scope.$apply(function () {
                                    scope.busy = false;
                                });
                                // fade in the new image
                                $(image).appendTo(stage).hide().fadeIn(300, 'swing', function () {
                                    stage.css({ width: '', height: '' });
                                    scope.$apply(function () {
                                        scope.inTransition = false;
                                    });
                                });
                            }
                        });
                    };
                    // preload image
                    image.src = scope.images[scope.index].src;
                    // preload next image
                    preloadNext();
                };
                function openImageGallery(imageService, e) {
                    var _a = e.data, estabId = _a.estabId, totalImgs = _a.totalImgs;
                    var w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
                    var h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
                    this.index = 0;
                    var images = [];
                    for (var i = 0, ii = totalImgs; i < ii; i++) {
                        images.push({
                            src: imageService.getImageUrl(estabId, w, h, i, false)
                        });
                    }
                    this.images = images;
                    this.open = true;
                }
                scope.$on('$destroy', function () {
                    // unbind jquery event listeners
                    $('html').off('keyup.lightboxGallery');
                    lightbox.off('click.lightboxGallery');
                    stage.off('click.lightboxGallery');
                    broker.unsubscribe('lightboxGallery');
                });
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .directive('occupancyUnified', Occupancy);
    function Occupancy($timeout, $route, $document, arrayUtil, occupancyService) {
        var minAdults = 2;
        return {
            restrict: 'E',
            replace: true,
            scope: {
                maxRooms: '@',
                maxAge: '@',
                maxAdultAge: '@',
                occupancy: '=',
                multiroomDisabled: '=',
                hideGroupBookingLink: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=OccupancyUnified',
            link: _linker
        };
        function _linker(scope, el) {
            var wrapper = $('#occupancy-selectors', el);
            var inp = $('.input-occupancy', el);
            var timer;
            function initPosition() {
                wrapper.position({
                    my: 'left top',
                    of: inp,
                    at: 'left bottom',
                    collision: 'fit'
                });
            }
            initPosition();
            function initPositionTimeout() {
                $timeout.cancel(timer);
                timer = $timeout(initPosition, 50);
            }
            scope.getAdultsLimit = memoizePerArea(function (area, firstRoom) {
                var limits = TRPCONFIG.Domain.OccupancyLimits[area];
                var maxValue = (firstRoom && limits) ? limits.maxAdults : 6;
                return arrayUtil.createRange(maxValue);
            });
            scope.getChildrenLimit = memoizePerArea(function (area, firstRoom) {
                var limits = TRPCONFIG.Domain.OccupancyLimits[area];
                var maxValue = (firstRoom && limits) ? limits.maxChildren : 5;
                return arrayUtil.createRange(maxValue, 0);
            });
            scope.getRooms = memoizePerArea(function (area, maxRooms) {
                if (!maxRooms) {
                    var limits = TRPCONFIG.Domain.OccupancyLimits[area];
                    maxRooms = limits ? limits.maxRooms : 3;
                }
                return arrayUtil.createRange(maxRooms);
            });
            scope.showOccupancyWrapper = showOccupancyWrapper;
            scope.switchWrapper = switchWrapper;
            scope.$watch('occupancy', function (val) {
                if (val) {
                    for (var i = 0; i < val.length; i++) {
                        val[i] = sanityCheck(val[i]);
                    }
                    scope.occupancyString = occupancyService.getOccupancyString(val);
                    scope.roomOccupancyString = occupancyService.getRoomOccupancyString(val);
                    scope.totalPeopleCounts = occupancyService.getTotalPeopleCounts(val);
                }
            }, true);
            scope.$watch('extraFocusTrackerFocused', function (val) {
                if (val === !!val) {
                    if (val) {
                        initPositionTimeout();
                    }
                    scope.showWrapper = val;
                }
            });
            scope.$watch('showWrapper', function (val) {
                if (val) {
                    scope.ages = arrayUtil.createRange(parseInt(scope.maxAge) || TRPCONFIG.Domain.MaximumChildAge, 0);
                    scope.adultAges = scope.maxAdultAge ? arrayUtil.createRange(parseInt(scope.maxAdultAge), (parseInt(scope.maxAge) || TRPCONFIG.Domain.MaximumChildAge) + 1) : [];
                }
                if (val && scope.multiroomDisabled && scope.occupancy && scope.occupancy.length > 1) {
                    var mergedRoom = { Adults: 0, ChildAges: [] };
                    mergedRoom = _.reduce(scope.occupancy, merge, mergedRoom);
                    scope.occupancy = [mergedRoom];
                }
                function merge(memo, next) {
                    memo.Adults += next.Adults;
                    memo.ChildAges = memo.ChildAges.concat(next.ChildAges);
                    return memo;
                }
            });
            function sanityCheck(room) {
                room = room || {};
                room.ChildAges = room.ChildAges || [];
                room.Adults = room.Adults || minAdults;
                if (scope.maxAdultAge) {
                    room.AdultAges = room.AdultAges || [];
                    room.AdultAges.length = room.Adults;
                }
                return room;
            }
            function switchWrapper(value) {
                if (value) {
                    initPositionTimeout();
                }
                scope.showWrapper = value;
                if (value === false) {
                    $timeout(function () { return scope.extraFocusTrackerFocused = false; });
                }
            }
            function showOccupancyWrapper(e) {
                initPositionTimeout();
                scope.showWrapper = true;
                // Going to attach another click event which should not be fired
                // in the current event bubble
                e.stopPropagation();
                //this function must be declared locally to prevent it being hoisted to far,
                //and then removed from scope
                var _hideOccupancyWrapper = function _hideOccupancyWrapperFn(e) {
                    var isChild = el.find(e.target).length > 0;
                    if (!isChild) {
                        scope.$apply(function () {
                            scope.showWrapper = false;
                            $document.off('click.occupancy', _hideOccupancyWrapper);
                        });
                    }
                };
                inp.on('keydown', function tab(e) {
                    if (e.which === 9 || e.which === 27) {
                        scope.$apply(function () {
                            scope.showWrapper = false;
                        });
                    }
                });
                $document.on('click.occupancy', _hideOccupancyWrapper);
            }
            function memoizePerArea(func) {
                var memo = _.memoize(func, function (area, input) { return area + "~" + input; });
                return function (input) {
                    var area = scope.$parent.areaOverride || $route.current.area;
                    var result = memo(area, input);
                    return result;
                };
            }
            scope.$on('$destroy', function () {
                inp.off('keydown');
                $document.off('click.occupancy');
            });
        }
    }
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('productExpander', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                startExpanded: '=',
                watchProperty: '@',
                expandText: '@',
                collapseText: '@'
            },
            template: '<div class="product-section" ng-transclude></div>',
            transclude: true,
            controller: function ($scope) {
                $scope.show = $scope.startExpanded || false;
            }
        };
    });
    TR.directive('productExpanderButton', function () {
        return {
            restrict: 'E',
            transclude: false,
            replace: true,
            scope: false,
            template: '<a href="#" ng-click="toggle()">{{buttonText}}</a>',
            link: function (scope) {
                scope.show = scope.$parent.show;
                var _setButtonText = function (show) {
                    scope.buttonText = (show === false) ? scope.$parent.expandText : scope.$parent.collapseText;
                };
                scope.toggle = function () {
                    scope.show = !scope.show;
                    _setButtonText(scope.show);
                };
                _setButtonText(scope.show);
                if (scope.$parent.watchProperty) {
                    var cancel_1 = scope.$watch(scope.$parent.watchProperty, function (v) {
                        if (!v) {
                            return;
                        }
                        cancel_1();
                        scope.show = v;
                        _setButtonText(scope.show);
                    });
                }
            }
        };
    });
    TR.directive('productExpanderBody', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: false,
            template: '<div class="body" ng-show="show" ng-transclude></div>',
            link: function (scope) {
                scope.show = scope.$parent.show;
            }
        };
    });
})();
(function () {
    'use strict';
    //this directive exists only to self destruct as soon as angular receives an unblock
    var TR = angular.module('TR');
    TR.directive('selfDestruct', function (broker) {
        return {
            restrict: 'A',
            link: function (scope, el) {
                broker.subscribe('SelfDestructDirective', 'selfdestruct', function () {
                    el.remove();
                    broker.unsubscribe('SelfDestructDirective', 'selfdestruct');
                });
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    /*
        CONFIGURATION
        -------------
        Config is defined in the maxParagraphs scope variable
        Use EITHER a number :: which defines number of paragraphs to show across all screen sizes
        OR object map with properties sm,md and lg with corresponding values;
        eg { sm : 1 } to only display 1 paragraph on small screens, will display all on md and lg screens
        eg { sm : 1, md : 1 } to display 1 paragraph on small & medium screens...
    
        screen size breakpoints defined in show-hide-text.less
    */
    TR.directive('showHideText', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                text: '=',
                maxParagraphs: '&',
                showMoreText: '@',
                showLessText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=ShowHideText',
            link: function (scope, element) {
                var content = '';
                var activeClasses = ['hidden-sm', 'hidden-md', 'hidden-lg'];
                scope.requiresCropping = false;
                scope.contentIsHidden = true;
                var maxParagraphs = scope.maxParagraphs();
                if (maxParagraphs) {
                    scope.requiresCropping = true;
                }
                if (scope.requiresCropping && angular.isObject(maxParagraphs)) {
                    var showHideClass = ['hidden-sm', 'hidden-md', 'hidden-lg'];
                    for (var key in maxParagraphs) {
                        showHideClass.splice(showHideClass.indexOf("hidden-" + key), 1);
                    }
                    scope.showHideClass = showHideClass.join(' ');
                }
                scope.$watch('text', function (t) {
                    if (!t) {
                        return;
                    }
                    content = $('<span/>').html(scope.text);
                    determineHiddenText();
                });
                scope.toggleHiddenContent = function (e) {
                    e.preventDefault();
                    scope.contentIsHidden = !scope.contentIsHidden;
                    element.find("." + activeClasses.join(' .')).toggleClass('visible');
                };
                function determineHiddenText() {
                    scope.htmlContent = '';
                    content.children().each(function (i, el) {
                        if (maxParagraphs) {
                            if (angular.isNumber(maxParagraphs)) {
                                if (i >= maxParagraphs) {
                                    el.classList.add(activeClasses.toString().split(',').join(' '));
                                }
                            }
                            else if (angular.isObject(maxParagraphs)) {
                                activeClasses = [];
                                for (var key in maxParagraphs) {
                                    if (i >= maxParagraphs[key]) {
                                        el.classList.add("hidden-" + key);
                                        activeClasses.push("hidden-" + key);
                                    }
                                }
                            }
                        }
                        scope.htmlContent += (el.outerHTML || el.textContent);
                    });
                }
            }
        };
    });
})();
(function () {
    'use strict';
    var TR = angular.module('TR');
    TR.directive('slidePanel', function (broker) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                open: '=',
                hideEvent: '@'
            },
            template: '<div class="slide-panel" ng-transclude></div>',
            link: function (scope, el) {
                scope.show = true;
                var slidePanel = el;
                var overlay = $('<div class="modal-overlay" />').appendTo(document.body);
                // subscribe to hide event
                if (scope.hideEvent != null) {
                    broker.subscribe('slidePanel', scope.hideEvent, function () {
                        scope.shutInstantly();
                    });
                    scope.$on('$destroy', function () {
                        broker.unsubscribe('slidePanel', scope.hideEvent);
                    });
                }
                scope.slideOpen = function () {
                    slidePanel.show();
                    //disable browser scroll bar
                    $('body').css('overflow', 'hidden');
                    overlay.fadeIn(300, 'swing', function () {
                        overlay.one('click.slidePanel', function () {
                            scope.$apply(scope.open = false);
                        });
                        slidePanel.addClass('open');
                    });
                };
                scope.slideShut = function () {
                    slidePanel.removeClass('open');
                    overlay.fadeOut(200, 'swing', function () {
                        overlay.hide(); //extra hide required to deal with when we close and are 'off screen'
                    });
                    // re-enable browser scroll bar
                    $('body').css('overflow', '');
                };
                scope.shutInstantly = function () {
                    // close panel instantly
                    overlay.hide();
                    slidePanel.hide();
                    slidePanel.removeClass('open');
                    // re-enable browser scroll bar
                    $('body').css('overflow', '');
                    stopWatch();
                    scope.open = false;
                    startWatch();
                };
                var canceller;
                function stopWatch() {
                    if (canceller != null) {
                        canceller();
                    }
                }
                function startWatch() {
                    stopWatch();
                    canceller = scope.$watch('open', function (v, o) {
                        if (v == null || v === o) {
                            return;
                        }
                        if (v) {
                            // open
                            scope.slideOpen();
                        }
                        else {
                            // close
                            scope.slideShut();
                        }
                    });
                }
                startWatch();
            }
        };
    });
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('sortButton', sortButton);
    function sortButton($timeout, preferences) {
        var opposite = {
            asc: 'desc',
            desc: 'asc'
        };
        return {
            restrict: 'E',
            replace: true,
            scope: {
                model: '=',
                title: '@',
                val: '=',
                id: '=',
                group: '@',
                property: '@',
                active: '=',
                order: '=',
                defaultOrder: '@',
                defaultSort: '@',
                preferenceKey: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SortButton',
            link: function (scope, el) {
                var chk = el.find('input');
                var val;
                preferences.get(scope.preferenceKey).then(function (so) {
                    scope.order = scope.defaultOrder;
                    if (scope.val.indexOf(so) >= 0) {
                        if (so !== parseInt(scope.defaultSort)) {
                            scope.order = opposite[scope.defaultOrder];
                        }
                    }
                });
                function checked(c) {
                    chk.prop('checked', c);
                    if (c) {
                        scope.active = true;
                    }
                    else {
                        scope.active = false;
                    }
                }
                // Verifies if we're dealing with an object or a direct value
                function safeCheck(modelValue) {
                    if (scope.property) {
                        checked(modelValue[scope.property] === val[scope.property]);
                    }
                    else {
                        checked(scope.val.indexOf(modelValue) > -1);
                    }
                }
                var canc = scope.$watch('val', function (v) {
                    if (v != null) {
                        val = scope.val[0];
                        safeCheck(scope.model);
                        canc();
                    }
                });
                scope.$watch('model', function (v) {
                    if (v == null) {
                        return;
                    }
                    safeCheck(v);
                });
                scope.toggle = function (event) {
                    // Changes the model only if the value is new, emits the click
                    // event anyway.
                    var sameSelection = scope.val.indexOf(scope.model) > -1;
                    if (!sameSelection) {
                        if (scope.val.length > 1) {
                            scope.model = parseInt(scope.defaultSort);
                        }
                        else {
                            scope.model = scope.val[0];
                        }
                    }
                    else if (scope.val.length > 1) {
                        scope.model = scope.model === scope.val[0] ? scope.val[1] : scope.val[0];
                    }
                    event.preventDefault();
                    $timeout(function () { scope.$emit('radio-clicked'); });
                };
                scope.class = function () {
                    var cls = {};
                    if (scope.active) {
                        cls.active = true;
                    }
                    if (scope.order) {
                        cls[scope.order] = true;
                    }
                    return cls;
                };
                scope.$watch('model', function () {
                    if (scope.active && scope.model !== parseInt(scope.defaultSort)) {
                        scope.order = opposite[scope.defaultOrder];
                    }
                    else {
                        scope.order = scope.defaultOrder;
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';
    angular.module('TR')
        .directive('sortDropdown', sortDropdown);
    function sortDropdown(resourceService) {
        var opposite = {
            asc: 'desc',
            desc: 'asc'
        };
        return {
            restrict: 'E',
            replace: true,
            scope: {
                criteria: '=',
                model: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=SortDropdown',
            link: function (scope) {
                var cancelWatch = scope.$watch('criteria', function (value) {
                    if (value && value.length) {
                        initOptions(scope, value);
                        cancelWatch();
                    }
                });
            }
        };
        function initOptions(scope, criteria) {
            scope.options = [];
            if (criteria) {
                _.forEach(criteria, function (c) {
                    _.forEach(c.val, function (v) {
                        var option = {
                            text: c.name(),
                            value: v
                        };
                        if (c.defaultSort) {
                            var order = c.defaultSort === v ? c.defaultOrder : opposite[c.defaultOrder];
                            var orderResource = order === 'asc' ?
                                (c.ascSuffix ? c.ascSuffix() : resourceService.get('SORTDIRECTIONLABELASCENDING')) :
                                (c.descSuffix ? c.descSuffix() : resourceService.get('SORTDIRECTIONLABELDESCENDING'));
                            var orderText = "(" + orderResource + ")";
                            option.text += " " + orderText;
                        }
                        scope.options.push(option);
                    });
                });
            }
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelCoordinates', hotelCoordinates);
    function hotelCoordinates($http, hotelSearch, currentDestination, broker, objectTypeService, fieldGroupService, $routeParams, $q) {
        var url = '/api/hotels/availability/';
        var staticUrl = '/api/hotels/static/';
        var service = {
            getCoordinates: getCoordinates
        };
        var fields = 'Hotels.Id,Hotels.Latitude,Hotels.Longitude';
        var coordsCache = {};
        var fieldTypes = fieldGroupService.getFieldTypes();
        var fieldFlags = fieldGroupService.getFieldGroup(fieldTypes.Global);
        // Cache invalidation on hotel list change
        broker.subscribe('hotelCoordinates', 'hotelListUpdated', function () { return coordsCache = {}; });
        function getCoordinates(searchId) {
            function removeUnmappedHotels(data) {
                if (data == null) {
                    return null;
                }
                data.Hotels = _.filter(data.Hotels, function (hotel) { return hotel.Latitude || hotel.Longitude; });
                return data;
            }
            var promise;
            if (searchId == null) {
                return currentDestination.getCurrentDestination().then(function (dest) {
                    promise = $q.when();
                    if (dest) {
                        var objectTypeAndId = objectTypeService.getObjectTypeAndId(dest);
                        var cacheKey = objectTypeAndId.Type + "_" + objectTypeAndId.Id;
                        if (coordsCache[cacheKey]) {
                            return coordsCache[cacheKey];
                        }
                        promise = $http.post(staticUrl + "gethotelsbydestination?fields=" + fields, {
                            DestinationType: objectTypeAndId.Type,
                            DestinationId: objectTypeAndId.Id,
                            DomainId: TRPCONFIG.Domain.DomainId,
                            CultureCode: TRPCONFIG.Domain.CultureCode,
                            FilterCriteria: hotelSearch.getUserSelectedFilterCriteria(),
                            FieldFlags: fieldFlags
                        }, { ignoreErrors: true }).then(function (res) {
                            return removeUnmappedHotels(res.data);
                        });
                        coordsCache[cacheKey] = promise;
                    }
                    return promise;
                });
            }
            if (coordsCache[searchId]) {
                return coordsCache[searchId];
            }
            promise = $http.post(url + "gethotels?fields=" + fields, {
                AvailabilitySearchId: searchId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                TripId: $routeParams.tripId,
                FilterCriteria: hotelSearch.getUserSelectedFilterCriteria(),
                FieldFlags: fieldFlags
            }, { ignoreErrors: true }).then(function (res) {
                return removeUnmappedHotels(res.data);
            });
            coordsCache[searchId] = promise;
            return promise;
        }
        return service;
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .service('hotelRoomService', hotelRoomService);
    function hotelRoomService(imageService) {
        var imageDomain = TRPCONFIG.Domain.HotelImageCDN
            ? "https://" + TRPCONFIG.Domain.HotelImageCDN
            : imageService.getImageDomain();
        var reAbsUrl = /https?:\/\//i;
        var service = {
            restructureData: restructureData,
            getImageUrl: getImageUrl
        };
        function restructureData(hotel) {
            var roomsData = _getRoomsData(hotel);
            if (TRPCONFIG.Domain.LowestBoardTypePriceOnly === true) {
                return _lowestBoardTypePricesOnly(roomsData);
            }
            return roomsData;
        }
        function _lowestBoardTypePricesOnly(data) {
            return data.map(function (data) {
                data.Availability = data.Availability.map(function (room) {
                    room.BoardTypes = room.BoardTypes.map(function (boardType) {
                        if (!_.isEmpty(boardType.Prices)) {
                            boardType.Prices = [_.minBy(boardType.Prices, function (price) { return price.Cost; })];
                        }
                        return boardType;
                    });
                    return room;
                });
                return data;
            });
        }
        function _getRoomsData(hotel) {
            return _.map(hotel.Rooms, function (r, i) { return ({
                Availability: _combineRatesForRoom(r.FilteredAvailability || r.Availability, _.keyBy(hotel.RoomDetails, 'MasterId')),
                Title: r.Title,
                nonInfants: r.nonInfants,
                isRoomKidsFree: r.isRoomKidsFree,
                Id: "id" + i
            }); });
        }
        function getImageUrl(_a) {
            var ImageUrl = _a.ImageUrl, NewImageUrl = _a.NewImageUrl;
            var url = TRPCONFIG.Domain.HotelImageCDN ? NewImageUrl : ImageUrl;
            if (url) {
                return reAbsUrl.test(url)
                    ? url.replace('http:', 'https:')
                    : imageDomain + url;
            }
        }
        function _combineRatesForRoom(prices, masterRooms) {
            //restructure the provided room availability prices in to a more compact set of data, grouping
            //by the room and boardType also add in extra data from the master room object if available
            var combinedRates = [];
            for (var i = 0; i < prices.length; i++) {
                var p = prices[i];
                var properties = (!p.MasterId || p.MasterId === 0) ? { Description: p.RoomDescription } : { MasterId: p.MasterId };
                var room = _.find(combinedRates, properties); //find a room by it's master id if present otherwise use the title
                if (!room) {
                    var master = _getMasterData(masterRooms, p.MasterId); //get the master room data
                    room = {
                        Description: p.RoomDescription,
                        MasterRoomDescription: master.MasterRoomDescription,
                        BoardTypes: [],
                        ImageUrl: master.ImageUrl,
                        ExtraDescription: master.Description,
                        MasterId: p.MasterId
                    };
                    combinedRates.push(room); //add it to the array too
                }
                //check if the board type already exists
                var board = _.find(room.BoardTypes, { BoardType: p.BoardType });
                if (!board) {
                    board = {
                        BoardType: p.BoardType,
                        BoardDescription: p.BoardDescription,
                        Prices: []
                    };
                    room.BoardTypes.push(board);
                }
                //push this price into the boards price list
                board.Prices.push(p);
            }
            return combinedRates;
        }
        function _getMasterData(data, id) {
            //function so we can handle cases where the master id isn't present in our list
            var masterRoom = { Description: '', ImageUrl: '' };
            if (data && id && data[id]) {
                masterRoom.ImageUrl = getImageUrl(data[id]);
                masterRoom.Description = data[id].Description;
                masterRoom.MasterRoomDescription = data[id].Title;
            }
            return masterRoom;
        }
        return service;
    }
})();
var TR;
(function (TR) {
    var Agent = /** @class */ (function () {
        function Agent(agentModeService, $location, $scope, currentUser, $q, resourceService, broker, basketStore, guidService, modalService, cookieService, rootPath, $routeParams) {
            var _this = this;
            this.agentModeService = agentModeService;
            this.$location = $location;
            this.$scope = $scope;
            this.currentUser = currentUser;
            this.$q = $q;
            this.resourceService = resourceService;
            this.broker = broker;
            this.basketStore = basketStore;
            this.guidService = guidService;
            this.modalService = modalService;
            this.cookieService = cookieService;
            this.rootPath = rootPath;
            this.$routeParams = $routeParams;
            this.saveUsername = false;
            this.agentSigninModel = {
                username: '',
                password: ''
            };
            //this.modalService.launch('partials/agents/signin', {}, true);
            this.lightbox = true;
            this.signedIn = !!this.currentUser.get().Agent;
            if (this.signedIn) {
                this.agentModeService.getAgentInformation().then(function (data) {
                    _this.agent = data;
                    if (_this.$location.search().Dest) {
                        _this.doRedirect();
                    }
                });
            }
            this.agentSigninModel.username = cookieService.get('trpUsername') || '';
        }
        Agent.prototype.doRedirect = function () {
            var rootpath = this.rootPath.getRootPath();
            var dest = this.$location.search().Dest || '/';
            window.location.href = dest.substr(0, 1) === '/' ? dest : "" + rootpath + dest;
        };
        Agent.prototype.updateDebugCookie = function () {
            var _this = this;
            this.agentModeService.updateDebugSettings(TRPCONFIG.Domain.AgentDebugSettings).then(function () {
                _this.doRedirect();
            }, function () {
                _this.doRedirect();
            });
        };
        Agent.prototype.signin = function (model) {
            var _this = this;
            if (TRPCONFIG.Domain.SessionOnlyAgentCookie) {
                model.sessionOnly = true;
            }
            this.agentModeService.signin(model).then(function (data) {
                if (data.Success) {
                    _this.basketStore.createBasket().then(function () {
                        _this.broker.publish('agentSignIn');
                        if (_this.saveUsername) {
                            _this.cookieService.set('trpUsername', model.username);
                        }
                        if (TRPCONFIG.Domain.AgentDebugOverridesEnabled) {
                            _this.updateDebugCookie();
                        }
                        else {
                            _this.doRedirect();
                        }
                    });
                }
                else {
                    _this.$scope.$broadcast('flash:error', _this.resourceService.get('SIGNINFAILURE'));
                    return _this.$q.reject(data);
                }
            }, function (res) {
                _this.$scope.$broadcast('flash:error', _this.resourceService.get('SIGNINFAILURE'));
                return _this.$q.reject(res);
            });
        };
        Agent.prototype.signout = function () {
            var _this = this;
            this.agentModeService.signout().then(function () { return _this.doRedirect(); });
        };
        Agent.prototype.changePassword = function () {
            var _this = this;
            if (this.newPassword !== this.confirmNewPassword) {
                this.$scope.$emit('flash:error', this.resourceService.get('NEWPASWORDSDONTMATCH'));
            }
            else {
                this.agentModeService.changePassword(this.oldPassword, this.newPassword).then(function (data) {
                    if (data.Status === 0 && data.Success) {
                        _this.$location.path('');
                    }
                    else if (data.Status === 1) {
                        _this.$scope.$emit('flash:error', _this.resourceService.get('USEDPASSWORD'));
                    }
                    else if (data.Status === 2) {
                        _this.$scope.$emit('flash:error', _this.resourceService.get('INCORRECTFORMAT'));
                    }
                    else if (data.Status === 3) {
                        _this.$scope.$emit('flash:error', _this.resourceService.get('PASSWORDTOOSMALL'));
                    }
                    else if (data.Status === 4) {
                        _this.$scope.$emit('flash:error', _this.resourceService.get('INVALIDVERIFICATION'));
                    }
                });
            }
        };
        Agent.prototype.initiateReset = function () {
            var _this = this;
            this.resetStatusText = null;
            this.$scope.$emit('flash:error', null);
            this.agentModeService.resetPasswordInitiate(this.username).then(function (data) {
                if (data.Result === 0) {
                    _this.resetStatusText = _this.resourceService.get('PASSWORDRESETINITIATED');
                }
                else if (data.Result === 3) {
                    _this.$scope.$emit('flash:error', _this.resourceService.get('PASSWORDRESETFAILEDACCOUNTDISABLED'));
                }
                else {
                    _this.$scope.$emit('flash:error', _this.resourceService.get('PASSWORDRESETFAILED'));
                }
            }, function (res) { _this.$scope.$emit('flash:error', _this.resourceService.get('PASSWORDRESETFAILED')); });
        };
        Agent.prototype.resetPassword = function () {
            var _this = this;
            this.$scope.$emit('flash:error', null);
            if (this.newPassword !== this.confirmNewPassword) {
                this.$scope.$emit('flash:error', this.resourceService.get('NEWPASWORDSDONTMATCH'));
                return;
            }
            this.agentModeService.resetPassword(this.newPassword, this.$routeParams.token).then(function (data) {
                if (data.Status === 0 && data.Result === 0) {
                    _this.$location.path('agents/resetsuccessful');
                }
                else if (data.Status === 1) {
                    _this.$scope.$emit('flash:error', _this.resourceService.get('USEDPASSWORD'));
                }
                else if (data.Status === 2) {
                    _this.$scope.$emit('flash:error', _this.resourceService.get('INCORRECTFORMAT'));
                }
                else if (data.Status === 3) {
                    _this.$scope.$emit('flash:error', _this.resourceService.get('PASSWORDTOOSMALL'));
                }
                else if (data.Status === 4) {
                    _this.$scope.$emit('flash:error', _this.resourceService.get('INVALIDVERIFICATION'));
                }
            }, function (res) { _this.$scope.$emit('flash:error', _this.resourceService.get('INVALIDRESETURL')); });
        };
        return Agent;
    }());
    angular
        .module('TR')
        .controller('Agent', Agent);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var SelectedAttractionCtrl = /** @class */ (function () {
        function SelectedAttractionCtrl(basketStore, attractionService) {
            var _this = this;
            this.basketStore = basketStore;
            this.attractionService = attractionService;
            this.totalPrice = 0;
            this.totalCurrency = 'GBP';
            this.showAttractionsInfo = true;
            basketStore.getAttractionsBasket().then(function (data) {
                var basketItems = data && data.LineItems ? data.LineItems : [];
                _this.attractionsBasket = basketItems.map(function (item) {
                    var dates = attractionService.getLineItemDates(item);
                    var description = item.Description;
                    var specification = description && description.Specification;
                    var basketItem = {
                        title: description.Title,
                        selectedDate: dates.selected,
                        options: specification && specification.reduce(function (str, op) { return "" + str + (str ? ',' : '') + " " + op.Label + ": " + op.Value; }, ''),
                        specification: specification,
                        dateValidity: dates.from && dates.to
                            ? { from: dates.from, to: dates.to } : null,
                        datesMatch: dates.selected === dates.from && dates.selected === dates.to,
                        tickets: item.Tickets ? item.Tickets.map(function (ticket) {
                            var count = parseInt(ticket.Value, 10) || 0;
                            if (0 < count) {
                                _this.totalPrice += count * ticket.Price;
                                _this.totalCurrency = ticket.Currency;
                                return {
                                    label: ticket.Label,
                                    count: count,
                                    currency: ticket.Currency,
                                    price: ticket.Price,
                                    total: count * ticket.Price
                                };
                            }
                            else {
                                return null;
                            }
                        }).filter(function (item) { return item != null; }) : [],
                        ticketsTotalPrice: 0
                    };
                    basketItem.ticketsTotalPrice = basketItem.tickets.reduce(function (total, ticket) {
                        return total + ticket.total;
                    }, 0);
                    return basketItem;
                });
            });
        }
        SelectedAttractionCtrl.prototype.getCount = function () {
            return this.attractionsBasket.length;
        };
        SelectedAttractionCtrl.prototype.toggleInfo = function () {
            this.showAttractionsInfo = !this.showAttractionsInfo;
        };
        SelectedAttractionCtrl.prototype.getItems = function () {
            return this.attractionsBasket;
        };
        SelectedAttractionCtrl.prototype.getTotalPrice = function () {
            return this.totalPrice;
        };
        SelectedAttractionCtrl.prototype.getTotalCurrency = function () {
            return this.totalCurrency;
        };
        return SelectedAttractionCtrl;
    }());
    angular
        .module('TR')
        .controller('SelectedAttraction', SelectedAttractionCtrl);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Auth', Auth);
    function Auth($scope, $location, authService, resourceService, $window, modalService, $timeout, postBookingLookup, accountMenuService, $routeParams, loaderService, analytics) {
        var cm = this;
        var qs = $location.search();
        var authPages = ['signin', 'signup', 'forgot', 'bookingsignin', 'resetsent', 'verificationsent'];
        //models
        cm.bookingSigninModel = {
            bookingRef: null,
            bookingNumber: modalService.get('bookingId') || null,
            surname: null
        };
        cm.forgot = { email: null };
        cm.registerModel = { email: null, password: null, emailSignUp: false };
        cm.resetModel = { password: null };
        cm.signinModel = { email: null, password: null };
        cm.tab = modalService.get('tab');
        cm.tabContent = modalService.get('tab');
        cm.cb = modalService.get('cb');
        var email = modalService.get('email');
        if (email) {
            cm.signinModel.email = email;
            cm.registerModel.email = email;
        }
        if ($routeParams.returnUrl) {
            authService.bufferRoute($routeParams.returnUrl, true);
        }
        $scope.$on('$destroy', function () {
            modalService.destroy('tab');
        });
        modalService.onSet('tab', function (tab) {
            switchTab(tab, false, false);
        });
        modalService.onSet('cb', function (cb) {
            cm.cb = cb;
        });
        modalService.onSet('email', function (email) {
            cm.signinModel.email = email;
            cm.registerModel.email = email;
        });
        loaderService.loadJS($window.document, 'script', 'facebook-jssdk', "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9&appId=" + $window.TRPCONFIG.Domain.FacebookAppId);
        loaderService.loadJS($window.document, 'script', 'google-jssdk', '//apis.google.com/js/client:platform.js');
        cm.cancelAuth = cancelAuth;
        cm.forgotPassword = forgotPassword;
        cm.signin = signin;
        cm.switchTab = switchTab;
        cm.login = login;
        cm.switchTabContent = switchTabContent;
        cm.register = register;
        cm.showHeaders = true;
        cm.byAgent = TRPCONFIG.Domain.BookingSignInByAgent;
        cm.verificationContinue = verificationContinue;
        cm.bookingSignIn = bookingSignIn;
        cm.toManage = toManage;
        cm.contact = authService.getUser();
        cm.resetPassword = resetPassword;
        cm.showForm = !TRPCONFIG.Domain.SocialSignin;
        cm.signInWithEmail = signInWithEmail;
        cm.verify = verify;
        cm.verifyAndChoose = verifyAndChoose;
        $timeout(function () { cm.deleteButton = resourceService.get('DELETEACCOUNT'); });
        function resetPassword(model) {
            authService.changePasswordWithToken({
                UserId: qs.userId,
                NewPassword: model.password,
                VerificationToken: qs.token
            }).then(function (res) {
                if (res.Result === 0) {
                    $location.path('resetsuccessful');
                }
                else {
                    $scope.$emit('flash:error', resourceService.get('RESETPASSWORDFAILURE'));
                }
            });
        }
        function signInWithEmail() {
            cm.showForm = true;
        }
        function verify() {
            authService.verify({
                UserId: qs.userId,
                VerificationToken: qs.token
            }).then(function (resp) {
                if (resp.Success) {
                    $location.path('verified');
                }
                else {
                    $scope.$emit('flash:error', resourceService.get('VERIFYFAILURE'));
                }
            });
        }
        function verifyAndChoose(password) {
            var changePasswordRequest = {
                UserId: qs.userId,
                NewPassword: password,
                VerificationToken: qs.token
            };
            authService.changePasswordWithToken(changePasswordRequest).then(function (res) {
                if (res.Result === 0) {
                    $location.path('verified');
                }
                else {
                    $scope.$emit('flash:error', resourceService.get('VERIFYFAILURE'));
                }
            });
        }
        function _cancelEvent(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        function login(provider, event) {
            cm.busy = true;
            _cancelEvent(event);
            if (cm.tab === 'signup' || location.href.indexOf('/signup') >= 0) {
                //tracking only the clicks when it is a signUp event, not tracking the signup success
                analytics.track('mixpanel', 'UserSignUp', {
                    IdentityProvider: provider
                });
            }
            switch (provider) {
                case 'facebook':
                    _facebookLogin();
                    break;
                case 'google':
                    _googleLogin();
                    break;
            }
        }
        function _isAuthPage() {
            var url = $location.path().substring(1);
            for (var i in authPages) {
                if (url.indexOf(authPages[i]) >= 0) {
                    return true;
                }
            }
            return false;
        }
        function switchTab(tab, event, hideHeaders) {
            if (_isAuthPage()) {
                $location.url(tab);
                return;
            }
            $scope.$emit('flash:hide');
            cm.showHeaders = !hideHeaders;
            _cancelEvent(event);
            cm.tab = tab;
            cm.switchTabContent(tab);
        }
        function switchTabContent(tab, event) {
            if (_isAuthPage()) {
                $location.url(tab);
                return;
            }
            $scope.$emit('flash:hide');
            _cancelEvent(event);
            cm.tabContent = tab;
        }
        $window.fbAsyncInit = function () {
            $window.FB.init({
                xfbml: true,
                version: 'v2.9',
                appId: $window.TRPCONFIG.Domain.FacebookAppId
            });
        };
        function _postSignin(resp) {
            switch (resp.Result) {
                case 0:
                    if (cm.cb) {
                        cm.cb();
                    }
                    _closeModal();
                    break;
                case 1:
                    $scope.$broadcast('flash:error', resourceService.get('SIGNINFAILURE'));
                    break;
                case 2:
                    $scope.$broadcast('flash:error', resourceService.get('EMAILADDRESSNOTFOUND'));
                    break;
            }
            cm.busy = false;
            if (!(cm.tab === 'signup' || location.href.indexOf('/signup') >= 0)) {
                //To track only signIn event, after the signIn success
                analytics.track('mixpanel', 'UserSignedIn', {
                    IdentityProvider: (resp.User && resp.User.Identity) ? resp.User.Identity.Provider : 'none'
                });
            }
        }
        function _socialSignIn(provider, token) {
            return authService.socialSignin({
                Provider: provider,
                AccessToken: token,
                ContextTag: 'Source:Website-Social'
            }).then(_postSignin);
        }
        function _facebookLogin() {
            /* eslint-disable camelcase */
            $window.FB.login(function (response) {
                if (!response.authResponse) {
                    $scope.$broadcast('flash:error', resourceService.get('SIGNINFAILURE'));
                }
                else {
                    _socialSignIn('facebook', response.authResponse.accessToken);
                }
            }, {
                scope: 'email',
                auth_type: 'rerequest'
            });
        }
        /* eslint-enable camelcase */
        function _googleLogin() {
            $window.gapi.auth.authorize({
                /* eslint-disable camelcase */
                client_id: $window.TRPCONFIG.Domain.GoogleAppId,
                response_type: 'token',
                /* eslint-enable camelcase */
                scope: TRPCONFIG.Domain2.GoogleAuthScopes
            }, function (response) {
                if (response.error) {
                    $scope.$broadcast('flash:error', resourceService.get('SIGNINFAILURE'));
                    cm.busy = false;
                }
                else if (response.status.signed_in) {
                    _socialSignIn(TRPCONFIG.Domain2.GoogleAuthProvider, response.access_token);
                }
            });
        }
        function cancelAuth() {
            if (_isAuthPage()) {
                var route = authService.getNextRoute();
                if (qs.cb) {
                    $location.url(decodeURIComponent(qs.cb));
                }
                else {
                    $location.url(route.length > 0 ? route : 'hotel');
                }
                return;
            }
            _closeModal();
        }
        function _closeModal() {
            modalService.close();
        }
        function signin(model, event) {
            _cancelEvent(event);
            cm.busy = true;
            authService.signin({
                Email: model.email || '',
                Password: model.password || ''
            }).then(_postSignin);
        }
        function register(model, event) {
            _cancelEvent(event);
            cm.busy = true;
            var email = _.get(model, 'email', '').split('@');
            if (!model.email || (email.length > 1 && email[1].split('.').length <= 1)) {
                _signupError();
                return;
            }
            authService.register({
                Email: model.email,
                Password: model.password,
                ContextTag: 'Source:Website',
                EmailSignUp: model.emailSignUp,
                Source: 'TravelRepublic',
                SignUpReason: 'Website User Registration'
            })
                .then(function (resp) {
                if (resp.Result === 0) {
                    cm.switchTab('verificationsent', false, true);
                    analytics.track('mixpanel', 'UserSignUp', {
                        IdentityProvider: 'EmailSignUp'
                    });
                }
                else {
                    _signupError();
                }
                cm.busy = false;
            }, _signupError);
        }
        function _signupError() {
            $scope.$broadcast('flash:error', resourceService.get('ACCOUNTSIGNUPERROR'));
            cm.busy = false;
        }
        function forgotPassword(model) {
            cm.busy = true;
            authService.forgotPassword({
                Email: model.email
            }).then(function (res) {
                if (res.Success) {
                    cm.switchTab('resetsent', false, true);
                }
                else {
                    $scope.$emit('flash:error', resourceService.get('FORGOTPASSWORDFAILURE'));
                }
                cm.busy = false;
            });
        }
        function verificationContinue(event) {
            _cancelEvent(event);
            if (_isAuthPage()) {
                var route = authService.getNextRoute();
                if (route.length === 0) {
                    route = qs.cb ? qs.cb : '';
                }
                $location.url(route);
            }
            authService.bufferRoute(null);
            _closeModal();
        }
        function bookingSignIn(model, event) {
            _cancelEvent(event);
            cm.busy = true;
            if (cm.byAgent) {
                bookingSignInByAgent(model.bookingNumber);
                return;
            }
            var ref = model.bookingRef + "/" + model.bookingNumber;
            authService
                .anonSignIn(ref, model.surname)
                .then(loginResult);
        }
        function bookingSignInByAgent(bookingNumber) {
            authService
                .bookingSignInByAgent(bookingNumber)
                .then(loginResult);
        }
        function loginResult(res) {
            cm.busy = false;
            if (res) {
                if (!authService.redirectToBufferedRoute()) {
                    postBookingLookup.redirect();
                }
                _closeModal();
                return;
            }
            $scope.$broadcast('flash:error', resourceService.get('LOOKUPFAIL'));
        }
        function toManage() {
            authService.bufferRoute(null);
            accountMenuService.launchOption('bookingsignin');
        }
    }
})();
var Core;
(function (Core) {
    var BookingType = Core.ManageBooking.BookingType;
    var CrossSellType = Core.Booking.CrossSellType;
    var BookingConfirmationCtrl = /** @class */ (function () {
        function BookingConfirmationCtrl($location, $routeParams, $scope, $window, analytics, authService, bookingsManagerService, customerDashboardService, dateUtil, resourceService, costBreakdownCodes) {
            var _this = this;
            this.$location = $location;
            this.$routeParams = $routeParams;
            this.$scope = $scope;
            this.$window = $window;
            this.analytics = analytics;
            this.authService = authService;
            this.bookingsManagerService = bookingsManagerService;
            this.customerDashboardService = customerDashboardService;
            this.dateUtil = dateUtil;
            this.resourceService = resourceService;
            this.costBreakdownCodes = costBreakdownCodes;
            this.crossSells = [];
            this.defaultColSizePromo = 'col-m-9 col-l-9';
            this.defaultColSizeCrossSell = 'col-m-3 col-l-3';
            this.loadingCrossSells = true;
            this.showBreakdown = false;
            this.showCarTrawlerWidget = false;
            this.showEmailInformation = false;
            this.bookingTypeProductLabelMap = {};
            this.$scope.$emit('block', {
                title: 'Booking Completed',
                loadingScreenStyle: 'booking'
            });
            if (TRPCONFIG.Domain.HideBookingRefOnConfirmation) {
                this.$location.replace();
                this.$location.url('booking/complete');
            }
            this.trackEvent('ConfPageLanding', null);
            this.analytics.track('Facebook', 'BookingComplete');
            this.isAgentMode = TRPCONFIG.Domain.isAgentMode;
            //set up our labels that might be needed
            var addProperty = function (obj, id, resourceKey) {
                obj[id] = _this.resourceService.getDeferred(resourceKey);
            };
            addProperty(this.bookingTypeProductLabelMap, BookingType.Accommodation, 'CONFIRMATION_HOTEL');
            addProperty(this.bookingTypeProductLabelMap, BookingType.AdHoc, 'CONFIRMATION_ADHOC');
            addProperty(this.bookingTypeProductLabelMap, BookingType.AttractionTickets, 'CONFIRMATION_ATTRACTIONS');
            addProperty(this.bookingTypeProductLabelMap, BookingType.CarHire, 'CONFIRMATION_CARHIRE');
            addProperty(this.bookingTypeProductLabelMap, BookingType.Flight, 'CONFIRMATION_FLIGHT');
            addProperty(this.bookingTypeProductLabelMap, BookingType.Parking, 'CONFIRMATION_PARKING');
            addProperty(this.bookingTypeProductLabelMap, BookingType.Transfer, 'CONFIRMATION_TRANSFER');
            addProperty(this.bookingTypeProductLabelMap, BookingType.TravelInsurance, 'CONFIRMATION_INSURANCE');
            //a bit of a nasty hack to deal with encoding and users signing in on the booking complete page. The
            //ref param gets encoded twice if they sign in on the complete page so we need to handle this.
            //This fix is not ideal, but until I can check that we can change the URL structure st that the booking refs
            //are QS parameters this will do the trick
            var bookingRefs = decodeURIComponent(this.$routeParams.ref).split('|'); // ACM/123456|EUF/123456|...
            var bookingId = Number(bookingRefs[0].split('/')[1]);
            bookingsManagerService.getTrip(bookingId).then(function (trip) {
                if (trip.Destination) {
                    _this.destinationImageUrl = trip.Destination.ImageUrl;
                    _this.destinationTitle = trip.Destination.Title;
                }
                _this.adults = trip.Adults;
                _this.children = trip.Children;
                _this.infants = trip.Infants;
                _this.attraction = trip.AttractionsBooking;
                _this.carhire = trip.CarHireBooking;
                _this.hotel = trip.HotelBooking;
                _this.flight = trip.FlightBooking;
                _this.insurance = trip.InsuranceBooking;
                _this.parking = trip.AirportParkingBooking;
                _this.transfer = trip.TransferBooking;
                _this.paymentDetails = trip.PaymentDetails;
                //for the purposes of cross sell always make sure the booking Id is that of the flight (if available)
                bookingId = _this.flight && _this.flight.BookingId || bookingId;
                _this.customerDashboardService.getAllCrossSellOptions(bookingId)
                    .then(function (crossSells) {
                    //we want to remove any car hire crosssells as we are doing this via the widget
                    _.remove(crossSells, function (c) { return c.CrossSellType === CrossSellType.CarHire; });
                    var orderedCrossSells = _this.orderCrosssells(trip, crossSells);
                    _this.crossSells = _.take(orderedCrossSells, 1);
                }).finally(function () {
                    //based on the length of the cross sell options we might want the app promo / carTrawler widget
                    //to take the full width
                    var colSize = 12;
                    var colSizeCrossSell = 0;
                    if (_this.crossSells.length > 0) {
                        colSize = 12 - (_this.crossSells.length * 3);
                        colSizeCrossSell = (12 - colSize) / _this.crossSells.length;
                    }
                    _this.defaultColSizeCrossSell = "col-m-" + colSizeCrossSell + " col-l-" + colSizeCrossSell;
                    _this.defaultColSizePromo = "col-m-" + colSize + " col-l-" + colSize;
                    _this.loadingCrossSells = false;
                });
                //restructure our price breakdown lines so there is less typing for us to do in the template as these
                //are all grouped together
                _this.breakdown = _this.groupProductBreakdowns(trip);
                //flag which item we want to show, the app promo or the cartrawler widget
                _this.showCarTrawlerWidget = trip.FlightBooking && !trip.TransferBooking && !trip.CarHireBooking;
                if (_this.showCarTrawlerWidget) {
                    _this.carTrawlerUrl = _this.buildCarTrawlerUrl(trip.FlightBooking, trip.Adults + trip.Children + trip.Infants);
                }
                _this.trackEvent('ConfPageCarWidget', { ShowWidget: _this.showCarTrawlerWidget, Url: _this.carTrawlerUrl });
            }).finally(function () {
                _this.$scope.$emit('unblock');
            });
            var user = authService.getUser();
            this.isSignedIn = user.HardSignedIn;
            this.usersFirstName = user.FirstName;
            this.authModalOptions = { email: user.Email };
            this.manageBookingUrl = "dashboard/bookings/reference/" + bookingId;
        }
        BookingConfirmationCtrl.prototype.showModal = function (show, event) {
            if (event) {
                event.preventDefault();
            }
            if (show === true) {
                this.trackEvent('ConfPagePriceClick', null);
            }
            this.showBreakdown = show;
        };
        BookingConfirmationCtrl.prototype.showEmailInformationModal = function (show, event) {
            if (event) {
                event.preventDefault();
            }
            if (show === true) {
                this.trackEvent('ConfPageInfoClick', null);
            }
            this.showEmailInformation = show;
        };
        BookingConfirmationCtrl.prototype.printPage = function () {
            this.trackEvent('ConfPagePrintClick', null);
            this.$window.print();
        };
        BookingConfirmationCtrl.prototype.trackEvent = function (eventName, data) {
            this.analytics.track('mixpanel', eventName, data);
        };
        BookingConfirmationCtrl.prototype.trackCrossSellClick = function (model) {
            var data = {
                Type: CrossSellType[model.CrossSellType]
            };
            this.analytics.track('mixpanel', 'ConfPageCrossSellClick', data);
        };
        BookingConfirmationCtrl.prototype.getProductLabelForBookingType = function (bookingType) {
            //we only need to handle a couple of cases for now, but have left
            //this general enough to apply to others
            return this.bookingTypeProductLabelMap[bookingType];
        };
        BookingConfirmationCtrl.prototype.buildCarTrawlerUrl = function (flight, passengerCount) {
            var _this = this;
            //build up the cartrawler url NOVERSION param is so that we don't add cache busting to it
            var outLeg = _.last(_.filter(flight.Legs, { 'IsOutbound': true }));
            var inLeg = _.first(_.filter(flight.Legs, { 'IsOutbound': false }));
            var amendDate = function (date, hourOffset) {
                return _this.dateUtil.format(_this.dateUtil.roundedToStartOfHour(_this.dateUtil.addHours(date, hourOffset), true), 'yyyyMMddHHmm');
            };
            var pickUp = amendDate(outLeg.ArrivalTime, TRPCONFIG.CarHireFlightDepartureOffset);
            var dropOff = amendDate(inLeg.DepartureTime, TRPCONFIG.CarHireFlightReturnOffset);
            //not pretty, but multiline string adds carriage returns in the output (which we do not want)
            var base = "https://cars.cartrawler.com/travelrepublic/widget?type=html&clientId=740760&NOVERSION=-1&" +
                "num=3&locCode={0}&curr={1}&residencyId={2}&pkDateTime={3}&rtDateTime={4}&passengers={5}&" +
                "airline={6}&airlineNum={7}";
            return String.format(base, outLeg.ArrivalAirport.Code, TRPCONFIG.Domain.CurrencyCode, TRPCONFIG.Domain.CountryCode, pickUp, dropOff, passengerCount, outLeg.Carrier, outLeg.FlightNo.slice(-4) //last 4 should be the flight number
            );
        };
        BookingConfirmationCtrl.prototype.orderCrosssells = function (trip, crossSells) {
            var orderedList = new Array();
            var orderPreference = {
                Holiday: [CrossSellType.Transfers,
                    CrossSellType.CarHire,
                    CrossSellType.Baggage,
                    CrossSellType.Seats,
                    CrossSellType.Attractions
                ],
                Hotel: [
                    CrossSellType.Transfers,
                    CrossSellType.CarHire,
                    CrossSellType.Attractions,
                    CrossSellType.Parking
                ],
                Flight: [
                    CrossSellType.Hotels,
                    CrossSellType.Baggage,
                    CrossSellType.Seats,
                    CrossSellType.CarHire,
                    CrossSellType.Parking,
                    CrossSellType.Attractions
                ]
            };
            var preference = null;
            if (trip.HotelBooking) {
                preference = trip.FlightBooking ? orderPreference.Holiday : orderPreference.Hotel;
            }
            else if (trip.FlightBooking) {
                preference = orderPreference.Flight;
            }
            else {
                return orderedList;
            }
            //make an object from our preference array to make sorting a little easier
            var sortMap = preference.reduce(function (acc, val, idx) {
                acc[val] = idx;
                return acc;
            }, {});
            orderedList = _.sortBy(crossSells, function (c) { return sortMap[c.CrossSellType]; });
            return orderedList;
        };
        BookingConfirmationCtrl.prototype.groupProductBreakdowns = function (trip) {
            var _this = this;
            var breakdown = {
                cardFee: {
                    total: 0, currencyCode: ''
                },
                items: [],
                packageTotal: 0,
                discount: 0
            };
            var createBreakdownItem = function (title, quantity, total, currencyCode, isPriceHidden, supplierRef, typeId) {
                return { currencyCode: currencyCode, quantity: quantity, title: title, total: total, isPriceHidden: isPriceHidden, supplierRef: supplierRef, typeId: typeId };
            };
            _.each([trip.FlightBooking, trip.HotelBooking, trip.AirportParkingBooking, trip.AttractionsBooking,
                trip.CarHireBooking, trip.InsuranceBooking, trip.TransferBooking], function (p) {
                if (p) {
                    _.each(_.filter(p.PriceBreakdown, { 'IsPaymentFee': true }), function (b) {
                        breakdown.cardFee.total += b.UnitAmount;
                        breakdown.cardFee.currencyCode = b.CurrencyCode;
                    });
                    var item_2 = {
                        name: _this.getProductLabelForBookingType(p.BookingType)(),
                        breakdown: _.map(_.filter(p.PriceBreakdown, { 'IsPaymentFee': false }), function (b) { return createBreakdownItem(b.Description, b.Quantity, b.UnitAmount * b.Quantity, b.CurrencyCode, b.IsPriceHidden, b.SupplierRef || '', b.TypeId); }),
                        isPackageProduct: !!p.PackageId,
                        discount: 0
                    };
                    // Sum discounts
                    item_2.breakdown.forEach(function (value) {
                        if (value.typeId === 20) {
                            item_2.discount += (value.total * value.quantity);
                        }
                    });
                    // Sum invisible price with hotel
                    item_2.breakdown = item_2.breakdown.map(function (breakdown) {
                        if (breakdown.typeId === 1) {
                            item_2.breakdown.forEach(function (invisible) {
                                // Where id 0 is id of the invisible price
                                if (invisible.typeId === 0 && invisible.isPriceHidden) {
                                    breakdown.total += invisible.total;
                                }
                            });
                        }
                        return breakdown;
                    });
                    if (item_2.isPackageProduct) {
                        breakdown.packageTotal =
                            _.reduce(item_2.breakdown, function (r, b) {
                                return r + (b.typeId === 0 && b.isPriceHidden ? 0 : b.total);
                            }, breakdown.packageTotal);
                    }
                    breakdown.items.push(item_2);
                    breakdown.discount += item_2.discount;
                }
            });
            return breakdown;
        };
        return BookingConfirmationCtrl;
    }());
    angular
        .module('core')
        .controller('BookingConfirmation', BookingConfirmationCtrl);
})(Core || (Core = {}));
// @ts-nocheck
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Booking', Booking)
        .directive('backButton', function ($window) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            controller: function ($scope, $routeParams, $location) {
                $scope.goBack = function () {
                    if ($scope.isHolidayOrFlightType) {
                        $location.url("holidays/options/" + $routeParams.tripId);
                    }
                    else {
                        $window.history.back();
                    }
                };
            },
            template: '<input type="button" ng-click="goBack($event)" value="Back" />'
        };
    });
    function Booking($anchorScroll, $filter, $location, $q, $route, $routeParams, $rootScope, $sce, $scope, $timeout, $window, abTest, analytics, arrayUtil, agentModeService, authService, basketService, bd4travel, basketStore, bookingCompleteTrackingService, bookingService, bookingStatus, broker, criteoService, cookieService, costBreakdownCodes, currencyService, dateUtil, ecommerceService, guidService, insuranceService, modalService, occupancyService, paymentsCalculator, paymentsService, paymentsUtilService, quoteService, resourceService, savedSearchService, scrollService, searchUnitService, taxationService, tokeniser, tripService, trackingPixelsService, adFormService, pricingService, flightDetail) {
        var cm = this;
        var thisYear = new Date().getFullYear();
        var ppResp = {
            cancel: 'PAYPALCANCELLED',
            fail: 'PAYPALFAILED'
        };
        var paymentTabOptions = {
            Card: 0,
            PayPal: 1,
            SavedCards: 2
        };
        var paypalInContextSet = false;
        var cards;
        function changeWorkflowState(n) {
            basketService.changeJourneyUrl(n);
        }
        cm.agentMode = TRPCONFIG.Domain.isAgentMode;
        cm.WPIframeUpdate = TRPCONFIG.Domain.WPIframeUpdate;
        cm.threeDS2Enabled = TRPCONFIG.Domain.ThreeDS2EnabledTR;
        cm.directPaymentCaveat = directPaymentCaveat;
        cm.changeWorkflowState = changeWorkflowState;
        cm.acceptedAgencyTerms = false;
        cm.checkbox = {
            specialRequests: false,
            cancellationProtection: false
        };
        cm.pixels = [];
        cm.checkoutTrackingProviders = ['roomerflex'];
        cm.feePercent = 0;
        cm.feeAmount = 0;
        cm.months = arrayUtil.numberArray(1, 12);
        cm.detailsMatch = bookingService.detailsMatch;
        cm.pastYears = arrayUtil.numberArray(thisYear - 10, thisYear);
        cm.productId = $routeParams.productId;
        cm.signIn = signIn;
        cm.signOut = signOut;
        cm.threedsRedirecting = false;
        cm.WPHostedRedirect = false;
        cm.copyFromContact = copyFromContact;
        cm.years = arrayUtil.numberArray(thisYear, thisYear + 20);
        cm.driverOptions = bookingService.driverOptions;
        cm.adultTitles = bookingService.getAdultTitles();
        cm.agentModeEnabled = !!$rootScope.user.Agent;
        // if agentMode is enabled this check needs to be manually checked
        // if agentMode is not enabled this check needs to be automatically checked
        cm.agentImportantNoticeCheck = !cm.agentModeEnabled;
        cm.paymentAmountWithCardFee = 0;
        cm.dontCaptureAddress = false;
        cm.bookingLoaded = undefined;
        cm.paymentModel = paymentsUtilService.createEmptyPaymentModel();
        cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        cm.importantInfoContent = '';
        cm.showTakingPaymentModal = false;
        cm.isSecurityCodeMasked = false;
        cm.isNotCash = true;
        cm.discount = 0;
        cm.voucherCode = cookieService.get('VoucherCode') || '';
        cm.voucherCodeInput = cookieService.get('VoucherCode') || '';
        cm.voucherDiscountMsg = JSON.parse(cookieService.get('VoucherWarnMessage')
            || '{ "Message": "", "Code": 0 }') || { Message: '', Code: 0 };
        cm.isDiscountMsgPositive = false;
        cm.showDiscountAppliedBox = false;
        cm.discountAppliedBoxMsg = 'Voucher code discount applied';
        cm.isHasActiveVouchers = false;
        cm.isDiscountApplied = isDiscountApplied;
        cm.isHFareFlightType = isHFareFlightType;
        cm.enbdOptionId = TRPCONFIG.Domain2.EnbdPaymentOptionId;
        cm.threeDS2AwaitDDC = TRPCONFIG.Domain.ThreeDS2AwaitDDC;
        cm.enbdDetails = {
            cardNumber: null,
            isCpgValid: null,
            isOtpValid: null,
            sessionToken: null,
            transactionId: null,
            domainId: TRPCONFIG.Domain.DomainId,
            currencyCode: cm.currencyCode,
            isPointsPaymentApproved: null,
            pointsToRedeem: null,
            amountToRedeem: null,
            availablePoints: null,
            balanceData: null,
            isCpgInProgress: null,
            isOtpInProgress: null,
            isOtpResent: null,
            showZeroBalanceAlert: null,
            cardNumberMinLength: 13
        };
        cm.isBookingDisabled = false;
        cm.showCovidPaymentDisclaimer = false;
        cm.isHoliday = false;
        cm.isTransfer = false;
        cm.ancillaries = false;
        cm.showBreadcrumbs = false;
        cm.hideForm = false;
        cm.threeDsValidationComplete = false;
        var cpgStatusApiEnabled = TRPCONFIG.Domain.CpgStatusApiEnabled;
        function onCpgStatusAPIError(err) {
            if (err && err.error) {
                var error = err.error;
                cm.threedsRedirecting = false;
                cm.hideForm = true;
                var paymentTakenMsg = resourceService.get('PAYMENTTAKEN') + " " + resourceService.get('TELEPHONENUMBER');
                var paymentFailedMsg = resourceService.get('PAYMENTFAILED') + " CPG Payment Failed<br/><br/> " + String.format(resourceService.get('PAYMENTASSISTENCE'), resourceService.get('TELEPHONENUMBER'));
                var errorMsg = error === 'TIMER' ? paymentTakenMsg : paymentFailedMsg;
                $scope.$broadcast('flash:error', errorMsg);
            }
        }
        $scope.$on('cpgStatusAPIError', function (ev, err) {
            if (err && err.error) {
                onCpgStatusAPIError(err);
            }
        });
        cm.getVouchers = function () {
            pricingService.hasActiveVouchers().then(function (data) {
                cm.isHasActiveVouchers = data;
            });
        };
        if (TRPCONFIG.Domain.IsAddVoucherEnabled) {
            cm.getVouchers();
        }
        cm.reloadPage = function (event) {
            event.preventDefault();
            window.location.reload();
        };
        switch (cm.voucherDiscountMsg.Code) {
            case 1:
                cm.isDiscountMsgPositive = false;
                break;
            case 2:
                cm.isDiscountMsgPositive = false;
                break;
            case 3:
                cm.isDiscountMsgPositive = false;
                cm.showDiscountAppliedBox = true;
                break;
            case 4:
                cm.isDiscountMsgPositive = true;
                cm.voucherDiscountMsg.Message = 'Voucher code not applied. <b>You already have a better deal!</b>';
                break;
            case 5:
                cm.isDiscountMsgPositive = true;
                cm.showDiscountAppliedBox = true;
                cm.voucherDiscountMsg.Message = 'Your new discount has been applied. <b>You’ve bagged an even better deal!</b>';
                break;
            case 6:
                cm.isDiscountMsgPositive = true;
                cm.showDiscountAppliedBox = true;
                break;
            case 7:
                cm.isDiscountMsgPositive = true;
                cm.showDiscountAppliedBox = true;
                cm.discountAppliedBoxMsg = 'Voucher code discount removed';
                break;
        }
        var bookingId = '';
        _block();
        var bookingFormVersion = 0;
        //if the pb query string parameter is set, that means that we need to re-run prepare booking
        //this happens when we are being re-directed here after a signin event.
        if ($routeParams.pb) {
            tripService.setBookingId($routeParams.tripId, guidService.uuid()).then(function (t) {
                bookingService.prepareBooking(t.BasketId, t.BookingId, $routeParams.tripId);
                authService.bufferRoute(null); //clear any buffered route that might be left behind
                $location.replace();
                $location.search('pb', null);
            });
            return;
        }
        tripService.getCurrency($routeParams.tripId).then(function (cur) {
            cm.currencyCode = cur;
            cm.currencySymbol = currencyService.getSymbol(cur);
        });
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var _this = this;
            var basketId = trip.BasketId;
            var isHoliday = trip.TripType === tripService.tripTypes.Holiday;
            var isTransfer = trip.TripType === tripService.tripTypes.Transfer;
            var isParking = trip.TripType === tripService.tripTypes.Parking;
            bookingId = trip.BookingId;
            if (!bookingId) {
                bookingId = trip.BookingProcessId;
            }
            cm.trip = trip;
            cm.tripId = trip.TripId;
            cm.basketId = basketId;
            cm.sharedUseFlag = false;
            cm.isHoliday = isHoliday;
            cm.isTransfer = isTransfer;
            cm.isParking = isParking;
            cm.showAgentBookingMessage = isTransfer || isParking;
            cm.showBreadcrumbs = !trip.QuoteId;
            if (!trip.FlightsRequest && trip.HotelsRequest) {
                var totalRooms = trip.HotelsRequest.Rooms && trip.HotelsRequest.Rooms.length || 0;
                var singleRoomOnly = TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly && totalRooms === 1;
                var isMobile = TRPCONFIG.IsMobileView;
                var goV3 = isMobile && (TRPCONFIG.Domain.ParasolHotelBooking && singleRoomOnly)
                    || (TRPCONFIG.Domain.ParasolHotelBooking && !TRPCONFIG.Domain.ParasolHotelBookingSingleRoomOnly);
                if (goV3) {
                    $window.location.href = "booking/summary/" + cm.tripId + "?gov=3";
                }
            }
            //only set the booking form version if we are on a page type that
            //will be supporting it.
            if (isHoliday || cm.trip.TripType === tripService.tripTypes.Flight) {
                bookingFormVersion = parseInt(cookieService.get('BookingFormVersion') || 0);
                $scope.isHolidayOrFlightType = true;
            }
            if (cm.trip.TripType === tripService.tripTypes.Hotel) {
                $scope.isHotelJourney = true;
            }
            $q.all([bookingService.getBooking(bookingId, cm.tripId),
                basketStore.all(basketId, $routeParams.productId),
                basketStore.rules(basketId, $routeParams.productId),
                basketStore.costBreakdown(basketId, $routeParams.productId),
                basketStore.totalDeposit(basketId, $routeParams.productId),
                basketStore.totalCost(basketId),
                basketStore.payments(basketId),
                basketStore.balancesDue(basketId, $routeParams.productId),
                basketStore.hotelCost(basketId),
                basketStore.getCancellationProtectionQuote(basketId),
                basketStore.getTaxAdjustmentValue(basketId),
                basketStore.carHireRequestedItemsCosts(basketId),
                basketStore.payDepositAggregates(basketId)
            ]).then(function (_a) {
                var booking = _a[0], products = _a[1], rules = _a[2], costBreakdown = _a[3], totalDeposit = _a[4], totalCost = _a[5], payments = _a[6], balancesDue = _a[7], hotelCost = _a[8], cancellationProtection = _a[9], taxAdjustments = _a[10], carHireRequestedItemCosts = _a[11], payDepositAggregates = _a[12];
                if ($routeParams.ppResp) {
                    $scope.$broadcast('flash:error', resourceService.get(ppResp[$routeParams.ppResp]));
                }
                if (booking) {
                    cm.booking = booking;
                    cm.bookingId = cm.booking.BookingProcessId;
                    cm.hotel = products.h;
                    cm.flight = products.f;
                    cm.insurance = products.i;
                    cm.marhaba = products.m;
                    cm.transfer = products.t;
                    cm.parking = products.p;
                    cm.attractions = products.a;
                    cm.carhire = products.c;
                    cm.basketRules = rules;
                    cm.isPackage = Boolean(_.get(cm.flight, 'PackageId') || _.get(cm.hotel, 'PackageId'));
                    var attractionAncillary = cm.attractions && cm.attractions.length > 0;
                    var carhireAncillary = cm.basketRules.captureVehicle;
                    cm.attractionAncillary = Boolean(attractionAncillary);
                    cm.carhireAncillary = carhireAncillary;
                    var airportParkingAncillary = cm.basketRules.captureMainDriver;
                    cm.airportParkingAncillary = airportParkingAncillary;
                    var costType_1 = {
                        Unknown: 0,
                        Accommodation: 1,
                        Discount: 20,
                        AccommodationCancellationProtection: 21,
                        AccommodationLocalFeesAndTaxes: 22,
                        AccommodationExtraTransfer: 23,
                        AccommodationExtraEvent: 24,
                        AccommodationExtraAttraction: 25,
                        AccommodationExtra: 26,
                    };
                    var isMandatoryTransfer = costBreakdown.filter(function (cost) {
                        var match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') === (costType_1.AccommodationExtraTransfer);
                        return match;
                    }).filter(function (extra) { return extra; });
                    cm.isMandatoryTransfer = isMandatoryTransfer && isMandatoryTransfer.length > 0;
                    cm.isOptionalTransfer = !cm.isMandatoryTransfer && cm.transfer;
                    var ancillaries = cm.carhireAncillary || cm.airportParkingAncillary || cm.attractionAncillary || cm.isOptionalTransfer;
                    cm.ancillaries = ancillaries && Boolean(ancillaries);
                    if ($scope.isHotelJourney && !cm.isPackage) {
                        var extraCostItems = costBreakdown.filter(function (cost) {
                            var match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') === (costType_1.AccommodationExtraTransfer ||
                                costType_1.AccommodationExtraEvent ||
                                costType_1.AccommodationExtraAttraction ||
                                costType_1.AccommodationExtra ||
                                costType_1.AccommodationLocalFeesAndTaxes ||
                                costType_1.AccommodationCancellationProtection ||
                                costType_1.Discount);
                            return match;
                        }).filter(function (extra) { return extra; });
                        var roomCostItems = costBreakdown.filter(function (cost) { return !_.get(cost, 'ParentId')
                            && _.get(cost, 'TypeId') === costType_1.Accommodation; }).map(function (room, LinkId) {
                            return __assign({}, room, { LinkId: LinkId });
                        });
                        if (extraCostItems && extraCostItems.length > 0 && roomCostItems && roomCostItems.length > 0) {
                            var updatedRoomCostItems_3 = roomCostItems.map(function (room) {
                                return { RoomId: room.Id, RoomDescription: room.Description };
                            });
                            var enhancedExtras = extraCostItems.map(function (extras) {
                                return __assign({}, extras, updatedRoomCostItems_3.find(function (acc) { return acc.RoomId === extras.ParentId; }));
                            });
                            var updatedExtrasCostItems = enhancedExtras.map(function (extra, LinkId) {
                                var splitDescription = _.get(extra, 'RoomDescription').split('(');
                                var Description = splitDescription[1] ? extra.Description + " (" + splitDescription[1] : extra.Description;
                                return __assign({}, extra, { Description: Description,
                                    LinkId: LinkId });
                            });
                            var updatedCostBreakdown = roomCostItems.concat(updatedExtrasCostItems);
                            var costsSortedById = updatedCostBreakdown.sort(function (a, b) { return (a.LinkId >= b.LinkId) ? 1 : -1; });
                            costBreakdown = costsSortedById;
                        }
                    }
                    cm.costBreakdown = costBreakdown;
                    cm.minDeposit = cm.totalDeposit = totalDeposit;
                    cm.cancellationProtection = cancellationProtection;
                    cm.taxAdjustment = 0;
                    cm.payDepositAggregates = payDepositAggregates;
                    if (taxAdjustments) {
                        cm.taxAdjustment = taxAdjustments;
                    }
                    cm.carHireRequestedItemsCosts = carHireRequestedItemCosts;
                    if (cm.agentModeEnabled) {
                        cm.providersString = agentModeService.buildProvidersString(products);
                        if (cm.flight) {
                            cm.departureDate = cm.flight.Details.Itinerary.DepartureDate;
                        }
                        else if (cm.hotel) {
                            cm.departureDate = cm.hotel.Details.Itinerary.CheckInDate;
                        }
                        else if (cm.transfer) {
                            var itinerary = cm.transfer.Details.Itinerary;
                            cm.departureDate = itinerary.OutboundLeg && itinerary.OutboundLeg.FlightDate ||
                                itinerary.InboundLeg && itinerary.InboundLeg.FlightDate;
                        }
                        cm.Customer = { Id: cm.booking.UserData.PaymentDetails.CustomerId, Title: cm.booking.UserData.PaymentDetails.CustomerName };
                        if (cm.booking.UserData.PaymentDetails.CustomerId && cm.booking.UserData.PaymentDetails.CustomerName) {
                            customerCreditCheck(cm.Customer);
                        }
                        if (TRPCONFIG.Domain.EnableExtraCustomerInfo) {
                            // In case we are impersonated we have impersonated customer info in UserData object
                            // So we need to set agent email manually
                            cm.booking.UserData.Contact.AgentEmail = $rootScope.agent.Email;
                            // It means that customer is not impersonated and we need to keep customer email empty
                            if (cm.booking.UserData.Contact.AgentEmail === cm.booking.UserData.Contact.Email) {
                                // customer email should not be populated if it's agent's email
                                cm.booking.UserData.Contact.Email = '';
                            }
                        }
                        if (!TRPCONFIG.Domain.EnableExtraContactInfo) {
                            //Even if EnableExtraContactInfo is false , we need to capture the customer address for flights and holidays.
                            cm.dontCaptureAddress = cm.flight == null;
                        }
                        bookingService.resumeRecording(TRPCONFIG.ClientIpAddress);
                    }
                    tripService.usePackageRates().then(function (packagePrice) { return cm.packagePrice = packagePrice; });
                    cm.booking.UserData.Contact.EmailSignUp = TRPCONFIG.Domain.EmailSignupDefaultValue;
                    if (cm.basketRules.hotelOnly) {
                        tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId)
                            .then(function (ds) { return cm.durationSummary = ds; });
                        if (cm.hotel && cm.cancellationProtection.IsApplicable && cm.cancellationProtection.Quote) {
                            cm.checkbox.cancellationProtection = cm.hotel.Options.some(function (option) { return option.OptionId === cm.cancellationProtection.Quote.QuoteId; });
                            cm.pixels = cm.checkoutTrackingProviders.map(function (provider) {
                                return trackingPixelsService.getProviderCheckoutUrl(provider, {
                                    quoteId: cm.cancellationProtection.Quote.QuoteId.split('_')[1]
                                });
                            });
                        }
                    }
                    if (cm.basketRules.captureFlight) {
                        if (cm.basketRules.captureInboundFlight) {
                            cm.InboundDestinationAirport = { Code: cm.booking.UserData.ConnectingFlight.InboundDestinationAirport, Title: cm.booking.UserData.ConnectingFlight.InboundDestinationAirportName };
                        }
                        if (cm.basketRules.captureOutboundFlight) {
                            cm.OutboundDepartureAirport = { Code: cm.booking.UserData.ConnectingFlight.OutboundDepartureAirport, Title: cm.booking.UserData.ConnectingFlight.OutboundDepartureAirportName };
                        }
                    }
                    cm.booking.UserData.PaymentDetails.PaymentAmount = cm.booking.paymentAmountInput = cm.minDeposit + cm.booking.UserData.PaymentDetails.DepositAmount;
                    _setPaymentTotalPlusFees();
                    cm.booking.paymentAmountInput = (cm.minDeposit + cm.booking.UserData.PaymentDetails.DepositAmount).toFixed(2);
                    cm.checkbox.specialRequests = arrayUtil.any(cm.booking.UserData.Rooms, function (r) {
                        return r.SpecialRequest;
                    });
                    $scope.$watch('cm.checkbox.specialRequests', function (v) {
                        if (v === false) {
                            cm.booking.UserData.Rooms.forEach(function (r) {
                                r.SpecialRequest = null;
                            });
                            cm.booking.UserData.RequirementsList = [];
                            cm.booking.UserData.RequirementsList[0] = { DisplayRoomNumber: -1, RequirementsText: '', RoomId: -1 };
                        }
                    });
                    if (TRPCONFIG.Domain.CancellationProtectionEnabled) {
                        if (cm.cancellationProtection.Quote != null) {
                            analytics.track('Roomerflex', 'RoomerflexQuoteId', {
                                QuoteId: cm.cancellationProtection.Quote.QuoteId.replace('canxp_', '')
                            });
                        }
                    }
                    if (cm.basketRules.isAttractionsStandalone) {
                        watchDeliveryOptions();
                    }
                    if (cm.hotel) {
                        cm.booking.UserData.PaymentDetails.HotelDeposit = cm.hotel.PayUsNowAmount;
                        cm.checkInDate = dateUtil.parseDate(cm.hotel.Details.Itinerary.CheckInDate);
                        cm.checkOutDate = dateUtil.parseDate(cm.hotel.Details.Itinerary.CheckOutDate);
                    }
                    if (cm.insurance) {
                        _prepareBookingSubscriber(basketId, trip);
                        cm.documentPaths = insuranceService.getDocumentPaths();
                        if (trip.InsuranceRequest) {
                            cm.insurance.StartDate = trip.InsuranceRequest.StartDate;
                            cm.insurance.EndDate = trip.InsuranceRequest.EndDate;
                        }
                        var policyextras = _.get(cm.insurance, 'Details.InsuranceQuotes[0].Endorsements', []);
                        cm.insurance.PolicyExtras = policyextras && policyextras.length ? policyextras.join(', ') : '';
                    }
                    if (cm.cancellationProtection.IsApplicable && !cm.insurance) {
                        _prepareBookingSubscriber(basketId, trip);
                    }
                    if (cm.flight) {
                        cm.booking.UserData.PaymentDetails.FlightDeposit = cm.flight.PayUsNowAmount;
                    }
                    if (cm.marhaba) {
                        if (!cm.booking.UserData.ConnectingFlight.InboundFlightClass) {
                            cm.booking.UserData.ConnectingFlight.InboundFlightClass = 0;
                        }
                        if (!cm.booking.UserData.RequirementsList) {
                            cm.booking.UserData.RequirementsList = [];
                            cm.booking.UserData.RequirementsList[0] = { DisplayRoomNumber: -1, RequirementsText: '', RoomId: -1 };
                        }
                        if (!cm.booking.UserData.ChauffeurDetails && cm.basketRules.hasChauffeur) {
                            cm.booking.UserData.ChauffeurDetails = {};
                            //always use the date from the trip, never from anywhere else.
                            var marhabaDate = trip.MarhabaRequest.DateAndTime;
                            if (cm.booking.BookingRules.AllowChauffeurTimeEdit) {
                                //handle decimal values for ChauffeurMinAdvanceHours
                                var hours = Math.floor(cm.booking.BookingRules.ChauffeurMinAdvanceHours);
                                var minutes = Math.ceil((cm.booking.BookingRules.ChauffeurMinAdvanceHours - hours) * 60);
                                //subtract the hours and minutes
                                cm.MarhabaMaxDate = dateUtil.addHours(marhabaDate, hours * (-1));
                                if (minutes > 0) {
                                    cm.MarhabaMaxDate = dateUtil.addMinutes(cm.MarhabaMaxDate, minutes * (-1));
                                }
                                cm.MarhabaMinDate = dateUtil.addHours(cm.MarhabaMaxDate, cm.booking.BookingRules.ChauffeurTimeWindow * (-1));
                                cm.booking.UserData.ChauffeurDetails.PickupTime = cm.MarhabaMaxDate;
                            }
                            else {
                                cm.booking.UserData.ChauffeurDetails.PickupTime = marhabaDate;
                            }
                        }
                        if (!cm.marhaba.Details.Date && trip.MarhabaRequest) {
                            cm.marhaba.Details.Date = trip.MarhabaRequest.DateAndTime;
                            cm.marhaba.Details.Terminal = trip.MarhabaRequest.Terminal;
                        }
                        cm.connectingFlightEnabled = cm.marhaba.Details.MarhabaQuote.Type === 2;
                        searchUnitService.restoreMarhabaSearch(trip);
                        cm.marhaba.Occupancy = _.get(trip, 'MarhabaRequest.Occupancy', {});
                    }
                    cm.showTransferDetails = function () {
                        broker.publish('showModalTransferDetails');
                    };
                    cm.showAttractionPreferredDates = cm.booking.UserData.AttractionDetails.some(function (a) {
                        return a.CaptureDate;
                    });
                    if (trip.FromHolidayDeal) {
                        var ca_1 = _.get(trip.HotelsRequest, 'Rooms[0].ChildAges', []);
                        var guests = _.get(cm.booking, 'UserData.Rooms[0].Guests', []);
                        if (guests) {
                            cm.booking.UserData.Rooms[0].Guests = guests.map(function (g) {
                                if (g.Type === 2) {
                                    g.Age = ca_1.pop();
                                }
                                return g;
                            });
                        }
                    }
                    bd4travel.trackBookingForm(false, cm.hotel, cm.flight, trip, cm.fees);
                    cm.totalCost = totalCost;
                    cm.paymentData = payments;
                    cm.balancesDue = balancesDue;
                    cm.packageBalanceDue = (cm.balancesDue && cm.balancesDue.length) ? cm.balancesDue[cm.balancesDue.length - 1].Due : null;
                    cm.totalCostExcludingDirectPayment = totalCostExcludingDirectPayment(parseFloat(cm.totalCost), cm.paymentData);
                    cm.costBreakdown.forEach(function (breakdown) {
                        cm.discount += breakdown.TypeId === 20 ? (breakdown.UnitAmount * breakdown.Quantity) : 0;
                    });
                    // Sum invisible price with hotel
                    cm.costBreakdown = cm.costBreakdown.map(function (breakdown) {
                        breakdown.TotalPrice = 0;
                        if (breakdown.TypeId === 1) {
                            breakdown.TotalPrice = (breakdown.UnitAmount * breakdown.Quantity);
                            cm.costBreakdown.forEach(function (invisible) {
                                // Where id 0 is id of the invisible price
                                if (invisible.TypeId === 0 && invisible.IsPriceHidden) {
                                    breakdown.TotalPrice += invisible.UnitAmount;
                                }
                            });
                        }
                        return breakdown;
                    });
                    var trackingData = {
                        TotalCost: cm.totalCost,
                        Hotel: cm.hotel,
                        Flight: cm.flight,
                        CarHire: cm.carhire,
                        Transfer: cm.transfer,
                        Attractions: cm.attractions,
                        Insurance: cm.insurance,
                        Parking: cm.parking,
                        PageVersion: bookingFormVersion,
                        Source: $routeParams.source
                    };
                    analytics.track('Event', 'BookingForm', trackingData);
                    analytics.track('mixpanel', 'BookingForm', trackingData);
                    analytics.track('Facebook', 'BookingForm', trackingData);
                    analytics.trackEvent({ category: 'searches', action: 'bookingPage' });
                    cards = arrayUtil.toDict(cm.booking.PaymentOptions, function (po) { return po.CardTypeId; });
                    if (cards && cm.booking.paymentOptions) {
                        cm.booking.paymentOptions = cm.booking.paymentOptions.filter(function (o) {
                            if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                                return o.CardTypeId === 370;
                            }
                            else if (TRPCONFIG.Domain.WPIframeUpdate) {
                                return o.CardTypeId === 369;
                            }
                            return o.CardTypeId !== 370 && o.CardTypeId !== 369;
                        });
                    }
                    cm.paymentOptions = angular.copy(cm.booking.PaymentOptions);
                    cm.convertedPaymentOptions = paymentsUtilService.convertBookingPaymentOptions(angular.copy(cm.booking.PaymentOptions));
                    var electronCardExclusion_1 = true;
                    angular.forEach(cm.paymentOptions, function (v, k) {
                        if (v.IsPayPalPayment) {
                            cm.paymentOptions.splice(k, 1);
                            cm.payPalOption = v;
                        }
                        if (v.Type && v.Type.toLowerCase().indexOf('electron') > -1) {
                            electronCardExclusion_1 = false;
                        }
                    });
                    cm.electronCardExclusion = electronCardExclusion_1;
                    cm.logosList = paymentsService.getLogosList(cm.booking.PaymentOptions);
                    cm.paymentTab = cm.booking.UserData.PaymentDetails.CardDetails.CardType === cm.payPalOption ? paymentTabOptions.PayPal : paymentTabOptions.Card;
                    var c = cm.booking.UserData.Contact;
                    c.manualAddress = c.manualAddress || (c.Address != null && c.Address !== '') || !cm.booking.BookingRules.EnablePostCodeLookup;
                    $timeout(function () {
                        $anchorScroll();
                    });
                    $scope.$watch('cm.booking.UserData.PaymentDetails.CardDetails.CardType', function (val) {
                        _updateCardFees(val);
                    });
                    if (bookingFormVersion === 2) {
                        $scope.$watch('cm.paymentModel.cardDetail.paymentOptionId', function (val) {
                            _updateCardFees(val);
                        });
                    }
                    if (TRPCONFIG.Domain.SavedCardsEnabled && authService.getUser().HardSignedIn) {
                        //When SavedCard is Enabled
                        cm.savedCards = cm.booking.SavedPaymentCards;
                        cm.booking.UserData.PaymentDetails.SaveThisCard = true; // Save a new card check box will be checked by default
                        cm.selectSavedCardTab = function () {
                            cm.paymentTab = paymentTabOptions.SavedCards;
                            cm.isSavedCard = true;
                            cm.selectedCard = cm.savedCards[0];
                            cm.booking.UserData.PaymentDetails.SaveThisCard = false;
                        };
                        if (cm.savedCards.length > 0) {
                            cm.selectSavedCardTab();
                        }
                        $scope.$watch('cm.selectedCard', function (c) {
                            if (c) {
                                cm.booking.UserData.PaymentDetails.CardDetails.CardType = c.CardTypeId;
                                cm.booking.UserData.PaymentDetails.CardDetails.CardId = c.CardId;
                            }
                        });
                        cm.confirmRemoveCard = function (card, ev) {
                            ev.stopPropagation();
                            card.showConfirmRemoveCard = true;
                        };
                        cm.removeCard = function (card, ev) {
                            ev.stopPropagation();
                            paymentsService.removeCard(card.CardId).then(function () {
                                cm.closeRemoveCard(card, ev);
                                card.isRemoved = true;
                                cm.savedCards = _.reject(cm.savedCards, function (c) { return c.isRemoved; });
                            });
                        };
                        cm.closeRemoveCard = function (card, ev) {
                            ev.stopPropagation();
                            card.showConfirmRemoveCard = false;
                        };
                        $scope.$on('auth:signout', function () {
                            clearSavedCards();
                        });
                        cm.convertedSavedCards = paymentsUtilService.convertBookingSavedCards(cm.booking.SavedPaymentCards, cm.booking.PaymentOptions);
                    }
                    cm.selectPayPalTab = function () {
                        if (TRPCONFIG.Domain.PaypalInContextEnabled && !paypalInContextSet && $window.paypal) {
                            $window.paypal.checkout.setup(TRPCONFIG.Domain.PaypalMerchantId, {
                                environment: TRPCONFIG.PaypalInContextEnvironment,
                                container: 'paypal-button-container',
                                click: cm.book
                            });
                            paypalInContextSet = true;
                        }
                        cm.booking.UserData.PaymentDetails.CardDetails.CardType = cm.payPalOption.CardTypeId;
                        cm.paymentTab = paymentTabOptions.PayPal;
                        cm.isSavedCard = false;
                        cm.selectedCard = null;
                        cm.booking.UserData.PaymentDetails.SaveThisCard = false;
                        cm.booking.UserData.PaymentDetails.CardDetails.CardId = null;
                    };
                    cm.selectCardTab = function () {
                        cm.booking.UserData.PaymentDetails.CardDetails.CardType = cm.booking.cardOption;
                        cm.paymentTab = paymentTabOptions.Card;
                        cm.isSavedCard = false;
                        cm.selectedCard = null;
                        if (TRPCONFIG.Domain.SavedCardsEnabled && authService.getUser().HardSignedIn) {
                            cm.booking.UserData.PaymentDetails.SaveThisCard = true;
                        }
                        else {
                            cm.booking.UserData.PaymentDetails.SaveThisCard = false;
                        }
                        cm.booking.UserData.PaymentDetails.CardDetails.CardId = null;
                    };
                    cm.updateCardType = function () {
                        cm.booking.UserData.PaymentDetails.CardDetails.CardNumber = undefined;
                        cm.booking.UserData.PaymentDetails.CardDetails.CardType = cm.booking.cardOption;
                        cm.isNotCash = cm.booking.cardOption !== 130;
                        cm.refreshEnbdObj();
                        if (cm.booking.cardOption === cm.enbdOptionId &&
                            cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber &&
                            cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber.length > cm.enbdDetails.cardNumberMinLength) {
                            cpgValidation();
                        }
                        if (cm.booking.cardOption === cm.enbdOptionId) {
                            cm.isBookingDisabled = true;
                        }
                    };
                    if (TRPCONFIG.Domain.PaymentPlanEnabled) {
                        cm.localChargesAmount = directPaymentAtHotelAmount(cm.paymentData);
                        if (TRPCONFIG.Domain2.MonthlyPaymentsEnabled && cm.booking.PaymentRules.RecurringPayments) {
                            cm.monthlyPayments = angular.copy(cm.booking.PaymentRules.RecurringPayments);
                            cm.monthlyPaymentsAllowed = Boolean(cm.monthlyPayments.Allowed);
                            if (cm.monthlyPaymentsAllowed) {
                                cm.monthlyPaymentsSchedule = getMonthlyPaymentsSchedule(cm.monthlyPayments);
                                cm.monthlyPaymentsAdminFee = cm.monthlyPayments.PaymentSchedules[0].Installments[0].AdminFee;
                                $scope.$watch('cm.payingMonthly', function (value) {
                                    if (value === true) {
                                        cm.payingFullAmount = null;
                                    }
                                });
                            }
                        }
                    }
                    if (cm.basketRules.depositAllowed || cm.monthlyPaymentsAllowed) {
                        cm.booking.UserData.PaymentDetails.PayFullAmount = cm.payingFullAmount = parseFloat(cm.booking.UserData.PaymentDetails.PaymentAmount) === parseFloat(totalCost);
                        paymentsCalculator.init(cm.paymentData, cm.booking.UserData.PaymentDetails.PaymentAmount, cm.payingFullAmount);
                        $scope.$watch('cm.payingFullAmount', function (val, oldVal) {
                            if (val != null && val !== oldVal) {
                                cm.payingMonthly = false;
                                cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(val ? cm.totalCostExcludingDirectPayment : cm.minDeposit);
                                cm.booking.UserData.PaymentDetails.PayFullAmount = val;
                                cm.booking.UserData.PaymentDetails.PayByInstallments = false;
                                cm.booking.UserData.PaymentDetails.InstallmentScheduleType = 0;
                                if (!val) {
                                    cm.booking.paymentAmountInput = cm.minDeposit.toFixed(2);
                                }
                            }
                            if (val == null && cm.payingMonthly === true) {
                                cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.monthlyPaymentsSchedule[0].Amount);
                                cm.booking.UserData.PaymentDetails.PayFullAmount = false;
                                cm.booking.UserData.PaymentDetails.PayByInstallments = true;
                                cm.booking.UserData.PaymentDetails.InstallmentScheduleType = cm.monthlyPayments.PaymentSchedules[0].ScheduleType;
                            }
                            bookingService.updateBooking(bookingService.trimBooking(cm.booking));
                        });
                        $scope.$watch(function () {
                            return cm.booking.UserData.PaymentDetails.PaymentAmount;
                        }, function (val) {
                            if (cm.monthlyPaymentsAllowed && cm.payingMonthly) {
                                cm.booking.UserData.PaymentDetails.DepositAmount = parseFloat(cm.monthlyPaymentsSchedule[0].Amount);
                            }
                            else {
                                cm.paymentData = paymentsCalculator.change(cm.payingFullAmount);
                                cm.booking.UserData.PaymentDetails.DepositAmount = val - cm.minDeposit;
                            }
                            if (cm.fees != null) {
                                if (cm.feeAmount != null && cm.feeAmount > 0) {
                                    cm.fees.CardHandlingFee = cm.feeAmount;
                                }
                                else {
                                    cm.fees.CardHandlingFee = (val * (cm.feePercent / 100));
                                }
                            }
                            broker.publish('paymentDataUpdated', Object.assign(cm.paymentData, { payingFullAmount: cm.payingFullAmount }));
                        });
                    }
                    if (cm.monthlyPaymentsAllowed) {
                        cm.payingMonthly = true;
                        cm.payingFullAmount = null;
                        cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.totalCostExcludingDirectPayment);
                        cm.booking.UserData.PaymentDetails.PayFullAmount = null;
                    }
                    else if (!cm.basketRules.depositAllowed) {
                        cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.totalCostExcludingDirectPayment);
                        cm.booking.UserData.PaymentDetails.PayFullAmount = true;
                        cm.payingFullAmount = true;
                    }
                    cm.updateDeposit = function (deposit) {
                        bookingService.updateDeposit(deposit, cm.booking.UserData.PaymentDetails, cm.totalCostExcludingDirectPayment, cm.minDeposit);
                    };
                    cm.selectCancellationProtection = function () {
                        var cancellationProtectionQuantity = 1;
                        switch (cm.checkbox.cancellationProtection) {
                            case true:
                                basketStore.addCancellationProtection(cm.hotel.ProductId, cm.cancellationProtection.Quote, cm.basketId, cancellationProtectionQuantity)
                                    .then(function () {
                                    broker.publish('bookingBasketUpdated');
                                });
                                break;
                            case false:
                                basketStore.removeCancellationProtection(cm.hotel.ProductId, cm.cancellationProtection.Quote, cm.basketId)
                                    .then(function () {
                                    broker.publish('bookingBasketUpdated');
                                });
                                break;
                        }
                    };
                    cm.checkCreditCardNumber = function (cardNumber) {
                        cm.cardChangedTo = undefined;
                        if (!cardNumber) {
                            return;
                        }
                        if (TRPCONFIG.Domain.EnableBinRangeDiscount === true) {
                            bookingService.getDiscountForCard(bookingId, cardNumber, TRPCONFIG.Domain.DomainId, TRPCONFIG.Domain.CultureCode)
                                .then(function (res) {
                                cm.booking.Discounts = res;
                                broker.publish('discountUpdated', res);
                            });
                        }
                        paymentsService
                            .checkCardNumber(cm.booking.PaymentOptions, cardNumber, cm.booking.cardOption)
                            .then(undefined, function setCorrectCard(correctId) {
                            if (cm.booking.cardOption !== cm.enbdOptionId) {
                                cm.booking.cardOption = correctId;
                                cm.updateCardType();
                                cm.cardChangedTo =
                                    paymentsService.getCardTitle(cm.booking.PaymentOptions, correctId);
                            }
                            else if (cm.booking.cardOption === cm.enbdOptionId &&
                                cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber &&
                                cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber.length > cm.enbdDetails.cardNumberMinLength) {
                                cpgValidation();
                            }
                            cm.booking.UserData.PaymentDetails.CardDetails.CardNumber =
                                cardNumber;
                        });
                    };
                    // Used to automatically trust the html in agents' scripts
                    cm.trustHtml = function (htmlCode) {
                        return $sce.trustAsHtml(htmlCode);
                    };
                    broker.publish('unblock');
                    $scope.$emit('unblock');
                    var data = {
                        items: {
                            hotel: cm.hotel,
                            flight: cm.flight
                        },
                        price: hotelCost
                    };
                    criteoService.enqueue(data, 'basket', trip.TripType);
                    cm.bookingLoaded = true;
                    cm.showSectionStep2 = !!cm.hotel
                        || cm.basketRules.captureInsurance
                        || (cm.attractions && cm.attractions.length > 0)
                        || cm.basketRules.captureVehicle
                        || cm.basketRules.captureMainDriver;
                }
            });
            function threeDSValidationComplete(data) {
                if (cm.threeDsValidationComplete === false) {
                    cm.threeDsValidationComplete = true;
                    cm.booking.UserData.PaymentDetails.PaRes = data.paRes;
                    cm.booking.UserData.PaymentDetails.PrePaymentID = data.prePaymentId;
                    cm.booking.UserData.PaymentDetails.MD = data.md;
                    cm.book();
                    cm.threedsRedirecting = false;
                }
            }
            function cpgValidationComplete(threedsData) {
                if (threedsData && threedsData.PrePaymentID) {
                    var prePaymentId = threedsData.PrePaymentID;
                    bookingService.getCpgStatus(prePaymentId).then(function (data) {
                        var paRes = data && data.paRes;
                        if (data && data.error) {
                            onCpgStatusAPIError(data);
                        }
                        if (paRes) {
                            threeDSValidationComplete(data);
                        }
                    });
                }
            }
            $scope.$on('3DSValidationComplete', function (ev, data) {
                threeDSValidationComplete(data);
                $scope.$apply(function () {
                    cm.threedsRedirecting = false;
                });
            });
            $scope.$on('3DSValidationCancel', function () {
                $scope.$apply(function () {
                    cm.threedsRedirecting = false;
                });
                broker.publish('unblock');
                $scope.$emit('unblock');
            });
            /*$scope.$on('3DSValidationCancelled', function() {
                $scope.$apply(function(){
                    $scope.threedsRedirecting = false;
                    $scope.busy = false;
                });
            });*/
            cm.book = book;
            cm.cpgValidationComplete = cpgValidationComplete;
            cm.setPaymentAndBook = setPaymentAndBook;
            cm.bypassThreeDS = function () {
                cm.booking.UserData.PaymentDetails.PaRes = '';
                cm.booking.UserData.PaymentDetails.PrePaymentID = cm.ThreeDSecure.PrePaymentID;
                cm.booking.UserData.PaymentDetails.MD = '';
                cm.booking.UserData.PaymentDetails.TL = '';
                cm.book();
                cm.threedsRedirecting = false;
            };
            cm.adminFeesApply = function () {
                return !cm.payingFullAmount && cm.payDepositAggregates && cm.payDepositAggregates.UnitAdminFee.Amount > 0;
            };
            cm.preBookCommands = [];
            cm.addPreBookCommand = function (command) {
                if (!cm.preBookCommands.includes(command)) {
                    cm.preBookCommands.push(command);
                }
            };
            cm.generateTokens = function () {
                //figure out if we need to generate tokens and if there should be an expiry
                //if pci compliant
                var requireTokens = TRPCONFIG.Domain.PCICompliant;
                var month = cm.booking.UserData.PaymentDetails.CardDetails.ExpiryDate.Month;
                var year = cm.booking.UserData.PaymentDetails.CardDetails.ExpiryDate.Year;
                var save = cm.booking.UserData.PaymentDetails.SaveThisCard;
                var expiryDate = save && month != null && year != null ? new Date(year, month) : null;
                if (save && !expiryDate) {
                    return $q.when(); //no point tokenising because the form is not valid
                }
                if (requireTokens) {
                    return tokeniser.execute(expiryDate ? expiryDate.toISOString() : null);
                }
                return $q.when();
            };
            cm.addPreBookCommand(cm.generateTokens);
            cm.executePrebookCommands = function () { return __awaiter(_this, void 0, void 0, function () {
                var onloadCommands, onloadCommands, _a, id;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(cm.paymentModel.isPayPalPayment || cm.agentModeEnabled)) return [3 /*break*/, 2];
                            onloadCommands = cm.preBookCommands.slice(0, 1).slice();
                            return [4 /*yield*/, Promise.all(onloadCommands.map(function (preBookCommand) { return preBookCommand(); }))];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            onloadCommands = cm.preBookCommands.slice(0, 2).slice();
                            return [4 /*yield*/, Promise.all(onloadCommands.map(function (preBookCommand) { return preBookCommand(); }))];
                        case 3:
                            _a = _b.sent(), id = _a[1];
                            if (id) {
                                cm.booking.UserData.PaymentDetails.DfReferenceId = id;
                            }
                            _b.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            cm.getTotalOutstandingBalance = function (paymentData) {
                if (!paymentData) {
                    return 0;
                }
                return paymentData.totalCosts - cm.booking.UserData.PaymentDetails.PaymentAmount - cm.getBookingDiscountValue();
            };
            cm.getBookingDiscountValue = function () {
                var bookingDiscounts = cm.booking.Discounts;
                return bookingDiscounts && bookingDiscounts[0] && bookingDiscounts[0].DiscountValue ? bookingDiscounts[0].DiscountValue : 0;
            };
            cm.getClosestPaymentDate = function (paymentData) {
                if (paymentData && paymentData.balanceSchedules && paymentData.balanceSchedules.length) {
                    return paymentData.balanceSchedules[0].due;
                }
                return '';
            };
            function reloadPage() {
                window.location.reload();
            }
            cm.addVoucher = function () {
                cm.voucherCode = cm.voucherCodeInput;
                cookieService.set('VoucherCode', cm.voucherCode);
                var currentTrip = JSON.parse(window.localStorage.getItem('trip'));
                if (currentTrip && currentTrip.HotelInfo.ProductId) {
                    basketStore.addVoucher(cm.basketId, cm.voucherCode).then(function (data) {
                        bookingService.prepareBooking(data.BasketId, bookingId, cm.tripId).then(reloadPage).catch(reloadPage);
                    });
                }
            };
            cm.removeVoucher = function () {
                cm.voucherCodeInput = '';
                cm.voucherCode = '';
                cookieService.set('VoucherCode', '');
                basketStore.addVoucher(cm.basketId, cm.voucherCode).then(function (data) {
                    cm.voucherDiscountMsg.Message = 'The code has been removed and your booking total updated';
                    cm.voucherDiscountMsg.Code = 7;
                    cookieService.set('VoucherWarnMessage', JSON.stringify(cm.voucherDiscountMsg));
                    bookingService.prepareBooking(data.BasketId, bookingId, cm.tripId).then(reloadPage).catch(reloadPage);
                });
            };
            function book() {
                try {
                    analytics.track('Event', 'Book', {
                        Revenue: cm.totalCost,
                        HotelTitle: cm.hotel && cm.hotel.Title
                    });
                }
                catch (err) { }
                if (cm.booking.UserData.ChauffeurDetails && cm.booking.UserData.ChauffeurDetails.ContactNo) {
                    cm.booking.UserData.ChauffeurDetails.ContactNo = cm.booking.UserData.ChauffeurDetails.ContactNo.replace(/ /g, '');
                }
                else {
                    cm.booking.UserData.ChauffeurDetails = {};
                }
                TRPCONFIG.Domain.PaypalInContextEnabled && cm.isPayPal
                    ? $window.paypal.checkout.initXO()
                    : _block(true);
                var booking = bookingService.trimBooking(cm.booking);
                bookingService.book(booking, cm.tripId, cm.basketId).then(function (result) {
                    if (result.Status === bookingStatus.PayPalVerification) {
                        bookingService.paypalPostBooking(result.PayPal);
                    }
                    else if (result.Status === bookingStatus.ThreeDs || result.Status === bookingStatus.Cpg ||
                        result.Status === bookingStatus.HostedPayment || result.Status === bookingStatus.WPHostedPayment) {
                        if (cpgStatusApiEnabled && result.Status !== bookingStatus.HostedPayment && result.Status !== bookingStatus.WPHostedPayment) {
                            cm.cpgValidationComplete(result.ThreeDSecure);
                        }
                        if (result.Status === bookingStatus.WPHostedPayment) {
                            cm.ThreeDSecure = result.ThreeDSecure;
                            $scope.$broadcast('wpHostedPaymentInit', result.ThreeDSecure);
                            cm.WPHostedRedirect = true;
                        }
                        else {
                            $scope.$broadcast('request3DSValidation', result.ThreeDSecure);
                            cm.threedsRedirecting = true;
                            cm.ThreeDSecure = result.ThreeDSecure;
                        }
                        broker.publish('unblock');
                        $scope.$emit('unblock');
                    }
                    else if (result.Status === bookingStatus.Refresh) {
                        if (result.RefreshResponse && result.RefreshResponse.StaleProducts && result.RefreshResponse.StaleProducts.length > 0) {
                            //check for a navl product
                            var navlProduct = _.find(result.RefreshResponse.StaleProducts, function (p) { return p.NewProductId === null; });
                            if (navlProduct) {
                                analytics.track('mixpanel', 'PUPNAVL Pop-up', { Type: 'NAVL' });
                                modalService.launch('partials/popups/navl', { popupType: 'NAVL' }, true, true);
                            }
                            //check for a pup product
                            var pupProducts_1 = _.filter(result.RefreshResponse.StaleProducts, function (p) { return p.NewProductId !== null; });
                            if (pupProducts_1.length > 0) {
                                _getCostBreakdown(result.RefreshResponse.Basket.BasketId).then(function (cb) {
                                    var dataForPup = cb;
                                    _.forEach(pupProducts_1, function (pupProduct) {
                                        if (pupProduct.Product.ProductType === 0) {
                                            dataForPup.oldHotelCost = pupProduct.Product.TotalAmount;
                                            dataForPup.oldHolidayCost = dataForPup.oldHotelCost + dataForPup.flightCost;
                                            dataForPup.pupAmount = dataForPup.pupAmount ? dataForPup.pupAmount + dataForPup.hotelCost - dataForPup.oldHotelCost : dataForPup.hotelCost - dataForPup.oldHotelCost;
                                        }
                                        else if (pupProduct.Product.ProductType === 1) {
                                            //isolate ATOL from old cost breakdown
                                            var atol = _.find(cm.costBreakdown, function (item) {
                                                return item.Description.indexOf('ATOL') >= 0;
                                            });
                                            if (atol) {
                                                dataForPup.oldFlightCost = pupProduct.Product.TotalAmount - atol.UnitAmount * atol.Quantity; // subtract the atol cost from the flights total
                                            }
                                            else {
                                                dataForPup.oldFlightCost = pupProduct.Product.TotalAmount;
                                            }
                                            dataForPup.oldHolidayCost = dataForPup.oldFlightCost + dataForPup.hotelCost;
                                            dataForPup.pupAmount = dataForPup.pupAmount ? dataForPup.pupAmount + dataForPup.flightCost - dataForPup.oldFlightCost : dataForPup.flightCost - dataForPup.oldFlightCost;
                                        }
                                    });
                                    broker.publish('updatePricesOnPUP');
                                    dataForPup.currencyCode = cm.currencyCode;
                                    dataForPup.packagePrice = cm.packagePrice;
                                    dataForPup.basketId = result.RefreshResponse.Basket.BasketId;
                                    analytics.track('mixpanel', 'PUPNAVL Pop-up', { Type: 'PUP', PUPAmount: dataForPup.pupAmount });
                                    modalService.launch('partials/popups/pup', { dataForPup: dataForPup, popupType: 'PUP' }, true, true);
                                });
                            }
                            broker.publish('unblock');
                            $scope.$emit('unblock');
                        }
                    }
                    else if (result.Messages && result.Messages.length > 0) {
                        setTimeout(function () { return analytics.track('mixpanel', 'FormValidation', { validationMessages: result.Messages }); });
                        $scope.$broadcast('flash:error', result.Messages);
                        cm.threeDsValidationComplete = false;
                        scrollService.scrollTo('#booking-form-wrapper', { animate: true, offset: 200 });
                        broker.publish('unblock');
                        $scope.$emit('unblock');
                        delete cm.booking.UserData.PaymentDetails.PaRes;
                        delete cm.booking.UserData.PaymentDetails.PrePaymentID;
                        cm.hideForm = true;
                    }
                    else {
                        analytics.track('eCommerce', 'purchase', result);
                        var bookingConfirmAdFormItem = {
                            totalCost: cm.paymentTotalWithCardFee || 0,
                            estabId: cm.hotel && cm.hotel.Details && cm.hotel.Details.Id ? cm.hotel.Details.Id.toString() : '',
                            bookingReference: result.BookingReferences[0],
                            currency: cm.currencyCode
                        };
                        sessionStorage.setItem('BookingConfirmAdFormItem', JSON.stringify(bookingConfirmAdFormItem));
                        bd4travel.trackBookingForm(true, cm.hotel, cm.flight, trip, cm.fees).then(function () {
                            basketService.redirectToComplete(result.BookingReferences, basketId, cm.totalCost, cm.tripId);
                            if (adFormService.isNewsletterSignUpEventEnabled()
                                && cm.booking.UserData && cm.booking.UserData.Contact && cm.booking.UserData.Contact.EmailSignUp) {
                                analytics.trackAdformClick({
                                    eventName: 'Newslettersignup',
                                    trackingId: adFormService.getTrackingId()
                                });
                            }
                        });
                    }
                });
            }
            function setPaymentAndBook(payFullAmount) {
                paymentsUtilService.copyCardDetailsToUserData(cm.paymentModel, cm.booking.UserData.PaymentDetails);
                var paymentAmount = parseFloat(payFullAmount ? cm.totalCostExcludingDirectPayment : cm.minDeposit);
                if (payFullAmount === null && cm.monthlyPaymentsAllowed) {
                    cm.booking.UserData.PaymentDetails.PaymentAmount = parseFloat(cm.monthlyPaymentsSchedule[0].Amount);
                    cm.booking.UserData.PaymentDetails.PayFullAmount = false;
                    cm.booking.UserData.PaymentDetails.PayByInstallments = true;
                    cm.booking.UserData.PaymentDetails.InstallmentScheduleType = cm.monthlyPayments.PaymentSchedules[0].ScheduleType;
                    cm.booking.UserData.PaymentDetails.DepositAmount = cm.booking.UserData.PaymentDetails.PaymentAmount;
                }
                else {
                    cm.booking.UserData.PaymentDetails.PaymentAmount = paymentAmount;
                    cm.booking.UserData.PaymentDetails.PayFullAmount = cm.payingFullAmount = payFullAmount;
                    cm.booking.UserData.PaymentDetails.PayByInstallments = false;
                    cm.booking.UserData.PaymentDetails.InstallmentScheduleType = 0;
                    //the following seems very silly, surely the API should be able to figure this out
                    //but it needs to be set otherwise we'd only take the deposit amount from the customer
                    cm.booking.UserData.PaymentDetails.DepositAmount = paymentAmount - cm.minDeposit;
                }
                trackAndBook(payFullAmount);
            }
            function getDfReferenceId() {
                return __awaiter(this, void 0, void 0, function () {
                    var newCommands, id;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                newCommands = [cm.preBookCommands[cm.preBookCommands.length - 1]];
                                return [4 /*yield*/, Promise.all(newCommands.map(function (preBookCommand) { return preBookCommand(); }))];
                            case 1:
                                id = (_a.sent())[0];
                                return [2 /*return*/, id];
                        }
                    });
                });
            }
            function threeDS2Book() {
                return __awaiter(this, void 0, void 0, function () {
                    var id, dfReferenceId, err_7;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                _block(true);
                                return [4 /*yield*/, getDfReferenceId()];
                            case 1:
                                id = _a.sent();
                                dfReferenceId = id || $rootScope.dfReferenceId;
                                cm.booking.UserData.PaymentDetails.DfReferenceId = dfReferenceId;
                                book();
                                return [3 /*break*/, 3];
                            case 2:
                                err_7 = _a.sent();
                                broker.publish('unblock');
                                $scope.$emit('unblock');
                                console.log('err', err_7);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
            function trackAndBook(FullAmountPaid) {
                var TypeTitle = Object.keys(tripService.tripTypes).find(function (item) { return tripService.tripTypes[item] === cm.trip.TripType; });
                analytics.track('mixpanel', 'BookingFormClick', {
                    TypeTitle: TypeTitle,
                    DepositAvailable: cm.basketRules.depositAllowed,
                    FullAmountPaid: FullAmountPaid
                });
                if (TRPCONFIG.Domain.WPIframeUpdate && !cm.paymentModel.isPayPalPayment) {
                    book();
                }
                else if (cm.agentModeEnabled || cm.paymentModel.isPayPalPayment) {
                    cm.booking.UserData.PaymentDetails.DfReferenceId = null;
                    book();
                }
                else if (cm.booking.UserData.PaymentDetails.DfReferenceId) {
                    book();
                }
                else if (cm.threeDS2Enabled) {
                    threeDS2Book();
                }
                else {
                    book();
                }
            }
            cm.trackAndBook = trackAndBook;
        }, basketService.bookingAlreadyDone("bookingCtrl : '" + $routeParams.tripId + "'"));
        function _block(completing) {
            $scope.$emit('block', {
                title: resourceService.get(completing ? 'COMPLETINGBOOKING' : 'PREPARINGBOOKING'),
                loadingScreenStyle: 'booking-bookingCtrl'
            });
        }
        function totalCostExcludingDirectPayment(totalCost, paymentData) {
            var directPaymentCost = 0;
            angular.forEach(paymentData.products, function (prod) {
                angular.forEach(prod.directPayments, function (dp) {
                    directPaymentCost += dp.amount;
                });
            });
            //It should be equal to, paymentData.totalBalances + paymentData.minimumDeposit
            return totalCost - directPaymentCost;
        }
        function getMonthlyPaymentsSchedule(data) {
            var monthlyPaymentsSchedule = _.find(data.PaymentSchedules, ['ScheduleType', 1]);
            return monthlyPaymentsSchedule.Installments.map(function (installment) {
                return {
                    Due: installment.DueDate,
                    Amount: installment.InstallmentCost
                };
            });
        }
        function watchDeliveryOptions() {
            var deliveryOptions = cm.booking.DeliveryOptions;
            if (deliveryOptions && deliveryOptions.length) {
                $scope.$watch('cm.booking.UserData.DeliverySupplierId', function (v) {
                    if (v != null) {
                        cm.delivery = deliveryOptions.reduce(function (delivery, option) {
                            if (v === option.SupplierId) {
                                option.Selected = true;
                                delivery.desc = option.Title;
                                delivery.total = option.Price;
                            }
                            else {
                                option.Selected = false;
                            }
                            return delivery;
                        }, { total: 0 });
                    }
                });
            }
        }
        function signIn() {
            var url = $location.path().substring(1) + "?pb=1";
            authService.bufferRoute(url);
            url = "signin?cb=" + encodeURIComponent(url);
            $location.url(url);
        }
        function signOut() {
            authService.signOut();
            bookingService.clearContact(cm.booking.UserData);
            bookingService.clearGuests(cm.booking.UserData.Rooms);
            bookingService.updateBooking(bookingService.trimBooking(cm.booking));
        }
        function copyFromContact(e) {
            bookingService.copyFromContact(cm.booking, e);
        }
        cm.formatPaymentAmountInput = function (depositAmount) {
            if (depositAmount.$valid) {
                cm.booking.paymentAmountInput = parseFloat(cm.booking.paymentAmountInput).toFixed(2);
            }
        };
        function directPaymentCaveat(product, payment) {
            var res = product.productType === 0 ? 'DIRECTACCOMPAYMENTADVICE' : 'DIRECTFLIGHTPAYMENTADVICE';
            if (payment.localCurrency === payment.currency) {
                return String.format(resourceService.get(res), $filter('customCurrency')(payment.amount, payment.currency));
            }
            return String.format(resourceService.get(res), $filter('customCurrency')(payment.localAmount, payment.localCurrency) + " " + String.format(resourceService.get('CUSTOMEREQUIVALENT'), $filter('customCurrency')(payment.amount, payment.currency)));
        }
        function directPaymentAtHotelAmount(paymentData) {
            var hotelPayment = _.find(paymentData.products, ['productType', 0]);
            if (!hotelPayment) {
                return;
            }
            cm.hasLocalCharges = hotelPayment.directPayments && hotelPayment.directPayments.length > 0;
            if (!cm.hasLocalCharges) {
                return;
            }
            var directPayments = hotelPayment.directPayments[0];
            return $filter('customCurrency')(directPayments.amount, directPayments.currency);
        }
        function clearSavedCards() {
            cm.savedCards = null;
            cm.convertedSavedCards = null;
            cm.selectCardTab();
        }
        function _updateCardFees(val) {
            if (val == null || val === 0 || cards[val] == null) {
                cm.isPayPal = false;
                cm.fees = null;
                broker.publish('feesUpdated', cm.fees);
                return;
            }
            cm.booking.UserData.PaymentDetails.CardDetails.PaymentTypeId = cards[val].PaymentTypeId;
            cm.fullCardDetails = cards[val].FullDetails;
            cm.feePercent = cards[val].FeePercent;
            cm.feeAmount = cards[val].FeeAmount || 0;
            cm.isPayPal = cards[val].IsPayPalPayment;
            basketStore.setPaymentMethod(cards[val].CardTypeId, cm.basketId).then(function (fees) {
                cm.fees = fees;
                if (cm.feeAmount != null && cm.feeAmount > 0) {
                    cm.fees.CardHandlingFee = cm.feeAmount;
                }
                else {
                    cm.fees.CardHandlingFee = (cm.booking.UserData.PaymentDetails.PaymentAmount * (cm.feePercent / 100));
                    cm.fees.CardHandlingForTotal = cm.totalCostExcludingDirectPayment * (cm.feePercent / 100);
                }
                broker.publish('feesUpdated', cm.fees);
            });
        }
        broker.subscribe('paymentPlusFee', 'feesUpdated', _setPaymentTotalPlusFees);
        broker.subscribe('paymentPlusFee', 'paymentDataUpdated', _setPaymentTotalPlusFees);
        function _setPaymentTotalPlusFees() {
            var cardFee = cm.fees && cm.fees.CardHandlingFee || 0;
            var cardFeeForTotal = cm.fees && cm.fees.CardHandlingForTotal || 0;
            cm.paymentAmountWithCardFee = parseFloat(cm.booking.UserData.PaymentDetails.PaymentAmount) + cardFee;
            cm.paymentTotalWithCardFee = cm.totalCostExcludingDirectPayment + cardFeeForTotal;
        }
        cm.customerCreditCheck = customerCreditCheck;
        function customerCreditCheck(item) {
            cm.customer = item;
            cm.customer.showCreditCheckResult = true;
            cm.customer.creditCheckResponseText = resourceService.get('CHECKINGCREDIT');
            cm.customer.creditCheckStatus = null;
            cm.customer.CreditCheckPassed = 'red';
            agentModeService.getCreditCheck(item.Id, cm.booking.UserData.PaymentDetails.PaymentAmount).then(function (data) {
                cm.customer.creditCheck = data;
                cm.customer.creditCheckResponseText = cm.customer.creditCheck.ResponseText;
                cm.booking.UserData.PaymentDetails.CustomerId = item.Id;
                cm.booking.UserData.PaymentDetails.CustomerName = item.Title;
                //showing credit check status, color of status, check passed or failed
                if (cm.customer.creditCheck.StatusId === 1) {
                    cm.customer.creditCheckStatus = 'green';
                }
                else {
                    cm.customer.creditCheckStatus = 'red';
                }
                if (cm.customer.creditCheck.StatusId === 5) {
                    cm.customer.showCreditCheckResult = false;
                }
                if (!(cm.customer.creditCheck.StatusId === 2 || cm.customer.creditCheck.StatusId === 3 || cm.customer.creditCheck.StatusId === 4)) {
                    cm.customer.CreditCheckPassed = 'green';
                }
            });
        }
        function _prepareBookingSubscriber(basketId, trip) {
            //only applies to insurance currently, but we may need to prepare the booking again
            broker.subscribe('bookingCtrl', 'bookingBasketUpdated', function (userData) {
                bookingService.prepareBooking(basketId, trip.BookingId, $routeParams.tripId, userData.data)
                    .then(function () {
                    return $q.all([
                        basketStore.payments(basketId),
                        basketStore.costBreakdown(basketId, $routeParams.productId),
                        basketStore.totalDeposit(basketId, $routeParams.productId),
                        basketStore.totalCost(basketId)
                    ]).then(function (_a) {
                        var payments = _a[0], costBreakdown = _a[1], totalDeposit = _a[2], totalCost = _a[3];
                        cm.paymentData = payments;
                        cm.costBreakdown = costBreakdown;
                        cm.totalDeposit = totalDeposit;
                        cm.totalCost = totalCost;
                        cm.minDeposit = cm.totalDeposit;
                        cm.booking.UserData.PaymentDetails.PaymentAmount = cm.booking.paymentAmountInput = (cm.minDeposit + cm.booking.UserData.PaymentDetails.DepositAmount).toFixed(2);
                        cm.booking.UserData.PaymentDetails.PayFullAmount = parseFloat(cm.booking.UserData.PaymentDetails.PaymentAmount) === parseFloat(totalCost);
                        cm.totalCostExcludingDirectPayment = totalCostExcludingDirectPayment(parseFloat(cm.totalCost), cm.paymentData);
                        paymentsCalculator.init(cm.paymentData, cm.booking.UserData.PaymentDetails.PaymentAmount, cm.payingFullAmount);
                        //a little un tidy but to fix the card fees not updating when changing insurance
                        // for both versions of the form need to do the following
                        _updateCardFees(cm.paymentModel.cardDetail.paymentOptionId ||
                            cm.booking.UserData.PaymentDetails.CardDetails.CardType);
                    });
                });
            });
        }
        cm.customerAutoCompleterDeselect = customerAutoCompleterDeselect;
        function customerAutoCompleterDeselect() {
            cm.customer = null;
        }
        cm.setChauffeurDate = function (date) {
            cm.booking.UserData.ChauffeurDetails.PickupTime = date;
        };
        cm.openTakingPaymentModal = function (e) {
            e.preventDefault();
            e.stopPropagation();
            cm.showTakingPaymentModal = true;
            bookingService.pauseRecording(TRPCONFIG.ClientIpAddress);
        };
        cm.closeTakingPaymentModal = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            cm.showTakingPaymentModal = false;
            bookingService.resumeRecording(TRPCONFIG.ClientIpAddress);
        };
        cm.securityCodeOnMask = function () {
            cm.isSecurityCodeMasked = true;
        };
        cm.hidePaymentForms = function () { return _.get(cm, 'booking.RebookDetails.Difference') <= 0; };
        cm.updateDfReferenceId = function (dfReferenceId) { return cm.booking.UserData.PaymentDetails.DfReferenceId = dfReferenceId; };
        broker.subscribe('bookingCtrl', 'confirmPUP', function (e) {
            //fetch the new payment info and advance to booking
            var basketId = e.data.basketId;
            $q.all([
                basketStore.payments(basketId),
                basketStore.totalDeposit(basketId, $routeParams.productId),
                basketStore.totalCost(basketId)
            ]).then(function (_a) {
                var payments = _a[0], totalDeposit = _a[1], totalCost = _a[2];
                cm.paymentData = payments;
                cm.totalDeposit = totalDeposit;
                cm.totalCost = totalCost;
                cm.minDeposit = cm.totalDeposit;
                cm.totalCostExcludingDirectPayment = totalCostExcludingDirectPayment(parseFloat(cm.totalCost), cm.paymentData);
                paymentsCalculator.init(cm.paymentData, cm.booking.UserData.PaymentDetails.PaymentAmount, cm.payingFullAmount);
                var paymentAmount = parseFloat(cm.booking.UserData.PaymentDetails.PayFullAmount ? cm.totalCostExcludingDirectPayment : cm.minDeposit);
                cm.booking.UserData.PaymentDetails.PaymentAmount = paymentAmount;
                cm.booking.UserData.PaymentDetails.DepositAmount = paymentAmount - cm.minDeposit;
                _setPaymentTotalPlusFees();
                cm.book();
            });
        });
        function _getCostBreakdown(basketId) {
            return basketStore.rehydrateBasketForPUP(basketId).then(function () {
                return $q.all([
                    basketStore.totalDiscount(basketId),
                    basketStore.totalDeposit(basketId, $routeParams.ProductId),
                    basketStore.costBreakdownGrouped(basketId),
                    basketStore.rules(basketId, $routeParams.ProductId),
                    basketStore.payDirectTotal(basketId),
                    basketStore.carHire(basketId),
                    basketStore.isAtolProtected(basketId)
                ]).then(function (_a) {
                    var totalDiscount = _a[0], totalDeposit = _a[1], costBreakdownGrouped = _a[2], rules = _a[3], payDirectTotal = _a[4], carHire = _a[5], isAtolProtected = _a[6];
                    var dataForPup = {};
                    dataForPup.totalDiscount = totalDiscount;
                    dataForPup.totalDeposit = totalDeposit;
                    dataForPup.costBreakdownGrouped = costBreakdownGrouped;
                    dataForPup.totalCostGrouped = costBreakdownGrouped.total;
                    dataForPup.atolAvailable = isAtolProtected;
                    _.each(costBreakdownGrouped, function (cb) {
                        if (cb.group === 1) {
                            // HOTEL
                            dataForPup.hotelCost = cb.costBreakdown
                                .filter(function (cost) { return cost.TypeId === costBreakdownCodes.Hotel; })
                                .reduce(function (totalCost, currentHotel) { return totalCost + currentHotel.UnitAmount; }, 0);
                            dataForPup.cancellationProtection = _.get(cb.costBreakdown.find(function (cost) {
                                return cost.TypeId === costBreakdownCodes.CancellationProtection;
                            }), 'UnitAmount', 0);
                        }
                        else if (cb.group === 2) {
                            // FLIGHTS
                            // Isolate the ATOL cost
                            // Ideally we would be able to search by type but we have to use the description
                            var atol = _.find(cb.costBreakdown, function (item) {
                                return item.Description.indexOf('ATOL') >= 0;
                            });
                            if (atol) {
                                dataForPup.atolCost = atol.UnitAmount * atol.Quantity;
                                dataForPup.flightCost = cb.total - dataForPup.atolCost; // subtract the atol cost from the flights total
                            }
                            else {
                                dataForPup.flightCost = cb.total;
                            }
                        }
                        else if (cb.group === 3) {
                            // EXTRAS
                            dataForPup.extraCost = cb.total;
                            dataForPup.extras = basketStore.extrasBreakdown(cb.costBreakdown);
                        }
                    });
                    dataForPup.hasDeposit = rules.depositAllowed;
                    dataForPup.hasPayDirect = payDirectTotal > 0;
                    var carHireExtras = _.get(carHire, 'RequestedItems');
                    if (carHireExtras && carHireExtras.length === 0) {
                        carHireExtras = [{
                                Quantity: 1,
                                UnitAmount: _.get(carHire, 'TotalAmount')
                            }];
                    }
                    dataForPup.carHireExtras = carHireExtras;
                    dataForPup.carHireExtrasTotal = carHireExtras ?
                        carHireExtras.reduce(function (total, extra) { return total += extra.UnitAmount; }, 0) :
                        undefined;
                    return dataForPup;
                });
            });
        }
        function isDiscountApplied() {
            return cm.booking.Discounts && cm.booking.Discounts.length;
        }
        function isHFareFlightType() {
            return flightDetail.isHFlightType(_.get(cm.flight, 'Details.Itinerary', false));
        }
        function cpgValidation() {
            cm.refreshEnbdObj();
            cm.changeOtpCode();
            cm.enbdDetails.isCpgInProgress = true;
            cm.isBookingDisabled = true;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails = null;
            cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode = null;
            cm.generateTokens().then(function () {
                cm.enbdDetails.cardNumber = cm.booking.UserData.PaymentDetails.CardDetails.CardNumber;
                paymentsService.cpgValidation(cm.enbdDetails).then(function (res) {
                    if (res.data.Status === 1) {
                        cm.enbdDetails.isCpgInProgress = false;
                        cm.enbdDetails.isCpgValid = true;
                        cm.enbdDetails.SessionToken = res.data.SessionToken;
                        cm.enbdDetails.TransactionId = res.data.TransactionId;
                    }
                    else {
                        cm.enbdDetails.isCpgValid = false;
                        cm.enbdDetails.isCpgInProgress = false;
                    }
                }, function () {
                    cm.enbdDetails.isCpgValid = false;
                    cm.enbdDetails.isCpgInProgress = false;
                });
            });
        }
        cm.otpValidation = function () {
            var options = Object.assign(cm.enbdDetails);
            cm.enbdDetails.isOtpInProgress = true;
            options.OTP = parseInt(cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode);
            paymentsService.verifyOtp(options).then(function (res) {
                if (res.data && res.data.Status === 1) {
                    cm.enbdDetails.isOtpInProgress = false;
                    cm.enbdDetails.balanceData = res.data;
                    cm.enbdDetails.availablePoints = cm.enbdDetails.balanceData.LoyaltyPoints.AvailablePoints *
                        cm.enbdDetails.balanceData.LoyaltyPoints.RedemptionRate;
                    cm.enbdDetails.isOtpValid = true;
                    cm.enbdDetails.pointsToRedeem = cm.totalCost > cm.enbdDetails.availablePoints
                        ? cm.enbdDetails.availablePoints
                        : cm.totalCost;
                    cm.enbdDetails.remainingPoints = cm.enbdDetails.availablePoints - cm.enbdDetails.pointsToRedeem < 0
                        ? 0 : cm.enbdDetails.availablePoints - cm.enbdDetails.pointsToRedeem;
                    cm.enbdDetails.amountToRedeem = cm.enbdDetails.pointsToRedeem !== cm.totalCost
                        ? cm.totalCost - cm.enbdDetails.pointsToRedeem : 0;
                }
                else {
                    cm.enbdDetails.isOtpValid = false;
                    cm.enbdDetails.isOtpInProgress = false;
                }
            }, function () {
                cm.enbdDetails.isOtpValid = false;
                cm.enbdDetails.isOtpInProgress = false;
            });
        };
        cm.resendOtpConfirmation = function () {
            cm.enbdDetails.isOtpValid = null;
            cm.enbdDetails.isOtpResent = false;
            cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode = null;
            paymentsService.resendOtpConfirmation(cm.enbdDetails).then(function (res) {
                if (res.data.Status === 1) {
                    cm.enbdDetails.isCpgValid = true;
                    cm.enbdDetails.isOtpResent = true;
                }
                else {
                    cm.enbdDetails.isCpgValid = false;
                }
            });
        };
        cm.usePoints = function () {
            cm.enbdDetails.isPointsPaymentApproved = true;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails = {};
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.RedeemedPoints = cm.enbdDetails.pointsToRedeem;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.ProductId = cm.enbdDetails.balanceData.LoyaltyPoints.ProductId;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.SessionToken = cm.enbdDetails.SessionToken;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.TransactionId = cm.enbdDetails.TransactionId;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.LoyaltyCardSplitPaymentAmount = cm.enbdDetails.amountToRedeem;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.LoyaltyCardNumber = cm.enbdDetails.cardNumber;
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.MaskedLoyaltyCardNumber =
                cm.booking.UserData.PaymentDetails.CardDetails.MaskedCardNumber;
            bookingService.updateBooking(bookingService.trimBooking(cm.booking));
            cm.booking.UserData.PaymentDetails.LoyaltyCardDetails.RedeemedPoints > 0 ? cm.isBookingDisabled = false : cm.enbdDetails.showZeroBalanceAlert = true;
        };
        cm.changeOtpCode = function () {
            if (cm.enbdDetails.isOtpValid) {
                cm.enbdDetails.isOtpValid = null;
            }
        };
        cm.refreshEnbdObj = function () {
            var staticProps = ['domainId', 'currencyCode'];
            cm.booking.UserData.PaymentDetails.CardDetails.otpConfirmationCode = null;
            cm.isBookingDisabled = false;
            for (var prop in cm.enbdDetails) {
                if (staticProps.indexOf(prop) === -1) {
                    cm.enbdDetails[prop] = null;
                }
            }
        };
        function wpHostedBookingCheckAndComplete(wpHostedResponse) {
            try {
                var prepaymentid = wpHostedResponse.prepaymentid, response = wpHostedResponse.response;
                var gateway = response.gateway, order = response.order;
                var status_1 = order.status;
                if (status_1 === 'cancelled_by_shopper') {
                    cm.WPHostedRedirect = false;
                }
                else if (status_1 === 'success') {
                    var mac2 = gateway.mac2, paymentAmount = gateway.paymentAmount, paymentCurrency = gateway.paymentCurrency, paymentStatus = gateway.paymentStatus, orderKey = gateway.orderKey;
                    var paRes = orderKey + "," + paymentAmount + "," + paymentCurrency + "," + paymentStatus + ":" + mac2;
                    cm.booking.UserData.PaymentDetails.PaRes = paRes;
                    cm.booking.UserData.PaymentDetails.PrePaymentID = prepaymentid;
                    cm.book();
                }
                else {
                    var errorMessage = '';
                    if (status_1 === 'failure') {
                        errorMessage = "" + resourceService.get('WP_HOSTED_PAYMENT_FAILED_TEXT');
                    }
                    else if (status_1 === 'error') {
                        errorMessage = "" + resourceService.get('WP_HOSTED_PAYMENT_ERROR_TEXT');
                    }
                    else {
                        errorMessage = "" + resourceService.get('WP_HOSTED_PAYMENT_ERROR_TEXT');
                    }
                    $scope.$broadcast('flash:error', errorMessage);
                }
            }
            catch (e) {
                console.log('Error in handling WP hosted response');
            }
            cm.WPHostedRedirect = false;
        }
        $scope.$on('WPHostedResponseHandler', function (ev, data) {
            wpHostedBookingCheckAndComplete(data);
            $scope.$apply(function () {
                cm.threedsRedirecting = false;
            });
        });
    }
})();
var TR;
(function (TR) {
    var HotelOptions = /** @class */ (function () {
        function HotelOptions($routeParams, $rootScope, $scope, $q, searchUnitService, basketStore, tripService, analytics, basketService, broker) {
            var _this = this;
            this.$routeParams = $routeParams;
            this.$q = $q;
            this.basketStore = basketStore;
            this.basketService = basketService;
            this.broker = broker;
            this.children = 0;
            this.loading = true;
            this.submitted = false;
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                _this.tripId = trip.TripId;
                _this.basketId = trip.BasketId;
                _this.broker.subscribe('HotelsOptions', 'basketUpdated', function () {
                    _this._updateCostBreakdown(_this.basketId)();
                });
                $q.all([
                    basketStore.all(_this.basketId, $routeParams.productId),
                    basketStore.costBreakdown(_this.basketId, $routeParams.productId),
                    basketStore.rules(_this.basketId, $routeParams.productId),
                    basketStore.totalDeposit(_this.basketId, $routeParams.productId),
                    basketStore.optionConditions(_this.basketId),
                    basketStore.totalCost(_this.basketId),
                    basketStore.payDirectTotal(_this.basketId),
                    basketStore.payments(_this.basketId),
                    tripService.getTripReducedOccupancy(_this.tripId)
                ]).then(function (results) {
                    _this.attractionsExtraEnabled = (!!TRPCONFIG.Domain.AttractionsExtraEnabled
                        || !!TRPCONFIG.Domain.AttractionsExtraMobileEnabled);
                    var products = results[0], costBreakdown = results[1], rules = results[2], totalDeposit = results[3], optionConditions = results[4], totalCost = results[5], paydirectTotal = results[6], payments = results[7], occupancy = results[8];
                    _this.hotel = products.h;
                    _this.transfer = products.t;
                    _this.costBreakdown = costBreakdown;
                    _this.optionConditions = optionConditions;
                    _this.totalCost = totalCost;
                    _this.payDirectAmount = paydirectTotal;
                    _this.paymentData = payments;
                    _this.basketRules = rules;
                    _this.totalDeposit = totalDeposit;
                    _this.children = (occupancy.ChildAges && occupancy.ChildAges.length) || 0;
                    $rootScope.unlockScreen($scope);
                    analytics.track('Event', 'OptionsPage', {
                        TotalCost: _this.totalCost,
                        Hotel: _this.hotel,
                    });
                    if (trip.HotelsRequest) {
                        tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId)
                            .then(function (ds) { return _this.durationSummary = ds; });
                        _this.additionalInformation = _this.hotel.Details.AdditionalInformation
                            .concat(_this.hotel.Details.PromotionalInformation);
                    }
                    _this.loading = false;
                });
            });
        }
        HotelOptions.prototype._updateCostBreakdown = function (basketId) {
            var _this = this;
            return function () {
                return _this.$q.all([_this.basketStore.costBreakdown(basketId, _this.$routeParams.productId),
                    _this.basketStore.totalDeposit(basketId, _this.$routeParams.productId),
                    _this.basketStore.totalCost(basketId),
                    _this.basketStore.payDirectTotal(basketId),
                    _this.basketStore.payments(basketId)]).then(function (res) {
                    _this.costBreakdown = res[0];
                    _this.totalDeposit = res[1];
                    _this.totalCost = res[2];
                    _this.payDirectAmount = res[3];
                    _this.paymentData = res[4];
                });
            };
        };
        HotelOptions.prototype.book = function () {
            this.submitted = true;
            this.basketService.bookHotelBasket(this.tripId);
        };
        return HotelOptions;
    }());
    angular
        .module('TR')
        .controller('HotelOptions', HotelOptions);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Options', Options);
    function Options($anchorScroll, $location, $q, $rootScope, $routeParams, $scope, $timeout, analytics, arrayUtil, guidService, baggageService, basketService, bd4travel, basketStore, broker, crossSellService, enumService, hotelFromSession, marhabaSearch, marhabaService, occupancyService, optionsUtil, resourceService, scrollService, searchUnitService, tripService, priorityBoardingService, cookieService, flightDetail, mandatoryTransferService) {
        var cm = this;
        var tripId = $routeParams.tripId;
        var OPTION_TRANSFER = 'transfer';
        var OPTION_PARKING = 'parking';
        var submitted = false;
        var optionsQueue = $q.when();
        cm.additionalInformation = [];
        cm.confirmedBaggageWarning = false;
        cm.loading = true;
        cm.loadingMarhaba = false;
        cm.agentReadConfirm = false;
        cm.showHandLuggageInfo = false;
        cm.skipBaggageCheck = false;
        cm.expandSummary = false;
        cm.allBaggageSelected = true;
        cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        cm.carHireTemporaryDisabled = false;
        cm.isTransferMandatory = false;
        cm.isAvailableTransfer = true;
        cm.isHotelFirstJourney = basketService.isFlightPreselected();
        cm.discount = 0;
        cm.isUaeAirportCode = false;
        scrollTo(0, 0);
        $rootScope.lockScreen($scope, {
            title: resourceService.get('PREPARINGBOOKING'),
            loadingScreenStyle: 'booking-optionsCtrl'
        });
        function changeWorkflowState(breadcrumb) {
            basketService.changeJourneyUrl(breadcrumb);
        }
        function _getHotelFromSession(trip, hotelFromBasket, routeParams) {
            return hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, hotelFromBasket.Details.Id, routeParams.tripId);
        }
        $scope.$on('sendTransferSelection', function (e, val) {
            if (val) {
                $scope.$emit('flash:hide', resourceService.get('BREADCRUMBTRANSFER'));
            }
            cm.selectedTransfer = val;
        });
        $scope.$on('sendParkingSelection', function (e, val) {
            if (val) {
                $scope.$emit('flash:hide', resourceService.get('BREADCRUMBPARKING'));
            }
            cm.selectedParking = val;
        });
        if (TRPCONFIG.Domain.HideOptionPageFooter === true) {
            broker.publish('hideFooter');
        }
        if (TRPCONFIG.Domain.SkipBaggageCheck === true) {
            cm.skipBaggageCheck = true; //skip the baggage check
        }
        tripService.getTrip(tripId).then(function (trip) {
            var BasketId = trip.BasketId, TripId = trip.TripId, TripType = trip.TripType;
            var productId = $routeParams.productId;
            var isHotelType = TripType === tripService.tripTypes.Hotel;
            var isHolidayType = TripType === tripService.tripTypes.Holiday;
            var isFlightType = TripType === tripService.tripTypes.Flight;
            cm.tripId = TripId;
            cm.tripType = TripType;
            cm.changeWorkflowState = changeWorkflowState;
            cm.attractionsExtraEnabled = (!!TRPCONFIG.Domain.AttractionsExtraEnabled || !!TRPCONFIG.Domain.AttractionsExtraMobileEnabled) && (isHolidayType || isFlightType);
            cm.isKidsFree = trip.IsKidsFree &&
                (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);
            if (trip.FlightsRequest && trip.FlightsRequest.SelectedFlight && trip.FlightsRequest.SelectedFlight.Unavailable) {
                return;
            }
            if (TRPCONFIG.Domain.HoldBaggageEnabled) {
                _updateBagInfo(trip);
            }
            var marhabaSearchId = trip.MarhabaRequest ? trip.MarhabaRequest.AvailabilitySearchId : null;
            cm.oneWayOnly = searchUnitService.isOneWayFlightEnabled();
            cm.book = function () {
                var validOptionsSelected = checkOptions([OPTION_TRANSFER, OPTION_PARKING]);
                if (validOptionsSelected.errors.length > 0) {
                    $scope.$emit('flash:error', resourceService.get("BREADCRUMB" + validOptionsSelected.errors[0].title.toUpperCase()));
                    scrollService.scrollTo("#" + validOptionsSelected.errors[0].id, { offset: validOptionsSelected.errors[0].offset });
                    return;
                }
                if (cm.disableWithAgentControl() || (cm.isTransferMandatory && !cm.isAvailableTransfer)) {
                    return;
                }
                try {
                    var sum = function (array) { return _(array).map(function (x) { return x.Quantity * x.UnitAmount; }).reduce(function (memo, num) { return memo + num; }, 0); };
                    var insurance = _.filter(cm.costBreakdown, function (c) { return c.Description.indexOf('Travel Insurance') > -1; });
                    var marhaba = _.filter(cm.costBreakdown, function (c) { return c.Description.indexOf('Meet and Greet') > -1 || c.Description.indexOf('Marhaba') > -1; });
                    analytics.track('Event', 'OptionsPageClick', {
                        Revenue: cm.totalCost,
                        Insurance: sum(insurance),
                        Marhaba: sum(marhaba)
                    });
                }
                catch (err) { }
                if (TRPCONFIG.DeviceSettings.UseBaggageWarningPopup && !cm.confirmedBaggageWarning && !cm.bagsSelected && !cm.bagsIncluded && !cm.skipBaggageCheck) {
                    cm.showPopupBaggage = true;
                    return;
                }
                submitted = true;
                basketService.bookBasket(TripId, BasketId);
            };
            broker.subscribe('Options', 'basketUpdated', function () {
                _updateCostBreakdown(BasketId)();
                if (TRPCONFIG.Domain.HoldBaggageEnabled) {
                    _updateBagInfo(trip);
                }
                _updateDepositValues(BasketId);
            });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('Options');
            });
            $q.all([
                basketStore.all(BasketId, productId),
                basketStore.costBreakdown(BasketId, productId),
                basketStore.flightOptions(BasketId, productId),
                basketStore.rules(BasketId, productId),
                basketStore.totalDeposit(BasketId, productId),
                basketStore.balancesDue(BasketId, productId),
                basketStore.optionConditions(BasketId),
                basketStore.totalCost(BasketId),
                basketStore.flightBaggageCostings(BasketId),
                basketStore.payDirectTotal(BasketId),
                basketStore.payments(BasketId),
                tripService.getTripReducedOccupancy(TripId)
            ]).then(function (results) {
                cm.products = results[0];
                var hotel = results[0].h;
                var flight = results[0].f;
                var transfer = results[0].t;
                cm.occupancy = results[11];
                cm.children = (cm.occupancy.ChildAges && cm.occupancy.ChildAges.length) || 0;
                cm.isUaeAirportCode = isUaeAirport(flight);
                if (hotel != null) {
                    _getHotelFromSession(trip, hotel, $routeParams).then(function (res) {
                        bd4travel.trackHotelAvailability(TripId, res.Id, 'booking:extras');
                        if (Object.keys(hotel && hotel.Details)) {
                            cm.roomsWithMandatoryTransfer = mandatoryTransferService
                                .getHolidayRoomsWithTransfers(hotel.Details || []);
                        }
                    });
                }
                function setAvailableTransfer() {
                    return __awaiter(this, void 0, void 0, function () {
                        var roomsWithMandatoryTransfer, mandatoryTransfers;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, mandatoryTransferService
                                        .getHolidayRoomsWithTransfers(hotel.Details || [])];
                                case 1:
                                    roomsWithMandatoryTransfer = _a.sent();
                                    mandatoryTransfers = _.get(roomsWithMandatoryTransfer, 'mandatoryTransfers');
                                    if (mandatoryTransfers) {
                                        cm.isAvailableTransfer = true;
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
                if (hotel != null) {
                    setAvailableTransfer();
                }
                $rootScope.unlockScreen($scope);
                if (flight == null) {
                    return;
                }
                cm.flight = flight;
                cm.hotel = hotel;
                if (TRPCONFIG.Domain.HideOptionPageAgentCheckboxWhenNoInfomation && !hotel) {
                    cm.agentReadConfirm = true;
                }
                cm.transfer = transfer;
                cm.costBreakdown = results[1];
                cm.marhabaEnabled = TRPCONFIG.Domain.MarhabaEnabled;
                cm.optionConditions = results[6];
                cm.totalCost = results[7];
                cm.payDirectAmount = results[9];
                cm.paymentData = results[10];
                cm.marhaba = results[0].m;
                cm.isPackage = _.get(flight, 'PackageId') || _.get(hotel, 'PackageId');
                analytics.track('Event', 'OptionsPage', {
                    TotalCost: cm.totalCost,
                    Hotel: cm.hotel,
                    Flight: cm.flight
                });
                analytics.track('Facebook', 'OptionsPage');
                var flightOptions = results[2];
                cm.priorityBoarding = priorityBoardingService.getPriorityBoardingInfo(flight, flightOptions);
                cm.selectedFlightSector = arrayUtil.map(flight.Details.FlightSectorOptionalExtras, function (sector) { return optionsUtil.parseSelectedOptions(sector, flightOptions); });
                angular.forEach(cm.flight.Details.FlightSectorOptionalExtras, function (sector, sectorIndex) {
                    var selected = cm.selectedFlightSector[sectorIndex];
                    angular.forEach(sector.OptionalExtras, function (extras, parentIndex) {
                        angular.forEach(extras.MultiOptionalExtras, function (extra, index) {
                            _setQuantitative(extra, parentIndex, index, selected);
                        });
                    });
                });
                cm.basketRules = results[3];
                cm.totalDeposit = results[4];
                cm.costBreakdown.forEach(function (breakdown) {
                    cm.discount += breakdown.TypeId === 20 ? (breakdown.UnitAmount * breakdown.Quantity) : 0;
                });
                // Sum invisible price with hotel
                cm.costBreakdown = cm.costBreakdown.map(function (breakdown) {
                    breakdown.TotalPrice = 0;
                    if (breakdown.TypeId === 1) {
                        breakdown.TotalPrice = (breakdown.UnitAmount * breakdown.Quantity);
                        cm.costBreakdown.forEach(function (invisible) {
                            // Where id 0 is id of the invisible price
                            if (invisible.TypeId === 0 && invisible.IsPriceHidden) {
                                breakdown.TotalPrice += invisible.UnitAmount;
                            }
                        });
                    }
                    return breakdown;
                });
                if ((isHotelType || isHolidayType) && hotel && hotel.Details) {
                    tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(function (ds) { return cm.durationSummary = ds; });
                    cm.additionalInformation = hotel.Details.AdditionalInformation.concat(hotel.Details.PromotionalInformation);
                }
                if (TRPCONFIG.Domain.IsCarHireTemporaryDisabled) {
                    isCarHireTemporaryDisabled();
                }
                cm.loading = false;
                function updateFlightOptionsInBasket(storeFn) {
                    return function (options) {
                        return storeFn.call(basketStore, basketStore.productType.Flight, flight.ProductId, options, BasketId);
                    };
                }
                function addOrRemoveFlightOptionsFromBasket() {
                    optionsQueue = optionsQueue.then(function () {
                        return basketStore.flightOptions(BasketId).then(function (bo) {
                            //we have to filter out checkin option from the flight options because everything is awful.
                            bo = arrayUtil.filter(bo, function (o) {
                                return !optionsUtil.isCheckInOption(flight.Details.FlightSectorOptionalExtras, o);
                            });
                            var so = _mergeSelectedOptions();
                            //we need to wait for all removes to return until we do the adds otherwise things
                            //get out of sync with the basket
                            return _missingFrom(bo, so, updateFlightOptionsInBasket(basketStore.removeOptions)).then(function () {
                                return _missingFrom(so, bo, updateFlightOptionsInBasket(basketStore.addOptions));
                            }).then(_updateBasket);
                        });
                    });
                }
                cm.removeMarhaba = function () {
                    basketStore.removeMarhaba(BasketId).then(function () {
                        _updateBasket();
                    });
                };
                if (cm.marhabaEnabled) {
                    _buildMarhabaOptions(flight);
                }
                cm.getSecondaryMarhabaOptions = function (option) {
                    var params = {
                        Terminal: { Id: option.TerminalId, Name: option.Terminal },
                        FlightType: option.FlightType,
                        Airport: option.Airport,
                        DateAndTime: option.Date,
                        Occupancy: { Adults: cm.occupancy.Adults, Children: cm.children, Infants: 0 }
                    };
                    if (!marhabaSearchId) {
                        marhabaSearchId = guidService.uuid();
                    }
                    return marhabaSearch.search({ searchId: marhabaSearchId, tripId: TripId, newSearch: true, parameters: params })
                        .then(function (res) {
                        return res;
                    });
                };
                cm.addMarhabaToBasket = function () {
                    cm.noOfPassengers = occupancyService.getNumberOfNonInfantPassengers();
                    cm.selection = { auxillaries: {} };
                    // Products are split between chauffeurs and auxiliaries
                    cm.auxillaryProducts = [];
                    cm.chauffeurs = [];
                    cm.lounges = [];
                    return basketStore.addMarhaba(marhabaSearchId, cm.selectedSecondayMarhabaOption.Id, BasketId)
                        .then(function (productInfo) {
                        cm.additionalMarhabaOptions = productInfo.Details.AvailableOptions;
                        var res = marhabaService.adjustMarhabaOptions(productInfo, resourceService.get('SELECTCHAUFFEUR'));
                        if (res.noOptions) {
                            cm.noOptions = res.noOptions;
                        }
                        else {
                            cm.auxillaryProducts = res.auxillaryProducts;
                            cm.chauffeurs = res.chauffeurs;
                            cm.lounges = res.lounges;
                            cm.selection.chauffeur = res.selectedChauffeur;
                        }
                        cm.loaded = true;
                        cm.loadingMarhaba = false;
                        _updateBasket();
                        return productInfo;
                    });
                };
                cm.confirmMarhaba = function () {
                    // The chauffeurs is treated as any other auxillaries
                    if (cm.selection.chauffeur && cm.selection.chauffeur.Id !== 0) {
                        cm.selection.auxillaries[cm.selection.chauffeur.Id] = cm.selection.chauffeur.Num;
                    }
                    // Lounges is treated as any other auxillaries
                    _.forEach(cm.lounges, function (lo) {
                        //Remove all other Lounges
                        cm.selection.auxillaries[lo.Id] = 0;
                    });
                    // Only one Lounge can be added
                    if (cm.selection.lounge) {
                        cm.selection.auxillaries[cm.selection.lounge.Id] = cm.noOfPassengers;
                    }
                    // Normalization of options for the request
                    var options = [];
                    for (var auxId in cm.selection.auxillaries) {
                        var quantity = cm.selection.auxillaries[auxId];
                        if (quantity > 0) {
                            options.push({ OptionId: auxId, ChosenQuantity: quantity });
                        }
                    }
                    // The marhaba product in the basket is removed and added again with all the options
                    basketStore.addMarhaba(marhabaSearchId, cm.selectedSecondayMarhabaOption.Id, BasketId, options).then(function () {
                        _updateBasket();
                    });
                };
                cm.selectMarhaba = function (option) {
                    var params = {
                        Terminal: { Id: option.TerminalId, Name: option.Terminal },
                        FlightType: option.FlightType,
                        Airport: option.Airport,
                        DateAndTime: option.Date,
                        Occupancy: { Adults: cm.occupancy.Adults, Children: cm.children, Infants: 0 }
                    };
                    marhabaSearch.clearSearchResults();
                    basketService.getMarhaba(marhabaSearchId, BasketId, TripId, params);
                };
                cm.balancesDue = results[5];
                cm.singleOptionChanged = function () {
                    addOrRemoveFlightOptionsFromBasket();
                };
                cm.multiOptionChanged = function () {
                    addOrRemoveFlightOptionsFromBasket();
                };
                cm.selectSeats = function (seats) {
                    cm.selectedFlightSector[0].selectedSeats = seats;
                    addOrRemoveFlightOptionsFromBasket();
                };
                cm.getSelectedSeats = function () {
                    return cm.selectedFlightSector[0].selectedSeats;
                };
                cm.disableContinue = function () {
                    var standardConditions = (!TRPCONFIG.DeviceSettings.UseBaggageWarningPopup &&
                        !cm.confirmedBaggageWarning &&
                        !cm.allBaggageSelected) || submitted;
                    return standardConditions;
                };
                cm.hideContinueButton = function () {
                    return TRPCONFIG.Domain.isAgentMode;
                };
                cm.disableWithAgentControl = function () {
                    if ($rootScope.user.Agent && !cm.agentReadConfirm) {
                        return true;
                    }
                    return cm.disableContinue();
                };
                cm.validateConsent = function (consentConfirmed) {
                    var isValid = !cm.hasOwnProperty('detailsStorageConsent') || consentConfirmed;
                    return isValid;
                };
                cm.restructuredOptions = restructureOptionsByOptionType();
                /*Options Page redesign simplified baggage helpers  START  */
                cm.flightBaggageCosts = results[8];
                cm.bagsIncluded = 0;
                cm.bagsSelected = 0;
                cm.bagsTeaserCost = 0;
                cm.bagsWeight = 0;
                var min = {
                    BagsIncludedCount: _(flight.Details.Itinerary.Legs).map(function (leg) { return leg.BagsIncludedCount; }).min(),
                    BaggageAllowanceTotalKg: _(flight.Details.Itinerary.Legs).map(function (leg) { return leg.BaggageAllowanceTotalKg; }).min(),
                    BaggageAllowanceKgPerBag: _(flight.Details.Itinerary.Legs).map(function (leg) { return leg.BaggageAllowanceKgPerBag; }).min()
                };
                cm.isBaggageInfoUnknown = min.BaggageAllowanceTotalKg === -1 && min.BagsIncludedCount === -1;
                if (min.BagsIncludedCount === 0) {
                    basketStore.simplifiedBaggageCount(BasketId)
                        .then(function (c) {
                        if (c.price === 0 && c.maxAllowed === c.selected) {
                            //to deal with the case where the bags we have included by default are free
                            cm.bagsIncluded = c.selected;
                        }
                        else {
                            cm.bagsTeaserCost = c.price / flight.Details.Itinerary.Legs.length;
                            cm.maxBagsSelectable = c.maxAllowed;
                            cm.bagsSelected = c.selected;
                        }
                        if (min.BaggageAllowanceKgPerBag > 0) {
                            cm.holdBagUnitWeightKg = min.BaggageAllowanceKgPerBag;
                        }
                        else {
                            cm.holdBagUnitWeightKg = c.unitWeightKg || 20;
                        }
                    });
                }
                else {
                    cm.bagsIncluded =
                        cm.isBaggageInfoUnknown ? null :
                            (min.BaggageAllowanceKgPerBag > 0) ? min.BagsIncludedCount :
                                (min.BaggageAllowanceTotalKg < 1) ? min.BagsIncludedCount :
                                    null;
                    cm.holdBagUnitWeightKg =
                        cm.isBaggageInfoUnknown ? null :
                            (min.BaggageAllowanceKgPerBag > 0) ? min.BaggageAllowanceKgPerBag :
                                (min.BaggageAllowanceTotalKg > 0) ? min.BaggageAllowanceTotalKg :
                                    null;
                }
                // get hand baggage restrictions
                cm.handBaggageInformation = _getHandBaggageInformation(cm.flight.Details);
                cm.updateBaggageCount = function (popup, element) {
                    if (popup === void 0) { popup = false; }
                    if (element === void 0) { element = null; }
                    setState(element, true);
                    analytics.track('mixpanel', popup
                        ? 'PopUpAddBagsClick'
                        : 'OptionsPageAddBagClick');
                    basketStore.updateBaggageOptions(BasketId, cm.bagsSelected, cm.selectedFlightSector[0].selectedMultiOptions)
                        .then(_updateBasket).then(setState(element, false));
                };
                /*Options Page redesign simplified baggage helpers  END  */
            });
        }, basketService.bookingAlreadyDone("options: '" + $routeParams.tripId + "'"));
        function setState(element, disabled) {
            if (element) {
                jQuery("#" + element + " :button").attr('disabled', disabled);
            }
        }
        function isUaeAirport(flight) {
            var airPortCode = _.get(TRPCONFIG, 'Domain2.ForArrivalAirportCodesExceptions') || [];
            var value = false;
            if (flight && flight.Details.Itinerary) {
                var arrivalAirPortCode = flight.Details.Itinerary.Legs[0].ArrivalAirport.Code;
                value = airPortCode.includes(arrivalAirPortCode);
            }
            return value;
        }
        function _getHandBaggageInformation(flight) {
            var baggageInfos = flight.Itinerary.Legs.map(function (l) { return l.HandBaggageInformation; })
                .filter(function (h) { return h != null; });
            var getMin = function (prop) {
                var relevant = _.filter(baggageInfos, function (info) {
                    return info[prop] > 0;
                });
                var min = _.min(_.flatMap(relevant, function (r) { return r[prop]; }));
                return min || 0;
            };
            return {
                PiecesAllowed: getMin('PiecesAllowed'),
                WidthCm: getMin('WidthCm'),
                HeightCm: getMin('HeightCm'),
                DepthCm: getMin('DepthCm'),
                WeightKg: getMin('WeightKg')
            };
        }
        function checkOptions(options) {
            var errors = [];
            if (options.length > 0) {
                errors = options.map(function (option) {
                    return checkRequiredOption(option);
                }).filter(function (reqOption) {
                    return reqOption.error === true;
                });
            }
            return { errors: errors };
        }
        function checkRequiredOption(option) {
            var error = false;
            var requiredOption = { error: error };
            switch (option.toLowerCase()) {
                case OPTION_TRANSFER:
                    error = (TRPCONFIG.Domain.EnforceTransferOptionSelection
                        && cm.selectedTransfer == null);
                    if (error) {
                        _.assign(requiredOption, { error: error }, { title: option, id: 'transfer-selection', offset: 0 });
                    }
                    break;
                case OPTION_PARKING:
                    error = (TRPCONFIG.Domain.AirportParkingEnabled
                        && TRPCONFIG.Domain.EnforceParkingOptionSelection
                        && cm.selectedParking == null);
                    if (error) {
                        _.assign(requiredOption, { error: error }, { title: option, id: 'parking-selection', offset: 200 });
                    }
                    break;
            }
            return requiredOption;
        }
        function _updateBasket() {
            return basketService.updateBasket();
        }
        function _setQuantitative(extra, parentIndex, index, selected) {
            var uniqueOptionExists = arrayUtil.any(extra.Options, function (option) {
                return option.Key.OptionId !== extra.Options[0].Key.OptionId;
            });
            if (!uniqueOptionExists) {
                if (!selected.multiOptionsQuantity) {
                    selected.multiOptionsQuantity = [];
                }
                if (!selected.multiOptionsQuantity[parentIndex]) {
                    selected.multiOptionsQuantity[parentIndex] = {};
                }
                if (selected.selectedMultiOptions && selected.selectedMultiOptions[parentIndex] && selected.selectedMultiOptions[parentIndex][index] && selected.selectedMultiOptions[parentIndex][index].Quantity) {
                    selected.multiOptionsQuantity[parentIndex][index] = selected.selectedMultiOptions[parentIndex][index].Quantity;
                }
                else {
                    selected.multiOptionsQuantity[parentIndex][index] = 0;
                }
                // remove options with quantity set to 0
                extra.Options = extra.Options.filter(function (op) { return op.Quantity; });
                extra.Quantitative = true;
            }
        }
        //this accepts a source options array and a destination options array and a
        //function into which to pass the items that are in src and missing from
        //dest. The function must accept an array of options and return a promise.
        function _missingFrom(src, dst, forall) {
            return forall(arrayUtil.map(arrayUtil.filter(src, function (o1) {
                return !arrayUtil.any(dst, function (o2) {
                    return angular.equals(o1, o2);
                });
            }), function (optionKey) {
                return { OptionId: optionKey.OptionId, ChosenQuantity: optionKey.Quantity };
            }));
        }
        function _updateCostBreakdown(basketId) {
            return function () {
                var productId = $routeParams.productId;
                return $q.all([
                    basketStore.costBreakdown(basketId, productId),
                    basketStore.totalDeposit(basketId, productId),
                    basketStore.totalCost(basketId),
                    basketStore.flightBaggageCostings(basketId),
                    basketStore.payDirectTotal(basketId),
                    basketStore.payments(basketId)
                ]).then(function (res) {
                    cm.costBreakdown = res[0];
                    cm.totalDeposit = res[1];
                    cm.totalCost = res[2];
                    cm.flightBaggageCosts = res[3];
                    cm.payDirectAmount = res[4];
                    cm.paymentData = res[5];
                });
            };
        }
        function _updateBagInfo(trip) {
            baggageService.getBaggageInfo(trip.TripId).then(function (bagInfo) {
                var people = occupancyService.getNumberOfNonInfantPassengers() || 1;
                _.forEach(cm.selectedFlightSector, function (sector, index) {
                    sector.bagInfo = bagInfo[index];
                    sector.bagInfo.allBaggageSelected = sector.bagInfo.holdBagsIncluded || sector.bagInfo.passengerHoldBags.length === people;
                });
                cm.allBaggageSelected = _.every(cm.selectedFlightSector, function (sector) { return sector.bagInfo.allBaggageSelected; });
            });
        }
        function _updateDepositValues(basketId) {
            return $q.all([
                basketStore.all(basketId),
                basketStore.balancesDue(basketId),
                basketStore.rules(basketId)
            ]).then(function (_a) {
                var _b = _a[0], h = _b.h, f = _b.f, t = _b.t, balancesDue = _a[1], basketRules = _a[2];
                cm.hotel = h;
                cm.flight = f;
                cm.transfer = t;
                cm.balancesDue = balancesDue;
                cm.basketRules = basketRules;
            });
        }
        function _mergeSelectedOptions() {
            var opts = [];
            angular.forEach(cm.selectedFlightSector, _mergeSelectedOptionsInternal);
            return opts;
            function _mergeSelectedOptionsInternal(model) {
                angular.forEach(model.selectedOptions, function (o) { return opts.push(o); });
                angular.forEach(model.selectedMultiOptions, function (grp) {
                    angular.forEach(grp, function (o) {
                        if (o != null) {
                            opts.push(o);
                        }
                    });
                });
                angular.forEach(model.selectedSeats, function (s) {
                    opts.push(s);
                });
            }
        }
        function _extractAirportsFromLeg(leg) {
            var validAirports = [];
            var a;
            a = _filterAirportObject(leg.ArrivalAirport, 'ARRIVAL');
            a.Date = leg.ArrivalDate;
            a.FlightType = { Id: 1, Name: resourceService.get('ARRIVAL'), Label: resourceService.get('ORIGIN') };
            a.TerminalId = _sanitizeTerminal(leg.Segments[leg.Segments.length - 1].DestinationTerminal);
            a.FullTitle = a.Title + " - Terminal " + a.TerminalId;
            validAirports.push(a);
            a = _filterAirportObject(leg.DepartureAirport, 'DEPARTURE');
            a.Date = leg.DepartureDate;
            a.FlightType = { Id: 2, Name: resourceService.get('DEPARTURE'), Label: resourceService.get('DESTINATION') };
            a.TerminalId = _sanitizeTerminal(leg.Segments[0].DepartureTerminal);
            a.FullTitle = a.Title + " - Terminal " + a.TerminalId;
            validAirports.push(a);
            return validAirports;
        }
        function _sanitizeTerminal(terminal) {
            if (!terminal) {
                return 1;
            }
            var terminalId = parseInt(terminal);
            if (isNaN(terminalId)) {
                return 1;
            }
            return terminalId;
        }
        function _filterAirportObject(airport, type) {
            return {
                Title: airport.Title,
                Airport: { Title: airport.Title, Code: airport.Code },
                Type: resourceService.get(type)
            };
        }
        function _buildMarhabaOptions(flight) {
            var itinerary = flight.Details.Itinerary;
            var m = _.flatMap(itinerary.Legs, _extractAirportsFromLeg);
            var codes = _.uniq(m.map(function (a) { return a.Airport.Code; }));
            // ...find out marhaba enabled terminals related to the selected airports...
            cm.marhabaOptions = [];
            marhabaService.getMarhabaEnabledTerminals(codes)
                .then(function (res) {
                // ...ignore non-enabled airports.
                for (var i = m.length - 1; i >= 0; i--) {
                    var option = m[i];
                    var validTerminals = res.data.AirportsTerminals[option.Airport.Code];
                    var marhabaEnabled = false;
                    if (!validTerminals) {
                        continue;
                    }
                    if (validTerminals.length === 1) {
                        option.TerminalId = validTerminals[0].Id;
                        option.Terminal = validTerminals[0].Name;
                        option.TerminalNumber = validTerminals[0].TerminalNumber;
                        marhabaEnabled = true;
                    }
                    else {
                        for (var j = validTerminals.length - 1; j >= 0; j--) {
                            if (option.TerminalId === parseInt(validTerminals[j].Id)) {
                                option.Terminal = validTerminals[j].Name;
                                option.TerminalNumber = validTerminals[j].TerminalNumber;
                                marhabaEnabled = true;
                                break;
                            }
                        }
                    }
                    if (marhabaEnabled) {
                        cm.marhabaOptions.push(option);
                    }
                }
            });
        }
        function isCarHireTemporaryDisabled() {
            if (cm.flight && cm.flight.Details.Itinerary) {
                var aiportCode = cm.flight.Details.Itinerary.Legs[0].ArrivalAirport.Code;
                if (TRPCONFIG.Domain.IsCarHireTemporaryDisabled.indexOf(aiportCode) > -1) {
                    cm.carHireTemporaryDisabled = true;
                }
            }
        }
        $timeout(function () {
            $anchorScroll();
        });
        cm.updateQuantitativeOption = function (parent, index, quantity, options, selected) {
            if (options && selected.selectedMultiOptions) {
                var option = (arrayUtil.first(options, function (op) {
                    return op.Key.Quantity === quantity;
                }));
                selected.selectedMultiOptions[parent][index] = option ? {
                    OptionId: option.Key.OptionId,
                    Quantity: option.Key.Quantity
                } : null;
            }
            cm.multiOptionChanged();
        };
        cm.quantitativeOptionTotalPrice = function (key, options) {
            if (key && options) {
                return arrayUtil.first(options, function (op) {
                    return angular.equals(op.Key, key);
                }).TotalAmountString;
            }
        };
        /* start desktop */
        cm.isBaggageOptionInTheHold = function (option, sector) {
            if (!sector || !sector.bagInfo || !option) {
                return false;
            }
            var showCheckbox = sector.bagInfo.passengerHoldBags.filter(function (value) {
                return value.Id === option.OptionId;
            });
            return showCheckbox.length > 0;
        };
        cm.showPopupBaggage = false;
        cm.popupBaggageNotRequired = function () {
            cm.confirmedBaggageWarning = true;
            $scope.$on('dfReferenceId', function (_, id) {
                cm.booking.UserData.PaymentDetails.DfReferenceId = id;
            });
            cm.book();
        };
        cm.scrollToExtraOptions = function () {
            scrollService.scrollTo('[optional-extras-scroll-target]', { animate: true });
        };
        cm.changeHotel = function () {
            basketService.changeJourneyUrl(20);
        };
        analytics.track('mixpanel', 'OptionsPage');
        /* end desktop */
        function restructureOptionsByOptionType() {
            var optionGroups = {};
            if (cm.flight && cm.flight.Details && cm.flight.Details.FlightSectorOptionalExtras) {
                var isTwoWayFlight_1 = cm.flight.Details.FlightSectorOptionalExtras.length === 2;
                _.forEach(cm.flight.Details.FlightSectorOptionalExtras, function (sector, sectorIndex) {
                    _.forEach(sector.NonCheckInOptions, function (option, parentIndex) {
                        var sectorLegType = null;
                        if (isTwoWayFlight_1) {
                            sectorLegType = sectorIndex === 0 ? 'outbound' : 'inbound';
                        }
                        if (!optionGroups[option.Title]) {
                            optionGroups[option.Title] = [];
                            optionGroups[option.Title].hideOptions = option.Type !== 0;
                        }
                        optionGroups[option.Title].push({
                            grp: option,
                            selected: cm.selectedFlightSector[sectorIndex],
                            parentIndex: parentIndex,
                            SectorDescription: sector.Description,
                            sectorLegType: sectorLegType
                        });
                    });
                });
            }
            return optionGroups;
        }
        cm.updateChauffeurNum = function () {
            cm.selection.chauffeur.Num = 1;
        };
        cm.getMarhabaHeading = function (p) {
            var value = p.Type ? p.Type : parseInt(p);
            switch (value) {
                case 1:
                    return resourceService.get('MEETANDGREET');
                case 5:
                    return resourceService.get('LOUNGES');
                case 2:
                    return resourceService.get('TRANSFERS');
            }
            return '';
        };
        cm.viewMarhabaInfo = function (marhabaId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            cm.currentMarhabaInfoId = marhabaId;
        };
        cm.noMarhabaOption = '';
        if (TRPCONFIG.Domain.MarhabaDefaultSelected) {
            cm.selectedMarhabaOption = cm.noMarhabaOption;
        }
        $scope.$watch('cm.selectedMarhabaOption', function (val) {
            cm.loadingMarhaba = true;
            cm.secondaryMarhabaOptions = null;
            cm.filteredMarhabaOptions = null;
            cm.selection = { auxillaries: {} };
            cm.auxillaryProducts = [];
            cm.chauffeurs = [];
            cm.lounges = [];
            cm.additionalMarhabaOptions = null;
            if (!_.isUndefined(val) && cm.removeMarhaba) {
                cm.removeMarhaba();
            }
            if (!val) {
                cm.loadingMarhaba = false;
                return;
            }
            cm.getSecondaryMarhabaOptions(val).then(function (data) {
                if (data && data.MarhabaQuotes && data.MarhabaQuotes.length > 0) {
                    data.MarhabaQuotes = data.MarhabaQuotes
                        .sort(marhabaService.sort)
                        .filter(marhabaService.filter)
                        .map(function (item, idx, arr) {
                        var prev = arr[idx - 1];
                        item.showHeading = !prev || (prev && prev.Type !== item.Type);
                        item.isLounge = item.Type === 5;
                        item.isTransfer = item.Type === 2;
                        return item;
                    });
                }
                else {
                    cm.noServices = true;
                }
                cm.secondaryMarhabaOptions = data;
                cm.filteredMarhabaOptions = _.groupBy(data.MarhabaQuotes, 'Type');
                cm.loadingMarhaba = false;
            });
        });
        $scope.$watch('cm.selectedSecondayMarhabaOption', function (val) {
            cm.loadingMarhaba = true;
            cm.selection = { auxillaries: {} };
            cm.auxillaryProducts = [];
            cm.chauffeurs = [];
            cm.lounges = [];
            cm.additionalMarhabaOptions = null;
            if (val == null) {
                cm.loadingMarhaba = false;
                return;
            }
            cm.addMarhabaToBasket();
        });
        /* Config for AbTest of the probability system for options */
        var cancel = $scope.$watch('cm.abTestProbability', function (v) {
            if (!v) {
                return;
            }
            cancel();
            if (v === true) {
                tripService.getTrip($routeParams.tripId).then(function (trip) {
                    var products = [enumService.ProductType.Transfer, enumService.ProductType.CarHire];
                    crossSellService.getCrossSellProbability(trip.BasketId, products)
                        .then(function (p) {
                        cm.TransferCrossSellExpand = (p[enumService.ProductType.Transfer] >= 0.5);
                        cm.CarHireCrossSellExpand = (p[enumService.ProductType.CarHire] >= 0.5);
                    });
                });
            }
        });
        cm.bagsPopupButtonText = function () {
            return resourceService.get(cm.bagsSelected
                ? 'POPUPCONFIRMBAGSADDED'
                : 'POPUPCONFIRMNOBAGS');
        };
        cm.isHFareFlightType = function () {
            return flightDetail.isHFlightType(_.get(cm.flight, 'Details.Itinerary'), false);
        };
    }
})();
var TR;
(function (TR) {
    var PriceRefresh = /** @class */ (function () {
        function PriceRefresh($location, $scope, modalService, broker, $route, savedSearchService, occupancyService, basketService, analytics) {
            this.$location = $location;
            this.$scope = $scope;
            this.modalService = modalService;
            this.broker = broker;
            this.$route = $route;
            this.savedSearchService = savedSearchService;
            this.occupancyService = occupancyService;
            this.basketService = basketService;
            this.analytics = analytics;
            this.dataForPup = modalService.get('dataForPup');
            if (this.dataForPup) {
                this.paymentAmount = this.dataForPup.totalCostGrouped + (this.dataForPup.cardFeeForTotal || 0);
                this.depositAmount = this.dataForPup.hasDeposit ?
                    this.dataForPup.totalDeposit + (this.dataForPup.cardFeeForDeposit || 0) : 0;
            }
        }
        PriceRefresh.prototype.confirmBooking = function () {
            this.analytics.track('mixpanel', 'PUPNAVL Pop-up Interaction', { Type: 'PUP',
                PUPAmount: this.dataForPup.pupAmount, CTA: 'Accept and continue' });
            this.modalService.close();
            this.broker.publish('confirmPUP', { paymentAmount: this.paymentAmount, depositAmount: this.depositAmount,
                basketId: this.dataForPup.basketId });
        };
        PriceRefresh.prototype.restoreSearch = function () {
            var _this = this;
            var popupType = this.modalService.get('popupType');
            if (popupType === 'PUP') {
                this.analytics.track('mixpanel', 'PUPNAVL Pop-up Interaction', { Type: popupType,
                    PUPAmount: this.dataForPup.pupAmount, CTA: 'Back to search' });
            }
            else {
                this.analytics.track('mixpanel', 'PUPNAVL Pop-up Interaction', { Type: popupType,
                    CTA: 'Back to search' });
            }
            this.savedSearchService.getSavedSearches().then(function (searches) {
                var mostRecent = _.head(searches);
                if (mostRecent == null && _this.$route.current) {
                    _this.$location.path("/" + _this.$route.current.area);
                }
                else {
                    if (mostRecent.Rooms) {
                        mostRecent.occupancyStr = _this.occupancyService.getOccupancyString(mostRecent.Rooms);
                    }
                    _this.$scope.$emit('block', {
                        title: null,
                        loadingScreenStyle: 'default-notFoundCtrl'
                    });
                    _this.savedSearchService.restoreSearch(mostRecent).then(function () {
                        _this.basketService.startWorkflow(_this.basketService.workflowType[mostRecent.SearchType]);
                    });
                }
            });
        };
        return PriceRefresh;
    }());
    angular
        .module('TR')
        .controller('PriceRefresh', PriceRefresh);
})(TR || (TR = {}));
/* tslint:disable:max-line-length */
var TR;
(function (TR) {
    var AmendBooking = /** @class */ (function () {
        function AmendBooking(booking, occupancyService) {
            var stay = _.get(booking, 'Itinerary.Stays[0]');
            var occupancy = occupancyService.serialise(stay.Rooms);
            this.hiddenQueryString =
                "dest=1-" + stay.Hotel.EstabId + "&startDate=" + stay.CheckIn + "&endDate=" + stay.CheckOut + "&occ=" + occupancy + "&currency=" + booking.Balance.ClientCurrencyCode;
            this.destinationName = _.get(stay, 'Hotel.Destinations[0].Title');
        }
        return AmendBooking;
    }());
    angular
        .module('TR')
        .controller('AmendBooking', AmendBooking);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var ProductType;
    (function (ProductType) {
        ProductType["Hotel"] = "Hotel";
        ProductType["Flight"] = "Flight";
        ProductType["Transfer"] = "Transfer";
    })(ProductType || (ProductType = {}));
    var Debug = /** @class */ (function () {
        function Debug(agentModeService, $scope, $q, $location, resourceService) {
            var _this = this;
            this.agentModeService = agentModeService;
            this.$scope = $scope;
            this.$q = $q;
            this.$location = $location;
            this.resourceService = resourceService;
            agentModeService.getAgentInformation().then(function () {
                _this.debugSettings = {
                    ShowNets: false,
                    DebugFlag: false,
                    RateMazeDebugFlag: false,
                    EnableSearchTracing: false,
                    AccomDebugFlag: false
                };
                $q.all([
                    agentModeService.getDebugSettings(),
                    agentModeService.getSuppliers()
                ]).then(function (_a) {
                    var debugSettings = _a[0], suppliers = _a[1];
                    _this.debugSettings = _.extend(_this.debugSettings, debugSettings);
                    _this.suppliers = suppliers;
                    _this.selectedAccomSupliers = _this.mapSelectedSuppliers(ProductType.Hotel);
                    _this.accomSuppliers = _this.getUnSelectedSupliers(ProductType.Hotel);
                    _this.selectedFlightSuppliers = _this.mapSelectedSuppliers(ProductType.Flight);
                    _this.flightSuppliers = _this.getUnSelectedSupliers(ProductType.Flight);
                    _this.selectedTransferSupliers = _this.mapSelectedSuppliers(ProductType.Transfer);
                    _this.transferSuppliers = _this.getUnSelectedSupliers(ProductType.Transfer);
                }, function () {
                    $scope.$broadcast('flash:error', resourceService.get('FAILEDGETTINGDEBUGSETTINGS'));
                });
            }, function () {
                $location.path('agents/signin').search({ Dest: TRPCONFIG.Domain.AgentLogonUrlDest });
            });
        }
        Debug.prototype.updateSettings = function () {
            var _this = this;
            this.debugSettings.SearchSupplierId = _.map(this.selectedAccomSupliers, function (s) { return s.Id; });
            this.debugSettings.SearchFlightSupplierIds = _.map(this.selectedFlightSuppliers, function (s) { return s.Id; });
            this.debugSettings.SearchTransferSupplierIds = _.map(this.selectedTransferSupliers, function (s) { return s.Id; });
            this.agentModeService.updateDebugSettings(this.debugSettings).then(function () {
                _this.$scope.$broadcast('flash:success', _this.resourceService.get('DEBUGSETTINGUPDATESUCCESS'));
            }, function () {
                _this.$scope.$broadcast('flash:error', _this.resourceService.get('DEBUGSETTINGUPDATEFAILURE'));
            });
        };
        ;
        Debug.prototype.supplierSelected = function (selected, productType) {
            var selectedSuppliers;
            var unSelectedSuppliers;
            if (productType === ProductType.Hotel) {
                selectedSuppliers = this.selectedAccomSupliers;
            }
            else if (productType === ProductType.Flight) {
                selectedSuppliers = this.selectedFlightSuppliers;
            }
            else if (productType === ProductType.Transfer) {
                selectedSuppliers = this.selectedTransferSupliers;
            }
            if (selected && !_.find(selectedSuppliers, function (s) { return s.Id === selected; })) {
                selectedSuppliers.push(selected);
                if (productType === ProductType.Hotel) {
                    this.accomSuppliers = this.getUnSelectedSupliers(productType);
                }
                else if (productType === ProductType.Flight) {
                    this.flightSuppliers = this.getUnSelectedSupliers(productType);
                }
                else if (productType === ProductType.Transfer) {
                    this.transferSuppliers = this.getUnSelectedSupliers(productType);
                }
            }
        };
        ;
        Debug.prototype.getUnSelectedSupliers = function (productType) {
            var selectedSuppliers;
            var suppliers;
            if (productType === ProductType.Hotel) {
                selectedSuppliers = this.selectedAccomSupliers;
                suppliers = this.suppliers.Hotel;
            }
            else if (productType === ProductType.Flight) {
                selectedSuppliers = this.selectedFlightSuppliers;
                suppliers = this.suppliers.Flight;
            }
            else if (productType === ProductType.Transfer) {
                selectedSuppliers = this.selectedTransferSupliers;
                suppliers = this.suppliers.Transfer;
            }
            return _.filter(suppliers, function (s) { return !_.find(selectedSuppliers, function (ss) { return ss.Id === s.Id; }); });
        };
        Debug.prototype.mapSelectedSuppliers = function (productType) {
            var ids;
            var suppliers;
            if (productType === ProductType.Hotel) {
                ids = this.debugSettings.SearchSupplierId;
                suppliers = this.suppliers.Hotel;
            }
            else if (productType === ProductType.Flight) {
                ids = this.debugSettings.SearchFlightSupplierIds;
                suppliers = this.suppliers.Flight;
            }
            else if (productType === ProductType.Transfer) {
                ids = this.debugSettings.SearchTransferSupplierIds;
                suppliers = this.suppliers.Transfer;
            }
            return _.map(ids, function (id) {
                return _.find(suppliers, function (s) { return s.Id === id; });
            });
        };
        Debug.prototype.removeSupplier = function (id, productType) {
            if (productType === ProductType.Hotel) {
                _.remove(this.selectedAccomSupliers, function (s) { return s.Id === id; });
                this.accomSuppliers = this.getUnSelectedSupliers(productType);
            }
            else if (productType === ProductType.Flight) {
                _.remove(this.selectedFlightSuppliers, function (s) { return s.Id === id; });
                this.flightSuppliers = this.getUnSelectedSupliers(productType);
            }
            else if (productType === ProductType.Transfer) {
                _.remove(this.selectedTransferSupliers, function (s) { return s.Id === id; });
                this.transferSuppliers = this.getUnSelectedSupliers(productType);
            }
        };
        return Debug;
    }());
    angular.module('TR').controller('Debug', Debug);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('SelectedFlight', SelectedFlight);
    function SelectedFlight($routeParams, $scope, basketService, urlStoreService, $location, resourceService, basketStore, broker, flightSearch, flightDetail, occupancyService, preferences, tripService, analytics, $window) {
        var sf = this;
        var stop = $scope.$watch(function () { return $window.abDeal173; }, function (v) {
            if (v) {
                sf.reloadingFlight = v;
                stop();
            }
        });
        if (!$routeParams.tripId) {
            return;
        }
        preferences.get('priceMode').then(function (p) {
            sf.priceMode = p;
        });
        sf.addingFlight = basketStore.addingFlight();
        sf.changeFlight = changeFlight;
        sf.keepFlight = keepFlight;
        sf.flightImage = flightImage;
        sf.noFlight = false;
        tripService.usePackageRates().then(function (packagePrice) {
            sf.detailOpen = (TRPCONFIG.Domain.isAgentMode && !TRPCONFIG.Domain.PriceBucketFilterEnabled)
                || TRPCONFIG.Domain.FlightDetailsExpanded
                || TRPCONFIG.Domain.BestFitFlightSelection
                || packagePrice;
            sf.isPackagePrice = packagePrice;
        });
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var FlightsRequest = trip.FlightsRequest;
            var SelectedFlight = FlightsRequest && FlightsRequest.SelectedFlight;
            var PriorityForPreSelection = SelectedFlight && SelectedFlight.PriorityForPreSelection;
            sf.priorityForPreSelection = PriorityForPreSelection;
            sf.isMultiDestHoliday = trip && trip.TripType === tripService.tripTypes.MultiDestHoliday;
            basketStore.totalCost(trip.BasketId).then(function (res) { return sf.totalCost = res; });
            if (sf.isMultiDestHoliday) {
                sf.detailOpen = true;
            }
            basketService.getFlight(trip.BasketId)
                .then(function (flight) {
                if (flight) {
                    sf.flight = flight.Details.Itinerary;
                    sf.flightRoutes = getFlightRoutes();
                    sf.flight.DepositAllowed = !_.isEmpty(flight.FuturePayments);
                    _flightCost(trip);
                    flightSearch.setBags(trip, sf.flight);
                    sf.oneWayOnly = sf.flight.Legs.length === 1;
                }
                else {
                    sf.noFlight = true;
                }
            });
            //we need to listen out for the flight to be ready here as well as requesting it directly because
            //it might be in the process of being added to the basket
            broker.subscribe('SelectedFlight', 'flightAddedToBasket', function (f) {
                sf.flight = f.data.Details.Itinerary;
                sf.flightRoutes = getFlightRoutes();
                _flightCost(trip);
                flightSearch.setBags(trip, sf.flight);
            });
            broker.subscribe('SelectedFlight', 'basketUpdated', _.debounce(function () {
                _flightCost(trip);
                flightSearch.setBags(trip, sf.flight);
            }, 100));
            broker.subscribe('SelectedFlight', 'priceModeChanged', function (ev) {
                sf.priceMode = ev.data;
            });
            $scope.$on('$destroy', function () {
                broker.unsubscribe('SelectedFlight');
            });
        });
        function getFlightRoutes() {
            var routes = [sf.flight.Legs[0].DepartureAirport.Code, sf.flight.Legs[0].ArrivalAirport.Code];
            if (TRPCONFIG.Rtl) {
                routes = _.reverse(routes);
            }
            return {
                Departure: routes[0],
                Arrival: routes[1]
            };
        }
        function changeFlight() {
            analytics.track('mixpanel', 'ChangeFlightClick');
            flightSearch.resetPageIndex();
            basketService.changeJourneyUrl(10);
            if (sf.isMultiDestHoliday) {
                $scope.$emit('block', {
                    title: resourceService.get('SEARCHINGFLIGHTS'),
                    subtitle: resourceService.get('THISMAYTAKE'),
                    loadingScreenStyle: 'default-searchUnitCtrl'
                });
            }
        }
        function keepFlight() {
            var opts = {
                bags: sf.flight.bags,
                maxbags: occupancyService.getNumberOfNonInfantPassengers() || 1
            };
            var previousURL = urlStoreService.getPreviousURL();
            var applicablePathRegEx = '(/|/holidays/|/hotels)(flights|hotels|options|book|([0-9a-fA-F-]+))/[0-9a-fA-F-]+';
            var cameFromWrongPath = urlStoreService.cameFromWrongPath(applicablePathRegEx);
            // if trip id for some reason was changes we should remove selected hotel and sand user to the usual flow
            if (urlStoreService.isTripIdChanged()) {
                cameFromWrongPath = true;
                sessionStorage.removeItem('preselectedHotelData');
            }
            // if user copied url from other browser previousURL will be empty and we need to handle this case
            // and we use selectFlight, it our default method
            if (!cameFromWrongPath) {
                if (previousURL === null) {
                    basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
                }
                else if (basketService.isFlightPreselected()) {
                    // we have the list of destination where flight preselected automatically and user have change flight page with keep flight button
                    // for this case we hawe _keepPreselectedFlight method which have additional check
                    _keepPreselectedFlight(opts, previousURL);
                }
                else if (TRPCONFIG.Domain2.ShowSelectedFlightV2) {
                    _keepManuallySelectedFlight(opts, previousURL);
                }
                else {
                    // just check if all expression was false we use default behaviour
                    basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
                }
            }
            else {
                basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
            }
        }
        function _keepPreselectedFlight(opts, previousURL) {
            var isHotelSelected = sessionStorage.getItem('preselectedHotelData') !== null;
            var preSelectedFlight = sessionStorage.getItem('storeSelectedFlight');
            var cameFromChooseRoomPage = previousURL.match('(holidays/)[0-9a-fA-F-]+(/)[0-9]+') !== null;
            preSelectedFlight = preSelectedFlight !== null ? JSON.parse(preSelectedFlight) : null;
            if (isHotelSelected && preSelectedFlight !== null && preSelectedFlight.FlightId === sf.flight.FlightId && cameFromChooseRoomPage) {
                basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
            }
            else {
                $location.path(previousURL);
            }
        }
        function _keepManuallySelectedFlight(opts, previousURL) {
            if (previousURL !== null) {
                $location.path(previousURL);
            }
            else {
                basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
            }
        }
        function flightImage(fallback) {
            if (!sf.flight) {
                return fallback + " ...";
            }
            var count = 0;
            var images = '';
            var img = '<img src="/build/img/Airline/Small/{0}" />';
            sf.flight.AirlineImages.forEach(function (i) {
                if (count < 3) {
                    images += String.format(img, i);
                    count++;
                }
            });
            return images;
        }
        function _flightCost(trip) {
            basketStore.flightCost(trip.BasketId).then(function (c) {
                var numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
                sf.totalFlightCost = c;
                sf.flightCostPerPerson = c / numPassengers;
                sf.addingFlight = false;
            });
            basketStore.totalCost(trip.BasketId).then(function (res) { return sf.totalCost = res; });
        }
        sf.toggleDetail = function () {
            sf.detailOpen = !sf.detailOpen;
        };
        sf.showDetails = function () {
            broker.publish('showModalFlightDetails', { flight: sf.flight });
        };
    }
})();
var TR;
(function (TR) {
    'use strict';
    var GroupBooking = /** @class */ (function () {
        function GroupBooking($q, $location, $http, $timeout, $scope, $rootScope, filtering, dateUtil, scrollService, funcUtil, resourceService) {
            this.$q = $q;
            this.$location = $location;
            this.$http = $http;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.filtering = filtering;
            this.dateUtil = dateUtil;
            this.scrollService = scrollService;
            this.funcUtil = funcUtil;
            this.resourceService = resourceService;
            this.model = {
                rooms: [this['newRoom']()],
                bookingType: 'holiday',
                passengerCount: {
                    Adults: 1,
                    Teenagers: 0,
                    Children: 0,
                    Infants: 0,
                },
                durationOfStay: 7,
            };
            this.departureDateMin = dateUtil.todayPlus(2);
            this.durationOfStayOptions = _.map(_.range(1, 41), function (i) { return ({
                value: i,
                text: i + ' ' + resourceService.get(i === 1 ? 'NIGHT' : 'NIGHTS')
            }); });
            this.bookingTypeOptions = [
                { text: 'Flights Only', value: 'flight' },
                { text: 'Hotel Only', value: 'hotel' },
                { text: 'Flights + Hotel', value: 'holiday' },
            ];
            this.boardBasisOptions = [
                'Room Only', 'Bed & Breakfast', 'Half Board', 'Full Board', 'All Inclusive', 'Self Catering'
            ];
            this.roomTypeOptions = [
                'Single', 'Twin', 'Double', 'Triple', 'Studio', '1 Bedroom Apartment', '2 Bedroom Apartment'
            ];
            this.roomAdultsCountOptions = _.range(1, 7);
            this.roomChildrenCountOptions = _.range(0, 6);
            this.passengerCountAdultsOptions = _.range(1, 100);
            this.passengerCountChildrenOptions = _.range(0, 100);
            this.transferTypeOptions = ['Shuttle', 'Minibus', 'Taxis'];
            /*
            $http.get('https://pp2.travelrepublic.co.uk/services/autocompleter.svc/GetHotelDestinations', {
                params: {
                    localeId: 10,
                    term: 'tenerife',
                    maximumStringDistance: 4,
                    maximumResults: 15,
                    _: new Date().getTime(),
                }
            }).then(response => {
                console.log('response', response);
            });
            {
              "s": true,
              "c": 15,
              "d": [
                {
                  "t": "Tenerife, Spain",
                  "v": { "c": 3522, "p": 54875, "l": 0, "pl": 0, "e": 0, "n": 571, "po": 0 }
                },
                {
                  "t": "Puerto de la Cruz, Tenerife, Spain",
                  "v": { "c": 3522, "p": 54875, "l": 219233, "pl": 0, "e": 0, "n": 87, "po": 0 }
                },
              ]
            }
            */
        }
        GroupBooking.prototype.newRoom = function () {
            return {
                roomType: 'Double',
                adults: 2,
                children: 0,
            };
        };
        GroupBooking.prototype.isOccupancyValid = function () {
            if (this.model.bookingType === 'hotel' || this.model.bookingType === 'holiday') {
                if (this.model.rooms.length > 3) {
                    return true;
                }
            }
            if (this.model.bookingType === 'flight' || this.model.bookingType === 'holiday') {
                var pax = this.model.passengerCount.Adults + this.model.passengerCount.Teenagers +
                    this.model.passengerCount.Children + this.model.passengerCount.Infants;
                if (pax > 12) {
                    return true;
                }
            }
            return false;
        };
        GroupBooking.prototype.onSubmit = function (form) {
            if (form.$valid) {
                var request_1 = angular.copy(this.model);
                request_1.bookingType = _.find(this.bookingTypeOptions, function (o) { return o.value === request_1.bookingType; }).text;
                this['apiRequest'] = request_1;
            }
        };
        return GroupBooking;
    }());
    if (TRPCONFIG.Domain.GroupBookingPageEnabled) {
        angular
            .module('TR')
            .controller('groupBooking', GroupBooking);
    }
})(TR || (TR = {}));
var TR;
(function (TR) {
    'use strict';
    var SpecialAssistance = /** @class */ (function () {
        function SpecialAssistance($q, $location, $http, $timeout, $scope, $rootScope, filtering, dateUtil, scrollService, funcUtil, resourceService) {
            this.$q = $q;
            this.$location = $location;
            this.$http = $http;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.filtering = filtering;
            this.dateUtil = dateUtil;
            this.scrollService = scrollService;
            this.funcUtil = funcUtil;
            this.resourceService = resourceService;
            this.model = {
                rooms: [this['newRoom']()],
                bookingType: 'holiday',
                passengerCount: {
                    Adults: 1,
                    Teenagers: 0,
                    Children: 0,
                    Infants: 0,
                },
                durationOfStay: 7,
                isTakingWheelchair: 'No',
                typeOfAssistance: 'N/A',
            };
            this.departureDateMin = dateUtil.todayPlus(2);
            this.durationOfStayOptions = _.map(_.range(1, 41), function (i) { return ({
                value: i,
                text: i + ' ' + resourceService.get(i === 1 ? 'NIGHT' : 'NIGHTS')
            }); });
            this.bookingTypeOptions = [
                { text: 'Flights Only', value: 'flight' },
                { text: 'Hotel Only', value: 'hotel' },
                { text: 'Flights + Hotel', value: 'holiday' },
            ];
            this.boardBasisOptions = [
                'Room Only', 'Bed & Breakfast', 'Half Board', 'Full Board', 'All Inclusive', 'Self Catering'
            ];
            this.roomTypeOptions = [
                'Single', 'Twin', 'Double', 'Triple', 'Studio', '1 Bedroom Apartment', '2 Bedroom Apartment'
            ];
            this.roomAdultsCountOptions = _.range(1, 7);
            this.roomChildrenCountOptions = _.range(0, 6);
            this.passengerCountAdultsOptions = _.range(1, 100);
            this.passengerCountChildrenOptions = _.range(0, 100);
            this.transferTypeOptions = ['Shuttle', 'Minibus', 'Taxis'];
            this.isTakingWheelchairOptions = ['Yes', 'No'];
            this.typeOfAssistanceOptions = [
                'N/A', 'Check In To Gate', 'Check In To Gate & Stairs', 'Check In To Seat'
            ];
        }
        SpecialAssistance.prototype.newRoom = function () {
            return {
                roomType: 'Double',
                adults: 2,
                children: 0,
            };
        };
        SpecialAssistance.prototype.isOccupancyValid = function () {
            if (this.model.bookingType === 'hotel' || this.model.bookingType === 'holiday') {
                if (this.model.rooms.length > 3) {
                    return true;
                }
            }
            if (this.model.bookingType === 'flight' || this.model.bookingType === 'holiday') {
                var pax = this.model.passengerCount.Adults + this.model.passengerCount.Teenagers +
                    this.model.passengerCount.Children + this.model.passengerCount.Infants;
                if (pax > 12) {
                    return true;
                }
            }
            return false;
        };
        SpecialAssistance.prototype.onSubmit = function (form) {
            if (form.$valid) {
                var request_2 = angular.copy(this.model);
                request_2.bookingType = _.find(this.bookingTypeOptions, function (o) { return o.value === request_2.bookingType; }).text;
                this['apiRequest'] = request_2;
            }
        };
        return SpecialAssistance;
    }());
    angular
        .module('TR')
        .controller('specialAssistance', SpecialAssistance);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var startDateInitialised = TRPCONFIG.Domain.DeviceType !== 'Mobile';
    var LastMinuteDeals = /** @class */ (function () {
        function LastMinuteDeals($q, $location, $timeout, $scope, $rootScope, $route, tripService, filtering, pageStrand, analytics, broker, holidayDeals, holidayDealsGrouped, holidayDealsPromoService, hotelFromSession, dateUtil, dealsBoxService, occupancyService, searchUnitService, scrollService, funcUtil, resourceService, destinationService) {
            var _this = this;
            this.$q = $q;
            this.$location = $location;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$route = $route;
            this.tripService = tripService;
            this.filtering = filtering;
            this.pageStrand = pageStrand;
            this.analytics = analytics;
            this.broker = broker;
            this.holidayDeals = holidayDeals;
            this.holidayDealsGrouped = holidayDealsGrouped;
            this.holidayDealsPromoService = holidayDealsPromoService;
            this.hotelFromSession = hotelFromSession;
            this.dateUtil = dateUtil;
            this.dealsBoxService = dealsBoxService;
            this.occupancyService = occupancyService;
            this.searchUnitService = searchUnitService;
            this.scrollService = scrollService;
            this.funcUtil = funcUtil;
            this.resourceService = resourceService;
            this.destinationService = destinationService;
            this.isLoading = true;
            this.hasDeals = false;
            this.hasSpecialDeals = false;
            this.counter = 0;
            this.priceMode = 0;
            this.showDiscount = false;
            $scope.navigatorUserAgent = '|' + navigator.userAgent + '|' + /prerender/i.test(navigator.userAgent) + '|';
            this.watchForPageRedirection();
            if (!startDateInitialised) {
                var startDate = this.dateUtil.getNextSaturday(TRPCONFIG.Domain.HolidayDealsDefaultWeeks);
                searchUnitService.startDate(1, startDate);
                startDateInitialised = true;
            }
            this.config = (function () {
                var configs = {
                    Default: {
                        findOptionsPageSize: 32,
                        smallBatchTake: 12,
                        halfBatchTake: 4,
                        halfBatchChunkSize: 4,
                        slidesToScroll: 4,
                        slidesToShow: 4
                    },
                    Phone: {
                        findOptionsPageSize: 16,
                        smallBatchTake: 4,
                        halfBatchTake: 8,
                        halfBatchChunkSize: 1,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    },
                    Tablet: {
                        findOptionsPageSize: 24,
                        smallBatchTake: 6,
                        halfBatchChunkSize: 3
                    }
                };
                _.merge(configs, TRPCONFIG.Domain.LastMinuteDealsConfig);
                return _.merge(configs.Default, configs[TRPCONFIG.DeviceCategory]);
            })();
            this.broker.subscribe('lastMinuteDealsCtrl', 'priceModeChanged', function (eventData) { return _this.priceMode = eventData.data; });
            this.$scope.$on('$destroy', function () { return _this.broker.unsubscribe('lastMinuteDealsCtrl'); });
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-lastMinuteDeals'
            });
            this.unblockOnce = _.once(function () { return _this.$scope.$emit('unblock'); });
            this.$rootScope.hideFooterToolbar = true;
            this.prepopulateForm();
            this.$q.when(TRPCONFIG.Domain.LastMinuteDealsDestinations)
                .then(function (config) { return _this.destinations =
                _(config.split('|'))
                    .map(function (d) { return d.split('-'); })
                    .map(function (_a) {
                    var Type = _a[0], Id = _a[1], Title = _a[2];
                    return ({
                        Title: Title,
                        Type: parseInt(Type, 10),
                        Id: parseInt(Id, 10),
                        TypeId: Type + "-" + Id,
                    });
                })
                    .value(); })
                .then(function () {
                var foundDestination;
                var searchDestination = _.get(_this.$location.search(), 'destination');
                var specialDeals = _.get(_this.$location.search(), 'specialDeals');
                if (searchDestination) {
                    foundDestination = _.find(_this.destinations, function (d) { return d.TypeId === searchDestination; });
                    if (foundDestination) {
                        _this.setFocusedDestination(foundDestination);
                    }
                }
                var LandingDestination = specialDeals ?
                    '45Star' :
                    foundDestination ?
                        foundDestination.Title :
                        'all';
                _this.analytics.track('mixpanel', 'WasNowLanding', { LandingDestination: LandingDestination });
            })
                .then(function () {
                if (TRPCONFIG.Domain.DeviceType === 'Mobile') {
                    _this.$scope.$watch(function () { return angular.toJson({
                        StartDate: _this.searchUnitService.startDate(1),
                        Duration: _this.searchUnitService.duration(1),
                        Flexibility: _this.searchUnitService.dealsFlexibility,
                    }); }, function () { return _this.loadAllDeals(); });
                }
                _this.$scope.$on('$routeUpdate', function () { return _this.loadAllDeals(); });
                _this.loadAllDeals();
            });
            this.seoLinks = this.parseSeoLinks();
            this.$scope.$watch(function () { return _this.$location.search().destination; }, function (value) {
                if (value === undefined) {
                    _this.setFocusedDestination(undefined);
                }
            });
            this.$scope.$watch(function () { return _this.$location.search().specialDeals; }, function (value) { return _this.setFocusedSpecialDeals(value); });
            /* UI-4273: Deals - % Discount Merchandising - A/B Test */
            this.broker.subscribe('LastMinuteDeals', 'HolidayDealDiscountPercentage', function () {
                _this.$scope.$apply(function () {
                    _this.showDiscount = true;
                });
            });
        }
        LastMinuteDeals.prototype.activeDestinations = function () {
            return this.focusedDestination ? [this.focusedDestination] : this.destinations;
        };
        LastMinuteDeals.prototype.loadAllDeals = function () {
            var _this = this;
            var specialDealStarLimit = 4;
            var counter = ++this.counter;
            var activeDestinations = this.activeDestinations();
            _.each(this.destinations, function (d) { return delete d.deals; });
            this.$timeout(function () {
                _this.isLoading = true;
                _this.hasDeals = false;
                _this.hasSpecialDeals = false;
                _this.funcUtil
                    .waitForValue(function () { return _this.tryGetOptions(); })
                    .then(function (options) { return _this.holidayDealsGrouped.find(options); })
                    .then(function (response) {
                    if (counter === _this.counter) {
                        _this.destinationsWithDeals = [];
                        var specialDealsFilter_1 = [];
                        _.each(response, function (deals, key) {
                            specialDealsFilter_1.push(_.filter(deals, function (deal) { return deal.StarRatingV2 >= specialDealStarLimit; }));
                            var typeId = (key + '').replace('|', '-');
                            _this.destinationsWithDeals.push(_.find(_this.destinations, function (d) { return d.TypeId === typeId; }));
                            var match = _.find(activeDestinations, function (d) { return d.TypeId === typeId; });
                            if (match && deals && deals.length) {
                                _this.hasDeals = true;
                                var pageStrand = _this.pageStrand.fromRoute();
                                if (!TRPCONFIG.Domain.CultureCode.includes('en')) {
                                    _this.destinationService
                                        .getDestinationInfo(match.Id, match.Type, pageStrand)
                                        .then(function (destinationDetail) {
                                        if (destinationDetail) {
                                            match.Title = destinationDetail.Title;
                                        }
                                    });
                                }
                                match.deals = _this.mapDealsToChunks(deals);
                            }
                        });
                        _this.specialDeals = _this.makeDealChunksFromDeals(_.slice(_.sortBy(_.flatten(specialDealsFilter_1), 'MinPricePerson'), 0, _this.config.findOptionsPageSize));
                        _this.hasSpecialDeals = !!_this.specialDeals;
                        _this.isLoading = false;
                        _this.unblockOnce();
                    }
                });
            });
        };
        LastMinuteDeals.prototype.tryGetOptions = function () {
            var options;
            if (TRPCONFIG.Domain.DeviceType === 'Mobile') {
                options = {
                    startDate: this.dateUtil.parseDate(this.searchUnitService.startDate(1)),
                    duration: this.searchUnitService.duration(1),
                    occupancy: this.occupancyService.getOccupancy(),
                    depAir: this.searchUnitService.getDepartureAirports(),
                    flexibility: this.searchUnitService.dealsFlexibility,
                };
            }
            else {
                var params = this.holidayDeals.deserialiseParameters();
                options = {
                    startDate: params.startDate,
                    duration: params.duration,
                    occupancy: params.occupancy,
                    depAir: params.depAir,
                };
            }
            if (!options.startDate || !options.duration
                || !options.occupancy || !options.occupancy[0]
                || !options.depAir || !options.depAir[0]) {
                return undefined;
            }
            options.destinations = this.destinations;
            options.dealsPerDestination = this.config.findOptionsPageSize;
            return options;
        };
        LastMinuteDeals.prototype.makeDealChunksFromDeals = function (deals) {
            if (deals && deals[0]) {
                var chunks = _.chunk(deals, this.config.halfBatchChunkSize);
                return {
                    SmallBatch: [_.take(deals, this.config.smallBatchTake)],
                    FirstHalfBatch: _.take(chunks, this.config.halfBatchTake),
                    SecondHalfBatch: _.slice(chunks, this.config.halfBatchTake)
                };
            }
        };
        LastMinuteDeals.prototype.mapDealsToChunks = function (deals) {
            if (deals && deals[0]) {
                _.forEach(deals, function (deal, index) {
                    deal.ImageUrl = deal.CroppedImage;
                    deal.DisplayIndex = index;
                });
                return this.makeDealChunksFromDeals(deals);
            }
        };
        LastMinuteDeals.prototype.dropdownDestinations = function () {
            var _this = this;
            var focusedTypeId = _.get(this, 'focusedDestination.TypeId');
            return _.filter(this.destinations, function (d) {
                return d.TypeId === focusedTypeId || _.find(_this.destinationsWithDeals, function (x) { return x === d; });
            });
        };
        LastMinuteDeals.prototype.prepopulateForm = function () {
            var startDate = this.searchUnitService.startDate(1);
            var minDate = this.dateUtil.todayPlus(3);
            if (!startDate || startDate < minDate) {
                this.searchUnitService.startDate(1, minDate);
            }
            var duration = this.searchUnitService.duration(1);
            /* tslint:disable */
            var isValid = _.some(TRPCONFIG.Domain.HolidayDealsDurations, function (d) { return d == duration; });
            /* tslint:enable */
            if (!isValid) {
                this.searchUnitService.duration(1, TRPCONFIG.Domain.HolidayDealsDefaultDuration);
            }
        };
        LastMinuteDeals.prototype.setFocusedDestination = function (destination) {
            if (destination) {
                this.showMore = false;
                this.focusedDestination = destination;
                this.focusedSpecialDeals = false;
                this.$location
                    .search('destination', destination.TypeId)
                    .search('specialDeals', null)
                    .replace();
            }
            else {
                delete this.focusedDestination;
                this.$location
                    .search('destination', null)
                    .replace();
            }
            this.scrollService.scrollTo('top');
        };
        LastMinuteDeals.prototype.setFocusedSpecialDeals = function (specialDeals) {
            if (specialDeals) {
                this.showMore = false;
                this.$location
                    .search('specialDeals', 1)
                    .search('destination', null)
                    .replace();
            }
            else {
                this.$location
                    .search('specialDeals', null)
                    .replace();
            }
            this.focusedSpecialDeals = specialDeals;
            this.scrollService.scrollTo('top');
        };
        LastMinuteDeals.prototype.goToDeal = function (deal, DealCategory) {
            var _this = this;
            this.analytics.track('mixpanel', 'WasNowCardClick', {
                CardDestination: deal.Country + ", " + deal.Province,
                CardRank: deal.DisplayIndex + 1,
                EstabId: deal.Id,
                OverlayShown: this.showDiscount,
                OverlayValue: deal.DiscountPercentage + "%",
                DealCategory: DealCategory
            });
            var occupancy = this.occupancyService.parseOccupancyString(this.$location.search().occ);
            var selected = deal.HolidayDeals[0];
            var estabId = deal.Id;
            this.$scope.$emit('block', {
                title: this.resourceService.get('LOADINGHOTELS'),
                subtitle: this.resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-lastMinuteDeals-select'
            });
            this.tripService
                .getTripIdForHolidayDeal(selected, occupancy)
                .then(function (tripId) { return _this.$location.path("/holidays/" + tripId + "/" + estabId); });
        };
        LastMinuteDeals.prototype.showMoreClick = function (ShowMoreDestination) {
            this.showMore = true;
            this.analytics.track('mixpanel', 'WasNowShowMore', { ShowMoreDestination: ShowMoreDestination });
        };
        LastMinuteDeals.prototype.watchForPageRedirection = function () {
            var _this = this;
            //This function protects against a bug which happens when clicking on a link in the menu.
            //e.g. <a href="holidaydeals?destination=3-54859">
            //When this happens the page must reload and start fresh.
            var wasPopulated = false;
            this.$scope.$watch(function () { return Object.keys(_this.$location.search()).length > 2; }, function (isPopulated) {
                if (wasPopulated && !isPopulated) {
                    _this.$route.reload();
                }
                wasPopulated = wasPopulated || isPopulated;
            });
        };
        LastMinuteDeals.prototype.parseSeoLinks = function () {
            var seoLinks = "Last Minute,holidays/last-minute|\nCity Breaks,holidays/city-breaks|Adults Only,holidays/adults|\nSelf Catering,holidays/self-catering|Spa Breaks,spa-breaks|Family,holidays/family|Couples,holidays/couples|\nRomantic Breaks,romantic-breaks|Ski,holidays/ski|Beach,holidays/beach|Winter Sun,holidays/winter-sun|\nSummer,holidays/summer|Waterparks,holidays/family/waterparks"
                .replace(/\r?\n/g, '')
                .split('|');
            return _(seoLinks)
                .map(function (x) { return x.split(','); })
                .map(function (x) { return ({ text: x[0], href: x[1] }); })
                .value();
        };
        return LastMinuteDeals;
    }());
    angular
        .module('TR')
        .controller('lastMinuteDeals', LastMinuteDeals);
})(TR || (TR = {}));
var TR;
(function (TR) {
    var startDateInitialised = TRPCONFIG.Domain.DeviceType !== 'Mobile';
    var SeasonalDeals = /** @class */ (function () {
        function SeasonalDeals($q, $location, $timeout, $scope, $rootScope, $route, $http, tripService, filtering, preferences, pageStrand, analytics, broker, holidayDeals, holidayDealsGrouped, holidayDealsPromoService, hotelFromSession, geo, dateUtil, dealsBoxService, occupancyService, searchUnitService, scrollService, funcUtil, resourceService, destinationService) {
            var _this = this;
            this.$q = $q;
            this.$location = $location;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$route = $route;
            this.$http = $http;
            this.tripService = tripService;
            this.filtering = filtering;
            this.preferences = preferences;
            this.pageStrand = pageStrand;
            this.analytics = analytics;
            this.broker = broker;
            this.holidayDeals = holidayDeals;
            this.holidayDealsGrouped = holidayDealsGrouped;
            this.holidayDealsPromoService = holidayDealsPromoService;
            this.hotelFromSession = hotelFromSession;
            this.geo = geo;
            this.dateUtil = dateUtil;
            this.dealsBoxService = dealsBoxService;
            this.occupancyService = occupancyService;
            this.searchUnitService = searchUnitService;
            this.scrollService = scrollService;
            this.funcUtil = funcUtil;
            this.resourceService = resourceService;
            this.destinationService = destinationService;
            this.isLoading = true;
            this.hasDeals = false;
            this.hasSpecialDeals = false;
            this.counter = 0;
            this.priceMode = 0;
            this.showDiscount = TRPCONFIG.Domain.SeasonalDeals && TRPCONFIG.Domain.SeasonalDeals.isPillVisible;
            this.isAprilCampaign = TRPCONFIG.Domain.AprilCampaignRoutes.indexOf(this.$location.path().substr(1)) > -1;
            this.dealConfigs = _.find(TRPCONFIG.Domain.ActiveSeasonalDeals, function (d) { return d.Url === $location.path(); });
            TRPCONFIG.Domain.FlightDetailsExpanded = true;
            if (this.isAprilCampaign) {
                this.dealConfigs = _.find(TRPCONFIG.Domain.ActiveSeasonalDeals, function (d) { return d.Url === '/aprilcampaign'; });
                this.aprilCampaignConfig = TRPCONFIG.Domain.AprilCampaignRoutesConfig[$location.path().substr(1)];
                this.dealConfigs.DealType = this.aprilCampaignConfig.dealType;
            }
            preferences.set('priceMode', 0);
            $scope.navigatorUserAgent = '|' + navigator.userAgent + '|' + /prerender/i.test(navigator.userAgent) + '|';
            this.watchForPageRedirection();
            analytics.track('mixpanel', 'SeasonalDealsPageView', {
                Name: this.dealConfigs && this.dealConfigs.Name
            });
            if (!startDateInitialised) {
                var startDate = this.dateUtil.getNextSaturday(TRPCONFIG.Domain.HolidayDealsDefaultWeeks);
                searchUnitService.startDate(1, startDate);
                startDateInitialised = true;
            }
            this.config = (function () {
                var configs = {
                    Default: {
                        findOptionsPageSize: 32,
                        smallBatchTake: 12,
                        halfBatchTake: 4,
                        halfBatchChunkSize: 4,
                        slidesToScroll: 4,
                        slidesToShow: 4
                    },
                    Phone: {
                        findOptionsPageSize: 16,
                        smallBatchTake: 4,
                        halfBatchTake: 8,
                        halfBatchChunkSize: 1,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    },
                    Tablet: {
                        findOptionsPageSize: 24,
                        smallBatchTake: 6,
                        halfBatchChunkSize: 3
                    }
                };
                _.merge(configs, TRPCONFIG.Domain.LastMinuteDealsConfig);
                return _.merge(configs.Default, configs[TRPCONFIG.DeviceCategory]);
            })();
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-lastMinuteDeals'
            });
            this.unblockOnce = _.once(function () { return _this.$scope.$emit('unblock'); });
            this.$rootScope.hideFooterToolbar = true;
            this.geo.getNearestAirports()
                .then(function (airposts) { return _this.$http.post(TRPCONFIG.Domain.SeasonalDealApiUrl, {
                //'/api/deals/seasonal'
                //http://pp.hotelsapi2.services.travelrepublic.local/api/deals/topdeals
                DealType: _this.dealConfigs.DealType,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DepartureAirports: _.map(airposts, function (a) { return a.Code; }),
                DealsPerDestination: 8,
                FieldFlags: 2166987,
            }); })
                .then(function (_a) {
                var data = _a.data;
                return data;
            })
                .then(function (destinations) {
                _this.destinations = _(destinations)
                    .map(function (d) {
                    var a = _.take(d.Hotels, 8);
                    _.forEach(a, function (a) { return _this.holidayDeals.enrichHotel(a, { Duration: 7 }); });
                    var b = [];
                    if (TRPCONFIG.DeviceCategory !== 'Phone') {
                        b = a.splice(4);
                    }
                    return {
                        Title: d.Destination.Title,
                        chunks: [a, b],
                    };
                })
                    .value();
                _this.unblockOnce();
                _this.hasDeals = !!_.find(_this.destinations, function (d) { return _.get(d, 'chunks[0].length'); });
                _this.isLoading = false;
            });
        }
        SeasonalDeals.prototype.goToDeal = function (deal, DealCategory) {
            var _this = this;
            this.analytics.track('mixpanel', 'SeasonalDealsCardClick', {
                CardDestination: deal.Country + ", " + deal.Province,
                CardRank: deal.DisplayIndex + 1,
                EstabId: deal.Id,
                OverlayShown: this.showDiscount,
                OverlayValue: deal.DiscountPercentage + "%",
                DealCategory: DealCategory,
                Name: this.dealConfigs && this.dealConfigs.Name
            });
            var occupancy = { Adults: 2, ChildAges: [] };
            var selected = deal.HolidayDeals[0];
            selected.HotelDeal.EstabId = deal.Id;
            this.$scope.$emit('block', {
                title: this.resourceService.get('LOADINGHOTELS'),
                subtitle: this.resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-seasonalDeals-select'
            });
            this.tripService
                .getTripIdForHolidayDeal(selected, occupancy)
                .then(function (tripId) {
                _this.$location.path("/holidays/hotels/" + tripId);
                _this.$location.search('bfd', deal.Id);
            });
        };
        SeasonalDeals.prototype.showMoreClick = function (ShowMoreDestination) {
            this.showMore = true;
            this.analytics.track('mixpanel', 'WasNowShowMore', { ShowMoreDestination: ShowMoreDestination });
        };
        SeasonalDeals.prototype.watchForPageRedirection = function () {
            var _this = this;
            //This function protects against a bug which happens when clicking on a link in the menu.
            //e.g. <a href="holidaydeals?destination=3-54859">
            //When this happens the page must reload and start fresh.
            var wasPopulated = false;
            this.$scope.$watch(function () { return Object.keys(_this.$location.search()).length > 2; }, function (isPopulated) {
                if (wasPopulated && !isPopulated) {
                    _this.$route.reload();
                }
                wasPopulated = wasPopulated || isPopulated;
            });
        };
        return SeasonalDeals;
    }());
    angular
        .module('TR')
        .controller('seasonalDeals', SeasonalDeals);
})(TR || (TR = {}));
(function () {
    'use strict';
    angular.module('TR')
        .controller('Departure', Departure);
    function Departure($scope, searchUnitService, $window) {
        var cm = this;
        cm.loading = true;
        cm.setDepartureAirport = setDepartureAirport;
        searchUnitService.getAvailableDepartureAirports()
            .then(function (airports) {
            cm.departureAirports = airports;
            cm.loading = false;
        }, function (msg) {
            $scope.$emit('flash:error', msg);
        });
        function setDepartureAirport(a) {
            a.clicked = true;
            searchUnitService.setDepartureAirports(a);
            a.clicked = false;
            setTimeout(function () {
                $window.history.back();
            }, 0);
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HolidaySearch', HolidaySearch);
    function HolidaySearch(broker, $route, $scope, $window, flightSearch, $routeParams, searchUnitService, resourceService, basketService, basketStore, bd4travel, $timeout, tripService, loggingService, dateUtil, occupancyService, locationService, flightsFilterService, analytics, $compile, confirmPopupService, $filter) {
        var cm = this;
        var tripId = $routeParams.tripId;
        var rangeFilters = ['PriceRange', 'OutboundTakeOffRange', 'ReturnTakeOffRange'];
        var searching = true;
        var routeSummaryUpToDate = false;
        var queryParams = {};
        cm.startAgainHolidayUrl = 'holidays';
        $scope.$on('$routeChangeSuccess', function (prev, next, current) {
            if (current === void 0) { current = {}; }
            var params = current.params;
            queryParams = __assign({}, params);
            var fid = queryParams.fid;
            cm.startAgainHolidayUrl = (fid) ? "holidays?fid=" + fid : 'holidays';
        });
        cm.basePrice = 0;
        cm.bags = 0;
        cm.filter = flightSearch.getFilter();
        cm.setTab = setTab;
        cm.filterTab = filterTab;
        cm.listTab = listTab;
        cm.more = more;
        cm.selectFlight = selectFlight;
        cm.showSpinner = showSpinner;
        cm.sortTab = sortTab;
        cm.tab = 'list';
        cm.translateStop = translateStop;
        updateOccupancy();
        cm.isPackagePrice = TRPCONFIG.Domain.PackagePrice && _.get($route, 'current.area') === 'holidays';
        cm.staticFlightsHero = _.get($route, 'current.area') === 'flights';
        cm.filterAllButtonEnabled = TRPCONFIG.Domain.FilterAllButtonEnabled;
        cm.showDetails = showDetails;
        cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax;
        // Desktop
        // for responsive filter panel
        cm.openSlideFilter = openSlideFilter;
        cm.showSlideFilter = false;
        cm.showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
        cm.toggleSearchUnit = toggleSearchUnit;
        cm.updating = false;
        cm.isHotelFirstJourney = basketService.isFlightPreselected();
        cm.showSelectedFlightV2 = TRPCONFIG.Domain2.ShowSelectedFlightV2;
        // DesktopEnd
        cm.showFilterOption = function (aggregate) {
            return !aggregate || Object.keys(aggregate).length > 0;
        };
        scrollTo(0, 0);
        _block();
        broker.subscribe('HolidaySearchCtrl', 'flightResultsModified', function (ev) {
            _modifyResults(ev.data);
        });
        broker.subscribe('HolidaySearchCtrl', 'newSearchTriggered', function () {
            cm.bags = 0;
            cm.currentFlight = null;
            cm.currentFlightRequestedDates = null;
            routeSummaryUpToDate = false;
        });
        broker.subscribe('HolidaySearchCtrl', 'searchCriteriaModified', function () {
            cm.updating = true;
        });
        broker.subscribe('HolidaySearchCtrl', 'flightNotAvailable', function () { return cm.flightUnavailable = true; });
        //nothing can happen unless we can decipher the tripId
        tripService.getTrip(tripId)
            .then(function (trip) {
            var _a = (trip || {}).FlightsRequest, FlightsRequest = _a === void 0 ? {} : _a;
            var selectedFlightExists = FlightsRequest && FlightsRequest.SelectedFlight;
            cm.selectedFlightAvailable = selectedFlightExists && selectedFlightExists.FlightId;
            function loggingError(message) {
                loggingService.logError("HolidaySearch: tripId:" + tripId + " returned a " + message);
                _unblock();
                locationService.home();
            }
            if (trip == null) {
                return loggingError('null trip');
            }
            if (trip.FlightsRequest == null) {
                return loggingError("trip with a null FlightsRequest: " + JSON.stringify(trip));
            }
            var FlexibleTripType = trip.FlexibleTripType, TripType = trip.TripType;
            var isHolidayAreaInner = _.get($route, 'current.area') === 'holidays';
            var isHolidayType = TripType === tripService.tripTypes.Holiday;
            var departureDate = trip.FlightsRequest.DepartureDate;
            var returnDate = trip.FlightsRequest.ReturnDate;
            var searchId = trip.FlightsRequest.AvailabilitySearchId;
            var basketId = trip.BasketId;
            cm.tripType = TripType;
            cm.showAtolProtection = isHolidayType && isHolidayAreaInner && !FlexibleTripType;
            cm.sortCriteria = flightSearch.getSortCriteria(trip.FlightsRequest.OneWayOnly);
            cm.oneWayOnly = trip.FlightsRequest.OneWayOnly;
            if (trip.FlightsRequest.SelectedFlight) {
                cm.bags = trip.FlightsRequest.SelectedFlight.BaggageCount;
                cm.flightUnavailable = trip.FlightsRequest.SelectedFlight.Unavailable;
            }
            cm.next = function () {
                cm.busy = true;
                flightSearch.nextPage()
                    .then(_setResults);
            };
            cm.applyFilters = flightSearch.filter;
            cm.applySort = function () {
                flightSearch.sort(cm.req.SortCriterion);
            };
            cm.removeArrayFilter = function (filter, ap) {
                flightSearch.removeArrayFilter(filter, ap);
            };
            cm.resetBooleanFilter = function (filter) {
                flightSearch.resetBooleanFilter(filter);
            };
            cm.resetRangeFilter = function (filter, minmax) {
                flightSearch.resetRangeFilter(filter, minmax);
            };
            cm.resetFilters = function () {
                flightSearch.resetFilters();
            };
            tripService.usePackageRates().then(function (packagePrice) {
                cm.isPackagePrice = packagePrice || cm.isHotelFirstJourney;
                cm.bestFlight = TRPCONFIG.Domain.BestFitFlightSelection || packagePrice;
                if (cm.bestFlight) {
                    _unblock();
                    if (trip.FlightsRequest.SelectedFlight) {
                        cm.basePrice = trip.FlightsRequest.SelectedFlight.LeadAdultPrice + trip.FlightsRequest.SelectedFlight.LeadAdultTax;
                        cm.basePriceReady = true;
                    }
                }
            });
            basketService.getFlight(basketId)
                .then(function (flight) {
                if (flight && trip.FlightsRequest.SelectedFlight) {
                    var numBags = cm.bags;
                    flight.Details.Itinerary.FlightId = trip.FlightsRequest.SelectedFlight.FlightId;
                    flight.Details.Itinerary.LeadAdultPrice = trip.FlightsRequest.SelectedFlight.LeadAdultPrice;
                    flight.Details.Itinerary.LeadAdultTax = trip.FlightsRequest.SelectedFlight.LeadAdultTax;
                    flight.Details.Itinerary.LeadBaggagePrice = trip.FlightsRequest.SelectedFlight.LeadBaggagePrice;
                    flight.Details.Itinerary.AllBagsOrNone = trip.FlightsRequest.SelectedFlight.AllBagsOrNone;
                    flight.Details.Itinerary.PriorityForPreSelection = trip.FlightsRequest.SelectedFlight.PriorityForPreSelection;
                    //flight.Details.Itinerary.PriorityForPreSelection = false;
                    if (flight.Details.Itinerary.LeadBaggagePrice === 0 || (flight.Details.AllBagsOrNone && cm.bags > 0)) {
                        numBags = cm.nonInfantPassengers;
                    }
                    flight.Details.Itinerary.bags = numBags;
                    // This is a terrible hack to make the select flight work with the razor partial
                    cm.currentFlight = [flight.Details.Itinerary];
                    cm.currentFlightRequestedDates = _matchesRequestedDates(flight.Details.Itinerary, departureDate, returnDate);
                }
                return flightSearch.getSearchResults(searchId, $routeParams.tripId, _.get(trip, 'FlightsRequest.SelectedFlight.FlightId'));
            }, function () { return flightSearch.getSearchResults(searchId, $routeParams.tripId); })
                .then(_setResults);
            $scope.$watch('cm.bags', function (newval, oldval) {
                if (newval !== oldval) {
                    var flight = cm.currentFlight && cm.currentFlight[0];
                    if (flight) {
                        broker.publish('searchCriteriaModified');
                        var opts = {
                            bags: cm.bags,
                            maxbags: cm.nonInfantPassengers
                        };
                        basketService.updateFlight(flight, $routeParams.tripId, opts, newval);
                    }
                    else {
                        flightSearch.modifyBags(newval);
                    }
                }
            });
        });
        function selectFlight(f) {
            if (TRPCONFIG.Domain2.ShowChangeNightsPopupWhenSelectFlight) {
                var curFlight = cm.currentFlight && cm.currentFlight[0];
                var _a = basketService.getHotelDatesFromFlight(curFlight), checkInCur = _a[0], checkOutCur = _a[1];
                var _b = basketService.getHotelDatesFromFlight(f), checkInNew = _b[0], checkOutNew = _b[1];
                var nights = basketService.getNumberOfNightsFromFlights(f, curFlight);
                if (!checkInCur || !checkInNew || !checkOutCur || !checkOutNew) {
                    return proceedFlightSelection(f);
                }
                if (checkInCur !== checkInNew || checkOutCur !== checkOutNew) {
                    return showChangeNightsConfirmationPopup([checkInNew, checkOutNew, checkInCur, checkOutCur], nights)
                        .then(function () {
                        _block();
                        proceedFlightSelection(f);
                    });
                }
                _block();
            }
            return proceedFlightSelection(f);
        }
        function showChangeNightsConfirmationPopup(dates, _a) {
            var selectedFlightNights = _a[0], curFlightNights = _a[1];
            var headerText = resourceService.get('CHANGENIGHTSPOPUPHEADER');
            var fromText = resourceService.get('UNIVERSALFROMLABEL');
            var toText = resourceService.get('UNIVERSALTOLABEL');
            var messageText = resourceService.get('CHANGENIGHTSPOPUPMESSAGE');
            var nightsText = resourceService.get('UNIVERSALNIGHTSLABEL');
            var okButtonLabel = resourceService.get('CHANGENIGHTSPOPUPOK');
            var cancelButtonLabel = resourceService.get('CHANGENIGHTSPOPUPCANCEL');
            var _b = dates.map(function (d) {
                return $filter('date')(d, 'EEE d MMM yyyy');
            }), checkInNew = _b[0], checkOutNew = _b[1], checkInOld = _b[2], checkOutOld = _b[3];
            var dateTemplate = "\n            <br>\n            <br>" + fromText + " <b>" + checkInOld + " - " + checkOutOld + "</b> (<b>" + curFlightNights + "</b> " + nightsText + "</b>)\n            <br>" + toText + " <b>" + checkInNew + " - " + checkOutNew + "</b> (<b>" + selectedFlightNights + "</b> " + nightsText + ")\n            ";
            var messageHtml = messageText + dateTemplate;
            return confirmPopupService.showPopup({
                popupHeader: headerText,
                popupMessage: messageHtml,
                okButtonLabel: okButtonLabel,
                cancelButtonLabel: cancelButtonLabel
            });
        }
        function proceedFlightSelection(f) {
            try {
                analytics.track('Event', 'SelectFlight', {
                    Revenue: f.LeadAdultPrice,
                    DepartureAirport: f.Legs[0].DepartureAirport.Code,
                    DestinationAirport: f.Legs[0].ArrivalAirport.Code,
                    StartDate: f.Legs[0].DepartureDate,
                    EndDate: f.Legs[f.Legs.length - 1].ArrivalDate
                });
            }
            catch (err) { }
            flightSearch.trackFlightClick(f, $routeParams.tripId);
            cm.flightUnavailable = false;
            cm.selectedFlight = f.FlightId;
            var opts = {
                bags: cm.bags,
                maxbags: cm.nonInfantPassengers
            };
            basketService.selectFlight(f, $routeParams.tripId, opts, $routeParams, queryParams);
        }
        function showDetails(flight) {
            broker.publish('showModalFlightDetails', { flight: flight });
        }
        function showSpinner(flight) {
            return cm.selectedFlight === flight.FlightId;
        }
        function more() {
            if (searching) {
                return 0;
            }
            var moreR = cm.requestedFilteredAgg.FilteredNumberOfFlights - (cm.combinedFlights.length + 1);
            return moreR > flightSearch.pageSize() ? flightSearch.pageSize() : moreR;
        }
        function setTab(tab) {
            if (cm.tab !== tab) {
                cm.tab = tab;
            }
        }
        function listTab() {
            cm.setTab('list');
        }
        function filterTab() {
            if (cm.combinedFlights.length > 0 || cm.anyFilter) {
                cm.setTab('filter');
                //hack to make sure that the range sliders get re-initialised
                $timeout(function () {
                    $scope.$broadcast('expanderExpanded');
                }, 0);
            }
        }
        function translateStop(stop) {
            stop = parseInt(stop);
            return stop === 0 ? resourceService.get('DIRECTFLIGHT') :
                stop === 1 ? resourceService.get('ONESTOP') :
                    stop === 2 ? resourceService.get('TWOPLUSSTOPS') : '';
        }
        function sortTab() {
            if (cm.combinedFlights.length > 0 || cm.anyFilter) {
                cm.req = flightSearch.getAvailabilityRequest();
                cm.setTab('sort');
            }
        }
        function _block() {
            var isHoliday = $route.current && $route.current.area === 'holidays';
            $scope.$emit('block', {
                title: resourceService.get(isHoliday ? 'SEARCHINGFLIGHTSANDHOTELS' : 'SEARCHINGFLIGHTS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: isHoliday ? 'holiday-holidaySearchCtrl-isHolidayTrue' : 'flights-holidaySearchCtrl-isHolidayFalse'
            });
        }
        function _unblock() {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
        function _matchesRequestedDates(f, departureDate, returnDate) {
            return dateUtil.sameDay(f.Legs[0].DepartureDate, departureDate) && (f.Legs.length > 1 ?
                dateUtil.sameDay(f.Legs[f.Legs.length - 1].DepartureDate, returnDate) : true);
        }
        function _bindFilterData() {
            cm.filter = flightSearch.getFilter();
            cm.airportFilterSet = flightSearch.filterSet('DepartureAirport');
            cm.airlineFilterSet = flightSearch.filterSet('Airline');
            cm.departureDatesFilterSet = flightSearch.filterSet('DepartureDates') && !cm.isHotelFirstJourney;
            cm.stopFilterSet = flightSearch.filterSet('Stop');
            cm.anyFilter = false;
            angular.forEach(rangeFilters, function (filter) {
                cm["Min" + filter + "Set"] = flightSearch.rangeFilterSet(filter, 'Min');
                cm["Max" + filter + "Set"] = flightSearch.rangeFilterSet(filter, 'Max');
                cm.anyFilter = cm.anyFilter || cm["Min" + filter + "Set"] || cm["Max" + filter + "Set"];
            });
            cm.anyFilter = cm.anyFilter || cm.airportFilterSet || cm.airlineFilterSet || cm.departureDatesFilterSet || cm.stopFilterSet;
        }
        function _setResults(data) {
            bd4travel.trackFlightsResults($routeParams.tripId);
            setTimeout(function () {
                var flights = data.CombinedDates.AvailableFlights;
                analytics.track('mixpanel', 'FlightListing', {
                    RepeatHotelOffered: _.some(_.get(data, 'CombinedDates.AvailableFlights'), function (f) { return f.RecentlyViewedIndex === 1; }),
                    CarrierArray: _.map(flights, function (f) { return _.get(f, 'Legs[0].Segments[0].CarrierName'); }),
                    ppPriceArray: _.map(flights, function (f) { return _.get(f, 'AdultFare.Amount'); }),
                    // Will be tricky,  Prices are always per person:
                    //TotalPriceArray: _.map(flights, f => f.AdultFare.Amount),
                    CabinArray: _.map(flights, function (f) { return _.get(f, 'Legs[0].Segments[0].CabinType'); }),
                    SearchID: $routeParams.tripId
                });
            });
            cm.sortCriteria = flightSearch.getSortCriteria(searchUnitService.isOneWayFlightEnabled());
            updateOccupancy();
            flightSearch.getSearchSummary(cm.tripType, $routeParams.tripId).then(function (searchSummary) { return cm.searchSummary = searchSummary; });
            if (!routeSummaryUpToDate) {
                flightSearch.getRouteSummary(cm.tripType, $routeParams.tripId).then(function (routeSummary) { return cm.routeSummary = routeSummary; });
                routeSummaryUpToDate = true;
            }
            tripService.getDurationSummary(searchUnitService.flight, $routeParams.tripId).then(function (ds) { return cm.durationSummary = ds; });
            tripService.getFlightsRequestDepartureDate($routeParams.tripId).then(function (date) { return cm.flightDepartureDate = dateUtil.format(date, 'yyyy-MM-dd'); });
            cm.filter = flightSearch.getFilter();
            cm.searchId = data.AvailabilitySearchId;
            cm.combinedFlights = data.CombinedDates.AvailableFlights;
            if (cm.isHotelFirstJourney) {
                _calculatePrices(cm.combinedFlights);
            }
            cm.requestedFilteredAgg = data.CombinedDates.FilteredAggregates;
            flightSearch.getSortCriterionDescription().then(function (so) {
                cm.sortedBy = so;
            });
            cm.agg = data.CombinedDates.UnfilteredAggregates;
            flightsFilterService.arrayifyAggregates(cm.agg, ['FlightsByAirline', 'DepartureDates']);
            flightsFilterService.populateMinimumPrice(cm.agg);
            cm.filteredAgg = data.CombinedDates.FilteredAggregates;
            cm.oneWayOnly = searchUnitService.isOneWayFlightEnabled();
            cm.showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone' ? true : !cm.agg.TotalNumberOfFlights;
            cm.busy = searching = false;
            broker.publish('flightsListUpdated', data);
            _unblock();
            _bindFilterData();
        }
        function _calculatePrices(flightList) {
            tripService.getTrip(tripId).then(function (trip) {
                basketStore.flightCost(trip.BasketId).then(function (cost) {
                    var numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
                    basketStore.totalCost(trip.BasketId).then(function (res) {
                        flightList.map(function (flight) {
                            // In some cases we get +1 or -1 delta price, but actually the flight prices are the same,
                            // this is due to rounding of the number, so we need to do this check to avoid the rounding issue
                            if (trip.FlightsRequest.SelectedFlight !== null) {
                                if (trip.FlightsRequest.SelectedFlight.LeadAdultPrice + trip.FlightsRequest.SelectedFlight.LeadAdultTax === flight.LeadAdultPrice + flight.LeadAdultTax) {
                                    flight.deltaPrice = 0;
                                }
                                else {
                                    flight.deltaPrice = (flight.LeadAdultPrice + flight.LeadAdultTax) * numPassengers - cost;
                                }
                                flight.totalHolidayPrice = parseFloat(res) + flight.deltaPrice;
                            }
                            return flight;
                        });
                    });
                });
            });
        }
        function _modifyResults(data) {
            _setResults(data);
            cm.listTab();
            cm.updating = false;
            if (cm.showSlideFilter === true) {
                scrollTo(0, 0);
            }
        }
        function toggleSearchUnit() {
            cm.showSearchUnit = !cm.showSearchUnit;
        }
        function openSlideFilter(e) {
            e.preventDefault();
            cm.showSlideFilter = true;
        }
        $scope.$on('$destroy', function () {
            broker.unsubscribe('HolidaySearchCtrl');
        });
        function updateOccupancy() {
            cm.nonInfantPassengers = occupancyService.getNumberOfNonInfantPassengers();
            cm.hidePerAdultExplaination = _.chain(occupancyService.getOccupancy())
                .flatMap(function (o) { return o.ChildAges; })
                .every(function (age) { return age < 2 || age > 16; })
                .value();
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('ChildDestinations', ChildDestinations);
    function ChildDestinations(urlUtils, destinationService, $location, currentDestination) {
        var cd = this;
        var limit = 6;
        var dest;
        var parsed = urlUtils.parse($location.url());
        parsed.qs = _.omit(parsed.qs, ['pi', 'pt']);
        parsed.qs.allDest = true;
        cd.allDestinationsUrl = urlUtils.stripLeadingSlash(urlUtils.format(parsed));
        cd.showAll = $location.search().allDest;
        function chunk(size, array) {
            return [].concat.apply([], array.map(function (elem, i) {
                return i % size ? [] : [array.slice(i, i + size)];
            }));
        }
        cd.toggleShowAll = function (e) {
            e.preventDefault();
            e.stopPropagation();
            cd.showAll = !cd.showAll;
            getChildDestinations(dest);
        };
        function processResults(children) {
            cd.children = destinationService.sortByTitle(children).map(function (child) {
                var childPagePath = urlUtils.appendExistingQueryString(urlUtils.stripLeadingSlash(child.PagePath));
                var parsed = urlUtils.parse(childPagePath);
                parsed.qs = _.omit(parsed.qs, ['pi', 'pt', 'allDest']);
                child.PagePath = urlUtils.format(parsed);
                return child;
            });
            cd.show = cd.children.length > 0;
            cd.chunks = chunk(2, cd.children);
        }
        function getChildDestinations(d) {
            if (cd.showAll) {
                destinationService.getAllChildren(d).then(processResults);
            }
            else {
                destinationService.getTopChildren(limit, d).then(processResults);
            }
        }
        currentDestination.getCurrentDestination().then(function (d) {
            dest = d;
            getChildDestinations(d);
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelAvailability', HotelAvailability);
    function HotelAvailability(pagingService, urlUtils, preferences, basketStore, breadcrumbDetailsService, tripService, occupancyService, scrollService, $route, $scope, arrayUtil, $rootScope, $location, $window, hotelSearch, reviewService, shortlistService, cookieService, hotel, hotelResolver, flightSearch, authService, bd4travel, broker, basketService, $routeParams, $timeout, resourceService, searchUnitService, analytics, criteoService, currentDestination, destinationService, taxationService, currencyService, $q, $filter, bookedEstabId, $anchorScroll, mandatoryTransferService, hotelRoomService) {
        if (hotel == null) {
            return;
        }
        this.bookedEstabId = bookedEstabId;
        if ($routeParams.shortlist) {
            shortlistService.addToShortlist(hotel)
                .then(function () {
                authService.bufferRoute(null); //clear any buffered route that might be left behind
                $location.search('shortlist', null);
            });
            return;
        }
        if (_.get($location.search(), 'source') != null) {
            this.isMeta = true;
        }
        if (_.get($location.search(), 'source') === 'TV') {
            $(window).one('click', function () {
                window.moveTo(0, 0);
                window.resizeTo(screen.availWidth, screen.availHeight);
            });
        }
        scrollTo(0, 0);
        $rootScope.unlockScreen($scope);
        analytics.startTimer(hotel.Title);
        var cm = this;
        var filter = angular.copy(hotelSearch.getFilter());
        var boardTypeFilterSet = hotelSearch.filterSet('BoardTypes');
        var showRoomPredicate = boardTypeFilterSet ? _matchesBoardTypeFilter : _isShortlisted;
        var deferredFlightCost = $q.defer();
        var deferredLowDepositValue = $q.defer();
        var deferredCurrency = $q.defer();
        var deferredFlight = $q.defer();
        var deferredRules = $q.defer();
        function isPriceModeInLocation(location) {
            return location.priceMode != null;
        }
        function setPriceMode(p, location) {
            if (isPriceModeInLocation(location) && TRPCONFIG.Domain.PriceModeUrlHash) {
                cm.priceMode = parseFloat(location.priceMode);
            }
            else {
                cm.priceMode = p;
            }
        }
        preferences.get('priceMode').then(function (p) {
            setPriceMode(p, $location.search());
        });
        cm.scrollToReviews = scrollToReviews;
        cm.scrollToRooms = scrollToRooms;
        cm.hideRooms = true;
        cm.activeHotel = angular.copy(hotel);
        cm.hotel = hotel;
        cm.isMobileDevice = TRPCONFIG.IsMobileDevice;
        cm.isMultiDestHoliday = false;
        cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        cm.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
        cm.longSpecialOfferText = '';
        broker.publish('hotelViewed', cm.hotel);
        // Isolate hotel facilites
        cm.hotelFacilities = _.find(cm.hotel.FacilityGroups, function (fg) {
            return fg.name = 'Facilities';
        });
        /*
         * Setter for cm.hotel.LowDepositValueWithFlight
         */
        function setLowDepositValueWithFlight(promiseFlightCost, promiseLowDepositValue, promiseCurrency, promiseFlight, promiseRules) {
            $q.all([promiseFlightCost, promiseLowDepositValue, promiseCurrency, promiseFlight, promiseRules]).then(function (data) {
                var roundedCurrencyFilter = $filter('roundedCurrency');
                var unformattedString = $filter('unformattedString');
                var flightCost = data[0];
                var lowDepositeValue = data[1];
                var currency = data[2];
                var flight = data[3];
                var rules = data[4];
                var flightDeposite = 0;
                var flightDepositeAllowed = rules.depositAllowed;
                if (flight != null) {
                    flightDeposite = flight.ImmediatePayment.Amount;
                }
                var lowDepositeAndFlightDeposite = flightDeposite + lowDepositeValue;
                var lowDepositeAndFlightCost = flightCost + lowDepositeValue;
                var lowDepositeValueFormated = roundedCurrencyFilter(lowDepositeValue, currency);
                var LOWDEPOSITEHOLIDAY = resourceService.get('LOWDEPOSIT:HOLIDAY');
                var LOWDEPOSITEFLIGHT = resourceService.get('LOWDEPOSIT:FLIGHT');
                var LOWDEPOSITPACKAGEHOLIDAY = resourceService.get('LOWDEPOSITPACKAGEHOLIDAY');
                function getLowDepositeAndFlightCostText() {
                    var roundedCost = roundedCurrencyFilter(lowDepositeAndFlightCost, currency);
                    return unformattedString(LOWDEPOSITEHOLIDAY, roundedCost, lowDepositeValueFormated);
                }
                function getLowDepositeAndFlightDepositeText() {
                    var roundedCost = roundedCurrencyFilter(lowDepositeAndFlightDeposite, currency);
                    return unformattedString((cm.packagePrice ? LOWDEPOSITPACKAGEHOLIDAY : LOWDEPOSITEFLIGHT), roundedCost, lowDepositeValueFormated);
                }
                cm.hotel.lowDepositText = flightDepositeAllowed ?
                    getLowDepositeAndFlightDepositeText() :
                    getLowDepositeAndFlightCostText();
            });
        }
        setLowDepositValueWithFlight(deferredFlightCost.promise, deferredLowDepositValue.promise, deferredCurrency.promise, deferredFlight.promise, deferredRules.promise);
        cm.loadingReviews = false;
        cm.loadingFirstReviews = false;
        cm.setTab = setTab;
        cm.mapTab = mapTab;
        cm.reviewsTab = reviewsTab;
        cm.photosTab = photosTab;
        cm.search = search;
        cm.selectRooms = selectRooms;
        cm.showAllRooms = false;
        cm.tab = 'detail';
        cm.tabClass = tabClass;
        cm.toggleShortlist = toggleShortlist;
        cm.roomsLeftLimit = TRPCONFIG.Domain.UrgencyMessageRoomThreshold;
        cm.roomAvailability = getRoomAvailability;
        cm.changeHotel = changeHotel;
        cm.isHoliday = $route.current && $route.current.area === 'holidays';
        var pi = $location.search().pi;
        cm.paging = pagingService.data(pi == null ? 1 : parseInt(pi) + 1, 10, cm.hotel.CustomerReviewCount);
        cm.pageReviews = TRPCONFIG.Domain.ReviewsEnabled ? _getReviews : null;
        cm.showSearchUnit = _showSearchUnit();
        cm.toggleSearchUnit = toggleSearchUnit;
        cm.topHotelRoomHasSpecialOffer = topHotelRoomHasSpecialOffer;
        cm.getTopHotelRoomSpecialOffer = getTopHotelRoomSpecialOffer;
        tripService.usePackageRates().then(function (packagePrice) { return cm.packagePrice = packagePrice; });
        tripService.getHotelsRequestNumberOfNights($routeParams.tripId).then(function (numNights) { return cm.numNights = numNights; });
        tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(function (ds) {
            cm.durationSummary = ds;
            cm.searchSummary = ds ? ds + ", " + hotelSearch.getOccupancySummary() : '';
        });
        currentDestination.getCurrentDestination().then(function (dest) { return cm.destination = dest; });
        broker.subscribe('HotelAvailability', 'boardTypeFilterUpdated', function (ev) {
            boardTypeFilterSet = ev.data != null && ev.data.length > 0;
            showRoomPredicate = boardTypeFilterSet ? _matchesBoardTypeFilter : _isShortlisted;
            filter.BoardTypes = ev.data;
            _setRooms();
        });
        broker.subscribe('HotelAvailability', 'priceModeChanged', function (ev) {
            if (isPriceModeInLocation(location) && TRPCONFIG.Domain.PriceModeUrlHash) {
                $location.search('priceMode', ev.data).replace();
                $anchorScroll('#rooms-grid');
            }
            cm.priceMode = ev.data;
        });
        broker.subscribe('HotelAvailability', 'hotelDetailCallFailed', function (ev) {
            cm.showSpinner = null;
            analytics.track('mixpanel', 'SupplierDetailError', {
                estabId: ev.data.EstabId
            });
            //When the hotel details call fails for any reason, we are assuming that the room is sold out
            cm.hotelDetailsFailed = true;
            _.forEach(cm.hotel.Rooms[0].Availability, function (room) {
                if (room.Id === ev.data.RoomAndBoardIds[0]) {
                    room.soldOut = true;
                }
            });
            broker.publish('roomsSet', cm.hotel);
            $rootScope.unlockScreen($scope);
            $timeout(function () { return scrollService.scrollTo('#roomsPanel'); }, 100);
        });
        broker.subscribe('HotelAvailability', 'continueToBookFromFlightDetailsModal', function (e) {
            continueToBook(e.data.priceId);
        });
        if (TRPCONFIG.Domain.ShortlistsEnabled) {
            shortlistService.isHotelShortlisted(cm.hotel).then(function (inList) {
                cm.hotelInShortlist = inList;
            });
        }
        $scope.$watch('cm.tab', function () {
            $rootScope.$emit('hideCloseButton');
        });
        angular.forEach(['detail'], function (val) {
            cm[val + "Tab"] = function () {
                cm.setTab(val);
            };
        });
        //call the hotel resolver again and this time make sure we ask for the rooms as well
        $timeout(function () { return scrollService.scrollTo(scrollService.getScrollTarget()); }, 500);
        var includeRooms = true;
        hotelResolver.resolve(includeRooms)
            .then(function (h) {
            broker.publish('hotelCacheReady', h);
            bd4travel.trackHotelAvailability($routeParams.tripId, hotel.Id, 'productDetails');
            if (h.LowDepositValue) {
                deferredLowDepositValue.resolve(h.LowDepositValue);
            }
            // Update hotel with all dest params
            destinationService.getDetails(h)
                .then(function (dest) { return cm.hotelDestination = dest; })
                .then(function () {
                cm.hotel = h;
                _setRooms();
                cm.hideRooms = false;
            });
        });
        var locSearch = $location.search();
        switch (locSearch.pd) {
            case 'mp':
                $timeout(function () { cm.mapTab(); });
                break;
            case 'rv':
                cm.reviewsTab();
                if (locSearch.lr) {
                    reviewService.likeReview.organic(locSearch.lr, true);
                }
                break;
            case 'ph':
                cm.photosTab();
                break;
        }
        if (TRPCONFIG.DeviceSettings.AutoLoadReviews && locSearch.pd !== 'rv' && TRPCONFIG.Domain.ReviewsEnabled) {
            reviewsTab();
        }
        broker.subscribe('HotelAvailability', 'roomSearchStarted', function hideRooms() {
            cm.hideRooms = true;
        });
        broker.subscribe('HotelAvailability', 'roomSearchEnded', function hideRooms() {
            cm.hideRooms = false;
            cm.hotel.Rooms = arrayUtil.map(cm.hotel.Rooms, function (r) {
                r.selected = r.Availability[0].Id;
                return r;
            });
            tripService.getHotelsRequestNumberOfNights($routeParams.tripId).then(function (numNights) { return cm.numNights = numNights; });
            scrollService.scrollTo('#roomsPanel');
            _setRooms();
        });
        cm.isHotelFirstJourney = basketService.isFlightPreselected();
        function _setRooms() {
            cm.allRoomsAvailable = true;
            cm.currencyCode = searchUnitService.getCurrency();
            if (cm.hotel.Rooms != null && cm.hotel.Rooms.length > 0) {
                cm.hotel.Rooms = arrayUtil.map(cm.hotel.Rooms, function (r, i) {
                    if (boardTypeFilterSet) {
                        r.FilteredAvailability = arrayUtil.filter(r.Availability, _matchesBoardTypeFilter);
                        if (r.FilteredAvailability.length > 0) {
                            r.selected = r.FilteredAvailability[0].Id; //overwrite the preselected room becuase it may have been filtered out
                        }
                        else {
                            cm.allRoomsAvailable = false;
                        }
                    }
                    else {
                        r.FilteredAvailability = r.Availability;
                    }
                    r.isRoomKidsFree = occupancyService.isRoomKidsFree(i) && cm.isKidsFree;
                    r.nonInfants = r.isRoomKidsFree
                        ? occupancyService.getOnlyAdultsPerRoom(i)
                        : occupancyService.getNumberOfNonInfantsForRoom(i);
                    return r;
                });
                cm.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
                var currentFbt = $location.search() && $location.search().fbt;
                if (currentFbt) {
                    var multipleBoardTypes = currentFbt.slice();
                    cm.lowestPriceBoardType = findLowestBoardDescLabel(cm.hotel.Rooms[0].Availability, multipleBoardTypes);
                }
                else {
                    cm.lowestPriceBoardType = lowestPriceBoardType(cm.hotel.Rooms[0].Availability);
                }
                $timeout(function () { return broker.publish('roomsSet', cm.hotel); });
            }
            //find out how many other hotels the user can look through if we dont have any availability for the current hotel
            if ((cm.hotel.Rooms == null || cm.hotel.Rooms.length === 0) && $routeParams.tripId) {
                tripService.getTrip($routeParams.tripId).then(function (trip) {
                    hotelSearch.getSearchResults(trip.HotelsRequest.AvailabilitySearchId, { ignoreTracking: true }).then(function (data) {
                        cm.HotelCount = data.Aggregates.HotelCount;
                        cm.LowestPricedHotel = data.Aggregates.LowestPricedHotel;
                        cm.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
                        analytics.trackEvent({ category: 'hotelResultsPage', action: 'noRates', label: 'no hotel availability message' });
                    });
                });
            }
            //this calculates the total number of room availability for all rooms
            var totalRooms = cm.hotel.Rooms ? (arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(cm.hotel.Rooms, function (rr) { return rr.FilteredAvailability.length; }))) : 0;
            var defaultMax = cm.hotel.Rooms ? 5 * cm.hotel.Rooms.length : 5;
            //this calculates the number of rooms that should be shown according to the showRoomPredicate
            var maxRooms = cm.hotel.Rooms ? (arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(cm.hotel.Rooms, function (rr) {
                return arrayUtil.filter(rr.FilteredAvailability, showRoomPredicate).length;
            }))) : 0;
            if (maxRooms > defaultMax) {
                maxRooms = defaultMax;
            }
            cm.moreRooms = cm.hotel.Rooms ? (totalRooms - maxRooms) : 0;
            if (cm.hotel.Rooms) {
                cm.roomLimit = function (r) {
                    return cm.showAllRooms || showRoomPredicate(r);
                };
                cm.toggleExtraRooms = function () {
                    if (cm.showAllRooms) {
                        scrollService.scrollTo('#roomsPanel', { animate: true }).then(function () {
                            cm.showAllRooms = !cm.showAllRooms;
                        });
                    }
                    else {
                        cm.showAllRooms = !cm.showAllRooms;
                    }
                };
                cm.longSpecialOfferText = getTopLongSpecialOfferText();
                updateRibbons(cm.hotel);
            }
            if (TRPCONFIG.Domain.EnableCityTax && cm.hotel.IsCityTaxIncludedInPrice) {
                cm.cityTax = {};
                if (cm.hotel.Rooms != null && cm.hotel.Rooms.length > 0
                    && cm.hotel.Rooms[0].Availability && cm.hotel.Rooms[0].Availability.length > 0) {
                    cm.cityTax.TotalAmount = cm.hotel.Rooms[0].Availability[0].CityTax;
                    cm.cityTax.CityTaxLocalAmount = cm.hotel.Rooms[0].Availability[0].CityTaxLocalAmount;
                    cm.cityTax.CurrencyCode = cm.hotel.Rooms[0].Availability[0].CityTaxLocalCurrency;
                }
            }
            cm.mandatoryExtras = hotelSearch.getMandatoryExtra(cm.hotel);
            $timeout(function () {
                scrollService.scrollTo(scrollService.getScrollTarget());
            }, 500);
            analytics.endTimer(cm.hotel.Title);
        }
        function _getReviews(page, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            cm.loadingReviews = true;
            if (page === 1) {
                cm.loadingFirstReviews = true;
            }
            reviewService.getReviews(cm.hotel, page - 1).then(function (result) {
                cm.reviews = result.reviews;
                cm.loadingReviews = false;
                cm.loadingFirstReviews = false;
                cm.paging = pagingService.data(page, 10, cm.hotel.CustomerReviewCount);
            });
        }
        function _matchesBoardTypeFilter(b) {
            return arrayUtil.indexOf(filter.BoardTypes, function (bt) {
                return parseInt(bt) === b.BoardType;
            }) >= 0;
        }
        function _isShortlisted(b) {
            return b.IsShortlisted;
        }
        function getRoomAvailability() {
            if (cm.hotel.Rooms.length === 1) {
                return cm.hotel.Rooms[0].Availability.length;
            }
            if (cm.hotel.Rooms.length > 1) {
                var roomOptions_1 = 0;
                angular.forEach(cm.hotel.Rooms, function (room) {
                    roomOptions_1 += room.Availability.length;
                });
                return roomOptions_1;
            }
        }
        function _showSearchUnit() {
            var showSearchUnit;
            if (TRPCONFIG.Domain.SearchUnitExpandedForMeta && cm.isMeta) {
                showSearchUnit = (TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone') || cm.isMeta;
            }
            else {
                showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
            }
            return showSearchUnit;
        }
        function toggleShortlist() {
            shortlistService.toggleHotel(cm.hotel).then(function (inShortlist) {
                cm.hotelInShortlist = inShortlist;
            });
        }
        function tabClass(tab) {
            if (tab instanceof Array) {
                return tab.indexOf(cm.tab) >= 0 ? 'active' : '';
            }
            return tab === cm.tab ? 'active' : '';
        }
        function scrollToRooms() {
            scrollService.scrollTo('#roomsPanel', { animate: true });
            analytics.trackEvent({ label: 'scroll to rooms grid' });
        }
        function scrollToReviews() {
            reviewsTab();
            scrollService.scrollTo('#reviewsSection', { animate: true });
        }
        function setTab(tab) {
            if (cm.tab !== tab) {
                cm.tab = tab;
            }
        }
        function reviewsTab() {
            cm.setTab('reviews');
            cm.reviews = [];
            _getReviews(cm.paging.page);
        }
        function photosTab() {
            cm.setTab('photos');
        }
        function mapTab() {
            cm.setTab('map');
            $scope.$broadcast('mapTabSelected');
        }
        function _chosenRooms() {
            return arrayUtil.map(arrayUtil.filter(cm.hotel.Rooms, function (rr) { return rr.selected != null; }), function (rr) {
                return rr.selected;
            });
        }
        function selectRooms(roomIds, room) {
            if (!roomIds) {
                roomIds = _chosenRooms();
            }
            if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !cm.isHoliday && (roomIds.length > 1 || room)) {
                checkOnMandatoryTransfers(roomIds);
            }
            else {
                continueToBook(roomIds);
            }
        }
        function continueToBook(roomIds) {
            var tripId = $routeParams.tripId;
            cookieService.set('VoucherCode', '');
            cookieService.set('VoucherWarnMessage', '');
            cookieService.set('SelectedPrices', roomIds || '');
            try {
                analytics.track('Event', 'SelectHotelRoom', {
                    Revenue: cm.hotel.MinCost,
                    HotelTitle: cm.hotel.Title
                });
            }
            catch (err) { }
            if (roomIds == null) {
                roomIds = _chosenRooms();
            }
            cm.showSpinner = roomIds[0];
            $rootScope.lockScreen($scope, {
                title: resourceService.get('PREPARINGBOOKING'),
                loadingScreenStyle: 'booking-hotelAvailabilityCtrl'
            });
            analytics.track('mixpanel', 'HotelDetailClick', {
                AwardClicked: !!_.get(hotel, 'AwardDetails')
            });
            if (cm.isMultiDestHoliday) {
                return tripService.getTrip(tripId)
                    .then(function () { return basketService.selectHotelRooms(cm.hotel, roomIds, tripId); })
                    .then(function () { return tripService.changeTripType(tripId, tripService.tripTypes.Holiday); });
            }
            return basketService.selectHotelRooms(cm.hotel, roomIds, tripId);
        }
        function checkOnMandatoryTransfers(roomIds) {
            if (!roomIds) {
                roomIds = _chosenRooms();
            }
            var roomGridData = hotelRoomService.restructureData(cm.hotel);
            var selectedPrices = {};
            for (var i = 0; i < roomIds.length; i++) {
                selectedPrices["id" + i] = roomIds[i];
            }
            var rooms = mandatoryTransferService.getRoomsWithTransfers(cm.hotel, roomGridData, selectedPrices);
            if (rooms.length > 0) {
                var priceMode = cm.priceMode;
                broker.publish('showModalAddFlightDetailsForMultiRooms', { rooms: rooms, priceMode: priceMode });
            }
            else {
                continueToBook(roomIds);
            }
        }
        function search() {
            basketService.startWorkflow(basketService.hotelBooking).then(null, function (errors) {
                $scope.$emit('flash:error', errors);
            });
        }
        function changeHotel() {
            if (cm.isMultiDestHoliday) {
                $location.url("/holidays/january-sale/" + $routeParams.tripId);
                return;
            }
            if ($routeParams.tripId && $route.current.area) {
                if (cm.dealsMode) {
                    tripService.getTrip($routeParams.tripId).then(function (trip) {
                        if (trip && trip.Deal) {
                            $location.url(urlUtils.stripLeadingSlash(trip.Deal.OriginPath));
                        }
                    });
                }
                else {
                    tripService.setDirectToHotel($routeParams.tripId, false).then(function () {
                        var nextUrl = $routeParams.BookingRef ?
                            "dashboard/amend-booking/" + $routeParams.BookingRef + "/" + $routeParams.BookingId + "/" + $routeParams.tripId :
                            $route.current.area + "/" + ($route.current.area === 'holidays' ? 'hotels/' : '') + $routeParams.tripId;
                        $location.path(nextUrl);
                    });
                }
            }
        }
        function toggleSearchUnit() {
            cm.showSearchUnit = !cm.showSearchUnit;
        }
        function getTopHotelRoomSpecialOffer() {
            return {
                offerText: _.get(cm, 'hotel.Rooms[0].Availability[0].LongSpecialOfferText', ''),
                roomType: _.get(cm, 'hotel.Rooms[0].Availability[0].RoomDescription', '')
            };
        }
        function topHotelRoomHasSpecialOffer() {
            return _.get(cm, 'hotel.Rooms[0].Availability[0].LongSpecialOfferText', '').trim() !== '';
        }
        function getTopLongSpecialOfferText() {
            var rooms = cm.hotel.Rooms[0] || [];
            var text = '';
            _.forEach(rooms.Availability, function (availability) {
                if (availability.LongSpecialOfferText) {
                    text = availability.LongSpecialOfferText;
                    return false;
                }
            });
            return text;
        }
        function lowestPriceBoardType(arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].IsCheapest) {
                    return arr[i].BoardDescription;
                }
            }
        }
        function findLowestBoardDescLabel(arr, fbt) {
            if ((!fbt || fbt.length === 0) && (!arr || arr.length === 0)) {
                return;
            }
            var filtered = arr.filter(function (room) {
                return fbt.indexOf(room.BoardType) !== -1;
            });
            var cheapestPrice = sortBoardTypes(filtered)[0];
            return cheapestPrice && cheapestPrice.BoardDescription;
        }
        function sortBoardTypes(arr) {
            return arr.sort(function (a, b) { return a.Cost >= b.Cost ? 1 : -1; });
        }
        function makeRibbonStyles(overlay) {
            var pillPrefix = 'sc-c-pill';
            var textPrefix = 'u-text';
            var pillStyle = [pillPrefix, pillPrefix + "--" + overlay.ColourClass];
            var promoTextStyle = [textPrefix + "--" + overlay.ColourClass];
            overlay.EffectClasses.forEach(function (effect) {
                pillStyle.push(pillPrefix + "--" + effect);
                promoTextStyle.push(textPrefix + "--" + effect);
            });
            return {
                pillClass: pillStyle.join(' '),
                promoTextClass: promoTextStyle.join(' ')
            };
        }
        function updateRibbons(hotel) {
            hotel.Rooms.forEach(function (room) {
                room.Availability.forEach(function (item) {
                    if (item.OverlayNew) {
                        var appliedToAllRooms = room.Availability.every(function (board) {
                            return (hotel.PromotionRibbon && hotel.PromotionRibbon.Text) === (board.OverlayNew && board.OverlayNew.Text);
                        });
                        if (!appliedToAllRooms) {
                            var styles = makeRibbonStyles(item.OverlayNew);
                            var textSeparator = getSeparator(item.OverlayNew.Text);
                            item.pillClass = styles.pillClass;
                            item.promoTextClass = styles.promoTextClass;
                            item.promotionText = item.OverlayNew.Text.toUpperCase()
                                .split(textSeparator)
                                .map(textLengthValidator);
                        }
                    }
                });
            });
        }
        function getSeparator(ribbonText) {
            return ribbonText && ribbonText.includes('|') ? '|' : ' ';
        }
        function textLengthValidator(text) {
            return text && text.slice(0, 10);
        }
        if ($routeParams.tripId) {
            tripService.getCurrency($routeParams.tripId).then(function (cur) {
                deferredCurrency.resolve(cur);
                cm.currencyCode = cur;
            });
            tripService.getTrip($routeParams.tripId).then(function (trip) {
                criteoService.enqueue(cm.hotel, 'hotel', trip.TripType);
                analytics.track('mixpanel', 'HotelPage');
                analytics.track('Event', 'HotelChanged', {
                    Hotel: cm.hotel,
                    Flight: trip.FlightsRequest ? trip.FlightsRequest : null
                });
                analytics.track('Facebook', 'HotelPage');
                cm.hotelAvailabilitySearchId = _.get(trip, 'HotelsRequest.AvailabilitySearchId');
                cm.isMultiDestHoliday = trip.TripType === tripService.tripTypes.MultiDestHoliday;
                cm.isKidsFree = trip.IsKidsFree &&
                    (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);
                if (cm.isKidsFree) {
                    cm.payingIndividuals = occupancyService.getOnlyPayingIndividuals();
                }
                var numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
                basketStore.rules(trip.BasketId).then(function (data) {
                    deferredRules.resolve(data);
                });
                basketStore.flight(trip.BasketId).then(function (data) {
                    deferredFlight.resolve(data);
                });
                basketStore.flightCost(trip.BasketId).then(function (c) {
                    deferredFlightCost.resolve(c);
                    cm.totalFlightCost = c;
                    cm.flightCostPerPerson = c / numPassengers;
                    cm.marhabaCost = 0;
                    if (cm.packagePrice && TRPCONFIG.Domain.MarhabaEnabled) {
                        basketStore.marhabaCost(trip.BasketId).then(function (cost) {
                            cm.marhabaCost = cost || 0;
                            return cost;
                        });
                    }
                    //make sure we don't set this up until the flight costs are available
                    cm.holidayPriceByMode = function (hotelPrice, roomNonInfants, marhabaCost) {
                        if (marhabaCost === void 0) { marhabaCost = 0; }
                        var payingNum = cm.isKidsFree ? cm.payingIndividuals : roomNonInfants;
                        if (cm.priceMode === 0) {
                            return hotelPrice / payingNum + cm.flightCostPerPerson + (marhabaCost / payingNum);
                        }
                        if (cm.priceMode === 1) {
                            return hotelPrice + (marhabaCost + cm.totalFlightCost * (roomNonInfants / cm.nonInfants));
                        }
                    };
                });
            });
        }
        $scope.$on('$destroy', function () {
            broker.unsubscribe('HotelAvailability');
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelLanding', HotelLanding);
    function HotelLanding(pagingService, scrollService, $scope, $rootScope, $location, reviewService, shortlistService, basketService, $timeout, destinationService, broker, currentDestination, criteoService) {
        scrollTo(0, 0);
        if ($location.search().autoSearch !== '1') {
            $rootScope.unlockScreen($scope);
        }
        var cm = this;
        cm.hideRooms = false;
        cm.seoRoomLoader = true;
        cm.similarHotelsLoader = true;
        cm.showSimilarHotels = true;
        cm.scrollToReviews = scrollToReviews;
        cm.activeHotel = angular.copy($scope.hotel);
        cm.hotel = $scope.hotel;
        var _a = $scope.hotel || {}, Title = _a.Title, Location = _a.Location, Province = _a.Province, Country = _a.Country;
        cm.altText = [Title, Location, Province, Country].join(', ');
        cm.loadingReviews = false;
        cm.loadingFirstReviews = false;
        cm.mapTab = mapTab;
        cm.reviewsTab = reviewsTab;
        cm.photosTab = photosTab;
        cm.createSeoLink = function (search) { return cm.hotel.Url + "?" + search; };
        cm.search = search;
        cm.tab = 'detail';
        cm.tabClass = tabClass;
        cm.toggleShortlist = toggleShortlist;
        cm.currencyCode = TRPCONFIG.Domain.CurrencyCode;
        var pi = $location.search().pi;
        cm.paging = pagingService.data(pi == null ? 1 : parseInt(pi) + 1, 10, cm.hotel.CustomerReviewCount);
        cm.pageReviews = TRPCONFIG.Domain.ReviewsEnabled ? _getReviews : null;
        cm.isMobileDevice = TRPCONFIG.IsMobileDevice;
        cm.seoHideRooms = false;
        cm.seoRoomsLanding = cm.hotel.RoomDetails || [];
        if (cm.seoRoomsLanding.length > 0) {
            cm.seoRoomLoader = false;
        }
        var titleCase = function (str) {
            return str ? str.toLowerCase().split(' ').map(_.upperFirst).join(' ') : '';
        };
        var _b = cm.hotel.AltTitles, AltTitles = _b === void 0 ? [] : _b;
        cm.hotelAlternativeTitles = AltTitles.map(function (title) {
            var titleCaseStr = titleCase(title);
            return "<li class=\"sc-c-list__item sc-c-list__item--inline-block\">" + titleCaseStr + "</li>";
        }).join(' | ');
        broker.publish('hotelViewed', cm.hotel);
        // Isolate hotel facilites
        cm.hotelFacilities = _.find(cm.hotel.FacilityGroups, function (fg) {
            return fg.name = 'Facilities';
        });
        currentDestination.getCurrentDestination().then(function (dest) {
            cm.destination = dest;
        });
        // Update hotel with all dest params
        destinationService.getDetails($scope.hotel).then(function (dest) {
            criteoService.enqueue(cm.hotel, 'hotel');
            cm.hotel = $scope.hotel;
            cm.hotelDestination = dest;
        });
        if (TRPCONFIG.Domain.ShortlistsEnabled) {
            shortlistService.isHotelShortlisted(cm.hotel).then(function (inList) {
                cm.hotelInShortlist = inList;
            });
        }
        $scope.$watch('cm.tab', function () {
            $rootScope.$emit('hideCloseButton');
        });
        angular.forEach(['detail'], function (val) {
            cm[val + "Tab"] = function () {
                cm.tab = val;
            };
        });
        var locSearch = $location.search();
        switch (locSearch.pd) {
            case 'mp':
                $timeout(function () { cm.mapTab(); });
                break;
            case 'rv':
                cm.reviewsTab();
                if (locSearch.lr) {
                    reviewService.likeReview.organic(locSearch.lr, true);
                }
                break;
            case 'ph':
                cm.photosTab();
                break;
        }
        if (TRPCONFIG.DeviceSettings.AutoLoadReviews && locSearch.pd !== 'rv') {
            reviewsTab();
        }
        function _getReviews(page, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            cm.loadingReviews = true;
            if (page === 1) {
                cm.loadingFirstReviews = true;
            }
            reviewService.getReviews(cm.hotel, page - 1).then(function (result) {
                cm.reviews = result.reviews;
                cm.loadingReviews = false;
                cm.loadingFirstReviews = false;
                cm.paging = pagingService.data(page, 10, cm.hotel.CustomerReviewCount);
            });
        }
        function toggleShortlist() {
            shortlistService.toggleHotel(cm.hotel).then(function (inShortlist) {
                cm.hotelInShortlist = inShortlist;
            });
        }
        function tabClass(tab) {
            if (tab instanceof Array) {
                return tab.indexOf(cm.tab) >= 0 ? 'active' : '';
            }
            return tab === cm.tab ? 'active' : '';
        }
        function scrollToReviews() {
            reviewsTab();
            scrollService.scrollTo('#reviewsSection', { animate: true });
        }
        function reviewsTab() {
            cm.tab = 'reviews';
            cm.reviews = [];
            _getReviews(cm.paging.page);
        }
        function photosTab() {
            cm.tab = 'photos';
        }
        function mapTab() {
            cm.tab = 'map';
            $scope.$broadcast('mapTabSelected');
            broker.publish('MAPLIGHTBOX', {
                hotel: cm.hotel,
                showInfoWindow: true,
            });
        }
        function search() {
            basketService.startWorkflow(basketService.hotelBooking).then(null, function (errors) {
                $scope.$emit('flash:error', errors);
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelSearch', HotelSearch);
    function HotelSearch(pagingService, urlUtils, pageStrand, preferences, arrayUtil, windowUtil, $q, $scope, $location, $window, $interval, $filter, flightSearch, hotelSearch, $routeParams, hotelService, basketService, cookieService, basketStore, searchUnitService, occupancyService, broker, tripService, resourceService, loggingService, reviewService, imageService, locationService, hotelsFilter, analytics, currentDestination, getPropertyTypeFromResKey, bd4travel, $rootScope, $route, fidParser, abTest, destinationService, urlStoreService) {
        var cm = this;
        var selectedHotel;
        var timerKey = 'modifying hotel list criteria';
        var boards = [
            'MIXEDROOM',
            'ROOMONLY',
            'BEDANDBREAKFAST',
            'HALFBOARD',
            'FULLBOARD',
            'ALLINCLUSIVE',
            'SELFCATERING'
        ];
        var tripId = $routeParams.tripId;
        cm.starName = starName;
        cm.addingFlight = basketStore.addingFlight();
        cm.applyFilters = applyFilters;
        cm.applySort = applySort;
        cm.boardTypePriceText = TRPCONFIG.Domain.BoardTypePriceText;
        cm.lockMultiDestUI = false;
        cm.hotelsFilterOrderABTest = TRPCONFIG.Domain.HotelsFilterOrderABTest;
        cm.trackEngagementClick = function (hotel) { return bd4travel.trackEngagementClick(hotel.Id); };
        $rootScope.$on('hotelShortlistStatusUpdated', function (ev, hotel) {
            bd4travel.trackEngagementClick(hotel.Id);
        });
        preferences.get('priceMode').then(function (p) {
            var priceMode = $location.search().priceMode;
            priceMode = (priceMode != null && !TRPCONFIG.Domain.PriceModeUrlHash) ? priceMode : p;
            cm.priceMode = parseInt(priceMode);
        });
        cm.fid = fidParser.parse();
        cm.filterTab = filterTab;
        cm.setTab = setTab;
        cm.listTab = listTab;
        cm.infoTab = infoTab;
        cm.page = page;
        cm.removeArrayFilter = removeArrayFilter;
        cm.removeFilter = removeFilter;
        cm.req = hotelSearch.getAvailabilityRequest();
        cm.requestedHotelNotAvailable = requestedHotelNotAvailable;
        cm.resetFilters = resetFilters;
        cm.resetRangeFilter = resetRangeFilter;
        cm.resetArrayFilter = resetArrayFilter;
        cm.resetBitFilter = resetBitFilter;
        cm.showSpinner = showSpinner;
        cm.sortCriteria = hotelSearch.getSortCriteria();
        cm.sortTab = sortTab;
        cm.startAgain = startAgain;
        cm.tab = 'list';
        cm.seo = false;
        cm.pollingInterval = null;
        cm.tabClass = tabClass;
        cm.isHotelFilterVisible = TRPCONFIG.Domain.SeasonalDeals && TRPCONFIG.Domain.SeasonalDeals.isHotelFilterVisible;
        cm.enableBoardTypeFilter = tripId != null;
        cm.isHoliday = $route.current && $route.current.area === 'holidays';
        tripService.usePackageRates().then(function (packagePrice) { return cm.packagePrice = packagePrice; });
        // Desktop
        cm.showMap = false;
        cm.toggleMap = toggleMap;
        cm.popupMap = popupMap;
        cm.showPopupMap = false;
        cm.showReviews = showReviews;
        cm.reviewsShowing = false;
        cm.openSlideFilter = openSlideFilter;
        cm.showSlideFilter = false;
        cm.showSelectedHotelV2 = TRPCONFIG.Domain.ShowSelectedHotelV2;
        cm.enableLabelOfRecentlyViewedHotel = (cm.showSelectedHotelV2 || basketService.isFlightPreselected()) && sessionStorage.getItem('preselectedHotelData') !== null
            ? false
            : TRPCONFIG.Domain.EnableLabelOfRecentlyViewedHotel;
        // for lightbox gallery
        cm.openImageGallery = openImageGallery;
        cm.hotelImages = null;
        cm.showHotelImages = false;
        cm.hotelImageIndex = 0;
        cm.showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
        cm.toggleSearchUnit = toggleSearchUnit;
        cm.updating = false;
        cm.showAllDestinations = false;
        cm.toggleDestinations = toggleDestinations;
        cm.showBreadcrumb = false;
        cm.destinationThumb = destinationThumb;
        cm.budgetRadioBtnEnabled = TRPCONFIG.Domain.BudgetRadioBtnInsteadSliderRange;
        cm.isHolidayType = false;
        // DesktopEnd
        cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        cm.isSeasonalDeals = isSeasonalDeals;
        cm.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
        cm.hotelsChunkNumber = 1;
        cm.isPagingDisabled = false;
        cm.isHotelFirstJourney = false;
        cm.selectedEstabId = $location.search().selectedEstabId ? parseInt($location.search().selectedEstabId) : undefined;
        $scope.$watchGroup(['cm.nonInfants', 'cm.numNights', 'cm.priceMode', 'cm.isLanding', 'cm.currency'], function (args) {
            if (_(args).some(function (x) { return x == null; })) {
                return;
            }
            if (TRPCONFIG.Domain.PriceBucketFilterEnabled || cm.budgetRadioBtnEnabled) {
                cm.holidayPriceRangeBuckets = [];
                var priceBuckets = [];
                if (cm.isHoliday && cm.agg.HolidayPriceRange) {
                    if (cm.packagePrice) {
                        priceBuckets = TRPCONFIG.Domain.PackagePriceBuckets;
                    }
                    else {
                        priceBuckets = TRPCONFIG.Domain.HolidayPriceBuckets;
                    }
                    cm.holidayPriceRangeBuckets = [{ value: cm.agg.HolidayPriceRange.Max, label: resourceService.get('RADIOPRICEFILTERNOMAXLABEL') }];
                }
                else {
                    priceBuckets = TRPCONFIG.Domain.HotelPriceBuckets;
                    cm.holidayPriceRangeBuckets = [{ value: cm.agg.PriceRange.Max, label: resourceService.get('RADIOPRICEFILTERNOMAXLABEL') }];
                }
                _.forEach(priceBuckets, function (value) {
                    var bucket = { value: value, label: '' };
                    bucket.value *= cm.nonInfants;
                    bucket.label = String.format(resourceService.get('RADIOPRICEFILTERUPTO'), $filter('roundedCurrency')(bucket.value, cm.currency));
                    if (cm.priceMode === 0) {
                        bucket.label = String.format(resourceService.get('RADIOPRICEFILTERUPTO'), $filter('roundedCurrency')(bucket.value / cm.nonInfants, cm.currency));
                    }
                    cm.holidayPriceRangeBuckets.push(bucket);
                });
                if (cm.budgetRadioBtnEnabled) {
                    var noMaxBucket = cm.holidayPriceRangeBuckets.shift();
                    cm.holidayPriceRangeBuckets.push(noMaxBucket);
                }
            }
            cm.priceRangeConfig = abTest.progressiveHotelSearchEnabled() ? {
                Min: 0,
                Max: cm.nonInfants * cm.numNights * TRPCONFIG.Domain.PriceRangeConfigPricePerRoomPerPerson,
                Plus: '+',
                edgesBecomeNull: {
                    Min: true,
                    Max: true,
                },
            } : {
                Min: cm.agg.PriceRange.Min,
                Max: cm.agg.PriceRange.Max,
            };
            _(['Min', 'Max']).forEach(function (key) {
                cm.priceRangeConfig[key + "Formatted"] = cm.formatPriceByPriceMode(cm.priceRangeConfig["" + key]);
            });
        });
        cm.ratingRangeConfig = {
            Min: 0,
            Max: 10,
            edgesBecomeNull: {
                Min: abTest.progressiveHotelSearchEnabled(),
            },
        };
        cm.formatPriceByPriceMode = function (price) {
            if (price == null) {
                return null;
            }
            if (cm.priceMode !== 1 && !cm.isLanding) {
                price /= cm.nonInfants;
            }
            return $filter('roundedCurrency')(price, cm.currency);
        };
        cm.openDatePicker = function () {
            if (TRPCONFIG.Domain.ShowDatepickerTimeout !== 0) {
                setTimeout(function () {
                    var datepicker = $('.icon-calendar');
                    if (datepicker && datepicker[0] && datepicker['0'].nextElementSibling) {
                        datepicker['0'].nextElementSibling.click();
                    }
                }, TRPCONFIG.Domain.ShowDatepickerTimeout);
            }
        };
        scrollTo(0, 0);
        _block();
        broker.subscribe('HotelCtrl', 'seoContentLoaded', function () {
            cm.seo = true;
        });
        broker.subscribe('HotelCtrl', 'priceModeChanged', function (ev) {
            $location.search('priceMode', ev.data).replace();
            cm.priceMode = ev.data;
        });
        broker.subscribe('HotelCtrl', 'searchCriteriaModified', function () {
            cm.updating = true;
            analytics.startTimer(timerKey);
            cm.hotelsChunkNumber = 1;
        });
        function _subscribeToModifications() {
            broker.subscribe('HotelCtrl', 'hotelResultsModified', function (ev) {
                _modifyResults(ev.data);
            });
        }
        function _flightCosts(basketId) {
            return function () {
                basketStore.flightCost(basketId).then(function (c) {
                    cm.totalFlightCost = c;
                    cm.addingFlight = false;
                });
            };
        }
        function buildPagePaths(children) {
            return destinationService.sortByTitle(children).map(function (child) {
                child.PagePath = urlUtils.appendExistingQueryString(urlUtils.stripLeadingSlash(child.PagePath));
                return child;
            });
        }
        function toggleDestinations(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!cm.showAllDestinations) {
                destinationService.getAllChildren(cm.destination).then(function (children) { return cm.all = buildPagePaths(children); });
                cm.showAllDestinations = !cm.showAllDestinations;
            }
        }
        function destinationThumb(dest) {
            return destinationService.destinationThumb(dest);
        }
        if (tripId == null) {
            cm.destination = searchUnitService.getDestination();
            currentDestination.getCurrentDestination()
                .then(function (dest) {
                var CountryOwnId = dest.CountryOwnId || null;
                if (CountryOwnId != null) {
                    var isPagingMode = hotelService.getPaginationMode(CountryOwnId);
                    hotelSearch.clearSearchResults(false, isPagingMode);
                    if (isPagingMode) {
                        cm.req.Paging.Size = 12;
                        cm.isPagingDisabled = true;
                    }
                }
                else {
                    hotelSearch.clearSearchResults();
                }
            });
            hotelSearch.updateFilterFromFid()
                .then(function () { return hotelSearch.getSearchResults(null, true); })
                .then(_setResults)
                .then(_subscribeToModifications)
                .then(_bindFilterData);
            cm.getHotelUrl = function getHotelUrl(hotel) {
                return urlUtils.stripLeadingSlash(pageStrand.adjustUrl(hotel.Url, cm.destination.PageStrand));
            };
            cm.selectHotel = function selectHotel(hotel, ev) {
                ev.preventDefault();
                var url = urlUtils.stripLeadingSlash(pageStrand.adjustUrl(urlUtils.appendExistingQueryString(hotel.Url), cm.destination.PageStrand));
                trackHotelClick(hotel, undefined);
                if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                    windowUtil.open(url);
                }
                else {
                    selectedHotel = hotel;
                    $location.url(url);
                }
                ev.stopPropagation();
            };
            cm.showSearchUnit = true;
            cm.showBreadcrumb = true;
        }
        else {
            //nothing can happen unless we can decipher the tripId
            hotelSearch.clearSearchResults();
            basketService.changeToHolidayTripType(tripId)
                .then(function () { return tripService.getTrip(tripId); })
                .then(function (trip) {
                var BasketId = trip.BasketId, TripType = trip.TripType, FlexibleTripType = trip.FlexibleTripType;
                cm.showBreadcrumb = true;
                cm.isFlexibleTripType = FlexibleTripType;
                cm.hotelAvailabilitySearchId = _.get(trip, 'HotelsRequest.AvailabilitySearchId');
                cm.roomsQuantity = trip.HotelsRequest && trip.HotelsRequest.Rooms ? trip.HotelsRequest.Rooms.length : 0;
                cm.isMultiDestHoliday = TripType === tripService.tripTypes.MultiDestHoliday;
                if (cm.isMultiDestHoliday) {
                    cm.requestedHotelNotAvailable = function () { return false; };
                    cm.showBreadcrumb = false;
                    cm.showSearchUnit = true;
                }
                cm.isHotelFirstJourney = basketService.isFlightPreselected();
                function getHotelUrl(hotel, pd) {
                    var url = basketService.getHotelUrl({
                        tripId: $routeParams.tripId,
                        hotel: hotel,
                        TripType: TripType
                    });
                    // append "page section" parameter
                    if (pd) {
                        url += url.indexOf('?') === -1 ? '?'
                            : !url.endsWith('?') ? '&'
                                : '';
                        url += "pd=" + pd;
                    }
                    return url;
                }
                function selectHotel(hotel, ev, area) {
                    var newTab = false;
                    if (ev.type === 'click' && (ev.ctrlKey || ev.metaKey)) {
                        newTab = true;
                    }
                    else if (ev.type === 'contextmenu') {
                        newTab = true;
                    }
                    if (cm.lockMultiDestUI) {
                        ev.preventDefault();
                        return;
                    }
                    try {
                        analytics.track('Event', 'SelectHotel', {
                            Revenue: hotel.MinCost,
                            StartDate: trip.HotelsRequest.CheckInDate,
                            EndDate: trip.HotelsRequest.CheckOutDate,
                            HotelTitle: hotel.Title,
                            TotalPax: _(trip.HotelsRequest.Rooms)
                                .map(function (r) { return r.Adults + r.ChildAges.length; })
                                .reduce(function (memo, num) { return memo + num; }, 0)
                        });
                    }
                    catch (err) { }
                    ev.preventDefault();
                    if (!TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                        selectedHotel = hotel;
                    }
                    if (cm.isMultiDestHoliday) {
                        selectedHotel = hotel;
                        cm.lockMultiDestUI = true;
                        hotelSearch.getTripForSelectedMultiDestHoliday(tripId, hotel)
                            .then(function (newTripId) {
                            return hotelSearch.getFlightDetailsForSelectedMultiDestHoliday(newTripId, hotel)
                                .then(function (flight) { return flightSearch.setBags(trip, flight).then(function () { return flight; }); })
                                .then(function (flight) { return basketService.selectFlight(flight, newTripId, {
                                bags: flight.bags,
                                maxbags: occupancyService.getNumberOfNonInfantPassengers() || 1
                            }); })
                                .then(function () {
                                return basketService.selectHotel(newTripId, hotel, BasketId, area, true);
                            });
                        });
                    }
                    else {
                        basketService.selectHotel($routeParams.tripId, hotel, BasketId, area, false, newTab);
                    }
                    trackHotelClick(hotel, trip);
                    ev.stopPropagation();
                }
                function _postProcessResults(results) {
                    _setResults(results)
                        .then(_subscribeToModifications)
                        .then(_bindFilterData)
                        .then(function () {
                        cm.updating = false;
                        cm.updatingAvailability = false;
                        cm.searchCompletePercentage = results.SearchCompletePercentage;
                    });
                }
                var _getMixpanelResultsCompletePayload = function (searchId, results) { return ({
                    SearchId: searchId,
                    Count: _.get(results, 'Aggregates.HotelCount', 0),
                    LowestPricedHotel: _.get(results, 'Aggregates.LowestPricedHotel', 0),
                }); };
                function _getPolledSearchResults(searchId) {
                    hotelSearch.getSearchResults(searchId, $routeParams.tripId).then(function (results) {
                        if (results.SearchCompletePercentage === 100) {
                            var mixpanelData = _.assign(_getMixpanelResultsCompletePayload(searchId, results), {
                                ProgressiveLoading: true,
                                FirstLoad: false
                            });
                            analytics.track('mixpanel', 'HotelListingComplete', mixpanelData);
                            cancelInterval();
                        }
                        return results;
                    }, function () {
                        $location.path('hotels');
                    }).then(_postProcessResults);
                }
                if ($location.search().disablePaging !== '1') {
                    $location.replace();
                    $location.search('disablePaging', null);
                    cm.req.Paging.Size = 8;
                }
                function _setSearchResultsPolling(searchId) {
                    cm.pollingInterval = $interval(function () {
                        _getPolledSearchResults(searchId);
                    }, 1000);
                }
                cm.selectHotel = selectHotel;
                cm.getHotelUrl = getHotelUrl;
                cm.isKidsFree = trip.IsKidsFree &&
                    (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);
                cm.isHolidayType = TripType === tripService.tripTypes.Holiday;
                cm.showChangeToFlight = function () { return !cm.packagePrice && cm.isHolidayType && cm.isFlexibleTripType && TRPCONFIG.Domain.HotelsOnFlightsEnabled; };
                cm.changeToFlightWorkflow = function (ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    trackChangeToFlightClick(trip);
                    basketService.changeToFlightWorkflow($routeParams.tripId);
                };
                cm.bookButton = function () {
                    return resourceService.get('SELECTHOTELTEXT');
                };
                if (trip == null) {
                    loggingService.logError("HotelSearch: tripId:" + $routeParams.tripId + " returned a null trip");
                    _unblock();
                    locationService.home();
                    return;
                }
                if (trip.HotelsRequest == null) {
                    loggingService.logError("HotelSearch: tripId:" + $routeParams.tripId + " returned a trip with a null HotelsRequest: " + JSON.stringify(trip));
                    _unblock();
                    locationService.home();
                    return;
                }
                if (TRPCONFIG.Domain.ImmediateSearch) {
                    cm.updatingAvailability = true;
                    hotelSearch.getStaticSearchResults()
                        .then(function (res) { return cm.updatingAvailability && _setResults(res); });
                }
                basketService.getFlight(BasketId).then(function (flight) {
                    if (flight) {
                        cm.flight = flight;
                        //if the page has been refreshed we need to reapply the airport code filter if there is a selected flight.
                        if (TRPCONFIG.Domain.AutoFilterByAirport) {
                            hotelSearch.setAirportCodeFilter(flight.Details.Itinerary.Legs[0].ArrivalAirport.Code);
                        }
                        _flightCosts(BasketId)();
                    }
                    if (cm.packagePrice && TRPCONFIG.Domain.MarhabaEnabled) {
                        basketStore.marhabaCost(BasketId).then(function (c) { return cm.marhabaCost = c; });
                    }
                    else {
                        cm.marhabaCost = 0;
                    }
                    //getFlight will wait if we are in the middle of adding a new flight. That action *may* cause a new
                    //hotel search to be triggered which will results in a new search Id in the trip.
                    //Therefore before we have to get the searchId from the trip again at this point to be sure
                    //we are getting the right value.
                    var searchId;
                    tripService.getTrip($routeParams.tripId)
                        .then(function (trip) { return trip.HotelsRequest.AvailabilitySearchId; })
                        .then(function (s) { return searchId = s; })
                        .then(function () { return hotelSearch.updateFilterFromFid(); })
                        .then(function () { return hotelSearch.getSearchResults(searchId, $routeParams.tripId); })
                        .then(function (results) {
                        if (abTest.progressiveHotelSearchEnabled()
                            && !!results.SearchCompletePercentage
                            && results.SearchCompletePercentage < 100) {
                            _setSearchResultsPolling(searchId);
                        }
                        else {
                            var mixpanelData = _.assign(_getMixpanelResultsCompletePayload(searchId, results), {
                                ProgressiveLoading: abTest.progressiveHotelSearchEnabled(),
                                FirstLoad: true
                            });
                            analytics.track('mixpanel', 'HotelListingComplete', mixpanelData);
                        }
                        return results;
                    }, function () {
                        $location.path('hotels');
                    })
                        .then(_postProcessResults);
                });
                broker.subscribe('HotelCtrl', 'flightAddedToBasket', _flightCosts(BasketId));
            });
        }
        //if we are in a trip and we searched for a specific hotel and we have not already been directed to that hotel
        //then route us automatically through to the hotel page
        function redirectToHotel(data) {
            if ($routeParams.tripId == null) {
                return $q.when(false);
            }
            return tripService.getTrip($routeParams.tripId).then(function (trip) {
                var BasketId = trip.BasketId;
                if (trip.HotelsRequest && trip.HotelsRequest.DirectToHotel && trip.TripType !== tripService.tripTypes.MultiDestHoliday) {
                    return hotelSearch.getDestinationEstabId().then(function (estabId) {
                        if (estabId > 0 && data.Hotels.length > 0 && parseInt(estabId) === data.Hotels[0].Id) {
                            var boostReason = _.get(data.Hotels, '[0].BoostReason');
                            hotelService.trackHotelClick(estabId, 0, boostReason);
                            basketService.selectHotel($routeParams.tripId, data.Hotels[0], BasketId, null, true);
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
        }
        function _processHotels(hotels, filteredBoardTypes) {
            function processHotels(hotel, index) {
                setLowestBoardTypePerHotel(hotel, index);
                setPropertyTypeFrom(hotel, index);
                var preselectedHotelData = sessionStorage.getItem('preselectedHotelData');
                preselectedHotelData !== null ? hotel.inBasket = JSON.parse(preselectedHotelData).d.Itinerary.EstabId === hotel.Id : hotel.inBasket = false;
                // Hide lightbox pin when there are no valid coordinates
                hotel.showLightboxPin = hotel.Latitude && hotel.Longitude;
                hotel.isFamilyFriendly = _.includes(hotel.EstabGroupIds, TRPCONFIG.Domain.FamilyFriendlyEstabGroup);
                hotel.callToBookWithHidePrice = hotel.CallToBookBehaviour === 2;
                hotel.mandatoryExtras = hotelSearch.getMandatoryExtra(hotel);
                hotel.reviewIcon = getReviewIcon(hotel.CustomerRating);
                var earliestBoardOption = (hotel && mapRefundableDateToBoardOption(hotel)).earliestBoardOption;
                hotel.earliestRefundableCutOffMsg = earliestBoardOption && earliestBoardOption.RefundableCutOffDate;
            }
            function getReviewIcon(customerRating) {
                var reviewMaxAmount = 10;
                var faceClasses = [
                    'icon-face-angry',
                    'icon-face-sad',
                    'icon-face-indifferent',
                    'icon-face-happy',
                    'icon-face-ecstatic'
                ];
                var faceStepSize = reviewMaxAmount / faceClasses.length;
                return faceClasses.reduce(function (acc, current, i) { return (customerRating > (i * faceStepSize)) && (customerRating <= ((i + 1) * faceStepSize)) ? current : acc; });
            }
            function mapRefundableDateToBoardOption(hotel) {
                var boardOptions = hotel && hotel.RequestedRooms.map(function (room) { return room && room.Availability[0] && room.Availability[0].BoardOptions[0]; });
                if (boardOptions == null) {
                    return undefined;
                }
                var earliestBoardOption = boardOptions.reduce(function (earliest, board) {
                    var refundableCutOffDate = board && board.RefundableCutOffDate;
                    var earliestRefundableCutOffDate = earliest && earliest.RefundableCutOffDate;
                    if (refundableCutOffDate != null) {
                        if (earliestRefundableCutOffDate == null || refundableCutOffDate < earliestRefundableCutOffDate) {
                            return board;
                        }
                    }
                    return earliest;
                }, boardOptions[0]);
                return { earliestBoardOption: earliestBoardOption };
            }
            function setLowestBoardTypePerHotel(hotel) {
                function _translateLowestBoardName(index) {
                    var boardsTranslation = resourceService.get(boards);
                    return boardsTranslation[index];
                }
                function processPrices(hotel) {
                    var cheapestBoardTypes = [];
                    if (hotel.RequestedRooms) {
                        hotel.RequestedRooms.forEach(function (room) {
                            if (filteredBoardTypes != null && filteredBoardTypes.length !== 0) {
                                room.BoardTypeMinPrices = room.BoardTypeMinPrices
                                    .filter(function (board) {
                                    return filteredBoardTypes.some(function (filtered) {
                                        return board.BoardType === parseFloat(filtered);
                                    });
                                });
                            }
                            var resolution = _.minBy(room.BoardTypeMinPrices, 'MinCost');
                            if (resolution && !_.includes(cheapestBoardTypes, resolution.BoardType)) {
                                cheapestBoardTypes.push(resolution.BoardType);
                            }
                        });
                    }
                    if (cheapestBoardTypes.length === 1 && !cm.isMultiDestHoliday) {
                        hotel.lowestPriceBoardType = _translateLowestBoardName(cheapestBoardTypes[0]);
                    }
                }
                processPrices(hotel);
            }
            function setPropertyTypeFrom(hotel, index) {
                hotels[index].propertyTypeFrom = resourceService.get(getPropertyTypeFromResKey(hotel.AcomTypeId, hotel.IsVilla));
            }
            hotels.forEach(processHotels);
            return hotels;
        }
        function setSitemapLink(hotels) {
            if (hotels && (hotels.length > 0) && hotels[0].Location !== undefined) {
                currentDestination.getCurrentDestination()
                    .then(function (dest) {
                    var splitedPath = dest.PagePath.split('/');
                    var orderTarget = pageStrand.toRoute(dest.PageStrand);
                    var opositeStr = orderTarget + "-in-";
                    var urlItem = splitedPath[splitedPath.length - 1].replace(opositeStr, '');
                    var matchStrand = TRPCONFIG.Domain.EnableSitemapLinkByPageStrand && TRPCONFIG.Domain.EnableSitemapLinkByPageStrand
                        .some(function (strand) { return parseInt(strand) === parseInt(dest.PageStrand); });
                    var shouldDisplay = hotelService.getPaginationMode(dest.CountryOwnId)
                        && hotels.length >= 12
                        && matchStrand;
                    var URL = "sitemap/" + splitedPath[1] + "/" + urlItem;
                    $scope.sitemapLink = {
                        url: URL,
                        name: dest.ShortTitle,
                        display: shouldDisplay
                    };
                })
                    .catch(function (err) {
                    console.log(err);
                });
            }
        }
        function _setResults(data) {
            if (data == null) {
                return $q.when();
            }
            var isAutoSearch = $location.search().autoSearch !== '1';
            return redirectToHotel(data).then(function (redirected) {
                if (!redirected) {
                    hotelSearch.getSortCriterionDescription().then(function (name) { return cm.sortedBy = name; });
                    cm.hotels = _processHotels(data.Hotels);
                    $scope.$watchCollection('cm.filter.BoardTypes', function (e) {
                        cm.hotels = _processHotels(data.Hotels, e);
                    });
                    cm.total = data.Aggregates.HotelCount;
                    cm.filteredTotal = data.Aggregates.FilteredHotelCount;
                    cm.agg = hotelsFilter.enhanceAggregates(data.Aggregates);
                    cm.enableFacilityFilter = !$.isEmptyObject(cm.agg.HotelsByFacility);
                    cm.enableChildDestinationFilter =
                        !$.isEmptyObject(cm.agg.HotelsByChildDestination) &&
                            !cm.isMultiDestHoliday;
                    cm.enableMultiDestHolidayFilter = cm.isMultiDestHoliday;
                    cm.busy = false;
                    tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(function (ds) {
                        cm.durationSummary = ds;
                        cm.searchSummary = ds ? ds + ", " + hotelSearch.getOccupancySummary() : '';
                    });
                    hotelSearch.getDestinationTitle().then(function (title) { return cm.pageTitle = cm.destinationTitle = title; });
                    if (!cm.isMultiDestHoliday) {
                        hotelSearch.getDestinationEstabId().then(function (destinationEstabId) { return cm.destinationEstabId = destinationEstabId; });
                    }
                    if ($routeParams.tripId) {
                        tripService.getHotelsRequestNumberOfNights($routeParams.tripId)
                            .then(function (numNights) { return cm.numNights = numNights; });
                    }
                    currentDestination.getCurrentDestination().then(function (dest) {
                        cm.destination = dest;
                        cm.isTransferMandatory = (_a = (dest && dest.DestinationAirports && dest.DestinationAirports.split(',') || [])).includes.apply(_a, TRPCONFIG.Domain2.IsTransferMandatorySearchDestination);
                        var _a;
                    });
                    cm.nonInfants = cm.isKidsFree
                        ? occupancyService.getOnlyPayingIndividuals()
                        : occupancyService.getNumberOfNonInfantPassengers();
                    if (cm.total === 0) {
                        cm.showSearchUnit = true; //if no results open the search unit
                    }
                    tripService.getCurrency($routeParams.tripId).then(function (cur) { return cm.currency = cur; });
                    broker.publish('hotelListUpdated', data);
                    basketService.getHolidaySearchProgress().then(function () {
                        if (isAutoSearch) {
                            _unblock();
                        }
                    });
                    hotelSearch.pageIndex()
                        .then(function (pi) {
                        cm.pageNumber = pi + 1;
                        cm.paging = pagingService.data(cm.pageNumber, hotelSearch.pageSize(), cm.filteredTotal);
                    });
                }
                setSitemapLink(data.Hotels);
                cm.updating = false;
                return redirected;
            });
        }
        function _modifyResults(data) {
            _setResults(data)
                .then(function (redirected) {
                if (!redirected) {
                    _bindFilterData();
                    // only force to list tab when it was invoked from sort or filter actions
                    if (_(['filter', 'sort']).includes(data.searchTriggeredBy)) {
                        cm.listTab();
                    }
                }
                if (cm.showSlideFilter === true) {
                    scrollTo(0, 0);
                }
            })
                .finally(function () {
                cm.updating = false;
                analytics.endTimer(timerKey);
            });
        }
        function codeIsInGroup(group) {
            return function (code) {
                return cm.agg.HotelsByFacility[group][code] != null;
            };
        }
        function cancelInterval() {
            $interval.cancel(cm.pollingInterval);
            cm.pollingInterval = null;
        }
        function _bindFilterData() {
            cm.filter = hotelSearch.getFilter();
            cm.nameFilterSet = hotelSearch.filterSet('HotelName');
            cm.starFilterSet = hotelSearch.filterSet('Stars');
            cm.propertyTypeFilterSet = hotelSearch.filterSet('PropertyTypes');
            cm.boardTypeFilterSet = hotelSearch.filterSet('BoardTypes');
            cm.facilityFilterSet = hotelSearch.filterSet('FacilityCodes');
            cm.childDestinationFilterSet = hotelSearch.filterSet('ChildDestinations');
            if (cm.agg != null) {
                for (var group in cm.agg.HotelsByFacility) {
                    cm[group + "FacilityFilterSet"] = arrayUtil.any(cm.filter.FacilityCodes, codeIsInGroup(group));
                }
                cm.seasonalDealFilter = TRPCONFIG.Domain.ActiveSeasonalDeals && TRPCONFIG.Domain.ActiveSeasonalDeals.find(function (deal) { return _.has(cm.agg, deal.ApiAggregateName); });
            }
            cm.minPriceFilterSet = hotelSearch.rangeFilterSet('PriceRange', 'Min');
            cm.maxPriceFilterSet = hotelSearch.rangeFilterSet('PriceRange', 'Max');
            cm.minHolidayPriceFilterSet = hotelSearch.rangeFilterSet('HolidayPriceRange', 'Min');
            cm.maxHolidayPriceFilterSet = hotelSearch.rangeFilterSet('HolidayPriceRange', 'Max');
            cm.ratingFilterSet = hotelSearch.rangeFilterSet('RatingRange', 'Min');
            cm.groupFilterSet = hotelSearch.bitFilterSet('FilterByEstabGroup');
            cm.showEstabGroupFilter = hotelSearch.estabGroupFilterAvailable();
            if (TRPCONFIG.Domain.PriceBucketFilterEnabled) {
                cm.anyFilter = cm.propertyTypeFilterSet || cm.nameFilterSet || cm.starFilterSet || cm.boardTypeFilterSet || cm.ratingFilterSet || cm.groupFilterSet || cm.facilityFilterSet || cm.childDestinationFilterSet;
            }
            else {
                cm.anyFilter = cm.propertyTypeFilterSet || cm.nameFilterSet || cm.starFilterSet || cm.boardTypeFilterSet || cm.minPriceFilterSet || cm.maxPriceFilterSet || cm.ratingFilterSet || cm.groupFilterSet || cm.facilityFilterSet || cm.childDestinationFilterSet;
            }
        }
        function _block() {
            var isHoliday = $route.current && $route.current.area === 'holidays';
            $scope.$emit('block', {
                title: resourceService.get($routeParams.tripId || $location.search().autoSearch === '1' ? 'SEARCHINGHOTELS' : 'LOADINGHOTELS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: isHoliday ? 'holidays-hotelSearchCtrl-isHolidayTrue' : 'hotels-hotelSearchCtrl-isHolidayFalse'
            });
        }
        function _unblock() {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
        function tabClass(tab) {
            return tab === cm.tab ? 'active' : '';
        }
        function setTab(tab) {
            if (cm.tab !== tab) {
                cm.tab = tab;
            }
        }
        function listTab() {
            cm.setTab('list');
        }
        function filterTab() {
            if (cm.hotels.length > 0 || cm.anyFilter) {
                _bindFilterData();
                cm.setTab('filter');
            }
        }
        function sortTab() {
            if (cm.hotels.length > 0 || cm.anyFilter) {
                cm.setTab('sort');
            }
        }
        function infoTab() {
            cm.tab = 'info';
        }
        function applyFilters() {
            hotelSearch.filter();
        }
        function applySort() {
            hotelSearch.sort(cm.req.SortCriterion);
        }
        function page(num, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            cm.updating = true;
            hotelSearch.page(num - 1).then(_setResults);
        }
        function resetFilters() {
            hotelSearch.resetFilters();
        }
        function removeFilter(filterName) {
            hotelSearch.removeFilter(filterName);
        }
        function removeArrayFilter(filterName, item) {
            hotelSearch.removeArrayFilter(filterName, item);
        }
        function resetRangeFilter(filterName, range) {
            hotelSearch.resetRangeFilter(filterName, range);
        }
        function resetArrayFilter(filterName) {
            hotelSearch.resetArrayFilter(filterName);
        }
        function resetBitFilter(filterName) {
            hotelSearch.resetBitFilter(filterName);
        }
        function showSpinner(hotel) {
            return selectedHotel === hotel;
        }
        function startAgain() {
            basketService.restartCurrentWorkflow($routeParams.tripId);
        }
        function requestedHotelNotAvailable(i, hotel) {
            var isNotAvailable = !cm.anyFilter &&
                i === 0 &&
                _.get(cm, 'paging.page') === 1 &&
                cm.destinationEstabId !== 0 &&
                !cm.updating &&
                hotel.Id !== parseInt(cm.destinationEstabId);
            if (isNotAvailable) {
                analytics.trackRequestedHotelNotAvailable(cm.destinationEstabId);
            }
            return isNotAvailable;
        }
        // Desktop
        function toggleMap() {
            cm.showMap = !cm.showMap;
        }
        function popupMap(hotel) {
            cm.showPopupMap = !cm.showPopupMap;
            cm.activeHotel = hotel;
        }
        function _getReviews(hotel, page) {
            cm.loadingReviews = true;
            if (page === 1) {
                cm.loadingFirstReviews = true;
            }
            return reviewService.getReviews(hotel, page - 1).then(function (result) {
                cm.reviews = result.reviews;
                cm.loadingReviews = false;
                cm.loadingFirstReviews = false;
                cm.reviewPaging = pagingService.data(page, 10, hotel.CustomerRatingCount);
            });
        }
        function showReviews(hotel, ev) {
            ev.preventDefault();
            cm.reviews = [];
            cm.selectedHotel = hotel;
            cm.reviewPaging = pagingService.data(1, 10, hotel.CustomerRatingCount);
            _getReviews(hotel, cm.reviewPaging.page);
            cm.reviewsShowing = true;
            ev.stopPropagation();
        }
        if (TRPCONFIG.Domain.ReviewsEnabled) {
            cm.pageReviews = function (page) {
                _getReviews(cm.selectedHotel, page);
            };
        }
        function starName(stars) {
            return stars > 0 ? (stars + " " + resourceService.get('STAR')) : resourceService.get('UNRATED');
        }
        function openImageGallery(hotel, e) {
            e.preventDefault();
            var w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
            var h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
            cm.hotelImageIndex = 0;
            cm.hotelImages = [];
            for (var i = 0, l = hotel.NumberOfPhotos; i < l; i++) {
                cm.hotelImages.push({
                    src: imageService.getImageUrl(hotel.Id, w, h, i, false)
                });
            }
            cm.showHotelImages = true;
        }
        function openSlideFilter(e) {
            e.preventDefault();
            cm.showSlideFilter = true;
        }
        broker.subscribe('HotelCtrl', 'toggleMap', function () {
            toggleMap();
        });
        broker.subscribe('HotelCtrl', 'showReviews', function (ev) {
            showReviews(ev.data.hotel, ev.data.event);
        });
        function toggleSearchUnit() {
            cm.showSearchUnit = !cm.showSearchUnit;
        }
        function trackHotelClick(hotel, trip) {
            analytics.trackEvent({ category: 'searches', action: 'hotelPage' });
            preferences.getHotelSortOrder().then(function (sc) {
                hotelService.trackHotelClick(hotel.Id, hotel.HotelIndex, hotel.BoostReason, sc, _.get(trip, 'HotelsRequest.AvailabilitySearchId'));
                var trackingProps = {
                    RepeatHotelClicked: !!_.get(hotel, 'UserClicksRank'),
                    WinnerClicked: _.has(hotel, 'HotelAward'),
                    ListRanking: _.get(hotel, 'HotelIndex') || 0,
                    TopDealClicked: _.get(hotel, 'Recommended'),
                    FamilyFriendlyClicked: _.get(hotel, 'isFamilyFriendly') && !_.get(hotel, 'Recommended'),
                    BlackFridayDeal: !!_.get(hotel, 'BlackFridayDeal') || !!_.get(hotel, 'JanuarySale') || !!_.get(hotel, 'SummerOffer'),
                    PromoDiscount: false
                };
                if (TRPCONFIG.Domain.BD4Enabled) {
                    var get = function (prop) { return _.get(bd4travel.filter, prop); };
                    var FilterCount = 0;
                    FilterCount += get('board.length') ? 1 : 0;
                    FilterCount += get('categoryStars.length') ? 1 : 0;
                    FilterCount += _(get('categories')).map(function (x) { return x.split(':')[0]; }).uniq().value().length;
                    FilterCount += (get('rating10.min') > 0) ? 1 : 0;
                    var destinationMatches = (get('destination[0]') || '').match(/(\d+):(\d+)/) || {};
                    angular.extend(trackingProps, {
                        // AdultsExclClicked: [t/f] (similar to family friendly)
                        SortCriteria: bd4travel.currentSort,
                        FilterCount: FilterCount,
                        FilterCountBoard: get('BoardTypes.length') || 0,
                        FilterCountStars: get('categoryStars.length') || 0,
                        FilterCountFacilities: get('categories.length') || 0,
                        DestinationType: parseInt(destinationMatches[1]),
                        DestinationID: parseInt(destinationMatches[2]),
                        PricePP: hotel.MinCostPerPersonStr,
                        PriceTotal: hotel.MinCostStr,
                        EstabID: hotel.Id,
                    });
                }
                if (trip) {
                    var _a = occupancyService.getTotalPeopleCounts(_.get(trip, 'HotelsRequest.Rooms')), adults_1 = _a.adults, children_1 = _a.children;
                    angular.extend(trackingProps, {
                        Rooms: _.get(trip, 'HotelsRequest.Rooms.length'),
                        Adults: adults_1,
                        Children: children_1
                    });
                    if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                        basketStore.flightCost(trip.BasketId).then(function (FlightCost) {
                            analytics.track('mixpanel', 'HotelListingSkip', {
                                Id: _.get(hotel, 'Id'),
                                ProvinceId: _.get(hotel, 'ProvinceId'),
                                LocationId: _.get(hotel, 'LocationId'),
                                Adults: adults_1,
                                Children: children_1,
                                FlightCost: FlightCost
                            });
                        });
                    }
                }
                if (hotel.SpecialOfferText) {
                    angular.extend(trackingProps, {
                        PromoDiscount: true,
                        PromoCampaign: hotel.SpecialOfferText
                    });
                }
                analytics.track('mixpanel', 'HotelListingClick', trackingProps);
            });
        }
        function trackChangeToFlightClick(trip) {
            if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                var BasketId = trip.BasketId, FlightsRequest_2 = trip.FlightsRequest, HotelsRequest_1 = trip.HotelsRequest;
                basketStore.flightCost(BasketId).then(function (FlightCost) {
                    var _a = occupancyService.getTotalPeopleCounts(_.get(HotelsRequest_1, 'Rooms')), adults = _a.adults, children = _a.children;
                    analytics.track('mixpanel', 'HotelListingSkip', {
                        Id: _.get(FlightsRequest_2, 'Destination.Id'),
                        ProvinceId: _.get(FlightsRequest_2, 'Destination.ProvinceId'),
                        LocationId: _.get(FlightsRequest_2, 'Destination.LocationId'),
                        Adults: adults,
                        Children: children,
                        FlightCost: FlightCost
                    });
                });
            }
        }
        cm.trackPriceBucket = function (label) {
            var typeTitles = {
                hotels: 'Hotels',
                flights: 'Flights',
                holidays: 'Holidays',
            };
            var title = cm.showChangeToFlight() ? 'flights' : $route.current.area;
            analytics.track('mixpanel', 'PriceBucketClick', {
                TypeTitle: typeTitles[title] || null,
                Priceband: label.replace(/\D/g, '') || label,
            });
        };
        cm.isLeftSectionRibbon = function (ribbon) {
            var ribbonsIdList = TRPCONFIG.Domain.LeftAllignedRibbonsList;
            var isLeftDirected = ribbonsIdList.includes(ribbon.Id.toString());
            return isLeftDirected;
        };
        function isSeasonalDeals(hotel) {
            return _.some(TRPCONFIG.Domain.ActiveSeasonalDeals, function (d) { return hotel.OverlaysNew && d.OverlayId === hotel.OverlaysNew[0].Id; });
        }
        $scope.$on('$destroy', function () {
            cancelInterval();
            broker.unsubscribe('HotelCtrl');
        });
        cm.showMore = function () {
            cm.updating = true;
            var hotels = cm.hotels;
            hotelSearch.page(cm.hotelsChunkNumber++)
                .then(function (data) {
                data.Hotels = hotels.concat(data.Hotels);
                return data;
            }).then(_setResults);
        };
        cm.showFlightDetails = function () {
            var passengers = occupancyService.getTotalPeopleCounts();
            var config = {
                flight: cm.flight.Details.Itinerary,
                passengers: passengers,
                customiseMessage: cm.isHotelFirstJourney,
            };
            broker.publish('showModalFlightDetails', config);
        };
        cm.keepHotel = function (hotel, ev) {
            // we can't use history.back() here because hotel can be opened in the new tab and history will be empty
            // or user can click back and after that forward button in the browser
            // and we cant just use $location.path(urlStoreService.getPreviousURL()) because user can click home button after that back button and click keep
            // also we can't use select hotel method because user will be redirected to room selection page
            var previousURL = urlStoreService.getPreviousURL();
            var applicablePathRegEx = '(/|/holidays/|/hotels)(flights|hotels|options|book|([0-9a-fA-F-]+))/[0-9a-fA-F-]+';
            var cameFromWrongPath = urlStoreService.cameFromWrongPath(applicablePathRegEx);
            if (!cameFromWrongPath) {
                var cameFromChooseFlightPage = previousURL.match('(holidays/flights/)[0-9a-fA-F-]+') !== null;
                var cameFromChooseRoomPage = previousURL.match('(holidays/)[0-9a-fA-F-]+(/)[0-9]+') !== null;
                var isHotelSelected = sessionStorage.getItem('preselectedHotelData') !== null;
                var URLHistory = urlStoreService.getURLHistory();
                var postPreviousURL = null;
                if (URLHistory !== null && URLHistory.length >= 3) {
                    postPreviousURL = URLHistory.slice(-3)[0];
                }
                // if you click 'keep hotel' it redirect you back to the flight selection, if you click 'keep flight' it redirect you back to the hotel selection
                // we need this check to avoid the loop between 'keep hotel' and keep 'flight buttons'
                if ((cameFromChooseFlightPage || cameFromChooseRoomPage) && isHotelSelected && postPreviousURL !== null) {
                    // when ab test (hotel first) will be ended, we can remove if-else below and just put $location.path(postPreviousURL);
                    // it looks like useless check, but let's keep it here for now just in case, since local smoke test was successful
                    if (postPreviousURL === '/' || postPreviousURL === '/holidays' || postPreviousURL === '/hotels') {
                        cm.selectHotel(hotel, ev);
                    }
                    else {
                        $location.path(postPreviousURL);
                    }
                }
                else {
                    $location.path(previousURL);
                }
            }
            else {
                cm.selectHotel(hotel, ev);
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('HotelsSitemap', HotelsSitemap);
    function HotelsSitemap($location, hotelsSitemap, scrollTo, $window, hotelSearch, resourceService) {
        var cm = this;
        var splitedPath = $location.path().split('/');
        var path = "/" + splitedPath[splitedPath.length - 2] + "/hotels-in-" + splitedPath[splitedPath.length - 1];
        var qs = $location.search();
        cm.size = 100;
        cm.page = page;
        cm.currentPage = qs.pi ? parseInt(qs.pi) + 1 : 1;
        cm.updating = false;
        hotelSearch.getDestinationTitle()
            .then(function (title) {
            cm.propertyTitle = title;
            document.title = title + " " + resourceService.get('SITEMAP_META_TITLE');
        });
        function getPage(pageNum, e) {
            if (($window && $window.history) && (e && e.target)) {
                var searchString = e.target.search ? e.target.search : '';
                var newUrl = e.target.pathname + searchString;
                $location.url(newUrl);
                $location.replace();
                $window.history.pushState(null, 'any', $location.absUrl());
            }
            cm.updating = true;
            hotelsSitemap.getHotels(path, pageNum).then(function (data) {
                cm.total = data.Aggregates.HotelCount;
                cm.updating = false;
                return cm.hotels = data.Hotels;
            });
        }
        getPage(cm.currentPage - 1);
        function page(num, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            getPage(num - 1, e);
            scrollTo('body');
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('RecentHotels', RecentHotels);
    function RecentHotels(urlUtils, $scope, $location, recentHotels, authService) {
        var cm = this;
        cm.clear = clear;
        cm.loading = true;
        cm.match = match;
        cm.remove = remove;
        cm.select = select;
        cm.signIn = signIn;
        authService.bufferRoute(null);
        _loadHotels();
        $scope.$on('auth:signout', _loadHotels);
        function _loadHotels() {
            recentHotels.get().then(function (hotels) {
                cm.hotels = hotels;
                cm.loading = false;
            });
        }
        function _contains(str, f) {
            return f == null ? true : str.toLowerCase().indexOf(f) > -1;
        }
        function clear() {
            recentHotels.clear().then(function () {
                cm.hotels = [];
            });
        }
        function remove(event, hotel) {
            event.preventDefault();
            event.stopPropagation();
            recentHotels.remove(hotel.Id).then(_loadHotels);
        }
        function select(hotel) {
            $location.path(urlUtils.stripLeadingSlash(hotel.Url));
        }
        function match(hotel) {
            return _contains(hotel.Name, cm.filter) || _contains(hotel.Location, cm.filter);
        }
        function signIn() {
            var url = 'recenthotels';
            authService.bufferRoute(url);
            $location.url("signin?cb=" + encodeURIComponent(url));
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('SelectedHotel', SelectedHotel);
    function SelectedHotel(hotelFromSession, arrayUtil, imageService, $q, tripService, $routeParams, basketStore, $route, basketService, taxationService, mandatoryTransferService) {
        var sh = this;
        var w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
        var h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
        sh.changeWorkflowState = changeWorkflowState;
        sh.openImageGallery = openImageGallery;
        sh.hotelImageIndex = 0;
        sh.showHotelImages = false;
        sh.isPackagePrice = TRPCONFIG.Domain.PackagePrice && $route.current && $route.current.area === 'holidays';
        sh.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        tripService.usePackageRates().then(function (packagePrice) { return sh.isPackagePrice = packagePrice; });
        function changeWorkflowState(breadcrumb) {
            basketService.changeJourneyUrl(breadcrumb);
        }
        function openImageGallery() {
            sh.showHotelImages = true;
        }
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            if (trip && trip.BasketId) {
                taxationService.getCityTax(trip.TripId, trip.BasketId).then(function (tax) {
                    sh.tax = tax;
                });
                $q.all([basketStore.hotel(trip.BasketId),
                    basketStore.hotelCost(trip.BasketId),
                    basketStore.hotelDeposit(trip.BasketId, $routeParams.productId)]).then(function (results) {
                    var hotelFromBasket = results[0];
                    if (hotelFromBasket) {
                        sh.hotelCost = results[1];
                        sh.hotelDeposit = results[2];
                        sh.hotelImages = arrayUtil.map(arrayUtil.numberArray(0, hotelFromBasket.Details.NumberOfPhotos - 1), function (i) {
                            return {
                                src: imageService.getImageUrl(hotelFromBasket.Details.Id, w, h, i, false)
                            };
                        });
                        sh.mandatoryTransfersCost = mandatoryTransferService.getBookedTransfersPrice(hotelFromBasket.CostBreakdown);
                        hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, hotelFromBasket.Details.Id, $routeParams.tripId).then(function (hotel) {
                            sh.hotel = angular.extend(hotel, hotelFromBasket);
                        });
                    }
                });
            }
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('ConnectingAirport', ConnectingAirport);
    function ConnectingAirport($window, $routeParams, bookingService, tripService) {
        var cm = this;
        cm.setDestinationAirport = undefined;
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            bookingService.getBooking(trip.BookingId).then(function (booking) {
                var cf = booking.UserData.ConnectingFlight;
                cm.setDestinationAirport = function (airport) {
                    cf.OutboundDestinationAirport = airport.Code;
                    cf.OutboundDestinationAirportName =
                        String.format('{0} ({1})', airport.Title, airport.Code);
                    bookingService.updateBooking(booking);
                    $window.history.back();
                };
            });
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('FlightType', FlightType);
    function FlightType($scope, searchUnitService, $location, $route) {
        var cm = this;
        cm.flightTypes = searchUnitService.getFlightTypes();
        cm.selected = { flightType: searchUnitService.getFlightType() };
        $scope.$on('radio-clicked', function () {
            searchUnitService.setFlightType(cm.selected.flightType);
            $location.path($route.current.area);
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('MarhabaAvailability', MarhabaAvailability);
    function MarhabaAvailability($scope, $rootScope, marhabaSearch, $routeParams, $location, tripService, resourceService, analytics) {
        var cm = this;
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var searchId = trip.MarhabaRequest.AvailabilitySearchId;
            analytics.track('mixpanel', 'MarhabaPage');
            cm.header = {};
            cm.loaded = false;
            cm.selectProduct = undefined;
            $rootScope.lockScreen($scope, {
                title: resourceService.get('MARHABASEARCHING'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-marhabaAvailabilityCtrl'
            });
            marhabaSearch.getSearchResults(searchId, trip).then(function (res) {
                cm.lounges = [];
                cm.meetGreet = [];
                cm.transfers = [];
                function _categorize(p, index) {
                    if (p.AdultPrice === 0) {
                        return;
                    }
                    switch (p.Type) {
                        case 1:
                            cm.meetGreet.push(p);
                            break;
                        case 5:
                            cm.lounges.push(p);
                            break;
                        case 2:
                            cm.transfers.push(p);
                    }
                    cm.loaded = index === res.MarhabaQuotes.length - 1;
                }
                function _order(a, b) {
                    if (a.TotalPrice > b.TotalPrice) {
                        return 1;
                    }
                    if (a.TotalPrice < b.TotalPrice) {
                        return -1;
                    }
                    return 0;
                }
                if (res && res.MarhabaQuotes && res.MarhabaQuotes.length !== 0) {
                    res.MarhabaQuotes.sort(_order).forEach(_categorize);
                }
                else {
                    cm.noServices = true;
                }
                $rootScope.unlockScreen($scope);
            });
            cm.header.title = resourceService.get(trip.MarhabaRequest.FlightType === 1 ? 'ARRIVAL' : 'DEPARTURE') + " ";
            cm.header.title += resourceService.get('SERVICEFOR') + " ";
            cm.header.title += trip.MarhabaRequest.Terminal.Name;
            cm.header.subTitle = trip.MarhabaRequest.DateAndTime;
            cm.selectProduct = function selectProduct(productId) {
                var category = 'Marhaba';
                function getProductName() {
                    var a = cm.lounges.concat(cm.meetGreet);
                    var i = a.find(function (item) {
                        return item.Id === productId;
                    });
                    if (i === undefined) {
                        category = 'Transfers';
                        i = cm.transfers.find(function (item) {
                            return item.Id === productId;
                        });
                    }
                    return i.Name;
                }
                analytics.track('mixpanel', 'MarhabaPageClick', {
                    ProductDescription: getProductName(),
                    productCategory: category
                });
                $location.path("marhaba/" + $routeParams.tripId + "/" + productId);
            };
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('MarhabaOptions', MarhabaOptions);
    function MarhabaOptions(marhabaService, $routeParams, $location, basketStore, basketService, resourceService, tripService, occupancyService, $sce, analytics) {
        var cm = this;
        cm.updateChauffeurNum = updateChauffeurNum;
        cm.changeMarhaba = changeMarhaba;
        analytics.track('mixpanel', 'MarhabaOptions');
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var basketId = trip.BasketId;
            var searchId = trip.MarhabaRequest.AvailabilitySearchId;
            var productId = $routeParams.productId;
            cm.noOfPassengers = occupancyService.getNumberOfNonInfantPassengers();
            cm.selection = { auxillaries: {} };
            // Products are splitted between chauffeurs and auxillaries
            cm.auxillaryProducts = [];
            cm.chauffeurs = [];
            cm.lounges = [];
            cm.isLounge = false;
            cm.isTransfer = false;
            basketStore.addMarhaba(searchId, productId, basketId).then(function (productInfo) {
                // Summary for header overlay
                cm.summary = {
                    productName: productInfo.Details.MarhabaQuote.Name,
                    terminal: trip.MarhabaRequest.Terminal.Name,
                    date: trip.MarhabaRequest.DateAndTime,
                    description: $sce.trustAsHtml(productInfo.Details.MarhabaQuote.Description),
                    price: productInfo.Details.MarhabaQuote.TotalPrice
                };
                var type = productInfo.Details.MarhabaQuote.Type;
                cm.isLounge = type === 5;
                cm.isTransfer = type === 2;
                cm.confirmMarhaba = confirmMarhaba;
                var res = marhabaService.adjustMarhabaOptions(productInfo, resourceService.get('SELECTCHAUFFEUR'));
                if (res.noOptions) {
                    cm.noOptions = res.noOptions;
                }
                else {
                    cm.auxillaryProducts = res.auxillaryProducts;
                    cm.chauffeurs = res.chauffeurs;
                    cm.lounges = res.lounges;
                    cm.selection.chauffeur = res.selectedChauffeur;
                }
                cm.loaded = true;
                function confirmMarhaba() {
                    trackOptionsInMixpanel();
                    // The chauffeurs is treated as any other auxillaries
                    if (cm.selection.chauffeur && cm.selection.chauffeur.Id !== 0) {
                        cm.selection.auxillaries[cm.selection.chauffeur.Id] = cm.selection.chauffeur.Num;
                    }
                    // Lounges is treated as any other auxillaries
                    // Only one Lounge can be added
                    if (cm.selection.lounge) {
                        cm.selection.auxillaries[cm.selection.lounge.Id] = cm.noOfPassengers;
                    }
                    // Normalization of options for the request
                    var options = [];
                    for (var auxId in cm.selection.auxillaries) {
                        var quantity = cm.selection.auxillaries[auxId];
                        if (quantity > 0) {
                            options.push({ OptionId: auxId, ChosenQuantity: quantity });
                        }
                    }
                    // The marhaba product in the basket is removed and added again with all the options
                    basketStore.addMarhaba(searchId, productId, basketId, options).then(function () {
                        basketStore.marhabaHolidayPath(basketId).then(function (asOption) {
                            if (asOption) {
                                $location.path("holidays/options/" + $routeParams.tripId + "/" + productId);
                            }
                            else {
                                basketService.prepareMarhabaBooking($routeParams.tripId, productId);
                            }
                        });
                    });
                }
            });
        });
        function updateChauffeurNum() {
            cm.selection.chauffeur.Num = 1;
        }
        function changeMarhaba() {
            basketService.changeJourneyUrl(45);
        }
        function trackOptionsInMixpanel() {
            var auxKeys = _.mapKeys(cm.selection.auxillaries, function (value, key) {
                var i = cm.auxillaryProducts.find(function (item) {
                    return item.Id === key;
                });
                return i.Name;
            });
            var mixpanelOptions = _.mapValues(auxKeys, function (val) {
                return !!val;
            });
            mixpanelOptions.Chauffeur = _.has(cm, 'selection.chauffeur.Num');
            if (cm.selection.lounge !== undefined) {
                mixpanelOptions.Lounge = cm.selection.lounge.Name;
            }
            return analytics.track('mixpanel', 'MarhabaOptionsClick', mixpanelOptions);
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Terminal', Terminal);
    function Terminal($scope, searchUnitService, $location, $route) {
        var cm = this;
        searchUnitService.getTerminals().then(function (t) {
            cm.terminals = t;
        });
        cm.selected = {
            terminal: searchUnitService.getTerminal()
        };
        $scope.$on('radio-clicked', function () {
            searchUnitService.setTerminal(cm.selected.terminal);
            $location.path($route.current.area);
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('MultiFlightsSearch', MultiFlightsSearch);
    function MultiFlightsSearch($routeParams, tripService, locationService, multiSectorSearch, loggingService, basketService, broker, $scope) {
        var mfs = this;
        var availabilitySearchId;
        var requestedRoutes;
        mfs.isLoading = true;
        tripService.getTrip($routeParams.tripId)
            .then(function (trip) {
            if (trip.MultiFlightsRequest == null) {
                loggingService.logError("MultiFlightsSearch: tripId:" + $routeParams.tripId + " returned a trip with a null MultiFlightsRequest: " + JSON.stringify(trip));
                unblock();
                locationService.home();
                return;
            }
            availabilitySearchId = trip.MultiFlightsRequest.AvailabilitySearchId;
            requestedRoutes = trip.MultiFlightsRequest.FlightRoutes;
            return multiSectorSearch.getSearchResults($routeParams.tripId, availabilitySearchId)
                .then(function (data) {
                unblock();
                setResults(data);
            });
        });
        mfs.selectOption = function (option) {
            mfs.selectedOption = option;
            basketService.selectMultiFlight(option, $routeParams.tripId);
        };
        mfs.toggleOption = function (option) {
            option.isExpanded = !option.isExpanded;
        };
        mfs.isSectorDefault = function (sector) {
            return sector.SectorTakeOffRange.IsDefault && sector.SectorLandingRange.IsDefault;
        };
        mfs.areSectorsDefault = function () {
            return mfs.sectors.every(mfs.isSectorDefault);
        };
        mfs.resetFilters = function () {
            mfs.sectors.forEach(function (sector, i) {
                mfs.resetRangeFilter(i, 'SectorTakeOffRange', false);
                mfs.resetRangeFilter(i, 'SectorLandingRange', false);
            });
            filterSearch();
        };
        mfs.resetRangeFilter = function (i, filterName, doSearch) {
            if (doSearch === void 0) { doSearch = true; }
            var filter = mfs.sectors[i][filterName];
            var source = mfs.unfilteredAggregates[filterName][i];
            filter.Min = source.Min;
            filter.Max = source.Max;
            filter.IsDefault = true;
            if (doSearch) {
                filterSearch();
            }
        };
        mfs.onSlideComplete = function (i, filterName) {
            var filter = mfs.sectors[i][filterName];
            var source = mfs.unfilteredAggregates[filterName][i];
            filter.IsDefault = filter.Min === source.Min && filter.Max === source.Max;
            filterSearch();
        };
        function setResults(data) {
            mfs.availableOptions = data.CombinedDates.AvailableFlights;
            mfs.aggregates = data.CombinedDates.FilteredAggregates;
            mfs.isLoading = false;
            if (mfs.sectors) {
                return;
            }
            mfs.unfilteredAggregates = data.CombinedDates.UnfilteredAggregates;
            if (!mfs.unfilteredAggregates.TotalNumberOfFlights) {
                return;
            }
            mfs.sectors = requestedRoutes.map(function (route, i) {
                var SectorTakeOffRange = mfs.unfilteredAggregates.SectorTakeOffRange[i];
                var SectorLandingRange = mfs.unfilteredAggregates.SectorLandingRange[i];
                return {
                    DepartureAirport: route.DepartureAirport,
                    DestinationAirport: route.DestinationAirport,
                    SectorTakeOffRange: {
                        IsDefault: true,
                        Min: SectorTakeOffRange.Min,
                        Max: SectorTakeOffRange.Max
                    },
                    SectorLandingRange: {
                        IsDefault: true,
                        Min: SectorLandingRange.Min,
                        Max: SectorLandingRange.Max
                    }
                };
            });
        }
        function filterSearch() {
            mfs.isLoading = true;
            if (mfs.areSectorsDefault()) {
                return multiSectorSearch.getSearchResults($routeParams.tripId, availabilitySearchId)
                    .then(setResults);
            }
            var filters = mfs.sectors
                .filter(function (sector) { return !mfs.isSectorDefault(sector); })
                .map(function (sector) {
                var filter = {
                    SectorIndex: mfs.sectors.indexOf(sector)
                };
                setFilterSectorRange(sector, filter, 'SectorTakeOffRange');
                setFilterSectorRange(sector, filter, 'SectorLandingRange');
                return filter;
            });
            multiSectorSearch.filter(availabilitySearchId, filters)
                .then(setResults);
        }
        function setFilterSectorRange(sector, filter, type) {
            if (!sector[type].IsDefault) {
                filter[type.replace('Sector', '')] = {
                    Min: sector[type].Min,
                    Max: sector[type].Max
                };
            }
        }
        function unblock() {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }
    }
})();
(function () {
    'use strict';
    angular.module('TR')
        .controller('SelectedParking', SelectedParking);
    function SelectedParking(tripService, $routeParams, modalService, basketStore) {
        var sp = this;
        tripService.getTrip($routeParams.tripId).then(function (trip) {
            var parkingReq = trip && trip.ParkingRequest;
            if (parkingReq) {
                sp.airport = parkingReq.Airport.ShortTitle;
                sp.dropOffDate = parkingReq.DepartureDate;
                sp.pickUpDate = parkingReq.ReturnDate;
            }
            basketStore.parking(trip.BasketId).then(function (result) {
                sp.Details = result.Details;
            });
        });
        sp.showDetails = function () {
            modalService.launch('partials/popups/parkingdetails', {
                details: sp.Details,
                airport: sp.airport,
                dropOffDate: sp.dropOffDate,
                pickUpDate: sp.pickUpDate
            });
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('TR')
        .controller('Shortlist', Shortlist);
    function Shortlist($location, $scope, arrayUtil, authService, shortlistService, urlUtils) {
        var cm = this;
        cm.clearShortlist = clearShortlist;
        cm.loading = true;
        cm.remove = remove;
        cm.selectHotel = selectHotel;
        cm.shortlistFilter = shortlistFilter;
        cm.signIn = signIn;
        authService.bufferRoute(null);
        _loadList();
        $scope.$on('auth:signout', _loadList);
        function _loadList() {
            shortlistService.getHotelsInShortlist().then(function (sl) {
                if (sl) {
                    cm.hotels = sl.Hotels;
                    cm.id = sl.ShortlistId;
                }
                cm.loading = false;
                //to make maps work on desktop
                _.each(cm.hotels, function (h) {
                    h.lat = h.Latitude;
                    h.lon = h.Longitude;
                });
            });
        }
        function _contains(hotelObj, filter) {
            if (typeof hotelObj === 'string' && typeof filter === 'string') {
                return hotelObj.toLowerCase().indexOf(filter) > -1;
            }
            return true;
        }
        function remove(event, hotel) {
            event.preventDefault();
            event.stopPropagation();
            shortlistService.removeFromShortlist({
                Id: hotel.Id
            }).then(function () {
                var index = arrayUtil.indexOf(cm.hotels, function (h) {
                    return h.Id === hotel.Id;
                });
                if (index >= 0) {
                    cm.hotels.splice(index, 1);
                }
            });
        }
        function selectHotel(hotel) {
            $location.path(urlUtils.stripLeadingSlash(hotel.Url));
        }
        function clearShortlist() {
            shortlistService.clear(cm.id).then(function () {
                cm.hotels = [];
            });
        }
        function shortlistFilter(hotel) {
            return _contains(hotel.Name, cm.filter) || _contains(hotel.Location, cm.filter);
        }
        function signIn() {
            var url = 'shortlist';
            authService.bufferRoute(url);
            $location.url("signin?cb=" + encodeURIComponent(url));
        }
    }
})();
(function () {
    'use strict';
    //this file must be at the end of the entire bundle
    $(function () {
        angular.bootstrap(document.documentElement, ['TR']);
    });
})();
